function $$Record1(b, c, d, e, f) {
        this.b = b;
        this.c = c;
        this.d = d;
        this.e = e;
        this.f = f;
    }
    $$Record1.prototype
        .$c = function () {
        return new $$Record1(this.b, this.c, this.d, this.e, this.f);
    };
    function $$Record2(p, q, r) {
        this.p = p;
        this.q = q;
        this.
            r = r;
    }
    $$Record2.prototype.$c = function () {
        return new $$Record2(this.p, this.q, this.r);
    };
    function $$Record3(e, u, a) {
        this.e = e;
        this.
            u = u;
        this.a = a;
    }
    $$Record3.prototype.$c = function () {
        return new $$Record3(this
            .e, this.u, this.a);
    };
    function $$Record4(f, u, a) {
        this.f = f;
        this.u = u;
        this.a = a;
    }
    $$Record4.prototype.$c = function () {
        return new $$Record4(this.f, this.u, this.a);
    };
    function $$Record5(f, o) {
        this.f = f;
        this.o
            = o;
    }
    $$Record5.prototype.$c = function () {
        return new $$Record5(this.f, this.o);
    };
    function $$Record6(j, p) {
        this.j = j;
        this.p = p;
    }
    $$Record6.prototype.$c = function () {
        return new $$Record6(this.j, this.p);
    };
    function $$Record7(w, x, y) {
        this
            .w = w;
        this.x = x;
        this.y
            = y;
    }
    $$Record7.prototype.$c = function () {
        return new $$Record7(this.w, this.x, this
            .y);
    };
    function $$Record8(c, z, r, s) {
        this.c = c;
        this.z = z;
        this.r = r;
        this.s = s;
    }
    $$Record8.prototype.$c
        = function () {
            return new $$Record8(this.c, this.z, this.r, this.s);
        };
    function $$Record9(p6, p7, jJ, fo) {
        this.p6 = p6;
        this
            .p7 = p7;
        this.jJ = jJ;
        this.fo = fo;
    }
    $$Record9.prototype.$c = function () {
        return new $$Record9(this.p6, this.p7, this.jJ, this.fo);
    };
    function $$Record10(oh, p1) {
        this.oh = oh;
        this.p1 = p1;
    }
    $$Record10.prototype.
        $c = function () {
        return new $$Record10(this.oh, this.p1);
    };
    function $$Record11(jJ, fo) {
        this.jJ = jJ;
        this.fo = fo;
    }
    $$Record11.prototype.$c = function () {
        return new $$Record11(this.jJ, this.fo);
    };
    function $$Record12(oh, p1, ln) {
        this.oh = oh;
        this.p1 = p1;
        this
            .ln = ln;
    }
    $$Record12.prototype.$c = function () {
        return new $$Record12(this.oh, this.p1, this.ln);
    };
    function $$Record13(hw, hK, at, nT, nY, n$) {
        this.hw = hw;
        this.
            hK = hK;
        this.at = at;
        this.nT = nT;
        this.nY = nY;
        this.n$ = n$;
    }
    $$Record13.prototype
        .$c = function () {
        return new $$Record13(this.
            hw, this.hK, this.at, this.nT, this.nY, this.n$);
    };
    function $$Record14(cC, cD, cN, cO, cP, cZ, c3, ed, c5, fR, df, di, pn, pR) {
        this.cC = cC;
        this.cD = cD;
        this.cN = cN;
        this.cO = cO;
        this.cP = cP;
        this.cZ = cZ;
        this.c3 = c3;
        this.ed = ed;
        this.c5 = c5;
        this.fR = fR;
        this.df = df;
        this.di = di;
        this.pn
            = pn;
        this.pR = pR;
    }
    $$Record14.prototype.$c = function () {
        return new $$Record14(this.cC, this.cD, this.cN, this.cO, this.cP, this.cZ, this.c3, this
            .ed, this.c5, this.fR, this.df, this.di, this.
            pn, this.pR);
    };
    function $$Record15(fa, fr, gi) {
        this.fa = fa;
        this.fr = fr;
        this.gi = gi;
    }
    $$Record15.prototype.$c = function () {
        return new $$Record15(this.fa, this.fr, this.gi);
    };
    function $$Record16(e7, g$, fe, hs, ht, lI, fs, hP, fA, hQ, mh, h2, n3, gk, jv, pJ) {
        this.e7 = e7;
        this.g$ = g$;
        this.fe = fe;
        this.hs = hs;
        this.ht = ht;
        this.lI = lI;
        this.fs = fs;
        this.hP = hP;
        this.fA = fA;
        this.
            hQ = hQ;
        this.mh = mh;
        this.h2 = h2;
        this.
            n3 = n3;
        this.gk = gk;
        this.jv = jv;
        this.
            pJ = pJ;
    }
    $$Record16.prototype.$c =
        function () {
            return new $$Record16(this.e7, this.g$, this.fe, this
                .hs, this.ht, this.lI, this.fs, this.hP, this.fA, this.hQ, this.mh, this.h2, this.n3, this.gk, this.
                jv, this.pJ);
        };
    function $$Record17(ao, by, nr, o$) {
        this.ao = ao;
        this
            .by = by;
        this.nr = nr;
        this.o$ = o$;
    }
    $$Record17.prototype.$c = function () {
        return new $$Record17(this.ao, this.by, this.nr, this.o$);
    };
    function $$Record18(bn, ao, pR) {
        this
            .bn = bn;
        this.ao = ao;
        this.pR = pR;
    }
    $$Record18.prototype.$c = function () {
        return new $$Record18(this.bn, this.ao, this.pR);
    };
    function $$Record19(fO, iz) {
        this.fO = fO;
        this.iz = iz;
    }
    $$Record19.prototype.$c = function () {
        return new $$Record19(this.fO, this.iz);
    };
    function $$Record20(gF, mg) {
        this.gF = gF;
        this.mg = mg;
    }
    $$Record20.prototype.$c = function () {
        return new $$Record20(this.gF, this.
            mg);
    };
    function $$Record21(iz, pR) {
        this.iz = iz;
        this.pR = pR;
    }
    $$Record21.prototype.
        $c = function () {
        return new $$Record21(this.iz, this.pR);
    };
    function $$Record22(fg, jD) {
        this.fg = fg;
        this.jD = jD;
    }
    $$Record22.prototype.$c = function () {
        return new $$Record22(this.fg, this.jD);
    };
    function $$Record23(gz, kd, ke, kT, e8, lh, fc, fh, hh, lv, mF, fR, f6, gh, gj, pR) {
        this.gz = gz;
        this.kd = kd;
        this.ke = ke;
        this.kT = kT;
        this.e8 = e8;
        this.lh = lh;
        this.fc = fc;
        this.fh = fh;
        this.hh = hh;
        this.lv = lv;
        this.mF = mF;
        this.fR = fR;
        this.f6 = f6;
        this.gh = gh;
        this.
            gj = gj;
        this.pR = pR;
    }
    $$Record23.prototype.$c = function () {
        return new $$Record23(this.gz, this.kd, this.ke, this.kT, this.e8, this.lh, this.fc, this.fh, this.hh, this.lv, this.mF, this.fR, this.f6, this.gh, this.gj, this.pR);
    };
    function $$Record24(lh, cR, b8, cf, c1, Y, ct, dn) {
        this.lh = lh;
        this.cR =
            cR;
        this.b8 = b8;
        this.cf = cf;
        this.c1 = c1;
        this.Y =
            Y;
        this.ct = ct;
        this.dn = dn;
    }
    $$Record24.prototype.$c = function () {
        return new $$Record24(this.lh, this.cR, this.b8, this.cf, this.c1, this.Y, this.ct, this.dn);
    };
    function $$Record25(lb, cW, m1, c2, bz, nt, or, bO) {
        this.lb = lb;
        this.cW = cW;
        this.m1 = m1;
        this.c2 = c2;
        this.bz = bz;
        this.nt = nt;
        this.or = or;
        this.bO = bO;
    }
    $$Record25.prototype.$c = function () {
        return new $$Record25(this.lb, this.cW, this.m1, this.c2, this.bz, this.nt, this.or, this.bO);
    };
    function $$Record26(gh, gw) {
        this.gh = gh;
        this.gw = gw;
    }
    $$Record26.prototype.$c = function () {
        return new $$Record26(this.gh, this.gw);
    };
    function $$Record27(lb, bz, bO) {
        this.lb = lb;
        this.bz = bz;
        this.bO = bO;
    }
    $$Record27.prototype.$c = function () {
        return new $$Record27(this.lb, this.
            bz, this.bO);
    };
    function $$Record28(fS, bO) {
        this.fS = fS;
        this.bO = bO;
    }
    $$Record28.prototype.$c = function () {
        return new $$Record28(this.fS, this.bO);
    };
    function $$Record29(lb, cW, m1, c2, bz, or, bO) {
        this.lb = lb;
        this.cW = cW;
        this.m1 = m1;
        this.c2 = c2;
        this.bz = bz;
        this.or = or;
        this.bO
            = bO;
    }
    $$Record29.prototype.$c = function () {
        return new $$Record29(this.lb, this.cW, this.m1, this.c2, this.bz, this.or, this.bO);
    };
    function $$Record30(g_, e8, l8, ip, jn) {
        this.g_ = g_;
        this.e8
            = e8;
        this.l8 = l8;
        this.ip = ip;
        this.jn = jn;
    }
    $$Record30.prototype.$c = function () {
        return new $$Record30(this.g_, this.e8, this.l8, this.ip, this.jn);
    };
    function $$Record31(kC, mR, b, nH, n3) {
        this.kC = kC;
        this.mR = mR;
        this
            .b = b;
        this.nH = nH;
        this.n3 = n3;
    }
    $$Record31.prototype.$c = function () {
        return new $$Record31(this.kC, this.mR, this.b, this.nH, this.n3);
    };
    function $$Record32(kV, g4, n, hc, at, p5) {
        this.kV = kV;
        this.
            g4 = g4;
        this.n = n;
        this.hc = hc;
        this.at = at;
        this.p5 = p5;
    }
    $$Record32.prototype.$c = function () {
        return new $$Record32(this.kV, this.g4, this.n, this.hc, this.at, this.p5);
    };
    function $$Record33(ko, e8, k1, lh, lo, mZ, b, no, fR, nM, f6, pR) {
        this.ko = ko;
        this.e8 = e8;
        this.k1 = k1;
        this.lh = lh;
        this.lo = lo;
        this.mZ = mZ;
        this.b = b;
        this.no = no;
        this.fR = fR;
        this.nM = nM;
        this.f6 = f6;
        this.pR = pR;
    }
    $$Record33.prototype.$c = function () {
        return new $$Record33(this.
            ko, this.e8, this
            .k1, this.lh, this.lo, this.mZ, this.b, this.no, this.fR, this.nM, this.f6, this.pR);
    };
    function $$Record34(ee, ai) {
        this.ee = ee;
        this
            .ai = ai;
    }
    $$Record34.prototype.$c =
        function () {
            return new $$Record34(this.ee, this.ai);
        };
    function $$Record35(fo, jJ) {
        this.fo = fo;
        this.jJ = jJ;
    }
    $$Record35.prototype.$c = function () {
        return new $$Record35(this.fo, this.jJ);
    };
    function $$Record36(fo, jJ, p6, p7) {
        this.fo = fo;
        this.jJ = jJ;
        this.p6 = p6;
        this.p7 = p7;
    }
    $$Record36.prototype.$c = function () {
        return new $$Record36(this.fo, this.jJ, this.p6, this.p7);
    };
    function $$Record37(cI, dA, dB, dC, dD, dE, dF, aL, aM, cd, aN, aO, aP, aQ, aR, aS, aT, aU, dZ, d_, d$, d0, d1, eg, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, ba, en, eo, ep, eq, er, es, pn, dw, eU, eV, eW) {
        this.cI = cI;
        this.dA = dA;
        this.dB = dB;
        this.dC = dC;
        this.dD = dD;
        this.dE = dE;
        this.dF = dF;
        this.aL = aL;
        this.aM = aM;
        this.cd = cd;
        this.aN = aN;
        this.aO = aO;
        this.aP = aP;
        this.aQ = aQ;
        this.aR = aR;
        this.
            aS = aS;
        this.aT = aT;
        this.aU = aU;
        this.dZ = dZ;
        this.d_ = d_;
        this
            .d$ = d$;
        this.d0 = d0;
        this.d1 = d1;
        this.eg = eg;
        this.a0 = a0;
        this
            .a1 = a1;
        this.a2 = a2;
        this.a3 = a3;
        this.a4 = a4;
        this.a5 = a5;
        this.
            a6 = a6;
        this.
            a7 = a7;
        this.a8 = a8;
        this.a9 = a9;
        this.ba = ba;
        this.en = en;
        this.eo = eo;
        this.ep = ep;
        this.
            eq = eq;
        this.er = er;
        this.es = es;
        this.pn = pn;
        this.dw = dw;
        this.eU = eU;
        this.eV = eV;
        this.eW = eW;
    }
    $$Record37.prototype.$c = function () {
        return new $$Record37(this.cI, this.dA, this.dB, this.dC, this.dD, this.dE, this.dF, this.aL, this.aM, this.cd, this.aN, this.aO, this.aP, this.aQ, this.aR, this.aS, this.aT, this.aU, this.dZ, this.d_, this.d$, this.d0, this.d1, this.eg, this.a0, this.a1, this.a2, this.a3, this.a4, this.a5, this.a6, this.a7, this.a8, this.a9, this.ba, this.en, this.eo, this.ep, this.eq, this.er, this.es, this.pn, this.dw, this.eU, this.eV, this.eW);
    };
    function $$Record38(bU, hN, h0, i2) {
        this.bU =
            bU;
        this.hN =
            hN;
        this.h0 = h0;
        this.i2 = i2;
    }
    $$Record38.prototype.$c = function () {
        return new $$Record38(this.bU, this.hN, this.h0, this.i2);
    };
    function $$Record39(k1, fH, b) {
        this.k1 = k1;
        this.fH = fH;
        this.b = b;
    }
    $$Record39.prototype.$c = function () {
        return new $$Record39(this.
            k1, this.fH, this.b);
    };
    function $$Record40(c6, eG) {
        this.c6 = c6;
        this.eG = eG;
    }
    $$Record40.prototype.$c = function () {
        return new $$Record40(this.c6, this.
            eG);
    };
    function $$Record41(be) {
        this.be = be;
    }
    $$Record41.prototype.$c =
        function () {
            return new $$Record41(this.be);
        };
    function $$Record42(kf, kn, kW, lF, mY, ot, oX, o_, o5) {
        this.kf = kf;
        this.kn = kn;
        this.kW = kW;
        this.lF = lF;
        this.mY = mY;
        this.ot = ot;
        this.oX = oX;
        this.o_ = o_;
        this.o5 = o5;
    }
    $$Record42.prototype.$c = function () {
        return new $$Record42(this.kf, this.kn, this
            .kW, this.lF, this.mY, this.ot, this.oX, this.o_, this.o5);
    };
    function $$Record43(lw, iq, iA) {
        this.lw = lw;
        this.iq =
            iq;
        this.iA = iA;
    }
    $$Record43.prototype.$c = function () {
        return new $$Record43(this.lw, this.iq, this.iA);
    };
    function $$Record44(j8, j9, e3, k5, ld, lw, hr, lD, lQ, lR, lY, ft, mf, ms, mw, mK, mM, na, nd, fO, nq, db, nI, iz, nV, iO, oe, oq, be, oz, dj, oV, pn, ps, pt, pu, jy, pV, pX, pY, p1) {
        this.j8 = j8;
        this.j9 = j9;
        this.e3 =
            e3;
        this.
            k5 = k5;
        this.ld = ld;
        this.lw = lw;
        this.hr = hr;
        this.lD
            = lD;
        this.lQ = lQ;
        this.lR = lR;
        this.lY = lY;
        this.ft = ft;
        this.mf =
            mf;
        this.ms = ms;
        this.mw = mw;
        this.mK = mK;
        this.mM = mM;
        this.na = na;
        this.nd = nd;
        this.fO = fO;
        this.nq = nq;
        this.db = db;
        this.nI = nI;
        this.iz = iz;
        this.nV = nV;
        this.iO = iO;
        this.oe = oe;
        this.oq = oq;
        this.be = be;
        this.
            oz = oz;
        this.dj = dj;
        this.oV = oV;
        this.pn
            = pn;
        this.ps = ps;
        this
            .pt = pt;
        this.pu = pu;
        this.jy = jy;
        this.pV
            = pV;
        this.pX =
            pX;
        this.pY = pY;
        this.p1 = p1;
    }
    $$Record44.prototype.$c = function () {
        return new $$Record44(this.j8, this.j9, this.e3, this.k5, this.ld, this.lw, this.hr, this.lD, this.lQ, this.lR, this.lY, this.ft, this.mf, this.ms, this.mw, this.mK, this.mM, this.na, this.nd, this.fO, this.nq, this.db, this.nI, this.iz, this.nV, this.iO, this.
            oe, this.oq, this.be, this.oz, this.dj, this.oV, this.pn, this.ps, this.pt, this.pu, this.jy, this.pV, this.pX, this.pY, this.p1);
    };
    function $$Record45(mA, n$) {
        this.mA = mA;
        this.n$ = n$;
    }
    $$Record45.prototype.$c = function () {
        return new $$Record45(this.mA, this.n$);
    };
    function $$Record46(ld, z, n$, p, gf) {
        this.ld = ld;
        this.z = z;
        this.n$ = n$;
        this.p = p;
        this.gf =
            gf;
    }
    $$Record46.prototype.$c = function () {
        return new $$Record46(this.ld, this.z, this.n$, this.p, this
            .gf);
    };
    function $$Record47(a, f4, gj) {
        this.a =
            a;
        this.f4 = f4;
        this.gj = gj;
    }
    $$Record47.prototype.$c = function () {
        return new $$Record47(this.a, this.f4, this.gj);
    };
    function $$Record48(j4, kd, fO, iz) {
        this.j4 = j4;
        this.kd = kd;
        this.fO = fO;
        this.iz = iz;
    }
    $$Record48.prototype.$c = function () {
        return new $$Record48(this.j4, this.kd, this.fO, this.iz);
    };
    function $$Record49(n$, f5) {
        this.n$ = n$;
        this.f5 = f5;
    }
    $$Record49.prototype.$c = function () {
        return new $$Record49(this.n$, this.
            f5);
    };
    function $$Record50(ll, l8) {
        this.ll = ll;
        this.l8 = l8;
    }
    $$Record50.prototype.$c = function () {
        return new $$Record50(this.ll, this.l8);
    };
    function $$Record51(kd, fO) {
        this.kd = kd;
        this.fO = fO;
    }
    $$Record51.prototype.$c = function () {
        return new $$Record51(this.kd, this
            .fO);
    };
    function $$Record52(aG, O) {
        this.aG = aG;
        this.O = O;
    }
    $$Record52.prototype.$c = function () {
        return new $$Record52(this.aG, this.O);
    };
    function $$Record53(bQ) {
        this.bQ = bQ;
    }
    $$Record53.prototype.$c = function () {
        return new $$Record53(this.bQ);
    };
    function $$Record54(bQ, U, dl) {
        this.bQ = bQ;
        this.U = U;
        this.dl = dl;
    }
    $$Record54.prototype.$c = function () {
        return new $$Record54(this.bQ, this.U, this.dl);
    };
    function $$Record55(bQ, bp, ff, aY, u, au, cw) {
        this.bQ = bQ;
        this.bp = bp;
        this.ff = ff;
        this.aY = aY;
        this.u = u;
        this.au = au;
        this.cw = cw;
    }
    $$Record55.prototype.$c = function () {
        return new $$Record55(this.bQ, this.bp, this.ff, this.aY, this.u, this.au, this.cw);
    };
    function $$Record56(e1, aH, p, dh, i8) {
        this.e1 = e1;
        this.aH = aH;
        this.p = p;
        this.
            dh = dh;
        this.i8 = i8;
    }
    $$Record56.prototype.$c = function () {
        return new $$Record56(this.e1, this.aH, this.p, this.dh, this.i8);
    };
    function $$Record57(bR, az, eH, eI) {
        this.bR = bR;
        this.az = az;
        this.eH = eH;
        this.eI = eI;
    }
    $$Record57.prototype.$c = function () {
        return new $$Record57(this.bR, this.az, this.eH, this.eI);
    };
    function $$Record58(dS, dT, cX) {
        this.dS = dS;
        this.dT = dT;
        this.cX = cX;
    }
    $$Record58.prototype.$c = function () {
        return new $$Record58(this.dS, this
            .dT, this.cX);
    };
    function $$Record59(bQ, bS, cE, cF, cG, b1, ff, ar, c4, f$, eF, bE, aw) {
        this.bQ = bQ;
        this.bS = bS;
        this.cE = cE;
        this.cF =
            cF;
        this.cG = cG;
        this.b1 = b1;
        this.ff = ff;
        this.ar = ar;
        this.c4 = c4;
        this.f$ = f$;
        this.eF = eF;
        this.bE = bE;
        this.aw = aw;
    }
    $$Record59.prototype.$c
        = function () {
            return new $$Record59(this.bQ, this.bS, this.cE, this.cF, this.cG, this.b1, this.ff, this.ar, this.c4, this.f$, this.eF, this.bE, this.aw);
        };
    function $$Record60(aB, lb, bz, gh, bO) {
        this.aB = aB;
        this.lb = lb;
        this.bz = bz;
        this.gh = gh;
        this.
            bO = bO;
    }
    $$Record60.prototype.$c = function () {
        return new $$Record60(this.aB, this.lb, this.bz, this.gh, this.bO);
    };
    function $$Record61(aB, lb, hx, bz, C, gh, jr) {
        this.aB = aB;
        this.lb = lb;
        this.hx = hx;
        this.bz = bz;
        this.C = C;
        this.
            gh = gh;
        this.jr = jr;
    }
    $$Record61.prototype.$c
        = function () {
            return new $$Record61(this.aB, this.lb, this.hx, this
                .bz, this.C, this.gh, this.jr);
        };
    function $$Record62(gG, dW, ix, op, f0) {
        this.gG = gG;
        this.dW = dW;
        this.ix =
            ix;
        this.op = op;
        this.f0 = f0;
    }
    $$Record62.prototype.$c = function () {
        return new $$Record62(this.gG, this.dW, this.ix, this.op, this.f0);
    };
    function $$Record63(ke, kT, kX, fc, b6, l4, l8, c8, nF, n1, n2, bF, oP, o4, dr) {
        this.ke =
            ke;
        this.
            kT = kT;
        this.kX = kX;
        this.fc = fc;
        this.
            b6 = b6;
        this.l4 = l4;
        this.l8 = l8;
        this.c8 = c8;
        this.nF = nF;
        this.
            n1 = n1;
        this.n2 = n2;
        this.bF = bF;
        this.oP = oP;
        this.o4 = o4;
        this.dr = dr;
    }
    $$Record63.prototype.$c = function () {
        return new $$Record63(this.ke, this.kT, this.kX, this.fc, this.b6, this.l4, this.l8, this.c8, this.nF, this.
            n1, this.n2, this.bF, this.oP, this.o4, this.dr);
    };
    function $$Record64(el, eT) {
        this.el = el;
        this.eT = eT;
    }
    $$Record64.prototype.$c = function () {
        return new $$Record64(this.el, this.eT);
    };
    function $$Record65(e4, e5, fc) {
        this.e4 = e4;
        this.e5 = e5;
        this.fc = fc;
    }
    $$Record65.prototype.$c = function () {
        return new $$Record65(this.e4, this.e5, this.fc);
    };
    function $$Record66(cS, b, ev, fW) {
        this.cS = cS;
        this.b = b;
        this.ev = ev;
        this.fW = fW;
    }
    $$Record66.
        prototype.$c = function () {
        return new $$Record66(this.cS, this.b, this.ev, this.fW);
    };
    function $$Record67(ke, kT, e4, e5, lh, fc, fh, ho, l8, c8, ew, oN, pv, gj, dr) {
        this.
            ke = ke;
        this.kT = kT;
        this.e4 = e4;
        this.e5 = e5;
        this.lh = lh;
        this
            .fc = fc;
        this.fh = fh;
        this.ho = ho;
        this.l8 = l8;
        this.c8 = c8;
        this.ew = ew;
        this.
            oN = oN;
        this.pv = pv;
        this.gj = gj;
        this
            .dr = dr;
    }
    $$Record67.prototype.$c = function () {
        return new $$Record67(this.ke, this
            .kT, this.e4, this.e5, this.
            lh, this.fc, this.fh, this.ho, this.l8, this.c8, this.ew, this.oN, this.pv, this.gj, this.dr);
    };
    function $$Record68(J, aA, K, bY, bZ, b4, hj, aa, cY, iT, f, pO, gq) {
        this.J = J;
        this.aA = aA;
        this.K =
            K;
        this.bY = bY;
        this.bZ = bZ;
        this.b4
            = b4;
        this.hj = hj;
        this.aa = aa;
        this.cY = cY;
        this.iT = iT;
        this.f =
            f;
        this.pO = pO;
        this.gq = gq;
    }
    $$Record68.prototype.$c = function () {
        return new $$Record68(this.J, this.aA, this.K, this.bY, this.bZ, this.b4, this.hj, this.aa, this.cY, this.iT, this.f, this.pO, this.gq);
    };
    function $$Record69(n, m0, at) {
        this.n = n;
        this.m0 = m0;
        this
            .at = at;
    }
    $$Record69.
        prototype.$c = function () {
        return new $$Record69(this.
            n, this.m0, this.at);
    };
    function $$Record70(a, l8, at, oO) {
        this.a = a;
        this.l8 = l8;
        this.at = at;
        this.oO = oO;
    }
    $$Record70.prototype.$c = function () {
        return new $$Record70(this.a, this.l8, this.at, this.oO);
    };
    function $$Record71(e8, cS, hr, hV, pv, pR) {
        this.e8 = e8;
        this.cS = cS;
        this.hr = hr;
        this.hV = hV;
        this.pv =
            pv;
        this.pR = pR;
    }
    $$Record71.prototype.$c = function () {
        return new $$Record71(this.e8, this.cS, this.hr, this.hV, this.pv, this.pR);
    };
    function $$Record72(gB, kg, kB, g7, cS, l8, mn, nN, nS, o0, pL) {
        this.gB
            = gB;
        this.kg = kg;
        this.kB = kB;
        this.g7 = g7;
        this.cS = cS;
        this.l8 = l8;
        this.mn = mn;
        this.nN = nN;
        this.nS = nS;
        this.o0 = o0;
        this.pL = pL;
    }
    $$Record72.prototype.$c = function () {
        return new $$Record72(this.gB, this.kg, this.kB, this.g7, this.cS, this.l8, this.mn, this.nN, this.nS, this.o0, this.pL);
    };
    function $$Record73(mH) {
        this.mH = mH;
    }
    $$Record73.prototype.$c = function () {
        return new $$Record73(this.mH);
    };
    function $$Record74(e7, fe, hP, fA, gk) {
        this.e7 = e7;
        this.fe = fe;
        this.
            hP = hP;
        this.fA = fA;
        this.gk = gk;
    }
    $$Record74.prototype.$c = function () {
        return new $$Record74(this.e7, this.fe, this.hP, this.fA, this.gk);
    };
    function $$Record75(cK, dJ, cR, bq, b8, cf, c1, Y, dn) {
        this.cK
            = cK;
        this.dJ = dJ;
        this.cR = cR;
        this.bq = bq;
        this.b8 = b8;
        this.cf = cf;
        this.c1 = c1;
        this.Y = Y;
        this.dn = dn;
    }
    $$Record75.prototype.$c = function () {
        return new $$Record75(this.cK, this.dJ, this.cR, this.bq, this.b8, this.cf, this.c1, this.Y, this.dn);
    };
    function $$Record76(gz, ip, f6) {
        this.gz = gz;
        this.ip = ip;
        this.f6 = f6;
    }
    $$Record76.prototype.$c = function () {
        return new $$Record76(this.gz, this.ip, this.f6);
    };
    function $$Record77(lc, l8, pS) {
        this.lc = lc;
        this.l8 = l8;
        this.pS = pS;
    }
    $$Record77.prototype.$c = function () {
        return new $$Record77(this.lc, this.l8, this.pS);
    };
    function $$Record78(eX, dG, g6, fU, jh) {
        this.eX = eX;
        this.dG = dG;
        this.g6 = g6;
        this.fU = fU;
        this.jh = jh;
    }
    $$Record78.prototype.$c = function () {
        return new $$Record78(this.eX, this.dG, this.g6, this.fU, this.jh);
    };
    function $$Record79(j5, dG, an, hG, id, ak, pI, dt) {
        this.j5 = j5;
        this.dG = dG;
        this.an = an;
        this.hG = hG;
        this.id = id;
        this.
            ak = ak;
        this.pI = pI;
        this.dt = dt;
    }
    $$Record79.prototype.$c = function () {
        return new $$Record79(this.j5, this.dG, this.an, this.hG, this.id, this.ak, this.pI, this.dt);
    };
    function $$Record80(dG, an, hG, id, ak, pI, dt) {
        this.dG = dG;
        this.an =
            an;
        this.hG = hG;
        this.id = id;
        this.ak = ak;
        this.pI = pI;
        this.dt = dt;
    }
    $$Record80.prototype.$c = function () {
        return new $$Record80(this.dG, this.an, this.hG, this.
            id, this.ak, this.pI, this.dt);
    };
    function $$Record81(cS, l8) {
        this.
            cS = cS;
        this.l8 = l8;
    }
    $$Record81.prototype.$c = function () {
        return new $$Record81(this.cS, this.l8);
    };
    function $$Record82(kg, dG, an, aF, fm, ak) {
        this.kg = kg;
        this.dG = dG;
        this.an = an;
        this.aF = aF;
        this.fm = fm;
        this.ak = ak;
    }
    $$Record82.prototype.$c = function () {
        return new $$Record82(this.kg, this.dG, this.an, this.aF, this.fm, this.ak);
    };
    function $$Record83(b7, mT, gj) {
        this.b7 = b7;
        this.mT = mT;
        this.gj = gj;
    }
    $$Record83.prototype.$c = function () {
        return new $$Record83(this.b7, this.mT, this.gj);
    };
    function $$Record84(dV, ek) {
        this.dV = dV;
        this.ek = ek;
    }
    $$Record84.prototype.$c = function () {
        return new $$Record84(this.dV, this.ek);
    };
    function $$Record85(cS, b, iB) {
        this.
            cS = cS;
        this.b = b;
        this.iB = iB;
    }
    $$Record85.prototype.$c = function () {
        return new $$Record85(this.cS, this.b, this.iB);
    };
    function $$Record86(jV, gV, g0, k4, g2, hd, hk, hD, hJ, il, im, iH, iI, bb, f0, be, oB, po, jG) {
        this.jV = jV;
        this.gV = gV;
        this.g0 = g0;
        this.k4 = k4;
        this.
            g2 = g2;
        this.hd = hd;
        this.hk = hk;
        this.hD = hD;
        this.hJ = hJ;
        this.il =
            il;
        this.im = im;
        this.iH = iH;
        this.iI = iI;
        this.bb = bb;
        this.f0 = f0;
        this.be
            = be;
        this.oB = oB;
        this.po = po;
        this.jG = jG;
    }
    $$Record86.prototype.$c = function () {
        return new $$Record86(this.jV, this.gV, this.g0, this
            .k4, this.g2, this.hd, this.hk, this.hD, this.hJ, this.il, this.im, this.iH, this.iI, this.bb, this.f0, this.be, this.oB, this.po, this.jG);
    };
    function $$Record87(bo, b6, d7, nJ, bF, gj) {
        this.bo = bo;
        this.b6 = b6;
        this.d7 = d7;
        this.nJ = nJ;
        this.bF = bF;
        this.gj = gj;
    }
    $$Record87.prototype.$c = function () {
        return new $$Record87(this.bo, this.
            b6, this.d7, this.nJ, this.bF, this.gj);
    };
    function $$Record88(b7, mT, oN, gj) {
        this.b7 = b7;
        this.mT = mT;
        this.oN = oN;
        this.gj = gj;
    }
    $$Record88.prototype.$c = function () {
        return new $$Record88(this.b7, this.mT, this.oN, this.gj);
    };
    function $$Record89(jR, f6, pD) {
        this.jR = jR;
        this.f6 = f6;
        this.pD = pD;
    }
    $$Record89.prototype.
        $c = function () {
        return new $$Record89(this.jR, this.f6, this.pD);
    };
    function $$Record90(ma, c0, bP) {
        this
            .ma = ma;
        this.c0 = c0;
        this.bP = bP;
    }
    $$Record90.prototype.$c = function () {
        return new $$Record90(this.ma, this.c0, this.bP);
    };
    function $$Record91(a, l8, at) {
        this.a = a;
        this.l8 = l8;
        this.at = at;
    }
    $$Record91.prototype.$c = function () {
        return new $$Record91(this.a, this.l8, this.at);
    };
    function $$Record92(l8, at) {
        this.l8 = l8;
        this.at = at;
    }
    $$Record92.prototype.$c = function () {
        return new $$Record92(this.l8, this.at);
    };
    function $$Record93(_, a, l8, al) {
        this._ = _;
        this.a = a;
        this
            .l8 = l8;
        this.al = al;
    }
    $$Record93.prototype.$c = function () {
        return new $$Record93(this
            ._, this.a, this.l8, this.al);
    };
    function $$Record94(_, l8, al) {
        this._ = _;
        this.l8 = l8;
        this.al = al;
    }
    $$Record94.prototype.$c = function () {
        return new $$Record94(this._, this.l8, this.al);
    };
    function $$Record95(e3, d4, fM, l, ir, as, ae, bb, f0, be, dj, pK) {
        this.e3 = e3;
        this.d4 =
            d4;
        this.fM = fM;
        this.l = l;
        this.ir = ir;
        this.as = as;
        this.ae = ae;
        this.bb = bb;
        this.f0 = f0;
        this.be = be;
        this.dj = dj;
        this.pK = pK;
    }
    $$Record95.prototype.$c = function () {
        return new $$Record95(this.e3, this.d4, this
            .fM, this.l, this.ir, this.as, this.ae, this.bb, this.f0, this.be, this.dj, this.pK);
    };
    function $$Record96(a, b) {
        this.a = a;
        this.b = b;
    }
    $$Record96.prototype.$c = function () {
        return new $$Record96(this.a, this.b);
    };
    function $$Record97(eX, e1, fF) {
        this.eX = eX;
        this.e1
            = e1;
        this.fF = fF;
    }
    $$Record97.prototype.$c = function () {
        return new $$Record97(this.eX, this.e1, this.fF);
    };
    function $$Record98(fB, em, eD) {
        this.fB = fB;
        this.em = em;
        this.eD = eD;
    }
    $$Record98.prototype.$c = function () {
        return new $$Record98(this.fB, this.em, this.eD);
    };
    function $$Record99(gH, ct) {
        this.gH = gH;
        this.ct = ct;
    }
    $$Record99.prototype.$c =
        function () {
            return new $$Record99(this.gH, this.ct);
        };
    function $$Record100(az, b9) {
        this.az = az;
        this.b9 = b9;
    }
    $$Record100.prototype.$c = function () {
        return new $$Record100(this.az, this.b9);
    };
    function $$Record101(a, at) {
        this.a = a;
        this.at = at;
    }
    $$Record101
        .prototype.$c = function () {
        return new $$Record101(this.a, this.at);
    };
    function $$Record102(he, l8) {
        this.he = he;
        this.l8
            = l8;
    }
    $$Record102.prototype.$c = function () {
        return new $$Record102(this.he, this.l8);
    };
    function $$Record103(mn, pL) {
        this.mn = mn;
        this.pL = pL;
    }
    $$Record103
        .prototype.$c = function () {
        return new $$Record103(this.mn, this.pL);
    };
    function $$Record104(dG, hG, id, n9, ak, dt) {
        this.dG = dG;
        this.hG = hG;
        this.id = id;
        this.n9 = n9;
        this.ak = ak;
        this.dt = dt;
    }
    $$Record104.prototype.$c = function () {
        return new $$Record104(this.dG, this.hG, this.id, this
            .n9, this.ak, this.dt);
    };
    function $$Record105(b4, l8, h5, i$) {
        this.b4 = b4;
        this.l8 = l8;
        this.h5 = h5;
        this.i$ = i$;
    }
    $$Record105.prototype.$c = function () {
        return new $$Record105(this.
            b4, this.l8, this.h5, this.i$);
    };
    function $$Record106(cK, b8, cf, c1, dn) {
        this.cK = cK;
        this.b8 = b8;
        this.cf = cf;
        this.c1 = c1;
        this.dn = dn;
    }
    $$Record106.prototype.$c
        = function () {
            return new $$Record106(this.cK, this.b8, this.cf, this.c1, this.dn);
        };
    function $$Record107(cR, bq, b8, cf, c1, Y, dn) {
        this.cR = cR;
        this.bq = bq;
        this.b8 = b8;
        this.cf = cf;
        this.c1 = c1;
        this.Y = Y;
        this.dn = dn;
    }
    $$Record107.prototype.$c = function () {
        return new $$Record107(this.cR, this.bq, this
            .b8, this.cf, this.c1, this.Y, this.dn);
    };
    function $$Record108(b6, l8, bF) {
        this.b6 = b6;
        this.l8 = l8;
        this.bF = bF;
    }
    $$Record108.prototype.$c = function () {
        return new $$Record108(this.b6, this.l8, this.bF);
    };
    function $$Record109(dV, b9, mp, mq) {
        this.dV = dV;
        this.b9 = b9;
        this.mp = mp;
        this.mq = mq;
    }
    $$Record109.prototype.
        $c = function () {
        return new $$Record109(this.dV, this.b9, this.mp, this.
            mq);
    };
    function $$Record110(jP, eY, jX, jY, jZ, j_, j$, j0, j1, gD, gE, j3, eZ, e_, j7, kl, km, kr, kt, ku, dH, kv, dK, kL, kM, kN, aC, dN, dO, dP, aD, cL, dQ, k_, k9, la, lK, hv, lO, lT, fn, fp, hH, fq, hI, l$, l9, mc, d5, mi, mj, mk, ml, mm, mz, h1, cl, $9, ny, nA, bA, nG, ix, iy, nK, od, of, ol, om, on, oo, oC, oF, oI, oW, jn, pa, pb, pc, pd, pe, eO, pf, pg, ph, pi, pj, pk, pl, pm, jx, bJ, pN, gs, jK, gt, jL, gv) {
        this.jP
            = jP;
        this.eY = eY;
        this.jX = jX;
        this.jY = jY;
        this.jZ = jZ;
        this.j_ = j_;
        this.j$ = j$;
        this.j0 = j0;
        this.
            j1 = j1;
        this.gD = gD;
        this.gE = gE;
        this.
            j3 = j3;
        this.eZ = eZ;
        this.e_ = e_;
        this.j7 = j7;
        this
            .kl = kl;
        this.km = km;
        this.kr = kr;
        this.kt = kt;
        this.ku = ku;
        this.dH = dH;
        this.kv = kv;
        this.dK = dK;
        this.kL =
            kL;
        this.kM = kM;
        this.kN = kN;
        this.aC = aC;
        this.dN = dN;
        this.dO = dO;
        this.dP = dP;
        this.aD = aD;
        this.cL = cL;
        this.dQ = dQ;
        this.k_ = k_;
        this.k9 = k9;
        this.la = la;
        this.lK = lK;
        this.hv = hv;
        this.lO
            = lO;
        this.lT = lT;
        this.fn = fn;
        this.fp = fp;
        this
            .hH = hH;
        this.fq = fq;
        this.hI = hI;
        this.l$ = l$;
        this.l9 = l9;
        this.mc = mc;
        this.d5 = d5;
        this.mi = mi;
        this.mj = mj;
        this.mk
            = mk;
        this.ml = ml;
        this.mm = mm;
        this.mz = mz;
        this
            .h1 = h1;
        this.cl = cl;
        this.$9 = $9;
        this.ny =
            ny;
        this.nA = nA;
        this.bA = bA;
        this.nG = nG;
        this.ix = ix;
        this.iy = iy;
        this.nK = nK;
        this
            .od = od;
        this.of
            = of;
        this.ol = ol;
        this.om = om;
        this.on = on;
        this.
            oo = oo;
        this.oC = oC;
        this.oF = oF;
        this.oI = oI;
        this.oW = oW;
        this.jn = jn;
        this.pa = pa;
        this.pb =
            pb;
        this.pc = pc;
        this.pd = pd;
        this.pe = pe;
        this.eO = eO;
        this.pf = pf;
        this.pg =
            pg;
        this.ph = ph;
        this.pi = pi;
        this.pj = pj;
        this.pk = pk;
        this.pl = pl;
        this.pm = pm;
        this.jx = jx;
        this.bJ = bJ;
        this.pN = pN;
        this.gs = gs;
        this.jK
            = jK;
        this.gt
            = gt;
        this.jL = jL;
        this.gv = gv;
    }
    $$Record110.prototype.$c = function () {
        return new $$Record110(this.
            jP, this.eY, this.jX, this.jY, this.jZ, this.j_, this.j$, this.j0, this.j1, this
            .gD, this.gE, this.j3, this.eZ, this.e_, this.j7, this.kl, this.km, this.kr, this.kt, this.ku, this.dH, this.kv, this.dK, this.kL, this.kM, this.kN, this.aC, this.dN, this.dO, this.dP, this.aD, this.cL, this.dQ, this.k_, this.k9, this.la, this.lK, this.hv, this.lO, this.lT, this.fn, this.fp, this.hH, this.fq, this.hI, this.
            l$, this
            .l9, this.mc, this.d5, this.mi, this.mj, this.mk, this.ml, this.
            mm, this.mz, this.h1, this.cl, this.$9, this.ny, this.nA, this.bA, this.nG, this.ix, this.iy, this.nK, this.od, this.of, this.ol, this.om, this.on, this.oo, this.oC, this.oF, this.oI, this.oW, this.jn, this.pa, this.pb, this.pc, this.pd, this.pe, this.eO, this
            .pf, this.pg, this.ph, this.pi, this.pj, this.pk, this.pl, this.pm, this.
            jx, this.bJ, this.pN, this.gs, this.jK, this.gt, this.jL, this.gv);
    };
    function $$Record111(dM, y, bc, ah) {
        this.dM = dM;
        this.y = y;
        this.bc =
            bc;
        this.ah = ah;
    }
    $$Record111.prototype.$c
        = function () {
            return new $$Record111(this.dM, this.y, this
                .bc, this.ah);
        };
    function $$Record112(fo, oE, jF) {
        this.fo = fo;
        this.oE = oE;
        this.jF = jF;
    }
    $$Record112.prototype.$c = function () {
        return new $$Record112(this.fo, this.oE, this.jF);
    };
    function $$Record113(gK, dG, cJ, e2, dL, b3, fo, nf, c7, dc, de, i5, co, gj, jJ) {
        this.gK = gK;
        this.dG = dG;
        this.cJ = cJ;
        this.e2 = e2;
        this.dL = dL;
        this.b3 = b3;
        this.fo = fo;
        this.nf =
            nf;
        this.c7 = c7;
        this
            .dc = dc;
        this.de = de;
        this.i5 = i5;
        this.co = co;
        this.gj = gj;
        this.jJ = jJ;
    }
    $$Record113.prototype.$c = function () {
        return new $$Record113(this.gK, this.dG, this.cJ, this.e2, this.dL, this.b3, this.fo, this.nf, this.c7, this.dc, this.de, this.i5, this.co, this.gj, this.jJ);
    };
    function $$Record114(fc, oM) {
        this.fc
            = fc;
        this.oM = oM;
    }
    $$Record114.prototype.$c = function () {
        return new $$Record114(this.fc, this.oM);
    };
    function $$Record115(kw, mE, oc, pE) {
        this.kw
            = kw;
        this.mE = mE;
        this.oc = oc;
        this.pE = pE;
    }
    $$Record115.prototype.$c = function () {
        return new $$Record115(this.kw, this.mE, this.oc, this.pE);
    };
    function $$Record116(bz, ck, gh, bO) {
        this.bz = bz;
        this.ck = ck;
        this.gh = gh;
        this.bO = bO;
    }
    $$Record116.prototype.$c = function () {
        return new $$Record116(this.bz, this.ck, this.gh, this.bO);
    };
    function $$Record117(cW, c2) {
        this.cW = cW;
        this.c2 = c2;
    }
    $$Record117.prototype
        .$c = function () {
        return new $$Record117(this.
            cW, this.c2);
    };
    function $$Record118(L, o, x, nJ, cy) {
        this.L =
            L;
        this.o = o;
        this.x = x;
        this.nJ = nJ;
        this.cy = cy;
    }
    $$Record118.prototype.$c = function () {
        return new $$Record118(this.L, this.o, this.x, this.nJ, this.cy);
    };
    function $$Record119(k3, nf, nu, nE) {
        this.k3 = k3;
        this.nf = nf;
        this.nu = nu;
        this.nE = nE;
    }
    $$Record119.prototype.$c = function () {
        return new $$Record119(this.k3, this.nf, this.nu, this.nE);
    };
    function $$Record120(lK, l$, m7) {
        this.lK = lK;
        this.l$ = l$;
        this.m7 = m7;
    }
    $$Record120.prototype.$c = function () {
        return new $$Record120(this.lK, this.l$, this.m7);
    };
    function $$Record121(jT, kG, lp, lL, n8, eG, oy) {
        this.jT = jT;
        this.kG = kG;
        this.lp = lp;
        this.lL = lL;
        this.n8 = n8;
        this
            .eG = eG;
        this.oy = oy;
    }
    $$Record121.prototype.$c = function () {
        return new $$Record121(this.jT, this.kG, this.lp, this.lL, this.n8, this.eG, this.oy);
    };
    function $$Record122(gz, l, ip) {
        this.gz = gz;
        this.l = l;
        this.ip =
            ip;
    }
    $$Record122.prototype.$c = function () {
        return new $$Record122(this.gz, this.l, this.
            ip);
    };
    function $$Record123(aE, nP) {
        this.aE = aE;
        this.nP = nP;
    }
    $$Record123.prototype.$c = function () {
        return new $$Record123(this.aE, this.nP);
    };
    function $$Record124(oN, gj) {
        this.oN = oN;
        this.gj = gj;
    }
    $$Record124.prototype.$c = function () {
        return new $$Record124(this.oN, this.gj);
    };
    function $$Record125(lp, hW, n8) {
        this.lp = lp;
        this.hW = hW;
        this.n8 = n8;
    }
    $$Record125
        .prototype.$c = function () {
        return new $$Record125(this.lp, this.hW, this.n8);
    };
    function $$Record126(jS, O, l, ip, eG) {
        this.jS = jS;
        this.O = O;
        this.l = l;
        this.ip = ip;
        this.eG = eG;
    }
    $$Record126.prototype.$c = function () {
        return new $$Record126(this.jS, this.O, this.l, this.ip, this.eG);
    };
    function $$Record127(bQ, jS, np, p0) {
        this.bQ = bQ;
        this.jS = jS;
        this.np = np;
        this.p0
            = p0;
    }
    $$Record127.prototype.$c = function () {
        return new $$Record127(this.bQ, this.jS, this.np, this.p0);
    };
    function $$Record128(kY, e6, bo, fi) {
        this.kY = kY;
        this.e6 = e6;
        this.bo = bo;
        this.fi = fi;
    }
    $$Record128.prototype.$c = function () {
        return new $$Record128(this.
            kY, this.e6, this.bo, this.fi);
    };
    function $$Record129(dx, eP) {
        this.dx = dx;
        this.eP = eP;
    }
    $$Record129.prototype.$c = function () {
        return new $$Record129(this.dx, this.eP);
    };
    function $$Record130(k5, mu, d8, fO, pu) {
        this.k5 = k5;
        this.mu = mu;
        this.d8 = d8;
        this.fO = fO;
        this.pu = pu;
    }
    $$Record130.prototype.$c = function () {
        return new $$Record130(this.k5, this.mu, this.d8, this.fO, this.pu);
    };
    function $$Record131(k5, fO, nI, pu) {
        this.k5 = k5;
        this.
            fO = fO;
        this.nI = nI;
        this.pu = pu;
    }
    $$Record131.prototype.$c = function () {
        return new $$Record131(this.k5, this.fO, this.nI, this.pu);
    };
    function $$Record132(a, pv) {
        this.a = a;
        this.pv = pv;
    }
    $$Record132
        .prototype.$c = function () {
        return new $$Record132(this.a, this.pv);
    };
    function $$Record133(bq, hp, f6, pn) {
        this.bq = bq;
        this.hp = hp;
        this.f6 = f6;
        this.pn = pn;
    }
    $$Record133.prototype.$c = function () {
        return new $$Record133(this.bq, this.hp, this.f6, this.pn);
    };
    function $$Record134(kQ, fo, of, jJ) {
        this.kQ = kQ;
        this.fo = fo;
        this.of =
            of;
        this.jJ = jJ;
    }
    $$Record134.prototype.$c = function () {
        return new $$Record134(this.kQ, this.fo, this.of, this.jJ);
    };
    function $$Record135(aC, aE, of) {
        this.aC = aC;
        this.aE = aE;
        this.of = of;
    }
    $$Record135.prototype.$c = function () {
        return new $$Record135(this.aC, this.aE, this.of);
    };
    function $$Record136(hF, p$, jJ) {
        this.hF = hF;
        this.p$ = p$;
        this.jJ = jJ;
    }
    $$Record136.prototype.$c = function () {
        return new $$Record136(this.hF, this.p$, this.jJ);
    };
    function $$Record137(k5, hr, fO, nI, pu) {
        this.k5 = k5;
        this.hr = hr;
        this.fO = fO;
        this.nI = nI;
        this.pu = pu;
    }
    $$Record137.prototype.$c = function () {
        return new $$Record137(this.k5, this.hr, this.fO, this.nI, this.pu);
    };
    function $$Record138(gz, nP, f6) {
        this.gz = gz;
        this.nP = nP;
        this.f6 = f6;
    }
    $$Record138.prototype.$c = function () {
        return new $$Record138(this.gz, this.nP, this.f6);
    };
    function $$Record139(iz) {
        this.iz = iz;
    }
    $$Record139.prototype.$c = function () {
        return new $$Record139(this.iz);
    };
    function $$Record140(lq, nP, f6) {
        this.lq = lq;
        this.nP = nP;
        this.f6 = f6;
    }
    $$Record140.
        prototype.$c =
        function () {
            return new $$Record140(this.lq, this.nP, this.f6);
        };
    function $$Record141(a, bq, hg, hp, mX, nv, nx, ok, pn) {
        this.a = a;
        this.bq = bq;
        this.hg = hg;
        this.hp = hp;
        this.mX = mX;
        this.nv = nv;
        this
            .nx = nx;
        this.ok = ok;
        this.pn = pn;
    }
    $$Record141.prototype.$c = function () {
        return new $$Record141(this.a, this.bq, this.hg, this.hp, this.mX, this.nv, this.nx, this.ok, this.pn);
    };
    function $$Record142(h$, $8, b, oE, p_) {
        this.h$ = h$;
        this.$8 = $8;
        this.b = b;
        this.oE = oE;
        this.p_ = p_;
    }
    $$Record142
        .prototype
        .$c = function () {
        return new $$Record142(this.h$, this.$8, this.b, this.oE, this.p_);
    };
    function $$Record143(nE) {
        this.nE = nE;
    }
    $$Record143.prototype.$c = function () {
        return new $$Record143(this
            .nE);
    };
    function $$Record144(kd, ke, eE, gu) {
        this.kd = kd;
        this.ke = ke;
        this.eE = eE;
        this.gu =
            gu;
    }
    $$Record144.prototype.$c = function () {
        return new $$Record144(this.kd, this.ke, this.eE, this.gu);
    };
    function $$Record145(bT, bX) {
        this.bT = bT;
        this.bX = bX;
    }
    $$Record145.prototype.$c = function () {
        return new $$Record145(this.bT, this.bX);
    };
    function $$Record146(nz, a_, nE, bh, jJ) {
        this.nz = nz;
        this.a_ = a_;
        this.nE = nE;
        this.bh
            = bh;
        this.jJ = jJ;
    }
    $$Record146.prototype.$c = function () {
        return new $$Record146(this.nz, this.a_, this.nE, this.bh, this.jJ);
    };
    function $$Record147(f2, gf) {
        this.f2 = f2;
        this
            .gf = gf;
    }
    $$Record147.prototype.
        $c = function () {
        return new $$Record147(this.
            f2, this.gf);
    };
    function $$Record148(kb, nz, a_, nE, fV, bh, jJ) {
        this.kb = kb;
        this.nz = nz;
        this.a_ = a_;
        this.nE = nE;
        this.fV = fV;
        this.bh = bh;
        this.jJ =
            jJ;
    }
    $$Record148.prototype.$c = function () {
        return new $$Record148(this.kb, this.nz, this.a_, this.nE, this.fV, this.bh, this.jJ);
    };
    function $$Record149(eb, ia) {
        this.eb = eb;
        this.ia = ia;
    }
    $$Record149.prototype.$c = function () {
        return new $$Record149(this.eb, this.ia);
    };
    function $$Record150(gy, gU, ca, lL, fG, cg, aV, ch, ci, bw, bx, ap, aZ, cr, cv, dq, p_) {
        this.gy = gy;
        this.gU = gU;
        this.ca = ca;
        this.lL = lL;
        this.fG = fG;
        this.cg = cg;
        this.aV = aV;
        this.ch = ch;
        this
            .ci = ci;
        this.bw = bw;
        this.bx = bx;
        this.ap = ap;
        this.aZ = aZ;
        this.cr = cr;
        this.cv = cv;
        this.dq = dq;
        this.p_ = p_;
    }
    $$Record150.prototype.$c
        = function () {
            return new $$Record150(this
                .gy, this.gU, this
                .ca, this.lL, this.fG, this.cg, this.aV, this.ch, this.ci, this.bw, this.bx, this.
                ap, this.aZ, this
                .cr, this.cv, this
                .dq, this.p_);
        };
    function $$Record151(le, b) {
        this.le = le;
        this.b = b;
    }
    $$Record151.prototype.$c = function () {
        return new $$Record151(this.le, this
            .b);
    };
    function $$Record152(dG, kq, kP, kZ, lM, lN, hF, lX, mS) {
        this.dG = dG;
        this.kq =
            kq;
        this.kP = kP;
        this.kZ = kZ;
        this.lM = lM;
        this.lN = lN;
        this.hF = hF;
        this.
            lX = lX;
        this.mS = mS;
    }
    $$Record152.prototype.$c
        = function () {
            return new $$Record152(this.dG, this.kq, this.kP, this.kZ, this.lM, this.lN, this.hF, this.lX, this.mS);
        };
    function $$Record153(d2) {
        this.d2 = d2;
    }
    $$Record153.prototype.$c = function () {
        return new $$Record153(this.d2);
    };
    function $$Record154(g, e1, fc, gj) {
        this
            .g = g;
        this.e1 = e1;
        this.fc = fc;
        this.gj = gj;
    }
    $$Record154.prototype.$c = function () {
        return new $$Record154(this.g, this.e1, this.fc, this.gj);
    };
    function $$Record155(dG, gj) {
        this.dG = dG;
        this.gj = gj;
    }
    $$Record155.prototype.$c = function () {
        return new $$Record155(this.dG, this.gj);
    };
    function $$update__bO__bz__c2__cW__lb__m1__or(obj, bO, bz, c2, cW, lb, m1, or) {
        var $r = obj.$c();
        $r.bO = bO;
        $r.bz = bz;
        $r.c2 =
            c2;
        $r.cW = cW;
        $r.lb = lb;
        $r.m1 = m1;
        $r.or = or;
        return $r;
    }
    function $$update__n(obj, n) {
        var $r = obj
            .$c();
        $r.n = n;
        return $r;
    }
    function $$update__a0__a1__a2__a3__a4__a5__a6__a7__a8__a9__aL__aM__aN__aO__aP__aQ__aR__aS__aT__aU__ba__pn(obj, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, aL, aM, aN, aO, aP, aQ, aR, aS, aT, aU, ba, pn) {
        var $r = obj.$c();
        $r.a0 = a0;
        $r
            .a1 = a1;
        $r.a2 = a2;
        $r
            .a3 = a3;
        $r.a4 = a4;
        $r.a5 =
            a5;
        $r.a6 = a6;
        $r.a7 = a7;
        $r.a8 = a8;
        $r.a9 = a9;
        $r.aL = aL;
        $r.aM = aM;
        $r.aN = aN;
        $r.aO = aO;
        $r.aP = aP;
        $r.aQ = aQ;
        $r.aR = aR;
        $r.aS = aS;
        $r
            .aT = aT;
        $r.aU = aU;
        $r.ba = ba;
        $r.pn = pn;
        return $r;
    }
    function $$update__ix(obj, ix) {
        var $r = obj.$c();
        $r.ix = ix;
        return $r;
    }
    function $$update__kd(obj, kd) {
        var $r = obj.$c();
        $r
            .kd = kd;
        return $r;
    }
    function $$update__bO__bz__lb(obj, bO, bz, lb) {
        var $r = obj.$c();
        $r.bO = bO;
        $r.bz = bz;
        $r.lb = lb;
        return $r;
    }
    function $$update__J(obj, J) {
        var $r = obj.$c();
        $r.J = J;
        return $r;
    }
    function $$update__K(obj, K) {
        var $r = obj.$c();
        $r.K = K;
        return $r;
    }
    function $$update__pn(obj, pn) {
        var $r = obj.$c();
        $r.pn = pn;
        return $r;
    }
    function $$update__ft(obj, ft) {
        var $r = obj.$c();
        $r.ft = ft;
        return $r;
    }
    function $$update__dW(obj, dW) {
        var $r = obj.$c();
        $r.dW = dW;
        return $r;
    }
    function $$update__n__p5(obj, n, p5) {
        var $r = obj.$c();
        $r.n = n;
        $r.p5 = p5;
        return $r;
    }
    function $$update__fO__iz(obj, fO, iz) {
        var $r = obj.$c();
        $r.fO = fO;
        $r.iz = iz;
        return $r;
    }
    function $$update__fR__pR(obj, fR, pR) {
        var $r = obj.$c();
        $r.fR = fR;
        $r.pR =
            pR;
        return $r;
    }
    function $$update__ai(obj, ai) {
        var $r = obj.$c();
        $r
            .ai = ai;
        return $r;
    }
    function $$update__bP(obj, bP) {
        var $r = obj.
            $c();
        $r.bP = bP;
        return $r;
    }
    function $$update__fO(obj, fO) {
        var $r = obj.$c();
        $r.fO = fO;
        return $r;
    }
    function $$update__oV(obj, oV) {
        var $r = obj.$c();
        $r.oV = oV;
        return $r;
    }
    function $$update__iz(obj, iz) {
        var $r = obj.$c();
        $r.iz = iz;
        return $r;
    }
    function $$update__mY(obj, mY) {
        var $r = obj.$c();
        $r.mY = mY;
        return $r;
    }
    function $$update__db__e3(obj, db, e3) {
        var $r = obj.$c();
        $r.db = db;
        $r.e3 =
            e3;
        return $r;
    }
    function $$update__ed(obj, ed) {
        var $r = obj.$c();
        $r.ed = ed;
        return $r;
    }
    function $$update__pV(obj, pV) {
        var $r = obj.$c();
        $r.pV = pV;
        return $r;
    }
    function $$update__o5(obj, o5) {
        var $r = obj.$c();
        $r.o5 = o5;
        return $r;
    }
    function $$update__db(obj, db) {
        var $r = obj.$c();
        $r.db = db;
        return $r;
    }
    function $$update__oX(obj, oX) {
        var $r = obj.$c();
        $r
            .oX = oX;
        return $r;
    }
    function $$update__dj(obj, dj) {
        var $r = obj.$c();
        $r.dj = dj;
        return $r;
    }
    function $$update__ke(obj, ke) {
        var $r = obj.$c();
        $r.ke = ke;
        return $r;
    }
    function $$update__o_(obj, o_) {
        var $r = obj.$c();
        $r.o_ = o_;
        return $r;
    }
    function $$update__ld(obj, ld) {
        var $r = obj.$c();
        $r.ld = ld;
        return $r;
    }
    function $$update__fh__gh__hh(obj, fh, gh, hh) {
        var $r = obj.$c();
        $r.fh = fh;
        $r.gh = gh;
        $r.hh = hh;
        return $r;
    }
    function $$update__e3(obj, e3) {
        var $r = obj.$c();
        $r.e3 = e3;
        return $r;
    }
    function $$update__lw(obj, lw) {
        var $r = obj.$c();
        $r.lw = lw;
        return $r;
    }
    function $$update__gh(obj, gh) {
        var $r = obj.$c();
        $r.
            gh = gh;
        return $r;
    }
    function $$update__oq(obj, oq) {
        var $r = obj.$c();
        $r.oq = oq;
        return $r;
    }
    function $$update__kf(obj, kf) {
        var $r = obj.$c();
        $r.kf = kf;
        return $r;
    }
    function $$update__kW(obj, kW) {
        var $r = obj.
            $c();
        $r.kW = kW;
        return $r;
    }
    function $$update__z(obj, z) {
        var $r = obj.$c();
        $r.z = z;
        return $r;
    }
    function $$update__bQ(obj, bQ) {
        var $r = obj.$c();
        $r.bQ = bQ;
        return $r;
    }
    function $$update__eG(obj, eG) {
        var $r = obj.$c();
        $r.eG = eG;
        return $r;
    }
    function $$update__lh(obj, lh) {
        var $r = obj.$c();
        $r.lh = lh;
        return $r;
    }
    function $$update__f6__fc__gz(obj, f6, fc, gz) {
        var $r = obj.$c();
        $r.f6 = f6;
        $r.fc = fc;
        $r.gz = gz;
        return $r;
    }
    function $$update__ar__bE(obj, ar, bE) {
        var $r = obj.$c();
        $r.ar = ar;
        $r.bE = bE;
        return $r;
    }
    function $$update__cE(obj, cE) {
        var $r = obj.$c();
        $r.cE = cE;
        return $r;
    }
    function $$update__ff(obj, ff) {
        var $r = obj.$c();
        $r.ff = ff;
        return $r;
    }
    function $$update__lo(obj, lo) {
        var $r = obj.
            $c();
        $r.lo = lo;
        return $r;
    }
    function $$update__bp(obj, bp) {
        var $r = obj.$c();
        $r.bp =
            bp;
        return $r;
    }
    function $$update__au(obj, au) {
        var $r = obj.$c();
        $r.au = au;
        return $r;
    }
    function $$update__c5(obj, c5) {
        var $r = obj.$c();
        $r.c5 = c5;
        return $r;
    }
    function $$update__dW__ix(obj, dW, ix) {
        var $r = obj.$c();
        $r.
            dW = dW;
        $r.ix = ix;
        return $r;
    }
    function $$update__kn(obj, kn) {
        var $r = obj.$c();
        $r.kn = kn;
        return $r;
    }
    function $$update__ot(obj, ot) {
        var $r = obj.$c();
        $r.ot = ot;
        return $r;
    }
    function $$update__lR(obj, lR) {
        var $r = obj.$c();
        $r.lR = lR;
        return $r;
    }
    function $$update__j9(obj, j9) {
        var $r = obj.$c();
        $r.j9 = j9;
        return $r;
    }
    function $$update__lF(obj, lF) {
        var $r = obj.$c();
        $r.lF = lF;
        return $r;
    }
    function $$update__y(obj, y) {
        var $r = obj.$c();
        $r.y = y;
        return $r;
    }
    function $$update__kw(obj, kw) {
        var $r = obj.$c();
        $r.kw = kw;
        return $r;
    }
    function $$update__dG__de__e2__gK__gj__i5__jJ(obj, dG, de, e2, gK, gj, i5, jJ) {
        var $r = obj.$c();
        $r.dG = dG;
        $r.de = de;
        $r.e2 = e2;
        $r.gK = gK;
        $r.gj = gj;
        $r.i5 = i5;
        $r.jJ = jJ;
        return $r;
    }
    function $$update__dG__dL__de__gj(obj, dG, dL, de, gj) {
        var $r = obj.$c();
        $r.dG = dG;
        $r.dL = dL;
        $r.de = de;
        $r.gj
            = gj;
        return $r;
    }
    function $$update__pE(obj, pE) {
        var $r = obj.
            $c();
        $r.pE = pE;
        return $r;
    }
    function $$update__dG__dL__jJ(obj, dG, dL, jJ) {
        var $r = obj.$c();
        $r.dG = dG;
        $r.dL = dL;
        $r.jJ = jJ;
        return $r;
    }
    function $$update__nJ(obj, nJ) {
        var $r = obj.$c();
        $r.nJ = nJ;
        return $r;
    }
    function $$update__o(obj, o) {
        var $r = obj.$c();
        $r.o = o;
        return $r;
    }
    function $$update__nJ__o(obj, nJ, o) {
        var $r = obj.$c();
        $r.nJ = nJ;
        $r.o = o;
        return $r;
    }
    function $$update__L__nJ(obj, L, nJ) {
        var $r = obj.$c();
        $r.L = L;
        $r.nJ = nJ;
        return $r;
    }
    function $$update__x(obj, x) {
        var $r = obj.$c();
        $r.x = x;
        return $r;
    }
    function $$update__dG__de(obj, dG, de) {
        var $r = obj.$c();
        $r.dG = dG;
        $r.de = de;
        return $r;
    }
    function $$update__dG(obj, dG) {
        var $r = obj.$c();
        $r.dG = dG;
        return $r;
    }
    function $$update__co__dG__de(obj, co, dG, de) {
        var $r = obj.
            $c();
        $r.co = co;
        $r.dG = dG;
        $r.de = de;
        return $r;
    }
    function $$update__mE(obj, mE) {
        var $r = obj.$c();
        $r
            .mE = mE;
        return $r;
    }
    function F(arity, fun, wrapper) {
        wrapper.a = arity;
        wrapper.f = fun;
        return wrapper;
    }
    function F2(fun) {
        var curried = function (a) {
            return function (b) {
                return fun(a, b);
            };
        };
        curried.a2 = fun;
        return curried;
    }
    function F3(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return fun(a, b, c);
                };
            };
        };
        curried.a3 =
            fun;
        return curried;
    }
    function F4(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return fun(a, b, c, d);
                    };
                };
            };
        };
        curried.a4 = fun;
        return curried;
    }
    function F5(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return fun(a, b, c, d, e);
                        };
                    };
                };
            };
        };
        curried.a5 = fun;
        return curried;
    }
    function F6(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return function (f) {
                                return fun(a, b, c, d, e, f);
                            };
                        };
                    };
                };
            };
        };
        curried.a6 = fun;
        return curried;
    }
    function F7(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return function (f) {
                                return function (g) { return fun(a, b, c, d, e, f, g); };
                            };
                        };
                    };
                };
            };
        };
        curried.
            a7 = fun;
        return curried;
    }
    function F8(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return function (f) {
                                return function (g) {
                                    return function (h) {
                                        return fun(a, b, c, d, e, f, g, h);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
        curried.a8 = fun;
        return curried;
    }
    function F9(fun) {
        var curried = function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return function (f) {
                                return function (g) {
                                    return function (h) {
                                        return function (i) {
                                            return fun(a, b, c, d, e, f, g, h, i);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
        curried
            .a9 = fun;
        return curried;
    }
    function A2(fun, a, b) {
        return fun.a2 ? fun.a2(a, b) : fun(a)(b);
    }
    function A3(fun, a, b, c) {
        return fun.a3 ? fun.a3(a, b, c) : fun(a)(b)(c);
    }
    function A4(fun, a, b, c, d) {
        return fun.a4 ? fun.a4(a, b, c, d) : fun(a)(b)(c)(d);
    }
    function A5(fun, a, b, c, d, e) {
        return fun.a5 ? fun.a5(a, b, c, d, e)
            : fun(a)(b)(c)(d)(e);
    }
    function A6(fun, a, b, c, d, e, f) {
        return fun.a6 ? fun.a6(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
    }
    function A7(fun, a, b, c, d, e, f, g) {
        return fun.a7 ? fun.a7(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
    }
    function A8(fun, a, b, c, d, e, f, g, h) {
        return fun.a8 ? fun.a8(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
    }
    function A9(fun, a, b, c, d, e, f, g, h, i) {
        return fun.a9 ? fun.a9(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
    }
    var _JsArray_empty = [];
    function _JsArray_singleton(value) {
        return [value];
    }
    function _JsArray_length(array) {
        return array.length;
    }
    var _JsArray_initialize_fn = function (size, offset, func) {
        var result = new Array(size);
        for (var i = 0; i < size; i++) {
            result[i] = func(offset + i);
        }
        return result;
    }, _JsArray_initialize = F3(_JsArray_initialize_fn);
    var _JsArray_initializeFromList_fn = function (max, ls) {
        var result = new Array(max);
        for (var i = 0; i < max && ls.b; i++) {
            result[i] = ls.a;
            ls = ls.b;
        }
        result.length = i;
        return _Utils_Tuple2(result, ls);
    }, _JsArray_initializeFromList = F2(_JsArray_initializeFromList_fn);
    var _JsArray_unsafeGet_fn = function (index, array) {
        return array[index];
    }, _JsArray_unsafeGet = F2(_JsArray_unsafeGet_fn);
    var _JsArray_unsafeSet_fn = function (index, value, array) {
        var length = array.length;
        var result = new Array(length);
        for (var i = 0; i < length; i++) {
            result[i] = array[i];
        }
        result[index] = value;
        return result;
    }, _JsArray_unsafeSet = F3(_JsArray_unsafeSet_fn);
    var _JsArray_push_fn = function (value, array) {
        var length = array.length;
        var result = new Array(length + 1);
        for (var i = 0; i < length; i++) {
            result[i] = array[i];
        }
        result[length] = value;
        return result;
    }, _JsArray_push = F2(_JsArray_push_fn);
    var _JsArray_foldl_fn = function (func, acc, array) {
        var length = array.length;
        for (var i = 0; i < length; i++) {
            acc = A2(func, array[i], acc);
        }
        return acc;
    }, _JsArray_foldl_fn_unwrapped = function (func, acc, array) {
        var length = array.length;
        for (var i = 0; i < length; i++) {
            acc = func(array[i], acc);
        }
        return acc;
    }, _JsArray_foldl = F3(_JsArray_foldl_fn);
    var _JsArray_foldr_fn = function (func, acc, array) {
        for (var i = array.length - 1; i >= 0; i--) {
            acc = A2(func, array[i], acc);
        }
        return acc;
    }, _JsArray_foldr_fn_unwrapped = function (func, acc, array) {
        for (var i = array.length - 1; i >= 0; i--) {
            acc = func(array[i], acc);
        }
        return acc;
    }, _JsArray_foldr = F3(_JsArray_foldr_fn);
    var _JsArray_map_fn = function (func, array) {
        var length = array.length;
        var result = new Array(length);
        for (var i = 0; i < length; i++) {
            result[i] = func(array[i]);
        }
        return result;
    }, _JsArray_map = F2(_JsArray_map_fn);
    var _JsArray_indexedMap_fn = function (func, offset, array) {
        var length = array.length;
        var result = new Array(length);
        for (var i = 0; i < length; i++) {
            result[i] = A2(func, offset + i, array[i]);
        }
        return result;
    }, _JsArray_indexedMap_fn_unwrapped = function (func, offset, array) {
        var length = array.length;
        var result = new Array(length);
        for (var i = 0; i < length; i++) {
            result[i] = func(offset + i, array[i]);
        }
        return result;
    }, _JsArray_indexedMap = F3(_JsArray_indexedMap_fn);
    var _JsArray_slice_fn = function (from, to, array) {
        return array.slice(from, to);
    }, _JsArray_slice = F3(_JsArray_slice_fn);
    var _JsArray_appendN_fn = function (n, dest, source) {
        var destLen = dest.length;
        var itemsToCopy = n - destLen;
        if (itemsToCopy > source.length) {
            itemsToCopy = source.length;
        }
        var size = destLen + itemsToCopy;
        var result = new Array(size);
        for (var i = 0; i < destLen; i++) {
            result[i] = dest[i];
        }
        for (var i = 0; i < itemsToCopy; i++) {
            result[i + destLen] = source[i];
        }
        return result;
    }, _JsArray_appendN = F3(_JsArray_appendN_fn);
    var _Debug_log_fn = function (tag, value) {
        return value;
    }, _Debug_log = F2(_Debug_log_fn);
    var _Debug_log_UNUSED_fn = function (tag, value) {
        console.log(tag + ": " + _Debug_toString(value));
        return value;
    }, _Debug_log_UNUSED = F2(_Debug_log_UNUSED_fn);
    function _Debug_todo(moduleName, region) {
        return function (message) {
            _Debug_crash(8, moduleName, region, message);
        };
    }
    function _Debug_todoCase(moduleName, region, value) {
        return function (message) {
            _Debug_crash(9, moduleName, region, value, message);
        };
    }
    function _Debug_toString(value) {
        return "<internals>";
    }
    function _Debug_toString_UNUSED(value) {
        return _Debug_toAnsiString(false, value);
    }
    function _Debug_toAnsiString(ansi, value) {
        if (typeof value === "function") {
            return _Debug_internalColor(ansi, "<function>");
        }
        if (typeof value === "boolean") {
            return _Debug_ctorColor(ansi, value ? "True" : "False");
        }
        if (typeof value === "number") {
            return _Debug_numberColor(ansi, value + "");
        }
        if (value instanceof String) {
            return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
        }
        if (typeof value === "string") {
            return _Debug_stringColor(ansi, "\"" + _Debug_addSlashes(value, false) + "\"");
        }
        if (typeof value === "object" && "$" in value) {
            var tag = value.$;
            if (typeof tag === "number") {
                return _Debug_internalColor(ansi, "<internals>");
            }
            if (tag[0] === "#") {
                var output = [];
                for (var __keys_k = Object.keys(value || {}), __i_k = 0; __i_k < __keys_k.length; __i_k++) { var k = __keys_k[__i_k];
                    if (k === "$")
                        continue;
                    output.push(_Debug_toAnsiString(ansi, value[k]));
                }
                return "(" + output.join(",") + ")";
            }
            if (tag === "Set_elm_builtin") {
                return _Debug_ctorColor(ansi, "Set")
                    + _Debug_fadeColor(ansi, ".fromList") + " "
                    + _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
            }
            if (tag === "RBNode_elm_builtin" || tag === "RBEmpty_elm_builtin") {
                return _Debug_ctorColor(ansi, "Dict")
                    + _Debug_fadeColor(ansi, ".fromList") + " "
                    + _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
            }
            if (tag === "Array_elm_builtin") {
                return _Debug_ctorColor(ansi, "Array")
                    + _Debug_fadeColor(ansi, ".fromList") + " "
                    + _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
            }
            if (tag === "::" || tag === "[]") {
                var output = "[";
                value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b);
                for (; value.b; value = value.b) {
                    output += "," + _Debug_toAnsiString(ansi, value.a);
                }
                return output + "]";
            }
            var output = "";
            for (var __keys_i = Object.keys(value || {}), __i_i = 0; __i_i < __keys_i.length; __i_i++) { var i = __keys_i[__i_i];
                if (i === "$")
                    continue;
                var str = _Debug_toAnsiString(ansi, value[i]);
                var c0 = str[0];
                var parenless = c0 === "{" || c0 === "(" || c0 === "[" || c0 === "<" || c0 === "\"" || str.indexOf(" ") < 0;
                output += " " + (parenless ? str : "(" + str + ")");
            }
            return _Debug_ctorColor(ansi, tag) + output;
        }
        if (typeof DataView === "function" && value instanceof DataView) {
            return _Debug_stringColor(ansi, "<" + value.byteLength + " bytes>");
        }
        if (typeof File !== "undefined" && value instanceof File) {
            return _Debug_internalColor(ansi, "<" + value.name + ">");
        }
        if (typeof value === "object") {
            var output = [];
            for (var __keys_key = Object.keys(value || {}), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
                var field = key[0] === "_" ? key.slice(1) : key;
                output.push(_Debug_fadeColor(ansi, field) + " = " + _Debug_toAnsiString(ansi, value[key]));
            }
            if (output.length === 0) {
                return "{}";
            }
            return "{ " + output.join(", ") + " }";
        }
        return _Debug_internalColor(ansi, "<internals>");
    }
    function _Debug_addSlashes(str, isChar) {
        var s = str
            .replace(/\\/g, "\\\\")
            .replace(/\n/g, "\\n")
            .replace(/\t/g, "\\t")
            .replace(/\r/g, "\\r")
            .replace(/\v/g, "\\v")
            .replace(/\0/g, "\\0");
        if (isChar) {
            return s.replace(/\'/g, "\\'");
        }
        else {
            return s.replace(/\"/g, "\\\"");
        }
    }
    function _Debug_ctorColor(ansi, string) {
        return ansi ? "\u001B[96m" + string + "\u001B[0m" : string;
    }
    function _Debug_numberColor(ansi, string) {
        return ansi ? "\u001B[95m" + string + "\u001B[0m" : string;
    }
    function _Debug_stringColor(ansi, string) {
        return ansi ? "\u001B[93m" + string + "\u001B[0m" : string;
    }
    function _Debug_charColor(ansi, string) {
        return ansi ? "\u001B[92m" + string + "\u001B[0m" : string;
    }
    function _Debug_fadeColor(ansi, string) {
        return ansi ? "\u001B[37m" + string + "\u001B[0m" : string;
    }
    function _Debug_internalColor(ansi, string) {
        return ansi ? "\u001B[36m" + string + "\u001B[0m" : string;
    }
    function _Debug_toHexDigit(n) {
        return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
    }
    function _Debug_crash(identifier) {
        throw new Error("https://github.com/elm/core/blob/1.0.0/hints/" + identifier + ".md");
    }
    function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4) {
        switch (identifier) {
            case 0:
                throw new Error("What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById(\"elm-node\")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.");
            case 1:
                throw new Error("Browser.application programs cannot handle URLs like this:\n\n    " + document.location.href + "\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.");
            case 2:
                var jsonErrorString = fact1;
                throw new Error("Problem with the flags given to your Elm program on initialization.\n\n" + jsonErrorString);
            case 3:
                var portName = fact1;
                throw new Error("There can only be one port named `" + portName + "`, but your program has multiple.");
            case 4:
                var portName = fact1;
                var problem = fact2;
                throw new Error("Trying to send an unexpected type of value through port `" + portName + "`:\n" + problem);
            case 5:
                throw new Error("Trying to use `(==)` on functions.\nThere is no way to know if functions are \"the same\" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.");
            case 6:
                var moduleName = fact1;
                throw new Error("Your page is loading multiple Elm scripts with a module named " + moduleName + ". Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!");
            case 8:
                var moduleName = fact1;
                var region = fact2;
                var message = fact3;
                throw new Error("TODO in module `" + moduleName + "` " + _Debug_regionToString(region) + "\n\n" + message);
            case 9:
                var moduleName = fact1;
                var region = fact2;
                var value = fact3;
                var message = fact4;
                throw new Error("TODO in module `" + moduleName + "` from the `case` expression "
                    + _Debug_regionToString(region) + "\n\nIt received the following value:\n\n    "
                    + _Debug_toString(value).replace("\n", "\n    ")
                    + "\n\nBut the branch that handles it says:\n\n    " + message.replace("\n", "\n    "));
            case 10:
                throw new Error("Bug in https://github.com/elm/virtual-dom/issues");
            case 11:
                throw new Error("Cannot perform mod 0. Division by zero error.");
        }
    }
    function _Debug_regionToString(region) {
        if (region.bF.c_ === region.b6.c_) {
            return "on line " + region.bF.c_;
        }
        return "on lines " + region.bF.c_ + " through " + region.b6.c_;
    }
    function _Utils_eq(x, y) {
        for (var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack); isEqual && (pair = stack.pop()); isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)) { }
        return isEqual;
    }
    function _Utils_eqHelp(x, y, depth, stack) {
        if (x === y) {
            return true;
        }
        if (typeof x !== "object" || x === null || y === null) {
            typeof x === "function" && _Debug_crash(5);
            return false;
        }
        if (depth > 100) {
            stack.push(_Utils_Tuple2(x, y));
            return true;
        }
        if (x.$ < 0) {
            x = $elm$core$Dict$toList(x);
            y = $elm$core$Dict$toList(y);
        }
        for (var __keys_key = Object.keys(x || {}), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
            if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack)) {
                return false;
            }
        }
        return true;
    }
    var _Utils_equal = F2(_Utils_eq);
    var _Utils_notEqual_fn = function (a, b) { return !_Utils_eq(a, b); }, _Utils_notEqual = F2(_Utils_notEqual_fn);
    function _Utils_cmp(x, y, ord) {
        if (typeof x !== "object") {
            return x === y ? 0 : x < y ? -1 : 1;
        }
        if (typeof x.$ === "undefined") {
            return (ord = _Utils_cmp(x.a, y.a))
                ? ord
                : (ord = _Utils_cmp(x.b, y.b))
                    ? ord
                    : _Utils_cmp(x.c, y.c);
        }
        for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) { }
        return ord || (x.b ? 1 : y.b ? -1 : 0);
    }
    var _Utils_lt_fn = function (a, b) { return _Utils_cmp(a, b) < 0; }, _Utils_lt = F2(_Utils_lt_fn);
    var _Utils_le_fn = function (a, b) { return _Utils_cmp(a, b) < 1; }, _Utils_le = F2(_Utils_le_fn);
    var _Utils_gt_fn = function (a, b) { return _Utils_cmp(a, b) > 0; }, _Utils_gt = F2(_Utils_gt_fn);
    var _Utils_ge_fn = function (a, b) { return _Utils_cmp(a, b) >= 0; }, _Utils_ge = F2(_Utils_ge_fn);
    var _Utils_compare_fn = function (x, y) {
        var n = _Utils_cmp(x, y);
        return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
    }, _Utils_compare = F2(_Utils_compare_fn);
    var _Utils_Tuple0 = 0;
    var _Utils_Tuple0_UNUSED = { $: "#0" };
    function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
    function _Utils_Tuple2_UNUSED(a, b) { return { $: "#2", a: a, b: b }; }
    function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
    function _Utils_Tuple3_UNUSED(a, b, c) { return { $: "#3", a: a, b: b, c: c }; }
    function _Utils_chr(c) { return c; }
    function _Utils_chr_UNUSED(c) { return new String(c); }
    function _Utils_update(oldRecord, updatedFields) {
        var newRecord = {};
        for (var __keys_key = Object.keys(oldRecord || {}), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
            newRecord[key] = oldRecord[key];
        }
        for (var __keys_key = Object.keys(updatedFields || {}), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
            newRecord[key] = updatedFields[key];
        }
        return newRecord;
    }
    var _Utils_append = F2(_Utils_ap);
    function _Utils_ap(xs, ys) {
        if (typeof xs === "string") {
            return xs + ys;
        }
        if (!xs.b) {
            return ys;
        }
        var root = _List_Cons(xs.a, ys);
        xs = xs.b;
        for (var curr = root; xs.b; xs = xs.b) {
            curr = curr.b = _List_Cons(xs.a, ys);
        }
        return root;
    }
    var _List_Nil = { $: 0, a: null, b: null };
    var _List_Nil_UNUSED = { $: "[]" };
    function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
    function _List_Cons_UNUSED(hd, tl) { return { $: "::", a: hd, b: tl }; }
    var _List_cons = F2(_List_Cons);
    function _List_fromArray(arr) {
        var out = _List_Nil;
        for (var i = arr.length; i--;) {
            out = _List_Cons(arr[i], out);
        }
        return out;
    }
    function _List_toArray(xs) {
        for (var out = []; xs.b; xs = xs.b) {
            out.push(xs.a);
        }
        return out;
    }
    var _List_map2_fn = function (f, xs, ys) {
        for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) {
            arr.push(A2(f, xs.a, ys.a));
        }
        return _List_fromArray(arr);
    }, _List_map2_fn_unwrapped = function (f, xs, ys) {
        for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) {
            arr.push(f(xs.a, ys.a));
        }
        return _List_fromArray(arr);
    }, _List_map2 = F3(_List_map2_fn);
    var _List_map3_fn = function (f, xs, ys, zs) {
        for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) {
            arr.push(A3(f, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map3_fn_unwrapped = function (f, xs, ys, zs) {
        for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) {
            arr.push(f(xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map3 = F4(_List_map3_fn);
    var _List_map4_fn = function (f, ws, xs, ys, zs) {
        for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) {
            arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map4_fn_unwrapped = function (f, ws, xs, ys, zs) {
        for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) {
            arr.push(f(ws.a, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map4 = F5(_List_map4_fn);
    var _List_map5_fn = function (f, vs, ws, xs, ys, zs) {
        for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) {
            arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map5_fn_unwrapped = function (f, vs, ws, xs, ys, zs) {
        for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) {
            arr.push(f(vs.a, ws.a, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map5 = F6(_List_map5_fn);
    var _List_sortBy_fn = function (f, xs) {
        return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
            return _Utils_cmp(f(a), f(b));
        }));
    }, _List_sortBy = F2(_List_sortBy_fn);
    var _List_sortWith_fn = function (f, xs) {
        return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
            var ord = A2(f, a, b);
            return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
        }));
    }, _List_sortWith_fn_unwrapped = function (f, xs) {
        return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
            var ord = f(a, b);
            return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
        }));
    }, _List_sortWith = F2(_List_sortWith_fn);
    var _Basics_add_fn = function (a, b) { return a + b; }, _Basics_add = F2(_Basics_add_fn);
    var _Basics_sub_fn = function (a, b) { return a - b; }, _Basics_sub = F2(_Basics_sub_fn);
    var _Basics_mul_fn = function (a, b) { return a * b; }, _Basics_mul = F2(_Basics_mul_fn);
    var _Basics_fdiv_fn = function (a, b) { return a / b; }, _Basics_fdiv = F2(_Basics_fdiv_fn);
    var _Basics_idiv_fn = function (a, b) { return (a / b) | 0; }, _Basics_idiv = F2(_Basics_idiv_fn);
    var _Basics_pow_fn = Math.pow, _Basics_pow = F2(_Basics_pow_fn);
    var _Basics_remainderBy_fn = function (b, a) { return a % b; }, _Basics_remainderBy = F2(_Basics_remainderBy_fn);
    var _Basics_modBy_fn = function (modulus, x) {
        var answer = x % modulus;
        return modulus === 0
            ? _Debug_crash(11)
            :
                ((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
                    ? answer + modulus
                    : answer;
    }, _Basics_modBy = F2(_Basics_modBy_fn);
    var _Basics_pi = Math.PI;
    var _Basics_e = Math.E;
    var _Basics_cos = Math.cos;
    var _Basics_sin = Math.sin;
    var _Basics_tan = Math.tan;
    var _Basics_acos = Math.acos;
    var _Basics_asin = Math.asin;
    var _Basics_atan = Math.atan;
    var _Basics_atan2_fn = Math.atan2, _Basics_atan2 = F2(_Basics_atan2_fn);
    function _Basics_toFloat(x) { return x; }
    function _Basics_truncate(n) { return n | 0; }
    function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
    var _Basics_ceiling = Math.ceil;
    var _Basics_floor = Math.floor;
    var _Basics_round = Math.round;
    var _Basics_sqrt = Math.sqrt;
    var _Basics_log = Math.log;
    var _Basics_isNaN = isNaN;
    function _Basics_not(bool) { return !bool; }
    var _Basics_and_fn = function (a, b) { return a && b; }, _Basics_and = F2(_Basics_and_fn);
    var _Basics_or_fn = function (a, b) { return a || b; }, _Basics_or = F2(_Basics_or_fn);
    var _Basics_xor_fn = function (a, b) { return a !== b; }, _Basics_xor = F2(_Basics_xor_fn);
    var _String_cons_fn = function (chr, str) {
        return chr + str;
    }, _String_cons = F2(_String_cons_fn);
    function _String_uncons(string) {
        var word = string.charCodeAt(0);
        return !isNaN(word)
            ? $elm$core$Maybe$Just(55296 <= word && word <= 56319
                ? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
                : _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1)))
            : $elm$core$Maybe$Nothing;
    }
    var _String_append_fn = function (a, b) {
        return a + b;
    }, _String_append = F2(_String_append_fn);
    function _String_length(str) {
        return str.length;
    }
    var _String_map_fn = function (func, string) {
        var len = string.length;
        var array = new Array(len);
        var i = 0;
        while (i < len) {
            var word = string.charCodeAt(i);
            if (55296 <= word && word <= 56319) {
                array[i] = func(_Utils_chr(string[i] + string[i + 1]));
                i += 2;
                continue;
            }
            array[i] = func(_Utils_chr(string[i]));
            i++;
        }
        return array.join("");
    }, _String_map = F2(_String_map_fn);
    var _String_filter_fn = function (isGood, str) {
        var arr = [];
        var len = str.length;
        var i = 0;
        while (i < len) {
            var char = str[i];
            var word = str.charCodeAt(i);
            i++;
            if (55296 <= word && word <= 56319) {
                char += str[i];
                i++;
            }
            if (isGood(_Utils_chr(char))) {
                arr.push(char);
            }
        }
        return arr.join("");
    }, _String_filter = F2(_String_filter_fn);
    function _String_reverse(str) {
        var len = str.length;
        var arr = new Array(len);
        var i = 0;
        while (i < len) {
            var word = str.charCodeAt(i);
            if (55296 <= word && word <= 56319) {
                arr[len - i] = str[i + 1];
                i++;
                arr[len - i] = str[i - 1];
                i++;
            }
            else {
                arr[len - i] = str[i];
                i++;
            }
        }
        return arr.join("");
    }
    var _String_foldl_fn = function (func, state, string) {
        var len = string.length;
        var i = 0;
        while (i < len) {
            var char = string[i];
            var word = string.charCodeAt(i);
            i++;
            if (55296 <= word && word <= 56319) {
                char += string[i];
                i++;
            }
            state = A2(func, _Utils_chr(char), state);
        }
        return state;
    }, _String_foldl_fn_unwrapped = function (func, state, string) {
        var len = string.length;
        var i = 0;
        while (i < len) {
            var char = string[i];
            var word = string.charCodeAt(i);
            i++;
            if (55296 <= word && word <= 56319) {
                char += string[i];
                i++;
            }
            state = func(_Utils_chr(char), state);
        }
        return state;
    }, _String_foldl = F3(_String_foldl_fn);
    var _String_foldr_fn = function (func, state, string) {
        var i = string.length;
        while (i--) {
            var char = string[i];
            var word = string.charCodeAt(i);
            if (56320 <= word && word <= 57343) {
                i--;
                char = string[i] + char;
            }
            state = A2(func, _Utils_chr(char), state);
        }
        return state;
    }, _String_foldr_fn_unwrapped = function (func, state, string) {
        var i = string.length;
        while (i--) {
            var char = string[i];
            var word = string.charCodeAt(i);
            if (56320 <= word && word <= 57343) {
                i--;
                char = string[i] + char;
            }
            state = func(_Utils_chr(char), state);
        }
        return state;
    }, _String_foldr = F3(_String_foldr_fn);
    var _String_split_fn = function (sep, str) {
        return str.split(sep);
    }, _String_split = F2(_String_split_fn);
    var _String_join_fn = function (sep, strs) {
        return strs.join(sep);
    }, _String_join = F2(_String_join_fn);
    var _String_slice_fn = function (start, end, str) {
        return str.slice(start, end);
    }, _String_slice = F3(_String_slice_fn);
    function _String_trim(str) {
        return str.trim();
    }
    function _String_trimLeft(str) {
        return str.replace(/^\s+/, "");
    }
    function _String_trimRight(str) {
        return str.replace(/\s+$/, "");
    }
    function _String_words(str) {
        return _List_fromArray(str.trim().split(/\s+/g));
    }
    function _String_lines(str) {
        return _List_fromArray(str.split(/\r\n|\r|\n/g));
    }
    function _String_toUpper(str) {
        return str.toUpperCase();
    }
    function _String_toLower(str) {
        return str.toLowerCase();
    }
    var _String_any_fn = function (isGood, string) {
        var i = string.length;
        while (i--) {
            var char = string[i];
            var word = string.charCodeAt(i);
            if (56320 <= word && word <= 57343) {
                i--;
                char = string[i] + char;
            }
            if (isGood(_Utils_chr(char))) {
                return true;
            }
        }
        return false;
    }, _String_any = F2(_String_any_fn);
    var _String_all_fn = function (isGood, string) {
        var i = string.length;
        while (i--) {
            var char = string[i];
            var word = string.charCodeAt(i);
            if (56320 <= word && word <= 57343) {
                i--;
                char = string[i] + char;
            }
            if (!isGood(_Utils_chr(char))) {
                return false;
            }
        }
        return true;
    }, _String_all = F2(_String_all_fn);
    var _String_contains_fn = function (sub, str) {
        return str.indexOf(sub) > -1;
    }, _String_contains = F2(_String_contains_fn);
    var _String_startsWith_fn = function (sub, str) {
        return str.indexOf(sub) === 0;
    }, _String_startsWith = F2(_String_startsWith_fn);
    var _String_endsWith_fn = function (sub, str) {
        return str.length >= sub.length &&
            str.lastIndexOf(sub) === str.length - sub.length;
    }, _String_endsWith = F2(_String_endsWith_fn);
    var _String_indexes_fn = function (sub, str) {
        var subLen = sub.length;
        if (subLen < 1) {
            return _List_Nil;
        }
        var i = 0;
        var is = [];
        while ((i = str.indexOf(sub, i)) > -1) {
            is.push(i);
            i = i + subLen;
        }
        return _List_fromArray(is);
    }, _String_indexes = F2(_String_indexes_fn);
    function _String_fromNumber(number) {
        return number + "";
    }
    function _String_toInt(str) {
        var total = 0;
        var code0 = str.charCodeAt(0);
        var start = code0 == 43 || code0 == 45 ? 1 : 0;
        for (var i = start; i < str.length; ++i) {
            var code = str.charCodeAt(i);
            if (code < 48 || 57 < code) {
                return $elm$core$Maybe$Nothing;
            }
            total = 10 * total + code - 48;
        }
        return i == start
            ? $elm$core$Maybe$Nothing
            : $elm$core$Maybe$Just(code0 == 45 ? -total : total);
    }
    function _String_toFloat(s) {
        if (s.length === 0 || /[\sxbo]/.test(s)) {
            return $elm$core$Maybe$Nothing;
        }
        var n = +s;
        return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
    }
    function _String_fromList(chars) {
        return _List_toArray(chars).join("");
    }
    function _Char_toCode(char) {
        var code = char.charCodeAt(0);
        if (55296 <= code && code <= 56319) {
            return (code - 55296) * 1024 + char.charCodeAt(1) - 56320 + 65536;
        }
        return code;
    }
    function _Char_fromCode(code) {
        return _Utils_chr((code < 0 || 1114111 < code)
            ? "\uFFFD"
            :
                (code <= 65535)
                    ? String.fromCharCode(code)
                    :
                        (code -= 65536,
                            String.fromCharCode(Math.floor(code / 1024) + 55296, code % 1024 + 56320)));
    }
    function _Char_toUpper(char) {
        return _Utils_chr(char.toUpperCase());
    }
    function _Char_toLower(char) {
        return _Utils_chr(char.toLowerCase());
    }
    function _Char_toLocaleUpper(char) {
        return _Utils_chr(char.toLocaleUpperCase());
    }
    function _Char_toLocaleLower(char) {
        return _Utils_chr(char.toLocaleLowerCase());
    }
    function _Json_succeed(msg) {
        return {
            $: 0,
            a: msg
        };
    }
    function _Json_fail(msg) {
        return {
            $: 1,
            a: msg
        };
    }
    function _Json_decodePrim(decoder) {
        return { $: 2, b: decoder };
    }
    var _Json_decodeInt = _Json_decodePrim(function (value) {
        return (typeof value !== "number")
            ? _Json_expecting("an INT", value)
            :
                (-2147483647 < value && value < 2147483647 && (value | 0) === value)
                    ? $elm$core$Result$Ok(value)
                    :
                        (isFinite(value) && !(value % 1))
                            ? $elm$core$Result$Ok(value)
                            : _Json_expecting("an INT", value);
    });
    var _Json_decodeBool = _Json_decodePrim(function (value) {
        return (typeof value === "boolean")
            ? $elm$core$Result$Ok(value)
            : _Json_expecting("a BOOL", value);
    });
    var _Json_decodeFloat = _Json_decodePrim(function (value) {
        return (typeof value === "number")
            ? $elm$core$Result$Ok(value)
            : _Json_expecting("a FLOAT", value);
    });
    var _Json_decodeValue = _Json_decodePrim(function (value) {
        return $elm$core$Result$Ok(_Json_wrap(value));
    });
    var _Json_decodeString = _Json_decodePrim(function (value) {
        return (typeof value === "string")
            ? $elm$core$Result$Ok(value)
            : (value instanceof String)
                ? $elm$core$Result$Ok(value + "")
                : _Json_expecting("a STRING", value);
    });
    function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
    function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
    function _Json_decodeNull(value) { return { $: 5, c: value }; }
    var _Json_decodeField_fn = function (field, decoder) {
        return {
            $: 6,
            d: field,
            b: decoder
        };
    }, _Json_decodeField = F2(_Json_decodeField_fn);
    var _Json_decodeIndex_fn = function (index, decoder) {
        return {
            $: 7,
            e: index,
            b: decoder
        };
    }, _Json_decodeIndex = F2(_Json_decodeIndex_fn);
    function _Json_decodeKeyValuePairs(decoder) {
        return {
            $: 8,
            b: decoder
        };
    }
    function _Json_mapMany(f, decoders) {
        return {
            $: 9,
            f: f,
            g: decoders
        };
    }
    var _Json_andThen_fn = function (callback, decoder) {
        return {
            $: 10,
            b: decoder,
            h: callback
        };
    }, _Json_andThen = F2(_Json_andThen_fn);
    function _Json_oneOf(decoders) {
        return {
            $: 11,
            g: decoders
        };
    }
    var _Json_map1_fn = function (f, d1) {
        return _Json_mapMany(f, [d1]);
    }, _Json_map1 = F2(_Json_map1_fn);
    var _Json_map2_fn = function (f, d1, d2) {
        return _Json_mapMany(f, [d1, d2]);
    }, _Json_map2 = F3(_Json_map2_fn);
    var _Json_map3_fn = function (f, d1, d2, d3) {
        return _Json_mapMany(f, [d1, d2, d3]);
    }, _Json_map3 = F4(_Json_map3_fn);
    var _Json_map4_fn = function (f, d1, d2, d3, d4) {
        return _Json_mapMany(f, [d1, d2, d3, d4]);
    }, _Json_map4 = F5(_Json_map4_fn);
    var _Json_map5_fn = function (f, d1, d2, d3, d4, d5) {
        return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
    }, _Json_map5 = F6(_Json_map5_fn);
    var _Json_map6_fn = function (f, d1, d2, d3, d4, d5, d6) {
        return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
    }, _Json_map6 = F7(_Json_map6_fn);
    var _Json_map7_fn = function (f, d1, d2, d3, d4, d5, d6, d7) {
        return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
    }, _Json_map7 = F8(_Json_map7_fn);
    var _Json_map8_fn = function (f, d1, d2, d3, d4, d5, d6, d7, d8) {
        return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
    }, _Json_map8 = F9(_Json_map8_fn);
    var _Json_runOnString_fn = function (decoder, string) {
        try {
            var value = JSON.parse(string);
            return _Json_runHelp(decoder, value);
        }
        catch (e) {
            return $elm$core$Result$Err($elm$json$Json$Decode$Failure_fn("This is not valid JSON! " + e.message, _Json_wrap(string)));
        }
    }, _Json_runOnString = F2(_Json_runOnString_fn);
    var _Json_run_fn = function (decoder, value) {
        return _Json_runHelp(decoder, _Json_unwrap(value));
    }, _Json_run = F2(_Json_run_fn);
    function _Json_runHelp(decoder, value) {
        switch (decoder.$) {
            case 2:
                return decoder.b(value);
            case 5:
                return (value === null)
                    ? $elm$core$Result$Ok(decoder.c)
                    : _Json_expecting("null", value);
            case 3:
                if (!_Json_isArray(value)) {
                    return _Json_expecting("a LIST", value);
                }
                return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
            case 4:
                if (!_Json_isArray(value)) {
                    return _Json_expecting("an ARRAY", value);
                }
                return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
            case 6:
                var field = decoder.d;
                if (typeof value !== "object" || value === null || !(field in value)) {
                    return _Json_expecting("an OBJECT with a field named `" + field + "`", value);
                }
                var result = _Json_runHelp(decoder.b, value[field]);
                return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err($elm$json$Json$Decode$Field_fn(field, result.a));
            case 7:
                var index = decoder.e;
                if (!_Json_isArray(value)) {
                    return _Json_expecting("an ARRAY", value);
                }
                if (index >= value.length) {
                    return _Json_expecting("a LONGER array. Need index " + index + " but only see " + value.length + " entries", value);
                }
                var result = _Json_runHelp(decoder.b, value[index]);
                return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err($elm$json$Json$Decode$Index_fn(index, result.a));
            case 8:
                if (typeof value !== "object" || value === null || _Json_isArray(value)) {
                    return _Json_expecting("an OBJECT", value);
                }
                var keyValuePairs = _List_Nil;
                for (var __keys_key = Object.keys(value || {}), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
                    if (value.hasOwnProperty(key)) {
                        var result = _Json_runHelp(decoder.b, value[key]);
                        if (!$elm$core$Result$isOk(result)) {
                            return $elm$core$Result$Err($elm$json$Json$Decode$Field_fn(key, result.a));
                        }
                        keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
                    }
                }
                return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));
            case 9:
                var answer = decoder.f;
                var decoders = decoder.g;
                for (var i = 0; i < decoders.length; i++) {
                    var result = _Json_runHelp(decoders[i], value);
                    if (!$elm$core$Result$isOk(result)) {
                        return result;
                    }
                    answer = answer(result.a);
                }
                return $elm$core$Result$Ok(answer);
            case 10:
                var result = _Json_runHelp(decoder.b, value);
                return (!$elm$core$Result$isOk(result))
                    ? result
                    : _Json_runHelp(decoder.h(result.a), value);
            case 11:
                var errors = _List_Nil;
                for (var temp = decoder.g; temp.b; temp = temp.b) {
                    var result = _Json_runHelp(temp.a, value);
                    if ($elm$core$Result$isOk(result)) {
                        return result;
                    }
                    errors = _List_Cons(result.a, errors);
                }
                return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));
            case 1:
                return $elm$core$Result$Err($elm$json$Json$Decode$Failure_fn(decoder.a, _Json_wrap(value)));
            case 0:
                return $elm$core$Result$Ok(decoder.a);
        }
    }
    function _Json_runArrayDecoder(decoder, value, toElmValue) {
        var len = value.length;
        var array = new Array(len);
        for (var i = 0; i < len; i++) {
            var result = _Json_runHelp(decoder, value[i]);
            if (!$elm$core$Result$isOk(result)) {
                return $elm$core$Result$Err($elm$json$Json$Decode$Index_fn(i, result.a));
            }
            array[i] = result.a;
        }
        return $elm$core$Result$Ok(toElmValue(array));
    }
    function _Json_isArray(value) {
        return Array.isArray(value) || (typeof FileList !== "undefined" && value instanceof FileList);
    }
    function _Json_toElmArray(array) {
        return $elm$core$Array$initialize_fn(array.length, function (i) { return array[i]; });
    }
    function _Json_expecting(type, value) {
        return $elm$core$Result$Err($elm$json$Json$Decode$Failure_fn("Expecting " + type, _Json_wrap(value)));
    }
    function _Json_equality(x, y) {
        if (x === y) {
            return true;
        }
        if (x.$ !== y.$) {
            return false;
        }
        switch (x.$) {
            case 0:
            case 1:
                return x.a === y.a;
            case 2:
                return x.b === y.b;
            case 5:
                return x.c === y.c;
            case 3:
            case 4:
            case 8:
                return _Json_equality(x.b, y.b);
            case 6:
                return x.d === y.d && _Json_equality(x.b, y.b);
            case 7:
                return x.e === y.e && _Json_equality(x.b, y.b);
            case 9:
                return x.f === y.f && _Json_listEquality(x.g, y.g);
            case 10:
                return x.h === y.h && _Json_equality(x.b, y.b);
            case 11:
                return _Json_listEquality(x.g, y.g);
        }
    }
    function _Json_listEquality(aDecoders, bDecoders) {
        var len = aDecoders.length;
        if (len !== bDecoders.length) {
            return false;
        }
        for (var i = 0; i < len; i++) {
            if (!_Json_equality(aDecoders[i], bDecoders[i])) {
                return false;
            }
        }
        return true;
    }
    var _Json_encode_fn = function (indentLevel, value) {
        return JSON.stringify(_Json_unwrap(value), null, indentLevel) + "";
    }, _Json_encode = F2(_Json_encode_fn);
    function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
    function _Json_unwrap_UNUSED(value) { return value.a; }
    function _Json_wrap(value) { return value; }
    function _Json_unwrap(value) { return value; }
    function _Json_emptyArray() { return []; }
    function _Json_emptyObject() { return {}; }
    var _Json_addField_fn = function (key, value, object) {
        object[key] = _Json_unwrap(value);
        return object;
    }, _Json_addField = F3(_Json_addField_fn);
    function _Json_addEntry(func) {
        return F2(function (entry, array) {
            array.push(_Json_unwrap(func(entry)));
            return array;
        });
    }
    var _Json_encodeNull = _Json_wrap(null);
    function _Scheduler_succeed(value) {
        return {
            $: 0,
            a: value
        };
    }
    function _Scheduler_fail(error) {
        return {
            $: 1,
            a: error
        };
    }
    function _Scheduler_binding(callback) {
        return {
            $: 2,
            b: callback,
            c: null
        };
    }
    var _Scheduler_andThen_fn = function (callback, task) {
        return {
            $: 3,
            b: callback,
            d: task
        };
    }, _Scheduler_andThen = F2(_Scheduler_andThen_fn);
    var _Scheduler_onError_fn = function (callback, task) {
        return {
            $: 4,
            b: callback,
            d: task
        };
    }, _Scheduler_onError = F2(_Scheduler_onError_fn);
    function _Scheduler_receive(callback) {
        return {
            $: 5,
            b: callback
        };
    }
    var _Scheduler_guid = 0;
    function _Scheduler_rawSpawn(task) {
        var proc = {
            $: 0,
            e: _Scheduler_guid++,
            f: task,
            g: null,
            h: []
        };
        _Scheduler_enqueue(proc);
        return proc;
    }
    function _Scheduler_spawn(task) {
        return _Scheduler_binding(function (callback) {
            callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
        });
    }
    function _Scheduler_rawSend(proc, msg) {
        proc.h.push(msg);
        _Scheduler_enqueue(proc);
    }
    var _Scheduler_send_fn = function (proc, msg) {
        return _Scheduler_binding(function (callback) {
            _Scheduler_rawSend(proc, msg);
            callback(_Scheduler_succeed(_Utils_Tuple0));
        });
    }, _Scheduler_send = F2(_Scheduler_send_fn);
    function _Scheduler_kill(proc) {
        return _Scheduler_binding(function (callback) {
            var task = proc.f;
            if (task.$ === 2 && task.c) {
                task.c();
            }
            proc.f = null;
            callback(_Scheduler_succeed(_Utils_Tuple0));
        });
    }
    var _Scheduler_working = false;
    var _Scheduler_queue = [];
    function _Scheduler_enqueue(proc) {
        _Scheduler_queue.push(proc);
        if (_Scheduler_working) {
            return;
        }
        _Scheduler_working = true;
        while (proc = _Scheduler_queue.shift()) {
            _Scheduler_step(proc);
        }
        _Scheduler_working = false;
    }
    function _Scheduler_step(proc) {
        while (proc.f) {
            var rootTag = proc.f.$;
            if (rootTag === 0 || rootTag === 1) {
                while (proc.g && proc.g.$ !== rootTag) {
                    proc.g = proc.g.i;
                }
                if (!proc.g) {
                    return;
                }
                proc.f = proc.g.b(proc.f.a);
                proc.g = proc.g.i;
            }
            else if (rootTag === 2) {
                proc.f.c = proc.f.b(function (newRoot) {
                    proc.f = newRoot;
                    _Scheduler_enqueue(proc);
                });
                return;
            }
            else if (rootTag === 5) {
                if (proc.h.length === 0) {
                    return;
                }
                proc.f = proc.f.b(proc.h.shift());
            }
            else {
                proc.g = {
                    $: rootTag === 3 ? 0 : 1,
                    b: proc.f.b,
                    i: proc.g
                };
                proc.f = proc.f.d;
            }
        }
    }
    function _Process_sleep(time) {
        return _Scheduler_binding(function (callback) {
            var id = setTimeout(function () {
                callback(_Scheduler_succeed(_Utils_Tuple0));
            }, time);
            return function () { clearTimeout(id); };
        });
    }
    var _Platform_worker_fn = function (impl, flagDecoder, debugMetadata, args) {
        return _Platform_initialize(flagDecoder, args, impl.me, impl.pP, impl.o2, function () { return function () { }; });
    }, _Platform_worker = F4(_Platform_worker_fn);
    function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder) {
        var result = _Json_run_fn(flagDecoder, _Json_wrap(args ? args["flags"] : undefined));
        $elm$core$Result$isOk(result) || _Debug_crash(2);
        var managers = {};
        var initPair = init(result.a);
        var model = initPair.a;
        var stepper = stepperBuilder(sendToApp, model);
        var ports = _Platform_setupEffects(managers, sendToApp);
        function sendToApp(msg, viewMetadata) {
            var pair = A2(update, msg, model);
            stepper(model = pair.a, viewMetadata);
            _Platform_enqueueEffects(managers, pair.b, subscriptions(model));
        }
        _Platform_enqueueEffects(managers, initPair.b, subscriptions(model));
        return ports ? { ports: ports } : {};
    }
    var _Platform_preload;
    function _Platform_registerPreload(url) {
        _Platform_preload.add(url);
    }
    var _Platform_effectManagers = {};
    function _Platform_setupEffects(managers, sendToApp) {
        var ports;
        for (var __keys_key = Object.keys(_Platform_effectManagers || {}), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
            var manager = _Platform_effectManagers[key];
            if (manager.a) {
                ports = ports || {};
                ports[key] = manager.a(key, sendToApp);
            }
            managers[key] = _Platform_instantiateManager(manager, sendToApp);
        }
        return ports;
    }
    function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap) {
        return (new $$Record1(init, onEffects, onSelfMsg, cmdMap, subMap));
    }
    function _Platform_instantiateManager(info, sendToApp) {
        var router = {
            g: sendToApp,
            h: undefined
        };
        var onEffects = info.c;
        var onSelfMsg = info.d;
        var cmdMap = info.e;
        var subMap = info.f;
        function loop(state) {
            return _Scheduler_andThen_fn(loop, _Scheduler_receive(function (msg) {
                var value = msg.a;
                if (msg.$ === 0) {
                    return A3(onSelfMsg, router, value, state);
                }
                return cmdMap && subMap
                    ? A4(onEffects, router, value.i, value.j, state)
                    : A3(onEffects, router, cmdMap ? value.i : value.j, state);
            }));
        }
        return router.h = _Scheduler_rawSpawn(_Scheduler_andThen_fn(loop, info.b));
    }
    var _Platform_sendToApp_fn = function (router, msg) {
        return _Scheduler_binding(function (callback) {
            router.g(msg);
            callback(_Scheduler_succeed(_Utils_Tuple0));
        });
    }, _Platform_sendToApp = F2(_Platform_sendToApp_fn);
    var _Platform_sendToSelf_fn = function (router, msg) {
        return _Scheduler_send_fn(router.h, {
            $: 0,
            a: msg
        });
    }, _Platform_sendToSelf = F2(_Platform_sendToSelf_fn);
    function _Platform_leaf(home) {
        return function (value) {
            return {
                $: 1,
                k: home,
                l: value
            };
        };
    }
    function _Platform_batch(list) {
        return {
            $: 2,
            m: list
        };
    }
    var _Platform_map_fn = function (tagger, bag) {
        return {
            $: 3,
            n: tagger,
            o: bag
        };
    }, _Platform_map = F2(_Platform_map_fn);
    var _Platform_effectsQueue = [];
    var _Platform_effectsActive = false;
    function _Platform_enqueueEffects(managers, cmdBag, subBag) {
        _Platform_effectsQueue.push((new $$Record2(managers, cmdBag, subBag)));
        if (_Platform_effectsActive)
            return;
        _Platform_effectsActive = true;
        for (var fx; fx = _Platform_effectsQueue.shift();) {
            _Platform_dispatchEffects(fx.p, fx.q, fx.r);
        }
        _Platform_effectsActive = false;
    }
    function _Platform_dispatchEffects(managers, cmdBag, subBag) {
        var effectsDict = {};
        _Platform_gatherEffects(true, cmdBag, effectsDict, null);
        _Platform_gatherEffects(false, subBag, effectsDict, null);
        for (var __keys_home = Object.keys(managers || {}), __i_home = 0; __i_home < __keys_home.length; __i_home++) { var home = __keys_home[__i_home];
            _Scheduler_rawSend(managers[home], {
                $: "fx",
                a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
            });
        }
    }
    function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers) {
        switch (bag.$) {
            case 1:
                var home = bag.k;
                var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
                effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
                return;
            case 2:
                for (var list = bag.m; list.b; list = list.b) {
                    _Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
                }
                return;
            case 3:
                _Platform_gatherEffects(isCmd, bag.o, effectsDict, {
                    s: bag.n,
                    t: taggers
                });
                return;
        }
    }
    function _Platform_toEffect(isCmd, home, taggers, value) {
        function applyTaggers(x) {
            for (var temp = taggers; temp; temp = temp.t) {
                x = temp.s(x);
            }
            return x;
        }
        var map = isCmd
            ? _Platform_effectManagers[home].e
            : _Platform_effectManagers[home].f;
        return A2(map, applyTaggers, value);
    }
    function _Platform_insert(isCmd, newEffect, effects) {
        effects = effects || { i: _List_Nil, j: _List_Nil };
        isCmd
            ? (effects.i = _List_Cons(newEffect, effects.i))
            : (effects.j = _List_Cons(newEffect, effects.j));
        return effects;
    }
    function _Platform_checkPortName(name) {
        if (_Platform_effectManagers[name]) {
            _Debug_crash(3, name);
        }
    }
    function _Platform_outgoingPort(name, converter) {
        _Platform_checkPortName(name);
        _Platform_effectManagers[name] = (new $$Record3(_Platform_outgoingPortMap, converter, _Platform_setupOutgoingPort));
        return _Platform_leaf(name);
    }
    var _Platform_outgoingPortMap_fn = function (tagger, value) { return value; }, _Platform_outgoingPortMap = F2(_Platform_outgoingPortMap_fn);
    function _Platform_setupOutgoingPort(name) {
        var subs = [];
        var converter = _Platform_effectManagers[name].u;
        var init = _Process_sleep(0);
        _Platform_effectManagers[name].b = init;
        _Platform_effectManagers[name].c = F3(function (router, cmdList, state) {
            for (; cmdList.b; cmdList = cmdList.b) {
                var currentSubs = subs;
                var value = _Json_unwrap(converter(cmdList.a));
                for (var i = 0; i < currentSubs.length; i++) {
                    currentSubs[i](value);
                }
            }
            return init;
        });
        function subscribe(callback) {
            subs.push(callback);
        }
        function unsubscribe(callback) {
            subs = subs.slice();
            var index = subs.indexOf(callback);
            if (index >= 0) {
                subs.splice(index, 1);
            }
        }
        return {
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };
    }
    function _Platform_incomingPort(name, converter) {
        _Platform_checkPortName(name);
        _Platform_effectManagers[name] = (new $$Record4(_Platform_incomingPortMap, converter, _Platform_setupIncomingPort));
        return _Platform_leaf(name);
    }
    var _Platform_incomingPortMap_fn = function (tagger, finalTagger) {
        return function (value) {
            return tagger(finalTagger(value));
        };
    }, _Platform_incomingPortMap = F2(_Platform_incomingPortMap_fn);
    function _Platform_setupIncomingPort(name, sendToApp) {
        var subs = _List_Nil;
        var converter = _Platform_effectManagers[name].u;
        var init = _Scheduler_succeed(null);
        _Platform_effectManagers[name].b = init;
        _Platform_effectManagers[name].c = F3(function (router, subList, state) {
            subs = subList;
            return init;
        });
        function send(incomingValue) {
            var result = _Json_run_fn(converter, _Json_wrap(incomingValue));
            $elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
            var value = result.a;
            for (var temp = subs; temp.b; temp = temp.b) {
                sendToApp(temp.a(value));
            }
        }
        return { send: send };
    }
    function _Platform_export(exports) {
        scope["Elm"]
            ? _Platform_mergeExportsProd(scope["Elm"], exports)
            : scope["Elm"] = exports;
    }
    function _Platform_mergeExportsProd(obj, exports) {
        for (var __keys_name = Object.keys(exports || {}), __i_name = 0; __i_name < __keys_name.length; __i_name++) { var name = __keys_name[__i_name];
            (name in obj)
                ? (name == "init")
                    ? _Debug_crash(6)
                    : _Platform_mergeExportsProd(obj[name], exports[name])
                : (obj[name] = exports[name]);
        }
    }
    function _Platform_export_UNUSED(exports) {
        scope["Elm"]
            ? _Platform_mergeExportsDebug("Elm", scope["Elm"], exports)
            : scope["Elm"] = exports;
    }
    function _Platform_mergeExportsDebug(moduleName, obj, exports) {
        for (var __keys_name = Object.keys(exports || {}), __i_name = 0; __i_name < __keys_name.length; __i_name++) { var name = __keys_name[__i_name];
            (name in obj)
                ? (name == "init")
                    ? _Debug_crash(6, moduleName)
                    : _Platform_mergeExportsDebug(moduleName + "." + name, obj[name], exports[name])
                : (obj[name] = exports[name]);
        }
    }
    var _VirtualDom_divertHrefToApp;
    var _VirtualDom_doc = typeof document !== "undefined" ? document : {};
    function _VirtualDom_appendChild(parent, child) {
        parent.appendChild(child);
    }
    var _VirtualDom_init_fn = function (virtualNode, flagDecoder, debugMetadata, args) {
        var node = args["node"];
        node.parentNode.replaceChild(_VirtualDom_render(virtualNode, function () { }), node);
        return {};
    }, _VirtualDom_init = F4(_VirtualDom_init_fn);
    function _VirtualDom_text(string) {
        return {
            $: 0,
            a: string
        };
    }
    var _VirtualDom_nodeNS_fn = function (namespace, tag) {
        return F2(function (factList, kidList) {
            for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) {
                var kid = kidList.a;
                descendantsCount += (kid.b || 0);
                kids.push(kid);
            }
            descendantsCount += kids.length;
            return {
                $: 1,
                c: tag,
                d: _VirtualDom_organizeFacts(factList),
                e: kids,
                f: namespace,
                b: descendantsCount
            };
        });
    }, _VirtualDom_nodeNS = F2(_VirtualDom_nodeNS_fn);
    var _VirtualDom_node_a0 = undefined, _VirtualDom_node = _VirtualDom_nodeNS(_VirtualDom_node_a0);
    var _VirtualDom_keyedNodeNS_fn = function (namespace, tag) {
        return F2(function (factList, kidList) {
            for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) {
                var kid = kidList.a;
                descendantsCount += (kid.b.b || 0);
                kids.push(kid);
            }
            descendantsCount += kids.length;
            return {
                $: 2,
                c: tag,
                d: _VirtualDom_organizeFacts(factList),
                e: kids,
                f: namespace,
                b: descendantsCount
            };
        });
    }, _VirtualDom_keyedNodeNS = F2(_VirtualDom_keyedNodeNS_fn);
    var _VirtualDom_keyedNode_a0 = undefined, _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(_VirtualDom_keyedNode_a0);
    function _VirtualDom_custom(factList, model, render, diff) {
        return {
            $: 3,
            d: _VirtualDom_organizeFacts(factList),
            g: model,
            h: render,
            i: diff
        };
    }
    var _VirtualDom_map_fn = function (tagger, node) {
        return {
            $: 4,
            j: tagger,
            k: node,
            b: 1 + (node.b || 0)
        };
    }, _VirtualDom_map = F2(_VirtualDom_map_fn);
    function _VirtualDom_thunk(refs, thunk) {
        return {
            $: 5,
            l: refs,
            m: thunk,
            k: undefined
        };
    }
    var _VirtualDom_lazy_fn = function (func, a) {
        return _VirtualDom_thunk([func, a], function () {
            return func(a);
        });
    }, _VirtualDom_lazy = F2(_VirtualDom_lazy_fn);
    var _VirtualDom_lazy2_fn = function (func, a, b) {
        return _VirtualDom_thunk([func, a, b], function () {
            return A2(func, a, b);
        });
    }, _VirtualDom_lazy2_fn_unwrapped = function (func, a, b) {
        return _VirtualDom_thunk([func, a, b], function () {
            return func(a, b);
        });
    }, _VirtualDom_lazy2 = F3(_VirtualDom_lazy2_fn);
    var _VirtualDom_lazy3_fn = function (func, a, b, c) {
        return _VirtualDom_thunk([func, a, b, c], function () {
            return A3(func, a, b, c);
        });
    }, _VirtualDom_lazy3_fn_unwrapped = function (func, a, b, c) {
        return _VirtualDom_thunk([func, a, b, c], function () {
            return func(a, b, c);
        });
    }, _VirtualDom_lazy3 = F4(_VirtualDom_lazy3_fn);
    var _VirtualDom_lazy4_fn = function (func, a, b, c, d) {
        return _VirtualDom_thunk([func, a, b, c, d], function () {
            return A4(func, a, b, c, d);
        });
    }, _VirtualDom_lazy4_fn_unwrapped = function (func, a, b, c, d) {
        return _VirtualDom_thunk([func, a, b, c, d], function () {
            return func(a, b, c, d);
        });
    }, _VirtualDom_lazy4 = F5(_VirtualDom_lazy4_fn);
    var _VirtualDom_lazy5_fn = function (func, a, b, c, d, e) {
        return _VirtualDom_thunk([func, a, b, c, d, e], function () {
            return A5(func, a, b, c, d, e);
        });
    }, _VirtualDom_lazy5_fn_unwrapped = function (func, a, b, c, d, e) {
        return _VirtualDom_thunk([func, a, b, c, d, e], function () {
            return func(a, b, c, d, e);
        });
    }, _VirtualDom_lazy5 = F6(_VirtualDom_lazy5_fn);
    var _VirtualDom_lazy6_fn = function (func, a, b, c, d, e, f) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f], function () {
            return A6(func, a, b, c, d, e, f);
        });
    }, _VirtualDom_lazy6_fn_unwrapped = function (func, a, b, c, d, e, f) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f], function () {
            return func(a, b, c, d, e, f);
        });
    }, _VirtualDom_lazy6 = F7(_VirtualDom_lazy6_fn);
    var _VirtualDom_lazy7_fn = function (func, a, b, c, d, e, f, g) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function () {
            return A7(func, a, b, c, d, e, f, g);
        });
    }, _VirtualDom_lazy7_fn_unwrapped = function (func, a, b, c, d, e, f, g) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function () {
            return func(a, b, c, d, e, f, g);
        });
    }, _VirtualDom_lazy7 = F8(_VirtualDom_lazy7_fn);
    var _VirtualDom_lazy8_fn = function (func, a, b, c, d, e, f, g, h) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function () {
            return A8(func, a, b, c, d, e, f, g, h);
        });
    }, _VirtualDom_lazy8_fn_unwrapped = function (func, a, b, c, d, e, f, g, h) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function () {
            return func(a, b, c, d, e, f, g, h);
        });
    }, _VirtualDom_lazy8 = F9(_VirtualDom_lazy8_fn);
    var _VirtualDom_on_fn = function (key, handler) {
        return {
            $: "a0",
            n: key,
            o: handler
        };
    }, _VirtualDom_on = F2(_VirtualDom_on_fn);
    var _VirtualDom_style_fn = function (key, value) {
        return {
            $: "a1",
            n: key,
            o: value
        };
    }, _VirtualDom_style = F2(_VirtualDom_style_fn);
    var _VirtualDom_property_fn = function (key, value) {
        return {
            $: "a2",
            n: key,
            o: value
        };
    }, _VirtualDom_property = F2(_VirtualDom_property_fn);
    var _VirtualDom_attribute_fn = function (key, value) {
        return {
            $: "a3",
            n: key,
            o: value
        };
    }, _VirtualDom_attribute = F2(_VirtualDom_attribute_fn);
    var _VirtualDom_attributeNS_fn = function (namespace, key, value) {
        return {
            $: "a4",
            n: key,
            o: (new $$Record5(namespace, value))
        };
    }, _VirtualDom_attributeNS = F3(_VirtualDom_attributeNS_fn);
    function _VirtualDom_noScript(tag) {
        return tag == "script" ? "p" : tag;
    }
    function _VirtualDom_noOnOrFormAction(key) {
        return /^(on|formAction$)/i.test(key) ? "data-" + key : key;
    }
    function _VirtualDom_noInnerHtmlOrFormAction(key) {
        return key == "innerHTML" || key == "formAction" ? "data-" + key : key;
    }
    function _VirtualDom_noJavaScriptUri(value) {
        return /^javascript:/i.test(value.replace(/\s/g, "")) ? "" : value;
    }
    function _VirtualDom_noJavaScriptUri_UNUSED(value) {
        return /^javascript:/i.test(value.replace(/\s/g, ""))
            ? "javascript:alert(\"This is an XSS vector. Please use ports or web components instead.\")"
            : value;
    }
    function _VirtualDom_noJavaScriptOrHtmlUri(value) {
        return /^\s*(javascript:|data:text\/html)/i.test(value) ? "" : value;
    }
    function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value) {
        return /^\s*(javascript:|data:text\/html)/i.test(value)
            ? "javascript:alert(\"This is an XSS vector. Please use ports or web components instead.\")"
            : value;
    }
    var _VirtualDom_mapAttribute_fn = function (func, attr) {
        return (attr.$ === "a0")
            ? _VirtualDom_on_fn(attr.n, _VirtualDom_mapHandler(func, attr.o)) : attr;
    }, _VirtualDom_mapAttribute = F2(_VirtualDom_mapAttribute_fn);
    function _VirtualDom_mapHandler(func, handler) {
        var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);
        return {
            $: handler.$,
            a: !tag
                ? _Json_map1_fn(func, handler.a) : _Json_map2_fn(tag < 3
                ? _VirtualDom_mapEventTuple
                : _VirtualDom_mapEventRecord, $elm$json$Json$Decode$succeed(func), handler.a)
        };
    }
    var _VirtualDom_mapEventTuple_fn = function (func, tuple) {
        return _Utils_Tuple2(func(tuple.a), tuple.b);
    }, _VirtualDom_mapEventTuple = F2(_VirtualDom_mapEventTuple_fn);
    var _VirtualDom_mapEventRecord_fn = function (func, record) {
        return {
            m_: func(record.m_),
            oU: record.oU,
            nU: record.nU
        };
    }, _VirtualDom_mapEventRecord = F2(_VirtualDom_mapEventRecord_fn);
    function _VirtualDom_organizeFacts(factList) {
        for (var facts = {}; factList.b; factList = factList.b) {
            var entry = factList.a;
            var tag = entry.$;
            var key = entry.n;
            var value = entry.o;
            if (tag === "a2") {
                (key === "className")
                    ? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
                    : facts[key] = _Json_unwrap(value);
                continue;
            }
            var subFacts = facts[tag] || (facts[tag] = {});
            (tag === "a3" && key === "class")
                ? _VirtualDom_addClass(subFacts, key, value)
                : subFacts[key] = value;
        }
        return facts;
    }
    function _VirtualDom_addClass(object, key, newClass) {
        var classes = object[key];
        object[key] = classes ? classes + " " + newClass : newClass;
    }
    function _VirtualDom_render(vNode, eventNode) {
        var tag = vNode.$;
        if (tag === 5) {
            return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
        }
        if (tag === 0) {
            return _VirtualDom_doc.createTextNode(vNode.a);
        }
        if (tag === 4) {
            var subNode = vNode.k;
            var tagger = vNode.j;
            while (subNode.$ === 4) {
                typeof tagger !== "object"
                    ? tagger = [tagger, subNode.j]
                    : tagger.push(subNode.j);
                subNode = subNode.k;
            }
            var subEventRoot = (new $$Record6(tagger, eventNode));
            var domNode = _VirtualDom_render(subNode, subEventRoot);
            domNode.elm_event_node_ref = subEventRoot;
            return domNode;
        }
        if (tag === 3) {
            var domNode = vNode.h(vNode.g);
            _VirtualDom_applyFacts(domNode, eventNode, vNode.d);
            return domNode;
        }
        var domNode = vNode.f
            ? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
            : _VirtualDom_doc.createElement(vNode.c);
        if (_VirtualDom_divertHrefToApp && vNode.c == "a") {
            domNode.addEventListener("click", _VirtualDom_divertHrefToApp(domNode));
        }
        _VirtualDom_applyFacts(domNode, eventNode, vNode.d);
        for (var kids = vNode.e, i = 0; i < kids.length; i++) {
            _VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
        }
        return domNode;
    }
    function _VirtualDom_applyFacts(domNode, eventNode, facts) {
        for (var __keys_key = Object.keys(facts || {}), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
            var value = facts[key];
            key === "a1"
                ? _VirtualDom_applyStyles(domNode, value)
                :
                    key === "a0"
                        ? _VirtualDom_applyEvents(domNode, eventNode, value)
                        :
                            key === "a3"
                                ? _VirtualDom_applyAttrs(domNode, value)
                                :
                                    key === "a4"
                                        ? _VirtualDom_applyAttrsNS(domNode, value)
                                        :
                                            ((key !== "value" && key !== "checked") || domNode[key] !== value) && (domNode[key] = value);
        }
    }
    function _VirtualDom_applyStyles(domNode, styles) {
        var domNodeStyle = domNode.style;
        for (var __keys_key = Object.keys(styles || {}), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
            domNodeStyle[key] = styles[key];
        }
    }
    function _VirtualDom_applyAttrs(domNode, attrs) {
        for (var __keys_key = Object.keys(attrs || {}), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
            var value = attrs[key];
            typeof value !== "undefined"
                ? domNode.setAttribute(key, value)
                : domNode.removeAttribute(key);
        }
    }
    function _VirtualDom_applyAttrsNS(domNode, nsAttrs) {
        for (var __keys_key = Object.keys(nsAttrs || {}), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
            var pair = nsAttrs[key];
            var namespace = pair.f;
            var value = pair.o;
            typeof value !== "undefined"
                ? domNode.setAttributeNS(namespace, key, value)
                : domNode.removeAttributeNS(namespace, key);
        }
    }
    function _VirtualDom_applyEvents(domNode, eventNode, events) {
        var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
        for (var __keys_key = Object.keys(events || {}), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
            var newHandler = events[key];
            var oldCallback = allCallbacks[key];
            if (!newHandler) {
                domNode.removeEventListener(key, oldCallback);
                allCallbacks[key] = undefined;
                continue;
            }
            if (oldCallback) {
                var oldHandler = oldCallback.q;
                if (oldHandler.$ === newHandler.$) {
                    oldCallback.q = newHandler;
                    continue;
                }
                domNode.removeEventListener(key, oldCallback);
            }
            oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
            domNode.addEventListener(key, oldCallback, _VirtualDom_passiveSupported
                && { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 });
            allCallbacks[key] = oldCallback;
        }
    }
    var _VirtualDom_passiveSupported;
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function () { _VirtualDom_passiveSupported = true; }
        }));
    }
    catch (e) { }
    function _VirtualDom_makeCallback(eventNode, initialHandler) {
        function callback(event) {
            var handler = callback.q;
            var result = _Json_runHelp(handler.a, event);
            if (!$elm$core$Result$isOk(result)) {
                return;
            }
            var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);
            var value = result.a;
            var message = !tag ? value : tag < 3 ? value.a : value.m_;
            var stopPropagation = tag == 1 ? value.b : tag == 3 && value.oU;
            var currentEventNode = (stopPropagation && event.stopPropagation(),
                (tag == 2 ? value.b : tag == 3 && value.nU) && event.preventDefault(),
                eventNode);
            var tagger;
            var i;
            while (tagger = currentEventNode.j) {
                if (typeof tagger == "function") {
                    message = tagger(message);
                }
                else {
                    for (var i = tagger.length; i--;) {
                        message = tagger[i](message);
                    }
                }
                currentEventNode = currentEventNode.p;
            }
            currentEventNode(message, stopPropagation);
        }
        callback.q = initialHandler;
        return callback;
    }
    function _VirtualDom_equalEvents(x, y) {
        return x.$ == y.$ && _Json_equality(x.a, y.a);
    }
    function _VirtualDom_diff(x, y) {
        var patches = [];
        _VirtualDom_diffHelp(x, y, patches, 0);
        return patches;
    }
    function _VirtualDom_pushPatch(patches, type, index, data) {
        var patch = {
            $: type,
            r: index,
            s: data,
            t: undefined,
            u: undefined
        };
        patches.push(patch);
        return patch;
    }
    function _VirtualDom_diffHelp(x, y, patches, index) {
        if (x === y) {
            return;
        }
        var xType = x.$;
        var yType = y.$;
        if (xType !== yType) {
            if (xType === 1 && yType === 2) {
                y = _VirtualDom_dekey(y);
                yType = 1;
            }
            else {
                _VirtualDom_pushPatch(patches, 0, index, y);
                return;
            }
        }
        switch (yType) {
            case 5:
                var xRefs = x.l;
                var yRefs = y.l;
                var i = xRefs.length;
                var same = i === yRefs.length;
                while (same && i--) {
                    same = xRefs[i] === yRefs[i];
                }
                if (same) {
                    y.k = x.k;
                    return;
                }
                y.k = y.m();
                var subPatches = [];
                _VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
                subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
                return;
            case 4:
                var xTaggers = x.j;
                var yTaggers = y.j;
                var nesting = false;
                var xSubNode = x.k;
                while (xSubNode.$ === 4) {
                    nesting = true;
                    typeof xTaggers !== "object"
                        ? xTaggers = [xTaggers, xSubNode.j]
                        : xTaggers.push(xSubNode.j);
                    xSubNode = xSubNode.k;
                }
                var ySubNode = y.k;
                while (ySubNode.$ === 4) {
                    nesting = true;
                    typeof yTaggers !== "object"
                        ? yTaggers = [yTaggers, ySubNode.j]
                        : yTaggers.push(ySubNode.j);
                    ySubNode = ySubNode.k;
                }
                if (nesting && xTaggers.length !== yTaggers.length) {
                    _VirtualDom_pushPatch(patches, 0, index, y);
                    return;
                }
                if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers) {
                    _VirtualDom_pushPatch(patches, 2, index, yTaggers);
                }
                _VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
                return;
            case 0:
                if (x.a !== y.a) {
                    _VirtualDom_pushPatch(patches, 3, index, y.a);
                }
                return;
            case 1:
                _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
                return;
            case 2:
                _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
                return;
            case 3:
                if (x.h !== y.h) {
                    _VirtualDom_pushPatch(patches, 0, index, y);
                    return;
                }
                var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
                factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
                var patch = y.i(x.g, y.g);
                patch && _VirtualDom_pushPatch(patches, 5, index, patch);
                return;
        }
    }
    function _VirtualDom_pairwiseRefEqual(as, bs) {
        for (var i = 0; i < as.length; i++) {
            if (as[i] !== bs[i]) {
                return false;
            }
        }
        return true;
    }
    function _VirtualDom_diffNodes(x, y, patches, index, diffKids) {
        if (x.c !== y.c || x.f !== y.f) {
            _VirtualDom_pushPatch(patches, 0, index, y);
            return;
        }
        var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
        factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
        diffKids(x, y, patches, index);
    }
    function _VirtualDom_diffFacts(x, y, category) {
        var diff;
        for (var __keys_xKey = Object.keys(x || {}), __i_xKey = 0; __i_xKey < __keys_xKey.length; __i_xKey++) { var xKey = __keys_xKey[__i_xKey];
            if (xKey === "a1" || xKey === "a0" || xKey === "a3" || xKey === "a4") {
                var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
                if (subDiff) {
                    diff = diff || {};
                    diff[xKey] = subDiff;
                }
                continue;
            }
            if (!(xKey in y)) {
                diff = diff || {};
                diff[xKey] =
                    !category
                        ? (typeof x[xKey] === "string" ? "" : null)
                        :
                            (category === "a1")
                                ? ""
                                :
                                    (category === "a0" || category === "a3")
                                        ? undefined
                                        : (new $$Record5(x[xKey].f, undefined));
                continue;
            }
            var xValue = x[xKey];
            var yValue = y[xKey];
            if (xValue === yValue && xKey !== "value" && xKey !== "checked"
                || category === "a0" && _VirtualDom_equalEvents(xValue, yValue)) {
                continue;
            }
            diff = diff || {};
            diff[xKey] = yValue;
        }
        for (var __keys_yKey = Object.keys(y || {}), __i_yKey = 0; __i_yKey < __keys_yKey.length; __i_yKey++) { var yKey = __keys_yKey[__i_yKey];
            if (!(yKey in x)) {
                diff = diff || {};
                diff[yKey] = y[yKey];
            }
        }
        return diff;
    }
    function _VirtualDom_diffKids(xParent, yParent, patches, index) {
        var xKids = xParent.e;
        var yKids = yParent.e;
        var xLen = xKids.length;
        var yLen = yKids.length;
        if (xLen > yLen) {
            _VirtualDom_pushPatch(patches, 6, index, {
                v: yLen,
                i: xLen - yLen
            });
        }
        else if (xLen < yLen) {
            _VirtualDom_pushPatch(patches, 7, index, {
                v: xLen,
                e: yKids
            });
        }
        for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++) {
            var xKid = xKids[i];
            _VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
            index += xKid.b || 0;
        }
    }
    function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex) {
        var localPatches = [];
        var changes = {};
        var inserts = [];
        var xKids = xParent.e;
        var yKids = yParent.e;
        var xLen = xKids.length;
        var yLen = yKids.length;
        var xIndex = 0;
        var yIndex = 0;
        var index = rootIndex;
        while (xIndex < xLen && yIndex < yLen) {
            var x = xKids[xIndex];
            var y = yKids[yIndex];
            var xKey = x.a;
            var yKey = y.a;
            var xNode = x.b;
            var yNode = y.b;
            var newMatch = undefined;
            var oldMatch = undefined;
            if (xKey === yKey) {
                index++;
                _VirtualDom_diffHelp(xNode, yNode, localPatches, index);
                index += xNode.b || 0;
                xIndex++;
                yIndex++;
                continue;
            }
            var xNext = xKids[xIndex + 1];
            var yNext = yKids[yIndex + 1];
            if (xNext) {
                var xNextKey = xNext.a;
                var xNextNode = xNext.b;
                oldMatch = yKey === xNextKey;
            }
            if (yNext) {
                var yNextKey = yNext.a;
                var yNextNode = yNext.b;
                newMatch = xKey === yNextKey;
            }
            if (newMatch && oldMatch) {
                index++;
                _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
                _VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
                index += xNode.b || 0;
                index++;
                _VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
                index += xNextNode.b || 0;
                xIndex += 2;
                yIndex += 2;
                continue;
            }
            if (newMatch) {
                index++;
                _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
                _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
                index += xNode.b || 0;
                xIndex += 1;
                yIndex += 2;
                continue;
            }
            if (oldMatch) {
                index++;
                _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
                index += xNode.b || 0;
                index++;
                _VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
                index += xNextNode.b || 0;
                xIndex += 2;
                yIndex += 1;
                continue;
            }
            if (xNext && xNextKey === yNextKey) {
                index++;
                _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
                _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
                index += xNode.b || 0;
                index++;
                _VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
                index += xNextNode.b || 0;
                xIndex += 2;
                yIndex += 2;
                continue;
            }
            break;
        }
        while (xIndex < xLen) {
            index++;
            var x = xKids[xIndex];
            var xNode = x.b;
            _VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
            index += xNode.b || 0;
            xIndex++;
        }
        while (yIndex < yLen) {
            var endInserts = endInserts || [];
            var y = yKids[yIndex];
            _VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
            yIndex++;
        }
        if (localPatches.length > 0 || inserts.length > 0 || endInserts) {
            _VirtualDom_pushPatch(patches, 8, rootIndex, (new $$Record7(localPatches, inserts, endInserts)));
        }
    }
    var _VirtualDom_POSTFIX = "_elmW6BL";
    function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts) {
        var entry = changes[key];
        if (!entry) {
            entry = (new $$Record8(0, vnode, yIndex, undefined));
            inserts.push({ r: yIndex, A: entry });
            changes[key] = entry;
            return;
        }
        if (entry.c === 1) {
            inserts.push({ r: yIndex, A: entry });
            entry.c = 2;
            var subPatches = [];
            _VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
            entry.r = yIndex;
            entry.s.s = {
                w: subPatches,
                A: entry
            };
            return;
        }
        _VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
    }
    function _VirtualDom_removeNode(changes, localPatches, key, vnode, index) {
        var entry = changes[key];
        if (!entry) {
            var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
            changes[key] = (new $$Record8(1, vnode, index, patch));
            return;
        }
        if (entry.c === 0) {
            entry.c = 2;
            var subPatches = [];
            _VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
            _VirtualDom_pushPatch(localPatches, 9, index, {
                w: subPatches,
                A: entry
            });
            return;
        }
        _VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
    }
    function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode) {
        _VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
    }
    function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode) {
        var patch = patches[i];
        var index = patch.r;
        while (index === low) {
            var patchType = patch.$;
            if (patchType === 1) {
                _VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
            }
            else if (patchType === 8) {
                patch.t = domNode;
                patch.u = eventNode;
                var subPatches = patch.s.w;
                if (subPatches.length > 0) {
                    _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
                }
            }
            else if (patchType === 9) {
                patch.t = domNode;
                patch.u = eventNode;
                var data = patch.s;
                if (data) {
                    data.A.s = domNode;
                    var subPatches = data.w;
                    if (subPatches.length > 0) {
                        _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
                    }
                }
            }
            else {
                patch.t = domNode;
                patch.u = eventNode;
            }
            i++;
            if (!(patch = patches[i]) || (index = patch.r) > high) {
                return i;
            }
        }
        var tag = vNode.$;
        if (tag === 4) {
            var subNode = vNode.k;
            while (subNode.$ === 4) {
                subNode = subNode.k;
            }
            return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
        }
        var vKids = vNode.e;
        var childNodes = domNode.childNodes;
        for (var j = 0; j < vKids.length; j++) {
            low++;
            var vKid = tag === 1 ? vKids[j] : vKids[j].b;
            var nextLow = low + (vKid.b || 0);
            if (low <= index && index <= nextLow) {
                i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
                if (!(patch = patches[i]) || (index = patch.r) > high) {
                    return i;
                }
            }
            low = nextLow;
        }
        return i;
    }
    function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode) {
        if (patches.length === 0) {
            return rootDomNode;
        }
        _VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
        return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
    }
    function _VirtualDom_applyPatchesHelp(rootDomNode, patches) {
        for (var i = 0; i < patches.length; i++) {
            var patch = patches[i];
            var localDomNode = patch.t;
            var newNode = _VirtualDom_applyPatch(localDomNode, patch);
            if (localDomNode === rootDomNode) {
                rootDomNode = newNode;
            }
        }
        return rootDomNode;
    }
    function _VirtualDom_applyPatch(domNode, patch) {
        switch (patch.$) {
            case 0:
                return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
            case 4:
                _VirtualDom_applyFacts(domNode, patch.u, patch.s);
                return domNode;
            case 3:
                domNode.replaceData(0, domNode.length, patch.s);
                return domNode;
            case 1:
                return _VirtualDom_applyPatchesHelp(domNode, patch.s);
            case 2:
                if (domNode.elm_event_node_ref) {
                    domNode.elm_event_node_ref.j = patch.s;
                }
                else {
                    domNode.elm_event_node_ref = (new $$Record6(patch.s, patch.u));
                }
                return domNode;
            case 6:
                var data = patch.s;
                for (var i = 0; i < data.i; i++) {
                    domNode.removeChild(domNode.childNodes[data.v]);
                }
                return domNode;
            case 7:
                var data = patch.s;
                var kids = data.e;
                var i = data.v;
                var theEnd = domNode.childNodes[i];
                for (; i < kids.length; i++) {
                    domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
                }
                return domNode;
            case 9:
                var data = patch.s;
                if (!data) {
                    domNode.parentNode.removeChild(domNode);
                    return domNode;
                }
                var entry = data.A;
                if (typeof entry.r !== "undefined") {
                    domNode.parentNode.removeChild(domNode);
                }
                entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
                return domNode;
            case 8:
                return _VirtualDom_applyPatchReorder(domNode, patch);
            case 5:
                return patch.s(domNode);
            default:
                _Debug_crash(10);
        }
    }
    function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode) {
        var parentNode = domNode.parentNode;
        var newNode = _VirtualDom_render(vNode, eventNode);
        if (!newNode.elm_event_node_ref) {
            newNode.elm_event_node_ref = domNode.elm_event_node_ref;
        }
        if (parentNode && newNode !== domNode) {
            parentNode.replaceChild(newNode, domNode);
        }
        return newNode;
    }
    function _VirtualDom_applyPatchReorder(domNode, patch) {
        var data = patch.s;
        var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
        domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
        var inserts = data.x;
        for (var i = 0; i < inserts.length; i++) {
            var insert = inserts[i];
            var entry = insert.A;
            var node = entry.c === 2
                ? entry.s
                : _VirtualDom_render(entry.z, patch.u);
            domNode.insertBefore(node, domNode.childNodes[insert.r]);
        }
        if (frag) {
            _VirtualDom_appendChild(domNode, frag);
        }
        return domNode;
    }
    function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch) {
        if (!endInserts) {
            return;
        }
        var frag = _VirtualDom_doc.createDocumentFragment();
        for (var i = 0; i < endInserts.length; i++) {
            var insert = endInserts[i];
            var entry = insert.A;
            _VirtualDom_appendChild(frag, entry.c === 2
                ? entry.s
                : _VirtualDom_render(entry.z, patch.u));
        }
        return frag;
    }
    function _VirtualDom_virtualize(node) {
        if (node.nodeType === 3) {
            return _VirtualDom_text(node.textContent);
        }
        if (node.nodeType !== 1) {
            return _VirtualDom_text("");
        }
        var attrList = _List_Nil;
        var attrs = node.attributes;
        for (var i = attrs.length; i--;) {
            var attr = attrs[i];
            var name = attr.name;
            var value = attr.value;
            attrList = _List_Cons(_VirtualDom_attribute_fn(name, value), attrList);
        }
        var tag = node.tagName.toLowerCase();
        var kidList = _List_Nil;
        var kids = node.childNodes;
        for (var i = kids.length; i--;) {
            kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
        }
        return A3(_VirtualDom_node, tag, attrList, kidList);
    }
    function _VirtualDom_dekey(keyedNode) {
        var keyedKids = keyedNode.e;
        var len = keyedKids.length;
        var kids = new Array(len);
        for (var i = 0; i < len; i++) {
            kids[i] = keyedKids[i].b;
        }
        return {
            $: 1,
            c: keyedNode.c,
            d: keyedNode.d,
            e: kids,
            f: keyedNode.f,
            b: keyedNode.b
        };
    }
    var _Debugger_element;
    var _Browser_element = _Debugger_element || F4(function (impl, flagDecoder, debugMetadata, args) {
        return _Platform_initialize(flagDecoder, args, impl.me, impl.pP, impl.o2, function (sendToApp, initialModel) {
            var view = impl.p$;
            var domNode = args["node"];
            var currNode = _VirtualDom_virtualize(domNode);
            return _Browser_makeAnimator(initialModel, function (model) {
                var nextNode = view(model);
                var patches = _VirtualDom_diff(currNode, nextNode);
                domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
                currNode = nextNode;
            });
        });
    });
    var _Debugger_document;
    var _Browser_document = _Debugger_document || F4(function (impl, flagDecoder, debugMetadata, args) {
        return _Platform_initialize(flagDecoder, args, impl.me, impl.pP, impl.o2, function (sendToApp, initialModel) {
            var divertHrefToApp = impl.f3 && impl.f3(sendToApp);
            var view = impl.p$;
            var title = _VirtualDom_doc.title;
            var bodyNode = _VirtualDom_doc.body;
            var currNode = _VirtualDom_virtualize(bodyNode);
            return _Browser_makeAnimator(initialModel, function (model) {
                _VirtualDom_divertHrefToApp = divertHrefToApp;
                var doc = view(model);
                var nextNode = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "body")(_List_Nil)(doc.dG);
                var patches = _VirtualDom_diff(currNode, nextNode);
                bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
                currNode = nextNode;
                _VirtualDom_divertHrefToApp = 0;
                (title !== doc.gj) && (_VirtualDom_doc.title = title = doc.gj);
            });
        });
    });
    var _Browser_cancelAnimationFrame = typeof cancelAnimationFrame !== "undefined"
        ? cancelAnimationFrame
        : function (id) { clearTimeout(id); };
    var _Browser_requestAnimationFrame = typeof requestAnimationFrame !== "undefined"
        ? requestAnimationFrame
        : function (callback) { return setTimeout(callback, 1000 / 60); };
    function _Browser_makeAnimator(model, draw) {
        draw(model);
        var state = 0;
        function updateIfNeeded() {
            state = state === 1
                ? 0
                : (_Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1);
        }
        return function (nextModel, isSync) {
            model = nextModel;
            isSync
                ? (draw(model),
                    state === 2 && (state = 1))
                : (state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
                    state = 2);
        };
    }
    function _Browser_application(impl) {
        var onUrlChange = impl.nB;
        var onUrlRequest = impl.nC;
        var key = function () { key.a(onUrlChange(_Browser_getUrl())); };
        return _Browser_document({
            f3: function (sendToApp) {
                key.a = sendToApp;
                _Browser_window.addEventListener("popstate", key);
                _Browser_window.navigator.userAgent.indexOf("Trident") < 0 || _Browser_window.addEventListener("hashchange", key);
                return F2(function (domNode, event) {
                    if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute("download")) {
                        event.preventDefault();
                        var href = domNode.href;
                        var curr = _Browser_getUrl();
                        var next = $elm$url$Url$fromString(href).a;
                        sendToApp(onUrlRequest((next
                            && curr.nY === next.nY
                            && curr.hK === next.hK
                            && curr.nT.a === next.nT.a)
                            ? $elm$browser$Browser$Internal(next)
                            : $elm$browser$Browser$External(href)));
                    }
                });
            },
            me: function (flags) {
                return A3(impl.me, flags, _Browser_getUrl(), key);
            },
            p$: impl.p$,
            pP: impl.pP,
            o2: impl.o2
        });
    }
    function _Browser_getUrl() {
        return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
    }
    var _Browser_go_fn = function (key, n) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function () {
            n && history.go(n);
            key();
        }));
    }, _Browser_go = F2(_Browser_go_fn);
    var _Browser_pushUrl_fn = function (key, url) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function () {
            history.pushState({}, "", url);
            key();
        }));
    }, _Browser_pushUrl = F2(_Browser_pushUrl_fn);
    var _Browser_replaceUrl_fn = function (key, url) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function () {
            history.replaceState({}, "", url);
            key();
        }));
    }, _Browser_replaceUrl = F2(_Browser_replaceUrl_fn);
    var _Browser_fakeNode = { addEventListener: function () { }, removeEventListener: function () { } };
    var _Browser_doc = typeof document !== "undefined" ? document : _Browser_fakeNode;
    var _Browser_window = typeof window !== "undefined" ? window : _Browser_fakeNode;
    var _Browser_on_fn = function (node, eventName, sendToSelf) {
        return _Scheduler_spawn(_Scheduler_binding(function (callback) {
            function handler(event) { _Scheduler_rawSpawn(sendToSelf(event)); }
            node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
            return function () { node.removeEventListener(eventName, handler); };
        }));
    }, _Browser_on = F3(_Browser_on_fn);
    var _Browser_decodeEvent_fn = function (decoder, event) {
        var result = _Json_runHelp(decoder, event);
        return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
    }, _Browser_decodeEvent = F2(_Browser_decodeEvent_fn);
    function _Browser_visibilityInfo() {
        return (typeof _VirtualDom_doc.hidden !== "undefined")
            ? { l_: "hidden", kF: "visibilitychange" }
            :
                (typeof _VirtualDom_doc.mozHidden !== "undefined")
                    ? { l_: "mozHidden", kF: "mozvisibilitychange" }
                    :
                        (typeof _VirtualDom_doc.msHidden !== "undefined")
                            ? { l_: "msHidden", kF: "msvisibilitychange" }
                            :
                                (typeof _VirtualDom_doc.webkitHidden !== "undefined")
                                    ? { l_: "webkitHidden", kF: "webkitvisibilitychange" }
                                    : { l_: "hidden", kF: "visibilitychange" };
    }
    function _Browser_rAF() {
        return _Scheduler_binding(function (callback) {
            var id = _Browser_requestAnimationFrame(function () {
                callback(_Scheduler_succeed(Date.now()));
            });
            return function () {
                _Browser_cancelAnimationFrame(id);
            };
        });
    }
    function _Browser_now() {
        return _Scheduler_binding(function (callback) {
            callback(_Scheduler_succeed(Date.now()));
        });
    }
    function _Browser_withNode(id, doStuff) {
        return _Scheduler_binding(function (callback) {
            _Browser_requestAnimationFrame(function () {
                var node = document.getElementById(id);
                callback(node
                    ? _Scheduler_succeed(doStuff(node))
                    : _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id)));
            });
        });
    }
    function _Browser_withWindow(doStuff) {
        return _Scheduler_binding(function (callback) {
            _Browser_requestAnimationFrame(function () {
                callback(_Scheduler_succeed(doStuff()));
            });
        });
    }
    var _Browser_call_fn = function (functionName, id) {
        return _Browser_withNode(id, function (node) {
            node[functionName]();
            return _Utils_Tuple0;
        });
    }, _Browser_call = F2(_Browser_call_fn);
    function _Browser_getViewport() {
        return (new $$Record10(_Browser_getScene(), (new $$Record9(_Browser_window.pageXOffset, _Browser_window.pageYOffset, _Browser_doc.documentElement.clientWidth, _Browser_doc.documentElement.clientHeight))));
    }
    function _Browser_getScene() {
        var body = _Browser_doc.body;
        var elem = _Browser_doc.documentElement;
        return (new $$Record11(Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth), Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)));
    }
    var _Browser_setViewport_fn = function (x, y) {
        return _Browser_withWindow(function () {
            _Browser_window.scroll(x, y);
            return _Utils_Tuple0;
        });
    }, _Browser_setViewport = F2(_Browser_setViewport_fn);
    function _Browser_getViewportOf(id) {
        return _Browser_withNode(id, function (node) {
            return (new $$Record10((new $$Record11(node.scrollWidth, node.scrollHeight)), (new $$Record9(node.scrollLeft, node.scrollTop, node.clientWidth, node.clientHeight))));
        });
    }
    var _Browser_setViewportOf_fn = function (id, x, y) {
        return _Browser_withNode(id, function (node) {
            node.scrollLeft = x;
            node.scrollTop = y;
            return _Utils_Tuple0;
        });
    }, _Browser_setViewportOf = F3(_Browser_setViewportOf_fn);
    function _Browser_getElement(id) {
        return _Browser_withNode(id, function (node) {
            var rect = node.getBoundingClientRect();
            var x = _Browser_window.pageXOffset;
            var y = _Browser_window.pageYOffset;
            return (new $$Record12(_Browser_getScene(), (new $$Record9(x, y, _Browser_doc.documentElement.clientWidth, _Browser_doc.documentElement.clientHeight)), (new $$Record9(x + rect.left, y + rect.top, rect.width, rect.height))));
        });
    }
    function _Browser_reload(skipCache) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function (callback) {
            _VirtualDom_doc.location.reload(skipCache);
        }));
    }
    function _Browser_load(url) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function (callback) {
            try {
                _Browser_window.location = url;
            }
            catch (err) {
                _VirtualDom_doc.location.reload(false);
            }
        }));
    }
    var _Parser_isSubString_fn = function (smallString, offset, row, col, bigString) {
        var smallLength = smallString.length;
        var isGood = offset + smallLength <= bigString.length;
        for (var i = 0; isGood && i < smallLength;) {
            var code = bigString.charCodeAt(offset);
            isGood =
                smallString[i++] === bigString[offset++]
                    && (code === 10
                        ? (row++, col = 1)
                        : (col++, (code & 63488) === 55296 ? smallString[i++] === bigString[offset++] : 1));
        }
        return _Utils_Tuple3(isGood ? offset : -1, row, col);
    }, _Parser_isSubString = F5(_Parser_isSubString_fn);
    var _Parser_isSubChar_fn = function (predicate, offset, string) {
        return (string.length <= offset
            ? -1
            :
                (string.charCodeAt(offset) & 63488) === 55296
                    ? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
                    :
                        (predicate(_Utils_chr(string[offset]))
                            ? ((string[offset] === "\n") ? -2 : (offset + 1))
                            : -1));
    }, _Parser_isSubChar = F3(_Parser_isSubChar_fn);
    var _Parser_isAsciiCode_fn = function (code, offset, string) {
        return string.charCodeAt(offset) === code;
    }, _Parser_isAsciiCode = F3(_Parser_isAsciiCode_fn);
    var _Parser_chompBase10_fn = function (offset, string) {
        for (; offset < string.length; offset++) {
            var code = string.charCodeAt(offset);
            if (code < 48 || 57 < code) {
                return offset;
            }
        }
        return offset;
    }, _Parser_chompBase10 = F2(_Parser_chompBase10_fn);
    var _Parser_consumeBase_fn = function (base, offset, string) {
        for (var total = 0; offset < string.length; offset++) {
            var digit = string.charCodeAt(offset) - 48;
            if (digit < 0 || base <= digit)
                break;
            total = base * total + digit;
        }
        return _Utils_Tuple2(offset, total);
    }, _Parser_consumeBase = F3(_Parser_consumeBase_fn);
    var _Parser_consumeBase16_fn = function (offset, string) {
        for (var total = 0; offset < string.length; offset++) {
            var code = string.charCodeAt(offset);
            if (48 <= code && code <= 57) {
                total = 16 * total + code - 48;
            }
            else if (65 <= code && code <= 70) {
                total = 16 * total + code - 55;
            }
            else if (97 <= code && code <= 102) {
                total = 16 * total + code - 87;
            }
            else {
                break;
            }
        }
        return _Utils_Tuple2(offset, total);
    }, _Parser_consumeBase16 = F2(_Parser_consumeBase16_fn);
    var _Parser_findSubString_fn = function (smallString, offset, row, col, bigString) {
        var newOffset = bigString.indexOf(smallString, offset);
        var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;
        while (offset < target) {
            var code = bigString.charCodeAt(offset++);
            code === 10
                ? (col = 1, row++)
                : (col++, (code & 63488) === 55296 && offset++);
        }
        return _Utils_Tuple3(newOffset, row, col);
    }, _Parser_findSubString = F5(_Parser_findSubString_fn);
    var _Regex_never = /.^/;
    var _Regex_fromStringWith_fn = function (options, string) {
        var flags = "g";
        if (options.ii) {
            flags += "m";
        }
        if (options.kE) {
            flags += "i";
        }
        try {
            return $elm$core$Maybe$Just(new RegExp(string, flags));
        }
        catch (error) {
            return $elm$core$Maybe$Nothing;
        }
    }, _Regex_fromStringWith = F2(_Regex_fromStringWith_fn);
    var _Regex_contains_fn = function (re, string) {
        return string.match(re) !== null;
    }, _Regex_contains = F2(_Regex_contains_fn);
    var _Regex_findAtMost_fn = function (n, re, str) {
        var out = [];
        var number = 0;
        var string = str;
        var lastIndex = re.lastIndex;
        var prevLastIndex = -1;
        var result;
        while (number++ < n && (result = re.exec(string))) {
            if (prevLastIndex == re.lastIndex)
                break;
            var i = result.length - 1;
            var subs = new Array(i);
            while (i > 0) {
                var submatch = result[i];
                subs[--i] = submatch
                    ? $elm$core$Maybe$Just(submatch)
                    : $elm$core$Maybe$Nothing;
            }
            out.push($elm$regex$Regex$Match_fn(result[0], result.index, number, _List_fromArray(subs)));
            prevLastIndex = re.lastIndex;
        }
        re.lastIndex = lastIndex;
        return _List_fromArray(out);
    }, _Regex_findAtMost = F3(_Regex_findAtMost_fn);
    var _Regex_replaceAtMost_fn = function (n, re, replacer, string) {
        var count = 0;
        function jsReplacer(match) {
            if (count++ >= n) {
                return match;
            }
            var i = arguments.length - 3;
            var submatches = new Array(i);
            while (i > 0) {
                var submatch = arguments[i];
                submatches[--i] = submatch
                    ? $elm$core$Maybe$Just(submatch)
                    : $elm$core$Maybe$Nothing;
            }
            return replacer($elm$regex$Regex$Match_fn(match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
        }
        return string.replace(re, jsReplacer);
    }, _Regex_replaceAtMost = F4(_Regex_replaceAtMost_fn);
    var _Regex_splitAtMost_fn = function (n, re, str) {
        var string = str;
        var out = [];
        var start = re.lastIndex;
        var restoreLastIndex = re.lastIndex;
        while (n--) {
            var result = re.exec(string);
            if (!result)
                break;
            out.push(string.slice(start, result.index));
            start = re.lastIndex;
        }
        out.push(string.slice(start));
        re.lastIndex = restoreLastIndex;
        return _List_fromArray(out);
    }, _Regex_splitAtMost = F3(_Regex_splitAtMost_fn);
    var _Regex_infinity = Infinity;
    var _Bitwise_and_fn = function (a, b) {
        return a & b;
    }, _Bitwise_and = F2(_Bitwise_and_fn);
    var _Bitwise_or_fn = function (a, b) {
        return a | b;
    }, _Bitwise_or = F2(_Bitwise_or_fn);
    var _Bitwise_xor_fn = function (a, b) {
        return a ^ b;
    }, _Bitwise_xor = F2(_Bitwise_xor_fn);
    function _Bitwise_complement(a) {
        return ~a;
    }
    ;
    var _Bitwise_shiftLeftBy_fn = function (offset, a) {
        return a << offset;
    }, _Bitwise_shiftLeftBy = F2(_Bitwise_shiftLeftBy_fn);
    var _Bitwise_shiftRightBy_fn = function (offset, a) {
        return a >> offset;
    }, _Bitwise_shiftRightBy = F2(_Bitwise_shiftRightBy_fn);
    var _Bitwise_shiftRightZfBy_fn = function (offset, a) {
        return a >>> offset;
    }, _Bitwise_shiftRightZfBy = F2(_Bitwise_shiftRightZfBy_fn);
    function _Bytes_width(bytes) {
        return bytes.byteLength;
    }
    var _Bytes_getHostEndianness_fn = function (le, be) {
        return _Scheduler_binding(function (callback) {
            callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
        });
    }, _Bytes_getHostEndianness = F2(_Bytes_getHostEndianness_fn);
    function _Bytes_encode(encoder) {
        var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
        $elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
        return mutableBytes;
    }
    var _Bytes_write_i8_fn = function (mb, i, n) { mb.setInt8(i, n); return i + 1; }, _Bytes_write_i8 = F3(_Bytes_write_i8_fn);
    var _Bytes_write_i16_fn = function (mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; }, _Bytes_write_i16 = F4(_Bytes_write_i16_fn);
    var _Bytes_write_i32_fn = function (mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; }, _Bytes_write_i32 = F4(_Bytes_write_i32_fn);
    var _Bytes_write_u8_fn = function (mb, i, n) { mb.setUint8(i, n); return i + 1; }, _Bytes_write_u8 = F3(_Bytes_write_u8_fn);
    var _Bytes_write_u16_fn = function (mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; }, _Bytes_write_u16 = F4(_Bytes_write_u16_fn);
    var _Bytes_write_u32_fn = function (mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; }, _Bytes_write_u32 = F4(_Bytes_write_u32_fn);
    var _Bytes_write_f32_fn = function (mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; }, _Bytes_write_f32 = F4(_Bytes_write_f32_fn);
    var _Bytes_write_f64_fn = function (mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; }, _Bytes_write_f64 = F4(_Bytes_write_f64_fn);
    var _Bytes_write_bytes_fn = function (mb, offset, bytes) {
        for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4) {
            mb.setUint32(offset + i, bytes.getUint32(i));
        }
        for (; i < len; i++) {
            mb.setUint8(offset + i, bytes.getUint8(i));
        }
        return offset + len;
    }, _Bytes_write_bytes = F3(_Bytes_write_bytes_fn);
    function _Bytes_getStringWidth(string) {
        for (var width = 0, i = 0; i < string.length; i++) {
            var code = string.charCodeAt(i);
            width +=
                (code < 128) ? 1 :
                    (code < 2048) ? 2 :
                        (code < 55296 || 56319 < code) ? 3 : (i++, 4);
        }
        return width;
    }
    var _Bytes_write_string_fn = function (mb, offset, string) {
        for (var i = 0; i < string.length; i++) {
            var code = string.charCodeAt(i);
            offset +=
                (code < 128)
                    ? (mb.setUint8(offset, code)
                        , 1)
                    :
                        (code < 2048)
                            ? (mb.setUint16(offset, 49280
                                | (code >>> 6 & 31) << 8
                                | code & 63)
                                , 2)
                            :
                                (code < 55296 || 56319 < code)
                                    ? (mb.setUint16(offset, 57472
                                        | (code >>> 12 & 15) << 8
                                        | code >>> 6 & 63)
                                        , mb.setUint8(offset + 2, 128
                                            | code & 63)
                                        , 3)
                                    :
                                        (code = (code - 55296) * 1024 + string.charCodeAt(++i) - 56320 + 65536
                                            , mb.setUint32(offset, 4034953344
                                                | (code >>> 18 & 7) << 24
                                                | (code >>> 12 & 63) << 16
                                                | (code >>> 6 & 63) << 8
                                                | code & 63)
                                            , 4);
        }
        return offset;
    }, _Bytes_write_string = F3(_Bytes_write_string_fn);
    var _Bytes_decode_fn = function (decoder, bytes) {
        try {
            return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
        }
        catch (e) {
            return $elm$core$Maybe$Nothing;
        }
    }, _Bytes_decode_fn_unwrapped = function (decoder, bytes) {
        try {
            return $elm$core$Maybe$Just(decoder(bytes, 0).b);
        }
        catch (e) {
            return $elm$core$Maybe$Nothing;
        }
    }, _Bytes_decode = F2(_Bytes_decode_fn);
    var _Bytes_read_i8_fn = function (bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); }, _Bytes_read_i8 = F2(_Bytes_read_i8_fn);
    var _Bytes_read_i16_fn = function (isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); }, _Bytes_read_i16 = F3(_Bytes_read_i16_fn);
    var _Bytes_read_i32_fn = function (isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); }, _Bytes_read_i32 = F3(_Bytes_read_i32_fn);
    var _Bytes_read_u8_fn = function (bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); }, _Bytes_read_u8 = F2(_Bytes_read_u8_fn);
    var _Bytes_read_u16_fn = function (isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); }, _Bytes_read_u16 = F3(_Bytes_read_u16_fn);
    var _Bytes_read_u32_fn = function (isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); }, _Bytes_read_u32 = F3(_Bytes_read_u32_fn);
    var _Bytes_read_f32_fn = function (isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); }, _Bytes_read_f32 = F3(_Bytes_read_f32_fn);
    var _Bytes_read_f64_fn = function (isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); }, _Bytes_read_f64 = F3(_Bytes_read_f64_fn);
    var _Bytes_read_bytes_fn = function (len, bytes, offset) {
        return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
    }, _Bytes_read_bytes = F3(_Bytes_read_bytes_fn);
    var _Bytes_read_string_fn = function (len, bytes, offset) {
        var string = "";
        var end = offset + len;
        for (; offset < end;) {
            var byte = bytes.getUint8(offset++);
            string +=
                (byte < 128)
                    ? String.fromCharCode(byte)
                    :
                        ((byte & 224) === 192)
                            ? String.fromCharCode((byte & 31) << 6 | bytes.getUint8(offset++) & 63)
                            :
                                ((byte & 240) === 224)
                                    ? String.fromCharCode((byte & 15) << 12
                                        | (bytes.getUint8(offset++) & 63) << 6
                                        | bytes.getUint8(offset++) & 63)
                                    :
                                        (byte =
                                            ((byte & 7) << 18
                                                | (bytes.getUint8(offset++) & 63) << 12
                                                | (bytes.getUint8(offset++) & 63) << 6
                                                | bytes.getUint8(offset++) & 63) - 65536
                                            , String.fromCharCode(Math.floor(byte / 1024) + 55296, byte % 1024 + 56320));
        }
        return _Utils_Tuple2(offset, string);
    }, _Bytes_read_string = F3(_Bytes_read_string_fn);
    var _Bytes_decodeFailure_fn = function () { throw 0; }, _Bytes_decodeFailure = F2(_Bytes_decodeFailure_fn);
    function _Url_percentEncode(string) {
        return encodeURIComponent(string);
    }
    function _Url_percentDecode(string) {
        try {
            return $elm$core$Maybe$Just(decodeURIComponent(string));
        }
        catch (e) {
            return $elm$core$Maybe$Nothing;
        }
    }
    function _Time_now(millisToPosix) {
        return _Scheduler_binding(function (callback) {
            callback(_Scheduler_succeed(millisToPosix(Date.now())));
        });
    }
    var _Time_setInterval_fn = function (interval, task) {
        return _Scheduler_binding(function (callback) {
            var id = setInterval(function () { _Scheduler_rawSpawn(task); }, interval);
            return function () { clearInterval(id); };
        });
    }, _Time_setInterval = F2(_Time_setInterval_fn);
    function _Time_here() {
        return _Scheduler_binding(function (callback) {
            callback(_Scheduler_succeed($elm$time$Time$Zone_fn(-(new Date().getTimezoneOffset()), _List_Nil)));
        });
    }
    function _Time_getZoneName() {
        return _Scheduler_binding(function (callback) {
            try {
                var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
            }
            catch (e) {
                var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
            }
            callback(_Scheduler_succeed(name));
        });
    }
    var _Http_toTask_fn = function (router, toTask, request) {
        return _Scheduler_binding(function (callback) {
            function done(response) {
                callback(toTask(request.an.a(response)));
            }
            var xhr = new XMLHttpRequest();
            xhr.addEventListener("error", function () { done($elm$http$Http$NetworkError_); });
            xhr.addEventListener("timeout", function () { done($elm$http$Http$Timeout_); });
            xhr.addEventListener("load", function () { done(_Http_toResponse(request.an.b, xhr)); });
            $elm$core$Maybe$isJust(request.pI) && _Http_track(router, xhr, request.pI.a);
            try {
                xhr.open(request.id, request.dt, true);
            }
            catch (e) {
                return done($elm$http$Http$BadUrl_(request.dt));
            }
            _Http_configureRequest(xhr, request);
            request.dG.a && xhr.setRequestHeader("Content-Type", request.dG.a);
            xhr.send(request.dG.b);
            return function () { xhr.c = true; xhr.abort(); };
        });
    }, _Http_toTask = F3(_Http_toTask_fn);
    function _Http_configureRequest(xhr, request) {
        for (var headers = request.hG; headers.b; headers = headers.b) {
            xhr.setRequestHeader(headers.a.a, headers.a.b);
        }
        xhr.timeout = request.ak.a || 0;
        xhr.responseType = request.an.d;
        xhr.withCredentials = request.j5;
    }
    function _Http_toResponse(toBody, xhr) {
        return A2(200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_, _Http_toMetadata(xhr), toBody(xhr.response));
    }
    function _Http_toMetadata(xhr) {
        return {
            dt: xhr.responseURL,
            oQ: xhr.status,
            oR: xhr.statusText,
            hG: _Http_parseHeaders(xhr.getAllResponseHeaders())
        };
    }
    function _Http_parseHeaders(rawHeaders) {
        if (!rawHeaders) {
            return $elm$core$Dict$empty;
        }
        var headers = $elm$core$Dict$empty;
        var headerPairs = rawHeaders.split("\r\n");
        for (var i = headerPairs.length; i--;) {
            var headerPair = headerPairs[i];
            var index = headerPair.indexOf(": ");
            if (index > 0) {
                var key = headerPair.substring(0, index);
                var value = headerPair.substring(index + 2);
                headers = $elm$core$Dict$update_fn(key, function (oldValue) {
                    return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
                        ? value + ", " + oldValue.a
                        : value);
                }, headers);
            }
        }
        return headers;
    }
    var _Http_expect_fn = function (type, toBody, toValue) {
        return {
            $: 0,
            d: type,
            b: toBody,
            a: toValue
        };
    }, _Http_expect = F3(_Http_expect_fn);
    var _Http_mapExpect_fn = function (func, expect) {
        return {
            $: 0,
            d: expect.d,
            b: expect.b,
            a: function (x) { return func(expect.a(x)); }
        };
    }, _Http_mapExpect = F2(_Http_mapExpect_fn);
    function _Http_toDataView(arrayBuffer) {
        return new DataView(arrayBuffer);
    }
    var _Http_emptyBody = { $: 0 };
    var _Http_pair_fn = function (a, b) { return { $: 0, a: a, b: b }; }, _Http_pair = F2(_Http_pair_fn);
    function _Http_toFormData(parts) {
        for (var formData = new FormData(); parts.b; parts = parts.b) {
            var part = parts.a;
            formData.append(part.a, part.b);
        }
        return formData;
    }
    var _Http_bytesToBlob_fn = function (mime, bytes) {
        return new Blob([bytes], { type: mime });
    }, _Http_bytesToBlob = F2(_Http_bytesToBlob_fn);
    function _Http_track(router, xhr, tracker) {
        xhr.upload.addEventListener("progress", function (event) {
            if (xhr.c) {
                return;
            }
            _Scheduler_rawSpawn(_Platform_sendToSelf_fn(router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
                ou: event.loaded,
                oE: event.total
            }))));
        });
        xhr.addEventListener("progress", function (event) {
            if (xhr.c) {
                return;
            }
            _Scheduler_rawSpawn(_Platform_sendToSelf_fn(router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
                n0: event.loaded,
                oE: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
            }))));
        });
    }
    var $elm$core$Maybe$Just = function (a) { return { $: 0, a: a }; };
    var $elm$core$Maybe$Nothing = { $: 1, a: null };
    var $author$project$Model$URLChange = function (a) {
        return { $: 39, a: a };
    };
    var $author$project$Model$URLRequest = function (a) {
        return { $: 38, a: a };
    };
    var $elm$core$List$cons = _List_cons;
    var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
    var $elm$core$Array$foldr_fn = function (func, baseCase, _v0) {
        var tree = _v0.c;
        var tail = _v0.d;
        var helper = F2(function (node, acc) {
            if (!node.$) {
                var subTree = node.a;
                return _JsArray_foldr_fn(helper, acc, subTree);
            }
            else {
                var values = node.a;
                return _JsArray_foldr_fn(func, acc, values);
            }
        });
        return _JsArray_foldr_fn(helper, _JsArray_foldr_fn(func, baseCase, tail), tree);
    }, $elm$core$Array$foldr = F3($elm$core$Array$foldr_fn);
    var $elm$core$Array$toList = function (array) {
        return $elm$core$Array$foldr_fn($elm$core$List$cons, _List_Nil, array);
    };
    var $elm$core$Dict$foldr_fn = function (func, acc, t) {
        foldr: while (true) {
            if (t.$ === -2) {
                return acc;
            }
            else {
                var key = t.b;
                var value = t.c;
                var left = t.d;
                var right = t.e;
                var $temp$func = func, $temp$acc = A3(func, key, value, $elm$core$Dict$foldr_fn(func, acc, right)), $temp$t = left;
                func = $temp$func;
                acc = $temp$acc;
                t = $temp$t;
                continue foldr;
            }
        }
    }, $elm$core$Dict$foldr_fn_unwrapped = function (func, acc, t) {
        foldr: while (true) {
            if (t.$ === -2) {
                return acc;
            }
            else {
                var key = t.b;
                var value = t.c;
                var left = t.d;
                var right = t.e;
                var $temp$func = func, $temp$acc = func(key, value, $elm$core$Dict$foldr_fn_unwrapped(func, acc, right)), $temp$t = left;
                func = $temp$func;
                acc = $temp$acc;
                t = $temp$t;
                continue foldr;
            }
        }
    }, $elm$core$Dict$foldr = F3($elm$core$Dict$foldr_fn);
    var $elm$core$Dict$toList = function (dict) {
        return $elm$core$Dict$foldr_fn_unwrapped(function (key, value, list) {
            return _List_Cons(_Utils_Tuple2(key, value), list);
        }, _List_Nil, dict);
    };
    var $elm$core$Dict$keys = function (dict) {
        return $elm$core$Dict$foldr_fn_unwrapped(function (key, value, keyList) {
            return _List_Cons(key, keyList);
        }, _List_Nil, dict);
    };
    var $elm$core$Set$toList = function (_v0) {
        var dict = _v0;
        return $elm$core$Dict$keys(dict);
    };
    var $elm$core$Basics$EQ = 1;
    var $elm$core$Basics$GT = 2;
    var $elm$core$Basics$LT = 0;
    var $elm$core$Result$Err = function (a) {
        return { $: 1, a: a };
    };
    var $elm$json$Json$Decode$Failure_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $elm$json$Json$Decode$Failure = F2($elm$json$Json$Decode$Failure_fn);
    var $elm$json$Json$Decode$Field_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$json$Json$Decode$Field = F2($elm$json$Json$Decode$Field_fn);
    var $elm$json$Json$Decode$Index_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $elm$json$Json$Decode$Index = F2($elm$json$Json$Decode$Index_fn);
    var $elm$core$Result$Ok = function (a) {
        return { $: 0, a: a };
    };
    var $elm$json$Json$Decode$OneOf = function (a) {
        return { $: 2, a: a };
    };
    var $elm$core$Basics$False = 1;
    var $elm$core$Basics$add = _Basics_add;
    var $elm$core$String$all = _String_all;
    var $elm$core$Basics$and = _Basics_and;
    var $elm$core$Basics$append = _Utils_append;
    var $elm$json$Json$Encode$encode = _Json_encode;
    var $elm$core$String$fromInt = _String_fromNumber;
    var $elm$core$String$join_fn = function (sep, chunks) {
        return _String_join_fn(sep, _List_toArray(chunks));
    }, $elm$core$String$join = F2($elm$core$String$join_fn);
    var $elm$core$String$split_fn = function (sep, string) {
        return _List_fromArray(_String_split_fn(sep, string));
    }, $elm$core$String$split = F2($elm$core$String$split_fn);
    var $elm$json$Json$Decode$indent = function (str) {
        return $elm$core$String$join_fn("\n    ", $elm$core$String$split_fn("\n", str));
    };
    var $elm$core$List$foldl_fn = function (func, acc, list) {
        foldl: while (true) {
            if (!list.b) {
                return acc;
            }
            else {
                var x = list.a;
                var xs = list.b;
                var $temp$func = func, $temp$acc = A2(func, x, acc), $temp$list = xs;
                func = $temp$func;
                acc = $temp$acc;
                list = $temp$list;
                continue foldl;
            }
        }
    }, $elm$core$List$foldl_fn_unwrapped = function (func, acc, list) {
        foldl: while (true) {
            if (!list.b) {
                return acc;
            }
            else {
                var x = list.a;
                var xs = list.b;
                var $temp$func = func, $temp$acc = func(x, acc), $temp$list = xs;
                func = $temp$func;
                acc = $temp$acc;
                list = $temp$list;
                continue foldl;
            }
        }
    }, $elm$core$List$foldl = F3($elm$core$List$foldl_fn);
    var $elm$core$List$length = function (xs) {
        return $elm$core$List$foldl_fn_unwrapped(function (_v0, i) {
            return i + 1;
        }, 0, xs);
    };
    var $elm$core$List$map2 = _List_map2;
    var $elm$core$Basics$le = _Utils_le;
    var $elm$core$Basics$sub = _Basics_sub;
    var $elm$core$List$rangeHelp_fn = function (lo, hi, list) {
        rangeHelp: while (true) {
            if (_Utils_cmp(lo, hi) < 1) {
                var $temp$lo = lo, $temp$hi = hi - 1, $temp$list = _List_Cons(hi, list);
                lo = $temp$lo;
                hi = $temp$hi;
                list = $temp$list;
                continue rangeHelp;
            }
            else {
                return list;
            }
        }
    }, $elm$core$List$rangeHelp = F3($elm$core$List$rangeHelp_fn);
    var $elm$core$List$range_fn = function (lo, hi) {
        return $elm$core$List$rangeHelp_fn(lo, hi, _List_Nil);
    }, $elm$core$List$range = F2($elm$core$List$range_fn);
    var $elm$core$List$indexedMap_fn = function (f, xs) {
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (var i = 0; xs.b; i++, xs = xs.b) {
            var next = _List_Cons(A2(f, i, xs.a), _List_Nil);
            end.b = next;
            end = next;
        }
        return tmp.b;
    }, $elm$core$List$indexedMap_fn_unwrapped = function (f, xs) {
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (var i = 0; xs.b; i++, xs = xs.b) {
            var next = _List_Cons(f(i, xs.a), _List_Nil);
            end.b = next;
            end = next;
        }
        return tmp.b;
    }, $elm$core$List$indexedMap = F2($elm$core$List$indexedMap_fn);
    var $elm$core$Char$toCode = _Char_toCode;
    var $elm$core$Char$isLower = function (_char) {
        var code = $elm$core$Char$toCode(_char);
        return (97 <= code) && (code <= 122);
    };
    var $elm$core$Char$isUpper = function (_char) {
        var code = $elm$core$Char$toCode(_char);
        return (code <= 90) && (65 <= code);
    };
    var $elm$core$Basics$or = _Basics_or;
    var $elm$core$Char$isAlpha = function (_char) {
        return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
    };
    var $elm$core$Char$isDigit = function (_char) {
        var code = $elm$core$Char$toCode(_char);
        return (code <= 57) && (48 <= code);
    };
    var $elm$core$Char$isAlphaNum = function (_char) {
        return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
    };
    var $elm$core$List$reverse = function (list) {
        return $elm$core$List$foldl_fn($elm$core$List$cons, _List_Nil, list);
    };
    var $elm$core$String$uncons = _String_uncons;
    var $elm$json$Json$Decode$errorOneOf_fn = function (i, error) {
        return "\n\n(" + ($elm$core$String$fromInt(i + 1) + (") " + $elm$json$Json$Decode$indent($elm$json$Json$Decode$errorToString(error))));
    }, $elm$json$Json$Decode$errorOneOf = F2($elm$json$Json$Decode$errorOneOf_fn);
    var $elm$json$Json$Decode$errorToString = function (error) {
        return $elm$json$Json$Decode$errorToStringHelp_fn(error, _List_Nil);
    };
    var $elm$json$Json$Decode$errorToStringHelp_fn = function (error, context) {
        errorToStringHelp: while (true) {
            switch (error.$) {
                case 0:
                    var f = error.a;
                    var err = error.b;
                    var isSimple = function () {
                        var _v1 = $elm$core$String$uncons(f);
                        if (_v1.$ === 1) {
                            return false;
                        }
                        else {
                            var _v2 = _v1.a;
                            var _char = _v2.a;
                            var rest = _v2.b;
                            return $elm$core$Char$isAlpha(_char) && _String_all_fn($elm$core$Char$isAlphaNum, rest);
                        }
                    }();
                    var fieldName = isSimple ? ("." + f) : ("['" + (f + "']"));
                    var $temp$error = err, $temp$context = _List_Cons(fieldName, context);
                    error = $temp$error;
                    context = $temp$context;
                    continue errorToStringHelp;
                case 1:
                    var i = error.a;
                    var err = error.b;
                    var indexName = "[" + ($elm$core$String$fromInt(i) + "]");
                    var $temp$error = err, $temp$context = _List_Cons(indexName, context);
                    error = $temp$error;
                    context = $temp$context;
                    continue errorToStringHelp;
                case 2:
                    var errors = error.a;
                    if (!errors.b) {
                        return "Ran into a Json.Decode.oneOf with no possibilities" + function () {
                            if (!context.b) {
                                return "!";
                            }
                            else {
                                return " at json" + $elm$core$String$join_fn("", $elm$core$List$reverse(context));
                            }
                        }();
                    }
                    else {
                        if (!errors.b.b) {
                            var err = errors.a;
                            var $temp$error = err, $temp$context = context;
                            error = $temp$error;
                            context = $temp$context;
                            continue errorToStringHelp;
                        }
                        else {
                            var starter = function () {
                                if (!context.b) {
                                    return "Json.Decode.oneOf";
                                }
                                else {
                                    return "The Json.Decode.oneOf at json" + $elm$core$String$join_fn("", $elm$core$List$reverse(context));
                                }
                            }();
                            var introduction = starter + (" failed in the following " + ($elm$core$String$fromInt($elm$core$List$length(errors)) + " ways:"));
                            return $elm$core$String$join_fn("\n\n", _List_Cons(introduction, $elm$core$List$indexedMap_fn($elm$json$Json$Decode$errorOneOf, errors)));
                        }
                    }
                default:
                    var msg = error.a;
                    var json = error.b;
                    var introduction = function () {
                        if (!context.b) {
                            return "Problem with the given value:\n\n";
                        }
                        else {
                            return "Problem with the value at json" + ($elm$core$String$join_fn("", $elm$core$List$reverse(context)) + ":\n\n    ");
                        }
                    }();
                    return introduction + ($elm$json$Json$Decode$indent(_Json_encode_fn(4, json)) + ("\n\n" + msg));
            }
        }
    }, $elm$json$Json$Decode$errorToStringHelp = F2($elm$json$Json$Decode$errorToStringHelp_fn);
    var $elm$core$Array$branchFactor = 32;
    var $elm$core$Array$Array_elm_builtin_fn = function (a, b, c, d) {
        return { $: 0, a: a, b: b, c: c, d: d };
    }, $elm$core$Array$Array_elm_builtin = F4($elm$core$Array$Array_elm_builtin_fn);
    var $elm$core$Elm$JsArray$empty = _JsArray_empty;
    var $elm$core$Basics$ceiling = _Basics_ceiling;
    var $elm$core$Basics$fdiv = _Basics_fdiv;
    var $elm$core$Basics$logBase_fn = function (base, number) {
        return _Basics_log(number) / _Basics_log(base);
    }, $elm$core$Basics$logBase = F2($elm$core$Basics$logBase_fn);
    var $elm$core$Basics$toFloat = _Basics_toFloat;
    var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling($elm$core$Basics$logBase_fn(2, $elm$core$Array$branchFactor));
    var $elm$core$Array$empty = $elm$core$Array$Array_elm_builtin_fn(0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
    var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
    var $elm$core$Array$Leaf = function (a) {
        return { $: 1, a: a };
    };
    var $elm$core$Basics$apL_fn = function (f, x) {
        return f(x);
    }, $elm$core$Basics$apL = F2($elm$core$Basics$apL_fn);
    var $elm$core$Basics$apR_fn = function (x, f) {
        return f(x);
    }, $elm$core$Basics$apR = F2($elm$core$Basics$apR_fn);
    var $elm$core$Basics$eq = _Utils_equal;
    var $elm$core$Basics$floor = _Basics_floor;
    var $elm$core$Elm$JsArray$length = _JsArray_length;
    var $elm$core$Basics$gt = _Utils_gt;
    var $elm$core$Basics$max_fn = function (x, y) {
        return (_Utils_cmp(x, y) > 0) ? x : y;
    }, $elm$core$Basics$max = F2($elm$core$Basics$max_fn);
    var $elm$core$Basics$mul = _Basics_mul;
    var $elm$core$Array$SubTree = function (a) {
        return { $: 0, a: a };
    };
    var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
    var $elm$core$Array$compressNodes_fn = function (nodes, acc) {
        compressNodes: while (true) {
            var _v0 = _JsArray_initializeFromList_fn($elm$core$Array$branchFactor, nodes);
            var node = _v0.a;
            var remainingNodes = _v0.b;
            var newAcc = _List_Cons($elm$core$Array$SubTree(node), acc);
            if (!remainingNodes.b) {
                return $elm$core$List$reverse(newAcc);
            }
            else {
                var $temp$nodes = remainingNodes, $temp$acc = newAcc;
                nodes = $temp$nodes;
                acc = $temp$acc;
                continue compressNodes;
            }
        }
    }, $elm$core$Array$compressNodes = F2($elm$core$Array$compressNodes_fn);
    var $elm$core$Tuple$first = function (_v0) {
        var x = _v0.a;
        return x;
    };
    var $elm$core$Array$treeFromBuilder_fn = function (nodeList, nodeListSize) {
        treeFromBuilder: while (true) {
            var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
            if (newNodeSize === 1) {
                return _JsArray_initializeFromList_fn($elm$core$Array$branchFactor, nodeList).a;
            }
            else {
                var $temp$nodeList = $elm$core$Array$compressNodes_fn(nodeList, _List_Nil), $temp$nodeListSize = newNodeSize;
                nodeList = $temp$nodeList;
                nodeListSize = $temp$nodeListSize;
                continue treeFromBuilder;
            }
        }
    }, $elm$core$Array$treeFromBuilder = F2($elm$core$Array$treeFromBuilder_fn);
    var $elm$core$Array$builderToArray_fn = function (reverseNodeList, builder) {
        if (!builder.s) {
            return $elm$core$Array$Array_elm_builtin_fn($elm$core$Elm$JsArray$length(builder.t), $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, builder.t);
        }
        else {
            var treeLen = builder.s * $elm$core$Array$branchFactor;
            var depth = $elm$core$Basics$floor($elm$core$Basics$logBase_fn($elm$core$Array$branchFactor, treeLen - 1));
            var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.v) : builder.v;
            var tree = $elm$core$Array$treeFromBuilder_fn(correctNodeList, builder.s);
            return $elm$core$Array$Array_elm_builtin_fn($elm$core$Elm$JsArray$length(builder.t) + treeLen, $elm$core$Basics$max_fn(5, depth * $elm$core$Array$shiftStep), tree, builder.t);
        }
    }, $elm$core$Array$builderToArray = F2($elm$core$Array$builderToArray_fn);
    var $elm$core$Basics$idiv = _Basics_idiv;
    var $elm$core$Basics$lt = _Utils_lt;
    var $elm$core$Array$initializeHelp_fn = function (fn, fromIndex, len, nodeList, tail) {
        initializeHelp: while (true) {
            if (fromIndex < 0) {
                return $elm$core$Array$builderToArray_fn(false, { v: nodeList, s: (len / $elm$core$Array$branchFactor) | 0, t: tail });
            }
            else {
                var leaf = $elm$core$Array$Leaf(_JsArray_initialize_fn($elm$core$Array$branchFactor, fromIndex, fn));
                var $temp$fn = fn, $temp$fromIndex = fromIndex - $elm$core$Array$branchFactor, $temp$len = len, $temp$nodeList = _List_Cons(leaf, nodeList), $temp$tail = tail;
                fn = $temp$fn;
                fromIndex = $temp$fromIndex;
                len = $temp$len;
                nodeList = $temp$nodeList;
                tail = $temp$tail;
                continue initializeHelp;
            }
        }
    }, $elm$core$Array$initializeHelp = F5($elm$core$Array$initializeHelp_fn);
    var $elm$core$Basics$remainderBy = _Basics_remainderBy;
    var $elm$core$Array$initialize_fn = function (len, fn) {
        if (len <= 0) {
            return $elm$core$Array$empty;
        }
        else {
            var tailLen = len % $elm$core$Array$branchFactor;
            var tail = _JsArray_initialize_fn(tailLen, len - tailLen, fn);
            var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
            return $elm$core$Array$initializeHelp_fn(fn, initialFromIndex, len, _List_Nil, tail);
        }
    }, $elm$core$Array$initialize = F2($elm$core$Array$initialize_fn);
    var $elm$core$Basics$True = 0;
    var $elm$core$Result$isOk = function (result) {
        if (!result.$) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$json$Json$Decode$andThen = _Json_andThen;
    var $elm$json$Json$Decode$map = _Json_map1;
    var $elm$json$Json$Decode$map2 = _Json_map2;
    var $elm$json$Json$Decode$succeed = _Json_succeed;
    var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
        switch (handler.$) {
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    };
    var $elm$browser$Browser$External = function (a) {
        return { $: 1, a: a };
    };
    var $elm$browser$Browser$Internal = function (a) {
        return { $: 0, a: a };
    };
    var $elm$core$Basics$identity = function (x) {
        return x;
    };
    var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
    var $elm$url$Url$Http = 0;
    var $elm$url$Url$Https = 1;
    var $elm$url$Url$Url_fn = function (protocol, host, port_, path, query, fragment) {
        return (new $$Record13(fragment, host, path, port_, protocol, query));
    }, $elm$url$Url$Url = F6($elm$url$Url$Url_fn);
    var $elm$core$String$contains = _String_contains;
    var $elm$core$String$length = _String_length;
    var $elm$core$String$slice = _String_slice;
    var $elm$core$String$dropLeft_fn = function (n, string) {
        return (n < 1) ? string : _String_slice_fn(n, $elm$core$String$length(string), string);
    }, $elm$core$String$dropLeft = F2($elm$core$String$dropLeft_fn);
    var $elm$core$String$indexes = _String_indexes;
    var $elm$core$String$isEmpty = function (string) {
        return string === "";
    };
    var $elm$core$String$left_fn = function (n, string) {
        return (n < 1) ? "" : _String_slice_fn(0, n, string);
    }, $elm$core$String$left = F2($elm$core$String$left_fn);
    var $elm$core$String$toInt = _String_toInt;
    var $elm$url$Url$chompBeforePath_fn = function (protocol, path, params, frag, str) {
        if ($elm$core$String$isEmpty(str) || _String_contains_fn("@", str)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v0 = _String_indexes_fn(":", str);
            if (!_v0.b) {
                return $elm$core$Maybe$Just($elm$url$Url$Url_fn(protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
            }
            else {
                if (!_v0.b.b) {
                    var i = _v0.a;
                    var _v1 = $elm$core$String$toInt($elm$core$String$dropLeft_fn(i + 1, str));
                    if (_v1.$ === 1) {
                        return $elm$core$Maybe$Nothing;
                    }
                    else {
                        var port_ = _v1;
                        return $elm$core$Maybe$Just($elm$url$Url$Url_fn(protocol, $elm$core$String$left_fn(i, str), port_, path, params, frag));
                    }
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
        }
    }, $elm$url$Url$chompBeforePath = F5($elm$url$Url$chompBeforePath_fn);
    var $elm$url$Url$chompBeforeQuery_fn = function (protocol, params, frag, str) {
        if ($elm$core$String$isEmpty(str)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v0 = _String_indexes_fn("/", str);
            if (!_v0.b) {
                return $elm$url$Url$chompBeforePath_fn(protocol, "/", params, frag, str);
            }
            else {
                var i = _v0.a;
                return $elm$url$Url$chompBeforePath_fn(protocol, $elm$core$String$dropLeft_fn(i, str), params, frag, $elm$core$String$left_fn(i, str));
            }
        }
    }, $elm$url$Url$chompBeforeQuery = F4($elm$url$Url$chompBeforeQuery_fn);
    var $elm$url$Url$chompBeforeFragment_fn = function (protocol, frag, str) {
        if ($elm$core$String$isEmpty(str)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v0 = _String_indexes_fn("?", str);
            if (!_v0.b) {
                return $elm$url$Url$chompBeforeQuery_fn(protocol, $elm$core$Maybe$Nothing, frag, str);
            }
            else {
                var i = _v0.a;
                return $elm$url$Url$chompBeforeQuery_fn(protocol, $elm$core$Maybe$Just($elm$core$String$dropLeft_fn(i + 1, str)), frag, $elm$core$String$left_fn(i, str));
            }
        }
    }, $elm$url$Url$chompBeforeFragment = F3($elm$url$Url$chompBeforeFragment_fn);
    var $elm$url$Url$chompAfterProtocol_fn = function (protocol, str) {
        if ($elm$core$String$isEmpty(str)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v0 = _String_indexes_fn("#", str);
            if (!_v0.b) {
                return $elm$url$Url$chompBeforeFragment_fn(protocol, $elm$core$Maybe$Nothing, str);
            }
            else {
                var i = _v0.a;
                return $elm$url$Url$chompBeforeFragment_fn(protocol, $elm$core$Maybe$Just($elm$core$String$dropLeft_fn(i + 1, str)), $elm$core$String$left_fn(i, str));
            }
        }
    }, $elm$url$Url$chompAfterProtocol = F2($elm$url$Url$chompAfterProtocol_fn);
    var $elm$core$String$startsWith = _String_startsWith;
    var $elm$url$Url$fromString = function (str) {
        return _String_startsWith_fn("http://", str) ? $elm$url$Url$chompAfterProtocol_fn(0, $elm$core$String$dropLeft_fn(7, str)) : (_String_startsWith_fn("https://", str) ? $elm$url$Url$chompAfterProtocol_fn(1, $elm$core$String$dropLeft_fn(8, str)) : $elm$core$Maybe$Nothing);
    };
    var $elm$core$Basics$never = function (_v0) {
        never: while (true) {
            var nvr = _v0;
            var $temp$_v0 = nvr;
            _v0 = $temp$_v0;
            continue never;
        }
    };
    var $elm$core$Task$Perform = $elm$core$Basics$identity;
    var $elm$core$Task$succeed = _Scheduler_succeed;
    var $elm$core$Task$init = $elm$core$Task$succeed(0);
    var $elm$core$List$foldrHelper_fn = function (fn, acc, ctr, ls) {
        if (!ls.b) {
            return acc;
        }
        else {
            var a = ls.a;
            var r1 = ls.b;
            if (!r1.b) {
                return A2(fn, a, acc);
            }
            else {
                var b = r1.a;
                var r2 = r1.b;
                if (!r2.b) {
                    return A2(fn, a, A2(fn, b, acc));
                }
                else {
                    var c = r2.a;
                    var r3 = r2.b;
                    if (!r3.b) {
                        return A2(fn, a, A2(fn, b, A2(fn, c, acc)));
                    }
                    else {
                        var d = r3.a;
                        var r4 = r3.b;
                        var res = (ctr > 500) ? $elm$core$List$foldl_fn(fn, acc, $elm$core$List$reverse(r4)) : $elm$core$List$foldrHelper_fn(fn, acc, ctr + 1, r4);
                        return A2(fn, a, A2(fn, b, A2(fn, c, A2(fn, d, res))));
                    }
                }
            }
        }
    }, $elm$core$List$foldrHelper_fn_unwrapped = function (fn, acc, ctr, ls) {
        if (!ls.b) {
            return acc;
        }
        else {
            var a = ls.a;
            var r1 = ls.b;
            if (!r1.b) {
                return fn(a, acc);
            }
            else {
                var b = r1.a;
                var r2 = r1.b;
                if (!r2.b) {
                    return fn(a, fn(b, acc));
                }
                else {
                    var c = r2.a;
                    var r3 = r2.b;
                    if (!r3.b) {
                        return fn(a, fn(b, fn(c, acc)));
                    }
                    else {
                        var d = r3.a;
                        var r4 = r3.b;
                        var res = (ctr > 500) ? $elm$core$List$foldl_fn_unwrapped(fn, acc, $elm$core$List$reverse(r4)) : $elm$core$List$foldrHelper_fn_unwrapped(fn, acc, ctr + 1, r4);
                        return fn(a, fn(b, fn(c, fn(d, res))));
                    }
                }
            }
        }
    }, $elm$core$List$foldrHelper = F4($elm$core$List$foldrHelper_fn);
    var $elm$core$List$foldr_fn = function (fn, acc, ls) {
        return $elm$core$List$foldrHelper_fn(fn, acc, 0, ls);
    }, $elm$core$List$foldr = F3($elm$core$List$foldr_fn);
    var $elm$core$List$map_fn = function (f, xs) {
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (; xs.b; xs
            = xs.b) {
            var next = _List_Cons(f(xs.a), _List_Nil);
            end.b = next;
            end = next;
        }
        return tmp.b;
    }, $elm$core$List$map = F2($elm$core$List$map_fn);
    var $elm$core$Task$andThen = _Scheduler_andThen;
    var $elm$core$Task$map_fn = function (func, taskA) {
        return _Scheduler_andThen_fn(function (a) {
            return $elm$core$Task$succeed(func(a));
        }, taskA);
    }, $elm$core$Task$map = F2($elm$core$Task$map_fn);
    var $elm$core$Task$map2_fn = function (func, taskA, taskB) {
        return _Scheduler_andThen_fn(function (a) {
            return _Scheduler_andThen_fn(function (b) {
                return $elm$core$Task$succeed(A2(func, a, b));
            }, taskB);
        }, taskA);
    }, $elm$core$Task$map2_fn_unwrapped = function (func, taskA, taskB) {
        return _Scheduler_andThen_fn(function (a) {
            return _Scheduler_andThen_fn(function (b) {
                return $elm$core$Task$succeed(func(a, b));
            }, taskB);
        }, taskA);
    }, $elm$core$Task$map2 = F3($elm$core$Task$map2_fn);
    var $elm$core$Task$sequence = function (tasks) {
        return $elm$core$List$foldr_fn($elm$core$Task$map2($elm$core$List$cons), $elm$core$Task$succeed(_List_Nil), tasks);
    };
    var $elm$core$Platform$sendToApp = _Platform_sendToApp;
    var $elm$core$Task$spawnCmd_fn = function (router, _v0) {
        var task = _v0;
        return _Scheduler_spawn(_Scheduler_andThen_fn($elm$core$Platform$sendToApp(router), task));
    }, $elm$core$Task$spawnCmd = F2($elm$core$Task$spawnCmd_fn);
    var $elm$core$Task$onEffects_fn = function (router, commands, state) {
        return $elm$core$Task$map_fn(function (_v0) {
            return 0;
        }, $elm$core$Task$sequence($elm$core$List$map_fn($elm$core$Task$spawnCmd(router), commands)));
    }, $elm$core$Task$onEffects = F3($elm$core$Task$onEffects_fn);
    var $elm$core$Task$onSelfMsg_fn = function (_v0, _v1, _v2) {
        return $elm$core$Task$succeed(0);
    }, $elm$core$Task$onSelfMsg = F3($elm$core$Task$onSelfMsg_fn);
    var $elm$core$Task$cmdMap_fn = function (tagger, _v0) {
        var task = _v0;
        return $elm$core$Task$map_fn(tagger, task);
    }, $elm$core$Task$cmdMap = F2($elm$core$Task$cmdMap_fn);
    _Platform_effectManagers["Task"] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
    var $elm$core$Task$command = _Platform_leaf("Task");
    var $elm$core$Task$perform_fn = function (toMessage, task) {
        return $elm$core$Task$command($elm$core$Task$map_fn(toMessage, task));
    }, $elm$core$Task$perform = F2($elm$core$Task$perform_fn);
    var $elm$browser$Browser$application = _Browser_application;
    var $elm$json$Json$Decode$bool = _Json_decodeBool;
    var $elm$json$Json$Decode$field = _Json_decodeField;
    var $justinmimbs$timezone_data$TimeZone$NoDataForZoneName = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Model$PageLoading = { $: 11 };
    var $author$project$Error$TimeZone = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Model$UpdateWindowViewport = function (a) {
        return { $: 3, a: a };
    };
    var $elm$core$Platform$Cmd$batch = _Platform_batch;
    var $elm$time$Time$Zone_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$time$Time$Zone = F2($elm$time$Time$Zone_fn);
    var $elm$time$Time$customZone = $elm$time$Time$Zone;
    var $author$project$Error$Decoding = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$Settings$Settings = function (armyTime) {
        return function (showWeekends) {
            return function (theme) {
                return function (keyboardShortcutsEnabled) {
                    return function (updatedAt) {
                        return function (analyticsEnabled) {
                            return function (notificationBatchFirstSeen) {
                                return function (reverseNoteColumns) {
                                    return function (defaultToAttendeesTab) {
                                        return function (dailyUpdateEmailEnabled) {
                                            return function (dailyUpdateEmailConfig) {
                                                return function (nextMeetingNotifications) {
                                                    return function (nextMeetingNudgerState) {
                                                        return function (ordering) {
                                                            return (new $$Record14(analyticsEnabled, armyTime, dailyUpdateEmailConfig, dailyUpdateEmailEnabled, defaultToAttendeesTab, keyboardShortcutsEnabled, nextMeetingNotifications, nextMeetingNudgerState, notificationBatchFirstSeen, ordering, reverseNoteColumns, showWeekends, theme, updatedAt));
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $elm$core$Basics$composeR_fn = function (f, g, x) {
        return g(f(x));
    }, $elm$core$Basics$composeR = F3($elm$core$Basics$composeR_fn);
    var $elm$json$Json$Decode$fail = _Json_fail;
    var $author$project$Util$Json$decoderFromResult = function (result) {
        if (!result.$) {
            var value = result.a;
            return $elm$json$Json$Decode$succeed(value);
        }
        else {
            var error = result.a;
            return $elm$json$Json$Decode$fail(error);
        }
    };
    var $elm$core$Dict$RBEmpty_elm_builtin = { $: -2 };
    var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
    var $elm$core$Dict$Black = 1;
    var $elm$core$Dict$RBNode_elm_builtin_fn = function (a, b, c, d, e) {
        return { $: -1, a: a, b: b, c: c, d: d, e: e };
    }, $elm$core$Dict$RBNode_elm_builtin = F5($elm$core$Dict$RBNode_elm_builtin_fn);
    var $elm$core$Dict$Red = 0;
    var $elm$core$Dict$balance_fn = function (color, key, value, left, right) {
        if ((right.$ === -1) && (!right.a)) {
            var _v1 = right.a;
            var rK = right.b;
            var rV = right.c;
            var rLeft = right.d;
            var rRight = right.e;
            if ((left.$ === -1) && (!left.a)) {
                var _v3 = left.a;
                var lK = left.b;
                var lV = left.c;
                var lLeft = left.d;
                var lRight = left.e;
                return $elm$core$Dict$RBNode_elm_builtin_fn(0, key, value, $elm$core$Dict$RBNode_elm_builtin_fn(1, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(1, rK, rV, rLeft, rRight));
            }
            else {
                return $elm$core$Dict$RBNode_elm_builtin_fn(color, rK, rV, $elm$core$Dict$RBNode_elm_builtin_fn(0, key, value, left, rLeft), rRight);
            }
        }
        else {
            if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
                var _v5 = left.a;
                var lK = left.b;
                var lV = left.c;
                var _v6 = left.d;
                var _v7 = _v6.a;
                var llK = _v6.b;
                var llV = _v6.c;
                var llLeft = _v6.d;
                var llRight = _v6.e;
                var lRight = left.e;
                return $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, $elm$core$Dict$RBNode_elm_builtin_fn(1, llK, llV, llLeft, llRight), $elm$core$Dict$RBNode_elm_builtin_fn(1, key, value, lRight, right));
            }
            else {
                return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, left, right);
            }
        }
    }, $elm$core$Dict$balance = F5($elm$core$Dict$balance_fn);
    var $elm$core$Basics$compare = _Utils_compare;
    var $elm$core$Dict$insertHelp_fn = function (key, value, dict) {
        if (dict.$ === -2) {
            return $elm$core$Dict$RBNode_elm_builtin_fn(0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
        }
        else {
            var nColor = dict.a;
            var nKey = dict.b;
            var nValue = dict.c;
            var nLeft = dict.d;
            var nRight = dict.e;
            var _v1 = _Utils_compare_fn(key, nKey);
            switch (_v1) {
                case 0:
                    return $elm$core$Dict$balance_fn(nColor, nKey, nValue, $elm$core$Dict$insertHelp_fn(key, value, nLeft), nRight);
                case 1:
                    return $elm$core$Dict$RBNode_elm_builtin_fn(nColor, nKey, value, nLeft, nRight);
                default:
                    return $elm$core$Dict$balance_fn(nColor, nKey, nValue, nLeft, $elm$core$Dict$insertHelp_fn(key, value, nRight));
            }
        }
    }, $elm$core$Dict$insertHelp = F3($elm$core$Dict$insertHelp_fn);
    var $elm$core$Dict$insert_fn = function (key, value, dict) {
        var _v0 = $elm$core$Dict$insertHelp_fn(key, value, dict);
        if ((_v0.$ === -1) && (!_v0.a)) {
            var _v1 = _v0.a;
            var k = _v0.b;
            var v = _v0.c;
            var l = _v0.d;
            var r = _v0.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, l, r);
        }
        else {
            var x = _v0;
            return x;
        }
    }, $elm$core$Dict$insert = F3($elm$core$Dict$insert_fn);
    var $elm$core$Dict$fromList = function (assocs) {
        return $elm$core$List$foldl_fn_unwrapped(function (_v0, dict) {
            var key = _v0.a;
            var value = _v0.b;
            return $elm$core$Dict$insert_fn(key, value, dict);
        }, $elm$core$Dict$empty, assocs);
    };
    var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
    var $elm$json$Json$Decode$dict = function (decoder) {
        return _Json_map1_fn($elm$core$Dict$fromList, $elm$json$Json$Decode$keyValuePairs(decoder));
    };
    var $elm$core$Basics$always_fn = function (a, _v0) {
        return a;
    }, $elm$core$Basics$always = F2($elm$core$Basics$always_fn);
    var $elm$parser$Parser$Advanced$Bad_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $elm$parser$Parser$Advanced$Bad = F2($elm$parser$Parser$Advanced$Bad_fn);
    var $elm$parser$Parser$Advanced$Good_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $elm$parser$Parser$Advanced$Good = F3($elm$parser$Parser$Advanced$Good_fn);
    var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
    var $elm$parser$Parser$Advanced$andThen_fn = function (callback, _v0) {
        var parseA = _v0;
        return function (s0) {
            var _v1 = parseA(s0);
            if (_v1.$ === 1) {
                var p = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p1 = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                var _v2 = callback(a);
                var parseB = _v2;
                var _v3 = parseB(s1);
                if (_v3.$ === 1) {
                    var p2 = _v3.a;
                    var x = _v3.b;
                    return $elm$parser$Parser$Advanced$Bad_fn(p1 || p2, x);
                }
                else {
                    var p2 = _v3.a;
                    var b = _v3.b;
                    var s2 = _v3.c;
                    return $elm$parser$Parser$Advanced$Good_fn(p1 || p2, b, s2);
                }
            }
        };
    }, $elm$parser$Parser$Advanced$andThen = F2($elm$parser$Parser$Advanced$andThen_fn);
    var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
    var $elm$parser$Parser$UnexpectedChar = { $: 11 };
    var $elm$parser$Parser$Advanced$AddRight_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $elm$parser$Parser$Advanced$AddRight = F2($elm$parser$Parser$Advanced$AddRight_fn);
    var $elm$parser$Parser$Advanced$DeadEnd_fn = function (row, col, problem, contextStack) {
        return { kQ: col, k$: contextStack, nX: problem, of: row };
    }, $elm$parser$Parser$Advanced$DeadEnd = F4($elm$parser$Parser$Advanced$DeadEnd_fn);
    var $elm$parser$Parser$Advanced$Empty = { $: 0 };
    var $elm$parser$Parser$Advanced$fromState_fn = function (s, x) {
        return $elm$parser$Parser$Advanced$AddRight_fn($elm$parser$Parser$Advanced$Empty, $elm$parser$Parser$Advanced$DeadEnd_fn(s.of, s.kQ, x, s.h));
    }, $elm$parser$Parser$Advanced$fromState = F2($elm$parser$Parser$Advanced$fromState_fn);
    var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
    var $elm$core$Basics$negate = function (n) {
        return -n;
    };
    var $elm$parser$Parser$Advanced$chompIf_fn = function (isGood, expecting) {
        return function (s) {
            var newOffset = _Parser_isSubChar_fn(isGood, s.nt, s.oM);
            return newOffset === -1 ? $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, expecting)) : (newOffset === -2 ? $elm$parser$Parser$Advanced$Good_fn(true, 0, { kQ: 1, h: s.h, i: s.i, nt: s.nt + 1, of: s.of + 1, oM: s.oM }) : $elm$parser$Parser$Advanced$Good_fn(true, 0, { kQ: s.kQ + 1, h: s.h, i: s.i, nt: newOffset, of: s.of, oM: s.oM }));
        };
    }, $elm$parser$Parser$Advanced$chompIf = F2($elm$parser$Parser$Advanced$chompIf_fn);
    var $elm$parser$Parser$chompIf = function (isGood) {
        return $elm$parser$Parser$Advanced$chompIf_fn(isGood, $elm$parser$Parser$UnexpectedChar);
    };
    var $justinmimbs$date$Date$deadEndToString = function (_v0) {
        var problem = _v0.nX;
        if (problem.$ === 12) {
            var message = problem.a;
            return message;
        }
        else {
            return "Expected a date in ISO 8601 format";
        }
    };
    var $elm$parser$Parser$ExpectingEnd = { $: 10 };
    var $elm$parser$Parser$Advanced$end = function (x) {
        return function (s) {
            return _Utils_eq($elm$core$String$length(s.oM), s.nt) ? $elm$parser$Parser$Advanced$Good_fn(false, 0, s) : $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, x));
        };
    };
    var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
    var $elm$parser$Parser$Advanced$map2_fn = function (func, _v0, _v1) {
        var parseA = _v0;
        var parseB = _v1;
        return function (s0) {
            var _v2 = parseA(s0);
            if (_v2.$ === 1) {
                var p = _v2.a;
                var x = _v2.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p1 = _v2.a;
                var a = _v2.b;
                var s1 = _v2.c;
                var _v3 = parseB(s1);
                if (_v3.$ === 1) {
                    var p2 = _v3.a;
                    var x = _v3.b;
                    return $elm$parser$Parser$Advanced$Bad_fn(p1 || p2, x);
                }
                else {
                    var p2 = _v3.a;
                    var b = _v3.b;
                    var s2 = _v3.c;
                    return $elm$parser$Parser$Advanced$Good_fn(p1 || p2, A2(func, a, b), s2);
                }
            }
        };
    }, $elm$parser$Parser$Advanced$map2_fn_unwrapped = function (func, _v0, _v1) {
        var parseA = _v0;
        var parseB = _v1;
        return function (s0) {
            var _v2 = parseA(s0);
            if (_v2.$ === 1) {
                var p = _v2.a;
                var x = _v2.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p1 = _v2.a;
                var a = _v2.b;
                var s1 = _v2.c;
                var _v3 = parseB(s1);
                if (_v3.$ === 1) {
                    var p2 = _v3.a;
                    var x = _v3.b;
                    return $elm$parser$Parser$Advanced$Bad_fn(p1 || p2, x);
                }
                else {
                    var p2 = _v3.a;
                    var b = _v3.b;
                    var s2 = _v3.c;
                    return $elm$parser$Parser$Advanced$Good_fn(p1 || p2, func(a, b), s2);
                }
            }
        };
    }, $elm$parser$Parser$Advanced$map2 = F3($elm$parser$Parser$Advanced$map2_fn);
    var $elm$parser$Parser$Advanced$ignorer_fn = function (keepParser, ignoreParser) {
        return $elm$parser$Parser$Advanced$map2_fn($elm$core$Basics$always, keepParser, ignoreParser);
    }, $elm$parser$Parser$Advanced$ignorer = F2($elm$parser$Parser$Advanced$ignorer_fn);
    var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
    var $elm$parser$Parser$Advanced$keeper_fn = function (parseFunc, parseArg) {
        return $elm$parser$Parser$Advanced$map2_fn($elm$core$Basics$apL, parseFunc, parseArg);
    }, $elm$parser$Parser$Advanced$keeper = F2($elm$parser$Parser$Advanced$keeper_fn);
    var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
    var $elm$parser$Parser$Advanced$map_fn = function (func, _v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse(s0);
            if (!_v1.$) {
                var p = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(p, func(a), s1);
            }
            else {
                var p = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
        };
    }, $elm$parser$Parser$Advanced$map = F2($elm$parser$Parser$Advanced$map_fn);
    var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
    var $elm$core$Result$mapError_fn = function (f, result) {
        if (!result.$) {
            var v = result.a;
            return $elm$core$Result$Ok(v);
        }
        else {
            var e = result.a;
            return $elm$core$Result$Err(f(e));
        }
    }, $elm$core$Result$mapError = F2($elm$core$Result$mapError_fn);
    var $elm$parser$Parser$Advanced$Append_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $elm$parser$Parser$Advanced$Append = F2($elm$parser$Parser$Advanced$Append_fn);
    var $elm$parser$Parser$Advanced$oneOfHelp_fn = function (s0, bag, parsers) {
        oneOfHelp: while (true) {
            if (!parsers.b) {
                return $elm$parser$Parser$Advanced$Bad_fn(false, bag);
            }
            else {
                var parse = parsers.a;
                var remainingParsers = parsers.b;
                var _v1 = parse(s0);
                if (!_v1.$) {
                    var step = _v1;
                    return step;
                }
                else {
                    var step = _v1;
                    var p = step.a;
                    var x = step.b;
                    if (p) {
                        return step;
                    }
                    else {
                        var $temp$s0 = s0, $temp$bag = $elm$parser$Parser$Advanced$Append_fn(bag, x), $temp$parsers = remainingParsers;
                        s0 = $temp$s0;
                        bag = $temp$bag;
                        parsers = $temp$parsers;
                        continue oneOfHelp;
                    }
                }
            }
        }
    }, $elm$parser$Parser$Advanced$oneOfHelp = F3($elm$parser$Parser$Advanced$oneOfHelp_fn);
    var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
        return function (s) {
            return $elm$parser$Parser$Advanced$oneOfHelp_fn(s, $elm$parser$Parser$Advanced$Empty, parsers);
        };
    };
    var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
    var $justinmimbs$date$Date$MonthAndDay_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $justinmimbs$date$Date$MonthAndDay = F2($justinmimbs$date$Date$MonthAndDay_fn);
    var $justinmimbs$date$Date$OrdinalDay = function (a) {
        return { $: 2, a: a };
    };
    var $justinmimbs$date$Date$WeekAndWeekday_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $justinmimbs$date$Date$WeekAndWeekday = F2($justinmimbs$date$Date$WeekAndWeekday_fn);
    var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse(s0);
            if (_v1.$ === 1) {
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(false, x);
            }
            else {
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(false, a, s1);
            }
        };
    };
    var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
    var $elm$parser$Parser$Advanced$commit = function (a) {
        return function (s) {
            return $elm$parser$Parser$Advanced$Good_fn(true, a, s);
        };
    };
    var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
    var $elm$parser$Parser$Advanced$mapChompedString_fn = function (func, _v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse(s0);
            if (_v1.$ === 1) {
                var p = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(p, A2(func, _String_slice_fn(s0.nt, s1.nt, s0.oM), a), s1);
            }
        };
    }, $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped = function (func, _v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse(s0);
            if (_v1.$ === 1) {
                var p = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(p, func(_String_slice_fn(s0.nt, s1.nt, s0.oM), a), s1);
            }
        };
    }, $elm$parser$Parser$Advanced$mapChompedString = F2($elm$parser$Parser$Advanced$mapChompedString_fn);
    var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
    var $elm$core$Maybe$withDefault_fn = function (_default, maybe) {
        if (!maybe.$) {
            var value = maybe.a;
            return value;
        }
        else {
            return _default;
        }
    }, $elm$core$Maybe$withDefault = F2($elm$core$Maybe$withDefault_fn);
    var $justinmimbs$date$Date$int1 = $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (str, _v0) {
        return $elm$core$Maybe$withDefault_fn(0, $elm$core$String$toInt(str));
    }, $elm$parser$Parser$chompIf($elm$core$Char$isDigit));
    var $elm$parser$Parser$Advanced$succeed = function (a) {
        return function (s) {
            return $elm$parser$Parser$Advanced$Good_fn(false, a, s);
        };
    };
    var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
    var $justinmimbs$date$Date$int2 = $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (str, _v0) {
        return $elm$core$Maybe$withDefault_fn(0, $elm$core$String$toInt(str));
    }, $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
    var $justinmimbs$date$Date$int3 = $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (str, _v0) {
        return $elm$core$Maybe$withDefault_fn(0, $elm$core$String$toInt(str));
    }, $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
    var $elm$parser$Parser$Expecting = function (a) {
        return { $: 0, a: a };
    };
    var $elm$parser$Parser$Advanced$Token_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$parser$Parser$Advanced$Token = F2($elm$parser$Parser$Advanced$Token_fn);
    var $elm$parser$Parser$toToken = function (str) {
        return $elm$parser$Parser$Advanced$Token_fn(str, $elm$parser$Parser$Expecting(str));
    };
    var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
    var $elm$core$Basics$not = _Basics_not;
    var $elm$parser$Parser$Advanced$token = function (_v0) {
        var str = _v0.a;
        var expecting = _v0.b;
        var progress = !$elm$core$String$isEmpty(str);
        return function (s) {
            var _v1 = _Parser_isSubString_fn(str, s.nt, s.of, s.kQ, s.oM);
            var newOffset = _v1.a;
            var newRow = _v1.b;
            var newCol = _v1.c;
            return newOffset === -1 ? $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, expecting)) : $elm$parser$Parser$Advanced$Good_fn(progress, 0, { kQ: newCol, h: s.h, i: s.i, nt: newOffset, of: newRow, oM: s.oM });
        };
    };
    var $elm$parser$Parser$token = function (str) {
        return $elm$parser$Parser$Advanced$token($elm$parser$Parser$toToken(str));
    };
    var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$token("-")), $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$backtrackable($elm$parser$Parser$Advanced$andThen_fn($elm$parser$Parser$commit, $elm$parser$Parser$Advanced$map_fn($justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay), $justinmimbs$date$Date$int2), $elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$token("-")), $justinmimbs$date$Date$int2),
                $elm$parser$Parser$succeed(1)
            ]))),
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday), $elm$parser$Parser$token("W")), $justinmimbs$date$Date$int2), $elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$token("-")), $justinmimbs$date$Date$int1),
                $elm$parser$Parser$succeed(1)
            ])))
        ]))),
        $elm$parser$Parser$backtrackable($elm$parser$Parser$Advanced$andThen_fn($elm$parser$Parser$commit, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay), $justinmimbs$date$Date$int2), $elm$parser$Parser$oneOf(_List_fromArray([
            $justinmimbs$date$Date$int2,
            $elm$parser$Parser$succeed(1)
        ]))))),
        $elm$parser$Parser$Advanced$map_fn($justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday), $elm$parser$Parser$token("W")), $justinmimbs$date$Date$int2), $elm$parser$Parser$oneOf(_List_fromArray([
            $justinmimbs$date$Date$int1,
            $elm$parser$Parser$succeed(1)
        ]))),
        $elm$parser$Parser$succeed($justinmimbs$date$Date$OrdinalDay(1))
    ]));
    var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
    var $elm$core$Basics$modBy = _Basics_modBy;
    var $elm$core$Basics$neq = _Utils_notEqual;
    var $justinmimbs$date$Date$isLeapYear = function (y) {
        return ((!_Basics_modBy_fn(4, y)) && (!(!_Basics_modBy_fn(100, y)))) || (!_Basics_modBy_fn(400, y));
    };
    var $justinmimbs$date$Date$daysBeforeMonth_fn = function (y, m) {
        var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
        switch (m) {
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + leapDays;
            case 3:
                return 90 + leapDays;
            case 4:
                return 120 + leapDays;
            case 5:
                return 151 + leapDays;
            case 6:
                return 181 + leapDays;
            case 7:
                return 212 + leapDays;
            case 8:
                return 243 + leapDays;
            case 9:
                return 273 + leapDays;
            case 10:
                return 304 + leapDays;
            default:
                return 334 + leapDays;
        }
    }, $justinmimbs$date$Date$daysBeforeMonth = F2($justinmimbs$date$Date$daysBeforeMonth_fn);
    var $justinmimbs$date$Date$floorDiv_fn = function (a, b) {
        return $elm$core$Basics$floor(a / b);
    }, $justinmimbs$date$Date$floorDiv = F2($justinmimbs$date$Date$floorDiv_fn);
    var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
        var y = y1 - 1;
        var leapYears = ($justinmimbs$date$Date$floorDiv_fn(y, 4) - $justinmimbs$date$Date$floorDiv_fn(y, 100)) + $justinmimbs$date$Date$floorDiv_fn(y, 400);
        return (365 * y) + leapYears;
    };
    var $justinmimbs$date$Date$daysInMonth_fn = function (y, m) {
        switch (m) {
            case 0:
                return 31;
            case 1:
                return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
            case 2:
                return 31;
            case 3:
                return 30;
            case 4:
                return 31;
            case 5:
                return 30;
            case 6:
                return 31;
            case 7:
                return 31;
            case 8:
                return 30;
            case 9:
                return 31;
            case 10:
                return 30;
            default:
                return 31;
        }
    }, $justinmimbs$date$Date$daysInMonth = F2($justinmimbs$date$Date$daysInMonth_fn);
    var $justinmimbs$date$Date$isBetweenInt_fn = function (a, b, x) {
        return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
    }, $justinmimbs$date$Date$isBetweenInt = F3($justinmimbs$date$Date$isBetweenInt_fn);
    var $elm$time$Time$Apr = 3;
    var $elm$time$Time$Aug = 7;
    var $elm$time$Time$Dec = 11;
    var $elm$time$Time$Feb = 1;
    var $elm$time$Time$Jan = 0;
    var $elm$time$Time$Jul = 6;
    var $elm$time$Time$Jun = 5;
    var $elm$time$Time$Mar = 2;
    var $elm$time$Time$May = 4;
    var $elm$time$Time$Nov = 10;
    var $elm$time$Time$Oct = 9;
    var $elm$time$Time$Sep = 8;
    var $justinmimbs$date$Date$numberToMonth = function (mn) {
        var _v0 = $elm$core$Basics$max_fn(1, mn);
        switch (_v0) {
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    };
    var $justinmimbs$date$Date$fromCalendarParts_fn = function (y, mn, d) {
        return ($justinmimbs$date$Date$isBetweenInt_fn(1, 12, mn) && $justinmimbs$date$Date$isBetweenInt_fn(1, $justinmimbs$date$Date$daysInMonth_fn(y, $justinmimbs$date$Date$numberToMonth(mn)), d)) ? $elm$core$Result$Ok(($justinmimbs$date$Date$daysBeforeYear(y) + $justinmimbs$date$Date$daysBeforeMonth_fn(y, $justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err("Invalid calendar date (" + ($elm$core$String$fromInt(y) + (", " + ($elm$core$String$fromInt(mn) + (", " + ($elm$core$String$fromInt(d) + ")"))))));
    }, $justinmimbs$date$Date$fromCalendarParts = F3($justinmimbs$date$Date$fromCalendarParts_fn);
    var $justinmimbs$date$Date$fromOrdinalParts_fn = function (y, od) {
        return ($justinmimbs$date$Date$isBetweenInt_fn(1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok($justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err("Invalid ordinal date (" + ($elm$core$String$fromInt(y) + (", " + ($elm$core$String$fromInt(od) + ")"))));
    }, $justinmimbs$date$Date$fromOrdinalParts = F2($justinmimbs$date$Date$fromOrdinalParts_fn);
    var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
        var rd = _v0;
        var _v1 = _Basics_modBy_fn(7, rd);
        if (!_v1) {
            return 7;
        }
        else {
            var n = _v1;
            return n;
        }
    };
    var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
        var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
        return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
    };
    var $justinmimbs$date$Date$firstOfYear = function (y) {
        return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
    };
    var $justinmimbs$date$Date$is53WeekYear = function (y) {
        var wdnJan1 = $justinmimbs$date$Date$weekdayNumber($justinmimbs$date$Date$firstOfYear(y));
        return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
    };
    var $justinmimbs$date$Date$fromWeekParts_fn = function (wy, wn, wdn) {
        return ($justinmimbs$date$Date$isBetweenInt_fn(1, 7, wdn) && ($justinmimbs$date$Date$isBetweenInt_fn(1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err("Invalid week date (" + ($elm$core$String$fromInt(wy) + (", " + ($elm$core$String$fromInt(wn) + (", " + ($elm$core$String$fromInt(wdn) + ")"))))));
    }, $justinmimbs$date$Date$fromWeekParts = F3($justinmimbs$date$Date$fromWeekParts_fn);
    var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
        var y = _v0.a;
        var doy = _v0.b;
        switch (doy.$) {
            case 0:
                var mn = doy.a;
                var d = doy.b;
                return $justinmimbs$date$Date$fromCalendarParts_fn(y, mn, d);
            case 1:
                var wn = doy.a;
                var wdn = doy.b;
                return $justinmimbs$date$Date$fromWeekParts_fn(y, wn, wdn);
            default:
                var od = doy.a;
                return $justinmimbs$date$Date$fromOrdinalParts_fn(y, od);
        }
    };
    var $justinmimbs$date$Date$int4 = $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (str, _v0) {
        return $elm$core$Maybe$withDefault_fn(0, $elm$core$String$toInt(str));
    }, $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$chompIf(function (c) {
            return c === "-";
        }),
        $elm$parser$Parser$succeed(0)
    ]))), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
    var $elm$core$Tuple$pair_fn = function (a, b) {
        return _Utils_Tuple2(a, b);
    }, $elm$core$Tuple$pair = F2($elm$core$Tuple$pair_fn);
    var $elm$parser$Parser$Problem = function (a) {
        return { $: 12, a: a };
    };
    var $elm$parser$Parser$Advanced$problem = function (x) {
        return function (s) {
            return $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, x));
        };
    };
    var $elm$parser$Parser$problem = function (msg) {
        return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem(msg));
    };
    var $justinmimbs$date$Date$resultToParser = function (result) {
        if (!result.$) {
            var x = result.a;
            return $elm$parser$Parser$succeed(x);
        }
        else {
            var message = result.a;
            return $elm$parser$Parser$problem(message);
        }
    };
    var $justinmimbs$date$Date$parser = $elm$parser$Parser$Advanced$andThen_fn(A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser), $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed($elm$core$Tuple$pair), $justinmimbs$date$Date$int4), $justinmimbs$date$Date$dayOfYear));
    var $elm$parser$Parser$DeadEnd_fn = function (row, col, problem) {
        return { kQ: col, nX: problem, of: row };
    }, $elm$parser$Parser$DeadEnd = F3($elm$parser$Parser$DeadEnd_fn);
    var $elm$parser$Parser$problemToDeadEnd = function (p) {
        return $elm$parser$Parser$DeadEnd_fn(p.of, p.kQ, p.nX);
    };
    var $elm$parser$Parser$Advanced$bagToList_fn = function (bag, list) {
        bagToList: while (true) {
            switch (bag.$) {
                case 0:
                    return list;
                case 1:
                    var bag1 = bag.a;
                    var x = bag.b;
                    var $temp$bag = bag1, $temp$list = _List_Cons(x, list);
                    bag = $temp$bag;
                    list = $temp$list;
                    continue bagToList;
                default:
                    var bag1 = bag.a;
                    var bag2 = bag.b;
                    var $temp$bag = bag1, $temp$list = $elm$parser$Parser$Advanced$bagToList_fn(bag2, list);
                    bag = $temp$bag;
                    list = $temp$list;
                    continue bagToList;
            }
        }
    }, $elm$parser$Parser$Advanced$bagToList = F2($elm$parser$Parser$Advanced$bagToList_fn);
    var $elm$parser$Parser$Advanced$run_fn = function (_v0, src) {
        var parse = _v0;
        var _v1 = parse({ kQ: 1, h: _List_Nil, i: 1, nt: 0, of: 1, oM: src });
        if (!_v1.$) {
            var value = _v1.b;
            return $elm$core$Result$Ok(value);
        }
        else {
            var bag = _v1.b;
            return $elm$core$Result$Err($elm$parser$Parser$Advanced$bagToList_fn(bag, _List_Nil));
        }
    }, $elm$parser$Parser$Advanced$run = F2($elm$parser$Parser$Advanced$run_fn);
    var $elm$parser$Parser$run_fn = function (parser, source) {
        var _v0 = $elm$parser$Parser$Advanced$run_fn(parser, source);
        if (!_v0.$) {
            var a = _v0.a;
            return $elm$core$Result$Ok(a);
        }
        else {
            var problems = _v0.a;
            return $elm$core$Result$Err($elm$core$List$map_fn($elm$parser$Parser$problemToDeadEnd, problems));
        }
    }, $elm$parser$Parser$run = F2($elm$parser$Parser$run_fn);
    var $justinmimbs$date$Date$fromIsoString_a0 = $elm$parser$Parser$run($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$ignorer_fn($justinmimbs$date$Date$parser, $elm$parser$Parser$Advanced$andThen_fn($justinmimbs$date$Date$resultToParser, $elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$map_fn($elm$core$Result$Ok, $elm$parser$Parser$end),
        $elm$parser$Parser$Advanced$map_fn($elm$core$Basics$always($elm$core$Result$Err("Expected a date only, not a date and time")), $elm$parser$Parser$chompIf($elm$core$Basics$eq("T"))),
        $elm$parser$Parser$succeed($elm$core$Result$Err("Expected a date only"))
    ])))))), $justinmimbs$date$Date$fromIsoString_a1 = $elm$core$Result$mapError(A2($elm$core$Basics$composeR, $elm$core$List$map($justinmimbs$date$Date$deadEndToString), $elm$core$String$join("; "))), $justinmimbs$date$Date$fromIsoString = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString_a0, $justinmimbs$date$Date$fromIsoString_a1);
    var $elm$json$Json$Decode$string = _Json_decodeString;
    var $author$project$Util$Json$decodeDateDict = $elm$json$Json$Decode$dict(_Json_andThen_fn(A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $author$project$Util$Json$decoderFromResult), $elm$json$Json$Decode$string));
    var $author$project$Data$Settings$NextMeetingNudgerComplete = 3;
    var $author$project$Data$Settings$NextMeetingNudgerDisplayed = 1;
    var $author$project$Data$Settings$NextMeetingNudgerHidden = 0;
    var $author$project$Data$Settings$NextMeetingNudgerMinimized = 2;
    var $author$project$Data$Settings$decodeNextMeetingNudgerState = _Json_andThen_fn(function (s) {
        switch (s) {
            case "hidden":
                return $elm$json$Json$Decode$succeed(0);
            case "displayed":
                return $elm$json$Json$Decode$succeed(1);
            case "minimized":
                return $elm$json$Json$Decode$succeed(2);
            case "complete":
                return $elm$json$Json$Decode$succeed(3);
            default:
                return $elm$json$Json$Decode$fail("unknown value for NextMeetingNudgerState: " + s);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Data$Timestamp$Existing = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$Timestamp$ServerTimestamp = { $: 0 };
    var $elm$json$Json$Decode$int = _Json_decodeInt;
    var $elm$time$Time$Posix = $elm$core$Basics$identity;
    var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
    var $elm$json$Json$Decode$oneOf = _Json_oneOf;
    var $author$project$Data$Timestamp$decoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_map1_fn(function (seconds) {
            return $author$project$Data$Timestamp$Existing($elm$time$Time$millisToPosix(seconds * 1000));
        }, _Json_decodeField_fn("seconds", $elm$json$Json$Decode$int)),
        $elm$json$Json$Decode$succeed($author$project$Data$Timestamp$ServerTimestamp)
    ]));
    var $author$project$Data$Color$ThemeLight = 0;
    var $author$project$Data$Timestamp$serverTimestamp = $author$project$Data$Timestamp$ServerTimestamp;
    var $author$project$Data$Settings$default = (new $$Record14(true, false, $elm$core$Maybe$Nothing, false, false, true, $elm$core$Maybe$Nothing, 0, $elm$core$Dict$empty, 1, false, false, 0, $author$project$Data$Timestamp$serverTimestamp));
    var $elm$json$Json$Decode$maybe = function (decoder) {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            _Json_map1_fn($elm$core$Maybe$Just, decoder),
            $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
        ]));
    };
    var $author$project$Data$Settings$NotifyWithin10m = 0;
    var $author$project$Data$Settings$NotifyWithin2m = 2;
    var $author$project$Data$Settings$NotifyWithin5m = 1;
    var $author$project$Data$Settings$nextMeetingNotificationsDecoder = _Json_andThen_fn(function (s) {
        switch (s) {
            case "notify_within_10m":
                return $elm$json$Json$Decode$succeed(0);
            case "notify_within_5m":
                return $elm$json$Json$Decode$succeed(1);
            case "notify_within_2m":
                return $elm$json$Json$Decode$succeed(2);
            default:
                return $elm$json$Json$Decode$fail("unknown value for ShowNextMeetingNotifications: " + s);
        }
    }, $elm$json$Json$Decode$string);
    var $elm$json$Json$Decode$null = _Json_decodeNull;
    var $elm$json$Json$Decode$nullable = function (decoder) {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
            _Json_map1_fn($elm$core$Maybe$Just, decoder)
        ]));
    };
    var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0 = $elm$core$Basics$apR, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0);
    var $elm$json$Json$Decode$decodeValue = _Json_run;
    var $elm$json$Json$Decode$value = _Json_decodeValue;
    var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder_fn = function (pathDecoder, valDecoder, fallback) {
        var nullOr = function (decoder) {
            return $elm$json$Json$Decode$oneOf(_List_fromArray([
                decoder,
                $elm$json$Json$Decode$null(fallback)
            ]));
        };
        var handleResult = function (input) {
            var _v0 = _Json_run_fn(pathDecoder, input);
            if (!_v0.$) {
                var rawValue = _v0.a;
                var _v1 = _Json_run_fn(nullOr(valDecoder), rawValue);
                if (!_v1.$) {
                    var finalResult = _v1.a;
                    return $elm$json$Json$Decode$succeed(finalResult);
                }
                else {
                    var finalErr = _v1.a;
                    return $elm$json$Json$Decode$fail($elm$json$Json$Decode$errorToString(finalErr));
                }
            }
            else {
                return $elm$json$Json$Decode$succeed(fallback);
            }
        };
        return _Json_andThen_fn(handleResult, $elm$json$Json$Decode$value);
    }, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder_fn);
    var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn = function (key, valDecoder, fallback, decoder) {
        return _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder_fn(_Json_decodeField_fn(key, $elm$json$Json$Decode$value), valDecoder, fallback), decoder);
    }, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn);
    var $author$project$Data$Settings$SnapshotEmailConfig_fn = function (daysToSend, hourOfDay, timezone) {
        return (new $$Record15(daysToSend, hourOfDay, timezone));
    }, $author$project$Data$Settings$SnapshotEmailConfig = F3($author$project$Data$Settings$SnapshotEmailConfig_fn);
    var $elm$time$Time$Fri = 4;
    var $elm$time$Time$Mon = 0;
    var $elm$time$Time$Sat = 5;
    var $elm$time$Time$Sun = 6;
    var $elm$time$Time$Thu = 3;
    var $elm$time$Time$Tue = 1;
    var $elm$time$Time$Wed = 2;
    var $author$project$Data$Settings$dayFromString = function (dayStr) {
        switch (dayStr) {
            case "sun":
                return 6;
            case "mon":
                return 0;
            case "tue":
                return 1;
            case "wed":
                return 2;
            case "thu":
                return 3;
            case "fri":
                return 4;
            case "sat":
                return 5;
            default:
                return 6;
        }
    };
    var $elm$json$Json$Decode$list = _Json_decodeList;
    var $author$project$Data$Settings$decodeDayList = $elm$json$Json$Decode$list(_Json_map1_fn($author$project$Data$Settings$dayFromString, $elm$json$Json$Decode$string));
    var $elm$json$Json$Decode$map3 = _Json_map3;
    var $author$project$Data$Settings$snapshotEmailConfigDecoder = _Json_map3_fn($author$project$Data$Settings$SnapshotEmailConfig, _Json_decodeField_fn("daysToSend", $author$project$Data$Settings$decodeDayList), _Json_decodeField_fn("hourOfDay", $elm$json$Json$Decode$int), _Json_decodeField_fn("timezone", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
    var $author$project$Data$Color$ThemeAmber = 3;
    var $author$project$Data$Color$ThemeDark = 1;
    var $author$project$Data$Color$ThemeEvening = 4;
    var $author$project$Data$Color$ThemeWinter = 2;
    var $author$project$Data$Color$themeDecoder = function () {
        var toCustomType = function (id) {
            switch (id) {
                case "theme_dark":
                    return $elm$json$Json$Decode$succeed(1);
                case "theme_light":
                    return $elm$json$Json$Decode$succeed(0);
                case "theme_winter":
                    return $elm$json$Json$Decode$succeed(2);
                case "theme_amber":
                    return $elm$json$Json$Decode$succeed(3);
                case "theme_evening":
                    return $elm$json$Json$Decode$succeed(4);
                default:
                    return $elm$json$Json$Decode$fail("Unknown theme " + id);
            }
        };
        return _Json_andThen_fn(toCustomType, $elm$json$Json$Decode$string);
    }();
    var $author$project$Data$Settings$decode = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("ordering", $elm$json$Json$Decode$int, 1, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("nextMeetingNudgerState", $author$project$Data$Settings$decodeNextMeetingNudgerState, $author$project$Data$Settings$default.ed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("nextMeetingNotifications", $elm$json$Json$Decode$maybe($author$project$Data$Settings$nextMeetingNotificationsDecoder), $author$project$Data$Settings$default.c3, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("dailyUpdateEmailConfig", $elm$json$Json$Decode$nullable($author$project$Data$Settings$snapshotEmailConfigDecoder), $author$project$Data$Settings$default.cN, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("dailyUpdateEmailEnabled", $elm$json$Json$Decode$bool, $author$project$Data$Settings$default.cO, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("defaultToAttendeesTab", $elm$json$Json$Decode$bool, $author$project$Data$Settings$default.cP, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("reverseNoteColumns", $elm$json$Json$Decode$bool, $author$project$Data$Settings$default.df, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("notificationBatchFirstSeen", $author$project$Util$Json$decodeDateDict, $author$project$Data$Settings$default.c5, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("analyticsEnabled", $elm$json$Json$Decode$bool, $author$project$Data$Settings$default.cC, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("updatedAt", $author$project$Data$Timestamp$decoder, $author$project$Data$Timestamp$serverTimestamp, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("keyboardShortcutsEnabled", $elm$json$Json$Decode$bool, $author$project$Data$Settings$default.cZ, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("theme", $author$project$Data$Color$themeDecoder, $author$project$Data$Settings$default.pn, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("showWeekends", $elm$json$Json$Decode$bool, $author$project$Data$Settings$default.di, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("armyTime", $elm$json$Json$Decode$bool, $author$project$Data$Settings$default.cD, $elm$json$Json$Decode$succeed($author$project$Data$Settings$Settings)))))))))))))));
    var $author$project$Error$Error = 1;
    var $author$project$Error$Msg_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Error$Msg = F2($author$project$Error$Msg_fn);
    var $author$project$Error$error_a0 = 1, $author$project$Error$error = $author$project$Error$Msg($author$project$Error$error_a0);
    var $elm_community$result_extra$Result$Extra$error = function (result) {
        if (!result.$) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var err = result.a;
            return $elm$core$Maybe$Just(err);
        }
    };
    var $elm$core$Maybe$map_fn = function (f, maybe) {
        if (!maybe.$) {
            var value = maybe.a;
            return $elm$core$Maybe$Just(f(value));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $elm$core$Maybe$map = F2($elm$core$Maybe$map_fn);
    var $elm$core$Result$withDefault_fn = function (def, result) {
        if (!result.$) {
            var a = result.a;
            return a;
        }
        else {
            return def;
        }
    }, $elm$core$Result$withDefault = F2($elm$core$Result$withDefault_fn);
    var $author$project$Init$decodeSettings = function (rawSettings) {
        var rInitSettings = _Json_run_fn($author$project$Data$Settings$decode, rawSettings);
        var mDecodeError = $elm$core$Maybe$map_fn(function (decodeError) {
            return $author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$Decoding({
                lg: $elm$json$Json$Decode$errorToString(decodeError),
                he: "Settings (localStorage)"
            }));
        }, $elm_community$result_extra$Result$Extra$error(rInitSettings));
        return _Utils_Tuple2($elm$core$Result$withDefault_fn($author$project$Data$Settings$default, rInitSettings), mDecodeError);
    };
    var $author$project$Util$Time$epoch = $elm$time$Time$millisToPosix(0);
    var $rluiten$elm_text_search$Index$Model$Index = $elm$core$Basics$identity;
    var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
    var $elm$core$Set$empty = $elm$core$Dict$empty;
    var $rluiten$trie$TrieModel$EmptyTrie = { $: 0 };
    var $rluiten$trie$TrieModel$empty = $rluiten$trie$TrieModel$EmptyTrie;
    var $rluiten$trie$Trie$empty = $rluiten$trie$TrieModel$empty;
    var $rluiten$elm_text_search$Index$Defaults$indexVersion = "1.1.0";
    var $rluiten$elm_text_search$Index$newWith = function (_v0) {
        var indexType = _v0.hP;
        var ref = _v0.n3;
        var fields = _v0.hs;
        var listFields = _v0.h2;
        var initialTransformFactories = _v0.hQ;
        var transformFactories = _v0.jv;
        var filterFactories = _v0.ht;
        return (new $$Record16($elm$core$Set$empty, $elm$core$Dict$empty, $elm$core$Dict$empty, fields, filterFactories, $elm$core$Maybe$Nothing, $elm$core$Dict$empty, indexType, $rluiten$elm_text_search$Index$Defaults$indexVersion, initialTransformFactories, $elm$core$Maybe$Nothing, listFields, ref, $rluiten$trie$Trie$empty, transformFactories, $elm$core$Maybe$Nothing));
    };
    var $rluiten$elm_text_search$ElmTextSearch$newWith = $rluiten$elm_text_search$Index$newWith;
    var $elm$core$Set$insert_fn = function (key, _v0) {
        var dict = _v0;
        return $elm$core$Dict$insert_fn(key, 0, dict);
    }, $elm$core$Set$insert = F2($elm$core$Set$insert_fn);
    var $elm$core$Set$fromList = function (list) {
        return $elm$core$List$foldl_fn($elm$core$Set$insert, $elm$core$Set$empty, list);
    };
    var $elm$core$Dict$get_fn = function (targetKey, dict) {
        get: while (true) {
            if (dict.$ === -2) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var key = dict.b;
                var value = dict.c;
                var left = dict.d;
                var right = dict.e;
                var _v1 = _Utils_compare_fn(targetKey, key);
                switch (_v1) {
                    case 0:
                        var $temp$targetKey = targetKey, $temp$dict = left;
                        targetKey = $temp$targetKey;
                        dict = $temp$dict;
                        continue get;
                    case 1:
                        return $elm$core$Maybe$Just(value);
                    default:
                        var $temp$targetKey = targetKey, $temp$dict = right;
                        targetKey = $temp$targetKey;
                        dict = $temp$dict;
                        continue get;
                }
            }
        }
    }, $elm$core$Dict$get = F2($elm$core$Dict$get_fn);
    var $elm$core$Dict$member_fn = function (key, dict) {
        var _v0 = $elm$core$Dict$get_fn(key, dict);
        if (!_v0.$) {
            return true;
        }
        else {
            return false;
        }
    }, $elm$core$Dict$member = F2($elm$core$Dict$member_fn);
    var $elm$core$Set$member_fn = function (key, _v0) {
        var dict = _v0;
        return $elm$core$Dict$member_fn(key, dict);
    }, $elm$core$Set$member = F2($elm$core$Set$member_fn);
    var $rluiten$elm_text_search$StopWordFilter$createFilterFunc_fn = function (tokens, index) {
        var tokenSet = $elm$core$Set$fromList(tokens);
        return _Utils_Tuple2(index, function (word) {
            return !$elm$core$Set$member_fn(word, tokenSet);
        });
    }, $rluiten$elm_text_search$StopWordFilter$createFilterFunc = F2($rluiten$elm_text_search$StopWordFilter$createFilterFunc_fn);
    var $rluiten$elm_text_search$StopWordFilter$stopEnglishWordList = _List_fromArray(["a", "able", "about", "across", "after", "all", "almost", "also", "am", "among", "an", "and", "any", "are", "as", "at", "be", "because", "been", "but", "by", "can", "cannot", "could", "dear", "did", "do", "does", "either", "else", "ever", "every", "for", "from", "get", "got", "had", "has", "have", "he", "her", "hers", "him", "his", "how", "however", "i", "if", "in", "into", "is", "it", "its", "just", "least", "let", "like", "likely", "may", "me", "might", "most", "must", "my", "neither", "no", "nor", "not", "of", "off", "often", "on", "only", "or", "other", "our", "own", "rather", "said", "say", "says", "she", "should", "since", "so", "some", "than", "that", "the", "their", "them", "then", "there", "these", "they", "this", "tis", "to", "too", "twas", "us", "wants", "was", "we", "were", "what", "when", "where", "which", "while", "who", "whom", "why", "will", "with", "would", "yet", "you", "your"]);
    var $rluiten$elm_text_search$StopWordFilter$createDefaultFilterFunc = function (index) {
        return $rluiten$elm_text_search$StopWordFilter$createFilterFunc_fn($rluiten$elm_text_search$StopWordFilter$stopEnglishWordList, index);
    };
    var $rluiten$elm_text_search$Index$Defaults$defaultStopWordFilterFuncCreator = $rluiten$elm_text_search$StopWordFilter$createDefaultFilterFunc;
    var $rluiten$elm_text_search$Index$Defaults$defaultFilterFactories = _List_fromArray([$rluiten$elm_text_search$Index$Defaults$defaultStopWordFilterFuncCreator]);
    var $rluiten$elm_text_search$Index$Utils$createFuncCreator_fn = function (func, index) {
        return _Utils_Tuple2(index, func);
    }, $rluiten$elm_text_search$Index$Utils$createFuncCreator = F2($rluiten$elm_text_search$Index$Utils$createFuncCreator_fn);
    var $elm$regex$Regex$Match_fn = function (match, index, number, submatches) {
        return (new $$Record17(index, match, number, submatches));
    }, $elm$regex$Regex$Match = F4($elm$regex$Regex$Match_fn);
    var $elm$regex$Regex$replace_a0 = _Regex_infinity, $elm$regex$Regex$replace = _Regex_replaceAtMost($elm$regex$Regex$replace_a0);
    var $elm$core$Basics$composeL_fn = function (g, f, x) {
        return g(f(x));
    }, $elm$core$Basics$composeL = F3($elm$core$Basics$composeL_fn);
    var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
    var $elm$regex$Regex$fromString = function (string) {
        return _Regex_fromStringWith_fn({ kE: false, ii: false }, string);
    };
    var $elm$regex$Regex$never = _Regex_never;
    var $rluiten$elm_text_search$TokenProcessors$forceRegex_a0 = $elm$core$Maybe$withDefault($elm$regex$Regex$never), $rluiten$elm_text_search$TokenProcessors$forceRegex_a1 = $elm$regex$Regex$fromString, $rluiten$elm_text_search$TokenProcessors$forceRegex = A2($elm$core$Basics$composeL, $rluiten$elm_text_search$TokenProcessors$forceRegex_a0, $rluiten$elm_text_search$TokenProcessors$forceRegex_a1);
    var $rluiten$elm_text_search$TokenProcessors$trimmerRegex = $elm$core$Basics$composeL_fn($rluiten$elm_text_search$TokenProcessors$forceRegex_a0, $rluiten$elm_text_search$TokenProcessors$forceRegex_a1, "^\\W+|\\W+$");
    var $rluiten$elm_text_search$TokenProcessors$trimmer = A2($elm$regex$Regex$replace, $rluiten$elm_text_search$TokenProcessors$trimmerRegex, function (_v0) {
        return "";
    });
    var $rluiten$elm_text_search$Index$Defaults$defaultTokenTrimmerFuncCreator_a0 = $rluiten$elm_text_search$TokenProcessors$trimmer, $rluiten$elm_text_search$Index$Defaults$defaultTokenTrimmerFuncCreator = $rluiten$elm_text_search$Index$Utils$createFuncCreator($rluiten$elm_text_search$Index$Defaults$defaultTokenTrimmerFuncCreator_a0);
    var $rluiten$elm_text_search$Index$Defaults$defaultInitialTransformFactories = _List_fromArray([$rluiten$elm_text_search$Index$Defaults$defaultTokenTrimmerFuncCreator]);
    var $elm$core$String$reverse = _String_reverse;
    var $rluiten$stemmer$Stemmer$step1aX = function (drow) {
        return _String_startsWith_fn("sess", drow) ? $elm$core$String$dropLeft_fn(2, drow) : (_String_startsWith_fn("sei", drow) ? $elm$core$String$dropLeft_fn(2, drow) : (_String_startsWith_fn("ss", drow) ? drow : (_String_startsWith_fn("s", drow) ? $elm$core$String$dropLeft_fn(1, drow) : drow)));
    };
    var $rluiten$stemmer$Stemmer$isVowelCore_fn = function (includeY, c) {
        switch (c) {
            case "a":
                return true;
            case "e":
                return true;
            case "i":
                return true;
            case "o":
                return true;
            case "u":
                return true;
            case "y":
                return includeY ? true : false;
            default:
                return false;
        }
    }, $rluiten$stemmer$Stemmer$isVowelCore = F2($rluiten$stemmer$Stemmer$isVowelCore_fn);
    var $rluiten$stemmer$Stemmer$isVowelWithY_a0 = true, $rluiten$stemmer$Stemmer$isVowelWithY = $rluiten$stemmer$Stemmer$isVowelCore($rluiten$stemmer$Stemmer$isVowelWithY_a0);
    var $rluiten$stemmer$Stemmer$hasVowel2X = function (word) {
        hasVowel2X: while (true) {
            var _v0 = $elm$core$String$uncons(word);
            if (!_v0.$) {
                var _v1 = _v0.a;
                var h = _v1.a;
                var wordTail = _v1.b;
                var _v2 = $rluiten$stemmer$Stemmer$isVowelCore_fn($rluiten$stemmer$Stemmer$isVowelWithY_a0, h);
                if (_v2) {
                    return true;
                }
                else {
                    var $temp$word = wordTail;
                    word = $temp$word;
                    continue hasVowel2X;
                }
            }
            else {
                return false;
            }
        }
    };
    var $rluiten$stemmer$Stemmer$isVowel_a0 = false, $rluiten$stemmer$Stemmer$isVowel = $rluiten$stemmer$Stemmer$isVowelCore($rluiten$stemmer$Stemmer$isVowel_a0);
    var $rluiten$stemmer$Stemmer$hasVowelX = function (drow) {
        var _v0 = $elm$core$String$uncons($elm$core$String$reverse(drow));
        if (!_v0.$) {
            var _v1 = _v0.a;
            var h = _v1.a;
            var wordTail = _v1.b;
            var _v2 = $rluiten$stemmer$Stemmer$isVowelCore_fn($rluiten$stemmer$Stemmer$isVowel_a0, h);
            if (_v2) {
                return true;
            }
            else {
                return $rluiten$stemmer$Stemmer$hasVowel2X(wordTail);
            }
        }
        else {
            return false;
        }
    };
    var $rluiten$stemmer$Stemmer$foundConsonantX_fn = function (word, m) {
        foundConsonantX: while (true) {
            var _v3 = $elm$core$String$uncons(word);
            if (!_v3.$) {
                var _v4 = _v3.a;
                var h = _v4.a;
                var wordTail = _v4.b;
                var _v5 = $rluiten$stemmer$Stemmer$isVowelCore_fn($rluiten$stemmer$Stemmer$isVowelWithY_a0, h);
                if (_v5) {
                    return $rluiten$stemmer$Stemmer$foundVowelX_fn(wordTail, m);
                }
                else {
                    var $temp$word = wordTail, $temp$m = m;
                    word = $temp$word;
                    m = $temp$m;
                    continue foundConsonantX;
                }
            }
            else {
                return m;
            }
        }
    }, $rluiten$stemmer$Stemmer$foundConsonantX = F2($rluiten$stemmer$Stemmer$foundConsonantX_fn);
    var $rluiten$stemmer$Stemmer$foundVowelX_fn = function (word, m) {
        foundVowelX: while (true) {
            var _v0 = $elm$core$String$uncons(word);
            if (!_v0.$) {
                var _v1 = _v0.a;
                var h = _v1.a;
                var wordTail = _v1.b;
                var _v2 = $rluiten$stemmer$Stemmer$isVowelCore_fn($rluiten$stemmer$Stemmer$isVowel_a0, h);
                if (_v2) {
                    var $temp$word = wordTail, $temp$m = m;
                    word = $temp$word;
                    m = $temp$m;
                    continue foundVowelX;
                }
                else {
                    return $rluiten$stemmer$Stemmer$foundConsonantX_fn(wordTail, m + 1);
                }
            }
            else {
                return m;
            }
        }
    }, $rluiten$stemmer$Stemmer$foundVowelX = F2($rluiten$stemmer$Stemmer$foundVowelX_fn);
    var $rluiten$stemmer$Stemmer$foundLeadingConsonantX = function (word) {
        foundLeadingConsonantX: while (true) {
            var _v0 = $elm$core$String$uncons(word);
            if (!_v0.$) {
                var _v1 = _v0.a;
                var h = _v1.a;
                var wordTail = _v1.b;
                var _v2 = $rluiten$stemmer$Stemmer$isVowelCore_fn($rluiten$stemmer$Stemmer$isVowelWithY_a0, h);
                if (_v2) {
                    return $rluiten$stemmer$Stemmer$foundVowelX_fn(wordTail, 0);
                }
                else {
                    var $temp$word = wordTail;
                    word = $temp$word;
                    continue foundLeadingConsonantX;
                }
            }
            else {
                return 0;
            }
        }
    };
    var $rluiten$stemmer$Stemmer$measureX = function (drow) {
        var word = $elm$core$String$reverse(drow);
        var _v0 = $elm$core$String$uncons(word);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var h = _v1.a;
            var wordTail = _v1.b;
            var _v2 = $rluiten$stemmer$Stemmer$isVowelCore_fn($rluiten$stemmer$Stemmer$isVowel_a0, h);
            if (_v2) {
                return $rluiten$stemmer$Stemmer$foundVowelX_fn(wordTail, 0);
            }
            else {
                return $rluiten$stemmer$Stemmer$foundLeadingConsonantX(wordTail);
            }
        }
        else {
            return 0;
        }
    };
    var $elm$core$String$cons = _String_cons;
    var $rluiten$stemmer$Stemmer$endsWithCVCX = function (drow) {
        var _v0 = $elm$core$String$uncons(drow);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var c2 = _v1.a;
            var drowTail1 = _v1.b;
            if (!($rluiten$stemmer$Stemmer$isVowelCore_fn($rluiten$stemmer$Stemmer$isVowel_a0, c2) || ((c2 === "w") || ((c2 === "x") || (c2 === "y"))))) {
                var _v2 = $elm$core$String$uncons(drowTail1);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var v = _v3.a;
                    var drowTail2 = _v3.b;
                    if ($rluiten$stemmer$Stemmer$isVowelCore_fn($rluiten$stemmer$Stemmer$isVowelWithY_a0, v)) {
                        var _v4 = $elm$core$String$uncons(drowTail2);
                        if (!_v4.$) {
                            var _v5 = _v4.a;
                            var c1 = _v5.a;
                            var drowTail3 = _v5.b;
                            return !$rluiten$stemmer$Stemmer$isVowelCore_fn($rluiten$stemmer$Stemmer$isVowel_a0, c1);
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    var $rluiten$stemmer$Stemmer$endsWithDoubleConsX = function (drow) {
        var _v0 = $elm$core$String$uncons(drow);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var c1 = _v1.a;
            var drowTail = _v1.b;
            if (!$rluiten$stemmer$Stemmer$isVowelCore_fn($rluiten$stemmer$Stemmer$isVowelWithY_a0, c1)) {
                var _v2 = $elm$core$String$uncons(drowTail);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var c2 = _v3.a;
                    var drowTail2 = _v3.b;
                    return _Utils_eq(c1, c2);
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    var $rluiten$stemmer$Stemmer$step1b2X = function (drow) {
        if (_String_startsWith_fn("ta", drow) || (_String_startsWith_fn("lb", drow) || _String_startsWith_fn("zi", drow))) {
            return _String_cons_fn("e", drow);
        }
        else {
            var _v0 = $elm$core$String$uncons(drow);
            if (!_v0.$) {
                var _v1 = _v0.a;
                var h = _v1.a;
                var drowTail = _v1.b;
                return ($rluiten$stemmer$Stemmer$endsWithDoubleConsX(drow) && (!((h === "l") || ((h === "s") || (h === "z"))))) ? drowTail : ((($rluiten$stemmer$Stemmer$measureX(drow) === 1) && $rluiten$stemmer$Stemmer$endsWithCVCX(drow)) ? _String_cons_fn("e", drow) : drow);
            }
            else {
                return drow;
            }
        }
    };
    var $rluiten$stemmer$Stemmer$step1bX = function (drow) {
        if (_String_startsWith_fn("dee", drow)) {
            return ($rluiten$stemmer$Stemmer$measureX($elm$core$String$dropLeft_fn(3, drow)) > 0) ? $elm$core$String$dropLeft_fn(1, drow) : drow;
        }
        else {
            if (_String_startsWith_fn("de", drow)) {
                var mets = $elm$core$String$dropLeft_fn(2, drow);
                return $rluiten$stemmer$Stemmer$hasVowelX(mets) ? $rluiten$stemmer$Stemmer$step1b2X(mets) : drow;
            }
            else {
                if (_String_startsWith_fn("gni", drow)) {
                    var mets = $elm$core$String$dropLeft_fn(3, drow);
                    return $rluiten$stemmer$Stemmer$hasVowelX(mets) ? $rluiten$stemmer$Stemmer$step1b2X(mets) : drow;
                }
                else {
                    return drow;
                }
            }
        }
    };
    var $rluiten$stemmer$Stemmer$step1cX = function (drow) {
        var _v0 = $elm$core$String$uncons(drow);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var c = _v1.a;
            var drowTail = _v1.b;
            return ((c === "y") && $rluiten$stemmer$Stemmer$hasVowelX(drowTail)) ? _String_cons_fn("i", drowTail) : drow;
        }
        else {
            return drow;
        }
    };
    var $rluiten$stemmer$Stemmer$step1X_a0 = A2($elm$core$Basics$composeL, $rluiten$stemmer$Stemmer$step1cX, $rluiten$stemmer$Stemmer$step1bX), $rluiten$stemmer$Stemmer$step1X_a1 = $rluiten$stemmer$Stemmer$step1aX, $rluiten$stemmer$Stemmer$step1X = A2($elm$core$Basics$composeL, $rluiten$stemmer$Stemmer$step1X_a0, $rluiten$stemmer$Stemmer$step1X_a1);
    var $elm$core$String$append = _String_append;
    var $rluiten$stemmer$Stemmer$replaceStartX_fn = function (measureThreshold, _v0, drow) {
        var start = _v0.a;
        var newStart = _v0.b;
        var startLen = $elm$core$String$length(start);
        var drowStart = $elm$core$String$left_fn(startLen, drow);
        if (_Utils_eq(drowStart, start)) {
            var drowEnd = $elm$core$String$dropLeft_fn(startLen, drow);
            return (_Utils_cmp($rluiten$stemmer$Stemmer$measureX(drowEnd), measureThreshold) > 0) ? _Utils_Tuple2(true, _String_append_fn(newStart, drowEnd)) : _Utils_Tuple2(true, drow);
        }
        else {
            return _Utils_Tuple2(false, drow);
        }
    }, $rluiten$stemmer$Stemmer$replaceStartX = F3($rluiten$stemmer$Stemmer$replaceStartX_fn);
    var $rluiten$stemmer$Stemmer$replaceStartsX_fn = function (measureThreshold, rules, drow) {
        replaceStartsX: while (true) {
            if (rules.b) {
                var r = rules.a;
                var rs = rules.b;
                var _v1 = $rluiten$stemmer$Stemmer$replaceStartX_fn(measureThreshold, r, drow);
                var patternMatched = _v1.a;
                var newDrow = _v1.b;
                if (patternMatched) {
                    return newDrow;
                }
                else {
                    var $temp$measureThreshold = measureThreshold, $temp$rules = rs, $temp$drow = drow;
                    measureThreshold = $temp$measureThreshold;
                    rules = $temp$rules;
                    drow = $temp$drow;
                    continue replaceStartsX;
                }
            }
            else {
                return drow;
            }
        }
    }, $rluiten$stemmer$Stemmer$replaceStartsX = F3($rluiten$stemmer$Stemmer$replaceStartsX_fn);
    var $rluiten$stemmer$Stemmer$toR = $elm$core$String$reverse;
    var $rluiten$stemmer$Stemmer$step2RulesX = _List_fromArray([
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ational"), $rluiten$stemmer$Stemmer$toR("ate")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("tional"), $rluiten$stemmer$Stemmer$toR("tion")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("enci"), $rluiten$stemmer$Stemmer$toR("ence")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("anci"), $rluiten$stemmer$Stemmer$toR("ance")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("izer"), $rluiten$stemmer$Stemmer$toR("ize")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("bli"), $rluiten$stemmer$Stemmer$toR("ble")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("alli"), $rluiten$stemmer$Stemmer$toR("al")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("entli"), $rluiten$stemmer$Stemmer$toR("ent")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("eli"), $rluiten$stemmer$Stemmer$toR("e")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ousli"), $rluiten$stemmer$Stemmer$toR("ous")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ization"), $rluiten$stemmer$Stemmer$toR("ize")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ation"), $rluiten$stemmer$Stemmer$toR("ate")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ator"), $rluiten$stemmer$Stemmer$toR("ate")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("alism"), $rluiten$stemmer$Stemmer$toR("al")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("iveness"), $rluiten$stemmer$Stemmer$toR("ive")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("fulness"), $rluiten$stemmer$Stemmer$toR("ful")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ousness"), $rluiten$stemmer$Stemmer$toR("ous")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("aliti"), $rluiten$stemmer$Stemmer$toR("al")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("iviti"), $rluiten$stemmer$Stemmer$toR("ive")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("biliti"), $rluiten$stemmer$Stemmer$toR("ble")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("logi"), $rluiten$stemmer$Stemmer$toR("log"))
    ]);
    var $rluiten$stemmer$Stemmer$step2X = function (drow) {
        return $rluiten$stemmer$Stemmer$replaceStartsX_fn(0, $rluiten$stemmer$Stemmer$step2RulesX, drow);
    };
    var $rluiten$stemmer$Stemmer$step3RulesX = _List_fromArray([
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("icate"), $rluiten$stemmer$Stemmer$toR("ic")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ative"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("alize"), $rluiten$stemmer$Stemmer$toR("al")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("iciti"), $rluiten$stemmer$Stemmer$toR("ic")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ical"), $rluiten$stemmer$Stemmer$toR("ic")),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ful"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ness"), "")
    ]);
    var $rluiten$stemmer$Stemmer$step3X = function (drow) {
        return $rluiten$stemmer$Stemmer$replaceStartsX_fn(0, $rluiten$stemmer$Stemmer$step3RulesX, drow);
    };
    var $rluiten$stemmer$Stemmer$step4IonX_fn = function (mThreshold, startLen, drow) {
        var afterNoi = $elm$core$String$dropLeft_fn(startLen, drow);
        var _v0 = $elm$core$String$uncons(afterNoi);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var _char = _v1.a;
            var drowEnd = _v1.b;
            return (((_char === "t") || (_char === "s")) && (_Utils_cmp($rluiten$stemmer$Stemmer$measureX(afterNoi), mThreshold) > 0)) ? afterNoi : drow;
        }
        else {
            return drow;
        }
    }, $rluiten$stemmer$Stemmer$step4IonX = F3($rluiten$stemmer$Stemmer$step4IonX_fn);
    var $rluiten$stemmer$Stemmer$step4RulesX = _List_fromArray([
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("al"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ance"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ence"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("er"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ic"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("able"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ible"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ant"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ement"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ment"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ent"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ou"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ism"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ate"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("iti"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ous"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ive"), ""),
        _Utils_Tuple2($rluiten$stemmer$Stemmer$toR("ize"), "")
    ]);
    var $rluiten$stemmer$Stemmer$step4X = function (drow) {
        var mThreshold = 1;
        var ionCase = "noi";
        var ionLen = $elm$core$String$length(ionCase);
        var drowStart = $elm$core$String$left_fn(ionLen, drow);
        return _Utils_eq(drowStart, ionCase) ? $rluiten$stemmer$Stemmer$step4IonX_fn(mThreshold, ionLen, drow) : $rluiten$stemmer$Stemmer$replaceStartsX_fn(mThreshold, $rluiten$stemmer$Stemmer$step4RulesX, drow);
    };
    var $rluiten$stemmer$Stemmer$step5aX = function (drow) {
        var _v0 = $elm$core$String$uncons(drow);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var _char = _v1.a;
            var drowEnd = _v1.b;
            if (_char === "e") {
                var m = $rluiten$stemmer$Stemmer$measureX(drowEnd);
                return (m > 1) ? drowEnd : (((m === 1) && (!$rluiten$stemmer$Stemmer$endsWithCVCX(drowEnd))) ? drowEnd : drow);
            }
            else {
                return drow;
            }
        }
        else {
            return drow;
        }
    };
    var $rluiten$stemmer$Stemmer$step5bX = function (drow) {
        var _v0 = $elm$core$String$uncons(drow);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var _char = _v1.a;
            var drowEnd = _v1.b;
            return ((_char === "l") && (($rluiten$stemmer$Stemmer$measureX(drowEnd) > 1) && $rluiten$stemmer$Stemmer$endsWithDoubleConsX(drow))) ? drowEnd : drow;
        }
        else {
            return drow;
        }
    };
    var $rluiten$stemmer$Stemmer$step5X_a0 = $rluiten$stemmer$Stemmer$step5bX, $rluiten$stemmer$Stemmer$step5X_a1 = $rluiten$stemmer$Stemmer$step5aX, $rluiten$stemmer$Stemmer$step5X = A2($elm$core$Basics$composeL, $rluiten$stemmer$Stemmer$step5X_a0, $rluiten$stemmer$Stemmer$step5X_a1);
    var $rluiten$stemmer$Stemmer$allStepsX_a0 = A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$String$reverse, $rluiten$stemmer$Stemmer$step5X), $rluiten$stemmer$Stemmer$step4X), $rluiten$stemmer$Stemmer$step3X), $rluiten$stemmer$Stemmer$step2X), $rluiten$stemmer$Stemmer$step1X), $rluiten$stemmer$Stemmer$allStepsX_a1 = $elm$core$String$reverse, $rluiten$stemmer$Stemmer$allStepsX = A2($elm$core$Basics$composeL, $rluiten$stemmer$Stemmer$allStepsX_a0, $rluiten$stemmer$Stemmer$allStepsX_a1);
    var $rluiten$stemmer$Stemmer$stem = function (word) {
        return ($elm$core$String$length(word) < 3) ? word : $elm$core$Basics$composeL_fn($rluiten$stemmer$Stemmer$allStepsX_a0, $rluiten$stemmer$Stemmer$allStepsX_a1, word);
    };
    var $rluiten$elm_text_search$Index$Defaults$defaultStemmerFuncCreator_a0 = $rluiten$stemmer$Stemmer$stem, $rluiten$elm_text_search$Index$Defaults$defaultStemmerFuncCreator = $rluiten$elm_text_search$Index$Utils$createFuncCreator($rluiten$elm_text_search$Index$Defaults$defaultStemmerFuncCreator_a0);
    var $rluiten$elm_text_search$Index$Defaults$defaultTransformFactories = _List_fromArray([$rluiten$elm_text_search$Index$Defaults$defaultStemmerFuncCreator]);
    var $author$project$Search$Index$noteConfig = {
        bm: {
            hs: _List_fromArray([
                _Utils_Tuple2(A2($elm$core$Basics$composeR, function ($) {
                    return $.ll;
                }, function ($) {
                    return $.gj;
                }), 3),
                _Utils_Tuple2(A2($elm$core$Basics$composeR, function ($) {
                    return $.ll;
                }, function ($) {
                    return $.fc;
                }), 2)
            ]),
            ht: $rluiten$elm_text_search$Index$Defaults$defaultFilterFactories,
            hP: "Notes",
            hQ: $rluiten$elm_text_search$Index$Defaults$defaultInitialTransformFactories,
            h2: _List_Nil,
            n3: function ($) {
                return $.l8;
            },
            jv: $rluiten$elm_text_search$Index$Defaults$defaultTransformFactories
        },
        bL: 1
    };
    var $elm$core$List$append_fn = function (xs, ys) {
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (; xs.b; xs = xs.b) {
            var next = _List_Cons(xs.a, _List_Nil);
            end.b = next;
            end = next;
        }
        end.b = ys;
        return tmp.b;
    }, $elm$core$List$append = F2($elm$core$List$append_fn);
    var $elm$core$List$concat = function (lists) {
        if (!lists.b) {
            return _List_Nil;
        }
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (; lists.b.b; lists = lists.b) {
            var xs = lists.a;
            for (; xs.b; xs = xs.b) {
                var next = _List_Cons(xs.a, _List_Nil);
                end.b = next;
                end = next;
            }
        }
        end.b = lists.a;
        return tmp.b;
    };
    var $elm$core$List$concatMap_fn = function (f, lists) {
        if (!lists.b) {
            return _List_Nil;
        }
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (; lists.b.
            b; lists = lists.b) {
            var xs = f(lists.a);
            for (; xs.b; xs = xs.b) {
                var next = _List_Cons(xs.a, _List_Nil);
                end.b = next;
                end = next;
            }
        }
        end.b = f(lists.a);
        return tmp.b;
    }, $elm$core$List$concatMap = F2($elm$core$List$concatMap_fn);
    var $author$project$Search$Index$emailFieldHelper_a0 = function (email) {
        return _List_Cons(email, $elm$core$String$split_fn("@", email));
    }, $author$project$Search$Index$emailFieldHelper = $elm$core$List$concatMap($author$project$Search$Index$emailFieldHelper_a0);
    var $author$project$Search$Index$personConfig = {
        bm: {
            hs: _List_fromArray([
                _Utils_Tuple2(A2($elm$core$Basics$composeR, function ($) {
                    return $.ll;
                }, function ($) {
                    return $.b;
                }), 1),
                _Utils_Tuple2(A2($elm$core$Basics$composeR, function ($) {
                    return $.ll;
                }, function ($) {
                    return $.ko;
                }), 0.4)
            ]),
            ht: _List_Nil,
            hP: "People",
            hQ: $rluiten$elm_text_search$Index$Defaults$defaultInitialTransformFactories,
            h2: _List_fromArray([
                _Utils_Tuple2(A2($elm$core$Basics$composeR, function ($) {
                    return $.ll;
                }, A2($elm$core$Basics$composeR, function ($) {
                    return $.lo;
                }, $author$project$Search$Index$emailFieldHelper)), 1)
            ]),
            n3: function ($) {
                return $.l8;
            },
            jv: _List_Nil
        },
        bL: 1
    };
    var $author$project$Search$Index$emptyIndices = (new $$Record19((new $$Record18($author$project$Search$Index$noteConfig.bL, $rluiten$elm_text_search$ElmTextSearch$newWith($author$project$Search$Index$noteConfig.bm), $author$project$Util$Time$epoch)), (new $$Record18($author$project$Search$Index$personConfig.bL, $rluiten$elm_text_search$ElmTextSearch$newWith($author$project$Search$Index$personConfig.bm), $author$project$Util$Time$epoch))));
    var $author$project$Env$DebounceMsg = function (a) {
        return { $: 29, a: a };
    };
    var $author$project$Data$LoadState$EventsLoadState_fn = function (initialLoaded, allLoaded) {
        return (new $$Record20(allLoaded, initialLoaded));
    }, $author$project$Data$LoadState$EventsLoadState = F2($author$project$Data$LoadState$EventsLoadState_fn);
    var $krisajenkins$remotedata$RemoteData$NotAsked = { $: 0 };
    var $author$project$Routing$RouteHome = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$FeatureFlags$default = {};
    var $author$project$Search$Weight$emptyIndex = (new $$Record21($elm$core$Dict$empty, $author$project$Util$Time$epoch));
    var $author$project$View$ImageViewer$NotDisplayed = { $: 0 };
    var $author$project$View$ImageViewer$hide = $author$project$View$ImageViewer$NotDisplayed;
    var $author$project$Data$GiftArea$defaultNumEmails = 3;
    var $author$project$Data$GiftArea$initEmailEntry = { ja: false, jn: "" };
    var $elm$core$List$repeatHelp_fn = function (result, n, value) {
        repeatHelp: while (true) {
            if (n <= 0) {
                return result;
            }
            else {
                var $temp$result = _List_Cons(value, result), $temp$n = n - 1, $temp$value = value;
                result = $temp$result;
                n = $temp$n;
                value = $temp$value;
                continue repeatHelp;
            }
        }
    }, $elm$core$List$repeatHelp = F3($elm$core$List$repeatHelp_fn);
    var $elm$core$List$repeat_fn = function (n, value) {
        return $elm$core$List$repeatHelp_fn(_List_Nil, n, value);
    }, $elm$core$List$repeat = F2($elm$core$List$repeat_fn);
    var $author$project$Data$GiftArea$init = (new $$Record22($elm$core$List$repeat_fn($author$project$Data$GiftArea$defaultNumEmails, $author$project$Data$GiftArea$initEmailEntry), $elm$core$Maybe$Nothing));
    var $author$project$Data$Note$comparator_fn = function (new_, old_) {
        return _Utils_compare_fn(new_.fR, old_.fR);
    }, $author$project$Data$Note$comparator = F2($author$project$Data$Note$comparator_fn);
    var $author$project$Data$Note$Note = function (title) {
        return function (description) {
            return function (slateDoc) {
                return function (actionItems) {
                    return function (deleted) {
                        return function (updatedAt) {
                            return function (time) {
                                return function (endTime) {
                                    return function (eventRef) {
                                        return function (eventTitle) {
                                            return function (attendees) {
                                                return function (linkShared) {
                                                    return function (attachments) {
                                                        return function (colorId) {
                                                            return function (ordering) {
                                                                return function (createdAt) {
                                                                    return (new $$Record23(actionItems, attachments, attendees, colorId, createdAt, deleted, description, endTime, eventRef, eventTitle, linkShared, ordering, slateDoc, time, title, updatedAt));
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $elm_community$list_extra$List$Extra$last = function (items) {
        last: while (true) {
            if (!items.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                if (!items.b.b) {
                    var x = items.a;
                    return $elm$core$Maybe$Just(x);
                }
                else {
                    var rest = items.b;
                    var $temp$items = rest;
                    items = $temp$items;
                    continue last;
                }
            }
        }
    };
    var $author$project$Data$Note$attachmentNameFromStoragePath = function (pathInStorage) {
        return $elm$core$Maybe$withDefault_fn("untitled file", $elm_community$list_extra$List$Extra$last($elm$core$String$split_fn("/", pathInStorage)));
    };
    var $author$project$Data$Note$attachmentSchema2 = _Json_map1_fn(function (pathInStorage) {
        return (new $$Record24(false, $elm$core$Maybe$Nothing, $author$project$Data$Note$attachmentNameFromStoragePath(pathInStorage), false, "application/octet-stream", pathInStorage, $elm$core$Maybe$Nothing, 0));
    }, $elm$json$Json$Decode$string);
    var $author$project$Data$Note$Attachment_fn = function (fileName, totalBytes, storagePath, downloadUrl, inline, thumbnailUrl, mimeType, deleted) {
        return (new $$Record24(deleted, downloadUrl, fileName, inline, mimeType, storagePath, thumbnailUrl, totalBytes));
    }, $author$project$Data$Note$Attachment = F8($author$project$Data$Note$Attachment_fn);
    var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn = function (key, valDecoder, decoder) {
        return _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, _Json_decodeField_fn(key, valDecoder), decoder);
    }, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn);
    var $author$project$Data$Note$attachmentSchema5 = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("deleted", $elm$json$Json$Decode$bool, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("mimeType", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("thumbnailUrl", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("inline", $elm$json$Json$Decode$bool, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("downloadUrl", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("storagePath", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("totalBytes", $elm$json$Json$Decode$int, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("fileName", $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Data$Note$Attachment)))))))));
    var $author$project$Data$Note$attachmentsDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_decodeField_fn("attachments", $elm$json$Json$Decode$list($author$project$Data$Note$attachmentSchema5)),
        _Json_decodeField_fn("attachmentPathsInStorage", $elm$json$Json$Decode$list($author$project$Data$Note$attachmentSchema2)),
        $elm$json$Json$Decode$succeed(_List_Nil)
    ]));
    var $author$project$Data$Time$Date = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$Time$Time = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$Time$decodeISODate = _Json_andThen_fn(function (dateStr) {
        var _v0 = $elm$core$Basics$composeR_fn($justinmimbs$date$Date$fromIsoString_a0, $justinmimbs$date$Date$fromIsoString_a1, dateStr);
        if (!_v0.$) {
            var date = _v0.a;
            return $elm$json$Json$Decode$succeed(date);
        }
        else {
            var err = _v0.a;
            return $elm$json$Json$Decode$fail(err + (" " + dateStr));
        }
    }, $elm$json$Json$Decode$string);
    var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
    var $jweir$elm_iso8601$ISO8601$iso8601Regex_a0 = 1, $jweir$elm_iso8601$ISO8601$iso8601Regex_a1 = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\d{4})-?" + ("(\\d{2})?-?" + ("(\\d{2})?" + ("T?" + ("(\\d{2})?:?" + ("(\\d{2})?:?" + ("(\\d{2})?" + ("([.,]\\d{1,})?" + ("(Z|[+-]\\d{2}:?\\d{2})?" + "(.*)?")))))))))), $jweir$elm_iso8601$ISO8601$iso8601Regex = A2($elm$regex$Regex$findAtMost, $jweir$elm_iso8601$ISO8601$iso8601Regex_a0, $jweir$elm_iso8601$ISO8601$iso8601Regex_a1);
    var $elm$regex$Regex$replaceAtMost = _Regex_replaceAtMost;
    var $elm$core$Basics$round = _Basics_round;
    var $elm$core$String$toFloat = _String_toFloat;
    var $jweir$elm_iso8601$ISO8601$parseMilliseconds = function (msString) {
        if (msString.$ === 1) {
            return 0;
        }
        else {
            var s = msString.a;
            var decimalStr = _Regex_replaceAtMost_fn(1, $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[,.]")), function (_v1) {
                return "0.";
            }, s);
            var decimal = $elm$core$Maybe$withDefault_fn(0, $elm$core$String$toFloat(decimalStr));
            return $elm$core$Basics$round(1000 * decimal);
        }
    };
    var $jweir$elm_iso8601$ISO8601$Extras$toInt = function (str) {
        return $elm$core$Maybe$withDefault_fn(0, $elm$core$String$toInt(str));
    };
    var $jweir$elm_iso8601$ISO8601$parseOffset = function (timeString) {
        var re = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(Z|([+-]\\d{2}:?\\d{2}))?"));
        var match = _Regex_findAtMost_fn(1, $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("([-+])(\\d\\d):?(\\d\\d)")), $elm$core$Maybe$withDefault_fn("", timeString));
        var parts = $elm$core$List$map_fn(function ($) {
            return $.o$;
        }, match);
        var calc = F2(function (modifier, minutes) {
            switch (modifier) {
                case "+":
                    return minutes;
                case "-":
                    return (-1) * minutes;
                default:
                    return minutes;
            }
        });
        _v0$2: while (true) {
            if ((((parts.b && parts.a.b) && (!parts.a.a.$)) && parts.a.b.b) && (!parts.a.b.a.$)) {
                if (parts.a.b.b.b) {
                    if (((!parts.a.b.b.a.$) && (!parts.a.b.b.b.b)) && (!parts.b.b)) {
                        var _v1 = parts.a;
                        var modifier = _v1.a.a;
                        var _v2 = _v1.b;
                        var hour_ = _v2.a.a;
                        var _v3 = _v2.b;
                        var minute_ = _v3.a.a;
                        return A2(calc, modifier, ($jweir$elm_iso8601$ISO8601$Extras$toInt(hour_) * 60) + $jweir$elm_iso8601$ISO8601$Extras$toInt(minute_));
                    }
                    else {
                        break _v0$2;
                    }
                }
                else {
                    if (!parts.b.b) {
                        var _v4 = parts.a;
                        var modifier = _v4.a.a;
                        var _v5 = _v4.b;
                        var hour_ = _v5.a.a;
                        return A2(calc, modifier, $jweir$elm_iso8601$ISO8601$Extras$toInt(hour_) * 60);
                    }
                    else {
                        break _v0$2;
                    }
                }
            }
            else {
                break _v0$2;
            }
        }
        return 0;
    };
    var $elm$core$Array$fromListHelp_fn = function (list, nodeList, nodeListSize) {
        fromListHelp: while (true) {
            var _v0 = _JsArray_initializeFromList_fn($elm$core$Array$branchFactor, list);
            var jsArray = _v0.a;
            var remainingItems = _v0.b;
            if (_Utils_cmp($elm$core$Elm$JsArray$length(jsArray), $elm$core$Array$branchFactor) < 0) {
                return $elm$core$Array$builderToArray_fn(true, { v: nodeList, s: nodeListSize, t: jsArray });
            }
            else {
                var $temp$list = remainingItems, $temp$nodeList = _List_Cons($elm$core$Array$Leaf(jsArray), nodeList), $temp$nodeListSize = nodeListSize + 1;
                list = $temp$list;
                nodeList = $temp$nodeList;
                nodeListSize = $temp$nodeListSize;
                continue fromListHelp;
            }
        }
    }, $elm$core$Array$fromListHelp = F3($elm$core$Array$fromListHelp_fn);
    var $elm$core$Array$fromList = function (list) {
        if (!list.b) {
            return $elm$core$Array$empty;
        }
        else {
            return $elm$core$Array$fromListHelp_fn(list, _List_Nil, 0);
        }
    };
    var $jweir$elm_iso8601$ISO8601$Extras$calendar = $elm$core$Array$fromList(_List_fromArray([
        _Utils_Tuple3("January", 31, 31),
        _Utils_Tuple3("February", 28, 29),
        _Utils_Tuple3("March", 31, 31),
        _Utils_Tuple3("April", 30, 30),
        _Utils_Tuple3("May", 31, 31),
        _Utils_Tuple3("June", 30, 30),
        _Utils_Tuple3("July", 31, 31),
        _Utils_Tuple3("August", 31, 31),
        _Utils_Tuple3("September", 30, 30),
        _Utils_Tuple3("October", 31, 31),
        _Utils_Tuple3("November", 30, 30),
        _Utils_Tuple3("December", 31, 31)
    ]));
    var $elm$core$Bitwise$and = _Bitwise_and;
    var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
    var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
    var $elm$core$Basics$ge = _Utils_ge;
    var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
    var $elm$core$Array$getHelp_fn = function (shift, index, tree) {
        getHelp: while (true) {
            var pos = $elm$core$Array$bitMask & (index >>> shift);
            var _v0 = _JsArray_unsafeGet_fn(pos, tree);
            if (!_v0.$) {
                var subTree = _v0.a;
                var $temp$shift = shift - $elm$core$Array$shiftStep, $temp$index = index, $temp$tree = subTree;
                shift = $temp$shift;
                index = $temp$index;
                tree = $temp$tree;
                continue getHelp;
            }
            else {
                var values = _v0.a;
                return _JsArray_unsafeGet_fn($elm$core$Array$bitMask & index, values);
            }
        }
    }, $elm$core$Array$getHelp = F3($elm$core$Array$getHelp_fn);
    var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
    var $elm$core$Array$tailIndex = function (len) {
        return (len >>> 5) << 5;
    };
    var $elm$core$Array$get_fn = function (index, _v0) {
        var len = _v0.a;
        var startShift = _v0.b;
        var tree = _v0.c;
        var tail = _v0.d;
        return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(index, $elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(_JsArray_unsafeGet_fn($elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just($elm$core$Array$getHelp_fn(startShift, index, tree)));
    }, $elm$core$Array$get = F2($elm$core$Array$get_fn);
    var $jweir$elm_iso8601$ISO8601$Extras$isLeapYear = function (year) {
        var c = !_Basics_modBy_fn(400, year);
        var b = !_Basics_modBy_fn(100, year);
        var a = !_Basics_modBy_fn(4, year);
        var _v0 = _List_fromArray([a, b, c]);
        _v0$3: while (true) {
            if ((_v0.b && _v0.a) && _v0.b.b) {
                if (!_v0.b.a) {
                    if (_v0.b.b.b && (!_v0.b.b.b.b)) {
                        var _v3 = _v0.b;
                        var _v4 = _v3.b;
                        return true;
                    }
                    else {
                        break _v0$3;
                    }
                }
                else {
                    if (_v0.b.b.b) {
                        if (_v0.b.b.a) {
                            if (!_v0.b.b.b.b) {
                                var _v1 = _v0.b;
                                var _v2 = _v1.b;
                                return true;
                            }
                            else {
                                break _v0$3;
                            }
                        }
                        else {
                            if (!_v0.b.b.b.b) {
                                var _v5 = _v0.b;
                                var _v6 = _v5.b;
                                return false;
                            }
                            else {
                                break _v0$3;
                            }
                        }
                    }
                    else {
                        break _v0$3;
                    }
                }
            }
            else {
                break _v0$3;
            }
        }
        return false;
    };
    var $jweir$elm_iso8601$ISO8601$Extras$daysInMonth_fn = function (year, monthInt) {
        var calMonth = $elm$core$Array$get_fn(monthInt - 1, $jweir$elm_iso8601$ISO8601$Extras$calendar);
        if (!calMonth.$) {
            var _v1 = calMonth.a;
            var days = _v1.b;
            var leapDays = _v1.c;
            return $jweir$elm_iso8601$ISO8601$Extras$isLeapYear(year) ? leapDays : days;
        }
        else {
            return 0;
        }
    }, $jweir$elm_iso8601$ISO8601$Extras$daysInMonth = F2($jweir$elm_iso8601$ISO8601$Extras$daysInMonth_fn);
    var $jweir$elm_iso8601$ISO8601$validateHour = function (time) {
        var s = time.or;
        var m = time.c2;
        var h = time.cW;
        return ((h === 24) && ((m + s) > 0)) ? $elm$core$Result$Err("hour is out of range") : (((h < 0) || (h > 24)) ? $elm$core$Result$Err("hour is out of range") : (((m < 0) || (m > 59)) ? $elm$core$Result$Err("minute is out of range") : (((s < 0) || (s > 59)) ? $elm$core$Result$Err("second is out of range") : $elm$core$Result$Ok(time))));
    };
    var $jweir$elm_iso8601$ISO8601$validateTime = function (time) {
        var maxDays = $jweir$elm_iso8601$ISO8601$Extras$daysInMonth;
        return ((time.bz < 1) || (time.bz > 12)) ? $elm$core$Result$Err("month is out of range") : (((time.lb < 1) || (_Utils_cmp(time.lb, $jweir$elm_iso8601$ISO8601$Extras$daysInMonth_fn(time.bO, time.bz)) > 0)) ? $elm$core$Result$Err("day is out of range") : $jweir$elm_iso8601$ISO8601$validateHour(time));
    };
    var $jweir$elm_iso8601$ISO8601$fromString = function (s) {
        var unwrap = F2(function (x, d) {
            return $jweir$elm_iso8601$ISO8601$Extras$toInt($elm$core$Maybe$withDefault_fn(d, x));
        });
        var parts = $elm$core$List$map_fn(function ($) {
            return $.o$;
        }, _Regex_findAtMost_fn($jweir$elm_iso8601$ISO8601$iso8601Regex_a0, $jweir$elm_iso8601$ISO8601$iso8601Regex_a1, s));
        if (((((((((((parts.b && parts.a.b) && parts.a.b.b) && parts.a.b.b.b) && parts.a.b.b.b.b) && parts.a.b.b.b.b.b) && parts.a.b.b.b.b.b.b) && parts.a.b.b.b.b.b.b.b) && parts.a.b.b.b.b.b.b.b.b) && parts.a.b.b.b.b.b.b.b.b.b) && (!parts.a.b.b.b.b.b.b.b.b.b.b)) && (!parts.b.b)) {
            var _v1 = parts.a;
            var y = _v1.a;
            var _v2 = _v1.b;
            var mon = _v2.a;
            var _v3 = _v2.b;
            var d = _v3.a;
            var _v4 = _v3.b;
            var h = _v4.a;
            var _v5 = _v4.b;
            var min = _v5.a;
            var _v6 = _v5.b;
            var sec = _v6.a;
            var _v7 = _v6.b;
            var mil = _v7.a;
            var _v8 = _v7.b;
            var off = _v8.a;
            var _v9 = _v8.b;
            var invalid = _v9.a;
            if (!invalid.$) {
                return $elm$core$Result$Err("unexpected text");
            }
            else {
                return $jweir$elm_iso8601$ISO8601$validateTime((new $$Record25(A2(unwrap, d, "1"), A2(unwrap, h, "0"), $jweir$elm_iso8601$ISO8601$parseMilliseconds(mil), A2(unwrap, min, "0"), A2(unwrap, mon, "1"), $jweir$elm_iso8601$ISO8601$parseOffset(off), A2(unwrap, sec, "0"), A2(unwrap, y, "0"))));
            }
        }
        else {
            return $elm$core$Result$Err("Unable to parse time");
        }
    };
    var $jweir$elm_iso8601$ISO8601$Extras$daysInYear = function (year) {
        return $jweir$elm_iso8601$ISO8601$Extras$isLeapYear(year) ? 366 : 365;
    };
    var $jweir$elm_iso8601$ISO8601$ims = 1;
    var $jweir$elm_iso8601$ISO8601$isec = $jweir$elm_iso8601$ISO8601$ims * 1000;
    var $jweir$elm_iso8601$ISO8601$imin = $jweir$elm_iso8601$ISO8601$isec * 60;
    var $jweir$elm_iso8601$ISO8601$ihour = $jweir$elm_iso8601$ISO8601$imin * 60;
    var $jweir$elm_iso8601$ISO8601$iday = $jweir$elm_iso8601$ISO8601$ihour * 24;
    var $jweir$elm_iso8601$ISO8601$offsetToTime = function (time) {
        return time.nt * $jweir$elm_iso8601$ISO8601$imin;
    };
    var $elm$core$List$sum = function (numbers) {
        return $elm$core$List$foldl_fn($elm$core$Basics$add, 0, numbers);
    };
    var $jweir$elm_iso8601$ISO8601$toTime = function (time) {
        var _v0 = time.bO >= 1970;
        if (!_v0) {
            var years = $elm$core$List$map_fn($jweir$elm_iso8601$ISO8601$Extras$daysInYear, $elm$core$List$range_fn(time.bO + 1, 1970 - 1));
            var totalDays = $elm$core$List$sum($elm$core$List$map_fn($jweir$elm_iso8601$ISO8601$Extras$daysInMonth(time.bO), $elm$core$List$range_fn(1, time.bz)));
            var tots = _List_fromArray([
                $jweir$elm_iso8601$ISO8601$iday * $elm$core$List$sum(years),
                $jweir$elm_iso8601$ISO8601$iday * ($jweir$elm_iso8601$ISO8601$Extras$daysInYear(time.bO) - totalDays),
                $jweir$elm_iso8601$ISO8601$iday * ($jweir$elm_iso8601$ISO8601$Extras$daysInMonth_fn(time.bO, time.bz) - time.lb),
                ($jweir$elm_iso8601$ISO8601$iday - $jweir$elm_iso8601$ISO8601$ihour) - ($jweir$elm_iso8601$ISO8601$ihour * time.cW),
                ($jweir$elm_iso8601$ISO8601$ihour - $jweir$elm_iso8601$ISO8601$imin) - ($jweir$elm_iso8601$ISO8601$imin * time.c2),
                $jweir$elm_iso8601$ISO8601$imin - ($jweir$elm_iso8601$ISO8601$isec * time.or),
                $jweir$elm_iso8601$ISO8601$offsetToTime(time)
            ]);
            return 0 - ($elm$core$List$sum(tots) - time.m1);
        }
        else {
            var years = $elm$core$List$map_fn($jweir$elm_iso8601$ISO8601$Extras$daysInYear, $elm$core$List$range_fn(1970, time.bO - 1));
            var months = $elm$core$List$map_fn($jweir$elm_iso8601$ISO8601$Extras$daysInMonth(time.bO), $elm$core$List$range_fn(1, time.bz - 1));
            var tots = _List_fromArray([
                $jweir$elm_iso8601$ISO8601$iday * $elm$core$List$sum(years),
                $jweir$elm_iso8601$ISO8601$iday * $elm$core$List$sum(months),
                $jweir$elm_iso8601$ISO8601$iday * (time.lb - 1),
                $jweir$elm_iso8601$ISO8601$ihour * time.cW,
                $jweir$elm_iso8601$ISO8601$imin * time.c2,
                $jweir$elm_iso8601$ISO8601$isec * time.or,
                (-1) * $jweir$elm_iso8601$ISO8601$offsetToTime(time)
            ]);
            return $elm$core$List$sum(tots) + time.m1;
        }
    };
    var $jweir$elm_iso8601$ISO8601$toPosix = function (time) {
        return $elm$time$Time$millisToPosix($jweir$elm_iso8601$ISO8601$toTime(time));
    };
    var $author$project$Data$Time$decodeISODateTime = _Json_andThen_fn(function (datetimeStr) {
        if (!_String_contains_fn("T", datetimeStr)) {
            return $elm$json$Json$Decode$fail("Time not found in " + datetimeStr);
        }
        else {
            var _v0 = $jweir$elm_iso8601$ISO8601$fromString(datetimeStr);
            if (!_v0.$) {
                var date = _v0.a;
                return $elm$json$Json$Decode$succeed($jweir$elm_iso8601$ISO8601$toPosix(date));
            }
            else {
                return $elm$json$Json$Decode$fail("Invalid ISO8601 datetime " + datetimeStr);
            }
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Data$Time$decodeZoneless = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_map1_fn($author$project$Data$Time$Date, $author$project$Data$Time$decodeISODate),
        _Json_map1_fn(function (t) {
            return $author$project$Data$Time$Time((new $$Record26(t, 0)));
        }, $author$project$Data$Time$decodeISODateTime)
    ]));
    var $author$project$Data$Timestamp$fromPosix = $author$project$Data$Timestamp$Existing;
    var $author$project$Data$Timestamp$fromMillis_a0 = $elm$time$Time$millisToPosix, $author$project$Data$Timestamp$fromMillis_a1 = $author$project$Data$Timestamp$fromPosix, $author$project$Data$Timestamp$fromMillis = A2($elm$core$Basics$composeR, $author$project$Data$Timestamp$fromMillis_a0, $author$project$Data$Timestamp$fromMillis_a1);
    var $elm$time$Time$posixToMillis = function (_v0) {
        var millis = _v0;
        return millis;
    };
    var $justinmimbs$date$Date$monthToNumber = function (m) {
        switch (m) {
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    };
    var $justinmimbs$date$Date$toCalendarDateHelp_fn = function (y, m, d) {
        toCalendarDateHelp: while (true) {
            var monthDays = $justinmimbs$date$Date$daysInMonth_fn(y, m);
            var mn = $justinmimbs$date$Date$monthToNumber(m);
            if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
                var $temp$y = y, $temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1), $temp$d = d - monthDays;
                y = $temp$y;
                m = $temp$m;
                d = $temp$d;
                continue toCalendarDateHelp;
            }
            else {
                return (new $$Record27(d, m, y));
            }
        }
    }, $justinmimbs$date$Date$toCalendarDateHelp = F3($justinmimbs$date$Date$toCalendarDateHelp_fn);
    var $justinmimbs$date$Date$divWithRemainder_fn = function (a, b) {
        return _Utils_Tuple2($justinmimbs$date$Date$floorDiv_fn(a, b), _Basics_modBy_fn(b, a));
    }, $justinmimbs$date$Date$divWithRemainder = F2($justinmimbs$date$Date$divWithRemainder_fn);
    var $justinmimbs$date$Date$year = function (_v0) {
        var rd = _v0;
        var _v1 = $justinmimbs$date$Date$divWithRemainder_fn(rd, 146097);
        var n400 = _v1.a;
        var r400 = _v1.b;
        var _v2 = $justinmimbs$date$Date$divWithRemainder_fn(r400, 36524);
        var n100 = _v2.a;
        var r100 = _v2.b;
        var _v3 = $justinmimbs$date$Date$divWithRemainder_fn(r100, 1461);
        var n4 = _v3.a;
        var r4 = _v3.b;
        var _v4 = $justinmimbs$date$Date$divWithRemainder_fn(r4, 365);
        var n1 = _v4.a;
        var r1 = _v4.b;
        var n = (!r1) ? 0 : 1;
        return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
    };
    var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
        var rd = _v0;
        var y = $justinmimbs$date$Date$year(rd);
        return (new $$Record28(rd - $justinmimbs$date$Date$daysBeforeYear(y), y));
    };
    var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
        var rd = _v0;
        var date = $justinmimbs$date$Date$toOrdinalDate(rd);
        return $justinmimbs$date$Date$toCalendarDateHelp_fn(date.bO, 0, date.fS);
    };
    var $justinmimbs$date$Date$day_a0 = $justinmimbs$date$Date$toCalendarDate, $justinmimbs$date$Date$day_a1 = function ($) {
        return $.lb;
    }, $justinmimbs$date$Date$day = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$day_a0, $justinmimbs$date$Date$day_a1);
    var $justinmimbs$date$Date$month_a0 = $justinmimbs$date$Date$toCalendarDate, $justinmimbs$date$Date$month_a1 = function ($) {
        return $.bz;
    }, $justinmimbs$date$Date$month = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month_a0, $justinmimbs$date$Date$month_a1);
    var $elm$core$Basics$clamp_fn = function (low, high, number) {
        return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
    }, $elm$core$Basics$clamp = F3($elm$core$Basics$clamp_fn);
    var $justinmimbs$date$Date$fromCalendarDate_fn = function (y, m, d) {
        return ($justinmimbs$date$Date$daysBeforeYear(y) + $justinmimbs$date$Date$daysBeforeMonth_fn(y, m)) + $elm$core$Basics$clamp_fn(1, $justinmimbs$date$Date$daysInMonth_fn(y, m), d);
    }, $justinmimbs$date$Date$fromCalendarDate = F3($justinmimbs$date$Date$fromCalendarDate_fn);
    var $justinmimbs$date$Date$toRataDie = function (_v0) {
        var rd = _v0;
        return rd;
    };
    var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
        var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
        return daysSinceEpoch * 86400000;
    };
    var $elm$time$Time$flooredDiv_fn = function (numerator, denominator) {
        return $elm$core$Basics$floor(numerator / denominator);
    }, $elm$time$Time$flooredDiv = F2($elm$time$Time$flooredDiv_fn);
    var $elm$time$Time$toAdjustedMinutesHelp_fn = function (defaultOffset, posixMinutes, eras) {
        toAdjustedMinutesHelp: while (true) {
            if (!eras.b) {
                return posixMinutes + defaultOffset;
            }
            else {
                var era = eras.a;
                var olderEras = eras.b;
                if (_Utils_cmp(era.bF, posixMinutes) < 0) {
                    return posixMinutes + era.nt;
                }
                else {
                    var $temp$defaultOffset = defaultOffset, $temp$posixMinutes = posixMinutes, $temp$eras = olderEras;
                    defaultOffset = $temp$defaultOffset;
                    posixMinutes = $temp$posixMinutes;
                    eras = $temp$eras;
                    continue toAdjustedMinutesHelp;
                }
            }
        }
    }, $elm$time$Time$toAdjustedMinutesHelp = F3($elm$time$Time$toAdjustedMinutesHelp_fn);
    var $elm$time$Time$toAdjustedMinutes_fn = function (_v0, time) {
        var defaultOffset = _v0.a;
        var eras = _v0.b;
        return $elm$time$Time$toAdjustedMinutesHelp_fn(defaultOffset, $elm$time$Time$flooredDiv_fn($elm$time$Time$posixToMillis(time), 60000), eras);
    }, $elm$time$Time$toAdjustedMinutes = F2($elm$time$Time$toAdjustedMinutes_fn);
    var $elm$time$Time$toCivil = function (minutes) {
        var rawDay = $elm$time$Time$flooredDiv_fn(minutes, 60 * 24) + 719468;
        var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
        var dayOfEra = rawDay - (era * 146097);
        var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
        var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
        var mp = (((5 * dayOfYear) + 2) / 153) | 0;
        var month = mp + ((mp < 10) ? 3 : (-9));
        var year = yearOfEra + (era * 400);
        return (new $$Record27((dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1, month, year + ((month <= 2) ? 1 : 0)));
    };
    var $elm$time$Time$toDay_fn = function (zone, time) {
        return $elm$time$Time$toCivil($elm$time$Time$toAdjustedMinutes_fn(zone, time)).lb;
    }, $elm$time$Time$toDay = F2($elm$time$Time$toDay_fn);
    var $elm$time$Time$toMonth_fn = function (zone, time) {
        var _v0 = $elm$time$Time$toCivil($elm$time$Time$toAdjustedMinutes_fn(zone, time)).bz;
        switch (_v0) {
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }, $elm$time$Time$toMonth = F2($elm$time$Time$toMonth_fn);
    var $elm$time$Time$toYear_fn = function (zone, time) {
        return $elm$time$Time$toCivil($elm$time$Time$toAdjustedMinutes_fn(zone, time)).bO;
    }, $elm$time$Time$toYear = F2($elm$time$Time$toYear_fn);
    var $justinmimbs$date$Date$fromPosix_fn = function (zone, posix) {
        return $justinmimbs$date$Date$fromCalendarDate_fn($elm$time$Time$toYear_fn(zone, posix), $elm$time$Time$toMonth_fn(zone, posix), $elm$time$Time$toDay_fn(zone, posix));
    }, $justinmimbs$date$Date$fromPosix = F2($justinmimbs$date$Date$fromPosix_fn);
    var $justinmimbs$time_extra$Time$Extra$timeFromClock_fn = function (hour, minute, second, millisecond) {
        return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
    }, $justinmimbs$time_extra$Time$Extra$timeFromClock = F4($justinmimbs$time_extra$Time$Extra$timeFromClock_fn);
    var $elm$time$Time$toHour_fn = function (zone, time) {
        return _Basics_modBy_fn(24, $elm$time$Time$flooredDiv_fn($elm$time$Time$toAdjustedMinutes_fn(zone, time), 60));
    }, $elm$time$Time$toHour = F2($elm$time$Time$toHour_fn);
    var $elm$time$Time$toMillis_fn = function (_v0, time) {
        return _Basics_modBy_fn(1000, $elm$time$Time$posixToMillis(time));
    }, $elm$time$Time$toMillis = F2($elm$time$Time$toMillis_fn);
    var $elm$time$Time$toMinute_fn = function (zone, time) {
        return _Basics_modBy_fn(60, $elm$time$Time$toAdjustedMinutes_fn(zone, time));
    }, $elm$time$Time$toMinute = F2($elm$time$Time$toMinute_fn);
    var $elm$time$Time$toSecond_fn = function (_v0, time) {
        return _Basics_modBy_fn(60, $elm$time$Time$flooredDiv_fn($elm$time$Time$posixToMillis(time), 1000));
    }, $elm$time$Time$toSecond = F2($elm$time$Time$toSecond_fn);
    var $justinmimbs$time_extra$Time$Extra$timeFromPosix_fn = function (zone, posix) {
        return $justinmimbs$time_extra$Time$Extra$timeFromClock_fn($elm$time$Time$toHour_fn(zone, posix), $elm$time$Time$toMinute_fn(zone, posix), $elm$time$Time$toSecond_fn(zone, posix), $elm$time$Time$toMillis_fn(zone, posix));
    }, $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2($justinmimbs$time_extra$Time$Extra$timeFromPosix_fn);
    var $justinmimbs$time_extra$Time$Extra$toOffset_fn = function (zone, posix) {
        var millis = $elm$time$Time$posixToMillis(posix);
        var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis($justinmimbs$date$Date$fromPosix_fn(zone, posix)) + $justinmimbs$time_extra$Time$Extra$timeFromPosix_fn(zone, posix);
        return ((localMillis - millis) / 60000) | 0;
    }, $justinmimbs$time_extra$Time$Extra$toOffset = F2($justinmimbs$time_extra$Time$Extra$toOffset_fn);
    var $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn = function (zone, date, time) {
        var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
        var offset0 = $justinmimbs$time_extra$Time$Extra$toOffset_fn(zone, $elm$time$Time$millisToPosix(millis));
        var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
        var offset1 = $justinmimbs$time_extra$Time$Extra$toOffset_fn(zone, posix1);
        if (_Utils_eq(offset0, offset1)) {
            return posix1;
        }
        else {
            var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
            var offset2 = $justinmimbs$time_extra$Time$Extra$toOffset_fn(zone, posix2);
            return _Utils_eq(offset1, offset2) ? posix2 : posix1;
        }
    }, $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3($justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn);
    var $justinmimbs$time_extra$Time$Extra$partsToPosix_fn = function (zone, _v0) {
        var year = _v0.bO;
        var month = _v0.bz;
        var day = _v0.lb;
        var hour = _v0.cW;
        var minute = _v0.c2;
        var second = _v0.or;
        var millisecond = _v0.m1;
        return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$fromCalendarDate_fn(year, month, day), $justinmimbs$time_extra$Time$Extra$timeFromClock_fn($elm$core$Basics$clamp_fn(0, 23, hour), $elm$core$Basics$clamp_fn(0, 59, minute), $elm$core$Basics$clamp_fn(0, 59, second), $elm$core$Basics$clamp_fn(0, 999, millisecond)));
    }, $justinmimbs$time_extra$Time$Extra$partsToPosix = F2($justinmimbs$time_extra$Time$Extra$partsToPosix_fn);
    var $author$project$Util$Time$dateToPosix_fn = function (zone, date) {
        return $justinmimbs$time_extra$Time$Extra$partsToPosix_fn(zone, (new $$Record29($elm$core$Basics$composeR_fn($justinmimbs$date$Date$day_a0, $justinmimbs$date$Date$day_a1, date), 0, 0, 0, $elm$core$Basics$composeR_fn($justinmimbs$date$Date$month_a0, $justinmimbs$date$Date$month_a1, date), 0, $justinmimbs$date$Date$year(date))));
    }, $author$project$Util$Time$dateToPosix = F2($author$project$Util$Time$dateToPosix_fn);
    var $author$project$Data$Time$toPosix_fn = function (userTimezone, time_) {
        if (!time_.$) {
            var time = time_.a.gh;
            return time;
        }
        else {
            var date = time_.a;
            return $author$project$Util$Time$dateToPosix_fn(userTimezone, date);
        }
    }, $author$project$Data$Time$toPosix = F2($author$project$Data$Time$toPosix_fn);
    var $author$project$Data$Time$toMillis_fn = function (zone, time) {
        return $elm$time$Time$posixToMillis($author$project$Data$Time$toPosix_fn(zone, time));
    }, $author$project$Data$Time$toMillis = F2($author$project$Data$Time$toMillis_fn);
    var $elm$time$Time$utc = $elm$time$Time$Zone_fn(0, _List_Nil);
    var $author$project$Data$Note$createdAtDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_decodeField_fn("createdAt", $author$project$Data$Timestamp$decoder),
        _Json_decodeField_fn("time", _Json_map1_fn(A2($elm$core$Basics$composeR, $author$project$Data$Time$toMillis($elm$time$Time$utc), $author$project$Data$Timestamp$fromMillis), $author$project$Data$Time$decodeZoneless))
    ]));
    var $author$project$Data$ActionItem$ActionItem_fn = function (id, noteId, text, createdAt, completedAt) {
        return (new $$Record30(completedAt, createdAt, id, noteId, text));
    }, $author$project$Data$ActionItem$ActionItem = F5($author$project$Data$ActionItem$ActionItem_fn);
    var $author$project$Util$Time$decodePosixFromMillis = _Json_map1_fn($elm$time$Time$millisToPosix, $elm$json$Json$Decode$int);
    var $author$project$Data$ActionItem$ActionItemChipElement = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Data$ActionItem$EventMentionElement_fn = function (a, b, c) {
        return { $: 1, a: a, b: b, c: c };
    }, $author$project$Data$ActionItem$EventMentionElement = F3($author$project$Data$ActionItem$EventMentionElement_fn);
    var $author$project$Data$Mention$EventRefMeta = function (currentTopic) {
        return { k7: currentTopic };
    };
    var $author$project$Data$ActionItem$PersonMentionElement = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Data$ActionItem$Plaintext = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$ActionItem$TalkingPointChip = { $: 1 };
    var $author$project$Data$ActionItem$TodoChip = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$ActionItem$HighPriority = 1;
    var $author$project$Data$ActionItem$NormalPriority = 0;
    var $author$project$Data$ActionItem$priorityDecoder = _Json_andThen_fn(function (id) {
        switch (id) {
            case "priority-normal":
                return $elm$json$Json$Decode$succeed(0);
            case "priority-high":
                return $elm$json$Json$Decode$succeed(1);
            default:
                return $elm$json$Json$Decode$fail("Unknown priority " + id);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Data$ActionItem$decodeActionItemChip = _Json_andThen_fn(function (aiType) {
        switch (aiType) {
            case "todo":
                return _Json_map1_fn($author$project$Data$ActionItem$TodoChip, _Json_decodeField_fn("priority", $author$project$Data$ActionItem$priorityDecoder));
            case "talking-point":
                return $elm$json$Json$Decode$succeed($author$project$Data$ActionItem$TalkingPointChip);
            default:
                return $elm$json$Json$Decode$fail("Unrecognized action item chip type: " + aiType);
        }
    }, _Json_decodeField_fn("aiType", $elm$json$Json$Decode$string));
    var $author$project$Data$Mention$InstanceEventCompletedIn = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$Mention$instanceCompletedInDecoder = _Json_map2_fn(F2(function (eventId, masterId) {
        return $author$project$Data$Mention$InstanceEventCompletedIn({ b7: eventId, mT: masterId });
    }), _Json_decodeField_fn("eventId", $elm$json$Json$Decode$string), _Json_decodeField_fn("masterId", $elm$json$Json$Decode$string));
    var $author$project$Data$Mention$SingleEventCompletedIn = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$Mention$singleCompletedInDecoder = _Json_map1_fn(function (eventId) {
        return $author$project$Data$Mention$SingleEventCompletedIn({ b7: eventId });
    }, _Json_decodeField_fn("eventId", $elm$json$Json$Decode$string));
    var $author$project$Data$Mention$mentionEventCompletedInDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([$author$project$Data$Mention$instanceCompletedInDecoder, $author$project$Data$Mention$singleCompletedInDecoder]));
    var $author$project$Data$Mention$InstanceEventRef = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$Mention$instanceRefDecoder = _Json_map2_fn(F2(function (eventId, masterId) {
        return $author$project$Data$Mention$InstanceEventRef({ b7: eventId, mT: masterId });
    }), _Json_decodeField_fn("eventId", $elm$json$Json$Decode$string), _Json_decodeField_fn("masterId", $elm$json$Json$Decode$string));
    var $author$project$Data$Mention$MasterEventRef = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$Mention$masterRefDecoder = _Json_map1_fn(function (masterId) {
        return $author$project$Data$Mention$MasterEventRef({ mT: masterId });
    }, _Json_decodeField_fn("masterId", $elm$json$Json$Decode$string));
    var $author$project$Data$Mention$SingleEventRef = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Data$Mention$singleRefDecoder = _Json_map1_fn(function (eventId) {
        return $author$project$Data$Mention$SingleEventRef({ b7: eventId });
    }, _Json_decodeField_fn("eventId", $elm$json$Json$Decode$string));
    var $author$project$Data$Mention$mentionEventRefDataDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([$author$project$Data$Mention$instanceRefDecoder, $author$project$Data$Mention$masterRefDecoder, $author$project$Data$Mention$singleRefDecoder]));
    var $author$project$Data$ActionItem$textElementDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_map1_fn($author$project$Data$ActionItem$Plaintext, _Json_decodeField_fn("plaintext", $elm$json$Json$Decode$string)),
        _Json_map1_fn(function (pId) {
            return $author$project$Data$ActionItem$PersonMentionElement({ iB: pId });
        }, _Json_decodeField_fn("personId", $elm$json$Json$Decode$string)),
        $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("currentTopic", _Json_map1_fn($author$project$Data$Mention$EventRefMeta, $elm$json$Json$Decode$bool), $author$project$Data$Mention$EventRefMeta(false), $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("completedIn", $elm$json$Json$Decode$nullable($author$project$Data$Mention$mentionEventCompletedInDecoder), $elm$core$Maybe$Nothing, _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, $author$project$Data$Mention$mentionEventRefDataDecoder, $elm$json$Json$Decode$succeed($author$project$Data$ActionItem$EventMentionElement)))),
        _Json_map1_fn($author$project$Data$ActionItem$ActionItemChipElement, $author$project$Data$ActionItem$decodeActionItemChip)
    ]));
    var $author$project$Data$ActionItem$decode = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("completedAt", $elm$json$Json$Decode$nullable($author$project$Util$Time$decodePosixFromMillis), $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("createdAt", $author$project$Util$Time$decodePosixFromMillis, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("text", $elm$json$Json$Decode$list($author$project$Data$ActionItem$textElementDecoder), $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("noteId", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("id", $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Data$ActionItem$ActionItem))))));
    var $author$project$Data$Note$Attendee_fn = function (name, ref, manual, calendarResponseStatus, overridenResponseStatus) {
        return (new $$Record31(calendarResponseStatus, manual, name, overridenResponseStatus, ref));
    }, $author$project$Data$Note$Attendee = F5($author$project$Data$Note$Attendee_fn);
    var $author$project$Data$Note$EmailRef = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$Note$PersonRef = function (a) {
        return { $: 0, a: a };
    };
    var $elm$json$Json$Decode$at_fn = function (fields, decoder) {
        return $elm$core$List$foldr_fn($elm$json$Json$Decode$field, decoder, fields);
    }, $elm$json$Json$Decode$at = F2($elm$json$Json$Decode$at_fn);
    var $author$project$Data$Note$attendeeRefDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_map1_fn($author$project$Data$Note$PersonRef, $elm$json$Json$Decode$at_fn(_List_fromArray(["ref", "personId"]), $elm$json$Json$Decode$string)),
        _Json_map1_fn($author$project$Data$Note$EmailRef, $elm$json$Json$Decode$at_fn(_List_fromArray(["ref", "email"]), $elm$json$Json$Decode$string)),
        _Json_map1_fn($author$project$Data$Note$EmailRef, _Json_decodeField_fn("email", $elm$json$Json$Decode$string))
    ]));
    var $author$project$Data$Event$Accepted = 0;
    var $author$project$Data$Event$Declined = 1;
    var $author$project$Data$Event$NeedsAction = 3;
    var $author$project$Data$Event$Tentative = 2;
    var $author$project$Data$Event$responseStatusFromString = function (status) {
        switch (status) {
            case "accepted":
                return 0;
            case "declined":
                return 1;
            case "needsAction":
                return 3;
            case "tentative":
                return 2;
            default:
                return 3;
        }
    };
    var $author$project$Data$Note$decodeResponseStatus = _Json_andThen_fn(A2($elm$core$Basics$composeR, $author$project$Data$Event$responseStatusFromString, $elm$json$Json$Decode$succeed), $elm$json$Json$Decode$string);
    var $author$project$Data$Note$decodeAttendee = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("overridenResponseStatus", $elm$json$Json$Decode$nullable($author$project$Data$Note$decodeResponseStatus), $elm$core$Maybe$Nothing, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("calendarResponseStatus", $elm$json$Json$Decode$nullable($author$project$Data$Note$decodeResponseStatus), $elm$core$Maybe$Nothing, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("manual", $elm$json$Json$Decode$bool, false, _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, $author$project$Data$Note$attendeeRefDecoder, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("name", $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Data$Note$Attendee))))));
    var $justinmimbs$date$Date$Days = 3;
    var $justinmimbs$date$Date$Months = 1;
    var $elm$core$Basics$min_fn = function (x, y) {
        return (_Utils_cmp(x, y) < 0) ? x : y;
    }, $elm$core$Basics$min = F2($elm$core$Basics$min_fn);
    var $justinmimbs$date$Date$add_fn = function (unit, n, _v0) {
        var rd = _v0;
        switch (unit) {
            case 0:
                return $justinmimbs$date$Date$add_fn(1, 12 * n, rd);
            case 1:
                var date = $justinmimbs$date$Date$toCalendarDate(rd);
                var wholeMonths = ((12 * (date.bO - 1)) + ($justinmimbs$date$Date$monthToNumber(date.bz) - 1)) + n;
                var m = $justinmimbs$date$Date$numberToMonth(_Basics_modBy_fn(12, wholeMonths) + 1);
                var y = $justinmimbs$date$Date$floorDiv_fn(wholeMonths, 12) + 1;
                return ($justinmimbs$date$Date$daysBeforeYear(y) + $justinmimbs$date$Date$daysBeforeMonth_fn(y, m)) + $elm$core$Basics$min_fn(date.lb, $justinmimbs$date$Date$daysInMonth_fn(y, m));
            case 2:
                return rd + (7 * n);
            default:
                return rd + n;
        }
    }, $justinmimbs$date$Date$add = F3($justinmimbs$date$Date$add_fn);
    var $author$project$Data$Note$decodeEndTime = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_decodeField_fn("endTime", $author$project$Data$Time$decodeZoneless),
        _Json_map1_fn(function (startTime) {
            if (startTime.$ === 1) {
                var date = startTime.a;
                return $author$project$Data$Time$Date($justinmimbs$date$Date$add_fn(3, 1, date));
            }
            else {
                return startTime;
            }
        }, _Json_decodeField_fn("time", $author$project$Data$Time$decodeZoneless))
    ]));
    var $author$project$Data$Note$Instance = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$Note$Single = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$Note$decodeEventRef = function () {
        var updatedDecoder = _Json_map1_fn($elm$core$Maybe$withDefault($author$project$Util$Time$epoch), $elm$json$Json$Decode$maybe(_Json_decodeField_fn("updated", $author$project$Util$Time$decodePosixFromMillis)));
        return _Json_andThen_fn(function (tipe) {
            switch (tipe) {
                case "single":
                    return _Json_map2_fn(F2(function (eventId, updated) {
                        return $author$project$Data$Note$Single({ b7: eventId, dr: updated });
                    }), _Json_decodeField_fn("eventId", $elm$json$Json$Decode$string), updatedDecoder);
                case "instance":
                    return _Json_map3_fn(F3(function (iId, mId, updated) {
                        return $author$project$Data$Note$Instance({ Q: iId, mT: mId, dr: updated });
                    }), _Json_decodeField_fn("instanceId", $elm$json$Json$Decode$string), _Json_decodeField_fn("masterId", $elm$json$Json$Decode$string), updatedDecoder);
                default:
                    return $elm$json$Json$Decode$fail("Unknown note.eventRef.type: " + tipe);
            }
        }, _Json_decodeField_fn("type", $elm$json$Json$Decode$string));
    }();
    var $author$project$Data$Slate$emptyDoc = "[{\"type\":\"p\",\"children\":[{\"text\":\"\"}]}]";
    var $author$project$Util$Time$decodePosixFromISO = _Json_andThen_fn(function (v) {
        var _v0 = $jweir$elm_iso8601$ISO8601$fromString(v);
        if (_v0.$ === 1) {
            var err = _v0.a;
            return $elm$json$Json$Decode$fail(err);
        }
        else {
            var t = _v0.a;
            return $elm$json$Json$Decode$succeed($jweir$elm_iso8601$ISO8601$toPosix(t));
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Data$Note$updatedAtDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_decodeField_fn("updatedAt", $author$project$Data$Timestamp$decoder),
        _Json_decodeField_fn("modified", _Json_map1_fn($author$project$Data$Timestamp$fromPosix, $author$project$Util$Time$decodePosixFromISO))
    ]));
    var $author$project$Data$Note$decode = _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, $author$project$Data$Note$createdAtDecoder, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("ordering", $elm$json$Json$Decode$int, 0, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("colorId", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, $author$project$Data$Note$attachmentsDecoder, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("linkShared", $elm$json$Json$Decode$bool, false, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("attendees", $elm$json$Json$Decode$list($author$project$Data$Note$decodeAttendee), _List_Nil, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("eventTitle", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("eventRef", $elm$json$Json$Decode$nullable($author$project$Data$Note$decodeEventRef), $elm$core$Maybe$Nothing, _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, $author$project$Data$Note$decodeEndTime, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("time", $author$project$Data$Time$decodeZoneless, _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, $author$project$Data$Note$updatedAtDecoder, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("deleted", $elm$json$Json$Decode$bool, false, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("actionItems", $elm$json$Json$Decode$list($author$project$Data$ActionItem$decode), _List_Nil, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("slateDoc", $elm$json$Json$Decode$string, $author$project$Data$Slate$emptyDoc, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("description", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("title", $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Data$Note$Note)))))))))))))))));
    var $author$project$Firestore$Internal$Collection = $elm$core$Basics$identity;
    var $author$project$Firestore$Collection$empty_fn = function (encoder, decoder, comparator) {
        return (new $$Record32(comparator, decoder, $elm$core$Dict$empty, encoder, "", $elm$core$Set$empty));
    }, $author$project$Firestore$Collection$empty = F3($author$project$Firestore$Collection$empty_fn);
    var $elm$json$Json$Encode$bool = _Json_wrap;
    var $elm$json$Json$Encode$null = _Json_encodeNull;
    var $author$project$Util$Json$encodeMaybe_fn = function (encoder, a) {
        return $elm$core$Maybe$withDefault_fn($elm$json$Json$Encode$null, $elm$core$Maybe$map_fn(encoder, a));
    }, $author$project$Util$Json$encodeMaybe = F2($author$project$Util$Json$encodeMaybe_fn);
    var $elm$json$Json$Encode$int = _Json_wrap;
    var $author$project$Util$Time$encodePosixToMillis_a0 = $elm$time$Time$posixToMillis, $author$project$Util$Time$encodePosixToMillis_a1 = $elm$json$Json$Encode$int, $author$project$Util$Time$encodePosixToMillis = A2($elm$core$Basics$composeR, $author$project$Util$Time$encodePosixToMillis_a0, $author$project$Util$Time$encodePosixToMillis_a1);
    var $elm$json$Json$Encode$string = _Json_wrap;
    var $author$project$Data$ActionItem$encodePriority = function (priority) {
        return $elm$json$Json$Encode$string(function () {
            if (!priority) {
                return "priority-normal";
            }
            else {
                return "priority-high";
            }
        }());
    };
    var $elm$json$Json$Encode$object = function (pairs) {
        return _Json_wrap($elm$core$List$foldl_fn_unwrapped(function (_v0, obj) {
            var k = _v0.a;
            var v = _v0.b;
            return _Json_addField_fn(k, v, obj);
        }, _Json_emptyObject(0), pairs));
    };
    var $author$project$Data$ActionItem$encodeActionItemChip = function (actionItemChipType) {
        if (!actionItemChipType.$) {
            var priority = actionItemChipType.a;
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("aiType", $elm$json$Json$Encode$string("todo")),
                _Utils_Tuple2("priority", $author$project$Data$ActionItem$encodePriority(priority))
            ]));
        }
        else {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("aiType", $elm$json$Json$Encode$string("talking-point"))
            ]));
        }
    };
    var $author$project$Data$Mention$encodeEventCompletedInData = function (mentionEventCompletedIn) {
        if (!mentionEventCompletedIn.$) {
            var eventId = mentionEventCompletedIn.a.b7;
            var masterId = mentionEventCompletedIn.a.mT;
            return _List_fromArray([
                _Utils_Tuple2("eventId", $elm$json$Json$Encode$string(eventId)),
                _Utils_Tuple2("masterId", $elm$json$Json$Encode$string(masterId))
            ]);
        }
        else {
            var eventId = mentionEventCompletedIn.a.b7;
            return _List_fromArray([
                _Utils_Tuple2("eventId", $elm$json$Json$Encode$string(eventId))
            ]);
        }
    };
    var $author$project$Data$Mention$encodeEventRefData = function (mentionEventRefData) {
        switch (mentionEventRefData.$) {
            case 0:
                var masterId = mentionEventRefData.a.mT;
                return _List_fromArray([
                    _Utils_Tuple2("masterId", $elm$json$Json$Encode$string(masterId))
                ]);
            case 1:
                var eventId = mentionEventRefData.a.b7;
                var masterId = mentionEventRefData.a.mT;
                return _List_fromArray([
                    _Utils_Tuple2("eventId", $elm$json$Json$Encode$string(eventId)),
                    _Utils_Tuple2("masterId", $elm$json$Json$Encode$string(masterId))
                ]);
            default:
                var eventId = mentionEventRefData.a.b7;
                return _List_fromArray([
                    _Utils_Tuple2("eventId", $elm$json$Json$Encode$string(eventId))
                ]);
        }
    };
    var $author$project$Data$ActionItem$encodeTextElement = function (textElement) {
        switch (textElement.$) {
            case 0:
                var str = textElement.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2("plaintext", $elm$json$Json$Encode$string(str))
                ]));
            case 1:
                var mentionEventRefData = textElement.a;
                var mCompletedIn = textElement.b;
                var currentTopic = textElement.c.k7;
                return $elm$json$Json$Encode$object(_List_Cons(_Utils_Tuple2("completedIn", $author$project$Util$Json$encodeMaybe_fn(A2($elm$core$Basics$composeR, $author$project$Data$Mention$encodeEventCompletedInData, $elm$json$Json$Encode$object), mCompletedIn)), _List_Cons(_Utils_Tuple2("currentTopic", $elm$json$Json$Encode$bool(currentTopic)), $author$project$Data$Mention$encodeEventRefData(mentionEventRefData))));
            case 2:
                var personId = textElement.a.iB;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2("personId", $elm$json$Json$Encode$string(personId))
                ]));
            default:
                var chipElement = textElement.a;
                return $author$project$Data$ActionItem$encodeActionItemChip(chipElement);
        }
    };
    var $elm$json$Json$Encode$list_fn = function (func, entries) {
        return _Json_wrap($elm$core$List$foldl_fn(_Json_addEntry(func), _Json_emptyArray(0), entries));
    }, $elm$json$Json$Encode$list = F2($elm$json$Json$Encode$list_fn);
    var $author$project$Data$ActionItem$encode = function (item) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("id", $elm$json$Json$Encode$string(item.l8)),
            _Utils_Tuple2("noteId", $elm$json$Json$Encode$string(item.ip)),
            _Utils_Tuple2("text", $elm$json$Json$Encode$list_fn($author$project$Data$ActionItem$encodeTextElement, item.jn)),
            _Utils_Tuple2("createdAt", $elm$core$Basics$composeR_fn($author$project$Util$Time$encodePosixToMillis_a0, $author$project$Util$Time$encodePosixToMillis_a1, item.e8)),
            _Utils_Tuple2("completedAt", $author$project$Util$Json$encodeMaybe_fn($author$project$Util$Time$encodePosixToMillis, item.g_))
        ]));
    };
    var $jweir$elm_iso8601$ISO8601$Extras$After = 1;
    var $jweir$elm_iso8601$ISO8601$Extras$Before = 0;
    var $jweir$elm_iso8601$ISO8601$Extras$daysToMonths_fn = function (year, startMonth, remainingDays) {
        daysToMonths: while (true) {
            var remainingDays_ = remainingDays - $jweir$elm_iso8601$ISO8601$Extras$daysInMonth_fn(year, startMonth);
            if (remainingDays_ > 0) {
                var $temp$year = year, $temp$startMonth = startMonth + 1, $temp$remainingDays = remainingDays_;
                year = $temp$year;
                startMonth = $temp$startMonth;
                remainingDays = $temp$remainingDays;
                continue daysToMonths;
            }
            else {
                return _Utils_Tuple2(startMonth, remainingDays);
            }
        }
    }, $jweir$elm_iso8601$ISO8601$Extras$daysToMonths = F3($jweir$elm_iso8601$ISO8601$Extras$daysToMonths_fn);
    var $jweir$elm_iso8601$ISO8601$Extras$daysToYears_fn = function (rel, startYear, remainingDays) {
        daysToYears: while (true) {
            if (rel === 1) {
                var remainingDays_ = remainingDays - $jweir$elm_iso8601$ISO8601$Extras$daysInYear(startYear);
                if (remainingDays_ > 0) {
                    var $temp$rel = 1, $temp$startYear = startYear + 1, $temp$remainingDays = remainingDays_;
                    rel = $temp$rel;
                    startYear = $temp$startYear;
                    remainingDays = $temp$remainingDays;
                    continue daysToYears;
                }
                else {
                    if (!remainingDays_) {
                        return _Utils_Tuple2(startYear + 1, 0);
                    }
                    else {
                        return _Utils_Tuple2(startYear, remainingDays);
                    }
                }
            }
            else {
                var remainingDays_ = remainingDays + $jweir$elm_iso8601$ISO8601$Extras$daysInYear(startYear);
                if (remainingDays_ < 0) {
                    var $temp$rel = 0, $temp$startYear = startYear - 1, $temp$remainingDays = remainingDays_;
                    rel = $temp$rel;
                    startYear = $temp$startYear;
                    remainingDays = $temp$remainingDays;
                    continue daysToYears;
                }
                else {
                    return _Utils_Tuple2(startYear, $jweir$elm_iso8601$ISO8601$Extras$daysInYear(startYear) + remainingDays);
                }
            }
        }
    }, $jweir$elm_iso8601$ISO8601$Extras$daysToYears = F3($jweir$elm_iso8601$ISO8601$Extras$daysToYears_fn);
    var $jweir$elm_iso8601$ISO8601$defaultTime = (new $$Record25(1, 0, 0, 0, 1, 0, 0, 0));
    var $jweir$elm_iso8601$ISO8601$fromTime = function (msFloat) {
        var ms = msFloat;
        var v = (ms >= 0) ? 1 : 0;
        var milliseconds = _Basics_modBy_fn($jweir$elm_iso8601$ISO8601$isec, ms);
        if (v === 1) {
            var seconds = _Basics_modBy_fn(60, $elm$core$Basics$floor(ms / $jweir$elm_iso8601$ISO8601$isec));
            var minutes = _Basics_modBy_fn(60, (ms / $jweir$elm_iso8601$ISO8601$imin) | 0);
            var hours = _Basics_modBy_fn(24, (ms / $jweir$elm_iso8601$ISO8601$ihour) | 0);
            var days = (ms / $jweir$elm_iso8601$ISO8601$iday) | 0;
            var _v1 = $jweir$elm_iso8601$ISO8601$Extras$daysToYears_fn(1, 1970, days);
            var years = _v1.a;
            var remainingDays = _v1.b;
            var _v2 = $jweir$elm_iso8601$ISO8601$Extras$daysToMonths_fn(years, 1, remainingDays + 1);
            var months = _v2.a;
            var daysInMonth = _v2.b;
            return $$update__bO__bz__c2__cW__lb__m1__or($jweir$elm_iso8601$ISO8601$defaultTime, years, months, minutes, hours, daysInMonth, milliseconds, seconds);
        }
        else {
            var totalDays = (ms / $jweir$elm_iso8601$ISO8601$iday) | 0;
            var rem = _Basics_modBy_fn($jweir$elm_iso8601$ISO8601$iday, ms);
            var seconds = _Basics_modBy_fn(60, (rem / $jweir$elm_iso8601$ISO8601$isec) | 0);
            var minutes = _Basics_modBy_fn(60, (rem / $jweir$elm_iso8601$ISO8601$imin) | 0);
            var hours = _Basics_modBy_fn(24, (rem / $jweir$elm_iso8601$ISO8601$ihour) | 0);
            var days = (rem / $jweir$elm_iso8601$ISO8601$iday) | 0;
            var _v3 = (!rem) ? $jweir$elm_iso8601$ISO8601$Extras$daysToYears_fn(0, 1969, totalDays + 1) : $jweir$elm_iso8601$ISO8601$Extras$daysToYears_fn(0, 1969, totalDays);
            var years = _v3.a;
            var remainingDays = _v3.b;
            var _v4 = $jweir$elm_iso8601$ISO8601$Extras$daysToMonths_fn(years, 1, remainingDays);
            var months = _v4.a;
            var daysInMonth = _v4.b;
            return $$update__bO__bz__c2__cW__lb__m1__or($jweir$elm_iso8601$ISO8601$defaultTime, years, months, minutes, hours, daysInMonth, milliseconds, seconds);
        }
    };
    var $jweir$elm_iso8601$ISO8601$fromPosix = function (posix) {
        return $jweir$elm_iso8601$ISO8601$fromTime($elm$time$Time$posixToMillis(posix));
    };
    var $jweir$elm_iso8601$ISO8601$fmt = function (n) {
        return (n < 10) ? ("0" + $elm$core$String$fromInt(n)) : $elm$core$String$fromInt(n);
    };
    var $jweir$elm_iso8601$ISO8601$fmtMs = function (n) {
        return (!n) ? "" : ((n < 10) ? (".00" + $elm$core$String$fromInt(n)) : ((n < 100) ? (".0" + $elm$core$String$fromInt(n)) : ("." + $elm$core$String$fromInt(n))));
    };
    var $elm$core$Basics$abs = function (n) {
        return (n < 0) ? (-n) : n;
    };
    var $jweir$elm_iso8601$ISO8601$fmtOffset = function (minutes) {
        if (!minutes) {
            return "Z";
        }
        else {
            var symbol = (minutes >= 0) ? "+" : "-";
            var m = _Basics_modBy_fn(60, minutes);
            var h = (minutes / 60) | 0;
            return _Utils_ap(symbol, _Utils_ap($jweir$elm_iso8601$ISO8601$fmt($elm$core$Basics$abs(h)), $jweir$elm_iso8601$ISO8601$fmt(m)));
        }
    };
    var $jweir$elm_iso8601$ISO8601$fmtYear = function (n) {
        var s = $elm$core$String$fromInt(n);
        return (n < 10) ? ("000" + s) : ((n < 100) ? ("00" + s) : ((n < 1000) ? ("0" + s) : s));
    };
    var $jweir$elm_iso8601$ISO8601$toString = function (time) {
        return $elm$core$String$join_fn("", _List_fromArray([
            $jweir$elm_iso8601$ISO8601$fmtYear(time.bO),
            "-",
            $jweir$elm_iso8601$ISO8601$fmt(time.bz),
            "-",
            $jweir$elm_iso8601$ISO8601$fmt(time.lb),
            "T",
            $jweir$elm_iso8601$ISO8601$fmt(time.cW),
            ":",
            $jweir$elm_iso8601$ISO8601$fmt(time.c2),
            ":",
            $jweir$elm_iso8601$ISO8601$fmt(time.or),
            $jweir$elm_iso8601$ISO8601$fmtMs(time.m1),
            $jweir$elm_iso8601$ISO8601$fmtOffset(time.nt)
        ]));
    };
    var $author$project$Util$Time$encodePosixToISO = function (posix) {
        return $elm$json$Json$Encode$string($jweir$elm_iso8601$ISO8601$toString($jweir$elm_iso8601$ISO8601$fromPosix(posix)));
    };
    var $justinmimbs$date$Date$monthNumber_a0 = $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthNumber_a1 = $justinmimbs$date$Date$monthToNumber, $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$monthNumber_a0, $justinmimbs$date$Date$monthNumber_a1);
    var $justinmimbs$date$Date$ordinalDay_a0 = $justinmimbs$date$Date$toOrdinalDate, $justinmimbs$date$Date$ordinalDay_a1 = function ($) {
        return $.fS;
    }, $justinmimbs$date$Date$ordinalDay = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$ordinalDay_a0, $justinmimbs$date$Date$ordinalDay_a1);
    var $elm$core$String$fromChar = function (_char) {
        return _String_cons_fn(_char, "");
    };
    var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
    var $elm$core$String$repeatHelp_fn = function (n, chunk, result) {
        return (n <= 0) ? result : $elm$core$String$repeatHelp_fn(n >> 1, _Utils_ap(chunk, chunk), (!(n & 1)) ? result : _Utils_ap(result, chunk));
    }, $elm$core$String$repeatHelp = F3($elm$core$String$repeatHelp_fn);
    var $elm$core$String$repeat_fn = function (n, chunk) {
        return $elm$core$String$repeatHelp_fn(n, chunk, "");
    }, $elm$core$String$repeat = F2($elm$core$String$repeat_fn);
    var $elm$core$String$padLeft_fn = function (n, _char, string) {
        return _Utils_ap($elm$core$String$repeat_fn(n - $elm$core$String$length(string), $elm$core$String$fromChar(_char)), string);
    }, $elm$core$String$padLeft = F3($elm$core$String$padLeft_fn);
    var $justinmimbs$date$Date$padSignedInt_fn = function (length, _int) {
        return _Utils_ap((_int < 0) ? "-" : "", $elm$core$String$padLeft_fn(length, "0", $elm$core$String$fromInt($elm$core$Basics$abs(_int))));
    }, $justinmimbs$date$Date$padSignedInt = F2($justinmimbs$date$Date$padSignedInt_fn);
    var $justinmimbs$date$Date$monthToQuarter = function (m) {
        return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
    };
    var $justinmimbs$date$Date$quarter_a0 = $justinmimbs$date$Date$month, $justinmimbs$date$Date$quarter_a1 = $justinmimbs$date$Date$monthToQuarter, $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$quarter_a0, $justinmimbs$date$Date$quarter_a1);
    var $elm$core$String$right_fn = function (n, string) {
        return (n < 1) ? "" : _String_slice_fn(-n, $elm$core$String$length(string), string);
    }, $elm$core$String$right = F2($elm$core$String$right_fn);
    var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
        var _v0 = $elm$core$Basics$max_fn(1, wdn);
        switch (_v0) {
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            default:
                return 6;
        }
    };
    var $justinmimbs$date$Date$toWeekDate = function (_v0) {
        var rd = _v0;
        var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
        var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
        var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
        return {
            jH: 1 + (((rd - week1Day1) / 7) | 0),
            jI: wy,
            p3: $justinmimbs$date$Date$numberToWeekday(wdn)
        };
    };
    var $justinmimbs$date$Date$weekNumber_a0 = $justinmimbs$date$Date$toWeekDate, $justinmimbs$date$Date$weekNumber_a1 = function ($) {
        return $.jH;
    }, $justinmimbs$date$Date$weekNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekNumber_a0, $justinmimbs$date$Date$weekNumber_a1);
    var $justinmimbs$date$Date$weekYear_a0 = $justinmimbs$date$Date$toWeekDate, $justinmimbs$date$Date$weekYear_a1 = function ($) {
        return $.jI;
    }, $justinmimbs$date$Date$weekYear = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekYear_a0, $justinmimbs$date$Date$weekYear_a1);
    var $justinmimbs$date$Date$weekday_a0 = $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$weekday_a1 = $justinmimbs$date$Date$numberToWeekday, $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekday_a0, $justinmimbs$date$Date$weekday_a1);
    var $justinmimbs$date$Date$ordinalSuffix = function (n) {
        var nn = _Basics_modBy_fn(100, n);
        var _v0 = $elm$core$Basics$min_fn((nn < 20) ? nn : _Basics_modBy_fn(10, nn), 4);
        switch (_v0) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    };
    var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
        return _Utils_ap($elm$core$String$fromInt(n), $justinmimbs$date$Date$ordinalSuffix(n));
    };
    var $justinmimbs$date$Date$formatField_fn = function (language, _char, length, date) {
        switch (_char) {
            case "y":
                if (length === 2) {
                    return $elm$core$String$right_fn(2, $elm$core$String$padLeft_fn(2, "0", $elm$core$String$fromInt($justinmimbs$date$Date$year(date))));
                }
                else {
                    return $justinmimbs$date$Date$padSignedInt_fn(length, $justinmimbs$date$Date$year(date));
                }
            case "Y":
                if (length === 2) {
                    return $elm$core$String$right_fn(2, $elm$core$String$padLeft_fn(2, "0", $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$weekYear_a0, $justinmimbs$date$Date$weekYear_a1, date))));
                }
                else {
                    return $justinmimbs$date$Date$padSignedInt_fn(length, $elm$core$Basics$composeR_fn($justinmimbs$date$Date$weekYear_a0, $justinmimbs$date$Date$weekYear_a1, date));
                }
            case "Q":
                switch (length) {
                    case 1:
                        return $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$quarter_a0, $justinmimbs$date$Date$quarter_a1, date));
                    case 2:
                        return $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$quarter_a0, $justinmimbs$date$Date$quarter_a1, date));
                    case 3:
                        return "Q" + $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$quarter_a0, $justinmimbs$date$Date$quarter_a1, date));
                    case 4:
                        return $justinmimbs$date$Date$withOrdinalSuffix($elm$core$Basics$composeR_fn($justinmimbs$date$Date$quarter_a0, $justinmimbs$date$Date$quarter_a1, date));
                    case 5:
                        return $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$quarter_a0, $justinmimbs$date$Date$quarter_a1, date));
                    default:
                        return "";
                }
            case "M":
                switch (length) {
                    case 1:
                        return $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$monthNumber_a0, $justinmimbs$date$Date$monthNumber_a1, date));
                    case 2:
                        return $elm$core$String$padLeft_fn(2, "0", $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$monthNumber_a0, $justinmimbs$date$Date$monthNumber_a1, date)));
                    case 3:
                        return language.ec($elm$core$Basics$composeR_fn($justinmimbs$date$Date$month_a0, $justinmimbs$date$Date$month_a1, date));
                    case 4:
                        return language.fK($elm$core$Basics$composeR_fn($justinmimbs$date$Date$month_a0, $justinmimbs$date$Date$month_a1, date));
                    case 5:
                        return $elm$core$String$left_fn(1, language.ec($elm$core$Basics$composeR_fn($justinmimbs$date$Date$month_a0, $justinmimbs$date$Date$month_a1, date)));
                    default:
                        return "";
                }
            case "w":
                switch (length) {
                    case 1:
                        return $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$weekNumber_a0, $justinmimbs$date$Date$weekNumber_a1, date));
                    case 2:
                        return $elm$core$String$padLeft_fn(2, "0", $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$weekNumber_a0, $justinmimbs$date$Date$weekNumber_a1, date)));
                    default:
                        return "";
                }
            case "d":
                switch (length) {
                    case 1:
                        return $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$day_a0, $justinmimbs$date$Date$day_a1, date));
                    case 2:
                        return $elm$core$String$padLeft_fn(2, "0", $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$day_a0, $justinmimbs$date$Date$day_a1, date)));
                    case 3:
                        return language.e9($elm$core$Basics$composeR_fn($justinmimbs$date$Date$day_a0, $justinmimbs$date$Date$day_a1, date));
                    default:
                        return "";
                }
            case "D":
                switch (length) {
                    case 1:
                        return $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$ordinalDay_a0, $justinmimbs$date$Date$ordinalDay_a1, date));
                    case 2:
                        return $elm$core$String$padLeft_fn(2, "0", $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$ordinalDay_a0, $justinmimbs$date$Date$ordinalDay_a1, date)));
                    case 3:
                        return $elm$core$String$padLeft_fn(3, "0", $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$ordinalDay_a0, $justinmimbs$date$Date$ordinalDay_a1, date)));
                    default:
                        return "";
                }
            case "E":
                switch (length) {
                    case 1:
                        return language.bN($elm$core$Basics$composeR_fn($justinmimbs$date$Date$weekday_a0, $justinmimbs$date$Date$weekday_a1, date));
                    case 2:
                        return language.bN($elm$core$Basics$composeR_fn($justinmimbs$date$Date$weekday_a0, $justinmimbs$date$Date$weekday_a1, date));
                    case 3:
                        return language.bN($elm$core$Basics$composeR_fn($justinmimbs$date$Date$weekday_a0, $justinmimbs$date$Date$weekday_a1, date));
                    case 4:
                        return language.gr($elm$core$Basics$composeR_fn($justinmimbs$date$Date$weekday_a0, $justinmimbs$date$Date$weekday_a1, date));
                    case 5:
                        return $elm$core$String$left_fn(1, language.bN($elm$core$Basics$composeR_fn($justinmimbs$date$Date$weekday_a0, $justinmimbs$date$Date$weekday_a1, date)));
                    case 6:
                        return $elm$core$String$left_fn(2, language.bN($elm$core$Basics$composeR_fn($justinmimbs$date$Date$weekday_a0, $justinmimbs$date$Date$weekday_a1, date)));
                    default:
                        return "";
                }
            case "e":
                switch (length) {
                    case 1:
                        return $elm$core$String$fromInt($justinmimbs$date$Date$weekdayNumber(date));
                    case 2:
                        return $elm$core$String$fromInt($justinmimbs$date$Date$weekdayNumber(date));
                    default:
                        return $justinmimbs$date$Date$formatField_fn(language, "E", length, date);
                }
            default:
                return "";
        }
    }, $justinmimbs$date$Date$formatField = F4($justinmimbs$date$Date$formatField_fn);
    var $justinmimbs$date$Date$formatWithTokens_fn = function (language, tokens, date) {
        return $elm$core$List$foldl_fn_unwrapped(function (token, formatted) {
            if (!token.$) {
                var _char = token.a;
                var length = token.b;
                return _Utils_ap($justinmimbs$date$Date$formatField_fn(language, _char, length, date), formatted);
            }
            else {
                var str = token.a;
                return _Utils_ap(str, formatted);
            }
        }, "", tokens);
    }, $justinmimbs$date$Date$formatWithTokens = F3($justinmimbs$date$Date$formatWithTokens_fn);
    var $justinmimbs$date$Pattern$Literal = function (a) {
        return { $: 1, a: a };
    };
    var $justinmimbs$date$Pattern$escapedQuote = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal("'")), $elm$parser$Parser$token("''"));
    var $justinmimbs$date$Pattern$Field_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $justinmimbs$date$Pattern$Field = F2($justinmimbs$date$Pattern$Field_fn);
    var $elm$parser$Parser$Advanced$chompWhileHelp_fn = function (isGood, offset, row, col, s0) {
        chompWhileHelp: while (true) {
            var newOffset = _Parser_isSubChar_fn(isGood, offset, s0.oM);
            if (newOffset === -1) {
                return $elm$parser$Parser$Advanced$Good_fn(_Utils_cmp(s0.nt, offset) < 0, 0, { kQ: col, h: s0.h, i: s0.i, nt: offset, of: row, oM: s0.oM });
            }
            else {
                if (newOffset === -2) {
                    var $temp$isGood = isGood, $temp$offset = offset + 1, $temp$row = row + 1, $temp$col = 1, $temp$s0 = s0;
                    isGood = $temp$isGood;
                    offset = $temp$offset;
                    row = $temp$row;
                    col = $temp$col;
                    s0 = $temp$s0;
                    continue chompWhileHelp;
                }
                else {
                    var $temp$isGood = isGood, $temp$offset = newOffset, $temp$row = row, $temp$col = col + 1, $temp$s0 = s0;
                    isGood = $temp$isGood;
                    offset = $temp$offset;
                    row = $temp$row;
                    col = $temp$col;
                    s0 = $temp$s0;
                    continue chompWhileHelp;
                }
            }
        }
    }, $elm$parser$Parser$Advanced$chompWhileHelp = F5($elm$parser$Parser$Advanced$chompWhileHelp_fn);
    var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
        return function (s) {
            return $elm$parser$Parser$Advanced$chompWhileHelp_fn(isGood, s.nt, s.of, s.kQ, s);
        };
    };
    var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
    var $elm$parser$Parser$Advanced$getOffset = function (s) {
        return $elm$parser$Parser$Advanced$Good_fn(false, s.nt, s);
    };
    var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
    var $elm$core$String$foldr = _String_foldr;
    var $elm$core$String$toList = function (string) {
        return _String_foldr_fn($elm$core$List$cons, _List_Nil, string);
    };
    var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
        var _v0 = $elm$core$String$toList(str);
        if (_v0.b && (!_v0.b.b)) {
            var _char = _v0.a;
            return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed(F2(function (x, y) {
                return $justinmimbs$date$Pattern$Field_fn(_char, 1 + (y - x));
            })), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$getOffset, $elm$parser$Parser$chompWhile($elm$core$Basics$eq(_char)))), $elm$parser$Parser$getOffset);
        }
        else {
            return $elm$parser$Parser$problem("expected exactly one char");
        }
    };
    var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
        return $elm$parser$Parser$Advanced$mapChompedString_fn($elm$core$Basics$always, parser);
    };
    var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
    var $justinmimbs$date$Pattern$field = $elm$parser$Parser$Advanced$andThen_fn($justinmimbs$date$Pattern$fieldRepeats, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
    var $justinmimbs$date$Pattern$finalize_a0 = F2(function (token, tokens) {
        var _v0 = _Utils_Tuple2(token, tokens);
        if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
            var x = _v0.a.a;
            var _v1 = _v0.b;
            var y = _v1.a.a;
            var rest = _v1.b;
            return _List_Cons($justinmimbs$date$Pattern$Literal(_Utils_ap(x, y)), rest);
        }
        else {
            return _List_Cons(token, tokens);
        }
    }), $justinmimbs$date$Pattern$finalize_a1 = _List_Nil, $justinmimbs$date$Pattern$finalize = A2($elm$core$List$foldl, $justinmimbs$date$Pattern$finalize_a0, $justinmimbs$date$Pattern$finalize_a1);
    var $elm$parser$Parser$Advanced$lazy = function (thunk) {
        return function (s) {
            var _v0 = thunk(0);
            var parse = _v0;
            return parse(s);
        };
    };
    var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
    var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
        return (_char !== "'") && (!$elm$core$Char$isAlpha(_char));
    };
    var $justinmimbs$date$Pattern$literal = $elm$parser$Parser$Advanced$map_fn($justinmimbs$date$Pattern$Literal, $elm$parser$Parser$getChompedString($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)), $elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
    var $justinmimbs$date$Pattern$quotedHelp = function (result) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$andThen_fn(function (str) {
                return $justinmimbs$date$Pattern$quotedHelp(_Utils_ap(result, str));
            }, $elm$parser$Parser$getChompedString($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf($elm$core$Basics$neq("'"))), $elm$parser$Parser$chompWhile($elm$core$Basics$neq("'"))))),
            $elm$parser$Parser$Advanced$andThen_fn(function (_v0) {
                return $justinmimbs$date$Pattern$quotedHelp(result + "'");
            }, $elm$parser$Parser$token("''")),
            $elm$parser$Parser$succeed(result)
        ]));
    };
    var $justinmimbs$date$Pattern$quoted = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal), $elm$parser$Parser$chompIf($elm$core$Basics$eq("'"))), $elm$parser$Parser$Advanced$ignorer_fn($justinmimbs$date$Pattern$quotedHelp(""), $elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$chompIf($elm$core$Basics$eq("'")),
        $elm$parser$Parser$end
    ]))));
    var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$andThen_fn(function (token) {
                return $justinmimbs$date$Pattern$patternHelp(_List_Cons(token, tokens));
            }, $elm$parser$Parser$oneOf(_List_fromArray([$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
            $elm$parser$Parser$lazy(function (_v0) {
                return $elm$parser$Parser$succeed($elm$core$List$foldl_fn($justinmimbs$date$Pattern$finalize_a0, $justinmimbs$date$Pattern$finalize_a1, tokens));
            })
        ]));
    };
    var $justinmimbs$date$Pattern$fromString = function (str) {
        return $elm$core$Result$withDefault_fn(_List_fromArray([
            $justinmimbs$date$Pattern$Literal(str)
        ]), $elm$parser$Parser$run_fn($justinmimbs$date$Pattern$patternHelp(_List_Nil), str));
    };
    var $justinmimbs$date$Date$formatWithLanguage_fn = function (language, pattern) {
        var tokens = $elm$core$List$reverse($justinmimbs$date$Pattern$fromString(pattern));
        return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
    }, $justinmimbs$date$Date$formatWithLanguage = F2($justinmimbs$date$Date$formatWithLanguage_fn);
    var $justinmimbs$date$Date$monthToName = function (m) {
        switch (m) {
            case 0:
                return "January";
            case 1:
                return "February";
            case 2:
                return "March";
            case 3:
                return "April";
            case 4:
                return "May";
            case 5:
                return "June";
            case 6:
                return "July";
            case 7:
                return "August";
            case 8:
                return "September";
            case 9:
                return "October";
            case 10:
                return "November";
            default:
                return "December";
        }
    };
    var $justinmimbs$date$Date$weekdayToName = function (wd) {
        switch (wd) {
            case 0:
                return "Monday";
            case 1:
                return "Tuesday";
            case 2:
                return "Wednesday";
            case 3:
                return "Thursday";
            case 4:
                return "Friday";
            case 5:
                return "Saturday";
            default:
                return "Sunday";
        }
    };
    var $justinmimbs$date$Date$language_en = {
        e9: $justinmimbs$date$Date$withOrdinalSuffix,
        fK: $justinmimbs$date$Date$monthToName,
        ec: A2($elm$core$Basics$composeR, $justinmimbs$date$Date$monthToName, $elm$core$String$left(3)),
        gr: $justinmimbs$date$Date$weekdayToName,
        bN: A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayToName, $elm$core$String$left(3))
    };
    var $justinmimbs$date$Date$format = function (pattern) {
        return $justinmimbs$date$Date$formatWithLanguage_fn($justinmimbs$date$Date$language_en, pattern);
    };
    var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format("yyyy-MM-dd");
    var $author$project$Data$Time$encode = function (time_) {
        if (!time_.$) {
            var time = time_.a.gh;
            return $author$project$Util$Time$encodePosixToISO(time);
        }
        else {
            var date = time_.a;
            return $elm$json$Json$Encode$string($justinmimbs$date$Date$toIsoString(date));
        }
    };
    var $author$project$Data$Timestamp$encode = function (timestamp) {
        if (!timestamp.$) {
            return $elm$json$Json$Encode$null;
        }
        else {
            var time = timestamp.a;
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("seconds", $elm$json$Json$Encode$int(($elm$time$Time$posixToMillis(time) / 1000) | 0)),
                _Utils_Tuple2("nanoseconds", $elm$json$Json$Encode$int(0))
            ]));
        }
    };
    var $author$project$Data$Note$encodeAttachment = function (attachment) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("fileName", $elm$json$Json$Encode$string(attachment.b8)),
            _Utils_Tuple2("totalBytes", $elm$json$Json$Encode$int(attachment.dn)),
            _Utils_Tuple2("storagePath", $elm$json$Json$Encode$string(attachment.Y)),
            _Utils_Tuple2("downloadUrl", $author$project$Util$Json$encodeMaybe_fn($elm$json$Json$Encode$string, attachment.cR)),
            _Utils_Tuple2("inline", $elm$json$Json$Encode$bool(attachment.cf)),
            _Utils_Tuple2("thumbnailUrl", $author$project$Util$Json$encodeMaybe_fn($elm$json$Json$Encode$string, attachment.ct)),
            _Utils_Tuple2("mimeType", $elm$json$Json$Encode$string(attachment.c1)),
            _Utils_Tuple2("deleted", $elm$json$Json$Encode$bool(attachment.lh))
        ]));
    };
    var $author$project$Data$Event$responseStatusToString = function (status) {
        switch (status) {
            case 0:
                return "accepted";
            case 1:
                return "declined";
            case 3:
                return "needsAction";
            default:
                return "tentative";
        }
    };
    var $author$project$Data$Note$encodeResponseStatus_a0 = $author$project$Data$Event$responseStatusToString, $author$project$Data$Note$encodeResponseStatus_a1 = $elm$json$Json$Encode$string, $author$project$Data$Note$encodeResponseStatus = A2($elm$core$Basics$composeR, $author$project$Data$Note$encodeResponseStatus_a0, $author$project$Data$Note$encodeResponseStatus_a1);
    var $author$project$Data$Note$encodeAttendee = function (a) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("name", $elm$json$Json$Encode$string(a.b)),
            _Utils_Tuple2("ref", function () {
                var _v0 = a.n3;
                if (!_v0.$) {
                    var personId = _v0.a;
                    return $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2("personId", $elm$json$Json$Encode$string(personId))
                    ]));
                }
                else {
                    var email = _v0.a;
                    return $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2("email", $elm$json$Json$Encode$string(email))
                    ]));
                }
            }()),
            _Utils_Tuple2("manual", $elm$json$Json$Encode$bool(a.mR)),
            _Utils_Tuple2("calendarResponseStatus", $elm$core$Maybe$withDefault_fn($elm$json$Json$Encode$null, $elm$core$Maybe$map_fn($author$project$Data$Note$encodeResponseStatus, a.kC))),
            _Utils_Tuple2("overridenResponseStatus", $elm$core$Maybe$withDefault_fn($elm$json$Json$Encode$null, $elm$core$Maybe$map_fn($author$project$Data$Note$encodeResponseStatus, a.nH)))
        ]));
    };
    var $author$project$Data$Note$schemaVersion = 17;
    var $author$project$Data$Note$encode = function (note) {
        var encodeEventRef = function (eventRef) {
            return $elm$json$Json$Encode$object(function () {
                if (!eventRef.$) {
                    var eventId = eventRef.a.b7;
                    var updated = eventRef.a.dr;
                    return _List_fromArray([
                        _Utils_Tuple2("type", $elm$json$Json$Encode$string("single")),
                        _Utils_Tuple2("eventId", $elm$json$Json$Encode$string(eventId)),
                        _Utils_Tuple2("updated", $elm$core$Basics$composeR_fn($author$project$Util$Time$encodePosixToMillis_a0, $author$project$Util$Time$encodePosixToMillis_a1, updated))
                    ]);
                }
                else {
                    var instanceId = eventRef.a.Q;
                    var masterId = eventRef.a.mT;
                    var updated = eventRef.a.dr;
                    return _List_fromArray([
                        _Utils_Tuple2("type", $elm$json$Json$Encode$string("instance")),
                        _Utils_Tuple2("instanceId", $elm$json$Json$Encode$string(instanceId)),
                        _Utils_Tuple2("masterId", $elm$json$Json$Encode$string(masterId)),
                        _Utils_Tuple2("updated", $elm$core$Basics$composeR_fn($author$project$Util$Time$encodePosixToMillis_a0, $author$project$Util$Time$encodePosixToMillis_a1, updated))
                    ]);
                }
            }());
        };
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("title", $elm$json$Json$Encode$string(note.gj)),
            _Utils_Tuple2("description", $elm$json$Json$Encode$string(note.fc)),
            _Utils_Tuple2("slateDoc", $elm$json$Json$Encode$string(note.f6)),
            _Utils_Tuple2("actionItems", $elm$json$Json$Encode$list_fn($author$project$Data$ActionItem$encode, note.gz)),
            _Utils_Tuple2("deleted", $elm$json$Json$Encode$bool(note.lh)),
            _Utils_Tuple2("updatedAt", $author$project$Data$Timestamp$encode(note.pR)),
            _Utils_Tuple2("time", $author$project$Data$Time$encode(note.gh)),
            _Utils_Tuple2("endTime", $author$project$Data$Time$encode(note.fh)),
            _Utils_Tuple2("eventRef", $author$project$Util$Json$encodeMaybe_fn(encodeEventRef, note.hh)),
            _Utils_Tuple2("eventTitle", $author$project$Util$Json$encodeMaybe_fn($elm$json$Json$Encode$string, note.lv)),
            _Utils_Tuple2("attendees", $elm$json$Json$Encode$list_fn($author$project$Data$Note$encodeAttendee, note.ke)),
            _Utils_Tuple2("linkShared", $elm$json$Json$Encode$bool(note.mF)),
            _Utils_Tuple2("attachments", $elm$json$Json$Encode$list_fn($author$project$Data$Note$encodeAttachment, note.kd)),
            _Utils_Tuple2("colorId", $author$project$Util$Json$encodeMaybe_fn($elm$json$Json$Encode$int, note.kT)),
            _Utils_Tuple2("ordering", $elm$json$Json$Encode$int(note.fR)),
            _Utils_Tuple2("createdAt", $author$project$Data$Timestamp$encode(note.e8)),
            _Utils_Tuple2("schemaVersion", $elm$json$Json$Encode$int($author$project$Data$Note$schemaVersion))
        ]));
    };
    var $author$project$Data$Note$init = $author$project$Firestore$Collection$empty_fn($author$project$Data$Note$encode, $author$project$Data$Note$decode, $author$project$Data$Note$comparator);
    var $author$project$Data$Person$comparator_fn = function (new_, old_) {
        return _Utils_compare_fn(new_.fR, old_.fR);
    }, $author$project$Data$Person$comparator = F2($author$project$Data$Person$comparator_fn);
    var $author$project$Data$Person$Person = function (name) {
        return function (bio) {
            return function (slateDoc) {
                return function (updatedAt) {
                    return function (deleted) {
                        return function (emailAddresses) {
                            return function (phoneNumbers) {
                                return function (mergedInto) {
                                    return function (notDuplicateOf) {
                                        return function (ordering) {
                                            return function (createdAt) {
                                                return function (createdBy) {
                                                    return (new $$Record33(bio, createdAt, createdBy, deleted, emailAddresses, mergedInto, name, notDuplicateOf, ordering, phoneNumbers, slateDoc, updatedAt));
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Data$Person$CreatedByMissing = { $: 5 };
    var $author$project$Data$Person$BackendCalendarPerson = { $: 2 };
    var $author$project$Data$Person$FrontendAdhocPerson = { $: 0 };
    var $author$project$Data$Person$PreloadedPerson = { $: 3 };
    var $author$project$Data$Person$UnknownCreatedBy = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Data$Person$createdByFromString = function (str) {
        switch (str) {
            case "frontend/ad-hoc-person":
                return $author$project$Data$Person$FrontendAdhocPerson;
            case "frontend/preloaded-person":
                return $author$project$Data$Person$PreloadedPerson;
            case "backend/calendar-person":
                return $author$project$Data$Person$BackendCalendarPerson;
            default:
                var other = str;
                return $author$project$Data$Person$UnknownCreatedBy(other);
        }
    };
    var $author$project$Data$Person$createdByDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_decodeField_fn("createdBy", $elm$json$Json$Decode$oneOf(_List_fromArray([
            _Json_map1_fn($author$project$Data$Person$createdByFromString, $elm$json$Json$Decode$string),
            $elm$json$Json$Decode$null($author$project$Data$Person$CreatedByMissing),
            $elm$json$Json$Decode$fail("createdBy field exists but isn't a string")
        ]))),
        $elm$json$Json$Decode$succeed($author$project$Data$Person$CreatedByMissing)
    ]));
    var $author$project$Data$Person$slateDocDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_decodeField_fn("slateDoc", $elm$json$Json$Decode$string),
        $elm$json$Json$Decode$succeed($author$project$Data$Slate$emptyDoc)
    ]));
    var $author$project$Data$Person$updatedAtDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_decodeField_fn("updatedAt", $author$project$Data$Timestamp$decoder),
        _Json_decodeField_fn("modified", _Json_map1_fn($author$project$Data$Timestamp$fromPosix, $author$project$Util$Time$decodePosixFromISO))
    ]));
    var $author$project$Data$Person$decode = _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, $author$project$Data$Person$createdByDecoder, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("createdAt", $author$project$Data$Timestamp$decoder, $author$project$Data$Timestamp$serverTimestamp, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("ordering", $elm$json$Json$Decode$int, 0, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("notDuplicateOf", $elm$json$Json$Decode$list($elm$json$Json$Decode$string), _List_Nil, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("mergedInto", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("phoneNumbers", $elm$json$Json$Decode$list($elm$json$Json$Decode$string), _List_Nil, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("emailAddresses", $elm$json$Json$Decode$list($elm$json$Json$Decode$string), _List_Nil, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("deleted", $elm$json$Json$Decode$bool, false, _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, $author$project$Data$Person$updatedAtDecoder, _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, $author$project$Data$Person$slateDocDecoder, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("bio", $elm$json$Json$Decode$string, "", $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("name", $elm$json$Json$Decode$string, "New Person", $elm$json$Json$Decode$succeed($author$project$Data$Person$Person)))))))))))));
    var $author$project$Data$Person$createdByToString = function (createdBy) {
        switch (createdBy.$) {
            case 0:
                return $elm$core$Maybe$Just("frontend/ad-hoc-person");
            case 1:
                return $elm$core$Maybe$Just("frontend/calendar-person");
            case 3:
                return $elm$core$Maybe$Just("frontend/preloaded-person");
            case 2:
                return $elm$core$Maybe$Just("backend/calendar-person");
            case 4:
                var rawString = createdBy.a;
                return $elm$core$Maybe$Just(rawString);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Data$Person$encodeCreatedBy_a0 = $author$project$Data$Person$createdByToString, $author$project$Data$Person$encodeCreatedBy_a1 = A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$json$Json$Encode$string), $elm$core$Maybe$withDefault($elm$json$Json$Encode$null)), $author$project$Data$Person$encodeCreatedBy = A2($elm$core$Basics$composeR, $author$project$Data$Person$encodeCreatedBy_a0, $author$project$Data$Person$encodeCreatedBy_a1);
    var $author$project$Data$Person$schemaVersion = 5;
    var $author$project$Data$Person$encode = function (person) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("name", $elm$json$Json$Encode$string(person.b)),
            _Utils_Tuple2("bio", $elm$json$Json$Encode$string(person.ko)),
            _Utils_Tuple2("slateDoc", $elm$json$Json$Encode$string(person.f6)),
            _Utils_Tuple2("updatedAt", $author$project$Data$Timestamp$encode(person.pR)),
            _Utils_Tuple2("deleted", $elm$json$Json$Encode$bool(person.lh)),
            _Utils_Tuple2("emailAddresses", $elm$json$Json$Encode$list_fn($elm$json$Json$Encode$string, person.lo)),
            _Utils_Tuple2("phoneNumbers", $elm$json$Json$Encode$list_fn($elm$json$Json$Encode$string, person.nM)),
            _Utils_Tuple2("mergedInto", $author$project$Util$Json$encodeMaybe_fn($elm$json$Json$Encode$string, person.mZ)),
            _Utils_Tuple2("notDuplicateOf", $elm$json$Json$Encode$list_fn($elm$json$Json$Encode$string, person.no)),
            _Utils_Tuple2("ordering", $elm$json$Json$Encode$int(person.fR)),
            _Utils_Tuple2("createdAt", $author$project$Data$Timestamp$encode(person.e8)),
            _Utils_Tuple2("createdBy", $elm$core$Basics$composeR_fn($author$project$Data$Person$encodeCreatedBy_a0, $author$project$Data$Person$encodeCreatedBy_a1, person.k1)),
            _Utils_Tuple2("schemaVersion", $elm$json$Json$Encode$int($author$project$Data$Person$schemaVersion))
        ]));
    };
    var $author$project$Data$Person$init = $author$project$Firestore$Collection$empty_fn($author$project$Data$Person$encode, $author$project$Data$Person$decode, $author$project$Data$Person$comparator);
    var $author$project$Data$Settings$comparator_fn = function (_new, old) {
        return _Utils_compare_fn(_new.fR, old.fR);
    }, $author$project$Data$Settings$comparator = F2($author$project$Data$Settings$comparator_fn);
    var $elm$core$Dict$foldl_fn = function (func, acc, dict) {
        foldl: while (true) {
            if (dict.$ === -2) {
                return acc;
            }
            else {
                var key = dict.b;
                var value = dict.c;
                var left = dict.d;
                var right = dict.e;
                var $temp$func = func, $temp$acc = A3(func, key, value, $elm$core$Dict$foldl_fn(func, acc, left)), $temp$dict = right;
                func = $temp$func;
                acc = $temp$acc;
                dict = $temp$dict;
                continue foldl;
            }
        }
    }, $elm$core$Dict$foldl_fn_unwrapped = function (func, acc, dict) {
        foldl: while (true) {
            if (dict.$ === -2) {
                return acc;
            }
            else {
                var key = dict.b;
                var value = dict.c;
                var left = dict.d;
                var right = dict.e;
                var $temp$func = func, $temp$acc = func(key, value, $elm$core$Dict$foldl_fn_unwrapped(func, acc, left)), $temp$dict = right;
                func = $temp$func;
                acc = $temp$acc;
                dict = $temp$dict;
                continue foldl;
            }
        }
    }, $elm$core$Dict$foldl = F3($elm$core$Dict$foldl_fn);
    var $elm$json$Json$Encode$dict_fn = function (toKey, toValue, dictionary) {
        return _Json_wrap($elm$core$Dict$foldl_fn_unwrapped(function (key, value, obj) {
            return _Json_addField_fn(toKey(key), toValue(value), obj);
        }, _Json_emptyObject(0), dictionary));
    }, $elm$json$Json$Encode$dict = F3($elm$json$Json$Encode$dict_fn);
    var $author$project$Util$Json$encodeDateDict_a0 = $elm$core$Basics$identity, $author$project$Util$Json$encodeDateDict_a1 = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$json$Json$Encode$string), $author$project$Util$Json$encodeDateDict = A2($elm$json$Json$Encode$dict, $author$project$Util$Json$encodeDateDict_a0, $author$project$Util$Json$encodeDateDict_a1);
    var $author$project$Data$Settings$encodeNextMeetingNotifications = function (setting) {
        switch (setting) {
            case 0:
                return $elm$json$Json$Encode$string("notify_within_10m");
            case 1:
                return $elm$json$Json$Encode$string("notify_within_5m");
            default:
                return $elm$json$Json$Encode$string("notify_within_2m");
        }
    };
    var $author$project$Data$Settings$encodeNextMeetingNudgerState = function (nextMeetingNudgerState) {
        switch (nextMeetingNudgerState) {
            case 0:
                return $elm$json$Json$Encode$string("hidden");
            case 1:
                return $elm$json$Json$Encode$string("displayed");
            case 2:
                return $elm$json$Json$Encode$string("minimized");
            default:
                return $elm$json$Json$Encode$string("complete");
        }
    };
    var $author$project$Data$Settings$dayToString = function (day) {
        switch (day) {
            case 6:
                return "sun";
            case 0:
                return "mon";
            case 1:
                return "tue";
            case 2:
                return "wed";
            case 3:
                return "thu";
            case 4:
                return "fri";
            default:
                return "sat";
        }
    };
    var $author$project$Data$Settings$encodeDayList_a0 = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Data$Settings$dayToString), $author$project$Data$Settings$encodeDayList = $elm$json$Json$Encode$list($author$project$Data$Settings$encodeDayList_a0);
    var $author$project$Data$Settings$encodeSnapshotEmailConfig = function (s) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("daysToSend", $elm$json$Json$Encode$list_fn($author$project$Data$Settings$encodeDayList_a0, s.fa)),
            _Utils_Tuple2("hourOfDay", $elm$json$Json$Encode$int(s.fr)),
            _Utils_Tuple2("timezone", $author$project$Util$Json$encodeMaybe_fn($elm$json$Json$Encode$string, s.gi))
        ]));
    };
    var $author$project$Data$Settings$schemaVersion = 20;
    var $author$project$Data$Color$themeToString = function (theme) {
        switch (theme) {
            case 0:
                return "theme_light";
            case 1:
                return "theme_dark";
            case 2:
                return "theme_winter";
            case 3:
                return "theme_amber";
            default:
                return "theme_evening";
        }
    };
    var $author$project$Data$Settings$encode = function (s) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("armyTime", $elm$json$Json$Encode$bool(s.cD)),
            _Utils_Tuple2("showWeekends", $elm$json$Json$Encode$bool(s.di)),
            _Utils_Tuple2("theme", A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Data$Color$themeToString)(s.pn)),
            _Utils_Tuple2("keyboardShortcutsEnabled", $elm$json$Json$Encode$bool(s.cZ)),
            _Utils_Tuple2("updatedAt", $author$project$Data$Timestamp$encode(s.pR)),
            _Utils_Tuple2("analyticsEnabled", $elm$json$Json$Encode$bool(s.cC)),
            _Utils_Tuple2("notificationBatchFirstSeen", $elm$json$Json$Encode$dict_fn($author$project$Util$Json$encodeDateDict_a0, $author$project$Util$Json$encodeDateDict_a1, s.c5)),
            _Utils_Tuple2("reverseNoteColumns", $elm$json$Json$Encode$bool(s.df)),
            _Utils_Tuple2("defaultToAttendeesTab", $elm$json$Json$Encode$bool(s.cP)),
            _Utils_Tuple2("dailyUpdateEmailEnabled", $elm$json$Json$Encode$bool(s.cO)),
            _Utils_Tuple2("dailyUpdateEmailConfig", $author$project$Util$Json$encodeMaybe_fn($author$project$Data$Settings$encodeSnapshotEmailConfig, s.cN)),
            _Utils_Tuple2("nextMeetingNotifications", $author$project$Util$Json$encodeMaybe_fn($author$project$Data$Settings$encodeNextMeetingNotifications, s.c3)),
            _Utils_Tuple2("nextMeetingNudgerState", $author$project$Data$Settings$encodeNextMeetingNudgerState(s.ed)),
            _Utils_Tuple2("ordering", $elm$json$Json$Encode$int(s.fR)),
            _Utils_Tuple2("schemaVersion", $elm$json$Json$Encode$int($author$project$Data$Settings$schemaVersion))
        ]));
    };
    var $author$project$Data$Settings$fixedDocId = "user";
    var $author$project$Firestore$Document$New = 0;
    var $author$project$Firestore$Collection$insertTransient_fn = function (id, doc, _v0) {
        var collection = _v0;
        return $$update__n(collection, $elm$core$Dict$insert_fn(id, _Utils_Tuple2(0, doc), collection.n));
    }, $author$project$Firestore$Collection$insertTransient = F3($author$project$Firestore$Collection$insertTransient_fn);
    var $author$project$Data$Settings$init = function (initialSettings) {
        return $author$project$Firestore$Collection$insertTransient_fn($author$project$Data$Settings$fixedDocId, initialSettings, $author$project$Firestore$Collection$empty_fn($author$project$Data$Settings$encode, $author$project$Data$Settings$decode, $author$project$Data$Settings$comparator));
    };
    var $author$project$Data$StorageUpload$Tracker = $elm$core$Basics$identity;
    var $author$project$Data$StorageUpload$init = $elm$core$Dict$empty;
    var $author$project$Lib$Debouncer$Debouncer_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Lib$Debouncer$Debouncer = F2($author$project$Lib$Debouncer$Debouncer_fn);
    var $author$project$Lib$Debouncer$init = function (config) {
        return $author$project$Lib$Debouncer$Debouncer_fn(config, $elm$core$Dict$empty);
    };
    var $author$project$Lib$Snackbar$init = (new $$Record34(0, $elm$core$Dict$empty));
    var $author$project$Lib$UID$Seed = $elm$core$Basics$identity;
    var $elm$random$Random$Seed_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$random$Random$Seed = F2($elm$random$Random$Seed_fn);
    var $elm$random$Random$next = function (_v0) {
        var state0 = _v0.a;
        var incr = _v0.b;
        return $elm$random$Random$Seed_fn(((state0 * 1664525) + incr) >>> 0, incr);
    };
    var $elm$random$Random$initialSeed = function (x) {
        var _v0 = $elm$random$Random$next($elm$random$Random$Seed_fn(0, 1013904223));
        var state1 = _v0.a;
        var incr = _v0.b;
        var state2 = (state1 + x) >>> 0;
        return $elm$random$Random$next($elm$random$Random$Seed_fn(state2, incr));
    };
    var $author$project$Lib$UID$initSeed_a0 = $elm$core$List$map($elm$random$Random$initialSeed), $author$project$Lib$UID$initSeed_a1 = $elm$core$Basics$identity, $author$project$Lib$UID$initSeed = A2($elm$core$Basics$composeR, $author$project$Lib$UID$initSeed_a0, $author$project$Lib$UID$initSeed_a1);
    var $author$project$Util$Misc$initViewport = (new $$Record10((new $$Record35(0, 0)), (new $$Record36(0, 0, 0, 0))));
    var $mdgriffith$elm_ui$Internal$Model$Rgba_fn = function (a, b, c, d) {
        return { $: 0, a: a, b: b, c: c, d: d };
    }, $mdgriffith$elm_ui$Internal$Model$Rgba = F4($mdgriffith$elm_ui$Internal$Model$Rgba_fn);
    var $mdgriffith$elm_ui$Element$rgb255_fn = function (red, green, blue) {
        return $mdgriffith$elm_ui$Internal$Model$Rgba_fn(red / 255, green / 255, blue / 255, 1);
    }, $mdgriffith$elm_ui$Element$rgb255 = F3($mdgriffith$elm_ui$Element$rgb255_fn);
    var $mdgriffith$elm_ui$Element$rgba255_fn = function (red, green, blue, a) {
        return $mdgriffith$elm_ui$Internal$Model$Rgba_fn(red / 255, green / 255, blue / 255, a);
    }, $mdgriffith$elm_ui$Element$rgba255 = F4($mdgriffith$elm_ui$Element$rgba255_fn);
    var $author$project$Data$Color$lightPalette = (new $$Record37($mdgriffith$elm_ui$Element$rgb255_fn(0, 0, 0), $mdgriffith$elm_ui$Element$rgb255_fn(235, 243, 255), $mdgriffith$elm_ui$Element$rgb255_fn(200, 222, 255), $mdgriffith$elm_ui$Element$rgb255_fn(56, 105, 176), $mdgriffith$elm_ui$Element$rgb255_fn(46, 87, 148), $mdgriffith$elm_ui$Element$rgb255_fn(36, 68, 116), $mdgriffith$elm_ui$Element$rgb255_fn(0, 210, 255), $mdgriffith$elm_ui$Element$rgb255_fn(252, 252, 252), $mdgriffith$elm_ui$Element$rgb255_fn(244, 243, 246), $mdgriffith$elm_ui$Element$rgb255_fn(27, 9, 55), $mdgriffith$elm_ui$Element$rgb255_fn(242, 242, 242), $mdgriffith$elm_ui$Element$rgb255_fn(236, 236, 236), $mdgriffith$elm_ui$Element$rgb255_fn(181, 174, 191), $mdgriffith$elm_ui$Element$rgb255_fn(204, 199, 211), $mdgriffith$elm_ui$Element$rgb255_fn(162, 155, 172), $mdgriffith$elm_ui$Element$rgb255_fn(107, 97, 121), $mdgriffith$elm_ui$Element$rgb255_fn(90, 90, 90), $mdgriffith$elm_ui$Element$rgb255_fn(68, 59, 83), $mdgriffith$elm_ui$Element$rgb255_fn(219, 251, 229), $mdgriffith$elm_ui$Element$rgb255_fn(129, 228, 163), $mdgriffith$elm_ui$Element$rgb255_fn(34, 221, 170), $mdgriffith$elm_ui$Element$rgb255_fn(81, 202, 88), $mdgriffith$elm_ui$Element$rgb255_fn(60, 135, 99), $mdgriffith$elm_ui$Element$rgb255_fn(222, 137, 105), $mdgriffith$elm_ui$Element$rgb255_fn(241, 237, 255), $mdgriffith$elm_ui$Element$rgb255_fn(232, 229, 255), $mdgriffith$elm_ui$Element$rgb255_fn(96, 0, 237), $mdgriffith$elm_ui$Element$rgb255_fn(210, 201, 243), $mdgriffith$elm_ui$Element$rgb255_fn(198, 184, 255), $mdgriffith$elm_ui$Element$rgb255_fn(175, 132, 250), $mdgriffith$elm_ui$Element$rgb255_fn(144, 100, 246), $mdgriffith$elm_ui$Element$rgb255_fn(122, 47, 237), $mdgriffith$elm_ui$Element$rgb255_fn(106, 19, 228), $mdgriffith$elm_ui$Element$rgb255_fn(109, 57, 231), $mdgriffith$elm_ui$Element$rgb255_fn(97, 0, 199), $mdgriffith$elm_ui$Element$rgb255_fn(255, 242, 242), $mdgriffith$elm_ui$Element$rgb255_fn(251, 174, 176), $mdgriffith$elm_ui$Element$rgb255_fn(247, 185, 186), $mdgriffith$elm_ui$Element$rgb255_fn(235, 94, 40), $mdgriffith$elm_ui$Element$rgb255_fn(219, 55, 55), $mdgriffith$elm_ui$Element$rgb255_fn(189, 0, 33), 0, $mdgriffith$elm_ui$Element$rgb255_fn(255, 255, 255), A3($mdgriffith$elm_ui$Element$rgba255, 72, 61, 5), A3($mdgriffith$elm_ui$Element$rgba255, 255, 249, 218), A3($mdgriffith$elm_ui$Element$rgba255, 255, 204, 103)));
    var $avh4$elm_color$Color$RgbaSpace_fn = function (a, b, c, d) {
        return { $: 0, a: a, b: b, c: c, d: d };
    }, $avh4$elm_color$Color$RgbaSpace = F4($avh4$elm_color$Color$RgbaSpace_fn);
    var $avh4$elm_color$Color$hsla_fn = function (hue, sat, light, alpha) {
        var _v0 = _Utils_Tuple3(hue, sat, light);
        var h = _v0.a;
        var s = _v0.b;
        var l = _v0.c;
        var m2 = (l <= 0.5) ? (l * (s + 1)) : ((l + s) - (l * s));
        var m1 = (l * 2) - m2;
        var hueToRgb = function (h__) {
            var h_ = (h__ < 0) ? (h__ + 1) : ((h__ > 1) ? (h__ - 1) : h__);
            return ((h_ * 6) < 1) ? (m1 + (((m2 - m1) * h_) * 6)) : (((h_ * 2) < 1) ? m2 : (((h_ * 3) < 2) ? (m1 + (((m2 - m1) * ((2 / 3) - h_)) * 6)) : m1));
        };
        var b = hueToRgb(h - (1 / 3));
        var g = hueToRgb(h);
        var r = hueToRgb(h + (1 / 3));
        return $avh4$elm_color$Color$RgbaSpace_fn(r, g, b, alpha);
    }, $avh4$elm_color$Color$hsla = F4($avh4$elm_color$Color$hsla_fn);
    var $avh4$elm_color$Color$fromHsla = function (_v0) {
        var hue = _v0.hN;
        var saturation = _v0.i2;
        var lightness = _v0.h0;
        var alpha = _v0.bU;
        return $avh4$elm_color$Color$hsla_fn(hue, saturation, lightness, alpha);
    };
    var $mdgriffith$elm_ui$Element$fromRgb = function (clr) {
        return $mdgriffith$elm_ui$Internal$Model$Rgba_fn(clr.iU, clr.hE, clr.gR, clr.bU);
    };
    var $avh4$elm_color$Color$toRgba = function (_v0) {
        var r = _v0.a;
        var g = _v0.b;
        var b = _v0.c;
        var a = _v0.d;
        return { bU: a, gR: b, hE: g, iU: r };
    };
    var $author$project$Util$Color$fromHsla_a0 = $avh4$elm_color$Color$fromHsla, $author$project$Util$Color$fromHsla_a1 = A2($elm$core$Basics$composeR, $avh4$elm_color$Color$toRgba, $mdgriffith$elm_ui$Element$fromRgb), $author$project$Util$Color$fromHsla = A2($elm$core$Basics$composeR, $author$project$Util$Color$fromHsla_a0, $author$project$Util$Color$fromHsla_a1);
    var $avh4$elm_color$Color$fromRgba = function (components) {
        return $avh4$elm_color$Color$RgbaSpace_fn(components.iU, components.hE, components.gR, components.bU);
    };
    var $elm$core$Basics$isNaN = _Basics_isNaN;
    var $avh4$elm_color$Color$toHsla = function (_v0) {
        var r = _v0.a;
        var g = _v0.b;
        var b = _v0.c;
        var a = _v0.d;
        var minColor = $elm$core$Basics$min_fn(r, $elm$core$Basics$min_fn(g, b));
        var maxColor = $elm$core$Basics$max_fn(r, $elm$core$Basics$max_fn(g, b));
        var l = (minColor + maxColor) / 2;
        var s = _Utils_eq(minColor, maxColor) ? 0 : ((l < 0.5) ? ((maxColor - minColor) / (maxColor + minColor)) : ((maxColor - minColor) / ((2 - maxColor) - minColor)));
        var h1 = _Utils_eq(maxColor, r) ? ((g - b) / (maxColor - minColor)) : (_Utils_eq(maxColor, g) ? (2 + ((b - r) / (maxColor - minColor))) : (4 + ((r - g) / (maxColor - minColor))));
        var h2 = h1 * (1 / 6);
        var h3 = $elm$core$Basics$isNaN(h2) ? 0 : ((h2 < 0) ? (h2 + 1) : h2);
        return (new $$Record38(a, h3, l, s));
    };
    var $mdgriffith$elm_ui$Element$toRgb = function (_v0) {
        var r = _v0.a;
        var g = _v0.b;
        var b = _v0.c;
        var a = _v0.d;
        return { bU: a, gR: b, hE: g, iU: r };
    };
    var $author$project$Util$Color$toHsla_a0 = $mdgriffith$elm_ui$Element$toRgb, $author$project$Util$Color$toHsla_a1 = A2($elm$core$Basics$composeR, $avh4$elm_color$Color$fromRgba, $avh4$elm_color$Color$toHsla), $author$project$Util$Color$toHsla = A2($elm$core$Basics$composeR, $author$project$Util$Color$toHsla_a0, $author$project$Util$Color$toHsla_a1);
    var $author$project$Util$Color$lighten_fn = function (amount, start) {
        var startHsla = $elm$core$Basics$composeR_fn($author$project$Util$Color$toHsla_a0, $author$project$Util$Color$toHsla_a1, start);
        return $elm$core$Basics$composeR_fn($author$project$Util$Color$fromHsla_a0, $author$project$Util$Color$fromHsla_a1, function () {
            var $r = startHsla.$c();
            $r.h0 = startHsla.h0 + amount;
            return $r;
        }());
    }, $author$project$Util$Color$lighten = F2($author$project$Util$Color$lighten_fn);
    var $author$project$Util$Color$saturate_fn = function (amount, start) {
        var startHsla = $elm$core$Basics$composeR_fn($author$project$Util$Color$toHsla_a0, $author$project$Util$Color$toHsla_a1, start);
        return $elm$core$Basics$composeR_fn($author$project$Util$Color$fromHsla_a0, $author$project$Util$Color$fromHsla_a1, function () {
            var $r = startHsla.$c();
            $r.i2 = startHsla.i2 + amount;
            return $r;
        }());
    }, $author$project$Util$Color$saturate = F2($author$project$Util$Color$saturate_fn);
    var $author$project$Data$Color$amberPalette = function () {
        var baseGray = $mdgriffith$elm_ui$Element$rgb255_fn(249, 247, 242);
        var baseColor = $mdgriffith$elm_ui$Element$rgb255_fn(221, 169, 26);
        return $$update__a0__a1__a2__a3__a4__a5__a6__a7__a8__a9__aL__aM__aN__aO__aP__aQ__aR__aS__aT__aU__ba__pn($author$project$Data$Color$lightPalette, $author$project$Util$Color$saturate_fn(-0.2, $author$project$Util$Color$lighten_fn(0.4, baseColor)), $author$project$Util$Color$saturate_fn(-0.05, $author$project$Util$Color$lighten_fn(0.38, baseColor)), $author$project$Util$Color$lighten_fn(-0.16, baseColor), $author$project$Util$Color$saturate_fn(-0.2, $author$project$Util$Color$lighten_fn(0.4, baseColor)), $author$project$Util$Color$saturate_fn(-0.2, $author$project$Util$Color$lighten_fn(0.3, baseColor)), $author$project$Util$Color$saturate_fn(-0.2, $author$project$Util$Color$lighten_fn(0.2, baseColor)), $author$project$Util$Color$saturate_fn(-0.2, $author$project$Util$Color$lighten_fn(0.1, baseColor)), $author$project$Util$Color$saturate_fn(-0.2, baseColor), baseColor, $author$project$Util$Color$lighten_fn(-0.07, baseColor), $author$project$Util$Color$lighten_fn(0.025, baseGray), $author$project$Util$Color$lighten_fn(0.02, baseGray), $author$project$Util$Color$lighten_fn(0.015, baseGray), $author$project$Util$Color$saturate_fn(-0.1, $author$project$Util$Color$lighten_fn(-0.04, baseGray)), $author$project$Util$Color$saturate_fn(-0.3, $author$project$Util$Color$lighten_fn(-0.1, baseGray)), $author$project$Util$Color$saturate_fn(-0.5, $author$project$Util$Color$lighten_fn(-0.2, baseGray)), $author$project$Util$Color$saturate_fn(-0.7, $author$project$Util$Color$lighten_fn(-0.3, baseGray)), $author$project$Util$Color$saturate_fn(-0.8, $author$project$Util$Color$lighten_fn(-0.5, baseGray)), $author$project$Util$Color$saturate_fn(-0.9, $author$project$Util$Color$lighten_fn(-0.7, baseGray)), $author$project$Util$Color$saturate_fn(-1, $author$project$Util$Color$lighten_fn(-0.8, baseGray)), $author$project$Util$Color$lighten_fn(-0.11, baseColor), 3);
    }();
    var $author$project$Data$Color$darkPalette = (new $$Record37($mdgriffith$elm_ui$Element$rgb255_fn(255, 255, 255), $mdgriffith$elm_ui$Element$rgb255_fn(46, 87, 148), $mdgriffith$elm_ui$Element$rgb255_fn(56, 105, 176), $mdgriffith$elm_ui$Element$rgb255_fn(200, 222, 255), $mdgriffith$elm_ui$Element$rgb255_fn(235, 243, 255), $mdgriffith$elm_ui$Element$rgb255_fn(235, 243, 255), $mdgriffith$elm_ui$Element$rgb255_fn(0, 149, 182), $mdgriffith$elm_ui$Element$rgb255_fn(30, 30, 30), $mdgriffith$elm_ui$Element$rgb255_fn(9, 9, 9), $mdgriffith$elm_ui$Element$rgb255_fn(252, 252, 252), $mdgriffith$elm_ui$Element$rgb255_fn(60, 60, 60), $mdgriffith$elm_ui$Element$rgb255_fn(30, 30, 30), $mdgriffith$elm_ui$Element$rgb255_fn(40, 40, 40), $mdgriffith$elm_ui$Element$rgb255_fn(110, 110, 110), $mdgriffith$elm_ui$Element$rgb255_fn(130, 130, 130), $mdgriffith$elm_ui$Element$rgb255_fn(178, 178, 178), $mdgriffith$elm_ui$Element$rgb255_fn(212, 212, 212), $mdgriffith$elm_ui$Element$rgb255_fn(235, 235, 235), $mdgriffith$elm_ui$Element$rgb255_fn(219, 251, 229), $mdgriffith$elm_ui$Element$rgb255_fn(129, 228, 163), $mdgriffith$elm_ui$Element$rgb255_fn(72, 241, 173), $mdgriffith$elm_ui$Element$rgb255_fn(81, 202, 88), $mdgriffith$elm_ui$Element$rgb255_fn(60, 135, 99), $mdgriffith$elm_ui$Element$rgb255_fn(255, 149, 71), $mdgriffith$elm_ui$Element$rgb255_fn(35, 35, 56), $mdgriffith$elm_ui$Element$rgb255_fn(37, 37, 84), $mdgriffith$elm_ui$Element$rgb255_fn(209, 184, 253), $mdgriffith$elm_ui$Element$rgb255_fn(97, 0, 199), $mdgriffith$elm_ui$Element$rgb255_fn(106, 19, 228), $mdgriffith$elm_ui$Element$rgb255_fn(106, 19, 228), $mdgriffith$elm_ui$Element$rgb255_fn(145, 85, 245), $mdgriffith$elm_ui$Element$rgb255_fn(190, 158, 255), $mdgriffith$elm_ui$Element$rgb255_fn(190, 158, 255), $mdgriffith$elm_ui$Element$rgb255_fn(190, 158, 255), $mdgriffith$elm_ui$Element$rgb255_fn(190, 158, 255), $mdgriffith$elm_ui$Element$rgb255_fn(255, 242, 242), $mdgriffith$elm_ui$Element$rgb255_fn(251, 174, 176), $mdgriffith$elm_ui$Element$rgb255_fn(247, 185, 186), $mdgriffith$elm_ui$Element$rgb255_fn(235, 94, 40), $mdgriffith$elm_ui$Element$rgb255_fn(219, 55, 55), $mdgriffith$elm_ui$Element$rgb255_fn(189, 0, 33), 1, $mdgriffith$elm_ui$Element$rgb255_fn(20, 20, 30), A3($mdgriffith$elm_ui$Element$rgba255, 10, 10, 20), A3($mdgriffith$elm_ui$Element$rgba255, 200, 200, 255), A3($mdgriffith$elm_ui$Element$rgba255, 150, 150, 255)));
    var $author$project$Data$Color$eveningPalette = function () {
        var baseGray = $mdgriffith$elm_ui$Element$rgb255_fn(92, 89, 107);
        var baseColor = $mdgriffith$elm_ui$Element$rgb255_fn(137, 129, 155);
        return function () {
            var $r = $author$project$Data$Color$darkPalette.$c();
            $r.a0 = $author$project$Util$Color$lighten_fn(-0.05, baseColor);
            $r.a1 = $author$project$Util$Color$lighten_fn(-0.1, baseColor);
            $r.a2 = $author$project$Util$Color$lighten_fn(0.4, baseColor);
            $r.a3 = $author$project$Util$Color$saturate_fn(0.15, $author$project$Util$Color$lighten_fn(-0.16, baseColor));
            $r.a4 = $author$project$Util$Color$saturate_fn(0.13, $author$project$Util$Color$lighten_fn(-0.11, baseColor));
            $r.a5 = $author$project$Util$Color$saturate_fn(0.1, $author$project$Util$Color$lighten_fn(-0.07, baseColor));
            $r.a6 = baseColor;
            $r.a7 = $author$project$Util$Color$lighten_fn(0.15, baseColor);
            $r.a8 = $author$project$Util$Color$lighten_fn(0.2, baseColor);
            $r.a9 = $author$project$Util$Color$lighten_fn(0.3, baseColor);
            $r.aL = $author$project$Util$Color$lighten_fn(-0.25, baseGray);
            $r.aM = $author$project$Util$Color$lighten_fn(-0.2, baseGray);
            $r.aN = $author$project$Util$Color$lighten_fn(-0.15, baseGray);
            $r.aO = $author$project$Util$Color$lighten_fn(0.05, baseGray);
            $r.aP = $author$project$Util$Color$lighten_fn(0.2, baseGray);
            $r.aQ = $author$project$Util$Color$lighten_fn(0.3, baseGray);
            $r.aR = $author$project$Util$Color$lighten_fn(0.35, baseGray);
            $r.aS = $author$project$Util$Color$lighten_fn(0.41, baseGray);
            $r.aT = $author$project$Util$Color$lighten_fn(0.46, baseGray);
            $r.aU = $author$project$Util$Color$lighten_fn(0.52, baseGray);
            $r.ba = $author$project$Util$Color$lighten_fn(0.34, baseColor);
            $r.cI = $mdgriffith$elm_ui$Element$rgb255_fn(190, 190, 190);
            $r.cd = $author$project$Util$Color$lighten_fn(0.55, baseGray);
            $r.dw = $author$project$Util$Color$lighten_fn(-0.3, baseColor);
            $r.pn = 4;
            return $r;
        }();
    }();
    var $author$project$Data$Color$winterPalette = function () {
        var baseGray = $mdgriffith$elm_ui$Element$rgb255_fn(240, 242, 254);
        var baseColor = $mdgriffith$elm_ui$Element$rgb255_fn(91, 47, 237);
        return $$update__a0__a1__a2__a3__a4__a5__a6__a7__a8__a9__aL__aM__aN__aO__aP__aQ__aR__aS__aT__aU__ba__pn($author$project$Data$Color$lightPalette, $author$project$Util$Color$saturate_fn(-0.2, $author$project$Util$Color$lighten_fn(0.4, baseColor)), $author$project$Util$Color$saturate_fn(-0.2, $author$project$Util$Color$lighten_fn(0.38, baseColor)), $author$project$Util$Color$lighten_fn(-0.16, baseColor), $author$project$Util$Color$saturate_fn(-0.2, $author$project$Util$Color$lighten_fn(0.4, baseColor)), $author$project$Util$Color$saturate_fn(-0.2, $author$project$Util$Color$lighten_fn(0.3, baseColor)), $author$project$Util$Color$saturate_fn(-0.2, $author$project$Util$Color$lighten_fn(0.2, baseColor)), $author$project$Util$Color$saturate_fn(-0.2, $author$project$Util$Color$lighten_fn(0.1, baseColor)), $author$project$Util$Color$saturate_fn(-0.2, baseColor), baseColor, $author$project$Util$Color$lighten_fn(-0.07, baseColor), $author$project$Util$Color$lighten_fn(0.025, baseGray), $mdgriffith$elm_ui$Element$rgb255_fn(246, 246, 248), $author$project$Util$Color$lighten_fn(0.015, baseGray), $author$project$Util$Color$saturate_fn(-0.1, $author$project$Util$Color$lighten_fn(-0.04, baseGray)), $author$project$Util$Color$saturate_fn(-0.3, $author$project$Util$Color$lighten_fn(-0.1, baseGray)), $author$project$Util$Color$saturate_fn(-0.5, $author$project$Util$Color$lighten_fn(-0.2, baseGray)), $author$project$Util$Color$saturate_fn(-0.7, $author$project$Util$Color$lighten_fn(-0.3, baseGray)), $author$project$Util$Color$saturate_fn(-0.8, $author$project$Util$Color$lighten_fn(-0.5, baseGray)), $author$project$Util$Color$saturate_fn(-0.9, $author$project$Util$Color$lighten_fn(-0.7, baseGray)), $author$project$Util$Color$saturate_fn(-1, $author$project$Util$Color$lighten_fn(-0.8, baseGray)), $author$project$Util$Color$lighten_fn(-0.11, baseColor), 2);
    }();
    var $author$project$Data$Color$paletteForTheme = function (theme) {
        switch (theme) {
            case 0:
                return $author$project$Data$Color$lightPalette;
            case 1:
                return $author$project$Data$Color$darkPalette;
            case 2:
                return $author$project$Data$Color$winterPalette;
            case 3:
                return $author$project$Data$Color$amberPalette;
            default:
                return $author$project$Data$Color$eveningPalette;
        }
    };
    var $author$project$Routing$RouteNotFound = { $: 19 };
    var $author$project$Routing$CollateByDomain = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Routing$CollateSeries = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Routing$CollateWithPerson = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Routing$RouteAuth = function (a) {
        return { $: 17, a: a };
    };
    var $author$project$Routing$RouteBilling = { $: 15 };
    var $author$project$Routing$RouteCalendar = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Routing$RouteCollate_fn = function (a, b) {
        return { $: 16, a: a, b: b };
    }, $author$project$Routing$RouteCollate = F2($author$project$Routing$RouteCollate_fn);
    var $author$project$Routing$RouteCreateAdHocNote = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Routing$RouteCreateEventNote_fn = function (a, b, c) {
        return { $: 2, a: a, b: b, c: c };
    }, $author$project$Routing$RouteCreateEventNote = F3($author$project$Routing$RouteCreateEventNote_fn);
    var $author$project$Routing$RouteDemo = { $: 18 };
    var $author$project$Routing$RouteNewAdHocNote_fn = function (a, b, c) {
        return { $: 5, a: a, b: b, c: c };
    }, $author$project$Routing$RouteNewAdHocNote = F3($author$project$Routing$RouteNewAdHocNote_fn);
    var $author$project$Routing$RouteNewEventNote_fn = function (a, b, c) {
        return { $: 3, a: a, b: b, c: c };
    }, $author$project$Routing$RouteNewEventNote = F3($author$project$Routing$RouteNewEventNote_fn);
    var $author$project$Routing$RouteNote_fn = function (a, b, c) {
        return { $: 6, a: a, b: b, c: c };
    }, $author$project$Routing$RouteNote = F3($author$project$Routing$RouteNote_fn);
    var $author$project$Routing$RoutePerson = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Routing$RouteSearch_fn = function (a, b) {
        return { $: 12, a: a, b: b };
    }, $author$project$Routing$RouteSearch = F2($author$project$Routing$RouteSearch_fn);
    var $author$project$Routing$RouteSettings = { $: 11 };
    var $author$project$Routing$RouteSignup = function (a) {
        return { $: 13, a: a };
    };
    var $author$project$Routing$RouteStripeReturn = function (a) {
        return { $: 14, a: a };
    };
    var $author$project$Routing$RouteThreads = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Util$Time$isLeapYear = function (y) {
        return ((!_Basics_modBy_fn(4, y)) && (!(!_Basics_modBy_fn(100, y)))) || (!_Basics_modBy_fn(400, y));
    };
    var $author$project$Util$Time$daysInMonth_fn = function (y, m) {
        switch (m) {
            case 0:
                return 31;
            case 1:
                return $author$project$Util$Time$isLeapYear(y) ? 29 : 28;
            case 2:
                return 31;
            case 3:
                return 30;
            case 4:
                return 31;
            case 5:
                return 30;
            case 6:
                return 31;
            case 7:
                return 31;
            case 8:
                return 30;
            case 9:
                return 31;
            case 10:
                return 30;
            default:
                return 31;
        }
    }, $author$project$Util$Time$daysInMonth = F2($author$project$Util$Time$daysInMonth_fn);
    var $author$project$Util$Time$dateFromYMD_fn = function (year, month, day_) {
        if ((month < 1) || (month > 12)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var monthEnum = $justinmimbs$date$Date$numberToMonth(month);
            var maximumDays = $author$project$Util$Time$daysInMonth_fn(year, monthEnum);
            return ((day_ < 1) || (_Utils_cmp(day_, maximumDays) > 0)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($justinmimbs$date$Date$fromCalendarDate_fn(year, monthEnum, day_));
        }
    }, $author$project$Util$Time$dateFromYMD = F3($author$project$Util$Time$dateFromYMD_fn);
    var $author$project$Routing$RouteCreatePerson = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Routing$handleCreatePersonRoute = function (mNewPerson) {
        if (!mNewPerson.$) {
            var newPerson = mNewPerson.a;
            return $author$project$Routing$RouteCreatePerson(newPerson);
        }
        else {
            return $author$project$Routing$RouteNotFound;
        }
    };
    var $author$project$Util$NextMeeting$NextInSeries = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Util$NextMeeting$NextMeeting = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Util$NextMeeting$NextOneOnOne = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Routing$RouteNextMeeting = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Routing$handleNextMeetingRoute_fn = function (mPersonId, mMasterId, meetingType) {
        return $author$project$Routing$RouteNextMeeting(function () {
            var _v0 = _Utils_Tuple3(mMasterId, mPersonId, meetingType);
            if (!_v0.a.$) {
                var masterId = _v0.a.a;
                return $author$project$Util$NextMeeting$NextInSeries(masterId);
            }
            else {
                if (_v0.b.$ === 1) {
                    var _v3 = _v0.a;
                    var _v4 = _v0.b;
                    return $author$project$Util$NextMeeting$NextMeeting($elm$core$Maybe$Nothing);
                }
                else {
                    if (!_v0.c.$) {
                        var _v1 = _v0.a;
                        var personId = _v0.b.a;
                        var _v2 = _v0.c.a;
                        return $author$project$Util$NextMeeting$NextOneOnOne(personId);
                    }
                    else {
                        var _v5 = _v0.a;
                        var personId = _v0.b.a;
                        return $author$project$Util$NextMeeting$NextMeeting($elm$core$Maybe$Just(personId));
                    }
                }
            }
        }());
    }, $author$project$Routing$handleNextMeetingRoute = F3($author$project$Routing$handleNextMeetingRoute_fn);
    var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
    var $elm$url$Url$Parser$State_fn = function (visited, unvisited, params, frag, value) {
        return { bt: frag, bB: params, bg: unvisited, p_: value, bM: visited };
    }, $elm$url$Url$Parser$State = F5($elm$url$Url$Parser$State_fn);
    var $elm$url$Url$Parser$custom_fn = function (tipe, stringToSomething) {
        return function (_v0) {
            var visited = _v0.bM;
            var unvisited = _v0.bg;
            var params = _v0.bB;
            var frag = _v0.bt;
            var value = _v0.p_;
            if (!unvisited.b) {
                return _List_Nil;
            }
            else {
                var next = unvisited.a;
                var rest = unvisited.b;
                var _v2 = stringToSomething(next);
                if (!_v2.$) {
                    var nextValue = _v2.a;
                    return _List_fromArray([
                        $elm$url$Url$Parser$State_fn(_List_Cons(next, visited), rest, params, frag, value(nextValue))
                    ]);
                }
                else {
                    return _List_Nil;
                }
            }
        };
    }, $elm$url$Url$Parser$custom = F2($elm$url$Url$Parser$custom_fn);
    var $elm$url$Url$Parser$int = $elm$url$Url$Parser$custom_fn("NUMBER", $elm$core$String$toInt);
    var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
    var $elm$url$Url$Parser$Query$custom_fn = function (key, func) {
        return function (dict) {
            return func($elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Dict$get_fn(key, dict)));
        };
    }, $elm$url$Url$Parser$Query$custom = F2($elm$url$Url$Parser$Query$custom_fn);
    var $elm$url$Url$Parser$Query$int = function (key) {
        return $elm$url$Url$Parser$Query$custom_fn(key, function (stringList) {
            if (stringList.b && (!stringList.b.b)) {
                var str = stringList.a;
                return $elm$core$String$toInt(str);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        });
    };
    var $elm$url$Url$Parser$mapState_fn = function (func, _v0) {
        var visited = _v0.bM;
        var unvisited = _v0.bg;
        var params = _v0.bB;
        var frag = _v0.bt;
        var value = _v0.p_;
        return $elm$url$Url$Parser$State_fn(visited, unvisited, params, frag, func(value));
    }, $elm$url$Url$Parser$mapState = F2($elm$url$Url$Parser$mapState_fn);
    var $elm$url$Url$Parser$map_fn = function (subValue, _v0) {
        var parseArg = _v0;
        return function (_v1) {
            var visited = _v1.bM;
            var unvisited = _v1.bg;
            var params = _v1.bB;
            var frag = _v1.bt;
            var value = _v1.p_;
            return $elm$core$List$map_fn($elm$url$Url$Parser$mapState(value), parseArg($elm$url$Url$Parser$State_fn(visited, unvisited, params, frag, subValue)));
        };
    }, $elm$url$Url$Parser$map = F2($elm$url$Url$Parser$map_fn);
    var $elm$url$Url$Parser$Query$map3_fn = function (func, _v0, _v1, _v2) {
        var a = _v0;
        var b = _v1;
        var c = _v2;
        return function (dict) {
            return A3(func, a(dict), b(dict), c(dict));
        };
    }, $elm$url$Url$Parser$Query$map3_fn_unwrapped = function (func, _v0, _v1, _v2) {
        var a = _v0;
        var b = _v1;
        var c = _v2;
        return function (dict) {
            return func(a(dict), b(dict), c(dict));
        };
    }, $elm$url$Url$Parser$Query$map3 = F4($elm$url$Url$Parser$Query$map3_fn);
    var $elm$url$Url$Parser$Query$string = function (key) {
        return $elm$url$Url$Parser$Query$custom_fn(key, function (stringList) {
            if (stringList.b && (!stringList.b.b)) {
                var str = stringList.a;
                return $elm$core$Maybe$Just(str);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        });
    };
    var $author$project$Routing$newPersonQuery = $elm$url$Url$Parser$Query$map3_fn_unwrapped(function (mName, mEmail, mCreatedBy) {
        var _v0 = _Utils_Tuple2(mName, mCreatedBy);
        if ((!_v0.a.$) && (!_v0.b.$)) {
            var name = _v0.a.a;
            var createdBy = _v0.b.a;
            return $elm$core$Maybe$Just((new $$Record39($author$project$Data$Person$createdByFromString(createdBy), mEmail, name)));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $elm$url$Url$Parser$Query$string("name"), $elm$url$Url$Parser$Query$string("email"), $elm$url$Url$Parser$Query$string("createdBy"));
    var $elm$url$Url$Parser$oneOf = function (parsers) {
        return function (state) {
            return $elm$core$List$concatMap_fn(function (_v0) {
                var parser = _v0;
                return parser(state);
            }, parsers);
        };
    };
    var $author$project$Routing$OneOnOne = 0;
    var $elm$url$Url$Parser$Query$enum_fn = function (key, dict) {
        return $elm$url$Url$Parser$Query$custom_fn(key, function (stringList) {
            if (stringList.b && (!stringList.b.b)) {
                var str = stringList.a;
                return $elm$core$Dict$get_fn(str, dict);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        });
    }, $elm$url$Url$Parser$Query$enum = F2($elm$url$Url$Parser$Query$enum_fn);
    var $author$project$Routing$parseMeetingType = function (paramName) {
        return $elm$url$Url$Parser$Query$enum_fn(paramName, $elm$core$Dict$fromList(_List_fromArray([
            _Utils_Tuple2("oneOnOne", 0)
        ])));
    };
    var $author$project$Routing$TabActionItems = 0;
    var $author$project$Routing$TabAttachments = 2;
    var $author$project$Routing$TabAttendees = 1;
    var $author$project$Routing$TabSeries = 3;
    var $elm$core$Maybe$andThen_fn = function (callback, maybeValue) {
        if (!maybeValue.$) {
            var value = maybeValue.a;
            return callback(value);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $elm$core$Maybe$andThen = F2($elm$core$Maybe$andThen_fn);
    var $elm$url$Url$Parser$Query$map_fn = function (func, _v0) {
        var a = _v0;
        return function (dict) {
            return func(a(dict));
        };
    }, $elm$url$Url$Parser$Query$map = F2($elm$url$Url$Parser$Query$map_fn);
    var $author$project$Routing$parseNoteTab = $elm$url$Url$Parser$Query$map_fn($elm$core$Maybe$andThen(function (s) {
        switch (s) {
            case "w":
                return $elm$core$Maybe$Just(0);
            case "p":
                return $elm$core$Maybe$Just(1);
            case "a":
                return $elm$core$Maybe$Just(2);
            case "s":
                return $elm$core$Maybe$Just(3);
            default:
                return $elm$core$Maybe$Nothing;
        }
    }), $elm$url$Url$Parser$Query$string("tab"));
    var $author$project$Routing$posix = $elm$url$Url$Parser$map_fn($elm$time$Time$millisToPosix, $elm$url$Url$Parser$int);
    var $author$project$Routing$posixQuery_a0 = $elm$url$Url$Parser$Query$int, $author$project$Routing$posixQuery_a1 = $elm$url$Url$Parser$Query$map($elm$core$Maybe$map($elm$time$Time$millisToPosix)), $author$project$Routing$posixQuery = A2($elm$core$Basics$composeR, $author$project$Routing$posixQuery_a0, $author$project$Routing$posixQuery_a1);
    var $author$project$Routing$queryBool = function (name) {
        return $elm$url$Url$Parser$Query$map_fn($elm$core$Maybe$withDefault(false), $elm$url$Url$Parser$Query$enum_fn(name, $elm$core$Dict$fromList(_List_fromArray([
            _Utils_Tuple2("true", true),
            _Utils_Tuple2("false", false)
        ]))));
    };
    var $author$project$Data$Auth$CanceledByUser = { $: 0 };
    var $author$project$Data$Auth$JwtError = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Data$Auth$MissingCodeParam = { $: 1 };
    var $author$project$Data$Auth$MissingIdTokenParam = { $: 2 };
    var $author$project$Data$Auth$MissingScopeParam = { $: 3 };
    var $author$project$Data$Auth$UntrackedGoogleError = function (a) {
        return { $: 5, a: a };
    };
    var $simonh1000$elm_jwt$Jwt$TokenDecodeError = function (a) {
        return { $: 1, a: a };
    };
    var $elm$core$Result$andThen_fn = function (callback, result) {
        if (!result.$) {
            var value = result.a;
            return callback(value);
        }
        else {
            var msg = result.a;
            return $elm$core$Result$Err(msg);
        }
    }, $elm$core$Result$andThen = F2($elm$core$Result$andThen_fn);
    var $elm$json$Json$Decode$decodeString = _Json_runOnString;
    var $simonh1000$elm_jwt$Jwt$TokenHeaderError = { $: 2 };
    var $simonh1000$elm_jwt$Jwt$TokenProcessingError = function (a) {
        return { $: 0, a: a };
    };
    var $elm$core$String$concat = function (strings) {
        return $elm$core$String$join_fn("", strings);
    };
    var $simonh1000$elm_jwt$Jwt$fixlength = function (s) {
        var _v0 = _Basics_modBy_fn(4, $elm$core$String$length(s));
        switch (_v0) {
            case 0:
                return $elm$core$Result$Ok(s);
            case 2:
                return $elm$core$Result$Ok($elm$core$String$concat(_List_fromArray([s, "=="])));
            case 3:
                return $elm$core$Result$Ok($elm$core$String$concat(_List_fromArray([s, "="])));
            default:
                return $elm$core$Result$Err($simonh1000$elm_jwt$Jwt$TokenProcessingError("Wrong length"));
        }
    };
    var $elm$core$Result$fromMaybe_fn = function (err, maybe) {
        if (!maybe.$) {
            var v = maybe.a;
            return $elm$core$Result$Ok(v);
        }
        else {
            return $elm$core$Result$Err(err);
        }
    }, $elm$core$Result$fromMaybe = F2($elm$core$Result$fromMaybe_fn);
    var $elm$core$Result$map_fn = function (func, ra) {
        if (!ra.$) {
            var a = ra.a;
            return $elm$core$Result$Ok(func(a));
        }
        else {
            var e = ra.a;
            return $elm$core$Result$Err(e);
        }
    }, $elm$core$Result$map = F2($elm$core$Result$map_fn);
    var $elm$core$Result$map2_fn = function (func, ra, rb) {
        if (ra.$ === 1) {
            var x = ra.a;
            return $elm$core$Result$Err(x);
        }
        else {
            var a = ra.a;
            if (rb.$ === 1) {
                var x = rb.a;
                return $elm$core$Result$Err(x);
            }
            else {
                var b = rb.a;
                return $elm$core$Result$Ok(A2(func, a, b));
            }
        }
    }, $elm$core$Result$map2_fn_unwrapped = function (func, ra, rb) {
        if (ra.$ === 1) {
            var x = ra.a;
            return $elm$core$Result$Err(x);
        }
        else {
            var a = ra.a;
            if (rb.$ === 1) {
                var x = rb.a;
                return $elm$core$Result$Err(x);
            }
            else {
                var b = rb.a;
                return $elm$core$Result$Ok(func(a, b));
            }
        }
    }, $elm$core$Result$map2 = F3($elm$core$Result$map2_fn);
    var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
        switch (builder.$) {
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 4;
            case 3:
                return 1;
            case 4:
                return 2;
            case 5:
                return 4;
            case 6:
                return 4;
            case 7:
                return 8;
            case 8:
                var w = builder.a;
                return w;
            case 9:
                var w = builder.a;
                return w;
            default:
                var bs = builder.a;
                return _Bytes_width(bs);
        }
    };
    var $elm$bytes$Bytes$LE = 0;
    var $elm$bytes$Bytes$Encode$write_fn = function (builder, mb, offset) {
        switch (builder.$) {
            case 0:
                var n = builder.a;
                return _Bytes_write_i8_fn(mb, offset, n);
            case 1:
                var e = builder.a;
                var n = builder.b;
                return _Bytes_write_i16_fn(mb, offset, n, !e);
            case 2:
                var e = builder.a;
                var n = builder.b;
                return _Bytes_write_i32_fn(mb, offset, n, !e);
            case 3:
                var n = builder.a;
                return _Bytes_write_u8_fn(mb, offset, n);
            case 4:
                var e = builder.a;
                var n = builder.b;
                return _Bytes_write_u16_fn(mb, offset, n, !e);
            case 5:
                var e = builder.a;
                var n = builder.b;
                return _Bytes_write_u32_fn(mb, offset, n, !e);
            case 6:
                var e = builder.a;
                var n = builder.b;
                return _Bytes_write_f32_fn(mb, offset, n, !e);
            case 7:
                var e = builder.a;
                var n = builder.b;
                return _Bytes_write_f64_fn(mb, offset, n, !e);
            case 8:
                var bs = builder.b;
                return $elm$bytes$Bytes$Encode$writeSequence_fn(bs, mb, offset);
            case 9:
                var s = builder.b;
                return _Bytes_write_string_fn(mb, offset, s);
            default:
                var bs = builder.a;
                return _Bytes_write_bytes_fn(mb, offset, bs);
        }
    }, $elm$bytes$Bytes$Encode$write = F3($elm$bytes$Bytes$Encode$write_fn);
    var $elm$bytes$Bytes$Encode$writeSequence_fn = function (builders, mb, offset) {
        writeSequence: while (true) {
            if (!builders.b) {
                return offset;
            }
            else {
                var b = builders.a;
                var bs = builders.b;
                var $temp$builders = bs, $temp$mb = mb, $temp$offset = $elm$bytes$Bytes$Encode$write_fn(b, mb, offset);
                builders = $temp$builders;
                mb = $temp$mb;
                offset = $temp$offset;
                continue writeSequence;
            }
        }
    }, $elm$bytes$Bytes$Encode$writeSequence = F3($elm$bytes$Bytes$Encode$writeSequence_fn);
    var $elm$bytes$Bytes$Decode$decode_fn = function (_v0, bs) {
        var decoder = _v0;
        return _Bytes_decode_fn(decoder, bs);
    }, $elm$bytes$Bytes$Decode$decode = F2($elm$bytes$Bytes$Decode$decode_fn);
    var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
    var $elm$bytes$Bytes$Decode$string = function (n) {
        return _Bytes_read_string(n);
    };
    var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
    var $elm$bytes$Bytes$BE = 1;
    var $danfishgold$base64_bytes$Encode$isValidChar = function (c) {
        if ($elm$core$Char$isAlphaNum(c)) {
            return true;
        }
        else {
            switch (c) {
                case "+":
                    return true;
                case "/":
                    return true;
                default:
                    return false;
            }
        }
    };
    var $elm$core$Bitwise$or = _Bitwise_or;
    var $elm$bytes$Bytes$Encode$Seq_fn = function (a, b) {
        return { $: 8, a: a, b: b };
    }, $elm$bytes$Bytes$Encode$Seq = F2($elm$bytes$Bytes$Encode$Seq_fn);
    var $elm$bytes$Bytes$Encode$getWidths_fn = function (width, builders) {
        getWidths: while (true) {
            if (!builders.b) {
                return width;
            }
            else {
                var b = builders.a;
                var bs = builders.b;
                var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b), $temp$builders = bs;
                width = $temp$width;
                builders = $temp$builders;
                continue getWidths;
            }
        }
    }, $elm$bytes$Bytes$Encode$getWidths = F2($elm$bytes$Bytes$Encode$getWidths_fn);
    var $elm$bytes$Bytes$Encode$sequence = function (builders) {
        return $elm$bytes$Bytes$Encode$Seq_fn($elm$bytes$Bytes$Encode$getWidths_fn(0, builders), builders);
    };
    var $danfishgold$base64_bytes$Encode$unsafeConvertChar = function (_char) {
        var key = $elm$core$Char$toCode(_char);
        if ((key >= 65) && (key <= 90)) {
            return key - 65;
        }
        else {
            if ((key >= 97) && (key <= 122)) {
                return (key - 97) + 26;
            }
            else {
                if ((key >= 48) && (key <= 57)) {
                    return ((key - 48) + 26) + 26;
                }
                else {
                    switch (_char) {
                        case "+":
                            return 62;
                        case "/":
                            return 63;
                        default:
                            return -1;
                    }
                }
            }
        }
    };
    var $elm$bytes$Bytes$Encode$U16_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $elm$bytes$Bytes$Encode$U16 = F2($elm$bytes$Bytes$Encode$U16_fn);
    var $elm$bytes$Bytes$Encode$unsignedInt16 = $elm$bytes$Bytes$Encode$U16;
    var $elm$bytes$Bytes$Encode$U8 = function (a) {
        return { $: 3, a: a };
    };
    var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
    var $danfishgold$base64_bytes$Encode$encodeCharacters_fn = function (a, b, c, d) {
        if ($danfishgold$base64_bytes$Encode$isValidChar(a) && $danfishgold$base64_bytes$Encode$isValidChar(b)) {
            var n2 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(b);
            var n1 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(a);
            if ("=" === d) {
                if ("=" === c) {
                    var n = (n1 << 18) | (n2 << 12);
                    var b1 = n >> 16;
                    return $elm$core$Maybe$Just($elm$bytes$Bytes$Encode$unsignedInt8(b1));
                }
                else {
                    if ($danfishgold$base64_bytes$Encode$isValidChar(c)) {
                        var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
                        var n = ((n1 << 18) | (n2 << 12)) | (n3 << 6);
                        var combined = n >> 8;
                        return $elm$core$Maybe$Just($elm$bytes$Bytes$Encode$U16_fn(1, combined));
                    }
                    else {
                        return $elm$core$Maybe$Nothing;
                    }
                }
            }
            else {
                if ($danfishgold$base64_bytes$Encode$isValidChar(c) && $danfishgold$base64_bytes$Encode$isValidChar(d)) {
                    var n4 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(d);
                    var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
                    var n = ((n1 << 18) | (n2 << 12)) | ((n3 << 6) | n4);
                    var combined = n >> 8;
                    var b3 = n;
                    return $elm$core$Maybe$Just($elm$bytes$Bytes$Encode$sequence(_List_fromArray([
                        $elm$bytes$Bytes$Encode$U16_fn(1, combined),
                        $elm$bytes$Bytes$Encode$unsignedInt8(b3)
                    ])));
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $danfishgold$base64_bytes$Encode$encodeCharacters = F4($danfishgold$base64_bytes$Encode$encodeCharacters_fn);
    var $danfishgold$base64_bytes$Encode$encodeChunks_fn = function (input, accum) {
        encodeChunks: while (true) {
            var _v0 = $elm$core$String$toList($elm$core$String$left_fn(4, input));
            _v0$4: while (true) {
                if (!_v0.b) {
                    return $elm$core$Maybe$Just(accum);
                }
                else {
                    if (_v0.b.b) {
                        if (_v0.b.b.b) {
                            if (_v0.b.b.b.b) {
                                if (!_v0.b.b.b.b.b) {
                                    var a = _v0.a;
                                    var _v1 = _v0.b;
                                    var b = _v1.a;
                                    var _v2 = _v1.b;
                                    var c = _v2.a;
                                    var _v3 = _v2.b;
                                    var d = _v3.a;
                                    var _v4 = $danfishgold$base64_bytes$Encode$encodeCharacters_fn(a, b, c, d);
                                    if (!_v4.$) {
                                        var enc = _v4.a;
                                        var $temp$input = $elm$core$String$dropLeft_fn(4, input), $temp$accum = _List_Cons(enc, accum);
                                        input = $temp$input;
                                        accum = $temp$accum;
                                        continue encodeChunks;
                                    }
                                    else {
                                        return $elm$core$Maybe$Nothing;
                                    }
                                }
                                else {
                                    break _v0$4;
                                }
                            }
                            else {
                                var a = _v0.a;
                                var _v5 = _v0.b;
                                var b = _v5.a;
                                var _v6 = _v5.b;
                                var c = _v6.a;
                                var _v7 = $danfishgold$base64_bytes$Encode$encodeCharacters_fn(a, b, c, "=");
                                if (_v7.$ === 1) {
                                    return $elm$core$Maybe$Nothing;
                                }
                                else {
                                    var enc = _v7.a;
                                    return $elm$core$Maybe$Just(_List_Cons(enc, accum));
                                }
                            }
                        }
                        else {
                            var a = _v0.a;
                            var _v8 = _v0.b;
                            var b = _v8.a;
                            var _v9 = $danfishgold$base64_bytes$Encode$encodeCharacters_fn(a, b, "=", "=");
                            if (_v9.$ === 1) {
                                return $elm$core$Maybe$Nothing;
                            }
                            else {
                                var enc = _v9.a;
                                return $elm$core$Maybe$Just(_List_Cons(enc, accum));
                            }
                        }
                    }
                    else {
                        break _v0$4;
                    }
                }
            }
            return $elm$core$Maybe$Nothing;
        }
    }, $danfishgold$base64_bytes$Encode$encodeChunks = F2($danfishgold$base64_bytes$Encode$encodeChunks_fn);
    var $danfishgold$base64_bytes$Encode$encoder = function (string) {
        return $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$bytes$Bytes$Encode$sequence), $danfishgold$base64_bytes$Encode$encodeChunks_fn(string, _List_Nil));
    };
    var $danfishgold$base64_bytes$Encode$toBytes = function (string) {
        return $elm$core$Maybe$map_fn($elm$bytes$Bytes$Encode$encode, $danfishgold$base64_bytes$Encode$encoder(string));
    };
    var $danfishgold$base64_bytes$Base64$toBytes = $danfishgold$base64_bytes$Encode$toBytes;
    var $elm$bytes$Bytes$width = _Bytes_width;
    var $danfishgold$base64_bytes$Base64$toString = function (b64String) {
        var _v0 = $danfishgold$base64_bytes$Base64$toBytes(b64String);
        if (_v0.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var b64Bytes = _v0.a;
            return $elm$bytes$Bytes$Decode$decode_fn($elm$bytes$Bytes$Decode$string($elm$bytes$Bytes$width(b64Bytes)), b64Bytes);
        }
    };
    var $elm$core$String$map = _String_map;
    var $simonh1000$elm_jwt$Jwt$unurl = function () {
        var fix = function (c) {
            switch (c) {
                case "-":
                    return "+";
                case "_":
                    return "/";
                default:
                    return c;
            }
        };
        return $elm$core$String$map(fix);
    }();
    var $simonh1000$elm_jwt$Jwt$getTokenParts = function (token) {
        var verifyJson = F2(function (errorHandler, str) {
            return $elm$core$Result$mapError_fn(errorHandler, $elm$core$Result$map_fn(function (_v8) {
                return str;
            }, _Json_runOnString_fn($elm$json$Json$Decode$value, str)));
        });
        var processor = A2($elm$core$Basics$composeR, $simonh1000$elm_jwt$Jwt$unurl, A2($elm$core$Basics$composeR, $elm$core$String$split("."), $elm$core$List$map($simonh1000$elm_jwt$Jwt$fixlength)));
        var _v0 = processor(token);
        _v0$1: while (true) {
            if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
                if (!_v0.a.$) {
                    if (!_v0.b.a.$) {
                        var header = _v0.a.a;
                        var _v1 = _v0.b;
                        var body = _v1.a.a;
                        var _v2 = _v1.b;
                        var header_ = $elm$core$Result$andThen_fn(verifyJson(function (_v3) {
                            return $simonh1000$elm_jwt$Jwt$TokenHeaderError;
                        }), $elm$core$Result$fromMaybe_fn($simonh1000$elm_jwt$Jwt$TokenHeaderError, $danfishgold$base64_bytes$Base64$toString(header)));
                        var body_ = $elm$core$Result$andThen_fn(verifyJson($simonh1000$elm_jwt$Jwt$TokenDecodeError), $elm$core$Result$fromMaybe_fn($simonh1000$elm_jwt$Jwt$TokenProcessingError("Invalid UTF-16"), $danfishgold$base64_bytes$Base64$toString(body)));
                        return $elm$core$Result$map2_fn_unwrapped(function (a, b) {
                            return _Utils_Tuple2(a, b);
                        }, header_, body_);
                    }
                    else {
                        break _v0$1;
                    }
                }
                else {
                    if (_v0.b.a.$ === 1) {
                        break _v0$1;
                    }
                    else {
                        var err = _v0.a.a;
                        var _v6 = _v0.b;
                        var _v7 = _v6.b;
                        return $elm$core$Result$Err(err);
                    }
                }
            }
            else {
                return $elm$core$Result$Err($simonh1000$elm_jwt$Jwt$TokenProcessingError("Token has invalid shape"));
            }
        }
        var _v4 = _v0.b;
        var err = _v4.a.a;
        var _v5 = _v4.b;
        return $elm$core$Result$Err(err);
    };
    var $elm$core$Tuple$second = function (_v0) {
        var y = _v0.b;
        return y;
    };
    var $simonh1000$elm_jwt$Jwt$decodeToken_fn = function (dec, token) {
        return $elm$core$Result$andThen_fn(A2($elm$core$Basics$composeR, $elm$json$Json$Decode$decodeString(dec), $elm$core$Result$mapError($simonh1000$elm_jwt$Jwt$TokenDecodeError)), $elm$core$Result$map_fn($elm$core$Tuple$second, $simonh1000$elm_jwt$Jwt$getTokenParts(token)));
    }, $simonh1000$elm_jwt$Jwt$decodeToken = F2($simonh1000$elm_jwt$Jwt$decodeToken_fn);
    var $elm$url$Url$Parser$Query$map4_fn = function (func, _v0, _v1, _v2, _v3) {
        var a = _v0;
        var b = _v1;
        var c = _v2;
        var d = _v3;
        return function (dict) {
            return A4(func, a(dict), b(dict), c(dict), d(dict));
        };
    }, $elm$url$Url$Parser$Query$map4_fn_unwrapped = function (func, _v0, _v1, _v2, _v3) {
        var a = _v0;
        var b = _v1;
        var c = _v2;
        var d = _v3;
        return function (dict) {
            return func(a(dict), b(dict), c(dict), d(dict));
        };
    }, $elm$url$Url$Parser$Query$map4 = F5($elm$url$Url$Parser$Query$map4_fn);
    var $author$project$Data$Auth$queryParser = $elm$url$Url$Parser$Query$map4_fn_unwrapped(function (mError, mCode, mIdToken, mScope) {
        var _v0 = _Utils_Tuple3(_Utils_Tuple2(mError, mCode), mIdToken, mScope);
        _v0$0: while (true) {
            _v0$1: while (true) {
                if (!_v0.a.a.$) {
                    if (_v0.a.b.$ === 1) {
                        if (_v0.a.a.a === "access_denied") {
                            break _v0$0;
                        }
                        else {
                            break _v0$1;
                        }
                    }
                    else {
                        if (_v0.b.$ === 1) {
                            if (_v0.a.a.a === "access_denied") {
                                break _v0$0;
                            }
                            else {
                                break _v0$1;
                            }
                        }
                        else {
                            if (_v0.c.$ === 1) {
                                if (_v0.a.a.a === "access_denied") {
                                    break _v0$0;
                                }
                                else {
                                    break _v0$1;
                                }
                            }
                            else {
                                if (_v0.a.a.a === "access_denied") {
                                    break _v0$0;
                                }
                                else {
                                    break _v0$1;
                                }
                            }
                        }
                    }
                }
                else {
                    if (_v0.a.b.$ === 1) {
                        var _v3 = _v0.a;
                        var _v4 = _v3.b;
                        return $elm$core$Result$Err($author$project$Data$Auth$MissingCodeParam);
                    }
                    else {
                        if (_v0.b.$ === 1) {
                            var _v5 = _v0.b;
                            return $elm$core$Result$Err($author$project$Data$Auth$MissingIdTokenParam);
                        }
                        else {
                            if (_v0.c.$ === 1) {
                                var _v6 = _v0.c;
                                return $elm$core$Result$Err($author$project$Data$Auth$MissingScopeParam);
                            }
                            else {
                                var _v7 = _v0.a;
                                var code = _v7.b.a;
                                var idToken = _v0.b.a;
                                var scope = _v0.c.a;
                                var _v8 = $simonh1000$elm_jwt$Jwt$decodeToken_fn(_Json_decodeField_fn("email", $elm$json$Json$Decode$string), idToken);
                                if (_v8.$ === 1) {
                                    var jwtError = _v8.a;
                                    return $elm$core$Result$Err($author$project$Data$Auth$JwtError(jwtError));
                                }
                                else {
                                    var email = _v8.a;
                                    return $elm$core$Result$Ok({ gZ: code, cS: email, f_: scope });
                                }
                            }
                        }
                    }
                }
            }
            var _v2 = _v0.a;
            var googleError = _v2.a.a;
            return $elm$core$Result$Err($author$project$Data$Auth$UntrackedGoogleError(googleError));
        }
        var _v1 = _v0.a;
        return $elm$core$Result$Err($author$project$Data$Auth$CanceledByUser);
    }, $elm$url$Url$Parser$Query$string("error"), $elm$url$Url$Parser$Query$string("code"), $elm$url$Url$Parser$Query$string("id_token"), $elm$url$Url$Parser$Query$string("scope"));
    var $elm$url$Url$Parser$query = function (_v0) {
        var queryParser = _v0;
        return function (_v1) {
            var visited = _v1.bM;
            var unvisited = _v1.bg;
            var params = _v1.bB;
            var frag = _v1.bt;
            var value = _v1.p_;
            return _List_fromArray([
                $elm$url$Url$Parser$State_fn(visited, unvisited, params, frag, value(queryParser(params)))
            ]);
        };
    };
    var $elm$url$Url$Parser$slash_fn = function (_v0, _v1) {
        var parseBefore = _v0;
        var parseAfter = _v1;
        return function (state) {
            return $elm$core$List$concatMap_fn(parseAfter, parseBefore(state));
        };
    }, $elm$url$Url$Parser$slash = F2($elm$url$Url$Parser$slash_fn);
    var $elm$url$Url$Parser$questionMark_fn = function (parser, queryParser) {
        return $elm$url$Url$Parser$slash_fn(parser, $elm$url$Url$Parser$query(queryParser));
    }, $elm$url$Url$Parser$questionMark = F2($elm$url$Url$Parser$questionMark_fn);
    var $elm$url$Url$Parser$s = function (str) {
        return function (_v0) {
            var visited = _v0.bM;
            var unvisited = _v0.bg;
            var params = _v0.bB;
            var frag = _v0.bt;
            var value = _v0.p_;
            if (!unvisited.b) {
                return _List_Nil;
            }
            else {
                var next = unvisited.a;
                var rest = unvisited.b;
                return _Utils_eq(next, str) ? _List_fromArray([
                    $elm$url$Url$Parser$State_fn(_List_Cons(next, visited), rest, params, frag, value)
                ]) : _List_Nil;
            }
        };
    };
    var $author$project$Search$Query$Attachments = 2;
    var $author$project$Search$Query$Notes = 0;
    var $author$project$Search$Query$People = 1;
    var $author$project$Search$Query$categoryFromString = function (str) {
        switch (str) {
            case "notes":
                return $elm$core$Maybe$Just(0);
            case "people":
                return $elm$core$Maybe$Just(1);
            case "attachments":
                return $elm$core$Maybe$Just(2);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Routing$searchCategoryParser = function (paramName) {
        return $elm$url$Url$Parser$Query$map_fn($elm$core$Maybe$andThen($author$project$Search$Query$categoryFromString), $elm$url$Url$Parser$Query$string(paramName));
    };
    var $author$project$Routing$SignupStepChooseSubscription = { $: 1 };
    var $author$project$Routing$SignupStepLinkAccountSignIn = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Routing$SignupStepLinkCalendar = { $: 3 };
    var $author$project$Routing$SignupStepSignIn_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $author$project$Routing$SignupStepSignIn = F3($author$project$Routing$SignupStepSignIn_fn);
    var $author$project$Routing$SignupStepWatchVideo = { $: 4 };
    var $author$project$Routing$SignupStepWizard = { $: 5 };
    var $author$project$Data$Subscription$Monthly = 0;
    var $author$project$Data$Subscription$Yearly = 1;
    var $elm$core$String$toLower = _String_toLower;
    var $author$project$Routing$subscriptionPlanParser = function (paramName) {
        return $elm$url$Url$Parser$Query$map_fn(function (billingPeriod) {
            var _v0 = $elm$core$Maybe$map_fn($elm$core$String$toLower, billingPeriod);
            _v0$2: while (true) {
                if (!_v0.$) {
                    switch (_v0.a) {
                        case "yearly":
                            return $elm$core$Maybe$Just(1);
                        case "monthly":
                            return $elm$core$Maybe$Just(0);
                        default:
                            break _v0$2;
                    }
                }
                else {
                    break _v0$2;
                }
            }
            return $elm$core$Maybe$Nothing;
        }, $elm$url$Url$Parser$Query$string(paramName));
    };
    var $author$project$Routing$signupStepParser = $elm$url$Url$Parser$oneOf(_List_fromArray([
        $elm$url$Url$Parser$map_fn($author$project$Routing$SignupStepSignIn, $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$s("signup"), $elm$url$Url$Parser$Query$string("giftId")), $elm$url$Url$Parser$Query$string("ref")), $author$project$Routing$subscriptionPlanParser("plan"))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$SignupStepLinkAccountSignIn, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("signup"), $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$s("link"), $elm$url$Url$Parser$Query$string("linkToken")))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$SignupStepChooseSubscription, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("signup"), $elm$url$Url$Parser$s("choose-subscription"))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$SignupStepLinkCalendar, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("signup"), $elm$url$Url$Parser$s("link-calendar"))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$SignupStepWatchVideo, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("signup"), $elm$url$Url$Parser$s("watch"))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$SignupStepWizard, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("signup"), $elm$url$Url$Parser$s("wizard")))
    ]));
    var $elm$url$Url$Parser$string = $elm$url$Url$Parser$custom_fn("STRING", $elm$core$Maybe$Just);
    var $elm$url$Url$Parser$top = function (state) {
        return _List_fromArray([state]);
    };
    var $author$project$Data$Auth$urlPath = "auth";
    var $author$project$Routing$matchers = $elm$url$Url$Parser$oneOf(_List_fromArray([
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteHome($elm$core$Maybe$Nothing), $elm$url$Url$Parser$top),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteHome, $elm$url$Url$Parser$map_fn($author$project$Util$Time$dateFromYMD, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$int, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$int, $elm$url$Url$Parser$int)))),
        $elm$url$Url$Parser$map_fn(F2(function (o, c) {
            return $author$project$Routing$RouteThreads((new $$Record40(o, c)));
        }), $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$s("threads"), $author$project$Routing$queryBool("oldestFirst")), $author$project$Routing$queryBool("showCompleted"))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteCreateEventNote, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("notes"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("create"), $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$Query$string("masterId")), $elm$url$Url$Parser$Query$string("ref"))))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteNewEventNote, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("notes"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("new"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$string, $author$project$Routing$parseNoteTab))))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteCreateAdHocNote, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("notes"), $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$s("create-ad-hoc"), $elm$core$Basics$composeR_fn($author$project$Routing$posixQuery_a0, $author$project$Routing$posixQuery_a1, "startTime")))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteNewAdHocNote, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("notes"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("new-ad-hoc"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$questionMark_fn($author$project$Routing$posix, $author$project$Routing$parseNoteTab))))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteNote, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("notes"), $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$Query$string("highlight")), $author$project$Routing$parseNoteTab))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$handleNextMeetingRoute, $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$s("next"), $elm$url$Url$Parser$Query$string("personId")), $elm$url$Url$Parser$Query$string("masterId")), $author$project$Routing$parseMeetingType("meetingType"))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$handleCreatePersonRoute, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("people"), $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$s("create"), $author$project$Routing$newPersonQuery))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RoutePerson, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("people"), $elm$url$Url$Parser$string)),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteSettings, $elm$url$Url$Parser$s("settings")),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteSearch, $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$s("search"), $elm$url$Url$Parser$Query$string("q")), $author$project$Routing$searchCategoryParser("category"))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteCalendar($elm$core$Maybe$Nothing), $elm$url$Url$Parser$s("calendar")),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteCalendar, $elm$url$Url$Parser$map_fn($author$project$Util$Time$dateFromYMD, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("calendar"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$int, $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$int, $elm$url$Url$Parser$int))))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteSignup, $author$project$Routing$signupStepParser),
        $elm$url$Url$Parser$map_fn(F2(function (eId, mCount) {
            return $author$project$Routing$RouteCollate_fn($author$project$Routing$CollateSeries({ h8: eId }), mCount);
        }), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("collate"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("series"), $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$Query$int("maxCount"))))),
        $elm$url$Url$Parser$map_fn(F2(function (pId, mCount) {
            return $author$project$Routing$RouteCollate_fn($author$project$Routing$CollateWithPerson(pId), mCount);
        }), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("collate"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("person"), $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$Query$int("maxCount"))))),
        $elm$url$Url$Parser$map_fn(F2(function (domain, mCount) {
            return $author$project$Routing$RouteCollate_fn($author$project$Routing$CollateByDomain({ g9: domain }), mCount);
        }), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("collate"), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("domain"), $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$string, $elm$url$Url$Parser$Query$int("maxCount"))))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteStripeReturn({ o3: true }), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("stripe"), $elm$url$Url$Parser$s("succeeded"))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteStripeReturn({ o3: false }), $elm$url$Url$Parser$slash_fn($elm$url$Url$Parser$s("stripe"), $elm$url$Url$Parser$s("canceled"))),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteBilling, $elm$url$Url$Parser$s("billing")),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteAuth, $elm$url$Url$Parser$questionMark_fn($elm$url$Url$Parser$s($author$project$Data$Auth$urlPath), $author$project$Data$Auth$queryParser)),
        $elm$url$Url$Parser$map_fn($author$project$Routing$RouteDemo, $elm$url$Url$Parser$s("demo"))
    ]));
    var $elm$url$Url$Parser$getFirstMatch = function (states) {
        getFirstMatch: while (true) {
            if (!states.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var state = states.a;
                var rest = states.b;
                var _v1 = state.bg;
                if (!_v1.b) {
                    return $elm$core$Maybe$Just(state.p_);
                }
                else {
                    if ((_v1.a === "") && (!_v1.b.b)) {
                        return $elm$core$Maybe$Just(state.p_);
                    }
                    else {
                        var $temp$states = rest;
                        states = $temp$states;
                        continue getFirstMatch;
                    }
                }
            }
        }
    };
    var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
        if (!segments.b) {
            return _List_Nil;
        }
        else {
            if ((segments.a === "") && (!segments.b.b)) {
                return _List_Nil;
            }
            else {
                var segment = segments.a;
                var rest = segments.b;
                return _List_Cons(segment, $elm$url$Url$Parser$removeFinalEmpty(rest));
            }
        }
    };
    var $elm$url$Url$Parser$preparePath = function (path) {
        var _v0 = $elm$core$String$split_fn("/", path);
        if (_v0.b && (_v0.a === "")) {
            var segments = _v0.b;
            return $elm$url$Url$Parser$removeFinalEmpty(segments);
        }
        else {
            var segments = _v0;
            return $elm$url$Url$Parser$removeFinalEmpty(segments);
        }
    };
    var $elm$url$Url$Parser$addToParametersHelp_fn = function (value, maybeList) {
        if (maybeList.$ === 1) {
            return $elm$core$Maybe$Just(_List_fromArray([value]));
        }
        else {
            var list = maybeList.a;
            return $elm$core$Maybe$Just(_List_Cons(value, list));
        }
    }, $elm$url$Url$Parser$addToParametersHelp = F2($elm$url$Url$Parser$addToParametersHelp_fn);
    var $elm$url$Url$percentDecode = _Url_percentDecode;
    var $elm$core$Dict$getMin = function (dict) {
        getMin: while (true) {
            if ((dict.$ === -1) && (dict.d.$ === -1)) {
                var left = dict.d;
                var $temp$dict = left;
                dict = $temp$dict;
                continue getMin;
            }
            else {
                return dict;
            }
        }
    };
    var $elm$core$Dict$moveRedLeft = function (dict) {
        if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
            if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v1 = dict.d;
                var lClr = _v1.a;
                var lK = _v1.b;
                var lV = _v1.c;
                var lLeft = _v1.d;
                var lRight = _v1.e;
                var _v2 = dict.e;
                var rClr = _v2.a;
                var rK = _v2.b;
                var rV = _v2.c;
                var rLeft = _v2.d;
                var _v3 = rLeft.a;
                var rlK = rLeft.b;
                var rlV = rLeft.c;
                var rlL = rLeft.d;
                var rlR = rLeft.e;
                var rRight = _v2.e;
                return $elm$core$Dict$RBNode_elm_builtin_fn(0, rlK, rlV, $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), rlL), $elm$core$Dict$RBNode_elm_builtin_fn(1, rK, rV, rlR, rRight));
            }
            else {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v4 = dict.d;
                var lClr = _v4.a;
                var lK = _v4.b;
                var lV = _v4.c;
                var lLeft = _v4.d;
                var lRight = _v4.e;
                var _v5 = dict.e;
                var rClr = _v5.a;
                var rK = _v5.b;
                var rV = _v5.c;
                var rLeft = _v5.d;
                var rRight = _v5.e;
                if (clr === 1) {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight));
                }
                else {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight));
                }
            }
        }
        else {
            return dict;
        }
    };
    var $elm$core$Dict$moveRedRight = function (dict) {
        if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
            if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v1 = dict.d;
                var lClr = _v1.a;
                var lK = _v1.b;
                var lV = _v1.c;
                var _v2 = _v1.d;
                var _v3 = _v2.a;
                var llK = _v2.b;
                var llV = _v2.c;
                var llLeft = _v2.d;
                var llRight = _v2.e;
                var lRight = _v1.e;
                var _v4 = dict.e;
                var rClr = _v4.a;
                var rK = _v4.b;
                var rV = _v4.c;
                var rLeft = _v4.d;
                var rRight = _v4.e;
                return $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, $elm$core$Dict$RBNode_elm_builtin_fn(1, llK, llV, llLeft, llRight), $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, lRight, $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight)));
            }
            else {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v5 = dict.d;
                var lClr = _v5.a;
                var lK = _v5.b;
                var lV = _v5.c;
                var lLeft = _v5.d;
                var lRight = _v5.e;
                var _v6 = dict.e;
                var rClr = _v6.a;
                var rK = _v6.b;
                var rV = _v6.c;
                var rLeft = _v6.d;
                var rRight = _v6.e;
                if (clr === 1) {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight));
                }
                else {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight));
                }
            }
        }
        else {
            return dict;
        }
    };
    var $elm$core$Dict$removeHelpPrepEQGT_fn = function (targetKey, dict, color, key, value, left, right) {
        if ((left.$ === -1) && (!left.a)) {
            var _v1 = left.a;
            var lK = left.b;
            var lV = left.c;
            var lLeft = left.d;
            var lRight = left.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(color, lK, lV, lLeft, $elm$core$Dict$RBNode_elm_builtin_fn(0, key, value, lRight, right));
        }
        else {
            _v2$2: while (true) {
                if ((right.$ === -1) && (right.a === 1)) {
                    if (right.d.$ === -1) {
                        if (right.d.a === 1) {
                            var _v3 = right.a;
                            var _v4 = right.d;
                            var _v5 = _v4.a;
                            return $elm$core$Dict$moveRedRight(dict);
                        }
                        else {
                            break _v2$2;
                        }
                    }
                    else {
                        var _v6 = right.a;
                        var _v7 = right.d;
                        return $elm$core$Dict$moveRedRight(dict);
                    }
                }
                else {
                    break _v2$2;
                }
            }
            return dict;
        }
    }, $elm$core$Dict$removeHelpPrepEQGT = F7($elm$core$Dict$removeHelpPrepEQGT_fn);
    var $elm$core$Dict$removeMin = function (dict) {
        if ((dict.$ === -1) && (dict.d.$ === -1)) {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var lColor = left.a;
            var lLeft = left.d;
            var right = dict.e;
            if (lColor === 1) {
                if ((lLeft.$ === -1) && (!lLeft.a)) {
                    var _v3 = lLeft.a;
                    return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, $elm$core$Dict$removeMin(left), right);
                }
                else {
                    var _v4 = $elm$core$Dict$moveRedLeft(dict);
                    if (_v4.$ === -1) {
                        var nColor = _v4.a;
                        var nKey = _v4.b;
                        var nValue = _v4.c;
                        var nLeft = _v4.d;
                        var nRight = _v4.e;
                        return $elm$core$Dict$balance_fn(nColor, nKey, nValue, $elm$core$Dict$removeMin(nLeft), nRight);
                    }
                    else {
                        return $elm$core$Dict$RBEmpty_elm_builtin;
                    }
                }
            }
            else {
                return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, $elm$core$Dict$removeMin(left), right);
            }
        }
        else {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
    };
    var $elm$core$Dict$removeHelp_fn = function (targetKey, dict) {
        if (dict.$ === -2) {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
        else {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            if (_Utils_cmp(targetKey, key) < 0) {
                if ((left.$ === -1) && (left.a === 1)) {
                    var _v4 = left.a;
                    var lLeft = left.d;
                    if ((lLeft.$ === -1) && (!lLeft.a)) {
                        var _v6 = lLeft.a;
                        return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, $elm$core$Dict$removeHelp_fn(targetKey, left), right);
                    }
                    else {
                        var _v7 = $elm$core$Dict$moveRedLeft(dict);
                        if (_v7.$ === -1) {
                            var nColor = _v7.a;
                            var nKey = _v7.b;
                            var nValue = _v7.c;
                            var nLeft = _v7.d;
                            var nRight = _v7.e;
                            return $elm$core$Dict$balance_fn(nColor, nKey, nValue, $elm$core$Dict$removeHelp_fn(targetKey, nLeft), nRight);
                        }
                        else {
                            return $elm$core$Dict$RBEmpty_elm_builtin;
                        }
                    }
                }
                else {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, $elm$core$Dict$removeHelp_fn(targetKey, left), right);
                }
            }
            else {
                return $elm$core$Dict$removeHelpEQGT_fn(targetKey, $elm$core$Dict$removeHelpPrepEQGT_fn(targetKey, dict, color, key, value, left, right));
            }
        }
    }, $elm$core$Dict$removeHelp = F2($elm$core$Dict$removeHelp_fn);
    var $elm$core$Dict$removeHelpEQGT_fn = function (targetKey, dict) {
        if (dict.$ === -1) {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            if (_Utils_eq(targetKey, key)) {
                var _v1 = $elm$core$Dict$getMin(right);
                if (_v1.$ === -1) {
                    var minKey = _v1.b;
                    var minValue = _v1.c;
                    return $elm$core$Dict$balance_fn(color, minKey, minValue, left, $elm$core$Dict$removeMin(right));
                }
                else {
                    return $elm$core$Dict$RBEmpty_elm_builtin;
                }
            }
            else {
                return $elm$core$Dict$balance_fn(color, key, value, left, $elm$core$Dict$removeHelp_fn(targetKey, right));
            }
        }
        else {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
    }, $elm$core$Dict$removeHelpEQGT = F2($elm$core$Dict$removeHelpEQGT_fn);
    var $elm$core$Dict$remove_fn = function (key, dict) {
        var _v0 = $elm$core$Dict$removeHelp_fn(key, dict);
        if ((_v0.$ === -1) && (!_v0.a)) {
            var _v1 = _v0.a;
            var k = _v0.b;
            var v = _v0.c;
            var l = _v0.d;
            var r = _v0.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, l, r);
        }
        else {
            var x = _v0;
            return x;
        }
    }, $elm$core$Dict$remove = F2($elm$core$Dict$remove_fn);
    var $elm$core$Dict$update_fn = function (targetKey, alter, dictionary) {
        var _v0 = alter($elm$core$Dict$get_fn(targetKey, dictionary));
        if (!_v0.$) {
            var value = _v0.a;
            return $elm$core$Dict$insert_fn(targetKey, value, dictionary);
        }
        else {
            return $elm$core$Dict$remove_fn(targetKey, dictionary);
        }
    }, $elm$core$Dict$update = F3($elm$core$Dict$update_fn);
    var $elm$url$Url$Parser$addParam_fn = function (segment, dict) {
        var _v0 = $elm$core$String$split_fn("=", segment);
        if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
            var rawKey = _v0.a;
            var _v1 = _v0.b;
            var rawValue = _v1.a;
            var _v2 = $elm$url$Url$percentDecode(rawKey);
            if (_v2.$ === 1) {
                return dict;
            }
            else {
                var key = _v2.a;
                var _v3 = $elm$url$Url$percentDecode(rawValue);
                if (_v3.$ === 1) {
                    return dict;
                }
                else {
                    var value = _v3.a;
                    return $elm$core$Dict$update_fn(key, $elm$url$Url$Parser$addToParametersHelp(value), dict);
                }
            }
        }
        else {
            return dict;
        }
    }, $elm$url$Url$Parser$addParam = F2($elm$url$Url$Parser$addParam_fn);
    var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
        if (maybeQuery.$ === 1) {
            return $elm$core$Dict$empty;
        }
        else {
            var qry = maybeQuery.a;
            return $elm$core$List$foldr_fn($elm$url$Url$Parser$addParam, $elm$core$Dict$empty, $elm$core$String$split_fn("&", qry));
        }
    };
    var $elm$url$Url$Parser$parse_fn = function (_v0, url) {
        var parser = _v0;
        return $elm$url$Url$Parser$getFirstMatch(parser($elm$url$Url$Parser$State_fn(_List_Nil, $elm$url$Url$Parser$preparePath(url.at), $elm$url$Url$Parser$prepareQuery(url.n$), url.hw, $elm$core$Basics$identity)));
    }, $elm$url$Url$Parser$parse = F2($elm$url$Url$Parser$parse_fn);
    var $author$project$Routing$parseLocation = function (url) {
        var finalUrl = (url.at === "/auth") ? function () {
            var $r = url.$c();
            $r.hw = $elm$core$Maybe$Nothing;
            $r.n$ = url.hw;
            return $r;
        }() : url;
        return $elm$core$Maybe$withDefault_fn($author$project$Routing$RouteNotFound, $elm$url$Url$Parser$parse_fn($author$project$Routing$matchers, finalUrl));
    };
    var $author$project$Firestore$Collection$getWithState_fn = function (id, _v0) {
        var collection = _v0;
        return $elm$core$Dict$get_fn(id, collection.n);
    }, $author$project$Firestore$Collection$getWithState = F2($author$project$Firestore$Collection$getWithState_fn);
    var $author$project$Firestore$Collection$get_fn = function (id, collection) {
        return $elm$core$Maybe$andThen_fn(function (_v0) {
            var state = _v0.a;
            var doc = _v0.b;
            if (state === 6) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                return $elm$core$Maybe$Just(doc);
            }
        }, $author$project$Firestore$Collection$getWithState_fn(id, collection));
    }, $author$project$Firestore$Collection$get = F2($author$project$Firestore$Collection$get_fn);
    var $author$project$Data$Settings$get = function (env) {
        return $elm$core$Maybe$withDefault_fn($author$project$Data$Settings$default, $author$project$Firestore$Collection$get_fn($author$project$Data$Settings$fixedDocId, env.be));
    };
    var $author$project$Data$Settings$theme_a0 = $author$project$Data$Settings$get, $author$project$Data$Settings$theme_a1 = function ($) {
        return $.pn;
    }, $author$project$Data$Settings$theme = A2($elm$core$Basics$composeR, $author$project$Data$Settings$theme_a0, $author$project$Data$Settings$theme_a1);
    var $author$project$Init$envHelper_fn = function (flags, timeZone, url, key, initSettings) {
        var theme = $elm$core$Basics$composeR_fn($author$project$Data$Settings$theme_a0, $author$project$Data$Settings$theme_a1, (new $$Record41($author$project$Data$Settings$init(initSettings))));
        var outboundRequests = (new $$Record42($krisajenkins$remotedata$RemoteData$NotAsked, $krisajenkins$remotedata$RemoteData$NotAsked, $krisajenkins$remotedata$RemoteData$NotAsked, $krisajenkins$remotedata$RemoteData$NotAsked, $krisajenkins$remotedata$RemoteData$NotAsked, $krisajenkins$remotedata$RemoteData$NotAsked, $krisajenkins$remotedata$RemoteData$NotAsked, $krisajenkins$remotedata$RemoteData$NotAsked, $krisajenkins$remotedata$RemoteData$NotAsked));
        var initialLoadWindow = {
            b6: $elm$time$Time$millisToPosix(flags.mf.b6),
            bF: $elm$time$Time$millisToPosix(flags.mf.bF)
        };
        return (new $$Record44($elm$time$Time$millisToPosix(flags.g1), $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$time$Time$millisToPosix(flags.g1), $author$project$Lib$Debouncer$init({ lc: 500, pp: 6000, pz: $author$project$Env$DebounceMsg }), $elm$core$Dict$empty, $author$project$Data$FeatureFlags$default, "", false, $author$project$Data$GiftArea$init, false, $author$project$View$ImageViewer$hide, initialLoadWindow, flags.ms, false, (new $$Record43($author$project$Data$LoadState$EventsLoadState_fn(false, false), false, false)), url, key, $elm$core$Maybe$Nothing, $author$project$Data$Note$init, false, outboundRequests, $author$project$Data$Color$paletteForTheme(theme), $author$project$Data$Person$init, _List_fromArray([
            $author$project$Routing$RouteHome($elm$core$Maybe$Nothing)
        ]), false, $author$project$Routing$parseLocation(url), $author$project$Search$Weight$emptyIndex, $author$project$Data$Settings$init(initSettings), false, $author$project$Lib$Snackbar$init, $author$project$Data$StorageUpload$init, theme, timeZone, flags.jq, timeZone, $elm$core$Basics$composeR_fn($author$project$Lib$UID$initSeed_a0, $author$project$Lib$UID$initSeed_a1, flags.pM), $elm$core$Maybe$Nothing, false, $elm$core$Maybe$Nothing, $author$project$Util$Misc$initViewport));
    }, $author$project$Init$envHelper = F5($author$project$Init$envHelper_fn);
    var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
    var $author$project$Search$Bar$DebouncerMsg = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Search$Query$empty = _List_Nil;
    var $author$project$Search$Result$SearchResult = $elm$core$Basics$identity;
    var $author$project$Search$Result$empty = (new $$Record45($elm$core$Dict$empty, _List_Nil));
    var $author$project$Search$Bar$viewAllResultsIndex = -1;
    var $author$project$Search$Bar$init = (new $$Record46($author$project$Lib$Debouncer$init({ lc: 150, pp: 50000, pz: $author$project$Search$Bar$DebouncerMsg }), $elm$core$Maybe$Just($author$project$Search$Bar$viewAllResultsIndex), $author$project$Search$Query$empty, $author$project$Search$Result$empty, $elm$core$Maybe$Nothing));
    var $author$project$Error$encodeHttpError = function (httpError) {
        return $elm$json$Json$Encode$object(function () {
            switch (httpError.$) {
                case 0:
                    var value = httpError.a;
                    return _List_fromArray([
                        _Utils_Tuple2("type", $elm$json$Json$Encode$string("Http.BadUrl")),
                        _Utils_Tuple2("value", $elm$json$Json$Encode$string(value))
                    ]);
                case 1:
                    return _List_fromArray([
                        _Utils_Tuple2("type", $elm$json$Json$Encode$string("Http.Timeout"))
                    ]);
                case 2:
                    return _List_fromArray([
                        _Utils_Tuple2("type", $elm$json$Json$Encode$string("Http.NetworkError"))
                    ]);
                case 3:
                    var status = httpError.a;
                    return _List_fromArray([
                        _Utils_Tuple2("type", $elm$json$Json$Encode$string("Http.BadStatus")),
                        _Utils_Tuple2("status", $elm$json$Json$Encode$int(status))
                    ]);
                default:
                    var value = httpError.a;
                    return _List_fromArray([
                        _Utils_Tuple2("type", $elm$json$Json$Encode$string("Http.BadBody")),
                        _Utils_Tuple2("value", $elm$json$Json$Encode$string(value))
                    ]);
            }
        }());
    };
    var $simonh1000$elm_jwt$Jwt$errorToString = function (jwtErr) {
        switch (jwtErr.$) {
            case 0:
                var err = jwtErr.a;
                return "JWT Token Processing error: " + err;
            case 1:
                var err = jwtErr.a;
                return "JWT Token Decoding error: " + $elm$json$Json$Decode$errorToString(err);
            default:
                return "JWT Token Header is corrupted";
        }
    };
    var $author$project$Error$authErrorExtraData = function (authError) {
        switch (authError.$) {
            case 4:
                var jwtError = authError.a;
                return _List_fromArray([
                    _Utils_Tuple2("jwtErrorInfo", $elm$json$Json$Encode$string($simonh1000$elm_jwt$Jwt$errorToString(jwtError)))
                ]);
            case 5:
                var errorParam = authError.a;
                return _List_fromArray([
                    _Utils_Tuple2("errorParamInRedirect", $elm$json$Json$Encode$string(errorParam))
                ]);
            case 8:
                var functionName = authError.a.fm;
                var httpError = authError.a.hM;
                return _List_fromArray([
                    _Utils_Tuple2("functionName", $elm$json$Json$Encode$string(functionName)),
                    _Utils_Tuple2("httpError", $author$project$Error$encodeHttpError(httpError))
                ]);
            default:
                return _List_Nil;
        }
    };
    var $author$project$Firestore$Error$codeToString = function (code) {
        switch (code) {
            case 0:
                return "permission-denied";
            case 1:
                return "invalid-argument";
            case 2:
                return "cancelled";
            case 3:
                return "deadline-exceeded";
            case 4:
                return "not-found";
            case 5:
                return "already-exists";
            case 6:
                return "resource-exhausted";
            case 7:
                return "failed-precondition";
            case 8:
                return "aborted";
            case 9:
                return "out-of-range";
            case 10:
                return "unimplemented";
            case 11:
                return "internal";
            case 12:
                return "unavailable";
            case 13:
                return "data-loss";
            case 14:
                return "unauthenticated";
            default:
                return "unknown";
        }
    };
    var $author$project$Error$severityToString = function (severity) {
        switch (severity) {
            case 0:
                return "critical";
            case 1:
                return "error";
            case 2:
                return "warning";
            case 3:
                return "info";
            default:
                return "debug";
        }
    };
    var $author$project$Data$Auth$authErrorToString = function (authError) {
        switch (authError.$) {
            case 0:
                return "canceled_by_user";
            case 1:
                return "missing_code_param";
            case 2:
                return "missing_id_token_param";
            case 3:
                return "missing_scope_param";
            case 4:
                return "jwt_error";
            case 5:
                return "untracked_google_error";
            case 6:
                return "mismatched_email";
            case 7:
                return "insufficient_scope";
            default:
                return "cloud_function_error";
        }
    };
    var $author$project$Error$titleFromType = function (tipe) {
        switch (tipe.$) {
            case 0:
                var entityName = tipe.a.he;
                return "Error Decoding " + entityName;
            case 1:
                var entityName = tipe.a.he;
                return entityName + " Not Found";
            case 3:
                var functionName = tipe.a.fm;
                return "Error Calling Cloud Function " + functionName;
            case 4:
                if (!tipe.a.$) {
                    var _v1 = tipe.a;
                    return "TimeZone Error: NoZoneName";
                }
                else {
                    return "TimeZone Error: NoDataForZoneName";
                }
            case 2:
                var entityName = tipe.a.he;
                return "Error Parsing " + entityName;
            case 8:
                return "Error Merging Persons";
            case 5:
                var code = tipe.a.gZ;
                return "Firestore Error: " + $author$project$Firestore$Error$codeToString(code);
            case 6:
                return "Search.Index.updateIndex errors";
            case 7:
                return "elm-rrule test failure";
            case 10:
                var authError = tipe.a;
                return "Auth Error: " + $author$project$Data$Auth$authErrorToString(authError);
            default:
                if (!tipe.a.$) {
                    return "Circular routing issue";
                }
                else {
                    var _v2 = tipe.a;
                    return "RouteToURLRequest should never be Nothing";
                }
        }
    };
    var $author$project$Error$encode = function (_v0) {
        var severity = _v0.a;
        var tipe = _v0.b;
        var helper = function (data) {
            return (new $$Record47($elm$json$Json$Encode$object(data), $author$project$Error$severityToString(severity), $author$project$Error$titleFromType(tipe)));
        };
        switch (tipe.$) {
            case 0:
                var decoderError = tipe.a.lg;
                return helper(_List_fromArray([
                    _Utils_Tuple2("decodeError", $elm$json$Json$Encode$string(decoderError))
                ]));
            case 1:
                var id = tipe.a.l8;
                return helper(_List_fromArray([
                    _Utils_Tuple2("id", $elm$json$Json$Encode$string(id))
                ]));
            case 4:
                var timezoneError = tipe.a;
                if (!timezoneError.$) {
                    return helper(_List_fromArray([
                        _Utils_Tuple2("reason", $elm$json$Json$Encode$string("Browser does not support 'Intl.DateTimeFormat().resolvedOptions().timeZone'"))
                    ]));
                }
                else {
                    var ianaName = timezoneError.a;
                    return helper(_List_fromArray([
                        _Utils_Tuple2("reason", $elm$json$Json$Encode$string("NoDataForZoneName")),
                        _Utils_Tuple2("ianaName", $elm$json$Json$Encode$string(ianaName))
                    ]));
                }
            case 3:
                var functionName = tipe.a.fm;
                var httpError = tipe.a.hM;
                return helper(_List_fromArray([
                    _Utils_Tuple2("functionName", $elm$json$Json$Encode$string(functionName)),
                    _Utils_Tuple2("httpError", $author$project$Error$encodeHttpError(httpError))
                ]));
            case 2:
                var message = tipe.a.m_;
                var value = tipe.a.p_;
                return helper(_List_fromArray([
                    _Utils_Tuple2("message", $elm$json$Json$Encode$string(message)),
                    _Utils_Tuple2("value", $elm$json$Json$Encode$string(value))
                ]));
            case 8:
                return helper(_List_Nil);
            case 5:
                var firestoreError = tipe.a;
                return helper(_List_fromArray([
                    _Utils_Tuple2("code", $elm$json$Json$Encode$string($author$project$Firestore$Error$codeToString(firestoreError.gZ))),
                    _Utils_Tuple2("message", $elm$json$Json$Encode$string(firestoreError.m_))
                ]));
            case 6:
                var errors = tipe.a;
                return helper(_List_fromArray([
                    _Utils_Tuple2("errors", $elm$json$Json$Encode$list_fn($elm$json$Json$Encode$string, errors))
                ]));
            case 7:
                var failedEventData = tipe.a;
                return helper(_List_fromArray([
                    _Utils_Tuple2("failedEvents", $elm$json$Json$Encode$list_fn($elm$json$Json$Encode$string, failedEventData))
                ]));
            case 10:
                var authError = tipe.a;
                return helper($author$project$Error$authErrorExtraData(authError));
            default:
                if (!tipe.a.$) {
                    var currentRoute = tipe.a.a.k6;
                    var nextRoute = tipe.a.a.ne;
                    return helper(_List_fromArray([
                        _Utils_Tuple2("currentRoute", $elm$json$Json$Encode$string(currentRoute)),
                        _Utils_Tuple2("nextRoute", $elm$json$Json$Encode$string(nextRoute))
                    ]));
                }
                else {
                    var _v3 = tipe.a;
                    return helper(_List_Nil);
                }
        }
    };
    var $author$project$Error$logError = _Platform_outgoingPort("logError", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("data", $elm$core$Basics$identity($.a)),
            _Utils_Tuple2("severity", $elm$json$Json$Encode$string($.f4)),
            _Utils_Tuple2("title", $elm$json$Json$Encode$string($.gj))
        ]));
    });
    var $author$project$Error$log_a0 = $author$project$Error$encode, $author$project$Error$log_a1 = $author$project$Error$logError, $author$project$Error$log = A2($elm$core$Basics$composeR, $author$project$Error$log_a0, $author$project$Error$log_a1);
    var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
    var $author$project$Model$HandleBacktalk = function (a) {
        return { $: 43, a: a };
    };
    var $author$project$Model$HandlePageMsg = function (a) {
        return { $: 42, a: a };
    };
    var $author$project$Model$PageActionItems = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Model$PageBilling = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Model$PageCalendar = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Model$PageCollate = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Model$PageDemo = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Model$PageHome = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Model$PageNotFound = { $: 12 };
    var $author$project$Model$PagePerson_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$Model$PagePerson = F2($author$project$Model$PagePerson_fn);
    var $author$project$Model$PageSearch = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Model$PageSettings = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Model$PageSignup_fn = function (a, b) {
        return { $: 9, a: a, b: b };
    }, $author$project$Model$PageSignup = F2($author$project$Model$PageSignup_fn);
    var $author$project$Model$SearchMsg = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Util$Cmd$executeMsg = function (msg) {
        return $elm$core$Task$perform_fn(function (_v0) {
            return msg;
        }, $elm$core$Task$succeed(0));
    };
    var $author$project$Search$Bar$personWeightComparator_fn = function (index, toId, personA, personB) {
        var toScore = function (person) {
            return $elm$core$Maybe$withDefault_fn(0, $elm$core$Dict$get_fn(toId(person), index.iz));
        };
        return _Utils_compare_fn(toScore(personB), toScore(personA));
    }, $author$project$Search$Bar$personWeightComparator = F4($author$project$Search$Bar$personWeightComparator_fn);
    var $justinmimbs$date$Date$compare_fn = function (_v0, _v1) {
        var a = _v0;
        var b = _v1;
        return _Utils_compare_fn(a, b);
    }, $justinmimbs$date$Date$compare = F2($justinmimbs$date$Date$compare_fn);
    var $justinmimbs$time_extra$Time$Extra$Day = 11;
    var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
    var $justinmimbs$time_extra$Time$Extra$Month = 2;
    var $justinmimbs$time_extra$Time$Extra$add_fn = function (interval, n, zone, posix) {
        add: while (true) {
            switch (interval) {
                case 15:
                    return $elm$time$Time$millisToPosix($elm$time$Time$posixToMillis(posix) + n);
                case 14:
                    var $temp$interval = 15, $temp$n = n * 1000, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
                case 13:
                    var $temp$interval = 15, $temp$n = n * 60000, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
                case 12:
                    var $temp$interval = 15, $temp$n = n * 3600000, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
                case 11:
                    return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$add_fn(3, n, $justinmimbs$date$Date$fromPosix_fn(zone, posix)), $justinmimbs$time_extra$Time$Extra$timeFromPosix_fn(zone, posix));
                case 2:
                    return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$add_fn(1, n, $justinmimbs$date$Date$fromPosix_fn(zone, posix)), $justinmimbs$time_extra$Time$Extra$timeFromPosix_fn(zone, posix));
                case 0:
                    var $temp$interval = 2, $temp$n = n * 12, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
                case 1:
                    var $temp$interval = 2, $temp$n = n * 3, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
                case 3:
                    var $temp$interval = 11, $temp$n = n * 7, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
                default:
                    var weekday = interval;
                    var $temp$interval = 11, $temp$n = n * 7, $temp$zone = zone, $temp$posix = posix;
                    interval = $temp$interval;
                    n = $temp$n;
                    zone = $temp$zone;
                    posix = $temp$posix;
                    continue add;
            }
        }
    }, $justinmimbs$time_extra$Time$Extra$add = F4($justinmimbs$time_extra$Time$Extra$add_fn);
    var $author$project$Util$Time$dateBoundaries_fn = function (zone, date) {
        var midnight = $author$project$Util$Time$dateToPosix_fn(zone, date);
        return _Utils_Tuple2(midnight, $justinmimbs$time_extra$Time$Extra$add_fn(11, 1, zone, midnight));
    }, $author$project$Util$Time$dateBoundaries = F2($author$project$Util$Time$dateBoundaries_fn);
    var $author$project$Util$Misc$tupleMap_fn = function (f, _v0) {
        var a1 = _v0.a;
        var a2 = _v0.b;
        return _Utils_Tuple2(f(a1), f(a2));
    }, $author$project$Util$Misc$tupleMap = F2($author$project$Util$Misc$tupleMap_fn);
    var $author$project$Data$Time$compare_fn = function (timezone, time1, time2) {
        var _v0 = _Utils_Tuple2(time1, time2);
        if (!_v0.a.$) {
            if (!_v0.b.$) {
                var t1 = _v0.a.a;
                var t2 = _v0.b.a;
                return _Utils_compare_fn($elm$time$Time$posixToMillis(t1.gh), $elm$time$Time$posixToMillis(t2.gh));
            }
            else {
                var time = _v0.a.a.gh;
                var date = _v0.b.a;
                var posix = $elm$time$Time$posixToMillis(time);
                var _v1 = $author$project$Util$Misc$tupleMap_fn($elm$time$Time$posixToMillis, $author$project$Util$Time$dateBoundaries_fn(timezone, date));
                var dateStart = _v1.a;
                var dateEnd = _v1.b;
                return (_Utils_cmp(posix, dateStart) < 0) ? 0 : ((_Utils_cmp(posix, dateEnd) > -1) ? 2 : 1);
            }
        }
        else {
            if (_v0.b.$ === 1) {
                var date1 = _v0.a.a;
                var date2 = _v0.b.a;
                return $justinmimbs$date$Date$compare_fn(date1, date2);
            }
            else {
                var date = _v0.a.a;
                var time = _v0.b.a.gh;
                var posix = $elm$time$Time$posixToMillis(time);
                var _v2 = $author$project$Util$Misc$tupleMap_fn($elm$time$Time$posixToMillis, $author$project$Util$Time$dateBoundaries_fn(timezone, date));
                var dateStart = _v2.a;
                var dateEnd = _v2.b;
                return (_Utils_cmp(posix, dateStart) < 0) ? 2 : ((_Utils_cmp(posix, dateEnd) > -1) ? 0 : 1);
            }
        }
    }, $author$project$Data$Time$compare = F3($author$project$Data$Time$compare_fn);
    var $author$project$Search$Bar$timeComparator_fn = function (currentZone, accessor, item1, item2) {
        return $author$project$Data$Time$compare_fn(currentZone, accessor(item2), accessor(item1));
    }, $author$project$Search$Bar$timeComparator = F4($author$project$Search$Bar$timeComparator_fn);
    var $author$project$Page$Search$config = function (env) {
        return (new $$Record48(true, {
            fk: A2($elm$core$Basics$composeR, function ($) {
                return $.ll;
            }, A2($elm$core$Basics$composeR, function ($) {
                return $.kc;
            }, A2($elm$core$Basics$composeR, function ($) {
                return $.lh;
            }, $elm$core$Basics$not))),
            fI: $elm$core$Maybe$Nothing,
            gd: $elm$core$Maybe$Just(A2($author$project$Search$Bar$timeComparator, env.pu, A2($elm$core$Basics$composeR, function ($) {
                return $.ll;
            }, A2($elm$core$Basics$composeR, function ($) {
                return $.l;
            }, function ($) {
                return $.gh;
            }))))
        }, {
            fk: A2($elm$core$Basics$composeR, function ($) {
                return $.ll;
            }, A2($elm$core$Basics$composeR, function ($) {
                return $.lh;
            }, $elm$core$Basics$not)),
            fI: $elm$core$Maybe$Nothing,
            gd: $elm$core$Maybe$Just(A2($author$project$Search$Bar$timeComparator, env.pu, A2($elm$core$Basics$composeR, function ($) {
                return $.ll;
            }, function ($) {
                return $.gh;
            })))
        }, {
            fk: A2($elm$core$Basics$composeR, function ($) {
                return $.ll;
            }, A2($elm$core$Basics$composeR, function ($) {
                return $.lh;
            }, $elm$core$Basics$not)),
            fI: $elm$core$Maybe$Nothing,
            gd: $elm$core$Maybe$Just(A2($author$project$Search$Bar$personWeightComparator, env.oq, function ($) {
                return $.l8;
            }))
        }));
    };
    var $truqu$elm_base64$Base64$Decode$pad = function (input) {
        var _v0 = $elm$core$String$length(input) % 4;
        switch (_v0) {
            case 3:
                return input + "=";
            case 2:
                return input + "==";
            default:
                return input;
        }
    };
    var $truqu$elm_base64$Base64$Decode$charToInt = function (_char) {
        switch (_char) {
            case "A":
                return 0;
            case "B":
                return 1;
            case "C":
                return 2;
            case "D":
                return 3;
            case "E":
                return 4;
            case "F":
                return 5;
            case "G":
                return 6;
            case "H":
                return 7;
            case "I":
                return 8;
            case "J":
                return 9;
            case "K":
                return 10;
            case "L":
                return 11;
            case "M":
                return 12;
            case "N":
                return 13;
            case "O":
                return 14;
            case "P":
                return 15;
            case "Q":
                return 16;
            case "R":
                return 17;
            case "S":
                return 18;
            case "T":
                return 19;
            case "U":
                return 20;
            case "V":
                return 21;
            case "W":
                return 22;
            case "X":
                return 23;
            case "Y":
                return 24;
            case "Z":
                return 25;
            case "a":
                return 26;
            case "b":
                return 27;
            case "c":
                return 28;
            case "d":
                return 29;
            case "e":
                return 30;
            case "f":
                return 31;
            case "g":
                return 32;
            case "h":
                return 33;
            case "i":
                return 34;
            case "j":
                return 35;
            case "k":
                return 36;
            case "l":
                return 37;
            case "m":
                return 38;
            case "n":
                return 39;
            case "o":
                return 40;
            case "p":
                return 41;
            case "q":
                return 42;
            case "r":
                return 43;
            case "s":
                return 44;
            case "t":
                return 45;
            case "u":
                return 46;
            case "v":
                return 47;
            case "w":
                return 48;
            case "x":
                return 49;
            case "y":
                return 50;
            case "z":
                return 51;
            case "0":
                return 52;
            case "1":
                return 53;
            case "2":
                return 54;
            case "3":
                return 55;
            case "4":
                return 56;
            case "5":
                return 57;
            case "6":
                return 58;
            case "7":
                return 59;
            case "8":
                return 60;
            case "9":
                return 61;
            case "+":
                return 62;
            case "/":
                return 63;
            default:
                return 0;
        }
    };
    var $elm$core$Char$fromCode = _Char_fromCode;
    var $truqu$elm_base64$Base64$Decode$intToString_a0 = $elm$core$Char$fromCode, $truqu$elm_base64$Base64$Decode$intToString_a1 = $elm$core$String$fromChar, $truqu$elm_base64$Base64$Decode$intToString = A2($elm$core$Basics$composeR, $truqu$elm_base64$Base64$Decode$intToString_a0, $truqu$elm_base64$Base64$Decode$intToString_a1);
    var $truqu$elm_base64$Base64$Decode$add_fn = function (_char, _v0) {
        var curr = _v0.a;
        var need = _v0.b;
        var res = _v0.c;
        var shiftAndAdd = function (_int) {
            return (63 & _int) | (curr << 6);
        };
        return (!need) ? ((!(128 & _char)) ? _Utils_Tuple3(0, 0, _Utils_ap(res, $elm$core$Basics$composeR_fn($truqu$elm_base64$Base64$Decode$intToString_a0, $truqu$elm_base64$Base64$Decode$intToString_a1, _char))) : (((224 & _char) === 192) ? _Utils_Tuple3(31 & _char, 1, res) : (((240 & _char) === 224) ? _Utils_Tuple3(15 & _char, 2, res) : _Utils_Tuple3(7 & _char, 3, res)))) : ((need === 1) ? _Utils_Tuple3(0, 0, _Utils_ap(res, $elm$core$Basics$composeR_fn($truqu$elm_base64$Base64$Decode$intToString_a0, $truqu$elm_base64$Base64$Decode$intToString_a1, shiftAndAdd(_char)))) : _Utils_Tuple3(shiftAndAdd(_char), need - 1, res));
    }, $truqu$elm_base64$Base64$Decode$add = F2($truqu$elm_base64$Base64$Decode$add_fn);
    var $truqu$elm_base64$Base64$Decode$toUTF16_fn = function (_char, acc) {
        return _Utils_Tuple3(0, 0, $truqu$elm_base64$Base64$Decode$add_fn(255 & (_char >>> 0), $truqu$elm_base64$Base64$Decode$add_fn(255 & (_char >>> 8), $truqu$elm_base64$Base64$Decode$add_fn(255 & (_char >>> 16), acc))));
    }, $truqu$elm_base64$Base64$Decode$toUTF16 = F2($truqu$elm_base64$Base64$Decode$toUTF16_fn);
    var $truqu$elm_base64$Base64$Decode$chomp_fn = function (char_, _v0) {
        var curr = _v0.a;
        var cnt = _v0.b;
        var utf8ToUtf16 = _v0.c;
        var _char = $truqu$elm_base64$Base64$Decode$charToInt(char_);
        if (cnt === 3) {
            return $truqu$elm_base64$Base64$Decode$toUTF16_fn(curr | _char, utf8ToUtf16);
        }
        else {
            return _Utils_Tuple3((_char << ((3 - cnt) * 6)) | curr, cnt + 1, utf8ToUtf16);
        }
    }, $truqu$elm_base64$Base64$Decode$chomp = F2($truqu$elm_base64$Base64$Decode$chomp_fn);
    var $elm$core$String$foldl = _String_foldl;
    var $truqu$elm_base64$Base64$Decode$initial = _Utils_Tuple3(0, 0, _Utils_Tuple3(0, 0, ""));
    var $elm$core$String$dropRight_fn = function (n, string) {
        return (n < 1) ? string : _String_slice_fn(0, -n, string);
    }, $elm$core$String$dropRight = F2($elm$core$String$dropRight_fn);
    var $elm$core$String$endsWith = _String_endsWith;
    var $truqu$elm_base64$Base64$Decode$stripNulls_fn = function (input, output) {
        return _String_endsWith_fn("==", input) ? $elm$core$String$dropRight_fn(2, output) : (_String_endsWith_fn("=", input) ? $elm$core$String$dropRight_fn(1, output) : output);
    }, $truqu$elm_base64$Base64$Decode$stripNulls = F2($truqu$elm_base64$Base64$Decode$stripNulls_fn);
    var $elm$regex$Regex$contains = _Regex_contains;
    var $truqu$elm_base64$Base64$Decode$validBase64Regex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^([A-Za-z0-9\\/+]{4})*([A-Za-z0-9\\/+]{2}[A-Za-z0-9\\/+=]{2})?$"));
    var $truqu$elm_base64$Base64$Decode$validate = function (input) {
        return _Regex_contains_fn($truqu$elm_base64$Base64$Decode$validBase64Regex, input) ? $elm$core$Result$Ok(input) : $elm$core$Result$Err("Invalid base64");
    };
    var $truqu$elm_base64$Base64$Decode$wrapUp = function (_v0) {
        var _v1 = _v0.c;
        var need = _v1.b;
        var res = _v1.c;
        return (need > 0) ? $elm$core$Result$Err("Invalid UTF-16") : $elm$core$Result$Ok(res);
    };
    var $truqu$elm_base64$Base64$Decode$validateAndDecode = function (input) {
        return $elm$core$Result$map_fn($truqu$elm_base64$Base64$Decode$stripNulls(input), $elm$core$Result$andThen_fn(A2($elm$core$Basics$composeR, A2($elm$core$String$foldl, $truqu$elm_base64$Base64$Decode$chomp, $truqu$elm_base64$Base64$Decode$initial), $truqu$elm_base64$Base64$Decode$wrapUp), $truqu$elm_base64$Base64$Decode$validate(input)));
    };
    var $truqu$elm_base64$Base64$Decode$decode_a0 = $truqu$elm_base64$Base64$Decode$pad, $truqu$elm_base64$Base64$Decode$decode_a1 = $truqu$elm_base64$Base64$Decode$validateAndDecode, $truqu$elm_base64$Base64$Decode$decode = A2($elm$core$Basics$composeR, $truqu$elm_base64$Base64$Decode$decode_a0, $truqu$elm_base64$Base64$Decode$decode_a1);
    var $truqu$elm_base64$Base64$decode = $truqu$elm_base64$Base64$Decode$decode;
    var $author$project$Util$UrlBase64$replaceFromUrl = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[-_]"));
    var $author$project$Util$UrlBase64$decode = function (str) {
        var strlen = $elm$core$String$length(str);
        var replaceChar = function (rematch) {
            var _v0 = rematch.by;
            if (_v0 === "-") {
                return "+";
            }
            else {
                return "/";
            }
        };
        var hanging = (!strlen) ? 4 : _Basics_modBy_fn(4, strlen);
        var ilen = (!hanging) ? 0 : (4 - hanging);
        return $truqu$elm_base64$Base64$decode(_Regex_replaceAtMost_fn($elm$regex$Regex$replace_a0, $author$project$Util$UrlBase64$replaceFromUrl, replaceChar, _Utils_ap(str, $elm$core$String$repeat_fn(ilen, "="))));
    };
    var $author$project$Search$Query$ParseAcc_fn = function (skipString, query) {
        return (new $$Record49(query, skipString));
    }, $author$project$Search$Query$ParseAcc = F2($author$project$Search$Query$ParseAcc_fn);
    var $author$project$Util$Misc$window2Builder_fn = function (next, accum) {
        if (!accum.b) {
            return _List_fromArray([
                _Utils_Tuple2(next, $elm$core$Maybe$Nothing)
            ]);
        }
        else {
            if (accum.a.b.$ === 1) {
                if (!accum.b.b) {
                    var _v1 = accum.a;
                    var current = _v1.a;
                    var _v2 = _v1.b;
                    return _List_fromArray([
                        _Utils_Tuple2(current, $elm$core$Maybe$Just(next))
                    ]);
                }
                else {
                    return _List_Nil;
                }
            }
            else {
                var _v3 = accum.a;
                var toCurrent = _v3.b.a;
                return _List_Cons(_Utils_Tuple2(toCurrent, $elm$core$Maybe$Just(next)), accum);
            }
        }
    }, $author$project$Util$Misc$window2Builder = F2($author$project$Util$Misc$window2Builder_fn);
    var $author$project$Util$Misc$foldl2_fn = function (func, accum, list) {
        var xs = $elm$core$List$foldl_fn($author$project$Util$Misc$window2Builder, _List_Nil, list);
        var xsWithLastItem = function () {
            if (!xs.b) {
                return _List_Nil;
            }
            else {
                if (!xs.a.b.$) {
                    var _v2 = xs.a;
                    var toCurrent = _v2.b.a;
                    return _List_Cons(_Utils_Tuple2(toCurrent, $elm$core$Maybe$Nothing), xs);
                }
                else {
                    return xs;
                }
            }
        }();
        var uncurried = function (_v0) {
            var current = _v0.a;
            var mNext = _v0.b;
            return A2(func, current, mNext);
        };
        return $elm$core$List$foldr_fn(uncurried, accum, xsWithLastItem);
    }, $author$project$Util$Misc$foldl2_fn_unwrapped = function (func, accum, list) {
        var xs = $elm$core$List$foldl_fn($author$project$Util$Misc$window2Builder, _List_Nil, list);
        var xsWithLastItem = function () {
            if (!xs.b) {
                return _List_Nil;
            }
            else {
                if (!xs.a.b.$) {
                    var _v2 = xs.a;
                    var toCurrent = _v2.b.a;
                    return _List_Cons(_Utils_Tuple2(toCurrent, $elm$core$Maybe$Nothing), xs);
                }
                else {
                    return xs;
                }
            }
        }();
        var uncurried = function (_v0) {
            var current = _v0.a;
            var mNext = _v0.b;
            return func(current, mNext);
        };
        return $elm$core$List$foldr_fn(uncurried, accum, xsWithLastItem);
    }, $author$project$Util$Misc$foldl2 = F3($author$project$Util$Misc$foldl2_fn);
    var $author$project$Search$Query$StringFilter = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Search$Query$After = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Search$Query$Before = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Search$Query$Event_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Search$Query$Event = F2($author$project$Search$Query$Event_fn);
    var $author$project$Search$Query$File = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Search$Query$In = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Search$Query$MeetingSearch = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Search$Query$Person_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Search$Query$Person = F2($author$project$Search$Query$Person_fn);
    var $author$project$Search$Query$PersonSearch = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Search$Query$With = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Search$Query$Audio = 4;
    var $author$project$Search$Query$Document = 1;
    var $author$project$Search$Query$Image = 2;
    var $author$project$Search$Query$PDF = 0;
    var $author$project$Search$Query$Video = 3;
    var $author$project$Search$Query$stringToFileType = function (fileType) {
        switch (fileType) {
            case "PDF":
                return $elm$core$Maybe$Just(0);
            case "document":
                return $elm$core$Maybe$Just(1);
            case "image":
                return $elm$core$Maybe$Just(2);
            case "video":
                return $elm$core$Maybe$Just(3);
            case "audio":
                return $elm$core$Maybe$Just(4);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Search$Query$handleKeyword_fn = function (keyword, mNextToken, acc) {
        var skipString = acc.f5;
        var query = acc.n$;
        var handleFileType = function (_v7) {
            return $elm$core$Maybe$andThen_fn(function (token) {
                if (token.$ === 1) {
                    var str = token.a;
                    return $elm$core$Maybe$map_fn($author$project$Search$Query$File, $author$project$Search$Query$stringToFileType(str));
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }, mNextToken);
        };
        var addFilter = function (filter) {
            return $author$project$Search$Query$ParseAcc_fn(true, _List_Cons(filter, query));
        };
        var handleDate = function (tagger) {
            if ((!mNextToken.$) && (mNextToken.a.$ === 1)) {
                var str = mNextToken.a.a;
                return $elm$core$Result$withDefault_fn($author$project$Search$Query$ParseAcc_fn(true, query), $elm$core$Result$map_fn(A2($elm$core$Basics$composeR, tagger, addFilter), $elm$core$Basics$composeR_fn($justinmimbs$date$Date$fromIsoString_a0, $justinmimbs$date$Date$fromIsoString_a1, str)));
            }
            else {
                return $author$project$Search$Query$ParseAcc_fn(true, query);
            }
        };
        switch (keyword) {
            case "in":
                _v1$3: while (true) {
                    if (!mNextToken.$) {
                        switch (mNextToken.a.$) {
                            case 0:
                                if (!mNextToken.a.a.$) {
                                    var _v2 = mNextToken.a.a;
                                    var eventTitle = _v2.a;
                                    var eventId = _v2.b;
                                    return addFilter($author$project$Search$Query$In($author$project$Search$Query$Event_fn(eventTitle, eventId)));
                                }
                                else {
                                    break _v1$3;
                                }
                            case 1:
                                var str = mNextToken.a.a;
                                return addFilter($author$project$Search$Query$In($author$project$Search$Query$MeetingSearch(str)));
                            default:
                                break _v1$3;
                        }
                    }
                    else {
                        return addFilter($author$project$Search$Query$In($author$project$Search$Query$MeetingSearch("")));
                    }
                }
                return $author$project$Search$Query$ParseAcc_fn(true, query);
            case "with":
                _v3$3: while (true) {
                    if (!mNextToken.$) {
                        switch (mNextToken.a.$) {
                            case 0:
                                if (mNextToken.a.a.$ === 1) {
                                    var _v4 = mNextToken.a.a;
                                    var personName = _v4.a;
                                    var personId = _v4.b;
                                    return addFilter($author$project$Search$Query$With($author$project$Search$Query$Person_fn(personName, personId)));
                                }
                                else {
                                    break _v3$3;
                                }
                            case 1:
                                var str = mNextToken.a.a;
                                return addFilter($author$project$Search$Query$With($author$project$Search$Query$PersonSearch(str)));
                            default:
                                break _v3$3;
                        }
                    }
                    else {
                        return addFilter($author$project$Search$Query$With($author$project$Search$Query$PersonSearch("")));
                    }
                }
                return $author$project$Search$Query$ParseAcc_fn(true, query);
            case "before":
                return handleDate($author$project$Search$Query$Before);
            case "after":
                return handleDate($author$project$Search$Query$After);
            case "file-type":
                return $elm$core$Maybe$withDefault_fn($author$project$Search$Query$ParseAcc_fn(true, query), $elm$core$Maybe$map_fn(addFilter, handleFileType(0)));
            default:
                return acc;
        }
    }, $author$project$Search$Query$handleKeyword = F3($author$project$Search$Query$handleKeyword_fn);
    var $author$project$Search$Query$tokenReducer_fn = function (token, mNextToken, acc) {
        var skipString = acc.f5;
        var query = acc.n$;
        switch (token.$) {
            case 2:
                var keyword = token.a;
                return $author$project$Search$Query$handleKeyword_fn(keyword, mNextToken, acc);
            case 1:
                var str = token.a;
                return skipString ? $author$project$Search$Query$ParseAcc_fn(false, query) : $author$project$Search$Query$ParseAcc_fn(false, _List_Cons($author$project$Search$Query$StringFilter(str), query));
            default:
                return $author$project$Search$Query$ParseAcc_fn(false, query);
        }
    }, $author$project$Search$Query$tokenReducer = F3($author$project$Search$Query$tokenReducer_fn);
    var $author$project$Search$Query$parse_a0 = A2($author$project$Util$Misc$foldl2, $author$project$Search$Query$tokenReducer, $author$project$Search$Query$ParseAcc_fn(false, _List_Nil)), $author$project$Search$Query$parse_a1 = A2($elm$core$Basics$composeR, function ($) {
        return $.n$;
    }, $elm$core$List$reverse), $author$project$Search$Query$parse = A2($elm$core$Basics$composeR, $author$project$Search$Query$parse_a0, $author$project$Search$Query$parse_a1);
    var $author$project$Search$Query$EventChip_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Search$Query$EventChip = F2($author$project$Search$Query$EventChip_fn);
    var $author$project$Search$Query$PersonChip_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $author$project$Search$Query$PersonChip = F2($author$project$Search$Query$PersonChip_fn);
    var $author$project$Search$Query$RawQueryChip = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Search$Query$RawQueryString = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Search$Query$rawQueryDecoder = function () {
        var decoderFromType = function (tipe) {
            switch (tipe) {
                case "text":
                    return _Json_map1_fn($author$project$Search$Query$RawQueryString, _Json_decodeField_fn("text", $elm$json$Json$Decode$string));
                case "event":
                    return _Json_map2_fn(F2(function (title, eventId) {
                        return $author$project$Search$Query$RawQueryChip($author$project$Search$Query$EventChip_fn(title, eventId));
                    }), _Json_decodeField_fn("eventTitle", $elm$json$Json$Decode$string), _Json_decodeField_fn("eventId", $elm$json$Json$Decode$string));
                case "person":
                    return _Json_map2_fn(F2(function (name, personId) {
                        return $author$project$Search$Query$RawQueryChip($author$project$Search$Query$PersonChip_fn(name, personId));
                    }), _Json_decodeField_fn("personName", $elm$json$Json$Decode$string), _Json_decodeField_fn("personId", $elm$json$Json$Decode$string));
                default:
                    return $elm$json$Json$Decode$fail("unrecognized raw query type: " + tipe);
            }
        };
        return $elm$json$Json$Decode$list(_Json_andThen_fn(decoderFromType, _Json_decodeField_fn("type", $elm$json$Json$Decode$string)));
    }();
    var $author$project$Search$Query$ChipToken = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Search$Query$KeywordToken = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Search$Query$StringToken = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Search$Query$stringToTokens = function (str) {
        var reducer = F2(function (_char, _v2) {
            var wordAcc = _v2.a;
            var tokensAcc = _v2.b;
            switch (_char) {
                case " ":
                    return (wordAcc === "") ? _Utils_Tuple2("", tokensAcc) : _Utils_Tuple2("", _List_Cons($author$project$Search$Query$StringToken(wordAcc), tokensAcc));
                case ":":
                    return _Utils_Tuple2("", _List_Cons($author$project$Search$Query$KeywordToken(wordAcc), tokensAcc));
                default:
                    return _Utils_Tuple2(_Utils_ap(wordAcc, $elm$core$String$fromChar(_char)), tokensAcc);
            }
        });
        return $elm$core$List$reverse(function (_v0) {
            var wordAcc = _v0.a;
            var tokensAcc = _v0.b;
            return (wordAcc === "") ? tokensAcc : _List_Cons($author$project$Search$Query$StringToken(wordAcc), tokensAcc);
        }($elm$core$List$foldl_fn(reducer, _Utils_Tuple2("", _List_Nil), $elm$core$String$toList(str))));
    };
    var $author$project$Search$Query$rawQueryToTokens_a0 = function (rawQuery) {
        if (rawQuery.$ === 1) {
            var str = rawQuery.a;
            return $author$project$Search$Query$stringToTokens(str);
        }
        else {
            var chip = rawQuery.a;
            return _List_fromArray([
                $author$project$Search$Query$ChipToken(chip)
            ]);
        }
    }, $author$project$Search$Query$rawQueryToTokens = $elm$core$List$concatMap($author$project$Search$Query$rawQueryToTokens_a0);
    var $author$project$Search$Query$decoder = _Json_map1_fn(A2($elm$core$Basics$composeR, $author$project$Search$Query$rawQueryToTokens, $author$project$Search$Query$parse), $author$project$Search$Query$rawQueryDecoder);
    var $author$project$Page$Search$defaultCategory = 0;
    var $author$project$Search$Result$AttachmentData_fn = function (noteId, note, attachment) {
        return { kc: attachment, l: note, ip: noteId };
    }, $author$project$Search$Result$AttachmentData = F3($author$project$Search$Result$AttachmentData_fn);
    var $author$project$Search$Result$AttachmentEntity = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Search$Result$NoteEntity = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Search$Result$PersonEntity = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Search$Result$UnindexedDoc_fn = function (id, doc) {
        return (new $$Record50(doc, id));
    }, $author$project$Search$Result$UnindexedDoc = F2($author$project$Search$Result$UnindexedDoc_fn);
    var $author$project$Firestore$Collection$foldrWithState_fn = function (reducer, initial, _v0) {
        var collection = _v0;
        return $elm$core$Dict$foldr_fn_unwrapped(function (id, _v1, accum) {
            var state = _v1.a;
            var doc = _v1.b;
            return A4(reducer, id, state, doc, accum);
        }, initial, collection.n);
    }, $author$project$Firestore$Collection$foldrWithState_fn_unwrapped = function (reducer, initial, _v0) {
        var collection = _v0;
        return $elm$core$Dict$foldr_fn_unwrapped(function (id, _v1, accum) {
            var state = _v1.a;
            var doc = _v1.b;
            return reducer(id, state, doc, accum);
        }, initial, collection.n);
    }, $author$project$Firestore$Collection$foldrWithState = F3($author$project$Firestore$Collection$foldrWithState_fn);
    var $author$project$Firestore$Collection$filterMapWithState = function (filterFn) {
        return A2($author$project$Firestore$Collection$foldrWithState, F4(function (id, state, doc, accum) {
            var _v0 = A3(filterFn, id, state, doc);
            if (!_v0.$) {
                var b = _v0.a;
                return _List_Cons(b, accum);
            }
            else {
                return accum;
            }
        }), _List_Nil);
    }, $author$project$Firestore$Collection$filterMapWithState_unwrapped = function (filterFn) {
        return A2($author$project$Firestore$Collection$foldrWithState, F4(function (id, state, doc, accum) {
            var _v0 = filterFn(id, state, doc);
            if (!_v0.$) {
                var b = _v0.a;
                return _List_Cons(b, accum);
            }
            else {
                return accum;
            }
        }), _List_Nil);
    };
    var $author$project$Firestore$Collection$filterMap = function (filterFn) {
        var filterFn_ = F3(function (id, state, doc) {
            switch (state) {
                case 6:
                    return $elm$core$Maybe$Nothing;
                case 5:
                    return $elm$core$Maybe$Nothing;
                case 0:
                    return $elm$core$Maybe$Nothing;
                default:
                    return A2(filterFn, id, doc);
            }
        });
        return $author$project$Firestore$Collection$filterMapWithState(filterFn_);
    }, $author$project$Firestore$Collection$filterMap_unwrapped = function (filterFn) {
        var filterFn_ = F3(function (id, state, doc) {
            switch (state) {
                case 6:
                    return $elm$core$Maybe$Nothing;
                case 5:
                    return $elm$core$Maybe$Nothing;
                case 0:
                    return $elm$core$Maybe$Nothing;
                default:
                    return filterFn(id, doc);
            }
        });
        return $author$project$Firestore$Collection$filterMapWithState(filterFn_);
    };
    var $elm$core$List$maybeCons_fn = function (f, mx, xs) {
        var _v0 = f(mx);
        if (!_v0.$) {
            var x = _v0.a;
            return _List_Cons(x, xs);
        }
        else {
            return xs;
        }
    }, $elm$core$List$maybeCons = F3($elm$core$List$maybeCons_fn);
    var $elm$core$List$filterMap_fn = function (f, xs) {
        return $elm$core$List$foldr_fn($elm$core$List$maybeCons(f), _List_Nil, xs);
    }, $elm$core$List$filterMap = F2($elm$core$List$filterMap_fn);
    var $author$project$Firestore$Collection$foldlWithState_fn = function (reducer, initial, _v0) {
        var collection = _v0;
        return $elm$core$Dict$foldl_fn_unwrapped(function (id, _v1, accum) {
            var state = _v1.a;
            var doc = _v1.b;
            return A4(reducer, id, state, doc, accum);
        }, initial, collection.n);
    }, $author$project$Firestore$Collection$foldlWithState_fn_unwrapped = function (reducer, initial, _v0) {
        var collection = _v0;
        return $elm$core$Dict$foldl_fn_unwrapped(function (id, _v1, accum) {
            var state = _v1.a;
            var doc = _v1.b;
            return reducer(id, state, doc, accum);
        }, initial, collection.n);
    }, $author$project$Firestore$Collection$foldlWithState = F3($author$project$Firestore$Collection$foldlWithState_fn);
    var $author$project$Firestore$Collection$reducerHelper_fn = function (reducer, id, state, doc, accum) {
        switch (state) {
            case 6:
                return accum;
            case 5:
                return accum;
            case 0:
                return accum;
            default:
                return A3(reducer, id, doc, accum);
        }
    }, $author$project$Firestore$Collection$reducerHelper_fn_unwrapped = function (reducer, id, state, doc, accum) {
        switch (state) {
            case 6:
                return accum;
            case 5:
                return accum;
            case 0:
                return accum;
            default:
                return reducer(id, doc, accum);
        }
    }, $author$project$Firestore$Collection$reducerHelper = F5($author$project$Firestore$Collection$reducerHelper_fn);
    var $author$project$Firestore$Collection$foldl = function (reducer) {
        return $author$project$Firestore$Collection$foldlWithState($author$project$Firestore$Collection$reducerHelper(reducer));
    };
    var $elm$core$List$sortWith = _List_sortWith;
    var $elm$core$List$takeReverse_fn = function (n, list, kept) {
        takeReverse: while (true) {
            if (n <= 0) {
                return kept;
            }
            else {
                if (!list.b) {
                    return kept;
                }
                else {
                    var x = list.a;
                    var xs = list.b;
                    var $temp$n = n - 1, $temp$list = xs, $temp$kept = _List_Cons(x, kept);
                    n = $temp$n;
                    list = $temp$list;
                    kept = $temp$kept;
                    continue takeReverse;
                }
            }
        }
    }, $elm$core$List$takeReverse = F3($elm$core$List$takeReverse_fn);
    var $elm$core$List$takeTailRec_fn = function (n, list) {
        return $elm$core$List$reverse($elm$core$List$takeReverse_fn(n, list, _List_Nil));
    }, $elm$core$List$takeTailRec = F2($elm$core$List$takeTailRec_fn);
    var $elm$core$List$takeFast_fn = function (ctr, n, list) {
        if (n <= 0) {
            return _List_Nil;
        }
        else {
            var _v0 = _Utils_Tuple2(n, list);
            _v0$1: while (true) {
                _v0$5: while (true) {
                    if (!_v0.b.b) {
                        return list;
                    }
                    else {
                        if (_v0.b.b.b) {
                            switch (_v0.a) {
                                case 1:
                                    break _v0$1;
                                case 2:
                                    var _v2 = _v0.b;
                                    var x = _v2.a;
                                    var _v3 = _v2.b;
                                    var y = _v3.a;
                                    return _List_fromArray([x, y]);
                                case 3:
                                    if (_v0.b.b.b.b) {
                                        var _v4 = _v0.b;
                                        var x = _v4.a;
                                        var _v5 = _v4.b;
                                        var y = _v5.a;
                                        var _v6 = _v5.b;
                                        var z = _v6.a;
                                        return _List_fromArray([x, y, z]);
                                    }
                                    else {
                                        break _v0$5;
                                    }
                                default:
                                    if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
                                        var _v7 = _v0.b;
                                        var x = _v7.a;
                                        var _v8 = _v7.b;
                                        var y = _v8.a;
                                        var _v9 = _v8.b;
                                        var z = _v9.a;
                                        var _v10 = _v9.b;
                                        var w = _v10.a;
                                        var tl = _v10.b;
                                        return (ctr > 1000) ? _List_Cons(x, _List_Cons(y, _List_Cons(z, _List_Cons(w, $elm$core$List$takeTailRec_fn(n - 4, tl))))) : _List_Cons(x, _List_Cons(y, _List_Cons(z, _List_Cons(w, $elm$core$List$takeFast_fn(ctr + 1, n - 4, tl)))));
                                    }
                                    else {
                                        break _v0$5;
                                    }
                            }
                        }
                        else {
                            if (_v0.a === 1) {
                                break _v0$1;
                            }
                            else {
                                break _v0$5;
                            }
                        }
                    }
                }
                return list;
            }
            var _v1 = _v0.b;
            var x = _v1.a;
            return _List_fromArray([x]);
        }
    }, $elm$core$List$takeFast = F3($elm$core$List$takeFast_fn);
    var $elm$core$List$take_fn = function (n, xs) {
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (var i = 0; i < n && xs.b; xs = xs.
            b, i++) {
            var next = _List_Cons(xs.a, _List_Nil);
            end.b = next;
            end = next;
        }
        return tmp.b;
    }, $elm$core$List$take = F2($elm$core$List$take_fn);
    var $author$project$Util$Misc$toJustIf_fn = function (condition, a) {
        return condition ? $elm$core$Maybe$Just(a) : $elm$core$Maybe$Nothing;
    }, $author$project$Util$Misc$toJustIf = F2($author$project$Util$Misc$toJustIf_fn);
    var $author$project$Search$Result$allEntities_fn = function (env, config, mCategory) {
        var taker = A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$core$List$take), $elm$core$Maybe$withDefault($elm$core$Basics$identity));
        var sorter = A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$core$List$sortWith), $elm$core$Maybe$withDefault($elm$core$Basics$identity));
        var personMapper = F2(function (id, person) {
            var item = $author$project$Search$Result$UnindexedDoc_fn(id, person);
            return $author$project$Util$Misc$toJustIf_fn(config.iz.fk(item), item);
        });
        var people = function (_v7) {
            return $elm$core$List$map_fn($author$project$Search$Result$PersonEntity, A2(taker, config.iz.fI, A2(sorter, config.iz.gd, A2($author$project$Firestore$Collection$filterMap, personMapper, env.iz))));
        };
        var attachmentsMapper = F3(function (noteId, note, attachment) {
            var item = $author$project$Search$Result$UnindexedDoc_fn(attachment.Y, $author$project$Search$Result$AttachmentData_fn(noteId, note, attachment));
            return $author$project$Util$Misc$toJustIf_fn(config.kd.fk(item), item);
        });
        var noteReducer = F3(function (noteId, note, acc) {
            var notes = acc.fO;
            var attachments = acc.kd;
            var item = $author$project$Search$Result$UnindexedDoc_fn(noteId, note);
            return (!config.fO.fk(item)) ? acc : (new $$Record51(_Utils_ap($elm$core$List$filterMap_fn(A2(attachmentsMapper, noteId, note), note.kd), attachments), _List_Cons(item, notes)));
        });
        var noteAndAttachments = function (_v6) {
            return function (_v5) {
                var notes = _v5.fO;
                var attachments = _v5.kd;
                return (new $$Record51($elm$core$List$map_fn($author$project$Search$Result$AttachmentEntity, A2(taker, config.kd.fI, A2(sorter, config.kd.gd, attachments))), $elm$core$List$map_fn($author$project$Search$Result$NoteEntity, A2(taker, config.fO.fI, A2(sorter, config.fO.gd, notes)))));
            }(A3($author$project$Firestore$Collection$foldl, noteReducer, (new $$Record51(_List_Nil, _List_Nil)), env.fO));
        };
        if (mCategory.$ === 1) {
            var _v1 = noteAndAttachments(0);
            var notes = _v1.fO;
            var attachments = _v1.kd;
            return $elm$core$List$concat(_List_fromArray([
                notes,
                people(0),
                attachments
            ]));
        }
        else {
            switch (mCategory.a) {
                case 0:
                    var _v2 = mCategory.a;
                    return noteAndAttachments(0).fO;
                case 1:
                    var _v3 = mCategory.a;
                    return people(0);
                default:
                    var _v4 = mCategory.a;
                    return noteAndAttachments(0).kd;
            }
        }
    }, $author$project$Search$Result$allEntities = F3($author$project$Search$Result$allEntities_fn);
    var $elm$core$List$any_fn = function (isOkay, list) {
        any: while (true) {
            if (!list.b) {
                return false;
            }
            else {
                var x = list.a;
                var xs = list.b;
                if (isOkay(x)) {
                    return true;
                }
                else {
                    var $temp$isOkay = isOkay, $temp$list = xs;
                    isOkay = $temp$isOkay;
                    list = $temp$list;
                    continue any;
                }
            }
        }
    }, $elm$core$List$any = F2($elm$core$List$any_fn);
    var $elm$core$List$member_fn = function (x, xs) {
        return $elm$core$List$any_fn(function (a) {
            return _Utils_eq(a, x);
        }, xs);
    }, $elm$core$List$member = F2($elm$core$List$member_fn);
    var $author$project$Search$Result$attachmentIsFileType_fn = function (fileType, attachment) {
        return function () {
            switch (fileType) {
                case 0:
                    return $elm$core$Basics$eq("application/pdf");
                case 1:
                    return function (mimeType) {
                        return $elm$core$List$member_fn(mimeType, _List_fromArray(["application/pdf", "text/csv", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.apple.keynote"])) || _String_startsWith_fn("text/", mimeType);
                    };
                case 2:
                    return $elm$core$String$startsWith("image/");
                case 3:
                    return $elm$core$String$startsWith("video/");
                default:
                    return $elm$core$String$startsWith("audio/");
            }
        }()(attachment.c1);
    }, $author$project$Search$Result$attachmentIsFileType = F2($author$project$Search$Result$attachmentIsFileType_fn);
    var $elm$core$List$head = function (list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just(x);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $elm_community$string_extra$String$Extra$leftOfBack_fn = function (pattern, string) {
        return $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn(function (a) {
            return $elm$core$String$left_fn(a, string);
        }, $elm$core$List$head($elm$core$List$reverse(_String_indexes_fn(pattern, string)))));
    }, $elm_community$string_extra$String$Extra$leftOfBack = F2($elm_community$string_extra$String$Extra$leftOfBack_fn);
    var $author$project$Data$Event$baseId = function (id) {
        var newId = $elm_community$string_extra$String$Extra$leftOfBack_fn("_", id);
        return $elm$core$String$isEmpty(newId) ? id : newId;
    };
    var $elm$core$List$filter_fn = function (f, xs) {
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        for (; xs.b; xs = xs.b) {
            if (f(xs.a)) {
                var next = _List_Cons(xs.a, _List_Nil);
                end.b = next;
                end = next;
            }
        }
        return tmp.
            b;
    }, $elm$core$List$filter = F2($elm$core$List$filter_fn);
    var $elm_community$basics_extra$Basics$Extra$flip_fn = function (f, b, a) {
        return A2(f, a, b);
    }, $elm_community$basics_extra$Basics$Extra$flip_fn_unwrapped = function (f, b, a) {
        return f(a, b);
    }, $elm_community$basics_extra$Basics$Extra$flip = F3($elm_community$basics_extra$Basics$Extra$flip_fn);
    var $author$project$Data$Note$getEventId = function (note) {
        return $elm$core$Maybe$map_fn(function (ref) {
            if (!ref.$) {
                var single = ref.a;
                return single.b7;
            }
            else {
                var instanceId = ref.a.Q;
                return instanceId;
            }
        }, note.hh);
    };
    var $author$project$Data$Person$resolvePerson_fn = function (firstId, persons) {
        var resolutionHelper = F2(function (id, seen) {
            return $elm$core$Maybe$andThen_fn(function (p) {
                var _v0 = p.mZ;
                if (!_v0.$) {
                    var newId = _v0.a;
                    return $elm$core$List$member_fn(newId, seen) ? $elm$core$Maybe$Nothing : A2(resolutionHelper, newId, _List_Cons(id, seen));
                }
                else {
                    return p.lh ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple2(id, p));
                }
            }, $author$project$Firestore$Collection$get_fn(id, persons));
        });
        return A2(resolutionHelper, firstId, _List_Nil);
    }, $author$project$Data$Person$resolvePerson = F2($author$project$Data$Person$resolvePerson_fn);
    var $elm$core$String$trim = _String_trim;
    var $elm_community$maybe_extra$Maybe$Extra$unwrap_fn = function (_default, f, m) {
        if (m.$ === 1) {
            return _default;
        }
        else {
            var a = m.a;
            return f(a);
        }
    }, $elm_community$maybe_extra$Maybe$Extra$unwrap = F3($elm_community$maybe_extra$Maybe$Extra$unwrap_fn);
    var $author$project$Search$Result$applyAttachmentFilters_fn = function (_v0, filter) {
        var timezoneUser = _v0.pu;
        var people = _v0.iz;
        _v1$5: while (true) {
            switch (filter.$) {
                case 0:
                    if (!filter.a.$) {
                        var _v2 = filter.a;
                        var eventId = _v2.b;
                        return $elm$core$List$filter(A2($elm$core$Basics$composeR, function ($) {
                            return $.l;
                        }, A2($elm$core$Basics$composeR, $author$project$Data$Note$getEventId, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($author$project$Data$Event$baseId), $elm$core$Basics$eq($elm$core$Maybe$Just($author$project$Data$Event$baseId(eventId)))))));
                    }
                    else {
                        break _v1$5;
                    }
                case 3:
                    var date = filter.a;
                    return $elm$core$List$filter(function (_v3) {
                        var note = _v3.l;
                        return $author$project$Data$Time$compare_fn(timezoneUser, note.gh, $author$project$Data$Time$Date(date)) === 2;
                    });
                case 2:
                    var date = filter.a;
                    return $elm$core$List$filter(function (_v4) {
                        var note = _v4.l;
                        return !$author$project$Data$Time$compare_fn(timezoneUser, note.gh, $author$project$Data$Time$Date(date));
                    });
                case 1:
                    if (!filter.a.$) {
                        var _v5 = filter.a;
                        var filterPersonId = _v5.b;
                        var emailAddresses = $elm$core$Set$fromList($elm$core$List$map_fn(A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$toLower), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, function ($) {
                            return $.lo;
                        }, $author$project$Firestore$Collection$get_fn(filterPersonId, people))));
                        return $elm$core$List$filter(function (_v6) {
                            var note = _v6.l;
                            return $elm$core$List$any_fn(function (attendee) {
                                var _v7 = attendee.n3;
                                if (_v7.$ === 1) {
                                    var email = _v7.a;
                                    return $elm_community$basics_extra$Basics$Extra$flip_fn($elm$core$Set$member, emailAddresses, $elm$core$String$trim($elm$core$String$toLower(email)));
                                }
                                else {
                                    var attendeePersonId = _v7.a;
                                    return _Utils_eq($elm$core$Maybe$Just(attendeePersonId), $elm$core$Maybe$map_fn($elm$core$Tuple$first, $author$project$Data$Person$resolvePerson_fn(filterPersonId, people)));
                                }
                            }, note.ke);
                        });
                    }
                    else {
                        break _v1$5;
                    }
                case 4:
                    var fileType = filter.a;
                    return $elm$core$List$filter(function (_v8) {
                        var attachment = _v8.kc;
                        return $author$project$Search$Result$attachmentIsFileType_fn(fileType, attachment);
                    });
                default:
                    break _v1$5;
            }
        }
        return $elm$core$Basics$identity;
    }, $author$project$Search$Result$applyAttachmentFilters = F2($author$project$Search$Result$applyAttachmentFilters_fn);
    var $author$project$Firestore$Collection$foldr = function (reducer) {
        return $author$project$Firestore$Collection$foldrWithState($author$project$Firestore$Collection$reducerHelper(reducer));
    };
    var $author$project$Firestore$Collection$map = function (fn) {
        return A2($author$project$Firestore$Collection$foldr, F3(function (id, doc, accum) {
            return _List_Cons(A2(fn, id, doc), accum);
        }), _List_Nil);
    }, $author$project$Firestore$Collection$map_unwrapped = function (fn) {
        return A2($author$project$Firestore$Collection$foldr, F3(function (id, doc, accum) {
            return _List_Cons(fn(id, doc), accum);
        }), _List_Nil);
    };
    var $author$project$Search$Query$attachmentFilterScore = function (filter) {
        switch (filter.$) {
            case 0:
                return $elm$core$Maybe$Just(1);
            case 4:
                return $elm$core$Maybe$Just(2);
            case 3:
                return $elm$core$Maybe$Just(3);
            case 2:
                return $elm$core$Maybe$Just(4);
            case 1:
                return $elm$core$Maybe$Just(5);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Search$Query$noteFilterScore = function (filter) {
        switch (filter.$) {
            case 0:
                return $elm$core$Maybe$Just(1);
            case 3:
                return $elm$core$Maybe$Just(2);
            case 2:
                return $elm$core$Maybe$Just(3);
            case 1:
                return $elm$core$Maybe$Just(4);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $elm$core$List$sortBy = _List_sortBy;
    var $author$project$Search$Query$normalizeQuery_fn = function (category, query) {
        var filterScoreFn = function () {
            switch (category) {
                case 0:
                    return $author$project$Search$Query$noteFilterScore;
                case 1:
                    return $elm$core$Basics$always($elm$core$Maybe$Nothing);
                default:
                    return $author$project$Search$Query$attachmentFilterScore;
            }
        }();
        return $elm$core$List$map_fn($elm$core$Tuple$first, _List_sortBy_fn($elm$core$Tuple$second, $elm$core$List$filterMap_fn(function (filter) {
            return $elm$core$Maybe$map_fn($elm$core$Tuple$pair(filter), filterScoreFn(filter));
        }, query)));
    }, $author$project$Search$Query$normalizeQuery = F2($author$project$Search$Query$normalizeQuery_fn);
    var $author$project$Search$Result$searchAttachments_fn = function (env, config, stringQuery, searchQuery) {
        var normalizedQuery = $author$project$Search$Query$normalizeQuery_fn(2, searchQuery);
        var attachmentData = function (_v2) {
            return $elm$core$List$concat(A2($author$project$Firestore$Collection$map, F2(function (noteId, note) {
                return $elm$core$List$map_fn(function (attachment) {
                    return { kc: attachment, l: note, ip: noteId };
                }, note.kd);
            }), env.fO));
        };
        var _v0 = config.kd;
        var sortWith = _v0.gd;
        var maxDocs = _v0.fI;
        var filter = _v0.fk;
        var attachmentMapper = function (attachmentDatum) {
            var attachment = attachmentDatum.kc;
            return (!filter((new $$Record50(attachmentDatum, attachment.Y)))) ? $elm$core$Maybe$Nothing : (_String_contains_fn($elm$core$String$toLower(stringQuery), $elm$core$String$toLower(attachment.b8)) ? $elm$core$Maybe$Just((new $$Record50(attachmentDatum, attachment.Y))) : $elm$core$Maybe$Nothing);
        };
        var _v1 = _Utils_Tuple2($elm$core$Maybe$withDefault_fn($elm$core$Basics$identity, $elm$core$Maybe$map_fn($elm$core$List$sortWith, sortWith)), $elm$core$Maybe$withDefault_fn($elm$core$Basics$identity, $elm$core$Maybe$map_fn($elm$core$List$take, maxDocs)));
        var sorter = _v1.a;
        var taker = _v1.b;
        return $elm$core$List$map_fn($author$project$Search$Result$AttachmentEntity, taker(sorter($elm$core$List$filterMap_fn(attachmentMapper, $elm$core$List$foldl_fn($author$project$Search$Result$applyAttachmentFilters(env), attachmentData(0), normalizedQuery)))));
    }, $author$project$Search$Result$searchAttachments = F4($author$project$Search$Result$searchAttachments_fn);
    var $author$project$Search$Result$applyNoteFilters_fn = function (_v0, filter) {
        var timezoneUser = _v0.pu;
        var people = _v0.iz;
        _v1$5: while (true) {
            switch (filter.$) {
                case 0:
                    if (!filter.a.$) {
                        var _v2 = filter.a;
                        var eventId = _v2.b;
                        return $elm$core$List$filter(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, A2($elm$core$Basics$composeR, $author$project$Data$Note$getEventId, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($author$project$Data$Event$baseId), $elm$core$Basics$eq($elm$core$Maybe$Just($author$project$Data$Event$baseId(eventId)))))));
                    }
                    else {
                        var searchText = filter.a.a;
                        return $elm$core$List$filter(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, A2($elm$core$Basics$composeR, function ($) {
                            return $.gj;
                        }, $elm$core$String$contains(searchText))));
                    }
                case 3:
                    var date = filter.a;
                    return $elm$core$List$filter(function (_v3) {
                        var note = _v3.b;
                        return $author$project$Data$Time$compare_fn(timezoneUser, note.gh, $author$project$Data$Time$Date(date)) === 2;
                    });
                case 2:
                    var date = filter.a;
                    return $elm$core$List$filter(function (_v4) {
                        var note = _v4.b;
                        return !$author$project$Data$Time$compare_fn(timezoneUser, note.gh, $author$project$Data$Time$Date(date));
                    });
                case 1:
                    if (!filter.a.$) {
                        var _v5 = filter.a;
                        var filterPersonId = _v5.b;
                        var emailAddresses = $elm$core$Set$fromList($elm$core$List$map_fn(A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$toLower), $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_List_Nil, function ($) {
                            return $.lo;
                        }, $author$project$Firestore$Collection$get_fn(filterPersonId, people))));
                        return $elm$core$List$filter(function (_v6) {
                            var note = _v6.b;
                            return $elm$core$List$any_fn(function (attendee) {
                                var _v7 = attendee.n3;
                                if (_v7.$ === 1) {
                                    var email = _v7.a;
                                    return $elm_community$basics_extra$Basics$Extra$flip_fn($elm$core$Set$member, emailAddresses, $elm$core$String$trim($elm$core$String$toLower(email)));
                                }
                                else {
                                    var attendeePersonId = _v7.a;
                                    return _Utils_eq($elm$core$Maybe$Just(attendeePersonId), $elm$core$Maybe$map_fn($elm$core$Tuple$first, $author$project$Data$Person$resolvePerson_fn(filterPersonId, people)));
                                }
                            }, note.ke);
                        });
                    }
                    else {
                        break _v1$5;
                    }
                default:
                    break _v1$5;
            }
        }
        return $elm$core$Basics$identity;
    }, $author$project$Search$Result$applyNoteFilters = F2($author$project$Search$Result$applyNoteFilters_fn);
    var $author$project$Search$Index$Doc_fn = function (id, doc) {
        return (new $$Record50(doc, id));
    }, $author$project$Search$Index$Doc = F2($author$project$Search$Index$Doc_fn);
    var $rluiten$trie$TrieModel$getNodeCore_fn = function (key, trie) {
        if (!key.b) {
            return $elm$core$Maybe$Just(trie);
        }
        else {
            var keyHead = key.a;
            var keyTail = key.b;
            var getTrie = function (trieDict) {
                return $elm$core$Maybe$andThen_fn($rluiten$trie$TrieModel$getNodeCore(keyTail), $elm$core$Dict$get_fn(keyHead, trieDict));
            };
            switch (trie.$) {
                case 0:
                    return $elm$core$Maybe$Nothing;
                case 1:
                    return $elm$core$Maybe$Nothing;
                case 2:
                    var trieDict = trie.a;
                    return getTrie(trieDict);
                default:
                    var _v2 = trie.a;
                    var trieDict = _v2.b;
                    return getTrie(trieDict);
            }
        }
    }, $rluiten$trie$TrieModel$getNodeCore = F2($rluiten$trie$TrieModel$getNodeCore_fn);
    var $elm$core$List$isEmpty = function (xs) {
        if (!xs.b) {
            return true;
        }
        else {
            return false;
        }
    };
    var $rluiten$trie$TrieModel$getNodeByStr_fn = function (key, trie) {
        return $elm$core$List$isEmpty(key) ? $elm$core$Maybe$Nothing : $rluiten$trie$TrieModel$getNodeCore_fn(key, trie);
    }, $rluiten$trie$TrieModel$getNodeByStr = F2($rluiten$trie$TrieModel$getNodeByStr_fn);
    var $rluiten$trie$TrieModel$toListString = function (str) {
        return $elm$core$List$map_fn(function (c) {
            return $elm$core$String$fromChar(c);
        }, $elm$core$String$toList(str));
    };
    var $rluiten$trie$TrieModel$getNode_fn = function (key, trie) {
        return $rluiten$trie$TrieModel$getNodeByStr_fn($rluiten$trie$TrieModel$toListString(key), trie);
    }, $rluiten$trie$TrieModel$getNode = F2($rluiten$trie$TrieModel$getNode_fn);
    var $rluiten$trie$Trie$getNode = $rluiten$trie$TrieModel$getNode;
    var $rluiten$elm_text_search$Index$Utils$applyFilterList_fn = function (filters, token) {
        applyFilterList: while (true) {
            if (!filters.b) {
                return true;
            }
            else {
                var filterFunc = filters.a;
                var restFilters = filters.b;
                if (token === "") {
                    return false;
                }
                else {
                    var _v2 = filterFunc(token);
                    if (!_v2) {
                        return false;
                    }
                    else {
                        var $temp$filters = restFilters, $temp$token = token;
                        filters = $temp$filters;
                        token = $temp$token;
                        continue applyFilterList;
                    }
                }
            }
        }
    }, $rluiten$elm_text_search$Index$Utils$applyFilterList = F2($rluiten$elm_text_search$Index$Utils$applyFilterList_fn);
    var $rluiten$elm_text_search$Index$Utils$runFactories_fn = function (factoryList, index) {
        return $elm$core$List$foldr_fn(F2(function (factory, _v0) {
            var u1index = _v0.a;
            var funcList = _v0.b;
            var _v1 = factory(u1index);
            var u2index = _v1.a;
            var newFunc = _v1.b;
            return _Utils_Tuple2(u2index, _List_Cons(newFunc, funcList));
        }), _Utils_Tuple2(index, _List_Nil), factoryList);
    }, $rluiten$elm_text_search$Index$Utils$runFactories = F2($rluiten$elm_text_search$Index$Utils$runFactories_fn);
    var $rluiten$elm_text_search$Index$Utils$getOrSetIndexFuncList_fn = function (getFuncs, getFactoryFuncs, setFuncs, index) {
        var _v0 = getFuncs(index);
        if (!_v0.$) {
            var funcList = _v0.a;
            return _Utils_Tuple2(index, funcList);
        }
        else {
            var _v1 = $rluiten$elm_text_search$Index$Utils$runFactories_fn(getFactoryFuncs(index), index);
            var u1index = _v1.a;
            var newFuncList = _v1.b;
            var u2index = A2(setFuncs, u1index, newFuncList);
            return _Utils_Tuple2(u2index, newFuncList);
        }
    }, $rluiten$elm_text_search$Index$Utils$getOrSetIndexFuncList_fn_unwrapped = function (getFuncs, getFactoryFuncs, setFuncs, index) {
        var _v0 = getFuncs(index);
        if (!_v0.$) {
            var funcList = _v0.a;
            return _Utils_Tuple2(index, funcList);
        }
        else {
            var _v1 = $rluiten$elm_text_search$Index$Utils$runFactories_fn(getFactoryFuncs(index), index);
            var u1index = _v1.a;
            var newFuncList = _v1.b;
            var u2index = setFuncs(u1index, newFuncList);
            return _Utils_Tuple2(u2index, newFuncList);
        }
    }, $rluiten$elm_text_search$Index$Utils$getOrSetIndexFuncList = F4($rluiten$elm_text_search$Index$Utils$getOrSetIndexFuncList_fn);
    var $rluiten$elm_text_search$Index$Utils$setIndexFilters_fn = function (_v0, listFuncs) {
        var irec = _v0;
        return function () {
            var $r = irec.$c();
            $r.lI = $elm$core$Maybe$Just(listFuncs);
            return $r;
        }();
    }, $rluiten$elm_text_search$Index$Utils$setIndexFilters = F2($rluiten$elm_text_search$Index$Utils$setIndexFilters_fn);
    var $rluiten$elm_text_search$Index$Utils$getOrSetFilterList = function (index) {
        return $rluiten$elm_text_search$Index$Utils$getOrSetIndexFuncList_fn(function (_v0) {
            var irec = _v0;
            return irec.lI;
        }, function (_v1) {
            var irec = _v1;
            return irec.ht;
        }, $rluiten$elm_text_search$Index$Utils$setIndexFilters, index);
    };
    var $rluiten$elm_text_search$Index$Utils$applyFilter_fn = function (index, strings) {
        var _v0 = $rluiten$elm_text_search$Index$Utils$getOrSetFilterList(index);
        var u1index = _v0.a;
        var filterList = _v0.b;
        return _Utils_Tuple2(u1index, $elm$core$List$filter_fn($rluiten$elm_text_search$Index$Utils$applyFilterList(filterList), strings));
    }, $rluiten$elm_text_search$Index$Utils$applyFilter = F2($rluiten$elm_text_search$Index$Utils$applyFilter_fn);
    var $rluiten$elm_text_search$Index$Utils$applyTransformList_fn = function (transforms, token) {
        applyTransformList: while (true) {
            if (!transforms.b) {
                return token;
            }
            else {
                var transform = transforms.a;
                var restTransforms = transforms.b;
                var newToken = transform(token);
                if (newToken === "") {
                    return "";
                }
                else {
                    var $temp$transforms = restTransforms, $temp$token = newToken;
                    transforms = $temp$transforms;
                    token = $temp$token;
                    continue applyTransformList;
                }
            }
        }
    }, $rluiten$elm_text_search$Index$Utils$applyTransformList = F2($rluiten$elm_text_search$Index$Utils$applyTransformList_fn);
    var $rluiten$elm_text_search$Index$Utils$setIndexInitialTransforms_fn = function (_v0, listFuncs) {
        var irec = _v0;
        return function () {
            var $r = irec.$c();
            $r.mh = $elm$core$Maybe$Just(listFuncs);
            return $r;
        }();
    }, $rluiten$elm_text_search$Index$Utils$setIndexInitialTransforms = F2($rluiten$elm_text_search$Index$Utils$setIndexInitialTransforms_fn);
    var $rluiten$elm_text_search$Index$Utils$getOrSetInitialTransformList = function (index) {
        return $rluiten$elm_text_search$Index$Utils$getOrSetIndexFuncList_fn(function (_v0) {
            var irec = _v0;
            return irec.mh;
        }, function (_v1) {
            var irec = _v1;
            return irec.hQ;
        }, $rluiten$elm_text_search$Index$Utils$setIndexInitialTransforms, index);
    };
    var $rluiten$elm_text_search$Index$Utils$applyInitialTransform_fn = function (index, strings) {
        var _v0 = $rluiten$elm_text_search$Index$Utils$getOrSetInitialTransformList(index);
        var u1index = _v0.a;
        var intitialTransformList = _v0.b;
        return _Utils_Tuple2(u1index, $elm$core$List$filter_fn(function (val) {
            return val !== "";
        }, $elm$core$List$map_fn($rluiten$elm_text_search$Index$Utils$applyTransformList(intitialTransformList), strings)));
    }, $rluiten$elm_text_search$Index$Utils$applyInitialTransform = F2($rluiten$elm_text_search$Index$Utils$applyInitialTransform_fn);
    var $rluiten$elm_text_search$Index$Utils$setIndexTransforms_fn = function (_v0, listFuncs) {
        var irec = _v0;
        return function () {
            var $r = irec.$c();
            $r.pJ = $elm$core$Maybe$Just(listFuncs);
            return $r;
        }();
    }, $rluiten$elm_text_search$Index$Utils$setIndexTransforms = F2($rluiten$elm_text_search$Index$Utils$setIndexTransforms_fn);
    var $rluiten$elm_text_search$Index$Utils$getOrSetTransformList = function (index) {
        return $rluiten$elm_text_search$Index$Utils$getOrSetIndexFuncList_fn(function (_v0) {
            var irec = _v0;
            return irec.pJ;
        }, function (_v1) {
            var irec = _v1;
            return irec.jv;
        }, $rluiten$elm_text_search$Index$Utils$setIndexTransforms, index);
    };
    var $rluiten$elm_text_search$Index$Utils$applyTransform_fn = function (index, strings) {
        var _v0 = $rluiten$elm_text_search$Index$Utils$getOrSetTransformList(index);
        var u1index = _v0.a;
        var transformList = _v0.b;
        return _Utils_Tuple2(u1index, $elm$core$List$filter_fn(function (val) {
            return val !== "";
        }, $elm$core$List$map_fn($rluiten$elm_text_search$Index$Utils$applyTransformList(transformList), strings)));
    }, $rluiten$elm_text_search$Index$Utils$applyTransform = F2($rluiten$elm_text_search$Index$Utils$applyTransform_fn);
    var $rluiten$elm_text_search$Index$Utils$processTokens_fn = function (index, tokens) {
        var _v0 = $rluiten$elm_text_search$Index$Utils$applyInitialTransform_fn(index, tokens);
        var u1index = _v0.a;
        var initialTransformTokens = _v0.b;
        var _v1 = $rluiten$elm_text_search$Index$Utils$applyFilter_fn(u1index, initialTransformTokens);
        var u2index = _v1.a;
        var filterTokens = _v1.b;
        return $rluiten$elm_text_search$Index$Utils$applyTransform_fn(u2index, filterTokens);
    }, $rluiten$elm_text_search$Index$Utils$processTokens = F2($rluiten$elm_text_search$Index$Utils$processTokens_fn);
    var $rluiten$elm_text_search$TokenProcessors$defaultSeparator = $elm$core$Basics$composeL_fn($rluiten$elm_text_search$TokenProcessors$forceRegex_a0, $rluiten$elm_text_search$TokenProcessors$forceRegex_a1, "[\\s\\-]+");
    var $elm$regex$Regex$split_a0 = _Regex_infinity, $elm$regex$Regex$split = _Regex_splitAtMost($elm$regex$Regex$split_a0);
    var $rluiten$elm_text_search$TokenProcessors$tokenizerWithRegex_fn = function (seperatorRegex, data) {
        var splitter = A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$regex$Regex$split(seperatorRegex), $elm$core$String$toLower), $elm$core$String$trim);
        return $elm$core$List$filter_fn(function (token) {
            return $elm$core$String$length(token) > 0;
        }, splitter(data));
    }, $rluiten$elm_text_search$TokenProcessors$tokenizerWithRegex = F2($rluiten$elm_text_search$TokenProcessors$tokenizerWithRegex_fn);
    var $rluiten$elm_text_search$TokenProcessors$tokenizer_a0 = $rluiten$elm_text_search$TokenProcessors$defaultSeparator, $rluiten$elm_text_search$TokenProcessors$tokenizer = $rluiten$elm_text_search$TokenProcessors$tokenizerWithRegex($rluiten$elm_text_search$TokenProcessors$tokenizer_a0);
    var $rluiten$elm_text_search$Index$Utils$getTokens_fn = function (index, string) {
        return $rluiten$elm_text_search$Index$Utils$processTokens_fn(index, $rluiten$elm_text_search$TokenProcessors$tokenizerWithRegex_fn($rluiten$elm_text_search$TokenProcessors$tokenizer_a0, string));
    }, $rluiten$elm_text_search$Index$Utils$getTokens = F2($rluiten$elm_text_search$Index$Utils$getTokens_fn);
    var $elm$core$Dict$isEmpty = function (dict) {
        if (dict.$ === -2) {
            return true;
        }
        else {
            return false;
        }
    };
    var $rluiten$trie$TrieModel$expandCore_fn = function (key, trie, keyList) {
        var expandSub = F3(function (_char, trie1, foldList) {
            return $rluiten$trie$TrieModel$expandCore_fn(_Utils_ap(key, _List_fromArray([_char])), trie1, foldList);
        });
        var addRefKey = function (refValues) {
            return (!$elm$core$Dict$isEmpty(refValues)) ? _List_Cons($elm$core$String$concat(key), keyList) : keyList;
        };
        switch (trie.$) {
            case 0:
                return keyList;
            case 1:
                var refValues = trie.a;
                return addRefKey(refValues);
            case 2:
                var trieDict = trie.a;
                return $elm$core$Dict$foldr_fn(expandSub, keyList, trieDict);
            default:
                var _v1 = trie.a;
                var refValues = _v1.a;
                var trieDict = _v1.b;
                var dirtyList = addRefKey(refValues);
                return $elm$core$Dict$foldr_fn(expandSub, dirtyList, trieDict);
        }
    }, $rluiten$trie$TrieModel$expandCore = F3($rluiten$trie$TrieModel$expandCore_fn);
    var $rluiten$trie$TrieModel$expandByStr_fn = function (key, trie) {
        var _v0 = $rluiten$trie$TrieModel$getNodeByStr_fn(key, trie);
        if (_v0.$ === 1) {
            return _List_Nil;
        }
        else {
            var keyTrie = _v0.a;
            return $rluiten$trie$TrieModel$expandCore_fn(key, keyTrie, _List_Nil);
        }
    }, $rluiten$trie$TrieModel$expandByStr = F2($rluiten$trie$TrieModel$expandByStr_fn);
    var $rluiten$trie$TrieModel$expand_fn = function (key, trie) {
        return $rluiten$trie$TrieModel$expandByStr_fn($rluiten$trie$TrieModel$toListString(key), trie);
    }, $rluiten$trie$TrieModel$expand = F2($rluiten$trie$TrieModel$expand_fn);
    var $rluiten$trie$Trie$expand = $rluiten$trie$TrieModel$expand;
    var $rluiten$trie$TrieModel$getValues = function (trie) {
        switch (trie.$) {
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                var refValues = trie.a;
                return $elm$core$Maybe$Just(refValues);
            case 2:
                return $elm$core$Maybe$Nothing;
            default:
                var _v1 = trie.a;
                var refValues = _v1.a;
                return $elm$core$Maybe$Just(refValues);
        }
    };
    var $rluiten$trie$TrieModel$getByStr_fn = function (key, trie) {
        return $elm$core$Maybe$andThen_fn($rluiten$trie$TrieModel$getValues, $rluiten$trie$TrieModel$getNodeByStr_fn(key, trie));
    }, $rluiten$trie$TrieModel$getByStr = F2($rluiten$trie$TrieModel$getByStr_fn);
    var $rluiten$trie$TrieModel$get_fn = function (key, trie) {
        return $rluiten$trie$TrieModel$getByStr_fn($rluiten$trie$TrieModel$toListString(key), trie);
    }, $rluiten$trie$TrieModel$get = F2($rluiten$trie$TrieModel$get_fn);
    var $rluiten$trie$Trie$get = $rluiten$trie$TrieModel$get;
    var $elm$core$Dict$sizeHelp_fn = function (n, dict) {
        sizeHelp: while (true) {
            if (dict.$ === -2) {
                return n;
            }
            else {
                var left = dict.d;
                var right = dict.e;
                var $temp$n = $elm$core$Dict$sizeHelp_fn(n + 1, right), $temp$dict = left;
                n = $temp$n;
                dict = $temp$dict;
                continue sizeHelp;
            }
        }
    }, $elm$core$Dict$sizeHelp = F2($elm$core$Dict$sizeHelp_fn);
    var $elm$core$Dict$size = function (dict) {
        return $elm$core$Dict$sizeHelp_fn(0, dict);
    };
    var $rluiten$trie$TrieModel$valueCount_fn = function (key, trie) {
        return $elm$core$Dict$size($elm$core$Maybe$withDefault_fn($elm$core$Dict$empty, $rluiten$trie$TrieModel$get_fn(key, trie)));
    }, $rluiten$trie$TrieModel$valueCount = F2($rluiten$trie$TrieModel$valueCount_fn);
    var $rluiten$trie$Trie$valueCount = $rluiten$trie$TrieModel$valueCount;
    var $rluiten$elm_text_search$Index$Utils$calcIdf_fn = function (_v0, token) {
        var irec = _v0;
        var docFrequency = $rluiten$trie$TrieModel$valueCount_fn(token, irec.gk);
        var idfLocal = (docFrequency > 0) ? (1 + $elm$core$Basics$logBase_fn(10, $elm$core$Dict$size(irec.fe) / docFrequency)) : 1;
        var updatedIdfCache = $elm$core$Dict$insert_fn(token, idfLocal, irec.fs);
        var u1index = function () {
            var $r = irec.$c();
            $r.fs = updatedIdfCache;
            return $r;
        }();
        return _Utils_Tuple2(u1index, idfLocal);
    }, $rluiten$elm_text_search$Index$Utils$calcIdf = F2($rluiten$elm_text_search$Index$Utils$calcIdf_fn);
    var $rluiten$elm_text_search$Index$Utils$idf_fn = function (index, token) {
        var irec = index;
        var _v0 = $elm$core$Dict$get_fn(token, irec.fs);
        if (_v0.$ === 1) {
            return $rluiten$elm_text_search$Index$Utils$calcIdf_fn(index, token);
        }
        else {
            var idfValue = _v0.a;
            return _Utils_Tuple2(index, idfValue);
        }
    }, $rluiten$elm_text_search$Index$Utils$idf = F2($rluiten$elm_text_search$Index$Utils$idf_fn);
    var $rluiten$sparsevector$SparseVector$insert_fn = function (index, value, svector) {
        return $elm$core$Dict$insert_fn(index, value, svector);
    }, $rluiten$sparsevector$SparseVector$insert = F3($rluiten$sparsevector$SparseVector$insert_fn);
    var $rluiten$elm_text_search$Index$Vector$similarityBoost_fn = function (token, expandedToken) {
        return _Utils_eq(expandedToken, token) ? 1 : (1 / $elm$core$Basics$logBase_fn(10, $elm$core$Basics$max_fn(3, $elm$core$String$length(expandedToken) - $elm$core$String$length(token))));
    }, $rluiten$elm_text_search$Index$Vector$similarityBoost = F2($rluiten$elm_text_search$Index$Vector$similarityBoost_fn);
    var $elm$core$Dict$union_fn = function (t1, t2) {
        return $elm$core$Dict$foldl_fn($elm$core$Dict$insert, t2, t1);
    }, $elm$core$Dict$union = F2($elm$core$Dict$union_fn);
    var $elm$core$Set$union_fn = function (_v0, _v1) {
        var dict1 = _v0;
        var dict2 = _v1;
        return $elm$core$Dict$union_fn(dict1, dict2);
    }, $elm$core$Set$union = F2($elm$core$Set$union_fn);
    var $rluiten$elm_text_search$Index$Vector$updateSetAndVec_fn = function (tf, token, expandedToken, _v0) {
        var docSets = _v0.a;
        var vec = _v0.b;
        var index = _v0.c;
        var irec = index;
        var _v1 = $rluiten$elm_text_search$Index$Utils$idf_fn(index, expandedToken);
        var u1index = _v1.a;
        var u1irec = u1index;
        var keyIdf = _v1.b;
        var tfidf = (tf * keyIdf) * $rluiten$elm_text_search$Index$Vector$similarityBoost_fn(token, expandedToken);
        var u1vec = $elm$core$Maybe$withDefault_fn(vec, $elm$core$Maybe$map_fn(function (pos) {
            return $rluiten$sparsevector$SparseVector$insert_fn(pos, tfidf, vec);
        }, $elm$core$Dict$get_fn(expandedToken, irec.g$)));
        var expandedTokenDocSet = $elm$core$Maybe$withDefault_fn($elm$core$Set$empty, $elm$core$Maybe$map_fn(function (dict) {
            return $elm$core$Set$fromList($elm$core$Dict$keys(dict));
        }, $rluiten$trie$TrieModel$get_fn(expandedToken, u1irec.gk)));
        var u1docSets = $elm$core$Set$union_fn(expandedTokenDocSet, docSets);
        return _Utils_Tuple3(u1docSets, u1vec, u1index);
    }, $rluiten$elm_text_search$Index$Vector$updateSetAndVec = F4($rluiten$elm_text_search$Index$Vector$updateSetAndVec_fn);
    var $rluiten$elm_text_search$Index$Vector$buildDocVector_fn = function (tokensLength, fieldBoosts, baseToken, _v0) {
        var docSets = _v0.a;
        var vec = _v0.b;
        var index = _v0.c;
        var irec = index;
        var termFrequency = ((1 / tokensLength) * $elm$core$List$length(irec.hs)) * fieldBoosts;
        var expandedTokens = $rluiten$trie$TrieModel$expand_fn(baseToken, irec.gk);
        var _v1 = $elm$core$List$foldr_fn(A2($rluiten$elm_text_search$Index$Vector$updateSetAndVec, termFrequency, baseToken), _Utils_Tuple3($elm$core$Set$empty, vec, index), expandedTokens);
        var docs = _v1.a;
        var vecU1 = _v1.b;
        var indexU1 = _v1.c;
        return _Utils_Tuple3(_List_Cons(docs, docSets), vecU1, indexU1);
    }, $rluiten$elm_text_search$Index$Vector$buildDocVector = F4($rluiten$elm_text_search$Index$Vector$buildDocVector_fn);
    var $rluiten$sparsevector$SparseVector$empty = $elm$core$Dict$empty;
    var $rluiten$elm_text_search$Index$Vector$getQueryVector_fn = function (fieldBoosts, tokens, index) {
        return $elm$core$List$foldr_fn(A2($rluiten$elm_text_search$Index$Vector$buildDocVector, $elm$core$List$length(tokens), fieldBoosts), _Utils_Tuple3(_List_Nil, $rluiten$sparsevector$SparseVector$empty, index), tokens);
    }, $rluiten$elm_text_search$Index$Vector$getQueryVector = F3($rluiten$elm_text_search$Index$Vector$getQueryVector_fn);
    var $elm$core$Dict$filter_fn = function (isGood, dict) {
        return $elm$core$Dict$foldl_fn_unwrapped(function (k, v, d) {
            return A2(isGood, k, v) ? $elm$core$Dict$insert_fn(k, v, d) : d;
        }, $elm$core$Dict$empty, dict);
    }, $elm$core$Dict$filter_fn_unwrapped = function (isGood, dict) {
        return $elm$core$Dict$foldl_fn_unwrapped(function (k, v, d) {
            return isGood(k, v) ? $elm$core$Dict$insert_fn(k, v, d) : d;
        }, $elm$core$Dict$empty, dict);
    }, $elm$core$Dict$filter = F2($elm$core$Dict$filter_fn);
    var $elm$core$Dict$intersect_fn = function (t1, t2) {
        return $elm$core$Dict$filter_fn_unwrapped(function (k, _v0) {
            return $elm$core$Dict$member_fn(k, t2);
        }, t1);
    }, $elm$core$Dict$intersect = F2($elm$core$Dict$intersect_fn);
    var $elm$core$Set$intersect_fn = function (_v0, _v1) {
        var dict1 = _v0;
        var dict2 = _v1;
        return $elm$core$Dict$intersect_fn(dict1, dict2);
    }, $elm$core$Set$intersect = F2($elm$core$Set$intersect_fn);
    var $rluiten$elm_text_search$Utils$intersectSets = function (sets) {
        if (!sets.b) {
            return $elm$core$Set$empty;
        }
        else {
            var h = sets.a;
            var tail = sets.b;
            return $elm$core$List$foldr_fn(F2(function (set, agg) {
                return $elm$core$Set$intersect_fn(set, agg);
            }), h, tail);
        }
    };
    var $elm$core$Dict$values = function (dict) {
        return $elm$core$Dict$foldr_fn_unwrapped(function (key, value, valueList) {
            return _List_Cons(value, valueList);
        }, _List_Nil, dict);
    };
    var $rluiten$sparsevector$SparseVector$dot_fn = function (vec1, vec2) {
        var common = $elm$core$Set$intersect_fn($elm$core$Set$fromList($elm$core$Dict$keys(vec1)), $elm$core$Set$fromList($elm$core$Dict$keys(vec2)));
        var d1 = $elm$core$Dict$filter_fn_unwrapped(function (k, v) {
            return $elm$core$Set$member_fn(k, common);
        }, vec1);
        var d2 = $elm$core$Dict$filter_fn_unwrapped(function (k, v) {
            return $elm$core$Set$member_fn(k, common);
        }, vec2);
        return $elm$core$List$sum(_List_map2_fn_unwrapped(function (v1, v2) {
            return v1 * v2;
        }, $elm$core$Dict$values(d1), $elm$core$Dict$values(d2)));
    }, $rluiten$sparsevector$SparseVector$dot = F2($rluiten$sparsevector$SparseVector$dot_fn);
    var $elm$core$Basics$sqrt = _Basics_sqrt;
    var $rluiten$sparsevector$SparseVector$magnitude = function (svector) {
        return $elm$core$Basics$sqrt($elm$core$List$sum($elm$core$List$map_fn(function (x) {
            return x * x;
        }, $elm$core$Dict$values(svector))));
    };
    var $rluiten$sparsevector$SparseVector$cosineSimilarity_fn = function (vec1, vec2) {
        return $rluiten$sparsevector$SparseVector$dot_fn(vec1, vec2) / ($rluiten$sparsevector$SparseVector$magnitude(vec1) * $rluiten$sparsevector$SparseVector$magnitude(vec2));
    }, $rluiten$sparsevector$SparseVector$cosineSimilarity = F2($rluiten$sparsevector$SparseVector$cosineSimilarity_fn);
    var $elm$core$Maybe$map2_fn = function (func, ma, mb) {
        if (ma.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var a = ma.a;
            if (mb.$ === 1) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var b = mb.a;
                return $elm$core$Maybe$Just(A2(func, a, b));
            }
        }
    }, $elm$core$Maybe$map2_fn_unwrapped = function (func, ma, mb) {
        if (ma.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var a = ma.a;
            if (mb.$ === 1) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var b = mb.a;
                return $elm$core$Maybe$Just(func(a, b));
            }
        }
    }, $elm$core$Maybe$map2 = F3($elm$core$Maybe$map2_fn);
    var $rluiten$elm_text_search$Index$Vector$updateDocVector_fn = function (docRef, token, inputTuple) {
        var index = inputTuple.a;
        var irec = index;
        var docVector = inputTuple.b;
        return $elm$core$Maybe$withDefault_fn(inputTuple, $elm$core$Maybe$map2_fn_unwrapped(function (position, termFrequency) {
            var _v0 = $rluiten$elm_text_search$Index$Utils$idf_fn(index, token);
            var u1index = _v0.a;
            var idfScore = _v0.b;
            return _Utils_Tuple2(u1index, $rluiten$sparsevector$SparseVector$insert_fn(position, termFrequency * idfScore, docVector));
        }, $elm$core$Dict$get_fn(token, irec.g$), $elm$core$Maybe$andThen_fn($elm$core$Dict$get(docRef), $rluiten$trie$TrieModel$get_fn(token, irec.gk))));
    }, $rluiten$elm_text_search$Index$Vector$updateDocVector = F3($rluiten$elm_text_search$Index$Vector$updateDocVector_fn);
    var $rluiten$elm_text_search$Index$Vector$getDocVector_fn = function (index, docRef) {
        var irec = index;
        return $elm$core$Maybe$withDefault_fn(_Utils_Tuple2(index, $rluiten$sparsevector$SparseVector$empty), $elm$core$Maybe$map_fn(function (tokenSet) {
            return $elm$core$List$foldr_fn($rluiten$elm_text_search$Index$Vector$updateDocVector(docRef), _Utils_Tuple2(index, $rluiten$sparsevector$SparseVector$empty), $elm$core$Set$toList(tokenSet));
        }, $elm$core$Dict$get_fn(docRef, irec.fe)));
    }, $rluiten$elm_text_search$Index$Vector$getDocVector = F2($rluiten$elm_text_search$Index$Vector$getDocVector_fn);
    var $rluiten$elm_text_search$Index$Vector$scoreAndCompare_fn = function (queryVector, ref, _v0) {
        var index = _v0.a;
        var docs = _v0.b;
        var _v1 = $rluiten$elm_text_search$Index$Vector$getDocVector_fn(index, ref);
        var u1index = _v1.a;
        var docVector = _v1.b;
        return _Utils_Tuple2(u1index, _List_Cons(_Utils_Tuple2(ref, $rluiten$sparsevector$SparseVector$cosineSimilarity_fn(queryVector, docVector)), docs));
    }, $rluiten$elm_text_search$Index$Vector$scoreAndCompare = F3($rluiten$elm_text_search$Index$Vector$scoreAndCompare_fn);
    var $rluiten$elm_text_search$Index$searchTokens_fn = function (tokens, index) {
        var irec = index;
        var fieldBoosts = $elm$core$List$sum($elm$core$List$map_fn($elm$core$Tuple$second, irec.hs));
        var _v0 = $rluiten$elm_text_search$Index$Vector$getQueryVector_fn(fieldBoosts, tokens, index);
        var tokenDocSets = _v0.a;
        var queryVector = _v0.b;
        var u1index = _v0.c;
        var _v1 = $elm$core$List$foldr_fn($rluiten$elm_text_search$Index$Vector$scoreAndCompare(queryVector), _Utils_Tuple2(u1index, _List_Nil), $elm$core$Set$toList($rluiten$elm_text_search$Utils$intersectSets(tokenDocSets)));
        var u2index = _v1.a;
        var matchedDocs = _v1.b;
        return _Utils_Tuple2(u2index, $elm$core$List$reverse(_List_sortBy_fn($elm$core$Tuple$second, matchedDocs)));
    }, $rluiten$elm_text_search$Index$searchTokens = F2($rluiten$elm_text_search$Index$searchTokens_fn);
    var $rluiten$elm_text_search$Index$search_fn = function (query, index) {
        var _v0 = $rluiten$elm_text_search$Index$Utils$getTokens_fn(index, query);
        var i1index = _v0.a;
        var i1irec = i1index;
        var tokens = _v0.b;
        var tokenInStore = function (token) {
            return !_Utils_eq($rluiten$trie$TrieModel$getNode_fn(token, i1irec.gk), $elm$core$Maybe$Nothing);
        };
        return $elm$core$Dict$isEmpty(i1irec.fe) ? $elm$core$Result$Err("Error there are no documents in index to search.") : ($elm$core$String$isEmpty($elm$core$String$trim(query)) ? $elm$core$Result$Err("Error query is empty.") : ($elm$core$List$isEmpty(tokens) ? $elm$core$Result$Err("Error after tokenisation there are no terms to search for.") : (($elm$core$List$isEmpty(tokens) || (!$elm$core$List$any_fn(tokenInStore, tokens))) ? $elm$core$Result$Ok(_Utils_Tuple2(i1index, _List_Nil)) : $elm$core$Result$Ok($rluiten$elm_text_search$Index$searchTokens_fn(tokens, i1index)))));
    }, $rluiten$elm_text_search$Index$search = F2($rluiten$elm_text_search$Index$search_fn);
    var $rluiten$elm_text_search$ElmTextSearch$search = $rluiten$elm_text_search$Index$search;
    var $elm_community$result_extra$Result$Extra$unwrap_fn = function (defaultValue, okFunc, result) {
        if (!result.$) {
            var ok = result.a;
            return okFunc(ok);
        }
        else {
            return defaultValue;
        }
    }, $elm_community$result_extra$Result$Extra$unwrap = F3($elm_community$result_extra$Result$Extra$unwrap_fn);
    var $author$project$Search$Index$search_fn = function (_v0, query, index, entities) {
        var maxDocs = _v0.fI;
        var filter = _v0.fk;
        var sortWith = _v0.gd;
        var toIndex = function (newSearchIndex) {
            return function () {
                var $r = index.$c();
                $r.ao = newSearchIndex;
                return $r;
            }();
        };
        var toEntitiesHelper = F2(function (_v1, searchResult) {
            toEntitiesHelper: while (true) {
                var currentCount = _v1.a;
                var acc = _v1.b;
                if (_Utils_eq($elm$core$Maybe$Just(currentCount), maxDocs)) {
                    return $elm$core$List$reverse(acc);
                }
                else {
                    if (!searchResult.b) {
                        return $elm$core$List$reverse(acc);
                    }
                    else {
                        var _v3 = searchResult.a;
                        var id = _v3.a;
                        var xs = searchResult.b;
                        var _v4 = $elm$core$Dict$get_fn(id, entities);
                        if (!_v4.$) {
                            var doc = _v4.a;
                            if (filter($author$project$Search$Index$Doc_fn(id, doc))) {
                                var $temp$_v1 = _Utils_Tuple2(currentCount + 1, _List_Cons($author$project$Search$Index$Doc_fn(id, doc), acc)), $temp$searchResult = xs;
                                _v1 = $temp$_v1;
                                searchResult = $temp$searchResult;
                                continue toEntitiesHelper;
                            }
                            else {
                                var $temp$_v1 = _Utils_Tuple2(currentCount, acc), $temp$searchResult = xs;
                                _v1 = $temp$_v1;
                                searchResult = $temp$searchResult;
                                continue toEntitiesHelper;
                            }
                        }
                        else {
                            var $temp$_v1 = _Utils_Tuple2(currentCount, acc), $temp$searchResult = xs;
                            _v1 = $temp$_v1;
                            searchResult = $temp$searchResult;
                            continue toEntitiesHelper;
                        }
                    }
                }
            }
        });
        var sorter = $elm$core$Maybe$withDefault_fn($elm$core$Basics$identity, $elm$core$Maybe$map_fn($elm$core$List$sortWith, sortWith));
        var mapResult = function (_v5) {
            var newIndex = _v5.a;
            var searchResult = _v5.b;
            return _Utils_Tuple2(toIndex(newIndex), sorter(A2(toEntitiesHelper, _Utils_Tuple2(0, _List_Nil), searchResult)));
        };
        return $elm_community$result_extra$Result$Extra$unwrap_fn(_Utils_Tuple2(index, _List_Nil), mapResult, $rluiten$elm_text_search$Index$search_fn(query, index.ao));
    }, $author$project$Search$Index$search = F4($author$project$Search$Index$search_fn);
    var $author$project$Firestore$Collection$toList = A2($author$project$Firestore$Collection$foldr, F3(function (id, doc, accum) {
        return _List_Cons(_Utils_Tuple2(id, doc), accum);
    }), _List_Nil);
    var $author$project$Search$Result$searchNotes_fn = function (env, noteIndex, config, stringQuery, searchQuery) {
        var noteFilterMapper = function (_v1) {
            var noteId = _v1.a;
            var note = _v1.b;
            var noteItem = $author$project$Search$Result$UnindexedDoc_fn(noteId, note);
            return $author$project$Util$Misc$toJustIf_fn(config.fO.fk(noteItem), noteItem);
        };
        var normalizedQuery = $author$project$Search$Query$normalizeQuery_fn(0, searchQuery);
        var _v0 = _Utils_Tuple2($elm$core$Maybe$withDefault_fn($elm$core$Basics$identity, $elm$core$Maybe$map_fn($elm$core$List$sortWith, config.fO.gd)), $elm$core$Maybe$withDefault_fn($elm$core$Basics$identity, $elm$core$Maybe$map_fn($elm$core$List$take, config.fO.fI)));
        var sorter = _v0.a;
        var taker = _v0.b;
        var searchFunc = $elm$core$String$isEmpty(stringQuery) ? A2($elm$core$Basics$composeR, $elm$core$List$filterMap(noteFilterMapper), A2($elm$core$Basics$composeR, sorter, A2($elm$core$Basics$composeR, taker, $elm$core$List$map($author$project$Search$Result$NoteEntity)))) : A2($elm$core$Basics$composeR, $elm$core$Dict$fromList, A2($elm$core$Basics$composeR, A3($author$project$Search$Index$search, config.fO, stringQuery, noteIndex), A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$map($author$project$Search$Result$NoteEntity))));
        return searchFunc($elm$core$List$foldl_fn($author$project$Search$Result$applyNoteFilters(env), $author$project$Firestore$Collection$toList(env.fO), normalizedQuery));
    }, $author$project$Search$Result$searchNotes = F5($author$project$Search$Result$searchNotes_fn);
    var $author$project$Search$Result$applyPeopleFilters = function (filter) {
        if ((filter.$ === 1) && (!filter.a.$)) {
            var _v1 = filter.a;
            var filterPersonId = _v1.b;
            return $elm$core$List$filter(A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$eq(filterPersonId)));
        }
        else {
            return $elm$core$Basics$identity;
        }
    };
    var $author$project$Search$Result$searchPeople_fn = function (people, personIndex, config, stringQuery, searchQuery) {
        var filterMapper = function (_v1) {
            var personId = _v1.a;
            var person = _v1.b;
            var personItem = $author$project$Search$Result$UnindexedDoc_fn(personId, person);
            return $author$project$Util$Misc$toJustIf_fn(config.iz.fk(personItem), personItem);
        };
        var _v0 = _Utils_Tuple2($elm$core$Maybe$withDefault_fn($elm$core$Basics$identity, $elm$core$Maybe$map_fn($elm$core$List$sortWith, config.iz.gd)), $elm$core$Maybe$withDefault_fn($elm$core$Basics$identity, $elm$core$Maybe$map_fn($elm$core$List$take, config.iz.fI)));
        var sorter = _v0.a;
        var taker = _v0.b;
        var searchFunc = $elm$core$String$isEmpty(stringQuery) ? A2($elm$core$Basics$composeR, $elm$core$List$filterMap(filterMapper), A2($elm$core$Basics$composeR, sorter, A2($elm$core$Basics$composeR, taker, $elm$core$List$map($author$project$Search$Result$PersonEntity)))) : A2($elm$core$Basics$composeR, $elm$core$Dict$fromList, A2($elm$core$Basics$composeR, A3($author$project$Search$Index$search, config.iz, stringQuery, personIndex), A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$map($author$project$Search$Result$PersonEntity))));
        return searchFunc($elm$core$List$foldl_fn($author$project$Search$Result$applyPeopleFilters, $author$project$Firestore$Collection$toList(people), searchQuery));
    }, $author$project$Search$Result$searchPeople = F5($author$project$Search$Result$searchPeople_fn);
    var $author$project$Search$Query$stringQuery_a0 = $elm$core$List$filterMap(function (filter) {
        if (filter.$ === 5) {
            var str = filter.a;
            return $elm$core$Maybe$Just(str);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }), $author$project$Search$Query$stringQuery_a1 = $elm$core$String$join(" "), $author$project$Search$Query$stringQuery = A2($elm$core$Basics$composeR, $author$project$Search$Query$stringQuery_a0, $author$project$Search$Query$stringQuery_a1);
    var $author$project$Search$Result$toEntityList_fn = function (env, indices, config, mCategory, searchQuery) {
        var stringQuery = $elm$core$Basics$composeR_fn($author$project$Search$Query$stringQuery_a0, $author$project$Search$Query$stringQuery_a1, searchQuery);
        var people = function (_v6) {
            return $author$project$Search$Result$searchPeople_fn(env.iz, indices.iz, config, stringQuery, searchQuery);
        };
        var notes = function (_v5) {
            return $author$project$Search$Result$searchNotes_fn(env, indices.fO, config, stringQuery, searchQuery);
        };
        var attachments = function (_v4) {
            return $author$project$Search$Result$searchAttachments_fn(env, config, stringQuery, searchQuery);
        };
        if (mCategory.$ === 1) {
            return _Utils_ap(people(0), _Utils_ap(notes(0), attachments(0)));
        }
        else {
            switch (mCategory.a) {
                case 0:
                    var _v1 = mCategory.a;
                    return notes(0);
                case 1:
                    var _v2 = mCategory.a;
                    return people(0);
                default:
                    var _v3 = mCategory.a;
                    return attachments(0);
            }
        }
    }, $author$project$Search$Result$toEntityList = F5($author$project$Search$Result$toEntityList_fn);
    var $author$project$Search$Result$search_fn = function (env, indices, config, mCategory, searchQuery) {
        if (!searchQuery.b) {
            return config.j4 ? (new $$Record45($elm$core$Dict$fromList($elm$core$List$indexedMap_fn($elm$core$Tuple$pair, $author$project$Search$Result$allEntities_fn(env, config, mCategory))), _List_Nil)) : $author$project$Search$Result$empty;
        }
        else {
            return (new $$Record45($elm$core$Dict$fromList($elm$core$List$indexedMap_fn($elm$core$Tuple$pair, $author$project$Search$Result$toEntityList_fn(env, indices, config, mCategory, searchQuery))), searchQuery));
        }
    }, $author$project$Search$Result$search = F5($author$project$Search$Result$search_fn);
    var $elm$core$Result$toMaybe = function (result) {
        if (!result.$) {
            var v = result.a;
            return $elm$core$Maybe$Just(v);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Page$Search$generateResults_fn = function (env, indices, mStringQuery, mCategory) {
        var searchQuery = $elm$core$Maybe$andThen_fn(A2($elm$core$Basics$composeR, $elm$json$Json$Decode$decodeString($author$project$Search$Query$decoder), $elm$core$Result$toMaybe), $elm$core$Maybe$andThen_fn(A2($elm$core$Basics$composeR, $author$project$Util$UrlBase64$decode, $elm$core$Result$toMaybe), mStringQuery));
        var initialCategory = $elm$core$Maybe$withDefault_fn($author$project$Page$Search$defaultCategory, mCategory);
        return $elm$core$Maybe$withDefault_fn($author$project$Search$Result$empty, $elm$core$Maybe$map_fn(A4($author$project$Search$Result$search, env, indices, $author$project$Page$Search$config(env), $elm$core$Maybe$Just(initialCategory)), searchQuery));
    }, $author$project$Page$Search$generateResults = F4($author$project$Page$Search$generateResults_fn);
    var $author$project$View$ActionItems$FadingDebouncerMsg = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$View$ActionItems$fadeOutDuration = 5000;
    var $author$project$View$ActionItems$initFader = (new $$Record52($author$project$Lib$Debouncer$init({ lc: $author$project$View$ActionItems$fadeOutDuration, pp: $author$project$View$ActionItems$fadeOutDuration, pz: $author$project$View$ActionItems$FadingDebouncerMsg }), $elm$core$Set$empty));
    var $author$project$Page$ActionItems$init = (new $$Record53($author$project$View$ActionItems$initFader));
    var $author$project$Page$Billing$init = {};
    var $justinmimbs$date$Date$Weeks = 2;
    var $justinmimbs$date$Date$toMonths = function (rd) {
        var date = $justinmimbs$date$Date$toCalendarDate(rd);
        var wholeMonths = (12 * (date.bO - 1)) + ($justinmimbs$date$Date$monthToNumber(date.bz) - 1);
        return wholeMonths + (date.lb / 100);
    };
    var $elm$core$Basics$truncate = _Basics_truncate;
    var $justinmimbs$date$Date$diff_fn = function (unit, _v0, _v1) {
        var rd1 = _v0;
        var rd2 = _v1;
        switch (unit) {
            case 0:
                return ((($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0) / 12) | 0;
            case 1:
                return ($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0;
            case 2:
                return ((rd2 - rd1) / 7) | 0;
            default:
                return rd2 - rd1;
        }
    }, $justinmimbs$date$Date$diff = F3($justinmimbs$date$Date$diff_fn);
    var $author$project$Page$Calendar$init_fn = function (env, maybeDate) {
        var agendaOffset = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn(function (date) {
            return $justinmimbs$date$Date$diff_fn(2, $justinmimbs$date$Date$fromPosix_fn(env.pu, env.k5), date);
        }, maybeDate));
        return { U: agendaOffset };
    }, $author$project$Page$Calendar$init = F2($author$project$Page$Calendar$init_fn);
    var $author$project$Page$Collate$paginateByCount = 30;
    var $author$project$Page$Collate$init_fn = function (collation, mCount) {
        return {
            b$: collation,
            dv: $elm$core$Maybe$withDefault_fn($author$project$Page$Collate$paginateByCount, mCount)
        };
    }, $author$project$Page$Collate$init = F2($author$project$Page$Collate$init_fn);
    var $author$project$Page$Demo$init = 0;
    var $author$project$Page$Home$ThreadTabTodos = 0;
    var $author$project$Page$Home$init_fn = function (env, maybeDate) {
        var agendaOffset = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn(function (date) {
            return $justinmimbs$date$Date$diff_fn(3, $justinmimbs$date$Date$fromPosix_fn(env.pu, env.k5), date);
        }, maybeDate));
        return (new $$Record54($author$project$View$ActionItems$initFader, agendaOffset, 0));
    }, $author$project$Page$Home$init = F2($author$project$Page$Home$init_fn);
    var $author$project$Page$Person$Recent = 0;
    var $elm$core$Set$foldl_fn = function (func, initialState, _v0) {
        var dict = _v0;
        return $elm$core$Dict$foldl_fn_unwrapped(function (key, _v1, state) {
            return A2(func, key, state);
        }, initialState, dict);
    }, $elm$core$Set$foldl_fn_unwrapped = function (func, initialState, _v0) {
        var dict = _v0;
        return $elm$core$Dict$foldl_fn_unwrapped(function (key, _v1, state) {
            return func(key, state);
        }, initialState, dict);
    }, $elm$core$Set$foldl = F3($elm$core$Set$foldl_fn);
    var $elm$core$Set$map_fn = function (func, set) {
        return $elm$core$Set$fromList($elm$core$Set$foldl_fn_unwrapped(function (x, xs) {
            return _List_Cons(func(x), xs);
        }, _List_Nil, set));
    }, $elm$core$Set$map = F2($elm$core$Set$map_fn);
    var $elm$core$Set$size = function (_v0) {
        var dict = _v0;
        return $elm$core$Dict$size(dict);
    };
    var $author$project$Data$Person$areSimilar_fn = function (primary, secondary) {
        return _Utils_eq(A2($elm$core$Basics$composeR, $elm$core$String$toLower, $elm$core$String$trim)(primary.b), A2($elm$core$Basics$composeR, $elm$core$String$toLower, $elm$core$String$trim)(secondary.b)) || (!(!$elm$core$Set$size($elm$core$Set$intersect_fn($elm$core$Set$map_fn($elm$core$String$toLower, $elm$core$Set$fromList(primary.lo)), $elm$core$Set$map_fn($elm$core$String$toLower, $elm$core$Set$fromList(secondary.lo))))));
    }, $author$project$Data$Person$areSimilar = F2($author$project$Data$Person$areSimilar_fn);
    var $author$project$Firestore$Collection$filter = function (filterFn) {
        return $author$project$Firestore$Collection$filterMap_unwrapped(function (id, doc) {
            return A2(filterFn, id, doc) ? $elm$core$Maybe$Just(_Utils_Tuple2(id, doc)) : $elm$core$Maybe$Nothing;
        });
    }, $author$project$Firestore$Collection$filter_unwrapped = function (filterFn) {
        return $author$project$Firestore$Collection$filterMap_unwrapped(function (id, doc) {
            return filterFn(id, doc) ? $elm$core$Maybe$Just(_Utils_Tuple2(id, doc)) : $elm$core$Maybe$Nothing;
        });
    };
    var $elm_community$maybe_extra$Maybe$Extra$filter_fn = function (f, m) {
        var _v0 = $elm$core$Maybe$map_fn(f, m);
        if ((!_v0.$) && _v0.a) {
            return m;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $elm_community$maybe_extra$Maybe$Extra$filter = F2($elm_community$maybe_extra$Maybe$Extra$filter_fn);
    var $author$project$Data$Person$isMergeable = function (person) {
        return (!person.lh) && _Utils_eq(person.mZ, $elm$core$Maybe$Nothing);
    };
    var $author$project$Page$Person$computePotentialDupes = function (env) {
        var mPerson = function () {
            var _v1 = env.oe;
            if (_v1.$ === 9) {
                var personId = _v1.a;
                return $elm$core$Maybe$map_fn(function (p) {
                    return _Utils_Tuple2(personId, p);
                }, $elm_community$maybe_extra$Maybe$Extra$filter_fn($author$project$Data$Person$isMergeable, $author$project$Firestore$Collection$get_fn(personId, env.iz)));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }();
        return _List_sortBy_fn($elm$core$Tuple$first, $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(function (_v0) {
            var personId = _v0.a;
            var person = _v0.b;
            return A2($author$project$Firestore$Collection$filter, F2(function (otherId, otherPerson) {
                return (!_Utils_eq(personId, otherId)) && ((!$elm$core$List$member_fn(otherId, person.no)) && ((!$elm$core$List$member_fn(personId, otherPerson.no)) && ($author$project$Data$Person$isMergeable(otherPerson) && $author$project$Data$Person$areSimilar_fn(person, otherPerson))));
            }), env.iz);
        }, mPerson)));
    };
    var $author$project$Page$Person$init = function (env) {
        return (new $$Record55($author$project$View$ActionItems$initFader, $elm$core$Maybe$Nothing, false, 0, $elm$core$Maybe$Nothing, $author$project$Page$Person$computePotentialDupes(env), false));
    };
    var $author$project$Page$Search$NoOp = function (a) {
        return { $: 12, a: a };
    };
    var $elm$core$Task$onError = _Scheduler_onError;
    var $elm$core$Task$attempt_fn = function (resultToMessage, task) {
        return $elm$core$Task$command(_Scheduler_onError_fn(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Err), _Scheduler_andThen_fn(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Ok), task)));
    }, $elm$core$Task$attempt = F2($elm$core$Task$attempt_fn);
    var $elm$browser$Browser$Dom$focus_a0 = "focus", $elm$browser$Browser$Dom$focus = _Browser_call($elm$browser$Browser$Dom$focus_a0);
    var $author$project$Search$Bar$inputId = "witful-searchbar";
    var $elm$core$Process$sleep = _Process_sleep;
    var $author$project$Search$Bar$focus = function (noOp) {
        return $elm$core$Task$attempt_fn(function (_v1) {
            return noOp("Focus searchbar");
        }, _Scheduler_andThen_fn(function (_v0) {
            return _Browser_call_fn($elm$browser$Browser$Dom$focus_a0, $author$project$Search$Bar$inputId);
        }, $elm$core$Process$sleep(30)));
    };
    var $author$project$Page$Search$init_fn = function (env, indices, mStringQuery, mCategory) {
        return _Utils_Tuple2((new $$Record56($elm$core$Maybe$withDefault_fn($author$project$Page$Search$defaultCategory, mCategory), "", $author$project$Page$Search$generateResults_fn(env, indices, mStringQuery, mCategory), $elm$core$Maybe$Nothing, 0)), $author$project$Search$Bar$focus($author$project$Page$Search$NoOp));
    }, $author$project$Page$Search$init = F4($author$project$Page$Search$init_fn);
    var $author$project$Page$Settings$init = 0;
    var $author$project$Env$InsertNoteTransient_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Env$InsertNoteTransient = F2($author$project$Env$InsertNoteTransient_fn);
    var $author$project$Data$Time$fromMillis = function (n) {
        return $author$project$Data$Time$Time((new $$Record26($elm$time$Time$millisToPosix(n), 0)));
    };
    var $author$project$Content$Person$introductoryPersonId = "_lindsey-welcome";
    var $author$project$Content$Note$baseIntroductoryNote = (new $$Record23(_List_Nil, _List_Nil, _List_fromArray([
        (new $$Record31($elm$core$Maybe$Just(0), false, "Lindsey from Witful", $elm$core$Maybe$Nothing, $author$project$Data$Note$PersonRef($author$project$Content$Person$introductoryPersonId)))
    ]), $elm$core$Maybe$Nothing, $author$project$Data$Timestamp$serverTimestamp, false, "", $author$project$Data$Time$fromMillis(0), $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, false, 1, $author$project$Data$Slate$emptyDoc, $author$project$Data$Time$fromMillis(0), "", $author$project$Data$Timestamp$serverTimestamp));
    var $author$project$Content$Note$wizardDefaultNote_fn = function (userTimezone, currentMinute) {
        var tomorrow = $author$project$Data$Time$Date($justinmimbs$date$Date$fromPosix_fn(userTimezone, $justinmimbs$time_extra$Time$Extra$add_fn(11, 1, userTimezone, currentMinute)));
        var today = $author$project$Data$Time$Date($justinmimbs$date$Date$fromPosix_fn(userTimezone, currentMinute));
        return function () {
            var $r = $author$project$Content$Note$baseIntroductoryNote.$c();
            $r.f6 = "[{\"type\":\"p\",\"children\":[{\"text\":\"This is my first to do\"}]}]";
            $r.fR = $elm$time$Time$posixToMillis(currentMinute);
            $r.fc = "This is my first to do";
            $r.fh = tomorrow;
            $r.gh = today;
            $r.gj = "This is my first meeting note";
            return $r;
        }();
    }, $author$project$Content$Note$wizardDefaultNote = F2($author$project$Content$Note$wizardDefaultNote_fn);
    var $author$project$Content$Note$wizardNoteId = "_witful-wizard-note";
    var $author$project$Page$Signup$init = function (env) {
        return _Utils_Tuple2((new $$Record57(false, 0, false, false)), $author$project$Env$InsertNoteTransient_fn($author$project$Content$Note$wizardNoteId, $author$project$Content$Note$wizardDefaultNote_fn(env.pu, env.k5)));
    };
    var $author$project$Data$App$isProd = function (url) {
        var _v0 = url.hK;
        switch (_v0) {
            case "next.witful.com":
                return true;
            case "app.witful.com":
                return true;
            default:
                return false;
        }
    };
    var $elm$core$Platform$Cmd$map = _Platform_map;
    var $author$project$Model$NoteMsg = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Model$PageNote_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Model$PageNote = F2($author$project$Model$PageNote_fn);
    var $author$project$Data$Settings$defaultToAttendeesTab_a0 = $author$project$Data$Settings$get, $author$project$Data$Settings$defaultToAttendeesTab_a1 = function ($) {
        return $.cP;
    }, $author$project$Data$Settings$defaultToAttendeesTab = A2($elm$core$Basics$composeR, $author$project$Data$Settings$defaultToAttendeesTab_a0, $author$project$Data$Settings$defaultToAttendeesTab_a1);
    var $author$project$Util$Misc$if__fn = function (a, b, c) {
        return a ? b : c;
    }, $author$project$Util$Misc$if_ = F3($author$project$Util$Misc$if__fn);
    var $author$project$Data$ActionItemsCache$totalCount = function (cache) {
        return $elm$core$List$sum($elm$core$List$map_fn(function (field) {
            return $elm$core$List$length(field(cache));
        }, _List_fromArray([
            function ($) {
                return $.cX;
            },
            function ($) {
                return $.dT;
            },
            function ($) {
                return $.dS;
            }
        ])));
    };
    var $author$project$Page$Note$fallbackTab_fn = function (env, actionItemsCache) {
        return $author$project$Util$Misc$if__fn((!$author$project$Data$ActionItemsCache$totalCount(actionItemsCache)) && $elm$core$Basics$composeR_fn($author$project$Data$Settings$defaultToAttendeesTab_a0, $author$project$Data$Settings$defaultToAttendeesTab_a1, env), 1, 0);
    }, $author$project$Page$Note$fallbackTab = F2($author$project$Page$Note$fallbackTab_fn);
    var $author$project$Util$Time$add_fn = function (unit, time) {
        return $elm$time$Time$millisToPosix($elm$time$Time$posixToMillis(time) + unit);
    }, $author$project$Util$Time$add = F2($author$project$Util$Time$add_fn);
    var $author$project$Util$Time$second = 1000;
    var $author$project$Util$Time$minute = $author$project$Util$Time$second * 60;
    var $author$project$Util$Time$addMins = function (mins) {
        return $author$project$Util$Time$add($author$project$Util$Time$minute * mins);
    };
    var $author$project$Data$AttendeeList$ExistingPerson = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$AttendeeList$NonExistentPersonEmail = function (a) {
        return { $: 1, a: a };
    };
    var $elm_community$string_extra$String$Extra$rightOfBack_fn = function (pattern, string) {
        return $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$Basics$add($elm$core$String$length(pattern)), function (a) {
            return $elm$core$String$dropLeft_fn(a, string);
        }), $elm$core$List$head($elm$core$List$reverse(_String_indexes_fn(pattern, string)))));
    }, $elm_community$string_extra$String$Extra$rightOfBack = F2($elm_community$string_extra$String$Extra$rightOfBack_fn);
    var $author$project$Util$Text$domainFromEmail = function (email) {
        return _String_contains_fn("@", email) ? $elm$core$Maybe$Just($elm$core$String$toLower($elm_community$string_extra$String$Extra$rightOfBack_fn("@", email))) : $elm$core$Maybe$Nothing;
    };
    var $author$project$Data$AttendeeList$domainOfEmail_a0 = $author$project$Util$Text$domainFromEmail, $author$project$Data$AttendeeList$domainOfEmail_a1 = $elm$core$Maybe$withDefault(""), $author$project$Data$AttendeeList$domainOfEmail = A2($elm$core$Basics$composeR, $author$project$Data$AttendeeList$domainOfEmail_a0, $author$project$Data$AttendeeList$domainOfEmail_a1);
    var $author$project$Util$Triple$dropSecond = function (_v0) {
        var a = _v0.a;
        var b = _v0.b;
        var c = _v0.c;
        return _Utils_Tuple2(a, c);
    };
    var $author$project$Firestore$Collection$find_fn = function (predicate, collection) {
        return $author$project$Firestore$Collection$foldlWithState_fn_unwrapped(function (id, state, doc, acc) {
            if (!acc.$) {
                return acc;
            }
            else {
                return A3(predicate, id, state, doc) ? $elm$core$Maybe$Just(_Utils_Tuple3(id, state, doc)) : $elm$core$Maybe$Nothing;
            }
        }, $elm$core$Maybe$Nothing, collection);
    }, $author$project$Firestore$Collection$find_fn_unwrapped = function (predicate, collection) {
        return $author$project$Firestore$Collection$foldlWithState_fn_unwrapped(function (id, state, doc, acc) {
            if (!acc.$) {
                return acc;
            }
            else {
                return predicate(id, state, doc) ? $elm$core$Maybe$Just(_Utils_Tuple3(id, state, doc)) : $elm$core$Maybe$Nothing;
            }
        }, $elm$core$Maybe$Nothing, collection);
    }, $author$project$Firestore$Collection$find = F2($author$project$Firestore$Collection$find_fn);
    var $author$project$Data$Person$findByEmail = function (email) {
        return $author$project$Firestore$Collection$find(F3(function (_v0, _v1, person) {
            return (!person.lh) && $elm$core$List$member_fn($elm$core$String$toLower(email), $elm$core$List$map_fn($elm$core$String$toLower, person.lo));
        }));
    };
    var $author$project$Data$AttendeeList$resolveAttendeeRef_fn = function (people, attendee) {
        var _v0 = attendee.n3;
        if (_v0.$ === 1) {
            var email = _v0.a;
            return $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just($elm$core$Basics$composeR_fn($author$project$Data$AttendeeList$domainOfEmail_a0, $author$project$Data$AttendeeList$domainOfEmail_a1, email)), $elm$core$Maybe$withDefault_fn($author$project$Data$AttendeeList$NonExistentPersonEmail(email), $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $author$project$Util$Triple$dropSecond, $author$project$Data$AttendeeList$ExistingPerson), A2($author$project$Data$Person$findByEmail, email, people)))));
        }
        else {
            var personId = _v0.a;
            return $elm$core$Maybe$map_fn(function (_v1) {
                var resolvedPersonId = _v1.a;
                var resolvedPerson = _v1.b;
                return _Utils_Tuple2($elm$core$Maybe$map_fn($author$project$Data$AttendeeList$domainOfEmail, $elm$core$List$head(resolvedPerson.lo)), $author$project$Data$AttendeeList$ExistingPerson(_Utils_Tuple2(resolvedPersonId, resolvedPerson)));
            }, $author$project$Data$Person$resolvePerson_fn(personId, people));
        }
    }, $author$project$Data$AttendeeList$resolveAttendeeRef = F2($author$project$Data$AttendeeList$resolveAttendeeRef_fn);
    var $author$project$Data$AttendeeList$attendeesPersonIds_fn = function (people, attendees) {
        return $elm$core$Set$fromList($elm$core$List$filterMap_fn(A2($elm$core$Basics$composeR, $author$project$Data$AttendeeList$resolveAttendeeRef(people), $elm$core$Maybe$andThen(function (_v0) {
            var resolvedRef = _v0.b;
            if (!resolvedRef.$) {
                var _v2 = resolvedRef.a;
                var personId = _v2.a;
                return $elm$core$Maybe$Just(personId);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        })), attendees));
    }, $author$project$Data$AttendeeList$attendeesPersonIds = F2($author$project$Data$AttendeeList$attendeesPersonIds_fn);
    var $elm$core$Dict$diff_fn = function (t1, t2) {
        return $elm$core$Dict$foldl_fn_unwrapped(function (k, v, t) {
            return $elm$core$Dict$remove_fn(k, t);
        }, t1, t2);
    }, $elm$core$Dict$diff = F2($elm$core$Dict$diff_fn);
    var $elm$core$Set$diff_fn = function (_v0, _v1) {
        var dict1 = _v0;
        var dict2 = _v1;
        return $elm$core$Dict$diff_fn(dict1, dict2);
    }, $elm$core$Set$diff = F2($elm$core$Set$diff_fn);
    var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
        if (m.$ === 1) {
            return false;
        }
        else {
            return true;
        }
    };
    var $author$project$Data$ActionItem$isComplete = function (_v0) {
        var completedAt = _v0.g_;
        return $elm_community$maybe_extra$Maybe$Extra$isJust(completedAt);
    };
    var $author$project$Data$Mention$nextEventId = "_witful-next-meeting";
    var $author$project$Data$Mention$isNextEventRef = function (mentionEventRefData) {
        if (!mentionEventRefData.$) {
            var masterId = mentionEventRefData.a.mT;
            return _Utils_eq(masterId, $author$project$Data$Mention$nextEventId);
        }
        else {
            return false;
        }
    };
    var $author$project$Data$Mention$nextOneOnOne = "_witful-next-1-on-1";
    var $author$project$Data$Mention$isNextOneOnOneRef = function (mentionEventRefData) {
        if (!mentionEventRefData.$) {
            var masterId = mentionEventRefData.a.mT;
            return _Utils_eq(masterId, $author$project$Data$Mention$nextOneOnOne);
        }
        else {
            return false;
        }
    };
    var $author$project$Util$Time$isOnOrAfter_fn = function (t1, t2) {
        return _Utils_cmp($elm$time$Time$posixToMillis(t2), $elm$time$Time$posixToMillis(t1)) > -1;
    }, $author$project$Util$Time$isOnOrAfter = F2($author$project$Util$Time$isOnOrAfter_fn);
    var $author$project$Data$ActionItem$isTodo = function (actionItem) {
        return $elm$core$List$any_fn(function (textEl) {
            if ((textEl.$ === 3) && (!textEl.a.$)) {
                return true;
            }
            else {
                return false;
            }
        }, actionItem.jn);
    };
    var $author$project$Data$Note$masterEventId = function (_v0) {
        var eventRef = _v0.hh;
        if ((!eventRef.$) && (eventRef.a.$ === 1)) {
            var masterId = eventRef.a.a.mT;
            return $elm$core$Maybe$Just(masterId);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $elm$core$Dict$singleton_fn = function (key, value) {
        return $elm$core$Dict$RBNode_elm_builtin_fn(1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
    }, $elm$core$Dict$singleton = F2($elm$core$Dict$singleton_fn);
    var $elm$core$Set$singleton = function (key) {
        return $elm$core$Dict$singleton_fn(key, 0);
    };
    var $author$project$Util$Misc$consIf_fn = function (bool, a, list) {
        return bool ? _List_Cons(a, list) : list;
    }, $author$project$Util$Misc$consIf = F3($author$project$Util$Misc$consIf_fn);
    var $author$project$Data$ActionItemsCache$isCurrentTopic_fn = function (mEventBaseId, ai) {
        return $elm$core$List$any_fn(function (text) {
            _v0$2: while (true) {
                switch (text.$) {
                    case 1:
                        var refData = text.a;
                        var currentTopic = text.c.k7;
                        return function () {
                            switch (refData.$) {
                                case 0:
                                    var masterId = refData.a.mT;
                                    return _Utils_eq($elm$core$Maybe$Just($author$project$Data$Event$baseId(masterId)), mEventBaseId);
                                case 1:
                                    var masterId = refData.a.mT;
                                    return false;
                                default:
                                    var eventId = refData.a.b7;
                                    return _Utils_eq($elm$core$Maybe$Just($author$project$Data$Event$baseId(eventId)), mEventBaseId);
                            }
                        }() && currentTopic;
                    case 3:
                        if (text.a.$ === 1) {
                            var _v2 = text.a;
                            return true;
                        }
                        else {
                            break _v0$2;
                        }
                    default:
                        break _v0$2;
                }
            }
            return false;
        }, ai.jn);
    }, $author$project$Data$ActionItemsCache$isCurrentTopic = F2($author$project$Data$ActionItemsCache$isCurrentTopic_fn);
    var $author$project$Data$ActionItemsCache$update_fn = function (mEventRef, oldCache, notesActionItems) {
        var mBaseId = function () {
            if (!mEventRef.$) {
                if (!mEventRef.a.$) {
                    var eventId = mEventRef.a.a.b7;
                    return $elm$core$Maybe$Just(eventId);
                }
                else {
                    var masterId = mEventRef.a.a.mT;
                    return $elm$core$Maybe$Just($author$project$Data$Event$baseId(masterId));
                }
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }();
        return function (_v1) {
            var topics = _v1.a;
            var actionItems = _v1.b;
            return function () {
                var $r = oldCache.$c();
                $r.dS = actionItems;
                $r.dT = topics;
                return $r;
            }();
        }($elm$core$List$foldr_fn(F2(function (ai, _v0) {
            var topics = _v0.a;
            var actionItems = _v0.b;
            var isCurrentTopic_ = $author$project$Data$ActionItemsCache$isCurrentTopic_fn(mBaseId, ai);
            return _Utils_Tuple2($author$project$Util$Misc$consIf_fn(isCurrentTopic_, ai, topics), $author$project$Util$Misc$consIf_fn(!isCurrentTopic_, ai, actionItems));
        }), _Utils_Tuple2(_List_Nil, _List_Nil), notesActionItems));
    }, $author$project$Data$ActionItemsCache$update = F3($author$project$Data$ActionItemsCache$update_fn);
    var $author$project$Data$ActionItemsCache$generate_fn = function (env, noteId) {
        var personMentionCount = function (_v12) {
            var text = _v12.jn;
            return $elm$core$List$length($elm$core$List$filter_fn(function (aiText) {
                if (aiText.$ === 2) {
                    return true;
                }
                else {
                    return false;
                }
            }, text));
        };
        var noteAttendeesPersonIds = $author$project$Data$AttendeeList$attendeesPersonIds_fn(env.iz, $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(function ($) {
            return $.ke;
        }, $author$project$Firestore$Collection$get_fn(noteId, env.fO))));
        var mNote = $author$project$Firestore$Collection$get_fn(noteId, env.fO);
        var mNoteEventId = $elm$core$Maybe$andThen_fn($author$project$Data$Note$getEventId, mNote);
        var meetingIsNowishOrInFuture = $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(function (currentNote) {
            return $author$project$Util$Time$isOnOrAfter_fn(env.k5, A2($author$project$Util$Time$addMins, 60, $author$project$Data$Time$toPosix_fn(env.pu, currentNote.fh)));
        }, mNote));
        var mMasterEventId = $elm$core$Maybe$andThen_fn($author$project$Data$Note$masterEventId, mNote);
        var isSameSeries = function (otherNote) {
            return $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map2_fn_unwrapped(function (otherNoteMasterId, currentNoteMasterId) {
                return _Utils_eq($author$project$Data$Event$baseId(otherNoteMasterId), $author$project$Data$Event$baseId(currentNoteMasterId));
            }, $author$project$Data$Note$masterEventId(otherNote), mMasterEventId));
        };
        var currentUsersPersonId = $elm$core$Maybe$withDefault_fn("user-does-not-exist", env.pY);
        var isOneOnOne = function (set) {
            return $elm$core$Set$size(set) === 1;
        }($elm$core$Set$diff_fn(noteAttendeesPersonIds, $elm$core$Set$singleton(currentUsersPersonId)));
        var actionItemMentionsAttendee = function (_v10) {
            var text = _v10.jn;
            return $elm$core$List$any_fn(function (aiText) {
                if (aiText.$ === 2) {
                    var personId = aiText.a.iB;
                    return $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(function (_v9) {
                        var resolvedPersonId = _v9.a;
                        return $elm$core$Set$member_fn(resolvedPersonId, noteAttendeesPersonIds);
                    }, $author$project$Data$Person$resolvePerson_fn(personId, env.iz)));
                }
                else {
                    return false;
                }
            }, text);
        };
        var showActionItemWithSeriesMention = F3(function (ai, masterId, eventRefType) {
            var isOneOnOneMention = function (_v7) {
                return $author$project$Data$Mention$isNextOneOnOneRef(eventRefType) && (isOneOnOne && actionItemMentionsAttendee(ai));
            };
            var isNextMention = function (_v6) {
                return $author$project$Data$Mention$isNextEventRef(eventRefType) && ((!personMentionCount(ai)) || actionItemMentionsAttendee(ai));
            };
            var currentNoteInSameSeries = _Utils_eq($elm$core$Maybe$map_fn($author$project$Data$Event$baseId, mNoteEventId), $elm$core$Maybe$Just($author$project$Data$Event$baseId(masterId)));
            return (!$author$project$Data$ActionItem$isComplete(ai)) && (currentNoteInSameSeries || (isOneOnOneMention(0) || isNextMention(0)));
        });
        var showActionItemWithEventRef = F3(function (ai, refData, mCompletedIn) {
            var _v2 = _Utils_Tuple2(refData, mCompletedIn);
            if (!_v2.b.$) {
                if (!_v2.b.a.$) {
                    var eventId = _v2.b.a.a.b7;
                    return _Utils_eq(mNoteEventId, $elm$core$Maybe$Just(eventId));
                }
                else {
                    var eventId = _v2.b.a.a.b7;
                    return _Utils_eq(mNoteEventId, $elm$core$Maybe$Just(eventId));
                }
            }
            else {
                switch (_v2.a.$) {
                    case 0:
                        var eventRefData = _v2.a;
                        var masterId = eventRefData.a.mT;
                        var _v3 = _v2.b;
                        return A3(showActionItemWithSeriesMention, ai, masterId, eventRefData);
                    case 1:
                        var eventId = _v2.a.a.b7;
                        var _v4 = _v2.b;
                        return _Utils_eq(mNoteEventId, $elm$core$Maybe$Just(eventId));
                    default:
                        var eventId = _v2.a.a.b7;
                        var _v5 = _v2.b;
                        return _Utils_eq(mNoteEventId, $elm$core$Maybe$Just(eventId));
                }
            }
        });
        var actionItemTextIsRelevant = F2(function (ai, aiText) {
            if (aiText.$ === 1) {
                var refData = aiText.a;
                var mCompletedIn = aiText.b;
                return A3(showActionItemWithEventRef, ai, refData, mCompletedIn);
            }
            else {
                return false;
            }
        });
        var actionItemIsRelevant = F2(function (otherNote, ai) {
            var isCarryForwardItem = isSameSeries(otherNote) && ((!$author$project$Data$ActionItem$isComplete(ai)) && $author$project$Data$ActionItem$isTodo(ai));
            var hasRelevantText = function (_v0) {
                return $elm$core$List$any_fn(actionItemTextIsRelevant(ai), ai.jn);
            };
            return isCarryForwardItem || hasRelevantText(0);
        });
        var reducer = F3(function (noteId_, note, acc) {
            return note.lh ? acc : (_Utils_eq(noteId_, noteId) ? $author$project$Data$ActionItemsCache$update_fn(note.hh, acc, note.gz) : function () {
                var $r = acc.$c();
                $r.cX = _Utils_ap($elm$core$List$filter_fn(actionItemIsRelevant(note), note.gz), acc.cX);
                return $r;
            }());
        });
        return A3($author$project$Firestore$Collection$foldl, reducer, (new $$Record58(_List_Nil, _List_Nil, _List_Nil)), env.fO);
    }, $author$project$Data$ActionItemsCache$generate = F2($author$project$Data$ActionItemsCache$generate_fn);
    var $author$project$Page$Note$AttachmentThumbnailUrlRequest_fn = function (a, b) {
        return { $: 26, a: a, b: b };
    }, $author$project$Page$Note$AttachmentThumbnailUrlRequest = F2($author$project$Page$Note$AttachmentThumbnailUrlRequest_fn);
    var $author$project$Page$Note$ManyMsgs = function (a) {
        return { $: 36, a: a };
    };
    var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
        if (m.$ === 1) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Page$Note$getMissingThumbnails_fn = function (noteId, note) {
        return $author$project$Page$Note$ManyMsgs($elm$core$List$filterMap_fn(function (_v0) {
            var thumbnailUrl = _v0.ct;
            var storagePath = _v0.Y;
            var mimeType = _v0.c1;
            return $author$project$Util$Misc$toJustIf_fn($elm_community$maybe_extra$Maybe$Extra$isNothing(thumbnailUrl), $author$project$Page$Note$AttachmentThumbnailUrlRequest_fn({ c1: mimeType }, { gH: storagePath, ip: noteId }));
        }, note.kd));
    }, $author$project$Page$Note$getMissingThumbnails = F2($author$project$Page$Note$getMissingThumbnails_fn);
    var $author$project$Util$Cmd$whenJust_fn = function (mThing, toCmd) {
        if (!mThing.$) {
            var a = mThing.a;
            return toCmd(a);
        }
        else {
            return $elm$core$Platform$Cmd$none;
        }
    }, $author$project$Util$Cmd$whenJust = F2($author$project$Util$Cmd$whenJust_fn);
    var $author$project$Page$Note$init_fn = function (env, noteId, mActionItemId, mTab) {
        var actionItemsCache = $author$project$Data$ActionItemsCache$generate_fn(env, noteId);
        return _Utils_Tuple2((new $$Record59($author$project$View$ActionItems$initFader, actionItemsCache, false, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$withDefault_fn($author$project$Page$Note$fallbackTab_fn(env, actionItemsCache), mTab), false, "", false, mActionItemId, false, false, false)), $elm_community$basics_extra$Basics$Extra$flip_fn($author$project$Util$Cmd$whenJust, $author$project$Util$Cmd$executeMsg, $elm$core$Maybe$map_fn($author$project$Page$Note$getMissingThumbnails(noteId), $author$project$Firestore$Collection$get_fn(noteId, env.fO))));
    }, $author$project$Page$Note$init = F4($author$project$Page$Note$init_fn);
    var $author$project$Update$notePage_fn = function (model, routeNoteId, mActionItemId, mTab) {
        var _v0 = function () {
            var _v1 = model.ix;
            if (_v1.$ === 4) {
                var currentPageNoteId = _v1.a;
                var currentNoteModel = _v1.b;
                return _Utils_eq(currentPageNoteId, routeNoteId) ? _Utils_Tuple2(function () {
                    var $r = currentNoteModel.$c();
                    $r.b1 = $elm$core$Maybe$withDefault_fn($author$project$Page$Note$fallbackTab_fn(model.dW, currentNoteModel.bS), mTab);
                    $r.f$ = mActionItemId;
                    return $r;
                }(), $elm$core$Platform$Cmd$none) : $author$project$Page$Note$init_fn(model.dW, routeNoteId, mActionItemId, mTab);
            }
            else {
                return $author$project$Page$Note$init_fn(model.dW, routeNoteId, mActionItemId, mTab);
            }
        }();
        var subModel = _v0.a;
        var pageCmd = _v0.b;
        return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageNote_fn(routeNoteId, subModel)), $elm$core$Platform$Cmd$batch(_List_fromArray([
            _Platform_map_fn(A2($elm$core$Basics$composeR, $author$project$Model$NoteMsg, $author$project$Model$HandlePageMsg), pageCmd)
        ])));
    }, $author$project$Update$notePage = F4($author$project$Update$notePage_fn);
    var $author$project$Page$Search$updateResultsAndCategory_fn = function (model, mCategory, searchResults) {
        return function () {
            var $r = model.$c();
            $r.e1 = $elm$core$Maybe$withDefault_fn($author$project$Page$Search$defaultCategory, mCategory);
            $r.p = searchResults;
            return $r;
        }();
    }, $author$project$Page$Search$updateResultsAndCategory = F3($author$project$Page$Search$updateResultsAndCategory_fn);
    var $author$project$Update$setPageFromRoute = function (model) {
        var env = model.dW;
        var _v0 = env.oe;
        switch (_v0.$) {
            case 0:
                var date = _v0.a;
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageHome($author$project$Page$Home$init_fn(env, date))), $elm$core$Platform$Cmd$none);
            case 1:
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageActionItems($author$project$Page$ActionItems$init)), $elm$core$Platform$Cmd$none);
            case 12:
                var mQuery = _v0.a;
                var mCategory = _v0.b;
                var _v1 = function () {
                    var _v2 = model.ix;
                    if (_v2.$ === 2) {
                        var subModel = _v2.a;
                        return _Utils_Tuple2($author$project$Page$Search$updateResultsAndCategory_fn(subModel, mCategory, $author$project$Page$Search$generateResults_fn(env, model.op, mQuery, mCategory)), $elm$core$Platform$Cmd$none);
                    }
                    else {
                        return $author$project$Page$Search$init_fn(env, model.op, mQuery, mCategory);
                    }
                }();
                var newSubModel = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageSearch(newSubModel)), _Platform_map_fn(A2($elm$core$Basics$composeR, $author$project$Model$SearchMsg, $author$project$Model$HandlePageMsg), cmd));
            case 11:
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageSettings($author$project$Page$Settings$init)), $elm$core$Platform$Cmd$none);
            case 16:
                var collation = _v0.a;
                var mCount = _v0.b;
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageCollate($author$project$Page$Collate$init_fn(collation, mCount))), $elm$core$Platform$Cmd$none);
            case 9:
                var personId = _v0.a;
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PagePerson_fn(personId, $author$project$Page$Person$init(env))), $elm$core$Platform$Cmd$none);
            case 3:
                var noteId = _v0.a;
                var tab = _v0.c;
                return $author$project$Update$notePage_fn(model, noteId, $elm$core$Maybe$Nothing, tab);
            case 5:
                var noteId = _v0.a;
                var tab = _v0.c;
                return $author$project$Update$notePage_fn(model, noteId, $elm$core$Maybe$Nothing, tab);
            case 6:
                var noteId = _v0.a;
                var mActionItemPath = _v0.b;
                var tab = _v0.c;
                return $author$project$Update$notePage_fn(model, noteId, mActionItemPath, tab);
            case 10:
                var mDate = _v0.a;
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageCalendar($author$project$Page$Calendar$init_fn(env, mDate))), $elm$core$Platform$Cmd$none);
            case 13:
                var signupStep = _v0.a;
                var _v3 = $author$project$Page$Signup$init(env);
                var subModel = _v3.a;
                var backtalk = _v3.b;
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageSignup_fn(signupStep, subModel)), $author$project$Util$Cmd$executeMsg($author$project$Model$HandleBacktalk(backtalk)));
            case 14:
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageLoading), $elm$core$Platform$Cmd$none);
            case 18:
                return _Utils_Tuple2($$update__ix(model, $author$project$Data$App$isProd(env.mM) ? $author$project$Model$PageNotFound : $author$project$Model$PageDemo($author$project$Page$Demo$init)), $elm$core$Platform$Cmd$none);
            case 15:
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageBilling($author$project$Page$Billing$init)), $elm$core$Platform$Cmd$none);
            case 17:
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageLoading), $elm$core$Platform$Cmd$none);
            case 4:
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageLoading), $elm$core$Platform$Cmd$none);
            case 2:
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageLoading), $elm$core$Platform$Cmd$none);
            case 8:
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageLoading), $elm$core$Platform$Cmd$none);
            case 7:
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageLoading), $elm$core$Platform$Cmd$none);
            default:
                return _Utils_Tuple2($$update__ix(model, $author$project$Model$PageNotFound), $elm$core$Platform$Cmd$none);
        }
    };
    var $author$project$Error$Warning = 2;
    var $author$project$Error$warning_a0 = 2, $author$project$Error$warning = $author$project$Error$Msg($author$project$Error$warning_a0);
    var $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn = function (year, month, day, time, clock) {
        return (new $$Record60(clock, day, month, time, year));
    }, $justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5($justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn);
    var $justinmimbs$timezone_data$TimeZone$Specification$Rules = function (a) {
        return { $: 1, a: a };
    };
    var $justinmimbs$timezone_data$TimeZone$Specification$Save = function (a) {
        return { $: 0, a: a };
    };
    var $justinmimbs$timezone_data$TimeZone$Specification$WallClock = 2;
    var $justinmimbs$timezone_data$TimeZone$Specification$Zone_fn = function (history, current) {
        return { k3: current, W: history };
    }, $justinmimbs$timezone_data$TimeZone$Specification$Zone = F2($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn);
    var $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn = function (standardOffset, zoneRules) {
        return { ge: standardOffset, gx: zoneRules };
    }, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn);
    var $justinmimbs$timezone_data$TimeZone$maxYear = 2037;
    var $justinmimbs$timezone_data$TimeZone$minYear = 1970;
    var $justinmimbs$timezone_data$TimeZone$Specification$Universal = 0;
    var $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function (_v0) {
        dropChangesBeforeEpoch: while (true) {
            var initial = _v0.a;
            var changes = _v0.b;
            if (changes.b) {
                var change = changes.a;
                var rest = changes.b;
                if (change.bF <= 0) {
                    var $temp$_v0 = _Utils_Tuple2(change.nt, rest);
                    _v0 = $temp$_v0;
                    continue dropChangesBeforeEpoch;
                }
                else {
                    return _Utils_Tuple2(initial, changes);
                }
            }
            else {
                return _Utils_Tuple2(initial, _List_Nil);
            }
        }
    };
    var $justinmimbs$timezone_data$RataDie$weekdayNumber = function (rd) {
        var _v0 = _Basics_modBy_fn(7, rd);
        if (!_v0) {
            return 7;
        }
        else {
            var n = _v0;
            return n;
        }
    };
    var $justinmimbs$timezone_data$RataDie$weekdayToNumber = function (wd) {
        switch (wd) {
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            default:
                return 7;
        }
    };
    var $justinmimbs$timezone_data$RataDie$floorWeekday_fn = function (weekday, rd) {
        var daysSincePreviousWeekday = _Basics_modBy_fn(7, ($justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7) - $justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
        return rd - daysSincePreviousWeekday;
    }, $justinmimbs$timezone_data$RataDie$floorWeekday = F2($justinmimbs$timezone_data$RataDie$floorWeekday_fn);
    var $justinmimbs$timezone_data$RataDie$ceilingWeekday_fn = function (weekday, rd) {
        var floored = $justinmimbs$timezone_data$RataDie$floorWeekday_fn(weekday, rd);
        return _Utils_eq(rd, floored) ? rd : (floored + 7);
    }, $justinmimbs$timezone_data$RataDie$ceilingWeekday = F2($justinmimbs$timezone_data$RataDie$ceilingWeekday_fn);
    var $justinmimbs$timezone_data$RataDie$isLeapYear = function (y) {
        return ((!_Basics_modBy_fn(4, y)) && (!(!_Basics_modBy_fn(100, y)))) || (!_Basics_modBy_fn(400, y));
    };
    var $justinmimbs$timezone_data$RataDie$daysBeforeMonth_fn = function (y, m) {
        var leapDays = $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
        switch (m) {
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + leapDays;
            case 3:
                return 90 + leapDays;
            case 4:
                return 120 + leapDays;
            case 5:
                return 151 + leapDays;
            case 6:
                return 181 + leapDays;
            case 7:
                return 212 + leapDays;
            case 8:
                return 243 + leapDays;
            case 9:
                return 273 + leapDays;
            case 10:
                return 304 + leapDays;
            default:
                return 334 + leapDays;
        }
    }, $justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2($justinmimbs$timezone_data$RataDie$daysBeforeMonth_fn);
    var $justinmimbs$timezone_data$RataDie$daysBeforeYear = function (y1) {
        var y = y1 - 1;
        var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
        return (365 * y) + leapYears;
    };
    var $justinmimbs$timezone_data$RataDie$dayOfMonth_fn = function (y, m, d) {
        return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + $justinmimbs$timezone_data$RataDie$daysBeforeMonth_fn(y, m)) + d;
    }, $justinmimbs$timezone_data$RataDie$dayOfMonth = F3($justinmimbs$timezone_data$RataDie$dayOfMonth_fn);
    var $justinmimbs$timezone_data$RataDie$daysInMonth_fn = function (y, m) {
        switch (m) {
            case 0:
                return 31;
            case 1:
                return $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
            case 2:
                return 31;
            case 3:
                return 30;
            case 4:
                return 31;
            case 5:
                return 30;
            case 6:
                return 31;
            case 7:
                return 31;
            case 8:
                return 30;
            case 9:
                return 31;
            case 10:
                return 30;
            default:
                return 31;
        }
    }, $justinmimbs$timezone_data$RataDie$daysInMonth = F2($justinmimbs$timezone_data$RataDie$daysInMonth_fn);
    var $justinmimbs$timezone_data$RataDie$lastOfMonth_fn = function (y, m) {
        return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + $justinmimbs$timezone_data$RataDie$daysBeforeMonth_fn(y, m)) + $justinmimbs$timezone_data$RataDie$daysInMonth_fn(y, m);
    }, $justinmimbs$timezone_data$RataDie$lastOfMonth = F2($justinmimbs$timezone_data$RataDie$lastOfMonth_fn);
    var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function (rd) {
        return (rd - 719163) * 1440;
    };
    var $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment_fn = function (clock, _v0) {
        var standard = _v0.bf;
        var save = _v0.C;
        switch (clock) {
            case 0:
                return 0;
            case 1:
                return 0 - standard;
            default:
                return 0 - (standard + save);
        }
    }, $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment_fn);
    var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function (_v0) {
        var year = _v0.bO;
        var month = _v0.bz;
        var day = _v0.lb;
        var time = _v0.gh;
        return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie($justinmimbs$timezone_data$RataDie$dayOfMonth_fn(year, month, day)) + time;
    };
    var $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime_fn = function (offset, datetime) {
        return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment_fn(datetime.aB, offset);
    }, $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime_fn);
    var $justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges_fn = function (previousOffset, start, until, standardOffset, rules) {
        var transitions = $elm$core$List$concatMap_fn(function (year) {
            return _List_sortBy_fn(function ($) {
                return $.bF;
            }, $elm$core$List$map_fn(function (rule) {
                return {
                    aB: rule.aB,
                    C: rule.C,
                    bF: $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(function () {
                        var _v2 = rule.lb;
                        switch (_v2.$) {
                            case 0:
                                var day = _v2.a;
                                return $justinmimbs$timezone_data$RataDie$dayOfMonth_fn(year, rule.bz, day);
                            case 1:
                                var weekday = _v2.a;
                                var after = _v2.b;
                                return $justinmimbs$timezone_data$RataDie$ceilingWeekday_fn(weekday, $justinmimbs$timezone_data$RataDie$dayOfMonth_fn(year, rule.bz, after));
                            case 2:
                                var weekday = _v2.a;
                                var before = _v2.b;
                                return $justinmimbs$timezone_data$RataDie$floorWeekday_fn(weekday, $justinmimbs$timezone_data$RataDie$dayOfMonth_fn(year, rule.bz, before));
                            default:
                                var weekday = _v2.a;
                                return $justinmimbs$timezone_data$RataDie$floorWeekday_fn(weekday, $justinmimbs$timezone_data$RataDie$lastOfMonth_fn(year, rule.bz));
                        }
                    }()) + rule.gh
                };
            }, $elm$core$List$filter_fn(function (rule) {
                return (_Utils_cmp(rule.hx, year) < 1) && (_Utils_cmp(year, rule.jr) < 1);
            }, rules)));
        }, $elm$core$List$range_fn(start.bO - 1, until.bO));
        var initialOffset = { C: 0, bf: standardOffset };
        var initialChange = {
            nt: standardOffset,
            bF: $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime_fn(previousOffset, start)
        };
        var _v0 = $elm$core$List$foldl_fn_unwrapped(function (transition, _v1) {
            var currentOffset = _v1.a;
            var changes = _v1.b;
            var newOffset = { C: transition.C, bf: standardOffset };
            if (_Utils_cmp(transition.bF + $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment_fn(transition.aB, previousOffset), initialChange.bF) < 1) {
                var updatedInitialChange = { nt: standardOffset + transition.C, bF: initialChange.bF };
                return _Utils_Tuple2(newOffset, _List_fromArray([updatedInitialChange]));
            }
            else {
                if (_Utils_cmp(transition.bF + $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment_fn(transition.aB, currentOffset), $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime_fn(currentOffset, until)) < 0) {
                    var change = {
                        nt: standardOffset + transition.C,
                        bF: transition.bF + $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment_fn(transition.aB, currentOffset)
                    };
                    return _Utils_Tuple2(newOffset, _List_Cons(change, changes));
                }
                else {
                    return _Utils_Tuple2(currentOffset, changes);
                }
            }
        }, _Utils_Tuple2(initialOffset, _List_fromArray([initialChange])), transitions);
        var nextOffset = _v0.a;
        var descendingChanges = _v0.b;
        return _Utils_Tuple2($elm$core$List$reverse(descendingChanges), nextOffset);
    }, $justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5($justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges_fn);
    var $justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges_fn = function (previousOffset, start, until, _v0) {
        var standardOffset = _v0.ge;
        var zoneRules = _v0.gx;
        if (!zoneRules.$) {
            var save = zoneRules.a;
            return _Utils_Tuple2(_List_fromArray([
                {
                    nt: standardOffset + save,
                    bF: $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime_fn(previousOffset, start)
                }
            ]), { C: save, bf: standardOffset });
        }
        else {
            var rules = zoneRules.a;
            return $justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges_fn(previousOffset, start, until, standardOffset, rules);
        }
    }, $justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4($justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges_fn);
    var $justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp_fn = function (f, a, rev, list) {
        stripDuplicatesByHelp: while (true) {
            if (!list.b) {
                return $elm$core$List$reverse(rev);
            }
            else {
                var x = list.a;
                var xs = list.b;
                var b = f(x);
                var rev_ = (!_Utils_eq(a, b)) ? _List_Cons(x, rev) : rev;
                var $temp$f = f, $temp$a = b, $temp$rev = rev_, $temp$list = xs;
                f = $temp$f;
                a = $temp$a;
                rev = $temp$rev;
                list = $temp$list;
                continue stripDuplicatesByHelp;
            }
        }
    }, $justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4($justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp_fn);
    var $justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges_fn = function (zoneStart, zoneUntil, zone) {
        var _v0 = $elm$core$List$foldl_fn_unwrapped(function (_v1, _v2) {
            var state = _v1.a;
            var nextStart = _v1.b;
            var start = _v2.a;
            var ranges = _v2.b;
            return _Utils_Tuple2(nextStart, _List_Cons(_Utils_Tuple3(start, state, nextStart), ranges));
        }, _Utils_Tuple2(zoneStart, _List_Nil), zone.W);
        var currentStart = _v0.a;
        var historyRanges = _v0.b;
        return $elm$core$List$reverse(_List_Cons(_Utils_Tuple3(currentStart, zone.k3, zoneUntil), historyRanges));
    }, $justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3($justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges_fn);
    var $justinmimbs$timezone_data$TimeZone$Specification$toOffsets_fn = function (minYear, maxYear, zone) {
        var initialState = function () {
            var _v5 = zone.W;
            if (_v5.b) {
                var _v6 = _v5.a;
                var earliest = _v6.a;
                return earliest;
            }
            else {
                return zone.k3;
            }
        }();
        var initialOffset = {
            C: function () {
                var _v4 = initialState.gx;
                if (!_v4.$) {
                    var save = _v4.a;
                    return save;
                }
                else {
                    return 0;
                }
            }(),
            bf: initialState.ge
        };
        var ascendingChanges = $justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp_fn(function ($) {
            return $.nt;
        }, initialOffset.bf + initialOffset.C, _List_Nil, $elm$core$List$foldl_fn_unwrapped(function (_v1, _v2) {
            var start = _v1.a;
            var state = _v1.b;
            var until = _v1.c;
            var prevOffset = _v2.a;
            var prevChanges = _v2.b;
            var _v3 = $justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges_fn(prevOffset, start, until, state);
            var nextChanges = _v3.a;
            var nextOffset = _v3.b;
            return _Utils_Tuple2(nextOffset, _Utils_ap(prevChanges, nextChanges));
        }, _Utils_Tuple2(initialOffset, _List_Nil), $justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges_fn($justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(minYear, 0, 1, 0, 0), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(maxYear + 1, 0, 1, 0, 0), zone)).b);
        var _v0 = $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(_Utils_Tuple2(initialOffset.bf + initialOffset.C, ascendingChanges));
        var initial = _v0.a;
        var ascending = _v0.b;
        return _Utils_Tuple2($elm$core$List$reverse(ascending), initial);
    }, $justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3($justinmimbs$timezone_data$TimeZone$Specification$toOffsets_fn);
    var $justinmimbs$timezone_data$TimeZone$fromSpecification = function (zone) {
        var _v0 = $justinmimbs$timezone_data$TimeZone$Specification$toOffsets_fn($justinmimbs$timezone_data$TimeZone$minYear, $justinmimbs$timezone_data$TimeZone$maxYear, zone);
        var descending = _v0.a;
        var bottom = _v0.b;
        return $elm$time$Time$Zone_fn(bottom, descending);
    };
    var $justinmimbs$timezone_data$TimeZone$Specification$Day = function (a) {
        return { $: 0, a: a };
    };
    var $justinmimbs$timezone_data$TimeZone$Specification$Last = function (a) {
        return { $: 3, a: a };
    };
    var $justinmimbs$timezone_data$TimeZone$Specification$Next_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $justinmimbs$timezone_data$TimeZone$Specification$Next = F2($justinmimbs$timezone_data$TimeZone$Specification$Next_fn);
    var $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn = function (from, to, month, day, time, clock, save) {
        return (new $$Record61(clock, day, from, month, save, time, to));
    }, $justinmimbs$timezone_data$TimeZone$Specification$Rule = F7($justinmimbs$timezone_data$TimeZone$Specification$Rule_fn);
    var $justinmimbs$timezone_data$TimeZone$rules_US = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1967, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1967, 1973, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, $justinmimbs$timezone_data$TimeZone$maxYear, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1971, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2006, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__los_angeles = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kolkata = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(330, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__abidjan = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__accra = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__nairobi = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__addis_ababa = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$Specification$Standard = 1;
    var $justinmimbs$timezone_data$TimeZone$rules_Algeria = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1971, 1971, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 1380, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1971, 1971, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 1380, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__algiers = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1977, 9, 21, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1979, 9, 26, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 4, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__asmara = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$africa__bamako = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__lagos = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__bangui = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__banjul = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__bissau = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1975, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__maputo = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__blantyre = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $justinmimbs$timezone_data$TimeZone$africa__brazzaville = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__bujumbura = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $justinmimbs$timezone_data$TimeZone$rules_Egypt = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1959, 1981, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1966, 1994, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1982, 1982, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1988, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1994, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1995, 2010, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1995, 2005, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(3, 1), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 7, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2009, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2010, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2010, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2010, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2014, 2014, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2014, 2014, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2014, 2014, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2014, 2014, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__cairo = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Egypt))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Morocco = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1977, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2009, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2009, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2010, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2010, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2013, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2012, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2012, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2012, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, 2013, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, 2013, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, 2018, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2014, 2018, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2014, 2014, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2014, 2014, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2015, 2015, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2015, 2015, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2016, 2016, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2016, 2016, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2017, 2017, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2017, 2017, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2018, 2018, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2018, 2018, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2019, 2019, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2019, 2019, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2020, 2020, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2020, 2020, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2021, 2021, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2021, 2021, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2022, 2022, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2022, 2022, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2023, 2023, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2023, 2023, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2024, 2024, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2024, 2024, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2025, 2025, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2025, 2025, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2026, 2026, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2026, 2026, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2027, 2027, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2027, 2027, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2028, 2028, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2028, 2028, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2029, 2029, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2029, 2029, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(18), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2029, 2029, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2030, 2030, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2030, 2030, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2031, 2031, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2031, 2031, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2032, 2032, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(18), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2032, 2032, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2033, 2033, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2033, 2033, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2033, 2033, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2034, 2034, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2034, 2034, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2035, 2035, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2035, 2035, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2036, 2036, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2036, 2036, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2037, 2037, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 180, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2037, 2037, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__casablanca = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1984, 2, 16, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1986, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2018, 9, 28, 180, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_EU = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 60, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$rules_SpainAfrica = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1977, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__ceuta = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SpainAfrica)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1984, 2, 16, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1986, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__conakry = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__dakar = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__dar_es_salaam = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$africa__djibouti = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$africa__douala = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__el_aaiun = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1976, 3, 14, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2018, 9, 28, 180, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__freetown = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__gaborone = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $justinmimbs$timezone_data$TimeZone$africa__harare = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $justinmimbs$timezone_data$TimeZone$africa__johannesburg = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Sudan = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1970, 1970, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1970, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1971, 1971, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__juba = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 0, 15, 720, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2021, 1, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__kampala = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$africa__khartoum = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 0, 15, 720, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2017, 10, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__kigali = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $justinmimbs$timezone_data$TimeZone$africa__kinshasa = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__libreville = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__lome = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__luanda = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__lubumbashi = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $justinmimbs$timezone_data$TimeZone$africa__lusaka = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $justinmimbs$timezone_data$TimeZone$africa__malabo = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__maseru = $justinmimbs$timezone_data$TimeZone$africa__johannesburg;
    var $justinmimbs$timezone_data$TimeZone$africa__mbabane = $justinmimbs$timezone_data$TimeZone$africa__johannesburg;
    var $justinmimbs$timezone_data$TimeZone$africa__mogadishu = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$africa__monrovia = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-45, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1972, 0, 7, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__ndjamena = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1979, 9, 14, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 2, 8, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__niamey = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__nouakchott = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__ouagadougou = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__porto_novo = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__sao_tome = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2018, 0, 1, 60, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2019, 0, 1, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Libya = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1982, 1984, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1982, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1989, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 1997, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 1997, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, 2013, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, 2013, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__tripoli = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 4, 4, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 8, 30, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1997, 9, 4, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2012, 10, 10, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2013, 9, 25, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Tunisia = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1988, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1990, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1990, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2005, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2005, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 60, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2008, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2008, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__tunis = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tunisia))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Namibia = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1994, 1994, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1994, 2017, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1995, 2017, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, -60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__windhoek = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 2, 21, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Namibia))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__adak = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 9, 30, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 10, 30, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__anchorage = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 9, 30, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 10, 30, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__port_of_spain = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__anguilla = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__antigua = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$rules_Brazil = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 1985, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1986, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1987, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1987, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1988, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1988, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1990, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1990, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1993, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1995, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 11), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1994, 1995, 1, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 1996, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 1996, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 1997, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 1997, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1998, 1998, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1998, 1998, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 1999, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 1999, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2000, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2001, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2006, 1, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2002, 2002, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2003, 2003, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2004, 2004, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2005, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2017, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2011, 1, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2012, 1, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 22), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, 2014, 1, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2015, 2015, 1, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 22), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2016, 2019, 1, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2018, 2018, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__araguaina = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 8, 17, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1995, 8, 14, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2003, 8, 24, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2012, 9, 21, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2013, 8, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Arg = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1968, 1969, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1988, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1993, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1992, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 1999, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2000, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2009, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 2, 3, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 9, 20, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 5, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 5, 20, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 9, 18, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 9, 20, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 2, 3, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 2, 4, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 9, 28, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 17, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 9, 6, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 9, 18, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 4, 7, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 5, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 5, 20, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 9, 18, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 2, 4, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 9, 15, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 9, 15, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 2, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 9, 18, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 4, 23, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 8, 26, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 9, 18, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 5, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 5, 20, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 9, 18, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__salta = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 9, 20, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 9, 18, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 4, 7, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 4, 31, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 6, 25, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 9, 18, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_SanLuis = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2009, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2008, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 2, 14, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 9, 15, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 5, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 4, 31, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 6, 25, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 0, 21, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SanLuis)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2009, 9, 11, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 9, 20, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 5, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 5, 13, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 2, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 4, 30, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 5, 20, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 9, 18, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__curacao = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__aruba = $justinmimbs$timezone_data$TimeZone$america__curacao;
    var $justinmimbs$timezone_data$TimeZone$rules_Para = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1988, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1978, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1991, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1990, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1993, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1995, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1994, 1995, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 1996, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 2001, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 1997, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1998, 2001, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2002, 2004, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2002, 2003, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2004, 2009, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2009, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2012, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 22), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__asuncion = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1972, 9, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 3, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Para))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__atikokan = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__bahia = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2003, 8, 24, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 9, 16, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2012, 9, 21, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Mexico = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 2000, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 2000, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2001, 4, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2001, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2002, $justinmimbs$timezone_data$TimeZone$maxYear, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2002, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__bahia_banderas = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1970, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 3, 4, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Barb = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__barbados = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Barb))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__belem = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1988, 8, 12, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Belize = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1973, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1982, 1982, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(18), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__belize = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Belize))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Canada = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, $justinmimbs$timezone_data$TimeZone$maxYear, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__blanc_sablon = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1970, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__boa_vista = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1988, 8, 12, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 8, 30, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 9, 15, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_CO = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1993, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__bogota = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CO))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__boise = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 1, 3, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_NT_YK = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__cambridge_bay = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 31, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 9, 29, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 10, 5, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2001, 3, 1, 180, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__campo_grande = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__cancun = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 11, 23, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1998, 7, 2, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2015, 1, 1, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__caracas = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2007, 11, 9, 180, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-270, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 4, 1, 150, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__cayenne = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__panama = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__cayman = $justinmimbs$timezone_data$TimeZone$america__panama;
    var $justinmimbs$timezone_data$TimeZone$america__chicago = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__chihuahua = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1998, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1998, 3, 5, 180, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_CR = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1980, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1980, 5, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1992, 0, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(5, 15), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__costa_rica = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CR))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__creston = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__cuiaba = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2003, 8, 24, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 9, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__danmarkshavn = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 3, 6, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__dawson = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1973, 9, 28, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2020, 10, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Vanc = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1946, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1962, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__dawson_creek = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1972, 7, 30, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__denver = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__detroit = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1973, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1975, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1975, 3, 27, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__dominica = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$rules_Edm = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__edmonton = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Edm)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1987, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__eirunepe = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1988, 8, 12, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1993, 8, 28, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1994, 8, 22, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 5, 24, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2013, 10, 10, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Salv = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1988, 4, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1988, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__el_salvador = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Salv))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__fort_nelson = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1987, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2015, 2, 8, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__fortaleza = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 8, 17, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 8, 30, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 9, 22, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2001, 8, 13, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2002, 9, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Halifax = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1962, 1973, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1962, 1973, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__glace_bay = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1972, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_StJohns = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1951, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1960, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1987, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 1, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 1, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1988, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 1, 2, 120),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 1, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2011, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 1, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2010, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 1, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__goose_bay = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 10, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__grand_turk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1979, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2015, 2, 8, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2018, 2, 11, 180, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__grenada = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__guadeloupe = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$rules_Guat = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1973, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__guatemala = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guat))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Ecuador = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1993, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__guayaquil = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__guyana = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-225, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1975, 6, 31, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__halifax = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Cuba = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1969, 1977, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1969, 1971, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1974, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1977, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1990, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1980, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1985, 4, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 5), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1989, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 14), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1997, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1995, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 1996, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 1997, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1998, 1999, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1998, 2003, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2003, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2004, 2004, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2010, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2010, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2012, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, $justinmimbs$timezone_data$TimeZone$maxYear, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 0, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__havana = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cuba))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__hermosillo = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1970, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__knox = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 9, 27, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2006, 3, 2, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__marengo = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 0, 6, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 9, 27, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1976, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2006, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1977, 9, 30, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2006, 3, 2, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2007, 10, 4, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1971, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2006, 3, 2, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__vevay = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1973, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2006, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1971, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2006, 3, 2, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2007, 10, 4, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__winamac = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1971, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2006, 3, 2, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2007, 2, 11, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__inuvik = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1979, 3, 29, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__iqaluit = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 31, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 9, 29, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__jamaica = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1984, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__juneau = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 3, 27, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 9, 26, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 9, 30, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 10, 30, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 0, 6, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 9, 27, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 9, 29, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__kralendijk = $justinmimbs$timezone_data$TimeZone$america__curacao;
    var $justinmimbs$timezone_data$TimeZone$america__la_paz = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Peru = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1987, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1987, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1990, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1990, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1994, 1994, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1994, 1994, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__lima = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Peru))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__lower_princes = $justinmimbs$timezone_data$TimeZone$america__curacao;
    var $justinmimbs$timezone_data$TimeZone$america__maceio = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 8, 17, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1995, 9, 13, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 8, 4, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 8, 30, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 9, 22, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2001, 8, 13, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2002, 9, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Nic = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1980, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 16), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1980, 5, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(0, 23), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2005, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2005, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 60, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__managua = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1973, 4, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1975, 1, 16, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 1, 240, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 8, 24, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1993, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1997, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__manaus = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1988, 8, 12, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1993, 8, 28, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1994, 8, 22, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__marigot = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__martinique = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 3, 6, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 8, 28, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__matamoros = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1988, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1989, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__mazatlan = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1970, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__menominee = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1973, 3, 29, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__merida = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 11, 23, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 11, 2, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__metlakatla = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 9, 30, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2015, 10, 1, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2018, 10, 4, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2019, 0, 20, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__mexico_city = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2001, 8, 30, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2002, 1, 20, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__miquelon = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 4, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1987, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Moncton = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1946, 1972, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1957, 1972, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 1, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 1, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__moncton = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1973, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1993, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2007, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__monterrey = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1988, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1989, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Uruguay = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1970, 1970, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1970, 1970, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1972, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1972, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 0, 2, 90),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 0, 2, 30),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1979, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1987, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1988, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1988, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1990, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1991, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 21), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1992, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(18), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1993, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2004, 2004, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2005, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2015, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2014, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__montevideo = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1970, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 2, 10, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 11, 22, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__montserrat = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$rules_Bahamas = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1964, 1975, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1964, 1975, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__nassau = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bahamas)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1976, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__new_york = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__nipigon = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__nome = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 9, 30, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 10, 30, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__noronha = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 8, 17, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 8, 30, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 9, 15, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2001, 8, 13, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2002, 9, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 10, 7, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__north_dakota__center = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 9, 25, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2003, 9, 26, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__nuuk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 3, 6, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__ojinaga = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1998, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1998, 3, 5, 180, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__pangnirtung = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1995, 3, 2, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 31, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 9, 29, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__paramaribo = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-210, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1984, 9, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__phoenix = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Haiti = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1987, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1987, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1997, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 60, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1997, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2015, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2015, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2017, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2017, $justinmimbs$timezone_data$TimeZone$maxYear, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__port_au_prince = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Haiti))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__porto_velho = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1988, 8, 12, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__puerto_rico = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Chile = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1969, 1969, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1969, 1969, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 240, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1970, 1970, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1971, 1971, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1970, 1972, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 240, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1986, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1973, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 240, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1987, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 240, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1987, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1990, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 240, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1990, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 240, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1996, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1997, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 240, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 1997, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1998, 1998, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1998, 1998, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 240, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 1999, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 2010, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 240, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2009, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2010, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 4, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 2), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 7, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 16), 240, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2014, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 23), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2014, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 2), 240, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2016, 2018, 4, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2016, 2018, 7, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 240, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2019, $justinmimbs$timezone_data$TimeZone$maxYear, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 2), 180, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2019, $justinmimbs$timezone_data$TimeZone$maxYear, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 2), 240, 0, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__punta_arenas = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 11, 4, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__rainy_river = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__rankin_inlet = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 9, 29, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2001, 3, 1, 180, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__recife = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 8, 17, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 8, 30, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 9, 15, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2001, 8, 13, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2002, 9, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__regina = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__resolute = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 9, 29, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2001, 3, 1, 180, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2006, 9, 29, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2007, 2, 11, 180, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__rio_branco = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1988, 8, 12, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 5, 24, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2013, 10, 10, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__santarem = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1988, 8, 12, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 5, 24, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__santiago = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_DR = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1969, 1973, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 30),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1970, 1970, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1971, 1971, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1974, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__santo_domingo = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_DR)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 9, 27, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 9, 29, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 11, 3, 60, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__sao_paulo = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_C_Eur = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__scoresbysund = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 3, 6, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 2, 29, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__sitka = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 9, 30, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 10, 30, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__st_barthelemy = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__st_johns = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-210, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 10, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-210, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__st_kitts = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__st_lucia = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__st_thomas = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__st_vincent = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__swift_current = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1972, 3, 30, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Hond = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1988, 4, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1988, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 4, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 7, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(0, 1), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__tegucigalpa = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hond))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Thule = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1992, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1992, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, $justinmimbs$timezone_data$TimeZone$maxYear, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__thule = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Thule))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Toronto = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1950, 1973, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1957, 1973, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__thunder_bay = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1970, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1973, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__tijuana = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1976, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2001, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2002, 1, 20, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__toronto = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__tortola = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__vancouver = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1987, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__whitehorse = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2020, 10, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Winn = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1966, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1966, 2005, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 2005, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__winnipeg = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Winn)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2006, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__yakutat = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 10, 30, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__yellowknife = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__casey = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2009, 9, 18, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 2, 5, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 9, 28, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2012, 1, 21, 1020, 0)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 9, 22, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2018, 2, 11, 240, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2018, 9, 7, 240, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2019, 2, 17, 180, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2019, 9, 4, 180, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2020, 2, 8, 180, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2020, 9, 4, 1, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__davis = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2009, 9, 18, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 2, 10, 1200, 0)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 9, 28, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2012, 1, 21, 1200, 0))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__dumontdurville = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_AT = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1968, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1969, 1971, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1972, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1981, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1982, 1983, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1986, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1990, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1987, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 22), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1990, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1999, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2000, 7, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$antarctica__macquarie = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__mawson = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2009, 9, 18, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_NZ = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1988, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1989, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, $justinmimbs$timezone_data$TimeZone$maxYear, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__auckland = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NZ))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__mcmurdo = $justinmimbs$timezone_data$TimeZone$pacific__auckland;
    var $justinmimbs$timezone_data$TimeZone$antarctica__palmer = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 4, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 11, 4, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__rothera = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1976, 11, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__syowa = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Troll = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 120),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2004, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$antarctica__troll = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2005, 1, 12, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Troll))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__vostok = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__oslo = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$arctic__longyearbyen = $justinmimbs$timezone_data$TimeZone$europe__oslo;
    var $justinmimbs$timezone_data$TimeZone$asia__riyadh = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__aden = $justinmimbs$timezone_data$TimeZone$asia__riyadh;
    var $justinmimbs$timezone_data$TimeZone$rules_RussiaAsia = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1984, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1983, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 2010, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 2010, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__almaty = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 9, 31, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Jordan = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1973, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1975, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1977, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1988, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(4, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1990, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(4, 1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1990, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1993, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(4, 1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1998, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(4, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1994, 1994, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(4, 15), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1995, 1998, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(4, 15), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 1999, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 2002, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2001, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2002, 2012, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2003, 2003, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2004, 2004, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2005, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2011, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, 2013, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2014, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2014, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__amman = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Russia = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1984, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1983, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 2010, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 2010, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__anadyr = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(780, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 3, 1, 0, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 2, 28, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__aqtau = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 9, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1994, 8, 25, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 9, 31, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__aqtobe = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 9, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 9, 31, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__ashgabat = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__atyrau = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 9, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 2, 28, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 9, 31, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Iraq = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1982, 1982, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1982, 1984, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 1990, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1990, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 2007, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 180, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 2007, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 180, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__baghdad = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 4, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iraq))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__qatar = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1972, 5, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__bahrain = $justinmimbs$timezone_data$TimeZone$asia__qatar;
    var $justinmimbs$timezone_data$TimeZone$rules_Azer = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 2015, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 240, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 2015, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 300, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$rules_EUAsia = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__baku = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 8, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1997, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Azer))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__bangkok = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__barnaul = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1995, 4, 28, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 2, 27, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Lebanon = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1972, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1977, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1977, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1987, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1991, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1988, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1992, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1998, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__beirut = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Lebanon))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Kyrgyz = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1996, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 7), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1996, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 150, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 2004, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 150, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__bishkek = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 7, 31, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Kyrgyz)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2005, 7, 12, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__brunei = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__chita = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 2, 27, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Mongol = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1984, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 1998, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1998, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2001, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(5), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2006, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(5), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2002, 2006, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(5), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2015, 2016, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(5), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2015, 2016, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(5), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__choibalsan = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1978, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 2, 31, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__colombo = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(330, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 4, 25, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(390, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 9, 26, 30, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2006, 3, 15, 30, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(330, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Syria = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1966, 1976, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1967, 1978, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1978, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1984, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1984, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1986, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1987, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1988, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1988, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1990, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1990, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1992, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1993, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1993, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1994, 1996, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1994, 2005, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 1998, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(0), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(4, 1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(4, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2009, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2011, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(4, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__damascus = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Syria))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Dhaka = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2009, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 1380, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2009, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 1440, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__dhaka = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2009, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Dhaka))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__dili = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1976, 4, 3, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 8, 17, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__dubai = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__dushanbe = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 8, 9, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Cyprus = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1997, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1998, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__famagusta = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1998, 8, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 8, 8, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2017, 9, 29, 60, 0))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Palestine = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 2005, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(4, 15), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 2003, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(4, 15), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2004, 2004, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2005, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2007, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2009, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2009, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2010, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2010, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 1, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2014, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2012, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, 2013, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2014, 2014, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2015, 2015, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2015, 2015, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2016, 2018, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(5, 24), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2016, 2018, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(5, 24), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2019, 2019, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2019, 2019, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(5, 24), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2020, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(5, 24), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2020, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(5, 24), 60, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$Specification$Prev_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $justinmimbs$timezone_data$TimeZone$Specification$Prev = F2($justinmimbs$timezone_data$TimeZone$Specification$Prev_fn);
    var $justinmimbs$timezone_data$TimeZone$rules_Zion = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 1440, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 1440, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1984, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 1440, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1984, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 1440, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 1985, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1986, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1986, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1987, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1987, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1988, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1988, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1990, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1990, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1993, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1993, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1994, 1994, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1994, 1994, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1995, 1995, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1995, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 1996, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 1996, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 1997, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 1997, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1998, 1998, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1998, 1998, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 1999, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 1999, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2000, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2000, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2001, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2001, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2002, 2002, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2002, 2002, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2003, 2003, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2003, 2003, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2004, 2004, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2004, 2004, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2012, 3, $justinmimbs$timezone_data$TimeZone$Specification$Prev_fn(4, 1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2005, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2009, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2010, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2012, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(4, 23), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__gaza = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 7, 29, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2008, 8, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 2, 27, 1, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 7, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2012, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__hebron = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1975, 5, 13, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_HK = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1965, 1976, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 16), 210, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1965, 1976, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 16), 210, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1973, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 210, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 210, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 210, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__hong_kong = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_HK))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__hovd = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1978, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__irkutsk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Turkey = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1973, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1976, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 31), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1978, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 60, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 1985, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 60, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1993, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1994, 1994, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 60, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1995, 2006, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__istanbul = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1978, 5, 29, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1984, 10, 1, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2007, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 60, 0)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 28, 60, 0)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 2, 30, 60, 0)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 2, 31, 60, 0)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2015, 9, 25, 60, 0)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2015, 10, 8, 60, 0)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 8, 7, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__istanbul = $justinmimbs$timezone_data$TimeZone$europe__istanbul;
    var $justinmimbs$timezone_data$TimeZone$asia__jakarta = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__jayapura = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__jerusalem = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kabul = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(270, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kamchatka = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 2, 28, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Pakistan = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2002, 2002, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 2), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2002, 2002, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 2), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2009, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2009, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__karachi = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1971, 2, 26, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Pakistan))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kathmandu = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(330, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1986, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(345, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__khandyga = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 8, 13, 0, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kuala_lumpur = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(450, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kuching = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kuwait = $justinmimbs$timezone_data$TimeZone$asia__riyadh;
    var $justinmimbs$timezone_data$TimeZone$rules_Macau = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1965, 1973, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 16), 210, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1967, 1976, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 16), 210, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1973, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 210, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1976, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 16), 210, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 210, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 16), 210, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__macau = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Macau))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__magadan = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 3, 24, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__makassar = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Phil = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__manila = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Phil))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__muscat = $justinmimbs$timezone_data$TimeZone$asia__dubai;
    var $justinmimbs$timezone_data$TimeZone$asia__nicosia = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1998, 8, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 2, 28, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__novosibirsk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1993, 4, 23, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 6, 24, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__omsk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__oral = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 9, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1989, 2, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 2, 29, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 9, 31, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__phnom_penh = $justinmimbs$timezone_data$TimeZone$asia__bangkok;
    var $justinmimbs$timezone_data$TimeZone$asia__pontianak = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1988, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__pyongyang = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2015, 7, 15, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(510, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2018, 4, 4, 1410, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__qostanay = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 9, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 9, 31, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__qyzylorda = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 9, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 8, 29, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 2, 29, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 9, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2018, 11, 21, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__sakhalin = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1997, 2, 30, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 2, 27, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__samarkand = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 9, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_ROK = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1988, 4, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1988, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 180, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__seoul = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_ROK))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_PRC = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1986, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1991, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 11), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1991, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 11), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__shanghai = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_PRC))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__singapore = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(450, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Taiwan = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1975, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1975, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__taipei = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Taiwan))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__tashkent = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_E_EurAsia = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__tbilisi = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1994, 8, 25, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 9, 27, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1997, 2, 30, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2004, 5, 27, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2005, 2, 27, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Iran = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1980, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(18), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1995, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 1996, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 1996, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 1999, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 1999, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2000, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2000, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2003, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2003, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2004, 2004, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2004, 2004, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2005, 2005, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2011, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2011, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2012, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2012, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, 2015, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2013, 2015, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2016, 2016, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2016, 2016, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2017, 2019, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2017, 2019, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2020, 2020, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2020, 2020, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2021, 2023, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2021, 2023, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2024, 2024, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2024, 2024, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2025, 2027, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2025, 2027, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2028, 2029, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2028, 2029, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2030, 2031, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2030, 2031, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2032, 2033, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2032, 2033, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2034, 2035, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2034, 2035, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2036, 2037, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2036, 2037, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__tehran = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(210, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1977, 10, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1979, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(210, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__thimphu = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(330, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1987, 9, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__tokyo = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__tomsk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2002, 4, 1, 180, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 4, 29, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1978, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__urumqi = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__ust_nera = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 3, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 8, 13, 0, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__vientiane = $justinmimbs$timezone_data$TimeZone$asia__bangkok;
    var $justinmimbs$timezone_data$TimeZone$asia__vladivostok = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__yakutsk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__yangon = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(390, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Armenia = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__yerevan = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1995, 8, 24, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1997, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Armenia))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Port = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1979, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1982, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1982, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$rules_W_Eur = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 60, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$atlantic__azores = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 8, 25, 60, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 8, 27, 60, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1993, 2, 28, 60, 0))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__bermuda = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 3, 28, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1976, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__canary = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 3, 6, 0, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 8, 28, 60, 0))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1975, 10, 25, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__faroe = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__madeira = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 8, 25, 60, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__reykjavik = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__st_helena = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$rules_Falk = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1984, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 2000, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 9), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 2000, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 16), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2010, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2010, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$atlantic__stanley = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 4, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1985, 8, 15, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 8, 5, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_AS = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1971, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 2007, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1972, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1985, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1990, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1993, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1994, 1994, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1995, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__adelaide = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(570, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1971, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(570, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_AQ = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1971, 1971, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1972, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1991, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1992, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__brisbane = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1971, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_AN = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1971, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1972, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1981, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1982, 1982, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1985, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1989, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1999, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1995, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2000, 7, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2007, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__broken_hill = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(570, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1971, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(570, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(570, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
    };
    var $justinmimbs$timezone_data$TimeZone$australia__darwin = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(570, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_AW = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1984, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1991, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2009, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2008, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__eucla = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(525, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
    };
    var $justinmimbs$timezone_data$TimeZone$australia__hobart = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Holiday = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1993, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1993, 1994, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__lindeman = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1971, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 6, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Holiday))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_LH = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1984, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1982, 1985, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1985, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 30),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1989, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 120, 2, 30),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1987, 1999, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 30),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1995, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2000, 7, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 30),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2007, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 30),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 30)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__lord_howe = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 2, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(630, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1985, 6, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(630, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_AV = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1971, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1972, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1985, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1990, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1986, 1987, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1988, 1999, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1994, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1995, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2000, 7, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2007, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2006, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__melbourne = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1971, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AV))));
    };
    var $justinmimbs$timezone_data$TimeZone$australia__perth = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
    };
    var $justinmimbs$timezone_data$TimeZone$australia__sydney = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1971, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__amsterdam = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1977, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__andorra = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1985, 2, 31, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__astrakhan = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1989, 2, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 2, 29, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 2, 27, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Greece = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1978, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 240, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 540, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__athens = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Greece)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__belgrade = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 10, 27, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__berlin = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__prague = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1979, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__bratislava = $justinmimbs$timezone_data$TimeZone$europe__prague;
    var $justinmimbs$timezone_data$TimeZone$europe__brussels = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1977, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_E_Eur = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$rules_Romania = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 1380, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1993, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1991, 1993, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__bucharest = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 2, 29, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1994, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1997, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Hungary = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1983, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1983, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__budapest = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hungary)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1984, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__zurich = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__busingen = $justinmimbs$timezone_data$TimeZone$europe__zurich;
    var $justinmimbs$timezone_data$TimeZone$rules_Moldova = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 180, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__chisinau = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 4, 6, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1997, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moldova))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__copenhagen = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Eire = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1971, 1971, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 0, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1980, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 16), 120, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1980, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 23), 120, 0, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 23), 60, 0, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1995, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 22), 60, 0, -60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, -60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__dublin = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Eire))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__gibraltar = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_GB_Eire = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1980, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 16), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1980, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 23), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1995, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 23), 60, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 1995, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 22), 60, 0, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__london = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1971, 9, 31, 120, 0)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_GB_Eire)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__guernsey = $justinmimbs$timezone_data$TimeZone$europe__london;
    var $justinmimbs$timezone_data$TimeZone$rules_Finland = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1982, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1982, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 180, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__helsinki = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Finland)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__isle_of_man = $justinmimbs$timezone_data$TimeZone$europe__london;
    var $justinmimbs$timezone_data$TimeZone$europe__jersey = $justinmimbs$timezone_data$TimeZone$europe__london;
    var $justinmimbs$timezone_data$TimeZone$europe__kaliningrad = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1989, 2, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__kiev = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 6, 1, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 8, 29, 180, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1995, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__kirov = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1989, 2, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 2, 29, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__lisbon = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1976, 8, 26, 60, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1983, 8, 25, 60, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 8, 27, 60, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 2, 31, 60, 0))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__ljubljana = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
    var $justinmimbs$timezone_data$TimeZone$europe__luxembourg = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1977, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Spain = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1975, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(5, 12), 1380, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1975, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 1380, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 1380, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__madrid = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Spain)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1979, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Italy = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1967, 1969, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 22), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1969, 1969, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1970, 1970, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1970, 1970, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1971, 1972, 4, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 22), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1971, 1971, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1972, 1972, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1973, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1974, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1979, 4, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 22), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$rules_Malta = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1973, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1973, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1979, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__malta = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1973, 2, 31, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Malta)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__mariehamn = $justinmimbs$timezone_data$TimeZone$europe__helsinki;
    var $justinmimbs$timezone_data$TimeZone$europe__minsk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_France = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 60, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 60, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__monaco = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1977, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__moscow = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__nicosia = $justinmimbs$timezone_data$TimeZone$asia__nicosia;
    var $justinmimbs$timezone_data$TimeZone$europe__paris = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1977, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__podgorica = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
    var $justinmimbs$timezone_data$TimeZone$rules_Latvia = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1996, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1996, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__riga = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1989, 2, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1989, 8, 24, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Latvia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1997, 0, 21, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 1, 29, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2001, 0, 2, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__rome = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__samara = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1989, 2, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 8, 29, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 9, 20, 180, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2010, 2, 28, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__san_marino = $justinmimbs$timezone_data$TimeZone$europe__rome;
    var $justinmimbs$timezone_data$TimeZone$europe__sarajevo = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
    var $justinmimbs$timezone_data$TimeZone$europe__saratov = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1988, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 2, 29, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 11, 4, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__simferopol = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 6, 1, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1994, 4, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 2, 31, 0, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 9, 27, 180, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1997, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1997, 2, 30, 60, 0)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 2, 30, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__skopje = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
    var $justinmimbs$timezone_data$TimeZone$rules_Bulg = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 1380, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1982, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(5, 1), 1380, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 60, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1981, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__sofia = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1979, 2, 31, 1380, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bulg)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 8, 26, 180, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1997, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__stockholm = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1980, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__tallinn = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1989, 2, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1989, 8, 24, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1998, 8, 22, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 31, 240, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2002, 1, 21, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Albania = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1979, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1981, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1981, 1981, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1982, 1982, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1982, 1982, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(18), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1984, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__tirane = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Albania)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1984, 6, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1989, 2, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 19, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2016, 2, 27, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__uzhgorod = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1990, 6, 1, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 180, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1995, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__vaduz = $justinmimbs$timezone_data$TimeZone$europe__zurich;
    var $justinmimbs$timezone_data$TimeZone$europe__vatican = $justinmimbs$timezone_data$TimeZone$europe__rome;
    var $justinmimbs$timezone_data$TimeZone$rules_Austria = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__vienna = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Austria)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1981, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__vilnius = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1989, 2, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 8, 29, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1998, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1998, 2, 29, 60, 0)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 9, 31, 60, 0)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2003, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__volgograd = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1988, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1992, 2, 29, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 2, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 9, 26, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2018, 9, 28, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2020, 11, 27, 120, 1))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__warsaw = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1977, 0, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1988, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__zagreb = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
    var $justinmimbs$timezone_data$TimeZone$europe__zaporozhye = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1991, 2, 31, 120, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1995, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$indian__antananarivo = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$indian__chagos = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1996, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$indian__christmas = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$indian__cocos = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(390, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$indian__comoro = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$indian__kerguelen = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$indian__mahe = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$indian__maldives = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Mauritius = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1982, 1982, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1983, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, 2008, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2009, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$indian__mauritius = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mauritius))));
    };
    var $justinmimbs$timezone_data$TimeZone$indian__mayotte = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$indian__reunion = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_WS = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2010, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(5, 1), 240, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(5), 180, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, $justinmimbs$timezone_data$TimeZone$maxYear, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 240, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, $justinmimbs$timezone_data$TimeZone$maxYear, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 180, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__apia = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 11, 29, 1440, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(780, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__bougainville = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2014, 11, 28, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Chatham = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 165, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1975, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 165, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1975, 1988, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 165, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1989, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 165, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1989, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 165, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 165, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1990, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 165, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2007, $justinmimbs$timezone_data$TimeZone$maxYear, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 165, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 165, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__chatham = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(765, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chatham))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__chuuk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__easter = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1982, 2, 14, 180, 0))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Vanuatu = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1973, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 720, 0, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 720, 0, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1983, 1991, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(5, 22), 1440, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1984, 1991, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(5, 22), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1993, 0, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(5, 22), 1440, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1992, 1992, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(5, 22), 1440, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__efate = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanuatu))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__enderbury = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1979, 9, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1994, 11, 31, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(780, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__fakaofo = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2011, 11, 30, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(780, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Fiji = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1998, 1999, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 2000, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2009, 2009, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2010, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2010, 2013, 9, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 21), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2011, 2011, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2012, 2013, 0, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 18), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2014, 2014, 0, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 18), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2014, 2018, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2015, $justinmimbs$timezone_data$TimeZone$maxYear, 0, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 12), 180, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2019, 2019, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2020, 2020, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2021, $justinmimbs$timezone_data$TimeZone$maxYear, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 8), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__fiji = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Fiji))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__funafuti = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__galapagos = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1986, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__gambier = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Guam = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1969, 1969, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 1, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1969, 1969, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1969, 1969, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1970, 1971, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1970, 1971, 8, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1973, 1973, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1974, 1974, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1976, 1976, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 121, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1977, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__guam = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guam)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2000, 11, 23, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__honolulu = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__kiritimati = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-640, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1979, 9, 1, 0, 2)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1994, 11, 31, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(840, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__kosrae = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__kwajalein = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1993, 7, 20, 1440, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__majuro = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__marquesas = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-570, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__pago_pago = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__midway = $justinmimbs$timezone_data$TimeZone$pacific__pago_pago;
    var $justinmimbs$timezone_data$TimeZone$pacific__nauru = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(690, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1979, 1, 10, 120, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__niue = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-690, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1978, 9, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__norfolk = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(690, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1974, 9, 27, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(690, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1975, 2, 2, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(690, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2015, 9, 4, 120, 1)),
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(2019, 6, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_NC = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1977, 1978, 11, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1979, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1996, 1996, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1997, 1997, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__noumea = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NC))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__palau = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__pitcairn = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-510, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1998, 3, 27, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__pohnpei = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__port_moresby = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Cook = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1978, 1978, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 0, 2, 30),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1991, 2, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 0, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1979, 1990, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 30)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__rarotonga = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-630, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1978, 10, 12, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cook))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__saipan = $justinmimbs$timezone_data$TimeZone$pacific__guam;
    var $justinmimbs$timezone_data$TimeZone$pacific__tahiti = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(-600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__tarawa = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Tonga = _List_fromArray([
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(1999, 1999, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 120, 1, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2000, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 120, 1, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2000, 2001, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2001, 2002, 0, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2016, 2016, 10, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 1), 120, 2, 60),
        $justinmimbs$timezone_data$TimeZone$Specification$Rule_fn(2017, 2017, 0, $justinmimbs$timezone_data$TimeZone$Specification$Next_fn(6, 15), 180, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__tongatapu = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_fromArray([
            _Utils_Tuple2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(780, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), $justinmimbs$timezone_data$TimeZone$Specification$DateTime_fn(1999, 0, 1, 0, 2))
        ]), $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(780, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tonga))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__wake = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__wallis = function (_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification($justinmimbs$timezone_data$TimeZone$Specification$Zone_fn(_List_Nil, $justinmimbs$timezone_data$TimeZone$Specification$ZoneState_fn(720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$zones = $elm$core$Dict$fromList(_List_fromArray([
        _Utils_Tuple2("Africa/Abidjan", $justinmimbs$timezone_data$TimeZone$africa__abidjan),
        _Utils_Tuple2("Africa/Accra", $justinmimbs$timezone_data$TimeZone$africa__accra),
        _Utils_Tuple2("Africa/Addis_Ababa", $justinmimbs$timezone_data$TimeZone$africa__addis_ababa),
        _Utils_Tuple2("Africa/Algiers", $justinmimbs$timezone_data$TimeZone$africa__algiers),
        _Utils_Tuple2("Africa/Asmara", $justinmimbs$timezone_data$TimeZone$africa__asmara),
        _Utils_Tuple2("Africa/Bamako", $justinmimbs$timezone_data$TimeZone$africa__bamako),
        _Utils_Tuple2("Africa/Bangui", $justinmimbs$timezone_data$TimeZone$africa__bangui),
        _Utils_Tuple2("Africa/Banjul", $justinmimbs$timezone_data$TimeZone$africa__banjul),
        _Utils_Tuple2("Africa/Bissau", $justinmimbs$timezone_data$TimeZone$africa__bissau),
        _Utils_Tuple2("Africa/Blantyre", $justinmimbs$timezone_data$TimeZone$africa__blantyre),
        _Utils_Tuple2("Africa/Brazzaville", $justinmimbs$timezone_data$TimeZone$africa__brazzaville),
        _Utils_Tuple2("Africa/Bujumbura", $justinmimbs$timezone_data$TimeZone$africa__bujumbura),
        _Utils_Tuple2("Africa/Cairo", $justinmimbs$timezone_data$TimeZone$africa__cairo),
        _Utils_Tuple2("Africa/Casablanca", $justinmimbs$timezone_data$TimeZone$africa__casablanca),
        _Utils_Tuple2("Africa/Ceuta", $justinmimbs$timezone_data$TimeZone$africa__ceuta),
        _Utils_Tuple2("Africa/Conakry", $justinmimbs$timezone_data$TimeZone$africa__conakry),
        _Utils_Tuple2("Africa/Dakar", $justinmimbs$timezone_data$TimeZone$africa__dakar),
        _Utils_Tuple2("Africa/Dar_es_Salaam", $justinmimbs$timezone_data$TimeZone$africa__dar_es_salaam),
        _Utils_Tuple2("Africa/Djibouti", $justinmimbs$timezone_data$TimeZone$africa__djibouti),
        _Utils_Tuple2("Africa/Douala", $justinmimbs$timezone_data$TimeZone$africa__douala),
        _Utils_Tuple2("Africa/El_Aaiun", $justinmimbs$timezone_data$TimeZone$africa__el_aaiun),
        _Utils_Tuple2("Africa/Freetown", $justinmimbs$timezone_data$TimeZone$africa__freetown),
        _Utils_Tuple2("Africa/Gaborone", $justinmimbs$timezone_data$TimeZone$africa__gaborone),
        _Utils_Tuple2("Africa/Harare", $justinmimbs$timezone_data$TimeZone$africa__harare),
        _Utils_Tuple2("Africa/Johannesburg", $justinmimbs$timezone_data$TimeZone$africa__johannesburg),
        _Utils_Tuple2("Africa/Juba", $justinmimbs$timezone_data$TimeZone$africa__juba),
        _Utils_Tuple2("Africa/Kampala", $justinmimbs$timezone_data$TimeZone$africa__kampala),
        _Utils_Tuple2("Africa/Khartoum", $justinmimbs$timezone_data$TimeZone$africa__khartoum),
        _Utils_Tuple2("Africa/Kigali", $justinmimbs$timezone_data$TimeZone$africa__kigali),
        _Utils_Tuple2("Africa/Kinshasa", $justinmimbs$timezone_data$TimeZone$africa__kinshasa),
        _Utils_Tuple2("Africa/Lagos", $justinmimbs$timezone_data$TimeZone$africa__lagos),
        _Utils_Tuple2("Africa/Libreville", $justinmimbs$timezone_data$TimeZone$africa__libreville),
        _Utils_Tuple2("Africa/Lome", $justinmimbs$timezone_data$TimeZone$africa__lome),
        _Utils_Tuple2("Africa/Luanda", $justinmimbs$timezone_data$TimeZone$africa__luanda),
        _Utils_Tuple2("Africa/Lubumbashi", $justinmimbs$timezone_data$TimeZone$africa__lubumbashi),
        _Utils_Tuple2("Africa/Lusaka", $justinmimbs$timezone_data$TimeZone$africa__lusaka),
        _Utils_Tuple2("Africa/Malabo", $justinmimbs$timezone_data$TimeZone$africa__malabo),
        _Utils_Tuple2("Africa/Maputo", $justinmimbs$timezone_data$TimeZone$africa__maputo),
        _Utils_Tuple2("Africa/Maseru", $justinmimbs$timezone_data$TimeZone$africa__maseru),
        _Utils_Tuple2("Africa/Mbabane", $justinmimbs$timezone_data$TimeZone$africa__mbabane),
        _Utils_Tuple2("Africa/Mogadishu", $justinmimbs$timezone_data$TimeZone$africa__mogadishu),
        _Utils_Tuple2("Africa/Monrovia", $justinmimbs$timezone_data$TimeZone$africa__monrovia),
        _Utils_Tuple2("Africa/Nairobi", $justinmimbs$timezone_data$TimeZone$africa__nairobi),
        _Utils_Tuple2("Africa/Ndjamena", $justinmimbs$timezone_data$TimeZone$africa__ndjamena),
        _Utils_Tuple2("Africa/Niamey", $justinmimbs$timezone_data$TimeZone$africa__niamey),
        _Utils_Tuple2("Africa/Nouakchott", $justinmimbs$timezone_data$TimeZone$africa__nouakchott),
        _Utils_Tuple2("Africa/Ouagadougou", $justinmimbs$timezone_data$TimeZone$africa__ouagadougou),
        _Utils_Tuple2("Africa/Porto-Novo", $justinmimbs$timezone_data$TimeZone$africa__porto_novo),
        _Utils_Tuple2("Africa/Sao_Tome", $justinmimbs$timezone_data$TimeZone$africa__sao_tome),
        _Utils_Tuple2("Africa/Tripoli", $justinmimbs$timezone_data$TimeZone$africa__tripoli),
        _Utils_Tuple2("Africa/Tunis", $justinmimbs$timezone_data$TimeZone$africa__tunis),
        _Utils_Tuple2("Africa/Windhoek", $justinmimbs$timezone_data$TimeZone$africa__windhoek),
        _Utils_Tuple2("America/Adak", $justinmimbs$timezone_data$TimeZone$america__adak),
        _Utils_Tuple2("America/Anchorage", $justinmimbs$timezone_data$TimeZone$america__anchorage),
        _Utils_Tuple2("America/Anguilla", $justinmimbs$timezone_data$TimeZone$america__anguilla),
        _Utils_Tuple2("America/Antigua", $justinmimbs$timezone_data$TimeZone$america__antigua),
        _Utils_Tuple2("America/Araguaina", $justinmimbs$timezone_data$TimeZone$america__araguaina),
        _Utils_Tuple2("America/Argentina/Buenos_Aires", $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires),
        _Utils_Tuple2("America/Argentina/Catamarca", $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca),
        _Utils_Tuple2("America/Argentina/Cordoba", $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba),
        _Utils_Tuple2("America/Argentina/Jujuy", $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy),
        _Utils_Tuple2("America/Argentina/La_Rioja", $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja),
        _Utils_Tuple2("America/Argentina/Mendoza", $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza),
        _Utils_Tuple2("America/Argentina/Rio_Gallegos", $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos),
        _Utils_Tuple2("America/Argentina/Salta", $justinmimbs$timezone_data$TimeZone$america__argentina__salta),
        _Utils_Tuple2("America/Argentina/San_Juan", $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan),
        _Utils_Tuple2("America/Argentina/San_Luis", $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis),
        _Utils_Tuple2("America/Argentina/Tucuman", $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman),
        _Utils_Tuple2("America/Argentina/Ushuaia", $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia),
        _Utils_Tuple2("America/Aruba", $justinmimbs$timezone_data$TimeZone$america__aruba),
        _Utils_Tuple2("America/Asuncion", $justinmimbs$timezone_data$TimeZone$america__asuncion),
        _Utils_Tuple2("America/Atikokan", $justinmimbs$timezone_data$TimeZone$america__atikokan),
        _Utils_Tuple2("America/Bahia", $justinmimbs$timezone_data$TimeZone$america__bahia),
        _Utils_Tuple2("America/Bahia_Banderas", $justinmimbs$timezone_data$TimeZone$america__bahia_banderas),
        _Utils_Tuple2("America/Barbados", $justinmimbs$timezone_data$TimeZone$america__barbados),
        _Utils_Tuple2("America/Belem", $justinmimbs$timezone_data$TimeZone$america__belem),
        _Utils_Tuple2("America/Belize", $justinmimbs$timezone_data$TimeZone$america__belize),
        _Utils_Tuple2("America/Blanc-Sablon", $justinmimbs$timezone_data$TimeZone$america__blanc_sablon),
        _Utils_Tuple2("America/Boa_Vista", $justinmimbs$timezone_data$TimeZone$america__boa_vista),
        _Utils_Tuple2("America/Bogota", $justinmimbs$timezone_data$TimeZone$america__bogota),
        _Utils_Tuple2("America/Boise", $justinmimbs$timezone_data$TimeZone$america__boise),
        _Utils_Tuple2("America/Cambridge_Bay", $justinmimbs$timezone_data$TimeZone$america__cambridge_bay),
        _Utils_Tuple2("America/Campo_Grande", $justinmimbs$timezone_data$TimeZone$america__campo_grande),
        _Utils_Tuple2("America/Cancun", $justinmimbs$timezone_data$TimeZone$america__cancun),
        _Utils_Tuple2("America/Caracas", $justinmimbs$timezone_data$TimeZone$america__caracas),
        _Utils_Tuple2("America/Cayenne", $justinmimbs$timezone_data$TimeZone$america__cayenne),
        _Utils_Tuple2("America/Cayman", $justinmimbs$timezone_data$TimeZone$america__cayman),
        _Utils_Tuple2("America/Chicago", $justinmimbs$timezone_data$TimeZone$america__chicago),
        _Utils_Tuple2("America/Chihuahua", $justinmimbs$timezone_data$TimeZone$america__chihuahua),
        _Utils_Tuple2("America/Costa_Rica", $justinmimbs$timezone_data$TimeZone$america__costa_rica),
        _Utils_Tuple2("America/Creston", $justinmimbs$timezone_data$TimeZone$america__creston),
        _Utils_Tuple2("America/Cuiaba", $justinmimbs$timezone_data$TimeZone$america__cuiaba),
        _Utils_Tuple2("America/Curacao", $justinmimbs$timezone_data$TimeZone$america__curacao),
        _Utils_Tuple2("America/Danmarkshavn", $justinmimbs$timezone_data$TimeZone$america__danmarkshavn),
        _Utils_Tuple2("America/Dawson", $justinmimbs$timezone_data$TimeZone$america__dawson),
        _Utils_Tuple2("America/Dawson_Creek", $justinmimbs$timezone_data$TimeZone$america__dawson_creek),
        _Utils_Tuple2("America/Denver", $justinmimbs$timezone_data$TimeZone$america__denver),
        _Utils_Tuple2("America/Detroit", $justinmimbs$timezone_data$TimeZone$america__detroit),
        _Utils_Tuple2("America/Dominica", $justinmimbs$timezone_data$TimeZone$america__dominica),
        _Utils_Tuple2("America/Edmonton", $justinmimbs$timezone_data$TimeZone$america__edmonton),
        _Utils_Tuple2("America/Eirunepe", $justinmimbs$timezone_data$TimeZone$america__eirunepe),
        _Utils_Tuple2("America/El_Salvador", $justinmimbs$timezone_data$TimeZone$america__el_salvador),
        _Utils_Tuple2("America/Fort_Nelson", $justinmimbs$timezone_data$TimeZone$america__fort_nelson),
        _Utils_Tuple2("America/Fortaleza", $justinmimbs$timezone_data$TimeZone$america__fortaleza),
        _Utils_Tuple2("America/Glace_Bay", $justinmimbs$timezone_data$TimeZone$america__glace_bay),
        _Utils_Tuple2("America/Goose_Bay", $justinmimbs$timezone_data$TimeZone$america__goose_bay),
        _Utils_Tuple2("America/Grand_Turk", $justinmimbs$timezone_data$TimeZone$america__grand_turk),
        _Utils_Tuple2("America/Grenada", $justinmimbs$timezone_data$TimeZone$america__grenada),
        _Utils_Tuple2("America/Guadeloupe", $justinmimbs$timezone_data$TimeZone$america__guadeloupe),
        _Utils_Tuple2("America/Guatemala", $justinmimbs$timezone_data$TimeZone$america__guatemala),
        _Utils_Tuple2("America/Guayaquil", $justinmimbs$timezone_data$TimeZone$america__guayaquil),
        _Utils_Tuple2("America/Guyana", $justinmimbs$timezone_data$TimeZone$america__guyana),
        _Utils_Tuple2("America/Halifax", $justinmimbs$timezone_data$TimeZone$america__halifax),
        _Utils_Tuple2("America/Havana", $justinmimbs$timezone_data$TimeZone$america__havana),
        _Utils_Tuple2("America/Hermosillo", $justinmimbs$timezone_data$TimeZone$america__hermosillo),
        _Utils_Tuple2("America/Indiana/Indianapolis", $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis),
        _Utils_Tuple2("America/Indiana/Knox", $justinmimbs$timezone_data$TimeZone$america__indiana__knox),
        _Utils_Tuple2("America/Indiana/Marengo", $justinmimbs$timezone_data$TimeZone$america__indiana__marengo),
        _Utils_Tuple2("America/Indiana/Petersburg", $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg),
        _Utils_Tuple2("America/Indiana/Tell_City", $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city),
        _Utils_Tuple2("America/Indiana/Vevay", $justinmimbs$timezone_data$TimeZone$america__indiana__vevay),
        _Utils_Tuple2("America/Indiana/Vincennes", $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes),
        _Utils_Tuple2("America/Indiana/Winamac", $justinmimbs$timezone_data$TimeZone$america__indiana__winamac),
        _Utils_Tuple2("America/Inuvik", $justinmimbs$timezone_data$TimeZone$america__inuvik),
        _Utils_Tuple2("America/Iqaluit", $justinmimbs$timezone_data$TimeZone$america__iqaluit),
        _Utils_Tuple2("America/Jamaica", $justinmimbs$timezone_data$TimeZone$america__jamaica),
        _Utils_Tuple2("America/Juneau", $justinmimbs$timezone_data$TimeZone$america__juneau),
        _Utils_Tuple2("America/Kentucky/Louisville", $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville),
        _Utils_Tuple2("America/Kentucky/Monticello", $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello),
        _Utils_Tuple2("America/Kralendijk", $justinmimbs$timezone_data$TimeZone$america__kralendijk),
        _Utils_Tuple2("America/La_Paz", $justinmimbs$timezone_data$TimeZone$america__la_paz),
        _Utils_Tuple2("America/Lima", $justinmimbs$timezone_data$TimeZone$america__lima),
        _Utils_Tuple2("America/Los_Angeles", $justinmimbs$timezone_data$TimeZone$america__los_angeles),
        _Utils_Tuple2("America/Lower_Princes", $justinmimbs$timezone_data$TimeZone$america__lower_princes),
        _Utils_Tuple2("America/Maceio", $justinmimbs$timezone_data$TimeZone$america__maceio),
        _Utils_Tuple2("America/Managua", $justinmimbs$timezone_data$TimeZone$america__managua),
        _Utils_Tuple2("America/Manaus", $justinmimbs$timezone_data$TimeZone$america__manaus),
        _Utils_Tuple2("America/Marigot", $justinmimbs$timezone_data$TimeZone$america__marigot),
        _Utils_Tuple2("America/Martinique", $justinmimbs$timezone_data$TimeZone$america__martinique),
        _Utils_Tuple2("America/Matamoros", $justinmimbs$timezone_data$TimeZone$america__matamoros),
        _Utils_Tuple2("America/Mazatlan", $justinmimbs$timezone_data$TimeZone$america__mazatlan),
        _Utils_Tuple2("America/Menominee", $justinmimbs$timezone_data$TimeZone$america__menominee),
        _Utils_Tuple2("America/Merida", $justinmimbs$timezone_data$TimeZone$america__merida),
        _Utils_Tuple2("America/Metlakatla", $justinmimbs$timezone_data$TimeZone$america__metlakatla),
        _Utils_Tuple2("America/Mexico_City", $justinmimbs$timezone_data$TimeZone$america__mexico_city),
        _Utils_Tuple2("America/Miquelon", $justinmimbs$timezone_data$TimeZone$america__miquelon),
        _Utils_Tuple2("America/Moncton", $justinmimbs$timezone_data$TimeZone$america__moncton),
        _Utils_Tuple2("America/Monterrey", $justinmimbs$timezone_data$TimeZone$america__monterrey),
        _Utils_Tuple2("America/Montevideo", $justinmimbs$timezone_data$TimeZone$america__montevideo),
        _Utils_Tuple2("America/Montserrat", $justinmimbs$timezone_data$TimeZone$america__montserrat),
        _Utils_Tuple2("America/Nassau", $justinmimbs$timezone_data$TimeZone$america__nassau),
        _Utils_Tuple2("America/New_York", $justinmimbs$timezone_data$TimeZone$america__new_york),
        _Utils_Tuple2("America/Nipigon", $justinmimbs$timezone_data$TimeZone$america__nipigon),
        _Utils_Tuple2("America/Nome", $justinmimbs$timezone_data$TimeZone$america__nome),
        _Utils_Tuple2("America/Noronha", $justinmimbs$timezone_data$TimeZone$america__noronha),
        _Utils_Tuple2("America/North_Dakota/Beulah", $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah),
        _Utils_Tuple2("America/North_Dakota/Center", $justinmimbs$timezone_data$TimeZone$america__north_dakota__center),
        _Utils_Tuple2("America/North_Dakota/New_Salem", $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem),
        _Utils_Tuple2("America/Nuuk", $justinmimbs$timezone_data$TimeZone$america__nuuk),
        _Utils_Tuple2("America/Ojinaga", $justinmimbs$timezone_data$TimeZone$america__ojinaga),
        _Utils_Tuple2("America/Panama", $justinmimbs$timezone_data$TimeZone$america__panama),
        _Utils_Tuple2("America/Pangnirtung", $justinmimbs$timezone_data$TimeZone$america__pangnirtung),
        _Utils_Tuple2("America/Paramaribo", $justinmimbs$timezone_data$TimeZone$america__paramaribo),
        _Utils_Tuple2("America/Phoenix", $justinmimbs$timezone_data$TimeZone$america__phoenix),
        _Utils_Tuple2("America/Port-au-Prince", $justinmimbs$timezone_data$TimeZone$america__port_au_prince),
        _Utils_Tuple2("America/Port_of_Spain", $justinmimbs$timezone_data$TimeZone$america__port_of_spain),
        _Utils_Tuple2("America/Porto_Velho", $justinmimbs$timezone_data$TimeZone$america__porto_velho),
        _Utils_Tuple2("America/Puerto_Rico", $justinmimbs$timezone_data$TimeZone$america__puerto_rico),
        _Utils_Tuple2("America/Punta_Arenas", $justinmimbs$timezone_data$TimeZone$america__punta_arenas),
        _Utils_Tuple2("America/Rainy_River", $justinmimbs$timezone_data$TimeZone$america__rainy_river),
        _Utils_Tuple2("America/Rankin_Inlet", $justinmimbs$timezone_data$TimeZone$america__rankin_inlet),
        _Utils_Tuple2("America/Recife", $justinmimbs$timezone_data$TimeZone$america__recife),
        _Utils_Tuple2("America/Regina", $justinmimbs$timezone_data$TimeZone$america__regina),
        _Utils_Tuple2("America/Resolute", $justinmimbs$timezone_data$TimeZone$america__resolute),
        _Utils_Tuple2("America/Rio_Branco", $justinmimbs$timezone_data$TimeZone$america__rio_branco),
        _Utils_Tuple2("America/Santarem", $justinmimbs$timezone_data$TimeZone$america__santarem),
        _Utils_Tuple2("America/Santiago", $justinmimbs$timezone_data$TimeZone$america__santiago),
        _Utils_Tuple2("America/Santo_Domingo", $justinmimbs$timezone_data$TimeZone$america__santo_domingo),
        _Utils_Tuple2("America/Sao_Paulo", $justinmimbs$timezone_data$TimeZone$america__sao_paulo),
        _Utils_Tuple2("America/Scoresbysund", $justinmimbs$timezone_data$TimeZone$america__scoresbysund),
        _Utils_Tuple2("America/Sitka", $justinmimbs$timezone_data$TimeZone$america__sitka),
        _Utils_Tuple2("America/St_Barthelemy", $justinmimbs$timezone_data$TimeZone$america__st_barthelemy),
        _Utils_Tuple2("America/St_Johns", $justinmimbs$timezone_data$TimeZone$america__st_johns),
        _Utils_Tuple2("America/St_Kitts", $justinmimbs$timezone_data$TimeZone$america__st_kitts),
        _Utils_Tuple2("America/St_Lucia", $justinmimbs$timezone_data$TimeZone$america__st_lucia),
        _Utils_Tuple2("America/St_Thomas", $justinmimbs$timezone_data$TimeZone$america__st_thomas),
        _Utils_Tuple2("America/St_Vincent", $justinmimbs$timezone_data$TimeZone$america__st_vincent),
        _Utils_Tuple2("America/Swift_Current", $justinmimbs$timezone_data$TimeZone$america__swift_current),
        _Utils_Tuple2("America/Tegucigalpa", $justinmimbs$timezone_data$TimeZone$america__tegucigalpa),
        _Utils_Tuple2("America/Thule", $justinmimbs$timezone_data$TimeZone$america__thule),
        _Utils_Tuple2("America/Thunder_Bay", $justinmimbs$timezone_data$TimeZone$america__thunder_bay),
        _Utils_Tuple2("America/Tijuana", $justinmimbs$timezone_data$TimeZone$america__tijuana),
        _Utils_Tuple2("America/Toronto", $justinmimbs$timezone_data$TimeZone$america__toronto),
        _Utils_Tuple2("America/Tortola", $justinmimbs$timezone_data$TimeZone$america__tortola),
        _Utils_Tuple2("America/Vancouver", $justinmimbs$timezone_data$TimeZone$america__vancouver),
        _Utils_Tuple2("America/Whitehorse", $justinmimbs$timezone_data$TimeZone$america__whitehorse),
        _Utils_Tuple2("America/Winnipeg", $justinmimbs$timezone_data$TimeZone$america__winnipeg),
        _Utils_Tuple2("America/Yakutat", $justinmimbs$timezone_data$TimeZone$america__yakutat),
        _Utils_Tuple2("America/Yellowknife", $justinmimbs$timezone_data$TimeZone$america__yellowknife),
        _Utils_Tuple2("Antarctica/Casey", $justinmimbs$timezone_data$TimeZone$antarctica__casey),
        _Utils_Tuple2("Antarctica/Davis", $justinmimbs$timezone_data$TimeZone$antarctica__davis),
        _Utils_Tuple2("Antarctica/DumontDUrville", $justinmimbs$timezone_data$TimeZone$antarctica__dumontdurville),
        _Utils_Tuple2("Antarctica/Macquarie", $justinmimbs$timezone_data$TimeZone$antarctica__macquarie),
        _Utils_Tuple2("Antarctica/Mawson", $justinmimbs$timezone_data$TimeZone$antarctica__mawson),
        _Utils_Tuple2("Antarctica/McMurdo", $justinmimbs$timezone_data$TimeZone$antarctica__mcmurdo),
        _Utils_Tuple2("Antarctica/Palmer", $justinmimbs$timezone_data$TimeZone$antarctica__palmer),
        _Utils_Tuple2("Antarctica/Rothera", $justinmimbs$timezone_data$TimeZone$antarctica__rothera),
        _Utils_Tuple2("Antarctica/Syowa", $justinmimbs$timezone_data$TimeZone$antarctica__syowa),
        _Utils_Tuple2("Antarctica/Troll", $justinmimbs$timezone_data$TimeZone$antarctica__troll),
        _Utils_Tuple2("Antarctica/Vostok", $justinmimbs$timezone_data$TimeZone$antarctica__vostok),
        _Utils_Tuple2("Arctic/Longyearbyen", $justinmimbs$timezone_data$TimeZone$arctic__longyearbyen),
        _Utils_Tuple2("Asia/Aden", $justinmimbs$timezone_data$TimeZone$asia__aden),
        _Utils_Tuple2("Asia/Almaty", $justinmimbs$timezone_data$TimeZone$asia__almaty),
        _Utils_Tuple2("Asia/Amman", $justinmimbs$timezone_data$TimeZone$asia__amman),
        _Utils_Tuple2("Asia/Anadyr", $justinmimbs$timezone_data$TimeZone$asia__anadyr),
        _Utils_Tuple2("Asia/Aqtau", $justinmimbs$timezone_data$TimeZone$asia__aqtau),
        _Utils_Tuple2("Asia/Aqtobe", $justinmimbs$timezone_data$TimeZone$asia__aqtobe),
        _Utils_Tuple2("Asia/Ashgabat", $justinmimbs$timezone_data$TimeZone$asia__ashgabat),
        _Utils_Tuple2("Asia/Atyrau", $justinmimbs$timezone_data$TimeZone$asia__atyrau),
        _Utils_Tuple2("Asia/Baghdad", $justinmimbs$timezone_data$TimeZone$asia__baghdad),
        _Utils_Tuple2("Asia/Bahrain", $justinmimbs$timezone_data$TimeZone$asia__bahrain),
        _Utils_Tuple2("Asia/Baku", $justinmimbs$timezone_data$TimeZone$asia__baku),
        _Utils_Tuple2("Asia/Bangkok", $justinmimbs$timezone_data$TimeZone$asia__bangkok),
        _Utils_Tuple2("Asia/Barnaul", $justinmimbs$timezone_data$TimeZone$asia__barnaul),
        _Utils_Tuple2("Asia/Beirut", $justinmimbs$timezone_data$TimeZone$asia__beirut),
        _Utils_Tuple2("Asia/Bishkek", $justinmimbs$timezone_data$TimeZone$asia__bishkek),
        _Utils_Tuple2("Asia/Brunei", $justinmimbs$timezone_data$TimeZone$asia__brunei),
        _Utils_Tuple2("Asia/Chita", $justinmimbs$timezone_data$TimeZone$asia__chita),
        _Utils_Tuple2("Asia/Choibalsan", $justinmimbs$timezone_data$TimeZone$asia__choibalsan),
        _Utils_Tuple2("Asia/Colombo", $justinmimbs$timezone_data$TimeZone$asia__colombo),
        _Utils_Tuple2("Asia/Damascus", $justinmimbs$timezone_data$TimeZone$asia__damascus),
        _Utils_Tuple2("Asia/Dhaka", $justinmimbs$timezone_data$TimeZone$asia__dhaka),
        _Utils_Tuple2("Asia/Dili", $justinmimbs$timezone_data$TimeZone$asia__dili),
        _Utils_Tuple2("Asia/Dubai", $justinmimbs$timezone_data$TimeZone$asia__dubai),
        _Utils_Tuple2("Asia/Dushanbe", $justinmimbs$timezone_data$TimeZone$asia__dushanbe),
        _Utils_Tuple2("Asia/Famagusta", $justinmimbs$timezone_data$TimeZone$asia__famagusta),
        _Utils_Tuple2("Asia/Gaza", $justinmimbs$timezone_data$TimeZone$asia__gaza),
        _Utils_Tuple2("Asia/Hebron", $justinmimbs$timezone_data$TimeZone$asia__hebron),
        _Utils_Tuple2("Asia/Ho_Chi_Minh", $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh),
        _Utils_Tuple2("Asia/Hong_Kong", $justinmimbs$timezone_data$TimeZone$asia__hong_kong),
        _Utils_Tuple2("Asia/Hovd", $justinmimbs$timezone_data$TimeZone$asia__hovd),
        _Utils_Tuple2("Asia/Irkutsk", $justinmimbs$timezone_data$TimeZone$asia__irkutsk),
        _Utils_Tuple2("Asia/Istanbul", $justinmimbs$timezone_data$TimeZone$asia__istanbul),
        _Utils_Tuple2("Asia/Jakarta", $justinmimbs$timezone_data$TimeZone$asia__jakarta),
        _Utils_Tuple2("Asia/Jayapura", $justinmimbs$timezone_data$TimeZone$asia__jayapura),
        _Utils_Tuple2("Asia/Jerusalem", $justinmimbs$timezone_data$TimeZone$asia__jerusalem),
        _Utils_Tuple2("Asia/Kabul", $justinmimbs$timezone_data$TimeZone$asia__kabul),
        _Utils_Tuple2("Asia/Kamchatka", $justinmimbs$timezone_data$TimeZone$asia__kamchatka),
        _Utils_Tuple2("Asia/Karachi", $justinmimbs$timezone_data$TimeZone$asia__karachi),
        _Utils_Tuple2("Asia/Kathmandu", $justinmimbs$timezone_data$TimeZone$asia__kathmandu),
        _Utils_Tuple2("Asia/Khandyga", $justinmimbs$timezone_data$TimeZone$asia__khandyga),
        _Utils_Tuple2("Asia/Kolkata", $justinmimbs$timezone_data$TimeZone$asia__kolkata),
        _Utils_Tuple2("Asia/Krasnoyarsk", $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk),
        _Utils_Tuple2("Asia/Kuala_Lumpur", $justinmimbs$timezone_data$TimeZone$asia__kuala_lumpur),
        _Utils_Tuple2("Asia/Kuching", $justinmimbs$timezone_data$TimeZone$asia__kuching),
        _Utils_Tuple2("Asia/Kuwait", $justinmimbs$timezone_data$TimeZone$asia__kuwait),
        _Utils_Tuple2("Asia/Macau", $justinmimbs$timezone_data$TimeZone$asia__macau),
        _Utils_Tuple2("Asia/Magadan", $justinmimbs$timezone_data$TimeZone$asia__magadan),
        _Utils_Tuple2("Asia/Makassar", $justinmimbs$timezone_data$TimeZone$asia__makassar),
        _Utils_Tuple2("Asia/Manila", $justinmimbs$timezone_data$TimeZone$asia__manila),
        _Utils_Tuple2("Asia/Muscat", $justinmimbs$timezone_data$TimeZone$asia__muscat),
        _Utils_Tuple2("Asia/Nicosia", $justinmimbs$timezone_data$TimeZone$asia__nicosia),
        _Utils_Tuple2("Asia/Novokuznetsk", $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk),
        _Utils_Tuple2("Asia/Novosibirsk", $justinmimbs$timezone_data$TimeZone$asia__novosibirsk),
        _Utils_Tuple2("Asia/Omsk", $justinmimbs$timezone_data$TimeZone$asia__omsk),
        _Utils_Tuple2("Asia/Oral", $justinmimbs$timezone_data$TimeZone$asia__oral),
        _Utils_Tuple2("Asia/Phnom_Penh", $justinmimbs$timezone_data$TimeZone$asia__phnom_penh),
        _Utils_Tuple2("Asia/Pontianak", $justinmimbs$timezone_data$TimeZone$asia__pontianak),
        _Utils_Tuple2("Asia/Pyongyang", $justinmimbs$timezone_data$TimeZone$asia__pyongyang),
        _Utils_Tuple2("Asia/Qatar", $justinmimbs$timezone_data$TimeZone$asia__qatar),
        _Utils_Tuple2("Asia/Qostanay", $justinmimbs$timezone_data$TimeZone$asia__qostanay),
        _Utils_Tuple2("Asia/Qyzylorda", $justinmimbs$timezone_data$TimeZone$asia__qyzylorda),
        _Utils_Tuple2("Asia/Riyadh", $justinmimbs$timezone_data$TimeZone$asia__riyadh),
        _Utils_Tuple2("Asia/Sakhalin", $justinmimbs$timezone_data$TimeZone$asia__sakhalin),
        _Utils_Tuple2("Asia/Samarkand", $justinmimbs$timezone_data$TimeZone$asia__samarkand),
        _Utils_Tuple2("Asia/Seoul", $justinmimbs$timezone_data$TimeZone$asia__seoul),
        _Utils_Tuple2("Asia/Shanghai", $justinmimbs$timezone_data$TimeZone$asia__shanghai),
        _Utils_Tuple2("Asia/Singapore", $justinmimbs$timezone_data$TimeZone$asia__singapore),
        _Utils_Tuple2("Asia/Srednekolymsk", $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk),
        _Utils_Tuple2("Asia/Taipei", $justinmimbs$timezone_data$TimeZone$asia__taipei),
        _Utils_Tuple2("Asia/Tashkent", $justinmimbs$timezone_data$TimeZone$asia__tashkent),
        _Utils_Tuple2("Asia/Tbilisi", $justinmimbs$timezone_data$TimeZone$asia__tbilisi),
        _Utils_Tuple2("Asia/Tehran", $justinmimbs$timezone_data$TimeZone$asia__tehran),
        _Utils_Tuple2("Asia/Thimphu", $justinmimbs$timezone_data$TimeZone$asia__thimphu),
        _Utils_Tuple2("Asia/Tokyo", $justinmimbs$timezone_data$TimeZone$asia__tokyo),
        _Utils_Tuple2("Asia/Tomsk", $justinmimbs$timezone_data$TimeZone$asia__tomsk),
        _Utils_Tuple2("Asia/Ulaanbaatar", $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar),
        _Utils_Tuple2("Asia/Urumqi", $justinmimbs$timezone_data$TimeZone$asia__urumqi),
        _Utils_Tuple2("Asia/Ust-Nera", $justinmimbs$timezone_data$TimeZone$asia__ust_nera),
        _Utils_Tuple2("Asia/Vientiane", $justinmimbs$timezone_data$TimeZone$asia__vientiane),
        _Utils_Tuple2("Asia/Vladivostok", $justinmimbs$timezone_data$TimeZone$asia__vladivostok),
        _Utils_Tuple2("Asia/Yakutsk", $justinmimbs$timezone_data$TimeZone$asia__yakutsk),
        _Utils_Tuple2("Asia/Yangon", $justinmimbs$timezone_data$TimeZone$asia__yangon),
        _Utils_Tuple2("Asia/Yekaterinburg", $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg),
        _Utils_Tuple2("Asia/Yerevan", $justinmimbs$timezone_data$TimeZone$asia__yerevan),
        _Utils_Tuple2("Atlantic/Azores", $justinmimbs$timezone_data$TimeZone$atlantic__azores),
        _Utils_Tuple2("Atlantic/Bermuda", $justinmimbs$timezone_data$TimeZone$atlantic__bermuda),
        _Utils_Tuple2("Atlantic/Canary", $justinmimbs$timezone_data$TimeZone$atlantic__canary),
        _Utils_Tuple2("Atlantic/Cape_Verde", $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde),
        _Utils_Tuple2("Atlantic/Faroe", $justinmimbs$timezone_data$TimeZone$atlantic__faroe),
        _Utils_Tuple2("Atlantic/Madeira", $justinmimbs$timezone_data$TimeZone$atlantic__madeira),
        _Utils_Tuple2("Atlantic/Reykjavik", $justinmimbs$timezone_data$TimeZone$atlantic__reykjavik),
        _Utils_Tuple2("Atlantic/South_Georgia", $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia),
        _Utils_Tuple2("Atlantic/St_Helena", $justinmimbs$timezone_data$TimeZone$atlantic__st_helena),
        _Utils_Tuple2("Atlantic/Stanley", $justinmimbs$timezone_data$TimeZone$atlantic__stanley),
        _Utils_Tuple2("Australia/Adelaide", $justinmimbs$timezone_data$TimeZone$australia__adelaide),
        _Utils_Tuple2("Australia/Brisbane", $justinmimbs$timezone_data$TimeZone$australia__brisbane),
        _Utils_Tuple2("Australia/Broken_Hill", $justinmimbs$timezone_data$TimeZone$australia__broken_hill),
        _Utils_Tuple2("Australia/Darwin", $justinmimbs$timezone_data$TimeZone$australia__darwin),
        _Utils_Tuple2("Australia/Eucla", $justinmimbs$timezone_data$TimeZone$australia__eucla),
        _Utils_Tuple2("Australia/Hobart", $justinmimbs$timezone_data$TimeZone$australia__hobart),
        _Utils_Tuple2("Australia/Lindeman", $justinmimbs$timezone_data$TimeZone$australia__lindeman),
        _Utils_Tuple2("Australia/Lord_Howe", $justinmimbs$timezone_data$TimeZone$australia__lord_howe),
        _Utils_Tuple2("Australia/Melbourne", $justinmimbs$timezone_data$TimeZone$australia__melbourne),
        _Utils_Tuple2("Australia/Perth", $justinmimbs$timezone_data$TimeZone$australia__perth),
        _Utils_Tuple2("Australia/Sydney", $justinmimbs$timezone_data$TimeZone$australia__sydney),
        _Utils_Tuple2("Europe/Amsterdam", $justinmimbs$timezone_data$TimeZone$europe__amsterdam),
        _Utils_Tuple2("Europe/Andorra", $justinmimbs$timezone_data$TimeZone$europe__andorra),
        _Utils_Tuple2("Europe/Astrakhan", $justinmimbs$timezone_data$TimeZone$europe__astrakhan),
        _Utils_Tuple2("Europe/Athens", $justinmimbs$timezone_data$TimeZone$europe__athens),
        _Utils_Tuple2("Europe/Belgrade", $justinmimbs$timezone_data$TimeZone$europe__belgrade),
        _Utils_Tuple2("Europe/Berlin", $justinmimbs$timezone_data$TimeZone$europe__berlin),
        _Utils_Tuple2("Europe/Bratislava", $justinmimbs$timezone_data$TimeZone$europe__bratislava),
        _Utils_Tuple2("Europe/Brussels", $justinmimbs$timezone_data$TimeZone$europe__brussels),
        _Utils_Tuple2("Europe/Bucharest", $justinmimbs$timezone_data$TimeZone$europe__bucharest),
        _Utils_Tuple2("Europe/Budapest", $justinmimbs$timezone_data$TimeZone$europe__budapest),
        _Utils_Tuple2("Europe/Busingen", $justinmimbs$timezone_data$TimeZone$europe__busingen),
        _Utils_Tuple2("Europe/Chisinau", $justinmimbs$timezone_data$TimeZone$europe__chisinau),
        _Utils_Tuple2("Europe/Copenhagen", $justinmimbs$timezone_data$TimeZone$europe__copenhagen),
        _Utils_Tuple2("Europe/Dublin", $justinmimbs$timezone_data$TimeZone$europe__dublin),
        _Utils_Tuple2("Europe/Gibraltar", $justinmimbs$timezone_data$TimeZone$europe__gibraltar),
        _Utils_Tuple2("Europe/Guernsey", $justinmimbs$timezone_data$TimeZone$europe__guernsey),
        _Utils_Tuple2("Europe/Helsinki", $justinmimbs$timezone_data$TimeZone$europe__helsinki),
        _Utils_Tuple2("Europe/Isle_of_Man", $justinmimbs$timezone_data$TimeZone$europe__isle_of_man),
        _Utils_Tuple2("Europe/Istanbul", $justinmimbs$timezone_data$TimeZone$europe__istanbul),
        _Utils_Tuple2("Europe/Jersey", $justinmimbs$timezone_data$TimeZone$europe__jersey),
        _Utils_Tuple2("Europe/Kaliningrad", $justinmimbs$timezone_data$TimeZone$europe__kaliningrad),
        _Utils_Tuple2("Europe/Kiev", $justinmimbs$timezone_data$TimeZone$europe__kiev),
        _Utils_Tuple2("Europe/Kirov", $justinmimbs$timezone_data$TimeZone$europe__kirov),
        _Utils_Tuple2("Europe/Lisbon", $justinmimbs$timezone_data$TimeZone$europe__lisbon),
        _Utils_Tuple2("Europe/Ljubljana", $justinmimbs$timezone_data$TimeZone$europe__ljubljana),
        _Utils_Tuple2("Europe/London", $justinmimbs$timezone_data$TimeZone$europe__london),
        _Utils_Tuple2("Europe/Luxembourg", $justinmimbs$timezone_data$TimeZone$europe__luxembourg),
        _Utils_Tuple2("Europe/Madrid", $justinmimbs$timezone_data$TimeZone$europe__madrid),
        _Utils_Tuple2("Europe/Malta", $justinmimbs$timezone_data$TimeZone$europe__malta),
        _Utils_Tuple2("Europe/Mariehamn", $justinmimbs$timezone_data$TimeZone$europe__mariehamn),
        _Utils_Tuple2("Europe/Minsk", $justinmimbs$timezone_data$TimeZone$europe__minsk),
        _Utils_Tuple2("Europe/Monaco", $justinmimbs$timezone_data$TimeZone$europe__monaco),
        _Utils_Tuple2("Europe/Moscow", $justinmimbs$timezone_data$TimeZone$europe__moscow),
        _Utils_Tuple2("Europe/Nicosia", $justinmimbs$timezone_data$TimeZone$europe__nicosia),
        _Utils_Tuple2("Europe/Oslo", $justinmimbs$timezone_data$TimeZone$europe__oslo),
        _Utils_Tuple2("Europe/Paris", $justinmimbs$timezone_data$TimeZone$europe__paris),
        _Utils_Tuple2("Europe/Podgorica", $justinmimbs$timezone_data$TimeZone$europe__podgorica),
        _Utils_Tuple2("Europe/Prague", $justinmimbs$timezone_data$TimeZone$europe__prague),
        _Utils_Tuple2("Europe/Riga", $justinmimbs$timezone_data$TimeZone$europe__riga),
        _Utils_Tuple2("Europe/Rome", $justinmimbs$timezone_data$TimeZone$europe__rome),
        _Utils_Tuple2("Europe/Samara", $justinmimbs$timezone_data$TimeZone$europe__samara),
        _Utils_Tuple2("Europe/San_Marino", $justinmimbs$timezone_data$TimeZone$europe__san_marino),
        _Utils_Tuple2("Europe/Sarajevo", $justinmimbs$timezone_data$TimeZone$europe__sarajevo),
        _Utils_Tuple2("Europe/Saratov", $justinmimbs$timezone_data$TimeZone$europe__saratov),
        _Utils_Tuple2("Europe/Simferopol", $justinmimbs$timezone_data$TimeZone$europe__simferopol),
        _Utils_Tuple2("Europe/Skopje", $justinmimbs$timezone_data$TimeZone$europe__skopje),
        _Utils_Tuple2("Europe/Sofia", $justinmimbs$timezone_data$TimeZone$europe__sofia),
        _Utils_Tuple2("Europe/Stockholm", $justinmimbs$timezone_data$TimeZone$europe__stockholm),
        _Utils_Tuple2("Europe/Tallinn", $justinmimbs$timezone_data$TimeZone$europe__tallinn),
        _Utils_Tuple2("Europe/Tirane", $justinmimbs$timezone_data$TimeZone$europe__tirane),
        _Utils_Tuple2("Europe/Ulyanovsk", $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk),
        _Utils_Tuple2("Europe/Uzhgorod", $justinmimbs$timezone_data$TimeZone$europe__uzhgorod),
        _Utils_Tuple2("Europe/Vaduz", $justinmimbs$timezone_data$TimeZone$europe__vaduz),
        _Utils_Tuple2("Europe/Vatican", $justinmimbs$timezone_data$TimeZone$europe__vatican),
        _Utils_Tuple2("Europe/Vienna", $justinmimbs$timezone_data$TimeZone$europe__vienna),
        _Utils_Tuple2("Europe/Vilnius", $justinmimbs$timezone_data$TimeZone$europe__vilnius),
        _Utils_Tuple2("Europe/Volgograd", $justinmimbs$timezone_data$TimeZone$europe__volgograd),
        _Utils_Tuple2("Europe/Warsaw", $justinmimbs$timezone_data$TimeZone$europe__warsaw),
        _Utils_Tuple2("Europe/Zagreb", $justinmimbs$timezone_data$TimeZone$europe__zagreb),
        _Utils_Tuple2("Europe/Zaporozhye", $justinmimbs$timezone_data$TimeZone$europe__zaporozhye),
        _Utils_Tuple2("Europe/Zurich", $justinmimbs$timezone_data$TimeZone$europe__zurich),
        _Utils_Tuple2("Indian/Antananarivo", $justinmimbs$timezone_data$TimeZone$indian__antananarivo),
        _Utils_Tuple2("Indian/Chagos", $justinmimbs$timezone_data$TimeZone$indian__chagos),
        _Utils_Tuple2("Indian/Christmas", $justinmimbs$timezone_data$TimeZone$indian__christmas),
        _Utils_Tuple2("Indian/Cocos", $justinmimbs$timezone_data$TimeZone$indian__cocos),
        _Utils_Tuple2("Indian/Comoro", $justinmimbs$timezone_data$TimeZone$indian__comoro),
        _Utils_Tuple2("Indian/Kerguelen", $justinmimbs$timezone_data$TimeZone$indian__kerguelen),
        _Utils_Tuple2("Indian/Mahe", $justinmimbs$timezone_data$TimeZone$indian__mahe),
        _Utils_Tuple2("Indian/Maldives", $justinmimbs$timezone_data$TimeZone$indian__maldives),
        _Utils_Tuple2("Indian/Mauritius", $justinmimbs$timezone_data$TimeZone$indian__mauritius),
        _Utils_Tuple2("Indian/Mayotte", $justinmimbs$timezone_data$TimeZone$indian__mayotte),
        _Utils_Tuple2("Indian/Reunion", $justinmimbs$timezone_data$TimeZone$indian__reunion),
        _Utils_Tuple2("Pacific/Apia", $justinmimbs$timezone_data$TimeZone$pacific__apia),
        _Utils_Tuple2("Pacific/Auckland", $justinmimbs$timezone_data$TimeZone$pacific__auckland),
        _Utils_Tuple2("Pacific/Bougainville", $justinmimbs$timezone_data$TimeZone$pacific__bougainville),
        _Utils_Tuple2("Pacific/Chatham", $justinmimbs$timezone_data$TimeZone$pacific__chatham),
        _Utils_Tuple2("Pacific/Chuuk", $justinmimbs$timezone_data$TimeZone$pacific__chuuk),
        _Utils_Tuple2("Pacific/Easter", $justinmimbs$timezone_data$TimeZone$pacific__easter),
        _Utils_Tuple2("Pacific/Efate", $justinmimbs$timezone_data$TimeZone$pacific__efate),
        _Utils_Tuple2("Pacific/Enderbury", $justinmimbs$timezone_data$TimeZone$pacific__enderbury),
        _Utils_Tuple2("Pacific/Fakaofo", $justinmimbs$timezone_data$TimeZone$pacific__fakaofo),
        _Utils_Tuple2("Pacific/Fiji", $justinmimbs$timezone_data$TimeZone$pacific__fiji),
        _Utils_Tuple2("Pacific/Funafuti", $justinmimbs$timezone_data$TimeZone$pacific__funafuti),
        _Utils_Tuple2("Pacific/Galapagos", $justinmimbs$timezone_data$TimeZone$pacific__galapagos),
        _Utils_Tuple2("Pacific/Gambier", $justinmimbs$timezone_data$TimeZone$pacific__gambier),
        _Utils_Tuple2("Pacific/Guadalcanal", $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal),
        _Utils_Tuple2("Pacific/Guam", $justinmimbs$timezone_data$TimeZone$pacific__guam),
        _Utils_Tuple2("Pacific/Honolulu", $justinmimbs$timezone_data$TimeZone$pacific__honolulu),
        _Utils_Tuple2("Pacific/Kiritimati", $justinmimbs$timezone_data$TimeZone$pacific__kiritimati),
        _Utils_Tuple2("Pacific/Kosrae", $justinmimbs$timezone_data$TimeZone$pacific__kosrae),
        _Utils_Tuple2("Pacific/Kwajalein", $justinmimbs$timezone_data$TimeZone$pacific__kwajalein),
        _Utils_Tuple2("Pacific/Majuro", $justinmimbs$timezone_data$TimeZone$pacific__majuro),
        _Utils_Tuple2("Pacific/Marquesas", $justinmimbs$timezone_data$TimeZone$pacific__marquesas),
        _Utils_Tuple2("Pacific/Midway", $justinmimbs$timezone_data$TimeZone$pacific__midway),
        _Utils_Tuple2("Pacific/Nauru", $justinmimbs$timezone_data$TimeZone$pacific__nauru),
        _Utils_Tuple2("Pacific/Niue", $justinmimbs$timezone_data$TimeZone$pacific__niue),
        _Utils_Tuple2("Pacific/Norfolk", $justinmimbs$timezone_data$TimeZone$pacific__norfolk),
        _Utils_Tuple2("Pacific/Noumea", $justinmimbs$timezone_data$TimeZone$pacific__noumea),
        _Utils_Tuple2("Pacific/Pago_Pago", $justinmimbs$timezone_data$TimeZone$pacific__pago_pago),
        _Utils_Tuple2("Pacific/Palau", $justinmimbs$timezone_data$TimeZone$pacific__palau),
        _Utils_Tuple2("Pacific/Pitcairn", $justinmimbs$timezone_data$TimeZone$pacific__pitcairn),
        _Utils_Tuple2("Pacific/Pohnpei", $justinmimbs$timezone_data$TimeZone$pacific__pohnpei),
        _Utils_Tuple2("Pacific/Port_Moresby", $justinmimbs$timezone_data$TimeZone$pacific__port_moresby),
        _Utils_Tuple2("Pacific/Rarotonga", $justinmimbs$timezone_data$TimeZone$pacific__rarotonga),
        _Utils_Tuple2("Pacific/Saipan", $justinmimbs$timezone_data$TimeZone$pacific__saipan),
        _Utils_Tuple2("Pacific/Tahiti", $justinmimbs$timezone_data$TimeZone$pacific__tahiti),
        _Utils_Tuple2("Pacific/Tarawa", $justinmimbs$timezone_data$TimeZone$pacific__tarawa),
        _Utils_Tuple2("Pacific/Tongatapu", $justinmimbs$timezone_data$TimeZone$pacific__tongatapu),
        _Utils_Tuple2("Pacific/Wake", $justinmimbs$timezone_data$TimeZone$pacific__wake),
        _Utils_Tuple2("Pacific/Wallis", $justinmimbs$timezone_data$TimeZone$pacific__wallis)
    ]));
    var $author$project$RRule$ianaTimezones = $elm$core$Dict$insert_fn("America/Indianapolis", $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis, $elm$core$Dict$insert_fn("Asia/Calcutta", $justinmimbs$timezone_data$TimeZone$asia__kolkata, $elm$core$Dict$insert_fn("PST8PDT", $justinmimbs$timezone_data$TimeZone$america__los_angeles, $elm$core$Dict$insert_fn("Etc/UTC", function (_v2) {
        return $elm$time$Time$utc;
    }, $elm$core$Dict$insert_fn("Etc/GMT", function (_v1) {
        return $elm$time$Time$utc;
    }, $elm$core$Dict$insert_fn("UTC", function (_v0) {
        return $elm$time$Time$utc;
    }, $justinmimbs$timezone_data$TimeZone$zones))))));
    var $author$project$Util$Time$zones = $author$project$RRule$ianaTimezones;
    var $author$project$Init$init_fn = function (flags, url, key) {
        var fallbackZone = $elm$time$Time$Zone_fn(flags.pr, _List_Nil);
        var _v0 = function () {
            var _v1 = flags.jq;
            if (_v1.$ === 1) {
                return _Utils_Tuple2(fallbackZone, $elm$core$Platform$Cmd$none);
            }
            else {
                var ianaName = _v1.a;
                var _v2 = $elm$core$Dict$get_fn(ianaName, $author$project$Util$Time$zones);
                if (!_v2.$) {
                    var zone = _v2.a;
                    return _Utils_Tuple2(zone(0), $elm$core$Platform$Cmd$none);
                }
                else {
                    return _Utils_Tuple2(fallbackZone, $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$warning_a0, $author$project$Error$TimeZone($justinmimbs$timezone_data$TimeZone$NoDataForZoneName(ianaName)))));
                }
            }
        }();
        var timeZone = _v0.a;
        var timeZoneErrors = _v0.b;
        var _v3 = $author$project$Init$decodeSettings(flags.pZ);
        var initSettings = _v3.a;
        var mSettingsDecodeError = _v3.b;
        var env = $author$project$Init$envHelper_fn(flags, timeZone, url, $elm$core$Maybe$Just(key), initSettings);
        var _v4 = $author$project$Update$setPageFromRoute((new $$Record62(flags.gG, env, $author$project$Model$PageLoading, $author$project$Search$Index$emptyIndices, $author$project$Search$Bar$init)));
        var model = _v4.a;
        var pageCmd = _v4.b;
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            pageCmd,
            timeZoneErrors,
            $elm$core$Task$perform_fn($author$project$Model$UpdateWindowViewport, $elm$browser$Browser$Dom$getViewport),
            $author$project$Util$Cmd$whenJust_fn(mSettingsDecodeError, $author$project$Error$log)
        ])));
    }, $author$project$Init$init = F3($author$project$Init$init_fn);
    var $author$project$Model$AppReloadRequired = function (a) {
        return { $: 41, a: a };
    };
    var $author$project$Model$AppVersionUpdated = function (a) {
        return { $: 40, a: a };
    };
    var $author$project$Model$EveryMinute = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Model$FirestoreMsg = function (a) {
        return { $: 14, a: a };
    };
    var $author$project$Model$GetWindowViewport = { $: 4 };
    var $author$project$Model$Keypressed = function (a) {
        return { $: 27, a: a };
    };
    var $author$project$Model$MentionRequest = function (a) {
        return { $: 44, a: a };
    };
    var $author$project$Data$App$NastyJavascriptError = 0;
    var $author$project$Model$PersonsMerged = function (a) {
        return { $: 22, a: a };
    };
    var $author$project$Model$SearchIndicesLoaded = function (a) {
        return { $: 25, a: a };
    };
    var $author$project$Model$SearchWeightIndexLoaded = function (a) {
        return { $: 26, a: a };
    };
    var $author$project$Model$SignedIn = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Model$StorageUploadMsg = function (a) {
        return { $: 21, a: a };
    };
    var $author$project$Model$UpdateUserIdToken = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Model$UserSubscription = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Ports$appVersion = _Platform_incomingPort("appVersion", $elm$json$Json$Decode$value);
    var $elm$core$Platform$Sub$batch = _Platform_batch;
    var $author$project$Model$CalendarEvents = function (a) {
        return { $: 11, a: a };
    };
    var $author$project$Data$GCal$Event = function (attendees) {
        return function (conferenceData) {
            return function (description) {
                return function (end) {
                    return function (htmlLink) {
                        return function (id) {
                            return function (organizer) {
                                return function (originalStartTime) {
                                    return function (recurrence) {
                                        return function (recurringEventId) {
                                            return function (start) {
                                                return function (status) {
                                                    return function (summary) {
                                                        return function (colorId) {
                                                            return function (updated) {
                                                                return (new $$Record63(attendees, colorId, conferenceData, description, end, htmlLink, id, organizer, originalStartTime, recurrence, recurringEventId, start, status, summary, updated));
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Data$Time$IANAZone_fn = function (zoneThunk, ianaName) {
        return { l5: ianaName, p8: zoneThunk };
    }, $author$project$Data$Time$IANAZone = F2($author$project$Data$Time$IANAZone_fn);
    var $author$project$Data$Time$decodeIANATimezone = _Json_andThen_fn(function (ianaName) {
        var _v0 = $elm$core$Dict$get_fn(ianaName, $author$project$Util$Time$zones);
        if (!_v0.$) {
            var zoneTunk = _v0.a;
            return $elm$json$Json$Decode$succeed($author$project$Data$Time$IANAZone_fn(zoneTunk, ianaName));
        }
        else {
            return $elm$json$Json$Decode$fail("Unknown IANA Timezone " + ianaName);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Data$GCal$decodeGCalTime = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_map2_fn(F2(function (time, mZone) {
            return $author$project$Data$Time$Time((new $$Record26(time, mZone)));
        }), _Json_decodeField_fn("dateTime", $author$project$Data$Time$decodeISODateTime), $elm$json$Json$Decode$maybe(_Json_decodeField_fn("timeZone", $author$project$Data$Time$decodeIANATimezone))),
        _Json_map1_fn($author$project$Data$Time$Date, _Json_decodeField_fn("date", $author$project$Data$Time$decodeISODate))
    ]));
    var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded_a0 = $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded_a1 = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded_a0, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded_a1);
    var $author$project$Data$GCal$cancelledInstanceDecoder = _Json_andThen_fn(function (event) {
        var _v0 = event.oP;
        if (_v0 === "cancelled") {
            return $elm$json$Json$Decode$succeed(event);
        }
        else {
            return $elm$json$Json$Decode$fail("Expected a 'cancelled' recurring instance");
        }
    }, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("updated", $author$project$Data$Time$decodeISODateTime, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, $elm$core$Maybe$Nothing, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, "Cancelled Instance", $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("status", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("start", $author$project$Data$GCal$decodeGCalTime, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("recurringEventId", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, $elm$core$Maybe$Nothing, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("originalStartTime", $elm$json$Json$Decode$nullable($author$project$Data$GCal$decodeGCalTime), A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, { g7: "", cS: "" }, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("id", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("htmlLink", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("end", $author$project$Data$GCal$decodeGCalTime, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, "", A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, $elm$core$Maybe$Nothing, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, _List_Nil, $elm$json$Json$Decode$succeed($author$project$Data$GCal$Event)))))))))))))))));
    var $author$project$Data$GCal$GCalAttendee_fn = function (displayName, email, responseStatus, self, resource, organizer, isCreator) {
        return { g7: displayName, cS: email, mv: isCreator, c8: organizer, ev: resource, ew: responseStatus, os: self };
    }, $author$project$Data$GCal$GCalAttendee = F7($author$project$Data$GCal$GCalAttendee_fn);
    var $author$project$Data$GCal$decodeAttendee = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("isCreator", $elm$json$Json$Decode$bool, false, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("organizer", $elm$json$Json$Decode$bool, false, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("resource", $elm$json$Json$Decode$bool, false, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("self", $elm$json$Json$Decode$bool, false, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("responseStatus", $elm$json$Json$Decode$string, "", $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("email", $elm$json$Json$Decode$string, "", $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("displayName", $elm$json$Json$Decode$string, "", $elm$json$Json$Decode$succeed($author$project$Data$GCal$GCalAttendee))))))));
    var $author$project$Data$GCal$ConferenceData = function (entryPoints) {
        return { ls: entryPoints };
    };
    var $author$project$Data$GCal$ConferenceEntryPoint_fn = function (entryPointType, label, uri, pin, regionCode) {
        return { lr: entryPointType, fF: label, nO: pin, n5: regionCode, pT: uri };
    }, $author$project$Data$GCal$ConferenceEntryPoint = F5($author$project$Data$GCal$ConferenceEntryPoint_fn);
    var $author$project$Data$GCal$decodeConferenceEntryPoint = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("regionCode", $elm$json$Json$Decode$string, "", $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("pin", $elm$json$Json$Decode$string, "", $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("uri", $elm$json$Json$Decode$string, "", $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("label", $elm$json$Json$Decode$string, "", $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("entryPointType", $elm$json$Json$Decode$string, "", $elm$json$Json$Decode$succeed($author$project$Data$GCal$ConferenceEntryPoint))))));
    var $author$project$Data$GCal$decodeConferenceData = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("entryPoints", $elm$json$Json$Decode$list($author$project$Data$GCal$decodeConferenceEntryPoint), $elm$json$Json$Decode$succeed($author$project$Data$GCal$ConferenceData));
    var $author$project$Data$GCal$Organizer_fn = function (displayName, email) {
        return { g7: displayName, cS: email };
    }, $author$project$Data$GCal$Organizer = F2($author$project$Data$GCal$Organizer_fn);
    var $author$project$Data$GCal$decodeOrganizer = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("email", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("displayName", $elm$json$Json$Decode$string, "", $elm$json$Json$Decode$succeed($author$project$Data$GCal$Organizer)));
    var $author$project$Data$GCal$fullEventDecoder = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("updated", $author$project$Data$Time$decodeISODateTime, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("colorId", _Json_map1_fn($elm$core$String$toInt, $elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("summary", $elm$json$Json$Decode$string, "(No title)", $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("status", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("start", $author$project$Data$GCal$decodeGCalTime, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("recurringEventId", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("recurrence", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$list($elm$json$Json$Decode$string)), $elm$core$Maybe$Nothing, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("originalStartTime", $elm$json$Json$Decode$nullable($author$project$Data$GCal$decodeGCalTime), $elm$core$Maybe$Nothing, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("organizer", $author$project$Data$GCal$decodeOrganizer, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("id", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("htmlLink", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("end", $author$project$Data$GCal$decodeGCalTime, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("description", $elm$json$Json$Decode$string, "", $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("conferenceData", $elm$json$Json$Decode$nullable($author$project$Data$GCal$decodeConferenceData), $elm$core$Maybe$Nothing, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("attendees", $elm$json$Json$Decode$list($author$project$Data$GCal$decodeAttendee), _List_Nil, $elm$json$Json$Decode$succeed($author$project$Data$GCal$Event))))))))))))))));
    var $author$project$Data$GCal$validate = function (event) {
        var _v0 = _Utils_Tuple2(event.bF, event.b6);
        _v0$2: while (true) {
            if (!_v0.a.$) {
                if (_v0.b.$ === 1) {
                    return $elm$json$Json$Decode$fail("start and end types differ. start:DATETIME end:DATE");
                }
                else {
                    break _v0$2;
                }
            }
            else {
                if (!_v0.b.$) {
                    return $elm$json$Json$Decode$fail("start and end types differ. start:DATE end:DATETIME");
                }
                else {
                    break _v0$2;
                }
            }
        }
        return $elm$json$Json$Decode$succeed(event);
    };
    var $author$project$Data$GCal$decoder = _Json_andThen_fn($author$project$Data$GCal$validate, $elm$json$Json$Decode$oneOf(_List_fromArray([$author$project$Data$GCal$fullEventDecoder, $author$project$Data$GCal$cancelledInstanceDecoder])));
    var $author$project$Util$Conference$getConferenceData = function (mConfData) {
        var extractUri = F2(function (entryPoint, callInfo) {
            var _v0 = entryPoint.lr;
            switch (_v0) {
                case "video":
                    return function (uri) {
                        return function () {
                            var $r = callInfo.$c();
                            $r.eT = $elm$core$Maybe$Just(uri);
                            return $r;
                        }();
                    }(entryPoint.pT);
                case "phone":
                    return function (uri) {
                        return function () {
                            var $r = callInfo.$c();
                            $r.el = $elm$core$Maybe$Just(uri);
                            return $r;
                        }();
                    }($elm$core$String$concat(_List_fromArray([entryPoint.pT, ",,", entryPoint.nO, "#"])));
                default:
                    return callInfo;
            }
        });
        var parseData = function (eventConfData) {
            return $elm$core$List$foldr_fn(extractUri, (new $$Record64($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)), eventConfData.ls);
        };
        return $elm$core$Maybe$withDefault_fn((new $$Record64($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)), $elm$core$Maybe$map_fn(parseData, mConfData));
    };
    var $author$project$Util$Conference$ConferenceCalendly = 3;
    var $author$project$Util$Conference$ConferenceGotoMeeting = 5;
    var $author$project$Util$Conference$ConferenceLync = 1;
    var $author$project$Util$Conference$ConferenceMicrosoftTeams = 0;
    var $author$project$Util$Conference$ConferenceStartMeeting = 4;
    var $author$project$Util$Conference$ConferenceZoom = 2;
    var $author$project$Util$Conference$detectConferenceType = function (domain) {
        var _v0 = $elm$core$String$split_fn(".", domain);
        _v0$7: while (true) {
            if (_v0.b && _v0.b.b) {
                if (_v0.b.b.b) {
                    if (!_v0.b.b.b.b) {
                        switch (_v0.b.b.a) {
                            case "us":
                                if (_v0.b.a === "zoom") {
                                    var _v6 = _v0.b;
                                    var _v7 = _v6.b;
                                    return $elm$core$Maybe$Just(2);
                                }
                                else {
                                    break _v0$7;
                                }
                            case "com":
                                switch (_v0.a) {
                                    case "teams":
                                        if (_v0.b.a === "microsoft") {
                                            var _v1 = _v0.b;
                                            var _v2 = _v1.b;
                                            return $elm$core$Maybe$Just(0);
                                        }
                                        else {
                                            break _v0$7;
                                        }
                                    case "meet":
                                        if (_v0.b.a === "lync") {
                                            var _v3 = _v0.b;
                                            var _v4 = _v3.b;
                                            return $elm$core$Maybe$Just(1);
                                        }
                                        else {
                                            break _v0$7;
                                        }
                                    case "join":
                                        if (_v0.b.a === "startmeeting") {
                                            var _v9 = _v0.b;
                                            var _v10 = _v9.b;
                                            return $elm$core$Maybe$Just(4);
                                        }
                                        else {
                                            break _v0$7;
                                        }
                                    default:
                                        break _v0$7;
                                }
                            default:
                                break _v0$7;
                        }
                    }
                    else {
                        break _v0$7;
                    }
                }
                else {
                    switch (_v0.b.a) {
                        case "us":
                            if (_v0.a === "zoom") {
                                var _v5 = _v0.b;
                                return $elm$core$Maybe$Just(2);
                            }
                            else {
                                break _v0$7;
                            }
                        case "com":
                            switch (_v0.a) {
                                case "calendly":
                                    var _v8 = _v0.b;
                                    return $elm$core$Maybe$Just(3);
                                case "gotomeeting":
                                    var _v11 = _v0.b;
                                    return $elm$core$Maybe$Just(5);
                                default:
                                    break _v0$7;
                            }
                        default:
                            break _v0$7;
                    }
                }
            }
            else {
                break _v0$7;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $elm$core$String$filter = _String_filter;
    var $elm$regex$Regex$find_a0 = _Regex_infinity, $elm$regex$Regex$find = _Regex_findAtMost($elm$regex$Regex$find_a0);
    var $author$project$Util$Conference$parseCalendlyZoomPhone = function (body) {
        var phone = $elm$core$Maybe$map_fn($elm$core$String$dropRight(1), $elm$core$Maybe$map_fn(function ($) {
            return $.by;
        }, $elm$core$List$head($elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(function (regex) {
            return _Regex_findAtMost_fn($elm$regex$Regex$find_a0, regex, body);
        }, $elm$regex$Regex$fromString("\\+[0-9 ()\\-]*,"))))));
        var code = $elm$core$Maybe$map_fn($elm$core$String$filter(function (c) {
            return (c !== "-") && (c !== " ");
        }), $elm$core$Maybe$map_fn($elm$core$String$dropLeft(12), $elm$core$Maybe$map_fn(function ($) {
            return $.by;
        }, $elm$core$List$head($elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(function (regex) {
            return _Regex_findAtMost_fn($elm$regex$Regex$find_a0, regex, body);
        }, $elm$regex$Regex$fromString("Meeting ID: [0-9\\- ]*")))))));
        var _v0 = _Utils_Tuple2(phone, code);
        if (!_v0.a.$) {
            if (!_v0.b.$) {
                var num = _v0.a.a;
                var pin = _v0.b.a;
                return $elm$core$Maybe$Just("tel:" + (num + (",," + (pin + "#"))));
            }
            else {
                var num = _v0.a.a;
                var _v1 = _v0.b;
                return $elm$core$Maybe$Just("tel:" + num);
            }
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Util$Conference$parseFirstPhoneHash = function (body) {
        return $elm$core$Maybe$map_fn(function (number) {
            return "tel:" + number.by;
        }, $elm$core$List$head($elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(function (regex) {
            return _Regex_findAtMost_fn($elm$regex$Regex$find_a0, regex, body);
        }, $elm$regex$Regex$fromString("\\+[0-9 ()\\-,]*#")))));
    };
    var $author$project$Util$Conference$urlRegex = $elm$regex$Regex$fromString("https?:\\/\\/((?:[a-zA-Z0-9-]+\\.)+(?:[a-zA-Z0-9-]+))\\/?[^\\s<>]*");
    var $author$project$Util$Conference$parseHostnames = function (body) {
        return $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(function (re) {
            return _Regex_findAtMost_fn($elm$regex$Regex$find_a0, re, body);
        }, $author$project$Util$Conference$urlRegex));
    };
    var $author$project$Util$Conference$parseTeamsPhone = function (body) {
        return $elm$core$Maybe$map_fn(function (number) {
            return "tel:" + number.by;
        }, $elm$core$List$head($elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(function (regex) {
            return _Regex_findAtMost_fn($elm$regex$Regex$find_a0, regex, body);
        }, $elm$regex$Regex$fromString("\\+[0-9%()\\-,]*#")))));
    };
    var $hecrj$html_parser$Html$Parser$Element_fn = function (a, b, c) {
        return { $: 1, a: a, b: b, c: c };
    }, $hecrj$html_parser$Html$Parser$Element = F3($hecrj$html_parser$Html$Parser$Element_fn);
    var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
        return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$chompIf(fn), $elm$parser$Parser$chompWhile(fn));
    };
    var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
        return (c === " ") || ((c === "\t") || ((c === "\n") || ((c === "\r") || ((c === "\f") || (c === "\u00A0")))));
    };
    var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
        var chompName = $elm$parser$Parser$Advanced$andThen_fn(function (closingName) {
            return _Utils_eq($elm$core$String$toLower(closingName), name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem("closing tag does not match opening tag: " + name);
        }, $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore(function (c) {
            return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== ">");
        })));
        return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$chompIf($elm$core$Basics$eq("<")), $elm$parser$Parser$chompIf($elm$core$Basics$eq("/"))), chompName), $elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)), $elm$parser$Parser$chompIf($elm$core$Basics$eq(">")));
    };
    var $hecrj$html_parser$Html$Parser$Comment = function (a) {
        return { $: 2, a: a };
    };
    var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
    var $elm$parser$Parser$Advanced$fromInfo_fn = function (row, col, x, context) {
        return $elm$parser$Parser$Advanced$AddRight_fn($elm$parser$Parser$Advanced$Empty, $elm$parser$Parser$Advanced$DeadEnd_fn(row, col, x, context));
    }, $elm$parser$Parser$Advanced$fromInfo = F4($elm$parser$Parser$Advanced$fromInfo_fn);
    var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
        var str = _v0.a;
        var expecting = _v0.b;
        return function (s) {
            var _v1 = _Parser_findSubString_fn(str, s.nt, s.of, s.kQ, s.oM);
            var newOffset = _v1.a;
            var newRow = _v1.b;
            var newCol = _v1.c;
            return newOffset === -1 ? $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromInfo_fn(newRow, newCol, expecting, s.h)) : $elm$parser$Parser$Advanced$Good_fn(_Utils_cmp(s.nt, newOffset) < 0, 0, { kQ: newCol, h: s.h, i: s.i, nt: newOffset, of: newRow, oM: s.oM });
        };
    };
    var $elm$parser$Parser$chompUntil = function (str) {
        return $elm$parser$Parser$Advanced$chompUntil($elm$parser$Parser$toToken(str));
    };
    var $hecrj$html_parser$Html$Parser$commentString = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$token("<!")), $elm$parser$Parser$token("--")), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$getChompedString($elm$parser$Parser$chompUntil("-->")), $elm$parser$Parser$token("-->")));
    var $hecrj$html_parser$Html$Parser$comment = $elm$parser$Parser$Advanced$map_fn($hecrj$html_parser$Html$Parser$Comment, $hecrj$html_parser$Html$Parser$commentString);
    var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(["area", "base", "br", "col", "embed", "hr", "img", "input", "link", "meta", "param", "source", "track", "wbr"]);
    var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
        return $elm$core$List$member_fn(name, $hecrj$html_parser$Html$Parser$voidElements);
    };
    var $elm$parser$Parser$Done = function (a) {
        return { $: 1, a: a };
    };
    var $elm$parser$Parser$Loop = function (a) {
        return { $: 0, a: a };
    };
    var $elm$parser$Parser$Advanced$loopHelp_fn = function (p, state, callback, s0) {
        loopHelp: while (true) {
            var _v0 = callback(state);
            var parse = _v0;
            var _v1 = parse(s0);
            if (!_v1.$) {
                var p1 = _v1.a;
                var step = _v1.b;
                var s1 = _v1.c;
                if (!step.$) {
                    var newState = step.a;
                    var $temp$p = p || p1, $temp$state = newState, $temp$callback = callback, $temp$s0 = s1;
                    p = $temp$p;
                    state = $temp$state;
                    callback = $temp$callback;
                    s0 = $temp$s0;
                    continue loopHelp;
                }
                else {
                    var result = step.a;
                    return $elm$parser$Parser$Advanced$Good_fn(p || p1, result, s1);
                }
            }
            else {
                var p1 = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p || p1, x);
            }
        }
    }, $elm$parser$Parser$Advanced$loopHelp = F4($elm$parser$Parser$Advanced$loopHelp_fn);
    var $elm$parser$Parser$Advanced$loop_fn = function (state, callback) {
        return function (s) {
            return $elm$parser$Parser$Advanced$loopHelp_fn(false, state, callback, s);
        };
    }, $elm$parser$Parser$Advanced$loop = F2($elm$parser$Parser$Advanced$loop_fn);
    var $elm$parser$Parser$Advanced$Done = function (a) {
        return { $: 1, a: a };
    };
    var $elm$parser$Parser$Advanced$Loop = function (a) {
        return { $: 0, a: a };
    };
    var $elm$parser$Parser$toAdvancedStep = function (step) {
        if (!step.$) {
            var s = step.a;
            return $elm$parser$Parser$Advanced$Loop(s);
        }
        else {
            var a = step.a;
            return $elm$parser$Parser$Advanced$Done(a);
        }
    };
    var $elm$parser$Parser$loop_fn = function (state, callback) {
        return $elm$parser$Parser$Advanced$loop_fn(state, function (s) {
            return $elm$parser$Parser$Advanced$map_fn($elm$parser$Parser$toAdvancedStep, callback(s));
        });
    }, $elm$parser$Parser$loop = F2($elm$parser$Parser$loop_fn);
    var $hecrj$html_parser$Html$Parser$many = function (parser_) {
        return $elm$parser$Parser$loop_fn(_List_Nil, function (list) {
            return $elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$map_fn(function (_new) {
                    return $elm$parser$Parser$Loop(_List_Cons(_new, list));
                }, parser_),
                $elm$parser$Parser$succeed($elm$parser$Parser$Done($elm$core$List$reverse(list)))
            ]));
        });
    };
    var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
        return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== "\"") && ((c !== "'") && ((c !== ">") && ((c !== "/") && (c !== "=")))));
    };
    var $hecrj$html_parser$Html$Parser$tagAttributeName = $elm$parser$Parser$Advanced$map_fn($elm$core$String$toLower, $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
    var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf($elm$core$Basics$eq(";"));
    var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(_List_fromArray([
        _Utils_Tuple2("Aacute", "\u00C1"),
        _Utils_Tuple2("aacute", "\u00E1"),
        _Utils_Tuple2("Abreve", "\u0102"),
        _Utils_Tuple2("abreve", "\u0103"),
        _Utils_Tuple2("ac", "\u223E"),
        _Utils_Tuple2("acd", "\u223F"),
        _Utils_Tuple2("acE", "\u223E\u0333"),
        _Utils_Tuple2("Acirc", "\u00C2"),
        _Utils_Tuple2("acirc", "\u00E2"),
        _Utils_Tuple2("acute", "\u00B4"),
        _Utils_Tuple2("Acy", "\u0410"),
        _Utils_Tuple2("acy", "\u0430"),
        _Utils_Tuple2("AElig", "\u00C6"),
        _Utils_Tuple2("aelig", "\u00E6"),
        _Utils_Tuple2("af", "\u2061"),
        _Utils_Tuple2("Afr", "\uD835\uDD04"),
        _Utils_Tuple2("afr", "\uD835\uDD1E"),
        _Utils_Tuple2("Agrave", "\u00C0"),
        _Utils_Tuple2("agrave", "\u00E0"),
        _Utils_Tuple2("alefsym", "\u2135"),
        _Utils_Tuple2("aleph", "\u2135"),
        _Utils_Tuple2("Alpha", "\u0391"),
        _Utils_Tuple2("alpha", "\u03B1"),
        _Utils_Tuple2("Amacr", "\u0100"),
        _Utils_Tuple2("amacr", "\u0101"),
        _Utils_Tuple2("amalg", "\u2A3F"),
        _Utils_Tuple2("amp", "&"),
        _Utils_Tuple2("AMP", "&"),
        _Utils_Tuple2("andand", "\u2A55"),
        _Utils_Tuple2("And", "\u2A53"),
        _Utils_Tuple2("and", "\u2227"),
        _Utils_Tuple2("andd", "\u2A5C"),
        _Utils_Tuple2("andslope", "\u2A58"),
        _Utils_Tuple2("andv", "\u2A5A"),
        _Utils_Tuple2("ang", "\u2220"),
        _Utils_Tuple2("ange", "\u29A4"),
        _Utils_Tuple2("angle", "\u2220"),
        _Utils_Tuple2("angmsdaa", "\u29A8"),
        _Utils_Tuple2("angmsdab", "\u29A9"),
        _Utils_Tuple2("angmsdac", "\u29AA"),
        _Utils_Tuple2("angmsdad", "\u29AB"),
        _Utils_Tuple2("angmsdae", "\u29AC"),
        _Utils_Tuple2("angmsdaf", "\u29AD"),
        _Utils_Tuple2("angmsdag", "\u29AE"),
        _Utils_Tuple2("angmsdah", "\u29AF"),
        _Utils_Tuple2("angmsd", "\u2221"),
        _Utils_Tuple2("angrt", "\u221F"),
        _Utils_Tuple2("angrtvb", "\u22BE"),
        _Utils_Tuple2("angrtvbd", "\u299D"),
        _Utils_Tuple2("angsph", "\u2222"),
        _Utils_Tuple2("angst", "\u00C5"),
        _Utils_Tuple2("angzarr", "\u237C"),
        _Utils_Tuple2("Aogon", "\u0104"),
        _Utils_Tuple2("aogon", "\u0105"),
        _Utils_Tuple2("Aopf", "\uD835\uDD38"),
        _Utils_Tuple2("aopf", "\uD835\uDD52"),
        _Utils_Tuple2("apacir", "\u2A6F"),
        _Utils_Tuple2("ap", "\u2248"),
        _Utils_Tuple2("apE", "\u2A70"),
        _Utils_Tuple2("ape", "\u224A"),
        _Utils_Tuple2("apid", "\u224B"),
        _Utils_Tuple2("apos", "'"),
        _Utils_Tuple2("ApplyFunction", "\u2061"),
        _Utils_Tuple2("approx", "\u2248"),
        _Utils_Tuple2("approxeq", "\u224A"),
        _Utils_Tuple2("Aring", "\u00C5"),
        _Utils_Tuple2("aring", "\u00E5"),
        _Utils_Tuple2("Ascr", "\uD835\uDC9C"),
        _Utils_Tuple2("ascr", "\uD835\uDCB6"),
        _Utils_Tuple2("Assign", "\u2254"),
        _Utils_Tuple2("ast", "*"),
        _Utils_Tuple2("asymp", "\u2248"),
        _Utils_Tuple2("asympeq", "\u224D"),
        _Utils_Tuple2("Atilde", "\u00C3"),
        _Utils_Tuple2("atilde", "\u00E3"),
        _Utils_Tuple2("Auml", "\u00C4"),
        _Utils_Tuple2("auml", "\u00E4"),
        _Utils_Tuple2("awconint", "\u2233"),
        _Utils_Tuple2("awint", "\u2A11"),
        _Utils_Tuple2("backcong", "\u224C"),
        _Utils_Tuple2("backepsilon", "\u03F6"),
        _Utils_Tuple2("backprime", "\u2035"),
        _Utils_Tuple2("backsim", "\u223D"),
        _Utils_Tuple2("backsimeq", "\u22CD"),
        _Utils_Tuple2("Backslash", "\u2216"),
        _Utils_Tuple2("Barv", "\u2AE7"),
        _Utils_Tuple2("barvee", "\u22BD"),
        _Utils_Tuple2("barwed", "\u2305"),
        _Utils_Tuple2("Barwed", "\u2306"),
        _Utils_Tuple2("barwedge", "\u2305"),
        _Utils_Tuple2("bbrk", "\u23B5"),
        _Utils_Tuple2("bbrktbrk", "\u23B6"),
        _Utils_Tuple2("bcong", "\u224C"),
        _Utils_Tuple2("Bcy", "\u0411"),
        _Utils_Tuple2("bcy", "\u0431"),
        _Utils_Tuple2("bdquo", "\u201E"),
        _Utils_Tuple2("becaus", "\u2235"),
        _Utils_Tuple2("because", "\u2235"),
        _Utils_Tuple2("Because", "\u2235"),
        _Utils_Tuple2("bemptyv", "\u29B0"),
        _Utils_Tuple2("bepsi", "\u03F6"),
        _Utils_Tuple2("bernou", "\u212C"),
        _Utils_Tuple2("Bernoullis", "\u212C"),
        _Utils_Tuple2("Beta", "\u0392"),
        _Utils_Tuple2("beta", "\u03B2"),
        _Utils_Tuple2("beth", "\u2136"),
        _Utils_Tuple2("between", "\u226C"),
        _Utils_Tuple2("Bfr", "\uD835\uDD05"),
        _Utils_Tuple2("bfr", "\uD835\uDD1F"),
        _Utils_Tuple2("bigcap", "\u22C2"),
        _Utils_Tuple2("bigcirc", "\u25EF"),
        _Utils_Tuple2("bigcup", "\u22C3"),
        _Utils_Tuple2("bigodot", "\u2A00"),
        _Utils_Tuple2("bigoplus", "\u2A01"),
        _Utils_Tuple2("bigotimes", "\u2A02"),
        _Utils_Tuple2("bigsqcup", "\u2A06"),
        _Utils_Tuple2("bigstar", "\u2605"),
        _Utils_Tuple2("bigtriangledown", "\u25BD"),
        _Utils_Tuple2("bigtriangleup", "\u25B3"),
        _Utils_Tuple2("biguplus", "\u2A04"),
        _Utils_Tuple2("bigvee", "\u22C1"),
        _Utils_Tuple2("bigwedge", "\u22C0"),
        _Utils_Tuple2("bkarow", "\u290D"),
        _Utils_Tuple2("blacklozenge", "\u29EB"),
        _Utils_Tuple2("blacksquare", "\u25AA"),
        _Utils_Tuple2("blacktriangle", "\u25B4"),
        _Utils_Tuple2("blacktriangledown", "\u25BE"),
        _Utils_Tuple2("blacktriangleleft", "\u25C2"),
        _Utils_Tuple2("blacktriangleright", "\u25B8"),
        _Utils_Tuple2("blank", "\u2423"),
        _Utils_Tuple2("blk12", "\u2592"),
        _Utils_Tuple2("blk14", "\u2591"),
        _Utils_Tuple2("blk34", "\u2593"),
        _Utils_Tuple2("block", "\u2588"),
        _Utils_Tuple2("bne", "=\u20E5"),
        _Utils_Tuple2("bnequiv", "\u2261\u20E5"),
        _Utils_Tuple2("bNot", "\u2AED"),
        _Utils_Tuple2("bnot", "\u2310"),
        _Utils_Tuple2("Bopf", "\uD835\uDD39"),
        _Utils_Tuple2("bopf", "\uD835\uDD53"),
        _Utils_Tuple2("bot", "\u22A5"),
        _Utils_Tuple2("bottom", "\u22A5"),
        _Utils_Tuple2("bowtie", "\u22C8"),
        _Utils_Tuple2("boxbox", "\u29C9"),
        _Utils_Tuple2("boxdl", "\u2510"),
        _Utils_Tuple2("boxdL", "\u2555"),
        _Utils_Tuple2("boxDl", "\u2556"),
        _Utils_Tuple2("boxDL", "\u2557"),
        _Utils_Tuple2("boxdr", "\u250C"),
        _Utils_Tuple2("boxdR", "\u2552"),
        _Utils_Tuple2("boxDr", "\u2553"),
        _Utils_Tuple2("boxDR", "\u2554"),
        _Utils_Tuple2("boxh", "\u2500"),
        _Utils_Tuple2("boxH", "\u2550"),
        _Utils_Tuple2("boxhd", "\u252C"),
        _Utils_Tuple2("boxHd", "\u2564"),
        _Utils_Tuple2("boxhD", "\u2565"),
        _Utils_Tuple2("boxHD", "\u2566"),
        _Utils_Tuple2("boxhu", "\u2534"),
        _Utils_Tuple2("boxHu", "\u2567"),
        _Utils_Tuple2("boxhU", "\u2568"),
        _Utils_Tuple2("boxHU", "\u2569"),
        _Utils_Tuple2("boxminus", "\u229F"),
        _Utils_Tuple2("boxplus", "\u229E"),
        _Utils_Tuple2("boxtimes", "\u22A0"),
        _Utils_Tuple2("boxul", "\u2518"),
        _Utils_Tuple2("boxuL", "\u255B"),
        _Utils_Tuple2("boxUl", "\u255C"),
        _Utils_Tuple2("boxUL", "\u255D"),
        _Utils_Tuple2("boxur", "\u2514"),
        _Utils_Tuple2("boxuR", "\u2558"),
        _Utils_Tuple2("boxUr", "\u2559"),
        _Utils_Tuple2("boxUR", "\u255A"),
        _Utils_Tuple2("boxv", "\u2502"),
        _Utils_Tuple2("boxV", "\u2551"),
        _Utils_Tuple2("boxvh", "\u253C"),
        _Utils_Tuple2("boxvH", "\u256A"),
        _Utils_Tuple2("boxVh", "\u256B"),
        _Utils_Tuple2("boxVH", "\u256C"),
        _Utils_Tuple2("boxvl", "\u2524"),
        _Utils_Tuple2("boxvL", "\u2561"),
        _Utils_Tuple2("boxVl", "\u2562"),
        _Utils_Tuple2("boxVL", "\u2563"),
        _Utils_Tuple2("boxvr", "\u251C"),
        _Utils_Tuple2("boxvR", "\u255E"),
        _Utils_Tuple2("boxVr", "\u255F"),
        _Utils_Tuple2("boxVR", "\u2560"),
        _Utils_Tuple2("bprime", "\u2035"),
        _Utils_Tuple2("breve", "\u02D8"),
        _Utils_Tuple2("Breve", "\u02D8"),
        _Utils_Tuple2("brvbar", "\u00A6"),
        _Utils_Tuple2("bscr", "\uD835\uDCB7"),
        _Utils_Tuple2("Bscr", "\u212C"),
        _Utils_Tuple2("bsemi", "\u204F"),
        _Utils_Tuple2("bsim", "\u223D"),
        _Utils_Tuple2("bsime", "\u22CD"),
        _Utils_Tuple2("bsolb", "\u29C5"),
        _Utils_Tuple2("bsol", "\\"),
        _Utils_Tuple2("bsolhsub", "\u27C8"),
        _Utils_Tuple2("bull", "\u2022"),
        _Utils_Tuple2("bullet", "\u2022"),
        _Utils_Tuple2("bump", "\u224E"),
        _Utils_Tuple2("bumpE", "\u2AAE"),
        _Utils_Tuple2("bumpe", "\u224F"),
        _Utils_Tuple2("Bumpeq", "\u224E"),
        _Utils_Tuple2("bumpeq", "\u224F"),
        _Utils_Tuple2("Cacute", "\u0106"),
        _Utils_Tuple2("cacute", "\u0107"),
        _Utils_Tuple2("capand", "\u2A44"),
        _Utils_Tuple2("capbrcup", "\u2A49"),
        _Utils_Tuple2("capcap", "\u2A4B"),
        _Utils_Tuple2("cap", "\u2229"),
        _Utils_Tuple2("Cap", "\u22D2"),
        _Utils_Tuple2("capcup", "\u2A47"),
        _Utils_Tuple2("capdot", "\u2A40"),
        _Utils_Tuple2("CapitalDifferentialD", "\u2145"),
        _Utils_Tuple2("caps", "\u2229\uFE00"),
        _Utils_Tuple2("caret", "\u2041"),
        _Utils_Tuple2("caron", "\u02C7"),
        _Utils_Tuple2("Cayleys", "\u212D"),
        _Utils_Tuple2("ccaps", "\u2A4D"),
        _Utils_Tuple2("Ccaron", "\u010C"),
        _Utils_Tuple2("ccaron", "\u010D"),
        _Utils_Tuple2("Ccedil", "\u00C7"),
        _Utils_Tuple2("ccedil", "\u00E7"),
        _Utils_Tuple2("Ccirc", "\u0108"),
        _Utils_Tuple2("ccirc", "\u0109"),
        _Utils_Tuple2("Cconint", "\u2230"),
        _Utils_Tuple2("ccups", "\u2A4C"),
        _Utils_Tuple2("ccupssm", "\u2A50"),
        _Utils_Tuple2("Cdot", "\u010A"),
        _Utils_Tuple2("cdot", "\u010B"),
        _Utils_Tuple2("cedil", "\u00B8"),
        _Utils_Tuple2("Cedilla", "\u00B8"),
        _Utils_Tuple2("cemptyv", "\u29B2"),
        _Utils_Tuple2("cent", "\u00A2"),
        _Utils_Tuple2("centerdot", "\u00B7"),
        _Utils_Tuple2("CenterDot", "\u00B7"),
        _Utils_Tuple2("cfr", "\uD835\uDD20"),
        _Utils_Tuple2("Cfr", "\u212D"),
        _Utils_Tuple2("CHcy", "\u0427"),
        _Utils_Tuple2("chcy", "\u0447"),
        _Utils_Tuple2("check", "\u2713"),
        _Utils_Tuple2("checkmark", "\u2713"),
        _Utils_Tuple2("Chi", "\u03A7"),
        _Utils_Tuple2("chi", "\u03C7"),
        _Utils_Tuple2("circ", "\u02C6"),
        _Utils_Tuple2("circeq", "\u2257"),
        _Utils_Tuple2("circlearrowleft", "\u21BA"),
        _Utils_Tuple2("circlearrowright", "\u21BB"),
        _Utils_Tuple2("circledast", "\u229B"),
        _Utils_Tuple2("circledcirc", "\u229A"),
        _Utils_Tuple2("circleddash", "\u229D"),
        _Utils_Tuple2("CircleDot", "\u2299"),
        _Utils_Tuple2("circledR", "\u00AE"),
        _Utils_Tuple2("circledS", "\u24C8"),
        _Utils_Tuple2("CircleMinus", "\u2296"),
        _Utils_Tuple2("CirclePlus", "\u2295"),
        _Utils_Tuple2("CircleTimes", "\u2297"),
        _Utils_Tuple2("cir", "\u25CB"),
        _Utils_Tuple2("cirE", "\u29C3"),
        _Utils_Tuple2("cire", "\u2257"),
        _Utils_Tuple2("cirfnint", "\u2A10"),
        _Utils_Tuple2("cirmid", "\u2AEF"),
        _Utils_Tuple2("cirscir", "\u29C2"),
        _Utils_Tuple2("ClockwiseContourIntegral", "\u2232"),
        _Utils_Tuple2("CloseCurlyDoubleQuote", "\u201D"),
        _Utils_Tuple2("CloseCurlyQuote", "\u2019"),
        _Utils_Tuple2("clubs", "\u2663"),
        _Utils_Tuple2("clubsuit", "\u2663"),
        _Utils_Tuple2("colon", ":"),
        _Utils_Tuple2("Colon", "\u2237"),
        _Utils_Tuple2("Colone", "\u2A74"),
        _Utils_Tuple2("colone", "\u2254"),
        _Utils_Tuple2("coloneq", "\u2254"),
        _Utils_Tuple2("comma", ","),
        _Utils_Tuple2("commat", "@"),
        _Utils_Tuple2("comp", "\u2201"),
        _Utils_Tuple2("compfn", "\u2218"),
        _Utils_Tuple2("complement", "\u2201"),
        _Utils_Tuple2("complexes", "\u2102"),
        _Utils_Tuple2("cong", "\u2245"),
        _Utils_Tuple2("congdot", "\u2A6D"),
        _Utils_Tuple2("Congruent", "\u2261"),
        _Utils_Tuple2("conint", "\u222E"),
        _Utils_Tuple2("Conint", "\u222F"),
        _Utils_Tuple2("ContourIntegral", "\u222E"),
        _Utils_Tuple2("copf", "\uD835\uDD54"),
        _Utils_Tuple2("Copf", "\u2102"),
        _Utils_Tuple2("coprod", "\u2210"),
        _Utils_Tuple2("Coproduct", "\u2210"),
        _Utils_Tuple2("copy", "\u00A9"),
        _Utils_Tuple2("COPY", "\u00A9"),
        _Utils_Tuple2("copysr", "\u2117"),
        _Utils_Tuple2("CounterClockwiseContourIntegral", "\u2233"),
        _Utils_Tuple2("crarr", "\u21B5"),
        _Utils_Tuple2("cross", "\u2717"),
        _Utils_Tuple2("Cross", "\u2A2F"),
        _Utils_Tuple2("Cscr", "\uD835\uDC9E"),
        _Utils_Tuple2("cscr", "\uD835\uDCB8"),
        _Utils_Tuple2("csub", "\u2ACF"),
        _Utils_Tuple2("csube", "\u2AD1"),
        _Utils_Tuple2("csup", "\u2AD0"),
        _Utils_Tuple2("csupe", "\u2AD2"),
        _Utils_Tuple2("ctdot", "\u22EF"),
        _Utils_Tuple2("cudarrl", "\u2938"),
        _Utils_Tuple2("cudarrr", "\u2935"),
        _Utils_Tuple2("cuepr", "\u22DE"),
        _Utils_Tuple2("cuesc", "\u22DF"),
        _Utils_Tuple2("cularr", "\u21B6"),
        _Utils_Tuple2("cularrp", "\u293D"),
        _Utils_Tuple2("cupbrcap", "\u2A48"),
        _Utils_Tuple2("cupcap", "\u2A46"),
        _Utils_Tuple2("CupCap", "\u224D"),
        _Utils_Tuple2("cup", "\u222A"),
        _Utils_Tuple2("Cup", "\u22D3"),
        _Utils_Tuple2("cupcup", "\u2A4A"),
        _Utils_Tuple2("cupdot", "\u228D"),
        _Utils_Tuple2("cupor", "\u2A45"),
        _Utils_Tuple2("cups", "\u222A\uFE00"),
        _Utils_Tuple2("curarr", "\u21B7"),
        _Utils_Tuple2("curarrm", "\u293C"),
        _Utils_Tuple2("curlyeqprec", "\u22DE"),
        _Utils_Tuple2("curlyeqsucc", "\u22DF"),
        _Utils_Tuple2("curlyvee", "\u22CE"),
        _Utils_Tuple2("curlywedge", "\u22CF"),
        _Utils_Tuple2("curren", "\u00A4"),
        _Utils_Tuple2("curvearrowleft", "\u21B6"),
        _Utils_Tuple2("curvearrowright", "\u21B7"),
        _Utils_Tuple2("cuvee", "\u22CE"),
        _Utils_Tuple2("cuwed", "\u22CF"),
        _Utils_Tuple2("cwconint", "\u2232"),
        _Utils_Tuple2("cwint", "\u2231"),
        _Utils_Tuple2("cylcty", "\u232D"),
        _Utils_Tuple2("dagger", "\u2020"),
        _Utils_Tuple2("Dagger", "\u2021"),
        _Utils_Tuple2("daleth", "\u2138"),
        _Utils_Tuple2("darr", "\u2193"),
        _Utils_Tuple2("Darr", "\u21A1"),
        _Utils_Tuple2("dArr", "\u21D3"),
        _Utils_Tuple2("dash", "\u2010"),
        _Utils_Tuple2("Dashv", "\u2AE4"),
        _Utils_Tuple2("dashv", "\u22A3"),
        _Utils_Tuple2("dbkarow", "\u290F"),
        _Utils_Tuple2("dblac", "\u02DD"),
        _Utils_Tuple2("Dcaron", "\u010E"),
        _Utils_Tuple2("dcaron", "\u010F"),
        _Utils_Tuple2("Dcy", "\u0414"),
        _Utils_Tuple2("dcy", "\u0434"),
        _Utils_Tuple2("ddagger", "\u2021"),
        _Utils_Tuple2("ddarr", "\u21CA"),
        _Utils_Tuple2("DD", "\u2145"),
        _Utils_Tuple2("dd", "\u2146"),
        _Utils_Tuple2("DDotrahd", "\u2911"),
        _Utils_Tuple2("ddotseq", "\u2A77"),
        _Utils_Tuple2("deg", "\u00B0"),
        _Utils_Tuple2("Del", "\u2207"),
        _Utils_Tuple2("Delta", "\u0394"),
        _Utils_Tuple2("delta", "\u03B4"),
        _Utils_Tuple2("demptyv", "\u29B1"),
        _Utils_Tuple2("dfisht", "\u297F"),
        _Utils_Tuple2("Dfr", "\uD835\uDD07"),
        _Utils_Tuple2("dfr", "\uD835\uDD21"),
        _Utils_Tuple2("dHar", "\u2965"),
        _Utils_Tuple2("dharl", "\u21C3"),
        _Utils_Tuple2("dharr", "\u21C2"),
        _Utils_Tuple2("DiacriticalAcute", "\u00B4"),
        _Utils_Tuple2("DiacriticalDot", "\u02D9"),
        _Utils_Tuple2("DiacriticalDoubleAcute", "\u02DD"),
        _Utils_Tuple2("DiacriticalGrave", "`"),
        _Utils_Tuple2("DiacriticalTilde", "\u02DC"),
        _Utils_Tuple2("diam", "\u22C4"),
        _Utils_Tuple2("diamond", "\u22C4"),
        _Utils_Tuple2("Diamond", "\u22C4"),
        _Utils_Tuple2("diamondsuit", "\u2666"),
        _Utils_Tuple2("diams", "\u2666"),
        _Utils_Tuple2("die", "\u00A8"),
        _Utils_Tuple2("DifferentialD", "\u2146"),
        _Utils_Tuple2("digamma", "\u03DD"),
        _Utils_Tuple2("disin", "\u22F2"),
        _Utils_Tuple2("div", "\u00F7"),
        _Utils_Tuple2("divide", "\u00F7"),
        _Utils_Tuple2("divideontimes", "\u22C7"),
        _Utils_Tuple2("divonx", "\u22C7"),
        _Utils_Tuple2("DJcy", "\u0402"),
        _Utils_Tuple2("djcy", "\u0452"),
        _Utils_Tuple2("dlcorn", "\u231E"),
        _Utils_Tuple2("dlcrop", "\u230D"),
        _Utils_Tuple2("dollar", "$"),
        _Utils_Tuple2("Dopf", "\uD835\uDD3B"),
        _Utils_Tuple2("dopf", "\uD835\uDD55"),
        _Utils_Tuple2("Dot", "\u00A8"),
        _Utils_Tuple2("dot", "\u02D9"),
        _Utils_Tuple2("DotDot", "\u20DC"),
        _Utils_Tuple2("doteq", "\u2250"),
        _Utils_Tuple2("doteqdot", "\u2251"),
        _Utils_Tuple2("DotEqual", "\u2250"),
        _Utils_Tuple2("dotminus", "\u2238"),
        _Utils_Tuple2("dotplus", "\u2214"),
        _Utils_Tuple2("dotsquare", "\u22A1"),
        _Utils_Tuple2("doublebarwedge", "\u2306"),
        _Utils_Tuple2("DoubleContourIntegral", "\u222F"),
        _Utils_Tuple2("DoubleDot", "\u00A8"),
        _Utils_Tuple2("DoubleDownArrow", "\u21D3"),
        _Utils_Tuple2("DoubleLeftArrow", "\u21D0"),
        _Utils_Tuple2("DoubleLeftRightArrow", "\u21D4"),
        _Utils_Tuple2("DoubleLeftTee", "\u2AE4"),
        _Utils_Tuple2("DoubleLongLeftArrow", "\u27F8"),
        _Utils_Tuple2("DoubleLongLeftRightArrow", "\u27FA"),
        _Utils_Tuple2("DoubleLongRightArrow", "\u27F9"),
        _Utils_Tuple2("DoubleRightArrow", "\u21D2"),
        _Utils_Tuple2("DoubleRightTee", "\u22A8"),
        _Utils_Tuple2("DoubleUpArrow", "\u21D1"),
        _Utils_Tuple2("DoubleUpDownArrow", "\u21D5"),
        _Utils_Tuple2("DoubleVerticalBar", "\u2225"),
        _Utils_Tuple2("DownArrowBar", "\u2913"),
        _Utils_Tuple2("downarrow", "\u2193"),
        _Utils_Tuple2("DownArrow", "\u2193"),
        _Utils_Tuple2("Downarrow", "\u21D3"),
        _Utils_Tuple2("DownArrowUpArrow", "\u21F5"),
        _Utils_Tuple2("DownBreve", "\u0311"),
        _Utils_Tuple2("downdownarrows", "\u21CA"),
        _Utils_Tuple2("downharpoonleft", "\u21C3"),
        _Utils_Tuple2("downharpoonright", "\u21C2"),
        _Utils_Tuple2("DownLeftRightVector", "\u2950"),
        _Utils_Tuple2("DownLeftTeeVector", "\u295E"),
        _Utils_Tuple2("DownLeftVectorBar", "\u2956"),
        _Utils_Tuple2("DownLeftVector", "\u21BD"),
        _Utils_Tuple2("DownRightTeeVector", "\u295F"),
        _Utils_Tuple2("DownRightVectorBar", "\u2957"),
        _Utils_Tuple2("DownRightVector", "\u21C1"),
        _Utils_Tuple2("DownTeeArrow", "\u21A7"),
        _Utils_Tuple2("DownTee", "\u22A4"),
        _Utils_Tuple2("drbkarow", "\u2910"),
        _Utils_Tuple2("drcorn", "\u231F"),
        _Utils_Tuple2("drcrop", "\u230C"),
        _Utils_Tuple2("Dscr", "\uD835\uDC9F"),
        _Utils_Tuple2("dscr", "\uD835\uDCB9"),
        _Utils_Tuple2("DScy", "\u0405"),
        _Utils_Tuple2("dscy", "\u0455"),
        _Utils_Tuple2("dsol", "\u29F6"),
        _Utils_Tuple2("Dstrok", "\u0110"),
        _Utils_Tuple2("dstrok", "\u0111"),
        _Utils_Tuple2("dtdot", "\u22F1"),
        _Utils_Tuple2("dtri", "\u25BF"),
        _Utils_Tuple2("dtrif", "\u25BE"),
        _Utils_Tuple2("duarr", "\u21F5"),
        _Utils_Tuple2("duhar", "\u296F"),
        _Utils_Tuple2("dwangle", "\u29A6"),
        _Utils_Tuple2("DZcy", "\u040F"),
        _Utils_Tuple2("dzcy", "\u045F"),
        _Utils_Tuple2("dzigrarr", "\u27FF"),
        _Utils_Tuple2("Eacute", "\u00C9"),
        _Utils_Tuple2("eacute", "\u00E9"),
        _Utils_Tuple2("easter", "\u2A6E"),
        _Utils_Tuple2("Ecaron", "\u011A"),
        _Utils_Tuple2("ecaron", "\u011B"),
        _Utils_Tuple2("Ecirc", "\u00CA"),
        _Utils_Tuple2("ecirc", "\u00EA"),
        _Utils_Tuple2("ecir", "\u2256"),
        _Utils_Tuple2("ecolon", "\u2255"),
        _Utils_Tuple2("Ecy", "\u042D"),
        _Utils_Tuple2("ecy", "\u044D"),
        _Utils_Tuple2("eDDot", "\u2A77"),
        _Utils_Tuple2("Edot", "\u0116"),
        _Utils_Tuple2("edot", "\u0117"),
        _Utils_Tuple2("eDot", "\u2251"),
        _Utils_Tuple2("ee", "\u2147"),
        _Utils_Tuple2("efDot", "\u2252"),
        _Utils_Tuple2("Efr", "\uD835\uDD08"),
        _Utils_Tuple2("efr", "\uD835\uDD22"),
        _Utils_Tuple2("eg", "\u2A9A"),
        _Utils_Tuple2("Egrave", "\u00C8"),
        _Utils_Tuple2("egrave", "\u00E8"),
        _Utils_Tuple2("egs", "\u2A96"),
        _Utils_Tuple2("egsdot", "\u2A98"),
        _Utils_Tuple2("el", "\u2A99"),
        _Utils_Tuple2("Element", "\u2208"),
        _Utils_Tuple2("elinters", "\u23E7"),
        _Utils_Tuple2("ell", "\u2113"),
        _Utils_Tuple2("els", "\u2A95"),
        _Utils_Tuple2("elsdot", "\u2A97"),
        _Utils_Tuple2("Emacr", "\u0112"),
        _Utils_Tuple2("emacr", "\u0113"),
        _Utils_Tuple2("empty", "\u2205"),
        _Utils_Tuple2("emptyset", "\u2205"),
        _Utils_Tuple2("EmptySmallSquare", "\u25FB"),
        _Utils_Tuple2("emptyv", "\u2205"),
        _Utils_Tuple2("EmptyVerySmallSquare", "\u25AB"),
        _Utils_Tuple2("emsp13", "\u2004"),
        _Utils_Tuple2("emsp14", "\u2005"),
        _Utils_Tuple2("emsp", "\u2003"),
        _Utils_Tuple2("ENG", "\u014A"),
        _Utils_Tuple2("eng", "\u014B"),
        _Utils_Tuple2("ensp", "\u2002"),
        _Utils_Tuple2("Eogon", "\u0118"),
        _Utils_Tuple2("eogon", "\u0119"),
        _Utils_Tuple2("Eopf", "\uD835\uDD3C"),
        _Utils_Tuple2("eopf", "\uD835\uDD56"),
        _Utils_Tuple2("epar", "\u22D5"),
        _Utils_Tuple2("eparsl", "\u29E3"),
        _Utils_Tuple2("eplus", "\u2A71"),
        _Utils_Tuple2("epsi", "\u03B5"),
        _Utils_Tuple2("Epsilon", "\u0395"),
        _Utils_Tuple2("epsilon", "\u03B5"),
        _Utils_Tuple2("epsiv", "\u03F5"),
        _Utils_Tuple2("eqcirc", "\u2256"),
        _Utils_Tuple2("eqcolon", "\u2255"),
        _Utils_Tuple2("eqsim", "\u2242"),
        _Utils_Tuple2("eqslantgtr", "\u2A96"),
        _Utils_Tuple2("eqslantless", "\u2A95"),
        _Utils_Tuple2("Equal", "\u2A75"),
        _Utils_Tuple2("equals", "="),
        _Utils_Tuple2("EqualTilde", "\u2242"),
        _Utils_Tuple2("equest", "\u225F"),
        _Utils_Tuple2("Equilibrium", "\u21CC"),
        _Utils_Tuple2("equiv", "\u2261"),
        _Utils_Tuple2("equivDD", "\u2A78"),
        _Utils_Tuple2("eqvparsl", "\u29E5"),
        _Utils_Tuple2("erarr", "\u2971"),
        _Utils_Tuple2("erDot", "\u2253"),
        _Utils_Tuple2("escr", "\u212F"),
        _Utils_Tuple2("Escr", "\u2130"),
        _Utils_Tuple2("esdot", "\u2250"),
        _Utils_Tuple2("Esim", "\u2A73"),
        _Utils_Tuple2("esim", "\u2242"),
        _Utils_Tuple2("Eta", "\u0397"),
        _Utils_Tuple2("eta", "\u03B7"),
        _Utils_Tuple2("ETH", "\u00D0"),
        _Utils_Tuple2("eth", "\u00F0"),
        _Utils_Tuple2("Euml", "\u00CB"),
        _Utils_Tuple2("euml", "\u00EB"),
        _Utils_Tuple2("euro", "\u20AC"),
        _Utils_Tuple2("excl", "!"),
        _Utils_Tuple2("exist", "\u2203"),
        _Utils_Tuple2("Exists", "\u2203"),
        _Utils_Tuple2("expectation", "\u2130"),
        _Utils_Tuple2("exponentiale", "\u2147"),
        _Utils_Tuple2("ExponentialE", "\u2147"),
        _Utils_Tuple2("fallingdotseq", "\u2252"),
        _Utils_Tuple2("Fcy", "\u0424"),
        _Utils_Tuple2("fcy", "\u0444"),
        _Utils_Tuple2("female", "\u2640"),
        _Utils_Tuple2("ffilig", "\uFB03"),
        _Utils_Tuple2("fflig", "\uFB00"),
        _Utils_Tuple2("ffllig", "\uFB04"),
        _Utils_Tuple2("Ffr", "\uD835\uDD09"),
        _Utils_Tuple2("ffr", "\uD835\uDD23"),
        _Utils_Tuple2("filig", "\uFB01"),
        _Utils_Tuple2("FilledSmallSquare", "\u25FC"),
        _Utils_Tuple2("FilledVerySmallSquare", "\u25AA"),
        _Utils_Tuple2("fjlig", "fj"),
        _Utils_Tuple2("flat", "\u266D"),
        _Utils_Tuple2("fllig", "\uFB02"),
        _Utils_Tuple2("fltns", "\u25B1"),
        _Utils_Tuple2("fnof", "\u0192"),
        _Utils_Tuple2("Fopf", "\uD835\uDD3D"),
        _Utils_Tuple2("fopf", "\uD835\uDD57"),
        _Utils_Tuple2("forall", "\u2200"),
        _Utils_Tuple2("ForAll", "\u2200"),
        _Utils_Tuple2("fork", "\u22D4"),
        _Utils_Tuple2("forkv", "\u2AD9"),
        _Utils_Tuple2("Fouriertrf", "\u2131"),
        _Utils_Tuple2("fpartint", "\u2A0D"),
        _Utils_Tuple2("frac12", "\u00BD"),
        _Utils_Tuple2("frac13", "\u2153"),
        _Utils_Tuple2("frac14", "\u00BC"),
        _Utils_Tuple2("frac15", "\u2155"),
        _Utils_Tuple2("frac16", "\u2159"),
        _Utils_Tuple2("frac18", "\u215B"),
        _Utils_Tuple2("frac23", "\u2154"),
        _Utils_Tuple2("frac25", "\u2156"),
        _Utils_Tuple2("frac34", "\u00BE"),
        _Utils_Tuple2("frac35", "\u2157"),
        _Utils_Tuple2("frac38", "\u215C"),
        _Utils_Tuple2("frac45", "\u2158"),
        _Utils_Tuple2("frac56", "\u215A"),
        _Utils_Tuple2("frac58", "\u215D"),
        _Utils_Tuple2("frac78", "\u215E"),
        _Utils_Tuple2("frasl", "\u2044"),
        _Utils_Tuple2("frown", "\u2322"),
        _Utils_Tuple2("fscr", "\uD835\uDCBB"),
        _Utils_Tuple2("Fscr", "\u2131"),
        _Utils_Tuple2("gacute", "\u01F5"),
        _Utils_Tuple2("Gamma", "\u0393"),
        _Utils_Tuple2("gamma", "\u03B3"),
        _Utils_Tuple2("Gammad", "\u03DC"),
        _Utils_Tuple2("gammad", "\u03DD"),
        _Utils_Tuple2("gap", "\u2A86"),
        _Utils_Tuple2("Gbreve", "\u011E"),
        _Utils_Tuple2("gbreve", "\u011F"),
        _Utils_Tuple2("Gcedil", "\u0122"),
        _Utils_Tuple2("Gcirc", "\u011C"),
        _Utils_Tuple2("gcirc", "\u011D"),
        _Utils_Tuple2("Gcy", "\u0413"),
        _Utils_Tuple2("gcy", "\u0433"),
        _Utils_Tuple2("Gdot", "\u0120"),
        _Utils_Tuple2("gdot", "\u0121"),
        _Utils_Tuple2("ge", "\u2265"),
        _Utils_Tuple2("gE", "\u2267"),
        _Utils_Tuple2("gEl", "\u2A8C"),
        _Utils_Tuple2("gel", "\u22DB"),
        _Utils_Tuple2("geq", "\u2265"),
        _Utils_Tuple2("geqq", "\u2267"),
        _Utils_Tuple2("geqslant", "\u2A7E"),
        _Utils_Tuple2("gescc", "\u2AA9"),
        _Utils_Tuple2("ges", "\u2A7E"),
        _Utils_Tuple2("gesdot", "\u2A80"),
        _Utils_Tuple2("gesdoto", "\u2A82"),
        _Utils_Tuple2("gesdotol", "\u2A84"),
        _Utils_Tuple2("gesl", "\u22DB\uFE00"),
        _Utils_Tuple2("gesles", "\u2A94"),
        _Utils_Tuple2("Gfr", "\uD835\uDD0A"),
        _Utils_Tuple2("gfr", "\uD835\uDD24"),
        _Utils_Tuple2("gg", "\u226B"),
        _Utils_Tuple2("Gg", "\u22D9"),
        _Utils_Tuple2("ggg", "\u22D9"),
        _Utils_Tuple2("gimel", "\u2137"),
        _Utils_Tuple2("GJcy", "\u0403"),
        _Utils_Tuple2("gjcy", "\u0453"),
        _Utils_Tuple2("gla", "\u2AA5"),
        _Utils_Tuple2("gl", "\u2277"),
        _Utils_Tuple2("glE", "\u2A92"),
        _Utils_Tuple2("glj", "\u2AA4"),
        _Utils_Tuple2("gnap", "\u2A8A"),
        _Utils_Tuple2("gnapprox", "\u2A8A"),
        _Utils_Tuple2("gne", "\u2A88"),
        _Utils_Tuple2("gnE", "\u2269"),
        _Utils_Tuple2("gneq", "\u2A88"),
        _Utils_Tuple2("gneqq", "\u2269"),
        _Utils_Tuple2("gnsim", "\u22E7"),
        _Utils_Tuple2("Gopf", "\uD835\uDD3E"),
        _Utils_Tuple2("gopf", "\uD835\uDD58"),
        _Utils_Tuple2("grave", "`"),
        _Utils_Tuple2("GreaterEqual", "\u2265"),
        _Utils_Tuple2("GreaterEqualLess", "\u22DB"),
        _Utils_Tuple2("GreaterFullEqual", "\u2267"),
        _Utils_Tuple2("GreaterGreater", "\u2AA2"),
        _Utils_Tuple2("GreaterLess", "\u2277"),
        _Utils_Tuple2("GreaterSlantEqual", "\u2A7E"),
        _Utils_Tuple2("GreaterTilde", "\u2273"),
        _Utils_Tuple2("Gscr", "\uD835\uDCA2"),
        _Utils_Tuple2("gscr", "\u210A"),
        _Utils_Tuple2("gsim", "\u2273"),
        _Utils_Tuple2("gsime", "\u2A8E"),
        _Utils_Tuple2("gsiml", "\u2A90"),
        _Utils_Tuple2("gtcc", "\u2AA7"),
        _Utils_Tuple2("gtcir", "\u2A7A"),
        _Utils_Tuple2("gt", ">"),
        _Utils_Tuple2("GT", ">"),
        _Utils_Tuple2("Gt", "\u226B"),
        _Utils_Tuple2("gtdot", "\u22D7"),
        _Utils_Tuple2("gtlPar", "\u2995"),
        _Utils_Tuple2("gtquest", "\u2A7C"),
        _Utils_Tuple2("gtrapprox", "\u2A86"),
        _Utils_Tuple2("gtrarr", "\u2978"),
        _Utils_Tuple2("gtrdot", "\u22D7"),
        _Utils_Tuple2("gtreqless", "\u22DB"),
        _Utils_Tuple2("gtreqqless", "\u2A8C"),
        _Utils_Tuple2("gtrless", "\u2277"),
        _Utils_Tuple2("gtrsim", "\u2273"),
        _Utils_Tuple2("gvertneqq", "\u2269\uFE00"),
        _Utils_Tuple2("gvnE", "\u2269\uFE00"),
        _Utils_Tuple2("Hacek", "\u02C7"),
        _Utils_Tuple2("hairsp", "\u200A"),
        _Utils_Tuple2("half", "\u00BD"),
        _Utils_Tuple2("hamilt", "\u210B"),
        _Utils_Tuple2("HARDcy", "\u042A"),
        _Utils_Tuple2("hardcy", "\u044A"),
        _Utils_Tuple2("harrcir", "\u2948"),
        _Utils_Tuple2("harr", "\u2194"),
        _Utils_Tuple2("hArr", "\u21D4"),
        _Utils_Tuple2("harrw", "\u21AD"),
        _Utils_Tuple2("Hat", "^"),
        _Utils_Tuple2("hbar", "\u210F"),
        _Utils_Tuple2("Hcirc", "\u0124"),
        _Utils_Tuple2("hcirc", "\u0125"),
        _Utils_Tuple2("hearts", "\u2665"),
        _Utils_Tuple2("heartsuit", "\u2665"),
        _Utils_Tuple2("hellip", "\u2026"),
        _Utils_Tuple2("hercon", "\u22B9"),
        _Utils_Tuple2("hfr", "\uD835\uDD25"),
        _Utils_Tuple2("Hfr", "\u210C"),
        _Utils_Tuple2("HilbertSpace", "\u210B"),
        _Utils_Tuple2("hksearow", "\u2925"),
        _Utils_Tuple2("hkswarow", "\u2926"),
        _Utils_Tuple2("hoarr", "\u21FF"),
        _Utils_Tuple2("homtht", "\u223B"),
        _Utils_Tuple2("hookleftarrow", "\u21A9"),
        _Utils_Tuple2("hookrightarrow", "\u21AA"),
        _Utils_Tuple2("hopf", "\uD835\uDD59"),
        _Utils_Tuple2("Hopf", "\u210D"),
        _Utils_Tuple2("horbar", "\u2015"),
        _Utils_Tuple2("HorizontalLine", "\u2500"),
        _Utils_Tuple2("hscr", "\uD835\uDCBD"),
        _Utils_Tuple2("Hscr", "\u210B"),
        _Utils_Tuple2("hslash", "\u210F"),
        _Utils_Tuple2("Hstrok", "\u0126"),
        _Utils_Tuple2("hstrok", "\u0127"),
        _Utils_Tuple2("HumpDownHump", "\u224E"),
        _Utils_Tuple2("HumpEqual", "\u224F"),
        _Utils_Tuple2("hybull", "\u2043"),
        _Utils_Tuple2("hyphen", "\u2010"),
        _Utils_Tuple2("Iacute", "\u00CD"),
        _Utils_Tuple2("iacute", "\u00ED"),
        _Utils_Tuple2("ic", "\u2063"),
        _Utils_Tuple2("Icirc", "\u00CE"),
        _Utils_Tuple2("icirc", "\u00EE"),
        _Utils_Tuple2("Icy", "\u0418"),
        _Utils_Tuple2("icy", "\u0438"),
        _Utils_Tuple2("Idot", "\u0130"),
        _Utils_Tuple2("IEcy", "\u0415"),
        _Utils_Tuple2("iecy", "\u0435"),
        _Utils_Tuple2("iexcl", "\u00A1"),
        _Utils_Tuple2("iff", "\u21D4"),
        _Utils_Tuple2("ifr", "\uD835\uDD26"),
        _Utils_Tuple2("Ifr", "\u2111"),
        _Utils_Tuple2("Igrave", "\u00CC"),
        _Utils_Tuple2("igrave", "\u00EC"),
        _Utils_Tuple2("ii", "\u2148"),
        _Utils_Tuple2("iiiint", "\u2A0C"),
        _Utils_Tuple2("iiint", "\u222D"),
        _Utils_Tuple2("iinfin", "\u29DC"),
        _Utils_Tuple2("iiota", "\u2129"),
        _Utils_Tuple2("IJlig", "\u0132"),
        _Utils_Tuple2("ijlig", "\u0133"),
        _Utils_Tuple2("Imacr", "\u012A"),
        _Utils_Tuple2("imacr", "\u012B"),
        _Utils_Tuple2("image", "\u2111"),
        _Utils_Tuple2("ImaginaryI", "\u2148"),
        _Utils_Tuple2("imagline", "\u2110"),
        _Utils_Tuple2("imagpart", "\u2111"),
        _Utils_Tuple2("imath", "\u0131"),
        _Utils_Tuple2("Im", "\u2111"),
        _Utils_Tuple2("imof", "\u22B7"),
        _Utils_Tuple2("imped", "\u01B5"),
        _Utils_Tuple2("Implies", "\u21D2"),
        _Utils_Tuple2("incare", "\u2105"),
        _Utils_Tuple2("in", "\u2208"),
        _Utils_Tuple2("infin", "\u221E"),
        _Utils_Tuple2("infintie", "\u29DD"),
        _Utils_Tuple2("inodot", "\u0131"),
        _Utils_Tuple2("intcal", "\u22BA"),
        _Utils_Tuple2("int", "\u222B"),
        _Utils_Tuple2("Int", "\u222C"),
        _Utils_Tuple2("integers", "\u2124"),
        _Utils_Tuple2("Integral", "\u222B"),
        _Utils_Tuple2("intercal", "\u22BA"),
        _Utils_Tuple2("Intersection", "\u22C2"),
        _Utils_Tuple2("intlarhk", "\u2A17"),
        _Utils_Tuple2("intprod", "\u2A3C"),
        _Utils_Tuple2("InvisibleComma", "\u2063"),
        _Utils_Tuple2("InvisibleTimes", "\u2062"),
        _Utils_Tuple2("IOcy", "\u0401"),
        _Utils_Tuple2("iocy", "\u0451"),
        _Utils_Tuple2("Iogon", "\u012E"),
        _Utils_Tuple2("iogon", "\u012F"),
        _Utils_Tuple2("Iopf", "\uD835\uDD40"),
        _Utils_Tuple2("iopf", "\uD835\uDD5A"),
        _Utils_Tuple2("Iota", "\u0399"),
        _Utils_Tuple2("iota", "\u03B9"),
        _Utils_Tuple2("iprod", "\u2A3C"),
        _Utils_Tuple2("iquest", "\u00BF"),
        _Utils_Tuple2("iscr", "\uD835\uDCBE"),
        _Utils_Tuple2("Iscr", "\u2110"),
        _Utils_Tuple2("isin", "\u2208"),
        _Utils_Tuple2("isindot", "\u22F5"),
        _Utils_Tuple2("isinE", "\u22F9"),
        _Utils_Tuple2("isins", "\u22F4"),
        _Utils_Tuple2("isinsv", "\u22F3"),
        _Utils_Tuple2("isinv", "\u2208"),
        _Utils_Tuple2("it", "\u2062"),
        _Utils_Tuple2("Itilde", "\u0128"),
        _Utils_Tuple2("itilde", "\u0129"),
        _Utils_Tuple2("Iukcy", "\u0406"),
        _Utils_Tuple2("iukcy", "\u0456"),
        _Utils_Tuple2("Iuml", "\u00CF"),
        _Utils_Tuple2("iuml", "\u00EF"),
        _Utils_Tuple2("Jcirc", "\u0134"),
        _Utils_Tuple2("jcirc", "\u0135"),
        _Utils_Tuple2("Jcy", "\u0419"),
        _Utils_Tuple2("jcy", "\u0439"),
        _Utils_Tuple2("Jfr", "\uD835\uDD0D"),
        _Utils_Tuple2("jfr", "\uD835\uDD27"),
        _Utils_Tuple2("jmath", "\u0237"),
        _Utils_Tuple2("Jopf", "\uD835\uDD41"),
        _Utils_Tuple2("jopf", "\uD835\uDD5B"),
        _Utils_Tuple2("Jscr", "\uD835\uDCA5"),
        _Utils_Tuple2("jscr", "\uD835\uDCBF"),
        _Utils_Tuple2("Jsercy", "\u0408"),
        _Utils_Tuple2("jsercy", "\u0458"),
        _Utils_Tuple2("Jukcy", "\u0404"),
        _Utils_Tuple2("jukcy", "\u0454"),
        _Utils_Tuple2("Kappa", "\u039A"),
        _Utils_Tuple2("kappa", "\u03BA"),
        _Utils_Tuple2("kappav", "\u03F0"),
        _Utils_Tuple2("Kcedil", "\u0136"),
        _Utils_Tuple2("kcedil", "\u0137"),
        _Utils_Tuple2("Kcy", "\u041A"),
        _Utils_Tuple2("kcy", "\u043A"),
        _Utils_Tuple2("Kfr", "\uD835\uDD0E"),
        _Utils_Tuple2("kfr", "\uD835\uDD28"),
        _Utils_Tuple2("kgreen", "\u0138"),
        _Utils_Tuple2("KHcy", "\u0425"),
        _Utils_Tuple2("khcy", "\u0445"),
        _Utils_Tuple2("KJcy", "\u040C"),
        _Utils_Tuple2("kjcy", "\u045C"),
        _Utils_Tuple2("Kopf", "\uD835\uDD42"),
        _Utils_Tuple2("kopf", "\uD835\uDD5C"),
        _Utils_Tuple2("Kscr", "\uD835\uDCA6"),
        _Utils_Tuple2("kscr", "\uD835\uDCC0"),
        _Utils_Tuple2("lAarr", "\u21DA"),
        _Utils_Tuple2("Lacute", "\u0139"),
        _Utils_Tuple2("lacute", "\u013A"),
        _Utils_Tuple2("laemptyv", "\u29B4"),
        _Utils_Tuple2("lagran", "\u2112"),
        _Utils_Tuple2("Lambda", "\u039B"),
        _Utils_Tuple2("lambda", "\u03BB"),
        _Utils_Tuple2("lang", "\u27E8"),
        _Utils_Tuple2("Lang", "\u27EA"),
        _Utils_Tuple2("langd", "\u2991"),
        _Utils_Tuple2("langle", "\u27E8"),
        _Utils_Tuple2("lap", "\u2A85"),
        _Utils_Tuple2("Laplacetrf", "\u2112"),
        _Utils_Tuple2("laquo", "\u00AB"),
        _Utils_Tuple2("larrb", "\u21E4"),
        _Utils_Tuple2("larrbfs", "\u291F"),
        _Utils_Tuple2("larr", "\u2190"),
        _Utils_Tuple2("Larr", "\u219E"),
        _Utils_Tuple2("lArr", "\u21D0"),
        _Utils_Tuple2("larrfs", "\u291D"),
        _Utils_Tuple2("larrhk", "\u21A9"),
        _Utils_Tuple2("larrlp", "\u21AB"),
        _Utils_Tuple2("larrpl", "\u2939"),
        _Utils_Tuple2("larrsim", "\u2973"),
        _Utils_Tuple2("larrtl", "\u21A2"),
        _Utils_Tuple2("latail", "\u2919"),
        _Utils_Tuple2("lAtail", "\u291B"),
        _Utils_Tuple2("lat", "\u2AAB"),
        _Utils_Tuple2("late", "\u2AAD"),
        _Utils_Tuple2("lates", "\u2AAD\uFE00"),
        _Utils_Tuple2("lbarr", "\u290C"),
        _Utils_Tuple2("lBarr", "\u290E"),
        _Utils_Tuple2("lbbrk", "\u2772"),
        _Utils_Tuple2("lbrace", "{"),
        _Utils_Tuple2("lbrack", "["),
        _Utils_Tuple2("lbrke", "\u298B"),
        _Utils_Tuple2("lbrksld", "\u298F"),
        _Utils_Tuple2("lbrkslu", "\u298D"),
        _Utils_Tuple2("Lcaron", "\u013D"),
        _Utils_Tuple2("lcaron", "\u013E"),
        _Utils_Tuple2("Lcedil", "\u013B"),
        _Utils_Tuple2("lcedil", "\u013C"),
        _Utils_Tuple2("lceil", "\u2308"),
        _Utils_Tuple2("lcub", "{"),
        _Utils_Tuple2("Lcy", "\u041B"),
        _Utils_Tuple2("lcy", "\u043B"),
        _Utils_Tuple2("ldca", "\u2936"),
        _Utils_Tuple2("ldquo", "\u201C"),
        _Utils_Tuple2("ldquor", "\u201E"),
        _Utils_Tuple2("ldrdhar", "\u2967"),
        _Utils_Tuple2("ldrushar", "\u294B"),
        _Utils_Tuple2("ldsh", "\u21B2"),
        _Utils_Tuple2("le", "\u2264"),
        _Utils_Tuple2("lE", "\u2266"),
        _Utils_Tuple2("LeftAngleBracket", "\u27E8"),
        _Utils_Tuple2("LeftArrowBar", "\u21E4"),
        _Utils_Tuple2("leftarrow", "\u2190"),
        _Utils_Tuple2("LeftArrow", "\u2190"),
        _Utils_Tuple2("Leftarrow", "\u21D0"),
        _Utils_Tuple2("LeftArrowRightArrow", "\u21C6"),
        _Utils_Tuple2("leftarrowtail", "\u21A2"),
        _Utils_Tuple2("LeftCeiling", "\u2308"),
        _Utils_Tuple2("LeftDoubleBracket", "\u27E6"),
        _Utils_Tuple2("LeftDownTeeVector", "\u2961"),
        _Utils_Tuple2("LeftDownVectorBar", "\u2959"),
        _Utils_Tuple2("LeftDownVector", "\u21C3"),
        _Utils_Tuple2("LeftFloor", "\u230A"),
        _Utils_Tuple2("leftharpoondown", "\u21BD"),
        _Utils_Tuple2("leftharpoonup", "\u21BC"),
        _Utils_Tuple2("leftleftarrows", "\u21C7"),
        _Utils_Tuple2("leftrightarrow", "\u2194"),
        _Utils_Tuple2("LeftRightArrow", "\u2194"),
        _Utils_Tuple2("Leftrightarrow", "\u21D4"),
        _Utils_Tuple2("leftrightarrows", "\u21C6"),
        _Utils_Tuple2("leftrightharpoons", "\u21CB"),
        _Utils_Tuple2("leftrightsquigarrow", "\u21AD"),
        _Utils_Tuple2("LeftRightVector", "\u294E"),
        _Utils_Tuple2("LeftTeeArrow", "\u21A4"),
        _Utils_Tuple2("LeftTee", "\u22A3"),
        _Utils_Tuple2("LeftTeeVector", "\u295A"),
        _Utils_Tuple2("leftthreetimes", "\u22CB"),
        _Utils_Tuple2("LeftTriangleBar", "\u29CF"),
        _Utils_Tuple2("LeftTriangle", "\u22B2"),
        _Utils_Tuple2("LeftTriangleEqual", "\u22B4"),
        _Utils_Tuple2("LeftUpDownVector", "\u2951"),
        _Utils_Tuple2("LeftUpTeeVector", "\u2960"),
        _Utils_Tuple2("LeftUpVectorBar", "\u2958"),
        _Utils_Tuple2("LeftUpVector", "\u21BF"),
        _Utils_Tuple2("LeftVectorBar", "\u2952"),
        _Utils_Tuple2("LeftVector", "\u21BC"),
        _Utils_Tuple2("lEg", "\u2A8B"),
        _Utils_Tuple2("leg", "\u22DA"),
        _Utils_Tuple2("leq", "\u2264"),
        _Utils_Tuple2("leqq", "\u2266"),
        _Utils_Tuple2("leqslant", "\u2A7D"),
        _Utils_Tuple2("lescc", "\u2AA8"),
        _Utils_Tuple2("les", "\u2A7D"),
        _Utils_Tuple2("lesdot", "\u2A7F"),
        _Utils_Tuple2("lesdoto", "\u2A81"),
        _Utils_Tuple2("lesdotor", "\u2A83"),
        _Utils_Tuple2("lesg", "\u22DA\uFE00"),
        _Utils_Tuple2("lesges", "\u2A93"),
        _Utils_Tuple2("lessapprox", "\u2A85"),
        _Utils_Tuple2("lessdot", "\u22D6"),
        _Utils_Tuple2("lesseqgtr", "\u22DA"),
        _Utils_Tuple2("lesseqqgtr", "\u2A8B"),
        _Utils_Tuple2("LessEqualGreater", "\u22DA"),
        _Utils_Tuple2("LessFullEqual", "\u2266"),
        _Utils_Tuple2("LessGreater", "\u2276"),
        _Utils_Tuple2("lessgtr", "\u2276"),
        _Utils_Tuple2("LessLess", "\u2AA1"),
        _Utils_Tuple2("lesssim", "\u2272"),
        _Utils_Tuple2("LessSlantEqual", "\u2A7D"),
        _Utils_Tuple2("LessTilde", "\u2272"),
        _Utils_Tuple2("lfisht", "\u297C"),
        _Utils_Tuple2("lfloor", "\u230A"),
        _Utils_Tuple2("Lfr", "\uD835\uDD0F"),
        _Utils_Tuple2("lfr", "\uD835\uDD29"),
        _Utils_Tuple2("lg", "\u2276"),
        _Utils_Tuple2("lgE", "\u2A91"),
        _Utils_Tuple2("lHar", "\u2962"),
        _Utils_Tuple2("lhard", "\u21BD"),
        _Utils_Tuple2("lharu", "\u21BC"),
        _Utils_Tuple2("lharul", "\u296A"),
        _Utils_Tuple2("lhblk", "\u2584"),
        _Utils_Tuple2("LJcy", "\u0409"),
        _Utils_Tuple2("ljcy", "\u0459"),
        _Utils_Tuple2("llarr", "\u21C7"),
        _Utils_Tuple2("ll", "\u226A"),
        _Utils_Tuple2("Ll", "\u22D8"),
        _Utils_Tuple2("llcorner", "\u231E"),
        _Utils_Tuple2("Lleftarrow", "\u21DA"),
        _Utils_Tuple2("llhard", "\u296B"),
        _Utils_Tuple2("lltri", "\u25FA"),
        _Utils_Tuple2("Lmidot", "\u013F"),
        _Utils_Tuple2("lmidot", "\u0140"),
        _Utils_Tuple2("lmoustache", "\u23B0"),
        _Utils_Tuple2("lmoust", "\u23B0"),
        _Utils_Tuple2("lnap", "\u2A89"),
        _Utils_Tuple2("lnapprox", "\u2A89"),
        _Utils_Tuple2("lne", "\u2A87"),
        _Utils_Tuple2("lnE", "\u2268"),
        _Utils_Tuple2("lneq", "\u2A87"),
        _Utils_Tuple2("lneqq", "\u2268"),
        _Utils_Tuple2("lnsim", "\u22E6"),
        _Utils_Tuple2("loang", "\u27EC"),
        _Utils_Tuple2("loarr", "\u21FD"),
        _Utils_Tuple2("lobrk", "\u27E6"),
        _Utils_Tuple2("longleftarrow", "\u27F5"),
        _Utils_Tuple2("LongLeftArrow", "\u27F5"),
        _Utils_Tuple2("Longleftarrow", "\u27F8"),
        _Utils_Tuple2("longleftrightarrow", "\u27F7"),
        _Utils_Tuple2("LongLeftRightArrow", "\u27F7"),
        _Utils_Tuple2("Longleftrightarrow", "\u27FA"),
        _Utils_Tuple2("longmapsto", "\u27FC"),
        _Utils_Tuple2("longrightarrow", "\u27F6"),
        _Utils_Tuple2("LongRightArrow", "\u27F6"),
        _Utils_Tuple2("Longrightarrow", "\u27F9"),
        _Utils_Tuple2("looparrowleft", "\u21AB"),
        _Utils_Tuple2("looparrowright", "\u21AC"),
        _Utils_Tuple2("lopar", "\u2985"),
        _Utils_Tuple2("Lopf", "\uD835\uDD43"),
        _Utils_Tuple2("lopf", "\uD835\uDD5D"),
        _Utils_Tuple2("loplus", "\u2A2D"),
        _Utils_Tuple2("lotimes", "\u2A34"),
        _Utils_Tuple2("lowast", "\u2217"),
        _Utils_Tuple2("lowbar", "_"),
        _Utils_Tuple2("LowerLeftArrow", "\u2199"),
        _Utils_Tuple2("LowerRightArrow", "\u2198"),
        _Utils_Tuple2("loz", "\u25CA"),
        _Utils_Tuple2("lozenge", "\u25CA"),
        _Utils_Tuple2("lozf", "\u29EB"),
        _Utils_Tuple2("lpar", "("),
        _Utils_Tuple2("lparlt", "\u2993"),
        _Utils_Tuple2("lrarr", "\u21C6"),
        _Utils_Tuple2("lrcorner", "\u231F"),
        _Utils_Tuple2("lrhar", "\u21CB"),
        _Utils_Tuple2("lrhard", "\u296D"),
        _Utils_Tuple2("lrm", "\u200E"),
        _Utils_Tuple2("lrtri", "\u22BF"),
        _Utils_Tuple2("lsaquo", "\u2039"),
        _Utils_Tuple2("lscr", "\uD835\uDCC1"),
        _Utils_Tuple2("Lscr", "\u2112"),
        _Utils_Tuple2("lsh", "\u21B0"),
        _Utils_Tuple2("Lsh", "\u21B0"),
        _Utils_Tuple2("lsim", "\u2272"),
        _Utils_Tuple2("lsime", "\u2A8D"),
        _Utils_Tuple2("lsimg", "\u2A8F"),
        _Utils_Tuple2("lsqb", "["),
        _Utils_Tuple2("lsquo", "\u2018"),
        _Utils_Tuple2("lsquor", "\u201A"),
        _Utils_Tuple2("Lstrok", "\u0141"),
        _Utils_Tuple2("lstrok", "\u0142"),
        _Utils_Tuple2("ltcc", "\u2AA6"),
        _Utils_Tuple2("ltcir", "\u2A79"),
        _Utils_Tuple2("lt", "<"),
        _Utils_Tuple2("LT", "<"),
        _Utils_Tuple2("Lt", "\u226A"),
        _Utils_Tuple2("ltdot", "\u22D6"),
        _Utils_Tuple2("lthree", "\u22CB"),
        _Utils_Tuple2("ltimes", "\u22C9"),
        _Utils_Tuple2("ltlarr", "\u2976"),
        _Utils_Tuple2("ltquest", "\u2A7B"),
        _Utils_Tuple2("ltri", "\u25C3"),
        _Utils_Tuple2("ltrie", "\u22B4"),
        _Utils_Tuple2("ltrif", "\u25C2"),
        _Utils_Tuple2("ltrPar", "\u2996"),
        _Utils_Tuple2("lurdshar", "\u294A"),
        _Utils_Tuple2("luruhar", "\u2966"),
        _Utils_Tuple2("lvertneqq", "\u2268\uFE00"),
        _Utils_Tuple2("lvnE", "\u2268\uFE00"),
        _Utils_Tuple2("macr", "\u00AF"),
        _Utils_Tuple2("male", "\u2642"),
        _Utils_Tuple2("malt", "\u2720"),
        _Utils_Tuple2("maltese", "\u2720"),
        _Utils_Tuple2("Map", "\u2905"),
        _Utils_Tuple2("map", "\u21A6"),
        _Utils_Tuple2("mapsto", "\u21A6"),
        _Utils_Tuple2("mapstodown", "\u21A7"),
        _Utils_Tuple2("mapstoleft", "\u21A4"),
        _Utils_Tuple2("mapstoup", "\u21A5"),
        _Utils_Tuple2("marker", "\u25AE"),
        _Utils_Tuple2("mcomma", "\u2A29"),
        _Utils_Tuple2("Mcy", "\u041C"),
        _Utils_Tuple2("mcy", "\u043C"),
        _Utils_Tuple2("mdash", "\u2014"),
        _Utils_Tuple2("mDDot", "\u223A"),
        _Utils_Tuple2("measuredangle", "\u2221"),
        _Utils_Tuple2("MediumSpace", "\u205F"),
        _Utils_Tuple2("Mellintrf", "\u2133"),
        _Utils_Tuple2("Mfr", "\uD835\uDD10"),
        _Utils_Tuple2("mfr", "\uD835\uDD2A"),
        _Utils_Tuple2("mho", "\u2127"),
        _Utils_Tuple2("micro", "\u00B5"),
        _Utils_Tuple2("midast", "*"),
        _Utils_Tuple2("midcir", "\u2AF0"),
        _Utils_Tuple2("mid", "\u2223"),
        _Utils_Tuple2("middot", "\u00B7"),
        _Utils_Tuple2("minusb", "\u229F"),
        _Utils_Tuple2("minus", "\u2212"),
        _Utils_Tuple2("minusd", "\u2238"),
        _Utils_Tuple2("minusdu", "\u2A2A"),
        _Utils_Tuple2("MinusPlus", "\u2213"),
        _Utils_Tuple2("mlcp", "\u2ADB"),
        _Utils_Tuple2("mldr", "\u2026"),
        _Utils_Tuple2("mnplus", "\u2213"),
        _Utils_Tuple2("models", "\u22A7"),
        _Utils_Tuple2("Mopf", "\uD835\uDD44"),
        _Utils_Tuple2("mopf", "\uD835\uDD5E"),
        _Utils_Tuple2("mp", "\u2213"),
        _Utils_Tuple2("mscr", "\uD835\uDCC2"),
        _Utils_Tuple2("Mscr", "\u2133"),
        _Utils_Tuple2("mstpos", "\u223E"),
        _Utils_Tuple2("Mu", "\u039C"),
        _Utils_Tuple2("mu", "\u03BC"),
        _Utils_Tuple2("multimap", "\u22B8"),
        _Utils_Tuple2("mumap", "\u22B8"),
        _Utils_Tuple2("nabla", "\u2207"),
        _Utils_Tuple2("Nacute", "\u0143"),
        _Utils_Tuple2("nacute", "\u0144"),
        _Utils_Tuple2("nang", "\u2220\u20D2"),
        _Utils_Tuple2("nap", "\u2249"),
        _Utils_Tuple2("napE", "\u2A70\u0338"),
        _Utils_Tuple2("napid", "\u224B\u0338"),
        _Utils_Tuple2("napos", "\u0149"),
        _Utils_Tuple2("napprox", "\u2249"),
        _Utils_Tuple2("natural", "\u266E"),
        _Utils_Tuple2("naturals", "\u2115"),
        _Utils_Tuple2("natur", "\u266E"),
        _Utils_Tuple2("nbsp", "\u00A0"),
        _Utils_Tuple2("nbump", "\u224E\u0338"),
        _Utils_Tuple2("nbumpe", "\u224F\u0338"),
        _Utils_Tuple2("ncap", "\u2A43"),
        _Utils_Tuple2("Ncaron", "\u0147"),
        _Utils_Tuple2("ncaron", "\u0148"),
        _Utils_Tuple2("Ncedil", "\u0145"),
        _Utils_Tuple2("ncedil", "\u0146"),
        _Utils_Tuple2("ncong", "\u2247"),
        _Utils_Tuple2("ncongdot", "\u2A6D\u0338"),
        _Utils_Tuple2("ncup", "\u2A42"),
        _Utils_Tuple2("Ncy", "\u041D"),
        _Utils_Tuple2("ncy", "\u043D"),
        _Utils_Tuple2("ndash", "\u2013"),
        _Utils_Tuple2("nearhk", "\u2924"),
        _Utils_Tuple2("nearr", "\u2197"),
        _Utils_Tuple2("neArr", "\u21D7"),
        _Utils_Tuple2("nearrow", "\u2197"),
        _Utils_Tuple2("ne", "\u2260"),
        _Utils_Tuple2("nedot", "\u2250\u0338"),
        _Utils_Tuple2("NegativeMediumSpace", "\u200B"),
        _Utils_Tuple2("NegativeThickSpace", "\u200B"),
        _Utils_Tuple2("NegativeThinSpace", "\u200B"),
        _Utils_Tuple2("NegativeVeryThinSpace", "\u200B"),
        _Utils_Tuple2("nequiv", "\u2262"),
        _Utils_Tuple2("nesear", "\u2928"),
        _Utils_Tuple2("nesim", "\u2242\u0338"),
        _Utils_Tuple2("NestedGreaterGreater", "\u226B"),
        _Utils_Tuple2("NestedLessLess", "\u226A"),
        _Utils_Tuple2("NewLine", "\n"),
        _Utils_Tuple2("nexist", "\u2204"),
        _Utils_Tuple2("nexists", "\u2204"),
        _Utils_Tuple2("Nfr", "\uD835\uDD11"),
        _Utils_Tuple2("nfr", "\uD835\uDD2B"),
        _Utils_Tuple2("ngE", "\u2267\u0338"),
        _Utils_Tuple2("nge", "\u2271"),
        _Utils_Tuple2("ngeq", "\u2271"),
        _Utils_Tuple2("ngeqq", "\u2267\u0338"),
        _Utils_Tuple2("ngeqslant", "\u2A7E\u0338"),
        _Utils_Tuple2("nges", "\u2A7E\u0338"),
        _Utils_Tuple2("nGg", "\u22D9\u0338"),
        _Utils_Tuple2("ngsim", "\u2275"),
        _Utils_Tuple2("nGt", "\u226B\u20D2"),
        _Utils_Tuple2("ngt", "\u226F"),
        _Utils_Tuple2("ngtr", "\u226F"),
        _Utils_Tuple2("nGtv", "\u226B\u0338"),
        _Utils_Tuple2("nharr", "\u21AE"),
        _Utils_Tuple2("nhArr", "\u21CE"),
        _Utils_Tuple2("nhpar", "\u2AF2"),
        _Utils_Tuple2("ni", "\u220B"),
        _Utils_Tuple2("nis", "\u22FC"),
        _Utils_Tuple2("nisd", "\u22FA"),
        _Utils_Tuple2("niv", "\u220B"),
        _Utils_Tuple2("NJcy", "\u040A"),
        _Utils_Tuple2("njcy", "\u045A"),
        _Utils_Tuple2("nlarr", "\u219A"),
        _Utils_Tuple2("nlArr", "\u21CD"),
        _Utils_Tuple2("nldr", "\u2025"),
        _Utils_Tuple2("nlE", "\u2266\u0338"),
        _Utils_Tuple2("nle", "\u2270"),
        _Utils_Tuple2("nleftarrow", "\u219A"),
        _Utils_Tuple2("nLeftarrow", "\u21CD"),
        _Utils_Tuple2("nleftrightarrow", "\u21AE"),
        _Utils_Tuple2("nLeftrightarrow", "\u21CE"),
        _Utils_Tuple2("nleq", "\u2270"),
        _Utils_Tuple2("nleqq", "\u2266\u0338"),
        _Utils_Tuple2("nleqslant", "\u2A7D\u0338"),
        _Utils_Tuple2("nles", "\u2A7D\u0338"),
        _Utils_Tuple2("nless", "\u226E"),
        _Utils_Tuple2("nLl", "\u22D8\u0338"),
        _Utils_Tuple2("nlsim", "\u2274"),
        _Utils_Tuple2("nLt", "\u226A\u20D2"),
        _Utils_Tuple2("nlt", "\u226E"),
        _Utils_Tuple2("nltri", "\u22EA"),
        _Utils_Tuple2("nltrie", "\u22EC"),
        _Utils_Tuple2("nLtv", "\u226A\u0338"),
        _Utils_Tuple2("nmid", "\u2224"),
        _Utils_Tuple2("NoBreak", "\u2060"),
        _Utils_Tuple2("NonBreakingSpace", "\u00A0"),
        _Utils_Tuple2("nopf", "\uD835\uDD5F"),
        _Utils_Tuple2("Nopf", "\u2115"),
        _Utils_Tuple2("Not", "\u2AEC"),
        _Utils_Tuple2("not", "\u00AC"),
        _Utils_Tuple2("NotCongruent", "\u2262"),
        _Utils_Tuple2("NotCupCap", "\u226D"),
        _Utils_Tuple2("NotDoubleVerticalBar", "\u2226"),
        _Utils_Tuple2("NotElement", "\u2209"),
        _Utils_Tuple2("NotEqual", "\u2260"),
        _Utils_Tuple2("NotEqualTilde", "\u2242\u0338"),
        _Utils_Tuple2("NotExists", "\u2204"),
        _Utils_Tuple2("NotGreater", "\u226F"),
        _Utils_Tuple2("NotGreaterEqual", "\u2271"),
        _Utils_Tuple2("NotGreaterFullEqual", "\u2267\u0338"),
        _Utils_Tuple2("NotGreaterGreater", "\u226B\u0338"),
        _Utils_Tuple2("NotGreaterLess", "\u2279"),
        _Utils_Tuple2("NotGreaterSlantEqual", "\u2A7E\u0338"),
        _Utils_Tuple2("NotGreaterTilde", "\u2275"),
        _Utils_Tuple2("NotHumpDownHump", "\u224E\u0338"),
        _Utils_Tuple2("NotHumpEqual", "\u224F\u0338"),
        _Utils_Tuple2("notin", "\u2209"),
        _Utils_Tuple2("notindot", "\u22F5\u0338"),
        _Utils_Tuple2("notinE", "\u22F9\u0338"),
        _Utils_Tuple2("notinva", "\u2209"),
        _Utils_Tuple2("notinvb", "\u22F7"),
        _Utils_Tuple2("notinvc", "\u22F6"),
        _Utils_Tuple2("NotLeftTriangleBar", "\u29CF\u0338"),
        _Utils_Tuple2("NotLeftTriangle", "\u22EA"),
        _Utils_Tuple2("NotLeftTriangleEqual", "\u22EC"),
        _Utils_Tuple2("NotLess", "\u226E"),
        _Utils_Tuple2("NotLessEqual", "\u2270"),
        _Utils_Tuple2("NotLessGreater", "\u2278"),
        _Utils_Tuple2("NotLessLess", "\u226A\u0338"),
        _Utils_Tuple2("NotLessSlantEqual", "\u2A7D\u0338"),
        _Utils_Tuple2("NotLessTilde", "\u2274"),
        _Utils_Tuple2("NotNestedGreaterGreater", "\u2AA2\u0338"),
        _Utils_Tuple2("NotNestedLessLess", "\u2AA1\u0338"),
        _Utils_Tuple2("notni", "\u220C"),
        _Utils_Tuple2("notniva", "\u220C"),
        _Utils_Tuple2("notnivb", "\u22FE"),
        _Utils_Tuple2("notnivc", "\u22FD"),
        _Utils_Tuple2("NotPrecedes", "\u2280"),
        _Utils_Tuple2("NotPrecedesEqual", "\u2AAF\u0338"),
        _Utils_Tuple2("NotPrecedesSlantEqual", "\u22E0"),
        _Utils_Tuple2("NotReverseElement", "\u220C"),
        _Utils_Tuple2("NotRightTriangleBar", "\u29D0\u0338"),
        _Utils_Tuple2("NotRightTriangle", "\u22EB"),
        _Utils_Tuple2("NotRightTriangleEqual", "\u22ED"),
        _Utils_Tuple2("NotSquareSubset", "\u228F\u0338"),
        _Utils_Tuple2("NotSquareSubsetEqual", "\u22E2"),
        _Utils_Tuple2("NotSquareSuperset", "\u2290\u0338"),
        _Utils_Tuple2("NotSquareSupersetEqual", "\u22E3"),
        _Utils_Tuple2("NotSubset", "\u2282\u20D2"),
        _Utils_Tuple2("NotSubsetEqual", "\u2288"),
        _Utils_Tuple2("NotSucceeds", "\u2281"),
        _Utils_Tuple2("NotSucceedsEqual", "\u2AB0\u0338"),
        _Utils_Tuple2("NotSucceedsSlantEqual", "\u22E1"),
        _Utils_Tuple2("NotSucceedsTilde", "\u227F\u0338"),
        _Utils_Tuple2("NotSuperset", "\u2283\u20D2"),
        _Utils_Tuple2("NotSupersetEqual", "\u2289"),
        _Utils_Tuple2("NotTilde", "\u2241"),
        _Utils_Tuple2("NotTildeEqual", "\u2244"),
        _Utils_Tuple2("NotTildeFullEqual", "\u2247"),
        _Utils_Tuple2("NotTildeTilde", "\u2249"),
        _Utils_Tuple2("NotVerticalBar", "\u2224"),
        _Utils_Tuple2("nparallel", "\u2226"),
        _Utils_Tuple2("npar", "\u2226"),
        _Utils_Tuple2("nparsl", "\u2AFD\u20E5"),
        _Utils_Tuple2("npart", "\u2202\u0338"),
        _Utils_Tuple2("npolint", "\u2A14"),
        _Utils_Tuple2("npr", "\u2280"),
        _Utils_Tuple2("nprcue", "\u22E0"),
        _Utils_Tuple2("nprec", "\u2280"),
        _Utils_Tuple2("npreceq", "\u2AAF\u0338"),
        _Utils_Tuple2("npre", "\u2AAF\u0338"),
        _Utils_Tuple2("nrarrc", "\u2933\u0338"),
        _Utils_Tuple2("nrarr", "\u219B"),
        _Utils_Tuple2("nrArr", "\u21CF"),
        _Utils_Tuple2("nrarrw", "\u219D\u0338"),
        _Utils_Tuple2("nrightarrow", "\u219B"),
        _Utils_Tuple2("nRightarrow", "\u21CF"),
        _Utils_Tuple2("nrtri", "\u22EB"),
        _Utils_Tuple2("nrtrie", "\u22ED"),
        _Utils_Tuple2("nsc", "\u2281"),
        _Utils_Tuple2("nsccue", "\u22E1"),
        _Utils_Tuple2("nsce", "\u2AB0\u0338"),
        _Utils_Tuple2("Nscr", "\uD835\uDCA9"),
        _Utils_Tuple2("nscr", "\uD835\uDCC3"),
        _Utils_Tuple2("nshortmid", "\u2224"),
        _Utils_Tuple2("nshortparallel", "\u2226"),
        _Utils_Tuple2("nsim", "\u2241"),
        _Utils_Tuple2("nsime", "\u2244"),
        _Utils_Tuple2("nsimeq", "\u2244"),
        _Utils_Tuple2("nsmid", "\u2224"),
        _Utils_Tuple2("nspar", "\u2226"),
        _Utils_Tuple2("nsqsube", "\u22E2"),
        _Utils_Tuple2("nsqsupe", "\u22E3"),
        _Utils_Tuple2("nsub", "\u2284"),
        _Utils_Tuple2("nsubE", "\u2AC5\u0338"),
        _Utils_Tuple2("nsube", "\u2288"),
        _Utils_Tuple2("nsubset", "\u2282\u20D2"),
        _Utils_Tuple2("nsubseteq", "\u2288"),
        _Utils_Tuple2("nsubseteqq", "\u2AC5\u0338"),
        _Utils_Tuple2("nsucc", "\u2281"),
        _Utils_Tuple2("nsucceq", "\u2AB0\u0338"),
        _Utils_Tuple2("nsup", "\u2285"),
        _Utils_Tuple2("nsupE", "\u2AC6\u0338"),
        _Utils_Tuple2("nsupe", "\u2289"),
        _Utils_Tuple2("nsupset", "\u2283\u20D2"),
        _Utils_Tuple2("nsupseteq", "\u2289"),
        _Utils_Tuple2("nsupseteqq", "\u2AC6\u0338"),
        _Utils_Tuple2("ntgl", "\u2279"),
        _Utils_Tuple2("Ntilde", "\u00D1"),
        _Utils_Tuple2("ntilde", "\u00F1"),
        _Utils_Tuple2("ntlg", "\u2278"),
        _Utils_Tuple2("ntriangleleft", "\u22EA"),
        _Utils_Tuple2("ntrianglelefteq", "\u22EC"),
        _Utils_Tuple2("ntriangleright", "\u22EB"),
        _Utils_Tuple2("ntrianglerighteq", "\u22ED"),
        _Utils_Tuple2("Nu", "\u039D"),
        _Utils_Tuple2("nu", "\u03BD"),
        _Utils_Tuple2("num", "#"),
        _Utils_Tuple2("numero", "\u2116"),
        _Utils_Tuple2("numsp", "\u2007"),
        _Utils_Tuple2("nvap", "\u224D\u20D2"),
        _Utils_Tuple2("nvdash", "\u22AC"),
        _Utils_Tuple2("nvDash", "\u22AD"),
        _Utils_Tuple2("nVdash", "\u22AE"),
        _Utils_Tuple2("nVDash", "\u22AF"),
        _Utils_Tuple2("nvge", "\u2265\u20D2"),
        _Utils_Tuple2("nvgt", ">\u20D2"),
        _Utils_Tuple2("nvHarr", "\u2904"),
        _Utils_Tuple2("nvinfin", "\u29DE"),
        _Utils_Tuple2("nvlArr", "\u2902"),
        _Utils_Tuple2("nvle", "\u2264\u20D2"),
        _Utils_Tuple2("nvlt", "<\u20D2"),
        _Utils_Tuple2("nvltrie", "\u22B4\u20D2"),
        _Utils_Tuple2("nvrArr", "\u2903"),
        _Utils_Tuple2("nvrtrie", "\u22B5\u20D2"),
        _Utils_Tuple2("nvsim", "\u223C\u20D2"),
        _Utils_Tuple2("nwarhk", "\u2923"),
        _Utils_Tuple2("nwarr", "\u2196"),
        _Utils_Tuple2("nwArr", "\u21D6"),
        _Utils_Tuple2("nwarrow", "\u2196"),
        _Utils_Tuple2("nwnear", "\u2927"),
        _Utils_Tuple2("Oacute", "\u00D3"),
        _Utils_Tuple2("oacute", "\u00F3"),
        _Utils_Tuple2("oast", "\u229B"),
        _Utils_Tuple2("Ocirc", "\u00D4"),
        _Utils_Tuple2("ocirc", "\u00F4"),
        _Utils_Tuple2("ocir", "\u229A"),
        _Utils_Tuple2("Ocy", "\u041E"),
        _Utils_Tuple2("ocy", "\u043E"),
        _Utils_Tuple2("odash", "\u229D"),
        _Utils_Tuple2("Odblac", "\u0150"),
        _Utils_Tuple2("odblac", "\u0151"),
        _Utils_Tuple2("odiv", "\u2A38"),
        _Utils_Tuple2("odot", "\u2299"),
        _Utils_Tuple2("odsold", "\u29BC"),
        _Utils_Tuple2("OElig", "\u0152"),
        _Utils_Tuple2("oelig", "\u0153"),
        _Utils_Tuple2("ofcir", "\u29BF"),
        _Utils_Tuple2("Ofr", "\uD835\uDD12"),
        _Utils_Tuple2("ofr", "\uD835\uDD2C"),
        _Utils_Tuple2("ogon", "\u02DB"),
        _Utils_Tuple2("Ograve", "\u00D2"),
        _Utils_Tuple2("ograve", "\u00F2"),
        _Utils_Tuple2("ogt", "\u29C1"),
        _Utils_Tuple2("ohbar", "\u29B5"),
        _Utils_Tuple2("ohm", "\u03A9"),
        _Utils_Tuple2("oint", "\u222E"),
        _Utils_Tuple2("olarr", "\u21BA"),
        _Utils_Tuple2("olcir", "\u29BE"),
        _Utils_Tuple2("olcross", "\u29BB"),
        _Utils_Tuple2("oline", "\u203E"),
        _Utils_Tuple2("olt", "\u29C0"),
        _Utils_Tuple2("Omacr", "\u014C"),
        _Utils_Tuple2("omacr", "\u014D"),
        _Utils_Tuple2("Omega", "\u03A9"),
        _Utils_Tuple2("omega", "\u03C9"),
        _Utils_Tuple2("Omicron", "\u039F"),
        _Utils_Tuple2("omicron", "\u03BF"),
        _Utils_Tuple2("omid", "\u29B6"),
        _Utils_Tuple2("ominus", "\u2296"),
        _Utils_Tuple2("Oopf", "\uD835\uDD46"),
        _Utils_Tuple2("oopf", "\uD835\uDD60"),
        _Utils_Tuple2("opar", "\u29B7"),
        _Utils_Tuple2("OpenCurlyDoubleQuote", "\u201C"),
        _Utils_Tuple2("OpenCurlyQuote", "\u2018"),
        _Utils_Tuple2("operp", "\u29B9"),
        _Utils_Tuple2("oplus", "\u2295"),
        _Utils_Tuple2("orarr", "\u21BB"),
        _Utils_Tuple2("Or", "\u2A54"),
        _Utils_Tuple2("or", "\u2228"),
        _Utils_Tuple2("ord", "\u2A5D"),
        _Utils_Tuple2("order", "\u2134"),
        _Utils_Tuple2("orderof", "\u2134"),
        _Utils_Tuple2("ordf", "\u00AA"),
        _Utils_Tuple2("ordm", "\u00BA"),
        _Utils_Tuple2("origof", "\u22B6"),
        _Utils_Tuple2("oror", "\u2A56"),
        _Utils_Tuple2("orslope", "\u2A57"),
        _Utils_Tuple2("orv", "\u2A5B"),
        _Utils_Tuple2("oS", "\u24C8"),
        _Utils_Tuple2("Oscr", "\uD835\uDCAA"),
        _Utils_Tuple2("oscr", "\u2134"),
        _Utils_Tuple2("Oslash", "\u00D8"),
        _Utils_Tuple2("oslash", "\u00F8"),
        _Utils_Tuple2("osol", "\u2298"),
        _Utils_Tuple2("Otilde", "\u00D5"),
        _Utils_Tuple2("otilde", "\u00F5"),
        _Utils_Tuple2("otimesas", "\u2A36"),
        _Utils_Tuple2("Otimes", "\u2A37"),
        _Utils_Tuple2("otimes", "\u2297"),
        _Utils_Tuple2("Ouml", "\u00D6"),
        _Utils_Tuple2("ouml", "\u00F6"),
        _Utils_Tuple2("ovbar", "\u233D"),
        _Utils_Tuple2("OverBar", "\u203E"),
        _Utils_Tuple2("OverBrace", "\u23DE"),
        _Utils_Tuple2("OverBracket", "\u23B4"),
        _Utils_Tuple2("OverParenthesis", "\u23DC"),
        _Utils_Tuple2("para", "\u00B6"),
        _Utils_Tuple2("parallel", "\u2225"),
        _Utils_Tuple2("par", "\u2225"),
        _Utils_Tuple2("parsim", "\u2AF3"),
        _Utils_Tuple2("parsl", "\u2AFD"),
        _Utils_Tuple2("part", "\u2202"),
        _Utils_Tuple2("PartialD", "\u2202"),
        _Utils_Tuple2("Pcy", "\u041F"),
        _Utils_Tuple2("pcy", "\u043F"),
        _Utils_Tuple2("percnt", "%"),
        _Utils_Tuple2("period", "."),
        _Utils_Tuple2("permil", "\u2030"),
        _Utils_Tuple2("perp", "\u22A5"),
        _Utils_Tuple2("pertenk", "\u2031"),
        _Utils_Tuple2("Pfr", "\uD835\uDD13"),
        _Utils_Tuple2("pfr", "\uD835\uDD2D"),
        _Utils_Tuple2("Phi", "\u03A6"),
        _Utils_Tuple2("phi", "\u03C6"),
        _Utils_Tuple2("phiv", "\u03D5"),
        _Utils_Tuple2("phmmat", "\u2133"),
        _Utils_Tuple2("phone", "\u260E"),
        _Utils_Tuple2("Pi", "\u03A0"),
        _Utils_Tuple2("pi", "\u03C0"),
        _Utils_Tuple2("pitchfork", "\u22D4"),
        _Utils_Tuple2("piv", "\u03D6"),
        _Utils_Tuple2("planck", "\u210F"),
        _Utils_Tuple2("planckh", "\u210E"),
        _Utils_Tuple2("plankv", "\u210F"),
        _Utils_Tuple2("plusacir", "\u2A23"),
        _Utils_Tuple2("plusb", "\u229E"),
        _Utils_Tuple2("pluscir", "\u2A22"),
        _Utils_Tuple2("plus", "+"),
        _Utils_Tuple2("plusdo", "\u2214"),
        _Utils_Tuple2("plusdu", "\u2A25"),
        _Utils_Tuple2("pluse", "\u2A72"),
        _Utils_Tuple2("PlusMinus", "\u00B1"),
        _Utils_Tuple2("plusmn", "\u00B1"),
        _Utils_Tuple2("plussim", "\u2A26"),
        _Utils_Tuple2("plustwo", "\u2A27"),
        _Utils_Tuple2("pm", "\u00B1"),
        _Utils_Tuple2("Poincareplane", "\u210C"),
        _Utils_Tuple2("pointint", "\u2A15"),
        _Utils_Tuple2("popf", "\uD835\uDD61"),
        _Utils_Tuple2("Popf", "\u2119"),
        _Utils_Tuple2("pound", "\u00A3"),
        _Utils_Tuple2("prap", "\u2AB7"),
        _Utils_Tuple2("Pr", "\u2ABB"),
        _Utils_Tuple2("pr", "\u227A"),
        _Utils_Tuple2("prcue", "\u227C"),
        _Utils_Tuple2("precapprox", "\u2AB7"),
        _Utils_Tuple2("prec", "\u227A"),
        _Utils_Tuple2("preccurlyeq", "\u227C"),
        _Utils_Tuple2("Precedes", "\u227A"),
        _Utils_Tuple2("PrecedesEqual", "\u2AAF"),
        _Utils_Tuple2("PrecedesSlantEqual", "\u227C"),
        _Utils_Tuple2("PrecedesTilde", "\u227E"),
        _Utils_Tuple2("preceq", "\u2AAF"),
        _Utils_Tuple2("precnapprox", "\u2AB9"),
        _Utils_Tuple2("precneqq", "\u2AB5"),
        _Utils_Tuple2("precnsim", "\u22E8"),
        _Utils_Tuple2("pre", "\u2AAF"),
        _Utils_Tuple2("prE", "\u2AB3"),
        _Utils_Tuple2("precsim", "\u227E"),
        _Utils_Tuple2("prime", "\u2032"),
        _Utils_Tuple2("Prime", "\u2033"),
        _Utils_Tuple2("primes", "\u2119"),
        _Utils_Tuple2("prnap", "\u2AB9"),
        _Utils_Tuple2("prnE", "\u2AB5"),
        _Utils_Tuple2("prnsim", "\u22E8"),
        _Utils_Tuple2("prod", "\u220F"),
        _Utils_Tuple2("Product", "\u220F"),
        _Utils_Tuple2("profalar", "\u232E"),
        _Utils_Tuple2("profline", "\u2312"),
        _Utils_Tuple2("profsurf", "\u2313"),
        _Utils_Tuple2("prop", "\u221D"),
        _Utils_Tuple2("Proportional", "\u221D"),
        _Utils_Tuple2("Proportion", "\u2237"),
        _Utils_Tuple2("propto", "\u221D"),
        _Utils_Tuple2("prsim", "\u227E"),
        _Utils_Tuple2("prurel", "\u22B0"),
        _Utils_Tuple2("Pscr", "\uD835\uDCAB"),
        _Utils_Tuple2("pscr", "\uD835\uDCC5"),
        _Utils_Tuple2("Psi", "\u03A8"),
        _Utils_Tuple2("psi", "\u03C8"),
        _Utils_Tuple2("puncsp", "\u2008"),
        _Utils_Tuple2("Qfr", "\uD835\uDD14"),
        _Utils_Tuple2("qfr", "\uD835\uDD2E"),
        _Utils_Tuple2("qint", "\u2A0C"),
        _Utils_Tuple2("qopf", "\uD835\uDD62"),
        _Utils_Tuple2("Qopf", "\u211A"),
        _Utils_Tuple2("qprime", "\u2057"),
        _Utils_Tuple2("Qscr", "\uD835\uDCAC"),
        _Utils_Tuple2("qscr", "\uD835\uDCC6"),
        _Utils_Tuple2("quaternions", "\u210D"),
        _Utils_Tuple2("quatint", "\u2A16"),
        _Utils_Tuple2("quest", "?"),
        _Utils_Tuple2("questeq", "\u225F"),
        _Utils_Tuple2("quot", "\""),
        _Utils_Tuple2("QUOT", "\""),
        _Utils_Tuple2("rAarr", "\u21DB"),
        _Utils_Tuple2("race", "\u223D\u0331"),
        _Utils_Tuple2("Racute", "\u0154"),
        _Utils_Tuple2("racute", "\u0155"),
        _Utils_Tuple2("radic", "\u221A"),
        _Utils_Tuple2("raemptyv", "\u29B3"),
        _Utils_Tuple2("rang", "\u27E9"),
        _Utils_Tuple2("Rang", "\u27EB"),
        _Utils_Tuple2("rangd", "\u2992"),
        _Utils_Tuple2("range", "\u29A5"),
        _Utils_Tuple2("rangle", "\u27E9"),
        _Utils_Tuple2("raquo", "\u00BB"),
        _Utils_Tuple2("rarrap", "\u2975"),
        _Utils_Tuple2("rarrb", "\u21E5"),
        _Utils_Tuple2("rarrbfs", "\u2920"),
        _Utils_Tuple2("rarrc", "\u2933"),
        _Utils_Tuple2("rarr", "\u2192"),
        _Utils_Tuple2("Rarr", "\u21A0"),
        _Utils_Tuple2("rArr", "\u21D2"),
        _Utils_Tuple2("rarrfs", "\u291E"),
        _Utils_Tuple2("rarrhk", "\u21AA"),
        _Utils_Tuple2("rarrlp", "\u21AC"),
        _Utils_Tuple2("rarrpl", "\u2945"),
        _Utils_Tuple2("rarrsim", "\u2974"),
        _Utils_Tuple2("Rarrtl", "\u2916"),
        _Utils_Tuple2("rarrtl", "\u21A3"),
        _Utils_Tuple2("rarrw", "\u219D"),
        _Utils_Tuple2("ratail", "\u291A"),
        _Utils_Tuple2("rAtail", "\u291C"),
        _Utils_Tuple2("ratio", "\u2236"),
        _Utils_Tuple2("rationals", "\u211A"),
        _Utils_Tuple2("rbarr", "\u290D"),
        _Utils_Tuple2("rBarr", "\u290F"),
        _Utils_Tuple2("RBarr", "\u2910"),
        _Utils_Tuple2("rbbrk", "\u2773"),
        _Utils_Tuple2("rbrace", "}"),
        _Utils_Tuple2("rbrack", "]"),
        _Utils_Tuple2("rbrke", "\u298C"),
        _Utils_Tuple2("rbrksld", "\u298E"),
        _Utils_Tuple2("rbrkslu", "\u2990"),
        _Utils_Tuple2("Rcaron", "\u0158"),
        _Utils_Tuple2("rcaron", "\u0159"),
        _Utils_Tuple2("Rcedil", "\u0156"),
        _Utils_Tuple2("rcedil", "\u0157"),
        _Utils_Tuple2("rceil", "\u2309"),
        _Utils_Tuple2("rcub", "}"),
        _Utils_Tuple2("Rcy", "\u0420"),
        _Utils_Tuple2("rcy", "\u0440"),
        _Utils_Tuple2("rdca", "\u2937"),
        _Utils_Tuple2("rdldhar", "\u2969"),
        _Utils_Tuple2("rdquo", "\u201D"),
        _Utils_Tuple2("rdquor", "\u201D"),
        _Utils_Tuple2("rdsh", "\u21B3"),
        _Utils_Tuple2("real", "\u211C"),
        _Utils_Tuple2("realine", "\u211B"),
        _Utils_Tuple2("realpart", "\u211C"),
        _Utils_Tuple2("reals", "\u211D"),
        _Utils_Tuple2("Re", "\u211C"),
        _Utils_Tuple2("rect", "\u25AD"),
        _Utils_Tuple2("reg", "\u00AE"),
        _Utils_Tuple2("REG", "\u00AE"),
        _Utils_Tuple2("ReverseElement", "\u220B"),
        _Utils_Tuple2("ReverseEquilibrium", "\u21CB"),
        _Utils_Tuple2("ReverseUpEquilibrium", "\u296F"),
        _Utils_Tuple2("rfisht", "\u297D"),
        _Utils_Tuple2("rfloor", "\u230B"),
        _Utils_Tuple2("rfr", "\uD835\uDD2F"),
        _Utils_Tuple2("Rfr", "\u211C"),
        _Utils_Tuple2("rHar", "\u2964"),
        _Utils_Tuple2("rhard", "\u21C1"),
        _Utils_Tuple2("rharu", "\u21C0"),
        _Utils_Tuple2("rharul", "\u296C"),
        _Utils_Tuple2("Rho", "\u03A1"),
        _Utils_Tuple2("rho", "\u03C1"),
        _Utils_Tuple2("rhov", "\u03F1"),
        _Utils_Tuple2("RightAngleBracket", "\u27E9"),
        _Utils_Tuple2("RightArrowBar", "\u21E5"),
        _Utils_Tuple2("rightarrow", "\u2192"),
        _Utils_Tuple2("RightArrow", "\u2192"),
        _Utils_Tuple2("Rightarrow", "\u21D2"),
        _Utils_Tuple2("RightArrowLeftArrow", "\u21C4"),
        _Utils_Tuple2("rightarrowtail", "\u21A3"),
        _Utils_Tuple2("RightCeiling", "\u2309"),
        _Utils_Tuple2("RightDoubleBracket", "\u27E7"),
        _Utils_Tuple2("RightDownTeeVector", "\u295D"),
        _Utils_Tuple2("RightDownVectorBar", "\u2955"),
        _Utils_Tuple2("RightDownVector", "\u21C2"),
        _Utils_Tuple2("RightFloor", "\u230B"),
        _Utils_Tuple2("rightharpoondown", "\u21C1"),
        _Utils_Tuple2("rightharpoonup", "\u21C0"),
        _Utils_Tuple2("rightleftarrows", "\u21C4"),
        _Utils_Tuple2("rightleftharpoons", "\u21CC"),
        _Utils_Tuple2("rightrightarrows", "\u21C9"),
        _Utils_Tuple2("rightsquigarrow", "\u219D"),
        _Utils_Tuple2("RightTeeArrow", "\u21A6"),
        _Utils_Tuple2("RightTee", "\u22A2"),
        _Utils_Tuple2("RightTeeVector", "\u295B"),
        _Utils_Tuple2("rightthreetimes", "\u22CC"),
        _Utils_Tuple2("RightTriangleBar", "\u29D0"),
        _Utils_Tuple2("RightTriangle", "\u22B3"),
        _Utils_Tuple2("RightTriangleEqual", "\u22B5"),
        _Utils_Tuple2("RightUpDownVector", "\u294F"),
        _Utils_Tuple2("RightUpTeeVector", "\u295C"),
        _Utils_Tuple2("RightUpVectorBar", "\u2954"),
        _Utils_Tuple2("RightUpVector", "\u21BE"),
        _Utils_Tuple2("RightVectorBar", "\u2953"),
        _Utils_Tuple2("RightVector", "\u21C0"),
        _Utils_Tuple2("ring", "\u02DA"),
        _Utils_Tuple2("risingdotseq", "\u2253"),
        _Utils_Tuple2("rlarr", "\u21C4"),
        _Utils_Tuple2("rlhar", "\u21CC"),
        _Utils_Tuple2("rlm", "\u200F"),
        _Utils_Tuple2("rmoustache", "\u23B1"),
        _Utils_Tuple2("rmoust", "\u23B1"),
        _Utils_Tuple2("rnmid", "\u2AEE"),
        _Utils_Tuple2("roang", "\u27ED"),
        _Utils_Tuple2("roarr", "\u21FE"),
        _Utils_Tuple2("robrk", "\u27E7"),
        _Utils_Tuple2("ropar", "\u2986"),
        _Utils_Tuple2("ropf", "\uD835\uDD63"),
        _Utils_Tuple2("Ropf", "\u211D"),
        _Utils_Tuple2("roplus", "\u2A2E"),
        _Utils_Tuple2("rotimes", "\u2A35"),
        _Utils_Tuple2("RoundImplies", "\u2970"),
        _Utils_Tuple2("rpar", ")"),
        _Utils_Tuple2("rpargt", "\u2994"),
        _Utils_Tuple2("rppolint", "\u2A12"),
        _Utils_Tuple2("rrarr", "\u21C9"),
        _Utils_Tuple2("Rrightarrow", "\u21DB"),
        _Utils_Tuple2("rsaquo", "\u203A"),
        _Utils_Tuple2("rscr", "\uD835\uDCC7"),
        _Utils_Tuple2("Rscr", "\u211B"),
        _Utils_Tuple2("rsh", "\u21B1"),
        _Utils_Tuple2("Rsh", "\u21B1"),
        _Utils_Tuple2("rsqb", "]"),
        _Utils_Tuple2("rsquo", "\u2019"),
        _Utils_Tuple2("rsquor", "\u2019"),
        _Utils_Tuple2("rthree", "\u22CC"),
        _Utils_Tuple2("rtimes", "\u22CA"),
        _Utils_Tuple2("rtri", "\u25B9"),
        _Utils_Tuple2("rtrie", "\u22B5"),
        _Utils_Tuple2("rtrif", "\u25B8"),
        _Utils_Tuple2("rtriltri", "\u29CE"),
        _Utils_Tuple2("RuleDelayed", "\u29F4"),
        _Utils_Tuple2("ruluhar", "\u2968"),
        _Utils_Tuple2("rx", "\u211E"),
        _Utils_Tuple2("Sacute", "\u015A"),
        _Utils_Tuple2("sacute", "\u015B"),
        _Utils_Tuple2("sbquo", "\u201A"),
        _Utils_Tuple2("scap", "\u2AB8"),
        _Utils_Tuple2("Scaron", "\u0160"),
        _Utils_Tuple2("scaron", "\u0161"),
        _Utils_Tuple2("Sc", "\u2ABC"),
        _Utils_Tuple2("sc", "\u227B"),
        _Utils_Tuple2("sccue", "\u227D"),
        _Utils_Tuple2("sce", "\u2AB0"),
        _Utils_Tuple2("scE", "\u2AB4"),
        _Utils_Tuple2("Scedil", "\u015E"),
        _Utils_Tuple2("scedil", "\u015F"),
        _Utils_Tuple2("Scirc", "\u015C"),
        _Utils_Tuple2("scirc", "\u015D"),
        _Utils_Tuple2("scnap", "\u2ABA"),
        _Utils_Tuple2("scnE", "\u2AB6"),
        _Utils_Tuple2("scnsim", "\u22E9"),
        _Utils_Tuple2("scpolint", "\u2A13"),
        _Utils_Tuple2("scsim", "\u227F"),
        _Utils_Tuple2("Scy", "\u0421"),
        _Utils_Tuple2("scy", "\u0441"),
        _Utils_Tuple2("sdotb", "\u22A1"),
        _Utils_Tuple2("sdot", "\u22C5"),
        _Utils_Tuple2("sdote", "\u2A66"),
        _Utils_Tuple2("searhk", "\u2925"),
        _Utils_Tuple2("searr", "\u2198"),
        _Utils_Tuple2("seArr", "\u21D8"),
        _Utils_Tuple2("searrow", "\u2198"),
        _Utils_Tuple2("sect", "\u00A7"),
        _Utils_Tuple2("semi", ";"),
        _Utils_Tuple2("seswar", "\u2929"),
        _Utils_Tuple2("setminus", "\u2216"),
        _Utils_Tuple2("setmn", "\u2216"),
        _Utils_Tuple2("sext", "\u2736"),
        _Utils_Tuple2("Sfr", "\uD835\uDD16"),
        _Utils_Tuple2("sfr", "\uD835\uDD30"),
        _Utils_Tuple2("sfrown", "\u2322"),
        _Utils_Tuple2("sharp", "\u266F"),
        _Utils_Tuple2("SHCHcy", "\u0429"),
        _Utils_Tuple2("shchcy", "\u0449"),
        _Utils_Tuple2("SHcy", "\u0428"),
        _Utils_Tuple2("shcy", "\u0448"),
        _Utils_Tuple2("ShortDownArrow", "\u2193"),
        _Utils_Tuple2("ShortLeftArrow", "\u2190"),
        _Utils_Tuple2("shortmid", "\u2223"),
        _Utils_Tuple2("shortparallel", "\u2225"),
        _Utils_Tuple2("ShortRightArrow", "\u2192"),
        _Utils_Tuple2("ShortUpArrow", "\u2191"),
        _Utils_Tuple2("shy", "\u00AD"),
        _Utils_Tuple2("Sigma", "\u03A3"),
        _Utils_Tuple2("sigma", "\u03C3"),
        _Utils_Tuple2("sigmaf", "\u03C2"),
        _Utils_Tuple2("sigmav", "\u03C2"),
        _Utils_Tuple2("sim", "\u223C"),
        _Utils_Tuple2("simdot", "\u2A6A"),
        _Utils_Tuple2("sime", "\u2243"),
        _Utils_Tuple2("simeq", "\u2243"),
        _Utils_Tuple2("simg", "\u2A9E"),
        _Utils_Tuple2("simgE", "\u2AA0"),
        _Utils_Tuple2("siml", "\u2A9D"),
        _Utils_Tuple2("simlE", "\u2A9F"),
        _Utils_Tuple2("simne", "\u2246"),
        _Utils_Tuple2("simplus", "\u2A24"),
        _Utils_Tuple2("simrarr", "\u2972"),
        _Utils_Tuple2("slarr", "\u2190"),
        _Utils_Tuple2("SmallCircle", "\u2218"),
        _Utils_Tuple2("smallsetminus", "\u2216"),
        _Utils_Tuple2("smashp", "\u2A33"),
        _Utils_Tuple2("smeparsl", "\u29E4"),
        _Utils_Tuple2("smid", "\u2223"),
        _Utils_Tuple2("smile", "\u2323"),
        _Utils_Tuple2("smt", "\u2AAA"),
        _Utils_Tuple2("smte", "\u2AAC"),
        _Utils_Tuple2("smtes", "\u2AAC\uFE00"),
        _Utils_Tuple2("SOFTcy", "\u042C"),
        _Utils_Tuple2("softcy", "\u044C"),
        _Utils_Tuple2("solbar", "\u233F"),
        _Utils_Tuple2("solb", "\u29C4"),
        _Utils_Tuple2("sol", "/"),
        _Utils_Tuple2("Sopf", "\uD835\uDD4A"),
        _Utils_Tuple2("sopf", "\uD835\uDD64"),
        _Utils_Tuple2("spades", "\u2660"),
        _Utils_Tuple2("spadesuit", "\u2660"),
        _Utils_Tuple2("spar", "\u2225"),
        _Utils_Tuple2("sqcap", "\u2293"),
        _Utils_Tuple2("sqcaps", "\u2293\uFE00"),
        _Utils_Tuple2("sqcup", "\u2294"),
        _Utils_Tuple2("sqcups", "\u2294\uFE00"),
        _Utils_Tuple2("Sqrt", "\u221A"),
        _Utils_Tuple2("sqsub", "\u228F"),
        _Utils_Tuple2("sqsube", "\u2291"),
        _Utils_Tuple2("sqsubset", "\u228F"),
        _Utils_Tuple2("sqsubseteq", "\u2291"),
        _Utils_Tuple2("sqsup", "\u2290"),
        _Utils_Tuple2("sqsupe", "\u2292"),
        _Utils_Tuple2("sqsupset", "\u2290"),
        _Utils_Tuple2("sqsupseteq", "\u2292"),
        _Utils_Tuple2("square", "\u25A1"),
        _Utils_Tuple2("Square", "\u25A1"),
        _Utils_Tuple2("SquareIntersection", "\u2293"),
        _Utils_Tuple2("SquareSubset", "\u228F"),
        _Utils_Tuple2("SquareSubsetEqual", "\u2291"),
        _Utils_Tuple2("SquareSuperset", "\u2290"),
        _Utils_Tuple2("SquareSupersetEqual", "\u2292"),
        _Utils_Tuple2("SquareUnion", "\u2294"),
        _Utils_Tuple2("squarf", "\u25AA"),
        _Utils_Tuple2("squ", "\u25A1"),
        _Utils_Tuple2("squf", "\u25AA"),
        _Utils_Tuple2("srarr", "\u2192"),
        _Utils_Tuple2("Sscr", "\uD835\uDCAE"),
        _Utils_Tuple2("sscr", "\uD835\uDCC8"),
        _Utils_Tuple2("ssetmn", "\u2216"),
        _Utils_Tuple2("ssmile", "\u2323"),
        _Utils_Tuple2("sstarf", "\u22C6"),
        _Utils_Tuple2("Star", "\u22C6"),
        _Utils_Tuple2("star", "\u2606"),
        _Utils_Tuple2("starf", "\u2605"),
        _Utils_Tuple2("straightepsilon", "\u03F5"),
        _Utils_Tuple2("straightphi", "\u03D5"),
        _Utils_Tuple2("strns", "\u00AF"),
        _Utils_Tuple2("sub", "\u2282"),
        _Utils_Tuple2("Sub", "\u22D0"),
        _Utils_Tuple2("subdot", "\u2ABD"),
        _Utils_Tuple2("subE", "\u2AC5"),
        _Utils_Tuple2("sube", "\u2286"),
        _Utils_Tuple2("subedot", "\u2AC3"),
        _Utils_Tuple2("submult", "\u2AC1"),
        _Utils_Tuple2("subnE", "\u2ACB"),
        _Utils_Tuple2("subne", "\u228A"),
        _Utils_Tuple2("subplus", "\u2ABF"),
        _Utils_Tuple2("subrarr", "\u2979"),
        _Utils_Tuple2("subset", "\u2282"),
        _Utils_Tuple2("Subset", "\u22D0"),
        _Utils_Tuple2("subseteq", "\u2286"),
        _Utils_Tuple2("subseteqq", "\u2AC5"),
        _Utils_Tuple2("SubsetEqual", "\u2286"),
        _Utils_Tuple2("subsetneq", "\u228A"),
        _Utils_Tuple2("subsetneqq", "\u2ACB"),
        _Utils_Tuple2("subsim", "\u2AC7"),
        _Utils_Tuple2("subsub", "\u2AD5"),
        _Utils_Tuple2("subsup", "\u2AD3"),
        _Utils_Tuple2("succapprox", "\u2AB8"),
        _Utils_Tuple2("succ", "\u227B"),
        _Utils_Tuple2("succcurlyeq", "\u227D"),
        _Utils_Tuple2("Succeeds", "\u227B"),
        _Utils_Tuple2("SucceedsEqual", "\u2AB0"),
        _Utils_Tuple2("SucceedsSlantEqual", "\u227D"),
        _Utils_Tuple2("SucceedsTilde", "\u227F"),
        _Utils_Tuple2("succeq", "\u2AB0"),
        _Utils_Tuple2("succnapprox", "\u2ABA"),
        _Utils_Tuple2("succneqq", "\u2AB6"),
        _Utils_Tuple2("succnsim", "\u22E9"),
        _Utils_Tuple2("succsim", "\u227F"),
        _Utils_Tuple2("SuchThat", "\u220B"),
        _Utils_Tuple2("sum", "\u2211"),
        _Utils_Tuple2("Sum", "\u2211"),
        _Utils_Tuple2("sung", "\u266A"),
        _Utils_Tuple2("sup1", "\u00B9"),
        _Utils_Tuple2("sup2", "\u00B2"),
        _Utils_Tuple2("sup3", "\u00B3"),
        _Utils_Tuple2("sup", "\u2283"),
        _Utils_Tuple2("Sup", "\u22D1"),
        _Utils_Tuple2("supdot", "\u2ABE"),
        _Utils_Tuple2("supdsub", "\u2AD8"),
        _Utils_Tuple2("supE", "\u2AC6"),
        _Utils_Tuple2("supe", "\u2287"),
        _Utils_Tuple2("supedot", "\u2AC4"),
        _Utils_Tuple2("Superset", "\u2283"),
        _Utils_Tuple2("SupersetEqual", "\u2287"),
        _Utils_Tuple2("suphsol", "\u27C9"),
        _Utils_Tuple2("suphsub", "\u2AD7"),
        _Utils_Tuple2("suplarr", "\u297B"),
        _Utils_Tuple2("supmult", "\u2AC2"),
        _Utils_Tuple2("supnE", "\u2ACC"),
        _Utils_Tuple2("supne", "\u228B"),
        _Utils_Tuple2("supplus", "\u2AC0"),
        _Utils_Tuple2("supset", "\u2283"),
        _Utils_Tuple2("Supset", "\u22D1"),
        _Utils_Tuple2("supseteq", "\u2287"),
        _Utils_Tuple2("supseteqq", "\u2AC6"),
        _Utils_Tuple2("supsetneq", "\u228B"),
        _Utils_Tuple2("supsetneqq", "\u2ACC"),
        _Utils_Tuple2("supsim", "\u2AC8"),
        _Utils_Tuple2("supsub", "\u2AD4"),
        _Utils_Tuple2("supsup", "\u2AD6"),
        _Utils_Tuple2("swarhk", "\u2926"),
        _Utils_Tuple2("swarr", "\u2199"),
        _Utils_Tuple2("swArr", "\u21D9"),
        _Utils_Tuple2("swarrow", "\u2199"),
        _Utils_Tuple2("swnwar", "\u292A"),
        _Utils_Tuple2("szlig", "\u00DF"),
        _Utils_Tuple2("Tab", "\t"),
        _Utils_Tuple2("target", "\u2316"),
        _Utils_Tuple2("Tau", "\u03A4"),
        _Utils_Tuple2("tau", "\u03C4"),
        _Utils_Tuple2("tbrk", "\u23B4"),
        _Utils_Tuple2("Tcaron", "\u0164"),
        _Utils_Tuple2("tcaron", "\u0165"),
        _Utils_Tuple2("Tcedil", "\u0162"),
        _Utils_Tuple2("tcedil", "\u0163"),
        _Utils_Tuple2("Tcy", "\u0422"),
        _Utils_Tuple2("tcy", "\u0442"),
        _Utils_Tuple2("tdot", "\u20DB"),
        _Utils_Tuple2("telrec", "\u2315"),
        _Utils_Tuple2("Tfr", "\uD835\uDD17"),
        _Utils_Tuple2("tfr", "\uD835\uDD31"),
        _Utils_Tuple2("there4", "\u2234"),
        _Utils_Tuple2("therefore", "\u2234"),
        _Utils_Tuple2("Therefore", "\u2234"),
        _Utils_Tuple2("Theta", "\u0398"),
        _Utils_Tuple2("theta", "\u03B8"),
        _Utils_Tuple2("thetasym", "\u03D1"),
        _Utils_Tuple2("thetav", "\u03D1"),
        _Utils_Tuple2("thickapprox", "\u2248"),
        _Utils_Tuple2("thicksim", "\u223C"),
        _Utils_Tuple2("ThickSpace", "\u205F\u200A"),
        _Utils_Tuple2("ThinSpace", "\u2009"),
        _Utils_Tuple2("thinsp", "\u2009"),
        _Utils_Tuple2("thkap", "\u2248"),
        _Utils_Tuple2("thksim", "\u223C"),
        _Utils_Tuple2("THORN", "\u00DE"),
        _Utils_Tuple2("thorn", "\u00FE"),
        _Utils_Tuple2("tilde", "\u02DC"),
        _Utils_Tuple2("Tilde", "\u223C"),
        _Utils_Tuple2("TildeEqual", "\u2243"),
        _Utils_Tuple2("TildeFullEqual", "\u2245"),
        _Utils_Tuple2("TildeTilde", "\u2248"),
        _Utils_Tuple2("timesbar", "\u2A31"),
        _Utils_Tuple2("timesb", "\u22A0"),
        _Utils_Tuple2("times", "\u00D7"),
        _Utils_Tuple2("timesd", "\u2A30"),
        _Utils_Tuple2("tint", "\u222D"),
        _Utils_Tuple2("toea", "\u2928"),
        _Utils_Tuple2("topbot", "\u2336"),
        _Utils_Tuple2("topcir", "\u2AF1"),
        _Utils_Tuple2("top", "\u22A4"),
        _Utils_Tuple2("Topf", "\uD835\uDD4B"),
        _Utils_Tuple2("topf", "\uD835\uDD65"),
        _Utils_Tuple2("topfork", "\u2ADA"),
        _Utils_Tuple2("tosa", "\u2929"),
        _Utils_Tuple2("tprime", "\u2034"),
        _Utils_Tuple2("trade", "\u2122"),
        _Utils_Tuple2("TRADE", "\u2122"),
        _Utils_Tuple2("triangle", "\u25B5"),
        _Utils_Tuple2("triangledown", "\u25BF"),
        _Utils_Tuple2("triangleleft", "\u25C3"),
        _Utils_Tuple2("trianglelefteq", "\u22B4"),
        _Utils_Tuple2("triangleq", "\u225C"),
        _Utils_Tuple2("triangleright", "\u25B9"),
        _Utils_Tuple2("trianglerighteq", "\u22B5"),
        _Utils_Tuple2("tridot", "\u25EC"),
        _Utils_Tuple2("trie", "\u225C"),
        _Utils_Tuple2("triminus", "\u2A3A"),
        _Utils_Tuple2("TripleDot", "\u20DB"),
        _Utils_Tuple2("triplus", "\u2A39"),
        _Utils_Tuple2("trisb", "\u29CD"),
        _Utils_Tuple2("tritime", "\u2A3B"),
        _Utils_Tuple2("trpezium", "\u23E2"),
        _Utils_Tuple2("Tscr", "\uD835\uDCAF"),
        _Utils_Tuple2("tscr", "\uD835\uDCC9"),
        _Utils_Tuple2("TScy", "\u0426"),
        _Utils_Tuple2("tscy", "\u0446"),
        _Utils_Tuple2("TSHcy", "\u040B"),
        _Utils_Tuple2("tshcy", "\u045B"),
        _Utils_Tuple2("Tstrok", "\u0166"),
        _Utils_Tuple2("tstrok", "\u0167"),
        _Utils_Tuple2("twixt", "\u226C"),
        _Utils_Tuple2("twoheadleftarrow", "\u219E"),
        _Utils_Tuple2("twoheadrightarrow", "\u21A0"),
        _Utils_Tuple2("Uacute", "\u00DA"),
        _Utils_Tuple2("uacute", "\u00FA"),
        _Utils_Tuple2("uarr", "\u2191"),
        _Utils_Tuple2("Uarr", "\u219F"),
        _Utils_Tuple2("uArr", "\u21D1"),
        _Utils_Tuple2("Uarrocir", "\u2949"),
        _Utils_Tuple2("Ubrcy", "\u040E"),
        _Utils_Tuple2("ubrcy", "\u045E"),
        _Utils_Tuple2("Ubreve", "\u016C"),
        _Utils_Tuple2("ubreve", "\u016D"),
        _Utils_Tuple2("Ucirc", "\u00DB"),
        _Utils_Tuple2("ucirc", "\u00FB"),
        _Utils_Tuple2("Ucy", "\u0423"),
        _Utils_Tuple2("ucy", "\u0443"),
        _Utils_Tuple2("udarr", "\u21C5"),
        _Utils_Tuple2("Udblac", "\u0170"),
        _Utils_Tuple2("udblac", "\u0171"),
        _Utils_Tuple2("udhar", "\u296E"),
        _Utils_Tuple2("ufisht", "\u297E"),
        _Utils_Tuple2("Ufr", "\uD835\uDD18"),
        _Utils_Tuple2("ufr", "\uD835\uDD32"),
        _Utils_Tuple2("Ugrave", "\u00D9"),
        _Utils_Tuple2("ugrave", "\u00F9"),
        _Utils_Tuple2("uHar", "\u2963"),
        _Utils_Tuple2("uharl", "\u21BF"),
        _Utils_Tuple2("uharr", "\u21BE"),
        _Utils_Tuple2("uhblk", "\u2580"),
        _Utils_Tuple2("ulcorn", "\u231C"),
        _Utils_Tuple2("ulcorner", "\u231C"),
        _Utils_Tuple2("ulcrop", "\u230F"),
        _Utils_Tuple2("ultri", "\u25F8"),
        _Utils_Tuple2("Umacr", "\u016A"),
        _Utils_Tuple2("umacr", "\u016B"),
        _Utils_Tuple2("uml", "\u00A8"),
        _Utils_Tuple2("UnderBar", "_"),
        _Utils_Tuple2("UnderBrace", "\u23DF"),
        _Utils_Tuple2("UnderBracket", "\u23B5"),
        _Utils_Tuple2("UnderParenthesis", "\u23DD"),
        _Utils_Tuple2("Union", "\u22C3"),
        _Utils_Tuple2("UnionPlus", "\u228E"),
        _Utils_Tuple2("Uogon", "\u0172"),
        _Utils_Tuple2("uogon", "\u0173"),
        _Utils_Tuple2("Uopf", "\uD835\uDD4C"),
        _Utils_Tuple2("uopf", "\uD835\uDD66"),
        _Utils_Tuple2("UpArrowBar", "\u2912"),
        _Utils_Tuple2("uparrow", "\u2191"),
        _Utils_Tuple2("UpArrow", "\u2191"),
        _Utils_Tuple2("Uparrow", "\u21D1"),
        _Utils_Tuple2("UpArrowDownArrow", "\u21C5"),
        _Utils_Tuple2("updownarrow", "\u2195"),
        _Utils_Tuple2("UpDownArrow", "\u2195"),
        _Utils_Tuple2("Updownarrow", "\u21D5"),
        _Utils_Tuple2("UpEquilibrium", "\u296E"),
        _Utils_Tuple2("upharpoonleft", "\u21BF"),
        _Utils_Tuple2("upharpoonright", "\u21BE"),
        _Utils_Tuple2("uplus", "\u228E"),
        _Utils_Tuple2("UpperLeftArrow", "\u2196"),
        _Utils_Tuple2("UpperRightArrow", "\u2197"),
        _Utils_Tuple2("upsi", "\u03C5"),
        _Utils_Tuple2("Upsi", "\u03D2"),
        _Utils_Tuple2("upsih", "\u03D2"),
        _Utils_Tuple2("Upsilon", "\u03A5"),
        _Utils_Tuple2("upsilon", "\u03C5"),
        _Utils_Tuple2("UpTeeArrow", "\u21A5"),
        _Utils_Tuple2("UpTee", "\u22A5"),
        _Utils_Tuple2("upuparrows", "\u21C8"),
        _Utils_Tuple2("urcorn", "\u231D"),
        _Utils_Tuple2("urcorner", "\u231D"),
        _Utils_Tuple2("urcrop", "\u230E"),
        _Utils_Tuple2("Uring", "\u016E"),
        _Utils_Tuple2("uring", "\u016F"),
        _Utils_Tuple2("urtri", "\u25F9"),
        _Utils_Tuple2("Uscr", "\uD835\uDCB0"),
        _Utils_Tuple2("uscr", "\uD835\uDCCA"),
        _Utils_Tuple2("utdot", "\u22F0"),
        _Utils_Tuple2("Utilde", "\u0168"),
        _Utils_Tuple2("utilde", "\u0169"),
        _Utils_Tuple2("utri", "\u25B5"),
        _Utils_Tuple2("utrif", "\u25B4"),
        _Utils_Tuple2("uuarr", "\u21C8"),
        _Utils_Tuple2("Uuml", "\u00DC"),
        _Utils_Tuple2("uuml", "\u00FC"),
        _Utils_Tuple2("uwangle", "\u29A7"),
        _Utils_Tuple2("vangrt", "\u299C"),
        _Utils_Tuple2("varepsilon", "\u03F5"),
        _Utils_Tuple2("varkappa", "\u03F0"),
        _Utils_Tuple2("varnothing", "\u2205"),
        _Utils_Tuple2("varphi", "\u03D5"),
        _Utils_Tuple2("varpi", "\u03D6"),
        _Utils_Tuple2("varpropto", "\u221D"),
        _Utils_Tuple2("varr", "\u2195"),
        _Utils_Tuple2("vArr", "\u21D5"),
        _Utils_Tuple2("varrho", "\u03F1"),
        _Utils_Tuple2("varsigma", "\u03C2"),
        _Utils_Tuple2("varsubsetneq", "\u228A\uFE00"),
        _Utils_Tuple2("varsubsetneqq", "\u2ACB\uFE00"),
        _Utils_Tuple2("varsupsetneq", "\u228B\uFE00"),
        _Utils_Tuple2("varsupsetneqq", "\u2ACC\uFE00"),
        _Utils_Tuple2("vartheta", "\u03D1"),
        _Utils_Tuple2("vartriangleleft", "\u22B2"),
        _Utils_Tuple2("vartriangleright", "\u22B3"),
        _Utils_Tuple2("vBar", "\u2AE8"),
        _Utils_Tuple2("Vbar", "\u2AEB"),
        _Utils_Tuple2("vBarv", "\u2AE9"),
        _Utils_Tuple2("Vcy", "\u0412"),
        _Utils_Tuple2("vcy", "\u0432"),
        _Utils_Tuple2("vdash", "\u22A2"),
        _Utils_Tuple2("vDash", "\u22A8"),
        _Utils_Tuple2("Vdash", "\u22A9"),
        _Utils_Tuple2("VDash", "\u22AB"),
        _Utils_Tuple2("Vdashl", "\u2AE6"),
        _Utils_Tuple2("veebar", "\u22BB"),
        _Utils_Tuple2("vee", "\u2228"),
        _Utils_Tuple2("Vee", "\u22C1"),
        _Utils_Tuple2("veeeq", "\u225A"),
        _Utils_Tuple2("vellip", "\u22EE"),
        _Utils_Tuple2("verbar", "|"),
        _Utils_Tuple2("Verbar", "\u2016"),
        _Utils_Tuple2("vert", "|"),
        _Utils_Tuple2("Vert", "\u2016"),
        _Utils_Tuple2("VerticalBar", "\u2223"),
        _Utils_Tuple2("VerticalLine", "|"),
        _Utils_Tuple2("VerticalSeparator", "\u2758"),
        _Utils_Tuple2("VerticalTilde", "\u2240"),
        _Utils_Tuple2("VeryThinSpace", "\u200A"),
        _Utils_Tuple2("Vfr", "\uD835\uDD19"),
        _Utils_Tuple2("vfr", "\uD835\uDD33"),
        _Utils_Tuple2("vltri", "\u22B2"),
        _Utils_Tuple2("vnsub", "\u2282\u20D2"),
        _Utils_Tuple2("vnsup", "\u2283\u20D2"),
        _Utils_Tuple2("Vopf", "\uD835\uDD4D"),
        _Utils_Tuple2("vopf", "\uD835\uDD67"),
        _Utils_Tuple2("vprop", "\u221D"),
        _Utils_Tuple2("vrtri", "\u22B3"),
        _Utils_Tuple2("Vscr", "\uD835\uDCB1"),
        _Utils_Tuple2("vscr", "\uD835\uDCCB"),
        _Utils_Tuple2("vsubnE", "\u2ACB\uFE00"),
        _Utils_Tuple2("vsubne", "\u228A\uFE00"),
        _Utils_Tuple2("vsupnE", "\u2ACC\uFE00"),
        _Utils_Tuple2("vsupne", "\u228B\uFE00"),
        _Utils_Tuple2("Vvdash", "\u22AA"),
        _Utils_Tuple2("vzigzag", "\u299A"),
        _Utils_Tuple2("Wcirc", "\u0174"),
        _Utils_Tuple2("wcirc", "\u0175"),
        _Utils_Tuple2("wedbar", "\u2A5F"),
        _Utils_Tuple2("wedge", "\u2227"),
        _Utils_Tuple2("Wedge", "\u22C0"),
        _Utils_Tuple2("wedgeq", "\u2259"),
        _Utils_Tuple2("weierp", "\u2118"),
        _Utils_Tuple2("Wfr", "\uD835\uDD1A"),
        _Utils_Tuple2("wfr", "\uD835\uDD34"),
        _Utils_Tuple2("Wopf", "\uD835\uDD4E"),
        _Utils_Tuple2("wopf", "\uD835\uDD68"),
        _Utils_Tuple2("wp", "\u2118"),
        _Utils_Tuple2("wr", "\u2240"),
        _Utils_Tuple2("wreath", "\u2240"),
        _Utils_Tuple2("Wscr", "\uD835\uDCB2"),
        _Utils_Tuple2("wscr", "\uD835\uDCCC"),
        _Utils_Tuple2("xcap", "\u22C2"),
        _Utils_Tuple2("xcirc", "\u25EF"),
        _Utils_Tuple2("xcup", "\u22C3"),
        _Utils_Tuple2("xdtri", "\u25BD"),
        _Utils_Tuple2("Xfr", "\uD835\uDD1B"),
        _Utils_Tuple2("xfr", "\uD835\uDD35"),
        _Utils_Tuple2("xharr", "\u27F7"),
        _Utils_Tuple2("xhArr", "\u27FA"),
        _Utils_Tuple2("Xi", "\u039E"),
        _Utils_Tuple2("xi", "\u03BE"),
        _Utils_Tuple2("xlarr", "\u27F5"),
        _Utils_Tuple2("xlArr", "\u27F8"),
        _Utils_Tuple2("xmap", "\u27FC"),
        _Utils_Tuple2("xnis", "\u22FB"),
        _Utils_Tuple2("xodot", "\u2A00"),
        _Utils_Tuple2("Xopf", "\uD835\uDD4F"),
        _Utils_Tuple2("xopf", "\uD835\uDD69"),
        _Utils_Tuple2("xoplus", "\u2A01"),
        _Utils_Tuple2("xotime", "\u2A02"),
        _Utils_Tuple2("xrarr", "\u27F6"),
        _Utils_Tuple2("xrArr", "\u27F9"),
        _Utils_Tuple2("Xscr", "\uD835\uDCB3"),
        _Utils_Tuple2("xscr", "\uD835\uDCCD"),
        _Utils_Tuple2("xsqcup", "\u2A06"),
        _Utils_Tuple2("xuplus", "\u2A04"),
        _Utils_Tuple2("xutri", "\u25B3"),
        _Utils_Tuple2("xvee", "\u22C1"),
        _Utils_Tuple2("xwedge", "\u22C0"),
        _Utils_Tuple2("Yacute", "\u00DD"),
        _Utils_Tuple2("yacute", "\u00FD"),
        _Utils_Tuple2("YAcy", "\u042F"),
        _Utils_Tuple2("yacy", "\u044F"),
        _Utils_Tuple2("Ycirc", "\u0176"),
        _Utils_Tuple2("ycirc", "\u0177"),
        _Utils_Tuple2("Ycy", "\u042B"),
        _Utils_Tuple2("ycy", "\u044B"),
        _Utils_Tuple2("yen", "\u00A5"),
        _Utils_Tuple2("Yfr", "\uD835\uDD1C"),
        _Utils_Tuple2("yfr", "\uD835\uDD36"),
        _Utils_Tuple2("YIcy", "\u0407"),
        _Utils_Tuple2("yicy", "\u0457"),
        _Utils_Tuple2("Yopf", "\uD835\uDD50"),
        _Utils_Tuple2("yopf", "\uD835\uDD6A"),
        _Utils_Tuple2("Yscr", "\uD835\uDCB4"),
        _Utils_Tuple2("yscr", "\uD835\uDCCE"),
        _Utils_Tuple2("YUcy", "\u042E"),
        _Utils_Tuple2("yucy", "\u044E"),
        _Utils_Tuple2("yuml", "\u00FF"),
        _Utils_Tuple2("Yuml", "\u0178"),
        _Utils_Tuple2("Zacute", "\u0179"),
        _Utils_Tuple2("zacute", "\u017A"),
        _Utils_Tuple2("Zcaron", "\u017D"),
        _Utils_Tuple2("zcaron", "\u017E"),
        _Utils_Tuple2("Zcy", "\u0417"),
        _Utils_Tuple2("zcy", "\u0437"),
        _Utils_Tuple2("Zdot", "\u017B"),
        _Utils_Tuple2("zdot", "\u017C"),
        _Utils_Tuple2("zeetrf", "\u2128"),
        _Utils_Tuple2("ZeroWidthSpace", "\u200B"),
        _Utils_Tuple2("Zeta", "\u0396"),
        _Utils_Tuple2("zeta", "\u03B6"),
        _Utils_Tuple2("zfr", "\uD835\uDD37"),
        _Utils_Tuple2("Zfr", "\u2128"),
        _Utils_Tuple2("ZHcy", "\u0416"),
        _Utils_Tuple2("zhcy", "\u0436"),
        _Utils_Tuple2("zigrarr", "\u21DD"),
        _Utils_Tuple2("zopf", "\uD835\uDD6B"),
        _Utils_Tuple2("Zopf", "\u2124"),
        _Utils_Tuple2("Zscr", "\uD835\uDCB5"),
        _Utils_Tuple2("zscr", "\uD835\uDCCF"),
        _Utils_Tuple2("zwj", "\u200D"),
        _Utils_Tuple2("zwnj", "\u200C")
    ]));
    var $hecrj$html_parser$Html$Parser$namedCharacterReference = $elm$parser$Parser$Advanced$map_fn(function (reference) {
        return $elm$core$Maybe$withDefault_fn("&" + (reference + ";"), $elm$core$Dict$get_fn(reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
    }, $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
    var $elm$core$Basics$pow = _Basics_pow;
    var $rtfeldman$elm_hex$Hex$fromStringHelp_fn = function (position, chars, accumulated) {
        fromStringHelp: while (true) {
            if (!chars.b) {
                return $elm$core$Result$Ok(accumulated);
            }
            else {
                var _char = chars.a;
                var rest = chars.b;
                switch (_char) {
                    case "0":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated;
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "1":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + _Basics_pow_fn(16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "2":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (2 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "3":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (3 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "4":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (4 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "5":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (5 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "6":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (6 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "7":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (7 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "8":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (8 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "9":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (9 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "a":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (10 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "b":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (11 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "c":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (12 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "d":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (13 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "e":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (14 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "f":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (15 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    default:
                        var nonHex = _char;
                        return $elm$core$Result$Err($elm$core$String$fromChar(nonHex) + " is not a valid hexadecimal character.");
                }
            }
        }
    }, $rtfeldman$elm_hex$Hex$fromStringHelp = F3($rtfeldman$elm_hex$Hex$fromStringHelp_fn);
    var $elm$core$List$tail = function (list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just(xs);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $rtfeldman$elm_hex$Hex$fromString = function (str) {
        if ($elm$core$String$isEmpty(str)) {
            return $elm$core$Result$Err("Empty strings are not valid hexadecimal strings.");
        }
        else {
            var result = function () {
                if (_String_startsWith_fn("-", str)) {
                    var list = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$List$tail($elm$core$String$toList(str)));
                    return $elm$core$Result$map_fn($elm$core$Basics$negate, $rtfeldman$elm_hex$Hex$fromStringHelp_fn($elm$core$List$length(list) - 1, list, 0));
                }
                else {
                    return $rtfeldman$elm_hex$Hex$fromStringHelp_fn($elm$core$String$length(str) - 1, $elm$core$String$toList(str), 0);
                }
            }();
            var formatError = function (err) {
                return $elm$core$String$join_fn(" ", _List_fromArray(["\"" + (str + "\""), "is not a valid hexadecimal string because", err]));
            };
            return $elm$core$Result$mapError_fn(formatError, result);
        }
    };
    var $elm$core$Char$isHexDigit = function (_char) {
        var code = $elm$core$Char$toCode(_char);
        return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
    };
    var $hecrj$html_parser$Html$Parser$hexadecimal = $elm$parser$Parser$Advanced$andThen_fn(function (hex) {
        var _v0 = $rtfeldman$elm_hex$Hex$fromString($elm$core$String$toLower(hex));
        if (!_v0.$) {
            var value = _v0.a;
            return $elm$parser$Parser$succeed(value);
        }
        else {
            var error = _v0.a;
            return $elm$parser$Parser$problem(error);
        }
    }, $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
    var $elm$parser$Parser$ExpectingInt = { $: 1 };
    var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
    var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
    var $elm$parser$Parser$Advanced$bumpOffset_fn = function (newOffset, s) {
        return { kQ: s.kQ + (newOffset - s.nt), h: s.h, i: s.i, nt: newOffset, of: s.of, oM: s.oM };
    }, $elm$parser$Parser$Advanced$bumpOffset = F2($elm$parser$Parser$Advanced$bumpOffset_fn);
    var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
    var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
    var $elm$parser$Parser$Advanced$consumeExp_fn = function (offset, src) {
        if (_Parser_isAsciiCode_fn(101, offset, src) || _Parser_isAsciiCode_fn(69, offset, src)) {
            var eOffset = offset + 1;
            var expOffset = (_Parser_isAsciiCode_fn(43, eOffset, src) || _Parser_isAsciiCode_fn(45, eOffset, src)) ? (eOffset + 1) : eOffset;
            var newOffset = _Parser_chompBase10_fn(expOffset, src);
            return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
        }
        else {
            return offset;
        }
    }, $elm$parser$Parser$Advanced$consumeExp = F2($elm$parser$Parser$Advanced$consumeExp_fn);
    var $elm$parser$Parser$Advanced$consumeDotAndExp_fn = function (offset, src) {
        return _Parser_isAsciiCode_fn(46, offset, src) ? $elm$parser$Parser$Advanced$consumeExp_fn(_Parser_chompBase10_fn(offset + 1, src), src) : $elm$parser$Parser$Advanced$consumeExp_fn(offset, src);
    }, $elm$parser$Parser$Advanced$consumeDotAndExp = F2($elm$parser$Parser$Advanced$consumeDotAndExp_fn);
    var $elm$parser$Parser$Advanced$finalizeInt_fn = function (invalid, handler, startOffset, _v0, s) {
        var endOffset = _v0.a;
        var n = _v0.b;
        if (handler.$ === 1) {
            var x = handler.a;
            return $elm$parser$Parser$Advanced$Bad_fn(true, $elm$parser$Parser$Advanced$fromState_fn(s, x));
        }
        else {
            var toValue = handler.a;
            return _Utils_eq(startOffset, endOffset) ? $elm$parser$Parser$Advanced$Bad_fn(_Utils_cmp(s.nt, startOffset) < 0, $elm$parser$Parser$Advanced$fromState_fn(s, invalid)) : $elm$parser$Parser$Advanced$Good_fn(true, toValue(n), $elm$parser$Parser$Advanced$bumpOffset_fn(endOffset, s));
        }
    }, $elm$parser$Parser$Advanced$finalizeInt = F5($elm$parser$Parser$Advanced$finalizeInt_fn);
    var $elm$parser$Parser$Advanced$finalizeFloat_fn = function (invalid, expecting, intSettings, floatSettings, intPair, s) {
        var intOffset = intPair.a;
        var floatOffset = $elm$parser$Parser$Advanced$consumeDotAndExp_fn(intOffset, s.oM);
        if (floatOffset < 0) {
            return $elm$parser$Parser$Advanced$Bad_fn(true, $elm$parser$Parser$Advanced$fromInfo_fn(s.of, s.kQ - (floatOffset + s.nt), invalid, s.h));
        }
        else {
            if (_Utils_eq(s.nt, floatOffset)) {
                return $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, expecting));
            }
            else {
                if (_Utils_eq(intOffset, floatOffset)) {
                    return $elm$parser$Parser$Advanced$finalizeInt_fn(invalid, intSettings, s.nt, intPair, s);
                }
                else {
                    if (floatSettings.$ === 1) {
                        var x = floatSettings.a;
                        return $elm$parser$Parser$Advanced$Bad_fn(true, $elm$parser$Parser$Advanced$fromState_fn(s, invalid));
                    }
                    else {
                        var toValue = floatSettings.a;
                        var _v1 = $elm$core$String$toFloat(_String_slice_fn(s.nt, floatOffset, s.oM));
                        if (_v1.$ === 1) {
                            return $elm$parser$Parser$Advanced$Bad_fn(true, $elm$parser$Parser$Advanced$fromState_fn(s, invalid));
                        }
                        else {
                            var n = _v1.a;
                            return $elm$parser$Parser$Advanced$Good_fn(true, toValue(n), $elm$parser$Parser$Advanced$bumpOffset_fn(floatOffset, s));
                        }
                    }
                }
            }
        }
    }, $elm$parser$Parser$Advanced$finalizeFloat = F6($elm$parser$Parser$Advanced$finalizeFloat_fn);
    var $elm$parser$Parser$Advanced$number = function (c) {
        return function (s) {
            if (_Parser_isAsciiCode_fn(48, s.nt, s.oM)) {
                var zeroOffset = s.nt + 1;
                var baseOffset = zeroOffset + 1;
                return _Parser_isAsciiCode_fn(120, zeroOffset, s.oM) ? $elm$parser$Parser$Advanced$finalizeInt_fn(c.mo, c.lZ, baseOffset, _Parser_consumeBase16_fn(baseOffset, s.oM), s) : (_Parser_isAsciiCode_fn(111, zeroOffset, s.oM) ? $elm$parser$Parser$Advanced$finalizeInt_fn(c.mo, c.is, baseOffset, _Parser_consumeBase_fn(8, baseOffset, s.oM), s) : (_Parser_isAsciiCode_fn(98, zeroOffset, s.oM) ? $elm$parser$Parser$Advanced$finalizeInt_fn(c.mo, c.gO, baseOffset, _Parser_consumeBase_fn(2, baseOffset, s.oM), s) : $elm$parser$Parser$Advanced$finalizeFloat_fn(c.mo, c.hm, c.hU, c.hu, _Utils_Tuple2(zeroOffset, 0), s)));
            }
            else {
                return $elm$parser$Parser$Advanced$finalizeFloat_fn(c.mo, c.hm, c.hU, c.hu, _Parser_consumeBase_fn(10, s.nt, s.oM), s);
            }
        };
    };
    var $elm$parser$Parser$Advanced$int_fn = function (expecting, invalid) {
        return $elm$parser$Parser$Advanced$number({
            gO: $elm$core$Result$Err(invalid),
            hm: expecting,
            hu: $elm$core$Result$Err(invalid),
            lZ: $elm$core$Result$Err(invalid),
            hU: $elm$core$Result$Ok($elm$core$Basics$identity),
            mo: invalid,
            is: $elm$core$Result$Err(invalid)
        });
    }, $elm$parser$Parser$Advanced$int = F2($elm$parser$Parser$Advanced$int_fn);
    var $elm$parser$Parser$int = $elm$parser$Parser$Advanced$int_fn($elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
    var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
        var codepoint = $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$chompIf(function (c) {
                return (c === "x") || (c === "X");
            })), $hecrj$html_parser$Html$Parser$hexadecimal),
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$chompWhile($elm$core$Basics$eq("0"))), $elm$parser$Parser$int)
        ]));
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$chompIf($elm$core$Basics$eq("#"))), $elm$parser$Parser$Advanced$map_fn(A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar), codepoint));
    }();
    var $hecrj$html_parser$Html$Parser$characterReference = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$chompIf($elm$core$Basics$eq("&"))), $elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference), $hecrj$html_parser$Html$Parser$chompSemicolon),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference), $hecrj$html_parser$Html$Parser$chompSemicolon),
        $elm$parser$Parser$succeed("&")
    ])));
    var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
        var isQuotedValueChar = function (c) {
            return (!_Utils_eq(c, quote)) && (c !== "&");
        };
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$chompIf($elm$core$Basics$eq(quote))), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$map_fn($elm$core$String$join(""), $hecrj$html_parser$Html$Parser$many($elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
            $hecrj$html_parser$Html$Parser$characterReference
        ])))), $elm$parser$Parser$chompIf($elm$core$Basics$eq(quote))));
    };
    var $hecrj$html_parser$Html$Parser$oneOrMore_fn = function (type_, parser_) {
        return $elm$parser$Parser$loop_fn(_List_Nil, function (list) {
            return $elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$map_fn(function (_new) {
                    return $elm$parser$Parser$Loop(_List_Cons(_new, list));
                }, parser_),
                $elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem("expecting at least one " + type_) : $elm$parser$Parser$succeed($elm$parser$Parser$Done($elm$core$List$reverse(list)))
            ]));
        });
    }, $hecrj$html_parser$Html$Parser$oneOrMore = F2($hecrj$html_parser$Html$Parser$oneOrMore_fn);
    var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
        var isUnquotedValueChar = function (c) {
            return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== "\"") && ((c !== "'") && ((c !== "=") && ((c !== "<") && ((c !== ">") && ((c !== "`") && (c !== "&")))))));
        };
        return $elm$parser$Parser$Advanced$map_fn($elm$core$String$join(""), $hecrj$html_parser$Html$Parser$oneOrMore_fn("attribute value", $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
            $hecrj$html_parser$Html$Parser$characterReference
        ]))));
    }();
    var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$chompIf($elm$core$Basics$eq("="))), $elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)), $elm$parser$Parser$oneOf(_List_fromArray([
            $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
            $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue("\""),
            $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue("'")
        ]))),
        $elm$parser$Parser$succeed("")
    ]));
    var $hecrj$html_parser$Html$Parser$tagAttribute = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed($elm$core$Tuple$pair), $elm$parser$Parser$Advanced$ignorer_fn($hecrj$html_parser$Html$Parser$tagAttributeName, $elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))), $elm$parser$Parser$Advanced$ignorer_fn($hecrj$html_parser$Html$Parser$tagAttributeValue, $elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
    var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
    var $hecrj$html_parser$Html$Parser$tagName = $elm$parser$Parser$Advanced$map_fn($elm$core$String$toLower, $elm$parser$Parser$getChompedString($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum), $elm$parser$Parser$chompWhile(function (c) {
        return $elm$core$Char$isAlphaNum(c) || (c === "-");
    }))));
    var $hecrj$html_parser$Html$Parser$Text = function (a) {
        return { $: 0, a: a };
    };
    var $hecrj$html_parser$Html$Parser$text = $elm$parser$Parser$Advanced$map_fn(A2($elm$core$Basics$composeR, $elm$core$String$join(""), $hecrj$html_parser$Html$Parser$Text), $hecrj$html_parser$Html$Parser$oneOrMore_fn("text element", $elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore(function (c) {
            return (c !== "<") && (c !== "&");
        })),
        $hecrj$html_parser$Html$Parser$characterReference
    ]))));
    function $hecrj$html_parser$Html$Parser$cyclic$node() {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $hecrj$html_parser$Html$Parser$text,
            $hecrj$html_parser$Html$Parser$comment,
            $hecrj$html_parser$Html$Parser$cyclic$element()
        ]));
    }
    function $hecrj$html_parser$Html$Parser$cyclic$element() {
        return $elm$parser$Parser$Advanced$andThen_fn(function (_v0) {
            var name = _v0.a;
            var attributes = _v0.b;
            return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($hecrj$html_parser$Html$Parser$Element_fn(name, attributes, _List_Nil)), $elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$chompIf($elm$core$Basics$eq("/")),
                $elm$parser$Parser$succeed(0)
            ]))), $elm$parser$Parser$chompIf($elm$core$Basics$eq(">"))) : $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed(A2($hecrj$html_parser$Html$Parser$Element, name, attributes)), $elm$parser$Parser$chompIf($elm$core$Basics$eq(">"))), $elm$parser$Parser$Advanced$ignorer_fn($hecrj$html_parser$Html$Parser$many($elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$cyclic$node())), $hecrj$html_parser$Html$Parser$closingTag(name)));
        }, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Tuple$pair), $elm$parser$Parser$chompIf($elm$core$Basics$eq("<"))), $elm$parser$Parser$Advanced$ignorer_fn($hecrj$html_parser$Html$Parser$tagName, $elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))), $hecrj$html_parser$Html$Parser$tagAttributes));
    }
    var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
    $hecrj$html_parser$Html$Parser$cyclic$node = function () {
        return $hecrj$html_parser$Html$Parser$node;
    };
    var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
    $hecrj$html_parser$Html$Parser$cyclic$element = function () {
        return $hecrj$html_parser$Html$Parser$element;
    };
    var $hecrj$html_parser$Html$Parser$run = function (str) {
        return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : $elm$parser$Parser$run_fn($hecrj$html_parser$Html$Parser$oneOrMore_fn("node", $hecrj$html_parser$Html$Parser$node), str);
    };
    var $author$project$Util$Conference$stringUntil_fn = function (delimiter, str) {
        return $elm$core$Maybe$withDefault_fn("", $elm$core$List$head($elm$core$String$split_fn(delimiter, str)));
    }, $author$project$Util$Conference$stringUntil = F2($author$project$Util$Conference$stringUntil_fn);
    var $author$project$Util$Conference$parseDescription = function (description) {
        var hostnameMatches = $author$project$Util$Conference$parseHostnames(description);
        var conferencingLinks = $elm$core$List$filterMap_fn(function (match) {
            var domain = $elm$core$Maybe$withDefault_fn("", $elm$core$List$head($elm$core$List$filterMap_fn($elm$core$Basics$identity, match.o$)));
            var conferenceType = $author$project$Util$Conference$detectConferenceType(domain);
            return (_Utils_eq(conferenceType, $elm$core$Maybe$Just(3)) && (_String_contains_fn("/cancellations", match.by) || _String_contains_fn("/reschedulings", match.by))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$map_fn(function (tipe) {
                return _Utils_Tuple2(match.by, tipe);
            }, conferenceType);
        }, hostnameMatches);
        var firstConferenceLink = $elm$core$List$head(conferencingLinks);
        var cleanDescriptionWith = function (cleaner) {
            var _v8 = $hecrj$html_parser$Html$Parser$run(description);
            _v8$2: while (true) {
                if ((!_v8.$) && _v8.a.b) {
                    switch (_v8.a.a.$) {
                        case 1:
                            var _v9 = _v8.a;
                            var _v10 = _v9.a;
                            return description;
                        case 2:
                            var _v11 = _v8.a;
                            return description;
                        default:
                            break _v8$2;
                    }
                }
                else {
                    break _v8$2;
                }
            }
            return cleaner(description);
        };
        var _v0 = function () {
            var _v1 = $elm$core$Maybe$map_fn($elm$core$Tuple$second, firstConferenceLink);
            if (_v1.$ === 1) {
                return _Utils_Tuple2(description, $elm$core$Maybe$Nothing);
            }
            else {
                switch (_v1.a) {
                    case 0:
                        var _v2 = _v1.a;
                        return _Utils_Tuple2(cleanDescriptionWith($author$project$Util$Conference$stringUntil($elm$core$String$repeat_fn(80, "_"))), $author$project$Util$Conference$parseTeamsPhone(description));
                    case 1:
                        var _v3 = _v1.a;
                        return _Utils_Tuple2(cleanDescriptionWith($author$project$Util$Conference$stringUntil($elm$core$String$repeat_fn(136, "."))), $author$project$Util$Conference$parseFirstPhoneHash(description));
                    case 2:
                        var _v4 = _v1.a;
                        return _Utils_Tuple2(cleanDescriptionWith(A2($elm$core$Basics$composeR, $author$project$Util$Conference$stringUntil("Join Zoom Meeting"), $author$project$Util$Conference$stringUntil("Location:"))), $author$project$Util$Conference$parseCalendlyZoomPhone(description));
                    case 3:
                        var _v5 = _v1.a;
                        return _Utils_Tuple2(description, $author$project$Util$Conference$parseCalendlyZoomPhone(description));
                    case 4:
                        var _v6 = _v1.a;
                        return _Utils_Tuple2(description, $elm$core$Maybe$Nothing);
                    default:
                        var _v7 = _v1.a;
                        return _Utils_Tuple2(description, $elm$core$Maybe$Nothing);
                }
            }
        }();
        var cleanedDescription = _v0.a;
        var confPhone = _v0.b;
        return (new $$Record65(confPhone, $elm$core$Maybe$map_fn($elm$core$Tuple$first, firstConferenceLink), cleanedDescription));
    };
    var $author$project$Util$Conference$extractNoteAndCallInfo = function (event) {
        var result = $author$project$Util$Conference$parseDescription(event.fc);
        var _v0 = _Utils_Tuple2(result.e5, result.e4);
        if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
            var _v1 = _v0.a;
            var _v2 = _v0.b;
            var _v3 = $author$project$Util$Conference$getConferenceData(event.kX);
            var video = _v3.eT;
            var phone = _v3.el;
            return (new $$Record65(phone, video, result.fc));
        }
        else {
            var confUrl = _v0.a;
            var confPhone = _v0.b;
            return (new $$Record65(confPhone, confUrl, result.fc));
        }
    };
    var $author$project$Util$Misc$toNonEmptyString = function (str) {
        return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
    };
    var $author$project$Data$Event$fromGCalEventHelp_fn = function (event, tipe) {
        var responseStatus = $elm$core$Maybe$withDefault_fn(3, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.ew;
        }, $author$project$Data$Event$responseStatusFromString), $elm$core$List$head($elm$core$List$filter_fn(function ($) {
            return $.os;
        }, event.ke))));
        var _v0 = $author$project$Util$Conference$extractNoteAndCallInfo(event);
        var description = _v0.fc;
        var confUrl = _v0.e5;
        var confPhone = _v0.e4;
        return (new $$Record67($elm$core$List$map_fn(function (a) {
            return (new $$Record66(a.cS, a.g7, a.ev, $author$project$Data$Event$responseStatusFromString(a.ew)));
        }, event.ke), event.kT, confPhone, confUrl, event.oP === "cancelled", description, event.b6, $author$project$Util$Misc$toNonEmptyString(event.l4), event.l8, (new $$Record66(event.c8.cS, event.c8.g7, false, 0)), responseStatus, event.bF, tipe, event.o4, event.dr));
    }, $author$project$Data$Event$fromGCalEventHelp = F2($author$project$Data$Event$fromGCalEventHelp_fn);
    var $author$project$Data$Event$Instance = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Data$Event$Master = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$Event$Single = { $: 0 };
    var $author$project$RRule$errorToString = function (error) {
        switch (error.$) {
            case 0:
                var info = error.a;
                return "Not Found: " + info;
            case 1:
                var info = error.a;
                return "RRULE Parse Failure: " + info;
            default:
                var errors = error.a;
                return $elm$core$String$join_fn("\n\n", $elm$core$List$map_fn($author$project$RRule$errorToString, errors));
        }
    };
    var $author$project$RRule$decodeLines_fn = function (lines, _v0) {
        var decoderF = _v0;
        return decoderF($elm$core$List$map_fn($elm$core$String$trim, lines));
    }, $author$project$RRule$decodeLines = F2($author$project$RRule$decodeLines_fn);
    var $author$project$RRule$DTSTART_fn = function (zone, start) {
        return { bF: start, gw: zone };
    }, $author$project$RRule$DTSTART = F2($author$project$RRule$DTSTART_fn);
    var $author$project$RRule$RawRRules_fn = function (dtStart, rrule_, exdate_, rdate_) {
        return { b4: dtStart, hi: exdate_, iS: rdate_, i_: rrule_ };
    }, $author$project$RRule$RawRRules = F4($author$project$RRule$RawRRules_fn);
    var $author$project$RRule$Decoder = $elm$core$Basics$identity;
    var $author$project$RRule$map2_fn = function (f, _v0, _v1) {
        var decoderFA = _v0;
        var decoderFB = _v1;
        return function (val) {
            return $elm$core$Result$map2_fn(f, decoderFA(val), decoderFB(val));
        };
    }, $author$project$RRule$map2 = F3($author$project$RRule$map2_fn);
    var $author$project$RRule$andMap_a0 = $elm$core$Basics$apR, $author$project$RRule$andMap = $author$project$RRule$map2($author$project$RRule$andMap_a0);
    var $author$project$RRule$andThen_fn = function (toB, _v0) {
        var decoderF = _v0;
        return function (val) {
            var _v1 = decoderF(val);
            if (!_v1.$) {
                var decoded = _v1.a;
                return $author$project$RRule$decodeLines_fn(val, toB(decoded));
            }
            else {
                var err = _v1.a;
                return $elm$core$Result$Err(err);
            }
        };
    }, $author$project$RRule$andThen = F2($author$project$RRule$andThen_fn);
    var $author$project$RRule$EXDATE = $elm$core$Basics$identity;
    var $author$project$RRule$NotFound = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$RRule$find_fn = function (required, tagger, name, vals) {
        find: while (true) {
            if (!vals.b) {
                return required ? $elm$core$Result$Err($author$project$RRule$NotFound(name)) : $elm$core$Result$Ok(tagger(""));
            }
            else {
                var x = vals.a;
                var xs = vals.b;
                if (_String_startsWith_fn(name, x)) {
                    return $elm$core$Result$Ok(tagger(x));
                }
                else {
                    var $temp$required = required, $temp$tagger = tagger, $temp$name = name, $temp$vals = xs;
                    required = $temp$required;
                    tagger = $temp$tagger;
                    name = $temp$name;
                    vals = $temp$vals;
                    continue find;
                }
            }
        }
    }, $author$project$RRule$find = F4($author$project$RRule$find_fn);
    var $author$project$RRule$getEXDATE_a0 = false, $author$project$RRule$getEXDATE_a1 = $elm$core$Basics$identity, $author$project$RRule$getEXDATE_a2 = "EXDATE", $author$project$RRule$getEXDATE = A3($author$project$RRule$find, $author$project$RRule$getEXDATE_a0, $author$project$RRule$getEXDATE_a1, $author$project$RRule$getEXDATE_a2);
    var $author$project$RRule$RDATE = $elm$core$Basics$identity;
    var $author$project$RRule$getRDATE_a0 = false, $author$project$RRule$getRDATE_a1 = $elm$core$Basics$identity, $author$project$RRule$getRDATE_a2 = "RDATE", $author$project$RRule$getRDATE = A3($author$project$RRule$find, $author$project$RRule$getRDATE_a0, $author$project$RRule$getRDATE_a1, $author$project$RRule$getRDATE_a2);
    var $author$project$RRule$RRULE = $elm$core$Basics$identity;
    var $author$project$RRule$getRRULE_a0 = true, $author$project$RRule$getRRULE_a1 = $elm$core$Basics$identity, $author$project$RRule$getRRULE_a2 = "RRULE", $author$project$RRule$getRRULE = A3($author$project$RRule$find, $author$project$RRule$getRRULE_a0, $author$project$RRule$getRRULE_a1, $author$project$RRule$getRRULE_a2);
    var $author$project$RRule$RRule = function (frequency) {
        return function (weekStart) {
            return function (interval) {
                return function (dtStart) {
                    return function (tzid) {
                        return function (untilCount) {
                            return function (byDay) {
                                return function (byMonthDay) {
                                    return function (byMonth) {
                                        return function (byWeekNo) {
                                            return function (byYearDay) {
                                                return function (exdates) {
                                                    return function (rdates) {
                                                        return (new $$Record68(byDay, byMonth, byMonthDay, byWeekNo, byYearDay, dtStart, exdates, frequency, interval, rdates, tzid, untilCount, weekStart));
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $elm$parser$Parser$ExpectingKeyword = function (a) {
        return { $: 9, a: a };
    };
    var $elm$parser$Parser$Advanced$keyword = function (_v0) {
        var kwd = _v0.a;
        var expecting = _v0.b;
        var progress = !$elm$core$String$isEmpty(kwd);
        return function (s) {
            var _v1 = _Parser_isSubString_fn(kwd, s.nt, s.of, s.kQ, s.oM);
            var newOffset = _v1.a;
            var newRow = _v1.b;
            var newCol = _v1.c;
            return (newOffset === -1 || (0 <= _Parser_isSubChar_fn(function (c) {
                return $elm$core$Char$isAlphaNum(c) || (c === "_");
            }, newOffset, s.oM))) ? $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, expecting)) : $elm$parser$Parser$Advanced$Good_fn(progress, 0, { kQ: newCol, h: s.h, i: s.i, nt: newOffset, of: newRow, oM: s.oM });
        };
    };
    var $elm$parser$Parser$keyword = function (kwd) {
        return $elm$parser$Parser$Advanced$keyword($elm$parser$Parser$Advanced$Token_fn(kwd, $elm$parser$Parser$ExpectingKeyword(kwd)));
    };
    var $author$project$RRule$chompThrough = function (str) {
        return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$chompUntil(str), $elm$parser$Parser$keyword(str));
    };
    var $author$project$RRule$OneOf = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$RRule$oneOf = function (decoders) {
        var wrapUp = function (_v4) {
            var errors = _v4.a;
            var result = _v4.b;
            return $elm$core$Maybe$withDefault_fn($elm$core$Result$Err($author$project$RRule$OneOf($elm$core$List$reverse(errors))), $elm$core$Maybe$map_fn($elm$core$Result$Ok, result));
        };
        var initialResult = _Utils_Tuple2(_List_Nil, $elm$core$Maybe$Nothing);
        var combineResults = F3(function (val, _v2, _v3) {
            var decoderF = _v2;
            var errors = _v3.a;
            var result = _v3.b;
            if (!result.$) {
                return _Utils_Tuple2(errors, result);
            }
            else {
                var _v1 = decoderF(val);
                if (!_v1.$) {
                    var val_ = _v1.a;
                    return _Utils_Tuple2(errors, $elm$core$Maybe$Just(val_));
                }
                else {
                    var e = _v1.a;
                    return _Utils_Tuple2(_List_Cons(e, errors), $elm$core$Maybe$Nothing);
                }
            }
        });
        return function (val) {
            return wrapUp($elm$core$List$foldl_fn(combineResults(val), initialResult, decoders));
        };
    };
    var $toastal$either$Either$Left = function (a) {
        return { $: 0, a: a };
    };
    var $toastal$either$Either$Right = function (a) {
        return { $: 1, a: a };
    };
    var $elm$parser$Parser$ExpectingSymbol = function (a) {
        return { $: 8, a: a };
    };
    var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
    var $elm$parser$Parser$symbol = function (str) {
        return $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn(str, $elm$parser$Parser$ExpectingSymbol(str)));
    };
    var $author$project$RRule$listHelper_fn = function (chompingParser, items) {
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed(F2(function (item, step) {
            return step(_List_Cons(item, items));
        })), chompingParser), $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$parser$Parser$Loop), $elm$parser$Parser$symbol(",")),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$parser$Parser$Done), $elm$parser$Parser$symbol(";")),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$parser$Parser$Done), $elm$parser$Parser$end)
        ])));
    }, $author$project$RRule$listHelper = F2($author$project$RRule$listHelper_fn);
    var $author$project$RRule$list = function (chompingParser) {
        return $elm$parser$Parser$Advanced$map_fn($elm$core$List$reverse, $elm$parser$Parser$loop_fn(_List_Nil, $author$project$RRule$listHelper(chompingParser)));
    };
    var $author$project$RRule$parseNegatableInt = $elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$negate), $elm$parser$Parser$symbol("-")), $elm$parser$Parser$int),
        $elm$parser$Parser$int
    ]));
    var $author$project$RRule$chompCharsHelper_fn = function (length, count_) {
        return _Utils_eq(length, count_) ? $elm$parser$Parser$Advanced$map_fn(function (_v0) {
            return $elm$parser$Parser$Done(count_);
        }, $elm$parser$Parser$succeed(0)) : $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$parser$Parser$Loop(count_ + 1)), $elm$parser$Parser$chompIf(function (_v1) {
            return true;
        }));
    }, $author$project$RRule$chompCharsHelper = F2($author$project$RRule$chompCharsHelper_fn);
    var $author$project$RRule$chompChars = function (length) {
        return $elm$parser$Parser$getChompedString($elm$parser$Parser$loop_fn(0, $author$project$RRule$chompCharsHelper(length)));
    };
    var $author$project$RRule$weekday = $elm$parser$Parser$Advanced$andThen_fn(function (str) {
        switch (str) {
            case "MO":
                return $elm$parser$Parser$succeed(0);
            case "TU":
                return $elm$parser$Parser$succeed(1);
            case "WE":
                return $elm$parser$Parser$succeed(2);
            case "TH":
                return $elm$parser$Parser$succeed(3);
            case "FR":
                return $elm$parser$Parser$succeed(4);
            case "SA":
                return $elm$parser$Parser$succeed(5);
            case "SU":
                return $elm$parser$Parser$succeed(6);
            default:
                return $elm$parser$Parser$problem("Unknown FREQ: " + str);
        }
    }, $author$project$RRule$chompChars(2));
    var $author$project$RRule$parseWeekdays = $author$project$RRule$list($elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$backtrackable($elm$parser$Parser$Advanced$map_fn($toastal$either$Either$Right, $author$project$RRule$weekday)),
        $elm$parser$Parser$Advanced$map_fn($toastal$either$Either$Left, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed($elm$core$Tuple$pair), $author$project$RRule$parseNegatableInt), $author$project$RRule$weekday))
    ])));
    var $author$project$RRule$ParseFailure = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$RRule$deadEndToString = function (deadEnd) {
        var position = "row:" + ($elm$core$String$fromInt(deadEnd.of) + (" col:" + ($elm$core$String$fromInt(deadEnd.kQ) + "\n")));
        var _v0 = deadEnd.nX;
        switch (_v0.$) {
            case 0:
                var str = _v0.a;
                return "Expecting " + (str + (" at " + position));
            case 1:
                return "ExpectingInt at " + position;
            case 2:
                return "ExpectingHex at " + position;
            case 3:
                return "ExpectingOctal at " + position;
            case 4:
                return "ExpectingBinary at " + position;
            case 5:
                return "ExpectingFloat at " + position;
            case 6:
                return "ExpectingNumber at " + position;
            case 7:
                return "ExpectingVariable at " + position;
            case 8:
                var str = _v0.a;
                return "ExpectingSymbol " + (str + (" at " + position));
            case 9:
                var str = _v0.a;
                return "ExpectingKeyword " + (str + (" at " + position));
            case 10:
                return "ExpectingEnd at " + position;
            case 11:
                return "UnexpectedChar at " + position;
            case 12:
                var str = _v0.a;
                return "ProblemString " + (str + (" at " + position));
            default:
                return "BadRepeat at " + position;
        }
    };
    var $author$project$RRule$deadEndsToString = function (deadEnds) {
        return $elm$core$List$foldl_fn($elm$core$Basics$append, "", $elm$core$List$map_fn($author$project$RRule$deadEndToString, deadEnds));
    };
    var $author$project$RRule$runParserOn_fn = function (val, parser) {
        return function (_v0) {
            return $elm$core$Result$mapError_fn(A2($elm$core$Basics$composeR, $author$project$RRule$deadEndsToString, $author$project$RRule$ParseFailure), $elm$parser$Parser$run_fn(parser, val));
        };
    }, $author$project$RRule$runParserOn = F2($author$project$RRule$runParserOn_fn);
    var $author$project$RRule$succeed = function (val) {
        return function (_v0) {
            return $elm$core$Result$Ok(val);
        };
    };
    var $author$project$RRule$byDay = function (_v0) {
        var rrule = _v0;
        return $author$project$RRule$oneOf(_List_fromArray([
            $author$project$RRule$runParserOn_fn(rrule, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $author$project$RRule$chompThrough("BYDAY")), $elm$parser$Parser$symbol("=")), $author$project$RRule$parseWeekdays)),
            $author$project$RRule$succeed(_List_Nil)
        ]));
    };
    var $author$project$RRule$byMonth = function (_v0) {
        var rrule = _v0;
        return $author$project$RRule$oneOf(_List_fromArray([
            $author$project$RRule$runParserOn_fn(rrule, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $author$project$RRule$chompThrough("BYMONTH")), $elm$parser$Parser$symbol("=")), $author$project$RRule$list($elm$parser$Parser$int))),
            $author$project$RRule$succeed(_List_Nil)
        ]));
    };
    var $author$project$RRule$byMonthDay = function (_v0) {
        var rrule = _v0;
        return $author$project$RRule$oneOf(_List_fromArray([
            $author$project$RRule$runParserOn_fn(rrule, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $author$project$RRule$chompThrough("BYMONTHDAY")), $elm$parser$Parser$symbol("=")), $author$project$RRule$list($author$project$RRule$parseNegatableInt))),
            $author$project$RRule$succeed(_List_Nil)
        ]));
    };
    var $author$project$RRule$byWeekNo = function (_v0) {
        var rrule = _v0;
        return $author$project$RRule$oneOf(_List_fromArray([
            $author$project$RRule$runParserOn_fn(rrule, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $author$project$RRule$chompThrough("BYWEEKNO")), $elm$parser$Parser$symbol("=")), $author$project$RRule$list($author$project$RRule$parseNegatableInt))),
            $author$project$RRule$succeed(_List_Nil)
        ]));
    };
    var $author$project$RRule$byYearDay = function (_v0) {
        var rrule = _v0;
        return $author$project$RRule$oneOf(_List_fromArray([
            $author$project$RRule$runParserOn_fn(rrule, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $author$project$RRule$chompThrough("BYYEARDAY")), $elm$parser$Parser$symbol("=")), $author$project$RRule$list($author$project$RRule$parseNegatableInt))),
            $author$project$RRule$succeed(_List_Nil)
        ]));
    };
    var $author$project$RRule$ifEmptyString = function (fallback) {
        return $elm$parser$Parser$Advanced$map_fn($elm$core$Basics$always(fallback), $elm$parser$Parser$end);
    };
    var $justinmimbs$time_extra$Time$Extra$Parts_fn = function (year, month, day, hour, minute, second, millisecond) {
        return (new $$Record29(day, hour, millisecond, minute, month, second, year));
    }, $justinmimbs$time_extra$Time$Extra$Parts = F7($justinmimbs$time_extra$Time$Extra$Parts_fn);
    var $author$project$RRule$stringToInt = function (str) {
        var _v0 = $elm$core$String$toInt(str);
        if (!_v0.$) {
            var num = _v0.a;
            return $elm$parser$Parser$succeed(num);
        }
        else {
            return $elm$parser$Parser$problem(str + " is not an int");
        }
    };
    var $author$project$RRule$chompDigits = function (length) {
        return $elm$parser$Parser$Advanced$andThen_fn($author$project$RRule$stringToInt, $author$project$RRule$chompChars(length));
    };
    var $author$project$RRule$parseDateTime = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed($justinmimbs$time_extra$Time$Extra$Parts), $author$project$RRule$chompDigits(4)), $elm$parser$Parser$Advanced$map_fn($justinmimbs$date$Date$numberToMonth, $author$project$RRule$chompDigits(2))), $elm$parser$Parser$Advanced$ignorer_fn($author$project$RRule$chompDigits(2), $elm$parser$Parser$symbol("T"))), $author$project$RRule$chompDigits(2)), $author$project$RRule$chompDigits(2)), $author$project$RRule$chompDigits(2)), $elm$parser$Parser$succeed(0));
    var $author$project$RRule$parseDateToParts = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$succeed($justinmimbs$time_extra$Time$Extra$Parts), $author$project$RRule$chompDigits(4)), $elm$parser$Parser$Advanced$map_fn($justinmimbs$date$Date$numberToMonth, $author$project$RRule$chompDigits(2))), $author$project$RRule$chompDigits(2)), $elm$parser$Parser$succeed(0)), $elm$parser$Parser$succeed(0)), $elm$parser$Parser$succeed(0)), $elm$parser$Parser$succeed(0));
    var $author$project$RRule$parseTzid = function (ianaZoneName) {
        var _v0 = $elm$core$Dict$get_fn(ianaZoneName, $author$project$RRule$ianaTimezones);
        if (!_v0.$) {
            var zone = _v0.a;
            return $elm$parser$Parser$succeed(zone(0));
        }
        else {
            return $elm$parser$Parser$problem("Unknown IANA zone: " + ianaZoneName);
        }
    };
    var $author$project$RRule$exdates_fn = function (zone, _v0) {
        var exdateString = _v0;
        return $author$project$RRule$runParserOn_fn(exdateString, $elm$parser$Parser$oneOf(_List_fromArray([
            $author$project$RRule$ifEmptyString(_List_Nil),
            $elm$parser$Parser$Advanced$map_fn(function (_v1) {
                var exdateZone = _v1.a;
                var exdates_ = _v1.b;
                return $elm$core$List$map_fn($justinmimbs$time_extra$Time$Extra$partsToPosix(exdateZone), exdates_);
            }, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Tuple$pair), $author$project$RRule$chompThrough("TZID")), $elm$parser$Parser$symbol("=")), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$andThen_fn($author$project$RRule$parseTzid, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompUntil(":"))), $elm$parser$Parser$symbol(":"))), $author$project$RRule$list($author$project$RRule$parseDateTime))),
            $elm$parser$Parser$Advanced$map_fn($elm$core$List$map($justinmimbs$time_extra$Time$Extra$partsToPosix(zone)), $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $author$project$RRule$chompThrough("VALUE")), $elm$parser$Parser$symbol("=")), $author$project$RRule$chompThrough("DATE")), $elm$parser$Parser$symbol(":")), $author$project$RRule$list($author$project$RRule$parseDateToParts)))
        ])));
    }, $author$project$RRule$exdates = F2($author$project$RRule$exdates_fn);
    var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
        return function (s) {
            var _v0 = _Parser_findSubString_fn(str, s.nt, s.of, s.kQ, s.oM);
            var newOffset = _v0.a;
            var newRow = _v0.b;
            var newCol = _v0.c;
            var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.oM) : newOffset;
            return $elm$parser$Parser$Advanced$Good_fn(_Utils_cmp(s.nt, adjustedOffset) < 0, 0, { kQ: newCol, h: s.h, i: s.i, nt: adjustedOffset, of: newRow, oM: s.oM });
        };
    };
    var $elm$parser$Parser$chompUntilEndOr = $elm$parser$Parser$Advanced$chompUntilEndOr;
    var $author$project$RRule$Daily = 0;
    var $author$project$RRule$Monthly = 2;
    var $author$project$RRule$Weekly = 1;
    var $author$project$RRule$Yearly = 3;
    var $author$project$RRule$parseFreq = function (str) {
        switch (str) {
            case "DAILY":
                return $elm$parser$Parser$succeed(0);
            case "WEEKLY":
                return $elm$parser$Parser$succeed(1);
            case "MONTHLY":
                return $elm$parser$Parser$succeed(2);
            case "YEARLY":
                return $elm$parser$Parser$succeed(3);
            default:
                return $elm$parser$Parser$problem("Unknown FREQ: " + str);
        }
    };
    var $author$project$RRule$frequency = function (_v0) {
        var rrule = _v0;
        return $author$project$RRule$runParserOn_fn(rrule, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $author$project$RRule$chompThrough("FREQ")), $elm$parser$Parser$symbol("=")), $elm$parser$Parser$Advanced$andThen_fn($author$project$RRule$parseFreq, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompUntilEndOr(";")))));
    };
    var $author$project$RRule$interval = function (_v0) {
        var rrule = _v0;
        return $author$project$RRule$oneOf(_List_fromArray([
            $author$project$RRule$runParserOn_fn(rrule, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $author$project$RRule$chompThrough("INTERVAL")), $elm$parser$Parser$symbol("=")), $elm$parser$Parser$int)),
            $author$project$RRule$succeed(1)
        ]));
    };
    var $author$project$RRule$Count = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$RRule$count = function (_v0) {
        var rrule = _v0;
        return $author$project$RRule$runParserOn_fn(rrule, $elm$parser$Parser$Advanced$map_fn($author$project$RRule$Count, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $author$project$RRule$chompThrough("COUNT")), $elm$parser$Parser$symbol("=")), $elm$parser$Parser$int)));
    };
    var $author$project$RRule$maybe = function (_v0) {
        var decoderF = _v0;
        return function (val) {
            var _v1 = decoderF(val);
            if (!_v1.$) {
                var a = _v1.a;
                return $elm$core$Result$Ok($elm$core$Maybe$Just(a));
            }
            else {
                return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
            }
        };
    };
    var $author$project$RRule$Until = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$RRule$until_fn = function (zone, _v0) {
        var rrule = _v0;
        return $author$project$RRule$runParserOn_fn(rrule, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $author$project$RRule$chompThrough("UNTIL")), $elm$parser$Parser$symbol("=")), $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$backtrackable($elm$parser$Parser$Advanced$map_fn(A2($elm$core$Basics$composeR, $justinmimbs$time_extra$Time$Extra$partsToPosix($elm$time$Time$utc), $author$project$RRule$Until), $author$project$RRule$parseDateTime)),
            $elm$parser$Parser$Advanced$map_fn(A2($elm$core$Basics$composeR, $justinmimbs$time_extra$Time$Extra$partsToPosix(zone), $author$project$RRule$Until), $author$project$RRule$parseDateToParts)
        ]))));
    }, $author$project$RRule$until = F2($author$project$RRule$until_fn);
    var $author$project$RRule$untilCount_fn = function (zone, rrule) {
        return $author$project$RRule$maybe($author$project$RRule$oneOf(_List_fromArray([
            $author$project$RRule$until_fn(zone, rrule),
            $author$project$RRule$count(rrule)
        ])));
    }, $author$project$RRule$untilCount = F2($author$project$RRule$untilCount_fn);
    var $author$project$RRule$weekStart = function (_v0) {
        var rrule = _v0;
        return $author$project$RRule$oneOf(_List_fromArray([
            $author$project$RRule$runParserOn_fn(rrule, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$succeed($elm$core$Basics$identity), $author$project$RRule$chompThrough("WKST")), $elm$parser$Parser$symbol("=")), $author$project$RRule$weekday)),
            $author$project$RRule$succeed(0)
        ]));
    };
    var $author$project$RRule$rawRRulesToRecurrence_fn = function (zone, _v0) {
        var dtStart = _v0.b4;
        var rrule_ = _v0.i_;
        var exdate_ = _v0.hi;
        var rdate_ = _v0.iS;
        return $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$succeed(_List_Nil), $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$exdates_fn(zone, exdate_), $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$byYearDay(rrule_), $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$byWeekNo(rrule_), $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$byMonth(rrule_), $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$byMonthDay(rrule_), $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$byDay(rrule_), $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$untilCount_fn(zone, rrule_), $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$succeed(dtStart.gw), $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$succeed(dtStart.bF), $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$interval(rrule_), $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$weekStart(rrule_), $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$frequency(rrule_), $author$project$RRule$succeed($author$project$RRule$RRule))))))))))))));
    }, $author$project$RRule$rawRRulesToRecurrence = F2($author$project$RRule$rawRRulesToRecurrence_fn);
    var $author$project$RRule$decoder_fn = function (zone, start) {
        return $author$project$RRule$andThen_fn($author$project$RRule$rawRRulesToRecurrence(zone), $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$getRDATE, $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$getEXDATE, $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$getRRULE, $author$project$RRule$map2_fn($author$project$RRule$andMap_a0, $author$project$RRule$succeed($author$project$RRule$DTSTART_fn(zone, start)), $author$project$RRule$succeed($author$project$RRule$RawRRules))))));
    }, $author$project$RRule$decoder = F2($author$project$RRule$decoder_fn);
    var $author$project$RRule$fromStringsWithStart_fn = function (rrules, zone, start) {
        return $author$project$RRule$decodeLines_fn(rrules, $author$project$RRule$decoder_fn(zone, start));
    }, $author$project$RRule$fromStringsWithStart = F3($author$project$RRule$fromStringsWithStart_fn);
    var $author$project$Data$Event$toRRule_fn = function (rrules, localZone, time) {
        if (!time.$) {
            var time_ = time.a;
            return $author$project$RRule$fromStringsWithStart_fn(rrules, time_.gw.p8(0), time_.gh);
        }
        else {
            var date = time.a;
            return $author$project$RRule$fromStringsWithStart_fn(rrules, localZone, $author$project$Util$Time$dateToPosix_fn(localZone, date));
        }
    }, $author$project$Data$Event$toRRule = F3($author$project$Data$Event$toRRule_fn);
    var $author$project$Data$Time$toZonedTime = function (time_) {
        if (time_.$ === 1) {
            var date = time_.a;
            return $elm$core$Maybe$Just($author$project$Data$Time$Date(date));
        }
        else {
            var time = time_.a.gh;
            var zone = time_.a.gw;
            return $elm$core$Maybe$map_fn(function (ianaZone) {
                return $author$project$Data$Time$Time((new $$Record26(time, ianaZone)));
            }, zone);
        }
    };
    var $author$project$Data$Event$toEventType_fn = function (localZone, event) {
        var _v0 = _Utils_Tuple3(event.n1, event.nF, event.n2);
        _v0$3: while (true) {
            if (!_v0.a.$) {
                if ((_v0.b.$ === 1) && (_v0.c.$ === 1)) {
                    var rrules_ = _v0.a.a;
                    var _v1 = _v0.b;
                    var _v2 = _v0.c;
                    var _v3 = $author$project$Data$Time$toZonedTime(event.bF);
                    if (!_v3.$) {
                        var time = _v3.a;
                        return $elm$core$Result$map_fn(function (rrule) {
                            return $author$project$Data$Event$Master({ b4: time, iR: rrules_, fZ: rrule });
                        }, $elm$core$Result$mapError_fn($author$project$RRule$errorToString, $author$project$Data$Event$toRRule_fn(rrules_, localZone, time)));
                    }
                    else {
                        return $elm$core$Result$Err("Expected timezone data on Non-All-Day Master recurring event.");
                    }
                }
                else {
                    break _v0$3;
                }
            }
            else {
                if (!_v0.b.$) {
                    if (!_v0.c.$) {
                        var _v4 = _v0.a;
                        var originalStartTime_ = _v0.b.a;
                        var masterId_ = _v0.c.a;
                        return $elm$core$Result$Ok($author$project$Data$Event$Instance({ mT: masterId_, nF: originalStartTime_, nZ: false }));
                    }
                    else {
                        break _v0$3;
                    }
                }
                else {
                    if (_v0.c.$ === 1) {
                        var _v5 = _v0.a;
                        var _v6 = _v0.b;
                        var _v7 = _v0.c;
                        return $elm$core$Result$Ok($author$project$Data$Event$Single);
                    }
                    else {
                        break _v0$3;
                    }
                }
            }
        }
        return $elm$core$Result$Err("Unexpected combination of recurrence, originalStartTime, and recurringEventId fields.");
    }, $author$project$Data$Event$toEventType = F2($author$project$Data$Event$toEventType_fn);
    var $author$project$Data$Event$fromGCalEvent_fn = function (localZone, event) {
        return $elm$core$Result$map_fn($author$project$Data$Event$fromGCalEventHelp(event), $author$project$Data$Event$toEventType_fn(localZone, event));
    }, $author$project$Data$Event$fromGCalEvent = F2($author$project$Data$Event$fromGCalEvent_fn);
    var $author$project$Data$Event$gcalDecoder = function (localZone) {
        return _Json_andThen_fn(A2($elm$core$Basics$composeR, $author$project$Data$Event$fromGCalEvent(localZone), $author$project$Util$Json$decoderFromResult), $author$project$Data$GCal$decoder);
    };
    var $author$project$Data$Event$decodeGCalEvent = function (localZone) {
        return _Json_map1_fn(function (eventVal) {
            return $elm$core$Result$mapError_fn(function (err) {
                return $author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$Decoding({
                    lg: $elm$json$Json$Decode$errorToString(err),
                    he: "GCal.Event"
                }));
            }, _Json_run_fn($author$project$Data$Event$gcalDecoder(localZone), eventVal));
        }, $elm$json$Json$Decode$value);
    };
    var $author$project$Data$Batch$Batch_fn = function (items, remaining, tag, total, fromCache) {
        return { hy: fromCache, mA: items, n7: remaining, o8: tag, pH: total };
    }, $author$project$Data$Batch$Batch = F5($author$project$Data$Batch$Batch_fn);
    var $author$project$Data$Batch$decoder = function (itemDecoder) {
        return $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("fromCache", $elm$json$Json$Decode$bool, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("total", $elm$json$Json$Decode$int, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("tag", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("remaining", $elm$json$Json$Decode$int, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("items", $elm$json$Json$Decode$list(itemDecoder), $elm$json$Json$Decode$succeed($author$project$Data$Batch$Batch))))));
    };
    var $author$project$Model$LogError = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Subscriptions$logDecodeError_fn = function (entityName, error) {
        return $author$project$Model$LogError($author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$Decoding({
            lg: $elm$json$Json$Decode$errorToString(error),
            he: entityName
        })));
    }, $author$project$Subscriptions$logDecodeError = F2($author$project$Subscriptions$logDecodeError_fn);
    var $author$project$Subscriptions$decodeEventBatch_fn = function (localZone, eventBatchVal) {
        var eventBatchDecoder = $author$project$Data$Batch$decoder($author$project$Data$Event$decodeGCalEvent(localZone));
        var _v0 = _Json_run_fn(eventBatchDecoder, eventBatchVal);
        if (!_v0.$) {
            var batch = _v0.a;
            return $author$project$Model$CalendarEvents(batch);
        }
        else {
            var err = _v0.a;
            return $author$project$Subscriptions$logDecodeError_fn("Batch GCal.Event", err);
        }
    }, $author$project$Subscriptions$decodeEventBatch = F2($author$project$Subscriptions$decodeEventBatch_fn);
    var $author$project$Firestore$Sub$DecodeError = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Firestore$Sub$Error = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Firestore$Sub$Change = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Firestore$Sub$FirestoreError = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Firestore$Error$Error_fn = function (code, message) {
        return { gZ: code, m_: message };
    }, $author$project$Firestore$Error$Error = F2($author$project$Firestore$Error$Error_fn);
    var $author$project$Firestore$Error$Aborted = 8;
    var $author$project$Firestore$Error$AlreadyExists = 5;
    var $author$project$Firestore$Error$Cancelled = 2;
    var $author$project$Firestore$Error$DataLoss = 13;
    var $author$project$Firestore$Error$DeadlineExceeded = 3;
    var $author$project$Firestore$Error$FailedPrecondition = 7;
    var $author$project$Firestore$Error$Internal = 11;
    var $author$project$Firestore$Error$InvalidArgument = 1;
    var $author$project$Firestore$Error$NotFound = 4;
    var $author$project$Firestore$Error$OutOfRange = 9;
    var $author$project$Firestore$Error$PermissionDenied = 0;
    var $author$project$Firestore$Error$ResourceExhausted = 6;
    var $author$project$Firestore$Error$Unauthenticated = 14;
    var $author$project$Firestore$Error$Unavailable = 12;
    var $author$project$Firestore$Error$Unimplemented = 10;
    var $author$project$Firestore$Error$Unknown = 15;
    var $author$project$Firestore$Error$stringToCode = function (codeStr) {
        switch (codeStr) {
            case "permission-denied":
                return 0;
            case "invalid-argument":
                return 1;
            case "cancelled":
                return 2;
            case "deadline-exceeded":
                return 3;
            case "not-found":
                return 4;
            case "already-exists":
                return 5;
            case "resource-exhausted":
                return 6;
            case "failed-precondition":
                return 7;
            case "aborted":
                return 8;
            case "out-of-range":
                return 9;
            case "unimplemented":
                return 10;
            case "internal":
                return 11;
            case "unavailable":
                return 12;
            case "data-loss":
                return 13;
            case "unauthenticated":
                return 14;
            default:
                return 15;
        }
    };
    var $author$project$Firestore$Error$decode = _Json_map2_fn($author$project$Firestore$Error$Error, _Json_decodeField_fn("code", _Json_map1_fn($author$project$Firestore$Error$stringToCode, $elm$json$Json$Decode$string)), _Json_decodeField_fn("message", $elm$json$Json$Decode$string));
    var $author$project$Firestore$Sub$DocChanges_fn = function (path, docs, metadata) {
        return (new $$Record69(docs, metadata, path));
    }, $author$project$Firestore$Sub$DocChanges = F3($author$project$Firestore$Sub$DocChanges_fn);
    var $author$project$Firestore$Sub$Metadata_fn = function (hasPendingWrites, fromCache) {
        return { hy: fromCache, lW: hasPendingWrites };
    }, $author$project$Firestore$Sub$Metadata = F2($author$project$Firestore$Sub$Metadata_fn);
    var $author$project$Firestore$Sub$decodeMetadata = _Json_map2_fn($author$project$Firestore$Sub$Metadata, _Json_decodeField_fn("hasPendingWrites", $elm$json$Json$Decode$bool), _Json_decodeField_fn("fromCache", $elm$json$Json$Decode$bool));
    var $author$project$Firestore$Document$Document_fn = function (path, id, state, data) {
        return (new $$Record70(data, id, path, state));
    }, $author$project$Firestore$Document$Document = F4($author$project$Firestore$Document$Document_fn);
    var $elm$json$Json$Decode$map4 = _Json_map4;
    var $author$project$Firestore$Document$Cached = 3;
    var $author$project$Firestore$Document$Deleted = 6;
    var $author$project$Firestore$Document$Deleting = 5;
    var $author$project$Firestore$Document$Modified = 1;
    var $author$project$Firestore$Document$Saved = 4;
    var $author$project$Firestore$Document$Saving = 2;
    var $author$project$Firestore$Document$stateDecoder = _Json_andThen_fn(function (val) {
        switch (val) {
            case "new":
                return $elm$json$Json$Decode$succeed(0);
            case "modified":
                return $elm$json$Json$Decode$succeed(1);
            case "saving":
                return $elm$json$Json$Decode$succeed(2);
            case "cached":
                return $elm$json$Json$Decode$succeed(3);
            case "saved":
                return $elm$json$Json$Decode$succeed(4);
            case "deleting":
                return $elm$json$Json$Decode$succeed(5);
            case "deleted":
                return $elm$json$Json$Decode$succeed(6);
            default:
                return $elm$json$Json$Decode$fail("Unknown Document.State " + val);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Firestore$Document$decoder = _Json_map4_fn($author$project$Firestore$Document$Document, _Json_decodeField_fn("path", $elm$json$Json$Decode$string), _Json_decodeField_fn("id", $elm$json$Json$Decode$string), _Json_decodeField_fn("state", $author$project$Firestore$Document$stateDecoder), _Json_decodeField_fn("data", $elm$json$Json$Decode$value));
    var $author$project$Firestore$Sub$decodeCollectionChange = _Json_map3_fn($author$project$Firestore$Sub$DocChanges, _Json_decodeField_fn("path", $elm$json$Json$Decode$string), _Json_decodeField_fn("docs", $elm$json$Json$Decode$list($author$project$Firestore$Document$decoder)), _Json_decodeField_fn("metadata", $author$project$Firestore$Sub$decodeMetadata));
    var $author$project$Firestore$Sub$msgDecoder = function () {
        var dataField = $elm$json$Json$Decode$field("data");
        return _Json_andThen_fn(function (opName) {
            switch (opName) {
                case "Change":
                    return _Json_map1_fn($author$project$Firestore$Sub$Change, dataField($author$project$Firestore$Sub$decodeCollectionChange));
                case "Error":
                    return _Json_map1_fn(A2($elm$core$Basics$composeR, $author$project$Firestore$Sub$FirestoreError, $author$project$Firestore$Sub$Error), dataField($author$project$Firestore$Error$decode));
                default:
                    return $elm$json$Json$Decode$fail("Unknown elm-firestore operation: " + opName);
            }
        }, _Json_decodeField_fn("operation", $elm$json$Json$Decode$string));
    }();
    var $author$project$Firestore$Sub$decodeMsg = function (val) {
        var _v0 = $elm$core$Result$mapError_fn(A2($elm$core$Basics$composeR, $author$project$Firestore$Sub$DecodeError, $author$project$Firestore$Sub$Error), _Json_run_fn($author$project$Firestore$Sub$msgDecoder, val));
        if (!_v0.$) {
            var changeMsg = _v0.a;
            return changeMsg;
        }
        else {
            var errorMsg = _v0.a;
            return errorMsg;
        }
    };
    var $author$project$Data$App$Version_fn = function (latestVersion, released, minimumAcceptableVersion) {
        return { mD: latestVersion, m3: minimumAcceptableVersion, n6: released };
    }, $author$project$Data$App$Version = F3($author$project$Data$App$Version_fn);
    var $author$project$Data$App$decodeVersion = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("minimumAcceptableVersion", $elm$json$Json$Decode$int, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("released", $author$project$Util$Time$decodePosixFromISO, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("latestVersion", $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Data$App$Version))));
    var $author$project$Data$Keypress$Keypress_fn = function (key, ctrl, meta, shift) {
        return { k2: ctrl, mC: key, m$: meta, ow: shift };
    }, $author$project$Data$Keypress$Keypress = F4($author$project$Data$Keypress$Keypress_fn);
    var $author$project$Data$Keypress$decoder = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("shiftKey", $elm$json$Json$Decode$bool, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("metaKey", $elm$json$Json$Decode$bool, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("ctrlKey", $elm$json$Json$Decode$bool, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("key", $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Data$Keypress$Keypress)))));
    var $author$project$Data$Subscription$Subscription_fn = function (email, isAdmin, createdAt, featureFlags, updatedAt, tipe) {
        return (new $$Record71(createdAt, email, featureFlags, isAdmin, tipe, updatedAt));
    }, $author$project$Data$Subscription$Subscription = F6($author$project$Data$Subscription$Subscription_fn);
    var $author$project$Data$FeatureFlags$FeatureFlags = {};
    var $author$project$Data$FeatureFlags$decoder = $elm$json$Json$Decode$succeed($author$project$Data$FeatureFlags$FeatureFlags);
    var $author$project$Data$Subscription$TypeStandard = $elm$core$Basics$identity;
    var $author$project$Data$BillingAccount$Active = 0;
    var $author$project$Data$BillingAccount$Inactive = 1;
    var $author$project$Data$BillingAccount$statusDecoder = _Json_andThen_fn(function (status) {
        switch (status) {
            case "active":
                return $elm$json$Json$Decode$succeed(0);
            case "inactive":
                return $elm$json$Json$Decode$succeed(1);
            default:
                return $elm$json$Json$Decode$fail("unrecognized BillingAccount.Status");
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Data$Subscription$typeDecoder = _Json_andThen_fn(function (tipeName) {
        if (tipeName === "invite_standard") {
            return _Json_map2_fn(F2(function (accountId, accountStatus) {
                return { gN: accountId, e0: accountStatus };
            }), _Json_decodeField_fn("billingAccountId", $elm$json$Json$Decode$string), _Json_decodeField_fn("billingAccountStatus", $author$project$Data$BillingAccount$statusDecoder));
        }
        else {
            return $elm$json$Json$Decode$fail("unknown Subscription.type field");
        }
    }, _Json_decodeField_fn("type", $elm$json$Json$Decode$string));
    var $author$project$Data$Subscription$decoder = _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, $author$project$Data$Subscription$typeDecoder, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("updatedAt", $author$project$Data$Timestamp$decoder, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("featureFlags", $author$project$Data$FeatureFlags$decoder, $author$project$Data$FeatureFlags$default, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("createdAt", $author$project$Data$Timestamp$decoder, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("isAdmin", $elm$json$Json$Decode$bool, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("email", $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Data$Subscription$Subscription)))))));
    var $author$project$Data$User$User = function (id) {
        return function (email) {
            return function (photoURL) {
                return function (displayName) {
                    return function (calendarIsLinked) {
                        return function (subscription) {
                            return function (authToken) {
                                return function (tutorialComplete) {
                                    return function (introContentPreloaded) {
                                        return function (popupsShown) {
                                            return function (alerts) {
                                                return (new $$Record72(alerts, authToken, calendarIsLinked, displayName, email, id, introContentPreloaded, photoURL, popupsShown, subscription, tutorialComplete));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Data$User$Alerts = function (linkWorkAccount) {
        return (new $$Record73(linkWorkAccount));
    };
    var $author$project$Data$User$Hidden = { $: 0 };
    var $author$project$Data$User$defaultAlerts = (new $$Record73($author$project$Data$User$Hidden));
    var $author$project$Data$User$Dismissed = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Data$User$DismissedForever = { $: 3 };
    var $author$project$Data$User$Displayable = { $: 1 };
    var $author$project$Data$User$linkWorkAccountAlertStatusDecoder = function () {
        var decoderFromType = function (t) {
            switch (t) {
                case "hidden":
                    return $elm$json$Json$Decode$succeed($author$project$Data$User$Hidden);
                case "displayable":
                    return $elm$json$Json$Decode$succeed($author$project$Data$User$Displayable);
                case "dismissed":
                    return _Json_map1_fn($author$project$Data$User$Dismissed, _Json_decodeField_fn("dismissedAt", $author$project$Util$Time$decodePosixFromMillis));
                case "dismissed_forever":
                    return $elm$json$Json$Decode$succeed($author$project$Data$User$DismissedForever);
                default:
                    return $elm$json$Json$Decode$fail("unknown type for LinkWorkAccountAlertStatus: " + t);
            }
        };
        return _Json_andThen_fn(decoderFromType, _Json_decodeField_fn("type", $elm$json$Json$Decode$string));
    }();
    var $author$project$Data$User$alertsDecoder = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("linkWorkAccount", $author$project$Data$User$linkWorkAccountAlertStatusDecoder, $author$project$Data$User$defaultAlerts.mH, $elm$json$Json$Decode$succeed($author$project$Data$User$Alerts));
    var $author$project$Data$User$decoder = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("alerts", $author$project$Data$User$alertsDecoder, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("popupsShown", $elm$json$Json$Decode$succeed({}), $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("introContentPreloaded", $elm$json$Json$Decode$bool, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("tutorialComplete", $elm$json$Json$Decode$bool, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("authToken", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("subscription", $elm$json$Json$Decode$nullable($author$project$Data$Subscription$decoder), $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("calendarIsLinked", $elm$json$Json$Decode$bool, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("displayName", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("photoURL", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("email", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("id", $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Data$User$User))))))))))));
    var $elm$time$Time$Every_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$time$Time$Every = F2($elm$time$Time$Every_fn);
    var $elm$time$Time$State_fn = function (taggers, processes) {
        return { iN: processes, jl: taggers };
    }, $elm$time$Time$State = F2($elm$time$Time$State_fn);
    var $elm$time$Time$init = $elm$core$Task$succeed($elm$time$Time$State_fn($elm$core$Dict$empty, $elm$core$Dict$empty));
    var $elm$time$Time$addMySub_fn = function (_v0, state) {
        var interval = _v0.a;
        var tagger = _v0.b;
        var _v1 = $elm$core$Dict$get_fn(interval, state);
        if (_v1.$ === 1) {
            return $elm$core$Dict$insert_fn(interval, _List_fromArray([tagger]), state);
        }
        else {
            var taggers = _v1.a;
            return $elm$core$Dict$insert_fn(interval, _List_Cons(tagger, taggers), state);
        }
    }, $elm$time$Time$addMySub = F2($elm$time$Time$addMySub_fn);
    var $elm$core$Process$kill = _Scheduler_kill;
    var $elm$core$Dict$merge_fn = function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
        var stepState = F3(function (rKey, rValue, _v0) {
            stepState: while (true) {
                var list = _v0.a;
                var result = _v0.b;
                if (!list.b) {
                    return _Utils_Tuple2(list, A3(rightStep, rKey, rValue, result));
                }
                else {
                    var _v2 = list.a;
                    var lKey = _v2.a;
                    var lValue = _v2.b;
                    var rest = list.b;
                    if (_Utils_cmp(lKey, rKey) < 0) {
                        var $temp$rKey = rKey, $temp$rValue = rValue, $temp$_v0 = _Utils_Tuple2(rest, A3(leftStep, lKey, lValue, result));
                        rKey = $temp$rKey;
                        rValue = $temp$rValue;
                        _v0 = $temp$_v0;
                        continue stepState;
                    }
                    else {
                        if (_Utils_cmp(lKey, rKey) > 0) {
                            return _Utils_Tuple2(list, A3(rightStep, rKey, rValue, result));
                        }
                        else {
                            return _Utils_Tuple2(rest, A4(bothStep, lKey, lValue, rValue, result));
                        }
                    }
                }
            }
        });
        var _v3 = $elm$core$Dict$foldl_fn(stepState, _Utils_Tuple2($elm$core$Dict$toList(leftDict), initialResult), rightDict);
        var leftovers = _v3.a;
        var intermediateResult = _v3.b;
        return $elm$core$List$foldl_fn_unwrapped(function (_v4, result) {
            var k = _v4.a;
            var v = _v4.b;
            return A3(leftStep, k, v, result);
        }, intermediateResult, leftovers);
    }, $elm$core$Dict$merge = F6($elm$core$Dict$merge_fn);
    var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
    var $elm$time$Time$Name = function (a) {
        return { $: 0, a: a };
    };
    var $elm$time$Time$Offset = function (a) {
        return { $: 1, a: a };
    };
    var $elm$time$Time$setInterval = _Time_setInterval;
    var $elm$core$Process$spawn = _Scheduler_spawn;
    var $elm$time$Time$spawnHelp_fn = function (router, intervals, processes) {
        if (!intervals.b) {
            return $elm$core$Task$succeed(processes);
        }
        else {
            var interval = intervals.a;
            var rest = intervals.b;
            var spawnTimer = $elm$core$Process$spawn(_Time_setInterval_fn(interval, _Platform_sendToSelf_fn(router, interval)));
            var spawnRest = function (id) {
                return $elm$time$Time$spawnHelp_fn(router, rest, $elm$core$Dict$insert_fn(interval, id, processes));
            };
            return _Scheduler_andThen_fn(spawnRest, spawnTimer);
        }
    }, $elm$time$Time$spawnHelp = F3($elm$time$Time$spawnHelp_fn);
    var $elm$time$Time$onEffects_fn = function (router, subs, _v0) {
        var processes = _v0.iN;
        var rightStep = F3(function (_v6, id, _v7) {
            var spawns = _v7.a;
            var existing = _v7.b;
            var kills = _v7.c;
            return _Utils_Tuple3(spawns, existing, _Scheduler_andThen_fn(function (_v5) {
                return kills;
            }, $elm$core$Process$kill(id)));
        });
        var newTaggers = $elm$core$List$foldl_fn($elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
        var leftStep = F3(function (interval, taggers, _v4) {
            var spawns = _v4.a;
            var existing = _v4.b;
            var kills = _v4.c;
            return _Utils_Tuple3(_List_Cons(interval, spawns), existing, kills);
        });
        var bothStep = F4(function (interval, taggers, id, _v3) {
            var spawns = _v3.a;
            var existing = _v3.b;
            var kills = _v3.c;
            return _Utils_Tuple3(spawns, $elm$core$Dict$insert_fn(interval, id, existing), kills);
        });
        var _v1 = $elm$core$Dict$merge_fn(leftStep, bothStep, rightStep, newTaggers, processes, _Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, $elm$core$Task$succeed(0)));
        var spawnList = _v1.a;
        var existingDict = _v1.b;
        var killTask = _v1.c;
        return _Scheduler_andThen_fn(function (newProcesses) {
            return $elm$core$Task$succeed($elm$time$Time$State_fn(newTaggers, newProcesses));
        }, _Scheduler_andThen_fn(function (_v2) {
            return $elm$time$Time$spawnHelp_fn(router, spawnList, existingDict);
        }, killTask));
    }, $elm$time$Time$onEffects = F3($elm$time$Time$onEffects_fn);
    var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
    var $elm$time$Time$onSelfMsg_fn = function (router, interval, state) {
        var _v0 = $elm$core$Dict$get_fn(interval, state.jl);
        if (_v0.$ === 1) {
            return $elm$core$Task$succeed(state);
        }
        else {
            var taggers = _v0.a;
            var tellTaggers = function (time) {
                return $elm$core$Task$sequence($elm$core$List$map_fn(function (tagger) {
                    return _Platform_sendToApp_fn(router, tagger(time));
                }, taggers));
            };
            return _Scheduler_andThen_fn(function (_v1) {
                return $elm$core$Task$succeed(state);
            }, _Scheduler_andThen_fn(tellTaggers, $elm$time$Time$now));
        }
    }, $elm$time$Time$onSelfMsg = F3($elm$time$Time$onSelfMsg_fn);
    var $elm$time$Time$subMap_fn = function (f, _v0) {
        var interval = _v0.a;
        var tagger = _v0.b;
        return $elm$time$Time$Every_fn(interval, A2($elm$core$Basics$composeL, f, tagger));
    }, $elm$time$Time$subMap = F2($elm$time$Time$subMap_fn);
    _Platform_effectManagers["Time"] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
    var $elm$time$Time$subscription = _Platform_leaf("Time");
    var $elm$time$Time$every_fn = function (interval, tagger) {
        return $elm$time$Time$subscription($elm$time$Time$Every_fn(interval, tagger));
    }, $elm$time$Time$every = F2($elm$time$Time$every_fn);
    var $author$project$Data$MentionResult$Request_fn = function (mentionSymbol, searchTerm, mentionsInLine) {
        return { ib: mentionSymbol, ic: mentionsInLine, dg: searchTerm };
    }, $author$project$Data$MentionResult$Request = F3($author$project$Data$MentionResult$Request_fn);
    var $author$project$Data$Mention$MentionEventRef_fn = function (a, b, c) {
        return { $: 1, a: a, b: b, c: c };
    }, $author$project$Data$Mention$MentionEventRef = F3($author$project$Data$Mention$MentionEventRef_fn);
    var $author$project$Data$Mention$MentionPersonRef = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$Mention$refDecoderHelp = function (mentionType) {
        switch (mentionType) {
            case "person-mention":
                return _Json_map1_fn(function (personId) {
                    return $author$project$Data$Mention$MentionPersonRef({ iB: personId });
                }, _Json_decodeField_fn("personId", $elm$json$Json$Decode$string));
            case "event-mention":
                return $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("currentTopic", _Json_map1_fn($author$project$Data$Mention$EventRefMeta, $elm$json$Json$Decode$bool), $author$project$Data$Mention$EventRefMeta(false), $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("completedIn", $elm$json$Json$Decode$nullable($author$project$Data$Mention$mentionEventCompletedInDecoder), $elm$core$Maybe$Nothing, _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, $author$project$Data$Mention$mentionEventRefDataDecoder, $elm$json$Json$Decode$succeed($author$project$Data$Mention$MentionEventRef))));
            default:
                return $elm$json$Json$Decode$fail("Unrecognized mention type: " + mentionType);
        }
    };
    var $author$project$Data$Mention$refDecoder = _Json_andThen_fn($author$project$Data$Mention$refDecoderHelp, _Json_decodeField_fn("mentionType", $elm$json$Json$Decode$string));
    var $author$project$Data$MentionResult$decodeRequest = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("mentionsInLine", $elm$json$Json$Decode$list($author$project$Data$Mention$refDecoder), $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("searchTerm", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("mentionSymbol", $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Data$MentionResult$Request))));
    var $author$project$Data$MentionResult$mentionSearchFromEditor = _Platform_incomingPort("mentionSearchFromEditor", $elm$json$Json$Decode$value);
    var $author$project$Data$MentionResult$fromEditor = function (toMsg) {
        return $author$project$Data$MentionResult$mentionSearchFromEditor(A2($elm$core$Basics$composeR, $elm$json$Json$Decode$decodeValue($author$project$Data$MentionResult$decodeRequest), toMsg));
    };
    var $author$project$Ports$fromFirestore = _Platform_incomingPort("fromFirestore", $elm$json$Json$Decode$value);
    var $author$project$Ports$gcalEvents = _Platform_incomingPort("gcalEvents", $elm$json$Json$Decode$value);
    var $author$project$Ports$keypressed = _Platform_incomingPort("keypressed", $elm$json$Json$Decode$value);
    var $author$project$Search$Index$Indices_fn = function (notes, people) {
        return (new $$Record19(notes, people));
    }, $author$project$Search$Index$Indices = F2($author$project$Search$Index$Indices_fn);
    var $author$project$Search$Index$freshIndex = function (config) {
        return (new $$Record18(config.bL, $rluiten$elm_text_search$ElmTextSearch$newWith(config.bm), $author$project$Util$Time$epoch));
    };
    var $author$project$Search$Index$Index_fn = function (index, configVersion, updatedAt) {
        return (new $$Record18(configVersion, index, updatedAt));
    }, $author$project$Search$Index$Index = F3($author$project$Search$Index$Index_fn);
    var $rluiten$elm_text_search$Index$Utils$buildOrderIndex = function (tokenSet) {
        var withIndex = $elm$core$List$indexedMap_fn($elm$core$Tuple$pair, $elm$core$Set$toList(tokenSet));
        return $elm$core$List$foldr_fn(F2(function (_v0, d) {
            var i = _v0.a;
            var v = _v0.b;
            return $elm$core$Dict$insert_fn(v, i, d);
        }), $elm$core$Dict$empty, withIndex);
    };
    var $rluiten$elm_text_search$Index$Load$createIndex = function (_v0) {
        var config = _v0.a;
        var decodedIndex = _v0.b;
        return $elm$json$Json$Decode$succeed((new $$Record16(decodedIndex.e7, $rluiten$elm_text_search$Index$Utils$buildOrderIndex(decodedIndex.e7), decodedIndex.fe, config.hs, config.ht, $elm$core$Maybe$Nothing, $elm$core$Dict$empty, decodedIndex.hP, decodedIndex.fA, config.hQ, $elm$core$Maybe$Nothing, config.h2, config.n3, decodedIndex.gk, config.jv, $elm$core$Maybe$Nothing)));
    };
    var $rluiten$elm_text_search$Index$Model$CodecIndexRecord_fn = function (indexVersion, indexType, documentStore, corpusTokens, tokenStore) {
        return (new $$Record74(corpusTokens, documentStore, indexType, indexVersion, tokenStore));
    }, $rluiten$elm_text_search$Index$Model$CodecIndexRecord = F5($rluiten$elm_text_search$Index$Model$CodecIndexRecord_fn);
    var $rluiten$trie$TrieModel$TrieNode = function (a) {
        return { $: 2, a: a };
    };
    var $rluiten$trie$TrieModel$ValNode = function (a) {
        return { $: 1, a: a };
    };
    var $rluiten$trie$TrieModel$ValTrieNode = function (a) {
        return { $: 3, a: a };
    };
    var $rluiten$trie$Trie$Json$Decoder$decoderValDict = $elm$json$Json$Decode$dict;
    var $elm$json$Json$Decode$index = _Json_decodeIndex;
    var $elm$json$Json$Decode$lazy = function (thunk) {
        return _Json_andThen_fn(thunk, $elm$json$Json$Decode$succeed(0));
    };
    var $rluiten$trie$Trie$Json$Decoder$decoder = function (valDec) {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$null($rluiten$trie$TrieModel$EmptyTrie),
            $rluiten$trie$Trie$Json$Decoder$decoderTrie(valDec)
        ]));
    };
    var $rluiten$trie$Trie$Json$Decoder$decoderTrie = function (valDec) {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            _Json_map1_fn($rluiten$trie$TrieModel$ValNode, $rluiten$trie$Trie$Json$Decoder$decoderValDict(valDec)),
            _Json_map1_fn($rluiten$trie$TrieModel$TrieNode, $elm$json$Json$Decode$lazy(function (_v0) {
                return $rluiten$trie$Trie$Json$Decoder$decoderTrieDict(valDec);
            })),
            _Json_map1_fn($rluiten$trie$TrieModel$ValTrieNode, $elm$json$Json$Decode$lazy(function (_v1) {
                return $rluiten$trie$Trie$Json$Decoder$decoderValTrieNode(valDec);
            })),
            $elm$json$Json$Decode$fail("Invalid Trie Structure found.")
        ]));
    };
    var $rluiten$trie$Trie$Json$Decoder$decoderTrieDict = function (valDec) {
        return $elm$json$Json$Decode$dict($rluiten$trie$Trie$Json$Decoder$decoder(valDec));
    };
    var $rluiten$trie$Trie$Json$Decoder$decoderValTrieNode = function (valDec) {
        return _Json_map2_fn($elm$core$Tuple$pair, _Json_decodeIndex_fn(0, $rluiten$trie$Trie$Json$Decoder$decoderValDict(valDec)), _Json_decodeIndex_fn(1, $rluiten$trie$Trie$Json$Decoder$decoderTrieDict(valDec)));
    };
    var $rluiten$elm_text_search$ElmTextSearch$Json$Decoder$setDecoder = _Json_map1_fn($elm$core$Set$fromList, $elm$json$Json$Decode$list($elm$json$Json$Decode$string));
    var $rluiten$elm_text_search$ElmTextSearch$Json$Decoder$documentStoreDecoder = $elm$json$Json$Decode$dict($rluiten$elm_text_search$ElmTextSearch$Json$Decoder$setDecoder);
    var $elm$json$Json$Decode$float = _Json_decodeFloat;
    var $rluiten$elm_text_search$ElmTextSearch$Json$Decoder$decoder = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("tokenStore", $rluiten$trie$Trie$Json$Decoder$decoder($elm$json$Json$Decode$float), $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("corpusTokens", $rluiten$elm_text_search$ElmTextSearch$Json$Decoder$setDecoder, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("documentStore", $rluiten$elm_text_search$ElmTextSearch$Json$Decoder$documentStoreDecoder, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("indexType", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("indexVersion", $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($rluiten$elm_text_search$Index$Model$CodecIndexRecord))))));
    var $rluiten$elm_text_search$Index$Load$errorPrefix = "Error cannot load Index.";
    var $rluiten$elm_text_search$Index$Load$mapIndexConfig_fn = function (supportedIndexConfigs, index) {
        if (!_Utils_eq($rluiten$elm_text_search$Index$Defaults$indexVersion, index.fA)) {
            return $elm$json$Json$Decode$fail($rluiten$elm_text_search$Index$Load$errorPrefix + (" Version supported is " + ($rluiten$elm_text_search$Index$Defaults$indexVersion + (". Version tried to load is " + (index.fA + ".")))));
        }
        else {
            var config = $elm$core$List$filter_fn(function (cfg) {
                return _Utils_eq(cfg.hP, index.hP);
            }, supportedIndexConfigs);
            if (!config.b) {
                return $elm$json$Json$Decode$fail($rluiten$elm_text_search$Index$Load$errorPrefix + (" Tried to load index of type \"" + (index.hP + "\". It is not in supported index configurations.")));
            }
            else {
                var matchedConfig = config.a;
                return $elm$json$Json$Decode$succeed(_Utils_Tuple2(matchedConfig, index));
            }
        }
    }, $rluiten$elm_text_search$Index$Load$mapIndexConfig = F2($rluiten$elm_text_search$Index$Load$mapIndexConfig_fn);
    var $rluiten$elm_text_search$Index$Load$loadIndexWith_fn = function (supportedIndexConfigs, inputString) {
        return _Json_runOnString_fn(_Json_andThen_fn($rluiten$elm_text_search$Index$Load$createIndex, _Json_andThen_fn($rluiten$elm_text_search$Index$Load$mapIndexConfig(supportedIndexConfigs), $rluiten$elm_text_search$ElmTextSearch$Json$Decoder$decoder)), inputString);
    }, $rluiten$elm_text_search$Index$Load$loadIndexWith = F2($rluiten$elm_text_search$Index$Load$loadIndexWith_fn);
    var $rluiten$elm_text_search$ElmTextSearch$fromStringWith = $rluiten$elm_text_search$Index$Load$loadIndexWith;
    var $author$project$Search$Index$indexDecoder = function (config) {
        var elmTextSearchDecoder = _Json_andThen_fn(function (stringEncoding) {
            var _v0 = $rluiten$elm_text_search$Index$Load$loadIndexWith_fn(_List_fromArray([config.bm]), stringEncoding);
            if (!_v0.$) {
                var index = _v0.a;
                return $elm$json$Json$Decode$succeed(index);
            }
            else {
                var err = _v0.a;
                return $elm$json$Json$Decode$fail($elm$json$Json$Decode$errorToString(err));
            }
        }, $elm$json$Json$Decode$string);
        var toIndex = function (storedVersion) {
            return _Utils_eq(storedVersion, config.bL) ? _Json_map3_fn($author$project$Search$Index$Index, _Json_decodeField_fn("index", elmTextSearchDecoder), $elm$json$Json$Decode$succeed(storedVersion), _Json_decodeField_fn("updatedAt", _Json_map1_fn($elm$time$Time$millisToPosix, $elm$json$Json$Decode$int))) : $elm$json$Json$Decode$succeed($author$project$Search$Index$freshIndex(config));
        };
        return _Json_andThen_fn(toIndex, _Json_decodeField_fn("configVersion", $elm$json$Json$Decode$int));
    };
    var $author$project$Search$Index$indicesDecoder = function () {
        var indexDecoderHelper = function (config) {
            return $elm$json$Json$Decode$oneOf(_List_fromArray([
                $author$project$Search$Index$indexDecoder(config),
                $elm$json$Json$Decode$null($author$project$Search$Index$freshIndex(config))
            ]));
        };
        return _Json_map2_fn($author$project$Search$Index$Indices, _Json_decodeField_fn("notes", indexDecoderHelper($author$project$Search$Index$noteConfig)), _Json_decodeField_fn("people", indexDecoderHelper($author$project$Search$Index$personConfig)));
    }();
    var $author$project$Search$Index$searchIndicesLoaded = _Platform_incomingPort("searchIndicesLoaded", $elm$json$Json$Decode$value);
    var $author$project$Search$Index$loaded = function (toMsg) {
        return $author$project$Search$Index$searchIndicesLoaded(A2($elm$core$Basics$composeR, $elm$json$Json$Decode$decodeValue($author$project$Search$Index$indicesDecoder), toMsg));
    };
    var $author$project$Search$Weight$Index_fn = function (updatedAt, people) {
        return (new $$Record21(people, updatedAt));
    }, $author$project$Search$Weight$Index = F2($author$project$Search$Weight$Index_fn);
    var $author$project$Search$Weight$decoder = _Json_map2_fn($author$project$Search$Weight$Index, _Json_decodeField_fn("updatedAt", $author$project$Util$Time$decodePosixFromMillis), _Json_decodeField_fn("people", $elm$json$Json$Decode$dict($elm$json$Json$Decode$float)));
    var $author$project$Search$Weight$searchWeightIndexLoaded_ = _Platform_incomingPort("searchWeightIndexLoaded_", $elm$json$Json$Decode$value);
    var $author$project$Search$Weight$loaded = function (toMsg) {
        return $author$project$Search$Weight$searchWeightIndexLoaded_(A2($elm$core$Basics$composeR, $elm$json$Json$Decode$decodeValue($author$project$Search$Weight$decoder), toMsg));
    };
    var $elm$browser$Browser$Events$Window = 1;
    var $elm$browser$Browser$Events$MySub_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $elm$browser$Browser$Events$MySub = F3($elm$browser$Browser$Events$MySub_fn);
    var $elm$browser$Browser$Events$State_fn = function (subs, pids) {
        return { iD: pids, jj: subs };
    }, $elm$browser$Browser$Events$State = F2($elm$browser$Browser$Events$State_fn);
    var $elm$browser$Browser$Events$init = $elm$core$Task$succeed($elm$browser$Browser$Events$State_fn(_List_Nil, $elm$core$Dict$empty));
    var $elm$browser$Browser$Events$nodeToKey = function (node) {
        if (!node) {
            return "d_";
        }
        else {
            return "w_";
        }
    };
    var $elm$browser$Browser$Events$addKey = function (sub) {
        var node = sub.a;
        var name = sub.b;
        return _Utils_Tuple2(_Utils_ap($elm$browser$Browser$Events$nodeToKey(node), name), sub);
    };
    var $elm$browser$Browser$Events$Event_fn = function (key, event) {
        return { hf: event, mC: key };
    }, $elm$browser$Browser$Events$Event = F2($elm$browser$Browser$Events$Event_fn);
    var $elm$browser$Browser$Events$spawn_fn = function (router, key, _v0) {
        var node = _v0.a;
        var name = _v0.b;
        var actualNode = function () {
            if (!node) {
                return _Browser_doc;
            }
            else {
                return _Browser_window;
            }
        }();
        return $elm$core$Task$map_fn(function (value) {
            return _Utils_Tuple2(key, value);
        }, _Browser_on_fn(actualNode, name, function (event) {
            return _Platform_sendToSelf_fn(router, $elm$browser$Browser$Events$Event_fn(key, event));
        }));
    }, $elm$browser$Browser$Events$spawn = F3($elm$browser$Browser$Events$spawn_fn);
    var $elm$browser$Browser$Events$onEffects_fn = function (router, subs, state) {
        var stepRight = F3(function (key, sub, _v6) {
            var deads = _v6.a;
            var lives = _v6.b;
            var news = _v6.c;
            return _Utils_Tuple3(deads, lives, _List_Cons($elm$browser$Browser$Events$spawn_fn(router, key, sub), news));
        });
        var stepLeft = F3(function (_v4, pid, _v5) {
            var deads = _v5.a;
            var lives = _v5.b;
            var news = _v5.c;
            return _Utils_Tuple3(_List_Cons(pid, deads), lives, news);
        });
        var stepBoth = F4(function (key, pid, _v2, _v3) {
            var deads = _v3.a;
            var lives = _v3.b;
            var news = _v3.c;
            return _Utils_Tuple3(deads, $elm$core$Dict$insert_fn(key, pid, lives), news);
        });
        var newSubs = $elm$core$List$map_fn($elm$browser$Browser$Events$addKey, subs);
        var _v0 = $elm$core$Dict$merge_fn(stepLeft, stepBoth, stepRight, state.iD, $elm$core$Dict$fromList(newSubs), _Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
        var deadPids = _v0.a;
        var livePids = _v0.b;
        var makeNewPids = _v0.c;
        return _Scheduler_andThen_fn(function (pids) {
            return $elm$core$Task$succeed($elm$browser$Browser$Events$State_fn(newSubs, $elm$core$Dict$union_fn(livePids, $elm$core$Dict$fromList(pids))));
        }, _Scheduler_andThen_fn(function (_v1) {
            return $elm$core$Task$sequence(makeNewPids);
        }, $elm$core$Task$sequence($elm$core$List$map_fn($elm$core$Process$kill, deadPids))));
    }, $elm$browser$Browser$Events$onEffects = F3($elm$browser$Browser$Events$onEffects_fn);
    var $elm$browser$Browser$Events$onSelfMsg_fn = function (router, _v0, state) {
        var key = _v0.mC;
        var event = _v0.hf;
        var toMessage = function (_v2) {
            var subKey = _v2.a;
            var _v3 = _v2.b;
            var node = _v3.a;
            var name = _v3.b;
            var decoder = _v3.c;
            return _Utils_eq(subKey, key) ? _Browser_decodeEvent_fn(decoder, event) : $elm$core$Maybe$Nothing;
        };
        var messages = $elm$core$List$filterMap_fn(toMessage, state.jj);
        return _Scheduler_andThen_fn(function (_v1) {
            return $elm$core$Task$succeed(state);
        }, $elm$core$Task$sequence($elm$core$List$map_fn($elm$core$Platform$sendToApp(router), messages)));
    }, $elm$browser$Browser$Events$onSelfMsg = F3($elm$browser$Browser$Events$onSelfMsg_fn);
    var $elm$browser$Browser$Events$subMap_fn = function (func, _v0) {
        var node = _v0.a;
        var name = _v0.b;
        var decoder = _v0.c;
        return $elm$browser$Browser$Events$MySub_fn(node, name, _Json_map1_fn(func, decoder));
    }, $elm$browser$Browser$Events$subMap = F2($elm$browser$Browser$Events$subMap_fn);
    _Platform_effectManagers["Browser.Events"] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
    var $elm$browser$Browser$Events$subscription = _Platform_leaf("Browser.Events");
    var $elm$browser$Browser$Events$on_fn = function (node, name, decoder) {
        return $elm$browser$Browser$Events$subscription($elm$browser$Browser$Events$MySub_fn(node, name, decoder));
    }, $elm$browser$Browser$Events$on = F3($elm$browser$Browser$Events$on_fn);
    var $elm$browser$Browser$Events$onResize = function (func) {
        return $elm$browser$Browser$Events$on_fn(1, "resize", _Json_decodeField_fn("target", _Json_map2_fn(func, _Json_decodeField_fn("innerWidth", $elm$json$Json$Decode$int), _Json_decodeField_fn("innerHeight", $elm$json$Json$Decode$int))));
    };
    var $author$project$Ports$personsMerged = _Platform_incomingPort("personsMerged", _Json_andThen_fn(function (success) {
        return _Json_andThen_fn(function (secondaryPersonId) {
            return _Json_andThen_fn(function (primaryPersonId) {
                return $elm$json$Json$Decode$succeed({ iL: primaryPersonId, f1: secondaryPersonId, o3: success });
            }, _Json_decodeField_fn("primaryPersonId", $elm$json$Json$Decode$string));
        }, _Json_decodeField_fn("secondaryPersonId", $elm$json$Json$Decode$string));
    }, _Json_decodeField_fn("success", $elm$json$Json$Decode$bool)));
    var $author$project$Ports$refreshApp = _Platform_incomingPort("refreshApp", $elm$json$Json$Decode$string);
    var $elm_community$result_extra$Result$Extra$unpack_fn = function (errFunc, okFunc, result) {
        if (!result.$) {
            var ok = result.a;
            return okFunc(ok);
        }
        else {
            var err = result.a;
            return errFunc(err);
        }
    }, $elm_community$result_extra$Result$Extra$unpack = F3($elm_community$result_extra$Result$Extra$unpack_fn);
    var $author$project$Subscriptions$sendToMsg_fn = function (entityName, toMsg, decodeResult) {
        return $elm_community$result_extra$Result$Extra$unpack_fn($author$project$Subscriptions$logDecodeError(entityName), toMsg, decodeResult);
    }, $author$project$Subscriptions$sendToMsg = F3($author$project$Subscriptions$sendToMsg_fn);
    var $author$project$Ports$signedInStatus = _Platform_incomingPort("signedInStatus", $elm$json$Json$Decode$value);
    var $author$project$Data$StorageUpload$Error_fn = function (msg, upload) {
        return { m8: msg, jA: upload };
    }, $author$project$Data$StorageUpload$Error = F2($author$project$Data$StorageUpload$Error_fn);
    var $author$project$Data$StorageUpload$MsgError = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$StorageUpload$MsgSnapshot = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$StorageUpload$Snapshot_fn = function (entityId, bytesTransferred, storagePath, totalBytes, downloadUrl, fileName, inline, canceller, mimeType) {
        return (new $$Record75(bytesTransferred, canceller, downloadUrl, entityId, fileName, inline, mimeType, storagePath, totalBytes));
    }, $author$project$Data$StorageUpload$Snapshot = F9($author$project$Data$StorageUpload$Snapshot_fn);
    var $author$project$Data$StorageUpload$msgDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        _Json_decodeField_fn("ok", _Json_map1_fn($author$project$Data$StorageUpload$MsgSnapshot, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("mimeType", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("canceller", $elm$json$Json$Decode$value, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("inline", $elm$json$Json$Decode$bool, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("fileName", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("downloadUrl", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("totalBytes", $elm$json$Json$Decode$int, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("storagePath", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("bytesTransferred", $elm$json$Json$Decode$int, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("entityId", $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Data$StorageUpload$Snapshot)))))))))))),
        _Json_decodeField_fn("err", _Json_map1_fn($author$project$Data$StorageUpload$MsgError, _Json_map2_fn($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom_a0, $elm$json$Json$Decode$maybe(_Json_decodeField_fn("upload", _Json_map2_fn(F2(function (entityId, storagePath) {
            return { bq: entityId, Y: storagePath };
        }), _Json_decodeField_fn("entityId", $elm$json$Json$Decode$string), _Json_decodeField_fn("storagePath", $elm$json$Json$Decode$string)))), $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("msg", $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Data$StorageUpload$Error)))))
    ]));
    var $author$project$Data$StorageUpload$uploadStatus = _Platform_incomingPort("uploadStatus", $elm$json$Json$Decode$value);
    var $author$project$Data$StorageUpload$subscribe = function (toMsg) {
        return $author$project$Data$StorageUpload$uploadStatus(A2($elm$core$Basics$composeR, $elm$json$Json$Decode$decodeValue($author$project$Data$StorageUpload$msgDecoder), toMsg));
    };
    var $author$project$Model$ElmRRULETest = function (a) {
        return { $: 47, a: a };
    };
    var $elm$core$Tuple$mapSecond_fn = function (func, _v0) {
        var x = _v0.a;
        var y = _v0.b;
        return _Utils_Tuple2(x, func(y));
    }, $elm$core$Tuple$mapSecond = F2($elm$core$Tuple$mapSecond_fn);
    var $author$project$Ports$receiveRRuleJSInstances = _Platform_incomingPort("receiveRRuleJSInstances", $elm$json$Json$Decode$list(_Json_andThen_fn(function (_v0) {
        return _Json_andThen_fn(function (_v1) {
            return $elm$json$Json$Decode$succeed(_Utils_Tuple2(_v0, _v1));
        }, _Json_decodeIndex_fn(1, $elm$json$Json$Decode$list($elm$json$Json$Decode$int)));
    }, _Json_decodeIndex_fn(0, $elm$json$Json$Decode$string))));
    var $author$project$ElmRRULETest$subscription = $author$project$Ports$receiveRRuleJSInstances(function (data) {
        return $author$project$Model$ElmRRULETest($elm$core$Dict$fromList($elm$core$List$map_fn($elm$core$Tuple$mapSecond($elm$core$List$map($elm$time$Time$millisToPosix)), data)));
    });
    var $author$project$Ports$unhibernated_ = _Platform_incomingPort("unhibernated_", $elm$json$Json$Decode$int);
    var $author$project$Ports$unhibernated = function (toMsg) {
        return $author$project$Ports$unhibernated_(A2($elm$core$Basics$composeR, $elm$time$Time$millisToPosix, toMsg));
    };
    var $author$project$Ports$updateSlateDoc = _Platform_incomingPort("updateSlateDoc", _Json_andThen_fn(function (slateDoc) {
        return _Json_andThen_fn(function (noteId) {
            return _Json_andThen_fn(function (actionItems) {
                return $elm$json$Json$Decode$succeed((new $$Record76(actionItems, noteId, slateDoc)));
            }, _Json_decodeField_fn("actionItems", $elm$json$Json$Decode$value));
        }, _Json_decodeField_fn("noteId", $elm$json$Json$Decode$string));
    }, _Json_decodeField_fn("slateDoc", $elm$json$Json$Decode$string)));
    var $author$project$Env$UpdateNote = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Subscriptions$updateSlateDocHelper = function (_v0) {
        var noteId = _v0.ip;
        var slateDoc = _v0.f6;
        var actionItems = _v0.gz;
        var toMsg = function (newActionItems) {
            return $author$project$Model$HandleBacktalk($author$project$Env$UpdateNote((new $$Record77(false, noteId, function (note) {
                return function () {
                    var $r = note.$c();
                    $r.f6 = slateDoc;
                    $r.gz = newActionItems;
                    return $r;
                }();
            }))));
        };
        var decodedActionItems = _Json_run_fn($elm$json$Json$Decode$list($author$project$Data$ActionItem$decode), actionItems);
        if (!decodedActionItems.$) {
            var newActionItems = decodedActionItems.a;
            return toMsg(newActionItems);
        }
        else {
            var decodeErr = decodedActionItems.a;
            return $author$project$Subscriptions$logDecodeError_fn("Ports.updateSlateDoc (Data.ActionItem)", decodeErr);
        }
    };
    var $author$project$Ports$updateUserIdToken = _Platform_incomingPort("updateUserIdToken", $elm$json$Json$Decode$string);
    var $author$project$Ports$userSubscription = _Platform_incomingPort("userSubscription", $elm$json$Json$Decode$value);
    var $author$project$Subscriptions$subscriptions = function (model) {
        var sendTo = F4(function (toMsg, entityName, decoder, val) {
            return $elm_community$result_extra$Result$Extra$unpack_fn($author$project$Subscriptions$logDecodeError(entityName), toMsg, _Json_run_fn(decoder, val));
        });
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $elm$time$Time$every_fn(60000, $author$project$Model$EveryMinute),
            $author$project$Ports$unhibernated($author$project$Model$EveryMinute),
            $author$project$Ports$fromFirestore(A2($elm$core$Basics$composeR, $author$project$Firestore$Sub$decodeMsg, $author$project$Model$FirestoreMsg)),
            $author$project$Ports$signedInStatus(A3(sendTo, $author$project$Model$SignedIn, "User", $elm$json$Json$Decode$nullable($author$project$Data$User$decoder))),
            $author$project$Ports$userSubscription(A3(sendTo, $author$project$Model$UserSubscription, "Subscription", $elm$json$Json$Decode$nullable($author$project$Data$Subscription$decoder))),
            $elm$browser$Browser$Events$onResize(F2(function (_v0, _v1) {
                return $author$project$Model$GetWindowViewport;
            })),
            $author$project$Ports$keypressed(A3(sendTo, $author$project$Model$Keypressed, "Keypress Event", $author$project$Data$Keypress$decoder)),
            $author$project$Ports$personsMerged($author$project$Model$PersonsMerged),
            $author$project$Ports$gcalEvents($author$project$Subscriptions$decodeEventBatch(model.dW.pu)),
            $author$project$Ports$appVersion(A3(sendTo, $author$project$Model$AppVersionUpdated, "Data.App.Version", $author$project$Data$App$decodeVersion)),
            $author$project$Ports$refreshApp(function (_v2) {
                return $author$project$Model$AppReloadRequired(0);
            }),
            $author$project$Ports$updateUserIdToken($author$project$Model$UpdateUserIdToken),
            $author$project$Ports$updateSlateDoc($author$project$Subscriptions$updateSlateDocHelper),
            $author$project$Search$Index$loaded(A2($author$project$Subscriptions$sendToMsg, "Search.Index.Indices", $author$project$Model$SearchIndicesLoaded)),
            $author$project$Search$Weight$loaded(A2($author$project$Subscriptions$sendToMsg, "Search.Weight.Index", $author$project$Model$SearchWeightIndexLoaded)),
            $author$project$Data$StorageUpload$subscribe(A2($author$project$Subscriptions$sendToMsg, "Data.StorageUpload.Msg", $author$project$Model$StorageUploadMsg)),
            $author$project$Data$MentionResult$fromEditor(A2($author$project$Subscriptions$sendToMsg, "Data.MentionResult.Result", $author$project$Model$MentionRequest)),
            $author$project$ElmRRULETest$subscription
        ]));
    };
    var $author$project$Env$AnalyticsEvent = function (a) {
        return { $: 32, a: a };
    };
    var $author$project$Analytics$AppLoadBenchmark = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Env$AttachmentThumbnailUrlRequest_fn = function (a, b) {
        return { $: 8, a: a, b: b };
    }, $author$project$Env$AttachmentThumbnailUrlRequest = F2($author$project$Env$AttachmentThumbnailUrlRequest_fn);
    var $author$project$Error$AuthError = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Analytics$CalendarLinked = { $: 61 };
    var $author$project$Model$CheckTimezone = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Model$ComputeNextMeeting = { $: 13 };
    var $author$project$Data$Dialog$Closeable$ErrorConnectingToStripe = { $: 11 };
    var $author$project$Data$Dialog$Closeable$ErrorSubmittingFeedback = { $: 3 };
    var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Analytics$GA_AccountCreated = 0;
    var $author$project$Analytics$GA_CalendarLinked = 1;
    var $author$project$Data$Dialog$Closeable$LinkCalendarError = function (a) {
        return { $: 10, a: a };
    };
    var $krisajenkins$remotedata$RemoteData$Loading = { $: 1 };
    var $author$project$Env$NoOp = function (a) {
        return { $: 36, a: a };
    };
    var $author$project$Model$NoOp = function (a) {
        return { $: 45, a: a };
    };
    var $author$project$Analytics$NoteAttachmentAdded = { $: 20 };
    var $author$project$Model$NoteFromEvent = function (a) {
        return { $: 12, a: a };
    };
    var $author$project$Analytics$NoteInlineAttachmentAdded = { $: 21 };
    var $author$project$Error$PersonMergeFailed = { $: 8 };
    var $author$project$Model$PersonMsg = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Env$PushToSnackbar = function (a) {
        return { $: 23, a: a };
    };
    var $author$project$Data$App$RequiredVersionUpdate = 1;
    var $author$project$Analytics$RouteChanged = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Model$SearchbarMsg = function (a) {
        return { $: 24, a: a };
    };
    var $author$project$Env$StripeCreateCheckoutSession = function (a) {
        return { $: 18, a: a };
    };
    var $krisajenkins$remotedata$RemoteData$Success = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Env$Tantrum = function (a) {
        return { $: 35, a: a };
    };
    var $author$project$Data$Dialog$Closeable$ThanksForFeedback = { $: 2 };
    var $elm_community$list_extra$List$Extra$uniqueHelp_fn = function (f, existing, remaining, accumulator) {
        uniqueHelp: while (true) {
            if (!remaining.b) {
                return $elm$core$List$reverse(accumulator);
            }
            else {
                var first = remaining.a;
                var rest = remaining.b;
                var computedFirst = f(first);
                if ($elm$core$Set$member_fn(computedFirst, existing)) {
                    var $temp$f = f, $temp$existing = existing, $temp$remaining = rest, $temp$accumulator = accumulator;
                    f = $temp$f;
                    existing = $temp$existing;
                    remaining = $temp$remaining;
                    accumulator = $temp$accumulator;
                    continue uniqueHelp;
                }
                else {
                    var $temp$f = f, $temp$existing = $elm$core$Set$insert_fn(computedFirst, existing), $temp$remaining = rest, $temp$accumulator = _List_Cons(first, accumulator);
                    f = $temp$f;
                    existing = $temp$existing;
                    remaining = $temp$remaining;
                    accumulator = $temp$accumulator;
                    continue uniqueHelp;
                }
            }
        }
    }, $elm_community$list_extra$List$Extra$uniqueHelp = F4($elm_community$list_extra$List$Extra$uniqueHelp_fn);
    var $elm_community$list_extra$List$Extra$uniqueBy_fn = function (f, list) {
        return $elm_community$list_extra$List$Extra$uniqueHelp_fn(f, $elm$core$Set$empty, list, _List_Nil);
    }, $elm_community$list_extra$List$Extra$uniqueBy = F2($elm_community$list_extra$List$Extra$uniqueBy_fn);
    var $author$project$Data$Note$addAttachment_fn = function (attachment, note) {
        return $$update__kd(note, $elm_community$list_extra$List$Extra$uniqueBy_fn(function ($) {
            return $.Y;
        }, _List_Cons(attachment, note.kd)));
    }, $author$project$Data$Note$addAttachment = F2($author$project$Data$Note$addAttachment_fn);
    var $elm$core$List$all_fn = function (isOkay, list) {
        all: while (true) {
            if (!list.b) {
                return true;
            }
            else {
                var x = list.a;
                if (!isOkay(x)) {
                    return false;
                }
                list = list.b;
                continue all;
            }
        }
    }, $elm$core$List$all = F2($elm$core$List$all_fn);
    var $author$project$Lib$Snackbar$Standard = 0;
    var $author$project$View$Snacks$attachmentUploadSuccess = function (filename) {
        return (new $$Record78($elm$core$Maybe$Nothing, {
            hF: "Attachment Uploaded!",
            cp: $elm$core$Maybe$Just(filename)
        }, true, false, 0));
    };
    var $author$project$Lib$Snackbar$Alert = 1;
    var $author$project$View$Snacks$attachmentUploadWarning = function (errorMsg) {
        return (new $$Record78($elm$core$Maybe$Nothing, {
            hF: errorMsg,
            cp: $elm$core$Maybe$Just("Attachments")
        }, true, false, 1));
    };
    var $author$project$Error$RRuleTest = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$ElmRRULETest$dropLast = function (list) {
        var _v0 = $elm$core$List$reverse(list);
        if (!_v0.b) {
            return _List_Nil;
        }
        else {
            var xs = _v0.b;
            return $elm$core$List$reverse(xs);
        }
    };
    var $author$project$ElmRRULETest$ignoredEventIds = $elm$core$Set$fromList(_List_fromArray(["l8ctra0mrvh8a6klmcd2p3l0ls", "b0s67jdrf398vui5bg83dktm4g_R20190918T123000", "4demnf8grimsdg8hnp60pg4cuo", "vfv8d0p0rs46sne3ftt80nf48u"]));
    var $author$project$Util$add_fn = function (_int, time) {
        return $elm$time$Time$millisToPosix($elm$time$Time$posixToMillis(time) + _int);
    }, $author$project$Util$add = F2($author$project$Util$add_fn);
    var $justinmimbs$time_extra$Time$Extra$Week = 3;
    var $justinmimbs$time_extra$Time$Extra$Year = 0;
    var $author$project$RRule$freqToInterval = function (freq) {
        switch (freq) {
            case 0:
                return 11;
            case 1:
                return 3;
            case 2:
                return 2;
            default:
                return 0;
        }
    };
    var $author$project$Util$subtract_fn = function (_int, time) {
        return $elm$time$Time$millisToPosix($elm$time$Time$posixToMillis(time) - _int);
    }, $author$project$Util$subtract = F2($author$project$Util$subtract_fn);
    var $author$project$RRule$computeNextWindow_fn = function (rrule, window) {
        var timeUnit = $author$project$RRule$freqToInterval(rrule.aa);
        var newUpperBound = $justinmimbs$time_extra$Time$Extra$add_fn(timeUnit, rrule.cY, rrule.f, $author$project$Util$add_fn(1, window.ds));
        var newLowerBound = $justinmimbs$time_extra$Time$Extra$add_fn(timeUnit, -1, rrule.f, newUpperBound);
        return {
            c$: newLowerBound,
            ds: $author$project$Util$subtract_fn(1, newUpperBound)
        };
    }, $author$project$RRule$computeNextWindow = F2($author$project$RRule$computeNextWindow_fn);
    var $author$project$Util$gt_fn = function (t1, t2) {
        return _Utils_cmp($elm$time$Time$posixToMillis(t1), $elm$time$Time$posixToMillis(t2)) > 0;
    }, $author$project$Util$gt = F2($author$project$Util$gt_fn);
    var $author$project$Util$gte_fn = function (t1, t2) {
        return _Utils_cmp($elm$time$Time$posixToMillis(t1), $elm$time$Time$posixToMillis(t2)) > -1;
    }, $author$project$Util$gte = F2($author$project$Util$gte_fn);
    var $author$project$RRule$inWindow_fn = function (time, _v0) {
        var lowerBound = _v0.c$;
        var upperBound = _v0.ds;
        var _v1 = _Utils_Tuple3($elm$time$Time$posixToMillis(time), $elm$time$Time$posixToMillis(lowerBound), $elm$time$Time$posixToMillis(upperBound));
        var time_ = _v1.a;
        var lowerBound_ = _v1.b;
        var upperBound_ = _v1.c;
        return (_Utils_cmp(time_, lowerBound_) > -1) && (_Utils_cmp(time_, upperBound_) < 1);
    }, $author$project$RRule$inWindow = F2($author$project$RRule$inWindow_fn);
    var $justinmimbs$date$Date$Day = 11;
    var $justinmimbs$date$Date$Friday = 8;
    var $justinmimbs$date$Date$Monday = 4;
    var $justinmimbs$date$Date$Month = 2;
    var $justinmimbs$date$Date$Quarter = 1;
    var $justinmimbs$date$Date$Saturday = 9;
    var $justinmimbs$date$Date$Sunday = 10;
    var $justinmimbs$date$Date$Thursday = 7;
    var $justinmimbs$date$Date$Tuesday = 5;
    var $justinmimbs$date$Date$Wednesday = 6;
    var $justinmimbs$date$Date$Week = 3;
    var $justinmimbs$date$Date$Year = 0;
    var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
        switch (wd) {
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            default:
                return 7;
        }
    };
    var $justinmimbs$date$Date$daysSincePreviousWeekday_fn = function (wd, date) {
        return _Basics_modBy_fn(7, ($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
    }, $justinmimbs$date$Date$daysSincePreviousWeekday = F2($justinmimbs$date$Date$daysSincePreviousWeekday_fn);
    var $justinmimbs$date$Date$firstOfMonth_fn = function (y, m) {
        return ($justinmimbs$date$Date$daysBeforeYear(y) + $justinmimbs$date$Date$daysBeforeMonth_fn(y, m)) + 1;
    }, $justinmimbs$date$Date$firstOfMonth = F2($justinmimbs$date$Date$firstOfMonth_fn);
    var $justinmimbs$date$Date$quarterToMonth = function (q) {
        return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
    };
    var $justinmimbs$date$Date$floor_fn = function (interval, date) {
        var rd = date;
        switch (interval) {
            case 0:
                return $justinmimbs$date$Date$firstOfYear($justinmimbs$date$Date$year(date));
            case 1:
                return $justinmimbs$date$Date$firstOfMonth_fn($justinmimbs$date$Date$year(date), $justinmimbs$date$Date$quarterToMonth($elm$core$Basics$composeR_fn($justinmimbs$date$Date$quarter_a0, $justinmimbs$date$Date$quarter_a1, date)));
            case 2:
                return $justinmimbs$date$Date$firstOfMonth_fn($justinmimbs$date$Date$year(date), $elm$core$Basics$composeR_fn($justinmimbs$date$Date$month_a0, $justinmimbs$date$Date$month_a1, date));
            case 3:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(0, date);
            case 4:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(0, date);
            case 5:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(1, date);
            case 6:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(2, date);
            case 7:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(3, date);
            case 8:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(4, date);
            case 9:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(5, date);
            case 10:
                return rd - $justinmimbs$date$Date$daysSincePreviousWeekday_fn(6, date);
            default:
                return date;
        }
    }, $justinmimbs$date$Date$floor = F2($justinmimbs$date$Date$floor_fn);
    var $justinmimbs$time_extra$Time$Extra$floorDate_fn = function (dateInterval, zone, posix) {
        return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$floor_fn(dateInterval, $justinmimbs$date$Date$fromPosix_fn(zone, posix)), 0);
    }, $justinmimbs$time_extra$Time$Extra$floorDate = F3($justinmimbs$time_extra$Time$Extra$floorDate_fn);
    var $justinmimbs$time_extra$Time$Extra$floor_fn = function (interval, zone, posix) {
        switch (interval) {
            case 15:
                return posix;
            case 14:
                return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$fromPosix_fn(zone, posix), $justinmimbs$time_extra$Time$Extra$timeFromClock_fn($elm$time$Time$toHour_fn(zone, posix), $elm$time$Time$toMinute_fn(zone, posix), $elm$time$Time$toSecond_fn(zone, posix), 0));
            case 13:
                return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$fromPosix_fn(zone, posix), $justinmimbs$time_extra$Time$Extra$timeFromClock_fn($elm$time$Time$toHour_fn(zone, posix), $elm$time$Time$toMinute_fn(zone, posix), 0, 0));
            case 12:
                return $justinmimbs$time_extra$Time$Extra$posixFromDateTime_fn(zone, $justinmimbs$date$Date$fromPosix_fn(zone, posix), $justinmimbs$time_extra$Time$Extra$timeFromClock_fn($elm$time$Time$toHour_fn(zone, posix), 0, 0, 0));
            case 11:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(11, zone, posix);
            case 2:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(2, zone, posix);
            case 0:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(0, zone, posix);
            case 1:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(1, zone, posix);
            case 3:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(3, zone, posix);
            case 4:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(4, zone, posix);
            case 5:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(5, zone, posix);
            case 6:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(6, zone, posix);
            case 7:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(7, zone, posix);
            case 8:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(8, zone, posix);
            case 9:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(9, zone, posix);
            default:
                return $justinmimbs$time_extra$Time$Extra$floorDate_fn(10, zone, posix);
        }
    }, $justinmimbs$time_extra$Time$Extra$floor = F3($justinmimbs$time_extra$Time$Extra$floor_fn);
    var $justinmimbs$time_extra$Time$Extra$ceiling_fn = function (interval, zone, posix) {
        var floored = $justinmimbs$time_extra$Time$Extra$floor_fn(interval, zone, posix);
        return _Utils_eq(floored, posix) ? posix : $justinmimbs$time_extra$Time$Extra$add_fn(interval, 1, zone, floored);
    }, $justinmimbs$time_extra$Time$Extra$ceiling = F3($justinmimbs$time_extra$Time$Extra$ceiling_fn);
    var $justinmimbs$time_extra$Time$Extra$Friday = 8;
    var $justinmimbs$time_extra$Time$Extra$Monday = 4;
    var $justinmimbs$time_extra$Time$Extra$Saturday = 9;
    var $justinmimbs$time_extra$Time$Extra$Sunday = 10;
    var $justinmimbs$time_extra$Time$Extra$Thursday = 7;
    var $justinmimbs$time_extra$Time$Extra$Tuesday = 5;
    var $justinmimbs$time_extra$Time$Extra$Wednesday = 6;
    var $author$project$Util$weekdayToInterval = function (weekday) {
        switch (weekday) {
            case 0:
                return 4;
            case 1:
                return 5;
            case 2:
                return 6;
            case 3:
                return 7;
            case 4:
                return 8;
            case 5:
                return 9;
            default:
                return 10;
        }
    };
    var $author$project$RRule$windowInterval = function (rrule) {
        var _v0 = rrule.aa;
        switch (_v0) {
            case 0:
                return 11;
            case 1:
                return $author$project$Util$weekdayToInterval(rrule.gq);
            case 2:
                return 2;
            default:
                return 0;
        }
    };
    var $author$project$RRule$initWindow_fn = function (lowerBound, rrule) {
        return {
            c$: lowerBound,
            ds: $author$project$Util$subtract_fn(1, $justinmimbs$time_extra$Time$Extra$ceiling_fn($author$project$RRule$windowInterval(rrule), rrule.f, lowerBound))
        };
    }, $author$project$RRule$initWindow = F2($author$project$RRule$initWindow_fn);
    var $justinmimbs$time_extra$Time$Extra$posixToParts_fn = function (zone, posix) {
        return (new $$Record29($elm$time$Time$toDay_fn(zone, posix), $elm$time$Time$toHour_fn(zone, posix), $elm$time$Time$toMillis_fn(zone, posix), $elm$time$Time$toMinute_fn(zone, posix), $elm$time$Time$toMonth_fn(zone, posix), $elm$time$Time$toSecond_fn(zone, posix), $elm$time$Time$toYear_fn(zone, posix)));
    }, $justinmimbs$time_extra$Time$Extra$posixToParts = F2($justinmimbs$time_extra$Time$Extra$posixToParts_fn);
    var $author$project$Util$mergeTimeOf_fn = function (zone, timeOf, dateOf) {
        var _v0 = _Utils_Tuple2($justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, timeOf), $justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, dateOf));
        var timeOfParts = _v0.a;
        var dateOfParts = _v0.b;
        return $justinmimbs$time_extra$Time$Extra$partsToPosix_fn(zone, $$update__bO__bz__lb(timeOfParts, dateOfParts.bO, dateOfParts.bz, dateOfParts.lb));
    }, $author$project$Util$mergeTimeOf = F3($author$project$Util$mergeTimeOf_fn);
    var $author$project$RRule$withinByRules_fn = function (rrule, _v0, time) {
        var limits = _v0.F;
        var expands = _v0.E;
        var apply = function (f) {
            return A2(f, rrule, time);
        }, apply_unwrapped = function (f) {
            return f(rrule, time);
        };
        return (!$elm$core$List$any_fn(A2($elm$core$Basics$composeR, apply, $elm$core$Basics$not), limits)) && $elm$core$List$all_fn(apply, expands);
    }, $author$project$RRule$withinByRules = F3($author$project$RRule$withinByRules_fn);
    var $author$project$RRule$withinRuleset = $author$project$RRule$withinByRules;
    var $author$project$RRule$betweenHelper_fn = function (rrule, check, firstInstance, _v0) {
        var start = _v0.bF;
        var end = _v0.b6;
        var mergeWithDTSTART = A2($author$project$Util$mergeTimeOf, rrule.f, firstInstance);
        var mergedStartTime_ = mergeWithDTSTART(start);
        var mergedStartTime = $author$project$Util$gt_fn(start, mergedStartTime_) ? $justinmimbs$time_extra$Time$Extra$add_fn(11, 1, rrule.f, mergedStartTime_) : mergedStartTime_;
        var findFirstInstance = F2(function (window, time) {
            findFirstInstance: while (true) {
                if ($author$project$Util$gt_fn(time, end)) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    if ($author$project$Util$gte_fn(time, start) && ($author$project$RRule$withinByRules_fn(rrule, check, time) && $author$project$RRule$inWindow_fn(time, window))) {
                        return $elm$core$Maybe$Just({ dX: time, eJ: window });
                    }
                    else {
                        if (!$author$project$RRule$inWindow_fn(time, window)) {
                            var nextWindow = $author$project$RRule$computeNextWindow_fn(rrule, window);
                            var $temp$window = nextWindow, $temp$time = mergeWithDTSTART(nextWindow.c$);
                            window = $temp$window;
                            time = $temp$time;
                            continue findFirstInstance;
                        }
                        else {
                            var $temp$window = window, $temp$time = $justinmimbs$time_extra$Time$Extra$add_fn(11, 1, rrule.f, time);
                            window = $temp$window;
                            time = $temp$time;
                            continue findFirstInstance;
                        }
                    }
                }
            }
        });
        return $author$project$Util$gt_fn(start, end) ? $elm$core$Maybe$Nothing : ($author$project$Util$gte_fn(firstInstance, start) ? $elm$core$Maybe$Just({
            dX: firstInstance,
            eJ: $author$project$RRule$initWindow_fn(firstInstance, rrule)
        }) : A2(findFirstInstance, $author$project$RRule$initWindow_fn(firstInstance, rrule), mergedStartTime));
    }, $author$project$RRule$betweenHelper = F4($author$project$RRule$betweenHelper_fn);
    var $author$project$RRule$canOptimizeRun = function (rrule) {
        var _v0 = rrule.aa;
        switch (_v0) {
            case 0:
                return true;
            case 1:
                var _v1 = rrule.J;
                if (_v1.b && (!_v1.b.b)) {
                    return true;
                }
                else {
                    return false;
                }
            case 2:
                var _v2 = rrule.K;
                if (_v2.b && (!_v2.b.b)) {
                    var md = _v2.a;
                    return (md >= 1) && (md <= 28);
                }
                else {
                    return false;
                }
            default:
                var _v3 = _Utils_Tuple2(rrule.aA, rrule.K);
                if (((_v3.a.b && (!_v3.a.b.b)) && _v3.b.b) && (!_v3.b.b.b)) {
                    var _v4 = _v3.a;
                    var m = _v4.a;
                    var _v5 = _v3.b;
                    var md = _v5.a;
                    return (md >= 1) && ((!((m === 2) && (md === 29))) && ($elm$core$List$isEmpty(rrule.bZ) && ($elm$core$List$isEmpty(rrule.bY) && $elm$core$List$isEmpty(rrule.J))));
                }
                else {
                    return false;
                }
        }
    };
    var $author$project$RRule$and_fn = function (by1, by2) {
        return F2(function (rrule_, time_) {
            return A2(by1, rrule_, time_) && A2(by2, rrule_, time_);
        });
    }, $author$project$RRule$and = F2($author$project$RRule$and_fn);
    var $author$project$RRule$Th = 0;
    var $author$project$RRule$ThToLast = 1;
    var $author$project$Util$lt_fn = function (t1, t2) {
        return _Utils_cmp($elm$time$Time$posixToMillis(t1), $elm$time$Time$posixToMillis(t2)) < 0;
    }, $author$project$Util$lt = F2($author$project$Util$lt_fn);
    var $author$project$RRule$ordinalDayMonthlyHelp_fn = function (zone, ordinality, originalMonthDay, counter, current) {
        ordinalDayMonthlyHelp: while (true) {
            var _v0 = function () {
                if (!ordinality) {
                    return _Utils_Tuple2(1, $author$project$Util$lt);
                }
                else {
                    return _Utils_Tuple2(-1, $author$project$Util$gt);
                }
            }();
            var adder = _v0.a;
            var comparator = _v0.b;
            var next = $justinmimbs$time_extra$Time$Extra$add_fn(3, adder, zone, current);
            if (A2(comparator, next, current)) {
                return false;
            }
            else {
                if (!counter) {
                    return _Utils_eq(originalMonthDay, $elm$time$Time$toDay_fn(zone, current));
                }
                else {
                    var $temp$zone = zone, $temp$ordinality = ordinality, $temp$originalMonthDay = originalMonthDay, $temp$counter = counter - 1, $temp$current = next;
                    zone = $temp$zone;
                    ordinality = $temp$ordinality;
                    originalMonthDay = $temp$originalMonthDay;
                    counter = $temp$counter;
                    current = $temp$current;
                    continue ordinalDayMonthlyHelp;
                }
            }
        }
    }, $author$project$RRule$ordinalDayMonthlyHelp = F5($author$project$RRule$ordinalDayMonthlyHelp_fn);
    var $elm$time$Time$toWeekday_fn = function (zone, time) {
        var _v0 = _Basics_modBy_fn(7, $elm$time$Time$flooredDiv_fn($elm$time$Time$toAdjustedMinutes_fn(zone, time), 60 * 24));
        switch (_v0) {
            case 0:
                return 3;
            case 1:
                return 4;
            case 2:
                return 5;
            case 3:
                return 6;
            case 4:
                return 0;
            case 5:
                return 1;
            default:
                return 2;
        }
    }, $elm$time$Time$toWeekday = F2($elm$time$Time$toWeekday_fn);
    var $author$project$RRule$onOrdinalDayMonthly_fn = function (zone, time, _v0) {
        var ordinal = _v0.a;
        var weekday_ = _v0.b;
        return (!_Utils_eq($elm$time$Time$toWeekday_fn(zone, time), weekday_)) ? false : (((ordinal > 5) || ((_Utils_cmp(ordinal, -5) < 0) || (!ordinal))) ? false : ((ordinal > 0) ? $author$project$RRule$ordinalDayMonthlyHelp_fn(zone, 0, $elm$time$Time$toDay_fn(zone, time), $elm$core$Basics$abs(ordinal) - 1, $justinmimbs$time_extra$Time$Extra$ceiling_fn($author$project$Util$weekdayToInterval(weekday_), zone, $justinmimbs$time_extra$Time$Extra$floor_fn(2, zone, time))) : $author$project$RRule$ordinalDayMonthlyHelp_fn(zone, 1, $elm$time$Time$toDay_fn(zone, time), $elm$core$Basics$abs(ordinal) - 1, $justinmimbs$time_extra$Time$Extra$floor_fn($author$project$Util$weekdayToInterval(weekday_), zone, $justinmimbs$time_extra$Time$Extra$add_fn(11, -1, zone, $justinmimbs$time_extra$Time$Extra$ceiling_fn(2, zone, time))))));
    }, $author$project$RRule$onOrdinalDayMonthly = F3($author$project$RRule$onOrdinalDayMonthly_fn);
    var $author$project$RRule$onOrdinalDayYearly_fn = function (zone, time, _v0) {
        var ordinal = _v0.a;
        var weekday_ = _v0.b;
        var jan1 = $justinmimbs$time_extra$Time$Extra$floor_fn(0, zone, time);
        var thOrdinalDay = $justinmimbs$time_extra$Time$Extra$add_fn(3, ordinal - 1, zone, $author$project$Util$mergeTimeOf_fn(zone, time, function (t) {
            return _Utils_eq(jan1, t) ? t : $justinmimbs$time_extra$Time$Extra$add_fn(3, 1, zone, t);
        }($justinmimbs$time_extra$Time$Extra$floor_fn($author$project$Util$weekdayToInterval(weekday_), zone, jan1))));
        return (ordinal > 0) ? _Utils_eq(thOrdinalDay, time) : false;
    }, $author$project$RRule$onOrdinalDayYearly = F3($author$project$RRule$onOrdinalDayYearly_fn);
    var $author$project$RRule$dayHelp_fn = function (rrule, time, byday) {
        if (byday.$ === 1) {
            var weekday_ = byday.a;
            return _Utils_eq($elm$time$Time$toWeekday_fn(rrule.f, time), weekday_);
        }
        else {
            var ordinality = byday.a;
            var _v1 = rrule.aa;
            switch (_v1) {
                case 2:
                    return $author$project$RRule$onOrdinalDayMonthly_fn(rrule.f, time, ordinality);
                case 3:
                    return $author$project$RRule$onOrdinalDayYearly_fn(rrule.f, time, ordinality);
                default:
                    return false;
            }
        }
    }, $author$project$RRule$dayHelp = F3($author$project$RRule$dayHelp_fn);
    var $author$project$RRule$trueIfEmpty_fn = function (list_, bool) {
        return $elm$core$List$isEmpty(list_) ? true : bool;
    }, $author$project$RRule$trueIfEmpty = F2($author$project$RRule$trueIfEmpty_fn);
    var $author$project$RRule$day_fn = function (rrule, time) {
        return $author$project$RRule$trueIfEmpty_fn(rrule.J, $elm$core$List$any_fn(A2($author$project$RRule$dayHelp, rrule, time), rrule.J));
    }, $author$project$RRule$day = F2($author$project$RRule$day_fn);
    var $author$project$RRule$month_fn = function (rrule, time) {
        return $author$project$RRule$trueIfEmpty_fn(rrule.aA, $elm$core$List$member_fn($justinmimbs$date$Date$monthToNumber($elm$time$Time$toMonth_fn(rrule.f, time)), rrule.aA));
    }, $author$project$RRule$month = F2($author$project$RRule$month_fn);
    var $author$project$Util$isLeapYear = function (y) {
        return ((!_Basics_modBy_fn(4, y)) && (!(!_Basics_modBy_fn(100, y)))) || (!_Basics_modBy_fn(400, y));
    };
    var $author$project$Util$daysInMonth_fn = function (year, month_) {
        switch (month_) {
            case 0:
                return 31;
            case 1:
                return $author$project$Util$isLeapYear(year) ? 29 : 28;
            case 2:
                return 31;
            case 3:
                return 30;
            case 4:
                return 31;
            case 5:
                return 30;
            case 6:
                return 31;
            case 7:
                return 31;
            case 8:
                return 30;
            case 9:
                return 31;
            case 10:
                return 30;
            default:
                return 31;
        }
    }, $author$project$Util$daysInMonth = F2($author$project$Util$daysInMonth_fn);
    var $author$project$RRule$monthDay_fn = function (rrule, time) {
        var thMonthDay = $elm$time$Time$toDay_fn(rrule.f, time);
        var thToLastMonthDay = (thMonthDay - 1) - $author$project$Util$daysInMonth_fn($elm$time$Time$toYear_fn(rrule.f, time), $elm$time$Time$toMonth_fn(rrule.f, time));
        var match = function (monthDayNum) {
            return _Utils_eq(thMonthDay, monthDayNum) || _Utils_eq(thToLastMonthDay, monthDayNum);
        };
        return $author$project$RRule$trueIfEmpty_fn(rrule.K, $elm$core$List$any_fn(match, rrule.K));
    }, $author$project$RRule$monthDay = F2($author$project$RRule$monthDay_fn);
    var $author$project$Util$notEmpty_a0 = $elm$core$List$isEmpty, $author$project$Util$notEmpty_a1 = $elm$core$Basics$not, $author$project$Util$notEmpty = A2($elm$core$Basics$composeR, $author$project$Util$notEmpty_a0, $author$project$Util$notEmpty_a1);
    var $author$project$Util$floorDiv_fn = function (a, b) {
        return $elm$core$Basics$floor(a / b);
    }, $author$project$Util$floorDiv = F2($author$project$Util$floorDiv_fn);
    var $author$project$Util$daysBeforeYear = function (y1) {
        var y = y1 - 1;
        var leapYears = ($author$project$Util$floorDiv_fn(y, 4) - $author$project$Util$floorDiv_fn(y, 100)) + $author$project$Util$floorDiv_fn(y, 400);
        return (365 * y) + leapYears;
    };
    var $justinmimbs$date$Date$fromRataDie = function (rd) {
        return rd;
    };
    var $author$project$Util$firstOfYear = function (y) {
        return $justinmimbs$date$Date$fromRataDie($author$project$Util$daysBeforeYear(y) + 1);
    };
    var $author$project$Util$weekdayNumber_fn = function (weekStart, date) {
        var adjust = function (rd) {
            switch (weekStart) {
                case 0:
                    return rd;
                case 6:
                    return rd + 1;
                default:
                    return rd + 2;
            }
        };
        var _v0 = _Basics_modBy_fn(7, adjust($justinmimbs$date$Date$toRataDie(date)));
        if (!_v0) {
            return 7;
        }
        else {
            var n = _v0;
            return n;
        }
    }, $author$project$Util$weekdayNumber = F2($author$project$Util$weekdayNumber_fn);
    var $author$project$Util$is53WeekYear_fn = function (weekStart, year) {
        var wdnJan1 = $author$project$Util$weekdayNumber_fn(weekStart, $author$project$Util$firstOfYear(year));
        return (wdnJan1 === 4) || ((wdnJan1 === 3) && $author$project$Util$isLeapYear(year));
    }, $author$project$Util$is53WeekYear = F2($author$project$Util$is53WeekYear_fn);
    var $author$project$Util$daysBeforeWeekYear_fn = function (weekStart, y) {
        var jan4 = $author$project$Util$daysBeforeYear(y) + 4;
        return jan4 - $author$project$Util$weekdayNumber_fn(weekStart, $justinmimbs$date$Date$fromRataDie(jan4));
    }, $author$project$Util$daysBeforeWeekYear = F2($author$project$Util$daysBeforeWeekYear_fn);
    var $author$project$Util$weekNumber_fn = function (weekStart, date) {
        var wdn = $author$project$Util$weekdayNumber_fn(weekStart, date);
        var rd = $justinmimbs$date$Date$toRataDie(date);
        var wy = $justinmimbs$date$Date$year($justinmimbs$date$Date$fromRataDie(rd + (4 - wdn)));
        var week1Day1 = $author$project$Util$daysBeforeWeekYear_fn(weekStart, wy) + 1;
        return 1 + (((rd - week1Day1) / 7) | 0);
    }, $author$project$Util$weekNumber = F2($author$project$Util$weekNumber_fn);
    var $author$project$RRule$weekNoHelp_fn = function (zone, weekStart_, time, weekNoNum) {
        var date = $justinmimbs$date$Date$fromPosix_fn(zone, time);
        var thWeekNo = $author$project$Util$weekNumber_fn(weekStart_, date);
        var thToLastWeekNo = $author$project$Util$is53WeekYear_fn(weekStart_, $elm$time$Time$toYear_fn(zone, time)) ? ((thWeekNo - 1) - 53) : ((thWeekNo - 1) - 52);
        return _Utils_eq(thWeekNo, weekNoNum) || _Utils_eq(thToLastWeekNo, weekNoNum);
    }, $author$project$RRule$weekNoHelp = F4($author$project$RRule$weekNoHelp_fn);
    var $author$project$RRule$weekNo_fn = function (rrule, time) {
        return $author$project$RRule$trueIfEmpty_fn(rrule.bY, $elm$core$List$any_fn(A3($author$project$RRule$weekNoHelp, rrule.f, rrule.gq, time), rrule.bY));
    }, $author$project$RRule$weekNo = F2($author$project$RRule$weekNo_fn);
    var $author$project$Util$daysBeforeMonth_fn = function (y, m) {
        var leapDays = $author$project$Util$isLeapYear(y) ? 1 : 0;
        switch (m) {
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + leapDays;
            case 3:
                return 90 + leapDays;
            case 4:
                return 120 + leapDays;
            case 5:
                return 151 + leapDays;
            case 6:
                return 181 + leapDays;
            case 7:
                return 212 + leapDays;
            case 8:
                return 243 + leapDays;
            case 9:
                return 273 + leapDays;
            case 10:
                return 304 + leapDays;
            default:
                return 334 + leapDays;
        }
    }, $author$project$Util$daysBeforeMonth = F2($author$project$Util$daysBeforeMonth_fn);
    var $author$project$Util$daysInYear = function (year) {
        return $author$project$Util$isLeapYear(year) ? 366 : 365;
    };
    var $author$project$RRule$yearDay_fn = function (rrule, time) {
        var year = $elm$time$Time$toYear_fn(rrule.f, time);
        var thYearDay = $elm$time$Time$toDay_fn(rrule.f, time) + $author$project$Util$daysBeforeMonth_fn(year, $elm$time$Time$toMonth_fn(rrule.f, time));
        var thToLastYearDay = (thYearDay - 1) - $author$project$Util$daysInYear(year);
        var match = function (yearDayNum) {
            return _Utils_eq(thYearDay, yearDayNum) || _Utils_eq(thToLastYearDay, yearDayNum);
        };
        return $author$project$RRule$trueIfEmpty_fn(rrule.bZ, $elm$core$List$any_fn(match, rrule.bZ));
    }, $author$project$RRule$yearDay = F2($author$project$RRule$yearDay_fn);
    var $author$project$RRule$computeCheck = function (rrule) {
        var _v0 = rrule.aa;
        switch (_v0) {
            case 0:
                return {
                    E: _List_Nil,
                    F: _List_fromArray([$author$project$RRule$day, $author$project$RRule$monthDay, $author$project$RRule$month])
                };
            case 1:
                return {
                    E: _List_fromArray([$author$project$RRule$day]),
                    F: _List_fromArray([$author$project$RRule$month])
                };
            case 2:
                var _v1 = _Utils_Tuple2($elm$core$Basics$composeR_fn($author$project$Util$notEmpty_a0, $author$project$Util$notEmpty_a1, rrule.K), $elm$core$Basics$composeR_fn($author$project$Util$notEmpty_a0, $author$project$Util$notEmpty_a1, rrule.J));
                if (_v1.a) {
                    if (!_v1.b) {
                        return {
                            E: _List_fromArray([$author$project$RRule$monthDay]),
                            F: _List_fromArray([$author$project$RRule$month])
                        };
                    }
                    else {
                        return {
                            E: _List_fromArray([$author$project$RRule$monthDay]),
                            F: _List_fromArray([$author$project$RRule$day, $author$project$RRule$month])
                        };
                    }
                }
                else {
                    if (_v1.b) {
                        return {
                            E: _List_fromArray([$author$project$RRule$day]),
                            F: _List_fromArray([$author$project$RRule$month])
                        };
                    }
                    else {
                        return {
                            E: _List_Nil,
                            F: _List_fromArray([$author$project$RRule$month])
                        };
                    }
                }
            default:
                var _v2 = _Utils_Tuple2($elm$core$Basics$composeR_fn($author$project$Util$notEmpty_a0, $author$project$Util$notEmpty_a1, rrule.J), $elm$core$Basics$composeR_fn($author$project$Util$notEmpty_a0, $author$project$Util$notEmpty_a1, rrule.bZ) || $elm$core$Basics$composeR_fn($author$project$Util$notEmpty_a0, $author$project$Util$notEmpty_a1, rrule.K));
                if (!_v2.a) {
                    return {
                        E: _List_fromArray([$author$project$RRule$month, $author$project$RRule$weekNo, $author$project$RRule$yearDay, $author$project$RRule$monthDay]),
                        F: _List_Nil
                    };
                }
                else {
                    if (_v2.b) {
                        return {
                            E: _List_fromArray([$author$project$RRule$month, $author$project$RRule$weekNo, $author$project$RRule$yearDay, $author$project$RRule$monthDay]),
                            F: _List_fromArray([$author$project$RRule$day])
                        };
                    }
                    else {
                        var _v3 = _Utils_Tuple2($elm$core$Basics$composeR_fn($author$project$Util$notEmpty_a0, $author$project$Util$notEmpty_a1, rrule.bY), $elm$core$Basics$composeR_fn($author$project$Util$notEmpty_a0, $author$project$Util$notEmpty_a1, rrule.aA));
                        if (_v3.a) {
                            return {
                                E: _List_fromArray([
                                    $author$project$RRule$month,
                                    $author$project$RRule$and_fn($author$project$RRule$day, $author$project$RRule$weekNo)
                                ]),
                                F: _List_Nil
                            };
                        }
                        else {
                            if (_v3.b) {
                                return {
                                    E: _List_fromArray([
                                        $author$project$RRule$and_fn($author$project$RRule$day, $author$project$RRule$month)
                                    ]),
                                    F: _List_Nil
                                };
                            }
                            else {
                                return {
                                    E: _List_fromArray([$author$project$RRule$day]),
                                    F: _List_Nil
                                };
                            }
                        }
                    }
                }
        }
    };
    var $author$project$RRule$firstValidInstance_fn = function (rrule, check) {
        var helper = function (t) {
            helper: while (true) {
                if ($author$project$RRule$withinByRules_fn(rrule, check, t)) {
                    return t;
                }
                else {
                    var $temp$t = $justinmimbs$time_extra$Time$Extra$add_fn(11, 1, rrule.f, t);
                    t = $temp$t;
                    continue helper;
                }
            }
        };
        return (rrule.cY !== 1) ? rrule.b4 : helper(rrule.b4);
    }, $author$project$RRule$firstValidInstance = F2($author$project$RRule$firstValidInstance_fn);
    var $author$project$RRule$hasCount = function (rrule) {
        var _v0 = rrule.pO;
        if ((!_v0.$) && (!_v0.a.$)) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$RRule$normalizeRRule = function (rrule) {
        var _v0 = rrule.aa;
        switch (_v0) {
            case 1:
                var _v1 = rrule.J;
                if (!_v1.b) {
                    return $$update__J(rrule, _List_fromArray([
                        $toastal$either$Either$Right($elm$time$Time$toWeekday_fn(rrule.f, rrule.b4))
                    ]));
                }
                else {
                    return rrule;
                }
            case 2:
                var _v2 = _Utils_Tuple2(rrule.J, rrule.K);
                if ((!_v2.a.b) && (!_v2.b.b)) {
                    return $$update__K(rrule, _List_fromArray([
                        $elm$time$Time$toDay_fn(rrule.f, rrule.b4)
                    ]));
                }
                else {
                    return rrule;
                }
            case 3:
                var _v3 = _Utils_Tuple2(_Utils_Tuple2(rrule.J, rrule.K), _Utils_Tuple3(rrule.bZ, rrule.bY, rrule.aA));
                _v3$4: while (true) {
                    if (_v3.a.a.b) {
                        if ((((!_v3.a.b.b) && (!_v3.b.a.b)) && (!_v3.b.b.b)) && (!_v3.b.c.b)) {
                            var _v9 = _v3.a;
                            var _v10 = _v9.a;
                            var _v11 = _v3.b;
                            return function () {
                                var $r = rrule.$c();
                                $r.aA = _List_fromArray([
                                    $justinmimbs$date$Date$monthToNumber($elm$time$Time$toMonth_fn(rrule.f, rrule.b4))
                                ]);
                                return $r;
                            }();
                        }
                        else {
                            break _v3$4;
                        }
                    }
                    else {
                        if ((!_v3.a.b.b) && (!_v3.b.a.b)) {
                            if (!_v3.b.b.b) {
                                if (!_v3.b.c.b) {
                                    var _v4 = _v3.a;
                                    var _v5 = _v3.b;
                                    return function () {
                                        var $r = rrule.$c();
                                        $r.K = _List_fromArray([
                                            $elm$time$Time$toDay_fn(rrule.f, rrule.b4)
                                        ]);
                                        $r.aA = _List_fromArray([
                                            $justinmimbs$date$Date$monthToNumber($elm$time$Time$toMonth_fn(rrule.f, rrule.b4))
                                        ]);
                                        return $r;
                                    }();
                                }
                                else {
                                    var _v6 = _v3.a;
                                    var _v7 = _v3.b;
                                    var _v8 = _v7.c;
                                    return $$update__K(rrule, _List_fromArray([
                                        $elm$time$Time$toDay_fn(rrule.f, rrule.b4)
                                    ]));
                                }
                            }
                            else {
                                if (!_v3.b.c.b) {
                                    var _v12 = _v3.a;
                                    var _v13 = _v3.b;
                                    var _v14 = _v13.b;
                                    return $$update__J(rrule, _List_fromArray([
                                        $toastal$either$Either$Right($elm$time$Time$toWeekday_fn(rrule.f, rrule.b4))
                                    ]));
                                }
                                else {
                                    break _v3$4;
                                }
                            }
                        }
                        else {
                            break _v3$4;
                        }
                    }
                }
                return rrule;
            default:
                return rrule;
        }
    };
    var $author$project$RRule$bumpToNextWindow_fn = function (rrule, time) {
        var next = $justinmimbs$time_extra$Time$Extra$floor_fn($author$project$RRule$freqToInterval(rrule.aa), rrule.f, $justinmimbs$time_extra$Time$Extra$add_fn($author$project$RRule$freqToInterval(rrule.aa), rrule.cY, rrule.f, time));
        return $author$project$Util$mergeTimeOf_fn(rrule.f, time, next);
    }, $author$project$RRule$bumpToNextWindow = F2($author$project$RRule$bumpToNextWindow_fn);
    var $elm$core$List$sort = function (xs) {
        return _List_sortBy_fn($elm$core$Basics$identity, xs);
    };
    var $author$project$Util$dedupeAndSortTimes = function (times) {
        return $elm$core$List$map_fn($elm$time$Time$millisToPosix, $elm$core$List$sort($elm$core$Set$toList($elm$core$List$foldl_fn_unwrapped(function (time, set) {
            return $elm$core$Set$insert_fn($elm$time$Time$posixToMillis(time), set);
        }, $elm$core$Set$empty, times))));
    };
    var $author$project$RRule$pastUntilCount__fn = function (mUntilCount, current, times) {
        if (!mUntilCount.$) {
            if (!mUntilCount.a.$) {
                var count_ = mUntilCount.a.a;
                return (_Utils_cmp($elm$core$List$length(times), count_) > -1) || ($elm$core$List$length(times) >= 5000);
            }
            else {
                var until_ = mUntilCount.a.a;
                return _Utils_cmp($elm$time$Time$posixToMillis(current), $elm$time$Time$posixToMillis(until_)) > 0;
            }
        }
        else {
            return false;
        }
    }, $author$project$RRule$pastUntilCount_ = F3($author$project$RRule$pastUntilCount__fn);
    var $author$project$RRule$pastUntilCount_fn = function (timeCeiling, mUntilCount, current, times) {
        return $author$project$RRule$pastUntilCount__fn(mUntilCount, current, times) || $author$project$Util$gte_fn(current, timeCeiling);
    }, $author$project$RRule$pastUntilCount = F4($author$project$RRule$pastUntilCount_fn);
    var $author$project$RRule$run_fn = function (optimizedMode, check, timeCeiling, rrule, window, current, acc) {
        run: while (true) {
            var withoutExDates = $elm$core$List$filter(function (time) {
                return !$elm$core$Set$member_fn($elm$time$Time$posixToMillis(time), $elm$core$Set$fromList($elm$core$List$map_fn($elm$time$Time$posixToMillis, rrule.hj)));
            });
            var nextByDay = $justinmimbs$time_extra$Time$Extra$add_fn(11, 1, rrule.f, current);
            var nextTime = optimizedMode ? $justinmimbs$time_extra$Time$Extra$add_fn($author$project$RRule$freqToInterval(rrule.aa), rrule.cY, rrule.f, current) : ($author$project$RRule$inWindow_fn(nextByDay, window) ? nextByDay : $author$project$RRule$bumpToNextWindow_fn(rrule, current));
            var nextWindow = $author$project$RRule$inWindow_fn(nextTime, window) ? window : $author$project$RRule$computeNextWindow_fn(rrule, window);
            if ($author$project$RRule$pastUntilCount_fn(timeCeiling, rrule.pO, current, acc)) {
                return withoutExDates($author$project$Util$dedupeAndSortTimes(_Utils_ap(acc, rrule.iT)));
            }
            else {
                if ($author$project$RRule$withinByRules_fn(rrule, check, current)) {
                    var $temp$optimizedMode = optimizedMode, $temp$check = check, $temp$timeCeiling = timeCeiling, $temp$rrule = rrule, $temp$window = nextWindow, $temp$current = nextTime, $temp$acc = _List_Cons(current, acc);
                    optimizedMode = $temp$optimizedMode;
                    check = $temp$check;
                    timeCeiling = $temp$timeCeiling;
                    rrule = $temp$rrule;
                    window = $temp$window;
                    current = $temp$current;
                    acc = $temp$acc;
                    continue run;
                }
                else {
                    var $temp$optimizedMode = optimizedMode, $temp$check = check, $temp$timeCeiling = timeCeiling, $temp$rrule = rrule, $temp$window = nextWindow, $temp$current = nextTime, $temp$acc = acc;
                    optimizedMode = $temp$optimizedMode;
                    check = $temp$check;
                    timeCeiling = $temp$timeCeiling;
                    rrule = $temp$rrule;
                    window = $temp$window;
                    current = $temp$current;
                    acc = $temp$acc;
                    continue run;
                }
            }
        }
    }, $author$project$RRule$run = F7($author$project$RRule$run_fn);
    var $author$project$Util$year2250 = $elm$time$Time$millisToPosix(8845394400000);
    var $author$project$RRule$between_fn = function (betweenWindow, preNormalizedRRule) {
        var start = betweenWindow.bF;
        var end = betweenWindow.b6;
        var rrule = $author$project$RRule$normalizeRRule(preNormalizedRRule);
        var check = $author$project$RRule$computeCheck(rrule);
        var firstInstance = $author$project$RRule$firstValidInstance_fn(rrule, check);
        var ceiling = $author$project$Util$lt_fn(end, $author$project$Util$year2250) ? end : $author$project$Util$year2250;
        var runHelp = function (_v0) {
            var firstInstanceTime = _v0.dX;
            var startingWindow = _v0.eJ;
            return $author$project$RRule$run_fn($author$project$RRule$canOptimizeRun(rrule), check, ceiling, rrule, startingWindow, firstInstanceTime, _List_Nil);
        };
        return $author$project$RRule$hasCount(rrule) ? $elm$core$List$filter_fn(function (time) {
            return $author$project$Util$gte_fn(time, start);
        }, runHelp({
            dX: firstInstance,
            eJ: $author$project$RRule$initWindow_fn(firstInstance, rrule)
        })) : $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(runHelp, $author$project$RRule$betweenHelper_fn(rrule, check, firstInstance, betweenWindow)));
    }, $author$project$RRule$between = F2($author$project$RRule$between_fn);
    var $elm$core$String$replace_fn = function (before, after, string) {
        return $elm$core$String$join_fn(after, $elm$core$String$split_fn(before, string));
    }, $elm$core$String$replace = F3($elm$core$String$replace_fn);
    var $author$project$ElmRRULETest$stripTimeSymbols_a0 = A2($elm$core$String$replace, ":", ""), $author$project$ElmRRULETest$stripTimeSymbols_a1 = A2($elm$core$String$replace, "-", ""), $author$project$ElmRRULETest$stripTimeSymbols = A2($elm$core$Basics$composeR, $author$project$ElmRRULETest$stripTimeSymbols_a0, $author$project$ElmRRULETest$stripTimeSymbols_a1);
    var $author$project$ElmRRULETest$toDTSTARTRule = function (time) {
        if (!time.$) {
            var data = time.a;
            return function (t) {
                return "DTSTART;TZID=" + (data.gw.l5 + (":" + t));
            }($elm$core$Basics$composeR_fn($author$project$ElmRRULETest$stripTimeSymbols_a0, $author$project$ElmRRULETest$stripTimeSymbols_a1, $jweir$elm_iso8601$ISO8601$toString($jweir$elm_iso8601$ISO8601$fromPosix(data.gh))));
        }
        else {
            var date = time.a;
            return function (d) {
                return "DTSTART:" + d;
            }($elm$core$Basics$composeR_fn($author$project$ElmRRULETest$stripTimeSymbols_a0, $author$project$ElmRRULETest$stripTimeSymbols_a1, $justinmimbs$date$Date$toIsoString(date)));
        }
    };
    var $author$project$Util$Time$hour = $author$project$Util$Time$minute * 60;
    var $author$project$Util$Time$day = $author$project$Util$Time$hour * 24;
    var $author$project$Util$Time$subtract_fn = function (unit, time) {
        return $elm$time$Time$millisToPosix($elm$time$Time$posixToMillis(time) - unit);
    }, $author$project$Util$Time$subtract = F2($author$project$Util$Time$subtract_fn);
    var $author$project$ElmRRULETest$window = function () {
        var aug15th2020 = $elm$time$Time$millisToPosix(1597542858009);
        return {
            b6: $author$project$Util$Time$add_fn($author$project$Util$Time$day * 540, aug15th2020),
            bF: $author$project$Util$Time$subtract_fn($author$project$Util$Time$day * 540, aug15th2020)
        };
    }();
    var $author$project$ElmRRULETest$reducer_fn = function (eventId, event, acc) {
        var _v0 = event.pv;
        if (_v0.$ === 1) {
            var rawRRule = _v0.a.iR;
            var dtStart = _v0.a.b4;
            var rrule = _v0.a.fZ;
            return $elm$core$Dict$insert_fn(eventId, {
                fC: $author$project$RRule$between_fn($author$project$ElmRRULETest$window, rrule),
                fZ: $elm$core$String$join_fn("\n", _List_Cons($author$project$ElmRRULETest$toDTSTARTRule(dtStart), rawRRule))
            }, acc);
        }
        else {
            return acc;
        }
    }, $author$project$ElmRRULETest$reducer = F3($author$project$ElmRRULETest$reducer_fn);
    var $author$project$ElmRRULETest$comparator_fn = function (_v0, rrulejsResult) {
        var events = _v0.lw;
        var sorter = A2($elm$core$Basics$composeR, $elm$core$List$map($elm$time$Time$posixToMillis), $elm$core$List$sort);
        var instances = $elm$core$Dict$foldl_fn($author$project$ElmRRULETest$reducer, $elm$core$Dict$empty, events);
        var failureFinder = F3(function (eventId, _v1, eventErrors) {
            var rrule = _v1.fZ;
            var instanceTimes = _v1.fC;
            var rruleJSInstanceTimes = sorter($elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Dict$get_fn(eventId, rrulejsResult)));
            var instanceTimes_ = sorter(instanceTimes);
            return (_Utils_eq(instanceTimes_, rruleJSInstanceTimes) || (_Utils_eq(instanceTimes_, $author$project$ElmRRULETest$dropLast(rruleJSInstanceTimes)) || $elm$core$Set$member_fn(eventId, $author$project$ElmRRULETest$ignoredEventIds))) ? eventErrors : _List_Cons(eventId + (" - " + rrule), eventErrors);
        });
        var failedEvents = $elm$core$Dict$foldl_fn(failureFinder, _List_Nil, instances);
        return _Utils_Tuple2($author$project$Util$Misc$toJustIf_fn(!$elm$core$List$isEmpty(failedEvents), $author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$RRuleTest(failedEvents))), instances);
    }, $author$project$ElmRRULETest$comparator = F2($author$project$ElmRRULETest$comparator_fn);
    var $elm_community$maybe_extra$Maybe$Extra$cons_fn = function (item, list) {
        if (!item.$) {
            var v = item.a;
            return _List_Cons(v, list);
        }
        else {
            return list;
        }
    }, $elm_community$maybe_extra$Maybe$Extra$cons = F2($elm_community$maybe_extra$Maybe$Extra$cons_fn);
    var $author$project$Data$Email$Email = $elm$core$Basics$identity;
    var $author$project$Data$Email$regex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$"));
    var $author$project$Data$Email$create = function (str) {
        var trimmed = $elm$core$String$trim(str);
        return _Regex_contains_fn($author$project$Data$Email$regex, trimmed) ? $elm$core$Maybe$Just(trimmed) : $elm$core$Maybe$Nothing;
    };
    var $author$project$Util$Cmd$delayBy_fn = function (millis, msg) {
        return $elm$core$Task$perform_fn(function (_v0) {
            return msg;
        }, $elm$core$Process$sleep(millis));
    }, $author$project$Util$Cmd$delayBy = F2($author$project$Util$Cmd$delayBy_fn);
    var $elm$core$List$drop_fn = function (n, list) {
        drop: while (true) {
            if (n <= 0) {
                return list;
            }
            else {
                if (!list.b) {
                    return list;
                }
                else {
                    var x = list.a;
                    var xs = list.b;
                    var $temp$n = n - 1, $temp$list = xs;
                    n = $temp$n;
                    list = $temp$list;
                    continue drop;
                }
            }
        }
    }, $elm$core$List$drop = F2($elm$core$List$drop_fn);
    var $author$project$Data$Dialog$Closeable$feedbackKindToString = function (kind) {
        switch (kind) {
            case 0:
                return "Issue";
            case 1:
                return "Suggestion";
            default:
                return "Question";
        }
    };
    var $author$project$Model$BillingAccountInfoReceived = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Error$CloudFunction = function (a) {
        return { $: 3, a: a };
    };
    var $elm$http$Http$Header_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$http$Http$Header = F2($elm$http$Http$Header_fn);
    var $elm$http$Http$header = $elm$http$Http$Header;
    var $author$project$Util$Request$authedHeader_a0 = "x-witful-google-auth-id-token", $author$project$Util$Request$authedHeader = $elm$http$Http$header($author$project$Util$Request$authedHeader_a0);
    var $elm$http$Http$BadStatus__fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $elm$http$Http$BadStatus_ = F2($elm$http$Http$BadStatus__fn);
    var $elm$http$Http$BadUrl_ = function (a) {
        return { $: 0, a: a };
    };
    var $elm$http$Http$GoodStatus__fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $elm$http$Http$GoodStatus_ = F2($elm$http$Http$GoodStatus__fn);
    var $elm$http$Http$NetworkError_ = { $: 2 };
    var $elm$http$Http$Receiving = function (a) {
        return { $: 1, a: a };
    };
    var $elm$http$Http$Sending = function (a) {
        return { $: 0, a: a };
    };
    var $elm$http$Http$Timeout_ = { $: 1 };
    var $elm$core$Maybe$isJust = function (maybe) {
        if (!maybe.$) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$http$Http$emptyBody = _Http_emptyBody;
    var $elm$http$Http$Request = function (a) {
        return { $: 1, a: a };
    };
    var $elm$http$Http$State_fn = function (reqs, subs) {
        return { iW: reqs, jj: subs };
    }, $elm$http$Http$State = F2($elm$http$Http$State_fn);
    var $elm$http$Http$init = $elm$core$Task$succeed($elm$http$Http$State_fn($elm$core$Dict$empty, _List_Nil));
    var $elm$http$Http$updateReqs_fn = function (router, cmds, reqs) {
        updateReqs: while (true) {
            if (!cmds.b) {
                return $elm$core$Task$succeed(reqs);
            }
            else {
                var cmd = cmds.a;
                var otherCmds = cmds.b;
                if (!cmd.$) {
                    var tracker = cmd.a;
                    var _v2 = $elm$core$Dict$get_fn(tracker, reqs);
                    if (_v2.$ === 1) {
                        var $temp$router = router, $temp$cmds = otherCmds, $temp$reqs = reqs;
                        router = $temp$router;
                        cmds = $temp$cmds;
                        reqs = $temp$reqs;
                        continue updateReqs;
                    }
                    else {
                        var pid = _v2.a;
                        return _Scheduler_andThen_fn(function (_v3) {
                            return $elm$http$Http$updateReqs_fn(router, otherCmds, $elm$core$Dict$remove_fn(tracker, reqs));
                        }, $elm$core$Process$kill(pid));
                    }
                }
                else {
                    var req = cmd.a;
                    return _Scheduler_andThen_fn(function (pid) {
                        var _v4 = req.pI;
                        if (_v4.$ === 1) {
                            return $elm$http$Http$updateReqs_fn(router, otherCmds, reqs);
                        }
                        else {
                            var tracker = _v4.a;
                            return $elm$http$Http$updateReqs_fn(router, otherCmds, $elm$core$Dict$insert_fn(tracker, pid, reqs));
                        }
                    }, $elm$core$Process$spawn(_Http_toTask_fn(router, $elm$core$Platform$sendToApp(router), req)));
                }
            }
        }
    }, $elm$http$Http$updateReqs = F3($elm$http$Http$updateReqs_fn);
    var $elm$http$Http$onEffects_fn = function (router, cmds, subs, state) {
        return _Scheduler_andThen_fn(function (reqs) {
            return $elm$core$Task$succeed($elm$http$Http$State_fn(reqs, subs));
        }, $elm$http$Http$updateReqs_fn(router, cmds, state.iW));
    }, $elm$http$Http$onEffects = F4($elm$http$Http$onEffects_fn);
    var $elm$http$Http$maybeSend_fn = function (router, desiredTracker, progress, _v0) {
        var actualTracker = _v0.a;
        var toMsg = _v0.b;
        return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(_Platform_sendToApp_fn(router, toMsg(progress))) : $elm$core$Maybe$Nothing;
    }, $elm$http$Http$maybeSend = F4($elm$http$Http$maybeSend_fn);
    var $elm$http$Http$onSelfMsg_fn = function (router, _v0, state) {
        var tracker = _v0.a;
        var progress = _v0.b;
        return _Scheduler_andThen_fn(function (_v1) {
            return $elm$core$Task$succeed(state);
        }, $elm$core$Task$sequence($elm$core$List$filterMap_fn(A3($elm$http$Http$maybeSend, router, tracker, progress), state.jj)));
    }, $elm$http$Http$onSelfMsg = F3($elm$http$Http$onSelfMsg_fn);
    var $elm$http$Http$Cancel = function (a) {
        return { $: 0, a: a };
    };
    var $elm$http$Http$cmdMap_fn = function (func, cmd) {
        if (!cmd.$) {
            var tracker = cmd.a;
            return $elm$http$Http$Cancel(tracker);
        }
        else {
            var r = cmd.a;
            return $elm$http$Http$Request((new $$Record79(r.j5, r.dG, _Http_mapExpect_fn(func, r.an), r.hG, r.id, r.ak, r.pI, r.dt)));
        }
    }, $elm$http$Http$cmdMap = F2($elm$http$Http$cmdMap_fn);
    var $elm$http$Http$MySub_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$http$Http$MySub = F2($elm$http$Http$MySub_fn);
    var $elm$http$Http$subMap_fn = function (func, _v0) {
        var tracker = _v0.a;
        var toMsg = _v0.b;
        return $elm$http$Http$MySub_fn(tracker, A2($elm$core$Basics$composeR, toMsg, func));
    }, $elm$http$Http$subMap = F2($elm$http$Http$subMap_fn);
    _Platform_effectManagers["Http"] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
    var $elm$http$Http$command = _Platform_leaf("Http");
    var $elm$http$Http$subscription = _Platform_leaf("Http");
    var $elm$http$Http$request = function (r) {
        return $elm$http$Http$command($elm$http$Http$Request((new $$Record79(false, r.dG, r.an, r.hG, r.id, r.ak, r.pI, r.dt))));
    };
    var $author$project$Util$Request$authedHttpPost = function (_v0) {
        var functionName = _v0.fm;
        var authToken = _v0.kg;
        var extraHeaders = _v0.aF;
        var expect = _v0.an;
        var body = _v0.dG;
        var timeout = _v0.ak;
        return $elm$http$Http$request((new $$Record80($elm$core$Maybe$withDefault_fn($elm$http$Http$emptyBody, body), expect, _List_Cons($elm$http$Http$Header_fn($author$project$Util$Request$authedHeader_a0, authToken), extraHeaders), "POST", timeout, $elm$core$Maybe$Nothing, "/funcs/" + (functionName + "/"))));
    };
    var $author$project$Data$BillingAccount$BillingAccountInfo_fn = function (linkedAccounts, giftStatus, hasCompletedCheckout) {
        return { hA: giftStatus, lV: hasCompletedCheckout, mI: linkedAccounts };
    }, $author$project$Data$BillingAccount$BillingAccountInfo = F3($author$project$Data$BillingAccount$BillingAccountInfo_fn);
    var $author$project$Data$BillingAccount$GiftedBetaUser = { $: 1 };
    var $author$project$Data$BillingAccount$GiftedForever = { $: 2 };
    var $author$project$Data$BillingAccount$GiftedWithExpiration = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$BillingAccount$giftStatusDecoder = _Json_andThen_fn(function (tipe) {
        switch (tipe) {
            case "gift-forever":
                return $elm$json$Json$Decode$succeed($author$project$Data$BillingAccount$GiftedForever);
            case "gift-beta-user":
                return $elm$json$Json$Decode$succeed($author$project$Data$BillingAccount$GiftedBetaUser);
            case "gift-with-expiration":
                return _Json_decodeField_fn("expiration", _Json_map1_fn(function (expiration) {
                    return $author$project$Data$BillingAccount$GiftedWithExpiration({ hn: expiration });
                }, _Json_map1_fn($elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)));
            default:
                return $elm$json$Json$Decode$fail("unrecognized BillingAccount.GiftStatus");
        }
    }, _Json_decodeField_fn("type", $elm$json$Json$Decode$string));
    var $author$project$Data$BillingAccount$LinkedAccountData_fn = function (id, email) {
        return (new $$Record81(email, id));
    }, $author$project$Data$BillingAccount$LinkedAccountData = F2($author$project$Data$BillingAccount$LinkedAccountData_fn);
    var $author$project$Data$BillingAccount$linkedAccountDataDecoder = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("email", $elm$json$Json$Decode$string, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("id", $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Data$BillingAccount$LinkedAccountData)));
    var $author$project$Data$BillingAccount$billingAccountInfoDecoder = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("hasCompletedCheckout", $elm$json$Json$Decode$bool, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("giftStatus", $elm$json$Json$Decode$nullable($author$project$Data$BillingAccount$giftStatusDecoder), $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required_fn("linkedAccounts", $elm$json$Json$Decode$list($author$project$Data$BillingAccount$linkedAccountDataDecoder), $elm$json$Json$Decode$succeed($author$project$Data$BillingAccount$BillingAccountInfo))));
    var $author$project$Util$Request$defaultRequestTimeout = 30000;
    var $elm$http$Http$expectStringResponse_fn = function (toMsg, toResult) {
        return _Http_expect_fn("", $elm$core$Basics$identity, A2($elm$core$Basics$composeR, toResult, toMsg));
    }, $elm$http$Http$expectStringResponse = F2($elm$http$Http$expectStringResponse_fn);
    var $elm$http$Http$BadBody = function (a) {
        return { $: 4, a: a };
    };
    var $elm$http$Http$BadStatus = function (a) {
        return { $: 3, a: a };
    };
    var $elm$http$Http$BadUrl = function (a) {
        return { $: 0, a: a };
    };
    var $elm$http$Http$NetworkError = { $: 2 };
    var $elm$http$Http$Timeout = { $: 1 };
    var $elm$http$Http$resolve_fn = function (toResult, response) {
        switch (response.$) {
            case 0:
                var url = response.a;
                return $elm$core$Result$Err($elm$http$Http$BadUrl(url));
            case 1:
                return $elm$core$Result$Err($elm$http$Http$Timeout);
            case 2:
                return $elm$core$Result$Err($elm$http$Http$NetworkError);
            case 3:
                var metadata = response.a;
                return $elm$core$Result$Err($elm$http$Http$BadStatus(metadata.oQ));
            default:
                var body = response.b;
                return $elm$core$Result$mapError_fn($elm$http$Http$BadBody, toResult(body));
        }
    }, $elm$http$Http$resolve = F2($elm$http$Http$resolve_fn);
    var $elm$http$Http$expectJson_fn = function (toMsg, decoder) {
        return $elm$http$Http$expectStringResponse_fn(toMsg, $elm$http$Http$resolve(function (string) {
            return $elm$core$Result$mapError_fn($elm$json$Json$Decode$errorToString, _Json_runOnString_fn(decoder, string));
        }));
    }, $elm$http$Http$expectJson = F2($elm$http$Http$expectJson_fn);
    var $author$project$Util$Request$fetchBillingAccountInfo = function (_v0) {
        var firebaseUserAuthToken = _v0.b9;
        var functionName = "billing_account_info";
        var customExpecter = $elm$http$Http$expectJson_fn(function (result) {
            return $author$project$Model$BillingAccountInfoReceived(function () {
                if (!result.$) {
                    var linkedAccounts = result.a;
                    return $krisajenkins$remotedata$RemoteData$Success(linkedAccounts);
                }
                else {
                    var err = result.a;
                    return $krisajenkins$remotedata$RemoteData$Failure($author$project$Error$CloudFunction({ fm: functionName, hM: err }));
                }
            }());
        }, $author$project$Data$BillingAccount$billingAccountInfoDecoder);
        return $author$project$Util$Request$authedHttpPost((new $$Record82(firebaseUserAuthToken, $elm$core$Maybe$Nothing, customExpecter, _List_Nil, functionName, $elm$core$Maybe$Just($author$project$Util$Request$defaultRequestTimeout))));
    };
    var $author$project$Util$NextMeeting$formatReturnType = function (event) {
        var _v0 = event.pv;
        switch (_v0.$) {
            case 2:
                var masterId = _v0.a.mT;
                return $elm$core$Maybe$Just({
                    hf: event,
                    b7: event.l8,
                    mT: $elm$core$Maybe$Just(masterId)
                });
            case 0:
                return $elm$core$Maybe$Just({ hf: event, b7: event.l8, mT: $elm$core$Maybe$Nothing });
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Util$Time$isBefore_fn = function (t1, t2) {
        return _Utils_cmp($elm$time$Time$posixToMillis(t2), $elm$time$Time$posixToMillis(t1)) < 0;
    }, $author$project$Util$Time$isBefore = F2($author$project$Util$Time$isBefore_fn);
    var $author$project$Data$Event$isMaster = function (event) {
        var _v0 = event.pv;
        if (_v0.$ === 1) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Util$NextMeeting$findCustom_fn = function (env, eventFilter) {
        var baseEventFilter = function (event) {
            return (!event.lh) && ((!$author$project$Data$Event$isMaster(event)) && $author$project$Util$Time$isOnOrAfter_fn(env.k5, $author$project$Data$Time$toPosix_fn(env.pu, event.oN)));
        };
        var reducer = F3(function (_v1, event, mResultEvent) {
            if (!(baseEventFilter(event) && eventFilter(event))) {
                return mResultEvent;
            }
            else {
                if (mResultEvent.$ === 1) {
                    return $elm$core$Maybe$Just(event);
                }
                else {
                    var resultEvent = mResultEvent.a;
                    return $author$project$Util$Time$isBefore_fn($author$project$Data$Time$toPosix_fn(env.pu, resultEvent.oN), $author$project$Data$Time$toPosix_fn(env.pu, event.oN)) ? $elm$core$Maybe$Just(event) : mResultEvent;
                }
            }
        });
        return $elm$core$Maybe$andThen_fn($author$project$Util$NextMeeting$formatReturnType, $elm$core$Dict$foldl_fn(reducer, $elm$core$Maybe$Nothing, env.lw));
    }, $author$project$Util$NextMeeting$findCustom = F2($author$project$Util$NextMeeting$findCustom_fn);
    var $author$project$Util$NextMeeting$nextInSeriesFilter_fn = function (masterIdParam, event) {
        return _Utils_eq($author$project$Data$Event$baseId(event.l8), $author$project$Data$Event$baseId(masterIdParam));
    }, $author$project$Util$NextMeeting$nextInSeriesFilter = F2($author$project$Util$NextMeeting$nextInSeriesFilter_fn);
    var $author$project$Util$NextMeeting$matchesEmailAddress_fn = function (emailAddresses, email) {
        return $elm$core$Set$member_fn($elm$core$String$toLower(email), emailAddresses);
    }, $author$project$Util$NextMeeting$matchesEmailAddress = F2($author$project$Util$NextMeeting$matchesEmailAddress_fn);
    var $elm_community$list_extra$List$Extra$unique = function (list) {
        return $elm_community$list_extra$List$Extra$uniqueHelp_fn($elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
    };
    var $author$project$Util$NextMeeting$relevantAttendees_fn = function (event, userEmail) {
        return $elm_community$list_extra$List$Extra$unique($elm$core$List$filterMap_fn(function (_v0) {
            var email = _v0.cS;
            var resource = _v0.ev;
            return ((!resource) && (!_Utils_eq($elm$core$String$toLower(email), $elm$core$String$toLower(userEmail)))) ? $elm$core$Maybe$Just($elm$core$String$toLower(email)) : $elm$core$Maybe$Nothing;
        }, _List_Cons(event.c8, event.ke)));
    }, $author$project$Util$NextMeeting$relevantAttendees = F2($author$project$Util$NextMeeting$relevantAttendees_fn);
    var $author$project$Util$NextMeeting$toPersonEmails_fn = function (env, personId) {
        return $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, A2($elm$core$Basics$composeR, function ($) {
            return $.lo;
        }, A2($elm$core$Basics$composeR, $elm$core$List$map($elm$core$String$toLower), $elm$core$Set$fromList))), $author$project$Data$Person$resolvePerson_fn(personId, env.iz));
    }, $author$project$Util$NextMeeting$toPersonEmails = F2($author$project$Util$NextMeeting$toPersonEmails_fn);
    var $author$project$Util$NextMeeting$nextMeetingFilter_fn = function (env, mPersonId, event) {
        var userEmail = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn("", function ($) {
            return $.cS;
        }, env.pV);
        var _v0 = _Utils_Tuple2(event.oN, mPersonId);
        if (_v0.a.$ === 1) {
            return false;
        }
        else {
            if (_v0.b.$ === 1) {
                var _v1 = _v0.b;
                return !$elm$core$List$isEmpty($author$project$Util$NextMeeting$relevantAttendees_fn(event, userEmail));
            }
            else {
                var personId = _v0.b.a;
                var _v2 = $author$project$Util$NextMeeting$toPersonEmails_fn(env, personId);
                if (_v2.$ === 1) {
                    return false;
                }
                else {
                    var personEmails = _v2.a;
                    return $elm$core$List$any_fn(A2($elm$core$Basics$composeR, function ($) {
                        return $.cS;
                    }, $author$project$Util$NextMeeting$matchesEmailAddress(personEmails)), _List_Cons(event.c8, event.ke));
                }
            }
        }
    }, $author$project$Util$NextMeeting$nextMeetingFilter = F3($author$project$Util$NextMeeting$nextMeetingFilter_fn);
    var $author$project$Util$NextMeeting$nextOneOnOneFilter_fn = function (userEmail, personEmails, event) {
        var _v0 = $author$project$Util$NextMeeting$relevantAttendees_fn(event, userEmail);
        if (_v0.b && (!_v0.b.b)) {
            var relevantAttendee = _v0.a;
            return $author$project$Util$NextMeeting$matchesEmailAddress_fn(personEmails, relevantAttendee);
        }
        else {
            return false;
        }
    }, $author$project$Util$NextMeeting$nextOneOnOneFilter = F3($author$project$Util$NextMeeting$nextOneOnOneFilter_fn);
    var $author$project$Util$NextMeeting$find_fn = function (env, nextMeeting) {
        switch (nextMeeting.$) {
            case 0:
                var mPersonId = nextMeeting.a;
                return $author$project$Util$NextMeeting$findCustom_fn(env, A2($author$project$Util$NextMeeting$nextMeetingFilter, env, mPersonId));
            case 1:
                var masterId = nextMeeting.a;
                return $author$project$Util$NextMeeting$findCustom_fn(env, $author$project$Util$NextMeeting$nextInSeriesFilter(masterId));
            default:
                var personId = nextMeeting.a;
                var _v1 = _Utils_Tuple2($author$project$Util$NextMeeting$toPersonEmails_fn(env, personId), env.pV);
                if ((!_v1.a.$) && (!_v1.b.$)) {
                    var personEmails = _v1.a.a;
                    var user = _v1.b.a;
                    return $author$project$Util$NextMeeting$findCustom_fn(env, A2($author$project$Util$NextMeeting$nextOneOnOneFilter, user.cS, personEmails));
                }
                else {
                    return $author$project$Util$NextMeeting$findCustom_fn(env, $elm$core$Basics$always(false));
                }
        }
    }, $author$project$Util$NextMeeting$find = F2($author$project$Util$NextMeeting$find_fn);
    var $author$project$Data$User$firstName = function (u) {
        return $elm$core$Maybe$withDefault_fn(u.g7, $elm$core$List$head($elm$core$String$split_fn(" ", u.g7)));
    };
    var $author$project$Util$Cmd$focusOnElement_fn = function (noOp, elementId) {
        return $elm$core$Task$attempt_fn($elm$core$Basics$always(noOp), _Browser_call_fn($elm$browser$Browser$Dom$focus_a0, elementId));
    }, $author$project$Util$Cmd$focusOnElement = F2($author$project$Util$Cmd$focusOnElement_fn);
    var $justinmimbs$time_extra$Time$Extra$Hour = 12;
    var $author$project$Search$Weight$timeDiscountRate = 0.996;
    var $author$project$Search$Weight$calculateScoreHelper_fn = function (_v0, entityTime, postProcess) {
        var currentMinute = _v0.k5;
        return postProcess(function (millisAgo) {
            return _Basics_pow_fn($author$project$Search$Weight$timeDiscountRate, ((millisAgo / 1000) / 60) / 60);
        }($elm$core$Basics$abs($elm$time$Time$posixToMillis(currentMinute) - $elm$time$Time$posixToMillis(entityTime))));
    }, $author$project$Search$Weight$calculateScoreHelper = F3($author$project$Search$Weight$calculateScoreHelper_fn);
    var $author$project$Search$Weight$attendeeScore_fn = function (env, noteTime) {
        return $author$project$Search$Weight$calculateScoreHelper_fn(env, $author$project$Data$Time$toPosix_fn(env.pu, noteTime), $elm$core$Basics$identity);
    }, $author$project$Search$Weight$attendeeScore = F2($author$project$Search$Weight$attendeeScore_fn);
    var $author$project$Data$Person$toEmailIndex = function () {
        var emailAddressReducer = F3(function (personId, email, acc) {
            return $elm$core$Dict$insert_fn($elm$core$String$toLower(email), personId, acc);
        });
        var personReducer = F3(function (personId, person, acc) {
            return person.lh ? acc : $elm$core$List$foldl_fn(emailAddressReducer(personId), acc, person.lo);
        });
        return A2($author$project$Firestore$Collection$foldl, personReducer, $elm$core$Dict$empty);
    }();
    var $author$project$Search$Weight$updateScoreIndex_fn = function (id, itemScore, scoreIndex) {
        return $elm$core$Dict$update_fn(id, function (mTotalScore) {
            if (!mTotalScore.$) {
                var totalScore = mTotalScore.a;
                return $elm$core$Maybe$Just(itemScore + totalScore);
            }
            else {
                return $elm$core$Maybe$Just(itemScore);
            }
        }, scoreIndex);
    }, $author$project$Search$Weight$updateScoreIndex = F3($author$project$Search$Weight$updateScoreIndex_fn);
    var $author$project$Search$Weight$withAttendeeScoring_fn = function (env, initIndex) {
        var personEmailReverseIndex = $author$project$Data$Person$toEmailIndex(env.iz);
        var attendeeReducer = F3(function (eventTime, attendee, acc) {
            var _v1 = $elm$core$Dict$get_fn($elm$core$String$toLower(attendee.cS), personEmailReverseIndex);
            if (!_v1.$) {
                var personId = _v1.a;
                return $author$project$Search$Weight$updateScoreIndex_fn(personId, $author$project$Search$Weight$attendeeScore_fn(env, eventTime), acc);
            }
            else {
                return acc;
            }
        });
        var eventReducer = F3(function (_v0, event, acc) {
            return $elm$core$List$foldl_fn(attendeeReducer(event.oN), acc, event.ke);
        });
        return $elm$core$Dict$foldl_fn(eventReducer, initIndex, env.lw);
    }, $author$project$Search$Weight$withAttendeeScoring = F2($author$project$Search$Weight$withAttendeeScoring_fn);
    var $author$project$Search$Weight$mentionScore_fn = function (env, noteTime) {
        return $author$project$Search$Weight$calculateScoreHelper_fn(env, $author$project$Data$Time$toPosix_fn(env.pu, noteTime), $elm$core$Basics$mul(2));
    }, $author$project$Search$Weight$mentionScore = F2($author$project$Search$Weight$mentionScore_fn);
    var $author$project$Search$Weight$withMentionsScoring_fn = function (env, initIndex) {
        var mentionReducer = F3(function (noteTime, mentionRef, scoreIndex) {
            if (mentionRef.$ === 2) {
                var personId = mentionRef.a.iB;
                return $author$project$Search$Weight$updateScoreIndex_fn(personId, $author$project$Search$Weight$mentionScore_fn(env, noteTime), scoreIndex);
            }
            else {
                return scoreIndex;
            }
        });
        var actionItemReducer = F3(function (noteTime, actionItem, scoreIndex) {
            return $elm$core$List$foldl_fn(mentionReducer(noteTime), scoreIndex, actionItem.jn);
        });
        var noteReducer = F3(function (_v0, note, scoreIndex) {
            return $elm$core$List$foldl_fn(actionItemReducer(note.gh), scoreIndex, note.gz);
        });
        return A3($author$project$Firestore$Collection$foldl, noteReducer, initIndex, env.fO);
    }, $author$project$Search$Weight$withMentionsScoring = F2($author$project$Search$Weight$withMentionsScoring_fn);
    var $author$project$Search$Weight$createFreshIndex = function (env) {
        return (new $$Record21($author$project$Search$Weight$withMentionsScoring_fn(env, $author$project$Search$Weight$withAttendeeScoring_fn(env, $elm$core$Dict$empty)), env.k5));
    };
    var $justinmimbs$time_extra$Time$Extra$toFractionalDay_fn = function (zone, posix) {
        return $justinmimbs$time_extra$Time$Extra$timeFromPosix_fn(zone, posix) / 86400000;
    }, $justinmimbs$time_extra$Time$Extra$toFractionalDay = F2($justinmimbs$time_extra$Time$Extra$toFractionalDay_fn);
    var $justinmimbs$time_extra$Time$Extra$toMonths_fn = function (zone, posix) {
        var wholeMonths = (12 * ($elm$time$Time$toYear_fn(zone, posix) - 1)) + ($justinmimbs$date$Date$monthToNumber($elm$time$Time$toMonth_fn(zone, posix)) - 1);
        var fractionalMonth = ($elm$time$Time$toDay_fn(zone, posix) + $justinmimbs$time_extra$Time$Extra$toFractionalDay_fn(zone, posix)) / 100;
        return wholeMonths + fractionalMonth;
    }, $justinmimbs$time_extra$Time$Extra$toMonths = F2($justinmimbs$time_extra$Time$Extra$toMonths_fn);
    var $justinmimbs$time_extra$Time$Extra$toRataDieMoment_fn = function (zone, posix) {
        return $justinmimbs$date$Date$toRataDie($justinmimbs$date$Date$fromPosix_fn(zone, posix)) + $justinmimbs$time_extra$Time$Extra$toFractionalDay_fn(zone, posix);
    }, $justinmimbs$time_extra$Time$Extra$toRataDieMoment = F2($justinmimbs$time_extra$Time$Extra$toRataDieMoment_fn);
    var $justinmimbs$time_extra$Time$Extra$diff_fn = function (interval, zone, posix1, posix2) {
        diff: while (true) {
            switch (interval) {
                case 15:
                    return $elm$time$Time$posixToMillis(posix2) - $elm$time$Time$posixToMillis(posix1);
                case 14:
                    return ($justinmimbs$time_extra$Time$Extra$diff_fn(15, zone, posix1, posix2) / 1000) | 0;
                case 13:
                    return ($justinmimbs$time_extra$Time$Extra$diff_fn(15, zone, posix1, posix2) / 60000) | 0;
                case 12:
                    return ($justinmimbs$time_extra$Time$Extra$diff_fn(15, zone, posix1, posix2) / 3600000) | 0;
                case 11:
                    return ($justinmimbs$time_extra$Time$Extra$toRataDieMoment_fn(zone, posix2) - $justinmimbs$time_extra$Time$Extra$toRataDieMoment_fn(zone, posix1)) | 0;
                case 2:
                    return ($justinmimbs$time_extra$Time$Extra$toMonths_fn(zone, posix2) - $justinmimbs$time_extra$Time$Extra$toMonths_fn(zone, posix1)) | 0;
                case 0:
                    return ($justinmimbs$time_extra$Time$Extra$diff_fn(2, zone, posix1, posix2) / 12) | 0;
                case 1:
                    return ($justinmimbs$time_extra$Time$Extra$diff_fn(2, zone, posix1, posix2) / 3) | 0;
                case 3:
                    return ($justinmimbs$time_extra$Time$Extra$diff_fn(11, zone, posix1, posix2) / 7) | 0;
                default:
                    var weekday = interval;
                    var $temp$interval = 3, $temp$zone = zone, $temp$posix1 = $justinmimbs$time_extra$Time$Extra$floor_fn(weekday, zone, posix1), $temp$posix2 = $justinmimbs$time_extra$Time$Extra$floor_fn(weekday, zone, posix2);
                    interval = $temp$interval;
                    zone = $temp$zone;
                    posix1 = $temp$posix1;
                    posix2 = $temp$posix2;
                    continue diff;
            }
        }
    }, $justinmimbs$time_extra$Time$Extra$diff = F4($justinmimbs$time_extra$Time$Extra$diff_fn);
    var $elm$json$Json$Encode$float = _Json_wrap;
    var $author$project$Search$Weight$encode = function (_v0) {
        var updatedAt = _v0.pR;
        var people = _v0.iz;
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("updatedAt", $elm$core$Basics$composeR_fn($author$project$Util$Time$encodePosixToMillis_a0, $author$project$Util$Time$encodePosixToMillis_a1, updatedAt)),
            _Utils_Tuple2("people", $elm$json$Json$Encode$dict_fn($elm$core$Basics$identity, $elm$json$Json$Encode$float, people))
        ]));
    };
    var $author$project$Search$Weight$saveSearchWeightIndex_ = _Platform_outgoingPort("saveSearchWeightIndex_", $elm$core$Basics$identity);
    var $author$project$Search$Weight$save_fn = function (index, _v0) {
        var id = _v0.l8;
        return $author$project$Search$Weight$saveSearchWeightIndex_($elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("path", $elm$json$Json$Encode$string("/accounts/" + id)),
            _Utils_Tuple2("data", $author$project$Search$Weight$encode(index))
        ])));
    }, $author$project$Search$Weight$save = F2($author$project$Search$Weight$save_fn);
    var $author$project$Search$Weight$generate = function (env) {
        var indexAgeInHours = $justinmimbs$time_extra$Time$Extra$diff_fn(12, env.pu, env.oq.pR, env.k5);
        if (indexAgeInHours >= 1) {
            var newSearchWeightIndex = $author$project$Search$Weight$createFreshIndex(env);
            return _Utils_Tuple2(newSearchWeightIndex, $author$project$Util$Cmd$whenJust_fn(env.pV, $author$project$Search$Weight$save(newSearchWeightIndex)));
        }
        else {
            return _Utils_Tuple2(env.oq, $elm$core$Platform$Cmd$none);
        }
    };
    var $author$project$Routing$currentNoteId = function (route) {
        _v0$4: while (true) {
            switch (route.$) {
                case 6:
                    var noteId = route.a;
                    return $elm$core$Maybe$Just(noteId);
                case 3:
                    var noteId = route.a;
                    return $elm$core$Maybe$Just(noteId);
                case 5:
                    var noteId = route.a;
                    return $elm$core$Maybe$Just(noteId);
                case 13:
                    if (route.a.$ === 5) {
                        var _v1 = route.a;
                        return $elm$core$Maybe$Just($author$project$Content$Note$wizardNoteId);
                    }
                    else {
                        break _v0$4;
                    }
                default:
                    break _v0$4;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $author$project$Data$MentionResult$currentNote = function (env) {
        return $elm$core$Maybe$andThen_fn(function (noteId) {
            return $elm$core$Maybe$map_fn($elm$core$Tuple$pair(noteId), $author$project$Firestore$Collection$get_fn(noteId, env.fO));
        }, $author$project$Routing$currentNoteId(env.oe));
    };
    var $author$project$Data$MentionResult$MentionEventData = function (a) {
        return { $: 1, a: a };
    };
    var $ryannhg$date_format$DateFormat$AmPmLowercase = { $: 23 };
    var $ryannhg$date_format$DateFormat$amPmLowercase = $ryannhg$date_format$DateFormat$AmPmLowercase;
    var $ryannhg$date_format$DateFormat$DayOfMonthNumber = { $: 5 };
    var $ryannhg$date_format$DateFormat$dayOfMonthNumber = $ryannhg$date_format$DateFormat$DayOfMonthNumber;
    var $ryannhg$date_format$DateFormat$Language$Language_fn = function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
        return { pw: toAmPm, px: toMonthAbbreviation, py: toMonthName, cu: toOrdinalSuffix, pA: toWeekdayAbbreviation, pB: toWeekdayName };
    }, $ryannhg$date_format$DateFormat$Language$Language = F6($ryannhg$date_format$DateFormat$Language$Language_fn);
    var $ryannhg$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
        return (hour > 11) ? "pm" : "am";
    };
    var $ryannhg$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
        switch (month) {
            case 0:
                return "January";
            case 1:
                return "February";
            case 2:
                return "March";
            case 3:
                return "April";
            case 4:
                return "May";
            case 5:
                return "June";
            case 6:
                return "July";
            case 7:
                return "August";
            case 8:
                return "September";
            case 9:
                return "October";
            case 10:
                return "November";
            default:
                return "December";
        }
    };
    var $ryannhg$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
        var _v0 = _Basics_modBy_fn(100, num);
        switch (_v0) {
            case 11:
                return "th";
            case 12:
                return "th";
            case 13:
                return "th";
            default:
                var _v1 = _Basics_modBy_fn(10, num);
                switch (_v1) {
                    case 1:
                        return "st";
                    case 2:
                        return "nd";
                    case 3:
                        return "rd";
                    default:
                        return "th";
                }
        }
    };
    var $ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
        switch (weekday) {
            case 0:
                return "Monday";
            case 1:
                return "Tuesday";
            case 2:
                return "Wednesday";
            case 3:
                return "Thursday";
            case 4:
                return "Friday";
            case 5:
                return "Saturday";
            default:
                return "Sunday";
        }
    };
    var $ryannhg$date_format$DateFormat$Language$english = $ryannhg$date_format$DateFormat$Language$Language_fn($ryannhg$date_format$DateFormat$Language$toEnglishMonthName, A2($elm$core$Basics$composeR, $ryannhg$date_format$DateFormat$Language$toEnglishMonthName, $elm$core$String$left(3)), $ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName, A2($elm$core$Basics$composeR, $ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName, $elm$core$String$left(3)), $ryannhg$date_format$DateFormat$Language$toEnglishAmPm, $ryannhg$date_format$DateFormat$Language$toEnglishSuffix);
    var $ryannhg$date_format$DateFormat$amPm_fn = function (language, zone, posix) {
        return language.pw($elm$time$Time$toHour_fn(zone, posix));
    }, $ryannhg$date_format$DateFormat$amPm = F3($ryannhg$date_format$DateFormat$amPm_fn);
    var $ryannhg$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
    var $ryannhg$date_format$DateFormat$days = _List_fromArray([6, 0, 1, 2, 3, 4, 5]);
    var $ryannhg$date_format$DateFormat$dayOfWeek_fn = function (zone, posix) {
        return function (_v1) {
            var i = _v1.a;
            return i;
        }($elm$core$Maybe$withDefault_fn(_Utils_Tuple2(0, 6), $elm$core$List$head($elm$core$List$filter_fn(function (_v0) {
            var day = _v0.b;
            return _Utils_eq(day, $elm$time$Time$toWeekday_fn(zone, posix));
        }, $elm$core$List$indexedMap_fn_unwrapped(function (i, day) {
            return _Utils_Tuple2(i, day);
        }, $ryannhg$date_format$DateFormat$days)))));
    }, $ryannhg$date_format$DateFormat$dayOfWeek = F2($ryannhg$date_format$DateFormat$dayOfWeek_fn);
    var $ryannhg$date_format$DateFormat$isLeapYear = function (year_) {
        return (!(!_Basics_modBy_fn(4, year_))) ? false : ((!(!_Basics_modBy_fn(100, year_))) ? true : ((!(!_Basics_modBy_fn(400, year_))) ? false : true));
    };
    var $ryannhg$date_format$DateFormat$daysInMonth_fn = function (year_, month) {
        switch (month) {
            case 0:
                return 31;
            case 1:
                return $ryannhg$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
            case 2:
                return 31;
            case 3:
                return 30;
            case 4:
                return 31;
            case 5:
                return 30;
            case 6:
                return 31;
            case 7:
                return 31;
            case 8:
                return 30;
            case 9:
                return 31;
            case 10:
                return 30;
            default:
                return 31;
        }
    }, $ryannhg$date_format$DateFormat$daysInMonth = F2($ryannhg$date_format$DateFormat$daysInMonth_fn);
    var $ryannhg$date_format$DateFormat$months = _List_fromArray([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
    var $ryannhg$date_format$DateFormat$monthPair_fn = function (zone, posix) {
        return $elm$core$Maybe$withDefault_fn(_Utils_Tuple2(0, 0), $elm$core$List$head($elm$core$List$filter_fn(function (_v0) {
            var i = _v0.a;
            var m = _v0.b;
            return _Utils_eq(m, $elm$time$Time$toMonth_fn(zone, posix));
        }, $elm$core$List$indexedMap_fn_unwrapped(function (a, b) {
            return _Utils_Tuple2(a, b);
        }, $ryannhg$date_format$DateFormat$months))));
    }, $ryannhg$date_format$DateFormat$monthPair = F2($ryannhg$date_format$DateFormat$monthPair_fn);
    var $ryannhg$date_format$DateFormat$monthNumber__fn = function (zone, posix) {
        return 1 + function (_v0) {
            var i = _v0.a;
            var m = _v0.b;
            return i;
        }($ryannhg$date_format$DateFormat$monthPair_fn(zone, posix));
    }, $ryannhg$date_format$DateFormat$monthNumber_ = F2($ryannhg$date_format$DateFormat$monthNumber__fn);
    var $ryannhg$date_format$DateFormat$dayOfYear_fn = function (zone, posix) {
        var monthsBeforeThisOne = $elm$core$List$take_fn($ryannhg$date_format$DateFormat$monthNumber__fn(zone, posix) - 1, $ryannhg$date_format$DateFormat$months);
        var daysBeforeThisMonth = $elm$core$List$sum($elm$core$List$map_fn($ryannhg$date_format$DateFormat$daysInMonth($elm$time$Time$toYear_fn(zone, posix)), monthsBeforeThisOne));
        return daysBeforeThisMonth + $elm$time$Time$toDay_fn(zone, posix);
    }, $ryannhg$date_format$DateFormat$dayOfYear = F2($ryannhg$date_format$DateFormat$dayOfYear_fn);
    var $ryannhg$date_format$DateFormat$quarter_fn = function (zone, posix) {
        return ($ryannhg$date_format$DateFormat$monthNumber__fn(zone, posix) / 4) | 0;
    }, $ryannhg$date_format$DateFormat$quarter = F2($ryannhg$date_format$DateFormat$quarter_fn);
    var $ryannhg$date_format$DateFormat$toFixedLength_fn = function (totalChars, num) {
        var numStr = $elm$core$String$fromInt(num);
        var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
        var zeros = $elm$core$String$join_fn("", $elm$core$List$map_fn(function (_v0) {
            return "0";
        }, $elm$core$List$range_fn(1, numZerosNeeded)));
        return _Utils_ap(zeros, numStr);
    }, $ryannhg$date_format$DateFormat$toFixedLength = F2($ryannhg$date_format$DateFormat$toFixedLength_fn);
    var $ryannhg$date_format$DateFormat$toNonMilitary = function (num) {
        return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
    };
    var $elm$core$String$toUpper = _String_toUpper;
    var $ryannhg$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
    var $ryannhg$date_format$DateFormat$firstDayOfYear_fn = function (zone, time) {
        return $elm$time$Time$millisToPosix($ryannhg$date_format$DateFormat$millisecondsPerYear * $elm$time$Time$toYear_fn(zone, time));
    }, $ryannhg$date_format$DateFormat$firstDayOfYear = F2($ryannhg$date_format$DateFormat$firstDayOfYear_fn);
    var $ryannhg$date_format$DateFormat$weekOfYear_fn = function (zone, posix) {
        var firstDay = $ryannhg$date_format$DateFormat$firstDayOfYear_fn(zone, posix);
        var firstDayOffset = $ryannhg$date_format$DateFormat$dayOfWeek_fn(zone, firstDay);
        var daysSoFar = $ryannhg$date_format$DateFormat$dayOfYear_fn(zone, posix);
        return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
    }, $ryannhg$date_format$DateFormat$weekOfYear = F2($ryannhg$date_format$DateFormat$weekOfYear_fn);
    var $ryannhg$date_format$DateFormat$year_fn = function (zone, time) {
        return $elm$core$String$fromInt($elm$time$Time$toYear_fn(zone, time));
    }, $ryannhg$date_format$DateFormat$year = F2($ryannhg$date_format$DateFormat$year_fn);
    var $ryannhg$date_format$DateFormat$piece_fn = function (language, zone, posix, token) {
        switch (token.$) {
            case 0:
                return $elm$core$String$fromInt($ryannhg$date_format$DateFormat$monthNumber__fn(zone, posix));
            case 1:
                return function (num) {
                    return _Utils_ap($elm$core$String$fromInt(num), language.cu(num));
                }($ryannhg$date_format$DateFormat$monthNumber__fn(zone, posix));
            case 2:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $ryannhg$date_format$DateFormat$monthNumber__fn(zone, posix));
            case 3:
                return language.px($elm$time$Time$toMonth_fn(zone, posix));
            case 4:
                return language.py($elm$time$Time$toMonth_fn(zone, posix));
            case 17:
                return $elm$core$String$fromInt(1 + $ryannhg$date_format$DateFormat$quarter_fn(zone, posix));
            case 18:
                return function (num) {
                    return _Utils_ap($elm$core$String$fromInt(num), language.cu(num));
                }(1 + $ryannhg$date_format$DateFormat$quarter_fn(zone, posix));
            case 5:
                return $elm$core$String$fromInt($elm$time$Time$toDay_fn(zone, posix));
            case 6:
                return function (num) {
                    return _Utils_ap($elm$core$String$fromInt(num), language.cu(num));
                }($elm$time$Time$toDay_fn(zone, posix));
            case 7:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $elm$time$Time$toDay_fn(zone, posix));
            case 8:
                return $elm$core$String$fromInt($ryannhg$date_format$DateFormat$dayOfYear_fn(zone, posix));
            case 9:
                return function (num) {
                    return _Utils_ap($elm$core$String$fromInt(num), language.cu(num));
                }($ryannhg$date_format$DateFormat$dayOfYear_fn(zone, posix));
            case 10:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(3, $ryannhg$date_format$DateFormat$dayOfYear_fn(zone, posix));
            case 11:
                return $elm$core$String$fromInt($ryannhg$date_format$DateFormat$dayOfWeek_fn(zone, posix));
            case 12:
                return function (num) {
                    return _Utils_ap($elm$core$String$fromInt(num), language.cu(num));
                }($ryannhg$date_format$DateFormat$dayOfWeek_fn(zone, posix));
            case 13:
                return language.pA($elm$time$Time$toWeekday_fn(zone, posix));
            case 14:
                return language.pB($elm$time$Time$toWeekday_fn(zone, posix));
            case 19:
                return $elm$core$String$fromInt($ryannhg$date_format$DateFormat$weekOfYear_fn(zone, posix));
            case 20:
                return function (num) {
                    return _Utils_ap($elm$core$String$fromInt(num), language.cu(num));
                }($ryannhg$date_format$DateFormat$weekOfYear_fn(zone, posix));
            case 21:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $ryannhg$date_format$DateFormat$weekOfYear_fn(zone, posix));
            case 15:
                return $elm$core$String$right_fn(2, $ryannhg$date_format$DateFormat$year_fn(zone, posix));
            case 16:
                return $ryannhg$date_format$DateFormat$year_fn(zone, posix);
            case 22:
                return $elm$core$String$toUpper($ryannhg$date_format$DateFormat$amPm_fn(language, zone, posix));
            case 23:
                return $elm$core$String$toLower($ryannhg$date_format$DateFormat$amPm_fn(language, zone, posix));
            case 24:
                return $elm$core$String$fromInt($elm$time$Time$toHour_fn(zone, posix));
            case 25:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $elm$time$Time$toHour_fn(zone, posix));
            case 26:
                return $elm$core$String$fromInt($ryannhg$date_format$DateFormat$toNonMilitary($elm$time$Time$toHour_fn(zone, posix)));
            case 27:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $ryannhg$date_format$DateFormat$toNonMilitary($elm$time$Time$toHour_fn(zone, posix)));
            case 28:
                return $elm$core$String$fromInt(1 + $elm$time$Time$toHour_fn(zone, posix));
            case 29:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, 1 + $elm$time$Time$toHour_fn(zone, posix));
            case 30:
                return $elm$core$String$fromInt($elm$time$Time$toMinute_fn(zone, posix));
            case 31:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $elm$time$Time$toMinute_fn(zone, posix));
            case 32:
                return $elm$core$String$fromInt($elm$time$Time$toSecond_fn(zone, posix));
            case 33:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(2, $elm$time$Time$toSecond_fn(zone, posix));
            case 34:
                return $elm$core$String$fromInt($elm$time$Time$toMillis_fn(zone, posix));
            case 35:
                return $ryannhg$date_format$DateFormat$toFixedLength_fn(3, $elm$time$Time$toMillis_fn(zone, posix));
            default:
                var string = token.a;
                return string;
        }
    }, $ryannhg$date_format$DateFormat$piece = F4($ryannhg$date_format$DateFormat$piece_fn);
    var $ryannhg$date_format$DateFormat$formatWithLanguage_fn = function (language, tokens, zone, time) {
        return $elm$core$String$join_fn("", $elm$core$List$map_fn(A3($ryannhg$date_format$DateFormat$piece, language, zone, time), tokens));
    }, $ryannhg$date_format$DateFormat$formatWithLanguage = F4($ryannhg$date_format$DateFormat$formatWithLanguage_fn);
    var $ryannhg$date_format$DateFormat$format_a0 = $ryannhg$date_format$DateFormat$Language$english, $ryannhg$date_format$DateFormat$format = $ryannhg$date_format$DateFormat$formatWithLanguage($ryannhg$date_format$DateFormat$format_a0);
    var $ryannhg$date_format$DateFormat$HourNumber = { $: 26 };
    var $ryannhg$date_format$DateFormat$hourNumber = $ryannhg$date_format$DateFormat$HourNumber;
    var $ryannhg$date_format$DateFormat$MinuteFixed = { $: 31 };
    var $ryannhg$date_format$DateFormat$minuteFixed = $ryannhg$date_format$DateFormat$MinuteFixed;
    var $ryannhg$date_format$DateFormat$MonthNumber = { $: 0 };
    var $ryannhg$date_format$DateFormat$monthNumber = $ryannhg$date_format$DateFormat$MonthNumber;
    var $ryannhg$date_format$DateFormat$Text = function (a) {
        return { $: 36, a: a };
    };
    var $ryannhg$date_format$DateFormat$text = $ryannhg$date_format$DateFormat$Text;
    var $ryannhg$date_format$DateFormat$YearNumberLastTwo = { $: 15 };
    var $ryannhg$date_format$DateFormat$yearNumberLastTwo = $ryannhg$date_format$DateFormat$YearNumberLastTwo;
    var $author$project$Util$Time$conciseFormatter = $ryannhg$date_format$DateFormat$format(_List_fromArray([
        $ryannhg$date_format$DateFormat$monthNumber,
        $ryannhg$date_format$DateFormat$text("/"),
        $ryannhg$date_format$DateFormat$dayOfMonthNumber,
        $ryannhg$date_format$DateFormat$text("/"),
        $ryannhg$date_format$DateFormat$yearNumberLastTwo,
        $ryannhg$date_format$DateFormat$text(" "),
        $ryannhg$date_format$DateFormat$hourNumber,
        $ryannhg$date_format$DateFormat$text(":"),
        $ryannhg$date_format$DateFormat$minuteFixed,
        $ryannhg$date_format$DateFormat$amPmLowercase
    ]));
    var $author$project$Data$MentionResult$searchStartsWith_fn = function (_v0, searchText) {
        var searchTerm = _v0.dg;
        return (!$elm$core$String$isEmpty(searchTerm)) && _String_startsWith_fn($elm$core$String$toLower(searchTerm), $elm$core$String$toLower(searchText));
    }, $author$project$Data$MentionResult$searchStartsWith = F2($author$project$Data$MentionResult$searchStartsWith_fn);
    var $author$project$Data$MentionResult$eventMentionResultReducer_fn = function (env, request, _v0, event, acc) {
        var dateTimeString = A2($author$project$Util$Time$conciseFormatter, env.pu, $author$project$Data$Time$toPosix_fn(env.pu, event.oN));
        var _v1 = function () {
            var _v2 = event.pv;
            switch (_v2.$) {
                case 2:
                    var masterId = _v2.a.mT;
                    return _Utils_Tuple2($author$project$Data$MentionResult$MentionEventData((new $$Record83($elm$core$Maybe$Nothing, $elm$core$Maybe$Just(masterId), event.gj))), "Next instance:  " + dateTimeString);
                case 0:
                    return _Utils_Tuple2($author$project$Data$MentionResult$MentionEventData((new $$Record83($elm$core$Maybe$Just(event.l8), $elm$core$Maybe$Nothing, event.gj))), dateTimeString);
                default:
                    return _Utils_Tuple2($author$project$Data$MentionResult$MentionEventData((new $$Record83($elm$core$Maybe$Nothing, $elm$core$Maybe$Just(event.l8), event.gj))), "Next instance:  " + dateTimeString);
            }
        }();
        var mentionEventData = _v1.a;
        var subtext = _v1.b;
        return _List_Cons({
            a: mentionEventData,
            bD: _Utils_Tuple3(0, 0, $author$project$Util$Misc$if__fn($author$project$Data$MentionResult$searchStartsWith_fn(request, event.gj), 1, 0)),
            bd: {
                cp: $elm$core$Maybe$Just(subtext),
                jn: event.gj
            }
        }, acc);
    }, $author$project$Data$MentionResult$eventMentionResultReducer = F5($author$project$Data$MentionResult$eventMentionResultReducer_fn);
    var $author$project$Util$Time$isOnOrBefore_fn = function (t1, t2) {
        return _Utils_cmp($elm$time$Time$posixToMillis(t2), $elm$time$Time$posixToMillis(t1)) < 1;
    }, $author$project$Util$Time$isOnOrBefore = F2($author$project$Util$Time$isOnOrBefore_fn);
    var $author$project$Data$MentionResult$instanceUpdater_fn = function (timezoneUser, _new, mExisting) {
        if (!mExisting.$) {
            var existing = mExisting.a;
            var _v1 = $author$project$Util$Misc$tupleMap_fn($author$project$Data$Time$toPosix(timezoneUser), _Utils_Tuple2(_new.oN, existing.oN));
            var newStart = _v1.a;
            var existingStart = _v1.b;
            return $author$project$Util$Time$isOnOrBefore_fn(existingStart, newStart) ? $elm$core$Maybe$Just(_new) : $elm$core$Maybe$Just(existing);
        }
        else {
            return $elm$core$Maybe$Just(_new);
        }
    }, $author$project$Data$MentionResult$instanceUpdater = F3($author$project$Data$MentionResult$instanceUpdater_fn);
    var $author$project$Data$MentionResult$searchContains_fn = function (_v0, searchText) {
        var searchTerm = _v0.dg;
        return (!$elm$core$String$isEmpty(searchTerm)) && _String_contains_fn($elm$core$String$toLower(searchTerm), $elm$core$String$toLower(searchText));
    }, $author$project$Data$MentionResult$searchContains = F2($author$project$Data$MentionResult$searchContains_fn);
    var $author$project$Data$MentionResult$eventReducer_fn = function (env, request, eventId, event, acc) {
        if ((!event.lh) && ($author$project$Util$Time$isOnOrAfter_fn(env.k5, $author$project$Data$Time$toPosix_fn(env.pu, event.oN)) && $author$project$Data$MentionResult$searchContains_fn(request, event.gj))) {
            var _v0 = event.pv;
            switch (_v0.$) {
                case 2:
                    var masterId = _v0.a.mT;
                    return $elm$core$Dict$update_fn($author$project$Data$Event$baseId(masterId), A2($author$project$Data$MentionResult$instanceUpdater, env.pu, event), acc);
                case 0:
                    return $elm$core$Dict$insert_fn(eventId, event, acc);
                default:
                    return acc;
            }
        }
        else {
            return acc;
        }
    }, $author$project$Data$MentionResult$eventReducer = F5($author$project$Data$MentionResult$eventReducer_fn);
    var $author$project$Data$MentionResult$nextInSeries_fn = function (masterId, eventTitle) {
        return $author$project$Data$MentionResult$MentionEventData((new $$Record83($elm$core$Maybe$Nothing, $elm$core$Maybe$Just(masterId), eventTitle)));
    }, $author$project$Data$MentionResult$nextInSeries = F2($author$project$Data$MentionResult$nextInSeries_fn);
    var $author$project$Data$MentionResult$nextInSeriesTitle = "next in series";
    var $author$project$Data$MentionResult$nextInSeriesResult = function (env) {
        var mMasterEventId = $elm$core$Maybe$andThen_fn($author$project$Data$Note$masterEventId, $elm$core$Maybe$andThen_fn(function (noteId) {
            return $author$project$Firestore$Collection$get_fn(noteId, env.fO);
        }, $author$project$Routing$currentNoteId(env.oe)));
        var mEventTitle = $elm$core$Maybe$map_fn(function ($) {
            return $.gj;
        }, $elm$core$Maybe$andThen_fn(function (eventId) {
            return $elm$core$Dict$get_fn(eventId, env.lw);
        }, mMasterEventId));
        return $elm$core$Maybe$map2_fn_unwrapped(function (masterEventId, eventTitle) {
            return {
                a: $author$project$Data$MentionResult$nextInSeries_fn(masterEventId, eventTitle),
                bD: _Utils_Tuple3(1, 0, 0),
                bd: {
                    cp: $elm$core$Maybe$Just("Next \"" + (eventTitle + "\"")),
                    jn: $author$project$Data$MentionResult$nextInSeriesTitle
                }
            };
        }, mMasterEventId, mEventTitle);
    };
    var $author$project$Data$MentionResult$nextMeetingTitle = "next meeting";
    var $author$project$Data$MentionResult$nextEvent = $author$project$Data$MentionResult$MentionEventData((new $$Record83($elm$core$Maybe$Nothing, $elm$core$Maybe$Just($author$project$Data$Mention$nextEventId), $author$project$Data$MentionResult$nextMeetingTitle)));
    var $author$project$Data$MentionResult$nextMeetingResult = function (firstPersonMentionsName) {
        return {
            a: $author$project$Data$MentionResult$nextEvent,
            bD: _Utils_Tuple3(1, 0, 0),
            bd: {
                cp: $elm$core$Maybe$Just(function () {
                    if (!firstPersonMentionsName.$) {
                        var name = firstPersonMentionsName.a;
                        return "Appears in all meetings w/ " + name;
                    }
                    else {
                        return "Appears in all future meetings";
                    }
                }()),
                jn: $author$project$Data$MentionResult$nextMeetingTitle
            }
        };
    };
    var $author$project$Data$MentionResult$nextOneOnOneTitle = "next 1-on-1";
    var $author$project$Data$MentionResult$nextOneOnOne = $author$project$Data$MentionResult$MentionEventData((new $$Record83($elm$core$Maybe$Nothing, $elm$core$Maybe$Just($author$project$Data$Mention$nextOneOnOne), $author$project$Data$MentionResult$nextOneOnOneTitle)));
    var $author$project$Data$MentionResult$nextOneOnOneResult = function (firstPersonMentionsName) {
        return {
            a: $author$project$Data$MentionResult$nextOneOnOne,
            bD: _Utils_Tuple3(1, 0, 0),
            bd: {
                cp: $elm$core$Maybe$Just(function () {
                    if (!firstPersonMentionsName.$) {
                        var name = firstPersonMentionsName.a;
                        return "Appears in next 1-on-1 w/ " + name;
                    }
                    else {
                        return "Make sure to use an @mention in the same line";
                    }
                }()),
                jn: $author$project$Data$MentionResult$nextOneOnOneTitle
            }
        };
    };
    var $author$project$Data$MentionResult$nextEventResults_fn = function (env, request) {
        var firstPersonMentionsName = $elm$core$Maybe$map_fn(function ($) {
            return $.b;
        }, $elm$core$Maybe$andThen_fn(function (personId) {
            return $author$project$Firestore$Collection$get_fn(personId, env.iz);
        }, $elm$core$List$head($elm$core$List$filterMap_fn(function (m) {
            if (!m.$) {
                var personId = m.a.iB;
                return $elm$core$Maybe$Just(personId);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, request.ic))));
        return $elm$core$List$filterMap_fn($elm$core$Basics$identity, _List_fromArray([
            $author$project$Data$MentionResult$nextInSeriesResult(env),
            $elm$core$Maybe$Just($author$project$Data$MentionResult$nextMeetingResult(firstPersonMentionsName)),
            $elm$core$Maybe$Just($author$project$Data$MentionResult$nextOneOnOneResult(firstPersonMentionsName))
        ]));
    }, $author$project$Data$MentionResult$nextEventResults = F2($author$project$Data$MentionResult$nextEventResults_fn);
    var $author$project$Data$MentionResult$maybeWithNextEventMention_fn = function (env, request, mentions) {
        var showNextEventResult = $elm$core$String$isEmpty(request.dg) || $author$project$Data$MentionResult$searchStartsWith_fn(request, $author$project$Data$MentionResult$nextMeetingTitle);
        return showNextEventResult ? _Utils_ap($author$project$Data$MentionResult$nextEventResults_fn(env, request), mentions) : mentions;
    }, $author$project$Data$MentionResult$maybeWithNextEventMention = F3($author$project$Data$MentionResult$maybeWithNextEventMention_fn);
    var $author$project$Data$MentionResult$eventSearch_fn = function (env, request, _v0) {
        var currentNoteId = _v0.a;
        return $author$project$Data$MentionResult$maybeWithNextEventMention_fn(env, request, $elm$core$Dict$foldl_fn(A2($author$project$Data$MentionResult$eventMentionResultReducer, env, request), _List_Nil, $elm$core$Dict$foldl_fn(A2($author$project$Data$MentionResult$eventReducer, env, request), $elm$core$Dict$empty, env.lw)));
    }, $author$project$Data$MentionResult$eventSearch = F3($author$project$Data$MentionResult$eventSearch_fn);
    var $author$project$Data$MentionResult$maxMentionables = 6;
    var $author$project$Data$MentionResult$MentionPersonData = function (a) {
        return { $: 0, a: a };
    };
    var $elm_community$maybe_extra$Maybe$Extra$orElse_fn = function (ma, mb) {
        if (mb.$ === 1) {
            return ma;
        }
        else {
            return mb;
        }
    }, $elm_community$maybe_extra$Maybe$Extra$orElse = F2($elm_community$maybe_extra$Maybe$Extra$orElse_fn);
    var $elm$core$Set$isEmpty = function (_v0) {
        var dict = _v0;
        return $elm$core$Dict$isEmpty(dict);
    };
    var $author$project$Data$MentionResult$personIsAttendee_fn = function (_v0, attendeeIds) {
        var personId = _v0.a;
        var person = _v0.b;
        var personsEmails = $elm$core$Set$fromList($elm$core$List$map_fn($elm$core$String$toLower, person.lo));
        return $elm$core$Set$member_fn(personId, attendeeIds.ek) || (!$elm$core$Set$isEmpty($elm$core$Set$intersect_fn(personsEmails, attendeeIds.dV)));
    }, $author$project$Data$MentionResult$personIsAttendee = F2($author$project$Data$MentionResult$personIsAttendee_fn);
    var $author$project$Data$MentionResult$calculatePersonScore_fn = function (attendeeIds, _v0, request) {
        var personId = _v0.a;
        var person = _v0.b;
        var personIsAttendee_ = $author$project$Data$MentionResult$personIsAttendee_fn(_Utils_Tuple2(personId, person), attendeeIds);
        var nameStartsWithQuery = $author$project$Data$MentionResult$searchStartsWith_fn(request, person.b);
        var emailsMatchingSearchTerm = $elm$core$List$filter_fn($author$project$Data$MentionResult$searchStartsWith(request), person.lo);
        var textMatchScore = $elm$core$List$sum(_List_fromArray([
            $author$project$Util$Misc$if__fn(nameStartsWithQuery, 1, 0),
            $author$project$Util$Misc$if__fn($author$project$Data$MentionResult$searchContains_fn(request, person.b), 1, 0),
            $author$project$Util$Misc$if__fn(!$elm$core$List$isEmpty(emailsMatchingSearchTerm), 1, 0)
        ]));
        var email = $elm_community$maybe_extra$Maybe$Extra$orElse_fn($elm$core$List$head(person.lo), $elm$core$List$head(emailsMatchingSearchTerm));
        var attendeeScore = $author$project$Util$Misc$if__fn(personIsAttendee_ && ((request.dg === "") || nameStartsWithQuery), 1, 0);
        return _Utils_Tuple2({ gI: attendeeScore, jo: textMatchScore }, email);
    }, $author$project$Data$MentionResult$calculatePersonScore = F3($author$project$Data$MentionResult$calculatePersonScore_fn);
    var $author$project$Data$MentionResult$AttendeeIdentifiers_fn = function (emails, personIds) {
        return (new $$Record84(emails, personIds));
    }, $author$project$Data$MentionResult$AttendeeIdentifiers = F2($author$project$Data$MentionResult$AttendeeIdentifiers_fn);
    var $author$project$Data$MentionResult$extractAttendeeIds = function (note) {
        return $elm$core$List$foldl_fn_unwrapped(function (attendee, info) {
            var emails = info.dV;
            var personIds = info.ek;
            var _v0 = attendee.n3;
            if (!_v0.$) {
                var personId = _v0.a;
                return function () {
                    var $r = info.$c();
                    $r.ek = $elm$core$Set$insert_fn(personId, personIds);
                    return $r;
                }();
            }
            else {
                var email = _v0.a;
                return function () {
                    var $r = info.$c();
                    $r.dV = $elm$core$Set$insert_fn($elm$core$String$toLower(email), emails);
                    return $r;
                }();
            }
        }, $author$project$Data$MentionResult$AttendeeIdentifiers_fn($elm$core$Set$empty, $elm$core$Set$empty), note.ke);
    };
    var $author$project$Data$MentionResult$personSearch_fn = function (env, request, _v0) {
        var note = _v0.b;
        var attendeeIdentifiers = $author$project$Data$MentionResult$extractAttendeeIds(note);
        return A2($author$project$Firestore$Collection$filterMap, F2(function (personId, person) {
            var _v1 = $author$project$Data$MentionResult$calculatePersonScore_fn(attendeeIdentifiers, _Utils_Tuple2(personId, person), request);
            var attendeeScore = _v1.a.gI;
            var textMatchScore = _v1.a.jo;
            var email = _v1.b;
            var isCurrentUser = _Utils_eq(email, $elm$core$Maybe$map_fn(function ($) {
                return $.cS;
            }, env.pV));
            if ((!person.lh) && ((!isCurrentUser) && (!(!(attendeeScore + textMatchScore))))) {
                var personWeight = $elm$core$Maybe$withDefault_fn(0, $elm$core$Dict$get_fn(personId, env.oq.iz));
                return $elm$core$Maybe$Just({
                    a: $author$project$Data$MentionResult$MentionPersonData((new $$Record85(email, person.b, personId))),
                    bD: _Utils_Tuple3(attendeeScore, textMatchScore, personWeight),
                    bd: { cp: email, jn: person.b }
                });
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }), env.iz);
    }, $author$project$Data$MentionResult$personSearch = F3($author$project$Data$MentionResult$personSearch_fn);
    var $author$project$Util$Misc$sortByReverse = function (byField) {
        var flippedComparison = F2(function (a, b) {
            var _v0 = _Utils_compare_fn(byField(a), byField(b));
            switch (_v0) {
                case 0:
                    return 2;
                case 1:
                    return 1;
                default:
                    return 0;
            }
        });
        return $elm$core$List$sortWith(flippedComparison);
    };
    var $author$project$Data$MentionResult$generateSearchResult_fn = function (env, request) {
        return $elm$core$List$take_fn($author$project$Data$MentionResult$maxMentionables, A2($author$project$Util$Misc$sortByReverse, function ($) {
            return $.bD;
        }, function () {
            var _v0 = _Utils_Tuple2($author$project$Data$MentionResult$currentNote(env), request.ib);
            _v0$2: while (true) {
                if (!_v0.a.$) {
                    switch (_v0.b) {
                        case "@":
                            var noteData = _v0.a.a;
                            return $author$project$Data$MentionResult$personSearch_fn(env, request, noteData);
                        case "#":
                            var noteData = _v0.a.a;
                            return $author$project$Data$MentionResult$eventSearch_fn(env, request, noteData);
                        default:
                            break _v0$2;
                    }
                }
                else {
                    break _v0$2;
                }
            }
            return _List_Nil;
        }()));
    }, $author$project$Data$MentionResult$generateSearchResult = F2($author$project$Data$MentionResult$generateSearchResult_fn);
    var $justinmimbs$timezone_data$TimeZone$NoZoneName = { $: 0 };
    var $elm$core$Task$fail = _Scheduler_fail;
    var $elm$time$Time$getZoneName = _Time_getZoneName(0);
    var $author$project$Util$Time$getZone = _Scheduler_andThen_fn(function (nameOrOffset) {
        if (!nameOrOffset.$) {
            var zoneName = nameOrOffset.a;
            var _v1 = $elm$core$Dict$get_fn(zoneName, $author$project$Util$Time$zones);
            if (!_v1.$) {
                var zone = _v1.a;
                return $elm$core$Task$succeed(_Utils_Tuple2(zoneName, zone(0)));
            }
            else {
                return $elm$core$Task$fail($justinmimbs$timezone_data$TimeZone$NoDataForZoneName(zoneName));
            }
        }
        else {
            return $elm$core$Task$fail($justinmimbs$timezone_data$TimeZone$NoZoneName);
        }
    }, $elm$time$Time$getZoneName);
    var $author$project$Model$CalendarMsg = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Model$HomeMsg = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Analytics$KeyboardShortcut_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $author$project$Analytics$KeyboardShortcut = F2($author$project$Analytics$KeyboardShortcut_fn);
    var $author$project$Data$Dialog$Closeable$KeyboardShortcuts = { $: 4 };
    var $author$project$Model$ManyMsgs = function (a) {
        return { $: 49, a: a };
    };
    var $author$project$Model$ProfileMenuOpen = function (a) {
        return { $: 28, a: a };
    };
    var $author$project$Env$RouteToURLRequest = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Env$SetDialog = function (a) {
        return { $: 19, a: a };
    };
    var $author$project$Env$ShowSearch = function (a) {
        return { $: 28, a: a };
    };
    var $author$project$Env$UpdateSettings = function (a) {
        return { $: 14, a: a };
    };
    var $author$project$Routing$defaultThreadsParams = (new $$Record40(false, false));
    var $elm$browser$Browser$Navigation$back_fn = function (key, n) {
        return _Browser_go_fn(key, -n);
    }, $elm$browser$Browser$Navigation$back = F2($elm$browser$Browser$Navigation$back_fn);
    var $author$project$Page$Home$SetAgendaOffset = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Page$Home$handleEscapeKeypress = function (_v0) {
        var agendaOffset = _v0.U;
        return (!agendaOffset) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Page$Home$SetAgendaOffset(0));
    };
    var $author$project$Page$Note$ToggleZenMode = { $: 14 };
    var $author$project$Page$Note$handleEscapeKeypress = function (model) {
        return $author$project$Util$Misc$toJustIf_fn(model.aw, $author$project$Page$Note$ToggleZenMode);
    };
    var $author$project$Page$Person$UpdateEmailInput = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Page$Person$handleEscapeKeypress = function (model) {
        return $elm_community$maybe_extra$Maybe$Extra$isJust(model.u) ? $elm$core$Maybe$Just($author$project$Page$Person$UpdateEmailInput($elm$core$Maybe$Nothing)) : $elm$core$Maybe$Nothing;
    };
    var $author$project$Cmd$Keypress$handleEscapeKey = function (model) {
        var routeToPageWith = function (pageMsg) {
            return A2($elm$core$Basics$composeR, pageMsg, A2($elm$core$Basics$composeR, $author$project$Model$HandlePageMsg, $author$project$Util$Cmd$executeMsg));
        };
        var _v0 = _Utils_Tuple2(model.dW.na, model.ix);
        if (!_v0.a.$) {
            switch (_v0.b.$) {
                case 4:
                    var navKey = _v0.a.a;
                    var _v1 = _v0.b;
                    var subModel = _v1.b;
                    return _Utils_Tuple2(model, $elm$core$Maybe$withDefault_fn($elm$browser$Browser$Navigation$back_fn(navKey, 1), $elm$core$Maybe$map_fn(routeToPageWith($author$project$Model$NoteMsg), $author$project$Page$Note$handleEscapeKeypress(subModel))));
                case 0:
                    var subModel = _v0.b.a;
                    return _Utils_Tuple2(model, $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map_fn(routeToPageWith($author$project$Model$HomeMsg), $author$project$Page$Home$handleEscapeKeypress(subModel))));
                case 3:
                    var navKey = _v0.a.a;
                    var _v2 = _v0.b;
                    var subModel = _v2.b;
                    return _Utils_Tuple2(model, $elm$core$Maybe$withDefault_fn($elm$browser$Browser$Navigation$back_fn(navKey, 1), $elm$core$Maybe$map_fn(routeToPageWith($author$project$Model$PersonMsg), $author$project$Page$Person$handleEscapeKeypress(subModel))));
                default:
                    var navKey = _v0.a.a;
                    return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$back_fn(navKey, 1));
            }
        }
        else {
            var _v3 = _v0.a;
            return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
        }
    };
    var $author$project$Page$Calendar$AnalyticsEvent = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Page$Calendar$SetAgendaOffset = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$Shortcut$keys = (new $$Record86({ mC: "a", q: "Add new note", ox: "Add new note" }, { mC: "w", q: "Go to week\n    view", ox: "Week View" }, { mC: "t", q: "Go to today", ox: "Today" }, { mC: "m", q: "Go to current meeting", ox: "Current/next meeting" }, { mC: "t", q: "Go to this week", ox: "Current week" }, { mC: "z", q: "Enter zen mode", ox: "Enter zen mode" }, { mC: "z", q: "Exit zen mode", ox: "Exit zen mode" }, { mC: "esc", q: "Go back", ox: "Back" }, { mC: "d", q: "Go to day view", ox: "Day View" }, { mC: "n", q: "Go to next day", ox: "Next day" }, { mC: "n", q: "Go to next week", ox: "Next week" }, { mC: "p", q: "Go to previous day", ox: "Previous day" }, { mC: "p", q: "Go to previous week", ox: "Previous week" }, { mC: "\\", q: "Open profile menu", ox: "Profile menu" }, { mC: "/", q: "Search", ox: "Search" }, { mC: "s", q: "Go to settings", ox: "Settings" }, { mC: "?", q: "Show keyboard shortcuts", ox: "Show shortcuts" }, { mC: "i", q: "Go to threads", ox: "Threads" }, { mC: "v", q: "Join meeting video call", ox: "Join video call" }));
    var $author$project$Page$Calendar$handleKeypress_fn = function (keypress, model) {
        var sendAnalytic = A2($elm$core$Basics$composeR, $author$project$Analytics$KeyboardShortcut(keypress), $author$project$Page$Calendar$AnalyticsEvent);
        var _v0 = keypress.mC;
        switch (_v0) {
            case "j":
                return _List_fromArray([
                    $author$project$Page$Calendar$SetAgendaOffset(model.U + 1),
                    sendAnalytic($author$project$Data$Shortcut$keys.im)
                ]);
            case "k":
                return _List_fromArray([
                    $author$project$Page$Calendar$SetAgendaOffset(model.U - 1),
                    sendAnalytic($author$project$Data$Shortcut$keys.iI)
                ]);
            case "n":
                return _List_fromArray([
                    $author$project$Page$Calendar$SetAgendaOffset(model.U + 1),
                    sendAnalytic($author$project$Data$Shortcut$keys.im)
                ]);
            case "p":
                return _List_fromArray([
                    $author$project$Page$Calendar$SetAgendaOffset(model.U - 1),
                    sendAnalytic($author$project$Data$Shortcut$keys.iI)
                ]);
            case "ArrowRight":
                return _List_fromArray([
                    $author$project$Page$Calendar$SetAgendaOffset(model.U + 1),
                    sendAnalytic($author$project$Data$Shortcut$keys.im)
                ]);
            case "ArrowLeft":
                return _List_fromArray([
                    $author$project$Page$Calendar$SetAgendaOffset(model.U - 1),
                    sendAnalytic($author$project$Data$Shortcut$keys.iI)
                ]);
            case "t":
                return _List_fromArray([
                    $author$project$Page$Calendar$SetAgendaOffset(0),
                    sendAnalytic($author$project$Data$Shortcut$keys.g2)
                ]);
            default:
                return _List_Nil;
        }
    }, $author$project$Page$Calendar$handleKeypress = F2($author$project$Page$Calendar$handleKeypress_fn);
    var $author$project$Page$Home$AnalyticsEvent = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Page$Home$handleKeypress_fn = function (keypress, model) {
        var sendAnalytic = A2($elm$core$Basics$composeR, $author$project$Analytics$KeyboardShortcut(keypress), $author$project$Page$Home$AnalyticsEvent);
        var _v0 = keypress.mC;
        switch (_v0) {
            case "j":
                return _List_fromArray([
                    $author$project$Page$Home$SetAgendaOffset(model.U + 1),
                    sendAnalytic($author$project$Data$Shortcut$keys.il)
                ]);
            case "k":
                return _List_fromArray([
                    $author$project$Page$Home$SetAgendaOffset(model.U - 1),
                    sendAnalytic($author$project$Data$Shortcut$keys.iH)
                ]);
            case "n":
                return _List_fromArray([
                    $author$project$Page$Home$SetAgendaOffset(model.U + 1),
                    sendAnalytic($author$project$Data$Shortcut$keys.il)
                ]);
            case "p":
                return _List_fromArray([
                    $author$project$Page$Home$SetAgendaOffset(model.U - 1),
                    sendAnalytic($author$project$Data$Shortcut$keys.iH)
                ]);
            case "ArrowRight":
                return _List_fromArray([
                    $author$project$Page$Home$SetAgendaOffset(model.U + 1),
                    sendAnalytic($author$project$Data$Shortcut$keys.il)
                ]);
            case "ArrowLeft":
                return _List_fromArray([
                    $author$project$Page$Home$SetAgendaOffset(model.U - 1),
                    sendAnalytic($author$project$Data$Shortcut$keys.iH)
                ]);
            case "t":
                return _List_fromArray([
                    $author$project$Page$Home$SetAgendaOffset(0),
                    sendAnalytic($author$project$Data$Shortcut$keys.g0)
                ]);
            default:
                return _List_Nil;
        }
    }, $author$project$Page$Home$handleKeypress = F2($author$project$Page$Home$handleKeypress_fn);
    var $author$project$Page$Note$AnalyticsEvent = function (a) {
        return { $: 34, a: a };
    };
    var $author$project$Page$Note$OpenVideoCall = function (a) {
        return { $: 30, a: a };
    };
    var $author$project$Page$Note$handleKeypress_fn = function (model, noteId, keypress) {
        var sendAnalytic = A2($elm$core$Basics$composeR, $author$project$Analytics$KeyboardShortcut(keypress), $author$project$Page$Note$AnalyticsEvent);
        var _v0 = keypress.mC;
        switch (_v0) {
            case "z":
                return _List_fromArray([
                    $author$project$Page$Note$ToggleZenMode,
                    sendAnalytic($author$project$Util$Misc$if__fn(model.aw, $author$project$Data$Shortcut$keys.hk, $author$project$Data$Shortcut$keys.hd))
                ]);
            case "v":
                return _List_fromArray([
                    $author$project$Page$Note$OpenVideoCall(noteId),
                    sendAnalytic($author$project$Data$Shortcut$keys.jG)
                ]);
            default:
                return _List_Nil;
        }
    }, $author$project$Page$Note$handleKeypress = F3($author$project$Page$Note$handleKeypress_fn);
    var $author$project$View$ImageViewer$isDisplaying = function (model) {
        return !_Utils_eq(model, $author$project$View$ImageViewer$NotDisplayed);
    };
    var $author$project$Data$Dialog$NonCloseable$AccountCreationFailed = { $: 1 };
    var $author$project$Data$Dialog$NonCloseable$AppReloadRequired = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Data$Dialog$NonCloseable$Login = { $: 0 };
    var $author$project$Data$Dialog$NonCloseable$BillingIssue = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Data$Dialog$NonCloseable$ConnectingToStripe = { $: 2 };
    var $author$project$Data$Dialog$NonCloseable$OutOfBeta = 0;
    var $author$project$Data$Dialog$NonCloseable$PaymentProcessingFailure = 2;
    var $author$project$Data$Dialog$NonCloseable$ReferralGiftExpired = 1;
    var $author$project$Data$Subscription$isPaidOrGifted = function (subscription) {
        var _v0 = subscription.pv;
        var billingAccountStatus = _v0.e0;
        return !billingAccountStatus;
    };
    var $author$project$Data$Subscription$isActive_a0 = $elm$core$Maybe$map($author$project$Data$Subscription$isPaidOrGifted), $author$project$Data$Subscription$isActive_a1 = $elm$core$Maybe$withDefault(false), $author$project$Data$Subscription$isActive = A2($elm$core$Basics$composeR, $author$project$Data$Subscription$isActive_a0, $author$project$Data$Subscription$isActive_a1);
    var $author$project$Routing$isSignup = function (route) {
        if (route.$ === 13) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Data$Dialog$NonCloseable$aproposBillingDialog_fn = function (env, subscription) {
        var shouldShowExpiredDialog = (!$elm$core$Basics$composeR_fn($author$project$Data$Subscription$isActive_a0, $author$project$Data$Subscription$isActive_a1, $elm$core$Maybe$Just(subscription))) && (!$author$project$Routing$isSignup(env.oe));
        var mLoadingDialog = function () {
            var _v3 = env.db.o_;
            switch (_v3.$) {
                case 3:
                    return $elm$core$Maybe$Just($author$project$Data$Dialog$NonCloseable$ConnectingToStripe);
                case 1:
                    return $elm$core$Maybe$Just($author$project$Data$Dialog$NonCloseable$ConnectingToStripe);
                default:
                    return $elm$core$Maybe$Nothing;
            }
        }();
        var billingIssueContext = function () {
            var _v0 = env.db.kn;
            if (_v0.$ === 3) {
                var info = _v0.a;
                if (info.lV) {
                    return 2;
                }
                else {
                    var _v1 = info.hA;
                    _v1$2: while (true) {
                        if (!_v1.$) {
                            switch (_v1.a.$) {
                                case 1:
                                    var _v2 = _v1.a;
                                    return 0;
                                case 0:
                                    return 1;
                                default:
                                    break _v1$2;
                            }
                        }
                        else {
                            break _v1$2;
                        }
                    }
                    return 2;
                }
            }
            else {
                return 2;
            }
        }();
        var mBillingIssueDialog = $author$project$Util$Misc$toJustIf_fn(shouldShowExpiredDialog, $author$project$Data$Dialog$NonCloseable$BillingIssue(billingIssueContext));
        return $elm_community$maybe_extra$Maybe$Extra$orElse_fn(mBillingIssueDialog, mLoadingDialog);
    }, $author$project$Data$Dialog$NonCloseable$aproposBillingDialog = F2($author$project$Data$Dialog$NonCloseable$aproposBillingDialog_fn);
    var $author$project$Data$Dialog$NonCloseable$SubmittingFeedback = { $: 9 };
    var $author$project$Data$Dialog$NonCloseable$aproposFeedbackDialog = function (env) {
        var _v0 = env.db.lF;
        if (_v0.$ === 1) {
            return $elm$core$Maybe$Just($author$project$Data$Dialog$NonCloseable$SubmittingFeedback);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Data$Dialog$NonCloseable$PersonMergeFailed = { $: 7 };
    var $author$project$Data$Dialog$NonCloseable$PersonMergePending = { $: 6 };
    var $author$project$Data$Dialog$NonCloseable$aproposMergePersonDialog = function (env) {
        var _v0 = env.db.mY;
        switch (_v0.$) {
            case 1:
                return $elm$core$Maybe$Just($author$project$Data$Dialog$NonCloseable$PersonMergePending);
            case 2:
                return $elm$core$Maybe$Just($author$project$Data$Dialog$NonCloseable$PersonMergeFailed);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Data$Dialog$NonCloseable$apropos = function (env) {
        var _v0 = _Utils_Tuple3(env.j9, env.pX, env.pV);
        _v0$1: while (true) {
            if (!_v0.a.$) {
                var reloadReason = _v0.a.a;
                return $elm$core$Maybe$Just($author$project$Data$Dialog$NonCloseable$AppReloadRequired(reloadReason));
            }
            else {
                if (_v0.c.$ === 1) {
                    if (!_v0.b) {
                        break _v0$1;
                    }
                    else {
                        var _v2 = _v0.a;
                        var _v3 = _v0.c;
                        var _v4 = env.oe;
                        if ((_v4.$ === 13) && (!_v4.a.$)) {
                            var _v5 = _v4.a;
                            return $elm$core$Maybe$Nothing;
                        }
                        else {
                            return $elm$core$Maybe$Just($author$project$Data$Dialog$NonCloseable$Login);
                        }
                    }
                }
                else {
                    if (!_v0.b) {
                        break _v0$1;
                    }
                    else {
                        var _v6 = _v0.a;
                        var user = _v0.c.a;
                        var _v7 = user.o0;
                        if (_v7.$ === 1) {
                            var _v8 = env.db.kW;
                            if (_v8.$ === 2) {
                                return $elm$core$Maybe$Just($author$project$Data$Dialog$NonCloseable$AccountCreationFailed);
                            }
                            else {
                                return $elm$core$Maybe$Nothing;
                            }
                        }
                        else {
                            var subscription = _v7.a;
                            return $elm_community$maybe_extra$Maybe$Extra$orElse_fn($author$project$Data$Dialog$NonCloseable$aproposFeedbackDialog(env), $elm_community$maybe_extra$Maybe$Extra$orElse_fn($author$project$Data$Dialog$NonCloseable$aproposMergePersonDialog(env), $elm_community$maybe_extra$Maybe$Extra$orElse_fn($author$project$Data$Dialog$NonCloseable$aproposBillingDialog_fn(env, subscription), $elm$core$Maybe$Nothing)));
                        }
                    }
                }
            }
        }
        var _v1 = _v0.a;
        return $elm$core$Maybe$Nothing;
    };
    var $author$project$View$EmptyState$isActive = function (env) {
        var _v0 = $author$project$Data$Dialog$NonCloseable$apropos(env);
        if (!_v0.$) {
            switch (_v0.a.$) {
                case 6:
                    var _v1 = _v0.a;
                    return false;
                case 9:
                    var _v2 = _v0.a;
                    return false;
                default:
                    return true;
            }
        }
        else {
            return false;
        }
    };
    var $author$project$Data$Settings$keyboardShortcutsEnabled_a0 = $author$project$Data$Settings$get, $author$project$Data$Settings$keyboardShortcutsEnabled_a1 = function ($) {
        return $.cZ;
    }, $author$project$Data$Settings$keyboardShortcutsEnabled = A2($elm$core$Basics$composeR, $author$project$Data$Settings$keyboardShortcutsEnabled_a0, $author$project$Data$Settings$keyboardShortcutsEnabled_a1);
    var $author$project$Cmd$Keypress$keyboardShortcutsEnabled_fn = function (env, keypress) {
        return (!$author$project$View$EmptyState$isActive(env)) && ($elm$core$Basics$composeR_fn($author$project$Data$Settings$keyboardShortcutsEnabled_a0, $author$project$Data$Settings$keyboardShortcutsEnabled_a1, env) && ((!$author$project$Routing$isSignup(env.oe)) && ((!env.lQ) && ((!env.oz) && (!(($elm_community$maybe_extra$Maybe$Extra$isJust(env.e3) || $author$project$View$ImageViewer$isDisplaying(env.ft)) && (!(keypress.mC === "Escape"))))))));
    }, $author$project$Cmd$Keypress$keyboardShortcutsEnabled = F2($author$project$Cmd$Keypress$keyboardShortcutsEnabled_fn);
    var $author$project$Routing$isEntityCreationRoute = function (route) {
        switch (route.$) {
            case 4:
                return true;
            case 2:
                return true;
            case 8:
                return true;
            default:
                return false;
        }
    };
    var $elm$url$Url$Builder$toQueryPair = function (_v0) {
        var key = _v0.a;
        var value = _v0.b;
        return key + ("=" + value);
    };
    var $elm$url$Url$Builder$toQuery = function (parameters) {
        if (!parameters.b) {
            return "";
        }
        else {
            return "?" + $elm$core$String$join_fn("&", $elm$core$List$map_fn($elm$url$Url$Builder$toQueryPair, parameters));
        }
    };
    var $elm$url$Url$Builder$absolute_fn = function (pathSegments, parameters) {
        return "/" + ($elm$core$String$join_fn("/", pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
    }, $elm$url$Url$Builder$absolute = F2($elm$url$Url$Builder$absolute_fn);
    var $author$project$Data$Subscription$billingPeriodToString = function (billingPeriod) {
        if (!billingPeriod) {
            return "monthly";
        }
        else {
            return "yearly";
        }
    };
    var $author$project$Search$Query$categoryToString = function (category) {
        switch (category) {
            case 0:
                return "notes";
            case 1:
                return "people";
            default:
                return "attachments";
        }
    };
    var $author$project$Routing$dateAsRoute = function (date) {
        return _List_fromArray([
            $elm$core$String$fromInt($justinmimbs$date$Date$year(date)),
            $elm$core$String$fromInt($justinmimbs$date$Date$monthToNumber($elm$core$Basics$composeR_fn($justinmimbs$date$Date$month_a0, $justinmimbs$date$Date$month_a1, date))),
            $elm$core$String$fromInt($elm$core$Basics$composeR_fn($justinmimbs$date$Date$day_a0, $justinmimbs$date$Date$day_a1, date))
        ]);
    };
    var $author$project$Routing$noteTabToString = function (t) {
        switch (t) {
            case 0:
                return "w";
            case 1:
                return "p";
            case 2:
                return "a";
            default:
                return "s";
        }
    };
    var $elm$url$Url$Builder$QueryParameter_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$url$Url$Builder$QueryParameter = F2($elm$url$Url$Builder$QueryParameter_fn);
    var $elm$url$Url$percentEncode = _Url_percentEncode;
    var $elm$url$Url$Builder$string_fn = function (key, value) {
        return $elm$url$Url$Builder$QueryParameter_fn($elm$url$Url$percentEncode(key), $elm$url$Url$percentEncode(value));
    }, $elm$url$Url$Builder$string = F2($elm$url$Url$Builder$string_fn);
    var $author$project$Routing$queryBuilder_a0 = function (_v0) {
        var name = _v0.a;
        var mParam = _v0.b;
        return $elm$core$Maybe$map_fn(function (param) {
            return $elm$url$Url$Builder$string_fn(name, param);
        }, mParam);
    }, $author$project$Routing$queryBuilder = $elm$core$List$filterMap($author$project$Routing$queryBuilder_a0);
    var $author$project$Util$Time$toString_a0 = $elm$time$Time$posixToMillis, $author$project$Util$Time$toString_a1 = $elm$core$String$fromInt, $author$project$Util$Time$toString = A2($elm$core$Basics$composeR, $author$project$Util$Time$toString_a0, $author$project$Util$Time$toString_a1);
    var $author$project$Routing$pathFromRoute = function (route) {
        var fmtBool = function (b) {
            return b ? $elm$core$Maybe$Just("true") : $elm$core$Maybe$Nothing;
        };
        switch (route.$) {
            case 1:
                var oldestFirst = route.a.c6;
                var showCompleted = route.a.eG;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["threads"]), $elm$core$List$filterMap_fn($author$project$Routing$queryBuilder_a0, _List_fromArray([
                    _Utils_Tuple2("oldestFirst", fmtBool(oldestFirst)),
                    _Utils_Tuple2("showCompleted", fmtBool(showCompleted))
                ])));
            case 0:
                if (route.a.$ === 1) {
                    var _v1 = route.a;
                    return $elm$url$Url$Builder$absolute_fn(_List_Nil, _List_Nil);
                }
                else {
                    var date = route.a.a;
                    return $elm$url$Url$Builder$absolute_fn($author$project$Routing$dateAsRoute(date), _List_Nil);
                }
            case 2:
                var eventId = route.a;
                var mMasterId = route.b;
                var ref = route.c;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["notes", "create", eventId]), $elm$core$List$filterMap_fn($author$project$Routing$queryBuilder_a0, _List_fromArray([
                    _Utils_Tuple2("masterId", mMasterId),
                    _Utils_Tuple2("ref", ref)
                ])));
            case 3:
                var noteId = route.a;
                var eventId = route.b;
                var noteTab = route.c;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["notes", "new", noteId, eventId]), $elm$core$List$filterMap_fn($author$project$Routing$queryBuilder_a0, _List_fromArray([
                    _Utils_Tuple2("tab", $elm$core$Maybe$map_fn($author$project$Routing$noteTabToString, noteTab))
                ])));
            case 4:
                var mStartTime = route.a;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["notes", "create-ad-hoc"]), $elm$core$List$filterMap_fn($author$project$Routing$queryBuilder_a0, _List_fromArray([
                    _Utils_Tuple2("startTime", $elm$core$Maybe$map_fn($author$project$Util$Time$toString, mStartTime))
                ])));
            case 5:
                var noteId = route.a;
                var startTime = route.b;
                var noteTab = route.c;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray([
                    "notes",
                    "new-ad-hoc",
                    noteId,
                    $elm$core$Basics$composeR_fn($author$project$Util$Time$toString_a0, $author$project$Util$Time$toString_a1, startTime)
                ]), $elm$core$List$filterMap_fn($author$project$Routing$queryBuilder_a0, _List_fromArray([
                    _Utils_Tuple2("tab", $elm$core$Maybe$map_fn($author$project$Routing$noteTabToString, noteTab))
                ])));
            case 6:
                var noteId = route.a;
                var mActionItemId = route.b;
                var noteTab = route.c;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["notes", noteId]), $elm$core$List$filterMap_fn($author$project$Routing$queryBuilder_a0, _List_fromArray([
                    _Utils_Tuple2("highlight", mActionItemId),
                    _Utils_Tuple2("tab", $elm$core$Maybe$map_fn($author$project$Routing$noteTabToString, noteTab))
                ])));
            case 7:
                var nextMeeting = route.a;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["next"]), function () {
                    switch (nextMeeting.$) {
                        case 0:
                            var mPersonId = nextMeeting.a;
                            return $elm$core$List$filterMap_fn($author$project$Routing$queryBuilder_a0, _List_fromArray([
                                _Utils_Tuple2("personId", mPersonId)
                            ]));
                        case 1:
                            var masterId = nextMeeting.a;
                            return _List_fromArray([
                                $elm$url$Url$Builder$string_fn("masterId", masterId)
                            ]);
                        default:
                            var personId = nextMeeting.a;
                            return _List_fromArray([
                                $elm$url$Url$Builder$string_fn("personId", personId),
                                $elm$url$Url$Builder$string_fn("meetingType", "oneOnOne")
                            ]);
                    }
                }());
            case 9:
                var personId = route.a;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["people", personId]), _List_Nil);
            case 8:
                var newPerson = route.a;
                var buildQuery = function (_v3) {
                    var name = _v3.b;
                    var mEmail = _v3.fH;
                    var createdBy = _v3.k1;
                    return $elm$core$List$filterMap_fn($author$project$Routing$queryBuilder_a0, _List_fromArray([
                        _Utils_Tuple2("name", $elm$core$Maybe$Just(name)),
                        _Utils_Tuple2("email", mEmail),
                        _Utils_Tuple2("createdBy", $author$project$Data$Person$createdByToString(createdBy))
                    ]));
                };
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["people", "create"]), buildQuery(newPerson));
            case 19:
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["404"]), _List_Nil);
            case 11:
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["settings"]), _List_Nil);
            case 13:
                var signupStep = route.a;
                var _v4 = function () {
                    switch (signupStep.$) {
                        case 0:
                            var mGiftId = signupStep.a;
                            var mRef = signupStep.b;
                            var mBillingPeriod = signupStep.c;
                            return _Utils_Tuple2(_List_Nil, _List_fromArray([
                                _Utils_Tuple2("giftId", mGiftId),
                                _Utils_Tuple2("ref", mRef),
                                _Utils_Tuple2("plan", $elm$core$Maybe$map_fn($author$project$Data$Subscription$billingPeriodToString, mBillingPeriod))
                            ]));
                        case 1:
                            return _Utils_Tuple2(_List_fromArray(["choose-subscription"]), _List_Nil);
                        case 2:
                            var mLinkToken = signupStep.a;
                            return _Utils_Tuple2(_List_fromArray(["link"]), _List_fromArray([
                                _Utils_Tuple2("linkToken", mLinkToken)
                            ]));
                        case 3:
                            return _Utils_Tuple2(_List_fromArray(["link-calendar"]), _List_Nil);
                        case 4:
                            return _Utils_Tuple2(_List_fromArray(["watch"]), _List_Nil);
                        default:
                            return _Utils_Tuple2(_List_fromArray(["wizard"]), _List_Nil);
                    }
                }();
                var extraPath = _v4.a;
                var params = _v4.b;
                return $elm$url$Url$Builder$absolute_fn(_List_Cons("signup", extraPath), $elm$core$List$filterMap_fn($author$project$Routing$queryBuilder_a0, params));
            case 12:
                var mQuery = route.a;
                var mCategory = route.b;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["search"]), $elm$core$List$filterMap_fn($author$project$Routing$queryBuilder_a0, _List_fromArray([
                    _Utils_Tuple2("q", mQuery),
                    _Utils_Tuple2("category", $elm$core$Maybe$map_fn($author$project$Search$Query$categoryToString, mCategory))
                ])));
            case 10:
                if (!route.a.$) {
                    var date = route.a.a;
                    return $elm$url$Url$Builder$absolute_fn(_List_Cons("calendar", $author$project$Routing$dateAsRoute(date)), _List_Nil);
                }
                else {
                    var _v6 = route.a;
                    return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["calendar"]), _List_Nil);
                }
            case 16:
                switch (route.a.$) {
                    case 0:
                        var masterEventBaseId = route.a.a.h8;
                        var mCount = route.b;
                        return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["collate", "series", masterEventBaseId]), $elm$core$List$filterMap_fn($author$project$Routing$queryBuilder_a0, _List_fromArray([
                            _Utils_Tuple2("maxCount", $elm$core$Maybe$map_fn($elm$core$String$fromInt, mCount))
                        ])));
                    case 1:
                        var personId = route.a.a;
                        var mCount = route.b;
                        return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["collate", "person", personId]), $elm$core$List$filterMap_fn($author$project$Routing$queryBuilder_a0, _List_fromArray([
                            _Utils_Tuple2("maxCount", $elm$core$Maybe$map_fn($elm$core$String$fromInt, mCount))
                        ])));
                    default:
                        var domainName = route.a.a.g9;
                        var mCount = route.b;
                        return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["collate", "domain", domainName]), $elm$core$List$filterMap_fn($author$project$Routing$queryBuilder_a0, _List_fromArray([
                            _Utils_Tuple2("maxCount", $elm$core$Maybe$map_fn($elm$core$String$fromInt, mCount))
                        ])));
                }
            case 14:
                var success = route.a.o3;
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray([
                    "stripe",
                    success ? "succeeded" : "canceled"
                ]), _List_Nil);
            case 17:
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray([$author$project$Data$Auth$urlPath]), _List_Nil);
            case 18:
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["demo"]), _List_Nil);
            default:
                return $elm$url$Url$Builder$absolute_fn(_List_fromArray(["billing"]), _List_Nil);
        }
    };
    var $author$project$Routing$pushToHistory_fn = function (env, toRoute) {
        var _v0 = _Utils_Tuple2(env.oe, toRoute);
        _v0$12: while (true) {
            switch (_v0.a.$) {
                case 2:
                    var _v1 = _v0.a;
                    return false;
                case 4:
                    return false;
                case 8:
                    return false;
                case 17:
                    return false;
                case 1:
                    if (_v0.b.$ === 1) {
                        return false;
                    }
                    else {
                        break _v0$12;
                    }
                case 3:
                    switch (_v0.b.$) {
                        case 6:
                            var _v2 = _v0.a;
                            var noteId = _v2.a;
                            var _v3 = _v0.b;
                            var nextNoteId = _v3.a;
                            return !_Utils_eq(noteId, nextNoteId);
                        case 3:
                            var _v6 = _v0.a;
                            var noteId = _v6.a;
                            var _v7 = _v0.b;
                            var nextNoteId = _v7.a;
                            return !_Utils_eq(noteId, nextNoteId);
                        default:
                            break _v0$12;
                    }
                case 5:
                    switch (_v0.b.$) {
                        case 6:
                            var _v4 = _v0.a;
                            var noteId = _v4.a;
                            var _v5 = _v0.b;
                            var nextNoteId = _v5.a;
                            return !_Utils_eq(noteId, nextNoteId);
                        case 5:
                            var _v8 = _v0.a;
                            var noteId = _v8.a;
                            var _v9 = _v0.b;
                            var nextNoteId = _v9.a;
                            return !_Utils_eq(noteId, nextNoteId);
                        default:
                            break _v0$12;
                    }
                case 6:
                    if (_v0.b.$ === 6) {
                        var _v10 = _v0.a;
                        var noteId = _v10.a;
                        var _v11 = _v0.b;
                        var nextNoteId = _v11.a;
                        return !_Utils_eq(noteId, nextNoteId);
                    }
                    else {
                        break _v0$12;
                    }
                case 16:
                    if (_v0.b.$ === 16) {
                        var _v12 = _v0.a;
                        var fromCollation = _v12.a;
                        var _v13 = _v0.b;
                        var toCollation = _v13.a;
                        return !_Utils_eq(fromCollation, toCollation);
                    }
                    else {
                        break _v0$12;
                    }
                case 12:
                    if (_v0.b.$ === 12) {
                        var _v14 = _v0.a;
                        var _v15 = _v0.b;
                        return false;
                    }
                    else {
                        break _v0$12;
                    }
                default:
                    break _v0$12;
            }
        }
        return true;
    }, $author$project$Routing$pushToHistory = F2($author$project$Routing$pushToHistory_fn);
    var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
    var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
    var $author$project$Routing$reroute_fn = function (env, newRoute) {
        var _v0 = env.na;
        if (!_v0.$) {
            var key = _v0.a;
            return $author$project$Routing$isEntityCreationRoute(newRoute) ? $elm$core$Platform$Cmd$none : ($author$project$Routing$pushToHistory_fn(env, newRoute) ? _Browser_pushUrl_fn(key, $author$project$Routing$pathFromRoute(newRoute)) : _Browser_replaceUrl_fn(key, $author$project$Routing$pathFromRoute(newRoute)));
        }
        else {
            return $elm$core$Platform$Cmd$none;
        }
    }, $author$project$Routing$reroute = F2($author$project$Routing$reroute_fn);
    var $author$project$Util$Time$roundToMins_fn = function (amount, time) {
        var minsAmount = $author$project$Util$Time$minute * amount;
        var millis = $elm$time$Time$posixToMillis(time);
        var minutesChunk = _Basics_modBy_fn(minsAmount, millis);
        var halfWay = (minsAmount / 2) | 0;
        var newMillis = (_Utils_cmp(minutesChunk, halfWay) < 0) ? (millis - minutesChunk) : (millis + (minsAmount - minutesChunk));
        return $elm$time$Time$millisToPosix(newMillis);
    }, $author$project$Util$Time$roundToMins = F2($author$project$Util$Time$roundToMins_fn);
    var $justinmimbs$time_extra$Time$Extra$Minute = 13;
    var $author$project$Data$Time$isDate = function (time) {
        if (time.$ === 1) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Data$Meeting$ParentNote_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $author$project$Data$Meeting$ParentNote = F2($author$project$Data$Meeting$ParentNote_fn);
    var $author$project$Data$Meeting$ParentNoteless = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$Meeting$fromEvent_fn = function (zone, event, parentData) {
        return (new $$Record87(event.ew === 1, $author$project$Data$Time$toPosix_fn(zone, event.fh), $author$project$Data$Time$isDate(event.oN), parentData, $author$project$Data$Time$toPosix_fn(zone, event.oN), event.gj));
    }, $author$project$Data$Meeting$fromEvent = F3($author$project$Data$Meeting$fromEvent_fn);
    var $author$project$Data$Meeting$fromNote_fn = function (zone, noteId, note) {
        return (new $$Record87(false, $author$project$Data$Time$toPosix_fn(zone, note.gh), $author$project$Data$Time$isDate(note.gh), $author$project$Data$Meeting$ParentNote_fn(noteId, note), $author$project$Data$Time$toPosix_fn(zone, note.gh), $elm$core$Maybe$withDefault_fn(note.gj, note.lv)));
    }, $author$project$Data$Meeting$fromNote = F3($author$project$Data$Meeting$fromNote_fn);
    var $author$project$Data$Note$getEvent_fn = function (_v0, events) {
        var eventRef = _v0.hh;
        if (!eventRef.$) {
            if (!eventRef.a.$) {
                var eventId = eventRef.a.a.b7;
                return $elm$core$Dict$get_fn(eventId, events);
            }
            else {
                var instanceId = eventRef.a.a.Q;
                return $elm$core$Dict$get_fn(instanceId, events);
            }
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Data$Note$getEvent = F2($author$project$Data$Note$getEvent_fn);
    var $author$project$Data$Meeting$meetingsBy_fn = function (events, notes, zone, _v0) {
        var eventfulNoteFilter = _v0.cU;
        var adHocNoteFilter = _v0.cA;
        var eventFilter = _v0.cT;
        var _v1 = A3($author$project$Firestore$Collection$foldl, F3(function (noteId, note, _v2) {
            var meetings = _v2.a;
            var eventIds = _v2.b;
            var _v3 = $author$project$Data$Note$getEvent_fn(note, events);
            if (!_v3.$) {
                var event = _v3.a;
                return A2(eventfulNoteFilter, event, note) ? _Utils_Tuple2(_List_Cons($author$project$Data$Meeting$fromEvent_fn(zone, event, $author$project$Data$Meeting$ParentNote_fn(noteId, note)), meetings), $elm$core$Set$insert_fn(event.l8, eventIds)) : _Utils_Tuple2(meetings, eventIds);
            }
            else {
                return adHocNoteFilter(note) ? _Utils_Tuple2(_List_Cons($author$project$Data$Meeting$fromNote_fn(zone, noteId, note), meetings), eventIds) : _Utils_Tuple2(meetings, eventIds);
            }
        }), _Utils_Tuple2(_List_Nil, $elm$core$Set$empty), notes);
        var notesAndEventsWithNotes = _v1.a;
        var eventIdsShowingNotes = _v1.b;
        var showingNote = function (event) {
            return $elm$core$Set$member_fn(event.l8, eventIdsShowingNotes);
        };
        var newEventFilter = function (event) {
            return (!event.lh) && ((!$author$project$Data$Event$isMaster(event)) && ((!showingNote(event)) && eventFilter(event)));
        };
        var notelessEvents = $elm$core$List$filterMap_fn(function (event) {
            return newEventFilter(event) ? $elm$core$Maybe$Just($author$project$Data$Meeting$fromEvent_fn(zone, event, $author$project$Data$Meeting$ParentNoteless(event))) : $elm$core$Maybe$Nothing;
        }, $elm$core$Dict$values(events));
        return _List_sortBy_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.bF;
        }, $elm$time$Time$posixToMillis), _Utils_ap(notesAndEventsWithNotes, notelessEvents));
    }, $author$project$Data$Meeting$meetingsBy = F4($author$project$Data$Meeting$meetingsBy_fn);
    var $author$project$Data$Meeting$currentOrNextMeeting = function (env) {
        var toPosix = $author$project$Data$Time$toPosix(env.pu);
        var floor = A2($justinmimbs$time_extra$Time$Extra$floor, 11, env.pu);
        var currentDayStart = floor(env.k5);
        var afterTime = $justinmimbs$time_extra$Time$Extra$add_fn(13, 5, env.pu, env.k5);
        var eventFilter = function (_v1) {
            var startTime = _v1.oN;
            var endTime = _v1.fh;
            var responseStatus = _v1.ew;
            return (responseStatus !== 1) && ((!$author$project$Data$Time$isDate(startTime)) && ($author$project$Util$Time$isOnOrAfter_fn(afterTime, toPosix(endTime)) && _Utils_eq(floor(toPosix(startTime)), currentDayStart)));
        };
        return $elm$core$List$head($author$project$Data$Meeting$meetingsBy_fn(env.lw, env.fO, env.pu, {
            cA: function (_v0) {
                return false;
            },
            cT: function (event) {
                return eventFilter(event);
            },
            cU: F2(function (event, note) {
                return eventFilter(event) && (!note.lh);
            })
        }));
    };
    var $author$project$Data$Note$hasEvent = function (note) {
        return $elm_community$maybe_extra$Maybe$Extra$isJust(note.hh);
    };
    var $author$project$Data$Event$masterId = function (event) {
        var _v0 = event.pv;
        if (_v0.$ === 2) {
            var data = _v0.a;
            return $elm$core$Maybe$Just(data.mT);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Routing$meetingToRoute = function (_v0) {
        var parent = _v0.nJ;
        if (!parent.$) {
            var event = parent.a;
            return $author$project$Routing$RouteCreateEventNote_fn(event.l8, $author$project$Data$Event$masterId(event), $elm$core$Maybe$Nothing);
        }
        else {
            var noteId = parent.a;
            return $author$project$Routing$RouteNote_fn(noteId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
        }
    };
    var $author$project$Cmd$Keypress$routeToCurrentOrNextMeeting = function (env) {
        var mMeeting = $author$project$Data$Meeting$currentOrNextMeeting(env);
        var hasEvent = function (meeting) {
            var _v0 = meeting.nJ;
            if (_v0.$ === 1) {
                var note = _v0.b;
                return $author$project$Data$Note$hasEvent(note);
            }
            else {
                return true;
            }
        };
        return $elm$core$Maybe$map_fn($author$project$Routing$meetingToRoute, $elm_community$maybe_extra$Maybe$Extra$filter_fn(hasEvent, mMeeting));
    };
    var $author$project$Util$Cmd$when_fn = function (condition, cmd) {
        return condition ? cmd : $elm$core$Platform$Cmd$none;
    }, $author$project$Util$Cmd$when = F2($author$project$Util$Cmd$when_fn);
    var $elm$core$List$singleton = function (value) {
        return _List_fromArray([value]);
    };
    var $author$project$Util$Cmd$with = function (extraCmd) {
        return $elm$core$Tuple$mapSecond(A2($elm$core$Basics$composeR, $elm$core$List$singleton, A2($elm$core$Basics$composeR, $elm$core$List$cons(extraCmd), $elm$core$Platform$Cmd$batch)));
    };
    var $author$project$Cmd$Keypress$handle_fn = function (updateFunc, model, keypress) {
        var env = model.dW;
        var updateHelper = F2(function (toPageMsg, pageMsgs) {
            return function (msgs) {
                return A2(updateFunc, $author$project$Model$ManyMsgs(msgs), model);
            }($elm$core$List$map_fn(A2($elm$core$Basics$composeR, toPageMsg, $author$project$Model$HandlePageMsg), pageMsgs));
        });
        var setThemeDevOnly = function (theme) {
            return $author$project$Util$Cmd$when_fn(!$author$project$Data$App$isProd(env.mM), $author$project$Util$Cmd$executeMsg($author$project$Model$HandleBacktalk($author$project$Env$UpdateSettings(function (settings) {
                return $$update__pn(settings, theme);
            }))));
        };
        var setDialog = A2($elm$core$Basics$composeR, $author$project$Env$SetDialog, A2($elm$core$Basics$composeR, $author$project$Model$HandleBacktalk, $author$project$Util$Cmd$executeMsg));
        var sendAnalytic = A2($elm$core$Basics$composeR, $author$project$Analytics$KeyboardShortcut(keypress), A2($elm$core$Basics$composeR, $author$project$Env$AnalyticsEvent, A2($elm$core$Basics$composeR, $author$project$Model$HandleBacktalk, $author$project$Util$Cmd$executeMsg)));
        var routeToUrlRequest = A2($elm$core$Basics$composeR, $author$project$Env$RouteToURLRequest, A2($elm$core$Basics$composeR, $author$project$Model$HandleBacktalk, $author$project$Util$Cmd$executeMsg));
        var reroute = $author$project$Routing$reroute(env);
        if (!$author$project$Cmd$Keypress$keyboardShortcutsEnabled_fn(env, keypress)) {
            return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
        }
        else {
            var _v0 = _Utils_Tuple2(keypress.mC, model.ix);
            switch (_v0.a) {
                case "Escape":
                    return $elm_community$maybe_extra$Maybe$Extra$isJust(env.e3) ? _Utils_Tuple2(model, setDialog($elm$core$Maybe$Nothing)) : (env.iO ? A2(updateFunc, $author$project$Model$ProfileMenuOpen(false), model) : ($author$project$View$ImageViewer$isDisplaying(env.ft) ? _Utils_Tuple2($$update__dW(model, $$update__ft(env, $author$project$View$ImageViewer$hide)), $elm$core$Platform$Cmd$none) : $author$project$Cmd$Keypress$handleEscapeKey(model)));
                case "/":
                    return A2($author$project$Util$Cmd$with, sendAnalytic($author$project$Data$Shortcut$keys.f0), A2(updateFunc, $author$project$Model$HandleBacktalk($author$project$Env$ShowSearch(true)), model));
                case "d":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        reroute($author$project$Routing$RouteHome($elm$core$Maybe$Nothing)),
                        sendAnalytic($author$project$Data$Shortcut$keys.hJ)
                    ])));
                case "w":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        reroute($author$project$Routing$RouteCalendar($elm$core$Maybe$Nothing)),
                        sendAnalytic($author$project$Data$Shortcut$keys.gV)
                    ])));
                case "h":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        reroute($author$project$Routing$RouteHome($elm$core$Maybe$Nothing)),
                        sendAnalytic($author$project$Data$Shortcut$keys.hJ)
                    ])));
                case "c":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        reroute($author$project$Routing$RouteCalendar($elm$core$Maybe$Nothing)),
                        sendAnalytic($author$project$Data$Shortcut$keys.gV)
                    ])));
                case "i":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        reroute($author$project$Routing$RouteThreads($author$project$Routing$defaultThreadsParams)),
                        sendAnalytic($author$project$Data$Shortcut$keys.po)
                    ])));
                case "m":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Util$Cmd$whenJust_fn($author$project$Cmd$Keypress$routeToCurrentOrNextMeeting(env), routeToUrlRequest),
                        sendAnalytic($author$project$Data$Shortcut$keys.k4)
                    ])));
                case "a":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        routeToUrlRequest($author$project$Routing$RouteCreateAdHocNote($elm$core$Maybe$Just($author$project$Util$Time$roundToMins_fn(5, env.k5)))),
                        sendAnalytic($author$project$Data$Shortcut$keys.jV)
                    ])));
                case "s":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        reroute($author$project$Routing$RouteSettings),
                        sendAnalytic($author$project$Data$Shortcut$keys.be)
                    ])));
                case "\\":
                    return A2($author$project$Util$Cmd$with, sendAnalytic($author$project$Data$Shortcut$keys.bb), A2(updateFunc, $author$project$Model$ProfileMenuOpen(!env.iO), model));
                case "?":
                    return _Utils_Tuple2(model, function () {
                        var _v1 = model.dW.e3;
                        if (!_v1.$) {
                            if (_v1.a.$ === 4) {
                                var _v2 = _v1.a;
                                return setDialog($elm$core$Maybe$Nothing);
                            }
                            else {
                                return $elm$core$Platform$Cmd$none;
                            }
                        }
                        else {
                            return $elm$core$Platform$Cmd$batch(_List_fromArray([
                                setDialog($elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$KeyboardShortcuts)),
                                sendAnalytic($author$project$Data$Shortcut$keys.oB)
                            ]));
                        }
                    }());
                case "1":
                    return _Utils_Tuple2(model, setThemeDevOnly(0));
                case "2":
                    return _Utils_Tuple2(model, setThemeDevOnly(2));
                case "3":
                    return _Utils_Tuple2(model, setThemeDevOnly(3));
                case "4":
                    return _Utils_Tuple2(model, setThemeDevOnly(4));
                case "5":
                    return _Utils_Tuple2(model, setThemeDevOnly(1));
                default:
                    switch (_v0.b.$) {
                        case 0:
                            var subModel = _v0.b.a;
                            return A2(updateHelper, $author$project$Model$HomeMsg, $author$project$Page$Home$handleKeypress_fn(keypress, subModel));
                        case 5:
                            var subModel = _v0.b.a;
                            return A2(updateHelper, $author$project$Model$CalendarMsg, $author$project$Page$Calendar$handleKeypress_fn(keypress, subModel));
                        case 4:
                            var _v3 = _v0.b;
                            var noteId = _v3.a;
                            var subModel = _v3.b;
                            return A2(updateHelper, $author$project$Model$NoteMsg, $author$project$Page$Note$handleKeypress_fn(subModel, noteId, keypress));
                        default:
                            return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    }
            }
        }
    }, $author$project$Cmd$Keypress$handle_fn_unwrapped = function (updateFunc, model, keypress) {
        var env = model.dW;
        var updateHelper = F2(function (toPageMsg, pageMsgs) {
            return function (msgs) {
                return updateFunc($author$project$Model$ManyMsgs(msgs), model);
            }($elm$core$List$map_fn(A2($elm$core$Basics$composeR, toPageMsg, $author$project$Model$HandlePageMsg), pageMsgs));
        });
        var setThemeDevOnly = function (theme) {
            return $author$project$Util$Cmd$when_fn(!$author$project$Data$App$isProd(env.mM), $author$project$Util$Cmd$executeMsg($author$project$Model$HandleBacktalk($author$project$Env$UpdateSettings(function (settings) {
                return $$update__pn(settings, theme);
            }))));
        };
        var setDialog = A2($elm$core$Basics$composeR, $author$project$Env$SetDialog, A2($elm$core$Basics$composeR, $author$project$Model$HandleBacktalk, $author$project$Util$Cmd$executeMsg));
        var sendAnalytic = A2($elm$core$Basics$composeR, $author$project$Analytics$KeyboardShortcut(keypress), A2($elm$core$Basics$composeR, $author$project$Env$AnalyticsEvent, A2($elm$core$Basics$composeR, $author$project$Model$HandleBacktalk, $author$project$Util$Cmd$executeMsg)));
        var routeToUrlRequest = A2($elm$core$Basics$composeR, $author$project$Env$RouteToURLRequest, A2($elm$core$Basics$composeR, $author$project$Model$HandleBacktalk, $author$project$Util$Cmd$executeMsg));
        var reroute = $author$project$Routing$reroute(env);
        if (!$author$project$Cmd$Keypress$keyboardShortcutsEnabled_fn(env, keypress)) {
            return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
        }
        else {
            var _v0 = _Utils_Tuple2(keypress.mC, model.ix);
            switch (_v0.a) {
                case "Escape":
                    return $elm_community$maybe_extra$Maybe$Extra$isJust(env.e3) ? _Utils_Tuple2(model, setDialog($elm$core$Maybe$Nothing)) : (env.iO ? updateFunc($author$project$Model$ProfileMenuOpen(false), model) : ($author$project$View$ImageViewer$isDisplaying(env.ft) ? _Utils_Tuple2($$update__dW(model, $$update__ft(env, $author$project$View$ImageViewer$hide)), $elm$core$Platform$Cmd$none) : $author$project$Cmd$Keypress$handleEscapeKey(model)));
                case "/":
                    return A2($author$project$Util$Cmd$with, sendAnalytic($author$project$Data$Shortcut$keys.f0), updateFunc($author$project$Model$HandleBacktalk($author$project$Env$ShowSearch(true)), model));
                case "d":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        reroute($author$project$Routing$RouteHome($elm$core$Maybe$Nothing)),
                        sendAnalytic($author$project$Data$Shortcut$keys.hJ)
                    ])));
                case "w":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        reroute($author$project$Routing$RouteCalendar($elm$core$Maybe$Nothing)),
                        sendAnalytic($author$project$Data$Shortcut$keys.gV)
                    ])));
                case "h":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        reroute($author$project$Routing$RouteHome($elm$core$Maybe$Nothing)),
                        sendAnalytic($author$project$Data$Shortcut$keys.hJ)
                    ])));
                case "c":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        reroute($author$project$Routing$RouteCalendar($elm$core$Maybe$Nothing)),
                        sendAnalytic($author$project$Data$Shortcut$keys.gV)
                    ])));
                case "i":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        reroute($author$project$Routing$RouteThreads($author$project$Routing$defaultThreadsParams)),
                        sendAnalytic($author$project$Data$Shortcut$keys.po)
                    ])));
                case "m":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Util$Cmd$whenJust_fn($author$project$Cmd$Keypress$routeToCurrentOrNextMeeting(env), routeToUrlRequest),
                        sendAnalytic($author$project$Data$Shortcut$keys.k4)
                    ])));
                case "a":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        routeToUrlRequest($author$project$Routing$RouteCreateAdHocNote($elm$core$Maybe$Just($author$project$Util$Time$roundToMins_fn(5, env.k5)))),
                        sendAnalytic($author$project$Data$Shortcut$keys.jV)
                    ])));
                case "s":
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        reroute($author$project$Routing$RouteSettings),
                        sendAnalytic($author$project$Data$Shortcut$keys.be)
                    ])));
                case "\\":
                    return A2($author$project$Util$Cmd$with, sendAnalytic($author$project$Data$Shortcut$keys.bb), updateFunc($author$project$Model$ProfileMenuOpen(!env.iO), model));
                case "?":
                    return _Utils_Tuple2(model, function () {
                        var _v1 = model.dW.e3;
                        if (!_v1.$) {
                            if (_v1.a.$ === 4) {
                                var _v2 = _v1.a;
                                return setDialog($elm$core$Maybe$Nothing);
                            }
                            else {
                                return $elm$core$Platform$Cmd$none;
                            }
                        }
                        else {
                            return $elm$core$Platform$Cmd$batch(_List_fromArray([
                                setDialog($elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$KeyboardShortcuts)),
                                sendAnalytic($author$project$Data$Shortcut$keys.oB)
                            ]));
                        }
                    }());
                case "1":
                    return _Utils_Tuple2(model, setThemeDevOnly(0));
                case "2":
                    return _Utils_Tuple2(model, setThemeDevOnly(2));
                case "3":
                    return _Utils_Tuple2(model, setThemeDevOnly(3));
                case "4":
                    return _Utils_Tuple2(model, setThemeDevOnly(4));
                case "5":
                    return _Utils_Tuple2(model, setThemeDevOnly(1));
                default:
                    switch (_v0.b.$) {
                        case 0:
                            var subModel = _v0.b.a;
                            return A2(updateHelper, $author$project$Model$HomeMsg, $author$project$Page$Home$handleKeypress_fn(keypress, subModel));
                        case 5:
                            var subModel = _v0.b.a;
                            return A2(updateHelper, $author$project$Model$CalendarMsg, $author$project$Page$Calendar$handleKeypress_fn(keypress, subModel));
                        case 4:
                            var _v3 = _v0.b;
                            var noteId = _v3.a;
                            var subModel = _v3.b;
                            return A2(updateHelper, $author$project$Model$NoteMsg, $author$project$Page$Note$handleKeypress_fn(subModel, noteId, keypress));
                        default:
                            return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    }
            }
        }
    }, $author$project$Cmd$Keypress$handle = F3($author$project$Cmd$Keypress$handle_fn);
    var $author$project$Analytics$CloseableDialogSet = function (a) {
        return { $: 69, a: a };
    };
    var $author$project$Analytics$GA_OnboardingComplete = 2;
    var $author$project$Env$ImageViewerMsg = function (a) {
        return { $: 21, a: a };
    };
    var $author$project$Error$ImpossibleState = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Analytics$PersonAdHocCreated = { $: 46 };
    var $author$project$Error$RouteToURLRequestIsNothing = { $: 1 };
    var $author$project$Env$SaveNotes = { $: 5 };
    var $author$project$Env$SavePeople = { $: 12 };
    var $author$project$Analytics$SignupCompleted = { $: 63 };
    var $author$project$Env$SnackbarMsg = function (a) {
        return { $: 24, a: a };
    };
    var $author$project$Env$AttachmentThumbnailUrlReceived_fn = function (a, b) {
        return { $: 9, a: a, b: b };
    }, $author$project$Env$AttachmentThumbnailUrlReceived = F2($author$project$Env$AttachmentThumbnailUrlReceived_fn);
    var $author$project$Util$Request$attachmentThumbnailUrlFunctionName = "attachment_thumbnail_url";
    var $elm$http$Http$jsonBody = function (value) {
        return _Http_pair_fn("application/json", _Json_encode_fn(0, value));
    };
    var $author$project$Util$Request$attachmentThumbnailUrl = function (_v0) {
        var firebaseUserAuthToken = _v0.b9;
        var attachmentStoragePath = _v0.gH;
        var noteId = _v0.ip;
        return $author$project$Util$Request$authedHttpPost((new $$Record82(firebaseUserAuthToken, $elm$core$Maybe$Just($elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("storagePath", $elm$json$Json$Encode$string(attachmentStoragePath))
        ])))), $elm$http$Http$expectJson_fn(A2($elm$core$Basics$composeR, $author$project$Env$AttachmentThumbnailUrlReceived({ gH: attachmentStoragePath, ip: noteId }), $author$project$Model$HandleBacktalk), _Json_decodeField_fn("thumbnailUrl", $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))), _List_Nil, $author$project$Util$Request$attachmentThumbnailUrlFunctionName, $elm$core$Maybe$Just($author$project$Util$Request$defaultRequestTimeout))));
    };
    var $author$project$Data$StorageUpload$cancelUpload = _Platform_outgoingPort("cancelUpload", $elm$core$Basics$identity);
    var $author$project$Data$StorageUpload$removeFromTrackerHelp_fn = function (entityId, storagePath, tracker) {
        return $elm$core$Dict$update_fn(entityId, $elm$core$Maybe$map($elm$core$Dict$remove(storagePath)), tracker);
    }, $author$project$Data$StorageUpload$removeFromTrackerHelp = F3($author$project$Data$StorageUpload$removeFromTrackerHelp_fn);
    var $author$project$Data$StorageUpload$cancel_fn = function (entityId, storagePath, _v0) {
        var tracker = _v0;
        return _Utils_Tuple2($author$project$Data$StorageUpload$removeFromTrackerHelp_fn(entityId, storagePath, tracker), $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.fD;
        }, A2($elm$core$Basics$composeR, function ($) {
            return $.dJ;
        }, $author$project$Data$StorageUpload$cancelUpload)), $elm$core$Maybe$andThen_fn($elm$core$Dict$get(storagePath), $elm$core$Dict$get_fn(entityId, tracker)))));
    }, $author$project$Data$StorageUpload$cancel = F3($author$project$Data$StorageUpload$cancel_fn);
    var $author$project$Data$Note$debounceId = "notes";
    var $author$project$Data$Person$debounceId = "people";
    var $author$project$View$Shortcut$focusPoint = "keyboard-shortcut-dialog-unfocusser";
    var $elm$core$Maybe$destruct_fn = function (_default, func, maybe) {
        if (!maybe.$) {
            var a = maybe.a;
            return func(a);
        }
        else {
            return _default;
        }
    }, $elm$core$Maybe$destruct = F3($elm$core$Maybe$destruct_fn);
    var $author$project$Ports$toggleActionItem = _Platform_outgoingPort("toggleActionItem", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("actionItem", $elm$core$Basics$identity($.jR)),
            _Utils_Tuple2("slateDoc", $elm$json$Json$Encode$string($.f6)),
            _Utils_Tuple2("toggledFrom", function ($) {
                return $elm$core$Maybe$destruct_fn($elm$json$Json$Encode$null, function ($) {
                    return $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2("eventId", $elm$json$Json$Encode$string($.b7)),
                        _Utils_Tuple2("masterId", function ($) {
                            return $elm$core$Maybe$destruct_fn($elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
                        }($.mT)),
                        _Utils_Tuple2("startTime", $elm$json$Json$Encode$int($.oN)),
                        _Utils_Tuple2("title", $elm$json$Json$Encode$string($.gj))
                    ]));
                }, $);
            }($.pD))
        ]));
    });
    var $author$project$Update$ToggleActionItem$handler_fn = function (env, mToggledFromNoteId, oldActionItem) {
        var mToggledFrom = $elm$core$Maybe$andThen_fn(function (note) {
            var _v0 = note.hh;
            if (!_v0.$) {
                if (_v0.a.$ === 1) {
                    var instanceId = _v0.a.a.Q;
                    var masterId = _v0.a.a.mT;
                    return $elm$core$Maybe$Just((new $$Record88(instanceId, $elm$core$Maybe$Just(masterId), $author$project$Data$Time$toMillis_fn(env.pu, note.gh), note.gj)));
                }
                else {
                    var eventId = _v0.a.a.b7;
                    return $elm$core$Maybe$Just((new $$Record88(eventId, $elm$core$Maybe$Nothing, $author$project$Data$Time$toMillis_fn(env.pu, note.gh), note.gj)));
                }
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, $elm$core$Maybe$andThen_fn(function (toggledFromNoteId) {
            return $author$project$Firestore$Collection$get_fn(toggledFromNoteId, env.fO);
        }, mToggledFromNoteId));
        return _Utils_Tuple2(env, $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map_fn(function (note) {
            return $author$project$Ports$toggleActionItem((new $$Record89($author$project$Data$ActionItem$encode(oldActionItem), note.f6, mToggledFrom)));
        }, $author$project$Firestore$Collection$get_fn(oldActionItem.ip, env.fO))));
    }, $author$project$Update$ToggleActionItem$handler = F3($author$project$Update$ToggleActionItem$handler_fn);
    var $author$project$View$ImageViewer$Displayed = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$View$ImageViewer$init = function (imageUrl) {
        return $author$project$View$ImageViewer$Displayed((new $$Record90(imageUrl, $elm$core$Maybe$Nothing, 0)));
    };
    var $author$project$Routing$isSearch = function (route) {
        if (route.$ === 12) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Ports$linkCalendar = _Platform_outgoingPort("linkCalendar", $elm$json$Json$Encode$bool);
    var $author$project$Ports$mergePersons = _Platform_outgoingPort("mergePersons", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("primaryPersonId", $elm$json$Json$Encode$string($.iL)),
            _Utils_Tuple2("secondaryPersonId", $elm$json$Json$Encode$string($.f1))
        ]));
    });
    var $elm$core$String$fromList = _String_fromList;
    var $author$project$Util$Text$capitalize = function (word) {
        var _v0 = $elm$core$String$toList(word);
        if (!_v0.b) {
            return "";
        }
        else {
            var x = _v0.a;
            var xs = _v0.b;
            return _Utils_ap($elm$core$String$toUpper($elm$core$String$fromChar(x)), $elm$core$String$fromList(xs));
        }
    };
    var $author$project$Util$Text$nameFromEmail = function (email) {
        return $elm$core$String$join_fn(" ", $elm$core$List$map_fn($author$project$Util$Text$capitalize, $elm$core$String$split_fn(".", $elm$core$Maybe$withDefault_fn("", $elm$core$List$head($elm$core$String$split_fn("@", email))))));
    };
    var $author$project$Data$Person$default = function (newPerson) {
        var name = (!$elm$core$String$isEmpty(newPerson.b)) ? newPerson.b : $elm$core$Maybe$withDefault_fn("New Person", $elm$core$Maybe$map_fn($author$project$Util$Text$nameFromEmail, newPerson.fH));
        return (new $$Record33("", $author$project$Data$Timestamp$serverTimestamp, newPerson.k1, false, $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$String$toLower, A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$List$singleton)), newPerson.fH)), $elm$core$Maybe$Nothing, name, _List_Nil, 0, _List_Nil, $author$project$Data$Slate$emptyDoc, $author$project$Data$Timestamp$serverTimestamp));
    };
    var $elm$random$Random$Generator = $elm$core$Basics$identity;
    var $elm$random$Random$andThen_fn = function (callback, _v0) {
        var genA = _v0;
        return function (seed) {
            var _v1 = genA(seed);
            var result = _v1.a;
            var newSeed = _v1.b;
            var _v2 = callback(result);
            var genB = _v2;
            return genB(newSeed);
        };
    }, $elm$random$Random$andThen = F2($elm$random$Random$andThen_fn);
    var $elm$core$Bitwise$xor = _Bitwise_xor;
    var $elm$random$Random$peel = function (_v0) {
        var state = _v0.a;
        var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
        return ((word >>> 22) ^ word) >>> 0;
    };
    var $elm$random$Random$float_fn = function (a, b) {
        return function (seed0) {
            var seed1 = $elm$random$Random$next(seed0);
            var range = $elm$core$Basics$abs(b - a);
            var n1 = $elm$random$Random$peel(seed1);
            var n0 = $elm$random$Random$peel(seed0);
            var lo = (134217727 & n1) * 1;
            var hi = (67108863 & n0) * 1;
            var val = ((hi * 134217728) + lo) / 9007199254740992;
            var scaled = (val * range) + a;
            return _Utils_Tuple2(scaled, $elm$random$Random$next(seed1));
        };
    }, $elm$random$Random$float = F2($elm$random$Random$float_fn);
    var $elm_community$random_extra$Random$Extra$frequency_fn = function (head, pairs) {
        var total = $elm$core$List$sum($elm$core$List$map_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$abs, $elm$core$Tuple$first), _List_Cons(head, pairs)));
        var pick = F2(function (someChoices, n) {
            pick: while (true) {
                if (someChoices.b) {
                    var _v1 = someChoices.a;
                    var k = _v1.a;
                    var g = _v1.b;
                    var rest = someChoices.b;
                    if (_Utils_cmp(n, k) < 1) {
                        return g;
                    }
                    else {
                        var $temp$someChoices = rest, $temp$n = n - k;
                        someChoices = $temp$someChoices;
                        n = $temp$n;
                        continue pick;
                    }
                }
                else {
                    return head.b;
                }
            }
        });
        return $elm$random$Random$andThen_fn(pick(_List_Cons(head, pairs)), $elm$random$Random$float_fn(0, total));
    }, $elm_community$random_extra$Random$Extra$frequency = F2($elm_community$random_extra$Random$Extra$frequency_fn);
    var $elm_community$random_extra$Random$Extra$choices_fn = function (hd, gens) {
        return $elm_community$random_extra$Random$Extra$frequency_fn(_Utils_Tuple2(1, hd), $elm$core$List$map_fn(function (g) {
            return _Utils_Tuple2(1, g);
        }, gens));
    }, $elm_community$random_extra$Random$Extra$choices = F2($elm_community$random_extra$Random$Extra$choices_fn);
    var $elm$random$Random$int_fn = function (a, b) {
        return function (seed0) {
            var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
            var lo = _v0.a;
            var hi = _v0.b;
            var range = (hi - lo) + 1;
            if (!((range - 1) & range)) {
                return _Utils_Tuple2((((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo, $elm$random$Random$next(seed0));
            }
            else {
                var threshhold = (((-range) >>> 0) % range) >>> 0;
                var accountForBias = function (seed) {
                    accountForBias: while (true) {
                        var x = $elm$random$Random$peel(seed);
                        var seedN = $elm$random$Random$next(seed);
                        if (_Utils_cmp(x, threshhold) < 0) {
                            var $temp$seed = seedN;
                            seed = $temp$seed;
                            continue accountForBias;
                        }
                        else {
                            return _Utils_Tuple2((x % range) + lo, seedN);
                        }
                    }
                };
                return accountForBias(seed0);
            }
        };
    }, $elm$random$Random$int = F2($elm$random$Random$int_fn);
    var $elm$random$Random$map_fn = function (func, _v0) {
        var genA = _v0;
        return function (seed0) {
            var _v1 = genA(seed0);
            var a = _v1.a;
            var seed1 = _v1.b;
            return _Utils_Tuple2(func(a), seed1);
        };
    }, $elm$random$Random$map = F2($elm$random$Random$map_fn);
    var $elm_community$random_extra$Random$Char$char_fn = function (start, end) {
        return $elm$random$Random$map_fn($elm$core$Char$fromCode, $elm$random$Random$int_fn(start, end));
    }, $elm_community$random_extra$Random$Char$char = F2($elm_community$random_extra$Random$Char$char_fn);
    var $author$project$Lib$UID$lowerCase = $elm_community$random_extra$Random$Char$char_fn(97, 122);
    var $author$project$Lib$UID$numChar = $elm_community$random_extra$Random$Char$char_fn(48, 57);
    var $author$project$Lib$UID$pieceLength = 5;
    var $elm$random$Random$listHelp_fn = function (revList, n, gen, seed) {
        listHelp: while (true) {
            if (n < 1) {
                return _Utils_Tuple2(revList, seed);
            }
            else {
                var _v0 = gen(seed);
                var value = _v0.a;
                var newSeed = _v0.b;
                var $temp$revList = _List_Cons(value, revList), $temp$n = n - 1, $temp$gen = gen, $temp$seed = newSeed;
                revList = $temp$revList;
                n = $temp$n;
                gen = $temp$gen;
                seed = $temp$seed;
                continue listHelp;
            }
        }
    }, $elm$random$Random$listHelp = F4($elm$random$Random$listHelp_fn);
    var $elm$random$Random$list_fn = function (n, _v0) {
        var gen = _v0;
        return function (seed) {
            return $elm$random$Random$listHelp_fn(_List_Nil, n, gen, seed);
        };
    }, $elm$random$Random$list = F2($elm$random$Random$list_fn);
    var $elm_community$random_extra$Random$String$string_fn = function (stringLength, charGenerator) {
        return $elm$random$Random$map_fn($elm$core$String$fromList, $elm$random$Random$list_fn(stringLength, charGenerator));
    }, $elm_community$random_extra$Random$String$string = F2($elm_community$random_extra$Random$String$string_fn);
    var $author$project$Lib$UID$upperCase = $elm_community$random_extra$Random$Char$char_fn(65, 90);
    var $author$project$Lib$UID$alphaNumeric = $elm_community$random_extra$Random$String$string_fn($author$project$Lib$UID$pieceLength, $elm_community$random_extra$Random$Extra$choices_fn($author$project$Lib$UID$numChar, _List_fromArray([$author$project$Lib$UID$lowerCase, $author$project$Lib$UID$upperCase])));
    var $elm$core$Tuple$mapFirst_fn = function (func, _v0) {
        var x = _v0.a;
        var y = _v0.b;
        return _Utils_Tuple2(func(x), y);
    }, $elm$core$Tuple$mapFirst = F2($elm$core$Tuple$mapFirst_fn);
    var $elm$random$Random$step_fn = function (_v0, seed) {
        var generator = _v0;
        return generator(seed);
    }, $elm$random$Random$step = F2($elm$random$Random$step_fn);
    var $elm$core$List$unzip = function (pairs) {
        var aHead = _List_Cons(undefined, _List_Nil);
        var bHead = _List_Cons(undefined, _List_Nil);
        var aEnd = aHead;
        var bEnd = bHead;
        for (; pairs.b; pairs = pairs.b) {
            var tuple = pairs.a;
            var aNext = _List_Cons(tuple.a, _List_Nil);
            aEnd.b = aNext;
            aEnd = aNext;
            var bNext = _List_Cons(tuple.b, _List_Nil);
            bEnd.b = bNext;
            bEnd = bNext;
        }
        return _Utils_Tuple2(aHead.b, bHead.
            b);
    };
    var $author$project$Lib$UID$generate = function (_v0) {
        var seed = _v0;
        return $elm$core$Tuple$mapSecond_fn($elm$core$Basics$identity, $elm$core$Tuple$mapFirst_fn($elm$core$String$join(""), $elm$core$List$unzip($elm$core$List$map_fn($elm$random$Random$step($author$project$Lib$UID$alphaNumeric), seed))));
    };
    var $author$project$Firestore$Collection$insert_fn = function (id, doc, _v0) {
        var collection = _v0;
        return $$update__n__p5(collection, $elm$core$Dict$insert_fn(id, _Utils_Tuple2(0, doc), collection.n), $elm$core$Set$insert_fn(id, collection.p5));
    }, $author$project$Firestore$Collection$insert = F3($author$project$Firestore$Collection$insert_fn);
    var $author$project$Cmd$Person$new_fn = function (env, newPerson) {
        var person = $author$project$Data$Person$default(newPerson);
        var _v0 = $author$project$Lib$UID$generate(env.jy);
        var newId = _v0.a;
        var newSeeds = _v0.b;
        return _Utils_Tuple3(function () {
            var $r = env.$c();
            $r.iz = $author$project$Firestore$Collection$insert_fn(newId, person, env.iz);
            $r.jy = newSeeds;
            return $r;
        }(), newId, $author$project$Routing$RoutePerson(newId));
    }, $author$project$Cmd$Person$new = F2($author$project$Cmd$Person$new_fn);
    var $author$project$Routing$notePageTab = function (route) {
        _v0$3: while (true) {
            switch (route.$) {
                case 3:
                    if (!route.c.$) {
                        var tab = route.c.a;
                        return $elm$core$Maybe$Just(tab);
                    }
                    else {
                        break _v0$3;
                    }
                case 5:
                    if (!route.c.$) {
                        var tab = route.c.a;
                        return $elm$core$Maybe$Just(tab);
                    }
                    else {
                        break _v0$3;
                    }
                case 6:
                    if (!route.c.$) {
                        var tab = route.c.a;
                        return $elm$core$Maybe$Just(tab);
                    }
                    else {
                        break _v0$3;
                    }
                default:
                    break _v0$3;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $author$project$Lib$Debouncer$Msg_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $author$project$Lib$Debouncer$Msg = F3($author$project$Lib$Debouncer$Msg_fn);
    var $author$project$Lib$Debouncer$Poke = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Lib$Debouncer$poke_fn = function (id, send, _v0) {
        var config = _v0.a;
        return _Platform_map_fn(config.pz, $elm$core$Task$perform_fn(A2($author$project$Lib$Debouncer$Msg, $author$project$Lib$Debouncer$Poke(send), id), $elm$time$Time$now));
    }, $author$project$Lib$Debouncer$poke = F3($author$project$Lib$Debouncer$poke_fn);
    var $author$project$Data$Time$fromPosix = function (posix) {
        return $author$project$Data$Time$Time((new $$Record26(posix, 0)));
    };
    var $author$project$Content$Note$introductoryNotes_fn = function (userTimezone, currentMinute) {
        var ordering = $elm$time$Time$posixToMillis(currentMinute);
        var nextHourAfterNow = $author$project$Data$Time$fromPosix($justinmimbs$time_extra$Time$Extra$add_fn(12, 1, userTimezone, $justinmimbs$time_extra$Time$Extra$floor_fn(12, userTimezone, currentMinute)));
        return _List_fromArray([
            _Utils_Tuple2("_example-meeting-1", function () {
                var $r = $author$project$Content$Note$baseIntroductoryNote.$c();
                $r.f6 = "[{\"type\":\"p\",\"children\":[{\"text\":\"This content was added by Witful to show you a meeting example.\"}]},{\"type\":\"p\",\"children\":[{\"text\":\"\"}]},{\"type\":\"p\",\"children\":[{\"text\":\"Meet at Ozo coffee at 8:30am.\"}]},{\"type\":\"p\",\"children\":[{\"text\":\"\"}]},{\"type\":\"ul\",\"children\":[{\"type\":\"li\",\"children\":[{\"type\":\"lic\",\"children\":[{\"text\":\"Discussed current workload.\"}]}]},{\"type\":\"li\",\"children\":[{\"type\":\"lic\",\"children\":[{\"text\":\"Some struggles with the client, but the team has been able to resolve so far.\"}]}]},{\"type\":\"li\",\"children\":[{\"type\":\"lic\",\"children\":[{\"text\":\"Scheduled a regroup with the creative group.\"}]}]},{\"type\":\"li\",\"children\":[{\"type\":\"lic\",\"children\":[{\"text\":\"Ask \"},{\"type\":\"mention\",\"children\":[{\"text\":\"@Lindsey\"}],\"data\":{\"mentionType\":\"person-mention\",\"personId\":\"_lindsey-welcome\",\"name\":\"Lindsey\",\"email\":\"lindsey@witful.com\"}},{\"text\":\" about mountain biking \"},{\"type\":\"action-item-chip\",\"children\":[{\"text\":\"\"}],\"data\":{\"aiType\":\"talking-point\",\"id\":\"xppyOUXh5n\",\"createdAt\":1646759282534,\"completedAt\":null}},{\"text\":\"\"}]}]}]},{\"type\":\"p\",\"children\":[{\"text\":\"\"}]},{\"type\":\"p\",\"children\":[{\"text\":\"Add \"},{\"type\":\"mention\",\"children\":[{\"text\":\"@Lindsey\"}],\"data\":{\"mentionType\":\"person-mention\",\"personId\":\"_lindsey-welcome\",\"name\":\"Lindsey\",\"email\":\"lindsey@witful.com\"}},{\"text\":\"'s coffee order to her person page \"},{\"type\":\"action-item-chip\",\"children\":[{\"text\":\"\"}],\"data\":{\"aiType\":\"todo\",\"priority\":\"priority-normal\",\"id\":\"VxqD53W6tQ\",\"createdAt\":1646759168171,\"completedAt\":null}},{\"text\":\"\"}]},{\"type\":\"p\",\"children\":[{\"text\":\"\"}]}]";
                $r.fR = ordering;
                $r.fc = "This content was added by Witful to show you a meeting example. Meet at Ozo coffee at 8:30am. Discussed current workload. Some struggles with the client, but the team has been able to resolve so far. Scheduled a regroup with the creative group. Ask @Lindsey about mountain biking Add @Lindsey 's coffee order to her person page";
                $r.fh = nextHourAfterNow;
                $r.gh = nextHourAfterNow;
                $r.gj = "Witful Tutorial: Sample 1:1";
                $r.gz = _List_fromArray([
                    (new $$Record30($elm$core$Maybe$Nothing, $author$project$Util$Time$epoch, "xppyOUXh5n", "_example-meeting-1", _List_fromArray([
                        $author$project$Data$ActionItem$Plaintext("Ask "),
                        $author$project$Data$ActionItem$PersonMentionElement({ iB: "_lindsey-welcome" }),
                        $author$project$Data$ActionItem$Plaintext(" about mountain biking "),
                        $author$project$Data$ActionItem$ActionItemChipElement($author$project$Data$ActionItem$TalkingPointChip)
                    ]))),
                    (new $$Record30($elm$core$Maybe$Nothing, $author$project$Util$Time$epoch, "VxqD53W6tQ", "_example-meeting-1", _List_fromArray([
                        $author$project$Data$ActionItem$Plaintext("Add "),
                        $author$project$Data$ActionItem$PersonMentionElement({ iB: "_lindsey-welcome" }),
                        $author$project$Data$ActionItem$Plaintext("'s coffee order to her person page "),
                        $author$project$Data$ActionItem$ActionItemChipElement($author$project$Data$ActionItem$TodoChip(0))
                    ])))
                ]);
                $r.hh = $elm$core$Maybe$Nothing;
                return $r;
            }())
        ]);
    }, $author$project$Content$Note$introductoryNotes = F2($author$project$Content$Note$introductoryNotes_fn);
    var $author$project$Content$Person$introductoryPeople = function (currentMinute) {
        var ordering = $elm$time$Time$posixToMillis(currentMinute);
        return _List_fromArray([
            _Utils_Tuple2($author$project$Content$Person$introductoryPersonId, (new $$Record33("The bio is a good place to keep notes that generally don\u2019t change. Like Lindsey\u2019s birthday, which is May 12th. And that Lindsey is originally from San Diego.", $author$project$Data$Timestamp$serverTimestamp, $author$project$Data$Person$PreloadedPerson, false, _List_fromArray(["lindsey@witful.com"]), $elm$core$Maybe$Nothing, "Lindsey", _List_Nil, ordering, _List_Nil, "[\n  {\n    \"type\": \"p\",\n    \"children\": [\n      {\n        \"text\": \"The bio is a good place to keep notes that generally don\u2019t change.\"\n      }\n    ]\n  },\n  {\n    \"type\": \"p\",\n    \"children\": [\n      {\n        \"text\": \"Like that Lindsey loves mountain biking. And that her coffee order is a 12oz Americano with no room.\"\n      }\n    ]\n  }\n]", $author$project$Data$Timestamp$serverTimestamp)))
        ]);
    };
    var $author$project$Update$preloadIntroContent = function (env) {
        var updatedPeople = $elm$core$List$foldl_fn(function (_v1) {
            var id = _v1.a;
            var person = _v1.b;
            return A2($author$project$Firestore$Collection$insert, id, person);
        }, env.iz, $author$project$Content$Person$introductoryPeople(env.k5));
        var updatedNotes = $elm$core$List$foldl_fn(function (_v0) {
            var id = _v0.a;
            var note = _v0.b;
            return A2($author$project$Firestore$Collection$insert, id, note);
        }, env.fO, $author$project$Content$Note$introductoryNotes_fn(env.pu, env.k5));
        return $$update__fO__iz(env, updatedNotes, updatedPeople);
    };
    var $author$project$Firestore$Document$ExistingId = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Firestore$Cmd$CreateDocument_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$Firestore$Cmd$CreateDocument = F2($author$project$Firestore$Cmd$CreateDocument_fn);
    var $author$project$Firestore$Query$encodeWhereFilterOp = function (whereFilterOp) {
        return $elm$json$Json$Encode$string(function () {
            switch (whereFilterOp) {
                case 0:
                    return "<";
                case 1:
                    return "<=";
                case 2:
                    return "==";
                case 3:
                    return "!=";
                case 4:
                    return ">=";
                default:
                    return ">";
            }
        }());
    };
    var $author$project$Firestore$Query$encode = function (query) {
        var field = query.a;
        var whereFilterOp = query.b;
        var value = query.c;
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("queryType", $elm$json$Json$Encode$string("where")),
            _Utils_Tuple2("field", $elm$json$Json$Encode$string(field)),
            _Utils_Tuple2("whereFilterOp", $author$project$Firestore$Query$encodeWhereFilterOp(whereFilterOp)),
            _Utils_Tuple2("value", value)
        ]));
    };
    var $author$project$Firestore$Cmd$encode = function (op) {
        switch (op.$) {
            case 0:
                var path = op.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2("name", $elm$json$Json$Encode$string("SubscribeCollection")),
                    _Utils_Tuple2("path", $elm$json$Json$Encode$string(path))
                ]));
            case 1:
                var path = op.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2("name", $elm$json$Json$Encode$string("UnsubscribeCollection")),
                    _Utils_Tuple2("path", $elm$json$Json$Encode$string(path))
                ]));
            case 2:
                var path = op.a;
                var queries = op.b;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2("name", $elm$json$Json$Encode$string("ReadCollection")),
                    _Utils_Tuple2("path", $elm$json$Json$Encode$string(path)),
                    _Utils_Tuple2("queries", $elm$json$Json$Encode$list_fn($author$project$Firestore$Query$encode, queries))
                ]));
            case 3:
                var isTransient = op.a;
                var path = op.b.at;
                var id = op.b.l8;
                var data = op.b.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2("name", $elm$json$Json$Encode$string("CreateDocument")),
                    _Utils_Tuple2("path", $elm$json$Json$Encode$string(path)),
                    _Utils_Tuple2("id", $elm$json$Json$Encode$string(id)),
                    _Utils_Tuple2("data", data),
                    _Utils_Tuple2("isTransient", $elm$json$Json$Encode$bool(isTransient))
                ]));
            case 4:
                var path = op.a.at;
                var id = op.a.l8;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2("name", $elm$json$Json$Encode$string("ReadDocument")),
                    _Utils_Tuple2("path", $elm$json$Json$Encode$string(path)),
                    _Utils_Tuple2("id", $elm$json$Json$Encode$string(id))
                ]));
            case 5:
                var path = op.a.at;
                var id = op.a.l8;
                var data = op.a.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2("name", $elm$json$Json$Encode$string("UpdateDocument")),
                    _Utils_Tuple2("path", $elm$json$Json$Encode$string(path)),
                    _Utils_Tuple2("id", $elm$json$Json$Encode$string(id)),
                    _Utils_Tuple2("data", data)
                ]));
            default:
                var path = op.a.at;
                var id = op.a.l8;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2("name", $elm$json$Json$Encode$string("DeleteDocument")),
                    _Utils_Tuple2("path", $elm$json$Json$Encode$string(path)),
                    _Utils_Tuple2("id", $elm$json$Json$Encode$string(id))
                ]));
        }
    };
    var $author$project$Firestore$Collection$encodeItem = function (_v0) {
        var collection = _v0;
        return collection.hc;
    };
    var $author$project$Firestore$Collection$getPath = function (_v0) {
        var collection = _v0;
        return collection.at;
    };
    var $author$project$Firestore$Cmd$createDocumentHelper_fn = function (isTransient, _v0) {
        var toFirestore = _v0.al;
        var collection = _v0._;
        var id = _v0.l8;
        var data = _v0.a;
        var id_ = function () {
            if (!id.$) {
                return "";
            }
            else {
                var string = id.a;
                return string;
            }
        }();
        return toFirestore($author$project$Firestore$Cmd$encode($author$project$Firestore$Cmd$CreateDocument_fn(isTransient, (new $$Record91(A2($author$project$Firestore$Collection$encodeItem, collection, data), id_, $author$project$Firestore$Collection$getPath(collection))))));
    }, $author$project$Firestore$Cmd$createDocumentHelper = F2($author$project$Firestore$Cmd$createDocumentHelper_fn);
    var $author$project$Firestore$Cmd$createDocument_a0 = false, $author$project$Firestore$Cmd$createDocument = $author$project$Firestore$Cmd$createDocumentHelper($author$project$Firestore$Cmd$createDocument_a0);
    var $author$project$Firestore$Cmd$DeleteDocument = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Firestore$Cmd$deleteDocument = function (_v0) {
        var toFirestore = _v0.al;
        var collection = _v0._;
        var id = _v0.l8;
        return toFirestore($author$project$Firestore$Cmd$encode($author$project$Firestore$Cmd$DeleteDocument((new $$Record92(id, $author$project$Firestore$Collection$getPath(collection))))));
    };
    var $author$project$Firestore$Collection$getWriteQueue = function (_v0) {
        var collection = _v0;
        return $elm$core$List$filterMap_fn($elm$core$Basics$identity, $elm$core$List$map_fn(function (id) {
            return $elm$core$Maybe$map_fn(function (_v1) {
                var state = _v1.a;
                var doc = _v1.b;
                return _Utils_Tuple3(id, state, doc);
            }, $elm$core$Dict$get_fn(id, collection.n));
        }, $elm$core$Set$toList(collection.p5)));
    };
    var $author$project$Firestore$Cmd$UpdateDocument = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Firestore$Cmd$updateDocument = function (_v0) {
        var toFirestore = _v0.al;
        var collection = _v0._;
        var id = _v0.l8;
        var data = _v0.a;
        return toFirestore($author$project$Firestore$Cmd$encode($author$project$Firestore$Cmd$UpdateDocument((new $$Record91(A2($author$project$Firestore$Collection$encodeItem, collection, data), id, $author$project$Firestore$Collection$getPath(collection))))));
    };
    var $author$project$Firestore$Cmd$processQueue_fn = function (toFirestore, collection) {
        var collection_ = collection;
        var writeQueue = $author$project$Firestore$Collection$getWriteQueue(collection);
        var cmds = $elm$core$Platform$Cmd$batch($elm$core$List$map_fn(function (_v0) {
            var id = _v0.a;
            var state = _v0.b;
            var doc = _v0.c;
            switch (state) {
                case 0:
                    return $author$project$Firestore$Cmd$createDocumentHelper_fn($author$project$Firestore$Cmd$createDocument_a0, (new $$Record93(collection, doc, $author$project$Firestore$Document$ExistingId(id), toFirestore)));
                case 1:
                    return $author$project$Firestore$Cmd$updateDocument((new $$Record93(collection, doc, id, toFirestore)));
                case 5:
                    return $author$project$Firestore$Cmd$deleteDocument((new $$Record94(collection, id, toFirestore)));
                default:
                    return $elm$core$Platform$Cmd$none;
            }
        }, writeQueue));
        return $elm$core$List$isEmpty(writeQueue) ? _Utils_Tuple2(collection, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(function () {
            var $r = collection_.$c();
            $r.p5 = $elm$core$Set$empty;
            return $r;
        }(), cmds);
    }, $author$project$Firestore$Cmd$processQueue = F2($author$project$Firestore$Cmd$processQueue_fn);
    var $author$project$Lib$Snackbar$Hide = 0;
    var $author$project$Lib$Snackbar$SetVisibility_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $author$project$Lib$Snackbar$SetVisibility = F2($author$project$Lib$Snackbar$SetVisibility_fn);
    var $author$project$Lib$Snackbar$Show = 1;
    var $author$project$Lib$Snackbar$countdownTime = 15000;
    var $author$project$Lib$Snackbar$push_fn = function (item, _v0) {
        var nonce = _v0.ee;
        var snacks = _v0.ai;
        return _Utils_Tuple2((new $$Record34(nonce + 1, $elm$core$Dict$insert_fn(nonce, _Utils_Tuple2(0, item), snacks))), $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Util$Cmd$delayBy_fn(300, $author$project$Lib$Snackbar$SetVisibility_fn(1, nonce)),
            $author$project$Util$Cmd$when_fn(!item.fU, $author$project$Util$Cmd$delayBy_fn($author$project$Lib$Snackbar$countdownTime, $author$project$Lib$Snackbar$SetVisibility_fn(0, nonce)))
        ])));
    }, $author$project$Lib$Snackbar$push = F2($author$project$Lib$Snackbar$push_fn);
    var $elm$browser$Browser$Navigation$reloadAndSkipCache = _Browser_reload(true);
    var $author$project$View$Dialog$BaseDialog$secondaryButtonId = "dialog-secondary-button";
    var $author$project$Analytics$sendAnalytic = _Platform_outgoingPort("sendAnalytic", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("data", $elm$core$Basics$identity($.a)),
            _Utils_Tuple2("name", $elm$json$Json$Encode$string($.b))
        ]));
    });
    var $author$project$Analytics$categories = (new $$Record95("closeable dialog", "help menu", "next meeting nudger", "note", "notification area", "onboarding", "person", "profile menu", "search bar", "settings", "snack bar", "tutorial"));
    var $author$project$Analytics$entityToString = function (entity) {
        switch (entity) {
            case 0:
                return "collation";
            case 1:
                return "person";
            case 2:
                return "note";
            case 3:
                return "event";
            default:
                return "attachment";
        }
    };
    var $author$project$Analytics$notePageTabToString = function (notePageTab) {
        switch (notePageTab) {
            case 0:
                return "action items";
            case 1:
                return "attendees";
            case 2:
                return "attachments";
            default:
                return "series";
        }
    };
    var $author$project$Analytics$signupStepToName = function (signupStep) {
        return "signup" + function () {
            switch (signupStep.$) {
                case 0:
                    if (!signupStep.a.$) {
                        if (signupStep.b.$ === 1) {
                            var ref = signupStep.a.a;
                            var _v1 = signupStep.b;
                            return " (via " + (ref + ")");
                        }
                        else {
                            var ref = signupStep.a.a;
                            return " (gifted, via " + (ref + ")");
                        }
                    }
                    else {
                        if (signupStep.b.$ === 1) {
                            var _v2 = signupStep.a;
                            var _v3 = signupStep.b;
                            return "";
                        }
                        else {
                            var _v4 = signupStep.a;
                            return " (gifted)";
                        }
                    }
                case 1:
                    return " - choose subscription";
                case 2:
                    return " - with linked account";
                case 3:
                    return " - link calendar";
                case 4:
                    return " - watch video";
                default:
                    return " - wizard";
            }
        }();
    };
    var $author$project$Analytics$routeToRouteAnalyticName = function (route) {
        switch (route.$) {
            case 0:
                return "home";
            case 1:
                return "action items";
            case 4:
                return "create note (ad-hoc)";
            case 2:
                if (route.c.$ === 1) {
                    var _v1 = route.c;
                    return "create note (event)";
                }
                else {
                    var ref = route.c.a;
                    return "create note (event via " + (ref + ")");
                }
            case 5:
                return "new note (ad-hoc)";
            case 3:
                return "new note (event)";
            case 6:
                return "note";
            case 7:
                return "next meeting";
            case 8:
                return "new person";
            case 9:
                return "person";
            case 10:
                return "calendar";
            case 11:
                return "settings";
            case 12:
                return "search";
            case 13:
                var signupStep = route.a;
                return $author$project$Analytics$signupStepToName(signupStep);
            case 14:
                return "stripe return";
            case 16:
                return "collate";
            case 15:
                return "billing";
            case 19:
                return "not found";
            case 17:
                return "auth";
            default:
                return "developer demo page";
        }
    };
    var $author$project$Analytics$settingHelper_fn = function (setting, flag) {
        return flag ? (setting + " activated") : (setting + " deactivated");
    }, $author$project$Analytics$settingHelper = F2($author$project$Analytics$settingHelper_fn);
    var $author$project$Analytics$toDialogName = function (closeableDialog) {
        switch (closeableDialog.$) {
            case 0:
                return "edit note time";
            case 1:
                return "feedback form";
            case 2:
                return "thanks for feedback";
            case 3:
                return "error submitting feedback";
            case 4:
                return "keyboard shortcuts";
            case 5:
                return "next meeting not found";
            case 6:
                return "how to use witful video";
            case 7:
                return "smart tags video";
            case 8:
                return "color coding video";
            case 9:
                return "video call video";
            case 10:
                return "link calendar error";
            default:
                return "error connecting to stripe";
        }
    };
    var $author$project$Analytics$toRawEvent = function (event) {
        var fields = A2($elm$core$Basics$composeR, $elm$core$List$map($elm$core$Tuple$mapSecond($elm$json$Json$Encode$string)), $elm$json$Json$Encode$object);
        var action = A2($elm$core$Basics$composeR, $elm$core$Tuple$pair("action"), A2($elm$core$Basics$composeR, $elm$core$List$singleton, fields));
        switch (event.$) {
            case 0:
                var route = event.a;
                return (new $$Record96(fields(_List_fromArray([
                    _Utils_Tuple2("name", $author$project$Analytics$routeToRouteAnalyticName(route)),
                    _Utils_Tuple2("path", $author$project$Routing$pathFromRoute(route))
                ])), "route change"));
            case 1:
                var data = event.a;
                return (new $$Record96($elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2("load_step", $elm$json$Json$Encode$string(data.h3)),
                    _Utils_Tuple2("from_cache", $elm$json$Json$Encode$bool(data.hy)),
                    _Utils_Tuple2("expanded_event_count", $elm$json$Json$Encode$int(data.hl)),
                    _Utils_Tuple2("millis_from_elm_init", $elm$json$Json$Encode$int(data.ie))
                ])), "app load benchmark"));
            case 2:
                var keypress = event.a;
                var key = event.b;
                return (new $$Record96(fields(_List_fromArray([
                    _Utils_Tuple2("action", $elm$core$String$toLower(key.ox)),
                    _Utils_Tuple2("key", $elm$core$String$toLower(keypress.mC))
                ])), "keyboard shortcut"));
            case 3:
                return (new $$Record96(action("opened"), $author$project$Analytics$categories.bb));
            case 4:
                return (new $$Record96(action("sign out"), $author$project$Analytics$categories.bb));
            case 5:
                return (new $$Record96(action("open stripe customer portal"), $author$project$Analytics$categories.bb));
            case 6:
                return (new $$Record96(action("open feedback form"), $author$project$Analytics$categories.bb));
            case 7:
                return (new $$Record96(action("open keyboard shortcuts"), $author$project$Analytics$categories.bb));
            case 8:
                return (new $$Record96(action("add linked account"), $author$project$Analytics$categories.bb));
            case 9:
                return (new $$Record96(action("switch account"), $author$project$Analytics$categories.bb));
            case 10:
                return (new $$Record96(action("opened"), $author$project$Analytics$categories.ir));
            case 11:
                return (new $$Record96(action("open zen mode"), $author$project$Analytics$categories.l));
            case 12:
                return (new $$Record96(action("soft delete"), $author$project$Analytics$categories.l));
            case 13:
                return (new $$Record96(action("restored"), $author$project$Analytics$categories.l));
            case 14:
                return (new $$Record96(action("shared"), $author$project$Analytics$categories.l));
            case 15:
                return (new $$Record96(action("unshared"), $author$project$Analytics$categories.l));
            case 16:
                return (new $$Record96(action("share link copied"), $author$project$Analytics$categories.l));
            case 17:
                return (new $$Record96(action("add person form opened"), $author$project$Analytics$categories.l));
            case 18:
                return (new $$Record96(action("attendee added (ad-hoc attendee)"), $author$project$Analytics$categories.l));
            case 19:
                return (new $$Record96(action("attendee deleted (ad-hoc attendee)"), $author$project$Analytics$categories.l));
            case 20:
                return (new $$Record96(action("attachment added"), $author$project$Analytics$categories.l));
            case 21:
                return (new $$Record96(action("inline attachment added"), $author$project$Analytics$categories.l));
            case 22:
                return (new $$Record96(action("attachment file picker opened"), $author$project$Analytics$categories.l));
            case 23:
                return (new $$Record96(action("attachment drag-n-dropped"), $author$project$Analytics$categories.l));
            case 24:
                return (new $$Record96(action("attachment removed"), $author$project$Analytics$categories.l));
            case 25:
                return (new $$Record96(action("attachment downloaded"), $author$project$Analytics$categories.l));
            case 26:
                return (new $$Record96(action("attachment rename form opened"), $author$project$Analytics$categories.l));
            case 27:
                return (new $$Record96(action("cursor set in note"), $author$project$Analytics$categories.l));
            case 28:
                return (new $$Record96(action("time adjusted (ad-hoc note)"), $author$project$Analytics$categories.l));
            case 29:
                return (new $$Record96(action("video call opened"), $author$project$Analytics$categories.l));
            case 30:
                return (new $$Record96(action("phone call opened"), $author$project$Analytics$categories.l));
            case 31:
                var tab = event.a;
                return (new $$Record96(fields(_List_fromArray([
                    _Utils_Tuple2("action", "tab changed"),
                    _Utils_Tuple2("tab", $author$project$Analytics$notePageTabToString(tab))
                ])), $author$project$Analytics$categories.l));
            case 32:
                return (new $$Record96(action("attendee status overriden"), $author$project$Analytics$categories.l));
            case 33:
                return (new $$Record96(action("opened"), $author$project$Analytics$categories.f0));
            case 34:
                var entity = event.a;
                return (new $$Record96(fields(_List_fromArray([
                    _Utils_Tuple2("action", "entity opened"),
                    _Utils_Tuple2("type", $author$project$Analytics$entityToString(entity))
                ])), $author$project$Analytics$categories.f0));
            case 35:
                return (new $$Record96(action("undo note soft-delete"), $author$project$Analytics$categories.dj));
            case 36:
                return (new $$Record96(action("undo attachment deletion"), $author$project$Analytics$categories.dj));
            case 37:
                return (new $$Record96(action("timezone updated"), $author$project$Analytics$categories.dj));
            case 38:
                return (new $$Record96(action("new app version refresh"), $author$project$Analytics$categories.dj));
            case 39:
                return (new $$Record96(action("soft deleted"), $author$project$Analytics$categories.ae));
            case 40:
                return (new $$Record96(action("email added"), $author$project$Analytics$categories.ae));
            case 41:
                return (new $$Record96(action("email removed"), $author$project$Analytics$categories.ae));
            case 42:
                return (new $$Record96(action("phone number added"), $author$project$Analytics$categories.ae));
            case 43:
                return (new $$Record96(action("phone number removed"), $author$project$Analytics$categories.ae));
            case 44:
                return (new $$Record96(action("marked as not duplicate"), $author$project$Analytics$categories.ae));
            case 45:
                return (new $$Record96(action("merged into another person"), $author$project$Analytics$categories.ae));
            case 46:
                return (new $$Record96(action("ad-hoc created on meeting"), $author$project$Analytics$categories.ae));
            case 47:
                return (new $$Record96(action("deleted"), $author$project$Analytics$categories.ae));
            case 48:
                var flag = event.a;
                return (new $$Record96(action($author$project$Analytics$settingHelper_fn("keyboard shortcuts", flag)), $author$project$Analytics$categories.be));
            case 49:
                var theme = event.a;
                return (new $$Record96(fields(_List_fromArray([
                    _Utils_Tuple2("action", "theme changed"),
                    _Utils_Tuple2("theme", $author$project$Data$Color$themeToString(theme))
                ])), $author$project$Analytics$categories.be));
            case 50:
                var flag = event.a;
                return (new $$Record96(action($author$project$Analytics$settingHelper_fn("army time", flag)), $author$project$Analytics$categories.be));
            case 51:
                var flag = event.a;
                return (new $$Record96(action($author$project$Analytics$settingHelper_fn("show weekends", flag)), $author$project$Analytics$categories.be));
            case 52:
                var flag = event.a;
                return (new $$Record96(action($author$project$Analytics$settingHelper_fn("reverse note columns", flag)), $author$project$Analytics$categories.be));
            case 53:
                var flag = event.a;
                return (new $$Record96(action($author$project$Analytics$settingHelper_fn("default to attendees tab", flag)), $author$project$Analytics$categories.be));
            case 54:
                var flag = event.a;
                return (new $$Record96(action($author$project$Analytics$settingHelper_fn("snapshot update emails", flag)), $author$project$Analytics$categories.be));
            case 55:
                return (new $$Record96(action("init google login"), $author$project$Analytics$categories.as));
            case 56:
                var billingPeriod = event.a;
                return (new $$Record96(fields(_List_fromArray([
                    _Utils_Tuple2("action", "subscription chosen"),
                    _Utils_Tuple2("dialog", $author$project$Data$Subscription$billingPeriodToString(billingPeriod))
                ])), $author$project$Analytics$categories.as));
            case 57:
                return (new $$Record96(action("no google account"), $author$project$Analytics$categories.as));
            case 58:
                return (new $$Record96(action("init calendar linking"), $author$project$Analytics$categories.as));
            case 59:
                return (new $$Record96(action("calendar linking skipped"), $author$project$Analytics$categories.as));
            case 60:
                return (new $$Record96(action("change google accounts"), $author$project$Analytics$categories.as));
            case 61:
                return (new $$Record96($elm$json$Json$Encode$null, "calendar linked"));
            case 62:
                var flag = event.a;
                return (new $$Record96(action("extension link " + ($author$project$Util$Misc$if__fn(flag, "", "not ") + "clicked")), $author$project$Analytics$categories.as));
            case 63:
                return (new $$Record96(action("signup complete"), $author$project$Analytics$categories.as));
            case 64:
                var wasMinimized = event.a;
                return (new $$Record96(action($author$project$Util$Misc$if__fn(wasMinimized, "minimized", "un-minimized")), $author$project$Analytics$categories.fM));
            case 65:
                var isComplete = event.a.mt;
                return (new $$Record96(action($author$project$Util$Misc$if__fn(isComplete, "completed", "dismissed")), $author$project$Analytics$categories.fM));
            case 66:
                return (new $$Record96(action("opened"), $author$project$Analytics$categories.d4));
            case 67:
                return (new $$Record96(action("video modal opened"), $author$project$Analytics$categories.d4));
            case 68:
                return (new $$Record96(action("keyboard shortcuts opened"), $author$project$Analytics$categories.d4));
            default:
                if (!event.a.$) {
                    var dialog = event.a.a;
                    return (new $$Record96(fields(_List_fromArray([
                        _Utils_Tuple2("action", "dialog opened"),
                        _Utils_Tuple2("dialog", $author$project$Analytics$toDialogName(dialog))
                    ])), $author$project$Analytics$categories.e3));
                }
                else {
                    var _v1 = event.a;
                    return (new $$Record96(action("dialog closed"), $author$project$Analytics$categories.e3));
                }
        }
    };
    var $author$project$Analytics$send_a0 = $author$project$Analytics$toRawEvent, $author$project$Analytics$send_a1 = $author$project$Analytics$sendAnalytic, $author$project$Analytics$send = A2($elm$core$Basics$composeR, $author$project$Analytics$send_a0, $author$project$Analytics$send_a1);
    var $author$project$Update$sendAnalytic_a0 = $author$project$Env$AnalyticsEvent, $author$project$Update$sendAnalytic_a1 = A2($elm$core$Basics$composeR, $author$project$Model$HandleBacktalk, $author$project$Util$Cmd$executeMsg), $author$project$Update$sendAnalytic = A2($elm$core$Basics$composeR, $author$project$Update$sendAnalytic_a0, $author$project$Update$sendAnalytic_a1);
    var $author$project$Analytics$googleAnalyticEventToString = function (event) {
        switch (event) {
            case 0:
                return "account_created";
            case 1:
                return "calendar_linked";
            default:
                return "onboarding_complete";
        }
    };
    var $author$project$Analytics$sendGoogleAnalytic_ = _Platform_outgoingPort("sendGoogleAnalytic_", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("action", $elm$json$Json$Encode$string($.eX)),
            _Utils_Tuple2("category", $elm$json$Json$Encode$string($.e1)),
            _Utils_Tuple2("label", function ($) {
                return $elm$core$Maybe$destruct_fn($elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
            }($.fF))
        ]));
    });
    var $author$project$Analytics$sendGoogleAnalytic_fn = function (mUser, googleAnalyticEvent) {
        return $author$project$Analytics$sendGoogleAnalytic_((new $$Record97($author$project$Analytics$googleAnalyticEventToString(googleAnalyticEvent), "onboarding", $elm$core$Maybe$map_fn(function ($) {
            return $.l8;
        }, mUser))));
    }, $author$project$Analytics$sendGoogleAnalytic = F2($author$project$Analytics$sendGoogleAnalytic_fn);
    var $author$project$Data$Note$setAttachmentThumbnailUrl_fn = function (_v0, note) {
        var attachmentStoragePath = _v0.gH;
        var thumbnailUrl = _v0.ct;
        return $$update__kd(note, $elm$core$List$map_fn(function (attachment) {
            return _Utils_eq(attachment.Y, attachmentStoragePath) ? function () {
                var $r = attachment.$c();
                $r.ct = $elm$core$Maybe$Just(thumbnailUrl);
                return $r;
            }() : attachment;
        }, note.kd));
    }, $author$project$Data$Note$setAttachmentThumbnailUrl = F2($author$project$Data$Note$setAttachmentThumbnailUrl_fn);
    var $author$project$Cmd$User$updateUser = _Platform_outgoingPort("updateUser", $elm$core$Basics$identity);
    var $author$project$Cmd$User$setIntroContentPreloaded = function (preloaded) {
        return $author$project$Cmd$User$updateUser($elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("introContentPreloaded", $elm$json$Json$Encode$bool(preloaded))
        ])));
    };
    var $author$project$Cmd$User$setTutorialComplete = function (complete) {
        return $author$project$Cmd$User$updateUser($elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("tutorialComplete", $elm$json$Json$Encode$bool(complete))
        ])));
    };
    var $author$project$Model$StripeCheckoutSessionCreated = function (a) {
        return { $: 16, a: a };
    };
    var $elm$http$Http$expectString = function (toMsg) {
        return $elm$http$Http$expectStringResponse_fn(toMsg, $elm$http$Http$resolve($elm$core$Result$Ok));
    };
    var $author$project$Util$Request$expecter_fn = function (functionName, msg) {
        return $elm$http$Http$expectString(A2($elm$core$Basics$composeR, function (result) {
            if (!result.$) {
                var s = result.a;
                return $krisajenkins$remotedata$RemoteData$Success(s);
            }
            else {
                var e = result.a;
                return $krisajenkins$remotedata$RemoteData$Failure($author$project$Error$CloudFunction({ fm: functionName, hM: e }));
            }
        }, msg));
    }, $author$project$Util$Request$expecter = F2($author$project$Util$Request$expecter_fn);
    var $author$project$Util$Request$stripeCreateCheckoutSession = function (_v0) {
        var billingPeriod = _v0.az;
        var firebaseUserAuthToken = _v0.b9;
        var functionName = "stripe_create_checkout_session/v1";
        var body = $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("billingPeriod", $elm$json$Json$Encode$string(function () {
                if (billingPeriod === 1) {
                    return "yearly";
                }
                else {
                    return "monthly";
                }
            }()))
        ])));
        return $author$project$Util$Request$authedHttpPost((new $$Record82(firebaseUserAuthToken, $elm$core$Maybe$Just(body), $author$project$Util$Request$expecter_fn(functionName, $author$project$Model$StripeCheckoutSessionCreated), _List_Nil, functionName, $elm$core$Maybe$Just($author$project$Util$Request$defaultRequestTimeout))));
    };
    var $author$project$Model$StripeSubscriptionManagementUrlGenerated = function (a) {
        return { $: 17, a: a };
    };
    var $author$project$Util$Request$stripeGenerateSubscriptionManagementUrl = function (_v0) {
        var firebaseUserAuthToken = _v0.b9;
        var functionName = "stripe_generate_subscription_management_url/v1";
        return $author$project$Util$Request$authedHttpPost((new $$Record82(firebaseUserAuthToken, $elm$core$Maybe$Nothing, $author$project$Util$Request$expecter_fn(functionName, $author$project$Model$StripeSubscriptionManagementUrlGenerated), _List_Nil, functionName, $elm$core$Maybe$Just($author$project$Util$Request$defaultRequestTimeout))));
    };
    var $author$project$Ports$switchAccount = _Platform_outgoingPort("switchAccount", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("email", function ($) {
                return $elm$core$Maybe$destruct_fn($elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
            }($.cS))
        ]));
    });
    var $author$project$View$Dialog$BaseDialog$textFieldId = "dialog-text-field";
    var $author$project$Util$Misc$urlHost = function (url) {
        var scheme = function () {
            var _v1 = url.nY;
            if (!_v1) {
                return "http://";
            }
            else {
                return "https://";
            }
        }();
        var portNumber = function () {
            var _v0 = url.nT;
            if (!_v0.$) {
                var portNum = _v0.a;
                return ":" + $elm$core$String$fromInt(portNum);
            }
            else {
                return "";
            }
        }();
        return _Utils_ap(scheme, _Utils_ap(url.hK, portNumber));
    };
    var $author$project$View$URLRequest$toBrowserUrlRequest_fn = function (fromUrl, toUrlString) {
        var isInternal = function (toUrl) {
            return _Utils_eq(fromUrl.nY, toUrl.nY) && (_Utils_eq(fromUrl.hK, toUrl.hK) && _Utils_eq(fromUrl.nT, toUrl.nT));
        };
        var absoluteUrl = (_String_startsWith_fn("http://", toUrlString) || _String_startsWith_fn("https://", toUrlString)) ? toUrlString : _Utils_ap($author$project$Util$Misc$urlHost(fromUrl), toUrlString);
        return $elm$core$Maybe$map_fn(function (toUrl) {
            return isInternal(toUrl) ? $elm$browser$Browser$Internal(toUrl) : $elm$browser$Browser$External(toUrlString);
        }, $elm$url$Url$fromString(absoluteUrl));
    }, $author$project$View$URLRequest$toBrowserUrlRequest = F2($author$project$View$URLRequest$toBrowserUrlRequest_fn);
    var $author$project$Ports$toFirestore = _Platform_outgoingPort("toFirestore", $elm$core$Basics$identity);
    var $author$project$Firestore$Collection$transientUpdate_fn = function (id, fn, collection_) {
        var collection = collection_;
        var updateIfChanged = function (_v0) {
            var state = _v0.a;
            var doc = _v0.b;
            var updatedDoc = fn(doc);
            return _Utils_eq(doc, updatedDoc) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($$update__n(collection, $elm$core$Dict$insert_fn(id, _Utils_Tuple2(state, updatedDoc), collection.n)));
        };
        return $elm$core$Maybe$withDefault_fn(collection_, $elm$core$Maybe$map_fn($elm$core$Basics$identity, $elm$core$Maybe$andThen_fn(updateIfChanged, $elm$core$Dict$get_fn(id, collection.n))));
    }, $author$project$Firestore$Collection$transientUpdate = F3($author$project$Firestore$Collection$transientUpdate_fn);
    var $author$project$Data$Note$update_fn = function (fn, note) {
        return fn($$update__fR__pR(note, note.fR + 1, $author$project$Data$Timestamp$serverTimestamp));
    }, $author$project$Data$Note$update = F2($author$project$Data$Note$update_fn);
    var $author$project$Data$Person$update_fn = function (fn, person) {
        return fn($$update__fR__pR(person, person.fR + 1, $author$project$Data$Timestamp$serverTimestamp));
    }, $author$project$Data$Person$update = F2($author$project$Data$Person$update_fn);
    var $author$project$Data$Settings$update_fn = function (fn, settings) {
        return fn($$update__fR__pR(settings, settings.fR + 1, $author$project$Data$Timestamp$serverTimestamp));
    }, $author$project$Data$Settings$update = F2($author$project$Data$Settings$update_fn);
    var $author$project$Firestore$Collection$update_fn = function (id, fn, collection_) {
        var collection = collection_;
        var updateIfChanged = function (doc) {
            var updatedDoc = fn(doc);
            return _Utils_eq(doc, updatedDoc) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($$update__n__p5(collection, $elm$core$Dict$insert_fn(id, _Utils_Tuple2(1, updatedDoc), collection.n), $elm$core$Set$insert_fn(id, collection.p5)));
        };
        return $elm$core$Maybe$withDefault_fn(collection_, $elm$core$Maybe$map_fn($elm$core$Basics$identity, function (mItem) {
            if (!mItem.$) {
                switch (mItem.a.a) {
                    case 6:
                        var _v1 = mItem.a;
                        var _v2 = _v1.a;
                        return $elm$core$Maybe$Just($$update__n(collection, $elm$core$Dict$remove_fn(id, collection.n)));
                    case 5:
                        var _v3 = mItem.a;
                        var _v4 = _v3.a;
                        return $elm$core$Maybe$Nothing;
                    default:
                        var _v5 = mItem.a;
                        var doc = _v5.b;
                        return updateIfChanged(doc);
                }
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }($elm$core$Dict$get_fn(id, collection.n))));
    }, $author$project$Firestore$Collection$update = F3($author$project$Firestore$Collection$update_fn);
    var $author$project$Lib$Debouncer$Check = { $: 0 };
    var $author$project$Lib$Debouncer$diff_fn = function (t1, t2) {
        return $elm$core$Basics$abs($elm$time$Time$posixToMillis(t1) - $elm$time$Time$posixToMillis(t2));
    }, $author$project$Lib$Debouncer$diff = F2($author$project$Lib$Debouncer$diff_fn);
    var $author$project$Lib$Debouncer$update_fn = function (_v0, _v1) {
        var op = _v0.a;
        var id = _v0.b;
        var time = _v0.c;
        var config = _v1.a;
        var trackers = _v1.b;
        if (op.$ === 1) {
            var send = op.a;
            var toDebouncer = function (tracker) {
                return $author$project$Lib$Debouncer$Debouncer_fn(config, $elm$core$Dict$insert_fn(id, tracker, trackers));
            };
            var _v3 = $elm$core$Dict$get_fn(id, trackers);
            if (_v3.$ === 1) {
                return $author$project$Lib$Debouncer$update_fn($author$project$Lib$Debouncer$Msg_fn($author$project$Lib$Debouncer$Check, id, time), toDebouncer((new $$Record98(time, time, send))));
            }
            else {
                var tracker = _v3.a;
                return _Utils_Tuple2(toDebouncer(function () {
                    var $r = tracker.$c();
                    $r.eD = send;
                    $r.em = time;
                    return $r;
                }()), $elm$core$Platform$Cmd$none);
            }
        }
        else {
            var sendAndReset = function (send) {
                return _Utils_Tuple2($author$project$Lib$Debouncer$Debouncer_fn(config, $elm$core$Dict$remove_fn(id, trackers)), $elm$core$Task$perform_fn(function (_v6) {
                    return send;
                }, $elm$core$Task$succeed(0)));
            };
            var debounce = _Platform_map_fn(config.pz, $elm$core$Task$perform_fn(A2($author$project$Lib$Debouncer$Msg, $author$project$Lib$Debouncer$Check, id), _Scheduler_andThen_fn(function (_v5) {
                return $elm$time$Time$now;
            }, $elm$core$Process$sleep($elm$core$Basics$clamp_fn(1, 1000, config.lc)))));
            var _v4 = $elm$core$Dict$get_fn(id, trackers);
            if (_v4.$ === 1) {
                return _Utils_Tuple2($author$project$Lib$Debouncer$Debouncer_fn(config, trackers), $elm$core$Platform$Cmd$none);
            }
            else {
                var pokedAt = _v4.a.em;
                var initializedAt = _v4.a.fB;
                var send = _v4.a.eD;
                return (_Utils_cmp($author$project$Lib$Debouncer$diff_fn(time, initializedAt), config.pp) > -1) ? sendAndReset(send) : ((_Utils_cmp($author$project$Lib$Debouncer$diff_fn(time, pokedAt), config.lc) < 0) ? _Utils_Tuple2($author$project$Lib$Debouncer$Debouncer_fn(config, trackers), debounce) : sendAndReset(send));
            }
        }
    }, $author$project$Lib$Debouncer$update = F2($author$project$Lib$Debouncer$update_fn);
    var $author$project$Lib$Snackbar$Remove = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Lib$Snackbar$slideInAnimationTime = 500;
    var $author$project$Lib$Snackbar$update_fn = function (msg, model) {
        switch (msg.$) {
            case 1:
                var visibility = msg.a;
                var id = msg.b;
                return _Utils_Tuple3($$update__ai(model, $elm$core$Dict$update_fn(id, $elm$core$Maybe$map(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$Tuple$pair(visibility))), model.ai)), $author$project$Util$Cmd$when_fn(!visibility, $author$project$Util$Cmd$delayBy_fn($elm$core$Basics$round($author$project$Lib$Snackbar$slideInAnimationTime * 0.7), $author$project$Lib$Snackbar$Remove(id))), $elm$core$Maybe$Nothing);
            case 0:
                var id = msg.a;
                return _Utils_Tuple3($$update__ai(model, $elm$core$Dict$remove_fn(id, model.ai)), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            default:
                var id = msg.a;
                return _Utils_Tuple3(model, $author$project$Util$Cmd$delayBy_fn(50, $author$project$Lib$Snackbar$SetVisibility_fn(0, id)), $elm$core$Maybe$map_fn(function ($) {
                    return $.fQ;
                }, $elm$core$Maybe$andThen_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, function ($) {
                    return $.eX;
                }), $elm$core$Dict$get_fn(id, model.ai))));
        }
    }, $author$project$Lib$Snackbar$update = F2($author$project$Lib$Snackbar$update_fn);
    var $author$project$View$ImageViewer$map_fn = function (f, model) {
        if (!model.$) {
            return $author$project$View$ImageViewer$NotDisplayed;
        }
        else {
            var internalModel = model.a;
            return $author$project$View$ImageViewer$Displayed(f(internalModel));
        }
    }, $author$project$View$ImageViewer$map = F2($author$project$View$ImageViewer$map_fn);
    var $author$project$View$ImageViewer$resetZoomLevel_a0 = function (subModel) {
        return $$update__bP(subModel, 0);
    }, $author$project$View$ImageViewer$resetZoomLevel = $author$project$View$ImageViewer$map($author$project$View$ImageViewer$resetZoomLevel_a0);
    var $author$project$View$ImageViewer$updateDimensions = function (imageDimensions) {
        return $author$project$View$ImageViewer$map(function (subModel) {
            return function () {
                var $r = subModel.$c();
                $r.c0 = $elm$core$Maybe$Just(imageDimensions);
                return $r;
            }();
        });
    };
    var $author$project$View$ImageViewer$applySizeAdjustment_fn = function (sizeAdjustment, zoomLevel) {
        if (!sizeAdjustment) {
            return zoomLevel + 1;
        }
        else {
            return zoomLevel - 1;
        }
    }, $author$project$View$ImageViewer$applySizeAdjustment = F2($author$project$View$ImageViewer$applySizeAdjustment_fn);
    var $author$project$View$ImageViewer$updateZoomLevel = function (sizeAdjustment) {
        return $author$project$View$ImageViewer$map(function (subModel) {
            return $$update__bP(subModel, $author$project$View$ImageViewer$applySizeAdjustment_fn(sizeAdjustment, subModel.bP));
        });
    };
    var $author$project$View$ImageViewer$update_fn = function (msg, model) {
        switch (msg.$) {
            case 0:
                var dimensions = msg.a;
                return _Utils_Tuple2(A2($author$project$View$ImageViewer$updateDimensions, dimensions, model), $elm$core$Platform$Cmd$none);
            case 1:
                var sizeAdjustment = msg.a;
                return _Utils_Tuple2(A2($author$project$View$ImageViewer$updateZoomLevel, sizeAdjustment, model), $elm$core$Platform$Cmd$none);
            case 2:
                return _Utils_Tuple2($author$project$View$ImageViewer$map_fn($author$project$View$ImageViewer$resetZoomLevel_a0, model), $elm$core$Platform$Cmd$none);
            default:
                return _Utils_Tuple2($author$project$View$ImageViewer$NotDisplayed, $elm$core$Platform$Cmd$none);
        }
    }, $author$project$View$ImageViewer$update = F2($author$project$View$ImageViewer$update_fn);
    var $author$project$Ports$viewAttachment = _Platform_outgoingPort("viewAttachment", $elm$json$Json$Encode$string);
    var $author$project$Update$handleBacktalk_fn = function (env, backtalk) {
        handleBacktalk: while (true) {
            var outboundRequests = env.db;
            switch (backtalk.$) {
                case 0:
                    var route = backtalk.a;
                    return _Utils_Tuple2(env, function () {
                        var _v1 = $author$project$View$URLRequest$toBrowserUrlRequest_fn(env.mM, $author$project$Routing$pathFromRoute(route));
                        if (!_v1.$) {
                            var newRoute = _v1.a;
                            return $author$project$Util$Cmd$executeMsg($author$project$Model$URLRequest(newRoute));
                        }
                        else {
                            return $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$ImpossibleState($author$project$Error$RouteToURLRequestIsNothing)));
                        }
                    }());
                case 1:
                    return _Utils_Tuple2(function () {
                        var $r = env.$c();
                        $r.mw = true;
                        return $r;
                    }(), $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map_fn(function (key) {
                        return $elm$browser$Browser$Navigation$back_fn(key, 1);
                    }, env.na)));
                case 34:
                    return _Utils_Tuple2(env, $author$project$Util$Cmd$executeMsg($author$project$Model$URLRequest($elm$browser$Browser$External("mailto:support@witful.com"))));
                case 2:
                    var debounce = backtalk.a.lc;
                    var id = backtalk.a.l8;
                    var updater = backtalk.a.pS;
                    var shouldRerouteFromNewNote = $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(function (_v2) {
                        var state = _v2.a;
                        var _v3 = env.oe;
                        switch (_v3.$) {
                            case 5:
                                var routeNoteId = _v3.a;
                                return (!state) && _Utils_eq(routeNoteId, id);
                            case 3:
                                var routeNoteId = _v3.a;
                                return (!state) && _Utils_eq(routeNoteId, id);
                            default:
                                return false;
                        }
                    }, $author$project$Firestore$Collection$getWithState_fn(id, env.fO)));
                    var saveCmd = debounce ? _Platform_map_fn($author$project$Model$HandleBacktalk, $author$project$Lib$Debouncer$poke_fn($author$project$Data$Note$debounceId, $author$project$Env$SaveNotes, env.ld)) : $author$project$Util$Cmd$executeMsg($author$project$Model$HandleBacktalk($author$project$Env$SaveNotes));
                    return _Utils_Tuple2($$update__fO(env, $author$project$Firestore$Collection$update_fn(id, $author$project$Data$Note$update(updater), env.fO)), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        saveCmd,
                        $author$project$Util$Cmd$when_fn(shouldRerouteFromNewNote, $author$project$Routing$reroute_fn(env, $author$project$Routing$RouteNote_fn(id, $elm$core$Maybe$Nothing, $author$project$Routing$notePageTab(env.oe))))
                    ])));
                case 3:
                    var noteId = backtalk.a;
                    var updater = backtalk.b;
                    return _Utils_Tuple2($$update__fO(env, $author$project$Firestore$Collection$transientUpdate_fn(noteId, updater, env.fO)), $elm$core$Platform$Cmd$none);
                case 4:
                    var noteId = backtalk.a;
                    var note = backtalk.b;
                    return _Utils_Tuple2($$update__fO(env, $author$project$Firestore$Collection$insertTransient_fn(noteId, note, env.fO)), $elm$core$Platform$Cmd$none);
                case 5:
                    var _v4 = $author$project$Firestore$Cmd$processQueue_fn($author$project$Ports$toFirestore, env.fO);
                    var newNotes = _v4.a;
                    var noteWrites = _v4.b;
                    return _Utils_Tuple2($$update__fO(env, newNotes), noteWrites);
                case 6:
                    var toggledFrom = backtalk.a.pD;
                    var actionItem = backtalk.b;
                    return $author$project$Update$ToggleActionItem$handler_fn(env, toggledFrom, actionItem);
                case 7:
                    var noteId = backtalk.a;
                    var storagePath = backtalk.b;
                    var _v5 = $author$project$Data$StorageUpload$cancel_fn(noteId, storagePath, env.oV);
                    var newAttachmentTracker = _v5.a;
                    var cmd = _v5.b;
                    return _Utils_Tuple2($$update__oV(env, newAttachmentTracker), cmd);
                case 8:
                    var mimeType = backtalk.a.c1;
                    var noteId = backtalk.b.ip;
                    var attachmentStoragePath = backtalk.b.gH;
                    return _Utils_Tuple2(env, $author$project$Util$Cmd$whenJust_fn(env.pV, function (_v6) {
                        var authToken = _v6.kg;
                        return $author$project$Util$Cmd$when_fn(_String_startsWith_fn("image/", mimeType), $author$project$Util$Request$attachmentThumbnailUrl({ gH: attachmentStoragePath, b9: authToken, ip: noteId }));
                    }));
                case 9:
                    var attachmentStoragePath = backtalk.a.gH;
                    var noteId = backtalk.a.ip;
                    var result = backtalk.b;
                    if (!result.$) {
                        if (!result.a.$) {
                            var thumbnailUrl = result.a.a;
                            var $temp$env = env, $temp$backtalk = $author$project$Env$UpdateNote((new $$Record77(false, noteId, $author$project$Data$Note$setAttachmentThumbnailUrl((new $$Record99(attachmentStoragePath, thumbnailUrl))))));
                            env = $temp$env;
                            backtalk = $temp$backtalk;
                            continue handleBacktalk;
                        }
                        else {
                            var _v8 = result.a;
                            return _Utils_Tuple2(env, $elm$core$Platform$Cmd$none);
                        }
                    }
                    else {
                        var httpError = result.a;
                        return _Utils_Tuple2(env, $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$CloudFunction({ fm: $author$project$Util$Request$attachmentThumbnailUrlFunctionName, hM: httpError }))));
                    }
                case 10:
                    var storagePath = backtalk.a.Y;
                    return _Utils_Tuple2(env, $author$project$Ports$viewAttachment(storagePath));
                case 11:
                    var debounce = backtalk.a.lc;
                    var id = backtalk.a.l8;
                    var updater = backtalk.a.pS;
                    var saveCmd = debounce ? _Platform_map_fn($author$project$Model$HandleBacktalk, $author$project$Lib$Debouncer$poke_fn($author$project$Data$Person$debounceId, $author$project$Env$SavePeople, env.ld)) : $author$project$Util$Cmd$executeMsg($author$project$Model$HandleBacktalk($author$project$Env$SavePeople));
                    return _Utils_Tuple2($$update__iz(env, $author$project$Firestore$Collection$update_fn(id, $author$project$Data$Person$update(updater), env.iz)), saveCmd);
                case 12:
                    var _v9 = $author$project$Firestore$Cmd$processQueue_fn($author$project$Ports$toFirestore, env.iz);
                    var newPeople = _v9.a;
                    var peopleWrites = _v9.b;
                    return _Utils_Tuple2($$update__iz(env, newPeople), peopleWrites);
                case 13:
                    var ids = backtalk.a;
                    return _Utils_Tuple2($$update__db__e3(env, $$update__mY(outboundRequests, $krisajenkins$remotedata$RemoteData$Loading), $elm$core$Maybe$Nothing), $author$project$Ports$mergePersons(ids));
                case 14:
                    var fn = backtalk.a;
                    var updatedSettings = $author$project$Firestore$Collection$update_fn($author$project$Data$Settings$fixedDocId, $author$project$Data$Settings$update(fn), env.be);
                    var _v10 = $author$project$Firestore$Cmd$processQueue_fn($author$project$Ports$toFirestore, updatedSettings);
                    var newSettings = _v10.a;
                    var settingsWrites = _v10.b;
                    return _Utils_Tuple2(function () {
                        var $r = env.$c();
                        $r.be = newSettings;
                        return $r;
                    }(), settingsWrites);
                case 15:
                    var newUser = $elm$core$Maybe$map_fn(function (user) {
                        return function () {
                            var $r = user.$c();
                            $r.pL = true;
                            return $r;
                        }();
                    }, env.pV);
                    var mUpdateNextMeetingNudger = function () {
                        var nudgerIsHidden = !$author$project$Data$Settings$get(env).ed;
                        return $author$project$Util$Cmd$when_fn(nudgerIsHidden, $author$project$Util$Cmd$delayBy_fn(2000, $author$project$Model$HandleBacktalk($author$project$Env$UpdateSettings(function (s) {
                            return $$update__ed(s, 1);
                        }))));
                    }();
                    return _Utils_Tuple2($$update__pV(env, newUser), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $elm$core$Basics$composeR_fn($author$project$Update$sendAnalytic_a0, $author$project$Update$sendAnalytic_a1, $author$project$Analytics$SignupCompleted),
                        $author$project$Routing$reroute_fn(env, $author$project$Routing$RouteHome($elm$core$Maybe$Nothing)),
                        $author$project$Cmd$User$setTutorialComplete(true),
                        mUpdateNextMeetingNudger,
                        $author$project$Analytics$sendGoogleAnalytic_fn(newUser, 2)
                    ])));
                case 16:
                    return _Utils_Tuple2($$update__db(env, $$update__o5(outboundRequests, $krisajenkins$remotedata$RemoteData$Loading)), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Routing$reroute_fn(env, $author$project$Routing$RouteSignup($author$project$Routing$SignupStepLinkAccountSignIn($elm$core$Maybe$map_fn(function ($) {
                            return $.kg;
                        }, env.pV)))),
                        $author$project$Ports$switchAccount({ cS: $elm$core$Maybe$Nothing })
                    ])));
                case 17:
                    var email = backtalk.a.cS;
                    var isHomeOrCalendar = function () {
                        var _v11 = env.oe;
                        switch (_v11.$) {
                            case 0:
                                return true;
                            case 10:
                                return true;
                            default:
                                return false;
                        }
                    }();
                    return _Utils_Tuple2($$update__db(env, $$update__o5(outboundRequests, $krisajenkins$remotedata$RemoteData$Loading)), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Ports$switchAccount({
                            cS: $elm$core$Maybe$Just(email)
                        }),
                        $author$project$Util$Cmd$when_fn(!isHomeOrCalendar, $author$project$Routing$reroute_fn(env, $author$project$Routing$RouteHome($elm$core$Maybe$Nothing)))
                    ])));
                case 18:
                    var billingPeriod = backtalk.a;
                    return _Utils_Tuple2($$update__db(env, $$update__oX(outboundRequests, $krisajenkins$remotedata$RemoteData$Loading)), $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map_fn($author$project$Util$Request$stripeCreateCheckoutSession, $elm$core$Maybe$map_fn(function (user) {
                        return (new $$Record100(billingPeriod, user.kg));
                    }, env.pV))));
                case 19:
                    var mDialogAction = backtalk.a;
                    var shouldSendAnalytic = ($elm_community$maybe_extra$Maybe$Extra$isNothing(env.e3) && $elm_community$maybe_extra$Maybe$Extra$isJust(mDialogAction)) || ($elm_community$maybe_extra$Maybe$Extra$isNothing(mDialogAction) && $elm_community$maybe_extra$Maybe$Extra$isJust(env.e3));
                    var focusId = function (dialog) {
                        switch (dialog.$) {
                            case 0:
                                return $author$project$View$Dialog$BaseDialog$textFieldId;
                            case 1:
                                return $author$project$View$Dialog$BaseDialog$textFieldId;
                            case 4:
                                return $author$project$View$Shortcut$focusPoint;
                            default:
                                return $author$project$View$Dialog$BaseDialog$secondaryButtonId;
                        }
                    };
                    return _Utils_Tuple2(function () {
                        var $r = env.$c();
                        $r.e3 = mDialogAction;
                        $r.iO = false;
                        return $r;
                    }(), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Util$Cmd$when_fn($elm_community$maybe_extra$Maybe$Extra$isNothing(env.e3), $author$project$Util$Cmd$whenJust_fn(mDialogAction, A2($elm$core$Basics$composeR, focusId, $author$project$Util$Cmd$focusOnElement($author$project$Model$NoOp("dialog focussed"))))),
                        $author$project$Util$Cmd$when_fn(shouldSendAnalytic, $elm$core$Basics$composeR_fn($author$project$Update$sendAnalytic_a0, $author$project$Update$sendAnalytic_a1, $author$project$Analytics$CloseableDialogSet(mDialogAction)))
                    ])));
                case 20:
                    var mImageUrl = backtalk.a;
                    var newImageViewer = function () {
                        if (!mImageUrl.$) {
                            var imageUrl = mImageUrl.a.ma;
                            return $author$project$View$ImageViewer$init(imageUrl);
                        }
                        else {
                            return $author$project$View$ImageViewer$hide;
                        }
                    }();
                    return _Utils_Tuple2($$update__ft(env, newImageViewer), $elm$core$Platform$Cmd$none);
                case 21:
                    var msg = backtalk.a;
                    var _v14 = $author$project$View$ImageViewer$update_fn(msg, env.ft);
                    var newImageViewer = _v14.a;
                    var imageViewerCmd = _v14.b;
                    return _Utils_Tuple2($$update__ft(env, newImageViewer), _Platform_map_fn(A2($elm$core$Basics$composeR, $author$project$Env$ImageViewerMsg, $author$project$Model$HandleBacktalk), imageViewerCmd));
                case 22:
                    var content = backtalk.a;
                    return _Utils_Tuple2(function () {
                        var $r = env.$c();
                        $r.lD = content;
                        return $r;
                    }(), $elm$core$Platform$Cmd$none);
                case 23:
                    var snackbarItem = backtalk.a;
                    var _v15 = $author$project$Lib$Snackbar$push_fn(snackbarItem, env.dj);
                    var subModel = _v15.a;
                    var subCmd = _v15.b;
                    return _Utils_Tuple2($$update__dj(env, subModel), _Platform_map_fn(A2($elm$core$Basics$composeL, $author$project$Model$HandleBacktalk, $author$project$Env$SnackbarMsg), subCmd));
                case 24:
                    var snackbarMsg = backtalk.a;
                    var _v16 = $author$project$Lib$Snackbar$update_fn(snackbarMsg, env.dj);
                    var subModel = _v16.a;
                    var subCmd = _v16.b;
                    var mBacktalk = _v16.c;
                    var _v17 = $author$project$Update$handleBacktalk_fn($$update__dj(env, subModel), $elm$core$Maybe$withDefault_fn($author$project$Env$NoOp("no backtalk from Snackbar"), mBacktalk));
                    var newEnv = _v17.a;
                    var backtalkCmd = _v17.b;
                    return _Utils_Tuple2(newEnv, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        backtalkCmd,
                        _Platform_map_fn(A2($elm$core$Basics$composeL, $author$project$Model$HandleBacktalk, $author$project$Env$SnackbarMsg), subCmd)
                    ])));
                case 33:
                    var noteId = backtalk.a;
                    var name = backtalk.b;
                    var _v18 = $author$project$Cmd$Person$new_fn(env, (new $$Record39($author$project$Data$Person$FrontendAdhocPerson, $elm$core$Maybe$Nothing, name)));
                    var newEnv = _v18.a;
                    var personId = _v18.b;
                    return $author$project$Update$handleBacktalk_fn(newEnv, $author$project$Env$Tantrum(_List_fromArray([
                        $author$project$Env$UpdateNote((new $$Record77(false, noteId, function (note) {
                            return $$update__ke(note, _List_Cons((new $$Record31($elm$core$Maybe$Nothing, true, name, $elm$core$Maybe$Nothing, $author$project$Data$Note$PersonRef(personId))), note.ke));
                        }))),
                        $author$project$Env$SavePeople,
                        $author$project$Env$AnalyticsEvent($author$project$Analytics$PersonAdHocCreated)
                    ])));
                case 25:
                    return _Utils_Tuple2(env, $elm$browser$Browser$Navigation$reloadAndSkipCache);
                case 26:
                    var newEnv = $author$project$Update$preloadIntroContent(env);
                    var _v19 = $author$project$Firestore$Cmd$processQueue_fn($author$project$Ports$toFirestore, newEnv.iz);
                    var newPeople = _v19.a;
                    var peopleWrites = _v19.b;
                    var _v20 = $author$project$Firestore$Cmd$processQueue_fn($author$project$Ports$toFirestore, newEnv.fO);
                    var newNotes = _v20.a;
                    var noteWrites = _v20.b;
                    return _Utils_Tuple2($$update__fO__iz(newEnv, newNotes, newPeople), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        noteWrites,
                        peopleWrites,
                        $author$project$Cmd$User$setIntroContentPreloaded(true)
                    ])));
                case 27:
                    var timezone = backtalk.a;
                    return _Utils_Tuple2(function () {
                        var $r = env.$c();
                        $r.ps = timezone;
                        $r.pu = timezone;
                        return $r;
                    }(), $elm$core$Platform$Cmd$none);
                case 28:
                    var flag = backtalk.a;
                    var newShowSearchbar = $author$project$Util$Misc$if__fn(flag && $author$project$Routing$isSearch(env.oe), false, flag);
                    return _Utils_Tuple2(function () {
                        var $r = env.$c();
                        $r.oz = newShowSearchbar;
                        return $r;
                    }(), $author$project$Util$Cmd$when_fn(flag, $elm$core$Task$attempt_fn(function (_v22) {
                        return $author$project$Model$NoOp("Focus searchbar");
                    }, _Scheduler_andThen_fn(function (_v21) {
                        return _Browser_call_fn($elm$browser$Browser$Dom$focus_a0, $author$project$Search$Bar$inputId);
                    }, $elm$core$Process$sleep(30)))));
                case 31:
                    return _Utils_Tuple2(function () {
                        var $r = env.$c();
                        $r.db = $$update__o_(outboundRequests, $krisajenkins$remotedata$RemoteData$Loading);
                        $r.iO = false;
                        return $r;
                    }(), $author$project$Util$Cmd$whenJust_fn(env.pV, function (user) {
                        return $author$project$Util$Request$stripeGenerateSubscriptionManagementUrl({ b9: user.kg });
                    }));
                case 30:
                    return _Utils_Tuple2(env, $author$project$Ports$linkCalendar(true));
                case 29:
                    var msg = backtalk.a;
                    var _v23 = $author$project$Lib$Debouncer$update_fn(msg, env.ld);
                    var newDebouncer = _v23.a;
                    var cmd = _v23.b;
                    return _Utils_Tuple2($$update__ld(env, newDebouncer), _Platform_map_fn($author$project$Model$HandleBacktalk, cmd));
                case 32:
                    var analyticsEvent = backtalk.a;
                    return _Utils_Tuple2(env, $elm$core$Basics$composeR_fn($author$project$Analytics$send_a0, $author$project$Analytics$send_a1, analyticsEvent));
                case 35:
                    var xs = backtalk.a;
                    var tantrumReducer = F2(function (backtalk_, _v24) {
                        var model_ = _v24.a;
                        var cmds = _v24.b;
                        return $elm$core$Tuple$mapSecond_fn(function (cmd) {
                            return _List_Cons(cmd, cmds);
                        }, $author$project$Update$handleBacktalk_fn(model_, backtalk_));
                    });
                    return $elm$core$Tuple$mapSecond_fn($elm$core$Platform$Cmd$batch, $elm$core$List$foldl_fn(tantrumReducer, _Utils_Tuple2(env, _List_Nil), xs));
                default:
                    return _Utils_Tuple2(env, $elm$core$Platform$Cmd$none);
            }
        }
    }, $author$project$Update$handleBacktalk = F2($author$project$Update$handleBacktalk_fn);
    var $author$project$Error$Firestore = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Util$Firestore$handleSubError = function (subError) {
        if (!subError.$) {
            var decodeError = subError.a;
            return $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$Decoding({
                lg: $elm$json$Json$Decode$errorToString(decodeError),
                he: "Firestore.Sub.Error"
            })));
        }
        else {
            var firestoreError = subError.a;
            return $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$Firestore(firestoreError)));
        }
    };
    var $author$project$Error$NotFound = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Update$Util$delayedSaveNotes = $author$project$Util$Cmd$delayBy_fn(10000, $author$project$Model$HandleBacktalk($author$project$Env$SaveNotes));
    var $author$project$Util$Triple$first = function (_v0) {
        var a = _v0.a;
        var b = _v0.b;
        var c = _v0.c;
        return a;
    };
    var $author$project$Search$Bar$GenerateResult = { $: 1 };
    var $author$project$Search$Bar$generateResult = $author$project$Search$Bar$GenerateResult;
    var $author$project$Data$App$isLoading = function (_v0) {
        var events = _v0.lw;
        return !events.mg;
    };
    var $author$project$Update$isNotes_fn = function (_v0, path) {
        var notes = _v0.fO;
        return _Utils_eq($author$project$Firestore$Collection$getPath(notes), path);
    }, $author$project$Update$isNotes = F2($author$project$Update$isNotes_fn);
    var $author$project$Update$isPeople_fn = function (_v0, path) {
        var people = _v0.iz;
        return _Utils_eq($author$project$Firestore$Collection$getPath(people), path);
    }, $author$project$Update$isPeople = F2($author$project$Update$isPeople_fn);
    var $author$project$Update$isSettings_fn = function (_v0, path) {
        var settings = _v0.be;
        return _Utils_eq($author$project$Firestore$Collection$getPath(settings), path);
    }, $author$project$Update$isSettings = F2($author$project$Update$isSettings_fn);
    var $author$project$Data$LoadState$markNotesLoaded = function (loadState) {
        return function () {
            var $r = loadState.$c();
            $r.iq = true;
            return $r;
        }();
    };
    var $author$project$Data$LoadState$markPeopleLoaded = function (loadState) {
        return function () {
            var $r = loadState.$c();
            $r.iA = true;
            return $r;
        }();
    };
    var $author$project$Firestore$Sub$processChanges_fn = function (_v0, opaqueCollection) {
        var path = _v0.at;
        var docs = _v0.n;
        var collection = opaqueCollection;
        var wrapper = function (acc) {
            return {
                bl: acc.bl,
                _: $$update__n(collection, acc.cQ),
                br: acc.br
            };
        };
        var updateExistingDoc = F2(function (_v8, _v9) {
            var newState = _v8.a;
            var newDoc = _v8.b;
            var currentState = _v9.a;
            var currentDoc = _v9.b;
            if ((newState === 5) || (newState === 6)) {
                return _Utils_Tuple2(newState, currentDoc);
            }
            else {
                var _v4 = A2(collection.kV, newDoc, currentDoc);
                switch (_v4) {
                    case 0:
                        return _Utils_Tuple2(currentState, currentDoc);
                    case 1:
                        var _v5 = _Utils_Tuple2(newState, currentState);
                        if ((_v5.a === 3) && (_v5.b === 4)) {
                            var _v6 = _v5.a;
                            var _v7 = _v5.b;
                            return _Utils_Tuple2(4, newDoc);
                        }
                        else {
                            return _Utils_Tuple2(newState, newDoc);
                        }
                    default:
                        return _Utils_Tuple2(newState, newDoc);
                }
            }
        });
        var updateDoc = F2(function (newDoc, mOldDoc) {
            if (!mOldDoc.$) {
                var oldDoc = mOldDoc.a;
                return $elm$core$Maybe$Just(A2(updateExistingDoc, newDoc, oldDoc));
            }
            else {
                return $elm$core$Maybe$Just(newDoc);
            }
        });
        var reducer = F2(function (doc, _v2) {
            var docDict = _v2.cQ;
            var changes = _v2.bl;
            var errors = _v2.br;
            var _v1 = _Json_run_fn(collection.g4, doc.a);
            if (_v1.$ === 1) {
                var newDocDecodeErr = _v1.a;
                return {
                    bl: changes,
                    cQ: docDict,
                    br: _List_Cons(newDocDecodeErr, errors)
                };
            }
            else {
                var newDocDecoded = _v1.a;
                return {
                    bl: _List_Cons((new $$Record50(newDocDecoded, doc.l8)), changes),
                    cQ: $elm$core$Dict$update_fn(doc.l8, updateDoc(_Utils_Tuple2(doc.oO, newDocDecoded)), docDict),
                    br: errors
                };
            }
        });
        return (!_Utils_eq(collection.at, path)) ? {
            bl: _List_Nil,
            _: opaqueCollection,
            br: _List_fromArray([
                $elm$json$Json$Decode$Failure_fn("Doc and Collection path should match", $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2("collectionPath", $elm$json$Json$Encode$string(collection.at)),
                    _Utils_Tuple2("docPath", $elm$json$Json$Encode$string(path))
                ])))
            ])
        } : wrapper($elm$core$List$foldl_fn(reducer, { bl: _List_Nil, cQ: collection.n, br: _List_Nil }, docs));
    }, $author$project$Firestore$Sub$processChanges = F2($author$project$Firestore$Sub$processChanges_fn);
    var $author$project$Util$Firestore$processChanges_fn = function (docChanges, collection_, entityName, toNewEnv) {
        var convertDecodeError = function (decodeError) {
            return $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$Decoding({
                lg: $elm$json$Json$Decode$errorToString(decodeError),
                he: entityName
            })));
        };
        var _v0 = $author$project$Firestore$Sub$processChanges_fn(docChanges, collection_);
        var collection = _v0._;
        var changes = _v0.bl;
        var errors = _v0.br;
        return _Utils_Tuple3(toNewEnv(collection), changes, $elm$core$Platform$Cmd$batch($elm$core$List$map_fn(convertDecodeError, errors)));
    }, $author$project$Util$Firestore$processChanges = F4($author$project$Util$Firestore$processChanges_fn);
    var $author$project$Routing$currentPersonId = function (route) {
        if (route.$ === 9) {
            var personId = route.a;
            return $elm$core$Maybe$Just(personId);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Page$Person$RecomputePotentialDupes = { $: 14 };
    var $author$project$Page$Person$recomputePotentialDupes = $author$project$Page$Person$RecomputePotentialDupes;
    var $author$project$Update$recomputePotentialDupesHelp_fn = function (env, docChanges) {
        var shouldRecomputeDupes = $elm_community$maybe_extra$Maybe$Extra$isJust($author$project$Routing$currentPersonId(env.oe)) && ($author$project$Update$isPeople_fn(env, docChanges.at) && $elm$core$List$any_fn(function (doc) {
            return doc.oO === 4;
        }, docChanges.n));
        return $author$project$Util$Cmd$when_fn(shouldRecomputeDupes, $author$project$Util$Cmd$executeMsg($author$project$Model$HandlePageMsg($author$project$Model$PersonMsg($author$project$Page$Person$recomputePotentialDupes))));
    }, $author$project$Update$recomputePotentialDupesHelp = F2($author$project$Update$recomputePotentialDupesHelp_fn);
    var $author$project$Page$Note$RegenerateActionItemsCache = function (a) {
        return { $: 33, a: a };
    };
    var $author$project$Page$Note$regenerateActionItemsCache = $author$project$Page$Note$RegenerateActionItemsCache;
    var $author$project$Update$regenerateActionItemsCacheHelp_fn = function (env, docChanges) {
        var shouldRegenerateActionItemsCache = $elm_community$maybe_extra$Maybe$Extra$isJust($author$project$Routing$currentNoteId(env.oe)) && (($author$project$Update$isPeople_fn(env, docChanges.at) || $author$project$Update$isNotes_fn(env, docChanges.at)) && $elm$core$List$any_fn(function (doc) {
            return (doc.oO === 4) || (doc.oO === 3);
        }, docChanges.n));
        return $author$project$Util$Cmd$when_fn(shouldRegenerateActionItemsCache, $author$project$Util$Cmd$executeMsg($author$project$Model$HandlePageMsg($author$project$Model$NoteMsg($author$project$Page$Note$regenerateActionItemsCache({
            o6: (!env.mK.iq) && $author$project$Update$isNotes_fn(env, docChanges.at)
        })))));
    }, $author$project$Update$regenerateActionItemsCacheHelp = F2($author$project$Update$regenerateActionItemsCacheHelp_fn);
    var $author$project$Data$Note$collectionPath = function (_v0) {
        var id = _v0.l8;
        return "/accounts/" + (id + "/notes");
    };
    var $rluiten$elm_text_search$ElmTextSearch$Json$Encoder$corpusTokensEncoder = function (setVal) {
        return $elm$json$Json$Encode$list_fn($elm$json$Json$Encode$string, $elm$core$Set$toList(setVal));
    };
    var $rluiten$elm_text_search$ElmTextSearch$Json$Encoder$documentStoreEncoder = function (dict) {
        return $elm$json$Json$Encode$object($elm$core$List$map_fn(function (_v0) {
            var key = _v0.a;
            var val = _v0.b;
            return _Utils_Tuple2(key, $elm$json$Json$Encode$list_fn($elm$json$Json$Encode$string, $elm$core$Set$toList(val)));
        }, $elm$core$Dict$toList(dict)));
    };
    var $rluiten$trie$Trie$Json$Encoder$encoderValDict_fn = function (valEnc, refValues) {
        return $elm$json$Json$Encode$object($elm$core$List$map_fn(function (_v0) {
            var key = _v0.a;
            var val = _v0.b;
            return _Utils_Tuple2(key, valEnc(val));
        }, $elm$core$Dict$toList(refValues)));
    }, $rluiten$trie$Trie$Json$Encoder$encoderValDict = F2($rluiten$trie$Trie$Json$Encoder$encoderValDict_fn);
    var $rluiten$trie$Trie$Json$Encoder$encoder_fn = function (valEnc, trie) {
        switch (trie.$) {
            case 0:
                return $elm$json$Json$Encode$null;
            case 1:
                var refValues = trie.a;
                return $rluiten$trie$Trie$Json$Encoder$encoderValDict_fn(valEnc, refValues);
            case 2:
                var trieDict = trie.a;
                return $rluiten$trie$Trie$Json$Encoder$encoderTrieDict_fn(valEnc, trieDict);
            default:
                var _v2 = trie.a;
                var refValues = _v2.a;
                var trieDict = _v2.b;
                var encodedValues = $rluiten$trie$Trie$Json$Encoder$encoderValDict_fn(valEnc, refValues);
                var encodedDict = $rluiten$trie$Trie$Json$Encoder$encoderTrieDict_fn(valEnc, trieDict);
                return $elm$json$Json$Encode$list_fn($elm$core$Basics$identity, _List_fromArray([encodedValues, encodedDict]));
        }
    }, $rluiten$trie$Trie$Json$Encoder$encoder = F2($rluiten$trie$Trie$Json$Encoder$encoder_fn);
    var $rluiten$trie$Trie$Json$Encoder$encoderTrieDict_fn = function (valEnc, trieDict) {
        return $elm$json$Json$Encode$object($elm$core$List$map_fn(function (_v0) {
            var key = _v0.a;
            var val = _v0.b;
            return _Utils_Tuple2(key, $rluiten$trie$Trie$Json$Encoder$encoder_fn(valEnc, val));
        }, $elm$core$Dict$toList(trieDict)));
    }, $rluiten$trie$Trie$Json$Encoder$encoderTrieDict = F2($rluiten$trie$Trie$Json$Encoder$encoderTrieDict_fn);
    var $rluiten$elm_text_search$ElmTextSearch$Json$Encoder$tokenStore_a0 = $elm$json$Json$Encode$float, $rluiten$elm_text_search$ElmTextSearch$Json$Encoder$tokenStore = $rluiten$trie$Trie$Json$Encoder$encoder($rluiten$elm_text_search$ElmTextSearch$Json$Encoder$tokenStore_a0);
    var $rluiten$elm_text_search$ElmTextSearch$Json$Encoder$codecIndexRecordEncoder = function (rec) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("indexVersion", $elm$json$Json$Encode$string(rec.fA)),
            _Utils_Tuple2("indexType", $elm$json$Json$Encode$string(rec.hP)),
            _Utils_Tuple2("documentStore", $rluiten$elm_text_search$ElmTextSearch$Json$Encoder$documentStoreEncoder(rec.fe)),
            _Utils_Tuple2("corpusTokens", $rluiten$elm_text_search$ElmTextSearch$Json$Encoder$corpusTokensEncoder(rec.e7)),
            _Utils_Tuple2("tokenStore", $rluiten$trie$Trie$Json$Encoder$encoder_fn($rluiten$elm_text_search$ElmTextSearch$Json$Encoder$tokenStore_a0, rec.gk))
        ]));
    };
    var $rluiten$elm_text_search$ElmTextSearch$Json$Encoder$encoder = function (_v0) {
        var irec = _v0;
        return $rluiten$elm_text_search$ElmTextSearch$Json$Encoder$codecIndexRecordEncoder((new $$Record74(irec.e7, irec.fe, irec.hP, irec.fA, irec.gk)));
    };
    var $rluiten$elm_text_search$ElmTextSearch$storeToString = function (index) {
        return _Json_encode_fn(0, $rluiten$elm_text_search$ElmTextSearch$Json$Encoder$encoder(index));
    };
    var $author$project$Search$Index$encodeIndex = function (index) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("index", $elm$json$Json$Encode$string($rluiten$elm_text_search$ElmTextSearch$storeToString(index.ao))),
            _Utils_Tuple2("configVersion", $elm$json$Json$Encode$int(index.bn)),
            _Utils_Tuple2("updatedAt", $elm$json$Json$Encode$int($elm$time$Time$posixToMillis(index.pR)))
        ]));
    };
    var $author$project$Search$Index$saveSearchIndex = _Platform_outgoingPort("saveSearchIndex", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("data", $elm$core$Basics$identity($.a)),
            _Utils_Tuple2("path", $elm$json$Json$Encode$string($.at))
        ]));
    });
    var $author$project$Search$Index$saveNotes_fn = function (index, user) {
        return $author$project$Search$Index$saveSearchIndex((new $$Record101($author$project$Search$Index$encodeIndex(index), $author$project$Data$Note$collectionPath(user))));
    }, $author$project$Search$Index$saveNotes = F2($author$project$Search$Index$saveNotes_fn);
    var $author$project$Update$saveNotesIndexHelper_fn = function (oldModel, _v0) {
        var newModel = _v0.a;
        var cmd = _v0.b;
        return ((!oldModel.dW.mK.iq) && (!_Utils_eq(oldModel.op.fO.pR, newModel.op.fO.pR))) ? _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
            cmd,
            $author$project$Util$Cmd$whenJust_fn(newModel.dW.pV, $author$project$Search$Index$saveNotes(newModel.op.fO))
        ]))) : _Utils_Tuple2(newModel, cmd);
    }, $author$project$Update$saveNotesIndexHelper = F2($author$project$Update$saveNotesIndexHelper_fn);
    var $author$project$Data$Person$collectionPath = function (_v0) {
        var id = _v0.l8;
        return "/accounts/" + (id + "/people");
    };
    var $author$project$Search$Index$savePeople_fn = function (index, user) {
        return $author$project$Search$Index$saveSearchIndex((new $$Record101($author$project$Search$Index$encodeIndex(index), $author$project$Data$Person$collectionPath(user))));
    }, $author$project$Search$Index$savePeople = F2($author$project$Search$Index$savePeople_fn);
    var $author$project$Update$savePeopleIndexHelper_fn = function (oldModel, _v0) {
        var newModel = _v0.a;
        var cmd = _v0.b;
        return ((!oldModel.dW.mK.iA) && (!_Utils_eq(oldModel.op.iz.pR, newModel.op.iz.pR))) ? _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
            cmd,
            $author$project$Util$Cmd$whenJust_fn(newModel.dW.pV, $author$project$Search$Index$savePeople(newModel.op.iz))
        ]))) : _Utils_Tuple2(newModel, cmd);
    }, $author$project$Update$savePeopleIndexHelper = F2($author$project$Update$savePeopleIndexHelper_fn);
    var $author$project$Data$Settings$saveUserSettingsToLocalStorage = _Platform_outgoingPort("saveUserSettingsToLocalStorage", $elm$core$Basics$identity);
    var $author$project$Data$Settings$saveToLocalStorage = function (settings) {
        return $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $author$project$Data$Settings$encode, $author$project$Data$Settings$saveUserSettingsToLocalStorage), $author$project$Firestore$Collection$get_fn($author$project$Data$Settings$fixedDocId, settings)));
    };
    var $author$project$Page$Search$SearchIndicesUpdated = { $: 2 };
    var $author$project$Page$Search$searchIndicesUpdated = $author$project$Page$Search$SearchIndicesUpdated;
    var $author$project$Data$Event$stripTimeSymbols_a0 = A2($elm$core$String$replace, ":", ""), $author$project$Data$Event$stripTimeSymbols_a1 = A2($elm$core$String$replace, "-", ""), $author$project$Data$Event$stripTimeSymbols = A2($elm$core$Basics$composeR, $author$project$Data$Event$stripTimeSymbols_a0, $author$project$Data$Event$stripTimeSymbols_a1);
    var $author$project$Data$Event$formatISO8601DateTime = function (time) {
        return $elm$core$Basics$composeR_fn($author$project$Data$Event$stripTimeSymbols_a0, $author$project$Data$Event$stripTimeSymbols_a1, $jweir$elm_iso8601$ISO8601$toString(function () {
            var $r = time.$c();
            $r.m1 = 0;
            return $r;
        }()));
    };
    var $author$project$Data$Event$formatiCalendarDatetime = function (startTime) {
        return $author$project$Data$Event$formatISO8601DateTime($jweir$elm_iso8601$ISO8601$fromPosix(startTime));
    };
    var $author$project$Data$Event$After = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$Event$Before = { $: 0 };
    var $author$project$Data$Event$Within = { $: 2 };
    var $author$project$Data$Event$getBoundary_fn = function (instanceOrigStart, dtStart, rrule) {
        if (!$author$project$Data$Time$compare_fn($elm$time$Time$utc, instanceOrigStart, dtStart)) {
            return $author$project$Data$Event$Before;
        }
        else {
            var _v0 = rrule.pO;
            if ((!_v0.$) && (_v0.a.$ === 1)) {
                var until = _v0.a.a;
                var until_ = $author$project$Data$Time$Time((new $$Record26(until, 0)));
                return ($author$project$Data$Time$compare_fn($elm$time$Time$utc, instanceOrigStart, until_) === 2) ? $author$project$Data$Event$After({ jz: until_ }) : $author$project$Data$Event$Within;
            }
            else {
                return $author$project$Data$Event$Within;
            }
        }
    }, $author$project$Data$Event$getBoundary = F3($author$project$Data$Event$getBoundary_fn);
    var $author$project$Util$Time$mergeTimeAndDate_fn = function (zone, t1_, t2_) {
        var _v0 = _Utils_Tuple2($justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, t1_), $justinmimbs$time_extra$Time$Extra$posixToParts_fn(zone, t2_));
        var t1 = _v0.a;
        var t2 = _v0.b;
        return $justinmimbs$time_extra$Time$Extra$partsToPosix_fn(zone, $$update__bO__bz__lb(t1, t2.bO, t2.bz, t2.lb));
    }, $author$project$Util$Time$mergeTimeAndDate = F3($author$project$Util$Time$mergeTimeAndDate_fn);
    var $author$project$Data$Time$withoutZone = function (time) {
        if (!time.$) {
            var data = time.a;
            return $author$project$Data$Time$Time((new $$Record26(data.gh, 0)));
        }
        else {
            var date = time.a;
            return $author$project$Data$Time$Date(date);
        }
    };
    var $author$project$Data$Event$boundaryGuardHelper_fn = function (events, instanceOriginalStart, masterEvent) {
        var toSoftMasterId = function (until) {
            var _v2 = _Utils_Tuple2(until, instanceOriginalStart);
            if (_v2.a.$ === 1) {
                var untilDate = _v2.a.a;
                return _Utils_ap($author$project$Data$Event$baseId(masterEvent.l8) + "_R", $elm$core$Basics$composeR_fn($author$project$Data$Event$stripTimeSymbols_a0, $author$project$Data$Event$stripTimeSymbols_a1, $justinmimbs$date$Date$toIsoString($justinmimbs$date$Date$add_fn(3, 1, untilDate))));
            }
            else {
                if (!_v2.b.$) {
                    var untilTime = _v2.a.a;
                    var instanceOrigStart = _v2.b.a;
                    return _Utils_ap($author$project$Data$Event$baseId(masterEvent.l8) + "_R", $elm$core$String$dropRight_fn(1, $author$project$Data$Event$formatiCalendarDatetime($author$project$Util$Time$mergeTimeAndDate_fn($elm$time$Time$utc, instanceOrigStart.gh, $author$project$Util$Time$add_fn($author$project$Util$Time$second, untilTime.gh)))));
                }
                else {
                    return "impossible_state";
                }
            }
        };
        var getSoftMasterHelper = function (until) {
            return $elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, function ($) {
                return $.lh;
            }), $elm$core$Dict$get_fn(toSoftMasterId(until), events));
        };
        var _v0 = masterEvent.pv;
        if (_v0.$ === 1) {
            var rrule = _v0.a.fZ;
            var dtStart = _v0.a.b4;
            var _v1 = $author$project$Data$Event$getBoundary_fn(instanceOriginalStart, $author$project$Data$Time$withoutZone(dtStart), rrule);
            switch (_v1.$) {
                case 2:
                    return $elm$core$Maybe$Just(masterEvent);
                case 1:
                    var until = _v1.a.jz;
                    return $elm$core$Maybe$andThen_fn(A2($author$project$Data$Event$boundaryGuardHelper, events, instanceOriginalStart), getSoftMasterHelper(until));
                default:
                    return $elm$core$Maybe$Nothing;
            }
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Data$Event$boundaryGuardHelper = F3($author$project$Data$Event$boundaryGuardHelper_fn);
    var $author$project$Data$Time$fromIsoString = function (str) {
        return $elm$core$Result$mapError_fn($elm$json$Json$Decode$errorToString, _Json_run_fn($author$project$Data$Time$decodeZoneless, $elm$json$Json$Encode$string(str)));
    };
    var $author$project$Data$Event$extractTimeFromId = function (eventId) {
        var softMasterTime = $elm_community$string_extra$String$Extra$rightOfBack_fn("_R", eventId);
        var instanceTime = $elm_community$string_extra$String$Extra$rightOfBack_fn("_", eventId);
        var isoString = $elm$core$String$isEmpty(softMasterTime) ? instanceTime : softMasterTime;
        return $elm$core$Result$toMaybe($author$project$Data$Time$fromIsoString(isoString));
    };
    var $author$project$Data$Event$boundaryGuard_fn = function (events, instanceId, masterEvent) {
        return $elm$core$Maybe$andThen_fn(function (time) {
            return $author$project$Data$Event$boundaryGuardHelper_fn(events, time, masterEvent);
        }, $author$project$Data$Event$extractTimeFromId(instanceId));
    }, $author$project$Data$Event$boundaryGuard = F3($author$project$Data$Event$boundaryGuard_fn);
    var $author$project$Util$Time$isAfter_fn = function (t1, t2) {
        return _Utils_cmp($elm$time$Time$posixToMillis(t2), $elm$time$Time$posixToMillis(t1)) > 0;
    }, $author$project$Util$Time$isAfter = F2($author$project$Util$Time$isAfter_fn);
    var $elm_community$maybe_extra$Maybe$Extra$orElseLazy_fn = function (fma, mb) {
        if (mb.$ === 1) {
            return fma(0);
        }
        else {
            return mb;
        }
    }, $elm_community$maybe_extra$Maybe$Extra$orElseLazy = F2($elm_community$maybe_extra$Maybe$Extra$orElseLazy_fn);
    var $author$project$Data$Time$diffMillis_fn = function (zone, time1, time2) {
        return $author$project$Data$Time$toMillis_fn(zone, time1) - $author$project$Data$Time$toMillis_fn(zone, time2);
    }, $author$project$Data$Time$diffMillis = F3($author$project$Data$Time$diffMillis_fn);
    var $author$project$Data$Note$eventAttendeeToAttendee_fn = function (overridenResponseStatus, attendee) {
        return $author$project$Util$Misc$toJustIf_fn(!attendee.ev, (new $$Record31($elm$core$Maybe$Just(attendee.fW), false, attendee.b, overridenResponseStatus, $author$project$Data$Note$EmailRef(attendee.cS))));
    }, $author$project$Data$Note$eventAttendeeToAttendee = F2($author$project$Data$Note$eventAttendeeToAttendee_fn);
    var $author$project$Data$Note$mergeAttendees_fn = function (noteAttendees, event) {
        var toDict = A2($elm$core$Basics$composeR, $elm$core$List$map(function (a) {
            return _Utils_Tuple2(a.cS, a);
        }), $elm$core$Dict$fromList);
        var personRefAttendees = $elm$core$List$filterMap_fn(function (a) {
            var _v5 = a.n3;
            if (!_v5.$) {
                return $elm$core$Maybe$Just(a);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, noteAttendees);
        var onlyInNote = F3(function (_v4, noteAttendee, acc) {
            return noteAttendee.mR ? _List_Cons(noteAttendee, acc) : acc;
        });
        var onlyInEvent = F2(function (_v3, eventAttendee) {
            return $elm_community$maybe_extra$Maybe$Extra$cons($author$project$Data$Note$eventAttendeeToAttendee_fn($elm$core$Maybe$Nothing, eventAttendee));
        });
        var noteEmailRefAttendees = $elm$core$Dict$fromList($elm$core$List$filterMap_fn(function (a) {
            var _v2 = a.n3;
            if (_v2.$ === 1) {
                var email = _v2.a;
                return $elm$core$Maybe$Just(_Utils_Tuple2(email, a));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, noteAttendees));
        var inBoth = F3(function (_v1, eventAttendee, noteAttendee) {
            return $elm_community$maybe_extra$Maybe$Extra$cons($author$project$Data$Note$eventAttendeeToAttendee_fn(noteAttendee.nH, eventAttendee));
        });
        return _Utils_ap(personRefAttendees, _List_sortBy_fn(function (attendee) {
            var _v0 = attendee.n3;
            if (_v0.$ === 1) {
                var email = _v0.a;
                return email;
            }
            else {
                var personId = _v0.a;
                return personId;
            }
        }, $elm$core$Dict$merge_fn(onlyInEvent, inBoth, onlyInNote, toDict(_List_Cons(event.c8, event.ke)), noteEmailRefAttendees, _List_Nil)));
    }, $author$project$Data$Note$mergeAttendees = F2($author$project$Data$Note$mergeAttendees_fn);
    var $author$project$Data$Event$formatiCalendarDate_a0 = $justinmimbs$date$Date$toIsoString, $author$project$Data$Event$formatiCalendarDate_a1 = $author$project$Data$Event$stripTimeSymbols, $author$project$Data$Event$formatiCalendarDate = A2($elm$core$Basics$composeR, $author$project$Data$Event$formatiCalendarDate_a0, $author$project$Data$Event$formatiCalendarDate_a1);
    var $author$project$Data$Event$toInstanceId_fn = function (masterId_, instanceOriginalStart) {
        if (!instanceOriginalStart.$) {
            var time = instanceOriginalStart.a.gh;
            return $author$project$Data$Event$baseId(masterId_) + ("_" + $author$project$Data$Event$formatiCalendarDatetime(time));
        }
        else {
            var date = instanceOriginalStart.a;
            return $author$project$Data$Event$baseId(masterId_) + ("_" + $elm$core$Basics$composeR_fn($author$project$Data$Event$formatiCalendarDate_a0, $author$project$Data$Event$formatiCalendarDate_a1, date));
        }
    }, $author$project$Data$Event$toInstanceId = F2($author$project$Data$Event$toInstanceId_fn);
    var $author$project$Data$Note$updateFromEvent_fn = function (note, event) {
        var updateRemainingFields = function (note_) {
            return function () {
                var $r = note_.$c();
                $r.kT = event.kT;
                $r.ke = $author$project$Data$Note$mergeAttendees_fn(note_.ke, event);
                $r.lv = $elm$core$Maybe$Just(event.gj);
                return $r;
            }();
        };
        var toInstance = F2(function (masterId, _v6) {
            var instanceStart = _v6.a;
            var instanceEnd = _v6.b;
            return $$update__fh__gh__hh(note, instanceEnd, instanceStart, $elm$core$Maybe$Just($author$project$Data$Note$Instance({
                Q: $author$project$Data$Event$toInstanceId_fn(event.l8, instanceStart),
                mT: masterId,
                dr: event.dr
            })));
        });
        var recomputeInstanceTime = F2(function (instanceId, dtStart) {
            var _v4 = _Utils_Tuple2($author$project$Data$Event$extractTimeFromId(instanceId), dtStart);
            _v4$2: while (true) {
                if (!_v4.a.$) {
                    if (_v4.a.a.$ === 1) {
                        if (_v4.b.$ === 1) {
                            var date = _v4.a.a.a;
                            var meetingDurationDays = function () {
                                var _v5 = _Utils_Tuple2(event.oN, event.fh);
                                if ((_v5.a.$ === 1) && (_v5.b.$ === 1)) {
                                    var startDate = _v5.a.a;
                                    var endDate = _v5.b.a;
                                    return $justinmimbs$date$Date$diff_fn(3, startDate, endDate);
                                }
                                else {
                                    return 0;
                                }
                            }();
                            var meetingEndDate = $justinmimbs$date$Date$add_fn(3, meetingDurationDays, date);
                            return _Utils_Tuple2($author$project$Data$Time$Date(date), $author$project$Data$Time$Date(meetingEndDate));
                        }
                        else {
                            break _v4$2;
                        }
                    }
                    else {
                        if (!_v4.b.$) {
                            var time = _v4.a.a.a.gh;
                            var masterStart = _v4.b.a;
                            var newStart = $author$project$Util$Time$mergeTimeAndDate_fn(masterStart.gw.p8(0), masterStart.gh, time);
                            var meetingDurationMillis = $author$project$Data$Time$diffMillis_fn($elm$time$Time$utc, event.fh, event.oN);
                            return _Utils_Tuple2($author$project$Data$Time$Time((new $$Record26(newStart, 0))), $author$project$Data$Time$Time((new $$Record26($author$project$Util$Time$add_fn(meetingDurationMillis, newStart), 0))));
                        }
                        else {
                            break _v4$2;
                        }
                    }
                }
                else {
                    break _v4$2;
                }
            }
            return _Utils_Tuple2(note.gh, note.fh);
        });
        var updatedNote = function () {
            var _v0 = _Utils_Tuple2(note.hh, event.pv);
            if (!_v0.a.$) {
                if (_v0.a.a.$ === 1) {
                    switch (_v0.b.$) {
                        case 1:
                            var instanceId = _v0.a.a.a.Q;
                            var dtStart = _v0.b.a.b4;
                            return updateRemainingFields(A2(toInstance, event.l8, A2(recomputeInstanceTime, instanceId, dtStart)));
                        case 2:
                            var instanceId = _v0.a.a.a.Q;
                            var masterId = _v0.b.a.mT;
                            return updateRemainingFields($$update__fh__gh__hh(note, $author$project$Data$Time$withoutZone(event.fh), $author$project$Data$Time$withoutZone(event.oN), $elm$core$Maybe$Just($author$project$Data$Note$Instance({ Q: instanceId, mT: masterId, dr: event.dr }))));
                        default:
                            var _v1 = _v0.b;
                            return note;
                    }
                }
                else {
                    switch (_v0.b.$) {
                        case 0:
                            var eventId = _v0.a.a.a.b7;
                            var _v2 = _v0.b;
                            return updateRemainingFields($$update__fh__gh__hh(note, $author$project$Data$Time$withoutZone(event.fh), $author$project$Data$Time$withoutZone(event.oN), $elm$core$Maybe$Just($author$project$Data$Note$Single({ b7: eventId, dr: event.dr }))));
                        case 1:
                            return updateRemainingFields(A2(toInstance, event.l8, _Utils_Tuple2($author$project$Data$Time$withoutZone(event.oN), $author$project$Data$Time$withoutZone(event.fh))));
                        default:
                            return note;
                    }
                }
            }
            else {
                var _v3 = _v0.a;
                return note;
            }
        }();
        return _Utils_eq(note, updatedNote) ? note : function () {
            var $r = updatedNote.$c();
            $r.fR = updatedNote.fR + 1;
            return $r;
        }();
    }, $author$project$Data$Note$updateFromEvent = F2($author$project$Data$Note$updateFromEvent_fn);
    var $author$project$Data$Note$updateFromEvents_fn = function (events, note) {
        var updateFromEventHelp = F2(function (lastSyncTime, event) {
            return $author$project$Util$Time$isAfter_fn(lastSyncTime, event.dr) ? $author$project$Data$Note$updateFromEvent_fn(note, event) : note;
        });
        var getEventHelper = function (eventId) {
            return $elm_community$maybe_extra$Maybe$Extra$filter_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, function ($) {
                return $.lh;
            }), $elm$core$Dict$get_fn(eventId, events));
        };
        var noteFromMaster = F4(function (lastEventSync, instanceId, masterId, _v2) {
            return $elm$core$Maybe$map_fn(updateFromEventHelp(lastEventSync), $elm$core$Maybe$andThen_fn(A2($author$project$Data$Event$boundaryGuard, events, instanceId), getEventHelper(masterId)));
        });
        var noteFromNonMaster = F2(function (lastEventSync, nonMasterId) {
            return $elm$core$Maybe$map_fn(updateFromEventHelp(lastEventSync), getEventHelper(nonMasterId));
        });
        var noteFromSoftMasterRevert = F3(function (lastEventUpdate, softMasterId, _v1) {
            return $elm$core$Maybe$map_fn(updateFromEventHelp(lastEventUpdate), getEventHelper($author$project$Data$Event$baseId(softMasterId)));
        });
        var _v0 = note.hh;
        if (!_v0.$) {
            if (!_v0.a.$) {
                var eventId = _v0.a.a.b7;
                var updated = _v0.a.a.dr;
                return $elm$core$Maybe$withDefault_fn(note, A2(noteFromNonMaster, updated, eventId));
            }
            else {
                var instanceId = _v0.a.a.Q;
                var masterId = _v0.a.a.mT;
                var updated = _v0.a.a.dr;
                return $elm$core$Maybe$withDefault_fn(note, $elm_community$maybe_extra$Maybe$Extra$orElseLazy_fn(A2(noteFromSoftMasterRevert, updated, masterId), $elm_community$maybe_extra$Maybe$Extra$orElseLazy_fn(A3(noteFromMaster, updated, instanceId, masterId), A2(noteFromNonMaster, updated, instanceId))));
            }
        }
        else {
            return note;
        }
    }, $author$project$Data$Note$updateFromEvents = F2($author$project$Data$Note$updateFromEvents_fn);
    var $author$project$Error$SearchIndexUpdate = function (a) {
        return { $: 6, a: a };
    };
    var $rluiten$trie$TrieModel$addByStr_fn = function (_v0, key, trie) {
        var ref = _v0.a;
        var value = _v0.b;
        if (!key.b) {
            switch (trie.$) {
                case 0:
                    return $rluiten$trie$TrieModel$ValNode($elm$core$Dict$singleton_fn(ref, value));
                case 1:
                    var refValues = trie.a;
                    return $rluiten$trie$TrieModel$ValNode($elm$core$Dict$insert_fn(ref, value, refValues));
                case 2:
                    var trieDict = trie.a;
                    return $rluiten$trie$TrieModel$ValTrieNode(_Utils_Tuple2($elm$core$Dict$singleton_fn(ref, value), trieDict));
                default:
                    var _v3 = trie.a;
                    var refValues = _v3.a;
                    var trieDict = _v3.b;
                    return $rluiten$trie$TrieModel$ValTrieNode(_Utils_Tuple2($elm$core$Dict$insert_fn(ref, value, refValues), trieDict));
            }
        }
        else {
            var keyHead = key.a;
            var keyTail = key.b;
            var updateTrieDict = function (trieDict) {
                var updatedSubTrie = $rluiten$trie$TrieModel$addByStr_fn(_Utils_Tuple2(ref, value), keyTail, $elm$core$Maybe$withDefault_fn($rluiten$trie$TrieModel$EmptyTrie, $elm$core$Dict$get_fn(keyHead, trieDict)));
                return $elm$core$Dict$insert_fn(keyHead, updatedSubTrie, trieDict);
            };
            var lazyNewTrieDict = function (_v6) {
                return $elm$core$Dict$singleton_fn(keyHead, $rluiten$trie$TrieModel$addByStr_fn(_Utils_Tuple2(ref, value), keyTail, $rluiten$trie$TrieModel$EmptyTrie));
            };
            switch (trie.$) {
                case 0:
                    return $rluiten$trie$TrieModel$TrieNode(lazyNewTrieDict(0));
                case 1:
                    var refValues = trie.a;
                    return $rluiten$trie$TrieModel$ValTrieNode(_Utils_Tuple2(refValues, lazyNewTrieDict(0)));
                case 2:
                    var trieDict = trie.a;
                    return $rluiten$trie$TrieModel$TrieNode(updateTrieDict(trieDict));
                default:
                    var _v5 = trie.a;
                    var refValues = _v5.a;
                    var trieDict = _v5.b;
                    return $rluiten$trie$TrieModel$ValTrieNode(_Utils_Tuple2(refValues, updateTrieDict(trieDict)));
            }
        }
    }, $rluiten$trie$TrieModel$addByStr = F3($rluiten$trie$TrieModel$addByStr_fn);
    var $rluiten$trie$TrieModel$add_fn = function (refValues, key, trie) {
        return $rluiten$trie$TrieModel$addByStr_fn(refValues, $rluiten$trie$TrieModel$toListString(key), trie);
    }, $rluiten$trie$TrieModel$add = F3($rluiten$trie$TrieModel$add_fn);
    var $rluiten$trie$Trie$add = $rluiten$trie$TrieModel$add;
    var $rluiten$elm_text_search$Index$scoreToken_fn = function (fieldTokensAndBoost, token) {
        var score = F2(function (_v0, scoreSum) {
            var tokenSet = _v0.a;
            var fieldBoost = _v0.b;
            if ($elm$core$Set$isEmpty(tokenSet)) {
                return scoreSum;
            }
            else {
                var tokenBoost = $elm$core$Set$member_fn(token, tokenSet) ? (fieldBoost / $elm$core$Set$size(tokenSet)) : 0;
                return scoreSum + tokenBoost;
            }
        });
        return _Utils_Tuple2(token, $elm$core$List$foldr_fn(score, 0, fieldTokensAndBoost));
    }, $rluiten$elm_text_search$Index$scoreToken = F2($rluiten$elm_text_search$Index$scoreToken_fn);
    var $rluiten$elm_text_search$Index$addDoc_fn = function (docRef, fieldsTokens, docTokens, index) {
        var irec = index;
        var updatedDocumentStore = $elm$core$Dict$insert_fn(docRef, docTokens, irec.fe);
        var updatedCorpusTokens = $elm$core$Set$union_fn(irec.e7, docTokens);
        var updatedCorpusTokensIndex = $rluiten$elm_text_search$Index$Utils$buildOrderIndex(updatedCorpusTokens);
        var allBoosts = $elm$core$List$append_fn($elm$core$List$map_fn($elm$core$Tuple$second, irec.h2), $elm$core$List$map_fn($elm$core$Tuple$second, irec.hs));
        var fieldTokensAndBoosts = _List_map2_fn($elm$core$Tuple$pair, fieldsTokens, allBoosts);
        var tokenAndScores = $elm$core$List$map_fn($rluiten$elm_text_search$Index$scoreToken(fieldTokensAndBoosts), $elm$core$Set$toList(docTokens));
        var addTokenScore = F2(function (_v0, trie) {
            var token = _v0.a;
            var score = _v0.b;
            return $rluiten$trie$TrieModel$add_fn(_Utils_Tuple2(docRef, score), token, trie);
        });
        var updatedTokenStore = $elm$core$List$foldr_fn(addTokenScore, irec.gk, tokenAndScores);
        return function () {
            var $r = irec.$c();
            $r.e7 = updatedCorpusTokens;
            $r.fe = updatedDocumentStore;
            $r.fs = $elm$core$Dict$empty;
            $r.g$ = updatedCorpusTokensIndex;
            $r.gk = updatedTokenStore;
            return $r;
        }();
    }, $rluiten$elm_text_search$Index$addDoc = F4($rluiten$elm_text_search$Index$addDoc_fn);
    var $rluiten$elm_text_search$Index$getWordsForField_fn = function (doc, getField, _v0) {
        var index = _v0.a;
        var fieldsLists = _v0.b;
        var _v1 = $rluiten$elm_text_search$Index$Utils$getTokens_fn(index, getField(doc));
        var u1index = _v1.a;
        var tokens = _v1.b;
        return _Utils_Tuple2(u1index, _List_Cons(tokens, fieldsLists));
    }, $rluiten$elm_text_search$Index$getWordsForField = F3($rluiten$elm_text_search$Index$getWordsForField_fn);
    var $rluiten$elm_text_search$TokenProcessors$tokenizerWithRegexList_fn = function (seperatorRegex, listData) {
        var splitter = A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$regex$Regex$split(seperatorRegex), $elm$core$String$toLower), $elm$core$String$trim);
        var tokens = $elm$core$List$foldr_fn(F2(function (str, agg) {
            return $elm$core$List$append_fn(agg, splitter(str));
        }), _List_Nil, listData);
        return $elm$core$List$filter_fn(function (token) {
            return $elm$core$String$length(token) > 0;
        }, tokens);
    }, $rluiten$elm_text_search$TokenProcessors$tokenizerWithRegexList = F2($rluiten$elm_text_search$TokenProcessors$tokenizerWithRegexList_fn);
    var $rluiten$elm_text_search$TokenProcessors$tokenizerList_a0 = $rluiten$elm_text_search$TokenProcessors$defaultSeparator, $rluiten$elm_text_search$TokenProcessors$tokenizerList = $rluiten$elm_text_search$TokenProcessors$tokenizerWithRegexList($rluiten$elm_text_search$TokenProcessors$tokenizerList_a0);
    var $rluiten$elm_text_search$Index$Utils$getTokensList_fn = function (index, listString) {
        return $rluiten$elm_text_search$Index$Utils$processTokens_fn(index, $rluiten$elm_text_search$TokenProcessors$tokenizerWithRegexList_fn($rluiten$elm_text_search$TokenProcessors$tokenizerList_a0, listString));
    }, $rluiten$elm_text_search$Index$Utils$getTokensList = F2($rluiten$elm_text_search$Index$Utils$getTokensList_fn);
    var $rluiten$elm_text_search$Index$getWordsForFieldList_fn = function (doc, getFieldList, _v0) {
        var index = _v0.a;
        var fieldsLists = _v0.b;
        var _v1 = $rluiten$elm_text_search$Index$Utils$getTokensList_fn(index, getFieldList(doc));
        var u1index = _v1.a;
        var tokens = _v1.b;
        return _Utils_Tuple2(u1index, _List_Cons(tokens, fieldsLists));
    }, $rluiten$elm_text_search$Index$getWordsForFieldList = F3($rluiten$elm_text_search$Index$getWordsForFieldList_fn);
    var $rluiten$elm_text_search$Index$Utils$refExists_fn = function (docRef, _v0) {
        var irec = _v0;
        return $elm$core$Dict$member_fn(docRef, irec.fe);
    }, $rluiten$elm_text_search$Index$Utils$refExists = F2($rluiten$elm_text_search$Index$Utils$refExists_fn);
    var $rluiten$elm_text_search$Index$add_fn = function (doc, index) {
        var irec = index;
        var docRef = irec.n3(doc);
        if ($elm$core$String$isEmpty(docRef)) {
            return $elm$core$Result$Err("Error document has an empty unique id (ref).");
        }
        else {
            if ($rluiten$elm_text_search$Index$Utils$refExists_fn(docRef, index)) {
                return $elm$core$Result$Err("Error adding document that allready exists.");
            }
            else {
                var _v0 = $elm$core$List$foldr_fn($rluiten$elm_text_search$Index$getWordsForField(doc), _Utils_Tuple2(index, _List_Nil), $elm$core$List$map_fn($elm$core$Tuple$first, irec.hs));
                var u1index = _v0.a;
                var fieldsWordList = _v0.b;
                var _v1 = $elm$core$List$foldr_fn($rluiten$elm_text_search$Index$getWordsForFieldList(doc), _Utils_Tuple2(u1index, fieldsWordList), $elm$core$List$map_fn($elm$core$Tuple$first, irec.h2));
                var u2index = _v1.a;
                var u2fieldsWordList = _v1.b;
                var fieldsTokens = $elm$core$List$map_fn($elm$core$Set$fromList, u2fieldsWordList);
                var docTokens = $elm$core$List$foldr_fn($elm$core$Set$union, $elm$core$Set$empty, fieldsTokens);
                return $elm$core$Set$isEmpty(docTokens) ? $elm$core$Result$Err("Error after tokenisation there are no terms to index.") : $elm$core$Result$Ok($rluiten$elm_text_search$Index$addDoc_fn(docRef, fieldsTokens, docTokens, u2index));
            }
        }
    }, $rluiten$elm_text_search$Index$add = F2($rluiten$elm_text_search$Index$add_fn);
    var $rluiten$elm_text_search$Index$errorMessageNotIndex = "Error document is not in index.";
    var $rluiten$trie$TrieModel$removeByStr_fn = function (key, ref, trie) {
        if (!key.b) {
            switch (trie.$) {
                case 0:
                    return trie;
                case 1:
                    var refValues = trie.a;
                    return $rluiten$trie$TrieModel$ValNode($elm$core$Dict$remove_fn(ref, refValues));
                case 2:
                    var trieDict = trie.a;
                    return trie;
                default:
                    var _v2 = trie.a;
                    var refValues = _v2.a;
                    var trieDict = _v2.b;
                    return $rluiten$trie$TrieModel$ValTrieNode(_Utils_Tuple2($elm$core$Dict$remove_fn(ref, refValues), trieDict));
            }
        }
        else {
            var keyHead = key.a;
            var keyTail = key.b;
            var removeTrieDict = function (trieDict) {
                var _v5 = $elm$core$Dict$get_fn(keyHead, trieDict);
                if (_v5.$ === 1) {
                    return trieDict;
                }
                else {
                    var subTrie = _v5.a;
                    return $elm$core$Dict$insert_fn(keyHead, $rluiten$trie$TrieModel$removeByStr_fn(keyTail, ref, subTrie), trieDict);
                }
            };
            switch (trie.$) {
                case 0:
                    return trie;
                case 1:
                    var refValues = trie.a;
                    return trie;
                case 2:
                    var trieDict = trie.a;
                    return $rluiten$trie$TrieModel$TrieNode(removeTrieDict(trieDict));
                default:
                    var _v4 = trie.a;
                    var refValues = _v4.a;
                    var trieDict = _v4.b;
                    return $rluiten$trie$TrieModel$ValTrieNode(_Utils_Tuple2(refValues, removeTrieDict(trieDict)));
            }
        }
    }, $rluiten$trie$TrieModel$removeByStr = F3($rluiten$trie$TrieModel$removeByStr_fn);
    var $rluiten$trie$TrieModel$remove_fn = function (key, ref, trie) {
        return $rluiten$trie$TrieModel$removeByStr_fn($rluiten$trie$TrieModel$toListString(key), ref, trie);
    }, $rluiten$trie$TrieModel$remove = F3($rluiten$trie$TrieModel$remove_fn);
    var $rluiten$trie$Trie$remove = $rluiten$trie$TrieModel$remove;
    var $rluiten$elm_text_search$Index$removeDoc_fn = function (docRef, index, docTokens) {
        var irec = index;
        var updatedDocumentStore = $elm$core$Dict$remove_fn(docRef, irec.fe);
        var removeToken = F2(function (token, trie) {
            return $rluiten$trie$TrieModel$remove_fn(token, docRef, trie);
        });
        var updatedTokenStore = $elm$core$List$foldr_fn(removeToken, irec.gk, $elm$core$Set$toList(docTokens));
        return function () {
            var $r = irec.$c();
            $r.fe = updatedDocumentStore;
            $r.fs = $elm$core$Dict$empty;
            $r.gk = updatedTokenStore;
            return $r;
        }();
    }, $rluiten$elm_text_search$Index$removeDoc = F3($rluiten$elm_text_search$Index$removeDoc_fn);
    var $rluiten$elm_text_search$Index$remove_fn = function (doc, index) {
        var irec = index;
        var docRef = irec.n3(doc);
        return $elm$core$String$isEmpty(docRef) ? $elm$core$Result$Err("Error document has an empty unique id (ref).") : ((!$rluiten$elm_text_search$Index$Utils$refExists_fn(docRef, index)) ? $elm$core$Result$Err($rluiten$elm_text_search$Index$errorMessageNotIndex) : $elm$core$Result$Ok($elm$core$Maybe$withDefault_fn(index, $elm$core$Maybe$map_fn(A2($rluiten$elm_text_search$Index$removeDoc, docRef, index), $elm$core$Dict$get_fn(docRef, irec.fe)))));
    }, $rluiten$elm_text_search$Index$remove = F2($rluiten$elm_text_search$Index$remove_fn);
    var $rluiten$elm_text_search$Index$addOrUpdate_fn = function (doc, index) {
        var _v0 = $rluiten$elm_text_search$Index$remove_fn(doc, index);
        if (!_v0.$) {
            var u1index = _v0.a;
            return $rluiten$elm_text_search$Index$add_fn(doc, u1index);
        }
        else {
            var msg = _v0.a;
            return _Utils_eq(msg, $rluiten$elm_text_search$Index$errorMessageNotIndex) ? $rluiten$elm_text_search$Index$add_fn(doc, index) : $elm$core$Result$Err(msg);
        }
    }, $rluiten$elm_text_search$Index$addOrUpdate = F2($rluiten$elm_text_search$Index$addOrUpdate_fn);
    var $rluiten$elm_text_search$ElmTextSearch$addOrUpdate = $rluiten$elm_text_search$Index$addOrUpdate;
    var $author$project$Util$Time$latest_fn = function (a, b) {
        return $author$project$Util$Time$isAfter_fn(b, a) ? a : b;
    }, $author$project$Util$Time$latest = F2($author$project$Util$Time$latest_fn);
    var $author$project$Data$Timestamp$toMillis = function (timestamp) {
        if (!timestamp.$) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var posix = timestamp.a;
            return $elm$core$Maybe$Just($elm$time$Time$posixToMillis(posix));
        }
    };
    var $author$project$Search$Index$update_fn = function (docChanges, index) {
        return $elm$core$Tuple$mapSecond_fn(function (errs) {
            return $elm$core$List$isEmpty(errs) ? $elm$core$Platform$Cmd$none : $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$SearchIndexUpdate(errs)));
        }, $elm$core$List$foldl_fn_unwrapped(function (data, _v0) {
            var indexAcc = _v0.a;
            var errorsAcc = _v0.b;
            var docUpdatedAt = $elm$time$Time$millisToPosix($elm$core$Maybe$withDefault_fn(0, $author$project$Data$Timestamp$toMillis(data.ll.pR)));
            var newIndexUpdatedAt = $author$project$Util$Time$latest_fn(docUpdatedAt, indexAcc.pR);
            if ($author$project$Util$Time$isBefore_fn(index.pR, docUpdatedAt)) {
                return _Utils_Tuple2(indexAcc, errorsAcc);
            }
            else {
                var _v1 = $rluiten$elm_text_search$Index$addOrUpdate_fn(data, indexAcc.ao);
                if (!_v1.$) {
                    var newIndex = _v1.a;
                    return _Utils_Tuple2((new $$Record18(index.bn, newIndex, newIndexUpdatedAt)), errorsAcc);
                }
                else {
                    var errorStr = _v1.a;
                    return $elm$core$List$any_fn($elm$core$Basics$eq(errorStr), _List_fromArray(["Error after tokenisation there are no terms to index."])) ? _Utils_Tuple2(indexAcc, errorsAcc) : _Utils_Tuple2(indexAcc, _List_Cons(errorStr, errorsAcc));
                }
            }
        }, _Utils_Tuple2(index, _List_Nil), docChanges));
    }, $author$project$Search$Index$update = F2($author$project$Search$Index$update_fn);
    var $author$project$Update$updateSearchIndexHelper_fn = function (oldModel, oldIndex, toSearchIndices, _v0) {
        var newEnv = _v0.a;
        var changes = _v0.b;
        var cmds = _v0.c;
        var _v1 = $author$project$Search$Index$update_fn(changes, oldIndex);
        var newIndex = _v1.a;
        var errorLogs = _v1.b;
        return _Utils_Tuple2(function () {
            var $r = oldModel.$c();
            $r.dW = newEnv;
            $r.op = toSearchIndices(newIndex);
            return $r;
        }(), $elm$core$Platform$Cmd$batch(_List_fromArray([cmds, errorLogs])));
    }, $author$project$Update$updateSearchIndexHelper = F4($author$project$Update$updateSearchIndexHelper_fn);
    var $author$project$Update$processChanges_fn = function (model, docChanges) {
        var env = model.dW;
        var searchIndices = model.op;
        var toModel = function (newEnv) {
            return $$update__dW(model, newEnv);
        };
        var notesShouldSync = $author$project$Update$isNotes_fn(env, docChanges.at) && ((!$elm$core$Dict$isEmpty(env.lw)) && (!env.mK.iq));
        var syncWithEvents = function (notes) {
            return notesShouldSync ? A3($author$project$Firestore$Collection$foldl, F3(function (id, _v3, acc) {
                return $author$project$Firestore$Collection$update_fn(id, $author$project$Data$Note$updateFromEvents(env.lw), acc);
            }), notes, notes) : notes;
        };
        var _v0 = $author$project$Update$isNotes_fn(env, docChanges.at) ? $author$project$Update$saveNotesIndexHelper_fn(model, $author$project$Update$updateSearchIndexHelper_fn(model, searchIndices.fO, function (newIndex) {
            return $$update__fO(searchIndices, newIndex);
        }, $author$project$Util$Firestore$processChanges_fn(docChanges, env.fO, "Data.Note", function (notes) {
            return function () {
                var $r = env.$c();
                $r.fO = syncWithEvents(notes);
                $r.mK = $author$project$Data$LoadState$markNotesLoaded(env.mK);
                return $r;
            }();
        }))) : ($author$project$Update$isPeople_fn(env, docChanges.at) ? $author$project$Update$savePeopleIndexHelper_fn(model, $author$project$Update$updateSearchIndexHelper_fn(model, searchIndices.iz, function (newIndex) {
            return $$update__iz(searchIndices, newIndex);
        }, $author$project$Util$Firestore$processChanges_fn(docChanges, env.iz, "Data.People", function (people) {
            var userPersonId = $elm_community$maybe_extra$Maybe$Extra$isNothing(env.pY) ? $elm$core$Maybe$map_fn($author$project$Util$Triple$first, $elm$core$Maybe$andThen_fn(A2($elm$core$Basics$composeR, function ($) {
                return $.cS;
            }, A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Data$Person$findByEmail, people)), env.pV)) : env.pY;
            return function () {
                var $r = env.$c();
                $r.iz = people;
                $r.mK = $author$project$Data$LoadState$markPeopleLoaded(env.mK);
                $r.pY = userPersonId;
                return $r;
            }();
        }))) : ($author$project$Update$isSettings_fn(env, docChanges.at) ? function (_v1) {
            var newEnv_ = _v1.a;
            var errors = _v1.c;
            return _Utils_Tuple2(toModel(newEnv_), $elm$core$Platform$Cmd$batch(_List_fromArray([
                errors,
                $author$project$Util$Cmd$when_fn($elm$core$List$any_fn(function (_v2) {
                    var state = _v2.oO;
                    return (state === 4) || (state === 3);
                }, docChanges.n), $author$project$Data$Settings$saveToLocalStorage(newEnv_.be))
            ])));
        }($author$project$Util$Firestore$processChanges_fn(docChanges, env.be, "Data.Settings", function (settings) {
            var theme = $elm$core$Basics$composeR_fn($author$project$Data$Settings$theme_a0, $author$project$Data$Settings$theme_a1, (new $$Record41(settings)));
            return function () {
                var $r = env.$c();
                $r.be = settings;
                $r.nI = $author$project$Data$Color$paletteForTheme(theme);
                $r.pn = theme;
                return $r;
            }();
        })) : _Utils_Tuple2(toModel(env), $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$NotFound((new $$Record102("Collection", docChanges.at))))))));
        var newModel = _v0.a;
        var cmds = _v0.b;
        return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
            cmds,
            $author$project$Util$Cmd$when_fn(notesShouldSync, $author$project$Update$Util$delayedSaveNotes),
            $author$project$Update$regenerateActionItemsCacheHelp_fn(env, docChanges),
            $author$project$Update$recomputePotentialDupesHelp_fn(env, docChanges),
            $author$project$Util$Cmd$when_fn(!$author$project$Data$App$isLoading(env.mK), _Platform_map_fn($author$project$Model$SearchbarMsg, $author$project$Util$Cmd$executeMsg($author$project$Search$Bar$generateResult))),
            $author$project$Util$Cmd$executeMsg($author$project$Model$HandlePageMsg($author$project$Model$SearchMsg($author$project$Page$Search$searchIndicesUpdated)))
        ])));
    }, $author$project$Update$processChanges = F2($author$project$Update$processChanges_fn);
    var $author$project$Update$handleFirestoreMsg_fn = function (model, firestoreMsg) {
        if (!firestoreMsg.$) {
            var docChanges = firestoreMsg.a;
            return $author$project$Update$processChanges_fn(model, docChanges);
        }
        else {
            var subError = firestoreMsg.a;
            return _Utils_Tuple2(model, $author$project$Util$Firestore$handleSubError(subError));
        }
    }, $author$project$Update$handleFirestoreMsg = F2($author$project$Update$handleFirestoreMsg_fn);
    var $author$project$Model$InitiateElmRRuleTest = { $: 46 };
    var $author$project$Data$Note$default = function (startTime) {
        return (new $$Record23(_List_Nil, _List_Nil, _List_Nil, $elm$core$Maybe$Nothing, $author$project$Data$Timestamp$serverTimestamp, false, "", $author$project$Data$Time$Time((new $$Record26(startTime, 0))), $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, false, 0, $author$project$Data$Slate$emptyDoc, $author$project$Data$Time$Time((new $$Record26(startTime, 0))), "", $author$project$Data$Timestamp$serverTimestamp));
    };
    var $author$project$Cmd$Note$newHelp_fn = function (env, note) {
        var _v0 = $author$project$Lib$UID$generate(env.jy);
        var newId = _v0.a;
        var newSeeds = _v0.b;
        return _Utils_Tuple2(function () {
            var $r = env.$c();
            $r.fO = $author$project$Firestore$Collection$insertTransient_fn(newId, note, env.fO);
            $r.jy = newSeeds;
            return $r;
        }(), newId);
    }, $author$project$Cmd$Note$newHelp = F2($author$project$Cmd$Note$newHelp_fn);
    var $author$project$Cmd$Note$newFromTime_fn = function (env, mStartTime) {
        var startTime = $elm$core$Maybe$withDefault_fn($author$project$Util$Time$roundToMins_fn(5, env.k5), mStartTime);
        return function (_v0) {
            var newEnv = _v0.a;
            var noteId = _v0.b;
            return _Utils_Tuple3(newEnv, noteId, $author$project$Routing$RouteNewAdHocNote_fn(noteId, startTime, $elm$core$Maybe$Nothing));
        }($author$project$Cmd$Note$newHelp_fn(env, $author$project$Data$Note$default(startTime)));
    }, $author$project$Cmd$Note$newFromTime = F2($author$project$Cmd$Note$newFromTime_fn);
    var $author$project$Error$CircularRoutingIssue = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Update$Util$withNewEntityReroute = function (_v0) {
        var newEnv = _v0.a;
        var route = _v0.c;
        return _Utils_Tuple2(newEnv, $author$project$Routing$isEntityCreationRoute(route) ? $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$ImpossibleState($author$project$Error$CircularRoutingIssue({
            k6: $author$project$Routing$pathFromRoute(newEnv.oe),
            ne: $author$project$Routing$pathFromRoute(route)
        })))) : $author$project$Util$Cmd$executeMsg($author$project$Model$HandleBacktalk($author$project$Env$RouteToURLRequest(route))));
    };
    var $author$project$Update$CalendarEvents$handleEntityCreation_fn = function (initialEventsLoaded, env) {
        return $elm$core$Tuple$mapSecond_fn($author$project$Util$Cmd$when(initialEventsLoaded), function () {
            var _v0 = env.oe;
            switch (_v0.$) {
                case 2:
                    var eventId = _v0.a;
                    var mMasterId = _v0.b;
                    return _Utils_Tuple2(env, $author$project$Util$Cmd$executeMsg($author$project$Model$NoteFromEvent({ b7: eventId, h4: mMasterId, iZ: 60 * 5 })));
                case 4:
                    var mStartTime = _v0.a;
                    return $author$project$Update$Util$withNewEntityReroute($author$project$Cmd$Note$newFromTime_fn(env, mStartTime));
                case 8:
                    var mPerson = _v0.a;
                    return $author$project$Update$Util$withNewEntityReroute($author$project$Cmd$Person$new_fn(env, mPerson));
                default:
                    return _Utils_Tuple2(env, $elm$core$Platform$Cmd$none);
            }
        }());
    }, $author$project$Update$CalendarEvents$handleEntityCreation = F2($author$project$Update$CalendarEvents$handleEntityCreation_fn);
    var $author$project$Data$Note$attendeesFromEvent = function (event) {
        return $elm$core$List$filterMap_fn($author$project$Data$Note$eventAttendeeToAttendee($elm$core$Maybe$Nothing), $elm_community$list_extra$List$Extra$uniqueBy_fn(function ($) {
            return $.cS;
        }, _List_Cons(event.c8, event.ke)));
    };
    var $author$project$Data$Note$toEventRef = function (event) {
        var _v0 = event.pv;
        switch (_v0.$) {
            case 0:
                return $elm$core$Maybe$Just($author$project$Data$Note$Single({ b7: event.l8, dr: event.dr }));
            case 2:
                var masterId = _v0.a.mT;
                return $elm$core$Maybe$Just($author$project$Data$Note$Instance({ Q: event.l8, mT: masterId, dr: event.dr }));
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Data$Note$fromEvent = function (event) {
        return (new $$Record23(_List_Nil, _List_Nil, $author$project$Data$Note$attendeesFromEvent(event), event.kT, $author$project$Data$Timestamp$serverTimestamp, false, event.fc, $author$project$Data$Time$withoutZone(event.fh), $author$project$Data$Note$toEventRef(event), $elm$core$Maybe$Just(event.gj), false, 0, $author$project$Data$Slate$emptyDoc, $author$project$Data$Time$withoutZone(event.oN), event.gj, $author$project$Data$Timestamp$serverTimestamp));
    };
    var $author$project$Update$CalendarEvents$handleNewNoteRoute_fn = function (initialEventsLoaded, env, events, notes) {
        var _v0 = env.oe;
        switch (_v0.$) {
            case 3:
                var noteId = _v0.a;
                var eventId = _v0.b;
                var tab = _v0.c;
                var _v1 = $author$project$Firestore$Collection$getWithState_fn(noteId, notes);
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var state = _v2.a;
                    return _Utils_Tuple2(notes, $author$project$Util$Cmd$when_fn($elm$core$List$all_fn($elm$core$Basics$neq(state), _List_fromArray([0, 6, 5])), $author$project$Routing$reroute_fn(env, $author$project$Routing$RouteNote_fn(noteId, $elm$core$Maybe$Nothing, tab))));
                }
                else {
                    return _Utils_Tuple2(function () {
                        var _v3 = $elm$core$Dict$get_fn(eventId, events);
                        if (!_v3.$) {
                            var event = _v3.a;
                            return $author$project$Firestore$Collection$insertTransient_fn(noteId, $author$project$Data$Note$fromEvent(event), notes);
                        }
                        else {
                            return notes;
                        }
                    }(), $elm$core$Platform$Cmd$none);
                }
            case 5:
                var noteId = _v0.a;
                var startTime = _v0.b;
                var tab = _v0.c;
                return $elm_community$maybe_extra$Maybe$Extra$isJust($author$project$Firestore$Collection$get_fn(noteId, notes)) ? _Utils_Tuple2(notes, $author$project$Util$Cmd$when_fn(initialEventsLoaded, $author$project$Routing$reroute_fn(env, $author$project$Routing$RouteNote_fn(noteId, $elm$core$Maybe$Nothing, tab)))) : _Utils_Tuple2($author$project$Firestore$Collection$insertTransient_fn(noteId, $author$project$Data$Note$default(startTime), notes), $elm$core$Platform$Cmd$none);
            default:
                return _Utils_Tuple2(notes, $elm$core$Platform$Cmd$none);
        }
    }, $author$project$Update$CalendarEvents$handleNewNoteRoute = F4($author$project$Update$CalendarEvents$handleNewNoteRoute_fn);
    var $author$project$Data$Dialog$Closeable$NextMeetingNotFound = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Update$Util$toNextMeeting_fn = function (env, nextMeeting) {
        var _v0 = $author$project$Util$NextMeeting$find_fn(env, nextMeeting);
        if (!_v0.$) {
            var eventId = _v0.a.b7;
            var masterId = _v0.a.mT;
            return _Utils_Tuple2(env, $author$project$Util$Cmd$executeMsg($author$project$Model$HandleBacktalk($author$project$Env$RouteToURLRequest($author$project$Routing$RouteCreateEventNote_fn(eventId, masterId, $elm$core$Maybe$Nothing)))));
        }
        else {
            return _Utils_Tuple2($$update__e3(env, $elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$NextMeetingNotFound(nextMeeting))), $elm$core$Platform$Cmd$none);
        }
    }, $author$project$Update$Util$toNextMeeting = F2($author$project$Update$Util$toNextMeeting_fn);
    var $author$project$Update$CalendarEvents$handleNextMeetingRoute_fn = function (initialEventsLoaded, env) {
        var _v0 = _Utils_Tuple2(initialEventsLoaded, env.oe);
        if (_v0.a && (_v0.b.$ === 7)) {
            var nextMeeting = _v0.b.a;
            return $author$project$Update$Util$toNextMeeting_fn(env, nextMeeting);
        }
        else {
            return _Utils_Tuple2(env, $elm$core$Platform$Cmd$none);
        }
    }, $author$project$Update$CalendarEvents$handleNextMeetingRoute = F2($author$project$Update$CalendarEvents$handleNextMeetingRoute_fn);
    var $author$project$Lib$Focuser$startingPointId = "focus-start-point";
    var $author$project$Lib$Focuser$initWhen_fn = function (noOp, flag) {
        return $author$project$Util$Cmd$when_fn(flag, $author$project$Util$Cmd$focusOnElement_fn(noOp("reset tabindex"), $author$project$Lib$Focuser$startingPointId));
    }, $author$project$Lib$Focuser$initWhen = F2($author$project$Lib$Focuser$initWhen_fn);
    var $author$project$Data$LoadState$allEventsBatchTag = "all-events";
    var $author$project$Data$LoadState$initalEventsBatchTag = "initial-events";
    var $author$project$Update$CalendarEvents$loadStateOfBatch_fn = function (eventBatch, eventLoadState) {
        return {
            bj: (!eventBatch.n7) && (_Utils_eq(eventBatch.o8, $author$project$Data$LoadState$allEventsBatchTag) && (!eventLoadState.gF)),
            P: (!eventBatch.n7) && (_Utils_eq(eventBatch.o8, $author$project$Data$LoadState$initalEventsBatchTag) && (!eventLoadState.mg))
        };
    }, $author$project$Update$CalendarEvents$loadStateOfBatch = F2($author$project$Update$CalendarEvents$loadStateOfBatch_fn);
    var $author$project$Model$SetLinkWorkAccountStatus = function (a) {
        return { $: 35, a: a };
    };
    var $author$project$Update$CalendarEvents$mUpdateUserAlerts_fn = function (env, batchLoadState) {
        var shouldSetLinkWorkAccountAlertToDisplayable = _Utils_eq($elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.gB;
        }, function ($) {
            return $.mH;
        }), env.pV), $elm$core$Maybe$Just($author$project$Data$User$Hidden)) && batchLoadState.bj;
        return $author$project$Util$Cmd$when_fn(shouldSetLinkWorkAccountAlertToDisplayable, $author$project$Util$Cmd$delayBy_fn(10000, $author$project$Model$SetLinkWorkAccountStatus($author$project$Data$User$Displayable)));
    }, $author$project$Update$CalendarEvents$mUpdateUserAlerts = F2($author$project$Update$CalendarEvents$mUpdateUserAlerts_fn);
    var $author$project$Data$LoadState$markAllEventsLoaded = function (loadState) {
        var eventLoadState = loadState.lw;
        return $$update__lw(loadState, function () {
            var $r = eventLoadState.$c();
            $r.gF = true;
            return $r;
        }());
    };
    var $author$project$Data$LoadState$markInitialEventsLoaded = function (loadState) {
        var eventLoadState = loadState.lw;
        return $$update__lw(loadState, function () {
            var $r = eventLoadState.$c();
            $r.mg = true;
            return $r;
        }());
    };
    var $author$project$Model$LogBenchmarks_fn = function (a, b) {
        return { $: 48, a: a, b: b };
    }, $author$project$Model$LogBenchmarks = F2($author$project$Model$LogBenchmarks_fn);
    var $author$project$Update$CalendarEvents$maybeLogBenchmark_fn = function (eventBatch, batchLoadState) {
        return $author$project$Util$Cmd$when_fn(batchLoadState.P || batchLoadState.bj, $elm$core$Task$perform_fn($author$project$Model$LogBenchmarks({ hy: eventBatch.hy, h3: eventBatch.o8 }), $elm$time$Time$now));
    }, $author$project$Update$CalendarEvents$maybeLogBenchmark = F2($author$project$Update$CalendarEvents$maybeLogBenchmark_fn);
    var $author$project$Data$Note$associatedEventIds = function (_v0) {
        var eventRef = _v0.hh;
        return $elm$core$Set$fromList(function () {
            if (!eventRef.$) {
                if (!eventRef.a.$) {
                    var eventId = eventRef.a.a.b7;
                    return _List_fromArray([eventId]);
                }
                else {
                    var instanceId = eventRef.a.a.Q;
                    var masterId = eventRef.a.a.mT;
                    return _List_fromArray([instanceId, masterId]);
                }
            }
            else {
                return _List_Nil;
            }
        }());
    };
    var $author$project$Update$CalendarEvents$syncNotesWithEvents_fn = function (env, incomingEventIds, events) {
        var noteUpdateReducer = F2(function (_v1, notes) {
            var noteId = _v1.a;
            var noteState = _v1.b;
            var note = _v1.c;
            switch (noteState) {
                case 6:
                    return notes;
                case 5:
                    return notes;
                case 0:
                    return $author$project$Firestore$Collection$insertTransient_fn(noteId, $author$project$Data$Note$updateFromEvents_fn(events, note), notes);
                default:
                    return $author$project$Firestore$Collection$update_fn(noteId, $author$project$Data$Note$updateFromEvents(events), notes);
            }
        });
        var inInitialLoadWindow = function (note) {
            var noteTime = $author$project$Data$Time$toPosix_fn(env.pu, note.gh);
            return $author$project$Util$Time$isOnOrAfter_fn(env.mf.bF, noteTime) && $author$project$Util$Time$isOnOrBefore_fn(env.mf.b6, noteTime);
        };
        var onlyNotesNeedingUpdating = F3(function (noteId, state, note) {
            return env.mK.lw.mg ? function (needsToUpdate) {
                return needsToUpdate ? $elm$core$Maybe$Just(_Utils_Tuple3(noteId, state, note)) : $elm$core$Maybe$Nothing;
            }($elm$core$Basics$composeR_fn($elm$core$Set$isEmpty, $elm$core$Basics$not, $elm$core$Set$intersect_fn(incomingEventIds, $author$project$Data$Note$associatedEventIds(note)))) : (inInitialLoadWindow(note) ? $elm$core$Maybe$Just(_Utils_Tuple3(noteId, state, note)) : $elm$core$Maybe$Nothing);
        });
        return $elm$core$List$foldl_fn(noteUpdateReducer, env.fO, A2($author$project$Firestore$Collection$filterMapWithState, onlyNotesNeedingUpdating, env.fO));
    }, $author$project$Update$CalendarEvents$syncNotesWithEvents = F3($author$project$Update$CalendarEvents$syncNotesWithEvents_fn);
    var $elm_community$result_extra$Result$Extra$partition = function (rs) {
        return $elm$core$List$foldr_fn(F2(function (r, _v0) {
            var succ = _v0.a;
            var err = _v0.b;
            if (!r.$) {
                var v = r.a;
                return _Utils_Tuple2(_List_Cons(v, succ), err);
            }
            else {
                var v = r.a;
                return _Utils_Tuple2(succ, _List_Cons(v, err));
            }
        }), _Utils_Tuple2(_List_Nil, _List_Nil), rs);
    };
    var $author$project$Data$Event$toPseudoInstance_fn = function (userTimezone, masterEvent, instanceStartTime) {
        var defaultTime = $author$project$Data$Time$Time((new $$Record26($elm$time$Time$millisToPosix(0), $elm$core$Maybe$Nothing)));
        var _v0 = function () {
            var _v1 = _Utils_Tuple2(masterEvent.oN, masterEvent.fh);
            _v1$2: while (true) {
                if (!_v1.a.$) {
                    if (!_v1.b.$) {
                        var startTime = _v1.a.a;
                        var endTime = _v1.b.a;
                        var lengthMillis = $justinmimbs$time_extra$Time$Extra$diff_fn(15, $elm$time$Time$utc, startTime.gh, endTime.gh);
                        var instanceEndTime = $justinmimbs$time_extra$Time$Extra$add_fn(15, lengthMillis, $elm$time$Time$utc, instanceStartTime);
                        return {
                            b6: $author$project$Data$Time$Time($$update__gh(endTime, instanceEndTime)),
                            bF: $author$project$Data$Time$Time($$update__gh(startTime, instanceStartTime))
                        };
                    }
                    else {
                        break _v1$2;
                    }
                }
                else {
                    if (_v1.b.$ === 1) {
                        var startDate = _v1.a.a;
                        var endDate = _v1.b.a;
                        var lengthDays = $justinmimbs$date$Date$diff_fn(3, startDate, endDate);
                        var instanceStartDate = $justinmimbs$date$Date$fromPosix_fn(userTimezone, instanceStartTime);
                        return {
                            b6: $author$project$Data$Time$Date($justinmimbs$date$Date$add_fn(3, lengthDays, instanceStartDate)),
                            bF: $author$project$Data$Time$Date(instanceStartDate)
                        };
                    }
                    else {
                        break _v1$2;
                    }
                }
            }
            return { b6: defaultTime, bF: defaultTime };
        }();
        var start = _v0.bF;
        var end = _v0.b6;
        var newId = $author$project$Data$Event$toInstanceId_fn(masterEvent.l8, start);
        return _Utils_Tuple2(newId, function () {
            var $r = masterEvent.$c();
            $r.fh = end;
            $r.l8 = newId;
            $r.oN = start;
            $r.pv = $author$project$Data$Event$Instance({ mT: masterEvent.l8, nF: start, nZ: true });
            return $r;
        }());
    }, $author$project$Data$Event$toPseudoInstance = F3($author$project$Data$Event$toPseudoInstance_fn);
    var $author$project$Data$Event$withPseudoInstances_fn = function (window, userTimezone, events) {
        var reducer = F3(function (_v1, event, acc) {
            var _v0 = event.pv;
            if (_v0.$ === 1) {
                var rrule = _v0.a.fZ;
                return $elm$core$Dict$union_fn(acc, $elm$core$Dict$fromList($elm$core$List$map_fn(A2($author$project$Data$Event$toPseudoInstance, userTimezone, event), $author$project$RRule$between_fn(window, rrule))));
            }
            else {
                return acc;
            }
        });
        return $elm$core$Dict$foldl_fn(reducer, events, events);
    }, $author$project$Data$Event$withPseudoInstances = F3($author$project$Data$Event$withPseudoInstances_fn);
    var $author$project$Data$Event$updateEventsDict_fn = function (timezoneUser, window, oldEvents, incomingEventsList) {
        var inBoth = F4(function (id, _new, old, acc) {
            if ($author$project$Util$Time$isOnOrBefore_fn(old.dr, _new.dr)) {
                return $elm$core$Dict$insert_fn(id, old, acc);
            }
            else {
                var _v2 = _Utils_Tuple2(_new.pv, old.pv);
                if ((_v2.a.$ === 2) && (_v2.b.$ === 2)) {
                    var newInstance = _v2.a.a;
                    var oldInstance = _v2.b.a;
                    return (newInstance.nZ && (!oldInstance.nZ)) ? $elm$core$Dict$insert_fn(id, old, acc) : $elm$core$Dict$insert_fn(id, _new, acc);
                }
                else {
                    return $elm$core$Dict$insert_fn(id, _new, acc);
                }
            }
        });
        var _v0 = $elm$core$Tuple$mapFirst_fn(A2($elm$core$Basics$composeR, $elm$core$List$map(function (e) {
            return _Utils_Tuple2(e.l8, e);
        }), $elm$core$Dict$fromList), $elm_community$result_extra$Result$Extra$partition(incomingEventsList));
        var incomingEvents = _v0.a;
        var decodingErrors = _v0.b;
        var addOldEvent = F3(function (id, old, acc) {
            var _v1 = old.pv;
            if (_v1.$ === 2) {
                var instance = _v1.a;
                return (instance.nZ && $elm$core$Dict$member_fn(instance.mT, incomingEvents)) ? acc : $elm$core$Dict$insert_fn(id, old, acc);
            }
            else {
                return $elm$core$Dict$insert_fn(id, old, acc);
            }
        });
        var newEvents = $elm$core$Dict$merge_fn($elm$core$Dict$insert, inBoth, addOldEvent, $author$project$Data$Event$withPseudoInstances_fn(window, timezoneUser, incomingEvents), oldEvents, $elm$core$Dict$empty);
        return {
            lu: decodingErrors,
            md: $elm$core$Set$fromList($elm$core$Dict$keys(incomingEvents)),
            nb: newEvents
        };
    }, $author$project$Data$Event$updateEventsDict = F4($author$project$Data$Event$updateEventsDict_fn);
    var $author$project$Update$CalendarEvents$handler_fn = function (model, eventBatch) {
        var env = model.dW;
        var maybeComputeNextMeeting = $author$project$Util$Cmd$when_fn(!eventBatch.n7, $author$project$Util$Cmd$executeMsg($author$project$Model$ComputeNextMeeting));
        var batchLoadState = $author$project$Update$CalendarEvents$loadStateOfBatch_fn(eventBatch, env.mK.lw);
        var maybeRegenerateActionItemsCache = $author$project$Util$Cmd$when_fn(batchLoadState.P, $author$project$Util$Cmd$executeMsg($author$project$Model$HandlePageMsg($author$project$Model$NoteMsg($author$project$Page$Note$regenerateActionItemsCache({ o6: batchLoadState.P })))));
        var newLoadState = batchLoadState.P ? $author$project$Data$LoadState$markInitialEventsLoaded(env.mK) : (batchLoadState.bj ? $author$project$Data$LoadState$markAllEventsLoaded(env.mK) : env.mK);
        var shouldSetFocus = function () {
            var _v5 = model.ix;
            switch (_v5.$) {
                case 0:
                    return batchLoadState.P;
                case 5:
                    return batchLoadState.P;
                default:
                    return false;
            }
        }();
        var addYears = function (n) {
            return $justinmimbs$time_extra$Time$Extra$add_fn(0, n, env.pu, env.k5);
        };
        var _v0 = $author$project$Data$Event$updateEventsDict_fn(env.pu, {
            b6: addYears(1),
            bF: addYears(-2)
        }, env.lw, eventBatch.mA);
        var incomingEventsIds = _v0.md;
        var newEvents = _v0.nb;
        var eventDecodingErrors = _v0.lu;
        var _v1 = $author$project$Update$CalendarEvents$handleNewNoteRoute_fn(batchLoadState.P, env, newEvents, $author$project$Update$CalendarEvents$syncNotesWithEvents_fn(env, incomingEventsIds, newEvents));
        var newNotes = _v1.a;
        var maybeRouteToExistingNote = _v1.b;
        var _v2 = $author$project$Update$CalendarEvents$handleEntityCreation_fn(batchLoadState.P, function () {
            var $r = env.$c();
            $r.fO = newNotes;
            $r.lw = newEvents;
            $r.mK = newLoadState;
            return $r;
        }());
        var nextEnv1 = _v2.a;
        var maybeCreateNewEnitity = _v2.b;
        var _v3 = $author$project$Update$CalendarEvents$handleNextMeetingRoute_fn(batchLoadState.P, nextEnv1);
        var nextEnv2 = _v3.a;
        var maybeRouteToNextMeeting = _v3.b;
        var _v4 = batchLoadState.bj ? $author$project$Search$Weight$generate(nextEnv2) : _Utils_Tuple2(env.oq, $elm$core$Platform$Cmd$none);
        var newSearchWeightIndex = _v4.a;
        var maybeSaveSearchWeightIndex = _v4.b;
        var finalEnv = $$update__oq(nextEnv2, newSearchWeightIndex);
        return _Utils_Tuple2($$update__dW(model, finalEnv), $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Update$Util$delayedSaveNotes,
            maybeCreateNewEnitity,
            maybeRouteToExistingNote,
            maybeRouteToNextMeeting,
            $author$project$Update$CalendarEvents$maybeLogBenchmark_fn(eventBatch, batchLoadState),
            $elm$core$Platform$Cmd$batch($elm$core$List$map_fn($author$project$Error$log, eventDecodingErrors)),
            _Platform_map_fn($author$project$Model$SearchbarMsg, $author$project$Util$Cmd$executeMsg($author$project$Search$Bar$generateResult)),
            $author$project$Util$Cmd$when_fn(batchLoadState.P, $author$project$Lib$Focuser$initWhen_fn($author$project$Model$NoOp, shouldSetFocus)),
            $author$project$Util$Cmd$when_fn(batchLoadState.bj, $author$project$Util$Cmd$delayBy_fn(10000, $author$project$Model$InitiateElmRRuleTest)),
            maybeSaveSearchWeightIndex,
            maybeRegenerateActionItemsCache,
            $author$project$Update$CalendarEvents$mUpdateUserAlerts_fn(env, batchLoadState),
            maybeComputeNextMeeting
        ])));
    }, $author$project$Update$CalendarEvents$handler = F2($author$project$Update$CalendarEvents$handler_fn);
    var $author$project$Model$AuthCodeExchanged = function (a) {
        return { $: 15, a: a };
    };
    var $author$project$Model$OnboardingCompleted = function (a) {
        return { $: 18, a: a };
    };
    var $author$project$Util$Request$completeOnboardingFunctionName = "complete_onboarding/v1";
    var $author$project$Data$OutboundRequests$CompleteOnboardingResponse = function (linkerAccountData) {
        return { mJ: linkerAccountData };
    };
    var $author$project$Util$Json$encodeMaybeString_a0 = $elm$json$Json$Encode$string, $author$project$Util$Json$encodeMaybeString = $author$project$Util$Json$encodeMaybe($author$project$Util$Json$encodeMaybeString_a0);
    var $author$project$Util$Request$httpResponseToResult = function (response) {
        switch (response.$) {
            case 0:
                var url = response.a;
                return $elm$core$Result$Err($elm$http$Http$BadUrl(url));
            case 1:
                return $elm$core$Result$Err($elm$http$Http$Timeout);
            case 2:
                return $elm$core$Result$Err($elm$http$Http$NetworkError);
            case 3:
                var metadata = response.a;
                var body = response.b;
                return $elm$core$Result$Err($elm$http$Http$BadStatus(metadata.oQ));
            default:
                var metadata = response.a;
                var body = response.b;
                return $elm$core$Result$Ok(_Utils_Tuple2(metadata, body));
        }
    };
    var $elm$http$Http$stringResolver_a0 = "", $elm$http$Http$stringResolver_a1 = $elm$core$Basics$identity, $elm$http$Http$stringResolver = A2(_Http_expect, $elm$http$Http$stringResolver_a0, $elm$http$Http$stringResolver_a1);
    var $elm$http$Http$resultToTask = function (result) {
        if (!result.$) {
            var a = result.a;
            return $elm$core$Task$succeed(a);
        }
        else {
            var x = result.a;
            return $elm$core$Task$fail(x);
        }
    };
    var $elm$http$Http$task = function (r) {
        return _Http_toTask_fn(0, $elm$http$Http$resultToTask, (new $$Record79(false, r.dG, r.n9, r.hG, r.id, r.ak, $elm$core$Maybe$Nothing, r.dt)));
    };
    var $author$project$Util$Request$completeOnboardingTask_fn = function (attempts, data) {
        var responseDecoder = $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional_fn("linkerAccountData", _Json_map2_fn(F2(function (tutorialComplete, introContentPreloaded) {
            return $elm$core$Maybe$Just((new $$Record103(introContentPreloaded, tutorialComplete)));
        }), _Json_decodeField_fn("tutorialComplete", $elm$json$Json$Decode$bool), _Json_decodeField_fn("introContentPreloaded", $elm$json$Json$Decode$bool)), $elm$core$Maybe$Nothing, $elm$json$Json$Decode$succeed($author$project$Data$OutboundRequests$CompleteOnboardingResponse));
        var resolver = _Http_expect_fn($elm$http$Http$stringResolver_a0, $elm$http$Http$stringResolver_a1, function (response) {
            var _v1 = $author$project$Util$Request$httpResponseToResult(response);
            if (!_v1.$) {
                var _v2 = _v1.a;
                var body = _v2.b;
                return $elm$core$Result$mapError_fn(A2($elm$core$Basics$composeR, $elm$json$Json$Decode$errorToString, $elm$http$Http$BadBody), _Json_runOnString_fn(responseDecoder, body));
            }
            else {
                var err = _v1.a;
                return $elm$core$Result$Err(err);
            }
        });
        var isRetriable = function (err) {
            if ((err.$ === 3) && (err.a === 403)) {
                return true;
            }
            else {
                return false;
            }
        };
        var baseTask = $elm$http$Http$task((new $$Record104($elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("giftId", $author$project$Util$Json$encodeMaybe_fn($author$project$Util$Json$encodeMaybeString_a0, data.lS)),
            _Utils_Tuple2("linkToken", $author$project$Util$Json$encodeMaybe_fn($author$project$Util$Json$encodeMaybeString_a0, data.mG)),
            _Utils_Tuple2("timezoneName", $author$project$Util$Json$encodeMaybe_fn($author$project$Util$Json$encodeMaybeString_a0, data.pt))
        ]))), _List_fromArray([
            $elm$http$Http$Header_fn($author$project$Util$Request$authedHeader_a0, data.b9)
        ]), "POST", resolver, $elm$core$Maybe$Just($author$project$Util$Request$defaultRequestTimeout), "/funcs/" + $author$project$Util$Request$completeOnboardingFunctionName)));
        return _Scheduler_onError_fn(function (err) {
            return (isRetriable(err) && (attempts > 0)) ? _Scheduler_andThen_fn($elm$core$Basics$always($author$project$Util$Request$completeOnboardingTask_fn(attempts - 1, data)), $elm$core$Process$sleep(1000)) : $elm$core$Task$fail(err);
        }, baseTask);
    }, $author$project$Util$Request$completeOnboardingTask = F2($author$project$Util$Request$completeOnboardingTask_fn);
    var $author$project$Util$Request$completeOnboarding = function (data) {
        return $elm$core$Task$attempt_fn(function (result) {
            return $author$project$Model$OnboardingCompleted(function () {
                if (!result.$) {
                    var response = result.a;
                    return $krisajenkins$remotedata$RemoteData$Success(response);
                }
                else {
                    var httpErr = result.a;
                    return $krisajenkins$remotedata$RemoteData$Failure($author$project$Error$CloudFunction({ fm: $author$project$Util$Request$completeOnboardingFunctionName, hM: httpErr }));
                }
            }());
        }, $author$project$Util$Request$completeOnboardingTask_fn(5, data));
    };
    var $author$project$Data$Auth$CloudFunctionError = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Routing$authRedirectUri = function (url) {
        return $author$project$Util$Misc$urlHost(url) + ("/" + $author$project$Data$Auth$urlPath);
    };
    var $author$project$Util$Request$exchangeAuthCode = function (_v0) {
        var firebaseUserAuthToken = _v0.b9;
        var oauthCode = _v0.ns;
        var currentUrl = _v0.k8;
        var functionName = "exchange_auth_code";
        var customExpecter = $elm$http$Http$expectString(function (result) {
            return $author$project$Model$AuthCodeExchanged(function () {
                if (!result.$) {
                    return $krisajenkins$remotedata$RemoteData$Success(0);
                }
                else {
                    var err = result.a;
                    return $krisajenkins$remotedata$RemoteData$Failure($author$project$Data$Auth$CloudFunctionError({ fm: functionName, hM: err }));
                }
            }());
        });
        var body = $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("oauthCode", $elm$json$Json$Encode$string(oauthCode)),
            _Utils_Tuple2("redirectUri", $elm$json$Json$Encode$string($author$project$Routing$authRedirectUri(currentUrl)))
        ])));
        return $author$project$Util$Request$authedHttpPost((new $$Record82(firebaseUserAuthToken, $elm$core$Maybe$Just(body), customExpecter, _List_Nil, functionName, $elm$core$Maybe$Just($author$project$Util$Request$defaultRequestTimeout))));
    };
    var $author$project$Routing$giftId = function (route) {
        if ((route.$ === 13) && (!route.a.$)) {
            var _v1 = route.a;
            var mGiftId = _v1.a;
            return mGiftId;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Data$Settings$collectionPath = function (_v0) {
        var id = _v0.l8;
        return "/accounts/" + (id + "/settings");
    };
    var $author$project$Ports$initTimestampHooks = _Platform_outgoingPort("initTimestampHooks", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("collectionPaths", $elm$json$Json$Encode$list($elm$json$Json$Encode$string)($.kR))
        ]));
    });
    var $author$project$Firestore$Collection$setPath_fn = function (newPath, _v0) {
        var collection = _v0;
        return function () {
            var $r = collection.$c();
            $r.at = newPath;
            return $r;
        }();
    }, $author$project$Firestore$Collection$setPath = F2($author$project$Firestore$Collection$setPath_fn);
    var $author$project$Firestore$Cmd$SubscribeCollection = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Firestore$Cmd$watchCollection = function (_v0) {
        var toFirestore = _v0.al;
        var collection = _v0._;
        return toFirestore($author$project$Firestore$Cmd$encode($author$project$Firestore$Cmd$SubscribeCollection($author$project$Firestore$Collection$getPath(collection))));
    };
    var $author$project$Util$Firestore$watch = function (collection) {
        return $author$project$Firestore$Cmd$watchCollection({ _: collection, al: $author$project$Ports$toFirestore });
    };
    var $author$project$Update$SignedIn$initCollections_fn = function (env, user) {
        var updatedSettings = $author$project$Firestore$Collection$setPath_fn($author$project$Data$Settings$collectionPath(user), env.be);
        var updatedPeople = $author$project$Firestore$Collection$setPath_fn($author$project$Data$Person$collectionPath(user), env.iz);
        var updatedNotes = $author$project$Firestore$Collection$setPath_fn($author$project$Data$Note$collectionPath(user), env.fO);
        return _Utils_Tuple2(function () {
            var $r = env.$c();
            $r.be = updatedSettings;
            $r.fO = updatedNotes;
            $r.iz = updatedPeople;
            return $r;
        }(), $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Util$Firestore$watch(updatedSettings),
            $author$project$Util$Firestore$watch(updatedNotes),
            $author$project$Util$Firestore$watch(updatedPeople),
            $author$project$Ports$initTimestampHooks({
                kR: _List_fromArray([
                    $author$project$Data$Person$collectionPath(user),
                    $author$project$Data$Note$collectionPath(user),
                    $author$project$Data$Settings$collectionPath(user)
                ])
            })
        ])));
    }, $author$project$Update$SignedIn$initCollections = F2($author$project$Update$SignedIn$initCollections_fn);
    var $author$project$Routing$maybeSignupRoute_fn = function (_v0, _v1) {
        var route = _v0.oe;
        var outboundRequests = _v0.db;
        var email = _v1.cS;
        var tutorialComplete = _v1.pL;
        var calendarIsLinked = _v1.kB;
        var subscription = _v1.o0;
        var handleSignupStepLinkAccountSignIn = function (mAuthToken) {
            var homeOrCalendarLinkPage = $author$project$Util$Misc$if__fn(calendarIsLinked, $elm$core$Maybe$Just($author$project$Routing$RouteHome($elm$core$Maybe$Nothing)), $elm$core$Maybe$Just($author$project$Routing$RouteSignup($author$project$Routing$SignupStepLinkCalendar)));
            var _v17 = _Utils_Tuple2(outboundRequests.kW, mAuthToken);
            _v17$0: while (true) {
                switch (_v17.a.$) {
                    case 3:
                        if (_v17.b.$ === 1) {
                            break _v17$0;
                        }
                        else {
                            return homeOrCalendarLinkPage;
                        }
                    case 0:
                        if (_v17.b.$ === 1) {
                            break _v17$0;
                        }
                        else {
                            var _v19 = _v17.a;
                            var authToken = _v17.b.a;
                            var _v20 = $simonh1000$elm_jwt$Jwt$decodeToken_fn(_Json_decodeField_fn("email", $elm$json$Json$Decode$string), authToken);
                            if (!_v20.$) {
                                var authTokenEmail = _v20.a;
                                var _v21 = _Utils_Tuple2(_Utils_eq(email, authTokenEmail), tutorialComplete);
                                if (!_v21.a) {
                                    return $elm$core$Maybe$Nothing;
                                }
                                else {
                                    if (!_v21.b) {
                                        return $elm$core$Maybe$Just($author$project$Routing$RouteSignup($author$project$Routing$SignupStepLinkCalendar));
                                    }
                                    else {
                                        return $elm$core$Maybe$Just($author$project$Routing$RouteHome($elm$core$Maybe$Nothing));
                                    }
                                }
                            }
                            else {
                                return homeOrCalendarLinkPage;
                            }
                        }
                    case 1:
                        if (_v17.b.$ === 1) {
                            break _v17$0;
                        }
                        else {
                            var _v22 = _v17.a;
                            return $elm$core$Maybe$Nothing;
                        }
                    default:
                        if (_v17.b.$ === 1) {
                            break _v17$0;
                        }
                        else {
                            return $elm$core$Maybe$Nothing;
                        }
                }
            }
            var _v18 = _v17.b;
            return homeOrCalendarLinkPage;
        };
        var billingAccountStatusOfSub = function () {
            var _v16 = $elm$core$Maybe$map_fn(function ($) {
                return $.pv;
            }, subscription);
            if (!_v16.$) {
                var billingAccountStatus = _v16.a.e0;
                return billingAccountStatus;
            }
            else {
                return 1;
            }
        }();
        var _v2 = _Utils_Tuple3(_Utils_Tuple2(tutorialComplete, calendarIsLinked), route, _Utils_Tuple2(outboundRequests.kf, outboundRequests.kW));
        _v2$0: while (true) {
            _v2$1: while (true) {
                _v2$2: while (true) {
                    _v2$3: while (true) {
                        _v2$4: while (true) {
                            _v2$5: while (true) {
                                _v2$6: while (true) {
                                    _v2$7: while (true) {
                                        _v2$8: while (true) {
                                            if (!_v2.a.a) {
                                                switch (_v2.b.$) {
                                                    case 13:
                                                        if (!_v2.a.b) {
                                                            switch (_v2.b.a.$) {
                                                                case 0:
                                                                    if ((!_v2.b.a.c.$) && (_v2.c.b.$ === 3)) {
                                                                        break _v2$0;
                                                                    }
                                                                    else {
                                                                        if (_v2.c.a.$ === 2) {
                                                                            break _v2$5;
                                                                        }
                                                                        else {
                                                                            break _v2$6;
                                                                        }
                                                                    }
                                                                case 2:
                                                                    break _v2$1;
                                                                default:
                                                                    if (_v2.c.a.$ === 2) {
                                                                        break _v2$5;
                                                                    }
                                                                    else {
                                                                        break _v2$6;
                                                                    }
                                                            }
                                                        }
                                                        else {
                                                            switch (_v2.b.a.$) {
                                                                case 0:
                                                                    if ((!_v2.b.a.c.$) && (_v2.c.b.$ === 3)) {
                                                                        break _v2$0;
                                                                    }
                                                                    else {
                                                                        if (_v2.c.a.$ === 2) {
                                                                            break _v2$5;
                                                                        }
                                                                        else {
                                                                            break _v2$7;
                                                                        }
                                                                    }
                                                                case 2:
                                                                    break _v2$1;
                                                                default:
                                                                    if (_v2.c.a.$ === 2) {
                                                                        break _v2$5;
                                                                    }
                                                                    else {
                                                                        break _v2$7;
                                                                    }
                                                            }
                                                        }
                                                    case 14:
                                                        break _v2$2;
                                                    case 17:
                                                        if (!_v2.a.b) {
                                                            switch (_v2.c.a.$) {
                                                                case 1:
                                                                    break _v2$3;
                                                                case 2:
                                                                    break _v2$5;
                                                                default:
                                                                    break _v2$6;
                                                            }
                                                        }
                                                        else {
                                                            switch (_v2.c.a.$) {
                                                                case 1:
                                                                    break _v2$3;
                                                                case 2:
                                                                    break _v2$5;
                                                                default:
                                                                    break _v2$7;
                                                            }
                                                        }
                                                    default:
                                                        if (!_v2.a.b) {
                                                            if (_v2.c.a.$ === 2) {
                                                                break _v2$5;
                                                            }
                                                            else {
                                                                break _v2$6;
                                                            }
                                                        }
                                                        else {
                                                            if (_v2.c.a.$ === 2) {
                                                                break _v2$5;
                                                            }
                                                            else {
                                                                break _v2$7;
                                                            }
                                                        }
                                                }
                                            }
                                            else {
                                                switch (_v2.b.$) {
                                                    case 14:
                                                        break _v2$2;
                                                    case 13:
                                                        switch (_v2.b.a.$) {
                                                            case 0:
                                                                if ((!_v2.b.a.c.$) && (_v2.c.b.$ === 3)) {
                                                                    break _v2$0;
                                                                }
                                                                else {
                                                                    if (_v2.c.a.$ === 2) {
                                                                        break _v2$4;
                                                                    }
                                                                    else {
                                                                        break _v2$8;
                                                                    }
                                                                }
                                                            case 2:
                                                                break _v2$1;
                                                            default:
                                                                if (_v2.c.a.$ === 2) {
                                                                    break _v2$4;
                                                                }
                                                                else {
                                                                    break _v2$8;
                                                                }
                                                        }
                                                    case 17:
                                                        switch (_v2.c.a.$) {
                                                            case 1:
                                                                break _v2$3;
                                                            case 2:
                                                                break _v2$4;
                                                            default:
                                                                var _v15 = _v2.a;
                                                                return $elm$core$Maybe$Just($author$project$Routing$RouteHome($elm$core$Maybe$Nothing));
                                                        }
                                                    default:
                                                        if (_v2.c.a.$ === 2) {
                                                            break _v2$4;
                                                        }
                                                        else {
                                                            return $elm$core$Maybe$Nothing;
                                                        }
                                                }
                                            }
                                        }
                                        var _v14 = _v2.a;
                                        return $elm$core$Maybe$Just($author$project$Routing$RouteHome($elm$core$Maybe$Nothing));
                                    }
                                    var _v13 = _v2.a;
                                    return $elm$core$Maybe$Just($author$project$Routing$RouteSignup($author$project$Routing$SignupStepWatchVideo));
                                }
                                var _v11 = _v2.a;
                                if (billingAccountStatusOfSub === 1) {
                                    return $elm$core$Maybe$Just($author$project$Routing$RouteSignup($author$project$Routing$SignupStepChooseSubscription));
                                }
                                else {
                                    return $elm$core$Maybe$Just($author$project$Routing$RouteSignup($author$project$Routing$SignupStepLinkCalendar));
                                }
                            }
                            var _v9 = _v2.a;
                            var _v10 = _v2.c;
                            return $elm$core$Maybe$Just($author$project$Routing$RouteSignup($author$project$Routing$SignupStepLinkCalendar));
                        }
                        var _v7 = _v2.a;
                        var _v8 = _v2.c;
                        return $elm$core$Maybe$Just($author$project$Routing$RouteHome($elm$core$Maybe$Nothing));
                    }
                    var _v5 = _v2.c;
                    var _v6 = _v5.a;
                    return $elm$core$Maybe$Nothing;
                }
                var success = _v2.b.a.o3;
                return success ? $elm$core$Maybe$Just($author$project$Routing$RouteSignup($author$project$Routing$SignupStepLinkCalendar)) : $elm$core$Maybe$Just($author$project$Routing$RouteSignup($author$project$Routing$SignupStepChooseSubscription));
            }
            var mAuthtoken = _v2.b.a.a;
            return handleSignupStepLinkAccountSignIn(mAuthtoken);
        }
        var _v3 = _v2.b.a;
        var _v4 = _v2.c;
        return $elm$core$Maybe$Nothing;
    }, $author$project$Routing$maybeSignupRoute = F2($author$project$Routing$maybeSignupRoute_fn);
    var $author$project$Routing$maybeRerouteSignup = function (env) {
        var _v0 = _Utils_Tuple2(env.pV, env.na);
        if ((!_v0.a.$) && (!_v0.b.$)) {
            var user = _v0.a.a;
            var key = _v0.b.a;
            return $author$project$Util$Cmd$whenJust_fn($author$project$Routing$maybeSignupRoute_fn(env, user), A2($elm$core$Basics$composeR, $author$project$Routing$pathFromRoute, $elm$browser$Browser$Navigation$replaceUrl(key)));
        }
        else {
            return $elm$core$Platform$Cmd$none;
        }
    };
    var $author$project$Data$Auth$InsufficientScope = { $: 7 };
    var $author$project$Data$Auth$MismatchedEmail = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Data$Auth$requiredScopes = _List_fromArray(["https://www.googleapis.com/auth/calendar.events.readonly"]);
    var $author$project$Data$Auth$hasSufficientScope = function (authParams) {
        return $elm$core$List$all_fn(function (requiredScope) {
            return _String_contains_fn(requiredScope, authParams.f_);
        }, $author$project$Data$Auth$requiredScopes);
    };
    var $author$project$Data$Auth$validateParams_fn = function (user, authParams) {
        return (!_Utils_eq(user.cS, authParams.cS)) ? $elm$core$Result$Err($author$project$Data$Auth$MismatchedEmail({ jQ: user.cS })) : ((!$author$project$Data$Auth$hasSufficientScope(authParams)) ? $elm$core$Result$Err($author$project$Data$Auth$InsufficientScope) : $elm$core$Result$Ok(0));
    }, $author$project$Data$Auth$validateParams = F2($author$project$Data$Auth$validateParams_fn);
    var $author$project$Ports$watchCalendarEvents = _Platform_outgoingPort("watchCalendarEvents", $elm$json$Json$Encode$string);
    var $author$project$Update$SignedIn$withUser_fn = function (model, user) {
        var env = model.dW;
        var outboundRequests = env.db;
        var handleAuthError = function (authError) {
            return _Utils_Tuple2($$update__kf(outboundRequests, $krisajenkins$remotedata$RemoteData$Failure(authError)), $author$project$Util$Cmd$executeMsg($author$project$Model$AuthCodeExchanged($krisajenkins$remotedata$RemoteData$Failure(authError))));
        };
        var _v0 = $author$project$Update$SignedIn$initCollections_fn(env, user);
        var newEnv = _v0.a;
        var watchCollectionsCmd = _v0.b;
        var _v1 = function () {
            if (_Utils_eq(user.o0, $elm$core$Maybe$Nothing)) {
                return _Utils_Tuple2($$update__kW(outboundRequests, $krisajenkins$remotedata$RemoteData$Loading), $author$project$Util$Request$completeOnboarding({
                    b9: user.kg,
                    lS: $author$project$Routing$giftId(env.oe),
                    mG: function () {
                        var _v2 = env.oe;
                        if ((_v2.$ === 13) && (_v2.a.$ === 2)) {
                            var mLinkToken = _v2.a.a;
                            return mLinkToken;
                        }
                        else {
                            return $elm$core$Maybe$Nothing;
                        }
                    }(),
                    pt: env.pt
                }));
            }
            else {
                var _v3 = env.oe;
                if (_v3.$ === 17) {
                    if (!_v3.a.$) {
                        var authParams = _v3.a.a;
                        var _v4 = $author$project$Data$Auth$validateParams_fn(user, authParams);
                        if (!_v4.$) {
                            return _Utils_Tuple2($$update__kf(outboundRequests, $krisajenkins$remotedata$RemoteData$Loading), $author$project$Util$Request$exchangeAuthCode({ k8: env.mM, b9: user.kg, ns: authParams.gZ }));
                        }
                        else {
                            var authError = _v4.a;
                            return handleAuthError(authError);
                        }
                    }
                    else {
                        var authError = _v3.a.a;
                        return handleAuthError(authError);
                    }
                }
                else {
                    return _Utils_Tuple2(outboundRequests, $elm$core$Platform$Cmd$none);
                }
            }
        }();
        var newOutboundRequests = _v1.a;
        var outboundRequestCmd = _v1.b;
        var newEnv1 = function () {
            var $r = newEnv.$c();
            $r.db = newOutboundRequests;
            $r.hr = $elm$core$Maybe$withDefault_fn($author$project$Data$FeatureFlags$default, $elm$core$Maybe$map_fn(function ($) {
                return $.hr;
            }, user.o0));
            $r.pV = $elm$core$Maybe$Just(user);
            $r.pX = true;
            return $r;
        }();
        return _Utils_Tuple2($$update__dW(model, newEnv1), $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Ports$watchCalendarEvents(user.l8),
            $author$project$Routing$maybeRerouteSignup(newEnv1),
            watchCollectionsCmd,
            outboundRequestCmd
        ])));
    }, $author$project$Update$SignedIn$withUser = F2($author$project$Update$SignedIn$withUser_fn);
    var $author$project$Update$SignedIn$withoutUser = function (model) {
        var env = model.dW;
        return _Utils_Tuple2($$update__dW(model, function () {
            var $r = env.$c();
            $r.pV = $elm$core$Maybe$Nothing;
            $r.pX = true;
            return $r;
        }()), $elm$core$Platform$Cmd$none);
    };
    var $author$project$Update$SignedIn$handler_fn = function (model, maybeUser) {
        if (!maybeUser.$) {
            var user = maybeUser.a;
            return $author$project$Update$SignedIn$withUser_fn(model, user);
        }
        else {
            return $author$project$Update$SignedIn$withoutUser(model);
        }
    }, $author$project$Update$SignedIn$handler = F2($author$project$Update$SignedIn$handler_fn);
    var $elm$time$Time$here = _Time_here(0);
    var $author$project$Lib$Focuser$init = function (noOp) {
        return $author$project$Lib$Focuser$initWhen_fn(noOp, true);
    };
    var $author$project$Ports$requestRRuleJSInstances = _Platform_outgoingPort("requestRRuleJSInstances", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("eventData", $elm$json$Json$Encode$list(function ($) {
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2("dtStart", $elm$json$Json$Encode$int($.b4)),
                    _Utils_Tuple2("id", $elm$json$Json$Encode$string($.l8)),
                    _Utils_Tuple2("mTimeZone", function ($) {
                        return $elm$core$Maybe$destruct_fn($elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
                    }($.h5)),
                    _Utils_Tuple2("rrules", $elm$json$Json$Encode$list($elm$json$Json$Encode$string)($.i$))
                ]));
            })($.hg)),
            _Utils_Tuple2("windowEnd", $elm$json$Json$Encode$int($.jM)),
            _Utils_Tuple2("windowStart", $elm$json$Json$Encode$int($.jN))
        ]));
    });
    var $author$project$Data$Time$getZone = function (time) {
        if (!time.$) {
            var zone = time.a.gw;
            return $elm$core$Maybe$Just(zone);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Data$Event$toRRuleJSRequest_fn = function (_v0, env) {
        var start = _v0.bF;
        var end = _v0.b6;
        var reducer = F3(function (eventId, event, acc) {
            var _v1 = event.pv;
            if (_v1.$ === 1) {
                var data = _v1.a;
                return _List_Cons((new $$Record105($elm$time$Time$posixToMillis($author$project$Data$Time$toPosix_fn(env.pu, data.b4)), eventId, $elm$core$Maybe$map_fn(function ($) {
                    return $.l5;
                }, $author$project$Data$Time$getZone(data.b4)), data.iR)), acc);
            }
            else {
                return acc;
            }
        });
        return {
            hg: $elm$core$Dict$foldl_fn(reducer, _List_Nil, env.lw),
            jM: $elm$time$Time$posixToMillis(end),
            jN: $elm$time$Time$posixToMillis(start)
        };
    }, $author$project$Data$Event$toRRuleJSRequest = F2($author$project$Data$Event$toRRuleJSRequest_fn);
    var $author$project$ElmRRULETest$initiate = function (env) {
        return $author$project$Ports$requestRRuleJSInstances($author$project$Data$Event$toRRuleJSRequest_fn($author$project$ElmRRULETest$window, env));
    };
    var $krisajenkins$remotedata$RemoteData$isFailure = function (data) {
        if (data.$ === 2) {
            var x = data.a;
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Routing$isStripe = function (route) {
        if (route.$ === 14) {
            return true;
        }
        else {
            return false;
        }
    };
    var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
        if (data.$ === 3) {
            var x = data.a;
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$browser$Browser$Navigation$load = _Browser_load;
    var $author$project$Env$PreloadContent = { $: 26 };
    var $author$project$Update$maybeInjectPreloadedContent = function (env) {
        var hasActiveSubscription = $elm$core$Basics$composeR_fn($author$project$Data$Subscription$isActive_a0, $author$project$Data$Subscription$isActive_a1, $elm$core$Maybe$andThen_fn(function ($) {
            return $.o0;
        }, env.pV));
        var shouldInjectPreloadedContent = function () {
            var _v0 = _Utils_Tuple2(env.pV, env.db.kW);
            if (!_v0.a.$) {
                if (_v0.b.$ === 1) {
                    var _v1 = _v0.b;
                    return false;
                }
                else {
                    var user = _v0.a.a;
                    return (!user.mn) && hasActiveSubscription;
                }
            }
            else {
                return false;
            }
        }();
        return $author$project$Util$Cmd$when_fn(shouldInjectPreloadedContent, $author$project$Util$Cmd$executeMsg($author$project$Model$HandleBacktalk($author$project$Env$PreloadContent)));
    };
    var $author$project$Util$Request$maybeLogFailure = function (remoteData) {
        if (remoteData.$ === 2) {
            var err = remoteData.a;
            return $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$error_a0, err));
        }
        else {
            return $elm$core$Platform$Cmd$none;
        }
    };
    var $author$project$Routing$maybeRerouteToStripeCheckout = function (_v0) {
        var route = _v0.oe;
        var outboundRequests = _v0.db;
        var _v1 = _Utils_Tuple2(route, outboundRequests.kW);
        if (((_v1.a.$ === 13) && (!_v1.a.a.$)) && (_v1.b.$ === 3)) {
            var _v2 = _v1.a.a;
            var mBillingPeriod = _v2.c;
            return mBillingPeriod;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Error$Parsing = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Data$Time$nothingZone = function (time) {
        if (!time.$) {
            var data = time.a;
            return $author$project$Data$Time$Time((new $$Record26(data.gh, $elm$core$Maybe$Nothing)));
        }
        else {
            var date = time.a;
            return $author$project$Data$Time$Date(date);
        }
    };
    var $elm_community$result_extra$Result$Extra$or_fn = function (ra, rb) {
        if (ra.$ === 1) {
            return rb;
        }
        else {
            return ra;
        }
    }, $elm_community$result_extra$Result$Extra$or = F2($elm_community$result_extra$Result$Extra$or_fn);
    var $elm_community$result_extra$Result$Extra$orElse_fn = function (ra, rb) {
        return $elm_community$result_extra$Result$Extra$or_fn(rb, ra);
    }, $elm_community$result_extra$Result$Extra$orElse = F2($elm_community$result_extra$Result$Extra$orElse_fn);
    var $author$project$Data$Event$withoutDeleted_a0 = F2(function (_v0, event) {
        return !event.lh;
    }), $author$project$Data$Event$withoutDeleted = $elm$core$Dict$filter($author$project$Data$Event$withoutDeleted_a0);
    var $author$project$Data$Event$withoutDeletedOrMasters_a0 = F2(function (_v0, event) {
        return (!event.lh) && (!$author$project$Data$Event$isMaster(event));
    }), $author$project$Data$Event$withoutDeletedOrMasters = $elm$core$Dict$filter($author$project$Data$Event$withoutDeletedOrMasters_a0);
    var $author$project$Cmd$Note$getEventHelp_fn = function (eventId, mMasterId, events) {
        var errorIfNothing = F2(function (name, id) {
            return $elm$core$Result$fromMaybe($author$project$Error$Msg_fn($author$project$Error$warning_a0, $author$project$Error$NotFound((new $$Record102(name, id)))));
        });
        var nonMaster = A3(errorIfNothing, "Event", eventId, $elm$core$Dict$get_fn(eventId, $elm$core$Dict$filter_fn($author$project$Data$Event$withoutDeletedOrMasters_a0, events)));
        var pseudoInstance = F2(function (masterId, startTime) {
            return A3(errorIfNothing, "Master Event", masterId, $elm$core$Maybe$map_fn(function (event) {
                return function () {
                    var $r = event.$c();
                    $r.l8 = eventId;
                    $r.oN = startTime;
                    $r.pv = $author$project$Data$Event$Instance({ mT: masterId, nF: startTime, nZ: true });
                    return $r;
                }();
            }, $elm$core$Dict$get_fn(masterId, $elm$core$Dict$filter_fn($author$project$Data$Event$withoutDeleted_a0, events))));
        });
        var _v0 = _Utils_Tuple2(mMasterId, $author$project$Data$Event$extractTimeFromId(eventId));
        if (!_v0.a.$) {
            if (!_v0.b.$) {
                var masterId = _v0.a.a;
                var instanceTime = _v0.b.a;
                return $elm_community$result_extra$Result$Extra$orElse_fn(A2(pseudoInstance, masterId, $author$project$Data$Time$nothingZone(instanceTime)), nonMaster);
            }
            else {
                var _v1 = _v0.b;
                return $elm$core$Result$Err($author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$Parsing({ he: "Recurring Instance Id", m_: "Error extracting time from instance id", p_: eventId })));
            }
        }
        else {
            return nonMaster;
        }
    }, $author$project$Cmd$Note$getEventHelp = F3($author$project$Cmd$Note$getEventHelp_fn);
    var $author$project$Data$Note$getFromEventId_fn = function (notes, eventId) {
        return A3($author$project$Firestore$Collection$foldl, F3(function (id, note, acc) {
            var noteHasEvent = $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(function (eventRef) {
                if (!eventRef.$) {
                    var single = eventRef.a;
                    return _Utils_eq(eventId, single.b7);
                }
                else {
                    var instanceId = eventRef.a.Q;
                    return _Utils_eq(eventId, instanceId);
                }
            }, note.hh));
            if (!acc.$) {
                return acc;
            }
            else {
                return (noteHasEvent && (!note.lh)) ? $elm$core$Maybe$Just(_Utils_Tuple2(id, note)) : $elm$core$Maybe$Nothing;
            }
        }), $elm$core$Maybe$Nothing, notes);
    }, $author$project$Data$Note$getFromEventId = F2($author$project$Data$Note$getFromEventId_fn);
    var $author$project$Cmd$Note$newFromEvent_fn = function (env, event) {
        var _v0 = $author$project$Data$Note$getFromEventId_fn(env.fO, event.l8);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var noteId = _v1.a;
            return _Utils_Tuple3(env, noteId, $author$project$Routing$RouteNote_fn(noteId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
        }
        else {
            return function (_v2) {
                var newEnv = _v2.a;
                var noteId = _v2.b;
                return _Utils_Tuple3(newEnv, noteId, $author$project$Routing$RouteNewEventNote_fn(noteId, event.l8, $elm$core$Maybe$Nothing));
            }($author$project$Cmd$Note$newHelp_fn(env, $author$project$Data$Note$fromEvent(event)));
        }
    }, $author$project$Cmd$Note$newFromEvent = F2($author$project$Cmd$Note$newFromEvent_fn);
    var $author$project$Cmd$Note$newFromEventId_fn = function (env, eventId, mMasterId) {
        return $elm$core$Result$map_fn($author$project$Cmd$Note$newFromEvent(env), $author$project$Cmd$Note$getEventHelp_fn(eventId, mMasterId, env.lw));
    }, $author$project$Cmd$Note$newFromEventId = F3($author$project$Cmd$Note$newFromEventId_fn);
    var $author$project$Env$ReloadApp = { $: 25 };
    var $author$project$Analytics$SnackbarNewAppVersionRefresh = { $: 38 };
    var $author$project$Lib$Snackbar$Special = 2;
    var $author$project$View$Snacks$newVersionReleased = (new $$Record78($elm$core$Maybe$Just({
        kA: "Refresh",
        fQ: $author$project$Env$Tantrum(_List_fromArray([
            $author$project$Env$AnalyticsEvent($author$project$Analytics$SnackbarNewAppVersionRefresh),
            $author$project$Env$ReloadApp
        ]))
    }), {
        hF: "New version of Witful!",
        cp: $elm$core$Maybe$Just("Refresh to get the latest release")
    }, true, true, 2));
    var $author$project$Page$Person$PersonsMerged = function (a) {
        return { $: 13, a: a };
    };
    var $author$project$Page$Person$personsMerged = $author$project$Page$Person$PersonsMerged;
    var $author$project$View$Header$profileButtonId = "profile-menu";
    var $author$project$Model$GiftEmailsSent = function (a) {
        return { $: 20, a: a };
    };
    var $author$project$Data$Email$toString = function (_v0) {
        var str = _v0;
        return str;
    };
    var $author$project$Util$Request$sendGiftEmails = function (_v0) {
        var firebaseUserAuthToken = _v0.b9;
        var invitingUserFirstName = _v0.mp;
        var invitingUserFullName = _v0.mq;
        var emails = _v0.dV;
        var functionName = "send_gift_emails";
        return $author$project$Util$Request$authedHttpPost((new $$Record82(firebaseUserAuthToken, $elm$core$Maybe$Just($elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("emailAddresses", $elm$json$Json$Encode$list_fn($elm$json$Json$Encode$string, $elm$core$List$map_fn($author$project$Data$Email$toString, emails))),
            _Utils_Tuple2("invitingUserFirstName", $elm$json$Json$Encode$string(invitingUserFirstName)),
            _Utils_Tuple2("invitingUserFullName", $elm$json$Json$Encode$string(invitingUserFullName))
        ])))), $author$project$Util$Request$expecter_fn(functionName, $author$project$Model$GiftEmailsSent), _List_Nil, functionName, $elm$core$Maybe$Just($author$project$Util$Request$defaultRequestTimeout))));
    };
    var $author$project$Data$User$enocdeLinkWorkAccountAlertStatus = function (linkWorkAccountAlertStatus) {
        return $elm$json$Json$Encode$object(function () {
            switch (linkWorkAccountAlertStatus.$) {
                case 0:
                    return _List_fromArray([
                        _Utils_Tuple2("type", $elm$json$Json$Encode$string("hidden"))
                    ]);
                case 1:
                    return _List_fromArray([
                        _Utils_Tuple2("type", $elm$json$Json$Encode$string("displayable"))
                    ]);
                case 2:
                    var dismissedAt = linkWorkAccountAlertStatus.a;
                    return _List_fromArray([
                        _Utils_Tuple2("type", $elm$json$Json$Encode$string("dismissed")),
                        _Utils_Tuple2("dismissedAt", $elm$core$Basics$composeR_fn($author$project$Util$Time$encodePosixToMillis_a0, $author$project$Util$Time$encodePosixToMillis_a1, dismissedAt))
                    ]);
                default:
                    return _List_fromArray([
                        _Utils_Tuple2("type", $elm$json$Json$Encode$string("dismissed_forever"))
                    ]);
            }
        }());
    };
    var $author$project$Cmd$User$setLinkWorkAccountAlertStatus_fn = function (linkWorkAccountAlertStatus, user) {
        var alerts = user.gB;
        var newUser = function () {
            var $r = user.$c();
            $r.gB = function () {
                var $r = alerts.$c();
                $r.mH = linkWorkAccountAlertStatus;
                return $r;
            }();
            return $r;
        }();
        return _Utils_Tuple2(newUser, $author$project$Cmd$User$updateUser($elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("alerts.linkWorkAccount", $author$project$Data$User$enocdeLinkWorkAccountAlertStatus(linkWorkAccountAlertStatus))
        ]))));
    }, $author$project$Cmd$User$setLinkWorkAccountAlertStatus = F2($author$project$Cmd$User$setLinkWorkAccountAlertStatus_fn);
    var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
    var $author$project$Ports$signIn = _Platform_outgoingPort("signIn", $elm$json$Json$Encode$bool);
    var $author$project$Routing$encodeRedirectLocation = function (redirectLocation) {
        var encodeHelp = F2(function (tipe, data) {
            return $elm$json$Json$Encode$object(_Utils_ap(_List_fromArray([
                _Utils_Tuple2("type", $elm$json$Json$Encode$string(tipe))
            ]), data));
        });
        switch (redirectLocation.$) {
            case 0:
                return A2(encodeHelp, "landing", _List_Nil);
            case 1:
                return A2(encodeHelp, "home", _List_Nil);
            default:
                var route = redirectLocation.a;
                return A2(encodeHelp, "internalRoute", _List_fromArray([
                    _Utils_Tuple2("path", $elm$json$Json$Encode$string($author$project$Routing$pathFromRoute(route)))
                ]));
        }
    };
    var $author$project$Ports$signOut_ = _Platform_outgoingPort("signOut_", $elm$core$Basics$identity);
    var $author$project$Ports$signOut_a0 = $author$project$Routing$encodeRedirectLocation, $author$project$Ports$signOut_a1 = $author$project$Ports$signOut_, $author$project$Ports$signOut = A2($elm$core$Basics$composeR, $author$project$Ports$signOut_a0, $author$project$Ports$signOut_a1);
    var $author$project$Ports$stripeRedirectToSessionById = _Platform_outgoingPort("stripeRedirectToSessionById", $elm$json$Json$Encode$string);
    var $author$project$Model$FeedbackSubmitted = function (a) {
        return { $: 37, a: a };
    };
    var $author$project$Util$Request$submitFeedback = function (_v0) {
        var firebaseUserAuthToken = _v0.b9;
        var feedbackKind = _v0.lE;
        var feedback = _v0.lC;
        var functionName = "submit_feedback";
        return $author$project$Util$Request$authedHttpPost((new $$Record82(firebaseUserAuthToken, $elm$core$Maybe$Just($elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("feedbackKind", $elm$json$Json$Encode$string(feedbackKind)),
            _Utils_Tuple2("feedback", $elm$json$Json$Encode$string(feedback))
        ])))), $author$project$Util$Request$expecter_fn(functionName, $author$project$Model$FeedbackSubmitted), _List_Nil, functionName, $elm$core$Maybe$Just($author$project$Util$Request$defaultRequestTimeout))));
    };
    var $author$project$Analytics$SnackbarTimezoneUpdated = { $: 37 };
    var $author$project$Env$UpdateTimezone = function (a) {
        return { $: 27, a: a };
    };
    var $author$project$View$Snacks$timezoneChanged_fn = function (zoneName, zone) {
        var zoneText = function () {
            if (!zoneName.$) {
                var zoneName_ = zoneName.a;
                return zoneName_;
            }
            else {
                return "new timezone";
            }
        }();
        return (new $$Record78($elm$core$Maybe$Just({
            kA: "Update",
            fQ: $author$project$Env$Tantrum(_List_fromArray([
                $author$project$Env$UpdateTimezone(zone),
                $author$project$Env$AnalyticsEvent($author$project$Analytics$SnackbarTimezoneUpdated)
            ]))
        }), {
            hF: "Your timezone changed",
            cp: $elm$core$Maybe$Just("Update to use " + zoneText)
        }, true, true, 0));
    }, $author$project$View$Snacks$timezoneChanged = F2($author$project$View$Snacks$timezoneChanged_fn);
    var $author$project$Data$MentionResult$encodeMentionData = function (mentionData) {
        return $elm$json$Json$Encode$object(function () {
            if (!mentionData.$) {
                var personId = mentionData.a.iB;
                var name = mentionData.a.b;
                var email = mentionData.a.cS;
                return _List_fromArray([
                    _Utils_Tuple2("mentionType", $elm$json$Json$Encode$string("person-mention")),
                    _Utils_Tuple2("personId", $elm$json$Json$Encode$string(personId)),
                    _Utils_Tuple2("name", $elm$json$Json$Encode$string(name)),
                    _Utils_Tuple2("email", $author$project$Util$Json$encodeMaybe_fn($author$project$Util$Json$encodeMaybeString_a0, email))
                ]);
            }
            else {
                var eventId = mentionData.a.b7;
                var masterId = mentionData.a.mT;
                var title = mentionData.a.gj;
                return _List_fromArray([
                    _Utils_Tuple2("mentionType", $elm$json$Json$Encode$string("event-mention")),
                    _Utils_Tuple2("eventId", $author$project$Util$Json$encodeMaybe_fn($author$project$Util$Json$encodeMaybeString_a0, eventId)),
                    _Utils_Tuple2("masterId", $author$project$Util$Json$encodeMaybe_fn($author$project$Util$Json$encodeMaybeString_a0, masterId)),
                    _Utils_Tuple2("title", $elm$json$Json$Encode$string(title)),
                    _Utils_Tuple2("completedIn", $elm$json$Json$Encode$null)
                ]);
            }
        }());
    };
    var $author$project$Data$MentionResult$encodeMentionable = function (mentionable) {
        var selectData = _List_fromArray([
            _Utils_Tuple2("text", $elm$json$Json$Encode$string(mentionable.bd.jn)),
            _Utils_Tuple2("subtext", $author$project$Util$Json$encodeMaybe_fn($author$project$Util$Json$encodeMaybeString_a0, mentionable.bd.cp))
        ]);
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("data", $author$project$Data$MentionResult$encodeMentionData(mentionable.a)),
            _Utils_Tuple2("select", $elm$json$Json$Encode$object(selectData))
        ]));
    };
    var $author$project$Data$MentionResult$mentionResultToEditor = _Platform_outgoingPort("mentionResultToEditor", $elm$core$Basics$identity);
    var $author$project$Data$MentionResult$toEditor_a0 = $elm$json$Json$Encode$list($author$project$Data$MentionResult$encodeMentionable), $author$project$Data$MentionResult$toEditor_a1 = $author$project$Data$MentionResult$mentionResultToEditor, $author$project$Data$MentionResult$toEditor = A2($elm$core$Basics$composeR, $author$project$Data$MentionResult$toEditor_a0, $author$project$Data$MentionResult$toEditor_a1);
    var $author$project$Data$Note$toNoteAttachment = function (upload) {
        return (new $$Record24(false, $elm$core$Maybe$Just(upload.cR), upload.b8, upload.cf, upload.c1, upload.Y, $elm$core$Maybe$Nothing, upload.dn));
    };
    var $author$project$Firestore$Cmd$UnsubscribeCollection = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Firestore$Cmd$unwatchCollection = function (_v0) {
        var toFirestore = _v0.al;
        var collection = _v0._;
        return toFirestore($author$project$Firestore$Cmd$encode($author$project$Firestore$Cmd$UnsubscribeCollection($author$project$Firestore$Collection$getPath(collection))));
    };
    var $author$project$Util$Firestore$unwatch = function (collection) {
        return $author$project$Firestore$Cmd$unwatchCollection({ _: collection, al: $author$project$Ports$toFirestore });
    };
    var $author$project$Data$StorageUpload$snapshotToState = function (snapshot) {
        return {
            fD: { dJ: snapshot.dJ, cR: snapshot.cR },
            gl: (new $$Record106(snapshot.cK, snapshot.b8, snapshot.cf, snapshot.c1, snapshot.dn))
        };
    };
    var $author$project$Data$StorageUpload$update_fn = function (msg, _v0) {
        var tracker = _v0;
        if (msg.$ === 1) {
            var error = msg.a;
            return _Utils_Tuple2($elm$core$Maybe$withDefault_fn(tracker, $elm$core$Maybe$map_fn(function (_v2) {
                var entityId = _v2.bq;
                var storagePath = _v2.Y;
                return $author$project$Data$StorageUpload$removeFromTrackerHelp_fn(entityId, storagePath, tracker);
            }, error.jA)), $elm$core$Maybe$Just($elm$core$Result$Err(error)));
        }
        else {
            var snapshot = msg.a;
            var uploadComplete = _Utils_eq(snapshot.cK, snapshot.dn);
            var toCompletedUpload = function (downloadUrl) {
                return (new $$Record107(downloadUrl, snapshot.bq, snapshot.b8, snapshot.cf, snapshot.c1, snapshot.Y, snapshot.dn));
            };
            var newTracker = $elm$core$Dict$update_fn(snapshot.bq, function (mEntity) {
                if (mEntity.$ === 1) {
                    return $author$project$Util$Misc$toJustIf_fn(!uploadComplete, $elm$core$Dict$singleton_fn(snapshot.Y, $author$project$Data$StorageUpload$snapshotToState(snapshot)));
                }
                else {
                    var entityUploads = mEntity.a;
                    return $elm$core$Maybe$Just($elm$core$Dict$update_fn(snapshot.Y, function (_v4) {
                        return $author$project$Util$Misc$toJustIf_fn(!uploadComplete, $author$project$Data$StorageUpload$snapshotToState(snapshot));
                    }, entityUploads));
                }
            }, tracker);
            return _Utils_Tuple2(newTracker, $elm_community$maybe_extra$Maybe$Extra$filter_fn($elm$core$Basics$always(uploadComplete), $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, toCompletedUpload, $elm$core$Result$Ok), snapshot.cR)));
        }
    }, $author$project$Data$StorageUpload$update = F2($author$project$Data$StorageUpload$update_fn);
    var $author$project$Search$Bar$CloseSearchBar = { $: 2 };
    var $author$project$Search$Bar$NoOp = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Search$Bar$RouteToItem = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Search$Bar$config = function (env) {
        return (new $$Record48(false, {
            fk: function (_v0) {
                var doc = _v0.ll;
                return (!doc.l.lh) && (!doc.kc.lh);
            },
            fI: $elm$core$Maybe$Just(5),
            gd: $elm$core$Maybe$Just(A2($author$project$Search$Bar$timeComparator, env.pu, A2($elm$core$Basics$composeR, function ($) {
                return $.ll;
            }, A2($elm$core$Basics$composeR, function ($) {
                return $.l;
            }, function ($) {
                return $.gh;
            }))))
        }, {
            fk: A2($elm$core$Basics$composeR, function ($) {
                return $.ll;
            }, A2($elm$core$Basics$composeR, function ($) {
                return $.lh;
            }, $elm$core$Basics$not)),
            fI: $elm$core$Maybe$Just(6),
            gd: $elm$core$Maybe$Just(A2($author$project$Search$Bar$timeComparator, env.pu, A2($elm$core$Basics$composeR, function ($) {
                return $.ll;
            }, function ($) {
                return $.gh;
            })))
        }, {
            fk: A2($elm$core$Basics$composeR, function ($) {
                return $.ll;
            }, A2($elm$core$Basics$composeR, function ($) {
                return $.lh;
            }, $elm$core$Basics$not)),
            fI: $elm$core$Maybe$Just(5),
            gd: $elm$core$Maybe$Just(A2($author$project$Search$Bar$personWeightComparator, env.oq, function ($) {
                return $.l8;
            }))
        }));
    };
    var $elm$core$String$indices = _String_indexes;
    var $author$project$Util$SimpleSearch$queryWordScore_fn = function (fullQuery, searchContents, queryWord) {
        var wordLength = $elm$core$String$length(queryWord);
        var reduceContent = F2(function (content, totalScore) {
            var _v0 = _Utils_Tuple2($elm$core$String$toLower(content), $elm$core$String$length(content));
            var downcasedContent = _v0.a;
            var contentLength = _v0.b;
            var fullQueryScore = $author$project$Util$Misc$if__fn(_String_startsWith_fn(fullQuery, downcasedContent), 1, 0);
            var multiplier = $author$project$Util$Misc$if__fn(_String_startsWith_fn(queryWord, downcasedContent), 2, 1);
            return totalScore + (fullQueryScore + (multiplier * $elm$core$List$sum($elm$core$List$map_fn(function (_v1) {
                return wordLength / contentLength;
            }, _String_indexes_fn(queryWord, downcasedContent)))));
        });
        return $elm$core$List$foldl_fn(reduceContent, 0, searchContents);
    }, $author$project$Util$SimpleSearch$queryWordScore = F3($author$project$Util$SimpleSearch$queryWordScore_fn);
    var $elm$core$String$words = _String_words;
    var $author$project$Util$SimpleSearch$score_fn = function (query, contents) {
        var normalizedQuery = $elm$core$String$toLower(query);
        return $elm$core$List$sum($elm$core$List$map_fn(A2($author$project$Util$SimpleSearch$queryWordScore, normalizedQuery, contents), $elm$core$String$words(normalizedQuery)));
    }, $author$project$Util$SimpleSearch$score = F2($author$project$Util$SimpleSearch$score_fn);
    var $author$project$Search$Bar$generateEventSuggestions_fn = function (env, searchQuery, restOfQuery) {
        var queryIsEmpty = $elm$core$String$isEmpty(searchQuery);
        var currentTimeInMillis = $elm$time$Time$posixToMillis(env.k5);
        var millisFromNow = function (eventTime) {
            return currentTimeInMillis - $author$project$Data$Time$toMillis_fn(env.pu, eventTime);
        };
        var reducer = F3(function (eventId, event, acc) {
            var millisFromNow_ = millisFromNow(event.oN);
            var insertWithScore = function (finalScore) {
                return $elm$core$Dict$insert_fn($author$project$Data$Event$baseId(eventId), {
                    i3: finalScore,
                    jk: _Utils_ap(restOfQuery, _List_fromArray([
                        $author$project$Search$Query$In($author$project$Search$Query$Event_fn(event.gj, event.l8))
                    ]))
                }, acc);
            };
            if (queryIsEmpty) {
                return $author$project$Util$Misc$if__fn(millisFromNow_ > 0, insertWithScore(-millisFromNow_), acc);
            }
            else {
                var searchScore = $author$project$Util$SimpleSearch$score_fn(searchQuery, _List_fromArray([event.gj]));
                return $author$project$Util$Misc$if__fn(searchScore > 0, insertWithScore(searchScore), acc);
            }
        });
        return $elm$core$Dict$fromList($elm$core$List$indexedMap_fn_unwrapped(function (i, _v0) {
            var suggestion = _v0.jk;
            return _Utils_Tuple2(i, suggestion);
        }, $elm$core$List$take_fn(8, A2($author$project$Util$Misc$sortByReverse, function ($) {
            return $.i3;
        }, $elm$core$Dict$values($elm$core$Dict$foldl_fn(reducer, $elm$core$Dict$empty, env.lw))))));
    }, $author$project$Search$Bar$generateEventSuggestions = F3($author$project$Search$Bar$generateEventSuggestions_fn);
    var $author$project$Search$Bar$generatePeopleSuggestions_fn = function (env, searchQuery, restOfQuery) {
        var sortBy = $author$project$Util$Misc$if__fn($elm$core$String$isEmpty(searchQuery), function ($) {
            return $.iC;
        }, function ($) {
            return $.i4;
        });
        var filterMapper = F2(function (personId, person) {
            var searchScore = $author$project$Util$SimpleSearch$score_fn(searchQuery, _List_Cons(person.b, person.lo));
            return ((searchScore <= 0) || (_Utils_eq($elm$core$Maybe$Just(personId), env.pY) || person.lh)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just({
                ae: person,
                iB: personId,
                iC: $elm$core$Maybe$withDefault_fn(0, $elm$core$Dict$get_fn(personId, env.oq.iz)),
                i4: searchScore
            });
        });
        return $elm$core$Dict$fromList($elm$core$List$indexedMap_fn_unwrapped(function (index, _v0) {
            var personId = _v0.iB;
            var person = _v0.ae;
            return _Utils_Tuple2(index, _Utils_ap(restOfQuery, _List_fromArray([
                $author$project$Search$Query$With($author$project$Search$Query$Person_fn(person.b, personId))
            ])));
        }, $elm$core$List$take_fn(8, A2($author$project$Util$Misc$sortByReverse, sortBy, A2($author$project$Firestore$Collection$filterMap, filterMapper, env.iz)))));
    }, $author$project$Search$Bar$generatePeopleSuggestions = F3($author$project$Search$Bar$generatePeopleSuggestions_fn);
    var $author$project$Search$Bar$generateSuggestions_fn = function (env, query) {
        var restOfQuery = $elm$core$List$reverse($elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$List$tail($elm$core$List$reverse(query))));
        var mFirstFilter = $elm$core$List$head($elm$core$List$reverse(query));
        _v0$2: while (true) {
            if (!mFirstFilter.$) {
                switch (mFirstFilter.a.$) {
                    case 1:
                        if (mFirstFilter.a.a.$ === 1) {
                            var personSearch = mFirstFilter.a.a.a;
                            var peopleSuggestions = $author$project$Search$Bar$generatePeopleSuggestions_fn(env, personSearch, restOfQuery);
                            return $author$project$Util$Misc$toJustIf_fn(!$elm$core$Dict$isEmpty(peopleSuggestions), peopleSuggestions);
                        }
                        else {
                            break _v0$2;
                        }
                    case 0:
                        if (mFirstFilter.a.a.$ === 1) {
                            var meetingSearch = mFirstFilter.a.a.a;
                            var eventSuggestions = $author$project$Search$Bar$generateEventSuggestions_fn(env, meetingSearch, restOfQuery);
                            return $author$project$Util$Misc$toJustIf_fn(!$elm$core$Dict$isEmpty(eventSuggestions), eventSuggestions);
                        }
                        else {
                            break _v0$2;
                        }
                    default:
                        break _v0$2;
                }
            }
            else {
                break _v0$2;
            }
        }
        return $elm$core$Maybe$Nothing;
    }, $author$project$Search$Bar$generateSuggestions = F2($author$project$Search$Bar$generateSuggestions_fn);
    var $author$project$Search$Query$isEmpty = $elm$core$List$isEmpty;
    var $author$project$Analytics$SearchBarEntityOpened = function (a) {
        return { $: 34, a: a };
    };
    var $truqu$elm_base64$Base64$Encode$intToBase64 = function (i) {
        switch (i) {
            case 0:
                return "A";
            case 1:
                return "B";
            case 2:
                return "C";
            case 3:
                return "D";
            case 4:
                return "E";
            case 5:
                return "F";
            case 6:
                return "G";
            case 7:
                return "H";
            case 8:
                return "I";
            case 9:
                return "J";
            case 10:
                return "K";
            case 11:
                return "L";
            case 12:
                return "M";
            case 13:
                return "N";
            case 14:
                return "O";
            case 15:
                return "P";
            case 16:
                return "Q";
            case 17:
                return "R";
            case 18:
                return "S";
            case 19:
                return "T";
            case 20:
                return "U";
            case 21:
                return "V";
            case 22:
                return "W";
            case 23:
                return "X";
            case 24:
                return "Y";
            case 25:
                return "Z";
            case 26:
                return "a";
            case 27:
                return "b";
            case 28:
                return "c";
            case 29:
                return "d";
            case 30:
                return "e";
            case 31:
                return "f";
            case 32:
                return "g";
            case 33:
                return "h";
            case 34:
                return "i";
            case 35:
                return "j";
            case 36:
                return "k";
            case 37:
                return "l";
            case 38:
                return "m";
            case 39:
                return "n";
            case 40:
                return "o";
            case 41:
                return "p";
            case 42:
                return "q";
            case 43:
                return "r";
            case 44:
                return "s";
            case 45:
                return "t";
            case 46:
                return "u";
            case 47:
                return "v";
            case 48:
                return "w";
            case 49:
                return "x";
            case 50:
                return "y";
            case 51:
                return "z";
            case 52:
                return "0";
            case 53:
                return "1";
            case 54:
                return "2";
            case 55:
                return "3";
            case 56:
                return "4";
            case 57:
                return "5";
            case 58:
                return "6";
            case 59:
                return "7";
            case 60:
                return "8";
            case 61:
                return "9";
            case 62:
                return "+";
            default:
                return "/";
        }
    };
    var $truqu$elm_base64$Base64$Encode$toBase64 = function (_int) {
        return _Utils_ap($truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 18)), _Utils_ap($truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 12)), _Utils_ap($truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 6)), $truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 0)))));
    };
    var $truqu$elm_base64$Base64$Encode$add_fn = function (_char, _v0) {
        var res = _v0.a;
        var count = _v0.b;
        var acc = _v0.c;
        var current = (acc << 8) | _char;
        if (count === 2) {
            return _Utils_Tuple3(_Utils_ap(res, $truqu$elm_base64$Base64$Encode$toBase64(current)), 0, 0);
        }
        else {
            return _Utils_Tuple3(res, count + 1, current);
        }
    }, $truqu$elm_base64$Base64$Encode$add = F2($truqu$elm_base64$Base64$Encode$add_fn);
    var $truqu$elm_base64$Base64$Encode$chomp_fn = function (char_, acc) {
        var _char = $elm$core$Char$toCode(char_);
        return (_char < 128) ? $truqu$elm_base64$Base64$Encode$add_fn(_char, acc) : ((_char < 2048) ? $truqu$elm_base64$Base64$Encode$add_fn(128 | (63 & _char), $truqu$elm_base64$Base64$Encode$add_fn(192 | (_char >>> 6), acc)) : (((_char < 55296) || ((_char >= 57344) && (_char <= 65535))) ? $truqu$elm_base64$Base64$Encode$add_fn(128 | (63 & _char), $truqu$elm_base64$Base64$Encode$add_fn(128 | (63 & (_char >>> 6)), $truqu$elm_base64$Base64$Encode$add_fn(224 | (_char >>> 12), acc))) : $truqu$elm_base64$Base64$Encode$add_fn(128 | (63 & _char), $truqu$elm_base64$Base64$Encode$add_fn(128 | (63 & (_char >>> 6)), $truqu$elm_base64$Base64$Encode$add_fn(128 | (63 & (_char >>> 12)), $truqu$elm_base64$Base64$Encode$add_fn(240 | (_char >>> 18), acc))))));
    }, $truqu$elm_base64$Base64$Encode$chomp = F2($truqu$elm_base64$Base64$Encode$chomp_fn);
    var $truqu$elm_base64$Base64$Encode$initial = _Utils_Tuple3("", 0, 0);
    var $truqu$elm_base64$Base64$Encode$wrapUp = function (_v0) {
        var res = _v0.a;
        var cnt = _v0.b;
        var acc = _v0.c;
        switch (cnt) {
            case 1:
                return res + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 2)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc << 4)) + "=="));
            case 2:
                return res + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 10)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 4)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc << 2)) + "=")));
            default:
                return res;
        }
    };
    var $truqu$elm_base64$Base64$Encode$encode = function (input) {
        return $truqu$elm_base64$Base64$Encode$wrapUp(_String_foldl_fn($truqu$elm_base64$Base64$Encode$chomp, $truqu$elm_base64$Base64$Encode$initial, input));
    };
    var $truqu$elm_base64$Base64$encode = $truqu$elm_base64$Base64$Encode$encode;
    var $author$project$Util$UrlBase64$replaceForUrl = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("[\\+/=]"));
    var $author$project$Util$UrlBase64$encode = function (str) {
        var replaceChar = function (rematch) {
            var _v0 = rematch.by;
            switch (_v0) {
                case "+":
                    return "-";
                case "/":
                    return "_";
                default:
                    return "";
            }
        };
        return _Regex_replaceAtMost_fn($elm$regex$Regex$replace_a0, $author$project$Util$UrlBase64$replaceForUrl, replaceChar, $truqu$elm_base64$Base64$encode(str));
    };
    var $author$project$Search$Query$encodeRawQueryString = function (str) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("type", $elm$json$Json$Encode$string("text")),
            _Utils_Tuple2("text", $elm$json$Json$Encode$string(str))
        ]));
    };
    var $author$project$Search$Query$encodeRawQueryChip = function (chip) {
        var _v0 = function () {
            if (!chip.$) {
                var eventTitle = chip.a;
                var eventId = chip.b;
                return _Utils_Tuple3("event", _Utils_Tuple2("eventId", $elm$json$Json$Encode$string(eventId)), _Utils_Tuple2("eventTitle", $elm$json$Json$Encode$string(eventTitle)));
            }
            else {
                var personName = chip.a;
                var personId = chip.b;
                return _Utils_Tuple3("person", _Utils_Tuple2("personId", $elm$json$Json$Encode$string(personId)), _Utils_Tuple2("personName", $elm$json$Json$Encode$string(personName)));
            }
        }();
        var tipe = _v0.a;
        var id = _v0.b;
        var title = _v0.c;
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("type", $elm$json$Json$Encode$string(tipe)),
            id,
            title
        ]));
    };
    var $author$project$Search$Query$fileTypeToString = function (fileType) {
        switch (fileType) {
            case 0:
                return "PDF";
            case 1:
                return "document";
            case 2:
                return "image";
            case 3:
                return "video";
            default:
                return "audio";
        }
    };
    var $author$project$Search$Query$encoderReducer_fn = function (filter, _v0) {
        var rawQueryStringBuffer = _v0.a;
        var encodedRawQueryElements = _v0.b;
        var appendToBuffer = function (str) {
            return $elm$core$String$isEmpty(rawQueryStringBuffer) ? str : (rawQueryStringBuffer + (" " + str));
        };
        switch (filter.$) {
            case 5:
                var str = filter.a;
                return _Utils_Tuple2(appendToBuffer(str), encodedRawQueryElements);
            case 0:
                if (!filter.a.$) {
                    var _v2 = filter.a;
                    var eventTitle = _v2.a;
                    var eventId = _v2.b;
                    return _Utils_Tuple2("", _List_Cons($author$project$Search$Query$encodeRawQueryChip($author$project$Search$Query$EventChip_fn(eventTitle, eventId)), _List_Cons($author$project$Search$Query$encodeRawQueryString(appendToBuffer("in:")), encodedRawQueryElements)));
                }
                else {
                    var str = filter.a.a;
                    return _Utils_Tuple2("", _List_Cons($author$project$Search$Query$encodeRawQueryString(appendToBuffer("in:" + str)), encodedRawQueryElements));
                }
            case 1:
                if (!filter.a.$) {
                    var _v3 = filter.a;
                    var personName = _v3.a;
                    var personId = _v3.b;
                    return _Utils_Tuple2("", _List_Cons($author$project$Search$Query$encodeRawQueryChip($author$project$Search$Query$PersonChip_fn(personName, personId)), _List_Cons($author$project$Search$Query$encodeRawQueryString(appendToBuffer("with:")), encodedRawQueryElements)));
                }
                else {
                    var str = filter.a.a;
                    return _Utils_Tuple2("", _List_Cons($author$project$Search$Query$encodeRawQueryString(appendToBuffer("with:" + str)), encodedRawQueryElements));
                }
            case 2:
                var date = filter.a;
                return _Utils_Tuple2(appendToBuffer("before:" + $justinmimbs$date$Date$toIsoString(date)), encodedRawQueryElements);
            case 3:
                var date = filter.a;
                return _Utils_Tuple2(appendToBuffer("after:" + $justinmimbs$date$Date$toIsoString(date)), encodedRawQueryElements);
            default:
                var fileType = filter.a;
                return _Utils_Tuple2(appendToBuffer("file-type:" + $author$project$Search$Query$fileTypeToString(fileType)), encodedRawQueryElements);
        }
    }, $author$project$Search$Query$encoderReducer = F2($author$project$Search$Query$encoderReducer_fn);
    var $author$project$Search$Query$encode = function (query) {
        var lastStep = function (_v0) {
            var rawQueryStringBuffer = _v0.a;
            var encodedRawQueryElements = _v0.b;
            return (rawQueryStringBuffer === "") ? encodedRawQueryElements : _List_Cons($author$project$Search$Query$encodeRawQueryString(rawQueryStringBuffer), encodedRawQueryElements);
        };
        return $elm$json$Json$Encode$list_fn($elm$core$Basics$identity, $elm$core$List$reverse(lastStep($elm$core$List$foldl_fn($author$project$Search$Query$encoderReducer, _Utils_Tuple2("", _List_Nil), query))));
    };
    var $author$project$Search$Query$encodeToString_a0 = $author$project$Search$Query$encode, $author$project$Search$Query$encodeToString_a1 = $elm$json$Json$Encode$encode(0), $author$project$Search$Query$encodeToString = A2($elm$core$Basics$composeR, $author$project$Search$Query$encodeToString_a0, $author$project$Search$Query$encodeToString_a1);
    var $author$project$Search$Query$encodeToBase64String_a0 = $author$project$Search$Query$encodeToString, $author$project$Search$Query$encodeToBase64String_a1 = $author$project$Util$UrlBase64$encode, $author$project$Search$Query$encodeToBase64String = A2($elm$core$Basics$composeR, $author$project$Search$Query$encodeToBase64String_a0, $author$project$Search$Query$encodeToBase64String_a1);
    var $author$project$Search$Result$get_fn = function (_int, _v0) {
        var items = _v0.mA;
        return $elm$core$Dict$get_fn(_int, items);
    }, $author$project$Search$Result$get = F2($author$project$Search$Result$get_fn);
    var $author$project$Analytics$Attachment = 4;
    var $author$project$Analytics$Collation = 0;
    var $author$project$Analytics$Event = 3;
    var $author$project$Analytics$Note = 2;
    var $author$project$Analytics$Person = 1;
    var $author$project$Search$Bar$toAnalyticsEntity = function (entity) {
        switch (entity.$) {
            case 4:
                return 0;
            case 1:
                return 2;
            case 0:
                return 1;
            case 3:
                return 3;
            default:
                return 4;
        }
    };
    var $author$project$Env$SetImageViewer = function (a) {
        return { $: 20, a: a };
    };
    var $author$project$Env$ViewAttachment = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Search$Bar$toItemMsg = function (resultItem) {
        switch (resultItem.$) {
            case 4:
                var collation = resultItem.a;
                return $author$project$Env$RouteToURLRequest($author$project$Routing$RouteCollate_fn(collation.ll, $elm$core$Maybe$Nothing));
            case 0:
                var person = resultItem.a;
                return $author$project$Env$RouteToURLRequest($author$project$Routing$RoutePerson(person.l8));
            case 1:
                var note = resultItem.a;
                return $author$project$Env$RouteToURLRequest($author$project$Routing$RouteNote_fn(note.l8, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
            case 3:
                var event = resultItem.a;
                return $author$project$Env$RouteToURLRequest($author$project$Routing$RouteCreateEventNote_fn(event.ll.l8, $author$project$Data$Event$masterId(event.ll), $elm$core$Maybe$Nothing));
            default:
                var doc = resultItem.a.ll;
                var _v1 = _Utils_Tuple2(_String_startsWith_fn("image/", doc.kc.c1), doc.kc.cR);
                if (_v1.a && (!_v1.b.$)) {
                    var downloadUrl = _v1.b.a;
                    return $author$project$Env$SetImageViewer($elm$core$Maybe$Just({ ma: downloadUrl }));
                }
                else {
                    return $author$project$Env$ViewAttachment(doc.kc);
                }
        }
    };
    var $author$project$Search$Bar$routeToResult_fn = function (env, model, itemIndex) {
        var item = $author$project$Search$Result$get_fn(itemIndex, model.p);
        var mAnalytic = $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $author$project$Search$Bar$toAnalyticsEntity, A2($elm$core$Basics$composeR, $author$project$Analytics$SearchBarEntityOpened, $author$project$Env$AnalyticsEvent)), item);
        var currentCategory = function () {
            var _v0 = env.oe;
            if (_v0.$ === 12) {
                var mCategory = _v0.b;
                return mCategory;
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }();
        var mItemMsg = (_Utils_eq(itemIndex, $author$project$Search$Bar$viewAllResultsIndex) || $author$project$Routing$isSearch(env.oe)) ? $elm$core$Maybe$Just($author$project$Env$RouteToURLRequest(function (encodedQuery) {
            return $author$project$Routing$RouteSearch_fn(encodedQuery, currentCategory);
        }($elm$core$Maybe$Just($elm$core$Basics$composeR_fn($author$project$Search$Query$encodeToBase64String_a0, $author$project$Search$Query$encodeToBase64String_a1, model.n$))))) : $elm$core$Maybe$map_fn($author$project$Search$Bar$toItemMsg, item);
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$Tantrum($elm_community$maybe_extra$Maybe$Extra$cons_fn(mItemMsg, $elm_community$maybe_extra$Maybe$Extra$cons_fn(mAnalytic, _List_fromArray([
            $author$project$Env$ShowSearch(false)
        ]))))));
    }, $author$project$Search$Bar$routeToResult = F3($author$project$Search$Bar$routeToResult_fn);
    var $author$project$Search$Bar$setSearchbarQuery_ = _Platform_outgoingPort("setSearchbarQuery_", $elm$core$Basics$identity);
    var $author$project$Search$Bar$setSearchbarQuery_a0 = $author$project$Search$Query$encode, $author$project$Search$Bar$setSearchbarQuery_a1 = $author$project$Search$Bar$setSearchbarQuery_, $author$project$Search$Bar$setSearchbarQuery = A2($elm$core$Basics$composeR, $author$project$Search$Bar$setSearchbarQuery_a0, $author$project$Search$Bar$setSearchbarQuery_a1);
    var $author$project$Search$Result$size = function (_v0) {
        var items = _v0.mA;
        return $elm$core$Dict$size(items);
    };
    var $author$project$Search$Bar$routeToSuggestion_fn = function (env, model, searchIndices, querySuggestions, itemIndex) {
        var _v9 = $elm$core$Dict$get_fn(itemIndex, querySuggestions);
        if (!_v9.$) {
            var query = _v9.a;
            return function (_v10) {
                var model_ = _v10.a;
                var cmds = _v10.b;
                var backtalk = _v10.c;
                return _Utils_Tuple3(model_, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmds,
                    $elm$core$Basics$composeR_fn($author$project$Search$Bar$setSearchbarQuery_a0, $author$project$Search$Bar$setSearchbarQuery_a1, query)
                ])), backtalk);
            }($author$project$Search$Bar$update_fn(env, searchIndices, $author$project$Search$Bar$GenerateResult, function () {
                var $r = model.$c();
                $r.gf = $elm$core$Maybe$Nothing;
                $r.n$ = query;
                return $r;
            }()));
        }
        else {
            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }
    }, $author$project$Search$Bar$routeToSuggestion = F5($author$project$Search$Bar$routeToSuggestion_fn);
    var $author$project$Search$Bar$update_fn = function (env, indices, msg, model) {
        switch (msg.$) {
            case 0:
                var text = msg.a;
                var _v1 = function () {
                    var _v2 = _Json_run_fn($author$project$Search$Query$decoder, text);
                    if (!_v2.$) {
                        var query_ = _v2.a;
                        return _Utils_Tuple2(query_, $elm$core$Platform$Cmd$none);
                    }
                    else {
                        var err = _v2.a;
                        return _Utils_Tuple2($author$project$Search$Query$empty, $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$Decoding({
                            lg: $elm$json$Json$Decode$errorToString(err),
                            he: "Search Query"
                        }))));
                    }
                }();
                var query = _v1.a;
                var mLogError = _v1.b;
                var suggestions = $author$project$Search$Bar$generateSuggestions_fn(env, query);
                var focusedItemIndex = $author$project$Util$Misc$if__fn($elm_community$maybe_extra$Maybe$Extra$isNothing(suggestions), $author$project$Search$Bar$viewAllResultsIndex, 0);
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.gf = suggestions;
                    $r.n$ = query;
                    $r.p = $author$project$Util$Misc$if__fn($author$project$Search$Query$isEmpty(query), $author$project$Search$Result$empty, model.p);
                    $r.z = $elm$core$Maybe$Just(focusedItemIndex);
                    return $r;
                }(), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Lib$Debouncer$poke_fn("generateResults", $author$project$Search$Bar$GenerateResult, model.ld),
                    mLogError
                ])), $elm$core$Maybe$Nothing);
            case 1:
                var newResult = $author$project$Search$Result$search_fn(env, indices, $author$project$Search$Bar$config(env), $elm$core$Maybe$Nothing, model.n$);
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.p = newResult;
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 2:
                return _Utils_Tuple3(model, $author$project$Lib$Focuser$init($author$project$Search$Bar$NoOp), $elm$core$Maybe$Just($author$project$Env$ShowSearch(false)));
            case 3:
                var mItemId = msg.a;
                return _Utils_Tuple3($$update__z(model, mItemId), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 4:
                var _v3 = function () {
                    var _v4 = model.gf;
                    if (_v4.$ === 1) {
                        return _Utils_Tuple2($author$project$Search$Result$size(model.p), $author$project$Search$Bar$viewAllResultsIndex);
                    }
                    else {
                        var suggestions = _v4.a;
                        return _Utils_Tuple2($elm$core$Dict$size(suggestions), 0);
                    }
                }();
                var numItems = _v3.a;
                var topItemIndex = _v3.b;
                var newFocusedItem = (_Utils_eq(model.z, $elm$core$Maybe$Just(topItemIndex)) || _Utils_eq(model.z, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(numItems - 1) : $elm$core$Maybe$map_fn(function (focussedItem) {
                    return focussedItem - 1;
                }, model.z);
                return _Utils_Tuple3($$update__z(model, newFocusedItem), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 5:
                var _v5 = function () {
                    var _v6 = model.gf;
                    if (_v6.$ === 1) {
                        return _Utils_Tuple2($author$project$Search$Result$size(model.p), $author$project$Search$Bar$viewAllResultsIndex);
                    }
                    else {
                        var suggestions = _v6.a;
                        return _Utils_Tuple2($elm$core$Dict$size(suggestions), 0);
                    }
                }();
                var numItems = _v5.a;
                var topItemIndex = _v5.b;
                var newFocusedItem = (_Utils_eq(model.z, $elm$core$Maybe$Just(numItems - 1)) || _Utils_eq(model.z, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(topItemIndex) : $elm$core$Maybe$map_fn(function (focussedItem) {
                    return focussedItem + 1;
                }, model.z);
                return _Utils_Tuple3($$update__z(model, newFocusedItem), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 6:
                return _Utils_Tuple3(model, $author$project$Util$Cmd$executeMsg($author$project$Search$Bar$RouteToItem($elm$core$Maybe$withDefault_fn($author$project$Search$Bar$viewAllResultsIndex, model.z))), $elm$core$Maybe$Nothing);
            case 7:
                var clearOrCloseSearchbar = $author$project$Search$Query$isEmpty(model.n$) ? $author$project$Util$Cmd$executeMsg($author$project$Search$Bar$CloseSearchBar) : $elm$core$Basics$composeR_fn($author$project$Search$Bar$setSearchbarQuery_a0, $author$project$Search$Bar$setSearchbarQuery_a1, $author$project$Search$Query$empty);
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.n$ = $author$project$Search$Query$empty;
                    $r.p = $author$project$Search$Result$empty;
                    $r.z = $elm$core$Maybe$Just($author$project$Search$Bar$viewAllResultsIndex);
                    return $r;
                }(), clearOrCloseSearchbar, $elm$core$Maybe$Nothing);
            case 8:
                var itemIndex = msg.a;
                var _v7 = model.gf;
                if (!_v7.$) {
                    var suggestions = _v7.a;
                    return $author$project$Search$Bar$routeToSuggestion_fn(env, model, indices, suggestions, itemIndex);
                }
                else {
                    return $author$project$Search$Bar$routeToResult_fn(env, model, itemIndex);
                }
            case 9:
                var debouncerMsg = msg.a;
                var _v8 = $author$project$Lib$Debouncer$update_fn(debouncerMsg, model.ld);
                var newDebouncer = _v8.a;
                var cmd = _v8.b;
                return _Utils_Tuple3($$update__ld(model, newDebouncer), cmd, $elm$core$Maybe$Nothing);
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }
    }, $author$project$Search$Bar$update = F4($author$project$Search$Bar$update_fn);
    var $author$project$Data$Dialog$Closeable$EditNoteTime = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$Dialog$Closeable$updateEditNoteTime_fn = function (newNewTime, dialog) {
        if (!dialog.$) {
            var noteId = dialog.a.ip;
            return $author$project$Data$Dialog$Closeable$EditNoteTime({ nc: newNewTime, ip: noteId });
        }
        else {
            var other = dialog;
            return other;
        }
    }, $author$project$Data$Dialog$Closeable$updateEditNoteTime = F2($author$project$Data$Dialog$Closeable$updateEditNoteTime_fn);
    var $author$project$Model$ActionItemsMsg = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Model$BillingMsg = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Model$CollateMsg = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Model$DemoMsg = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Model$SettingsMsg = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Model$SignupMsg = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Page$ActionItems$ActionItemMsg = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Page$ActionItems$getOptions = function (env) {
        var _v0 = env.oe;
        if (_v0.$ === 1) {
            var opts = _v0.a;
            return opts;
        }
        else {
            return $author$project$Routing$defaultThreadsParams;
        }
    };
    var $author$project$View$ActionItems$RemoveFromFadingSet = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Env$ToggleActionItem_fn = function (a, b) {
        return { $: 6, a: a, b: b };
    }, $author$project$Env$ToggleActionItem = F2($author$project$Env$ToggleActionItem_fn);
    var $author$project$Lib$Debouncer$cancel_fn = function (id, _v0) {
        var config = _v0.a;
        var trackers = _v0.b;
        return $author$project$Lib$Debouncer$Debouncer_fn(config, $elm$core$Dict$remove_fn(id, trackers));
    }, $author$project$Lib$Debouncer$cancel = F2($author$project$Lib$Debouncer$cancel_fn);
    var $elm$core$Set$remove_fn = function (key, _v0) {
        var dict = _v0;
        return $elm$core$Dict$remove_fn(key, dict);
    }, $elm$core$Set$remove = F2($elm$core$Set$remove_fn);
    var $author$project$View$ActionItems$update_fn = function (msg, model) {
        switch (msg.$) {
            case 2:
                var actionItem = msg.a;
                var _v1 = (!$author$project$Data$ActionItem$isComplete(actionItem)) ? _Utils_Tuple3(model.aG, $author$project$Lib$Debouncer$poke_fn(actionItem.l8, $author$project$View$ActionItems$RemoveFromFadingSet(actionItem.l8), model.aG), $elm$core$Set$insert_fn(actionItem.l8, model.O)) : _Utils_Tuple3($author$project$Lib$Debouncer$cancel_fn(actionItem.l8, model.aG), $author$project$Util$Cmd$delayBy_fn(100, $author$project$View$ActionItems$RemoveFromFadingSet(actionItem.l8)), model.O);
                var newDebouncer = _v1.a;
                var cmd = _v1.b;
                var newFadingSet = _v1.c;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.O = newFadingSet;
                    $r.aG = newDebouncer;
                    return $r;
                }(), cmd, $elm$core$Maybe$Just($author$project$Env$ToggleActionItem_fn({ pD: $elm$core$Maybe$Nothing }, actionItem)));
            case 0:
                var debounceMsg = msg.a;
                var _v2 = $author$project$Lib$Debouncer$update_fn(debounceMsg, model.aG);
                var newDebouncer = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.aG = newDebouncer;
                    return $r;
                }(), cmd, $elm$core$Maybe$Nothing);
            default:
                var uid_ = msg.a;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.O = $elm$core$Set$remove_fn(uid_, model.O);
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }
    }, $author$project$View$ActionItems$update = F2($author$project$View$ActionItems$update_fn);
    var $author$project$Page$ActionItems$update_fn = function (env, msg, model) {
        var options = $author$project$Page$ActionItems$getOptions(env);
        if (!msg.$) {
            var actionItemMsg = msg.a;
            var _v1 = $author$project$View$ActionItems$update_fn(actionItemMsg, model.bQ);
            var newActionItemFader = _v1.a;
            var cmds = _v1.b;
            var mBacktalk = _v1.c;
            return _Utils_Tuple3($$update__bQ(model, newActionItemFader), _Platform_map_fn($author$project$Page$ActionItems$ActionItemMsg, cmds), mBacktalk);
        }
        else {
            var flag = msg.a;
            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$RouteToURLRequest($author$project$Routing$RouteThreads($$update__eG(options, flag)))));
        }
    }, $author$project$Page$ActionItems$update = F3($author$project$Page$ActionItems$update_fn);
    var $author$project$Env$StripeGenerateSubscriptionManagementUrl = { $: 31 };
    var $author$project$Page$Billing$update_fn = function (env, msg, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$StripeGenerateSubscriptionManagementUrl));
    }, $author$project$Page$Billing$update = F3($author$project$Page$Billing$update_fn);
    var $author$project$Page$Calendar$update_fn = function (env, msg, model) {
        if (!msg.$) {
            var offset = msg.a;
            return _Utils_Tuple3(model, (!offset) ? $author$project$Routing$reroute_fn(env, $author$project$Routing$RouteCalendar($elm$core$Maybe$Nothing)) : $author$project$Routing$reroute_fn(env, $author$project$Routing$RouteCalendar($elm$core$Maybe$Just($justinmimbs$date$Date$add_fn(2, offset, $justinmimbs$date$Date$fromPosix_fn(env.pu, env.k5))))), $elm$core$Maybe$Nothing);
        }
        else {
            var analyticsEvent = msg.a;
            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$AnalyticsEvent(analyticsEvent)));
        }
    }, $author$project$Page$Calendar$update = F3($author$project$Page$Calendar$update_fn);
    var $author$project$Env$NavigateBackwards = { $: 1 };
    var $author$project$Page$Collate$update_fn = function (env, msg, model) {
        if (!msg.$) {
            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$NavigateBackwards));
        }
        else {
            var backtalk = msg.a;
            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(backtalk));
        }
    }, $author$project$Page$Collate$update = F3($author$project$Page$Collate$update_fn);
    var $author$project$Page$Demo$update_fn = function (msg, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
    }, $author$project$Page$Demo$update = F2($author$project$Page$Demo$update_fn);
    var $author$project$Page$Home$ActionItemMsg = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Page$Home$update_fn = function (env, msg, model) {
        switch (msg.$) {
            case 0:
                var offset = msg.a;
                return _Utils_Tuple3(model, (!offset) ? $author$project$Routing$reroute_fn(env, $author$project$Routing$RouteHome($elm$core$Maybe$Nothing)) : $author$project$Routing$reroute_fn(env, $author$project$Routing$RouteHome($elm$core$Maybe$Just($justinmimbs$date$Date$add_fn(3, offset, $justinmimbs$date$Date$fromPosix_fn(env.pu, env.k5))))), $elm$core$Maybe$Nothing);
            case 1:
                var actionItemMsg = msg.a;
                var _v1 = $author$project$View$ActionItems$update_fn(actionItemMsg, model.bQ);
                var newActionItemModel = _v1.a;
                var cmds = _v1.b;
                var mBacktalk = _v1.c;
                return _Utils_Tuple3($$update__bQ(model, newActionItemModel), _Platform_map_fn($author$project$Page$Home$ActionItemMsg, cmds), mBacktalk);
            case 2:
                var tab = msg.a;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.dl = tab;
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            default:
                var analyticsEvent = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$AnalyticsEvent(analyticsEvent)));
        }
    }, $author$project$Page$Home$update = F3($author$project$Page$Home$update_fn);
    var $author$project$Page$Note$ActionItemMsg = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Env$CancelAttachmentUpload_fn = function (a, b) {
        return { $: 7, a: a, b: b };
    }, $author$project$Env$CancelAttachmentUpload = F2($author$project$Env$CancelAttachmentUpload_fn);
    var $author$project$Env$CreateAdHocPersonOnNote_fn = function (a, b) {
        return { $: 33, a: a, b: b };
    }, $author$project$Env$CreateAdHocPersonOnNote = F2($author$project$Env$CreateAdHocPersonOnNote_fn);
    var $author$project$Page$Note$NoOp = function (a) {
        return { $: 37, a: a };
    };
    var $author$project$Page$Note$ShowClipboardNotification = function (a) {
        return { $: 18, a: a };
    };
    var $author$project$Env$UpdateNoteWithoutSaving_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$Env$UpdateNoteWithoutSaving = F2($author$project$Env$UpdateNoteWithoutSaving_fn);
    var $author$project$Analytics$SnackbarUndoDeleteAttachment = { $: 36 };
    var $author$project$Data$Note$setAttachmentDeleted_fn = function (flag, _v0, note) {
        var storagePath = _v0.Y;
        return $$update__kd(note, $elm$core$List$map_fn(function (attachment) {
            return _Utils_eq(attachment.Y, storagePath) ? $$update__lh(attachment, flag) : attachment;
        }, note.kd));
    }, $author$project$Data$Note$setAttachmentDeleted = F3($author$project$Data$Note$setAttachmentDeleted_fn);
    var $author$project$Data$Note$restoreAttachment_a0 = false, $author$project$Data$Note$restoreAttachment = $author$project$Data$Note$setAttachmentDeleted($author$project$Data$Note$restoreAttachment_a0);
    var $author$project$View$Snacks$attachmentDeleted_fn = function (noteId, attachment) {
        var onClick = $author$project$Env$Tantrum(_List_fromArray([
            $author$project$Env$UpdateNote((new $$Record77(false, noteId, $author$project$Data$Note$restoreAttachment(attachment)))),
            $author$project$Env$AnalyticsEvent($author$project$Analytics$SnackbarUndoDeleteAttachment)
        ]));
        return (new $$Record78($elm$core$Maybe$Just({ kA: "Undo", fQ: onClick }), {
            hF: "Attachment deleted",
            cp: $elm$core$Maybe$Just(attachment.b8)
        }, false, false, 0));
    }, $author$project$View$Snacks$attachmentDeleted = F2($author$project$View$Snacks$attachmentDeleted_fn);
    var $author$project$Page$Note$attachmentRenameFormId = "rename-attachment-form";
    var $author$project$Routing$changeNotePageTabTo_fn = function (tab, route) {
        switch (route.$) {
            case 3:
                var noteId = route.a;
                var eventId = route.b;
                return $author$project$Routing$RouteNewEventNote_fn(noteId, eventId, $elm$core$Maybe$Just(tab));
            case 5:
                var noteId = route.a;
                var posix_ = route.b;
                return $author$project$Routing$RouteNewAdHocNote_fn(noteId, posix_, $elm$core$Maybe$Just(tab));
            case 6:
                var noteId_ = route.a;
                var mPos = route.b;
                return $author$project$Routing$RouteNote_fn(noteId_, mPos, $elm$core$Maybe$Just(tab));
            default:
                return route;
        }
    }, $author$project$Routing$changeNotePageTabTo = F2($author$project$Routing$changeNotePageTabTo_fn);
    var $author$project$Data$Note$deleteAttachment_a0 = true, $author$project$Data$Note$deleteAttachment = $author$project$Data$Note$setAttachmentDeleted($author$project$Data$Note$deleteAttachment_a0);
    var $author$project$Ports$downloadAttachment = _Platform_outgoingPort("downloadAttachment", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("downloadUrl", $elm$json$Json$Encode$string($.cR)),
            _Utils_Tuple2("filename", $elm$json$Json$Encode$string($.lG))
        ]));
    });
    var $author$project$Ports$dragStartActionItem = _Platform_outgoingPort("dragStartActionItem", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("dragEvent", $elm$core$Basics$identity($.ha)),
            _Utils_Tuple2("href", $elm$json$Json$Encode$string($.l2)),
            _Utils_Tuple2("text", $elm$json$Json$Encode$string($.jn))
        ]));
    });
    var $author$project$Util$Page$manyMsgHandler_fn = function (pageUpdater, initModel, msgs) {
        var reducer = F2(function (msg, _v2) {
            var model = _v2.a;
            var cmds = _v2.b;
            var backtalks = _v2.c;
            var _v1 = A2(pageUpdater, msg, model);
            var newModel = _v1.a;
            var newCmd = _v1.b;
            var newBacktalk = _v1.c;
            return _Utils_Tuple3(newModel, _List_Cons(newCmd, cmds), $elm_community$maybe_extra$Maybe$Extra$cons_fn(newBacktalk, backtalks));
        });
        var finalize = function (_v0) {
            var finalModel = _v0.a;
            var cmds = _v0.b;
            var mBacktalks = _v0.c;
            return _Utils_Tuple3(finalModel, $elm$core$Platform$Cmd$batch(cmds), $elm$core$Maybe$Just($author$project$Env$Tantrum(mBacktalks)));
        };
        return finalize($elm$core$List$foldl_fn(reducer, _Utils_Tuple3(initModel, _List_Nil, _List_Nil), msgs));
    }, $author$project$Util$Page$manyMsgHandler_fn_unwrapped = function (pageUpdater, initModel, msgs) {
        var reducer = F2(function (msg, _v2) {
            var model = _v2.a;
            var cmds = _v2.b;
            var backtalks = _v2.c;
            var _v1 = pageUpdater(msg, model);
            var newModel = _v1.a;
            var newCmd = _v1.b;
            var newBacktalk = _v1.c;
            return _Utils_Tuple3(newModel, _List_Cons(newCmd, cmds), $elm_community$maybe_extra$Maybe$Extra$cons_fn(newBacktalk, backtalks));
        });
        var finalize = function (_v0) {
            var finalModel = _v0.a;
            var cmds = _v0.b;
            var mBacktalks = _v0.c;
            return _Utils_Tuple3(finalModel, $elm$core$Platform$Cmd$batch(cmds), $elm$core$Maybe$Just($author$project$Env$Tantrum(mBacktalks)));
        };
        return finalize($elm$core$List$foldl_fn(reducer, _Utils_Tuple3(initModel, _List_Nil, _List_Nil), msgs));
    }, $author$project$Util$Page$manyMsgHandler = F3($author$project$Util$Page$manyMsgHandler_fn);
    var $author$project$Analytics$SnackbarUndoDeleteNote = { $: 35 };
    var $author$project$View$Snacks$noteDeleted_fn = function (noteId, mNoteTitle) {
        var onClick = $author$project$Env$Tantrum(_List_fromArray([
            $author$project$Env$UpdateNote((new $$Record77(false, noteId, function (note) {
                return $$update__lh(note, false);
            }))),
            $author$project$Env$AnalyticsEvent($author$project$Analytics$SnackbarUndoDeleteNote)
        ]));
        return (new $$Record78($elm$core$Maybe$Just({ kA: "Undo", fQ: onClick }), { hF: "Note deleted", cp: mNoteTitle }, false, false, 0));
    }, $author$project$View$Snacks$noteDeleted = F2($author$project$View$Snacks$noteDeleted_fn);
    var $author$project$Ports$openPopup = _Platform_outgoingPort("openPopup", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("url", $elm$json$Json$Encode$string($.dt))
        ]));
    });
    var $elm_community$list_extra$List$Extra$remove_fn = function (x, xs) {
        if (!xs.b) {
            return _List_Nil;
        }
        else {
            var y = xs.a;
            var ys = xs.b;
            return _Utils_eq(x, y) ? ys : _List_Cons(y, $elm_community$list_extra$List$Extra$remove_fn(x, ys));
        }
    }, $elm_community$list_extra$List$Extra$remove = F2($elm_community$list_extra$List$Extra$remove_fn);
    var $author$project$Data$Note$renameAttachment_fn = function (newName, _v0, note) {
        var storagePath = _v0.Y;
        return $$update__kd(note, $elm$core$List$map_fn(function (attachment) {
            return _Utils_eq(attachment.Y, storagePath) ? function () {
                var $r = attachment.$c();
                $r.b8 = newName;
                return $r;
            }() : attachment;
        }, note.kd));
    }, $author$project$Data$Note$renameAttachment = F3($author$project$Data$Note$renameAttachment_fn);
    var $author$project$Ports$setSelectionRange = _Platform_outgoingPort("setSelectionRange", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("end", $elm$json$Json$Encode$int($.b6)),
            _Utils_Tuple2("id", $elm$json$Json$Encode$string($.l8)),
            _Utils_Tuple2("start", $elm$json$Json$Encode$int($.bF))
        ]));
    });
    var $author$project$Data$Note$softDelete = function (note) {
        return function () {
            var $r = note.$c();
            $r.lh = true;
            $r.mF = false;
            return $r;
        }();
    };
    var $author$project$Ports$uploadAttachments = _Platform_outgoingPort("uploadAttachments", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("files", $elm$json$Json$Encode$list($elm$core$Basics$identity)($.lH)),
            _Utils_Tuple2("noteId", $elm$json$Json$Encode$string($.ip))
        ]));
    });
    var $author$project$Page$Note$update_fn = function (env, currentNoteId, msg, model) {
        switch (msg.$) {
            case 0:
                var noteId = msg.a;
                var title = msg.b;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateNote((new $$Record77(true, noteId, function (note) {
                    return function () {
                        var $r = note.$c();
                        $r.gj = title;
                        return $r;
                    }();
                })))));
            case 1:
                var noteId = msg.a;
                var mEventRef = msg.b;
                var slateDoc = msg.c.f6;
                var plaintext = msg.c.nP;
                var actionItems = msg.c.gz;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.bS = $author$project$Data$ActionItemsCache$update_fn(mEventRef, model.bS, actionItems);
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$Tantrum(_List_fromArray([
                    $author$project$Env$UpdateNote((new $$Record77(true, noteId, function (note) {
                        return $$update__f6__fc__gz(note, slateDoc, plaintext, actionItems);
                    })))
                ]))));
            case 2:
                var noteId = msg.a;
                var actionItem = msg.b;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$ToggleActionItem_fn({
                    pD: $elm$core$Maybe$Just(noteId)
                }, actionItem)));
            case 3:
                var actionItemMsg = msg.a;
                var _v1 = $author$project$View$ActionItems$update_fn(actionItemMsg, model.bQ);
                var newActionItemModel = _v1.a;
                var cmds = _v1.b;
                var mBacktalk = _v1.c;
                return _Utils_Tuple3($$update__bQ(model, newActionItemModel), _Platform_map_fn($author$project$Page$Note$ActionItemMsg, cmds), mBacktalk);
            case 4:
                var data = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$dragStartActionItem(data), $elm$core$Maybe$Nothing);
            case 5:
                var flag = msg.a;
                return _Utils_Tuple3($$update__ar__bE(model, "", flag), $author$project$Util$Cmd$focusOnElement_fn($author$project$Page$Note$NoOp("focus witful-note-add-attendee"), "witful-note-add-attendee"), $elm$core$Maybe$Nothing);
            case 6:
                var val = msg.a;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.ar = val;
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 8:
                var noteId = msg.a;
                var name = msg.b;
                return _Utils_Tuple3($$update__ar__bE(model, "", false), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$CreateAdHocPersonOnNote_fn(noteId, name)));
            case 7:
                var noteId = msg.a;
                var attendee = msg.b;
                var addAttendee_ = function (note) {
                    return $$update__ke(note, _Utils_ap(note.ke, _List_fromArray([attendee])));
                };
                return _Utils_Tuple3($$update__ar__bE(model, "", false), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateNote((new $$Record77(false, noteId, addAttendee_)))));
            case 9:
                var noteId = msg.a;
                var attendee = msg.b;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateNote((new $$Record77(false, noteId, function (note) {
                    return $$update__ke(note, $elm_community$list_extra$List$Extra$remove_fn(attendee, note.ke));
                })))));
            case 10:
                var noteId = msg.a;
                var attendee = msg.b;
                var responseStatus = msg.c;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateNote((new $$Record77(false, noteId, function (note) {
                    return $$update__ke(note, $elm$core$List$member_fn(attendee, note.ke) ? _List_Cons(function () {
                        var $r = attendee.$c();
                        $r.nH = $elm$core$Maybe$Just(responseStatus);
                        return $r;
                    }(), $elm_community$list_extra$List$Extra$remove_fn(attendee, note.ke)) : note.ke);
                })))));
            case 11:
                var noteId = msg.a;
                var flag = msg.b;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateNote((new $$Record77(false, noteId, function (note) {
                    return function () {
                        var $r = note.$c();
                        $r.mF = flag;
                        return $r;
                    }();
                })))));
            case 12:
                var noteId = msg.a;
                var mNoteTitle = $elm$core$Maybe$map_fn(function ($) {
                    return $.gj;
                }, $author$project$Firestore$Collection$get_fn(noteId, env.fO));
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$Tantrum(_List_fromArray([
                    $author$project$Env$PushToSnackbar($author$project$View$Snacks$noteDeleted_fn(noteId, mNoteTitle)),
                    $author$project$Env$UpdateNote((new $$Record77(false, noteId, $author$project$Data$Note$softDelete))),
                    $author$project$Env$NavigateBackwards
                ]))));
            case 22:
                var attachment = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$ViewAttachment(attachment)));
            case 23:
                var imageUrl = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$SetImageViewer($elm$core$Maybe$Just(imageUrl))));
            case 24:
                var attachmentInfo = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$downloadAttachment(attachmentInfo), $elm$core$Maybe$Nothing);
            case 25:
                var attachment = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$Tantrum(_List_fromArray([
                    $author$project$Env$UpdateNote((new $$Record77(false, currentNoteId, $author$project$Data$Note$deleteAttachment(attachment)))),
                    $author$project$Env$PushToSnackbar($author$project$View$Snacks$attachmentDeleted_fn(currentNoteId, attachment))
                ]))));
            case 26:
                var otherData = msg.a;
                var attachmentPointer = msg.b;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$AttachmentThumbnailUrlRequest_fn(otherData, attachmentPointer)));
            case 27:
                var noteId = msg.a;
                var pathInStorage = msg.b;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$CancelAttachmentUpload_fn(noteId, pathInStorage)));
            case 28:
                var flag = msg.a;
                return _Utils_Tuple3($$update__cE(model, flag), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 29:
                var noteId = msg.a;
                var file = msg.b;
                var files = msg.c;
                return _Utils_Tuple3($$update__cE(model, false), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Ports$uploadAttachments({
                        lH: $elm$core$List$map_fn(function ($) {
                            return $.p_;
                        }, _List_Cons(file, files)),
                        ip: noteId
                    }),
                    $author$project$Routing$reroute_fn(env, $author$project$Routing$changeNotePageTabTo_fn(2, env.oe))
                ])), $elm$core$Maybe$Nothing);
            case 13:
                var noteId = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateNote((new $$Record77(false, noteId, function (note) {
                    return $$update__lh(note, false);
                })))));
            case 30:
                var noteId = msg.a;
                var maybeConfUrl = $elm$core$Maybe$andThen_fn(function ($) {
                    return $.e5;
                }, $elm$core$Maybe$andThen_fn(function (note) {
                    return $author$project$Data$Note$getEvent_fn(note, env.lw);
                }, $author$project$Firestore$Collection$get_fn(noteId, env.fO)));
                return _Utils_Tuple3(model, $author$project$Util$Cmd$whenJust_fn(maybeConfUrl, function (confUrl) {
                    return $author$project$Ports$openPopup({ dt: confUrl });
                }), $elm$core$Maybe$Nothing);
            case 14:
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.aw = !model.aw;
                    $r.c4 = false;
                    return $r;
                }(), $author$project$Lib$Focuser$init($author$project$Page$Note$NoOp), $elm$core$Maybe$Nothing);
            case 15:
                var isFocused = msg.a;
                return _Utils_Tuple3($$update__ff(model, isFocused), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 16:
                return _Utils_Tuple3(model, $author$project$Lib$Focuser$init($author$project$Page$Note$NoOp), $elm$core$Maybe$Nothing);
            case 17:
                var noteId = msg.a;
                var slateDoc = msg.b;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateNoteWithoutSaving_fn(noteId, function (note) {
                    return function () {
                        var $r = note.$c();
                        $r.f6 = slateDoc;
                        return $r;
                    }();
                })));
            case 18:
                var flag = msg.a;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.eF = flag;
                    return $r;
                }(), $author$project$Util$Cmd$when_fn(flag, $elm$core$Task$perform_fn(function (_v2) {
                    return $author$project$Page$Note$ShowClipboardNotification(false);
                }, $elm$core$Process$sleep(1500))), $elm$core$Maybe$Nothing);
            case 19:
                var mAttachmentId = msg.a;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.cF = mAttachmentId;
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 20:
                var mAttachmentBeforeRename = msg.a;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.cG = mAttachmentBeforeRename;
                    return $r;
                }(), $author$project$Util$Cmd$when_fn($elm_community$maybe_extra$Maybe$Extra$isJust(mAttachmentBeforeRename), $author$project$Ports$setSelectionRange((new $$Record108(-1, $author$project$Page$Note$attachmentRenameFormId, 0)))), $elm$core$Maybe$Nothing);
            case 21:
                var attachment = msg.a;
                var newName = msg.b;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$Tantrum(_List_fromArray([
                    $author$project$Env$UpdateNote((new $$Record77(true, currentNoteId, A2($author$project$Data$Note$renameAttachment, newName, attachment))))
                ]))));
            case 31:
                var noteId = msg.a;
                var editNoteTimeDialog = $elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$EditNoteTime({ nc: "", ip: noteId }));
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$SetDialog(editNoteTimeDialog)));
            case 32:
                var flag = msg.a;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.c4 = flag;
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 33:
                var switchToAttendeesTabWhenEmpty = msg.a.o6;
                var newActionItemsCache = $author$project$Data$ActionItemsCache$generate_fn(env, currentNoteId);
                var newTab = switchToAttendeesTabWhenEmpty ? $elm$core$Maybe$withDefault_fn($author$project$Page$Note$fallbackTab_fn(env, newActionItemsCache), $author$project$Routing$notePageTab(env.oe)) : model.b1;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.b1 = newTab;
                    $r.bS = newActionItemsCache;
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 34:
                var analyticsEvent = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$AnalyticsEvent(analyticsEvent)));
            case 35:
                var backtalk = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(backtalk));
            case 36:
                var msgs = msg.a;
                return $author$project$Util$Page$manyMsgHandler_fn(A2($author$project$Page$Note$update, env, currentNoteId), model, msgs);
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }
    }, $author$project$Page$Note$update = F4($author$project$Page$Note$update_fn);
    var $author$project$Page$Person$ActionItemMsg = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Env$MergePersons = function (a) {
        return { $: 13, a: a };
    };
    var $author$project$Page$Person$NoOp = function (a) {
        return { $: 16, a: a };
    };
    var $author$project$Analytics$PersonDeleted = { $: 47 };
    var $author$project$Analytics$PersonEmailAdded = { $: 40 };
    var $author$project$Analytics$PersonEmailRemoved = { $: 41 };
    var $author$project$Analytics$PersonMarkedNotDuplicate = { $: 44 };
    var $author$project$Analytics$PersonMerged = { $: 45 };
    var $author$project$Env$UpdatePerson = function (a) {
        return { $: 11, a: a };
    };
    var $author$project$Util$Misc$appendUnique_fn = function (a, list) {
        return $elm_community$list_extra$List$Extra$unique(_Utils_ap(list, _List_fromArray([a])));
    }, $author$project$Util$Misc$appendUnique = F2($author$project$Util$Misc$appendUnique_fn);
    var $author$project$Data$Person$addEmail_fn = function (email, person) {
        return $$update__lo(person, $author$project$Util$Misc$appendUnique_fn($author$project$Data$Email$toString(email), person.lo));
    }, $author$project$Data$Person$addEmail = F2($author$project$Data$Person$addEmail_fn);
    var $author$project$Page$Person$update_fn = function (env, msg, model) {
        switch (msg.$) {
            case 0:
                var personId = msg.a;
                var name = msg.b;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdatePerson((new $$Record77(true, personId, function (person) {
                    return function () {
                        var $r = person.$c();
                        $r.b = name;
                        return $r;
                    }();
                })))));
            case 1:
                var personId = msg.a;
                var slateDoc = msg.b.f6;
                var plaintext = msg.b.nP;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdatePerson((new $$Record77(true, personId, function (person) {
                    return function () {
                        var $r = person.$c();
                        $r.f6 = slateDoc;
                        $r.ko = plaintext;
                        return $r;
                    }();
                })))));
            case 2:
                var personId = msg.a;
                var email = msg.b;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$Tantrum(_List_fromArray([
                    $author$project$Env$UpdatePerson((new $$Record77(false, personId, function (person) {
                        return $$update__lo(person, $elm_community$list_extra$List$Extra$unique($elm_community$list_extra$List$Extra$remove_fn(email, person.lo)));
                    }))),
                    $author$project$Env$AnalyticsEvent($author$project$Analytics$PersonEmailRemoved)
                ]))));
            case 5:
                var personId = msg.a;
                var email = msg.b;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.u = $elm$core$Maybe$Nothing;
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$Tantrum(_List_fromArray([
                    $author$project$Env$UpdatePerson((new $$Record77(false, personId, $author$project$Data$Person$addEmail(email)))),
                    $author$project$Env$AnalyticsEvent($author$project$Analytics$PersonEmailAdded)
                ]))));
            case 6:
                var actionItemMsg = msg.a;
                var _v1 = $author$project$View$ActionItems$update_fn(actionItemMsg, model.bQ);
                var newActionItemModel = _v1.a;
                var cmds = _v1.b;
                var mBacktalk = _v1.c;
                return _Utils_Tuple3($$update__bQ(model, newActionItemModel), _Platform_map_fn($author$project$Page$Person$ActionItemMsg, cmds), mBacktalk);
            case 3:
                var input = msg.a;
                var formIsOpening = _Utils_eq(model.u, $elm$core$Maybe$Nothing);
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.cw = _Utils_eq(input, $elm$core$Maybe$Just("")) ? false : model.cw;
                    $r.u = input;
                    return $r;
                }(), $author$project$Util$Cmd$when_fn(formIsOpening, $author$project$Util$Cmd$focusOnElement_fn($author$project$Page$Person$NoOp("focus on new email input"), "info-form-text-input")), $elm$core$Maybe$Nothing);
            case 4:
                var b = msg.a;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.cw = b;
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 7:
                var meetingsView = msg.a;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.aY = meetingsView;
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 8:
                var isFocused = msg.a;
                return _Utils_Tuple3($$update__ff(model, isFocused), $author$project$Lib$Focuser$initWhen_fn($author$project$Page$Person$NoOp, !isFocused), $elm$core$Maybe$Nothing);
            case 10:
                var mDialog = msg.a;
                return _Utils_Tuple3($$update__bp(model, mDialog), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 11:
                var personId = msg.a;
                var otherId = msg.b;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.au = $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$neq(otherId)), model.au);
                    $r.bp = $elm$core$Maybe$Nothing;
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$Tantrum(_List_fromArray([
                    $author$project$Env$UpdatePerson((new $$Record77(false, personId, function (person) {
                        return function () {
                            var $r = person.$c();
                            $r.no = $elm_community$list_extra$List$Extra$unique(_List_Cons(otherId, person.no));
                            return $r;
                        }();
                    }))),
                    $author$project$Env$AnalyticsEvent($author$project$Analytics$PersonMarkedNotDuplicate)
                ]))));
            case 12:
                var ids = msg.a;
                return _Utils_Tuple3($$update__bp(model, $elm$core$Maybe$Nothing), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$MergePersons(ids)));
            case 13:
                var secondaryPersonId = msg.a.f1;
                return _Utils_Tuple3($$update__au(model, $elm$core$List$filter_fn(function (_v2) {
                    var id = _v2.a;
                    return !_Utils_eq(id, secondaryPersonId);
                }, model.au)), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$AnalyticsEvent($author$project$Analytics$PersonMerged)));
            case 14:
                return _Utils_Tuple3($$update__au(model, $author$project$Page$Person$computePotentialDupes(env)), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 9:
                var personId = msg.a;
                return _Utils_Tuple3($$update__bp(model, $elm$core$Maybe$Nothing), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$Tantrum(_List_fromArray([
                    $author$project$Env$UpdatePerson((new $$Record77(false, personId, function (p) {
                        return $$update__lh(p, true);
                    }))),
                    $author$project$Env$AnalyticsEvent($author$project$Analytics$PersonDeleted),
                    $author$project$Env$NavigateBackwards
                ]))));
            case 15:
                var backtalk = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(backtalk));
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }
    }, $author$project$Page$Person$update = F3($author$project$Page$Person$update_fn);
    var $author$project$Page$Search$GenerateResult = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Page$Search$ManyMsgs = function (a) {
        return { $: 11, a: a };
    };
    var $author$project$Page$Search$SetSelectedFilterForm = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Page$Search$filterSearchInputId = "filter-search-input";
    var $author$project$Search$Result$query = function (_v0) {
        var result = _v0;
        return result.n$;
    };
    var $author$project$Page$Search$removeFilter = function (queryFilterToRemove) {
        return $elm$core$List$filter(function (queryFilter) {
            var _v0 = _Utils_Tuple2(queryFilter, queryFilterToRemove);
            _v0$2: while (true) {
                switch (_v0.a.$) {
                    case 0:
                        if (((!_v0.a.a.$) && (!_v0.b.$)) && (!_v0.b.a.$)) {
                            var _v1 = _v0.a.a;
                            var idA = _v1.b;
                            var _v2 = _v0.b.a;
                            var idB = _v2.b;
                            return !_Utils_eq(idA, idB);
                        }
                        else {
                            break _v0$2;
                        }
                    case 1:
                        if (((!_v0.a.a.$) && (_v0.b.$ === 1)) && (!_v0.b.a.$)) {
                            var _v3 = _v0.a.a;
                            var idA = _v3.b;
                            var _v4 = _v0.b.a;
                            var idB = _v4.b;
                            return !_Utils_eq(idA, idB);
                        }
                        else {
                            break _v0$2;
                        }
                    default:
                        break _v0$2;
                }
            }
            return !_Utils_eq(queryFilter, queryFilterToRemove);
        });
    };
    var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
        if (m.$ === 1) {
            return _List_Nil;
        }
        else {
            var x = m.a;
            return _List_fromArray([x]);
        }
    };
    var $author$project$Page$Search$update_fn = function (env, indices, msg, model) {
        update: while (true) {
            switch (msg.$) {
                case 0:
                    var newQuery = msg.a;
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Routing$reroute_fn(env, $author$project$Routing$RouteSearch_fn($elm$core$Maybe$Just($elm$core$Basics$composeR_fn($author$project$Search$Query$encodeToBase64String_a0, $author$project$Search$Query$encodeToBase64String_a1, newQuery)), $elm$core$Maybe$Just(model.e1))),
                        $elm$core$Basics$composeR_fn($author$project$Search$Bar$setSearchbarQuery_a0, $author$project$Search$Bar$setSearchbarQuery_a1, newQuery)
                    ])), $elm$core$Maybe$Nothing);
                case 1:
                    var itemIndex = msg.a;
                    var item = $author$project$Search$Result$get_fn(itemIndex, model.p);
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$map_fn($author$project$Search$Bar$toItemMsg, item));
                case 3:
                    var filter = msg.a;
                    var newQuery = _Utils_ap($author$project$Search$Result$query(model.p), _List_fromArray([filter]));
                    var $temp$env = env, $temp$indices = indices, $temp$msg = $author$project$Page$Search$GenerateResult(newQuery), $temp$model = model;
                    env = $temp$env;
                    indices = $temp$indices;
                    msg = $temp$msg;
                    model = $temp$model;
                    continue update;
                case 4:
                    var filter = msg.a;
                    var newQuery = A2($author$project$Page$Search$removeFilter, filter, $author$project$Search$Result$query(model.p));
                    var $temp$env = env, $temp$indices = indices, $temp$msg = $author$project$Page$Search$GenerateResult(newQuery), $temp$model = model;
                    env = $temp$env;
                    indices = $temp$indices;
                    msg = $temp$msg;
                    model = $temp$model;
                    continue update;
                case 5:
                    var mDates = msg.a;
                    var newDateFilters = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(function (_v2) {
                        var after = _v2.bT;
                        var before = _v2.bX;
                        return _List_fromArray([
                            $author$project$Search$Query$Before(before),
                            $author$project$Search$Query$After(after)
                        ]);
                    }, mDates));
                    var newQuery = $elm_community$basics_extra$Basics$Extra$flip_fn($elm$core$List$append, newDateFilters, $elm$core$List$filter_fn(function (filter) {
                        switch (filter.$) {
                            case 2:
                                return false;
                            case 3:
                                return false;
                            default:
                                return true;
                        }
                    }, $author$project$Search$Result$query(model.p)));
                    var msgs = $author$project$Page$Search$ManyMsgs(_List_fromArray([
                        $author$project$Page$Search$GenerateResult(newQuery),
                        $author$project$Page$Search$SetSelectedFilterForm($elm$core$Maybe$Nothing)
                    ]));
                    var $temp$env = env, $temp$indices = indices, $temp$msg = msgs, $temp$model = model;
                    env = $temp$env;
                    indices = $temp$indices;
                    msg = $temp$msg;
                    model = $temp$model;
                    continue update;
                case 6:
                    var mFileType = msg.a;
                    var newFileTypeFilter = $elm_community$maybe_extra$Maybe$Extra$toList($elm$core$Maybe$map_fn($author$project$Search$Query$File, mFileType));
                    var newQuery = $elm_community$basics_extra$Basics$Extra$flip_fn($elm$core$List$append, newFileTypeFilter, $elm$core$List$filter_fn(function (filter) {
                        if (filter.$ === 4) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }, $author$project$Search$Result$query(model.p)));
                    var msgs = $author$project$Page$Search$ManyMsgs(_List_fromArray([
                        $author$project$Page$Search$GenerateResult(newQuery),
                        $author$project$Page$Search$SetSelectedFilterForm($elm$core$Maybe$Nothing)
                    ]));
                    var $temp$env = env, $temp$indices = indices, $temp$msg = msgs, $temp$model = model;
                    env = $temp$env;
                    indices = $temp$indices;
                    msg = $temp$msg;
                    model = $temp$model;
                    continue update;
                case 7:
                    var category = msg.a;
                    var $temp$env = env, $temp$indices = indices, $temp$msg = $author$project$Page$Search$GenerateResult($author$project$Search$Result$query(model.p)), $temp$model = function () {
                        var $r = model.$c();
                        $r.e1 = category;
                        return $r;
                    }();
                    env = $temp$env;
                    indices = $temp$indices;
                    msg = $temp$msg;
                    model = $temp$model;
                    continue update;
                case 2:
                    var $temp$env = env, $temp$indices = indices, $temp$msg = $author$project$Page$Search$GenerateResult($author$project$Search$Result$query(model.p)), $temp$model = model;
                    env = $temp$env;
                    indices = $temp$indices;
                    msg = $temp$msg;
                    model = $temp$model;
                    continue update;
                case 8:
                    var mFilterDropdown = msg.a;
                    return _Utils_Tuple3(function () {
                        var $r = model.$c();
                        $r.aH = "";
                        $r.dh = mFilterDropdown;
                        return $r;
                    }(), $author$project$Util$Cmd$when_fn($elm_community$maybe_extra$Maybe$Extra$isJust(mFilterDropdown), $author$project$Util$Cmd$focusOnElement_fn($author$project$Page$Search$NoOp("filter search input focused"), $author$project$Page$Search$filterSearchInputId)), $elm$core$Maybe$Nothing);
                case 9:
                    var text = msg.a;
                    return _Utils_Tuple3(function () {
                        var $r = model.$c();
                        $r.aH = text;
                        return $r;
                    }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                case 10:
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$ShowSearch(true)));
                case 11:
                    var msgs = msg.a;
                    return $author$project$Util$Page$manyMsgHandler_fn(A2($author$project$Page$Search$update, env, indices), model, msgs);
                default:
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            }
        }
    }, $author$project$Page$Search$update = F4($author$project$Page$Search$update_fn);
    var $author$project$Data$Settings$defaultSnapshotEmailConfig = function (timezoneName) {
        return (new $$Record15(_List_fromArray([0, 1, 2, 3, 4]), 6, timezoneName));
    };
    var $author$project$Ports$devUnlinkCalendar = _Platform_outgoingPort("devUnlinkCalendar", function ($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("restartOnboarding", $elm$json$Json$Encode$bool($.ex))
        ]));
    });
    var $author$project$View$Snacks$developerAction = function (name) {
        return (new $$Record78($elm$core$Maybe$Nothing, {
            hF: "Developer Activity \uD83D\uDD27",
            cp: $elm$core$Maybe$Just(name)
        }, true, false, 0));
    };
    var $author$project$Page$Settings$update_fn = function (env, msg, model) {
        switch (msg.$) {
            case 0:
                var flag = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateSettings(function (s) {
                    return function () {
                        var $r = s.$c();
                        $r.cD = flag;
                        return $r;
                    }();
                })));
            case 1:
                var flag = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateSettings(function (s) {
                    return function () {
                        var $r = s.$c();
                        $r.di = flag;
                        return $r;
                    }();
                })));
            case 2:
                var newTheme = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateSettings(function (s) {
                    return $$update__pn(s, newTheme);
                })));
            case 3:
                var flag = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateSettings(function (s) {
                    return function () {
                        var $r = s.$c();
                        $r.cZ = flag;
                        return $r;
                    }();
                })));
            case 4:
                var flag = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateSettings(function (s) {
                    return function () {
                        var $r = s.$c();
                        $r.cC = flag;
                        return $r;
                    }();
                })));
            case 5:
                var flag = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateSettings(function (s) {
                    return function () {
                        var $r = s.$c();
                        $r.df = flag;
                        return $r;
                    }();
                })));
            case 9:
                var setting = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateSettings(function (s) {
                    return function () {
                        var $r = s.$c();
                        $r.c3 = setting;
                        return $r;
                    }();
                })));
            case 6:
                var flag = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateSettings(function (s) {
                    return function () {
                        var $r = s.$c();
                        $r.cP = flag;
                        return $r;
                    }();
                })));
            case 7:
                var flag = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateSettings(function (s) {
                    return function () {
                        var $r = s.$c();
                        $r.cN = flag ? $elm$core$Maybe$Just($author$project$Data$Settings$defaultSnapshotEmailConfig(env.pt)) : $elm$core$Maybe$Nothing;
                        $r.cO = flag;
                        return $r;
                    }();
                })));
            case 8:
                var day = msg.a;
                var flag = msg.b;
                var dayFilter = function (d) {
                    return _Utils_eq(d, day) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(d);
                };
                var updateDayList = function (days) {
                    return flag ? ($elm$core$List$member_fn(day, days) ? days : _List_Cons(day, days)) : $elm$core$List$filterMap_fn(dayFilter, days);
                };
                var toggleDay = $elm$core$Maybe$map(function (config) {
                    return function () {
                        var $r = config.$c();
                        $r.fa = updateDayList(config.fa);
                        return $r;
                    }();
                });
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$UpdateSettings(function (s) {
                    return function () {
                        var $r = s.$c();
                        $r.cN = toggleDay(s.cN);
                        return $r;
                    }();
                })));
            case 11:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$SetDialog($elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$KeyboardShortcuts))));
            case 10:
                var analyticsEvent = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$AnalyticsEvent(analyticsEvent)));
            case 13:
                var restartOnboarding = msg.a.ex;
                return _Utils_Tuple3(model, $author$project$Ports$devUnlinkCalendar({ ex: restartOnboarding }), $elm$core$Maybe$Nothing);
            case 14:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$Tantrum(_List_fromArray([
                    $author$project$Env$UpdateSettings(function (settings) {
                        return $$update__c5(settings, $elm$core$Dict$empty);
                    }),
                    $author$project$Env$PushToSnackbar($author$project$View$Snacks$developerAction("Notification bell reset"))
                ]))));
            case 15:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$Tantrum(_List_fromArray([
                    $author$project$Env$PreloadContent,
                    $author$project$Env$PushToSnackbar($author$project$View$Snacks$developerAction("Reloaded preloaded content"))
                ]))));
            case 12:
                var msgs = msg.a;
                return $author$project$Util$Page$manyMsgHandler_fn($author$project$Page$Settings$update(env), model, msgs);
            default:
                var backtalk = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(backtalk));
        }
    }, $author$project$Page$Settings$update = F3($author$project$Page$Settings$update_fn);
    var $author$project$Env$AddLinkedAccount = { $: 16 };
    var $author$project$Env$CompleteSignup = { $: 15 };
    var $author$project$Env$LinkCalendar = { $: 30 };
    var $author$project$Data$Slate$Paragraph = 0;
    var $author$project$Data$Slate$elementType = function (element_) {
        switch (element_) {
            case 0:
                return "p";
            case 1:
                return "ol";
            case 2:
                return "lic";
            default:
                return "li";
        }
    };
    var $author$project$Data$Slate$element_fn = function (tipe, children) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("type", $elm$json$Json$Encode$string($author$project$Data$Slate$elementType(tipe))),
            _Utils_Tuple2("children", $elm$json$Json$Encode$list_fn($elm$core$Basics$identity, children))
        ]));
    }, $author$project$Data$Slate$element = F2($author$project$Data$Slate$element_fn);
    var $author$project$Data$Slate$text = function (str) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("text", $elm$json$Json$Encode$string(str))
        ]));
    };
    var $author$project$Data$Slate$nextMeetingChip = function (id) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("type", $elm$json$Json$Encode$string("mention")),
            _Utils_Tuple2("children", $elm$json$Json$Encode$list_fn($elm$core$Basics$identity, _List_fromArray([
                $author$project$Data$Slate$text("#next meeting")
            ]))),
            _Utils_Tuple2("data", $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("mentionType", $elm$json$Json$Encode$string("event-mention")),
                _Utils_Tuple2("eventId", $elm$json$Json$Encode$null),
                _Utils_Tuple2("masterId", $elm$json$Json$Encode$string("_witful-next-meeting")),
                _Utils_Tuple2("title", $elm$json$Json$Encode$string("next meeting")),
                _Utils_Tuple2("completedIn", $elm$json$Json$Encode$null),
                _Utils_Tuple2("createdAt", $elm$json$Json$Encode$int(1647546974457)),
                _Utils_Tuple2("completedAt", $elm$json$Json$Encode$null),
                _Utils_Tuple2("id", $elm$json$Json$Encode$string(id))
            ])))
        ]));
    };
    var $author$project$Content$Note$wizardCompletionContent = {
        nP: " From here, feel free to play around with Witful, or prepare some notes for your next meeting !",
        oG: _List_fromArray([
            $author$project$Data$Slate$element_fn(0, _List_fromArray([
                $author$project$Data$Slate$text("")
            ])),
            $author$project$Data$Slate$element_fn(0, _List_fromArray([
                $author$project$Data$Slate$text("")
            ])),
            $author$project$Data$Slate$element_fn(0, _List_fromArray([
                $author$project$Data$Slate$text("\u2014")
            ])),
            $author$project$Data$Slate$element_fn(0, _List_fromArray([
                $author$project$Data$Slate$text("From here, feel free to play around with Witful, or prepare some notes for your "),
                $author$project$Data$Slate$nextMeetingChip("wEvONphI_K"),
                $author$project$Data$Slate$text("!")
            ]))
        ])
    };
    var $author$project$Page$Signup$appendWizardPostloadedContent = function (note) {
        var updatedDescription = _Utils_ap(note.fc, $author$project$Content$Note$wizardCompletionContent.nP);
        var slateDocList = $elm$core$Result$withDefault_fn(_List_Nil, _Json_runOnString_fn($elm$json$Json$Decode$list($elm$json$Json$Decode$value), note.f6));
        var updatedSlateDoc = _Json_encode_fn(0, $elm$json$Json$Encode$list_fn($elm$core$Basics$identity, _Utils_ap(slateDocList, $author$project$Content$Note$wizardCompletionContent.oG)));
        return function () {
            var $r = note.$c();
            $r.f6 = updatedSlateDoc;
            $r.fc = updatedDescription;
            return $r;
        }();
    };
    var $author$project$Page$Signup$update_fn = function (env, msg, model) {
        switch (msg.$) {
            case 4:
                var b = msg.a;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.eI = b;
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 5:
                var b = msg.a;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.eH = b;
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 0:
                return _Utils_Tuple3(model, $author$project$Ports$signIn(true), $elm$core$Maybe$Nothing);
            case 1:
                var period = msg.a;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.az = period;
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 2:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$StripeCreateCheckoutSession(model.az)));
            case 3:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$AddLinkedAccount));
            case 7:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$LinkCalendar));
            case 9:
                var slateDoc = msg.a.f6;
                var plaintext = msg.a.nP;
                var actionItems = msg.a.gz;
                return _Utils_Tuple3(function () {
                    var $r = model.$c();
                    $r.bR = model.bR || (!$elm$core$List$isEmpty(actionItems));
                    return $r;
                }(), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$Tantrum(_List_fromArray([
                    $author$project$Env$UpdateNote((new $$Record77(true, $author$project$Content$Note$wizardNoteId, function (note) {
                        return $$update__f6__fc__gz(note, slateDoc, plaintext, actionItems);
                    })))
                ]))));
            case 10:
                var actionItem = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$ToggleActionItem_fn({
                    pD: $elm$core$Maybe$Just($author$project$Content$Note$wizardNoteId)
                }, actionItem)));
            case 6:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$Tantrum(_List_fromArray([
                    $author$project$Env$CompleteSignup,
                    $author$project$Env$UpdateNote((new $$Record77(false, $author$project$Content$Note$wizardNoteId, $author$project$Page$Signup$appendWizardPostloadedContent)))
                ]))));
            case 8:
                var analyticsEvent = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Env$AnalyticsEvent(analyticsEvent)));
            default:
                var msgs = msg.a;
                return $author$project$Util$Page$manyMsgHandler_fn($author$project$Page$Signup$update(env), model, msgs);
        }
    }, $author$project$Page$Signup$update = F3($author$project$Page$Signup$update_fn);
    var $author$project$Update$updateWith_fn = function (toPage, toMsg, model, _v0) {
        var subModel = _v0.a;
        var subCmd = _v0.b;
        var mBacktalk = _v0.c;
        var _v1 = $elm$core$Maybe$withDefault_fn(_Utils_Tuple2(model.dW, $elm$core$Platform$Cmd$none), $elm$core$Maybe$map_fn($author$project$Update$handleBacktalk(model.dW), mBacktalk));
        var newEnv = _v1.a;
        var cmds = _v1.b;
        return _Utils_Tuple2($$update__dW__ix(model, newEnv, toPage(subModel)), $elm$core$Platform$Cmd$batch(_List_fromArray([
            cmds,
            _Platform_map_fn(A2($elm$core$Basics$composeR, toMsg, $author$project$Model$HandlePageMsg), subCmd)
        ])));
    }, $author$project$Update$updateWith = F4($author$project$Update$updateWith_fn);
    var $author$project$Update$updatePage_fn = function (pageMsg, model) {
        var env = model.dW;
        var _v0 = _Utils_Tuple2(pageMsg, model.ix);
        _v0$11: while (true) {
            switch (_v0.a.$) {
                case 0:
                    if (!_v0.b.$) {
                        var subMsg = _v0.a.a;
                        var subModel = _v0.b.a;
                        return $author$project$Update$updateWith_fn($author$project$Model$PageHome, $author$project$Model$HomeMsg, model, $author$project$Page$Home$update_fn(env, subMsg, subModel));
                    }
                    else {
                        break _v0$11;
                    }
                case 1:
                    if (_v0.b.$ === 1) {
                        var subMsg = _v0.a.a;
                        var subModel = _v0.b.a;
                        return $author$project$Update$updateWith_fn($author$project$Model$PageActionItems, $author$project$Model$ActionItemsMsg, model, $author$project$Page$ActionItems$update_fn(env, subMsg, subModel));
                    }
                    else {
                        break _v0$11;
                    }
                case 2:
                    if (_v0.b.$ === 2) {
                        var subMsg = _v0.a.a;
                        var subModel = _v0.b.a;
                        return $author$project$Update$updateWith_fn($author$project$Model$PageSearch, $author$project$Model$SearchMsg, model, $author$project$Page$Search$update_fn(env, model.op, subMsg, subModel));
                    }
                    else {
                        break _v0$11;
                    }
                case 5:
                    if (_v0.b.$ === 5) {
                        var subMsg = _v0.a.a;
                        var subModel = _v0.b.a;
                        return $author$project$Update$updateWith_fn($author$project$Model$PageCalendar, $author$project$Model$CalendarMsg, model, $author$project$Page$Calendar$update_fn(env, subMsg, subModel));
                    }
                    else {
                        break _v0$11;
                    }
                case 4:
                    if (_v0.b.$ === 4) {
                        var subMsg = _v0.a.a;
                        var _v1 = _v0.b;
                        var noteId = _v1.a;
                        var subModel = _v1.b;
                        return $author$project$Update$updateWith_fn($author$project$Model$PageNote(noteId), $author$project$Model$NoteMsg, model, $author$project$Page$Note$update_fn(env, noteId, subMsg, subModel));
                    }
                    else {
                        break _v0$11;
                    }
                case 3:
                    if (_v0.b.$ === 3) {
                        var subMsg = _v0.a.a;
                        var _v2 = _v0.b;
                        var personId = _v2.a;
                        var subModel = _v2.b;
                        return $author$project$Update$updateWith_fn($author$project$Model$PagePerson(personId), $author$project$Model$PersonMsg, model, $author$project$Page$Person$update_fn(env, subMsg, subModel));
                    }
                    else {
                        break _v0$11;
                    }
                case 7:
                    if (_v0.b.$ === 7) {
                        var subMsg = _v0.a.a;
                        var subModel = _v0.b.a;
                        return $author$project$Update$updateWith_fn($author$project$Model$PageCollate, $author$project$Model$CollateMsg, model, $author$project$Page$Collate$update_fn(env, subMsg, subModel));
                    }
                    else {
                        break _v0$11;
                    }
                case 6:
                    if (_v0.b.$ === 6) {
                        var subMsg = _v0.a.a;
                        var subModel = _v0.b.a;
                        return $author$project$Update$updateWith_fn($author$project$Model$PageSettings, $author$project$Model$SettingsMsg, model, $author$project$Page$Settings$update_fn(env, subMsg, subModel));
                    }
                    else {
                        break _v0$11;
                    }
                case 8:
                    if (_v0.b.$ === 8) {
                        var subMsg = _v0.a.a;
                        var subModel = _v0.b.a;
                        return $author$project$Update$updateWith_fn($author$project$Model$PageDemo, $author$project$Model$DemoMsg, model, $author$project$Page$Demo$update_fn(subMsg, subModel));
                    }
                    else {
                        break _v0$11;
                    }
                case 9:
                    if (_v0.b.$ === 9) {
                        var subMsg = _v0.a.a;
                        var _v3 = _v0.b;
                        var signupStep = _v3.a;
                        var subModel = _v3.b;
                        return $author$project$Update$updateWith_fn($author$project$Model$PageSignup(signupStep), $author$project$Model$SignupMsg, model, $author$project$Page$Signup$update_fn(env, subMsg, subModel));
                    }
                    else {
                        break _v0$11;
                    }
                default:
                    if (_v0.b.$ === 10) {
                        var subMsg = _v0.a.a;
                        var subModel = _v0.b.a;
                        return $author$project$Update$updateWith_fn($author$project$Model$PageBilling, $author$project$Model$BillingMsg, model, $author$project$Page$Billing$update_fn(env, subMsg, subModel));
                    }
                    else {
                        break _v0$11;
                    }
            }
        }
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    }, $author$project$Update$updatePage = F2($author$project$Update$updatePage_fn);
    var $author$project$Update$update_fn = function (msg, model) {
        var env = model.dW;
        var toModel = function (newEnv) {
            return $$update__dW(model, newEnv);
        };
        var outboundRequests = env.db;
        switch (msg.$) {
            case 38:
                var urlRequest = msg.a;
                if (!urlRequest.$) {
                    var location = urlRequest.a;
                    return $elm$core$Tuple$mapFirst_fn(function (newEnv) {
                        return toModel(function () {
                            var $r = newEnv.$c();
                            $r.iO = false;
                            $r.nq = false;
                            return $r;
                        }());
                    }, function () {
                        var _v2 = $author$project$Routing$parseLocation(location);
                        switch (_v2.$) {
                            case 4:
                                var mStartTime = _v2.a;
                                return $author$project$Update$Util$withNewEntityReroute($author$project$Cmd$Note$newFromTime_fn(env, mStartTime));
                            case 2:
                                var eventId = _v2.a;
                                var mMasterId = _v2.b;
                                var _v3 = $author$project$Cmd$Note$newFromEventId_fn(env, eventId, mMasterId);
                                if (_v3.$ === 1) {
                                    var err = _v3.a;
                                    return _Utils_Tuple2(env, $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, err));
                                }
                                else {
                                    var success = _v3.a;
                                    return $author$project$Update$Util$withNewEntityReroute(success);
                                }
                            case 8:
                                var mPerson = _v2.a;
                                return $author$project$Update$Util$withNewEntityReroute($author$project$Cmd$Person$new_fn(env, mPerson));
                            case 7:
                                var nextMeeting = _v2.a;
                                return $author$project$Update$Util$toNextMeeting_fn(env, nextMeeting);
                            default:
                                var route = _v2;
                                return _Utils_Tuple2(env, $author$project$Routing$reroute_fn(env, route));
                        }
                    }());
                }
                else {
                    var href = urlRequest.a;
                    return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$load(href));
                }
            case 39:
                var location = msg.a;
                var newRoute = $author$project$Routing$parseLocation(location);
                var previousRoutes = env.mw ? $elm$core$List$drop_fn(1, env.nV) : $author$project$Util$Misc$consIf_fn($author$project$Routing$pushToHistory_fn(env, newRoute), env.oe, env.nV);
                var shouldResetFocus = function () {
                    var _v12 = _Utils_Tuple2(env.oe, newRoute);
                    _v12$5: while (true) {
                        switch (_v12.b.$) {
                            case 6:
                                switch (_v12.a.$) {
                                    case 3:
                                        var _v13 = _v12.a;
                                        var prevId = _v13.a;
                                        var _v14 = _v12.b;
                                        var nextId = _v14.a;
                                        return !_Utils_eq(prevId, nextId);
                                    case 5:
                                        var _v15 = _v12.a;
                                        var prevId = _v15.a;
                                        var _v16 = _v12.b;
                                        var nextId = _v16.a;
                                        return !_Utils_eq(prevId, nextId);
                                    case 6:
                                        var _v17 = _v12.a;
                                        var prevId = _v17.a;
                                        var _v18 = _v12.b;
                                        var nextId = _v18.a;
                                        return !_Utils_eq(prevId, nextId);
                                    default:
                                        break _v12$5;
                                }
                            case 0:
                                if (!_v12.a.$) {
                                    return false;
                                }
                                else {
                                    break _v12$5;
                                }
                            case 10:
                                if (_v12.a.$ === 10) {
                                    return false;
                                }
                                else {
                                    break _v12$5;
                                }
                            default:
                                break _v12$5;
                        }
                    }
                    return true;
                }();
                var shouldScrollTop = function () {
                    var _v7 = _Utils_Tuple2(newRoute, env.oe);
                    _v7$2: while (true) {
                        switch (_v7.a.$) {
                            case 16:
                                if (_v7.b.$ === 16) {
                                    var _v8 = _v7.a;
                                    var a = _v8.a;
                                    var _v9 = _v7.b;
                                    var b = _v9.a;
                                    return !_Utils_eq(a, b);
                                }
                                else {
                                    break _v7$2;
                                }
                            case 6:
                                if (_v7.b.$ === 6) {
                                    var _v10 = _v7.a;
                                    var id1 = _v10.a;
                                    var _v11 = _v7.b;
                                    var id2 = _v11.a;
                                    return !_Utils_eq(id1, id2);
                                }
                                else {
                                    break _v7$2;
                                }
                            default:
                                break _v7$2;
                        }
                    }
                    return true;
                }();
                var closeableDialog = function () {
                    var _v6 = env.e3;
                    if ((!_v6.$) && (_v6.a.$ === 10)) {
                        return env.e3;
                    }
                    else {
                        return $elm$core$Maybe$Nothing;
                    }
                }();
                var newEnv = function () {
                    var $r = env.$c();
                    $r.e3 = closeableDialog;
                    $r.iO = false;
                    $r.mM = location;
                    $r.mw = false;
                    $r.nV = previousRoutes;
                    $r.oe = newRoute;
                    return $r;
                }();
                var _v4 = $author$project$Update$setPageFromRoute(toModel(newEnv));
                var newModel = _v4.a;
                var pageCmd = _v4.b;
                return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    pageCmd,
                    $elm$core$Basics$composeR_fn($author$project$Update$sendAnalytic_a0, $author$project$Update$sendAnalytic_a1, $author$project$Analytics$RouteChanged(newRoute)),
                    $author$project$Lib$Focuser$initWhen_fn($author$project$Model$NoOp, shouldResetFocus),
                    $author$project$Util$Cmd$when_fn(shouldScrollTop, $elm$core$Task$perform_fn(function (_v5) {
                        return $author$project$Model$NoOp("scroll to top");
                    }, _Browser_setViewport_fn(0, 0)))
                ])));
            case 0:
                var latestMinute = msg.a;
                var _v19 = env.mK.lw.gF ? $author$project$Search$Weight$generate(env) : _Utils_Tuple2(env.oq, $elm$core$Platform$Cmd$none);
                var newScoreIndex = _v19.a;
                var maybeSaveSearchWeightIndex = _v19.b;
                return _Utils_Tuple2(toModel(function () {
                    var $r = env.$c();
                    $r.k5 = latestMinute;
                    $r.oq = newScoreIndex;
                    return $r;
                }()), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $elm$core$Task$attempt_fn($author$project$Model$CheckTimezone, $elm$core$Task$map_fn($elm$core$Tuple$mapFirst($elm$time$Time$Name), $author$project$Util$Time$getZone)),
                    maybeSaveSearchWeightIndex,
                    $author$project$Util$Cmd$executeMsg($author$project$Model$ComputeNextMeeting)
                ])));
            case 1:
                if (!msg.a.$) {
                    var _v20 = msg.a.a;
                    var zoneName = _v20.a;
                    var latestTimezone = _v20.b;
                    return (!_Utils_eq(latestTimezone, env.ps)) ? $elm$core$Tuple$mapFirst_fn(toModel, $author$project$Update$handleBacktalk_fn(function () {
                        var $r = env.$c();
                        $r.ps = latestTimezone;
                        return $r;
                    }(), $author$project$Env$PushToSnackbar($author$project$View$Snacks$timezoneChanged_fn(zoneName, latestTimezone)))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
                else {
                    var timeZoneError = msg.a.a;
                    var fallbackZoneRequest = $elm$core$Task$perform_fn($author$project$Model$CheckTimezone, $elm$core$Task$map_fn($elm$core$Result$Ok, $elm$core$Task$map2_fn($elm$core$Tuple$pair, $elm$time$Time$getZoneName, $elm$time$Time$here)));
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$warning_a0, $author$project$Error$TimeZone(timeZoneError))),
                        fallbackZoneRequest
                    ])));
                }
            case 8:
                var maybeUser = msg.a;
                return $author$project$Update$SignedIn$handler_fn(model, maybeUser);
            case 10:
                var token = msg.a;
                var newUser = $elm$core$Maybe$map_fn(function (u) {
                    return function () {
                        var $r = u.$c();
                        $r.kg = token;
                        return $r;
                    }();
                }, env.pV);
                return _Utils_Tuple2(toModel($$update__pV(env, newUser)), $elm$core$Platform$Cmd$none);
            case 5:
                return _Utils_Tuple2(model, $author$project$Ports$signIn(true));
            case 6:
                var redirectLocation = msg.a;
                var newEnv = $$update__pV(env, $elm$core$Maybe$Nothing);
                return _Utils_Tuple2($$update__dW__ix(model, newEnv, $author$project$Model$PageLoading), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Util$Firestore$unwatch(env.fO),
                    $author$project$Util$Firestore$unwatch(env.iz),
                    $author$project$Util$Firestore$unwatch(env.be),
                    $elm$core$Basics$composeR_fn($author$project$Ports$signOut_a0, $author$project$Ports$signOut_a1, redirectLocation)
                ])));
            case 7:
                var outboundRequestStatus = msg.a;
                return _Utils_Tuple2(toModel($$update__db(env, $$update__kn(outboundRequests, outboundRequestStatus))), $elm$core$Platform$Cmd$none);
            case 15:
                var outboundRequestStatus = msg.a;
                var newEnv = $$update__db(env, $$update__kf(outboundRequests, outboundRequestStatus));
                switch (outboundRequestStatus.$) {
                    case 3:
                        var newUser = $elm$core$Maybe$map_fn(function (user) {
                            return function () {
                                var $r = user.$c();
                                $r.kB = true;
                                return $r;
                            }();
                        }, env.pV);
                        var mSendGoogleAnalytic = $author$project$Util$Cmd$when_fn($krisajenkins$remotedata$RemoteData$isSuccess(outboundRequestStatus), $author$project$Analytics$sendGoogleAnalytic_fn(newUser, 1));
                        var finalEnv = $$update__pV(newEnv, newUser);
                        return _Utils_Tuple2(toModel(finalEnv), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Util$Cmd$whenJust_fn(newUser, function (user) {
                                return $author$project$Ports$watchCalendarEvents(user.l8);
                            }),
                            $author$project$Routing$maybeRerouteSignup(finalEnv),
                            $elm$core$Basics$composeR_fn($author$project$Update$sendAnalytic_a0, $author$project$Update$sendAnalytic_a1, $author$project$Analytics$CalendarLinked),
                            mSendGoogleAnalytic
                        ])));
                    case 2:
                        var authError = outboundRequestStatus.a;
                        var pressedCancelButton = _Utils_eq(authError, $author$project$Data$Auth$CanceledByUser);
                        var onboardingComplete = $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(function ($) {
                            return $.pL;
                        }, env.pV));
                        return _Utils_Tuple2(toModel($$update__e3(newEnv, $author$project$Util$Misc$if__fn((!onboardingComplete) || pressedCancelButton, env.e3, $elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$LinkCalendarError(authError))))), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Routing$maybeRerouteSignup(newEnv),
                            $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$error_a0, $author$project$Error$AuthError(authError)))
                        ])));
                    default:
                        return _Utils_Tuple2(toModel(newEnv), $elm$core$Platform$Cmd$none);
                }
            case 16:
                var status = msg.a;
                return _Utils_Tuple2(toModel($$update__db__e3(env, $$update__oX(outboundRequests, status), $krisajenkins$remotedata$RemoteData$isFailure(status) ? $elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$ErrorConnectingToStripe) : env.e3)), function () {
                    switch (status.$) {
                        case 3:
                            var sessionId = status.a;
                            return $author$project$Ports$stripeRedirectToSessionById(sessionId);
                        case 2:
                            var e = status.a;
                            return $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$error_a0, e));
                        default:
                            return $elm$core$Platform$Cmd$none;
                    }
                }());
            case 17:
                var status = msg.a;
                return _Utils_Tuple2(toModel($$update__db__e3(env, $$update__o_(outboundRequests, status), $krisajenkins$remotedata$RemoteData$isFailure(status) ? $elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$ErrorConnectingToStripe) : env.e3)), function () {
                    switch (status.$) {
                        case 3:
                            var url = status.a;
                            return $elm$browser$Browser$Navigation$load(url);
                        case 2:
                            var e = status.a;
                            return $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, $author$project$Error$Msg_fn($author$project$Error$error_a0, e));
                        default:
                            return $elm$core$Platform$Cmd$none;
                    }
                }());
            case 18:
                var status = msg.a;
                var newUser = function () {
                    var _v26 = _Utils_Tuple2(env.pV, status);
                    if ((!_v26.a.$) && (_v26.b.$ === 3)) {
                        var user = _v26.a.a;
                        var linkerAccountData = _v26.b.a.mJ;
                        if (linkerAccountData.$ === 1) {
                            return env.pV;
                        }
                        else {
                            var tutorialComplete = linkerAccountData.a.pL;
                            var introContentPreloaded = linkerAccountData.a.mn;
                            return $elm$core$Maybe$Just(function () {
                                var $r = user.$c();
                                $r.mn = introContentPreloaded;
                                $r.pL = tutorialComplete;
                                return $r;
                            }());
                        }
                    }
                    else {
                        return env.pV;
                    }
                }();
                var newEnv = function () {
                    var $r = env.$c();
                    $r.db = $$update__kW(outboundRequests, status);
                    $r.pV = newUser;
                    return $r;
                }();
                var mSendGoogleAnalytic = $author$project$Util$Cmd$when_fn($krisajenkins$remotedata$RemoteData$isSuccess(status), $author$project$Analytics$sendGoogleAnalytic_fn(newUser, 0));
                var _v24 = function () {
                    var _v25 = $author$project$Routing$maybeRerouteToStripeCheckout(newEnv);
                    if (!_v25.$) {
                        var billingPeriod = _v25.a;
                        return $author$project$Update$handleBacktalk_fn(newEnv, $author$project$Env$StripeCreateCheckoutSession(billingPeriod));
                    }
                    else {
                        return _Utils_Tuple2(newEnv, $elm$core$Platform$Cmd$none);
                    }
                }();
                var finalEnv = _v24.a;
                var maybeRerouteToStripeCheckout = _v24.b;
                return _Utils_Tuple2(toModel(finalEnv), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Util$Request$maybeLogFailure(status),
                    $author$project$Routing$maybeRerouteSignup(newEnv),
                    maybeRerouteToStripeCheckout,
                    $author$project$Update$maybeInjectPreloadedContent(newEnv),
                    mSendGoogleAnalytic
                ])));
            case 19:
                var giftAreaState = msg.a;
                var parsedEmails = $elm$core$List$filterMap_fn(A2($elm$core$Basics$composeR, function ($) {
                    return $.jn;
                }, $author$project$Data$Email$create), giftAreaState.fg);
                var atLeastOneParseableEmail = !$elm$core$List$isEmpty(parsedEmails);
                var isValid = atLeastOneParseableEmail && $elm$core$List$all_fn(function (entry) {
                    return (entry.jn === "") || $elm_community$maybe_extra$Maybe$Extra$isJust($author$project$Data$Email$create(entry.jn));
                }, giftAreaState.fg);
                var allBlank = $elm$core$List$all_fn($elm$core$String$isEmpty, $elm$core$List$map_fn(function ($) {
                    return $.jn;
                }, giftAreaState.fg));
                return isValid ? _Utils_Tuple2(toModel($$update__db(env, $$update__ot(outboundRequests, $krisajenkins$remotedata$RemoteData$Loading))), $elm$core$Maybe$withDefault_fn($elm$core$Platform$Cmd$none, $elm$core$Maybe$map_fn($author$project$Util$Request$sendGiftEmails, $elm$core$Maybe$map_fn(function (user) {
                    return (new $$Record109(parsedEmails, user.kg, $author$project$Data$User$firstName(user), user.g7));
                }, env.pV)))) : _Utils_Tuple2(toModel($$update__lR(env, function () {
                    var $r = giftAreaState.$c();
                    $r.jD = allBlank ? $elm$core$Maybe$Just("Please enter at least one email address.") : $elm$core$Maybe$Just("Please make sure all email addresses are valid.");
                    return $r;
                }())), $elm$core$Platform$Cmd$none);
            case 20:
                var status = msg.a;
                return _Utils_Tuple2(toModel($$update__db(env, $$update__ot(outboundRequests, status))), $author$project$Util$Request$maybeLogFailure(status));
            case 33:
                var closeMenu = msg.a.kO;
                var clearEntries = msg.a.kK;
                return _Utils_Tuple2(toModel(function () {
                    var $r = env.$c();
                    $r.db = $$update__ot(outboundRequests, $krisajenkins$remotedata$RemoteData$NotAsked);
                    $r.lQ = !closeMenu;
                    $r.lR = clearEntries ? $author$project$Data$GiftArea$init : env.lR;
                    return $r;
                }()), $elm$core$Platform$Cmd$none);
            case 22:
                var success = msg.a.o3;
                var primaryPersonId = msg.a.iL;
                var secondaryPersonId = msg.a.f1;
                return success ? _Utils_Tuple2(toModel($$update__db(env, $$update__mY(outboundRequests, $krisajenkins$remotedata$RemoteData$Success("")))), $author$project$Util$Cmd$executeMsg($author$project$Model$HandlePageMsg($author$project$Model$PersonMsg($author$project$Page$Person$personsMerged({ iL: primaryPersonId, f1: secondaryPersonId }))))) : _Utils_Tuple2(toModel($$update__db(env, $$update__mY(outboundRequests, $krisajenkins$remotedata$RemoteData$Failure($author$project$Error$PersonMergeFailed)))), $elm$core$Platform$Cmd$none);
            case 23:
                return _Utils_Tuple2(toModel($$update__db(env, $$update__mY(outboundRequests, $krisajenkins$remotedata$RemoteData$NotAsked))), $elm$core$Platform$Cmd$none);
            case 9:
                var subscription = msg.a;
                var newUser = $elm$core$Maybe$map_fn(function (user) {
                    return function () {
                        var $r = user.$c();
                        $r.o0 = subscription;
                        return $r;
                    }();
                }, env.pV);
                var _v28 = function () {
                    var _v29 = _Utils_Tuple2(newUser, subscription);
                    if ((!_v29.a.$) && (!_v29.b.$)) {
                        var authToken = _v29.a.a.kg;
                        return _Utils_Tuple2($author$project$Util$Request$fetchBillingAccountInfo({ b9: authToken }), $krisajenkins$remotedata$RemoteData$Loading);
                    }
                    else {
                        return _Utils_Tuple2($elm$core$Platform$Cmd$none, outboundRequests.kn);
                    }
                }();
                var mGetBillingAccountInfo = _v28.a;
                var billingAccountInfoRemoteData = _v28.b;
                var newEnv = function () {
                    var $r = env.$c();
                    $r.db = $$update__kn(outboundRequests, billingAccountInfoRemoteData);
                    $r.hr = $elm$core$Maybe$withDefault_fn($author$project$Data$FeatureFlags$default, $elm$core$Maybe$map_fn(function ($) {
                        return $.hr;
                    }, subscription));
                    $r.pV = newUser;
                    return $r;
                }();
                return _Utils_Tuple2(toModel(newEnv), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Util$Cmd$when_fn($author$project$Routing$isStripe(env.oe), $author$project$Routing$maybeRerouteSignup(env)),
                    $author$project$Update$maybeInjectPreloadedContent(newEnv),
                    mGetBillingAccountInfo
                ])));
            case 11:
                var eventBatch = msg.a;
                return $author$project$Update$CalendarEvents$handler_fn(model, eventBatch);
            case 12:
                var retries = msg.a.iZ;
                var eventId = msg.a.b7;
                var mMasterId = msg.a.h4;
                var _v30 = $author$project$Cmd$Note$newFromEventId_fn(env, eventId, mMasterId);
                if (!_v30.$) {
                    var result = _v30.a;
                    return $elm$core$Tuple$mapFirst_fn(toModel, $author$project$Update$Util$withNewEntityReroute(result));
                }
                else {
                    var err = _v30.a;
                    return _Utils_Tuple2(model, (retries > 0) ? $author$project$Util$Cmd$delayBy_fn(200, $author$project$Model$NoteFromEvent({ b7: eventId, h4: mMasterId, iZ: retries - 1 })) : $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Routing$reroute_fn(env, $author$project$Routing$RouteNotFound),
                        $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, err)
                    ])));
                }
            case 13:
                return _Utils_Tuple2(toModel(function () {
                    var $r = env.$c();
                    $r.nd = $elm$core$Maybe$map_fn(function ($) {
                        return $.b7;
                    }, $author$project$Util$NextMeeting$find_fn(model.dW, $author$project$Util$NextMeeting$NextMeeting($elm$core$Maybe$Nothing)));
                    return $r;
                }()), $elm$core$Platform$Cmd$none);
            case 48:
                var loadStep = msg.a.h3;
                var fromCache = msg.a.hy;
                var currentTime = msg.b;
                return _Utils_Tuple2(model, $elm$core$Basics$composeR_fn($author$project$Update$sendAnalytic_a0, $author$project$Update$sendAnalytic_a1, $author$project$Analytics$AppLoadBenchmark({
                    hl: $elm$core$Dict$size(model.dW.lw),
                    hy: fromCache,
                    h3: loadStep,
                    ie: $elm$time$Time$posixToMillis(currentTime) - $elm$time$Time$posixToMillis(model.dW.j8)
                })));
            case 24:
                var searchMsg = msg.a;
                var _v31 = $author$project$Search$Bar$update_fn(env, model.op, searchMsg, model.f0);
                var subModel = _v31.a;
                var subCmd = _v31.b;
                var mBacktalk = _v31.c;
                var _v32 = $author$project$Update$handleBacktalk_fn(env, $elm$core$Maybe$withDefault_fn($author$project$Env$NoOp("no backtalk from Search"), mBacktalk));
                var newEnv = _v32.a;
                var backtalkCmd = _v32.b;
                return _Utils_Tuple2(function () {
                    var $r = model.$c();
                    $r.dW = newEnv;
                    $r.f0 = subModel;
                    return $r;
                }(), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    backtalkCmd,
                    _Platform_map_fn($author$project$Model$SearchbarMsg, subCmd)
                ])));
            case 25:
                var indices = msg.a;
                return _Utils_Tuple2(function () {
                    var $r = model.$c();
                    $r.op = indices;
                    return $r;
                }(), $elm$core$Platform$Cmd$none);
            case 26:
                var index = msg.a;
                return _Utils_Tuple2($$update__dW(model, $$update__oq(env, index)), $elm$core$Platform$Cmd$none);
            case 28:
                var open = msg.a;
                return _Utils_Tuple2(toModel(function () {
                    var $r = env.$c();
                    $r.iO = open;
                    return $r;
                }()), open ? $author$project$Util$Cmd$focusOnElement_fn($author$project$Model$NoOp("focus on profile menu"), $author$project$View$Header$profileButtonId) : $author$project$Lib$Focuser$init($author$project$Model$NoOp));
            case 29:
                var open = msg.a;
                return _Utils_Tuple2(toModel(function () {
                    var $r = env.$c();
                    $r.nq = open;
                    return $r;
                }()), $author$project$Lib$Focuser$init($author$project$Model$NoOp));
            case 31:
                var open = msg.a;
                return _Utils_Tuple2(toModel(function () {
                    var $r = env.$c();
                    $r.lQ = open;
                    return $r;
                }()), $author$project$Lib$Focuser$init($author$project$Model$NoOp));
            case 32:
                var updater = msg.a;
                return _Utils_Tuple2(toModel($$update__lR(env, updater(env.lR))), $elm$core$Platform$Cmd$none);
            case 30:
                var open = msg.a;
                return _Utils_Tuple2(toModel(function () {
                    var $r = env.$c();
                    $r.lY = open;
                    return $r;
                }()), $elm$core$Platform$Cmd$none);
            case 27:
                var event = msg.a;
                return $author$project$Cmd$Keypress$handle_fn($author$project$Update$update, model, event);
            case 40:
                var newVersion = msg.a;
                return (_Utils_cmp(newVersion.m3, model.gG) > 0) ? _Utils_Tuple2(toModel($$update__j9(env, $elm$core$Maybe$Just(1))), $elm$core$Platform$Cmd$none) : ((_Utils_cmp(newVersion.mD, model.gG) > 0) ? $elm$core$Tuple$mapFirst_fn(toModel, $author$project$Update$handleBacktalk_fn(env, $author$project$Env$PushToSnackbar($author$project$View$Snacks$newVersionReleased))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 36:
                var kind = msg.a;
                var feedback = msg.b;
                return _Utils_Tuple2(toModel($$update__db(env, $$update__lF(outboundRequests, $krisajenkins$remotedata$RemoteData$Loading))), function () {
                    var _v33 = env.pV;
                    if (!_v33.$) {
                        var user = _v33.a;
                        return $author$project$Util$Request$submitFeedback({
                            lC: feedback,
                            lE: $author$project$Data$Dialog$Closeable$feedbackKindToString(kind),
                            b9: user.kg
                        });
                    }
                    else {
                        return $elm$core$Platform$Cmd$none;
                    }
                }());
            case 37:
                var status = msg.a;
                return _Utils_Tuple2(toModel($$update__db__e3(env, $$update__lF(outboundRequests, status), function () {
                    switch (status.$) {
                        case 3:
                            return $elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$ThanksForFeedback);
                        case 2:
                            return $elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$ErrorSubmittingFeedback);
                        default:
                            return $elm$core$Maybe$Nothing;
                    }
                }())), $author$project$Util$Request$maybeLogFailure(status));
            case 21:
                var subMsg = msg.a;
                var shouldShowSnack = function (upload) {
                    var _v37 = model.dW.oe;
                    if (_v37.$ === 6) {
                        var noteId = _v37.a;
                        return !_Utils_eq(noteId, upload.bq);
                    }
                    else {
                        return true;
                    }
                };
                var mPushToSnackbar = function (upload) {
                    return $author$project$Util$Misc$toJustIf_fn(shouldShowSnack(upload), $author$project$Env$PushToSnackbar($author$project$View$Snacks$attachmentUploadSuccess(upload.b8)));
                };
                var toBacktalk = function (uploadResult) {
                    if (!uploadResult.$) {
                        var upload = uploadResult.a;
                        return $author$project$Env$Tantrum($elm_community$maybe_extra$Maybe$Extra$cons_fn(mPushToSnackbar(upload), _List_fromArray([
                            $author$project$Env$UpdateNote((new $$Record77(false, upload.bq, $author$project$Data$Note$addAttachment($author$project$Data$Note$toNoteAttachment(upload))))),
                            $author$project$Env$AnalyticsEvent(upload.cf ? $author$project$Analytics$NoteInlineAttachmentAdded : $author$project$Analytics$NoteAttachmentAdded),
                            $author$project$Env$AttachmentThumbnailUrlRequest_fn({ c1: upload.c1 }, { gH: upload.Y, ip: upload.bq })
                        ])));
                    }
                    else {
                        var error = uploadResult.a;
                        return $author$project$Env$PushToSnackbar($author$project$View$Snacks$attachmentUploadWarning(error.m8));
                    }
                };
                var _v35 = $author$project$Data$StorageUpload$update_fn(subMsg, model.dW.oV);
                var newTracker = _v35.a;
                var mUploadResult = _v35.b;
                var newEnv = $$update__oV(env, newTracker);
                return $elm$core$Tuple$mapFirst_fn(toModel, $elm$core$Maybe$withDefault_fn(_Utils_Tuple2(newEnv, $elm$core$Platform$Cmd$none), $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, toBacktalk, $author$project$Update$handleBacktalk(newEnv)), mUploadResult)));
            case 34:
                var newNewTime = msg.a;
                var newCloseableDialog = $elm$core$Maybe$map_fn($author$project$Data$Dialog$Closeable$updateEditNoteTime(newNewTime), model.dW.e3);
                return _Utils_Tuple2(toModel($$update__e3(env, newCloseableDialog)), $elm$core$Platform$Cmd$none);
            case 35:
                var linkWorkAccountStatus = msg.a;
                return $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(_Utils_Tuple2(model, $elm$core$Platform$Cmd$none), A2($elm$core$Basics$composeR, $author$project$Cmd$User$setLinkWorkAccountAlertStatus(linkWorkAccountStatus), $elm$core$Tuple$mapFirst(function (newUser) {
                    return toModel($$update__pV(env, $elm$core$Maybe$Just(newUser)));
                })), env.pV);
            case 41:
                var reloadReason = msg.a;
                return _Utils_Tuple2(toModel($$update__j9(env, $elm$core$Maybe$Just(reloadReason))), $elm$core$Platform$Cmd$none);
            case 3:
                var viewport = msg.a;
                return _Utils_Tuple2(toModel(function () {
                    var $r = env.$c();
                    $r.p1 = viewport;
                    return $r;
                }()), $elm$core$Platform$Cmd$none);
            case 4:
                return _Utils_Tuple2(model, $elm$core$Task$perform_fn($author$project$Model$UpdateWindowViewport, $elm$browser$Browser$Dom$getViewport));
            case 2:
                var errorMsg = msg.a;
                return _Utils_Tuple2(model, $elm$core$Basics$composeR_fn($author$project$Error$log_a0, $author$project$Error$log_a1, errorMsg));
            case 44:
                var mentionRequest = msg.a;
                return _Utils_Tuple2(model, $elm$core$Basics$composeR_fn($author$project$Data$MentionResult$toEditor_a0, $author$project$Data$MentionResult$toEditor_a1, $author$project$Data$MentionResult$generateSearchResult_fn(env, mentionRequest)));
            case 43:
                var backtalk = msg.a;
                return $elm$core$Tuple$mapFirst_fn(toModel, $author$project$Update$handleBacktalk_fn(env, backtalk));
            case 49:
                var msgs = msg.a;
                var msgsReducer = F2(function (msg_, _v38) {
                    var model_ = _v38.a;
                    var cmds = _v38.b;
                    return $elm$core$Tuple$mapSecond_fn(function (cmd) {
                        return _List_Cons(cmd, cmds);
                    }, $author$project$Update$update_fn(msg_, model_));
                });
                return $elm$core$Tuple$mapSecond_fn($elm$core$Platform$Cmd$batch, $elm$core$List$foldl_fn(msgsReducer, _Utils_Tuple2(model, _List_Nil), msgs));
            case 42:
                var pageMsg = msg.a;
                return $author$project$Update$updatePage_fn(pageMsg, model);
            case 14:
                var firestoreMsg = msg.a;
                return $author$project$Update$handleFirestoreMsg_fn(model, firestoreMsg);
            case 46:
                return _Utils_Tuple2(model, $author$project$ElmRRULETest$initiate(model.dW));
            case 47:
                var rruleJsResults = msg.a;
                var _v39 = $author$project$ElmRRULETest$comparator_fn(model.dW, rruleJsResults);
                var mLogData = _v39.a;
                return _Utils_Tuple2(model, $author$project$Util$Cmd$whenJust_fn(mLogData, $author$project$Error$log));
            default:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
        }
    }, $author$project$Update$update = F2($author$project$Update$update_fn);
    var $mdgriffith$elm_ui$Internal$Model$AlignY = function (a) {
        return { $: 5, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$Bottom = 2;
    var $mdgriffith$elm_ui$Element$alignBottom = $mdgriffith$elm_ui$Internal$Model$AlignY(2);
    var $mdgriffith$elm_ui$Internal$Model$AlignX = function (a) {
        return { $: 6, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$Right = 2;
    var $mdgriffith$elm_ui$Element$alignRight = $mdgriffith$elm_ui$Internal$Model$AlignX(2);
    var $mdgriffith$elm_ui$Internal$Model$CenterX = 1;
    var $mdgriffith$elm_ui$Element$centerX = $mdgriffith$elm_ui$Internal$Model$AlignX(1);
    var $mdgriffith$elm_ui$Internal$Model$CenterY = 1;
    var $mdgriffith$elm_ui$Element$centerY = $mdgriffith$elm_ui$Internal$Model$AlignY(1);
    var $mdgriffith$elm_ui$Internal$Model$Colored_fn = function (a, b, c) {
        return { $: 4, a: a, b: b, c: c };
    }, $mdgriffith$elm_ui$Internal$Model$Colored = F3($mdgriffith$elm_ui$Internal$Model$Colored_fn);
    var $mdgriffith$elm_ui$Internal$Model$StyleClass_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$StyleClass = F2($mdgriffith$elm_ui$Internal$Model$StyleClass_fn);
    var $mdgriffith$elm_ui$Internal$Flag$Flag = function (a) {
        return { $: 0, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Flag$Second = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Flag$flag = function (i) {
        return (i > 31) ? $mdgriffith$elm_ui$Internal$Flag$Second(1 << (i - 32)) : $mdgriffith$elm_ui$Internal$Flag$Flag(1 << i);
    };
    var $mdgriffith$elm_ui$Internal$Flag$bgColor = $mdgriffith$elm_ui$Internal$Flag$flag(8);
    var $mdgriffith$elm_ui$Internal$Model$floatClass = function (x) {
        return $elm$core$String$fromInt($elm$core$Basics$round(x * 255));
    };
    var $mdgriffith$elm_ui$Internal$Model$formatColorClass = function (_v0) {
        var red = _v0.a;
        var green = _v0.b;
        var blue = _v0.c;
        var alpha = _v0.d;
        return $mdgriffith$elm_ui$Internal$Model$floatClass(red) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(green) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(blue) + ("-" + $mdgriffith$elm_ui$Internal$Model$floatClass(alpha))))));
    };
    var $mdgriffith$elm_ui$Element$Background$color = function (clr) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$bgColor, $mdgriffith$elm_ui$Internal$Model$Colored_fn("bg-" + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr), "background-color", clr));
    };
    var $mdgriffith$elm_ui$Internal$Model$Unkeyed = function (a) {
        return { $: 0, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$AsEl = 2;
    var $mdgriffith$elm_ui$Internal$Model$asEl = 2;
    var $mdgriffith$elm_ui$Internal$Model$Generic = { $: 0 };
    var $mdgriffith$elm_ui$Internal$Model$div = $mdgriffith$elm_ui$Internal$Model$Generic;
    var $mdgriffith$elm_ui$Internal$Model$NoNearbyChildren = { $: 0 };
    var $mdgriffith$elm_ui$Internal$Style$classes = (new $$Record110("a", "atv", "ab", "cx", "cy", "acb", "accx", "accy", "acr", "al", "ar", "at", "ah", "av", "s", "bh", "b", "w7", "bd", "bdt", "bn", "bs", "cpe", "cp", "cpx", "cpy", "c", "ctr", "cb", "ccx", "ccy", "cl", "cr", "ct", "cptr", "ctxt", "fcs", "focus-within", "fs", "g", "hbh", "hc", "he", "hf", "hfp", "hv", "ic", "fr", "lbl", "iml", "imlf", "imlp", "implw", "it", "i", "lnk", "nb", "notxt", "ol", "or", "oq", "oh", "pg", "p", "ppe", "ui", "r", "sb", "sbx", "sby", "sbt", "e", "cap", "sev", "sk", "t", "tc", "w8", "w2", "w9", "tj", "tja", "tl", "w3", "w5", "w4", "tr", "w6", "w1", "tun", "ts", "clr", "u", "wc", "we", "wf", "wfp", "wrp"));
    var $mdgriffith$elm_ui$Internal$Model$columnClass = $mdgriffith$elm_ui$Internal$Style$classes.j7 + (" " + $mdgriffith$elm_ui$Internal$Style$classes.aC);
    var $mdgriffith$elm_ui$Internal$Model$gridClass = $mdgriffith$elm_ui$Internal$Style$classes.j7 + (" " + $mdgriffith$elm_ui$Internal$Style$classes.lT);
    var $mdgriffith$elm_ui$Internal$Model$pageClass = $mdgriffith$elm_ui$Internal$Style$classes.j7 + (" " + $mdgriffith$elm_ui$Internal$Style$classes.ix);
    var $mdgriffith$elm_ui$Internal$Model$paragraphClass = $mdgriffith$elm_ui$Internal$Style$classes.j7 + (" " + $mdgriffith$elm_ui$Internal$Style$classes.iy);
    var $mdgriffith$elm_ui$Internal$Model$rowClass = $mdgriffith$elm_ui$Internal$Style$classes.j7 + (" " + $mdgriffith$elm_ui$Internal$Style$classes.of);
    var $mdgriffith$elm_ui$Internal$Model$singleClass = $mdgriffith$elm_ui$Internal$Style$classes.j7 + (" " + $mdgriffith$elm_ui$Internal$Style$classes.oC);
    var $mdgriffith$elm_ui$Internal$Model$contextClasses = function (context) {
        switch (context) {
            case 0:
                return $mdgriffith$elm_ui$Internal$Model$rowClass;
            case 1:
                return $mdgriffith$elm_ui$Internal$Model$columnClass;
            case 2:
                return $mdgriffith$elm_ui$Internal$Model$singleClass;
            case 3:
                return $mdgriffith$elm_ui$Internal$Model$gridClass;
            case 4:
                return $mdgriffith$elm_ui$Internal$Model$paragraphClass;
            default:
                return $mdgriffith$elm_ui$Internal$Model$pageClass;
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$Keyed = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$NoStyleSheet = { $: 0 };
    var $mdgriffith$elm_ui$Internal$Model$Styled = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$Unstyled = function (a) {
        return { $: 0, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$addChildren_fn = function (existing, nearbyChildren) {
        switch (nearbyChildren.$) {
            case 0:
                return existing;
            case 1:
                var behind = nearbyChildren.a;
                return _Utils_ap(behind, existing);
            case 2:
                var inFront = nearbyChildren.a;
                return _Utils_ap(existing, inFront);
            default:
                var behind = nearbyChildren.a;
                var inFront = nearbyChildren.b;
                return _Utils_ap(behind, _Utils_ap(existing, inFront));
        }
    }, $mdgriffith$elm_ui$Internal$Model$addChildren = F2($mdgriffith$elm_ui$Internal$Model$addChildren_fn);
    var $mdgriffith$elm_ui$Internal$Model$addKeyedChildren_fn = function (key, existing, nearbyChildren) {
        switch (nearbyChildren.$) {
            case 0:
                return existing;
            case 1:
                var behind = nearbyChildren.a;
                return _Utils_ap($elm$core$List$map_fn(function (x) {
                    return _Utils_Tuple2(key, x);
                }, behind), existing);
            case 2:
                var inFront = nearbyChildren.a;
                return _Utils_ap(existing, $elm$core$List$map_fn(function (x) {
                    return _Utils_Tuple2(key, x);
                }, inFront));
            default:
                var behind = nearbyChildren.a;
                var inFront = nearbyChildren.b;
                return _Utils_ap($elm$core$List$map_fn(function (x) {
                    return _Utils_Tuple2(key, x);
                }, behind), _Utils_ap(existing, $elm$core$List$map_fn(function (x) {
                    return _Utils_Tuple2(key, x);
                }, inFront)));
        }
    }, $mdgriffith$elm_ui$Internal$Model$addKeyedChildren = F3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren_fn);
    var $mdgriffith$elm_ui$Internal$Model$AsParagraph = 4;
    var $mdgriffith$elm_ui$Internal$Model$asParagraph = 4;
    var $mdgriffith$elm_ui$Internal$Flag$alignBottom = $mdgriffith$elm_ui$Internal$Flag$flag(41);
    var $mdgriffith$elm_ui$Internal$Flag$alignRight = $mdgriffith$elm_ui$Internal$Flag$flag(40);
    var $mdgriffith$elm_ui$Internal$Flag$centerX = $mdgriffith$elm_ui$Internal$Flag$flag(42);
    var $mdgriffith$elm_ui$Internal$Flag$centerY = $mdgriffith$elm_ui$Internal$Flag$flag(43);
    var $elm$html$Html$Attributes$stringProperty_fn = function (key, string) {
        return _VirtualDom_property_fn(key, $elm$json$Json$Encode$string(string));
    }, $elm$html$Html$Attributes$stringProperty = F2($elm$html$Html$Attributes$stringProperty_fn);
    var $elm$html$Html$Attributes$class_a0 = "className", $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$class_a0);
    var $elm$html$Html$div = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "div"), $elm$html$Html$div_fn = $elm$html$Html$div.a2;
    var $mdgriffith$elm_ui$Internal$Model$lengthClassName = function (x) {
        switch (x.$) {
            case 0:
                var px = x.a;
                return $elm$core$String$fromInt(px) + "px";
            case 1:
                return "auto";
            case 2:
                var i = x.a;
                return $elm$core$String$fromInt(i) + "fr";
            case 3:
                var min = x.a;
                var len = x.b;
                return "min" + ($elm$core$String$fromInt(min) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
            default:
                var max = x.a;
                var len = x.b;
                return "max" + ($elm$core$String$fromInt(max) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$transformClass = function (transform) {
        switch (transform.$) {
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                var _v1 = transform.a;
                var x = _v1.a;
                var y = _v1.b;
                var z = _v1.c;
                return $elm$core$Maybe$Just("mv-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(x) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(y) + ("-" + $mdgriffith$elm_ui$Internal$Model$floatClass(z))))));
            default:
                var _v2 = transform.a;
                var tx = _v2.a;
                var ty = _v2.b;
                var tz = _v2.c;
                var _v3 = transform.b;
                var sx = _v3.a;
                var sy = _v3.b;
                var sz = _v3.c;
                var _v4 = transform.c;
                var ox = _v4.a;
                var oy = _v4.b;
                var oz = _v4.c;
                var angle = transform.d;
                return $elm$core$Maybe$Just("tfrm-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(tx) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(ty) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(tz) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(sx) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(sy) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(sz) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(ox) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(oy) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(oz) + ("-" + $mdgriffith$elm_ui$Internal$Model$floatClass(angle))))))))))))))))))));
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$getStyleName = function (style) {
        switch (style.$) {
            case 13:
                var name = style.a;
                return name;
            case 12:
                var name = style.a;
                var o = style.b;
                return name;
            case 0:
                var _class = style.a;
                return _class;
            case 1:
                var name = style.a;
                return name;
            case 2:
                var i = style.a;
                return "font-size-" + $elm$core$String$fromInt(i);
            case 3:
                var _class = style.a;
                return _class;
            case 4:
                var _class = style.a;
                return _class;
            case 5:
                var cls = style.a;
                var x = style.b;
                var y = style.c;
                return cls;
            case 7:
                var cls = style.a;
                var top = style.b;
                var right = style.c;
                var bottom = style.d;
                var left = style.e;
                return cls;
            case 6:
                var cls = style.a;
                var top = style.b;
                var right = style.c;
                var bottom = style.d;
                var left = style.e;
                return cls;
            case 8:
                var template = style.a;
                return "grid-rows-" + ($elm$core$String$join_fn("-", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$lengthClassName, template.og)) + ("-cols-" + ($elm$core$String$join_fn("-", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$lengthClassName, template.kU)) + ("-space-x-" + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.oJ.a) + ("-space-y-" + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.oJ.b)))))));
            case 9:
                var pos = style.a;
                return "gp grid-pos-" + ($elm$core$String$fromInt(pos.of) + ("-" + ($elm$core$String$fromInt(pos.kQ) + ("-" + ($elm$core$String$fromInt(pos.jJ) + ("-" + $elm$core$String$fromInt(pos.fo)))))));
            case 11:
                var selector = style.a;
                var subStyle = style.b;
                var name = function () {
                    switch (selector) {
                        case 0:
                            return "fs";
                        case 1:
                            return "hv";
                        default:
                            return "act";
                    }
                }();
                return $elm$core$String$join_fn(" ", $elm$core$List$map_fn(function (sty) {
                    var _v1 = $mdgriffith$elm_ui$Internal$Model$getStyleName(sty);
                    if (_v1 === "") {
                        return "";
                    }
                    else {
                        var styleName = _v1;
                        return styleName + ("-" + name);
                    }
                }, subStyle));
            default:
                var x = style.a;
                return $elm$core$Maybe$withDefault_fn("", $mdgriffith$elm_ui$Internal$Model$transformClass(x));
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$reduceStyles_fn = function (style, nevermind) {
        var cache = nevermind.a;
        var existing = nevermind.b;
        var styleName = $mdgriffith$elm_ui$Internal$Model$getStyleName(style);
        return $elm$core$Set$member_fn(styleName, cache) ? nevermind : _Utils_Tuple2($elm$core$Set$insert_fn(styleName, cache), _List_Cons(style, existing));
    }, $mdgriffith$elm_ui$Internal$Model$reduceStyles = F2($mdgriffith$elm_ui$Internal$Model$reduceStyles_fn);
    var $mdgriffith$elm_ui$Internal$Model$Property_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Property = F2($mdgriffith$elm_ui$Internal$Model$Property_fn);
    var $mdgriffith$elm_ui$Internal$Model$Style_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Style = F2($mdgriffith$elm_ui$Internal$Model$Style_fn);
    var $mdgriffith$elm_ui$Internal$Style$dot = function (c) {
        return "." + c;
    };
    var $elm$core$String$fromFloat = _String_fromNumber;
    var $mdgriffith$elm_ui$Internal$Model$formatColor = function (_v0) {
        var red = _v0.a;
        var green = _v0.b;
        var blue = _v0.c;
        var alpha = _v0.d;
        return "rgba(" + ($elm$core$String$fromInt($elm$core$Basics$round(red * 255)) + (("," + $elm$core$String$fromInt($elm$core$Basics$round(green * 255))) + (("," + $elm$core$String$fromInt($elm$core$Basics$round(blue * 255))) + ("," + ($elm$core$String$fromFloat(alpha) + ")")))));
    };
    var $mdgriffith$elm_ui$Internal$Model$formatBoxShadow = function (shadow) {
        return $elm$core$String$join_fn(" ", $elm$core$List$filterMap_fn($elm$core$Basics$identity, _List_fromArray([
            shadow.hT ? $elm$core$Maybe$Just("inset") : $elm$core$Maybe$Nothing,
            $elm$core$Maybe$Just($elm$core$String$fromFloat(shadow.nt.a) + "px"),
            $elm$core$Maybe$Just($elm$core$String$fromFloat(shadow.nt.b) + "px"),
            $elm$core$Maybe$Just($elm$core$String$fromFloat(shadow.kp) + "px"),
            $elm$core$Maybe$Just($elm$core$String$fromFloat(shadow.oE) + "px"),
            $elm$core$Maybe$Just($mdgriffith$elm_ui$Internal$Model$formatColor(shadow.kS))
        ])));
    };
    var $mdgriffith$elm_ui$Internal$Model$renderFocusStyle = function (focus) {
        return _List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$Style_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hv) + ":focus-within", $elm$core$List$filterMap_fn($elm$core$Basics$identity, _List_fromArray([
                $elm$core$Maybe$map_fn(function (color) {
                    return $mdgriffith$elm_ui$Internal$Model$Property_fn("border-color", $mdgriffith$elm_ui$Internal$Model$formatColor(color));
                }, focus.ks),
                $elm$core$Maybe$map_fn(function (color) {
                    return $mdgriffith$elm_ui$Internal$Model$Property_fn("background-color", $mdgriffith$elm_ui$Internal$Model$formatColor(color));
                }, focus.ki),
                $elm$core$Maybe$map_fn(function (shadow) {
                    return $mdgriffith$elm_ui$Internal$Model$Property_fn("box-shadow", $mdgriffith$elm_ui$Internal$Model$formatBoxShadow({
                        kp: shadow.kp,
                        kS: shadow.kS,
                        hT: false,
                        nt: $elm$core$Tuple$mapSecond_fn($elm$core$Basics$toFloat, $elm$core$Tuple$mapFirst_fn($elm$core$Basics$toFloat, shadow.nt)),
                        oE: shadow.oE
                    }));
                }, focus.ov),
                $elm$core$Maybe$Just($mdgriffith$elm_ui$Internal$Model$Property_fn("outline", "none"))
            ]))),
            $mdgriffith$elm_ui$Internal$Model$Style_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7) + (":focus .focusable, " + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7) + ".focusable:focus")), $elm$core$List$filterMap_fn($elm$core$Basics$identity, _List_fromArray([
                $elm$core$Maybe$map_fn(function (color) {
                    return $mdgriffith$elm_ui$Internal$Model$Property_fn("border-color", $mdgriffith$elm_ui$Internal$Model$formatColor(color));
                }, focus.ks),
                $elm$core$Maybe$map_fn(function (color) {
                    return $mdgriffith$elm_ui$Internal$Model$Property_fn("background-color", $mdgriffith$elm_ui$Internal$Model$formatColor(color));
                }, focus.ki),
                $elm$core$Maybe$map_fn(function (shadow) {
                    return $mdgriffith$elm_ui$Internal$Model$Property_fn("box-shadow", $mdgriffith$elm_ui$Internal$Model$formatBoxShadow({
                        kp: shadow.kp,
                        kS: shadow.kS,
                        hT: false,
                        nt: $elm$core$Tuple$mapSecond_fn($elm$core$Basics$toFloat, $elm$core$Tuple$mapFirst_fn($elm$core$Basics$toFloat, shadow.nt)),
                        oE: shadow.oE
                    }));
                }, focus.ov),
                $elm$core$Maybe$Just($mdgriffith$elm_ui$Internal$Model$Property_fn("outline", "none"))
            ])))
        ]);
    };
    var $elm$virtual_dom$VirtualDom$node = function (tag) {
        return _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, _VirtualDom_noScript(tag));
    };
    var $elm$virtual_dom$VirtualDom$property_fn = function (key, value) {
        return _VirtualDom_property_fn(_VirtualDom_noInnerHtmlOrFormAction(key), _VirtualDom_noJavaScriptOrHtmlUri(value));
    }, $elm$virtual_dom$VirtualDom$property = F2($elm$virtual_dom$VirtualDom$property_fn);
    var $mdgriffith$elm_ui$Internal$Style$AllChildren_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Style$AllChildren = F2($mdgriffith$elm_ui$Internal$Style$AllChildren_fn);
    var $mdgriffith$elm_ui$Internal$Style$Batch = function (a) {
        return { $: 6, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Style$Child_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Style$Child = F2($mdgriffith$elm_ui$Internal$Style$Child_fn);
    var $mdgriffith$elm_ui$Internal$Style$Class_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Style$Class = F2($mdgriffith$elm_ui$Internal$Style$Class_fn);
    var $mdgriffith$elm_ui$Internal$Style$Descriptor_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Style$Descriptor = F2($mdgriffith$elm_ui$Internal$Style$Descriptor_fn);
    var $mdgriffith$elm_ui$Internal$Style$Left = 3;
    var $mdgriffith$elm_ui$Internal$Style$Prop_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Style$Prop = F2($mdgriffith$elm_ui$Internal$Style$Prop_fn);
    var $mdgriffith$elm_ui$Internal$Style$Right = 2;
    var $mdgriffith$elm_ui$Internal$Style$Self = $elm$core$Basics$identity;
    var $mdgriffith$elm_ui$Internal$Style$Supports_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Style$Supports = F2($mdgriffith$elm_ui$Internal$Style$Supports_fn);
    var $mdgriffith$elm_ui$Internal$Style$Content = $elm$core$Basics$identity;
    var $mdgriffith$elm_ui$Internal$Style$Bottom = 1;
    var $mdgriffith$elm_ui$Internal$Style$CenterX = 4;
    var $mdgriffith$elm_ui$Internal$Style$CenterY = 5;
    var $mdgriffith$elm_ui$Internal$Style$Top = 0;
    var $mdgriffith$elm_ui$Internal$Style$alignments = _List_fromArray([0, 1, 2, 3, 4, 5]);
    var $mdgriffith$elm_ui$Internal$Style$contentName = function (desc) {
        switch (desc) {
            case 0:
                var _v1 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.k_);
            case 1:
                var _v2 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dO);
            case 2:
                var _v3 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dQ);
            case 3:
                var _v4 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cL);
            case 4:
                var _v5 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dP);
            default:
                var _v6 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aD);
        }
    };
    var $mdgriffith$elm_ui$Internal$Style$selfName = function (desc) {
        switch (desc) {
            case 0:
                var _v1 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j3);
            case 1:
                var _v2 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jX);
            case 2:
                var _v3 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gE);
            case 3:
                var _v4 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gD);
            case 4:
                var _v5 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jY);
            default:
                var _v6 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jZ);
        }
    };
    var $mdgriffith$elm_ui$Internal$Style$describeAlignment = function (values) {
        var createDescription = function (alignment) {
            var _v0 = values(alignment);
            var content = _v0.a;
            var indiv = _v0.b;
            return _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$contentName(alignment), content),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$selfName(alignment), indiv)
                ]))
            ]);
        };
        return $mdgriffith$elm_ui$Internal$Style$Batch($elm$core$List$concatMap_fn(createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
    };
    var $mdgriffith$elm_ui$Internal$Style$elDescription = _List_fromArray([
        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex"),
        $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-direction", "column"),
        $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "pre"),
        $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fn), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "0"),
            $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kl), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "-1")
            ]))
        ])),
        $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oo), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jn), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fq), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gt), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "auto !important")
                ]))
            ]))
        ])),
        $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fp), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "auto")
        ])),
        $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fq), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "100000")
        ])),
        $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gt), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%")
        ])),
        $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jL), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%")
        ])),
        $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gs), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-start")
        ])),
        $mdgriffith$elm_ui$Internal$Style$describeAlignment(function (alignment) {
            switch (alignment) {
                case 0:
                    return _Utils_Tuple2(_List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-start")
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "0 !important")
                    ]));
                case 1:
                    return _Utils_Tuple2(_List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-end")
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "0 !important")
                    ]));
                case 2:
                    return _Utils_Tuple2(_List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-end")
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-end")
                    ]));
                case 3:
                    return _Utils_Tuple2(_List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-start")
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-start")
                    ]));
                case 4:
                    return _Utils_Tuple2(_List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "center")
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "center")
                    ]));
                default:
                    return _Utils_Tuple2(_List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto")
                        ]))
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto !important")
                    ]));
            }
        })
    ]);
    var $mdgriffith$elm_ui$Internal$Style$gridAlignments = function (values) {
        var createDescription = function (alignment) {
            return _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$selfName(alignment), values(alignment))
                ]))
            ]);
        };
        return $mdgriffith$elm_ui$Internal$Style$Batch($elm$core$List$concatMap_fn(createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
    };
    var $mdgriffith$elm_ui$Internal$Style$Above = 0;
    var $mdgriffith$elm_ui$Internal$Style$Behind = 5;
    var $mdgriffith$elm_ui$Internal$Style$Below = 1;
    var $mdgriffith$elm_ui$Internal$Style$OnLeft = 3;
    var $mdgriffith$elm_ui$Internal$Style$OnRight = 2;
    var $mdgriffith$elm_ui$Internal$Style$Within = 4;
    var $mdgriffith$elm_ui$Internal$Style$locations = function () {
        var loc = 0;
        var _v0 = function () {
            switch (loc) {
                case 0:
                    return 0;
                case 1:
                    return 0;
                case 2:
                    return 0;
                case 3:
                    return 0;
                case 4:
                    return 0;
                default:
                    return 0;
            }
        }();
        return _List_fromArray([0, 1, 2, 3, 4, 5]);
    }();
    var $mdgriffith$elm_ui$Internal$Style$baseSheet = _List_fromArray([
        $mdgriffith$elm_ui$Internal$Style$Class_fn("html,body", _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("padding", "0"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0")
        ])),
        $mdgriffith$elm_ui$Internal$Style$Class_fn(_Utils_ap($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7), _Utils_ap($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oC), $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.l9))), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "block"),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fq), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Child_fn("img", _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("max-height", "100%"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("object-fit", "cover")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gt), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Child_fn("img", _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("max-width", "100%"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("object-fit", "cover")
                ]))
            ]))
        ])),
        $mdgriffith$elm_ui$Internal$Style$Class_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7) + ":focus", _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("outline", "none")
        ])),
        $mdgriffith$elm_ui$Internal$Style$Class_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.od), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "auto"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("min-height", "100%"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "0"),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn(_Utils_ap($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7), $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fq)), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fq), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mc), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cl), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "fixed"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "20")
                ]))
            ]))
        ])),
        $mdgriffith$elm_ui$Internal$Style$Class_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cl), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "relative"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("border", "none"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-direction", "row"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto"),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oC), $mdgriffith$elm_ui$Internal$Style$elDescription),
            $mdgriffith$elm_ui$Internal$Style$Batch(function (fn) {
                return $elm$core$List$map_fn(fn, $mdgriffith$elm_ui$Internal$Style$locations);
            }(function (loc) {
                switch (loc) {
                    case 0:
                        return $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jP), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "absolute"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("bottom", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("left", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "20"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fq), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "auto")
                            ])),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gt), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%")
                            ])),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn("*", _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto")
                            ]))
                        ]));
                    case 1:
                        return $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.km), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "absolute"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("bottom", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("left", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "20"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn("*", _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto")
                            ])),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fq), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "auto")
                            ]))
                        ]));
                    case 2:
                        return $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nA), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "absolute"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("left", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("top", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "20"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn("*", _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto")
                            ]))
                        ]));
                    case 3:
                        return $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ny), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "absolute"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("right", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("top", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "20"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn("*", _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto")
                            ]))
                        ]));
                    case 4:
                        return $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mc), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "absolute"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("left", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("top", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn("*", _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto")
                            ]))
                        ]));
                    default:
                        return $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kl), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "absolute"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("left", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("top", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn("*", _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto")
                            ]))
                        ]));
                }
            }))
        ])),
        $mdgriffith$elm_ui$Internal$Style$Class_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "relative"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("border", "none"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-shrink", "0"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-direction", "row"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("resize", "none"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-feature-settings", "inherit"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("box-sizing", "border-box"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("padding", "0"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-width", "0"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-style", "solid"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-size", "inherit"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("color", "inherit"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-family", "inherit"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("line-height", "1"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "inherit"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration", "none"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-style", "inherit"),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gv), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-wrap", "wrap")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.$9), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("-moz-user-select", "none"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("-webkit-user-select", "none"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("-ms-user-select", "none"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("user-select", "none")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.k9), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("cursor", "pointer")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.la), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("cursor", "text")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nK), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none !important")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dK), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto !important")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bJ), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "0")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bA), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "1")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot(_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.l$, $mdgriffith$elm_ui$Internal$Style$classes.bJ)) + ":hover", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "0")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot(_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.l$, $mdgriffith$elm_ui$Internal$Style$classes.bA)) + ":hover", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "1")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot(_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.lK, $mdgriffith$elm_ui$Internal$Style$classes.bJ)) + ":focus", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "0")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot(_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.lK, $mdgriffith$elm_ui$Internal$Style$classes.bA)) + ":focus", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "1")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot(_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.eY, $mdgriffith$elm_ui$Internal$Style$classes.bJ)) + ":active", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "0")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot(_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.eY, $mdgriffith$elm_ui$Internal$Style$classes.bA)) + ":active", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "1")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jx), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("transition", $elm$core$String$join_fn(", ", $elm$core$List$map_fn(function (x) {
                    return x + " 160ms";
                }, _List_fromArray(["transform", "opacity", "filter", "background-color", "color", "font-size"]))))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ol), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow", "auto"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-shrink", "1")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.om), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow-x", "auto"),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.of), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-shrink", "1")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.on), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow-y", "auto"),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aC), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-shrink", "1")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oC), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-shrink", "1")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kL), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow", "hidden")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kM), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow-x", "hidden")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kN), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow-y", "hidden")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gs), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "auto")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dH), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-width", "0")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kt), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-style", "dashed")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ku), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-style", "dotted")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kv), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-style", "solid")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jn), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "pre"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline-block")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mm), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("line-height", "1.05"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("background", "transparent"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-align", "inherit")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oC), $mdgriffith$elm_ui$Internal$Style$elDescription),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.of), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-direction", "row"),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "0%"),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jK), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.h1), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fq), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "stretch !important")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hI), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "stretch !important")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gt), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "100000")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dN), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "stretch")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("u:first-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.j1, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:first-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.j$, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jY), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-left", "auto !important")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:last-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.j$, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jY), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-right", "auto !important")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:only-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.j$, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jZ), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto !important")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:last-of-type." + ($mdgriffith$elm_ui$Internal$Style$classes.j$ + " ~ u"), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("u:first-of-type." + ($mdgriffith$elm_ui$Internal$Style$classes.j1 + (" ~ s." + $mdgriffith$elm_ui$Internal$Style$classes.j$)), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0")
                ])),
                $mdgriffith$elm_ui$Internal$Style$describeAlignment(function (alignment) {
                    switch (alignment) {
                        case 0:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-start")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-start")
                            ]));
                        case 1:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-end")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-end")
                            ]));
                        case 2:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-end")
                            ]), _List_Nil);
                        case 3:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-start")
                            ]), _List_Nil);
                        case 4:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "center")
                            ]), _List_Nil);
                        default:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "center")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "center")
                            ]));
                    }
                }),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oI), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "space-between")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.d5), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "baseline")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aC), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-direction", "column"),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fq), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "100000")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gt), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jL), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gs), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-start")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("u:first-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.j_, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:first-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.j0, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jZ), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "0 !important")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:last-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.j0, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jZ), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "0 !important")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:only-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.j0, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jZ), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto !important")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:last-of-type." + ($mdgriffith$elm_ui$Internal$Style$classes.j0 + " ~ u"), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("u:first-of-type." + ($mdgriffith$elm_ui$Internal$Style$classes.j_ + (" ~ s." + $mdgriffith$elm_ui$Internal$Style$classes.j0)), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0")
                ])),
                $mdgriffith$elm_ui$Internal$Style$describeAlignment(function (alignment) {
                    switch (alignment) {
                        case 0:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-start")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto")
                            ]));
                        case 1:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-end")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto")
                            ]));
                        case 2:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-end")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-end")
                            ]));
                        case 3:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-start")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-start")
                            ]));
                        case 4:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "center")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "center")
                            ]));
                        default:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "center")
                            ]), _List_Nil);
                    }
                }),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dN), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "stretch !important")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oI), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "space-between")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lT), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "-ms-grid"),
                $mdgriffith$elm_ui$Internal$Style$Child_fn(".gp", _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Supports_fn(_Utils_Tuple2("display", "grid"), _List_fromArray([
                    _Utils_Tuple2("display", "grid")
                ])),
                $mdgriffith$elm_ui$Internal$Style$gridAlignments(function (alignment) {
                    switch (alignment) {
                        case 0:
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-start")
                            ]);
                        case 1:
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-end")
                            ]);
                        case 2:
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-end")
                            ]);
                        case 3:
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-start")
                            ]);
                        case 4:
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "center")
                            ]);
                        default:
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "center")
                            ]);
                    }
                })
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ix), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "block"),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7 + ":first-child"), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7 + ($mdgriffith$elm_ui$Internal$Style$selfName(3) + (":first-child + ." + $mdgriffith$elm_ui$Internal$Style$classes.j7))), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7 + ($mdgriffith$elm_ui$Internal$Style$selfName(2) + (":first-child + ." + $mdgriffith$elm_ui$Internal$Style$classes.j7))), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important")
                ])),
                $mdgriffith$elm_ui$Internal$Style$describeAlignment(function (alignment) {
                    switch (alignment) {
                        case 0:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                        case 1:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                        case 2:
                            return _Utils_Tuple2(_List_Nil, _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("float", "right"),
                                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn("::after", _List_fromArray([
                                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("content", "\"\""),
                                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "table"),
                                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("clear", "both")
                                ]))
                            ]));
                        case 3:
                            return _Utils_Tuple2(_List_Nil, _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("float", "left"),
                                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn("::after", _List_fromArray([
                                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("content", "\"\""),
                                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "table"),
                                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("clear", "both")
                                ]))
                            ]));
                        case 4:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                        default:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                    }
                })
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mi), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "pre-wrap !important"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("background-color", "transparent")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ml), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oC), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mk), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "pre-wrap !important"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("cursor", "text"),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mj), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "pre-wrap !important"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("color", "transparent")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iy), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "block"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "normal"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow-wrap", "break-word"),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fn), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "0"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kl), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "-1")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$AllChildren_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jn), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "normal")
                ])),
                $mdgriffith$elm_ui$Internal$Style$AllChildren_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iy), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline"),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn("::after", _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("content", "none")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn("::before", _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("content", "none")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$AllChildren_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oC), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "normal"),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jK), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline-block")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mc), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kl), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jP), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.km), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nA), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ny), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jn), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "normal")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.of), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aC), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline-flex")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lT), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline-grid")
                ])),
                $mdgriffith$elm_ui$Internal$Style$describeAlignment(function (alignment) {
                    switch (alignment) {
                        case 0:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                        case 1:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                        case 2:
                            return _Utils_Tuple2(_List_Nil, _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("float", "right")
                            ]));
                        case 3:
                            return _Utils_Tuple2(_List_Nil, _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("float", "left")
                            ]));
                        case 4:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                        default:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                    }
                })
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn(".hidden", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "none")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pl), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "100")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pc), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "200")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pg), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "300")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pi), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "400")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ph), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "500")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pk), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "600")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kr), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "700")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pb), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "800")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pd), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "900")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mz), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-style", "italic")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oW), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration", "line-through")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pN), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration", "underline"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration-skip-ink", "auto"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration-skip", "ink")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn(_Utils_ap($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pN), $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oW)), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration", "line-through underline"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration-skip-ink", "auto"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration-skip", "ink")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pm), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-style", "normal")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pe), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-align", "justify")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eO), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-align", "justify-all")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pa), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-align", "center")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pj), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-align", "right")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pf), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-align", "left")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn(".modal", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "fixed"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("left", "0"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("top", "0"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none")
            ]))
        ]))
    ]);
    var $mdgriffith$elm_ui$Internal$Style$fontVariant = function (_var) {
        return _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Class_fn(".v-" + _var, _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-feature-settings", "\"" + (_var + "\""))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Class_fn(".v-" + (_var + "-off"), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-feature-settings", "\"" + (_var + "\" 0"))
            ]))
        ]);
    };
    var $mdgriffith$elm_ui$Internal$Style$commonValues = $elm$core$List$concat(_List_fromArray([
        $elm$core$List$map_fn(function (x) {
            return $mdgriffith$elm_ui$Internal$Style$Class_fn(".border-" + $elm$core$String$fromInt(x), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-width", $elm$core$String$fromInt(x) + "px")
            ]));
        }, $elm$core$List$range_fn(0, 6)),
        $elm$core$List$map_fn(function (i) {
            return $mdgriffith$elm_ui$Internal$Style$Class_fn(".font-size-" + $elm$core$String$fromInt(i), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-size", $elm$core$String$fromInt(i) + "px")
            ]));
        }, $elm$core$List$range_fn(8, 32)),
        $elm$core$List$map_fn(function (i) {
            return $mdgriffith$elm_ui$Internal$Style$Class_fn(".p-" + $elm$core$String$fromInt(i), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("padding", $elm$core$String$fromInt(i) + "px")
            ]));
        }, $elm$core$List$range_fn(0, 24)),
        _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Class_fn(".v-smcp", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-variant", "small-caps")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Class_fn(".v-smcp-off", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-variant", "normal")
            ]))
        ]),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("zero"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("onum"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("liga"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("dlig"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("ordn"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("tnum"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("afrc"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("frac")
    ]));
    var $mdgriffith$elm_ui$Internal$Style$explainer = "\n.explain {\n    border: 6px solid rgb(174, 121, 15) !important;\n}\n.explain > ." + ($mdgriffith$elm_ui$Internal$Style$classes.j7 + (" {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n.ctr {\n    border: none !important;\n}\n.explain > .ctr > ." + ($mdgriffith$elm_ui$Internal$Style$classes.j7 + " {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n")));
    var $mdgriffith$elm_ui$Internal$Style$inputTextReset = "\ninput[type=\"search\"],\ninput[type=\"search\"]::-webkit-search-decoration,\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-results-button,\ninput[type=\"search\"]::-webkit-search-results-decoration {\n  -webkit-appearance:none;\n}\n";
    var $mdgriffith$elm_ui$Internal$Style$sliderReset = "\ninput[type=range] {\n  -webkit-appearance: none; \n  background: transparent;\n  position:absolute;\n  left:0;\n  top:0;\n  z-index:10;\n  width: 100%;\n  outline: dashed 1px;\n  height: 100%;\n  opacity: 0;\n}\n";
    var $mdgriffith$elm_ui$Internal$Style$thumbReset = "\ninput[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-moz-range-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-ms-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range][orient=vertical]{\n    writing-mode: bt-lr; /* IE */\n    -webkit-appearance: slider-vertical;  /* WebKit */\n}\n";
    var $mdgriffith$elm_ui$Internal$Style$trackReset = "\ninput[type=range]::-moz-range-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-ms-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-webkit-slider-runnable-track {\n    background: transparent;\n    cursor: pointer;\n}\n";
    var $mdgriffith$elm_ui$Internal$Style$overrides = "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {" + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.of) + (" > " + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7) + (" { flex-basis: auto !important; } " + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.of) + (" > " + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dN) + (" { flex-basis: auto !important; }}" + ($mdgriffith$elm_ui$Internal$Style$inputTextReset + ($mdgriffith$elm_ui$Internal$Style$sliderReset + ($mdgriffith$elm_ui$Internal$Style$trackReset + ($mdgriffith$elm_ui$Internal$Style$thumbReset + $mdgriffith$elm_ui$Internal$Style$explainer)))))))))))))));
    var $mdgriffith$elm_ui$Internal$Style$Intermediate = $elm$core$Basics$identity;
    var $mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn = function (selector, closing) {
        return (new $$Record111(closing, _List_Nil, _List_Nil, selector));
    }, $mdgriffith$elm_ui$Internal$Style$emptyIntermediate = F2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn);
    var $mdgriffith$elm_ui$Internal$Style$renderRules_fn = function (_v0, rulesToRender) {
        var parent = _v0;
        var generateIntermediates = F2(function (rule, rendered) {
            switch (rule.$) {
                case 0:
                    var name = rule.a;
                    var val = rule.b;
                    return function () {
                        var $r = rendered.$c();
                        $r.bc = _List_Cons(_Utils_Tuple2(name, val), rendered.bc);
                        return $r;
                    }();
                case 3:
                    var _v2 = rule.a;
                    var prop = _v2.a;
                    var value = _v2.b;
                    var props = rule.b;
                    return $$update__y(rendered, _List_Cons((new $$Record111("\n}", _List_Nil, props, "@supports (" + (prop + (":" + (value + (") {" + parent.ah)))))), rendered.y));
                case 5:
                    var selector = rule.a;
                    var adjRules = rule.b;
                    return $$update__y(rendered, _List_Cons($mdgriffith$elm_ui$Internal$Style$renderRules_fn($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn(parent.ah + (" + " + selector), ""), adjRules), rendered.y));
                case 1:
                    var child = rule.a;
                    var childRules = rule.b;
                    return $$update__y(rendered, _List_Cons($mdgriffith$elm_ui$Internal$Style$renderRules_fn($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn(parent.ah + (" > " + child), ""), childRules), rendered.y));
                case 2:
                    var child = rule.a;
                    var childRules = rule.b;
                    return $$update__y(rendered, _List_Cons($mdgriffith$elm_ui$Internal$Style$renderRules_fn($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn(parent.ah + (" " + child), ""), childRules), rendered.y));
                case 4:
                    var descriptor = rule.a;
                    var descriptorRules = rule.b;
                    return $$update__y(rendered, _List_Cons($mdgriffith$elm_ui$Internal$Style$renderRules_fn($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn(_Utils_ap(parent.ah, descriptor), ""), descriptorRules), rendered.y));
                default:
                    var batched = rule.a;
                    return $$update__y(rendered, _List_Cons($mdgriffith$elm_ui$Internal$Style$renderRules_fn($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn(parent.ah, ""), batched), rendered.y));
            }
        });
        return $elm$core$List$foldr_fn(generateIntermediates, parent, rulesToRender);
    }, $mdgriffith$elm_ui$Internal$Style$renderRules = F2($mdgriffith$elm_ui$Internal$Style$renderRules_fn);
    var $mdgriffith$elm_ui$Internal$Style$renderCompact = function (styleClasses) {
        var renderValues = function (values) {
            return $elm$core$String$concat($elm$core$List$map_fn(function (_v3) {
                var x = _v3.a;
                var y = _v3.b;
                return x + (":" + (y + ";"));
            }, values));
        };
        var renderClass = function (rule) {
            var _v2 = rule.bc;
            if (!_v2.b) {
                return "";
            }
            else {
                return rule.ah + ("{" + (renderValues(rule.bc) + (rule.dM + "}")));
            }
        };
        var renderIntermediate = function (_v0) {
            var rule = _v0;
            return _Utils_ap(renderClass(rule), $elm$core$String$concat($elm$core$List$map_fn(renderIntermediate, rule.y)));
        };
        return $elm$core$String$concat($elm$core$List$map_fn(renderIntermediate, $elm$core$List$foldr_fn(F2(function (_v1, existing) {
            var name = _v1.a;
            var styleRules = _v1.b;
            return _List_Cons($mdgriffith$elm_ui$Internal$Style$renderRules_fn($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn(name, ""), styleRules), existing);
        }), _List_Nil, styleClasses)));
    };
    var $mdgriffith$elm_ui$Internal$Style$rules = _Utils_ap($mdgriffith$elm_ui$Internal$Style$overrides, $mdgriffith$elm_ui$Internal$Style$renderCompact(_Utils_ap($mdgriffith$elm_ui$Internal$Style$baseSheet, $mdgriffith$elm_ui$Internal$Style$commonValues)));
    var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
    var $mdgriffith$elm_ui$Internal$Model$staticRoot = function (opts) {
        var _v0 = opts.m7;
        switch (_v0) {
            case 0:
                return A3($elm$virtual_dom$VirtualDom$node, "div", _List_Nil, _List_fromArray([
                    A3($elm$virtual_dom$VirtualDom$node, "style", _List_Nil, _List_fromArray([
                        $elm$virtual_dom$VirtualDom$text($mdgriffith$elm_ui$Internal$Style$rules)
                    ]))
                ]));
            case 1:
                return $elm$virtual_dom$VirtualDom$text("");
            default:
                return A3($elm$virtual_dom$VirtualDom$node, "elm-ui-static-rules", _List_fromArray([
                    $elm$virtual_dom$VirtualDom$property_fn("rules", $elm$json$Json$Encode$string($mdgriffith$elm_ui$Internal$Style$rules))
                ]), _List_Nil);
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$fontName = function (font) {
        switch (font.$) {
            case 0:
                return "serif";
            case 1:
                return "sans-serif";
            case 2:
                return "monospace";
            case 3:
                var name = font.a;
                return "\"" + (name + "\"");
            case 4:
                var name = font.a;
                var url = font.b;
                return "\"" + (name + "\"");
            default:
                var name = font.a.b;
                return "\"" + (name + "\"");
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$isSmallCaps = function (_var) {
        switch (_var.$) {
            case 0:
                var name = _var.a;
                return name === "smcp";
            case 1:
                var name = _var.a;
                return false;
            default:
                var name = _var.a;
                var index = _var.b;
                return (name === "smcp") && (index === 1);
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$hasSmallCaps = function (typeface) {
        if (typeface.$ === 5) {
            var font = typeface.a;
            return $elm$core$List$any_fn($mdgriffith$elm_ui$Internal$Model$isSmallCaps, font.jE);
        }
        else {
            return false;
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$renderProps_fn = function (force, _v0, existing) {
        var key = _v0.a;
        var val = _v0.b;
        return force ? (existing + ("\n  " + (key + (": " + (val + " !important;"))))) : (existing + ("\n  " + (key + (": " + (val + ";")))));
    }, $mdgriffith$elm_ui$Internal$Model$renderProps = F3($mdgriffith$elm_ui$Internal$Model$renderProps_fn);
    var $mdgriffith$elm_ui$Internal$Model$renderStyle_fn = function (options, maybePseudo, selector, props) {
        if (maybePseudo.$ === 1) {
            return _List_fromArray([
                selector + ("{" + ($elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderProps(false), "", props) + "\n}"))
            ]);
        }
        else {
            var pseudo = maybePseudo.a;
            switch (pseudo) {
                case 1:
                    var _v2 = options.l$;
                    switch (_v2) {
                        case 0:
                            return _List_Nil;
                        case 2:
                            return _List_fromArray([
                                selector + ("-hv {" + ($elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderProps(true), "", props) + "\n}"))
                            ]);
                        default:
                            return _List_fromArray([
                                selector + ("-hv:hover {" + ($elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderProps(false), "", props) + "\n}"))
                            ]);
                    }
                case 0:
                    var renderedProps = $elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderProps(false), "", props);
                    return _List_fromArray([selector + ("-fs:focus {" + (renderedProps + "\n}")), ("." + ($mdgriffith$elm_ui$Internal$Style$classes.j7 + (":focus " + (selector + "-fs  {")))) + (renderedProps + "\n}"), (selector + "-fs:focus-within {") + (renderedProps + "\n}"), (".focusable-parent:focus ~ " + ("." + ($mdgriffith$elm_ui$Internal$Style$classes.j7 + (" " + (selector + "-fs {"))))) + (renderedProps + "\n}")]);
                default:
                    return _List_fromArray([
                        selector + ("-act:active {" + ($elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderProps(false), "", props) + "\n}"))
                    ]);
            }
        }
    }, $mdgriffith$elm_ui$Internal$Model$renderStyle = F4($mdgriffith$elm_ui$Internal$Model$renderStyle_fn);
    var $mdgriffith$elm_ui$Internal$Model$renderVariant = function (_var) {
        switch (_var.$) {
            case 0:
                var name = _var.a;
                return "\"" + (name + "\"");
            case 1:
                var name = _var.a;
                return "\"" + (name + "\" 0");
            default:
                var name = _var.a;
                var index = _var.b;
                return "\"" + (name + ("\" " + $elm$core$String$fromInt(index)));
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$renderVariants = function (typeface) {
        if (typeface.$ === 5) {
            var font = typeface.a;
            return $elm$core$Maybe$Just($elm$core$String$join_fn(", ", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$renderVariant, font.jE)));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$transformValue = function (transform) {
        switch (transform.$) {
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                var _v1 = transform.a;
                var x = _v1.a;
                var y = _v1.b;
                var z = _v1.c;
                return $elm$core$Maybe$Just("translate3d(" + ($elm$core$String$fromFloat(x) + ("px, " + ($elm$core$String$fromFloat(y) + ("px, " + ($elm$core$String$fromFloat(z) + "px)"))))));
            default:
                var _v2 = transform.a;
                var tx = _v2.a;
                var ty = _v2.b;
                var tz = _v2.c;
                var _v3 = transform.b;
                var sx = _v3.a;
                var sy = _v3.b;
                var sz = _v3.c;
                var _v4 = transform.c;
                var ox = _v4.a;
                var oy = _v4.b;
                var oz = _v4.c;
                var angle = transform.d;
                var translate = "translate3d(" + ($elm$core$String$fromFloat(tx) + ("px, " + ($elm$core$String$fromFloat(ty) + ("px, " + ($elm$core$String$fromFloat(tz) + "px)")))));
                var scale = "scale3d(" + ($elm$core$String$fromFloat(sx) + (", " + ($elm$core$String$fromFloat(sy) + (", " + ($elm$core$String$fromFloat(sz) + ")")))));
                var rotate = "rotate3d(" + ($elm$core$String$fromFloat(ox) + (", " + ($elm$core$String$fromFloat(oy) + (", " + ($elm$core$String$fromFloat(oz) + (", " + ($elm$core$String$fromFloat(angle) + "rad)")))))));
                return $elm$core$Maybe$Just(translate + (" " + (scale + (" " + rotate))));
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$renderStyleRule_fn = function (options, rule, maybePseudo) {
        switch (rule.$) {
            case 0:
                var selector = rule.a;
                var props = rule.b;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, selector, props);
            case 13:
                var name = rule.a;
                var prop = rule.b;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "." + name, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("box-shadow", prop)
                ]));
            case 12:
                var name = rule.a;
                var transparency = rule.b;
                var opacity = $elm$core$Basics$max_fn(0, $elm$core$Basics$min_fn(1, 1 - transparency));
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "." + name, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("opacity", $elm$core$String$fromFloat(opacity))
                ]));
            case 2:
                var i = rule.a;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, ".font-size-" + $elm$core$String$fromInt(i), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("font-size", $elm$core$String$fromInt(i) + "px")
                ]));
            case 1:
                var name = rule.a;
                var typefaces = rule.b;
                var features = $elm$core$String$join_fn(", ", $elm$core$List$filterMap_fn($mdgriffith$elm_ui$Internal$Model$renderVariants, typefaces));
                var families = _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("font-family", $elm$core$String$join_fn(", ", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$fontName, typefaces))),
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("font-feature-settings", features),
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("font-variant", $elm$core$List$any_fn($mdgriffith$elm_ui$Internal$Model$hasSmallCaps, typefaces) ? "small-caps" : "normal")
                ]);
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "." + name, families);
            case 3:
                var _class = rule.a;
                var prop = rule.b;
                var val = rule.c;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "." + _class, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn(prop, val)
                ]));
            case 4:
                var _class = rule.a;
                var prop = rule.b;
                var color = rule.c;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "." + _class, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn(prop, $mdgriffith$elm_ui$Internal$Model$formatColor(color))
                ]));
            case 5:
                var cls = rule.a;
                var x = rule.b;
                var y = rule.c;
                var yPx = $elm$core$String$fromInt(y) + "px";
                var xPx = $elm$core$String$fromInt(x) + "px";
                var single = "." + $mdgriffith$elm_ui$Internal$Style$classes.oC;
                var row = "." + $mdgriffith$elm_ui$Internal$Style$classes.of;
                var wrappedRow = "." + ($mdgriffith$elm_ui$Internal$Style$classes.gv + row);
                var right = "." + $mdgriffith$elm_ui$Internal$Style$classes.gE;
                var paragraph = "." + $mdgriffith$elm_ui$Internal$Style$classes.iy;
                var page = "." + $mdgriffith$elm_ui$Internal$Style$classes.ix;
                var left = "." + $mdgriffith$elm_ui$Internal$Style$classes.gD;
                var halfY = $elm$core$String$fromFloat(y / 2) + "px";
                var halfX = $elm$core$String$fromFloat(x / 2) + "px";
                var column = "." + $mdgriffith$elm_ui$Internal$Style$classes.aC;
                var _class = "." + cls;
                var any = "." + $mdgriffith$elm_ui$Internal$Style$classes.j7;
                return $elm$core$List$concat(_List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (row + (" > " + (any + (" + " + any)))), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-left", xPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (wrappedRow + (" > " + any)), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin", halfY + (" " + halfX))
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (column + (" > " + (any + (" + " + any)))), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-top", yPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (page + (" > " + (any + (" + " + any)))), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-top", yPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (page + (" > " + left)), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-right", xPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (page + (" > " + right)), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-left", xPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _Utils_ap(_class, paragraph), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("line-height", "calc(1em + " + ($elm$core$String$fromInt(y) + "px)"))
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "textarea" + (any + _class), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("line-height", "calc(1em + " + ($elm$core$String$fromInt(y) + "px)")),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("height", "calc(100% + " + ($elm$core$String$fromInt(y) + "px)"))
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (paragraph + (" > " + left)), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-right", xPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (paragraph + (" > " + right)), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-left", xPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (paragraph + "::after"), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("content", "''"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("display", "block"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("height", "0"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("width", "0"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-top", $elm$core$String$fromInt((-1) * ((y / 2) | 0)) + "px")
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (paragraph + "::before"), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("content", "''"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("display", "block"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("height", "0"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("width", "0"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-bottom", $elm$core$String$fromInt((-1) * ((y / 2) | 0)) + "px")
                    ]))
                ]));
            case 7:
                var cls = rule.a;
                var top = rule.b;
                var right = rule.c;
                var bottom = rule.d;
                var left = rule.e;
                var _class = "." + cls;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("padding", $elm$core$String$fromFloat(top) + ("px " + ($elm$core$String$fromFloat(right) + ("px " + ($elm$core$String$fromFloat(bottom) + ("px " + ($elm$core$String$fromFloat(left) + "px")))))))
                ]));
            case 6:
                var cls = rule.a;
                var top = rule.b;
                var right = rule.c;
                var bottom = rule.d;
                var left = rule.e;
                var _class = "." + cls;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("border-width", $elm$core$String$fromInt(top) + ("px " + ($elm$core$String$fromInt(right) + ("px " + ($elm$core$String$fromInt(bottom) + ("px " + ($elm$core$String$fromInt(left) + "px")))))))
                ]));
            case 8:
                var template = rule.a;
                var toGridLengthHelper = F3(function (minimum, maximum, x) {
                    toGridLengthHelper: while (true) {
                        switch (x.$) {
                            case 0:
                                var px = x.a;
                                return $elm$core$String$fromInt(px) + "px";
                            case 1:
                                var _v2 = _Utils_Tuple2(minimum, maximum);
                                if (_v2.a.$ === 1) {
                                    if (_v2.b.$ === 1) {
                                        var _v3 = _v2.a;
                                        var _v4 = _v2.b;
                                        return "max-content";
                                    }
                                    else {
                                        var _v6 = _v2.a;
                                        var maxSize = _v2.b.a;
                                        return "minmax(max-content, " + ($elm$core$String$fromInt(maxSize) + "px)");
                                    }
                                }
                                else {
                                    if (_v2.b.$ === 1) {
                                        var minSize = _v2.a.a;
                                        var _v5 = _v2.b;
                                        return "minmax(" + ($elm$core$String$fromInt(minSize) + ("px, " + "max-content)"));
                                    }
                                    else {
                                        var minSize = _v2.a.a;
                                        var maxSize = _v2.b.a;
                                        return "minmax(" + ($elm$core$String$fromInt(minSize) + ("px, " + ($elm$core$String$fromInt(maxSize) + "px)")));
                                    }
                                }
                            case 2:
                                var i = x.a;
                                var _v7 = _Utils_Tuple2(minimum, maximum);
                                if (_v7.a.$ === 1) {
                                    if (_v7.b.$ === 1) {
                                        var _v8 = _v7.a;
                                        var _v9 = _v7.b;
                                        return $elm$core$String$fromInt(i) + "fr";
                                    }
                                    else {
                                        var _v11 = _v7.a;
                                        var maxSize = _v7.b.a;
                                        return "minmax(max-content, " + ($elm$core$String$fromInt(maxSize) + "px)");
                                    }
                                }
                                else {
                                    if (_v7.b.$ === 1) {
                                        var minSize = _v7.a.a;
                                        var _v10 = _v7.b;
                                        return "minmax(" + ($elm$core$String$fromInt(minSize) + ("px, " + ($elm$core$String$fromInt(i) + ("fr" + "fr)"))));
                                    }
                                    else {
                                        var minSize = _v7.a.a;
                                        var maxSize = _v7.b.a;
                                        return "minmax(" + ($elm$core$String$fromInt(minSize) + ("px, " + ($elm$core$String$fromInt(maxSize) + "px)")));
                                    }
                                }
                            case 3:
                                var m = x.a;
                                var len = x.b;
                                var $temp$minimum = $elm$core$Maybe$Just(m), $temp$maximum = maximum, $temp$x = len;
                                minimum = $temp$minimum;
                                maximum = $temp$maximum;
                                x = $temp$x;
                                continue toGridLengthHelper;
                            default:
                                var m = x.a;
                                var len = x.b;
                                var $temp$minimum = minimum, $temp$maximum = $elm$core$Maybe$Just(m), $temp$x = len;
                                minimum = $temp$minimum;
                                maximum = $temp$maximum;
                                x = $temp$x;
                                continue toGridLengthHelper;
                        }
                    }
                });
                var toGridLength = function (x) {
                    return A3(toGridLengthHelper, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, x);
                };
                var xSpacing = toGridLength(template.oJ.a);
                var ySpacing = toGridLength(template.oJ.b);
                var rows = function (x) {
                    return "grid-template-rows: " + (x + ";");
                }($elm$core$String$join_fn(" ", $elm$core$List$map_fn(toGridLength, template.og)));
                var msRows = function (x) {
                    return "-ms-grid-rows: " + (x + ";");
                }($elm$core$String$join_fn(ySpacing, $elm$core$List$map_fn(toGridLength, template.kU)));
                var msColumns = function (x) {
                    return "-ms-grid-columns: " + (x + ";");
                }($elm$core$String$join_fn(ySpacing, $elm$core$List$map_fn(toGridLength, template.kU)));
                var gapY = "grid-row-gap:" + (toGridLength(template.oJ.b) + ";");
                var gapX = "grid-column-gap:" + (toGridLength(template.oJ.a) + ";");
                var columns = function (x) {
                    return "grid-template-columns: " + (x + ";");
                }($elm$core$String$join_fn(" ", $elm$core$List$map_fn(toGridLength, template.kU)));
                var _class = ".grid-rows-" + ($elm$core$String$join_fn("-", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$lengthClassName, template.og)) + ("-cols-" + ($elm$core$String$join_fn("-", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$lengthClassName, template.kU)) + ("-space-x-" + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.oJ.a) + ("-space-y-" + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.oJ.b)))))));
                var modernGrid = _class + ("{" + (columns + (rows + (gapX + (gapY + "}")))));
                var supports = "@supports (display:grid) {" + (modernGrid + "}");
                var base = _class + ("{" + (msColumns + (msRows + "}")));
                return _List_fromArray([base, supports]);
            case 9:
                var position = rule.a;
                var msPosition = $elm$core$String$join_fn(" ", _List_fromArray([
                    "-ms-grid-row: " + ($elm$core$String$fromInt(position.of) + ";"),
                    "-ms-grid-row-span: " + ($elm$core$String$fromInt(position.fo) + ";"),
                    "-ms-grid-column: " + ($elm$core$String$fromInt(position.kQ) + ";"),
                    "-ms-grid-column-span: " + ($elm$core$String$fromInt(position.jJ) + ";")
                ]));
                var modernPosition = $elm$core$String$join_fn(" ", _List_fromArray([
                    "grid-row: " + ($elm$core$String$fromInt(position.of) + (" / " + ($elm$core$String$fromInt(position.of + position.fo) + ";"))),
                    "grid-column: " + ($elm$core$String$fromInt(position.kQ) + (" / " + ($elm$core$String$fromInt(position.kQ + position.jJ) + ";")))
                ]));
                var _class = ".grid-pos-" + ($elm$core$String$fromInt(position.of) + ("-" + ($elm$core$String$fromInt(position.kQ) + ("-" + ($elm$core$String$fromInt(position.jJ) + ("-" + $elm$core$String$fromInt(position.fo)))))));
                var modernGrid = _class + ("{" + (modernPosition + "}"));
                var supports = "@supports (display:grid) {" + (modernGrid + "}");
                var base = _class + ("{" + (msPosition + "}"));
                return _List_fromArray([base, supports]);
            case 11:
                var _class = rule.a;
                var styles = rule.b;
                var renderPseudoRule = function (style) {
                    return $mdgriffith$elm_ui$Internal$Model$renderStyleRule_fn(options, style, $elm$core$Maybe$Just(_class));
                };
                return $elm$core$List$concatMap_fn(renderPseudoRule, styles);
            default:
                var transform = rule.a;
                var val = $mdgriffith$elm_ui$Internal$Model$transformValue(transform);
                var _class = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
                var _v12 = _Utils_Tuple2(_class, val);
                if ((!_v12.a.$) && (!_v12.b.$)) {
                    var cls = _v12.a.a;
                    var v = _v12.b.a;
                    return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "." + cls, _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("transform", v)
                    ]));
                }
                else {
                    return _List_Nil;
                }
        }
    }, $mdgriffith$elm_ui$Internal$Model$renderStyleRule = F3($mdgriffith$elm_ui$Internal$Model$renderStyleRule_fn);
    var $mdgriffith$elm_ui$Internal$Model$encodeStyles_fn = function (options, stylesheet) {
        return $elm$json$Json$Encode$object($elm$core$List$map_fn(function (style) {
            var styled = $mdgriffith$elm_ui$Internal$Model$renderStyleRule_fn(options, style, $elm$core$Maybe$Nothing);
            return _Utils_Tuple2($mdgriffith$elm_ui$Internal$Model$getStyleName(style), $elm$json$Json$Encode$list_fn($elm$json$Json$Encode$string, styled));
        }, stylesheet));
    }, $mdgriffith$elm_ui$Internal$Model$encodeStyles = F2($mdgriffith$elm_ui$Internal$Model$encodeStyles_fn);
    var $mdgriffith$elm_ui$Internal$Model$bracket_fn = function (selector, rules) {
        var renderPair = function (_v0) {
            var name = _v0.a;
            var val = _v0.b;
            return name + (": " + (val + ";"));
        };
        return selector + (" {" + ($elm$core$String$join_fn("", $elm$core$List$map_fn(renderPair, rules)) + "}"));
    }, $mdgriffith$elm_ui$Internal$Model$bracket = F2($mdgriffith$elm_ui$Internal$Model$bracket_fn);
    var $mdgriffith$elm_ui$Internal$Model$fontRule_fn = function (name, modifier, _v0) {
        var parentAdj = _v0.a;
        var textAdjustment = _v0.b;
        return _List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$bracket_fn("." + (name + ("." + (modifier + (", " + ("." + (name + (" ." + modifier))))))), parentAdj),
            $mdgriffith$elm_ui$Internal$Model$bracket_fn("." + (name + ("." + (modifier + ("> ." + ($mdgriffith$elm_ui$Internal$Style$classes.jn + (", ." + (name + (" ." + (modifier + (" > ." + $mdgriffith$elm_ui$Internal$Style$classes.jn)))))))))), textAdjustment)
        ]);
    }, $mdgriffith$elm_ui$Internal$Model$fontRule = F3($mdgriffith$elm_ui$Internal$Model$fontRule_fn);
    var $mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule_fn = function (fontToAdjust, _v0, otherFontName) {
        var full = _v0.a;
        var capital = _v0.b;
        var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (" ." + fontToAdjust));
        return $elm$core$String$join_fn(" ", _Utils_ap($mdgriffith$elm_ui$Internal$Model$fontRule_fn(name, $mdgriffith$elm_ui$Internal$Style$classes.oF, capital), $mdgriffith$elm_ui$Internal$Model$fontRule_fn(name, $mdgriffith$elm_ui$Internal$Style$classes.lO, full)));
    }, $mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule = F3($mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule_fn);
    var $mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule_fn = function (fontToAdjust, otherFontName) {
        var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (" ." + fontToAdjust));
        return $elm$core$String$join_fn(" ", _List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$bracket_fn("." + (name + ("." + ($mdgriffith$elm_ui$Internal$Style$classes.oF + (", " + ("." + (name + (" ." + $mdgriffith$elm_ui$Internal$Style$classes.oF))))))), _List_fromArray([
                _Utils_Tuple2("line-height", "1")
            ])),
            $mdgriffith$elm_ui$Internal$Model$bracket_fn("." + (name + ("." + ($mdgriffith$elm_ui$Internal$Style$classes.oF + ("> ." + ($mdgriffith$elm_ui$Internal$Style$classes.jn + (", ." + (name + (" ." + ($mdgriffith$elm_ui$Internal$Style$classes.oF + (" > ." + $mdgriffith$elm_ui$Internal$Style$classes.jn)))))))))), _List_fromArray([
                _Utils_Tuple2("vertical-align", "0"),
                _Utils_Tuple2("line-height", "1")
            ]))
        ]));
    }, $mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule = F2($mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule_fn);
    var $mdgriffith$elm_ui$Internal$Model$adjust_fn = function (size, height, vertical) {
        return (new $$Record112(height / size, size, vertical));
    }, $mdgriffith$elm_ui$Internal$Model$adjust = F3($mdgriffith$elm_ui$Internal$Model$adjust_fn);
    var $elm$core$List$maximum = function (list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just($elm$core$List$foldl_fn($elm$core$Basics$max, x, xs));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $elm$core$List$minimum = function (list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just($elm$core$List$foldl_fn($elm$core$Basics$min, x, xs));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$convertAdjustment = function (adjustment) {
        var lines = _List_fromArray([adjustment.kD, adjustment.kk, adjustment.lj, adjustment.mO]);
        var lineHeight = 1.5;
        var normalDescender = (lineHeight - 1) / 2;
        var oldMiddle = lineHeight / 2;
        var descender = $elm$core$Maybe$withDefault_fn(adjustment.lj, $elm$core$List$minimum(lines));
        var newBaseline = $elm$core$Maybe$withDefault_fn(adjustment.kk, $elm$core$List$minimum($elm$core$List$filter_fn(function (x) {
            return !_Utils_eq(x, descender);
        }, lines)));
        var base = lineHeight;
        var ascender = $elm$core$Maybe$withDefault_fn(adjustment.kD, $elm$core$List$maximum(lines));
        var capitalSize = 1 / (ascender - newBaseline);
        var capitalVertical = 1 - ascender;
        var fullSize = 1 / (ascender - descender);
        var fullVertical = 1 - ascender;
        var newCapitalMiddle = ((ascender - newBaseline) / 2) + newBaseline;
        var newFullMiddle = ((ascender - descender) / 2) + descender;
        return {
            kD: $mdgriffith$elm_ui$Internal$Model$adjust_fn(capitalSize, ascender - newBaseline, capitalVertical),
            hz: $mdgriffith$elm_ui$Internal$Model$adjust_fn(fullSize, ascender - descender, fullVertical)
        };
    };
    var $mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules = function (converted) {
        return _Utils_Tuple2(_List_fromArray([
            _Utils_Tuple2("display", "block")
        ]), _List_fromArray([
            _Utils_Tuple2("display", "inline-block"),
            _Utils_Tuple2("line-height", $elm$core$String$fromFloat(converted.fo)),
            _Utils_Tuple2("vertical-align", $elm$core$String$fromFloat(converted.jF) + "em"),
            _Utils_Tuple2("font-size", $elm$core$String$fromFloat(converted.oE) + "em")
        ]));
    };
    var $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment = function (typefaces) {
        return $elm$core$List$foldl_fn_unwrapped(function (face, found) {
            if (found.$ === 1) {
                if (face.$ === 5) {
                    var _with = face.a;
                    var _v2 = _with.jW;
                    if (_v2.$ === 1) {
                        return found;
                    }
                    else {
                        var adjustment = _v2.a;
                        return $elm$core$Maybe$Just(_Utils_Tuple2($mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(function ($) {
                            return $.hz;
                        }($mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment))), $mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(function ($) {
                            return $.kD;
                        }($mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment)))));
                    }
                }
                else {
                    return found;
                }
            }
            else {
                return found;
            }
        }, $elm$core$Maybe$Nothing, typefaces);
    };
    var $mdgriffith$elm_ui$Internal$Model$renderTopLevelValues = function (rules) {
        var withImport = function (font) {
            if (font.$ === 4) {
                var url = font.b;
                return $elm$core$Maybe$Just("@import url('" + (url + "');"));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        };
        var fontImports = function (_v2) {
            var name = _v2.a;
            var typefaces = _v2.b;
            var imports = $elm$core$String$join_fn("\n", $elm$core$List$filterMap_fn(withImport, typefaces));
            return imports;
        };
        var allNames = $elm$core$List$map_fn($elm$core$Tuple$first, rules);
        var fontAdjustments = function (_v1) {
            var name = _v1.a;
            var typefaces = _v1.b;
            var _v0 = $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment(typefaces);
            if (_v0.$ === 1) {
                return $elm$core$String$join_fn("", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule(name), allNames));
            }
            else {
                var adjustment = _v0.a;
                return $elm$core$String$join_fn("", $elm$core$List$map_fn(A2($mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule, name, adjustment), allNames));
            }
        };
        return _Utils_ap($elm$core$String$join_fn("\n", $elm$core$List$map_fn(fontImports, rules)), $elm$core$String$join_fn("\n", $elm$core$List$map_fn(fontAdjustments, rules)));
    };
    var $mdgriffith$elm_ui$Internal$Model$topLevelValue = function (rule) {
        if (rule.$ === 1) {
            var name = rule.a;
            var typefaces = rule.b;
            return $elm$core$Maybe$Just(_Utils_Tuple2(name, typefaces));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$toStyleSheetString_fn = function (options, stylesheet) {
        var combine = F2(function (style, rendered) {
            return {
                ey: _Utils_ap(rendered.ey, $mdgriffith$elm_ui$Internal$Model$renderStyleRule_fn(options, style, $elm$core$Maybe$Nothing)),
                dm: function () {
                    var _v1 = $mdgriffith$elm_ui$Internal$Model$topLevelValue(style);
                    if (_v1.$ === 1) {
                        return rendered.dm;
                    }
                    else {
                        var topLevel = _v1.a;
                        return _List_Cons(topLevel, rendered.dm);
                    }
                }()
            };
        });
        var _v0 = $elm$core$List$foldl_fn(combine, { ey: _List_Nil, dm: _List_Nil }, stylesheet);
        var topLevel = _v0.dm;
        var rules = _v0.ey;
        return _Utils_ap($mdgriffith$elm_ui$Internal$Model$renderTopLevelValues(topLevel), $elm$core$String$concat(rules));
    }, $mdgriffith$elm_ui$Internal$Model$toStyleSheetString = F2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString_fn);
    var $mdgriffith$elm_ui$Internal$Model$toStyleSheet_fn = function (options, styleSheet) {
        var _v0 = options.m7;
        switch (_v0) {
            case 0:
                return A3($elm$virtual_dom$VirtualDom$node, "div", _List_Nil, _List_fromArray([
                    A3($elm$virtual_dom$VirtualDom$node, "style", _List_Nil, _List_fromArray([
                        $elm$virtual_dom$VirtualDom$text($mdgriffith$elm_ui$Internal$Model$toStyleSheetString_fn(options, styleSheet))
                    ]))
                ]));
            case 1:
                return A3($elm$virtual_dom$VirtualDom$node, "div", _List_Nil, _List_fromArray([
                    A3($elm$virtual_dom$VirtualDom$node, "style", _List_Nil, _List_fromArray([
                        $elm$virtual_dom$VirtualDom$text($mdgriffith$elm_ui$Internal$Model$toStyleSheetString_fn(options, styleSheet))
                    ]))
                ]));
            default:
                return A3($elm$virtual_dom$VirtualDom$node, "elm-ui-rules", _List_fromArray([
                    $elm$virtual_dom$VirtualDom$property_fn("rules", $mdgriffith$elm_ui$Internal$Model$encodeStyles_fn(options, styleSheet))
                ]), _List_Nil);
        }
    }, $mdgriffith$elm_ui$Internal$Model$toStyleSheet = F2($mdgriffith$elm_ui$Internal$Model$toStyleSheet_fn);
    var $mdgriffith$elm_ui$Internal$Model$embedKeyed_fn = function (_static, opts, styles, children) {
        var dynamicStyleSheet = $mdgriffith$elm_ui$Internal$Model$toStyleSheet_fn(opts, $elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$reduceStyles, _Utils_Tuple2($elm$core$Set$empty, $mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.lK)), styles).b);
        return _static ? _List_Cons(_Utils_Tuple2("static-stylesheet", $mdgriffith$elm_ui$Internal$Model$staticRoot(opts)), _List_Cons(_Utils_Tuple2("dynamic-stylesheet", dynamicStyleSheet), children)) : _List_Cons(_Utils_Tuple2("dynamic-stylesheet", dynamicStyleSheet), children);
    }, $mdgriffith$elm_ui$Internal$Model$embedKeyed = F4($mdgriffith$elm_ui$Internal$Model$embedKeyed_fn);
    var $mdgriffith$elm_ui$Internal$Model$embedWith_fn = function (_static, opts, styles, children) {
        var dynamicStyleSheet = $mdgriffith$elm_ui$Internal$Model$toStyleSheet_fn(opts, $elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$reduceStyles, _Utils_Tuple2($elm$core$Set$empty, $mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.lK)), styles).b);
        return _static ? _List_Cons($mdgriffith$elm_ui$Internal$Model$staticRoot(opts), _List_Cons(dynamicStyleSheet, children)) : _List_Cons(dynamicStyleSheet, children);
    }, $mdgriffith$elm_ui$Internal$Model$embedWith = F4($mdgriffith$elm_ui$Internal$Model$embedWith_fn);
    var $mdgriffith$elm_ui$Internal$Flag$heightBetween = $mdgriffith$elm_ui$Internal$Flag$flag(45);
    var $mdgriffith$elm_ui$Internal$Flag$heightFill = $mdgriffith$elm_ui$Internal$Flag$flag(37);
    var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
        return _VirtualDom_keyedNodeNS_fn(_VirtualDom_keyedNode_a0, _VirtualDom_noScript(tag));
    };
    var $elm$html$Html$p = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "p"), $elm$html$Html$p_fn = $elm$html$Html$p.a2;
    var $mdgriffith$elm_ui$Internal$Flag$present_fn = function (myFlag, _v0) {
        var fieldOne = _v0.a;
        var fieldTwo = _v0.b;
        if (!myFlag.$) {
            var first = myFlag.a;
            return _Utils_eq(first & fieldOne, first);
        }
        else {
            var second = myFlag.a;
            return _Utils_eq(second & fieldTwo, second);
        }
    }, $mdgriffith$elm_ui$Internal$Flag$present = F2($mdgriffith$elm_ui$Internal$Flag$present_fn);
    var $elm$html$Html$s = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "s"), $elm$html$Html$s_fn = $elm$html$Html$s.a2;
    var $elm$html$Html$u = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "u"), $elm$html$Html$u_fn = $elm$html$Html$u.a2;
    var $mdgriffith$elm_ui$Internal$Flag$widthBetween = $mdgriffith$elm_ui$Internal$Flag$flag(44);
    var $mdgriffith$elm_ui$Internal$Flag$widthFill = $mdgriffith$elm_ui$Internal$Flag$flag(39);
    var $mdgriffith$elm_ui$Internal$Model$finalizeNode_fn = function (has, node, attributes, children, embedMode, parentContext) {
        var createNode = F2(function (nodeName, attrs) {
            if (children.$ === 1) {
                var keyed = children.a;
                return A3($elm$virtual_dom$VirtualDom$keyedNode, nodeName, attrs, function () {
                    switch (embedMode.$) {
                        case 0:
                            return keyed;
                        case 2:
                            var opts = embedMode.a;
                            var styles = embedMode.b;
                            return $mdgriffith$elm_ui$Internal$Model$embedKeyed_fn(false, opts, styles, keyed);
                        default:
                            var opts = embedMode.a;
                            var styles = embedMode.b;
                            return $mdgriffith$elm_ui$Internal$Model$embedKeyed_fn(true, opts, styles, keyed);
                    }
                }());
            }
            else {
                var unkeyed = children.a;
                return A2(function () {
                    switch (nodeName) {
                        case "div":
                            return $elm$html$Html$div;
                        case "p":
                            return $elm$html$Html$p;
                        default:
                            return $elm$virtual_dom$VirtualDom$node(nodeName);
                    }
                }(), attrs, function () {
                    switch (embedMode.$) {
                        case 0:
                            return unkeyed;
                        case 2:
                            var opts = embedMode.a;
                            var styles = embedMode.b;
                            return $mdgriffith$elm_ui$Internal$Model$embedWith_fn(false, opts, styles, unkeyed);
                        default:
                            var opts = embedMode.a;
                            var styles = embedMode.b;
                            return $mdgriffith$elm_ui$Internal$Model$embedWith_fn(true, opts, styles, unkeyed);
                    }
                }());
            }
        });
        var html = function () {
            switch (node.$) {
                case 0:
                    return A2(createNode, "div", attributes);
                case 1:
                    var nodeName = node.a;
                    return A2(createNode, nodeName, attributes);
                default:
                    var nodeName = node.a;
                    var internal = node.b;
                    return A3($elm$virtual_dom$VirtualDom$node, nodeName, attributes, _List_fromArray([
                        A2(createNode, internal, _List_fromArray([
                            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $mdgriffith$elm_ui$Internal$Style$classes.j7 + (" " + $mdgriffith$elm_ui$Internal$Style$classes.oC))
                        ]))
                    ]));
            }
        }();
        switch (parentContext) {
            case 0:
                return ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$widthFill, has) && (!$mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$widthBetween, has))) ? html : ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$alignRight, has) ? $elm$html$Html$u_fn(_List_fromArray([
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.j7, $mdgriffith$elm_ui$Internal$Style$classes.oC, $mdgriffith$elm_ui$Internal$Style$classes.dN, $mdgriffith$elm_ui$Internal$Style$classes.aD, $mdgriffith$elm_ui$Internal$Style$classes.j1])))
                ]), _List_fromArray([html])) : ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$centerX, has) ? $elm$html$Html$s_fn(_List_fromArray([
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.j7, $mdgriffith$elm_ui$Internal$Style$classes.oC, $mdgriffith$elm_ui$Internal$Style$classes.dN, $mdgriffith$elm_ui$Internal$Style$classes.aD, $mdgriffith$elm_ui$Internal$Style$classes.j$])))
                ]), _List_fromArray([html])) : html));
            case 1:
                return ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$heightFill, has) && (!$mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$heightBetween, has))) ? html : ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$centerY, has) ? $elm$html$Html$s_fn(_List_fromArray([
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.j7, $mdgriffith$elm_ui$Internal$Style$classes.oC, $mdgriffith$elm_ui$Internal$Style$classes.dN, $mdgriffith$elm_ui$Internal$Style$classes.j0])))
                ]), _List_fromArray([html])) : ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$alignBottom, has) ? $elm$html$Html$u_fn(_List_fromArray([
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.j7, $mdgriffith$elm_ui$Internal$Style$classes.oC, $mdgriffith$elm_ui$Internal$Style$classes.dN, $mdgriffith$elm_ui$Internal$Style$classes.j_])))
                ]), _List_fromArray([html])) : html));
            default:
                return html;
        }
    }, $mdgriffith$elm_ui$Internal$Model$finalizeNode = F6($mdgriffith$elm_ui$Internal$Model$finalizeNode_fn);
    var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
    var $mdgriffith$elm_ui$Internal$Model$textElementClasses = $mdgriffith$elm_ui$Internal$Style$classes.j7 + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.jn + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.gs + (" " + $mdgriffith$elm_ui$Internal$Style$classes.fp)))));
    var $mdgriffith$elm_ui$Internal$Model$textElement = function (str) {
        return $elm$html$Html$div_fn(_List_fromArray([
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $mdgriffith$elm_ui$Internal$Model$textElementClasses)
        ]), _List_fromArray([
            $elm$html$Html$text(str)
        ]));
    };
    var $mdgriffith$elm_ui$Internal$Model$textElementFillClasses = $mdgriffith$elm_ui$Internal$Style$classes.j7 + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.jn + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.gt + (" " + $mdgriffith$elm_ui$Internal$Style$classes.fq)))));
    var $mdgriffith$elm_ui$Internal$Model$textElementFill = function (str) {
        return $elm$html$Html$div_fn(_List_fromArray([
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $mdgriffith$elm_ui$Internal$Model$textElementFillClasses)
        ]), _List_fromArray([
            $elm$html$Html$text(str)
        ]));
    };
    var $mdgriffith$elm_ui$Internal$Model$createElement_fn = function (context, children, rendered) {
        var gatherKeyed = F2(function (_v8, _v9) {
            var key = _v8.a;
            var child = _v8.b;
            var htmls = _v9.a;
            var existingStyles = _v9.b;
            switch (child.$) {
                case 0:
                    var html = child.a;
                    return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, html(context)), htmls), existingStyles) : _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, html(context)), htmls), existingStyles);
                case 1:
                    var styled = child.a;
                    return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, A2(styled.l3, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)), htmls), $elm$core$List$isEmpty(existingStyles) ? styled.ji : _Utils_ap(styled.ji, existingStyles)) : _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, A2(styled.l3, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)), htmls), $elm$core$List$isEmpty(existingStyles) ? styled.ji : _Utils_ap(styled.ji, existingStyles));
                case 2:
                    var str = child.a;
                    return _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str)), htmls), existingStyles);
                default:
                    return _Utils_Tuple2(htmls, existingStyles);
            }
        });
        var gather = F2(function (child, _v6) {
            var htmls = _v6.a;
            var existingStyles = _v6.b;
            switch (child.$) {
                case 0:
                    var html = child.a;
                    return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(_List_Cons(html(context), htmls), existingStyles) : _Utils_Tuple2(_List_Cons(html(context), htmls), existingStyles);
                case 1:
                    var styled = child.a;
                    return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(_List_Cons(A2(styled.l3, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context), htmls), $elm$core$List$isEmpty(existingStyles) ? styled.ji : _Utils_ap(styled.ji, existingStyles)) : _Utils_Tuple2(_List_Cons(A2(styled.l3, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context), htmls), $elm$core$List$isEmpty(existingStyles) ? styled.ji : _Utils_ap(styled.ji, existingStyles));
                case 2:
                    var str = child.a;
                    return _Utils_Tuple2(_List_Cons(_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str), htmls), existingStyles);
                default:
                    return _Utils_Tuple2(htmls, existingStyles);
            }
        });
        if (children.$ === 1) {
            var keyedChildren = children.a;
            var _v1 = $elm$core$List$foldr_fn(gatherKeyed, _Utils_Tuple2(_List_Nil, _List_Nil), keyedChildren);
            var keyed = _v1.a;
            var styles = _v1.b;
            var newStyles = $elm$core$List$isEmpty(styles) ? rendered.ji : _Utils_ap(rendered.ji, styles);
            if (!newStyles.b) {
                return $mdgriffith$elm_ui$Internal$Model$Unstyled(A5($mdgriffith$elm_ui$Internal$Model$finalizeNode, rendered.bu, rendered.io, rendered.bk, $mdgriffith$elm_ui$Internal$Model$Keyed($mdgriffith$elm_ui$Internal$Model$addKeyedChildren_fn("nearby-element-pls", keyed, rendered.kI)), $mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
            }
            else {
                var allStyles = newStyles;
                return $mdgriffith$elm_ui$Internal$Model$Styled({
                    l3: A4($mdgriffith$elm_ui$Internal$Model$finalizeNode, rendered.bu, rendered.io, rendered.bk, $mdgriffith$elm_ui$Internal$Model$Keyed($mdgriffith$elm_ui$Internal$Model$addKeyedChildren_fn("nearby-element-pls", keyed, rendered.kI))),
                    ji: allStyles
                });
            }
        }
        else {
            var unkeyedChildren = children.a;
            var _v3 = $elm$core$List$foldr_fn(gather, _Utils_Tuple2(_List_Nil, _List_Nil), unkeyedChildren);
            var unkeyed = _v3.a;
            var styles = _v3.b;
            var newStyles = $elm$core$List$isEmpty(styles) ? rendered.ji : _Utils_ap(rendered.ji, styles);
            if (!newStyles.b) {
                return $mdgriffith$elm_ui$Internal$Model$Unstyled(A5($mdgriffith$elm_ui$Internal$Model$finalizeNode, rendered.bu, rendered.io, rendered.bk, $mdgriffith$elm_ui$Internal$Model$Unkeyed($mdgriffith$elm_ui$Internal$Model$addChildren_fn(unkeyed, rendered.kI)), $mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
            }
            else {
                var allStyles = newStyles;
                return $mdgriffith$elm_ui$Internal$Model$Styled({
                    l3: A4($mdgriffith$elm_ui$Internal$Model$finalizeNode, rendered.bu, rendered.io, rendered.bk, $mdgriffith$elm_ui$Internal$Model$Unkeyed($mdgriffith$elm_ui$Internal$Model$addChildren_fn(unkeyed, rendered.kI))),
                    ji: allStyles
                });
            }
        }
    }, $mdgriffith$elm_ui$Internal$Model$createElement = F3($mdgriffith$elm_ui$Internal$Model$createElement_fn);
    var $mdgriffith$elm_ui$Internal$Model$Single_fn = function (a, b, c) {
        return { $: 3, a: a, b: b, c: c };
    }, $mdgriffith$elm_ui$Internal$Model$Single = F3($mdgriffith$elm_ui$Internal$Model$Single_fn);
    var $mdgriffith$elm_ui$Internal$Model$Transform = function (a) {
        return { $: 10, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Flag$Field_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Flag$Field = F2($mdgriffith$elm_ui$Internal$Flag$Field_fn);
    var $mdgriffith$elm_ui$Internal$Flag$add_fn = function (myFlag, _v0) {
        var one = _v0.a;
        var two = _v0.b;
        if (!myFlag.$) {
            var first = myFlag.a;
            return $mdgriffith$elm_ui$Internal$Flag$Field_fn(first | one, two);
        }
        else {
            var second = myFlag.a;
            return $mdgriffith$elm_ui$Internal$Flag$Field_fn(one, second | two);
        }
    }, $mdgriffith$elm_ui$Internal$Flag$add = F2($mdgriffith$elm_ui$Internal$Flag$add_fn);
    var $mdgriffith$elm_ui$Internal$Model$ChildrenBehind = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront = F2($mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront_fn);
    var $mdgriffith$elm_ui$Internal$Model$ChildrenInFront = function (a) {
        return { $: 2, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$nearbyElement_fn = function (location, elem) {
        return $elm$html$Html$div_fn(_List_fromArray([
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, function () {
                switch (location) {
                    case 0:
                        return $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.cl, $mdgriffith$elm_ui$Internal$Style$classes.oC, $mdgriffith$elm_ui$Internal$Style$classes.jP]));
                    case 1:
                        return $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.cl, $mdgriffith$elm_ui$Internal$Style$classes.oC, $mdgriffith$elm_ui$Internal$Style$classes.km]));
                    case 2:
                        return $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.cl, $mdgriffith$elm_ui$Internal$Style$classes.oC, $mdgriffith$elm_ui$Internal$Style$classes.nA]));
                    case 3:
                        return $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.cl, $mdgriffith$elm_ui$Internal$Style$classes.oC, $mdgriffith$elm_ui$Internal$Style$classes.ny]));
                    case 4:
                        return $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.cl, $mdgriffith$elm_ui$Internal$Style$classes.oC, $mdgriffith$elm_ui$Internal$Style$classes.mc]));
                    default:
                        return $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.cl, $mdgriffith$elm_ui$Internal$Style$classes.oC, $mdgriffith$elm_ui$Internal$Style$classes.kl]));
                }
            }())
        ]), _List_fromArray([
            function () {
                switch (elem.$) {
                    case 3:
                        return $elm$virtual_dom$VirtualDom$text("");
                    case 2:
                        var str = elem.a;
                        return $mdgriffith$elm_ui$Internal$Model$textElement(str);
                    case 0:
                        var html = elem.a;
                        return html($mdgriffith$elm_ui$Internal$Model$asEl);
                    default:
                        var styled = elem.a;
                        return A2(styled.l3, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, $mdgriffith$elm_ui$Internal$Model$asEl);
                }
            }()
        ]));
    }, $mdgriffith$elm_ui$Internal$Model$nearbyElement = F2($mdgriffith$elm_ui$Internal$Model$nearbyElement_fn);
    var $mdgriffith$elm_ui$Internal$Model$addNearbyElement_fn = function (location, elem, existing) {
        var nearby = $mdgriffith$elm_ui$Internal$Model$nearbyElement_fn(location, elem);
        switch (existing.$) {
            case 0:
                if (location === 5) {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(_List_fromArray([nearby]));
                }
                else {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(_List_fromArray([nearby]));
                }
            case 1:
                var existingBehind = existing.a;
                if (location === 5) {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(_List_Cons(nearby, existingBehind));
                }
                else {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront_fn(existingBehind, _List_fromArray([nearby]));
                }
            case 2:
                var existingInFront = existing.a;
                if (location === 5) {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront_fn(_List_fromArray([nearby]), existingInFront);
                }
                else {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(_List_Cons(nearby, existingInFront));
                }
            default:
                var existingBehind = existing.a;
                var existingInFront = existing.b;
                if (location === 5) {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront_fn(_List_Cons(nearby, existingBehind), existingInFront);
                }
                else {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront_fn(existingBehind, _List_Cons(nearby, existingInFront));
                }
        }
    }, $mdgriffith$elm_ui$Internal$Model$addNearbyElement = F3($mdgriffith$elm_ui$Internal$Model$addNearbyElement_fn);
    var $mdgriffith$elm_ui$Internal$Model$Embedded_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Embedded = F2($mdgriffith$elm_ui$Internal$Model$Embedded_fn);
    var $mdgriffith$elm_ui$Internal$Model$NodeName = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$addNodeName_fn = function (newNode, old) {
        switch (old.$) {
            case 0:
                return $mdgriffith$elm_ui$Internal$Model$NodeName(newNode);
            case 1:
                var name = old.a;
                return $mdgriffith$elm_ui$Internal$Model$Embedded_fn(name, newNode);
            default:
                var x = old.a;
                var y = old.b;
                return $mdgriffith$elm_ui$Internal$Model$Embedded_fn(x, y);
        }
    }, $mdgriffith$elm_ui$Internal$Model$addNodeName = F2($mdgriffith$elm_ui$Internal$Model$addNodeName_fn);
    var $mdgriffith$elm_ui$Internal$Model$alignXName = function (align) {
        switch (align) {
            case 0:
                return $mdgriffith$elm_ui$Internal$Style$classes.eZ + (" " + $mdgriffith$elm_ui$Internal$Style$classes.gD);
            case 2:
                return $mdgriffith$elm_ui$Internal$Style$classes.eZ + (" " + $mdgriffith$elm_ui$Internal$Style$classes.gE);
            default:
                return $mdgriffith$elm_ui$Internal$Style$classes.eZ + (" " + $mdgriffith$elm_ui$Internal$Style$classes.jY);
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$alignYName = function (align) {
        switch (align) {
            case 0:
                return $mdgriffith$elm_ui$Internal$Style$classes.e_ + (" " + $mdgriffith$elm_ui$Internal$Style$classes.j3);
            case 2:
                return $mdgriffith$elm_ui$Internal$Style$classes.e_ + (" " + $mdgriffith$elm_ui$Internal$Style$classes.jX);
            default:
                return $mdgriffith$elm_ui$Internal$Style$classes.e_ + (" " + $mdgriffith$elm_ui$Internal$Style$classes.jZ);
        }
    };
    var $elm$virtual_dom$VirtualDom$attribute_fn = function (key, value) {
        return _VirtualDom_attribute_fn(_VirtualDom_noOnOrFormAction(key), _VirtualDom_noJavaScriptOrHtmlUri(value));
    }, $elm$virtual_dom$VirtualDom$attribute = F2($elm$virtual_dom$VirtualDom$attribute_fn);
    var $mdgriffith$elm_ui$Internal$Model$FullTransform_fn = function (a, b, c, d) {
        return { $: 2, a: a, b: b, c: c, d: d };
    }, $mdgriffith$elm_ui$Internal$Model$FullTransform = F4($mdgriffith$elm_ui$Internal$Model$FullTransform_fn);
    var $mdgriffith$elm_ui$Internal$Model$Moved = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$composeTransformation_fn = function (transform, component) {
        switch (transform.$) {
            case 0:
                switch (component.$) {
                    case 0:
                        var x = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(_Utils_Tuple3(x, 0, 0));
                    case 1:
                        var y = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(_Utils_Tuple3(0, y, 0));
                    case 2:
                        var z = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(_Utils_Tuple3(0, 0, z));
                    case 3:
                        var xyz = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
                    case 4:
                        var xyz = component.a;
                        var angle = component.b;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(_Utils_Tuple3(0, 0, 0), _Utils_Tuple3(1, 1, 1), xyz, angle);
                    default:
                        var xyz = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(_Utils_Tuple3(0, 0, 0), xyz, _Utils_Tuple3(0, 0, 1), 0);
                }
            case 1:
                var moved = transform.a;
                var x = moved.a;
                var y = moved.b;
                var z = moved.c;
                switch (component.$) {
                    case 0:
                        var newX = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(_Utils_Tuple3(newX, y, z));
                    case 1:
                        var newY = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(_Utils_Tuple3(x, newY, z));
                    case 2:
                        var newZ = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(_Utils_Tuple3(x, y, newZ));
                    case 3:
                        var xyz = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
                    case 4:
                        var xyz = component.a;
                        var angle = component.b;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(moved, _Utils_Tuple3(1, 1, 1), xyz, angle);
                    default:
                        var scale = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(moved, scale, _Utils_Tuple3(0, 0, 1), 0);
                }
            default:
                var moved = transform.a;
                var x = moved.a;
                var y = moved.b;
                var z = moved.c;
                var scaled = transform.b;
                var origin = transform.c;
                var angle = transform.d;
                switch (component.$) {
                    case 0:
                        var newX = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(_Utils_Tuple3(newX, y, z), scaled, origin, angle);
                    case 1:
                        var newY = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(_Utils_Tuple3(x, newY, z), scaled, origin, angle);
                    case 2:
                        var newZ = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(_Utils_Tuple3(x, y, newZ), scaled, origin, angle);
                    case 3:
                        var newMove = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(newMove, scaled, origin, angle);
                    case 4:
                        var newOrigin = component.a;
                        var newAngle = component.b;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(moved, scaled, newOrigin, newAngle);
                    default:
                        var newScale = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(moved, newScale, origin, angle);
                }
        }
    }, $mdgriffith$elm_ui$Internal$Model$composeTransformation = F2($mdgriffith$elm_ui$Internal$Model$composeTransformation_fn);
    var $mdgriffith$elm_ui$Internal$Flag$height = $mdgriffith$elm_ui$Internal$Flag$flag(7);
    var $mdgriffith$elm_ui$Internal$Flag$heightContent = $mdgriffith$elm_ui$Internal$Flag$flag(36);
    var $mdgriffith$elm_ui$Internal$Flag$merge_fn = function (_v0, _v1) {
        var one = _v0.a;
        var two = _v0.b;
        var three = _v1.a;
        var four = _v1.b;
        return $mdgriffith$elm_ui$Internal$Flag$Field_fn(one | three, two | four);
    }, $mdgriffith$elm_ui$Internal$Flag$merge = F2($mdgriffith$elm_ui$Internal$Flag$merge_fn);
    var $mdgriffith$elm_ui$Internal$Flag$none = $mdgriffith$elm_ui$Internal$Flag$Field_fn(0, 0);
    var $mdgriffith$elm_ui$Internal$Model$renderHeight = function (h) {
        switch (h.$) {
            case 0:
                var px = h.a;
                var val = $elm$core$String$fromInt(px);
                var name = "height-px-" + val;
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$none, $mdgriffith$elm_ui$Internal$Style$classes.hH + (" " + name), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Single_fn(name, "height", val + "px")
                ]));
            case 1:
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightContent, $mdgriffith$elm_ui$Internal$Flag$none), $mdgriffith$elm_ui$Internal$Style$classes.fp, _List_Nil);
            case 2:
                var portion = h.a;
                return (portion === 1) ? _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none), $mdgriffith$elm_ui$Internal$Style$classes.fq, _List_Nil) : _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none), $mdgriffith$elm_ui$Internal$Style$classes.hI + (" height-fill-" + $elm$core$String$fromInt(portion)), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Single_fn($mdgriffith$elm_ui$Internal$Style$classes.j7 + ("." + ($mdgriffith$elm_ui$Internal$Style$classes.aC + (" > " + $mdgriffith$elm_ui$Internal$Style$dot("height-fill-" + $elm$core$String$fromInt(portion))))), "flex-grow", $elm$core$String$fromInt(portion * 100000))
                ]));
            case 3:
                var minSize = h.a;
                var len = h.b;
                var cls = "min-height-" + $elm$core$String$fromInt(minSize);
                var style = $mdgriffith$elm_ui$Internal$Model$Single_fn(cls, "min-height", $elm$core$String$fromInt(minSize) + "px");
                var _v1 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
                var newFlag = _v1.a;
                var newAttrs = _v1.b;
                var newStyle = _v1.c;
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag), cls + (" " + newAttrs), _List_Cons(style, newStyle));
            default:
                var maxSize = h.a;
                var len = h.b;
                var cls = "max-height-" + $elm$core$String$fromInt(maxSize);
                var style = $mdgriffith$elm_ui$Internal$Model$Single_fn(cls, "max-height", $elm$core$String$fromInt(maxSize) + "px");
                var _v2 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
                var newFlag = _v2.a;
                var newAttrs = _v2.b;
                var newStyle = _v2.c;
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag), cls + (" " + newAttrs), _List_Cons(style, newStyle));
        }
    };
    var $mdgriffith$elm_ui$Internal$Flag$widthContent = $mdgriffith$elm_ui$Internal$Flag$flag(38);
    var $mdgriffith$elm_ui$Internal$Model$renderWidth = function (w) {
        switch (w.$) {
            case 0:
                var px = w.a;
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$none, $mdgriffith$elm_ui$Internal$Style$classes.jK + (" width-px-" + $elm$core$String$fromInt(px)), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Single_fn("width-px-" + $elm$core$String$fromInt(px), "width", $elm$core$String$fromInt(px) + "px")
                ]));
            case 1:
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthContent, $mdgriffith$elm_ui$Internal$Flag$none), $mdgriffith$elm_ui$Internal$Style$classes.gs, _List_Nil);
            case 2:
                var portion = w.a;
                return (portion === 1) ? _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none), $mdgriffith$elm_ui$Internal$Style$classes.gt, _List_Nil) : _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none), $mdgriffith$elm_ui$Internal$Style$classes.jL + (" width-fill-" + $elm$core$String$fromInt(portion)), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Single_fn($mdgriffith$elm_ui$Internal$Style$classes.j7 + ("." + ($mdgriffith$elm_ui$Internal$Style$classes.of + (" > " + $mdgriffith$elm_ui$Internal$Style$dot("width-fill-" + $elm$core$String$fromInt(portion))))), "flex-grow", $elm$core$String$fromInt(portion * 100000))
                ]));
            case 3:
                var minSize = w.a;
                var len = w.b;
                var cls = "min-width-" + $elm$core$String$fromInt(minSize);
                var style = $mdgriffith$elm_ui$Internal$Model$Single_fn(cls, "min-width", $elm$core$String$fromInt(minSize) + "px");
                var _v1 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
                var newFlag = _v1.a;
                var newAttrs = _v1.b;
                var newStyle = _v1.c;
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag), cls + (" " + newAttrs), _List_Cons(style, newStyle));
            default:
                var maxSize = w.a;
                var len = w.b;
                var cls = "max-width-" + $elm$core$String$fromInt(maxSize);
                var style = $mdgriffith$elm_ui$Internal$Model$Single_fn(cls, "max-width", $elm$core$String$fromInt(maxSize) + "px");
                var _v2 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
                var newFlag = _v2.a;
                var newAttrs = _v2.b;
                var newStyle = _v2.c;
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag), cls + (" " + newAttrs), _List_Cons(style, newStyle));
        }
    };
    var $mdgriffith$elm_ui$Internal$Flag$borderWidth = $mdgriffith$elm_ui$Internal$Flag$flag(27);
    var $mdgriffith$elm_ui$Internal$Model$skippable_fn = function (flag, style) {
        if (_Utils_eq(flag, $mdgriffith$elm_ui$Internal$Flag$borderWidth)) {
            if (style.$ === 3) {
                var val = style.c;
                switch (val) {
                    case "0px":
                        return true;
                    case "1px":
                        return true;
                    case "2px":
                        return true;
                    case "3px":
                        return true;
                    case "4px":
                        return true;
                    case "5px":
                        return true;
                    case "6px":
                        return true;
                    default:
                        return false;
                }
            }
            else {
                return false;
            }
        }
        else {
            switch (style.$) {
                case 2:
                    var i = style.a;
                    return (i >= 8) && (i <= 32);
                case 7:
                    var name = style.a;
                    var t = style.b;
                    var r = style.c;
                    var b = style.d;
                    var l = style.e;
                    return _Utils_eq(t, b) && (_Utils_eq(t, r) && (_Utils_eq(t, l) && ((t >= 0) && (t <= 24))));
                default:
                    return false;
            }
        }
    }, $mdgriffith$elm_ui$Internal$Model$skippable = F2($mdgriffith$elm_ui$Internal$Model$skippable_fn);
    var $mdgriffith$elm_ui$Internal$Flag$width = $mdgriffith$elm_ui$Internal$Flag$flag(6);
    var $mdgriffith$elm_ui$Internal$Flag$xAlign = $mdgriffith$elm_ui$Internal$Flag$flag(30);
    var $mdgriffith$elm_ui$Internal$Flag$yAlign = $mdgriffith$elm_ui$Internal$Flag$flag(29);
    var $mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive_fn = function (classes, node, has, transform, styles, attrs, children, elementAttrs) {
        gatherAttrRecursive: while (true) {
            if (!elementAttrs.b) {
                var _v1 = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
                if (_v1.$ === 1) {
                    return {
                        bk: _List_Cons($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, classes), attrs),
                        kI: children,
                        bu: has,
                        io: node,
                        ji: styles
                    };
                }
                else {
                    var _class = _v1.a;
                    return {
                        bk: _List_Cons($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, classes + (" " + _class)), attrs),
                        kI: children,
                        bu: has,
                        io: node,
                        ji: _List_Cons($mdgriffith$elm_ui$Internal$Model$Transform(transform), styles)
                    };
                }
            }
            else {
                var attribute = elementAttrs.a;
                var remaining = elementAttrs.b;
                switch (attribute.$) {
                    case 0:
                        var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                        classes = $temp$classes;
                        node = $temp$node;
                        has = $temp$has;
                        transform = $temp$transform;
                        styles = $temp$styles;
                        attrs = $temp$attrs;
                        children = $temp$children;
                        elementAttrs = $temp$elementAttrs;
                        continue gatherAttrRecursive;
                    case 3:
                        var flag = attribute.a;
                        var exactClassName = attribute.b;
                        if ($mdgriffith$elm_ui$Internal$Flag$present_fn(flag, has)) {
                            var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                        else {
                            var $temp$classes = exactClassName + (" " + classes), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn(flag, has), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                    case 1:
                        var actualAttribute = attribute.a;
                        var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = _List_Cons(actualAttribute, attrs), $temp$children = children, $temp$elementAttrs = remaining;
                        classes = $temp$classes;
                        node = $temp$node;
                        has = $temp$has;
                        transform = $temp$transform;
                        styles = $temp$styles;
                        attrs = $temp$attrs;
                        children = $temp$children;
                        elementAttrs = $temp$elementAttrs;
                        continue gatherAttrRecursive;
                    case 4:
                        var flag = attribute.a;
                        var style = attribute.b;
                        if ($mdgriffith$elm_ui$Internal$Flag$present_fn(flag, has)) {
                            var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                        else {
                            if ($mdgriffith$elm_ui$Internal$Model$skippable_fn(flag, style)) {
                                var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (" " + classes), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn(flag, has), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            }
                            else {
                                var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (" " + classes), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn(flag, has), $temp$transform = transform, $temp$styles = _List_Cons(style, styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            }
                        }
                    case 10:
                        var flag = attribute.a;
                        var component = attribute.b;
                        var $temp$classes = classes, $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn(flag, has), $temp$transform = $mdgriffith$elm_ui$Internal$Model$composeTransformation_fn(transform, component), $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                        classes = $temp$classes;
                        node = $temp$node;
                        has = $temp$has;
                        transform = $temp$transform;
                        styles = $temp$styles;
                        attrs = $temp$attrs;
                        children = $temp$children;
                        elementAttrs = $temp$elementAttrs;
                        continue gatherAttrRecursive;
                    case 7:
                        var width = attribute.a;
                        if ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$width, has)) {
                            var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                        else {
                            switch (width.$) {
                                case 0:
                                    var px = width.a;
                                    var $temp$classes = ($mdgriffith$elm_ui$Internal$Style$classes.jK + (" width-px-" + $elm$core$String$fromInt(px))) + (" " + classes), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$width, has), $temp$transform = transform, $temp$styles = _List_Cons($mdgriffith$elm_ui$Internal$Model$Single_fn("width-px-" + $elm$core$String$fromInt(px), "width", $elm$core$String$fromInt(px) + "px"), styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                                case 1:
                                    var $temp$classes = classes + (" " + $mdgriffith$elm_ui$Internal$Style$classes.gs), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthContent, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$width, has)), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                                case 2:
                                    var portion = width.a;
                                    if (portion === 1) {
                                        var $temp$classes = classes + (" " + $mdgriffith$elm_ui$Internal$Style$classes.gt), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$width, has)), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                        classes = $temp$classes;
                                        node = $temp$node;
                                        has = $temp$has;
                                        transform = $temp$transform;
                                        styles = $temp$styles;
                                        attrs = $temp$attrs;
                                        children = $temp$children;
                                        elementAttrs = $temp$elementAttrs;
                                        continue gatherAttrRecursive;
                                    }
                                    else {
                                        var $temp$classes = classes + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.jL + (" width-fill-" + $elm$core$String$fromInt(portion)))), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$width, has)), $temp$transform = transform, $temp$styles = _List_Cons($mdgriffith$elm_ui$Internal$Model$Single_fn($mdgriffith$elm_ui$Internal$Style$classes.j7 + ("." + ($mdgriffith$elm_ui$Internal$Style$classes.of + (" > " + $mdgriffith$elm_ui$Internal$Style$dot("width-fill-" + $elm$core$String$fromInt(portion))))), "flex-grow", $elm$core$String$fromInt(portion * 100000)), styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                        classes = $temp$classes;
                                        node = $temp$node;
                                        has = $temp$has;
                                        transform = $temp$transform;
                                        styles = $temp$styles;
                                        attrs = $temp$attrs;
                                        children = $temp$children;
                                        elementAttrs = $temp$elementAttrs;
                                        continue gatherAttrRecursive;
                                    }
                                default:
                                    var _v4 = $mdgriffith$elm_ui$Internal$Model$renderWidth(width);
                                    var addToFlags = _v4.a;
                                    var newClass = _v4.b;
                                    var newStyles = _v4.c;
                                    var $temp$classes = classes + (" " + newClass), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$merge_fn(addToFlags, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$width, has)), $temp$transform = transform, $temp$styles = _Utils_ap(newStyles, styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                            }
                        }
                    case 8:
                        var height = attribute.a;
                        if ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$height, has)) {
                            var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                        else {
                            switch (height.$) {
                                case 0:
                                    var px = height.a;
                                    var val = $elm$core$String$fromInt(px) + "px";
                                    var name = "height-px-" + val;
                                    var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.hH + (" " + (name + (" " + classes))), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$height, has), $temp$transform = transform, $temp$styles = _List_Cons($mdgriffith$elm_ui$Internal$Model$Single_fn(name, "height ", val), styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                                case 1:
                                    var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.fp + (" " + classes), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightContent, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$height, has)), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                                case 2:
                                    var portion = height.a;
                                    if (portion === 1) {
                                        var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.fq + (" " + classes), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$height, has)), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                        classes = $temp$classes;
                                        node = $temp$node;
                                        has = $temp$has;
                                        transform = $temp$transform;
                                        styles = $temp$styles;
                                        attrs = $temp$attrs;
                                        children = $temp$children;
                                        elementAttrs = $temp$elementAttrs;
                                        continue gatherAttrRecursive;
                                    }
                                    else {
                                        var $temp$classes = classes + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.hI + (" height-fill-" + $elm$core$String$fromInt(portion)))), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$height, has)), $temp$transform = transform, $temp$styles = _List_Cons($mdgriffith$elm_ui$Internal$Model$Single_fn($mdgriffith$elm_ui$Internal$Style$classes.j7 + ("." + ($mdgriffith$elm_ui$Internal$Style$classes.aC + (" > " + $mdgriffith$elm_ui$Internal$Style$dot("height-fill-" + $elm$core$String$fromInt(portion))))), "flex-grow", $elm$core$String$fromInt(portion * 100000)), styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                        classes = $temp$classes;
                                        node = $temp$node;
                                        has = $temp$has;
                                        transform = $temp$transform;
                                        styles = $temp$styles;
                                        attrs = $temp$attrs;
                                        children = $temp$children;
                                        elementAttrs = $temp$elementAttrs;
                                        continue gatherAttrRecursive;
                                    }
                                default:
                                    var _v6 = $mdgriffith$elm_ui$Internal$Model$renderHeight(height);
                                    var addToFlags = _v6.a;
                                    var newClass = _v6.b;
                                    var newStyles = _v6.c;
                                    var $temp$classes = classes + (" " + newClass), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$merge_fn(addToFlags, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$height, has)), $temp$transform = transform, $temp$styles = _Utils_ap(newStyles, styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                            }
                        }
                    case 2:
                        var description = attribute.a;
                        switch (description.$) {
                            case 0:
                                var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("main", node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 1:
                                var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("nav", node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 2:
                                var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("footer", node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 3:
                                var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("aside", node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 4:
                                var i = description.a;
                                if (i <= 1) {
                                    var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("h1", node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                                }
                                else {
                                    if (i < 7) {
                                        var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("h" + $elm$core$String$fromInt(i), node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                        classes = $temp$classes;
                                        node = $temp$node;
                                        has = $temp$has;
                                        transform = $temp$transform;
                                        styles = $temp$styles;
                                        attrs = $temp$attrs;
                                        children = $temp$children;
                                        elementAttrs = $temp$elementAttrs;
                                        continue gatherAttrRecursive;
                                    }
                                    else {
                                        var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("h6", node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                        classes = $temp$classes;
                                        node = $temp$node;
                                        has = $temp$has;
                                        transform = $temp$transform;
                                        styles = $temp$styles;
                                        attrs = $temp$attrs;
                                        children = $temp$children;
                                        elementAttrs = $temp$elementAttrs;
                                        continue gatherAttrRecursive;
                                    }
                                }
                            case 9:
                                var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 8:
                                var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = _List_Cons($elm$virtual_dom$VirtualDom$attribute_fn("role", "button"), attrs), $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 5:
                                var label = description.a;
                                var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = _List_Cons($elm$virtual_dom$VirtualDom$attribute_fn("aria-label", label), attrs), $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 6:
                                var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = _List_Cons($elm$virtual_dom$VirtualDom$attribute_fn("aria-live", "polite"), attrs), $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            default:
                                var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = _List_Cons($elm$virtual_dom$VirtualDom$attribute_fn("aria-live", "assertive"), attrs), $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                        }
                    case 9:
                        var location = attribute.a;
                        var elem = attribute.b;
                        var newStyles = function () {
                            switch (elem.$) {
                                case 3:
                                    return styles;
                                case 2:
                                    var str = elem.a;
                                    return styles;
                                case 0:
                                    var html = elem.a;
                                    return styles;
                                default:
                                    var styled = elem.a;
                                    return _Utils_ap(styles, styled.ji);
                            }
                        }();
                        var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = newStyles, $temp$attrs = attrs, $temp$children = $mdgriffith$elm_ui$Internal$Model$addNearbyElement_fn(location, elem, children), $temp$elementAttrs = remaining;
                        classes = $temp$classes;
                        node = $temp$node;
                        has = $temp$has;
                        transform = $temp$transform;
                        styles = $temp$styles;
                        attrs = $temp$attrs;
                        children = $temp$children;
                        elementAttrs = $temp$elementAttrs;
                        continue gatherAttrRecursive;
                    case 6:
                        var x = attribute.a;
                        if ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$xAlign, has)) {
                            var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                        else {
                            var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignXName(x) + (" " + classes), $temp$node = node, $temp$has = function (flags) {
                                switch (x) {
                                    case 1:
                                        return $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$centerX, flags);
                                    case 2:
                                        return $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$alignRight, flags);
                                    default:
                                        return flags;
                                }
                            }($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$xAlign, has)), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                    default:
                        var y = attribute.a;
                        if ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$yAlign, has)) {
                            var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                        else {
                            var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignYName(y) + (" " + classes), $temp$node = node, $temp$has = function (flags) {
                                switch (y) {
                                    case 1:
                                        return $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$centerY, flags);
                                    case 2:
                                        return $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$alignBottom, flags);
                                    default:
                                        return flags;
                                }
                            }($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$yAlign, has)), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                }
            }
        }
    }, $mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive = F8($mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive_fn);
    var $mdgriffith$elm_ui$Internal$Model$Untransformed = { $: 0 };
    var $mdgriffith$elm_ui$Internal$Model$untransformed = $mdgriffith$elm_ui$Internal$Model$Untransformed;
    var $mdgriffith$elm_ui$Internal$Model$element_fn = function (context, node, attributes, children) {
        return $mdgriffith$elm_ui$Internal$Model$createElement_fn(context, children, $mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive_fn($mdgriffith$elm_ui$Internal$Model$contextClasses(context), node, $mdgriffith$elm_ui$Internal$Flag$none, $mdgriffith$elm_ui$Internal$Model$untransformed, _List_Nil, _List_Nil, $mdgriffith$elm_ui$Internal$Model$NoNearbyChildren, $elm$core$List$reverse(attributes)));
    }, $mdgriffith$elm_ui$Internal$Model$element = F4($mdgriffith$elm_ui$Internal$Model$element_fn);
    var $mdgriffith$elm_ui$Internal$Model$Height = function (a) {
        return { $: 8, a: a };
    };
    var $mdgriffith$elm_ui$Element$height = $mdgriffith$elm_ui$Internal$Model$Height;
    var $mdgriffith$elm_ui$Internal$Model$Content = { $: 1 };
    var $mdgriffith$elm_ui$Element$shrink = $mdgriffith$elm_ui$Internal$Model$Content;
    var $mdgriffith$elm_ui$Internal$Model$Width = function (a) {
        return { $: 7, a: a };
    };
    var $mdgriffith$elm_ui$Element$width = $mdgriffith$elm_ui$Internal$Model$Width;
    var $mdgriffith$elm_ui$Element$el_fn = function (attrs, child) {
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), attrs)), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([child])));
    }, $mdgriffith$elm_ui$Element$el = F2($mdgriffith$elm_ui$Element$el_fn);
    var $mdgriffith$elm_ui$Internal$Model$Attr = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Element$htmlAttribute = $mdgriffith$elm_ui$Internal$Model$Attr;
    var $elm$virtual_dom$VirtualDom$Normal = function (a) {
        return { $: 0, a: a };
    };
    var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
    var $elm$html$Html$Events$on_fn = function (event, decoder) {
        return _VirtualDom_on_fn(event, $elm$virtual_dom$VirtualDom$Normal(decoder));
    }, $elm$html$Html$Events$on = F2($elm$html$Html$Events$on_fn);
    var $author$project$View$URLRequest$eventListener = function (fromUrl) {
        var logFailure = A2($elm$core$Basics$composeR, $author$project$Error$Decoding, A2($elm$core$Basics$composeR, $author$project$Error$error, A2($elm$core$Basics$composeR, $author$project$Model$LogError, $elm$json$Json$Decode$succeed)));
        var urlDecoder = _Json_andThen_fn(function (urlStr) {
            return $elm$core$Maybe$withDefault_fn(logFailure({ lg: "Invalid url " + urlStr, he: "View.URLRequest.eventListener" }), $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $author$project$Model$URLRequest, $elm$json$Json$Decode$succeed), $author$project$View$URLRequest$toBrowserUrlRequest_fn(fromUrl, urlStr)));
        }, $elm$json$Json$Decode$at_fn(_List_fromArray(["detail", "url"]), $elm$json$Json$Decode$string));
        return $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$on_fn("witfulUrlRequest", $elm$json$Json$Decode$oneOf(_List_fromArray([
            urlDecoder,
            logFailure({ lg: "Expected event.detail.url string", he: "View.URLRequest.eventListener" })
        ]))));
    };
    var $mdgriffith$elm_ui$Internal$Flag$fontColor = $mdgriffith$elm_ui$Internal$Flag$flag(14);
    var $mdgriffith$elm_ui$Element$Font$color = function (fontColor) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$fontColor, $mdgriffith$elm_ui$Internal$Model$Colored_fn("fc-" + $mdgriffith$elm_ui$Internal$Model$formatColorClass(fontColor), "color", fontColor));
    };
    var $mdgriffith$elm_ui$Internal$Model$FontFamily_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$FontFamily = F2($mdgriffith$elm_ui$Internal$Model$FontFamily_fn);
    var $mdgriffith$elm_ui$Internal$Flag$fontFamily = $mdgriffith$elm_ui$Internal$Flag$flag(5);
    var $mdgriffith$elm_ui$Internal$Model$renderFontClassName_fn = function (font, current) {
        return _Utils_ap(current, function () {
            switch (font.$) {
                case 0:
                    return "serif";
                case 1:
                    return "sans-serif";
                case 2:
                    return "monospace";
                case 3:
                    var name = font.a;
                    return $elm$core$String$join_fn("-", $elm$core$String$words($elm$core$String$toLower(name)));
                case 4:
                    var name = font.a;
                    var url = font.b;
                    return $elm$core$String$join_fn("-", $elm$core$String$words($elm$core$String$toLower(name)));
                default:
                    var name = font.a.b;
                    return $elm$core$String$join_fn("-", $elm$core$String$words($elm$core$String$toLower(name)));
            }
        }());
    }, $mdgriffith$elm_ui$Internal$Model$renderFontClassName = F2($mdgriffith$elm_ui$Internal$Model$renderFontClassName_fn);
    var $mdgriffith$elm_ui$Element$Font$family = function (families) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$fontFamily, $mdgriffith$elm_ui$Internal$Model$FontFamily_fn($elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderFontClassName, "ff-", families), families));
    };
    var $mdgriffith$elm_ui$Internal$Model$Class_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Class = F2($mdgriffith$elm_ui$Internal$Model$Class_fn);
    var $mdgriffith$elm_ui$Internal$Flag$fontWeight = $mdgriffith$elm_ui$Internal$Flag$flag(13);
    var $mdgriffith$elm_ui$Element$Font$regular = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.pi);
    var $mdgriffith$elm_ui$Internal$Model$SansSerif = { $: 1 };
    var $mdgriffith$elm_ui$Element$Font$sansSerif = $mdgriffith$elm_ui$Internal$Model$SansSerif;
    var $mdgriffith$elm_ui$Internal$Model$FontSize = function (a) {
        return { $: 2, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Flag$fontSize = $mdgriffith$elm_ui$Internal$Flag$flag(4);
    var $mdgriffith$elm_ui$Element$Font$size = function (i) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$fontSize, $mdgriffith$elm_ui$Internal$Model$FontSize(i));
    };
    var $mdgriffith$elm_ui$Internal$Model$Typeface = function (a) {
        return { $: 3, a: a };
    };
    var $mdgriffith$elm_ui$Element$Font$typeface = $mdgriffith$elm_ui$Internal$Model$Typeface;
    var $author$project$View$Styling$global = function (palette) {
        return _List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(14),
            $mdgriffith$elm_ui$Element$Font$color(palette.cd),
            $mdgriffith$elm_ui$Element$Font$regular,
            $mdgriffith$elm_ui$Element$Font$family(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$typeface("Lato"),
                $mdgriffith$elm_ui$Element$Font$sansSerif
            ]))
        ]);
    };
    var $author$project$Page$Person$AllCandidates = { $: 0 };
    var $author$project$Page$Person$MarkAsNotDuplicate_fn = function (a, b) {
        return { $: 11, a: a, b: b };
    }, $author$project$Page$Person$MarkAsNotDuplicate = F2($author$project$Page$Person$MarkAsNotDuplicate_fn);
    var $author$project$Page$Person$SetDialog = function (a) {
        return { $: 10, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$Empty = { $: 3 };
    var $mdgriffith$elm_ui$Element$none = $mdgriffith$elm_ui$Internal$Model$Empty;
    var $mdgriffith$elm_ui$Internal$Model$Px = function (a) {
        return { $: 0, a: a };
    };
    var $mdgriffith$elm_ui$Element$px = $mdgriffith$elm_ui$Internal$Model$Px;
    var $author$project$View$Dialog$BaseDialog$empty_fn = function (noOp, onBackgroundClick) {
        return (new $$Record113($elm$core$Maybe$Nothing, $mdgriffith$elm_ui$Element$none, false, false, $elm$core$Maybe$Nothing, false, $mdgriffith$elm_ui$Element$shrink, noOp, onBackgroundClick, 40, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $mdgriffith$elm_ui$Element$none, $elm$core$Maybe$Nothing, $mdgriffith$elm_ui$Element$px(400)));
    }, $author$project$View$Dialog$BaseDialog$empty = F2($author$project$View$Dialog$BaseDialog$empty_fn);
    var $author$project$Page$Person$closeable = $author$project$View$Dialog$BaseDialog$empty_fn($author$project$Page$Person$NoOp, $elm$core$Maybe$Just($author$project$Page$Person$SetDialog($elm$core$Maybe$Nothing)));
    var $mdgriffith$elm_ui$Internal$Model$AsColumn = 1;
    var $mdgriffith$elm_ui$Internal$Model$asColumn = 1;
    var $mdgriffith$elm_ui$Internal$Model$htmlClass = function (cls) {
        return $mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, cls));
    };
    var $mdgriffith$elm_ui$Element$column_fn = function (attrs, children) {
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asColumn, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.k_ + (" " + $mdgriffith$elm_ui$Internal$Style$classes.cL)), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), attrs))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
    }, $mdgriffith$elm_ui$Element$column = F2($mdgriffith$elm_ui$Element$column_fn);
    var $mdgriffith$elm_ui$Internal$Model$SpacingStyle_fn = function (a, b, c) {
        return { $: 5, a: a, b: b, c: c };
    }, $mdgriffith$elm_ui$Internal$Model$SpacingStyle = F3($mdgriffith$elm_ui$Internal$Model$SpacingStyle_fn);
    var $mdgriffith$elm_ui$Internal$Flag$spacing = $mdgriffith$elm_ui$Internal$Flag$flag(3);
    var $mdgriffith$elm_ui$Internal$Model$spacingName_fn = function (x, y) {
        return "spacing-" + ($elm$core$String$fromInt(x) + ("-" + $elm$core$String$fromInt(y)));
    }, $mdgriffith$elm_ui$Internal$Model$spacingName = F2($mdgriffith$elm_ui$Internal$Model$spacingName_fn);
    var $mdgriffith$elm_ui$Element$spacing = function (x) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$spacing, $mdgriffith$elm_ui$Internal$Model$SpacingStyle_fn($mdgriffith$elm_ui$Internal$Model$spacingName_fn(x, x), x, x));
    };
    var $mdgriffith$elm_ui$Internal$Model$Text = function (a) {
        return { $: 2, a: a };
    };
    var $mdgriffith$elm_ui$Element$text = function (content) {
        return $mdgriffith$elm_ui$Internal$Model$Text(content);
    };
    var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
    var $author$project$View$Util$attribute_fn = function (k, v) {
        return $mdgriffith$elm_ui$Element$htmlAttribute($elm$virtual_dom$VirtualDom$attribute_fn(k, v));
    }, $author$project$View$Util$attribute = F2($author$project$View$Util$attribute_fn);
    var $author$project$View$Util$title_a0 = "title", $author$project$View$Util$title = $author$project$View$Util$attribute($author$project$View$Util$title_a0);
    var $author$project$Util$Text$truncateToNChars_fn = function (n, s) {
        return (_Utils_cmp($elm$core$String$length(s), n) > 0) ? (($elm$core$String$right_fn(1, s) === "?") ? ($elm$core$String$left_fn(n - 4, s) + "...?") : ($elm$core$String$left_fn(n - 3, s) + "...")) : s;
    }, $author$project$Util$Text$truncateToNChars = F2($author$project$Util$Text$truncateToNChars_fn);
    var $author$project$Page$Person$emailListColumn_fn = function (palette, fontSize) {
        return A2($elm$core$Basics$composeR, $elm$core$List$map(function (email) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $author$project$View$Util$attribute_fn($author$project$View$Util$title_a0, email)
            ]), $mdgriffith$elm_ui$Element$text($author$project$Util$Text$truncateToNChars_fn(33, email)));
        }), $mdgriffith$elm_ui$Element$column(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(5),
            $mdgriffith$elm_ui$Element$Font$size(fontSize),
            $mdgriffith$elm_ui$Element$Font$color(palette.aS)
        ])));
    }, $author$project$Page$Person$emailListColumn = F2($author$project$Page$Person$emailListColumn_fn);
    var $mdgriffith$elm_ui$Internal$Flag$overflow = $mdgriffith$elm_ui$Internal$Flag$flag(20);
    var $mdgriffith$elm_ui$Element$clip = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.kL);
    var $elm$html$Html$Attributes$alt_a0 = "alt", $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$alt_a0);
    var $elm$html$Html$Attributes$src = function (url) {
        return $elm$html$Html$Attributes$stringProperty_fn("src", _VirtualDom_noJavaScriptOrHtmlUri(url));
    };
    var $mdgriffith$elm_ui$Element$image_fn = function (attrs, _v0) {
        var src = _v0.oM;
        var description = _v0.fc;
        var imageAttributes = $elm$core$List$filter_fn(function (a) {
            switch (a.$) {
                case 7:
                    return true;
                case 8:
                    return true;
                default:
                    return false;
            }
        }, attrs);
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.l9), attrs), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$NodeName("img"), _Utils_ap(_List_fromArray([
                $mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$src(src)),
                $mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$alt_a0, description))
            ]), imageAttributes), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil))
        ])));
    }, $mdgriffith$elm_ui$Element$image = F2($mdgriffith$elm_ui$Element$image_fn);
    var $mdgriffith$elm_ui$Internal$Flag$borderRound = $mdgriffith$elm_ui$Internal$Flag$flag(17);
    var $mdgriffith$elm_ui$Element$Border$rounded = function (radius) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$borderRound, $mdgriffith$elm_ui$Internal$Model$Single_fn("br-" + $elm$core$String$fromInt(radius), "border-radius", $elm$core$String$fromInt(radius) + "px"));
    };
    var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
    var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
    var $author$project$View$Util$style_fn = function (k, v) {
        return $mdgriffith$elm_ui$Element$htmlAttribute(_VirtualDom_style_fn(k, v));
    }, $author$project$View$Util$style = F2($author$project$View$Util$style_fn);
    var $author$project$View$Widgets$favicon_fn = function (size, extraAttrs, domain) {
        return $mdgriffith$elm_ui$Element$el_fn(_Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$Border$rounded(100),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(size)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(size)),
            $mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$rgb255_fn(255, 255, 255)),
            $mdgriffith$elm_ui$Element$clip
        ]), extraAttrs), $mdgriffith$elm_ui$Element$image_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(((10 * size) / 16) | 0)),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY,
            $author$project$View$Util$style_fn("opacity", "0.8")
        ]), (new $$Record114(domain + " logo", "https://us-central1-witful-production.cloudfunctions.net/serve_favicons/v1/" + (domain + "?default=person")))));
    }, $author$project$View$Widgets$favicon = F3($author$project$View$Widgets$favicon_fn);
    var $mdgriffith$elm_ui$Internal$Model$boxShadowClass = function (shadow) {
        return $elm$core$String$concat(_List_fromArray([
            shadow.hT ? "box-inset" : "box-",
            $mdgriffith$elm_ui$Internal$Model$floatClass(shadow.nt.a) + "px",
            $mdgriffith$elm_ui$Internal$Model$floatClass(shadow.nt.b) + "px",
            $mdgriffith$elm_ui$Internal$Model$floatClass(shadow.kp) + "px",
            $mdgriffith$elm_ui$Internal$Model$floatClass(shadow.oE) + "px",
            $mdgriffith$elm_ui$Internal$Model$formatColorClass(shadow.kS)
        ]));
    };
    var $mdgriffith$elm_ui$Internal$Flag$shadows = $mdgriffith$elm_ui$Internal$Flag$flag(19);
    var $mdgriffith$elm_ui$Element$Border$shadow = function (almostShade) {
        var shade = { kp: almostShade.kp, kS: almostShade.kS, hT: false, nt: almostShade.nt, oE: almostShade.oE };
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$shadows, $mdgriffith$elm_ui$Internal$Model$Single_fn($mdgriffith$elm_ui$Internal$Model$boxShadowClass(shade), "box-shadow", $mdgriffith$elm_ui$Internal$Model$formatBoxShadow(shade)));
    };
    var $mdgriffith$elm_ui$Element$Border$glow_fn = function (clr, size) {
        return $mdgriffith$elm_ui$Element$Border$shadow({
            kp: size * 2,
            kS: clr,
            nt: _Utils_Tuple2(0, 0),
            oE: size
        });
    }, $mdgriffith$elm_ui$Element$Border$glow = F2($mdgriffith$elm_ui$Element$Border$glow_fn);
    var $mdgriffith$elm_ui$Internal$Model$AsRow = 0;
    var $mdgriffith$elm_ui$Internal$Model$asRow = 0;
    var $mdgriffith$elm_ui$Element$row_fn = function (attrs, children) {
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asRow, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cL + (" " + $mdgriffith$elm_ui$Internal$Style$classes.aD)), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), attrs))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
    }, $mdgriffith$elm_ui$Element$row = F2($mdgriffith$elm_ui$Element$row_fn);
    var $author$project$View$Widgets$faviconStackedArray_fn = function (palette, favicons) {
        return $mdgriffith$elm_ui$Element$row_fn(_List_Nil, $elm$core$List$map_fn(A2($elm$core$Basics$composeR, A2($author$project$View$Widgets$favicon, 30, _List_fromArray([
            $mdgriffith$elm_ui$Element$Border$glow_fn(palette.aO, 2)
        ])), $mdgriffith$elm_ui$Element$el(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(22))
        ]))), favicons));
    }, $author$project$View$Widgets$faviconStackedArray = F2($author$project$View$Widgets$faviconStackedArray_fn);
    var $author$project$Page$Person$faviconStackedArrayForEmails = function (palette) {
        return A2($elm$core$Basics$composeR, $elm$core$List$filterMap($author$project$Util$Text$domainFromEmail), A2($elm$core$Basics$composeR, $elm_community$list_extra$List$Extra$unique, A2($elm$core$Basics$composeR, $elm$core$List$reverse, $author$project$View$Widgets$faviconStackedArray(palette))));
    };
    var $mdgriffith$elm_ui$Internal$Model$Fill = function (a) {
        return { $: 2, a: a };
    };
    var $mdgriffith$elm_ui$Element$fill = $mdgriffith$elm_ui$Internal$Model$Fill(1);
    var $mdgriffith$elm_ui$Internal$Flag$borderColor = $mdgriffith$elm_ui$Internal$Flag$flag(28);
    var $mdgriffith$elm_ui$Element$Border$color = function (clr) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$borderColor, $mdgriffith$elm_ui$Internal$Model$Colored_fn("bc-" + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr), "border-color", clr));
    };
    var $mdgriffith$elm_ui$Internal$Model$BorderWidth_fn = function (a, b, c, d, e) {
        return { $: 6, a: a, b: b, c: c, d: d, e: e };
    }, $mdgriffith$elm_ui$Internal$Model$BorderWidth = F5($mdgriffith$elm_ui$Internal$Model$BorderWidth_fn);
    var $mdgriffith$elm_ui$Element$Border$width = function (v) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$borderWidth, $mdgriffith$elm_ui$Internal$Model$BorderWidth_fn("b-" + $elm$core$String$fromInt(v), v, v, v, v));
    };
    var $mdgriffith$elm_ui$Element$Border$widthXY_fn = function (x, y) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$borderWidth, $mdgriffith$elm_ui$Internal$Model$BorderWidth_fn("b-" + ($elm$core$String$fromInt(x) + ("-" + $elm$core$String$fromInt(y))), y, x, y, x));
    }, $mdgriffith$elm_ui$Element$Border$widthXY = F2($mdgriffith$elm_ui$Element$Border$widthXY_fn);
    var $mdgriffith$elm_ui$Element$Border$widthEach = function (_v0) {
        var bottom = _v0.kw;
        var top = _v0.pE;
        var left = _v0.mE;
        var right = _v0.oc;
        return (_Utils_eq(top, bottom) && _Utils_eq(left, right)) ? (_Utils_eq(top, right) ? $mdgriffith$elm_ui$Element$Border$width(top) : $mdgriffith$elm_ui$Element$Border$widthXY_fn(left, top)) : $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$borderWidth, $mdgriffith$elm_ui$Internal$Model$BorderWidth_fn("b-" + ($elm$core$String$fromInt(top) + ("-" + ($elm$core$String$fromInt(right) + ("-" + ($elm$core$String$fromInt(bottom) + ("-" + $elm$core$String$fromInt(left))))))), top, right, bottom, left));
    };
    var $author$project$View$Util$horizontalLine_fn = function (palette, thickness, attrs) {
        return $mdgriffith$elm_ui$Element$el_fn(_Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$Border$widthEach((new $$Record115(thickness, 0, 0, 0))),
            $mdgriffith$elm_ui$Element$Border$color(palette.aP),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), attrs), $mdgriffith$elm_ui$Element$none);
    }, $author$project$View$Util$horizontalLine = F3($author$project$View$Util$horizontalLine_fn);
    var $elm$html$Html$Attributes$href = function (url) {
        return $elm$html$Html$Attributes$stringProperty_fn("href", _VirtualDom_noJavaScriptUri(url));
    };
    var $elm$html$Html$Attributes$rel_a0 = "rel", $elm$html$Html$Attributes$rel = _VirtualDom_attribute($elm$html$Html$Attributes$rel_a0);
    var $mdgriffith$elm_ui$Element$link_fn = function (attrs, _v0) {
        var url = _v0.dt;
        var label = _v0.fF;
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$NodeName("a"), _List_Cons($mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$href(url)), _List_Cons($mdgriffith$elm_ui$Internal$Model$Attr(_VirtualDom_attribute_fn($elm$html$Html$Attributes$rel_a0, "noopener noreferrer")), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.dP + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.aD + (" " + $mdgriffith$elm_ui$Internal$Style$classes.h1)))), attrs))))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([label])));
    }, $mdgriffith$elm_ui$Element$link = F2($mdgriffith$elm_ui$Element$link_fn);
    var $mdgriffith$elm_ui$Internal$Model$Hover = 1;
    var $mdgriffith$elm_ui$Internal$Model$PseudoSelector_fn = function (a, b) {
        return { $: 11, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$PseudoSelector = F2($mdgriffith$elm_ui$Internal$Model$PseudoSelector_fn);
    var $mdgriffith$elm_ui$Internal$Flag$hover = $mdgriffith$elm_ui$Internal$Flag$flag(33);
    var $mdgriffith$elm_ui$Internal$Model$Describe = function (a) {
        return { $: 2, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$Nearby_fn = function (a, b) {
        return { $: 9, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Nearby = F2($mdgriffith$elm_ui$Internal$Model$Nearby_fn);
    var $mdgriffith$elm_ui$Internal$Model$NoAttribute = { $: 0 };
    var $mdgriffith$elm_ui$Internal$Model$TransformComponent_fn = function (a, b) {
        return { $: 10, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$TransformComponent = F2($mdgriffith$elm_ui$Internal$Model$TransformComponent_fn);
    var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
    var $mdgriffith$elm_ui$Internal$Model$map_fn = function (fn, el) {
        switch (el.$) {
            case 1:
                var styled = el.a;
                return $mdgriffith$elm_ui$Internal$Model$Styled({
                    l3: F2(function (add, context) {
                        return _VirtualDom_map_fn(fn, A2(styled.l3, add, context));
                    }),
                    ji: styled.ji
                });
            case 0:
                var html = el.a;
                return $mdgriffith$elm_ui$Internal$Model$Unstyled(A2($elm$core$Basics$composeL, $elm$virtual_dom$VirtualDom$map(fn), html));
            case 2:
                var str = el.a;
                return $mdgriffith$elm_ui$Internal$Model$Text(str);
            default:
                return $mdgriffith$elm_ui$Internal$Model$Empty;
        }
    }, $mdgriffith$elm_ui$Internal$Model$map = F2($mdgriffith$elm_ui$Internal$Model$map_fn);
    var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
    var $mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle_fn = function (fn, attr) {
        switch (attr.$) {
            case 0:
                return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
            case 2:
                var description = attr.a;
                return $mdgriffith$elm_ui$Internal$Model$Describe(description);
            case 6:
                var x = attr.a;
                return $mdgriffith$elm_ui$Internal$Model$AlignX(x);
            case 5:
                var y = attr.a;
                return $mdgriffith$elm_ui$Internal$Model$AlignY(y);
            case 7:
                var x = attr.a;
                return $mdgriffith$elm_ui$Internal$Model$Width(x);
            case 8:
                var x = attr.a;
                return $mdgriffith$elm_ui$Internal$Model$Height(x);
            case 3:
                var x = attr.a;
                var y = attr.b;
                return $mdgriffith$elm_ui$Internal$Model$Class_fn(x, y);
            case 4:
                var flag = attr.a;
                var style = attr.b;
                return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn(flag, style);
            case 9:
                var location = attr.a;
                var elem = attr.b;
                return $mdgriffith$elm_ui$Internal$Model$Nearby_fn(location, $mdgriffith$elm_ui$Internal$Model$map_fn(fn, elem));
            case 1:
                var htmlAttr = attr.a;
                return $mdgriffith$elm_ui$Internal$Model$Attr(_VirtualDom_mapAttribute_fn(fn, htmlAttr));
            default:
                var fl = attr.a;
                var trans = attr.b;
                return $mdgriffith$elm_ui$Internal$Model$TransformComponent_fn(fl, trans);
        }
    }, $mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle = F2($mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle_fn);
    var $mdgriffith$elm_ui$Internal$Model$removeNever = function (style) {
        return $mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle_fn($elm$core$Basics$never, style);
    };
    var $mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper_fn = function (attr, _v0) {
        var styles = _v0.a;
        var trans = _v0.b;
        var _v1 = $mdgriffith$elm_ui$Internal$Model$removeNever(attr);
        switch (_v1.$) {
            case 4:
                var style = _v1.b;
                return _Utils_Tuple2(_List_Cons(style, styles), trans);
            case 10:
                var flag = _v1.a;
                var component = _v1.b;
                return _Utils_Tuple2(styles, $mdgriffith$elm_ui$Internal$Model$composeTransformation_fn(trans, component));
            default:
                return _Utils_Tuple2(styles, trans);
        }
    }, $mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper = F2($mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper_fn);
    var $mdgriffith$elm_ui$Internal$Model$unwrapDecorations = function (attrs) {
        var _v0 = $elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper, _Utils_Tuple2(_List_Nil, $mdgriffith$elm_ui$Internal$Model$Untransformed), attrs);
        var styles = _v0.a;
        var transform = _v0.b;
        return _List_Cons($mdgriffith$elm_ui$Internal$Model$Transform(transform), styles);
    };
    var $mdgriffith$elm_ui$Element$mouseOver = function (decs) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$hover, $mdgriffith$elm_ui$Internal$Model$PseudoSelector_fn(1, $mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
    };
    var $author$project$View$Styling$edges = (new $$Record115(0, 0, 0, 0));
    var $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn = function (a, b, c, d, e) {
        return { $: 7, a: a, b: b, c: c, d: d, e: e };
    }, $mdgriffith$elm_ui$Internal$Model$PaddingStyle = F5($mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn);
    var $mdgriffith$elm_ui$Internal$Flag$padding = $mdgriffith$elm_ui$Internal$Flag$flag(2);
    var $mdgriffith$elm_ui$Internal$Model$paddingName_fn = function (top, right, bottom, left) {
        return "pad-" + ($elm$core$String$fromInt(top) + ("-" + ($elm$core$String$fromInt(right) + ("-" + ($elm$core$String$fromInt(bottom) + ("-" + $elm$core$String$fromInt(left)))))));
    }, $mdgriffith$elm_ui$Internal$Model$paddingName = F4($mdgriffith$elm_ui$Internal$Model$paddingName_fn);
    var $mdgriffith$elm_ui$Element$paddingEach = function (_v0) {
        var top = _v0.pE;
        var right = _v0.oc;
        var bottom = _v0.kw;
        var left = _v0.mE;
        if (_Utils_eq(top, right) && (_Utils_eq(top, bottom) && _Utils_eq(top, left))) {
            var topFloat = top;
            return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$padding, $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn("p-" + $elm$core$String$fromInt(top), topFloat, topFloat, topFloat, topFloat));
        }
        else {
            return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$padding, $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn($mdgriffith$elm_ui$Internal$Model$paddingName_fn(top, right, bottom, left), top, right, bottom, left));
        }
    };
    var $author$project$View$Styling$paddingBottom = function (amount) {
        return $mdgriffith$elm_ui$Element$paddingEach($$update__kw($author$project$View$Styling$edges, amount));
    };
    var $mdgriffith$elm_ui$Element$paddingXY_fn = function (x, y) {
        if (_Utils_eq(x, y)) {
            var f = x;
            return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$padding, $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn("p-" + $elm$core$String$fromInt(x), f, f, f, f));
        }
        else {
            var yFloat = y;
            var xFloat = x;
            return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$padding, $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn("p-" + ($elm$core$String$fromInt(x) + ("-" + $elm$core$String$fromInt(y))), yFloat, xFloat, yFloat, xFloat));
        }
    }, $mdgriffith$elm_ui$Element$paddingXY = F2($mdgriffith$elm_ui$Element$paddingXY_fn);
    var $mdgriffith$elm_ui$Internal$Model$Paragraph = { $: 9 };
    var $mdgriffith$elm_ui$Element$paragraph_fn = function (attrs, children) {
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asParagraph, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Paragraph), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$spacing(5), attrs))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
    }, $mdgriffith$elm_ui$Element$paragraph = F2($mdgriffith$elm_ui$Element$paragraph_fn);
    var $author$project$Page$Person$confirmNotDupeDialog_fn = function (palette, personId, _v0) {
        var otherId = _v0.a;
        var otherPerson = _v0.b;
        return $$update__dG__de__e2__gK__gj__i5__jJ($author$project$Page$Person$closeable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$Font$size(16),
            $mdgriffith$elm_ui$Element$spacing(5),
            $author$project$View$Styling$paddingBottom(30)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.aS),
                $mdgriffith$elm_ui$Element$Font$size(15)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$text("Once dismissed, you won't be able to merge this person.")
            ])),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$paddingXY_fn(0, 40),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), $author$project$View$Util$horizontalLine_fn(palette, 1, _List_Nil)),
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$spacing(5)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(8)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(palette.a7),
                        $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(palette.a9)
                        ]))
                    ]), {
                        fF: $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$size(18)
                        ]), $mdgriffith$elm_ui$Element$text(otherPerson.b)),
                        dt: $author$project$Routing$pathFromRoute($author$project$Routing$RoutePerson(otherId))
                    }),
                    A2($author$project$Page$Person$faviconStackedArrayForEmails, palette, otherPerson.lo)
                ])),
                A3($author$project$Page$Person$emailListColumn, palette, 16, otherPerson.lo)
            ]))
        ])), $elm$core$Maybe$Just(_Utils_Tuple2("I'm sure. Dismiss.", $author$project$Page$Person$MarkAsNotDuplicate_fn(personId, otherId))), true, $elm$core$Maybe$Just($author$project$Page$Person$SetDialog($elm$core$Maybe$Just($author$project$Page$Person$AllCandidates))), $elm$core$Maybe$Just("Are you sure this isn't a duplicate?"), $elm$core$Maybe$Just(_Utils_Tuple2("Cancel and go back", $author$project$Page$Person$SetDialog($elm$core$Maybe$Just($author$project$Page$Person$AllCandidates)))), $mdgriffith$elm_ui$Element$px(450));
    }, $author$project$Page$Person$confirmNotDupeDialog = F3($author$project$Page$Person$confirmNotDupeDialog_fn);
    var $author$project$Page$Person$DeletePerson = function (a) {
        return { $: 9, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Flag$fontAlignment = $mdgriffith$elm_ui$Internal$Flag$flag(12);
    var $mdgriffith$elm_ui$Element$Font$center = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.pa);
    var $author$project$Page$Person$confirmPersonDeletion_fn = function (palette, personId) {
        return function () {
            var $r = $author$project$Page$Person$closeable.$c();
            $r.dG = $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(16),
                $mdgriffith$elm_ui$Element$Font$color(palette.aQ),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Font$center,
                $mdgriffith$elm_ui$Element$paddingXY_fn(0, 10)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$text("They will be removed from all meetings.")
            ]));
            $r.dL = $elm$core$Maybe$Just($author$project$Page$Person$SetDialog($elm$core$Maybe$Nothing));
            $r.de = $elm$core$Maybe$Just(_Utils_Tuple2("Delete", $author$project$Page$Person$DeletePerson(personId)));
            $r.e2 = true;
            $r.gj = $elm$core$Maybe$Just("Delete this Person?");
            return $r;
        }();
    }, $author$project$Page$Person$confirmPersonDeletion = F2($author$project$Page$Person$confirmPersonDeletion_fn);
    var $author$project$Page$Person$ConfirmNotDupe = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Page$Person$MergePersons = function (a) {
        return { $: 12, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$Top = 0;
    var $mdgriffith$elm_ui$Element$alignTop = $mdgriffith$elm_ui$Internal$Model$AlignY(0);
    var $author$project$Data$Color$grayAlpha_a0 = 0, $author$project$Data$Color$grayAlpha_a1 = 0, $author$project$Data$Color$grayAlpha_a2 = 0, $author$project$Data$Color$grayAlpha = A3($mdgriffith$elm_ui$Element$rgba255, $author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2);
    var $author$project$Data$Color$grayAlphaLight = $mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.05);
    var $author$project$View$Styling$elevation1 = $mdgriffith$elm_ui$Element$Border$shadow({
        kp: 3,
        kS: $author$project$Data$Color$grayAlphaLight,
        nt: _Utils_Tuple2(0, 1.5),
        oE: 1
    });
    var $mdgriffith$elm_ui$Element$padding = function (x) {
        var f = x;
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$padding, $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn("p-" + $elm$core$String$fromInt(x), f, f, f, f));
    };
    var $author$project$View$Layout$standardBorderRounding = 10;
    var $author$project$View$Layout$card_fn = function (palette, attrs) {
        return $mdgriffith$elm_ui$Element$column(_Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$padding(30),
            $mdgriffith$elm_ui$Element$spacing(10),
            $mdgriffith$elm_ui$Element$Border$rounded($author$project$View$Layout$standardBorderRounding),
            $mdgriffith$elm_ui$Element$Background$color(palette.dw),
            $author$project$View$Styling$elevation1,
            $mdgriffith$elm_ui$Element$alignTop,
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), attrs));
    }, $author$project$View$Layout$card = F2($author$project$View$Layout$card_fn);
    var $author$project$Page$Person$closeDialog = $author$project$Page$Person$SetDialog($elm$core$Maybe$Nothing);
    var $author$project$Data$Color$grayAlphaDark = $mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.12);
    var $author$project$Content$ImagePaths$mergeIcon = "/static/img/merge-icon.svg";
    var $author$project$View$Styling$noElevation = $mdgriffith$elm_ui$Element$Border$shadow({
        kp: 0,
        kS: $mdgriffith$elm_ui$Element$rgba255_fn(0, 0, 0, 0),
        nt: _Utils_Tuple2(0, 0),
        oE: 0
    });
    var $mdgriffith$elm_ui$Internal$Model$Scale = function (a) {
        return { $: 5, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Flag$scale = $mdgriffith$elm_ui$Internal$Flag$flag(23);
    var $mdgriffith$elm_ui$Element$scale = function (n) {
        return $mdgriffith$elm_ui$Internal$Model$TransformComponent_fn($mdgriffith$elm_ui$Internal$Flag$scale, $mdgriffith$elm_ui$Internal$Model$Scale(_Utils_Tuple3(n, n, 1)));
    };
    var $mdgriffith$elm_ui$Element$spaceEvenly = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$spacing, $mdgriffith$elm_ui$Internal$Style$classes.oI);
    var $author$project$View$Util$spacer = function (size) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(size))
        ]), $mdgriffith$elm_ui$Element$none);
    };
    var $author$project$Page$Person$mergeParticularCandidateDialog_fn = function (env, ids) {
        var primaryPersonId = ids.iL;
        var secondaryPersonId = ids.f1;
        var dialogBody = F2(function (primaryPerson, secondaryPerson) {
            var mergedEmailsPreview = $elm_community$list_extra$List$Extra$unique(_Utils_ap(primaryPerson.lo, secondaryPerson.lo));
            return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$spacing(10)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.aS),
                    $mdgriffith$elm_ui$Element$Font$size(15)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Don't worry\u2014 you won't lose any of your notes or other content. ")
                ])),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$paddingXY_fn(0, 20),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), $author$project$View$Util$horizontalLine_fn(env.nI, 1, _List_Nil)),
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spaceEvenly,
                    $mdgriffith$elm_ui$Element$Font$size(16),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(240)),
                    $mdgriffith$elm_ui$Element$centerX
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.a7),
                        $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.a9)
                        ]))
                    ]), {
                        fF: $mdgriffith$elm_ui$Element$text(primaryPerson.b),
                        dt: $author$project$Routing$pathFromRoute($author$project$Routing$RoutePerson(primaryPersonId))
                    }),
                    $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.a7),
                        $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.a9)
                        ]))
                    ]), {
                        fF: $mdgriffith$elm_ui$Element$text(secondaryPerson.b),
                        dt: $author$project$Routing$pathFromRoute($author$project$Routing$RoutePerson(secondaryPersonId))
                    })
                ])),
                $mdgriffith$elm_ui$Element$image_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$padding(15),
                    $mdgriffith$elm_ui$Element$scale(-1.7),
                    $author$project$View$Util$style_fn("filter", "invert(58%)")
                ]), (new $$Record114("Merge icon", $author$project$Content$ImagePaths$mergeIcon))),
                A3($author$project$View$Layout$card, env.nI, _List_fromArray([
                    $mdgriffith$elm_ui$Element$Border$color(env.nI.aO),
                    $mdgriffith$elm_ui$Element$Border$width(1),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
                    $mdgriffith$elm_ui$Element$spacing(0),
                    $author$project$View$Styling$noElevation
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$spacing(10)
                    ]), _List_fromArray([
                        $elm$core$Maybe$withDefault_fn($mdgriffith$elm_ui$Element$none, $elm$core$Maybe$map_fn(A2($author$project$View$Widgets$favicon, 35, _List_fromArray([
                            $mdgriffith$elm_ui$Element$Border$glow_fn($author$project$Data$Color$grayAlphaDark, 0.9)
                        ])), $elm$core$Maybe$andThen_fn($author$project$Util$Text$domainFromEmail, $elm$core$List$head(mergedEmailsPreview)))),
                        $mdgriffith$elm_ui$Element$text(primaryPerson.b)
                    ])),
                    $author$project$View$Util$spacer(8),
                    A3($author$project$Page$Person$emailListColumn, env.nI, 16, mergedEmailsPreview)
                ]))
            ]));
        });
        var _v0 = _Utils_Tuple2($author$project$Firestore$Collection$get_fn(primaryPersonId, env.iz), $author$project$Firestore$Collection$get_fn(secondaryPersonId, env.iz));
        if ((!_v0.a.$) && (!_v0.b.$)) {
            var primaryPerson = _v0.a.a;
            var secondaryPerson = _v0.b.a;
            return (primaryPerson.lh || secondaryPerson.lh) ? $$update__dG__dL__de__gj($author$project$Page$Person$closeable, $mdgriffith$elm_ui$Element$text("One of those Persons is deleted."), $elm$core$Maybe$Just($author$project$Page$Person$closeDialog), $elm$core$Maybe$Just(_Utils_Tuple2("Dismiss", $author$project$Page$Person$closeDialog)), $elm$core$Maybe$Just("Merge Persons")) : $$update__dG__de__e2__gK__gj__i5__jJ($author$project$Page$Person$closeable, A2(dialogBody, primaryPerson, secondaryPerson), $elm$core$Maybe$Just(_Utils_Tuple2("Merge", $author$project$Page$Person$MergePersons(ids))), true, $elm$core$Maybe$Just($author$project$Page$Person$SetDialog($elm$core$Maybe$Just($author$project$Page$Person$AllCandidates))), $elm$core$Maybe$Just("Ready to merge these people?"), $elm$core$Maybe$Just(_Utils_Tuple2("These aren't duplicates", $author$project$Page$Person$SetDialog($elm$core$Maybe$Just($author$project$Page$Person$ConfirmNotDupe(_Utils_Tuple2(secondaryPersonId, secondaryPerson)))))), $mdgriffith$elm_ui$Element$px(530));
        }
        else {
            return $$update__dG__dL__de__gj($author$project$Page$Person$closeable, $mdgriffith$elm_ui$Element$text("Selected merge candidate doesn't exist."), $elm$core$Maybe$Just($author$project$Page$Person$closeDialog), $elm$core$Maybe$Just(_Utils_Tuple2("Dismiss", $author$project$Page$Person$closeDialog)), $elm$core$Maybe$Just("Merge Persons"));
        }
    }, $author$project$Page$Person$mergeParticularCandidateDialog = F2($author$project$Page$Person$mergeParticularCandidateDialog_fn);
    var $author$project$Page$Person$ParticularCandidate = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$Button = { $: 8 };
    var $elm$html$Html$Attributes$boolProperty_fn = function (key, bool) {
        return _VirtualDom_property_fn(key, $elm$json$Json$Encode$bool(bool));
    }, $elm$html$Html$Attributes$boolProperty = F2($elm$html$Html$Attributes$boolProperty_fn);
    var $elm$html$Html$Attributes$disabled_a0 = "disabled", $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty($elm$html$Html$Attributes$disabled_a0);
    var $mdgriffith$elm_ui$Element$Input$hasFocusStyle = function (attr) {
        if (((attr.$ === 4) && (attr.b.$ === 11)) && (!attr.b.a)) {
            var _v1 = attr.b;
            var _v2 = _v1.a;
            return true;
        }
        else {
            return false;
        }
    };
    var $mdgriffith$elm_ui$Element$Input$focusDefault = function (attrs) {
        return $elm$core$List$any_fn($mdgriffith$elm_ui$Element$Input$hasFocusStyle, attrs) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass("focusable");
    };
    var $elm$html$Html$Events$onClick = function (msg) {
        return $elm$html$Html$Events$on_fn("click", $elm$json$Json$Decode$succeed(msg));
    };
    var $mdgriffith$elm_ui$Element$Events$onClick_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Events$onClick_a1 = $elm$html$Html$Events$onClick, $mdgriffith$elm_ui$Element$Events$onClick = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1);
    var $mdgriffith$elm_ui$Element$Input$enter = "Enter";
    var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
        return { $: 2, a: a };
    };
    var $elm$html$Html$Events$preventDefaultOn_fn = function (event, decoder) {
        return _VirtualDom_on_fn(event, $elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
    }, $elm$html$Html$Events$preventDefaultOn = F2($elm$html$Html$Events$preventDefaultOn_fn);
    var $mdgriffith$elm_ui$Element$Input$onKey_fn = function (desiredCode, msg) {
        var decode = function (code) {
            return _Utils_eq(code, desiredCode) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail("Not the enter key");
        };
        var isKey = _Json_andThen_fn(decode, _Json_decodeField_fn("key", $elm$json$Json$Decode$string));
        return $mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Events$preventDefaultOn_fn("keyup", _Json_map1_fn(function (fired) {
            return _Utils_Tuple2(fired, true);
        }, isKey)));
    }, $mdgriffith$elm_ui$Element$Input$onKey = F2($mdgriffith$elm_ui$Element$Input$onKey_fn);
    var $mdgriffith$elm_ui$Element$Input$onEnter = function (msg) {
        return $mdgriffith$elm_ui$Element$Input$onKey_fn($mdgriffith$elm_ui$Element$Input$enter, msg);
    };
    var $mdgriffith$elm_ui$Internal$Flag$cursor = $mdgriffith$elm_ui$Internal$Flag$flag(21);
    var $mdgriffith$elm_ui$Element$pointer = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.k9);
    var $elm$html$Html$Attributes$tabindex = function (n) {
        return _VirtualDom_attribute_fn("tabIndex", $elm$core$String$fromInt(n));
    };
    var $mdgriffith$elm_ui$Element$Input$button_fn = function (attrs, _v0) {
        var onPress = _v0.nz;
        var label = _v0.fF;
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.dP + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.aD + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.oo + (" " + $mdgriffith$elm_ui$Internal$Style$classes.$9)))))), _List_Cons($mdgriffith$elm_ui$Element$pointer, _List_Cons($mdgriffith$elm_ui$Element$Input$focusDefault(attrs), _List_Cons($mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Button), _List_Cons($mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$tabindex(0)), function () {
            if (onPress.$ === 1) {
                return _List_Cons($mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$disabled_a0, true)), attrs);
            }
            else {
                var msg = onPress.a;
                return _List_Cons($elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, msg), _List_Cons($mdgriffith$elm_ui$Element$Input$onEnter(msg), attrs));
            }
        }()))))))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([label])));
    }, $mdgriffith$elm_ui$Element$Input$button = F2($mdgriffith$elm_ui$Element$Input$button_fn);
    var $author$project$View$Util$class_a0 = $mdgriffith$elm_ui$Element$htmlAttribute, $author$project$View$Util$class_a1 = $elm$html$Html$Attributes$class, $author$project$View$Util$class = A2($elm$core$Basics$composeL, $author$project$View$Util$class_a0, $author$project$View$Util$class_a1);
    var $author$project$View$Styling$focusableOnlyBorderStyling = $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "focusable-only-border-styling");
    var $mdgriffith$elm_ui$Internal$Model$unstyled_a0 = $mdgriffith$elm_ui$Internal$Model$Unstyled, $mdgriffith$elm_ui$Internal$Model$unstyled_a1 = $elm$core$Basics$always, $mdgriffith$elm_ui$Internal$Model$unstyled = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$unstyled_a0, $mdgriffith$elm_ui$Internal$Model$unstyled_a1);
    var $mdgriffith$elm_ui$Element$html = $mdgriffith$elm_ui$Internal$Model$unstyled;
    var $elm$html$Html$i = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "i"), $elm$html$Html$i_fn = $elm$html$Html$i.a2;
    var $author$project$View$Icon$stylePrefix = function (style) {
        switch (style) {
            case 0:
                return "fas";
            case 1:
                return "far";
            case 2:
                return "fal";
            case 3:
                return "fad";
            default:
                return "fab";
        }
    };
    var $author$project$View$Icon$icon_fn = function (attrs, style, name) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_Cons($mdgriffith$elm_ui$Element$Font$size(20), attrs), $mdgriffith$elm_ui$Element$html($elm$html$Html$i_fn(_List_fromArray([
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $author$project$View$Icon$stylePrefix(style) + (" fa-fw fa-" + name))
        ]), _List_Nil)));
    }, $author$project$View$Icon$icon = F3($author$project$View$Icon$icon_fn);
    var $mdgriffith$elm_ui$Internal$Flag$letterSpacing = $mdgriffith$elm_ui$Internal$Flag$flag(16);
    var $mdgriffith$elm_ui$Element$Font$letterSpacing = function (offset) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$letterSpacing, $mdgriffith$elm_ui$Internal$Model$Single_fn("ls-" + $mdgriffith$elm_ui$Internal$Model$floatClass(offset), "letter-spacing", $elm$core$String$fromFloat(offset) + "px"));
    };
    var $author$project$View$Styling$ripple = $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "ripple");
    var $mdgriffith$elm_ui$Element$spacingXY_fn = function (x, y) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$spacing, $mdgriffith$elm_ui$Internal$Model$SpacingStyle_fn($mdgriffith$elm_ui$Internal$Model$spacingName_fn(x, y), x, y));
    }, $mdgriffith$elm_ui$Element$spacingXY = F2($mdgriffith$elm_ui$Element$spacingXY_fn);
    var $author$project$View$Util$whenJust_fn = function (mVal, toEl) {
        if (!mVal.$) {
            var a = mVal.a;
            return toEl(a);
        }
        else {
            return $mdgriffith$elm_ui$Element$none;
        }
    }, $author$project$View$Util$whenJust = F2($author$project$View$Util$whenJust_fn);
    var $author$project$View$Widgets$button_fn = function (_v0, buttonText) {
        var onClick = _v0.fQ;
        var icon = _v0.l7;
        var extraAttrs = _v0.hp;
        var icon_ = $author$project$View$Util$whenJust_fn(icon, function (_v1) {
            var style = _v1.a;
            var name = _v1.b;
            var iconAttrs = _v1.c;
            return $author$project$View$Icon$icon_fn(iconAttrs, style, name);
        });
        var attrs = _Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacingXY_fn(10, 30),
            $mdgriffith$elm_ui$Element$paddingXY_fn(10, 10),
            $mdgriffith$elm_ui$Element$Font$regular,
            $mdgriffith$elm_ui$Element$Font$size(14),
            $mdgriffith$elm_ui$Element$Font$letterSpacing(0.6),
            $mdgriffith$elm_ui$Element$Border$width(2),
            $mdgriffith$elm_ui$Element$Border$rounded(4),
            $author$project$View$Styling$ripple,
            $author$project$View$Styling$focusableOnlyBorderStyling,
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$grayAlphaLight)
            ]))
        ]), extraAttrs);
        return $mdgriffith$elm_ui$Element$Input$button_fn(attrs, {
            fF: $elm$core$String$isEmpty(buttonText) ? icon_ : $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(10)
            ]), _List_fromArray([
                icon_,
                $mdgriffith$elm_ui$Element$text(buttonText)
            ])),
            nz: onClick
        });
    }, $author$project$View$Widgets$button = F2($author$project$View$Widgets$button_fn);
    var $mdgriffith$elm_ui$Internal$Model$Focus = 0;
    var $mdgriffith$elm_ui$Internal$Flag$focus = $mdgriffith$elm_ui$Internal$Flag$flag(31);
    var $mdgriffith$elm_ui$Element$focused = function (decs) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$focus, $mdgriffith$elm_ui$Internal$Model$PseudoSelector_fn(0, $mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
    };
    var $mdgriffith$elm_ui$Internal$Model$MoveY = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Flag$moveY = $mdgriffith$elm_ui$Internal$Flag$flag(26);
    var $mdgriffith$elm_ui$Element$moveUp = function (y) {
        return $mdgriffith$elm_ui$Internal$Model$TransformComponent_fn($mdgriffith$elm_ui$Internal$Flag$moveY, $mdgriffith$elm_ui$Internal$Model$MoveY(-y));
    };
    var $author$project$View$Styling$paddingTop = function (amount) {
        return $mdgriffith$elm_ui$Element$paddingEach($$update__pE($author$project$View$Styling$edges, amount));
    };
    var $author$project$Data$Color$transparent = $mdgriffith$elm_ui$Element$rgba255_fn(0, 0, 0, 0);
    var $author$project$Page$Person$viewAllCandidatesDialog_fn = function (env, potentialDupes) {
        var viewPotentialDupe = function (_v0) {
            var personId = _v0.a;
            var person = _v0.b;
            return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(18),
                $mdgriffith$elm_ui$Element$spacing(10),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(3)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$spacing(10)
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.a7),
                            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Font$color(env.nI.a9)
                            ]))
                        ]), {
                            fF: $mdgriffith$elm_ui$Element$text(person.b),
                            dt: $author$project$Routing$pathFromRoute($author$project$Routing$RoutePerson(personId))
                        }),
                        A2($author$project$Page$Person$faviconStackedArrayForEmails, env.nI, person.lo)
                    ])),
                    A3($author$project$Page$Person$emailListColumn, env.nI, 14, person.lo)
                ])),
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$alignRight,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
                    $mdgriffith$elm_ui$Element$spacing(5)
                ]), _List_fromArray([
                    $author$project$View$Widgets$button_fn({
                        hp: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Background$color(env.nI.ba),
                            $mdgriffith$elm_ui$Element$Border$width(0),
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.dw),
                            $mdgriffith$elm_ui$Element$paddingXY_fn(8, 8),
                            $mdgriffith$elm_ui$Element$centerY,
                            $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Background$color(env.nI.a7)
                            ])),
                            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Background$color(env.nI.a7)
                            ])),
                            $mdgriffith$elm_ui$Element$Font$size(14)
                        ]),
                        l7: $elm$core$Maybe$Nothing,
                        fQ: $elm$core$Maybe$Just($author$project$Page$Person$SetDialog($elm$core$Maybe$Just($author$project$Page$Person$ParticularCandidate(personId))))
                    }, "Review & Merge"),
                    $author$project$View$Widgets$button_fn({
                        hp: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$transparent),
                            $mdgriffith$elm_ui$Element$Border$width(0),
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.aR),
                            $mdgriffith$elm_ui$Element$paddingXY_fn(8, 8),
                            $mdgriffith$elm_ui$Element$centerY,
                            $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Font$color(env.nI.a8)
                            ])),
                            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Font$color(env.nI.a8)
                            ])),
                            $mdgriffith$elm_ui$Element$Font$size(14)
                        ]),
                        l7: $elm$core$Maybe$Nothing,
                        fQ: $elm$core$Maybe$Just($author$project$Page$Person$SetDialog($elm$core$Maybe$Just($author$project$Page$Person$ConfirmNotDupe(_Utils_Tuple2(personId, person)))))
                    }, "Dismiss")
                ]))
            ]));
        };
        return $$update__dG__dL__jJ($author$project$Page$Person$closeable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(20),
            $author$project$View$Styling$paddingTop(10)
        ]), _List_Cons($mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(19),
            $author$project$View$Styling$paddingTop(10),
            $mdgriffith$elm_ui$Element$Font$center,
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$moveUp(17),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(300))
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$text("Duplicates are detected by similar names or email addresses.")
        ])), _List_Cons($author$project$View$Util$horizontalLine_fn(env.nI, 1, _List_Nil), _List_Cons($author$project$View$Util$spacer(5), $elm$core$List$isEmpty(potentialDupes) ? _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(16),
                $mdgriffith$elm_ui$Element$Font$color(env.nI.aS)
            ]), $mdgriffith$elm_ui$Element$text("No potential duplicates found for this person."))
        ]) : $elm$core$List$map_fn(viewPotentialDupe, potentialDupes))))), $elm$core$Maybe$Just($author$project$Page$Person$closeDialog), $mdgriffith$elm_ui$Element$px(500));
    }, $author$project$Page$Person$viewAllCandidatesDialog = F2($author$project$Page$Person$viewAllCandidatesDialog_fn);
    var $author$project$Page$Person$dialog_fn = function (env, model, personId) {
        return $elm$core$Maybe$map_fn(function (d) {
            switch (d.$) {
                case 0:
                    return $author$project$Page$Person$viewAllCandidatesDialog_fn(env, model.au);
                case 1:
                    var otherId = d.a;
                    return $author$project$Page$Person$mergeParticularCandidateDialog_fn(env, { iL: personId, f1: otherId });
                case 2:
                    var other = d.a;
                    return $author$project$Page$Person$confirmNotDupeDialog_fn(env.nI, personId, other);
                default:
                    return $author$project$Page$Person$confirmPersonDeletion_fn(env.nI, personId);
            }
        }, model.bp);
    }, $author$project$Page$Person$dialog = F3($author$project$Page$Person$dialog_fn);
    var $mdgriffith$elm_ui$Element$map = $mdgriffith$elm_ui$Internal$Model$map;
    var $author$project$View$Dialog$BaseDialog$map_fn = function (conv, d) {
        var elMap = $mdgriffith$elm_ui$Element$map(conv);
        return (new $$Record113($elm$core$Maybe$map_fn(conv, d.gK), elMap(d.dG), d.cJ, d.e2, $elm$core$Maybe$map_fn(conv, d.dL), d.b3, d.fo, A2($elm$core$Basics$composeR, d.nf, conv), $elm$core$Maybe$map_fn(conv, d.c7), d.dc, $elm$core$Maybe$map_fn($elm$core$Tuple$mapSecond(conv), d.de), $elm$core$Maybe$map_fn($elm$core$Tuple$mapSecond(conv), d.i5), elMap(d.co), d.gj, d.jJ));
    }, $author$project$View$Dialog$BaseDialog$map = F2($author$project$View$Dialog$BaseDialog$map_fn);
    var $author$project$View$Dialog$pageDialog = function (model) {
        var _v0 = model.ix;
        if (_v0.$ === 3) {
            var personId = _v0.a;
            var subModel = _v0.b;
            return $elm$core$Maybe$map_fn($author$project$View$Dialog$BaseDialog$map(A2($elm$core$Basics$composeR, $author$project$Model$PersonMsg, $author$project$Model$HandlePageMsg)), $author$project$Page$Person$dialog_fn(model.dW, subModel, personId));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$View$Dialog$Common$closeDialog = $author$project$Model$HandleBacktalk($author$project$Env$SetDialog($elm$core$Maybe$Nothing));
    var $author$project$View$Dialog$Common$closeable = $author$project$View$Dialog$BaseDialog$empty_fn($author$project$Model$NoOp, $elm$core$Maybe$Just($author$project$View$Dialog$Common$closeDialog));
    var $author$project$Content$Videos$colorCoding = "https://www.youtube.com/embed/oxqRc40ZjZg?rel=0";
    var $author$project$View$Styling$hHelp_fn = function (palette, size, internalAttrs, attrs, str) {
        return $mdgriffith$elm_ui$Element$el_fn(_Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(size),
            $mdgriffith$elm_ui$Element$Font$color(palette.cd)
        ]), _Utils_ap(internalAttrs, attrs)), $mdgriffith$elm_ui$Element$text(str));
    }, $author$project$View$Styling$hHelp = F5($author$project$View$Styling$hHelp_fn);
    var $mdgriffith$elm_ui$Element$Font$semiBold = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.pk);
    var $author$project$View$Styling$h2 = function (palette) {
        return A3($author$project$View$Styling$hHelp, palette, 24, _List_fromArray([$mdgriffith$elm_ui$Element$Font$semiBold]));
    };
    var $mdgriffith$elm_ui$Internal$Model$Max_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Max = F2($mdgriffith$elm_ui$Internal$Model$Max_fn);
    var $mdgriffith$elm_ui$Element$maximum_fn = function (i, l) {
        return $mdgriffith$elm_ui$Internal$Model$Max_fn(i, l);
    }, $mdgriffith$elm_ui$Element$maximum = F2($mdgriffith$elm_ui$Element$maximum_fn);
    var $elm$html$Html$Attributes$height = function (n) {
        return _VirtualDom_attribute_fn("height", $elm$core$String$fromInt(n));
    };
    var $elm$html$Html$iframe = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "iframe"), $elm$html$Html$iframe_fn = $elm$html$Html$iframe.a2;
    var $elm$html$Html$Attributes$title_a0 = "title", $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$title_a0);
    var $elm$html$Html$Attributes$width = function (n) {
        return _VirtualDom_attribute_fn("width", $elm$core$String$fromInt(n));
    };
    var $author$project$View$Widgets$youtubeVideo = function (_v0) {
        var viewportWidth = _v0.p2;
        var src = _v0.oM;
        var _v1 = (viewportWidth > 960) ? _Utils_Tuple2(800, 450) : ((viewportWidth > 848) ? _Utils_Tuple2(640, 360) : ((viewportWidth > 640) ? _Utils_Tuple2(426, 240) : _Utils_Tuple2(256, 144)));
        var w = _v1.a;
        var h = _v1.b;
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
        ]), $mdgriffith$elm_ui$Element$html($elm$html$Html$iframe_fn(_List_fromArray([
            $elm$html$Html$Attributes$width(w),
            $elm$html$Html$Attributes$height(h),
            $elm$html$Html$Attributes$src(src),
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$title_a0, "YouTube video player"),
            $elm$virtual_dom$VirtualDom$attribute_fn("frameborder", "0"),
            $elm$virtual_dom$VirtualDom$attribute_fn("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"),
            $elm$virtual_dom$VirtualDom$attribute_fn("allowfullscreen", "true")
        ]), _List_Nil)));
    };
    var $author$project$View$Dialog$Closeable$colorCodingVideo = function (env) {
        return $$update__dG__dL__jJ($author$project$View$Dialog$Common$closeable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(30)
        ]), _List_fromArray([
            A3($author$project$View$Styling$h2, env.nI, _List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $author$project$View$Styling$paddingBottom(15)
            ]), "Color code your calendar"),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]), $author$project$View$Widgets$youtubeVideo({
                oM: $author$project$Content$Videos$colorCoding,
                p2: $elm$core$Basics$floor(env.p1.p1.jJ)
            }))
        ])), $elm$core$Maybe$Just($author$project$View$Dialog$Common$closeDialog), $mdgriffith$elm_ui$Element$maximum_fn(900, $mdgriffith$elm_ui$Element$fill));
    };
    var $author$project$Analytics$NoteAdHocTimeAdjusted = { $: 28 };
    var $author$project$Model$UpdateEditNoteTime = function (a) {
        return { $: 34, a: a };
    };
    var $elm$virtual_dom$VirtualDom$Custom = function (a) {
        return { $: 3, a: a };
    };
    var $elm$html$Html$Events$custom_fn = function (event, decoder) {
        return _VirtualDom_on_fn(event, $elm$virtual_dom$VirtualDom$Custom(decoder));
    }, $elm$html$Html$Events$custom = F2($elm$html$Html$Events$custom_fn);
    var $elm$html$Html$Attributes$id_a0 = "id", $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$id_a0);
    var $author$project$View$Util$id_a0 = $mdgriffith$elm_ui$Element$htmlAttribute, $author$project$View$Util$id_a1 = $elm$html$Html$Attributes$id, $author$project$View$Util$id = A2($elm$core$Basics$composeL, $author$project$View$Util$id_a0, $author$project$View$Util$id_a1);
    var $author$project$Data$Settings$isShowArmyTime_a0 = $author$project$Data$Settings$get, $author$project$Data$Settings$isShowArmyTime_a1 = function ($) {
        return $.cD;
    }, $author$project$Data$Settings$isShowArmyTime = A2($elm$core$Basics$composeR, $author$project$Data$Settings$isShowArmyTime_a0, $author$project$Data$Settings$isShowArmyTime_a1);
    var $mdgriffith$elm_ui$Element$Input$HiddenLabel = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Element$Input$labelHidden = $mdgriffith$elm_ui$Element$Input$HiddenLabel;
    var $ryannhg$date_format$DateFormat$DayOfMonthSuffix = { $: 6 };
    var $ryannhg$date_format$DateFormat$dayOfMonthSuffix = $ryannhg$date_format$DateFormat$DayOfMonthSuffix;
    var $ryannhg$date_format$DateFormat$MonthNameAbbreviated = { $: 3 };
    var $ryannhg$date_format$DateFormat$monthNameAbbreviated = $ryannhg$date_format$DateFormat$MonthNameAbbreviated;
    var $ryannhg$date_format$DateFormat$YearNumber = { $: 16 };
    var $ryannhg$date_format$DateFormat$yearNumber = $ryannhg$date_format$DateFormat$YearNumber;
    var $author$project$Util$Time$monthDayYearFormatter = $ryannhg$date_format$DateFormat$format(_List_fromArray([
        $ryannhg$date_format$DateFormat$monthNameAbbreviated,
        $ryannhg$date_format$DateFormat$text(" "),
        $ryannhg$date_format$DateFormat$dayOfMonthSuffix,
        $ryannhg$date_format$DateFormat$text(", "),
        $ryannhg$date_format$DateFormat$yearNumber
    ]));
    var $author$project$Util$Time$formatTimeOfDay = $ryannhg$date_format$DateFormat$format(_List_fromArray([
        $ryannhg$date_format$DateFormat$hourNumber,
        $ryannhg$date_format$DateFormat$text(":"),
        $ryannhg$date_format$DateFormat$minuteFixed,
        $ryannhg$date_format$DateFormat$amPmLowercase
    ]));
    var $ryannhg$date_format$DateFormat$HourMilitaryFixed = { $: 25 };
    var $ryannhg$date_format$DateFormat$hourMilitaryFixed = $ryannhg$date_format$DateFormat$HourMilitaryFixed;
    var $author$project$Util$Time$formatTimeOfDayArmy = $ryannhg$date_format$DateFormat$format(_List_fromArray([
        $ryannhg$date_format$DateFormat$hourMilitaryFixed,
        $ryannhg$date_format$DateFormat$text(":"),
        $ryannhg$date_format$DateFormat$minuteFixed
    ]));
    var $author$project$Util$Time$monthDayYearTimeFormatterHumanized_fn = function (isArmyTime, zone, now, time) {
        var timeText = isArmyTime ? A2($author$project$Util$Time$formatTimeOfDayArmy, zone, time) : A2($author$project$Util$Time$formatTimeOfDay, zone, time);
        var isToday = _Utils_eq($justinmimbs$date$Date$fromPosix_fn(zone, now), $justinmimbs$date$Date$fromPosix_fn(zone, time));
        return $ryannhg$date_format$DateFormat$formatWithLanguage_fn($ryannhg$date_format$DateFormat$format_a0, isToday ? _List_fromArray([
            $ryannhg$date_format$DateFormat$text("Today, "),
            $ryannhg$date_format$DateFormat$text(timeText)
        ]) : _List_fromArray([
            $ryannhg$date_format$DateFormat$monthNameAbbreviated,
            $ryannhg$date_format$DateFormat$text(" "),
            $ryannhg$date_format$DateFormat$dayOfMonthSuffix,
            $ryannhg$date_format$DateFormat$text(", "),
            $ryannhg$date_format$DateFormat$yearNumber,
            $ryannhg$date_format$DateFormat$text("  "),
            $ryannhg$date_format$DateFormat$text(timeText)
        ]), zone, time);
    }, $author$project$Util$Time$monthDayYearTimeFormatterHumanized = F4($author$project$Util$Time$monthDayYearTimeFormatterHumanized_fn);
    var $elm_community$maybe_extra$Maybe$Extra$combine_a0 = $elm$core$Maybe$map2($elm$core$List$cons), $elm_community$maybe_extra$Maybe$Extra$combine_a1 = $elm$core$Maybe$Just(_List_Nil), $elm_community$maybe_extra$Maybe$Extra$combine = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$combine_a0, $elm_community$maybe_extra$Maybe$Extra$combine_a1);
    var $author$project$Data$Time$Parser$maybeWhen_fn = function (b, a) {
        return b ? $elm$core$Maybe$Just(a) : $elm$core$Maybe$Nothing;
    }, $author$project$Data$Time$Parser$maybeWhen = F2($author$project$Data$Time$Parser$maybeWhen_fn);
    var $author$project$Data$Time$Parser$combine_fn = function (priorComponents, component) {
        var year = priorComponents.bO;
        var month = priorComponents.bz;
        var monthDay = priorComponents.ck;
        var time = priorComponents.gh;
        switch (component.$) {
            case 0:
                var date = component.a;
                var _v1 = _Utils_Tuple3(year, month, monthDay);
                if (((_v1.a.$ === 1) && (_v1.b.$ === 1)) && (_v1.c.$ === 1)) {
                    var _v2 = _v1.a;
                    var _v3 = _v1.b;
                    var _v4 = _v1.c;
                    return $elm$core$Maybe$Just((new $$Record116($elm$core$Maybe$Just($elm$core$Basics$composeR_fn($justinmimbs$date$Date$month_a0, $justinmimbs$date$Date$month_a1, date)), $elm$core$Maybe$Just($elm$core$Basics$composeR_fn($justinmimbs$date$Date$day_a0, $justinmimbs$date$Date$day_a1, date)), time, $elm$core$Maybe$Just($justinmimbs$date$Date$year(date)))));
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            case 1:
                var newYear = component.a;
                if (!year.$) {
                    var oldYear = year.a;
                    return $author$project$Data$Time$Parser$maybeWhen_fn(_Utils_eq(newYear, oldYear), priorComponents);
                }
                else {
                    return $elm$core$Maybe$Just(function () {
                        var $r = priorComponents.$c();
                        $r.bO = $elm$core$Maybe$Just(newYear);
                        return $r;
                    }());
                }
            case 2:
                var newMonth = component.a;
                if (!month.$) {
                    var oldMonth = month.a;
                    return $author$project$Data$Time$Parser$maybeWhen_fn(_Utils_eq(newMonth, oldMonth), priorComponents);
                }
                else {
                    return $elm$core$Maybe$Just(function () {
                        var $r = priorComponents.$c();
                        $r.bz = $elm$core$Maybe$Just(newMonth);
                        return $r;
                    }());
                }
            case 3:
                var newDay = component.a;
                if (!monthDay.$) {
                    var oldDay = monthDay.a;
                    return $author$project$Data$Time$Parser$maybeWhen_fn(_Utils_eq(newDay, oldDay), priorComponents);
                }
                else {
                    return $elm$core$Maybe$Just(function () {
                        var $r = priorComponents.$c();
                        $r.ck = $elm$core$Maybe$Just(newDay);
                        return $r;
                    }());
                }
            default:
                var newTime = component.a;
                if (!time.$) {
                    var oldTime = time.a;
                    return $author$project$Data$Time$Parser$maybeWhen_fn(_Utils_eq(newTime, oldTime), priorComponents);
                }
                else {
                    return $elm$core$Maybe$Just($$update__gh(priorComponents, $elm$core$Maybe$Just(newTime)));
                }
        }
    }, $author$project$Data$Time$Parser$combine = F2($author$project$Data$Time$Parser$combine_fn);
    var $author$project$Data$Time$Parser$customFold_fn = function (start, components) {
        customFold: while (true) {
            if (!components.b) {
                return $elm$core$Maybe$Just(start);
            }
            else {
                var x = components.a;
                var others = components.b;
                var _v1 = $author$project$Data$Time$Parser$combine_fn(start, x);
                if (!_v1.$) {
                    var newComponents = _v1.a;
                    var $temp$start = newComponents, $temp$components = others;
                    start = $temp$start;
                    components = $temp$components;
                    continue customFold;
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
        }
    }, $author$project$Data$Time$Parser$customFold = F2($author$project$Data$Time$Parser$customFold_fn);
    var $author$project$Data$Time$Parser$emptyComponents = (new $$Record116($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
    var $author$project$Data$Time$Parser$DateComponent = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$Time$Parser$parseDate_fn = function (context, s) {
        var _v0 = $elm$core$String$toLower(s);
        switch (_v0) {
            case "yesterday":
                return $elm$core$Maybe$Just($author$project$Data$Time$Parser$DateComponent($justinmimbs$date$Date$add_fn(3, -1, context.bI)));
            case "today":
                return $elm$core$Maybe$Just($author$project$Data$Time$Parser$DateComponent(context.bI));
            case "tomorrow":
                return $elm$core$Maybe$Just($author$project$Data$Time$Parser$DateComponent($justinmimbs$date$Date$add_fn(3, 1, context.bI)));
            default:
                return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Data$Time$Parser$parseDate = F2($author$project$Data$Time$Parser$parseDate_fn);
    var $author$project$Data$Time$Parser$MonthComponent = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Data$Time$Parser$months = $elm$core$Dict$fromList(_List_fromArray([
        _Utils_Tuple2("january", 0),
        _Utils_Tuple2("jan", 0),
        _Utils_Tuple2("february", 1),
        _Utils_Tuple2("feb", 1),
        _Utils_Tuple2("march", 2),
        _Utils_Tuple2("mar", 2),
        _Utils_Tuple2("april", 3),
        _Utils_Tuple2("apr", 3),
        _Utils_Tuple2("may", 4),
        _Utils_Tuple2("june", 5),
        _Utils_Tuple2("jun", 5),
        _Utils_Tuple2("july", 6),
        _Utils_Tuple2("jul", 6),
        _Utils_Tuple2("august", 7),
        _Utils_Tuple2("aug", 7),
        _Utils_Tuple2("september", 8),
        _Utils_Tuple2("sep", 8),
        _Utils_Tuple2("october", 9),
        _Utils_Tuple2("oct", 9),
        _Utils_Tuple2("november", 10),
        _Utils_Tuple2("nov", 10),
        _Utils_Tuple2("december", 11),
        _Utils_Tuple2("dec", 11)
    ]));
    var $author$project$Data$Time$Parser$parseMonth = function (s) {
        return $elm$core$Maybe$map_fn($author$project$Data$Time$Parser$MonthComponent, $elm$core$Dict$get_fn(s, $author$project$Data$Time$Parser$months));
    };
    var $author$project$Data$Time$Parser$MonthDayComponent = function (a) {
        return { $: 3, a: a };
    };
    var $elm_community$string_extra$String$Extra$firstResultHelp_fn = function (_default, list) {
        firstResultHelp: while (true) {
            if (!list.b) {
                return _default;
            }
            else {
                if (!list.a.$) {
                    var a = list.a.a;
                    return a;
                }
                else {
                    var _v1 = list.a;
                    var rest = list.b;
                    var $temp$default = _default, $temp$list = rest;
                    _default = $temp$default;
                    list = $temp$list;
                    continue firstResultHelp;
                }
            }
        }
    }, $elm_community$string_extra$String$Extra$firstResultHelp = F2($elm_community$string_extra$String$Extra$firstResultHelp_fn);
    var $elm_community$string_extra$String$Extra$firstResult = function (list) {
        return $elm_community$string_extra$String$Extra$firstResultHelp_fn("", list);
    };
    var $elm_community$string_extra$String$Extra$regexFromString_a0 = $elm$regex$Regex$fromString, $elm_community$string_extra$String$Extra$regexFromString_a1 = $elm$core$Maybe$withDefault($elm$regex$Regex$never), $elm_community$string_extra$String$Extra$regexFromString = A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1);
    var $elm_community$string_extra$String$Extra$regexEscape = A2($elm$regex$Regex$replace, $elm$core$Basics$composeR_fn($elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1, "[-/\\^$*+?.()|[\\]{}]"), function (_v0) {
        var match = _v0.by;
        return "\\" + match;
    });
    var $elm_community$string_extra$String$Extra$leftOf_fn = function (pattern, string) {
        return $elm$core$String$join_fn("", $elm$core$List$map_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.o$;
        }, $elm_community$string_extra$String$Extra$firstResult), _Regex_findAtMost_fn(1, $elm$core$Basics$composeR_fn($elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1, "^(.*?)" + $elm_community$string_extra$String$Extra$regexEscape(pattern)), string)));
    }, $elm_community$string_extra$String$Extra$leftOf = F2($elm_community$string_extra$String$Extra$leftOf_fn);
    var $author$project$Data$Time$Parser$parseMonthDay = function (s) {
        return $elm$core$Maybe$map_fn($author$project$Data$Time$Parser$MonthDayComponent, $elm_community$maybe_extra$Maybe$Extra$filter_fn(function (v) {
            return (v >= 1) && (v <= 31);
        }, $elm$core$String$toInt(_String_endsWith_fn("st", s) ? $elm_community$string_extra$String$Extra$leftOf_fn("st", s) : (_String_endsWith_fn("rd", s) ? $elm_community$string_extra$String$Extra$leftOf_fn("rd", s) : (_String_endsWith_fn("nd", s) ? $elm_community$string_extra$String$Extra$leftOf_fn("nd", s) : (_String_endsWith_fn("th", s) ? $elm_community$string_extra$String$Extra$leftOf_fn("th", s) : s))))));
    };
    var $author$project$Data$Time$Parser$TimeComponent = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Data$Time$Parser$timeRegex = $elm$regex$Regex$fromString("^([0-9]+)(?::([0-9]+))?([ap]m?)?$");
    var $author$project$Data$Time$Parser$parseTime = function (s) {
        return $elm$core$Maybe$andThen_fn(function (match) {
            var _v1 = match.o$;
            _v1$3: while (true) {
                if ((_v1.b && (!_v1.a.$)) && _v1.b.b) {
                    if (_v1.b.a.$ === 1) {
                        if ((_v1.b.b.b && (!_v1.b.b.a.$)) && (!_v1.b.b.b.b)) {
                            var hour = _v1.a.a;
                            var _v2 = _v1.b;
                            var _v3 = _v2.a;
                            var _v4 = _v2.b;
                            var amPm = _v4.a.a;
                            var _v5 = $elm$core$String$toInt(hour);
                            if (!_v5.$) {
                                var h = _v5.a;
                                return ((h >= 1) && (h <= 12)) ? $elm$core$Maybe$Just($author$project$Data$Time$Parser$TimeComponent((new $$Record117(_String_startsWith_fn("a", amPm) ? (h % 12) : ((h % 12) + 12), 0)))) : $elm$core$Maybe$Nothing;
                            }
                            else {
                                return $elm$core$Maybe$Nothing;
                            }
                        }
                        else {
                            break _v1$3;
                        }
                    }
                    else {
                        if (_v1.b.b.b) {
                            if (_v1.b.b.a.$ === 1) {
                                if (!_v1.b.b.b.b) {
                                    var hour = _v1.a.a;
                                    var _v6 = _v1.b;
                                    var minute = _v6.a.a;
                                    var _v7 = _v6.b;
                                    var _v8 = _v7.a;
                                    var _v9 = _Utils_Tuple2($elm$core$String$toInt(hour), $elm$core$String$toInt(minute));
                                    if ((!_v9.a.$) && (!_v9.b.$)) {
                                        var h = _v9.a.a;
                                        var m = _v9.b.a;
                                        return ((h >= 0) && ((h <= 23) && ((m >= 0) && (m <= 59)))) ? $elm$core$Maybe$Just($author$project$Data$Time$Parser$TimeComponent((new $$Record117((h < 7) ? (h + 12) : h, m)))) : $elm$core$Maybe$Nothing;
                                    }
                                    else {
                                        return $elm$core$Maybe$Nothing;
                                    }
                                }
                                else {
                                    break _v1$3;
                                }
                            }
                            else {
                                if (!_v1.b.b.b.b) {
                                    var hour = _v1.a.a;
                                    var _v10 = _v1.b;
                                    var minute = _v10.a.a;
                                    var _v11 = _v10.b;
                                    var amPm = _v11.a.a;
                                    var _v12 = _Utils_Tuple2($elm$core$String$toInt(hour), $elm$core$String$toInt(minute));
                                    if ((!_v12.a.$) && (!_v12.b.$)) {
                                        var h = _v12.a.a;
                                        var m = _v12.b.a;
                                        return ((h >= 1) && ((h <= 12) && ((m >= 0) && (m <= 59)))) ? $elm$core$Maybe$Just($author$project$Data$Time$Parser$TimeComponent((new $$Record117(_String_startsWith_fn("a", amPm) ? (h % 12) : ((h % 12) + 12), m)))) : $elm$core$Maybe$Nothing;
                                    }
                                    else {
                                        return $elm$core$Maybe$Nothing;
                                    }
                                }
                                else {
                                    break _v1$3;
                                }
                            }
                        }
                        else {
                            break _v1$3;
                        }
                    }
                }
                else {
                    break _v1$3;
                }
            }
            return $elm$core$Maybe$Nothing;
        }, $elm$core$Maybe$andThen_fn(function (re) {
            var _v0 = _Regex_findAtMost_fn($elm$regex$Regex$find_a0, re, s);
            if (_v0.b && (!_v0.b.b)) {
                var match = _v0.a;
                return $elm$core$Maybe$Just(match);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, $author$project$Data$Time$Parser$timeRegex));
    };
    var $author$project$Data$Time$Parser$YearComponent = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$Time$Parser$parseYear = function (s) {
        return $elm$core$Maybe$map_fn($author$project$Data$Time$Parser$YearComponent, $elm_community$maybe_extra$Maybe$Extra$filter_fn(function (v) {
            return (v >= 1900) && (v <= 2300);
        }, $elm$core$String$toInt(s)));
    };
    var $author$project$Data$Time$Parser$parseComponent_fn = function (context, s) {
        return $elm_community$maybe_extra$Maybe$Extra$orElse_fn($author$project$Data$Time$Parser$parseDate_fn(context, s), $elm_community$maybe_extra$Maybe$Extra$orElse_fn($author$project$Data$Time$Parser$parseMonthDay(s), $elm_community$maybe_extra$Maybe$Extra$orElse_fn($author$project$Data$Time$Parser$parseMonth(s), $elm_community$maybe_extra$Maybe$Extra$orElse_fn($author$project$Data$Time$Parser$parseYear(s), $elm_community$maybe_extra$Maybe$Extra$orElse_fn($author$project$Data$Time$Parser$parseTime(s), $elm$core$Maybe$Nothing)))));
    }, $author$project$Data$Time$Parser$parseComponent = F2($author$project$Data$Time$Parser$parseComponent_fn);
    var $author$project$Data$Time$Parser$stopWords = $elm$core$Set$fromList(_List_fromArray(["at", "on", "around", "the"]));
    var $author$project$Data$Time$Parser$splitComponents = function (s) {
        return $elm$core$List$filter_fn(function (w) {
            return !$elm$core$Set$member_fn(w, $author$project$Data$Time$Parser$stopWords);
        }, $elm$core$List$map_fn(function (s_) {
            return _String_endsWith_fn(",", s_) ? $elm_community$string_extra$String$Extra$leftOf_fn(",", s_) : s_;
        }, $elm$core$String$words($elm$core$String$toLower(s))));
    };
    var $author$project$Data$Time$Parser$parse_fn = function (context, s) {
        var components = function () {
            var stringComponents = $author$project$Data$Time$Parser$splitComponents(s);
            return $elm$core$List$isEmpty(stringComponents) ? $elm$core$Maybe$Nothing : $elm$core$List$foldr_fn($elm_community$maybe_extra$Maybe$Extra$combine_a0, $elm_community$maybe_extra$Maybe$Extra$combine_a1, $elm$core$List$map_fn($author$project$Data$Time$Parser$parseComponent(context), stringComponents));
        }();
        var combined = $elm$core$Maybe$andThen_fn($author$project$Data$Time$Parser$customFold($author$project$Data$Time$Parser$emptyComponents), components);
        return $elm$core$Maybe$andThen_fn(function (c) {
            var year = $elm$core$Maybe$withDefault_fn($justinmimbs$date$Date$year(context.bI), c.bO);
            var monthDay = $elm$core$Maybe$withDefault_fn($elm$core$Basics$composeR_fn($justinmimbs$date$Date$day_a0, $justinmimbs$date$Date$day_a1, context.bI), c.ck);
            var month = $elm$core$Maybe$withDefault_fn($elm$core$Basics$composeR_fn($justinmimbs$date$Date$month_a0, $justinmimbs$date$Date$month_a1, context.bI), c.bz);
            var _v0 = c.gh;
            if (!_v0.$) {
                var hour = _v0.a.cW;
                var minute = _v0.a.c2;
                return $elm$core$Maybe$Just($author$project$Data$Time$fromPosix($justinmimbs$time_extra$Time$Extra$partsToPosix_fn(context.gw, (new $$Record29(monthDay, hour, 0, minute, month, 0, year)))));
            }
            else {
                return $elm$core$Maybe$Just($author$project$Data$Time$Date($justinmimbs$date$Date$fromCalendarDate_fn(year, month, monthDay)));
            }
        }, combined);
    }, $author$project$Data$Time$Parser$parse = F2($author$project$Data$Time$Parser$parse_fn);
    var $mdgriffith$elm_ui$Element$Input$Placeholder_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $mdgriffith$elm_ui$Element$Input$Placeholder = F2($mdgriffith$elm_ui$Element$Input$Placeholder_fn);
    var $mdgriffith$elm_ui$Element$Input$placeholder = $mdgriffith$elm_ui$Element$Input$Placeholder;
    var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
        return { $: 1, a: a };
    };
    var $elm$html$Html$Events$stopPropagationOn_fn = function (event, decoder) {
        return _VirtualDom_on_fn(event, $elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
    }, $elm$html$Html$Events$stopPropagationOn = F2($elm$html$Html$Events$stopPropagationOn_fn);
    var $author$project$View$Util$stopPropagationOn_fn = function (eventName, noOpMsg) {
        return $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$stopPropagationOn_fn(eventName, $elm$json$Json$Decode$succeed(_Utils_Tuple2(noOpMsg, true))));
    }, $author$project$View$Util$stopPropagationOn = F2($author$project$View$Util$stopPropagationOn_fn);
    var $author$project$View$Util$preventKeypressPropagation = function (noOpMsg) {
        return $author$project$View$Util$stopPropagationOn_fn("keypress", noOpMsg("preventKeypressPropagation"));
    };
    var $mdgriffith$elm_ui$Element$Input$TextInputNode = function (a) {
        return { $: 0, a: a };
    };
    var $mdgriffith$elm_ui$Element$Input$TextArea = { $: 1 };
    var $mdgriffith$elm_ui$Internal$Model$LivePolite = { $: 6 };
    var $mdgriffith$elm_ui$Element$Region$announce = $mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$LivePolite);
    var $mdgriffith$elm_ui$Element$Input$applyLabel_fn = function (attrs, label, input) {
        if (label.$ === 1) {
            var labelText = label.a;
            return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asColumn, $mdgriffith$elm_ui$Internal$Model$NodeName("label"), attrs, $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([input])));
        }
        else {
            var position = label.a;
            var labelAttrs = label.b;
            var labelChild = label.c;
            var labelElement = $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, labelAttrs, $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([labelChild])));
            switch (position) {
                case 2:
                    return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asColumn, $mdgriffith$elm_ui$Internal$Model$NodeName("label"), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.d5), attrs), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([labelElement, input])));
                case 3:
                    return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asColumn, $mdgriffith$elm_ui$Internal$Model$NodeName("label"), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.d5), attrs), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([input, labelElement])));
                case 0:
                    return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asRow, $mdgriffith$elm_ui$Internal$Model$NodeName("label"), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.d5), attrs), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([input, labelElement])));
                default:
                    return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asRow, $mdgriffith$elm_ui$Internal$Model$NodeName("label"), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.d5), attrs), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([labelElement, input])));
            }
        }
    }, $mdgriffith$elm_ui$Element$Input$applyLabel = F3($mdgriffith$elm_ui$Element$Input$applyLabel_fn);
    var $mdgriffith$elm_ui$Element$Input$autofill_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Input$autofill_a1 = $elm$html$Html$Attributes$attribute("autocomplete"), $mdgriffith$elm_ui$Element$Input$autofill = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Input$autofill_a0, $mdgriffith$elm_ui$Element$Input$autofill_a1);
    var $mdgriffith$elm_ui$Internal$Model$Behind = 5;
    var $mdgriffith$elm_ui$Element$createNearby_fn = function (loc, element) {
        if (element.$ === 3) {
            return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
        }
        else {
            return $mdgriffith$elm_ui$Internal$Model$Nearby_fn(loc, element);
        }
    }, $mdgriffith$elm_ui$Element$createNearby = F2($mdgriffith$elm_ui$Element$createNearby_fn);
    var $mdgriffith$elm_ui$Element$behindContent = function (element) {
        return $mdgriffith$elm_ui$Element$createNearby_fn(5, element);
    };
    var $mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding = function (attrs) {
        var gatherSpacing = F2(function (attr, found) {
            if ((attr.$ === 4) && (attr.b.$ === 5)) {
                var _v2 = attr.b;
                var x = _v2.b;
                var y = _v2.c;
                if (found.$ === 1) {
                    return $elm$core$Maybe$Just(y);
                }
                else {
                    return found;
                }
            }
            else {
                return found;
            }
        });
        var _v0 = $elm$core$List$foldr_fn(gatherSpacing, $elm$core$Maybe$Nothing, attrs);
        if (_v0.$ === 1) {
            return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
        }
        else {
            var vSpace = _v0.a;
            return $mdgriffith$elm_ui$Element$moveUp($elm$core$Basics$floor(vSpace / 2));
        }
    };
    var $mdgriffith$elm_ui$Element$rgb_fn = function (r, g, b) {
        return $mdgriffith$elm_ui$Internal$Model$Rgba_fn(r, g, b, 1);
    }, $mdgriffith$elm_ui$Element$rgb = F3($mdgriffith$elm_ui$Element$rgb_fn);
    var $mdgriffith$elm_ui$Element$Input$darkGrey = $mdgriffith$elm_ui$Element$rgb_fn(186 / 255, 189 / 255, 182 / 255);
    var $mdgriffith$elm_ui$Element$Input$defaultTextPadding = $mdgriffith$elm_ui$Element$paddingXY_fn(12, 12);
    var $mdgriffith$elm_ui$Element$Input$white = $mdgriffith$elm_ui$Element$rgb_fn(1, 1, 1);
    var $mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle = _List_fromArray([
        $mdgriffith$elm_ui$Element$Input$defaultTextPadding,
        $mdgriffith$elm_ui$Element$Border$rounded(3),
        $mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Element$Input$darkGrey),
        $mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$Input$white),
        $mdgriffith$elm_ui$Element$Border$width(1),
        $mdgriffith$elm_ui$Element$spacing(5),
        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
        $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink)
    ]);
    var $mdgriffith$elm_ui$Element$Input$getHeight = function (attr) {
        if (attr.$ === 8) {
            var h = attr.a;
            return $elm$core$Maybe$Just(h);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$Label = function (a) {
        return { $: 5, a: a };
    };
    var $mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute = function (label) {
        if (label.$ === 1) {
            var textLabel = label.a;
            return $mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Label(textLabel));
        }
        else {
            return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$InFront = 4;
    var $mdgriffith$elm_ui$Element$inFront = function (element) {
        return $mdgriffith$elm_ui$Element$createNearby_fn(4, element);
    };
    var $mdgriffith$elm_ui$Element$Input$isConstrained = function (len) {
        isConstrained: while (true) {
            switch (len.$) {
                case 1:
                    return false;
                case 0:
                    return true;
                case 2:
                    return true;
                case 3:
                    var l = len.b;
                    var $temp$len = l;
                    len = $temp$len;
                    continue isConstrained;
                default:
                    var l = len.b;
                    return true;
            }
        }
    };
    var $mdgriffith$elm_ui$Element$Input$isHiddenLabel = function (label) {
        if (label.$ === 1) {
            return true;
        }
        else {
            return false;
        }
    };
    var $mdgriffith$elm_ui$Element$Input$isStacked = function (label) {
        if (!label.$) {
            var loc = label.a;
            switch (loc) {
                case 0:
                    return false;
                case 1:
                    return false;
                case 2:
                    return true;
                default:
                    return true;
            }
        }
        else {
            return true;
        }
    };
    var $mdgriffith$elm_ui$Element$Input$negateBox = function (box) {
        return (new $$Record115(-box.kw, -box.mE, -box.oc, -box.pE));
    };
    var $elm$html$Html$Events$alwaysStop = function (x) {
        return _Utils_Tuple2(x, true);
    };
    var $elm$html$Html$Events$targetValue = $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "value"]), $elm$json$Json$Decode$string);
    var $elm$html$Html$Events$onInput = function (tagger) {
        return $elm$html$Html$Events$stopPropagationOn_fn("input", _Json_map1_fn($elm$html$Html$Events$alwaysStop, _Json_map1_fn(tagger, $elm$html$Html$Events$targetValue)));
    };
    var $mdgriffith$elm_ui$Element$Input$isFill = function (len) {
        isFill: while (true) {
            switch (len.$) {
                case 2:
                    return true;
                case 1:
                    return false;
                case 0:
                    return false;
                case 3:
                    var l = len.b;
                    var $temp$len = l;
                    len = $temp$len;
                    continue isFill;
                default:
                    var l = len.b;
                    var $temp$len = l;
                    len = $temp$len;
                    continue isFill;
            }
        }
    };
    var $mdgriffith$elm_ui$Element$Input$isPixel = function (len) {
        isPixel: while (true) {
            switch (len.$) {
                case 1:
                    return false;
                case 0:
                    return true;
                case 2:
                    return false;
                case 3:
                    var l = len.b;
                    var $temp$len = l;
                    len = $temp$len;
                    continue isPixel;
                default:
                    var l = len.b;
                    var $temp$len = l;
                    len = $temp$len;
                    continue isPixel;
            }
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$paddingNameFloat_fn = function (top, right, bottom, left) {
        return "pad-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(top) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(right) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(bottom) + ("-" + $mdgriffith$elm_ui$Internal$Model$floatClass(left)))))));
    }, $mdgriffith$elm_ui$Internal$Model$paddingNameFloat = F4($mdgriffith$elm_ui$Internal$Model$paddingNameFloat_fn);
    var $mdgriffith$elm_ui$Element$Input$redistributeOver_fn = function (isMultiline, stacked, attr, els) {
        switch (attr.$) {
            case 9:
                return $$update__nJ(els, _List_Cons(attr, els.nJ));
            case 7:
                var width = attr.a;
                return $mdgriffith$elm_ui$Element$Input$isFill(width) ? function () {
                    var $r = els.$c();
                    $r.nJ = _List_Cons(attr, els.nJ);
                    $r.o = _List_Cons(attr, els.o);
                    $r.x = _List_Cons(attr, els.x);
                    return $r;
                }() : (stacked ? $$update__o(els, _List_Cons(attr, els.o)) : $$update__nJ(els, _List_Cons(attr, els.nJ)));
            case 8:
                var height = attr.a;
                return (!stacked) ? $$update__nJ__o(els, _List_Cons(attr, els.nJ), _List_Cons(attr, els.o)) : ($mdgriffith$elm_ui$Element$Input$isFill(height) ? $$update__nJ__o(els, _List_Cons(attr, els.nJ), _List_Cons(attr, els.o)) : ($mdgriffith$elm_ui$Element$Input$isPixel(height) ? $$update__nJ(els, _List_Cons(attr, els.nJ)) : $$update__nJ(els, _List_Cons(attr, els.nJ))));
            case 6:
                return $$update__o(els, _List_Cons(attr, els.o));
            case 5:
                return $$update__o(els, _List_Cons(attr, els.o));
            case 4:
                switch (attr.b.$) {
                    case 5:
                        var _v1 = attr.b;
                        return function () {
                            var $r = els.$c();
                            $r.cy = _List_Cons(attr, els.cy);
                            $r.nJ = _List_Cons(attr, els.nJ);
                            $r.o = _List_Cons(attr, els.o);
                            $r.x = _List_Cons(attr, els.x);
                            return $r;
                        }();
                    case 7:
                        var cls = attr.a;
                        var _v2 = attr.b;
                        var pad = _v2.a;
                        var t = _v2.b;
                        var r = _v2.c;
                        var b = _v2.d;
                        var l = _v2.e;
                        if (isMultiline) {
                            return $$update__L__nJ(els, _List_Cons(attr, els.L), _List_Cons(attr, els.nJ));
                        }
                        else {
                            var newTop = t - $elm$core$Basics$min_fn(t, b);
                            var newLineHeight = $mdgriffith$elm_ui$Element$htmlAttribute(_VirtualDom_style_fn("line-height", "calc(1.0em + " + ($elm$core$String$fromFloat(2 * $elm$core$Basics$min_fn(t, b)) + "px)")));
                            var newHeight = $mdgriffith$elm_ui$Element$htmlAttribute(_VirtualDom_style_fn("height", "calc(1.0em + " + ($elm$core$String$fromFloat(2 * $elm$core$Basics$min_fn(t, b)) + "px)")));
                            var newBottom = b - $elm$core$Basics$min_fn(t, b);
                            var reducedVerticalPadding = $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$padding, $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn($mdgriffith$elm_ui$Internal$Model$paddingNameFloat_fn(newTop, r, newBottom, l), newTop, r, newBottom, l));
                            return function () {
                                var $r = els.$c();
                                $r.L = _List_Cons(attr, els.L);
                                $r.nJ = _List_Cons(reducedVerticalPadding, els.nJ);
                                $r.x = _List_Cons(newHeight, _List_Cons(newLineHeight, els.x));
                                return $r;
                            }();
                        }
                    case 6:
                        var _v3 = attr.b;
                        return $$update__L__nJ(els, _List_Cons(attr, els.L), _List_Cons(attr, els.nJ));
                    case 10:
                        return $$update__L__nJ(els, _List_Cons(attr, els.L), _List_Cons(attr, els.nJ));
                    case 2:
                        return $$update__o(els, _List_Cons(attr, els.o));
                    case 1:
                        var _v4 = attr.b;
                        return $$update__o(els, _List_Cons(attr, els.o));
                    default:
                        var flag = attr.a;
                        var cls = attr.b;
                        return $$update__nJ(els, _List_Cons(attr, els.nJ));
                }
            case 0:
                return els;
            case 1:
                var a = attr.a;
                return $$update__x(els, _List_Cons(attr, els.x));
            case 2:
                return $$update__x(els, _List_Cons(attr, els.x));
            case 3:
                return $$update__nJ(els, _List_Cons(attr, els.nJ));
            default:
                return $$update__x(els, _List_Cons(attr, els.x));
        }
    }, $mdgriffith$elm_ui$Element$Input$redistributeOver = F4($mdgriffith$elm_ui$Element$Input$redistributeOver_fn);
    var $mdgriffith$elm_ui$Element$Input$redistribute_fn = function (isMultiline, stacked, attrs) {
        return function (redist) {
            return (new $$Record118($elm$core$List$reverse(redist.L), $elm$core$List$reverse(redist.o), $elm$core$List$reverse(redist.x), $elm$core$List$reverse(redist.nJ), $elm$core$List$reverse(redist.cy)));
        }($elm$core$List$foldl_fn(A2($mdgriffith$elm_ui$Element$Input$redistributeOver, isMultiline, stacked), (new $$Record118(_List_Nil, _List_Nil, _List_Nil, _List_Nil, _List_Nil)), attrs));
    }, $mdgriffith$elm_ui$Element$Input$redistribute = F3($mdgriffith$elm_ui$Element$Input$redistribute_fn);
    var $mdgriffith$elm_ui$Element$Input$renderBox = function (_v0) {
        var top = _v0.pE;
        var right = _v0.oc;
        var bottom = _v0.kw;
        var left = _v0.mE;
        return $elm$core$String$fromInt(top) + ("px " + ($elm$core$String$fromInt(right) + ("px " + ($elm$core$String$fromInt(bottom) + ("px " + ($elm$core$String$fromInt(left) + "px"))))));
    };
    var $mdgriffith$elm_ui$Internal$Model$Transparency_fn = function (a, b) {
        return { $: 12, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Transparency = F2($mdgriffith$elm_ui$Internal$Model$Transparency_fn);
    var $mdgriffith$elm_ui$Internal$Flag$transparency = $mdgriffith$elm_ui$Internal$Flag$flag(0);
    var $mdgriffith$elm_ui$Element$alpha = function (o) {
        var transparency = function (x) {
            return 1 - x;
        }($elm$core$Basics$min_fn(1, $elm$core$Basics$max_fn(0, o)));
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$transparency, $mdgriffith$elm_ui$Internal$Model$Transparency_fn("transparency-" + $mdgriffith$elm_ui$Internal$Model$floatClass(transparency), transparency));
    };
    var $mdgriffith$elm_ui$Element$Input$charcoal = $mdgriffith$elm_ui$Element$rgb_fn(136 / 255, 138 / 255, 133 / 255);
    var $mdgriffith$elm_ui$Element$rgba = $mdgriffith$elm_ui$Internal$Model$Rgba;
    var $mdgriffith$elm_ui$Element$Input$renderPlaceholder_fn = function (_v0, forPlaceholder, on) {
        var placeholderAttrs = _v0.a;
        var placeholderEl = _v0.b;
        return $mdgriffith$elm_ui$Element$el_fn(_Utils_ap(forPlaceholder, _Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$Input$charcoal),
            $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.$9 + (" " + $mdgriffith$elm_ui$Internal$Style$classes.nK)),
            $mdgriffith$elm_ui$Element$clip,
            $mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Internal$Model$Rgba_fn(0, 0, 0, 0)),
            $mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Internal$Model$Rgba_fn(0, 0, 0, 0)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$alpha(on ? 1 : 0)
        ]), placeholderAttrs)), placeholderEl);
    }, $mdgriffith$elm_ui$Element$Input$renderPlaceholder = F3($mdgriffith$elm_ui$Element$Input$renderPlaceholder_fn);
    var $mdgriffith$elm_ui$Element$scrollbarY = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.on);
    var $elm$html$Html$span = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "span"), $elm$html$Html$span_fn = $elm$html$Html$span.a2;
    var $elm$html$Html$Attributes$spellcheck_a0 = "spellcheck", $elm$html$Html$Attributes$spellcheck = $elm$html$Html$Attributes$boolProperty($elm$html$Html$Attributes$spellcheck_a0);
    var $mdgriffith$elm_ui$Element$Input$spellcheck_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Input$spellcheck_a1 = $elm$html$Html$Attributes$spellcheck, $mdgriffith$elm_ui$Element$Input$spellcheck = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Input$spellcheck_a0, $mdgriffith$elm_ui$Element$Input$spellcheck_a1);
    var $elm$html$Html$Attributes$type__a0 = "type", $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$type__a0);
    var $elm$html$Html$Attributes$value_a0 = "value", $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$value_a0);
    var $mdgriffith$elm_ui$Element$Input$value_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Input$value_a1 = $elm$html$Html$Attributes$value, $mdgriffith$elm_ui$Element$Input$value = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Input$value_a0, $mdgriffith$elm_ui$Element$Input$value_a1);
    var $mdgriffith$elm_ui$Element$Input$textHelper_fn = function (textInput, attrs, textOptions) {
        var withDefaults = _Utils_ap($mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle, attrs);
        var redistributed = $mdgriffith$elm_ui$Element$Input$redistribute_fn(_Utils_eq(textInput.D, $mdgriffith$elm_ui$Element$Input$TextArea), $mdgriffith$elm_ui$Element$Input$isStacked(textOptions.fF), withDefaults);
        var onlySpacing = function (attr) {
            if ((attr.$ === 4) && (attr.b.$ === 5)) {
                var _v9 = attr.b;
                return true;
            }
            else {
                return false;
            }
        };
        var heightConstrained = function () {
            var _v7 = textInput.D;
            if (!_v7.$) {
                var inputType = _v7.a;
                return false;
            }
            else {
                return $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn($mdgriffith$elm_ui$Element$Input$isConstrained, $elm$core$List$head($elm$core$List$reverse($elm$core$List$filterMap_fn($mdgriffith$elm_ui$Element$Input$getHeight, withDefaults)))));
            }
        }();
        var getPadding = function (attr) {
            if ((attr.$ === 4) && (attr.b.$ === 7)) {
                var cls = attr.a;
                var _v6 = attr.b;
                var pad = _v6.a;
                var t = _v6.b;
                var r = _v6.c;
                var b = _v6.d;
                var l = _v6.e;
                return $elm$core$Maybe$Just((new $$Record115($elm$core$Basics$max_fn(0, $elm$core$Basics$floor(b - 3)), $elm$core$Basics$max_fn(0, $elm$core$Basics$floor(l - 3)), $elm$core$Basics$max_fn(0, $elm$core$Basics$floor(r - 3)), $elm$core$Basics$max_fn(0, $elm$core$Basics$floor(t - 3)))));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        };
        var parentPadding = $elm$core$Maybe$withDefault_fn((new $$Record115(0, 0, 0, 0)), $elm$core$List$head($elm$core$List$reverse($elm$core$List$filterMap_fn(getPadding, withDefaults))));
        var inputElement = $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, function () {
            var _v3 = textInput.D;
            if (!_v3.$) {
                var inputType = _v3.a;
                return $mdgriffith$elm_ui$Internal$Model$NodeName("input");
            }
            else {
                return $mdgriffith$elm_ui$Internal$Model$NodeName("textarea");
            }
        }(), _Utils_ap(function () {
            var _v4 = textInput.D;
            if (!_v4.$) {
                var inputType = _v4.a;
                return _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$type__a0, inputType)),
                    $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mm)
                ]);
            }
            else {
                return _List_fromArray([
                    $mdgriffith$elm_ui$Element$clip,
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mi),
                    $mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding(withDefaults),
                    $mdgriffith$elm_ui$Element$paddingEach(parentPadding),
                    $mdgriffith$elm_ui$Internal$Model$Attr(_VirtualDom_style_fn("margin", $mdgriffith$elm_ui$Element$Input$renderBox($mdgriffith$elm_ui$Element$Input$negateBox(parentPadding)))),
                    $mdgriffith$elm_ui$Internal$Model$Attr(_VirtualDom_style_fn("box-sizing", "content-box"))
                ]);
            }
        }(), _Utils_ap(_List_fromArray([
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Input$value_a0, $mdgriffith$elm_ui$Element$Input$value_a1, textOptions.jn),
            $mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Events$onInput(textOptions.nu)),
            $mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(textOptions.fF),
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Input$spellcheck_a0, $mdgriffith$elm_ui$Element$Input$spellcheck_a1, textInput.aj),
            $elm$core$Maybe$withDefault_fn($mdgriffith$elm_ui$Internal$Model$NoAttribute, $elm$core$Maybe$map_fn($mdgriffith$elm_ui$Element$Input$autofill, textInput.Z))
        ]), redistributed.x)), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil));
        var wrappedInput = function () {
            var _v0 = textInput.D;
            if (_v0.$ === 1) {
                return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, _Utils_ap((heightConstrained ? $elm$core$List$cons($mdgriffith$elm_ui$Element$scrollbarY) : $elm$core$Basics$identity)(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $elm$core$List$any_fn($mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.hv),
                    $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.ml)
                ])), redistributed.nJ), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asParagraph, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$inFront(inputElement), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mk), redistributed.cy)))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(function () {
                        if (textOptions.jn === "") {
                            var _v1 = textOptions.fV;
                            if (_v1.$ === 1) {
                                return _List_fromArray([
                                    $mdgriffith$elm_ui$Element$text("\u00A0")
                                ]);
                            }
                            else {
                                var place = _v1.a;
                                return _List_fromArray([
                                    $mdgriffith$elm_ui$Element$Input$renderPlaceholder_fn(place, _List_Nil, textOptions.jn === "")
                                ]);
                            }
                        }
                        else {
                            return _List_fromArray([
                                $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Internal$Model$unstyled_a0, $mdgriffith$elm_ui$Internal$Model$unstyled_a1, $elm$html$Html$span_fn(_List_fromArray([
                                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $mdgriffith$elm_ui$Internal$Style$classes.mj)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(textOptions.jn + "\u00A0")
                                ])))
                            ]);
                        }
                    }()))
                ])));
            }
            else {
                var inputType = _v0.a;
                return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill), _List_Cons($elm$core$List$any_fn($mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.hv), $elm$core$List$concat(_List_fromArray([
                    redistributed.nJ,
                    function () {
                        var _v2 = textOptions.fV;
                        if (_v2.$ === 1) {
                            return _List_Nil;
                        }
                        else {
                            var place = _v2.a;
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Element$behindContent($mdgriffith$elm_ui$Element$Input$renderPlaceholder_fn(place, redistributed.L, textOptions.jn === ""))
                            ]);
                        }
                    }()
                ])))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([inputElement])));
            }
        }();
        return $mdgriffith$elm_ui$Element$Input$applyLabel_fn(_List_Cons($mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.la), _List_Cons($mdgriffith$elm_ui$Element$Input$isHiddenLabel(textOptions.fF) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Element$spacing(5), _List_Cons($mdgriffith$elm_ui$Element$Region$announce, redistributed.o))), textOptions.fF, wrappedInput);
    }, $mdgriffith$elm_ui$Element$Input$textHelper = F3($mdgriffith$elm_ui$Element$Input$textHelper_fn);
    var $mdgriffith$elm_ui$Element$Input$text_a0 = {
        Z: $elm$core$Maybe$Nothing,
        aj: false,
        D: $mdgriffith$elm_ui$Element$Input$TextInputNode("text")
    }, $mdgriffith$elm_ui$Element$Input$text = $mdgriffith$elm_ui$Element$Input$textHelper($mdgriffith$elm_ui$Element$Input$text_a0);
    var $author$project$View$Util$when_fn = function (condition, el) {
        return condition ? el : $mdgriffith$elm_ui$Element$none;
    }, $author$project$View$Util$when = F2($author$project$View$Util$when_fn);
    var $author$project$View$Dialog$Closeable$editNoteTime_fn = function (env, noteId, newTime) {
        var newTimeParsed = $author$project$Data$Time$Parser$parse_fn({
            bI: $justinmimbs$date$Date$fromPosix_fn(env.pu, env.k5),
            gw: env.pu
        }, newTime);
        var updateNoteTime = function (note) {
            var noteTime = $elm$core$Maybe$withDefault_fn(note.gh, newTimeParsed);
            return function () {
                var $r = note.$c();
                $r.fh = function () {
                    if (noteTime.$ === 1) {
                        var d = noteTime.a;
                        return $author$project$Data$Time$Date($justinmimbs$date$Date$add_fn(3, 1, d));
                    }
                    else {
                        return noteTime;
                    }
                }();
                $r.gh = noteTime;
                return $r;
            }();
        };
        var submitMsg = $author$project$Model$HandleBacktalk($author$project$Env$Tantrum(_List_fromArray([
            $author$project$Env$UpdateNote((new $$Record77(false, noteId, updateNoteTime))),
            $author$project$Env$SetDialog($elm$core$Maybe$Nothing),
            $author$project$Env$AnalyticsEvent($author$project$Analytics$NoteAdHocTimeAdjusted)
        ])));
        var onKeyDown = $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$custom_fn("keydown", _Json_map1_fn(function (msg) {
            return { m_: msg, nU: true, oU: true };
        }, _Json_andThen_fn(function (event) {
            var _v1 = event.mC;
            if (_v1 === "Enter") {
                return $elm$json$Json$Decode$succeed(submitMsg);
            }
            else {
                return $elm$json$Json$Decode$fail("matching keypress not found");
            }
        }, $author$project$Data$Keypress$decoder))));
        var isShowArmyTime = $elm$core$Basics$composeR_fn($author$project$Data$Settings$isShowArmyTime_a0, $author$project$Data$Settings$isShowArmyTime_a1, env);
        return function () {
            var $r = $author$project$View$Dialog$Common$closeable.$c();
            $r.b3 = _Utils_eq(newTimeParsed, $elm$core$Maybe$Nothing);
            $r.cJ = true;
            $r.dG = $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$Input$textHelper_fn($mdgriffith$elm_ui$Element$Input$text_a0, _List_fromArray([
                    onKeyDown,
                    $author$project$View$Util$preventKeypressPropagation($author$project$Model$NoOp),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$Background$color(env.nI.dw),
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.cI),
                    $elm$core$Basics$composeL_fn($author$project$View$Util$id_a0, $author$project$View$Util$id_a1, $author$project$View$Dialog$BaseDialog$textFieldId)
                ]), {
                    fF: $mdgriffith$elm_ui$Element$Input$labelHidden("New note time"),
                    nu: $author$project$Model$UpdateEditNoteTime,
                    fV: $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$Input$Placeholder_fn(_List_Nil, $mdgriffith$elm_ui$Element$text("e.g., 3pm yesterday"))),
                    jn: newTime
                }),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(20)),
                    $mdgriffith$elm_ui$Element$Font$size(16)
                ]), $author$project$View$Util$when_fn(!$elm$core$String$isEmpty($elm$core$String$trim(newTime)), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$padding(5)
                ]), function () {
                    if (!newTimeParsed.$) {
                        var t = newTimeParsed.a;
                        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.d1)
                        ]), $mdgriffith$elm_ui$Element$text("\u2192  " + ($author$project$Data$Time$isDate(t) ? A2($author$project$Util$Time$monthDayYearFormatter, env.pu, $author$project$Data$Time$toPosix_fn(env.pu, t)) : $author$project$Util$Time$monthDayYearTimeFormatterHumanized_fn(isShowArmyTime, env.pu, env.k5, $author$project$Data$Time$toPosix_fn(env.pu, t)))));
                    }
                    else {
                        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.eg)
                        ]), $mdgriffith$elm_ui$Element$text("Unrecognized time."));
                    }
                }())))
            ]));
            $r.de = $elm$core$Maybe$Just(_Utils_Tuple2("UPDATE", submitMsg));
            $r.gj = $elm$core$Maybe$Just("Enter new time");
            $r.i5 = $elm$core$Maybe$Just(_Utils_Tuple2("Cancel", $author$project$View$Dialog$Common$closeDialog));
            return $r;
        }();
    }, $author$project$View$Dialog$Closeable$editNoteTime = F3($author$project$View$Dialog$Closeable$editNoteTime_fn);
    var $author$project$View$Icon$DuoTone = 3;
    var $author$project$View$Dialog$Common$onboardingIcon = function (palette) {
        return A2($author$project$View$Icon$icon, _List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(40),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$paddingXY_fn(0, 15),
            $mdgriffith$elm_ui$Element$Font$color(palette.d0)
        ]), 3);
    };
    var $author$project$View$Dialog$Closeable$errorConnectingToStripe = function (env) {
        return function () {
            var $r = $author$project$View$Dialog$Common$closeable.$c();
            $r.dG = $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$center,
                $mdgriffith$elm_ui$Element$spacing(20)
            ]), _List_fromArray([
                A2($author$project$View$Dialog$Common$onboardingIcon, env.nI, "outlet"),
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Sorry!")
                ])),
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("An error occurred while connecting to Stripe. Our developers have been notified.")
                ])),
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Feel free to contact our team at "),
                    $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.a2)
                    ]), {
                        fF: $mdgriffith$elm_ui$Element$text("support@witful.com"),
                        dt: "mailto:support@witful.com"
                    })
                ]))
            ]));
            $r.de = $elm$core$Maybe$Just(_Utils_Tuple2("Close", $author$project$View$Dialog$Common$closeDialog));
            $r.jJ = $mdgriffith$elm_ui$Element$px(450);
            return $r;
        }();
    };
    var $author$project$View$Dialog$Closeable$errorSubmittingFeedback = function (env) {
        return $$update__dG__de($author$project$View$Dialog$Common$closeable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(20),
            $mdgriffith$elm_ui$Element$Font$center
        ]), _List_fromArray([
            A2($author$project$View$Dialog$Common$onboardingIcon, env.nI, "outlet"),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$text("Sorry!")
            ])),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$text("An error occurred while sending feedback. Our developers have been notified.")
            ])),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$text("Feel free to contact our team at "),
                $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.a2)
                ]), {
                    fF: $mdgriffith$elm_ui$Element$text("support@witful.com"),
                    dt: "mailto:support@witful.com"
                })
            ]))
        ])), $elm$core$Maybe$Just(_Utils_Tuple2("Dismiss", $author$project$View$Dialog$Common$closeDialog)));
    };
    var $author$project$Data$Dialog$Closeable$FeedbackForm = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$Dialog$Closeable$FeedbackIssue = 0;
    var $author$project$Data$Dialog$Closeable$FeedbackQuestion = 2;
    var $author$project$Data$Dialog$Closeable$FeedbackSuggestion = 1;
    var $author$project$Model$SubmitFeedback_fn = function (a, b) {
        return { $: 36, a: a, b: b };
    }, $author$project$Model$SubmitFeedback = F2($author$project$Model$SubmitFeedback_fn);
    var $author$project$Env$UpdateFeedbackFormContent = function (a) {
        return { $: 22, a: a };
    };
    var $elm_community$list_extra$List$Extra$getAt_fn = function (idx, xs) {
        return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head($elm$core$List$drop_fn(idx, xs));
    }, $elm_community$list_extra$List$Extra$getAt = F2($elm_community$list_extra$List$Extra$getAt_fn);
    var $elm$html$Html$option = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "option"), $elm$html$Html$option_fn = $elm$html$Html$option.a2;
    var $elm$html$Html$select = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "select"), $elm$html$Html$select_fn = $elm$html$Html$select.a2;
    var $elm$html$Html$Attributes$selected_a0 = "selected", $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty($elm$html$Html$Attributes$selected_a0);
    var $author$project$Lib$DropDown$dropdown_fn = function (attrs, _v0) {
        var options = _v0.nE;
        var current = _v0.k3;
        var onChange = _v0.nu;
        var noOp = _v0.nf;
        return $mdgriffith$elm_ui$Element$el_fn(attrs, $mdgriffith$elm_ui$Element$html($elm$html$Html$select_fn(_List_fromArray([
            $elm$html$Html$Events$onInput(function (index) {
                return $elm$core$Maybe$withDefault_fn(noOp, $elm$core$Maybe$map_fn(function (_v2) {
                    var option = _v2.b;
                    return onChange(option);
                }, $elm$core$Maybe$andThen_fn(function (i) {
                    return $elm_community$list_extra$List$Extra$getAt_fn(i, options);
                }, $elm$core$String$toInt(index))));
            }),
            _VirtualDom_style_fn("width", "100%"),
            _VirtualDom_style_fn("height", "100%")
        ]), $elm$core$List$indexedMap_fn_unwrapped(function (index, _v1) {
            var text = _v1.a;
            var option = _v1.b;
            return $elm$html$Html$option_fn(_List_fromArray([
                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$value_a0, $elm$core$String$fromInt(index)),
                $elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$selected_a0, _Utils_eq(option, current))
            ]), _List_fromArray([
                $elm$html$Html$text(text)
            ]));
        }, options))));
    }, $author$project$Lib$DropDown$dropdown = F2($author$project$Lib$DropDown$dropdown_fn);
    var $mdgriffith$elm_ui$Element$Input$multiline_fn = function (attrs, multi) {
        return $mdgriffith$elm_ui$Element$Input$textHelper_fn({ Z: $elm$core$Maybe$Nothing, aj: multi.oL, D: $mdgriffith$elm_ui$Element$Input$TextArea }, attrs, { fF: multi.fF, nu: multi.nu, fV: multi.fV, jn: multi.jn });
    }, $mdgriffith$elm_ui$Element$Input$multiline = F2($mdgriffith$elm_ui$Element$Input$multiline_fn);
    var $author$project$View$Dialog$Closeable$feedbackForm_fn = function (palette, kind, feedback) {
        var setKind = A2($elm$core$Basics$composeR, $author$project$Data$Dialog$Closeable$FeedbackForm, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, $author$project$Env$SetDialog, $author$project$Model$HandleBacktalk)));
        var setFeedbackContent = A2($elm$core$Basics$composeR, $author$project$Env$UpdateFeedbackFormContent, $author$project$Model$HandleBacktalk);
        return function () {
            var $r = $author$project$View$Dialog$Common$closeable.$c();
            $r.cJ = true;
            $r.dG = $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$spacing(20)
            ]), _List_fromArray([
                $author$project$Lib$DropDown$dropdown_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), (new $$Record119(kind, $author$project$Model$NoOp("Feedback dropdown noop"), function (choice) {
                    return setKind(choice);
                }, _List_fromArray([
                    _Utils_Tuple2("Issue", 0),
                    _Utils_Tuple2("Suggestion", 1),
                    _Utils_Tuple2("Question", 2)
                ])))),
                $mdgriffith$elm_ui$Element$Input$multiline_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(200)),
                    $mdgriffith$elm_ui$Element$Font$size(15),
                    $elm$core$Basics$composeL_fn($author$project$View$Util$id_a0, $author$project$View$Util$id_a1, $author$project$View$Dialog$BaseDialog$textFieldId),
                    $mdgriffith$elm_ui$Element$Background$color(palette.dw),
                    $mdgriffith$elm_ui$Element$Font$color(palette.cI)
                ]), {
                    fF: $mdgriffith$elm_ui$Element$Input$labelHidden("Enter feedback here."),
                    nu: setFeedbackContent,
                    fV: $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$Input$Placeholder_fn(_List_Nil, $mdgriffith$elm_ui$Element$text("Here's some feedback..."))),
                    oL: false,
                    jn: feedback
                })
            ]));
            $r.de = $elm$core$Maybe$Just(_Utils_Tuple2("Send", $author$project$Model$SubmitFeedback_fn(kind, feedback)));
            $r.gj = $elm$core$Maybe$Just("Send us feedback!");
            $r.i5 = $elm$core$Maybe$Just(_Utils_Tuple2("Close", $author$project$View$Dialog$Common$closeDialog));
            return $r;
        }();
    }, $author$project$View$Dialog$Closeable$feedbackForm = F3($author$project$View$Dialog$Closeable$feedbackForm_fn);
    var $author$project$Content$Videos$howToUseWitful = "https://www.youtube.com/embed/Q-_JT1cP-y8?rel=0";
    var $mdgriffith$elm_ui$Internal$Model$Monospace = { $: 2 };
    var $mdgriffith$elm_ui$Element$Font$monospace = $mdgriffith$elm_ui$Internal$Model$Monospace;
    var $author$project$View$ActionItems$chipHelp_fn = function (extraAttrs, str) {
        return $mdgriffith$elm_ui$Element$el_fn(_Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$family(_List_fromArray([$mdgriffith$elm_ui$Element$Font$monospace])),
            $mdgriffith$elm_ui$Element$Border$rounded(3),
            $mdgriffith$elm_ui$Element$Font$size(13),
            $mdgriffith$elm_ui$Element$Font$regular,
            $mdgriffith$elm_ui$Element$paddingEach((new $$Record115(2, 2, 4, 2)))
        ]), extraAttrs), $mdgriffith$elm_ui$Element$text(str));
    }, $author$project$View$ActionItems$chipHelp = F2($author$project$View$ActionItems$chipHelp_fn);
    var $author$project$View$ActionItems$keyShortcutChip_fn = function (palette, greyScale) {
        return $author$project$View$ActionItems$chipHelp(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$letterSpacing(-1.7),
            $mdgriffith$elm_ui$Element$Background$color($author$project$Util$Misc$if__fn(greyScale, palette.aM, palette.dA)),
            $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn(greyScale, palette.aR, palette.dC)),
            $mdgriffith$elm_ui$Element$Border$color($author$project$Util$Misc$if__fn(greyScale, palette.aR, palette.dC)),
            $mdgriffith$elm_ui$Element$Border$width(1)
        ]));
    }, $author$project$View$ActionItems$keyShortcutChip = F2($author$project$View$ActionItems$keyShortcutChip_fn);
    var $author$project$View$ActionItems$mentionChip_fn = function (palette, greyScale) {
        return $author$project$View$ActionItems$chipHelp(_List_fromArray([
            $mdgriffith$elm_ui$Element$Background$color($author$project$Util$Misc$if__fn(greyScale, palette.aS, palette.a3)),
            $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn(greyScale, palette.aM, palette.a2))
        ]));
    }, $author$project$View$ActionItems$mentionChip = F2($author$project$View$ActionItems$mentionChip_fn);
    var $author$project$View$Dialog$Closeable$howToUseWitfulVideo = function (env) {
        var mentionChip = $author$project$View$ActionItems$mentionChip_fn(env.nI, false);
        var keyShortcutChip = $author$project$View$ActionItems$keyShortcutChip_fn(env.nI, false);
        return $$update__dG__dL__jJ($author$project$View$Dialog$Common$closeable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(30)
        ]), _List_fromArray([
            A3($author$project$View$Styling$h2, env.nI, _List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $author$project$View$Styling$paddingBottom(15)
            ]), "Learn Witful in 1 minute"),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]), $author$project$View$Widgets$youtubeVideo({
                oM: $author$project$Content$Videos$howToUseWitful,
                p2: $elm$core$Basics$floor(env.p1.p1.jJ)
            })),
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $author$project$View$Styling$paddingBottom(10),
                $mdgriffith$elm_ui$Element$spacing(15),
                $mdgriffith$elm_ui$Element$Font$size(15)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(8),
                    $mdgriffith$elm_ui$Element$centerX
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Type "),
                    keyShortcutChip("??"),
                    $mdgriffith$elm_ui$Element$text(" in your note to surface current topics.")
                ]))),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(8),
                    $mdgriffith$elm_ui$Element$Font$size(15)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Combine "),
                    mentionChip("@person"),
                    $mdgriffith$elm_ui$Element$text(", "),
                    mentionChip("#meeting"),
                    $mdgriffith$elm_ui$Element$text(", and "),
                    keyShortcutChip("!!"),
                    $mdgriffith$elm_ui$Element$text(" in your note to surface items in upcoming meetings.")
                ])))
            ]))
        ])), $elm$core$Maybe$Just($author$project$View$Dialog$Common$closeDialog), $mdgriffith$elm_ui$Element$maximum_fn(900, $mdgriffith$elm_ui$Element$fill));
    };
    var $author$project$View$Layout$breakpoints = { m6: 430, oD: 965 };
    var $author$project$View$Responsive$DoubleColumn = 0;
    var $author$project$View$Responsive$Mobile = 2;
    var $author$project$View$Responsive$SingleColumn = 1;
    var $author$project$View$Responsive$mode_fn = function (_v0, _v1) {
        var singleColumn = _v0.oD;
        var mobile = _v0.m6;
        var viewport = _v1.p1;
        return (_Utils_cmp(viewport.jJ, mobile) < 1) ? 2 : ((_Utils_cmp(viewport.jJ, singleColumn) < 1) ? 1 : 0);
    }, $author$project$View$Responsive$mode = F2($author$project$View$Responsive$mode_fn);
    var $author$project$View$Icon$Light = 2;
    var $elm$html$Html$Attributes$classList = function (classes) {
        return $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $elm$core$String$join_fn(" ", $elm$core$List$map_fn($elm$core$Tuple$first, $elm$core$List$filter_fn($elm$core$Tuple$second, classes))));
    };
    var $author$project$View$Util$attrNone = $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Attributes$classList(_List_Nil));
    var $author$project$View$Util$attrWhen_fn = function (condition, attr) {
        return condition ? attr : $author$project$View$Util$attrNone;
    }, $author$project$View$Util$attrWhen = F2($author$project$View$Util$attrWhen_fn);
    var $author$project$View$Util$draggable = function (flag) {
        return $author$project$View$Util$attribute_fn("draggable", $author$project$Util$Misc$if__fn(flag, "true", "false"));
    };
    var $author$project$View$Widgets$baseChipAttrs = _List_fromArray([
        $mdgriffith$elm_ui$Element$paddingXY_fn(3, 1),
        $mdgriffith$elm_ui$Element$Border$rounded(4),
        $mdgriffith$elm_ui$Element$Font$size(14),
        $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "no-wrap-within-paragraph"),
        $author$project$View$Util$draggable(false)
    ]);
    var $mdgriffith$elm_ui$Element$moveDown = function (y) {
        return $mdgriffith$elm_ui$Internal$Model$TransformComponent_fn($mdgriffith$elm_ui$Internal$Flag$moveY, $mdgriffith$elm_ui$Internal$Model$MoveY(y));
    };
    var $author$project$View$Widgets$actionItemChip_fn = function (palette, _v0, string) {
        var makeLink = _v0.mQ;
        var isComplete = _v0.mt;
        var isPriority = _v0.my;
        var actionItemChipAttrs = function () {
            var _v1 = _Utils_Tuple2(isComplete, isPriority);
            if (!_v1.b) {
                if (!_v1.a) {
                    return _List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(palette.a2),
                        $mdgriffith$elm_ui$Element$Border$color(palette.a4)
                    ]);
                }
                else {
                    return _List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(palette.aR),
                        $mdgriffith$elm_ui$Element$Border$color(palette.aR)
                    ]);
                }
            }
            else {
                return _List_fromArray([
                    $mdgriffith$elm_ui$Element$Background$color(palette.eW(1)),
                    $mdgriffith$elm_ui$Element$Font$color(palette.eV(1)),
                    $mdgriffith$elm_ui$Element$Border$color(palette.eV(1))
                ]);
            }
        }();
        var attrs = _Utils_ap(actionItemChipAttrs, _Utils_ap($author$project$View$Widgets$baseChipAttrs, _List_fromArray([
            $mdgriffith$elm_ui$Element$Border$width(1),
            $mdgriffith$elm_ui$Element$Font$regular,
            $mdgriffith$elm_ui$Element$Font$size(13),
            $mdgriffith$elm_ui$Element$paddingXY_fn(3, 1),
            $mdgriffith$elm_ui$Element$spacing(2)
        ])));
        var viewHelp = function (str) {
            var innerElAttrs = _List_fromArray([
                $author$project$View$Util$attrWhen_fn(isComplete, $mdgriffith$elm_ui$Element$paddingEach((new $$Record115(0, 15, 0, 0)))),
                $mdgriffith$elm_ui$Element$inFront($author$project$View$Util$when_fn(isComplete, $author$project$View$Icon$icon_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(12),
                    $mdgriffith$elm_ui$Element$moveDown(3)
                ]), 2, "check"))),
                $author$project$View$Util$draggable(false)
            ]);
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$paddingXY_fn(3, 0)
            ]), $mdgriffith$elm_ui$Element$el_fn(attrs, makeLink ? $mdgriffith$elm_ui$Element$link_fn(innerElAttrs, {
                fF: $mdgriffith$elm_ui$Element$text(str),
                dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteThreads($author$project$Routing$defaultThreadsParams))
            }) : $mdgriffith$elm_ui$Element$el_fn(innerElAttrs, $mdgriffith$elm_ui$Element$text(str))));
        };
        return viewHelp(string);
    }, $author$project$View$Widgets$actionItemChip = F3($author$project$View$Widgets$actionItemChip_fn);
    var $mdgriffith$elm_ui$Element$Font$extraBold = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.pb);
    var $elm$html$Html$Attributes$target_a0 = "target", $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$target_a0);
    var $mdgriffith$elm_ui$Element$newTabLink_fn = function (attrs, _v0) {
        var url = _v0.dt;
        var label = _v0.fF;
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$NodeName("a"), _List_Cons($mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$href(url)), _List_Cons($mdgriffith$elm_ui$Internal$Model$Attr(_VirtualDom_attribute_fn($elm$html$Html$Attributes$rel_a0, "noopener noreferrer")), _List_Cons($mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$target_a0, "_blank")), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.dP + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.aD + (" " + $mdgriffith$elm_ui$Internal$Style$classes.h1)))), attrs)))))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([label])));
    }, $mdgriffith$elm_ui$Element$newTabLink = F2($mdgriffith$elm_ui$Element$newTabLink_fn);
    var $author$project$View$Styling$paddingRight = function (amount) {
        return $mdgriffith$elm_ui$Element$paddingEach(function () {
            var $r = $author$project$View$Styling$edges.$c();
            $r.oc = amount;
            return $r;
        }());
    };
    var $author$project$View$Shortcut$viewBigKey_fn = function (palette, key) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Border$rounded(4),
            $mdgriffith$elm_ui$Element$paddingXY_fn(0, 12),
            $mdgriffith$elm_ui$Element$Background$color(palette.aO),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(45)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(26)),
            $mdgriffith$elm_ui$Element$Font$color(palette.aS),
            $mdgriffith$elm_ui$Element$Font$size(14),
            $mdgriffith$elm_ui$Element$Font$semiBold
        ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$moveUp(6)
        ]), $mdgriffith$elm_ui$Element$text(key)));
    }, $author$project$View$Shortcut$viewBigKey = F2($author$project$View$Shortcut$viewBigKey_fn);
    var $author$project$View$Shortcut$shortcutRow_fn = function (palette, _v0) {
        var key = _v0.mC;
        var longDesc = _v0.q;
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacingXY_fn(20, 0),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(16)
            ]), $mdgriffith$elm_ui$Element$text(longDesc)),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$alignRight,
                $author$project$View$Styling$paddingRight(25)
            ]), $author$project$View$Shortcut$viewBigKey_fn(palette, key))
        ]));
    }, $author$project$View$Shortcut$shortcutRow = F2($author$project$View$Shortcut$shortcutRow_fn);
    var $author$project$Content$Videos$smartTags = "https://www.youtube.com/embed/V75JLJgqH0M?rel=0";
    var $author$project$View$Shortcut$keypressLegend_fn = function (palette, mode) {
        var subText = function (s) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(12),
                $mdgriffith$elm_ui$Element$Font$color(palette.aR)
            ]), $mdgriffith$elm_ui$Element$text(s));
        };
        var styledColumn = $mdgriffith$elm_ui$Element$column(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(30),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(320)),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$alignTop,
            $mdgriffith$elm_ui$Element$padding(10),
            $mdgriffith$elm_ui$Element$Font$color(palette.aU)
        ]));
        var responsiveEl = $author$project$Util$Misc$if__fn(!mode, $mdgriffith$elm_ui$Element$row, $mdgriffith$elm_ui$Element$column);
        var noteShortcutRow = F3(function (key, line1, line2) {
            return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacingXY_fn(20, 0),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(5),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(16)
                    ]), line1),
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        subText(line2)
                    ]))
                ])),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$alignRight,
                    $author$project$View$Styling$paddingRight(25)
                ]), $author$project$View$Shortcut$viewBigKey_fn(palette, key))
            ]));
        });
        var mentionChip = function (string) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(palette.dA),
                $mdgriffith$elm_ui$Element$Font$color(palette.dC),
                $mdgriffith$elm_ui$Element$paddingXY_fn(4, 3),
                $mdgriffith$elm_ui$Element$Border$rounded(4),
                $mdgriffith$elm_ui$Element$Font$size(14)
            ]), $mdgriffith$elm_ui$Element$text(string));
        };
        var internalSpacing = $mdgriffith$elm_ui$Element$spacingXY_fn(0, 12);
        var headerRow = function (string) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.cd),
                $mdgriffith$elm_ui$Element$Font$extraBold,
                $mdgriffith$elm_ui$Element$paddingXY_fn(0, 9)
            ]), $mdgriffith$elm_ui$Element$text(string));
        };
        return A2(responsiveEl, _List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(16),
            $mdgriffith$elm_ui$Element$centerX
        ]), _List_fromArray([
            styledColumn(_List_fromArray([
                $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(0)
                ]), _List_fromArray([
                    headerRow("Smart Tags"),
                    subText("Use these shortcuts within the text of your notes")
                ])),
                A3(noteShortcutRow, "!!", $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Create a "),
                    $author$project$View$Widgets$actionItemChip_fn(palette, { mt: false, my: false, mQ: false }, "to-do")
                ])), "Displays on home and all follow up lists"),
                A3(noteShortcutRow, "!!!", $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Create a high-priority "),
                    $author$project$View$Widgets$actionItemChip_fn(palette, { mt: false, my: false, mQ: false }, "to-do")
                ])), "Displays at the top of your todos"),
                A3(noteShortcutRow, "??", $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Create a "),
                    $author$project$View$Widgets$actionItemChip_fn(palette, { mt: false, my: false, mQ: false }, "topic")
                ])), "Displays in series meetings"),
                A3(noteShortcutRow, "#", $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Reference a "),
                    mentionChip("#meeting")
                ])), "Create a meeting-specific follow up"),
                A3(noteShortcutRow, "@", $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Mention a "),
                    mentionChip("@person")
                ])), "Associate note content with a person"),
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(14)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$newTabLink_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(palette.a6),
                        $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(palette.a4)
                        ]))
                    ]), {
                        fF: $mdgriffith$elm_ui$Element$text("Learn more"),
                        dt: $author$project$Content$Videos$smartTags
                    }),
                    $mdgriffith$elm_ui$Element$text(" about Smart Tags and how to combine them in powerful ways.")
                ]))
            ])),
            styledColumn(_List_fromArray([
                $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    internalSpacing,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), _List_fromArray([
                    headerRow("Global Shortcuts"),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.hD),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.f0),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.hJ),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.gV),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.po),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.k4),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.jV),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.be)
                ])),
                $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    internalSpacing,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), _List_fromArray([
                    headerRow("Note Page"),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.jG),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.hd)
                ]))
            ])),
            styledColumn(_List_fromArray([
                $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    internalSpacing,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), _List_fromArray([
                    headerRow("Home Page"),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.il),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.iH),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.g0)
                ])),
                $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    internalSpacing,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), _List_fromArray([
                    headerRow("Calendar Page"),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.im),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.iI),
                    $author$project$View$Shortcut$shortcutRow_fn(palette, $author$project$Data$Shortcut$keys.g2)
                ]))
            ]))
        ]));
    }, $author$project$View$Shortcut$keypressLegend = F2($author$project$View$Shortcut$keypressLegend_fn);
    var $mdgriffith$elm_ui$Element$Font$light = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.pg);
    var $author$project$View$Util$tabIndex = function (mIndex) {
        return $author$project$View$Util$attribute_fn("tabindex", $elm$core$String$fromInt($elm$core$Maybe$withDefault_fn(-1, mIndex)));
    };
    var $author$project$View$Shortcut$view_fn = function (palette, mode) {
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(10),
            $mdgriffith$elm_ui$Element$scrollbarY,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(15),
                $mdgriffith$elm_ui$Element$paddingXY_fn(10, 8)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$light,
                    $mdgriffith$elm_ui$Element$Font$size(26)
                ]), $mdgriffith$elm_ui$Element$text("Shortcuts")),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $elm$core$Basics$composeL_fn($author$project$View$Util$id_a0, $author$project$View$Util$id_a1, $author$project$View$Shortcut$focusPoint),
                    $author$project$View$Util$tabIndex($elm$core$Maybe$Just(1))
                ]), $mdgriffith$elm_ui$Element$none),
                $author$project$View$Shortcut$viewBigKey_fn(palette, "?")
            ])),
            $author$project$View$Util$horizontalLine_fn(palette, 1, _List_Nil),
            $author$project$View$Shortcut$keypressLegend_fn(palette, mode)
        ]));
    }, $author$project$View$Shortcut$view = F2($author$project$View$Shortcut$view_fn);
    var $author$project$View$Dialog$Closeable$keyboardShortcuts = function (env) {
        return function () {
            var $r = $author$project$View$Dialog$Common$closeable.$c();
            $r.dG = $author$project$View$Shortcut$view_fn(env.nI, $author$project$View$Responsive$mode_fn($author$project$View$Layout$breakpoints, env.p1));
            $r.dL = $elm$core$Maybe$Just($author$project$View$Dialog$Common$closeDialog);
            $r.dc = 20;
            $r.fo = $mdgriffith$elm_ui$Element$maximum_fn(640, $mdgriffith$elm_ui$Element$px($elm$core$Basics$floor(env.p1.p1.fo - 100)));
            $r.jJ = $mdgriffith$elm_ui$Element$shrink;
            return $r;
        }();
    };
    var $author$project$View$Widgets$contactOurTeam = function (palette) {
        return $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$center,
            $mdgriffith$elm_ui$Element$Font$size(16)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$text("Feel free to contact our team at "),
            $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.a9)
            ]), {
                fF: $mdgriffith$elm_ui$Element$text("support@witful.com"),
                dt: "mailto:support@witful.com"
            })
        ]));
    };
    var $author$project$View$Dialog$Closeable$linkCalendarError_fn = function (palette, authError) {
        var icon = A2($author$project$View$Icon$icon, _List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(40),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$paddingXY_fn(0, 15),
            $mdgriffith$elm_ui$Element$Font$color(palette.er)
        ]), 3);
        var goBackAndAllowAccess = _Utils_Tuple2("Allow access", _List_fromArray([
            icon("check-square"),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$text("Oops! Witful needs your permission to sync with your calendar.")
            ])),
            $author$project$View$Util$spacer(0)
        ]));
        var _v0 = function () {
            switch (authError.$) {
                case 6:
                    var accountEmail = authError.a.jQ;
                    return _Utils_Tuple2("Allow access", _List_fromArray([
                        icon("user-times"),
                        $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$size(16)
                        ]), _List_fromArray([
                            $mdgriffith$elm_ui$Element$text("Oops! The account you logged in with needs to match your calendar's account.")
                        ])),
                        $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$size(16)
                        ]), _List_fromArray([
                            $mdgriffith$elm_ui$Element$text("Be sure to link this account's calendar:")
                        ])),
                        $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(palette.a7),
                            $mdgriffith$elm_ui$Element$centerX
                        ]), $mdgriffith$elm_ui$Element$text(accountEmail)),
                        $author$project$View$Util$spacer(0)
                    ]));
                case 7:
                    return goBackAndAllowAccess;
                case 0:
                    return goBackAndAllowAccess;
                default:
                    return _Utils_Tuple2("Try linking again", _List_fromArray([
                        icon("outlet"),
                        $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                            $mdgriffith$elm_ui$Element$text("Sorry!")
                        ])),
                        $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$center,
                            $mdgriffith$elm_ui$Element$Font$size(16)
                        ]), _List_fromArray([
                            $mdgriffith$elm_ui$Element$text("There was an error linking your calendar. \n Our developers have been notified.")
                        ])),
                        $author$project$View$Widgets$contactOurTeam(palette)
                    ]));
            }
        }();
        var buttonText = _v0.a;
        var elements = _v0.b;
        return function () {
            var $r = $author$project$View$Dialog$Common$closeable.$c();
            $r.dG = $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(20),
                $mdgriffith$elm_ui$Element$Font$center,
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$Font$size(18)
            ]), elements);
            $r.de = $elm$core$Maybe$Just(_Utils_Tuple2(buttonText, $author$project$Model$HandleBacktalk($author$project$Env$LinkCalendar)));
            $r.i5 = $elm$core$Maybe$Just(_Utils_Tuple2("I'll try again later", $author$project$View$Dialog$Common$closeDialog));
            return $r;
        }();
    }, $author$project$View$Dialog$Closeable$linkCalendarError = F2($author$project$View$Dialog$Closeable$linkCalendarError_fn);
    var $author$project$View$Dialog$Closeable$nextMeetingNotFound_fn = function (env, nextMeeting) {
        var mPersonName = function (personId) {
            return $elm$core$Maybe$map_fn(function ($) {
                return $.b;
            }, $author$project$Firestore$Collection$get_fn(personId, env.iz));
        };
        var _v0 = function () {
            switch (nextMeeting.$) {
                case 0:
                    if (nextMeeting.a.$ === 1) {
                        var _v2 = nextMeeting.a;
                        return _Utils_Tuple2("No future meetings", "calendar-times");
                    }
                    else {
                        var personId = nextMeeting.a.a;
                        return $elm$core$Maybe$withDefault_fn(_Utils_Tuple2("Person not found", "user-times"), $elm$core$Maybe$map_fn(function (name) {
                            return _Utils_Tuple2("No future meetings with " + name, "calendar-times");
                        }, mPersonName(personId)));
                    }
                case 1:
                    return _Utils_Tuple2("Next meeting in series not found", "calendar-times");
                default:
                    if (nextMeeting.a === "null") {
                        return _Utils_Tuple2("Missing an @mention in your #next 1-on-1 action item", "at");
                    }
                    else {
                        var personId = nextMeeting.a;
                        return $elm$core$Maybe$withDefault_fn(_Utils_Tuple2("Person not found", "user-times"), $elm$core$Maybe$map_fn(function (name) {
                            return _Utils_Tuple2("No future 1-on-1 with " + name, "calendar-times");
                        }, mPersonName(personId)));
                    }
            }
        }();
        var message = _v0.a;
        var iconName = _v0.b;
        return $$update__dG__de($author$project$View$Dialog$Common$closeable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(25),
            $mdgriffith$elm_ui$Element$Font$center,
            $mdgriffith$elm_ui$Element$centerX
        ]), _List_fromArray([
            $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(40),
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$Font$color(env.nI.eg)
            ]), 3, iconName),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$text(message)
            ]))
        ])), $elm$core$Maybe$Just(_Utils_Tuple2("Dismiss", $author$project$View$Dialog$Common$closeDialog)));
    }, $author$project$View$Dialog$Closeable$nextMeetingNotFound = F2($author$project$View$Dialog$Closeable$nextMeetingNotFound_fn);
    var $author$project$View$Dialog$Closeable$smartTagsVideo = function (env) {
        return $$update__dG__dL__jJ($author$project$View$Dialog$Common$closeable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(30)
        ]), _List_fromArray([
            A3($author$project$View$Styling$h2, env.nI, _List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $author$project$View$Styling$paddingBottom(15)
            ]), "Witful Smart Tags"),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]), $author$project$View$Widgets$youtubeVideo({
                oM: $author$project$Content$Videos$smartTags,
                p2: $elm$core$Basics$floor(env.p1.p1.jJ)
            }))
        ])), $elm$core$Maybe$Just($author$project$View$Dialog$Common$closeDialog), $mdgriffith$elm_ui$Element$maximum_fn(900, $mdgriffith$elm_ui$Element$fill));
    };
    var $author$project$View$Dialog$Closeable$thanksForFeedback = function () {
        var $r = $author$project$View$Dialog$Common$closeable.$c();
        $r.dG = $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(15)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$text("We've received your message and someone from our team will be in touch.")
        ]));
        $r.de = $elm$core$Maybe$Just(_Utils_Tuple2("Done", $author$project$View$Dialog$Common$closeDialog));
        $r.gj = $elm$core$Maybe$Just("We're glad to hear from you!");
        return $r;
    }();
    var $author$project$Content$Videos$videoCalls = "https://www.youtube.com/embed/usHrJjzyrv0?rel=0";
    var $author$project$View$Dialog$Closeable$videoCallVideo = function (env) {
        var keyShortcut = $author$project$View$ActionItems$keyShortcutChip_fn(env.nI, false);
        return $$update__dG__dL__jJ($author$project$View$Dialog$Common$closeable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(30)
        ]), _List_fromArray([
            A3($author$project$View$Styling$h2, env.nI, _List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $author$project$View$Styling$paddingBottom(15)
            ]), "Use Witful with video calls"),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]), $author$project$View$Widgets$youtubeVideo({
                oM: $author$project$Content$Videos$videoCalls,
                p2: $elm$core$Basics$floor(env.p1.p1.jJ)
            })),
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $author$project$View$Styling$paddingBottom(10),
                $mdgriffith$elm_ui$Element$spacing(15),
                $mdgriffith$elm_ui$Element$Font$size(15)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(8),
                    $mdgriffith$elm_ui$Element$centerX
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Press the "),
                    keyShortcut("v"),
                    $mdgriffith$elm_ui$Element$text(" key within the note page to open the video call quickly")
                ])))
            ]))
        ])), $elm$core$Maybe$Just($author$project$View$Dialog$Common$closeDialog), $mdgriffith$elm_ui$Element$maximum_fn(900, $mdgriffith$elm_ui$Element$fill));
    };
    var $author$project$View$Dialog$Closeable$view = function (env) {
        var actionToDialogConfig = function (dialogAction) {
            switch (dialogAction.$) {
                case 0:
                    var noteId = dialogAction.a.ip;
                    var newTime = dialogAction.a.nc;
                    return $author$project$View$Dialog$Closeable$editNoteTime_fn(env, noteId, newTime);
                case 1:
                    var kind = dialogAction.a;
                    return $author$project$View$Dialog$Closeable$feedbackForm_fn(env.nI, kind, env.lD);
                case 2:
                    return $author$project$View$Dialog$Closeable$thanksForFeedback;
                case 3:
                    return $author$project$View$Dialog$Closeable$errorSubmittingFeedback(env);
                case 4:
                    return $author$project$View$Dialog$Closeable$keyboardShortcuts(env);
                case 5:
                    var nextMeeting = dialogAction.a;
                    return $author$project$View$Dialog$Closeable$nextMeetingNotFound_fn(env, nextMeeting);
                case 6:
                    return $author$project$View$Dialog$Closeable$howToUseWitfulVideo(env);
                case 7:
                    return $author$project$View$Dialog$Closeable$smartTagsVideo(env);
                case 8:
                    return $author$project$View$Dialog$Closeable$colorCodingVideo(env);
                case 9:
                    return $author$project$View$Dialog$Closeable$videoCallVideo(env);
                case 10:
                    var authError = dialogAction.a;
                    return $author$project$View$Dialog$Closeable$linkCalendarError_fn(env.nI, authError);
                default:
                    return $author$project$View$Dialog$Closeable$errorConnectingToStripe(env);
            }
        };
        return $elm$core$Maybe$map_fn(actionToDialogConfig, env.e3);
    };
    var $author$project$View$Dialog$Common$noncloseable = $author$project$View$Dialog$BaseDialog$empty_fn($author$project$Model$NoOp, $elm$core$Maybe$Nothing);
    var $author$project$View$Dialog$NonCloseable$accountCreatedSuccessfully = function (palette) {
        return $$update__dG($author$project$View$Dialog$Common$noncloseable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$spacing(5)
        ]), _List_fromArray([
            A2($author$project$View$Dialog$Common$onboardingIcon, palette, "trophy-alt"),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$text("Fantastic!")),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$text("Your account is set up.")),
            $author$project$View$Util$spacer(16),
            $author$project$View$Util$horizontalLine_fn(palette, 1, _List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(100)),
                $mdgriffith$elm_ui$Element$centerX
            ])),
            $author$project$View$Util$spacer(16),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$Font$size(15)
            ]), $mdgriffith$elm_ui$Element$text("You can close this tab, and we'll see")),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$Font$size(15)
            ]), $mdgriffith$elm_ui$Element$text("you in your Onboarding meeting."))
        ])));
    };
    var $author$project$View$Dialog$NonCloseable$accountSetupError = function (palette) {
        return $$update__dG($author$project$View$Dialog$Common$noncloseable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(20),
            $mdgriffith$elm_ui$Element$Font$center
        ]), _List_fromArray([
            A2($author$project$View$Dialog$Common$onboardingIcon, palette, "outlet"),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$text("Sorry!")
            ])),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$text("An error occurred while activating your account. Our developers have been notified.")
            ])),
            $author$project$View$Widgets$contactOurTeam(palette)
        ])));
    };
    var $author$project$Env$OpenSupportLink = { $: 34 };
    var $author$project$View$Icon$Regular = 1;
    var $author$project$View$Widgets$loadingAnimation = $mdgriffith$elm_ui$Element$el_fn(_List_Nil, $mdgriffith$elm_ui$Element$html($elm$html$Html$div_fn(_List_fromArray([
        $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "lds-ring")
    ]), _List_fromArray([
        $elm$html$Html$div_fn(_List_Nil, _List_Nil),
        $elm$html$Html$div_fn(_List_Nil, _List_Nil),
        $elm$html$Html$div_fn(_List_Nil, _List_Nil),
        $elm$html$Html$div_fn(_List_Nil, _List_Nil)
    ]))));
    var $author$project$View$Dialog$NonCloseable$billingIssue_fn = function (env, billingIssueContext) {
        var isLoading = _Utils_eq(env.db.kn, $krisajenkins$remotedata$RemoteData$Loading) || _Utils_eq(env.db.kn, $krisajenkins$remotedata$RemoteData$NotAsked);
        var _v0 = function () {
            switch (billingIssueContext) {
                case 0:
                    return _Utils_Tuple3(_Utils_Tuple2("rocket-launch", "Witful has officially launched!"), _Utils_Tuple2("Add payment method", $author$project$Model$HandleBacktalk($author$project$Env$RouteToURLRequest($author$project$Routing$RouteSignup($author$project$Routing$SignupStepChooseSubscription)))), "Now that we're no longer in Beta, you'll need to add a payment method to access your account.");
                case 1:
                    return _Utils_Tuple3(_Utils_Tuple2("gift", "Your gift has expired"), _Utils_Tuple2("Add payment method", $author$project$Model$HandleBacktalk($author$project$Env$RouteToURLRequest($author$project$Routing$RouteSignup($author$project$Routing$SignupStepChooseSubscription)))), "Your one year gift subscription has expired. But not to worry! Just add a payment method to continue using Witful.");
                default:
                    return _Utils_Tuple3(_Utils_Tuple2("credit-card", "We couldn't process your payment"), _Utils_Tuple2("Update Payment", $author$project$Model$HandleBacktalk($author$project$Env$StripeGenerateSubscriptionManagementUrl)), "Update your payment method and your account will be back up and running in no time!");
            }
        }();
        var _v1 = _v0.a;
        var iconName = _v1.a;
        var title = _v1.b;
        var _v2 = _v0.b;
        var buttonCopy = _v2.a;
        var buttonMsg = _v2.b;
        var subtext = _v0.c;
        return isLoading ? $$update__dG($author$project$View$Dialog$Common$noncloseable, $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$paddingXY_fn(0, 20)
        ]), $author$project$View$Widgets$loadingAnimation)) : function () {
            var $r = $author$project$View$Dialog$Common$noncloseable.$c();
            $r.cJ = true;
            $r.dG = $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$spacing(15)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(20),
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.a8)
                ]), _List_fromArray([
                    $author$project$View$Icon$icon_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(25),
                        $mdgriffith$elm_ui$Element$centerX,
                        $mdgriffith$elm_ui$Element$paddingXY_fn(0, 15)
                    ]), 1, iconName),
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(20)
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$text(title)
                    ]))
                ])),
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$Font$center,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(330, $mdgriffith$elm_ui$Element$fill)),
                    $mdgriffith$elm_ui$Element$Font$size(16)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text(subtext)
                ])),
                $author$project$View$Util$spacer(10)
            ]));
            $r.de = $elm$core$Maybe$Just(_Utils_Tuple2(buttonCopy, buttonMsg));
            $r.i5 = $elm$core$Maybe$Just(_Utils_Tuple2("Contact Support", $author$project$Model$HandleBacktalk($author$project$Env$OpenSupportLink)));
            $r.jJ = $mdgriffith$elm_ui$Element$px(450);
            return $r;
        }();
    }, $author$project$View$Dialog$NonCloseable$billingIssue = F2($author$project$View$Dialog$NonCloseable$billingIssue_fn);
    var $author$project$View$Dialog$NonCloseable$connectingToStripe = $$update__dG($author$project$View$Dialog$Common$noncloseable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
        $mdgriffith$elm_ui$Element$centerX,
        $mdgriffith$elm_ui$Element$spacing(30)
    ]), _List_fromArray([
        $mdgriffith$elm_ui$Element$text("Connecting to Stripe..."),
        $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $author$project$View$Widgets$loadingAnimation)
    ])));
    var $author$project$Model$SignIn = { $: 5 };
    var $author$project$View$Dialog$NonCloseable$login = function (palette) {
        return $$update__co__dG__de($author$project$View$Dialog$Common$noncloseable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$spacing(5)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$text("Not a member?")),
            $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.a9)
            ]), {
                fF: $mdgriffith$elm_ui$Element$text("Sign up on our homepage."),
                dt: "https://witful.com"
            })
        ])), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$text("Welcome to Witful!")), $elm$core$Maybe$Just(_Utils_Tuple2("LOGIN", $author$project$Model$SignIn)));
    };
    var $author$project$Model$DismissPersonMergeFailed = { $: 23 };
    var $author$project$View$Dialog$NonCloseable$personMergeFailed = function (palette) {
        return $$update__dG__de($author$project$View$Dialog$Common$noncloseable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$spacing(30)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$text("Merging Persons failed"),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$text("We were unable to merge those persons. "),
                $mdgriffith$elm_ui$Element$text("This may be due to a network error, "),
                $mdgriffith$elm_ui$Element$text("or those persons being edited from another tab."),
                $mdgriffith$elm_ui$Element$text("Please try again, and if the issue persists,")
            ])),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$text("Contact our team at "),
                $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(palette.a2)
                ]), {
                    fF: $mdgriffith$elm_ui$Element$text("support@witful.com"),
                    dt: "mailto:support@witful.com"
                })
            ]))
        ])), $elm$core$Maybe$Just(_Utils_Tuple2("Dismiss", $author$project$Model$DismissPersonMergeFailed)));
    };
    var $author$project$View$Dialog$NonCloseable$personMergePending = $$update__dG($author$project$View$Dialog$Common$noncloseable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
        $mdgriffith$elm_ui$Element$centerX,
        $mdgriffith$elm_ui$Element$spacing(30)
    ]), _List_fromArray([
        $mdgriffith$elm_ui$Element$text("Merging people..."),
        $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $author$project$View$Widgets$loadingAnimation)
    ])));
    var $author$project$View$Dialog$NonCloseable$promptAppReload = function (reloadReason) {
        var bodyElements = function () {
            if (!reloadReason) {
                return _List_fromArray([
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$text("\uD83D\uDE15")),
                    $author$project$View$Util$spacer(10),
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$text("Witful needs to be reloaded")),
                    $author$project$View$Util$spacer(10),
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$centerX,
                        $mdgriffith$elm_ui$Element$Font$size(16)
                    ]), $mdgriffith$elm_ui$Element$text("Our apologies. Something odd has occurred."))
                ]);
            }
            else {
                return _List_fromArray([
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$text("\uD83C\uDF89")),
                    $author$project$View$Util$spacer(10),
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$text("A new version of Witful is out!")),
                    $author$project$View$Util$spacer(10),
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$centerX,
                        $mdgriffith$elm_ui$Element$Font$size(16)
                    ]), $mdgriffith$elm_ui$Element$text("Don't worry, all your data is safe and sound."))
                ]);
            }
        }();
        return $$update__co__dG__de($author$project$View$Dialog$Common$noncloseable, $mdgriffith$elm_ui$Element$none, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), bodyElements), $elm$core$Maybe$Just(_Utils_Tuple2("RELOAD", $author$project$Model$HandleBacktalk($author$project$Env$ReloadApp))));
    };
    var $author$project$View$Dialog$NonCloseable$stripeConnectionError = function (palette) {
        return $$update__dG($author$project$View$Dialog$Common$noncloseable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(20),
            $mdgriffith$elm_ui$Element$Font$center
        ]), _List_fromArray([
            A2($author$project$View$Dialog$Common$onboardingIcon, palette, "outlet"),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$text("Sorry!")
            ])),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$text("An error occurred while connecting to Stripe. Our developers have been notified.")
            ])),
            $author$project$View$Widgets$contactOurTeam(palette)
        ])));
    };
    var $author$project$View$Dialog$NonCloseable$submittingFeedback = $$update__dG($author$project$View$Dialog$Common$noncloseable, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
        $mdgriffith$elm_ui$Element$centerX,
        $mdgriffith$elm_ui$Element$spacing(30)
    ]), _List_fromArray([
        $mdgriffith$elm_ui$Element$text("Submitting feedback..."),
        $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $author$project$View$Widgets$loadingAnimation)
    ])));
    var $author$project$View$Dialog$NonCloseable$view_fn = function (env, nc) {
        switch (nc.$) {
            case 0:
                return $author$project$View$Dialog$NonCloseable$login(env.nI);
            case 1:
                return $author$project$View$Dialog$NonCloseable$accountSetupError(env.nI);
            case 2:
                return $author$project$View$Dialog$NonCloseable$connectingToStripe;
            case 3:
                return $author$project$View$Dialog$NonCloseable$stripeConnectionError(env.nI);
            case 4:
                var context = nc.a;
                return $author$project$View$Dialog$NonCloseable$billingIssue_fn(env, context);
            case 5:
                return $author$project$View$Dialog$NonCloseable$accountCreatedSuccessfully(env.nI);
            case 6:
                return $author$project$View$Dialog$NonCloseable$personMergePending;
            case 7:
                return $author$project$View$Dialog$NonCloseable$personMergeFailed(env.nI);
            case 8:
                var reloadReason = nc.a;
                return $author$project$View$Dialog$NonCloseable$promptAppReload(reloadReason);
            default:
                return $author$project$View$Dialog$NonCloseable$submittingFeedback;
        }
    }, $author$project$View$Dialog$NonCloseable$view = F2($author$project$View$Dialog$NonCloseable$view_fn);
    var $author$project$View$Dialog$highestPriority = function (model) {
        return $elm_community$maybe_extra$Maybe$Extra$orElse_fn($author$project$View$Dialog$Closeable$view(model.dW), $elm_community$maybe_extra$Maybe$Extra$orElse_fn($author$project$View$Dialog$pageDialog(model), $elm$core$Maybe$map_fn($author$project$View$Dialog$NonCloseable$view(model.dW), $author$project$Data$Dialog$NonCloseable$apropos(model.dW))));
    };
    var $mdgriffith$elm_ui$Internal$Model$OnlyDynamic_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$OnlyDynamic = F2($mdgriffith$elm_ui$Internal$Model$OnlyDynamic_fn);
    var $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic = F2($mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic_fn);
    var $mdgriffith$elm_ui$Internal$Model$AllowHover = 1;
    var $mdgriffith$elm_ui$Internal$Model$Layout = 0;
    var $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle = {
        ki: $elm$core$Maybe$Nothing,
        ks: $elm$core$Maybe$Nothing,
        ov: $elm$core$Maybe$Just({
            kp: 0,
            kS: $mdgriffith$elm_ui$Internal$Model$Rgba_fn(155 / 255, 203 / 255, 1, 1),
            nt: _Utils_Tuple2(0, 0),
            oE: 3
        })
    };
    var $mdgriffith$elm_ui$Internal$Model$optionsToRecord = function (options) {
        var combine = F2(function (opt, record) {
            switch (opt.$) {
                case 0:
                    var hoverable = opt.a;
                    var _v4 = record.l$;
                    if (_v4.$ === 1) {
                        return function () {
                            var $r = record.$c();
                            $r.l$ = $elm$core$Maybe$Just(hoverable);
                            return $r;
                        }();
                    }
                    else {
                        return record;
                    }
                case 1:
                    var focusStyle = opt.a;
                    var _v5 = record.lK;
                    if (_v5.$ === 1) {
                        return function () {
                            var $r = record.$c();
                            $r.lK = $elm$core$Maybe$Just(focusStyle);
                            return $r;
                        }();
                    }
                    else {
                        return record;
                    }
                default:
                    var renderMode = opt.a;
                    var _v6 = record.m7;
                    if (_v6.$ === 1) {
                        return function () {
                            var $r = record.$c();
                            $r.m7 = $elm$core$Maybe$Just(renderMode);
                            return $r;
                        }();
                    }
                    else {
                        return record;
                    }
            }
        });
        var andFinally = function (record) {
            return (new $$Record120(function () {
                var _v0 = record.lK;
                if (_v0.$ === 1) {
                    return $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle;
                }
                else {
                    var focusable = _v0.a;
                    return focusable;
                }
            }(), function () {
                var _v1 = record.l$;
                if (_v1.$ === 1) {
                    return 1;
                }
                else {
                    var hoverable = _v1.a;
                    return hoverable;
                }
            }(), function () {
                var _v2 = record.m7;
                if (_v2.$ === 1) {
                    return 0;
                }
                else {
                    var actualMode = _v2.a;
                    return actualMode;
                }
            }()));
        };
        return andFinally($elm$core$List$foldr_fn(combine, (new $$Record120($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)), options));
    };
    var $mdgriffith$elm_ui$Internal$Model$toHtml_fn = function (mode, el) {
        switch (el.$) {
            case 0:
                var html = el.a;
                return html($mdgriffith$elm_ui$Internal$Model$asEl);
            case 1:
                var styles = el.a.ji;
                var html = el.a.l3;
                return A2(html, mode(styles), $mdgriffith$elm_ui$Internal$Model$asEl);
            case 2:
                var text = el.a;
                return $mdgriffith$elm_ui$Internal$Model$textElement(text);
            default:
                return $mdgriffith$elm_ui$Internal$Model$textElement("");
        }
    }, $mdgriffith$elm_ui$Internal$Model$toHtml = F2($mdgriffith$elm_ui$Internal$Model$toHtml_fn);
    var $mdgriffith$elm_ui$Internal$Model$renderRoot_fn = function (optionList, attributes, child) {
        var options = $mdgriffith$elm_ui$Internal$Model$optionsToRecord(optionList);
        var embedStyle = function () {
            var _v0 = options.m7;
            if (_v0 === 1) {
                return $mdgriffith$elm_ui$Internal$Model$OnlyDynamic(options);
            }
            else {
                return $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic(options);
            }
        }();
        return $mdgriffith$elm_ui$Internal$Model$toHtml_fn(embedStyle, $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, attributes, $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([child]))));
    }, $mdgriffith$elm_ui$Internal$Model$renderRoot = F3($mdgriffith$elm_ui$Internal$Model$renderRoot_fn);
    var $mdgriffith$elm_ui$Internal$Model$rootStyle = function () {
        var families = _List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$Typeface("Open Sans"),
            $mdgriffith$elm_ui$Internal$Model$Typeface("Helvetica"),
            $mdgriffith$elm_ui$Internal$Model$Typeface("Verdana"),
            $mdgriffith$elm_ui$Internal$Model$SansSerif
        ]);
        return _List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$bgColor, $mdgriffith$elm_ui$Internal$Model$Colored_fn("bg-" + $mdgriffith$elm_ui$Internal$Model$formatColorClass($mdgriffith$elm_ui$Internal$Model$Rgba_fn(1, 1, 1, 0)), "background-color", $mdgriffith$elm_ui$Internal$Model$Rgba_fn(1, 1, 1, 0))),
            $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$fontColor, $mdgriffith$elm_ui$Internal$Model$Colored_fn("fc-" + $mdgriffith$elm_ui$Internal$Model$formatColorClass($mdgriffith$elm_ui$Internal$Model$Rgba_fn(0, 0, 0, 1)), "color", $mdgriffith$elm_ui$Internal$Model$Rgba_fn(0, 0, 0, 1))),
            $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$fontSize, $mdgriffith$elm_ui$Internal$Model$FontSize(20)),
            $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$fontFamily, $mdgriffith$elm_ui$Internal$Model$FontFamily_fn($elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderFontClassName, "font-", families), families))
        ]);
    }();
    var $mdgriffith$elm_ui$Element$layoutWith_fn = function (_v0, attrs, child) {
        var options = _v0.nE;
        return $mdgriffith$elm_ui$Internal$Model$renderRoot_fn(options, _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.od, $mdgriffith$elm_ui$Internal$Style$classes.j7, $mdgriffith$elm_ui$Internal$Style$classes.oC]))), _Utils_ap($mdgriffith$elm_ui$Internal$Model$rootStyle, attrs)), child);
    }, $mdgriffith$elm_ui$Element$layoutWith = F3($mdgriffith$elm_ui$Element$layoutWith_fn);
    var $mdgriffith$elm_ui$Element$Lazy$embed = function (x) {
        switch (x.$) {
            case 0:
                var html = x.a;
                return html;
            case 1:
                var styled = x.a;
                return styled.l3($mdgriffith$elm_ui$Internal$Model$OnlyDynamic_fn((new $$Record120({ ki: $elm$core$Maybe$Nothing, ks: $elm$core$Maybe$Nothing, ov: $elm$core$Maybe$Nothing }, 1, 0)), styled.ji));
            case 2:
                var text = x.a;
                return $elm$core$Basics$always($elm$virtual_dom$VirtualDom$text(text));
            default:
                return $elm$core$Basics$always($elm$virtual_dom$VirtualDom$text(""));
        }
    };
    var $mdgriffith$elm_ui$Element$Lazy$apply2_fn = function (fn, a, b) {
        return $mdgriffith$elm_ui$Element$Lazy$embed(A2(fn, a, b));
    }, $mdgriffith$elm_ui$Element$Lazy$apply2_fn_unwrapped = function (fn, a, b) {
        return $mdgriffith$elm_ui$Element$Lazy$embed(fn(a, b));
    }, $mdgriffith$elm_ui$Element$Lazy$apply2 = F3($mdgriffith$elm_ui$Element$Lazy$apply2_fn);
    var $elm$virtual_dom$VirtualDom$lazy4 = _VirtualDom_lazy4;
    var $mdgriffith$elm_ui$Element$Lazy$lazy2_fn = function (fn, a, b) {
        return $mdgriffith$elm_ui$Internal$Model$Unstyled(A4($elm$virtual_dom$VirtualDom$lazy4, $mdgriffith$elm_ui$Element$Lazy$apply2, fn, a, b));
    }, $mdgriffith$elm_ui$Element$Lazy$lazy2 = F3($mdgriffith$elm_ui$Element$Lazy$lazy2_fn);
    var $author$project$View$Styling$h3 = function (palette) {
        return A3($author$project$View$Styling$hHelp, palette, 20, _List_fromArray([$mdgriffith$elm_ui$Element$Font$semiBold]));
    };
    var $author$project$View$Widgets$notFound = function (palette) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$paddingXY_fn(30, 80),
            $mdgriffith$elm_ui$Element$centerX
        ]), $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacingXY_fn(10, 30)
        ]), _List_fromArray([
            A3($author$project$View$Styling$h2, palette, _List_fromArray([$mdgriffith$elm_ui$Element$centerX]), "Not found"),
            $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), {
                fF: A3($author$project$View$Styling$h3, palette, _List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(palette.ba)
                ]), "Return Home"),
                dt: "/"
            })
        ])));
    };
    var $author$project$View$Widgets$loadingOrNotFound_fn = function (palette, loadState) {
        return $author$project$Data$App$isLoading(loadState) ? $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]), $author$project$View$Widgets$loadingAnimation) : $author$project$View$Widgets$notFound(palette);
    }, $author$project$View$Widgets$loadingOrNotFound = F2($author$project$View$Widgets$loadingOrNotFound_fn);
    var $mdgriffith$elm_ui$Element$Keyed$column_fn = function (attrs, children) {
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asColumn, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.k_ + (" " + $mdgriffith$elm_ui$Internal$Style$classes.cL)), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), attrs))), $mdgriffith$elm_ui$Internal$Model$Keyed(children));
    }, $mdgriffith$elm_ui$Element$Keyed$column = F2($mdgriffith$elm_ui$Element$Keyed$column_fn);
    var $author$project$View$ActionItems$defaultViewConfig = (new $$Record121(10, 0.889, true, 14, false, true, true));
    var $author$project$Page$ActionItems$emptyStateInfoCard = function (env) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$padding(30)
        ]), $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$padding(30),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.dA),
            $mdgriffith$elm_ui$Element$Font$color(env.nI.dE),
            $mdgriffith$elm_ui$Element$Border$rounded(10),
            $mdgriffith$elm_ui$Element$spacing(10)
        ]), _List_fromArray([
            $author$project$View$Icon$icon_fn(_List_fromArray([$mdgriffith$elm_ui$Element$alignTop]), 1, "check-double"),
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$spacing(25)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("When you add action items within a note, they will display here.")
                ])),
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("To create an action item, just type !! anywhere inside of a note.")
                ]))
            ]))
        ])));
    };
    var $author$project$View$Responsive$isDoubleColumned_fn = function (breakpoints, viewport) {
        return !$author$project$View$Responsive$mode_fn(breakpoints, viewport);
    }, $author$project$View$Responsive$isDoubleColumned = F2($author$project$View$Responsive$isDoubleColumned_fn);
    var $author$project$View$Layout$maxPageWidth = 1150;
    var $author$project$View$Layout$onePanel_fn = function (env, extraAttrs, innerElts) {
        var isDoubleColumned = $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, env.p1);
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$alignTop,
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
        ]), $mdgriffith$elm_ui$Element$column_fn(_List_Cons($mdgriffith$elm_ui$Element$padding($author$project$Util$Misc$if__fn(isDoubleColumned, 30, 10)), _List_Cons($mdgriffith$elm_ui$Element$spacing(15), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn((($author$project$View$Layout$maxPageWidth * 2) / 3) | 0, $mdgriffith$elm_ui$Element$fill)), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$centerX, extraAttrs))))), innerElts));
    }, $author$project$View$Layout$onePanel = F3($author$project$View$Layout$onePanel_fn);
    var $author$project$Page$ActionItems$SetShowCompleted = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$Left = 0;
    var $mdgriffith$elm_ui$Element$alignLeft = $mdgriffith$elm_ui$Internal$Model$AlignX(0);
    var $mdgriffith$elm_ui$Element$Input$onKeyLookup = function (lookup) {
        var decode = function (code) {
            var _v0 = lookup(code);
            if (_v0.$ === 1) {
                return $elm$json$Json$Decode$fail("No key matched");
            }
            else {
                var msg = _v0.a;
                return $elm$json$Json$Decode$succeed(msg);
            }
        };
        var isKey = _Json_andThen_fn(decode, _Json_decodeField_fn("key", $elm$json$Json$Decode$string));
        return $mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Events$on_fn("keyup", isKey));
    };
    var $mdgriffith$elm_ui$Element$Input$space = " ";
    var $mdgriffith$elm_ui$Element$Input$tabindex_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Input$tabindex_a1 = $elm$html$Html$Attributes$tabindex, $mdgriffith$elm_ui$Element$Input$tabindex = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Input$tabindex_a0, $mdgriffith$elm_ui$Element$Input$tabindex_a1);
    var $mdgriffith$elm_ui$Element$Input$checkbox_fn = function (attrs, _v0) {
        var label = _v0.fF;
        var icon = _v0.l7;
        var checked = _v0.kH;
        var onChange = _v0.nu;
        var attributes = _Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$Input$isHiddenLabel(label) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Element$spacing(6),
            $mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Events$onClick(onChange(!checked))),
            $mdgriffith$elm_ui$Element$Region$announce,
            $mdgriffith$elm_ui$Element$Input$onKeyLookup(function (code) {
                return _Utils_eq(code, $mdgriffith$elm_ui$Element$Input$enter) ? $elm$core$Maybe$Just(onChange(!checked)) : (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space) ? $elm$core$Maybe$Just(onChange(!checked)) : $elm$core$Maybe$Nothing);
            }),
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Input$tabindex_a0, $mdgriffith$elm_ui$Element$Input$tabindex_a1, 0),
            $mdgriffith$elm_ui$Element$pointer,
            $mdgriffith$elm_ui$Element$alignLeft,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), attrs);
        return $mdgriffith$elm_ui$Element$Input$applyLabel_fn(attributes, label, $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, _List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$Attr($elm$virtual_dom$VirtualDom$attribute_fn("role", "checkbox")),
            $mdgriffith$elm_ui$Internal$Model$Attr($elm$virtual_dom$VirtualDom$attribute_fn("aria-checked", checked ? "true" : "false")),
            $mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(label),
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink)
        ]), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([
            icon(checked)
        ]))));
    }, $mdgriffith$elm_ui$Element$Input$checkbox = F2($mdgriffith$elm_ui$Element$Input$checkbox_fn);
    var $author$project$View$Styling$focusable = $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "focusable");
    var $mdgriffith$elm_ui$Element$Input$Label_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $mdgriffith$elm_ui$Element$Input$Label = F3($mdgriffith$elm_ui$Element$Input$Label_fn);
    var $mdgriffith$elm_ui$Element$Input$OnRight = 0;
    var $mdgriffith$elm_ui$Element$Input$labelRight_a0 = 0, $mdgriffith$elm_ui$Element$Input$labelRight = $mdgriffith$elm_ui$Element$Input$Label($mdgriffith$elm_ui$Element$Input$labelRight_a0);
    var $author$project$View$Widgets$toggleSwitchAnimationHelper = function (attr) {
        return $author$project$View$Util$style_fn("transition", attr + " 125ms ease");
    };
    var $mdgriffith$elm_ui$Internal$Model$MoveX = function (a) {
        return { $: 0, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Flag$moveX = $mdgriffith$elm_ui$Internal$Flag$flag(25);
    var $mdgriffith$elm_ui$Element$moveLeft = function (x) {
        return $mdgriffith$elm_ui$Internal$Model$TransformComponent_fn($mdgriffith$elm_ui$Internal$Flag$moveX, $mdgriffith$elm_ui$Internal$Model$MoveX(-x));
    };
    var $mdgriffith$elm_ui$Element$moveRight = function (x) {
        return $mdgriffith$elm_ui$Internal$Model$TransformComponent_fn($mdgriffith$elm_ui$Internal$Flag$moveX, $mdgriffith$elm_ui$Internal$Model$MoveX(x));
    };
    var $author$project$View$Widgets$toggleSwitchIcon_fn = function (palette, isChecked) {
        var thumbBackgroundColor = isChecked ? palette.a7 : palette.aO;
        var thumbButton = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(16)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(16)),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$Border$rounded(100),
            $mdgriffith$elm_ui$Element$Background$color(thumbBackgroundColor),
            $author$project$View$Widgets$toggleSwitchAnimationHelper("background-color"),
            $mdgriffith$elm_ui$Element$Border$shadow({
                kp: 4,
                kS: $mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.5),
                nt: _Utils_Tuple2(1, 1),
                oE: 0.2
            })
        ]), $mdgriffith$elm_ui$Element$none);
        var positioning = isChecked ? $mdgriffith$elm_ui$Element$moveRight(12) : $mdgriffith$elm_ui$Element$moveLeft(8);
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$inFront(thumbButton),
            positioning,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(26)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(26)),
            $mdgriffith$elm_ui$Element$moveUp(8),
            $mdgriffith$elm_ui$Element$Border$rounded(100),
            $author$project$View$Styling$ripple,
            $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$grayAlphaLight)
            ])),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$grayAlphaLight)
            ])),
            $author$project$View$Widgets$toggleSwitchAnimationHelper("transform")
        ]), $mdgriffith$elm_ui$Element$none);
    }, $author$project$View$Widgets$toggleSwitchIcon = F2($author$project$View$Widgets$toggleSwitchIcon_fn);
    var $author$project$View$Util$zIndex_a0 = $author$project$View$Util$style("z-index"), $author$project$View$Util$zIndex_a1 = $elm$core$String$fromInt, $author$project$View$Util$zIndex = A2($elm$core$Basics$composeL, $author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1);
    var $author$project$View$Widgets$toggleSwitch_fn = function (_v0, palette) {
        var onChange = _v0.nu;
        var ariaLabel = _v0.kb;
        var checked = _v0.kH;
        var sliderColor = checked ? $mdgriffith$elm_ui$Element$Background$color(palette.a5) : $mdgriffith$elm_ui$Element$Background$color(palette.aQ);
        return $mdgriffith$elm_ui$Element$Input$checkbox_fn(_List_fromArray([
            $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, 2),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(30)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(10)),
            $mdgriffith$elm_ui$Element$Border$rounded(9),
            $author$project$View$Widgets$toggleSwitchAnimationHelper("background-color"),
            sliderColor,
            $author$project$View$Styling$focusable
        ]), {
            kH: checked,
            l7: $author$project$View$Widgets$toggleSwitchIcon(palette),
            fF: $mdgriffith$elm_ui$Element$Input$Label_fn($mdgriffith$elm_ui$Element$Input$labelRight_a0, _List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(0)),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(0)),
                $author$project$View$Util$attribute_fn("label", ariaLabel)
            ]), $mdgriffith$elm_ui$Element$none),
            nu: onChange
        });
    }, $author$project$View$Widgets$toggleSwitch = F2($author$project$View$Widgets$toggleSwitch_fn);
    var $author$project$Page$ActionItems$showCompletedToggle_fn = function (env, showCompleted) {
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(10),
            $mdgriffith$elm_ui$Element$alignRight,
            $mdgriffith$elm_ui$Element$Font$letterSpacing(0.3),
            $mdgriffith$elm_ui$Element$Font$color(env.nI.aR)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$text("Show completed"),
            $author$project$View$Widgets$toggleSwitch_fn({ kb: "Show completed", kH: showCompleted, nu: $author$project$Page$ActionItems$SetShowCompleted }, env.nI)
        ]));
    }, $author$project$Page$ActionItems$showCompletedToggle = F2($author$project$Page$ActionItems$showCompletedToggle_fn);
    var $author$project$View$Widgets$linkButtonHelp_fn = function (newTab, _v0, buttonText) {
        var icon = _v0.l7;
        var extraAttrs = _v0.hp;
        var url = _v0.dt;
        var linkEl = $author$project$Util$Misc$if__fn(newTab, $mdgriffith$elm_ui$Element$newTabLink, $mdgriffith$elm_ui$Element$link);
        var icon_ = $author$project$View$Util$whenJust_fn(icon, function (_v1) {
            var style = _v1.a;
            var name = _v1.b;
            var iconAttrs = _v1.c;
            return $author$project$View$Icon$icon_fn(iconAttrs, style, name);
        });
        var attrs = _Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacingXY_fn(10, 30),
            $mdgriffith$elm_ui$Element$paddingXY_fn(10, 10),
            $mdgriffith$elm_ui$Element$Font$regular,
            $mdgriffith$elm_ui$Element$Font$size(14),
            $mdgriffith$elm_ui$Element$Font$letterSpacing(0.6),
            $mdgriffith$elm_ui$Element$Border$width(2),
            $mdgriffith$elm_ui$Element$Border$rounded(4),
            $author$project$View$Styling$ripple,
            $author$project$View$Styling$focusable,
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$grayAlphaLight)
            ]))
        ]), extraAttrs);
        return A2(linkEl, attrs, {
            fF: $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(10)
            ]), $elm$core$String$isEmpty(buttonText) ? _List_fromArray([icon_]) : _List_fromArray([
                icon_,
                $mdgriffith$elm_ui$Element$text(buttonText)
            ])),
            dt: url
        });
    }, $author$project$View$Widgets$linkButtonHelp = F3($author$project$View$Widgets$linkButtonHelp_fn);
    var $author$project$View$Widgets$linkButton_a0 = false, $author$project$View$Widgets$linkButton = $author$project$View$Widgets$linkButtonHelp($author$project$View$Widgets$linkButton_a0);
    var $author$project$Page$ActionItems$sortOrderButton = function (options) {
        return $author$project$View$Widgets$linkButtonHelp_fn($author$project$View$Widgets$linkButton_a0, {
            hp: _List_fromArray([
                $mdgriffith$elm_ui$Element$alignLeft,
                $mdgriffith$elm_ui$Element$Border$width(0),
                $mdgriffith$elm_ui$Element$Font$size(15),
                $mdgriffith$elm_ui$Element$Font$letterSpacing(0.3)
            ]),
            l7: $elm$core$Maybe$Just(_Utils_Tuple3(3, $author$project$Util$Misc$if__fn(options.c6, "angle-double-down", "angle-double-up"), _List_Nil)),
            dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteThreads(function () {
                var $r = options.$c();
                $r.c6 = !options.c6;
                return $r;
            }()))
        }, $author$project$Util$Misc$if__fn(options.c6, "Oldest first", "Newest first"));
    };
    var $author$project$View$ActionItems$extractFromNote = function (_v0) {
        var showCompleted = _v0.eG;
        var fading = _v0.O;
        var noteId = _v0.ip;
        var note = _v0.l;
        var actionItemFilter = _v0.jS;
        var actionItems = $elm$core$List$filter_fn(actionItemFilter, note.gz);
        var hasIncompleteActionItems = $elm$core$List$any_fn(A2($elm$core$Basics$composeR, $author$project$Data$ActionItem$isComplete, $elm$core$Basics$not), actionItems);
        var isDebouncing = $elm$core$List$any_fn(function (uid) {
            return $elm$core$Set$member_fn(uid, fading);
        }, $elm$core$List$map_fn(function ($) {
            return $.l8;
        }, actionItems));
        var includeNote = (!note.lh) && (showCompleted || (hasIncompleteActionItems || isDebouncing));
        var _v1 = _Utils_Tuple2(actionItems, includeNote);
        _v1$0: while (true) {
            if (!_v1.b) {
                if (!_v1.a.b) {
                    break _v1$0;
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
            else {
                if (!_v1.a.b) {
                    break _v1$0;
                }
                else {
                    return $elm$core$Maybe$Just((new $$Record122(actionItems, note, noteId)));
                }
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $mdgriffith$elm_ui$Element$Font$bold = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.kr);
    var $author$project$View$Styling$breakWord = $author$project$View$Util$style_fn("word-break", "break-word");
    var $author$project$Util$Time$weekDayToWord = function (weekday) {
        switch (weekday) {
            case 6:
                return "Sun";
            case 0:
                return "Mon";
            case 1:
                return "Tue";
            case 2:
                return "Wed";
            case 3:
                return "Thu";
            case 4:
                return "Fri";
            default:
                return "Sat";
        }
    };
    var $author$project$Util$Time$dateFormatterShort_fn = function (zone, time) {
        return $ryannhg$date_format$DateFormat$formatWithLanguage_fn($ryannhg$date_format$DateFormat$format_a0, _List_fromArray([
            $ryannhg$date_format$DateFormat$text($author$project$Util$Time$weekDayToWord($elm$time$Time$toWeekday_fn(zone, time))),
            $ryannhg$date_format$DateFormat$text(" "),
            $ryannhg$date_format$DateFormat$monthNameAbbreviated,
            $ryannhg$date_format$DateFormat$text(" "),
            $ryannhg$date_format$DateFormat$dayOfMonthSuffix,
            $ryannhg$date_format$DateFormat$text(", "),
            $ryannhg$date_format$DateFormat$yearNumber
        ]), zone, time);
    }, $author$project$Util$Time$dateFormatterShort = F2($author$project$Util$Time$dateFormatterShort_fn);
    var $author$project$View$Styling$h4 = function (palette) {
        return A3($author$project$View$Styling$hHelp, palette, 16, _List_fromArray([$mdgriffith$elm_ui$Element$Font$semiBold]));
    };
    var $elm$core$List$intersperse_fn = function (sep, xs) {
        if (!xs.b) {
            return xs;
        }
        var tmp = _List_Cons(undefined, _List_Nil);
        var end = tmp;
        end.b = _List_Cons(xs.a, _List_Nil);
        end = end.b;
        xs = xs.b;
        for (; xs.b; xs = xs.b) {
            var valNode = _List_Cons(xs.a, _List_Nil);
            var sepNode = _List_Cons(sep, valNode);
            end.b = sepNode;
            end = valNode;
        }
        return tmp.b;
    }, $elm$core$List$intersperse = F2($elm$core$List$intersperse_fn);
    var $mdgriffith$elm_ui$Element$Font$medium = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.ph);
    var $author$project$Data$ActionItem$isHighPriority = function (actionItem) {
        return $elm$core$List$any_fn(function (textEl) {
            if (((textEl.$ === 3) && (!textEl.a.$)) && (textEl.a.a === 1)) {
                var _v1 = textEl.a.a;
                return true;
            }
            else {
                return false;
            }
        }, actionItem.jn);
    };
    var $author$project$Data$ActionItem$prioritizationNumber = function (actionItem) {
        return $author$project$Util$Misc$if__fn($author$project$Data$ActionItem$isHighPriority(actionItem), 0, 100);
    };
    var $author$project$View$ActionItems$spacerLine = function (palette) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(1)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$paddingXY_fn(8, 0)
        ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Background$color(palette.aN),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(1)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), $mdgriffith$elm_ui$Element$none));
    };
    var $author$project$View$ActionItems$ToggleActionItem = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$View$Util$attrWhenJust_fn = function (mVal, toAttr) {
        if (!mVal.$) {
            var val = mVal.a;
            return toAttr(val);
        }
        else {
            return $author$project$View$Util$attrNone;
        }
    }, $author$project$View$Util$attrWhenJust = F2($author$project$View$Util$attrWhenJust_fn);
    var $author$project$View$Widgets$checkboxIcon_fn = function (palette, size, mBorderColor, isChecked) {
        var circleContainer = $mdgriffith$elm_ui$Element$el(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(35)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(35)),
            $mdgriffith$elm_ui$Element$Border$rounded(100),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$grayAlphaLight)
            ])),
            $author$project$View$Util$style_fn("transform", "scale(" + ($elm$core$String$fromFloat(size) + ")"))
        ]));
        var borderColor = $elm$core$Maybe$withDefault_fn(palette.a2, mBorderColor);
        var _v0 = isChecked ? _Utils_Tuple2($mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$transparent), $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "")) : _Utils_Tuple2($mdgriffith$elm_ui$Element$Background$color(palette.a6), $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, ""));
        var backgroundColor = _v0.a;
        var checkedStyling = _v0.b;
        var squareContainer = $mdgriffith$elm_ui$Element$el(_List_fromArray([
            backgroundColor,
            $mdgriffith$elm_ui$Element$Border$rounded(999),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(18)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(18)),
            $mdgriffith$elm_ui$Element$Border$width(3),
            $mdgriffith$elm_ui$Element$Border$color(borderColor)
        ]));
        var checkmark = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            checkedStyling,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(18)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(18))
        ]), $mdgriffith$elm_ui$Element$none);
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(35)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(35))
        ]), $author$project$View$Icon$icon_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY,
            isChecked ? $mdgriffith$elm_ui$Element$Font$color(palette.aR) : $mdgriffith$elm_ui$Element$Font$color(borderColor),
            $mdgriffith$elm_ui$Element$Font$size(18)
        ]), 1, $author$project$Util$Misc$if__fn(isChecked, "check", "circle")));
    }, $author$project$View$Widgets$checkboxIcon = F4($author$project$View$Widgets$checkboxIcon_fn);
    var $author$project$View$Widgets$sizedCheckbox_fn = function (checkBoxsize, mBorderColor, _v0, palette) {
        var onChange = _v0.nu;
        var label = _v0.fF;
        var checked = _v0.kH;
        return $mdgriffith$elm_ui$Element$Input$checkbox_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $author$project$View$Styling$focusable
        ]), {
            kH: checked,
            l7: A3($author$project$View$Widgets$checkboxIcon, palette, checkBoxsize, mBorderColor),
            fF: $mdgriffith$elm_ui$Element$Input$Label_fn($mdgriffith$elm_ui$Element$Input$labelRight_a0, _List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $author$project$View$Styling$paddingTop(8)
            ]), label),
            nu: onChange
        });
    }, $author$project$View$Widgets$sizedCheckbox = F4($author$project$View$Widgets$sizedCheckbox_fn);
    var $author$project$View$ActionItems$ActionItemText_fn = function (plaintext, elements) {
        return (new $$Record123(elements, plaintext));
    }, $author$project$View$ActionItems$ActionItemText = F2($author$project$View$ActionItems$ActionItemText_fn);
    var $author$project$Util$Time$conciseMonthDayYearFormatter = $ryannhg$date_format$DateFormat$format(_List_fromArray([
        $ryannhg$date_format$DateFormat$monthNumber,
        $ryannhg$date_format$DateFormat$text("/"),
        $ryannhg$date_format$DateFormat$dayOfMonthNumber,
        $ryannhg$date_format$DateFormat$text("/"),
        $ryannhg$date_format$DateFormat$yearNumberLastTwo
    ]));
    var $author$project$View$ActionItems$viewTextReducer_fn = function (env, _v0, actionItem, mPersonId, textEl, _v1) {
        var enableLinks = _v0.lp;
        var isHighPriority = _v0.hW;
        var renderAsTopic = _v0.n8;
        var acc = _v1.a;
        var letterCount = _v1.b;
        var _return = _v1.c;
        var mentionChipAttrs = _Utils_ap($author$project$View$Widgets$baseChipAttrs, isHighPriority ? _List_fromArray([
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(env.nI.eW(0.7)),
                $mdgriffith$elm_ui$Element$Font$color(env.nI.eU(1))
            ])),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.eW(0.35)),
            $mdgriffith$elm_ui$Element$Font$color(env.nI.eU(0.9))
        ]) : _List_fromArray([
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(env.nI.a4),
                $mdgriffith$elm_ui$Element$Font$color(env.nI.ba)
            ])),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.a3),
            $mdgriffith$elm_ui$Element$Font$color(env.nI.a2)
        ]));
        var maxLetterCount = 98;
        var toReturn = F2(function (str, toElement) {
            var newLetterCount = $elm$core$String$length(str) + letterCount;
            return (_Utils_cmp(newLetterCount, maxLetterCount) > -1) ? _Utils_Tuple3((new $$Record123(_List_Cons(toElement($author$project$Util$Text$truncateToNChars_fn(maxLetterCount - letterCount, str)), acc.aE), _Utils_ap(acc.nP, str))), newLetterCount, true) : _Utils_Tuple3((new $$Record123(_List_Cons(toElement(str), acc.aE), _Utils_ap(acc.nP, str))), newLetterCount, false);
        });
        var mLink = F3(function (attrs, url, label) {
            return enableLinks ? $mdgriffith$elm_ui$Element$link_fn(attrs, { fF: label, dt: url }) : $mdgriffith$elm_ui$Element$el_fn(attrs, label);
        });
        if (_return) {
            return _Utils_Tuple3(acc, letterCount, _return);
        }
        else {
            switch (textEl.$) {
                case 0:
                    var plaintext = textEl.a;
                    return A2(toReturn, plaintext, function (str) {
                        return A3(mLink, _List_fromArray([
                            $author$project$View$Util$draggable(false)
                        ]), $author$project$Routing$pathFromRoute($author$project$Routing$RouteNote_fn(actionItem.ip, $elm$core$Maybe$Just(actionItem.l8), $elm$core$Maybe$Nothing)), $mdgriffith$elm_ui$Element$text(str));
                    });
                case 1:
                    var mentionEventRefData = textEl.a;
                    var mCompletedIn = textEl.b;
                    var mEventToTitleData = $elm$core$Maybe$map(function (event) {
                        return (new $$Record124($author$project$Data$Time$toPosix_fn(env.pu, event.oN), event.gj));
                    });
                    var getTitleData = F2(function (eventId, mMasterId) {
                        return $elm_community$maybe_extra$Maybe$Extra$orElse_fn(mEventToTitleData($elm$core$Maybe$andThen_fn(A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$Dict$get, env.lw), mMasterId)), mEventToTitleData($elm$core$Dict$get_fn(eventId, env.lw)));
                    });
                    var formatTitleData = function (isComplete) {
                        return A2($elm$core$Basics$composeR, $elm$core$Maybe$map(function (_v7) {
                            var title = _v7.gj;
                            var startTime = _v7.oN;
                            return isComplete ? ("#" + (title + (" - " + A2($author$project$Util$Time$conciseMonthDayYearFormatter, env.pu, startTime)))) : ("#" + title);
                        }), A2($elm$core$Basics$composeR, $elm$core$Maybe$withDefault("#loading"), $author$project$Util$Text$truncateToNChars(45)));
                    };
                    var _v3 = function () {
                        var _v4 = _Utils_Tuple2(mentionEventRefData, mCompletedIn);
                        _v4$0: while (true) {
                            _v4$1: while (true) {
                                switch (_v4.a.$) {
                                    case 0:
                                        if (!_v4.b.$) {
                                            if (!_v4.b.a.$) {
                                                break _v4$0;
                                            }
                                            else {
                                                break _v4$1;
                                            }
                                        }
                                        else {
                                            var masterId = _v4.a.a.mT;
                                            if ($author$project$Data$Mention$isNextEventRef(mentionEventRefData)) {
                                                return _Utils_Tuple3($author$project$Routing$RouteNextMeeting($author$project$Util$NextMeeting$NextMeeting(mPersonId)), "#next meeting", false);
                                            }
                                            else {
                                                if ($author$project$Data$Mention$isNextOneOnOneRef(mentionEventRefData)) {
                                                    if (!mPersonId.$) {
                                                        var personId = mPersonId.a;
                                                        return _Utils_Tuple3($author$project$Routing$RouteNextMeeting($author$project$Util$NextMeeting$NextOneOnOne(personId)), "#next 1-on-1", false);
                                                    }
                                                    else {
                                                        return _Utils_Tuple3($author$project$Routing$RouteNextMeeting($author$project$Util$NextMeeting$NextOneOnOne("null")), "#next 1-on-1", false);
                                                    }
                                                }
                                                else {
                                                    return _Utils_Tuple3($author$project$Routing$RouteNextMeeting($author$project$Util$NextMeeting$NextInSeries(masterId)), A2(formatTitleData, false, A2(getTitleData, masterId, $elm$core$Maybe$Nothing)), true);
                                                }
                                            }
                                        }
                                    case 1:
                                        if (!_v4.b.$) {
                                            if (!_v4.b.a.$) {
                                                break _v4$0;
                                            }
                                            else {
                                                break _v4$1;
                                            }
                                        }
                                        else {
                                            var eventId = _v4.a.a.b7;
                                            var masterId = _v4.a.a.mT;
                                            return _Utils_Tuple3($author$project$Routing$RouteCreateEventNote_fn(eventId, $elm$core$Maybe$Just(masterId), $elm$core$Maybe$Nothing), A2(formatTitleData, false, A2(getTitleData, eventId, $elm$core$Maybe$Just(masterId))), true);
                                        }
                                    default:
                                        if (!_v4.b.$) {
                                            if (!_v4.b.a.$) {
                                                break _v4$0;
                                            }
                                            else {
                                                break _v4$1;
                                            }
                                        }
                                        else {
                                            var eventId = _v4.a.a.b7;
                                            return _Utils_Tuple3($author$project$Routing$RouteCreateEventNote_fn(eventId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing), A2(formatTitleData, false, A2(getTitleData, eventId, $elm$core$Maybe$Nothing)), true);
                                        }
                                }
                            }
                            var eventId = _v4.b.a.a.b7;
                            return _Utils_Tuple3($author$project$Routing$RouteCreateEventNote_fn(eventId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing), A2(formatTitleData, true, A2(getTitleData, eventId, $elm$core$Maybe$Nothing)), true);
                        }
                        var eventId = _v4.b.a.a.b7;
                        var masterId = _v4.b.a.a.mT;
                        return _Utils_Tuple3($author$project$Routing$RouteCreateEventNote_fn(eventId, $elm$core$Maybe$Just(masterId), $elm$core$Maybe$Nothing), A2(formatTitleData, true, A2(getTitleData, eventId, $elm$core$Maybe$Just(masterId))), true);
                    }();
                    var route = _v3.a;
                    var eventTitle = _v3.b;
                    var topicRenderable = _v3.c;
                    return (renderAsTopic && topicRenderable) ? A2(toReturn, "", function (_v6) {
                        return $author$project$View$Widgets$actionItemChip_fn(env.nI, {
                            mt: $author$project$Data$ActionItem$isComplete(actionItem),
                            my: false,
                            mQ: enableLinks
                        }, "topic");
                    }) : A2(toReturn, eventTitle, function (str) {
                        return A3(mLink, mentionChipAttrs, $author$project$Routing$pathFromRoute(route), $mdgriffith$elm_ui$Element$text(str));
                    });
                case 2:
                    var personId = textEl.a.iB;
                    var name = $author$project$Util$Text$truncateToNChars_fn(45, $elm$core$Maybe$withDefault_fn("@not found", $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, function ($) {
                        return $.b;
                    }, $elm$core$Basics$append("@")), $author$project$Firestore$Collection$get_fn(personId, env.iz))));
                    return A2(toReturn, name, function (str) {
                        return A3(mLink, mentionChipAttrs, $author$project$Routing$pathFromRoute($author$project$Routing$RoutePerson(personId)), $mdgriffith$elm_ui$Element$text(str));
                    });
                default:
                    var chipType = textEl.a;
                    var string = function () {
                        if (!chipType.$) {
                            return "to-do";
                        }
                        else {
                            return "topic";
                        }
                    }();
                    return A2(toReturn, "", function (_v8) {
                        return $author$project$View$Widgets$actionItemChip_fn(env.nI, {
                            mt: $author$project$Data$ActionItem$isComplete(actionItem),
                            my: _Utils_eq(chipType, $author$project$Data$ActionItem$TodoChip(1)),
                            mQ: enableLinks
                        }, string);
                    });
            }
        }
    }, $author$project$View$ActionItems$viewTextReducer = F6($author$project$View$ActionItems$viewTextReducer_fn);
    var $author$project$View$ActionItems$viewText_fn = function (env, options, actionItem) {
        var mPersonId = $elm$core$List$head($elm$core$List$filterMap_fn(function (textEl) {
            if (textEl.$ === 2) {
                var personId = textEl.a.iB;
                return $elm$core$Maybe$Just(personId);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, actionItem.jn));
        return function (_v0) {
            var plaintext = _v0.a.nP;
            var elements = _v0.a.aE;
            return (new $$Record123($elm$core$List$reverse(elements), plaintext));
        }($elm$core$List$foldl_fn(A4($author$project$View$ActionItems$viewTextReducer, env, options, actionItem, mPersonId), _Utils_Tuple3($author$project$View$ActionItems$ActionItemText_fn("", _List_Nil), 0, false), actionItem.jn));
    }, $author$project$View$ActionItems$viewText = F3($author$project$View$ActionItems$viewText_fn);
    var $author$project$View$ActionItems$viewActionItemHelp_fn = function (env, config, fadingList, msgs, actionItem) {
        var isHighPriority = $author$project$Data$ActionItem$isHighPriority(actionItem);
        var isFadingOut = $elm$core$Set$member_fn(actionItem.l8, fadingList);
        var isComplete = $author$project$Data$ActionItem$isComplete(actionItem);
        var hoverAttrs = isHighPriority ? _List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(env.nI.eU(1)),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.eV(1))
        ]) : _List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(env.nI.a9)
        ]);
        var checkBorderColor = $author$project$Util$Misc$toJustIf_fn(isHighPriority, env.nI.eU(0.6));
        var animateRemoval = $author$project$View$Util$attrWhen_fn((!config.eG) && isFadingOut, $author$project$View$Util$style_fn("animation", "removeActionItem " + ($elm$core$String$fromInt($author$project$View$ActionItems$fadeOutDuration) + "ms normal ease-in-out")));
        if ((!config.eG) && (isComplete && (!isFadingOut))) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var checkboxElement = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$alignTop]), $author$project$View$Widgets$sizedCheckbox_fn(config.kG, checkBorderColor, {
                kH: isComplete,
                fF: $mdgriffith$elm_ui$Element$none,
                nu: $elm$core$Basics$always(msgs.pC(actionItem))
            }, env.nI));
            var attrs = _List_Cons(animateRemoval, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$Border$rounded(8), _List_Cons($mdgriffith$elm_ui$Element$mouseOver(hoverAttrs), _List_Cons($mdgriffith$elm_ui$Element$focused(hoverAttrs), isHighPriority ? _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(env.nI.eU(0.9)),
                $mdgriffith$elm_ui$Element$Background$color(env.nI.eV(0.6)),
                $mdgriffith$elm_ui$Element$Font$regular
            ]) : _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$regular,
                $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$transparent),
                $mdgriffith$elm_ui$Element$Font$color(env.nI.aU)
            ]))))));
            var _v0 = $author$project$View$ActionItems$viewText_fn(env, (new $$Record125(config.lp, isHighPriority, config.n8)), actionItem);
            var plaintext = _v0.nP;
            var elements = _v0.aE;
            var toDragStartListener = function (toMsg) {
                return $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$on_fn("dragstart", _Json_map1_fn(function (dragStartEvent) {
                    return toMsg({
                        ha: dragStartEvent,
                        l2: $author$project$Routing$pathFromRoute($author$project$Routing$RouteNote_fn(actionItem.ip, $elm$core$Maybe$Just(actionItem.l8), $elm$core$Maybe$Nothing)),
                        jn: plaintext
                    });
                }, $elm$json$Json$Decode$value)));
            };
            var actionItemTextElement = $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                $author$project$View$Util$draggable(true),
                $author$project$View$Util$attrWhenJust_fn(msgs.nw, toDragStartListener),
                $mdgriffith$elm_ui$Element$spacing(9),
                $author$project$View$Styling$breakWord,
                $author$project$View$Util$attrWhen_fn(isComplete, $mdgriffith$elm_ui$Element$Font$color(env.nI.aR)),
                $mdgriffith$elm_ui$Element$paddingXY_fn(0, config.jT),
                $mdgriffith$elm_ui$Element$alignTop,
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Font$size(config.lL),
                $mdgriffith$elm_ui$Element$moveUp(1)
            ]), elements);
            return $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$row_fn(attrs, _List_fromArray([checkboxElement, actionItemTextElement])));
        }
    }, $author$project$View$ActionItems$viewActionItemHelp = F5($author$project$View$ActionItems$viewActionItemHelp_fn);
    var $author$project$View$ActionItems$viewFadingActionItem_fn = function (env, viewConfig, model, actionItem) {
        return $author$project$View$ActionItems$viewActionItemHelp_fn(env, viewConfig, model.O, { nw: $elm$core$Maybe$Nothing, pC: $author$project$View$ActionItems$ToggleActionItem }, actionItem);
    }, $author$project$View$ActionItems$viewFadingActionItem = F4($author$project$View$ActionItems$viewFadingActionItem_fn);
    var $author$project$View$ActionItems$viewForNote_fn = function (env, config, model, _v0) {
        var note = _v0.l;
        var noteId = _v0.ip;
        var actionItems = _v0.gz;
        return _Utils_Tuple2(noteId, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(10),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$spacing(10),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$link_fn(_List_Nil, {
                    fF: A3($author$project$View$Styling$h4, env.nI, _List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn($elm$core$String$isEmpty(note.gj), env.nI.aR, env.nI.aU)),
                        $mdgriffith$elm_ui$Element$Font$bold,
                        $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.a7)
                        ])),
                        $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.a7)
                        ]))
                    ]), (note.gj === "") ? "(Untitled Note)" : $author$project$Util$Text$truncateToNChars_fn(48, note.gj)),
                    dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteNote_fn(noteId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(0)))
                }),
                $author$project$View$Util$when_fn(config.oy, $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.aQ),
                    $mdgriffith$elm_ui$Element$Font$medium,
                    $mdgriffith$elm_ui$Element$Font$size(12)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text($author$project$Util$Time$dateFormatterShort_fn(env.pu, $author$project$Data$Time$toPosix_fn(env.pu, note.gh)))
                ])))
            ])),
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$moveLeft(8),
                $author$project$View$Styling$breakWord,
                $mdgriffith$elm_ui$Element$spacing(0),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), $elm$core$List$intersperse_fn($author$project$View$ActionItems$spacerLine(env.nI), $elm$core$List$filterMap_fn(A3($author$project$View$ActionItems$viewFadingActionItem, env, config, model), _List_sortBy_fn($author$project$Data$ActionItem$prioritizationNumber, actionItems))))
        ])));
    }, $author$project$View$ActionItems$viewForNote = F4($author$project$View$ActionItems$viewForNote_fn);
    var $author$project$View$ActionItems$viewAll_fn = function (env, _v0) {
        var actionItemFader = _v0.bQ;
        var viewConfig = _v0.p0;
        var noteFilter = _v0.np;
        var actionItemFilter = _v0.jS;
        var viewActionItemsForNote_ = A3($author$project$View$ActionItems$viewForNote, env, function () {
            var $r = viewConfig.$c();
            $r.n8 = false;
            return $r;
        }(), actionItemFader);
        var toPosix = $author$project$Data$Time$toPosix(env.pu);
        var extractActionItems = function (_v2) {
            var noteId = _v2.a;
            var note = _v2.b;
            return $author$project$View$ActionItems$extractFromNote((new $$Record126(actionItemFilter, actionItemFader.O, note, noteId, viewConfig.eG)));
        };
        return $elm$core$List$map_fn(viewActionItemsForNote_, $elm$core$List$reverse(_List_sortBy_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.l;
        }, A2($elm$core$Basics$composeR, function ($) {
            return $.gh;
        }, A2($elm$core$Basics$composeR, toPosix, $elm$time$Time$posixToMillis))), $elm$core$List$filterMap_fn(extractActionItems, A2($author$project$Firestore$Collection$filter, F2(function (_v1, note) {
            return noteFilter(note);
        }), env.fO)))));
    }, $author$project$View$ActionItems$viewAll = F2($author$project$View$ActionItems$viewAll_fn);
    var $author$project$Page$ActionItems$view_fn = function (env, model) {
        var options = $author$project$Page$ActionItems$getOptions(env);
        var optionsSection = $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$Font$size(15),
            $mdgriffith$elm_ui$Element$Font$color(env.nI.a8),
            $mdgriffith$elm_ui$Element$Border$color(env.nI.aQ),
            $mdgriffith$elm_ui$Element$Border$widthEach((new $$Record115(1, 0, 0, 0))),
            $author$project$View$Styling$paddingBottom(10)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_Nil, $author$project$Page$ActionItems$sortOrderButton(options)),
            $author$project$Page$ActionItems$showCompletedToggle_fn(env, options.eG)
        ]));
        var actionItemsViewConfig = $$update__eG($author$project$View$ActionItems$defaultViewConfig, options.eG);
        var actionItemElements = A4($author$project$Util$Misc$if_, options.c6, $elm$core$List$reverse, $elm$core$Basics$identity, $elm$core$List$map_fn($elm$core$Tuple$mapSecond($mdgriffith$elm_ui$Element$map($author$project$Page$ActionItems$ActionItemMsg)), $author$project$View$ActionItems$viewAll_fn(env, (new $$Record127(model.bQ, $elm$core$Basics$always(true), $elm$core$Basics$always(true), actionItemsViewConfig)))));
        return $author$project$View$Layout$onePanel_fn(env, _List_Nil, _List_fromArray([
            optionsSection,
            function () {
                if (!actionItemElements.b) {
                    return $author$project$Page$ActionItems$emptyStateInfoCard(env);
                }
                else {
                    var elts = actionItemElements;
                    return $mdgriffith$elm_ui$Element$Keyed$column_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$spacing(40)
                    ]), elts);
                }
            }()
        ]));
    }, $author$project$Page$ActionItems$view = F2($author$project$Page$ActionItems$view_fn);
    var $mdgriffith$elm_ui$Element$fillPortion = $mdgriffith$elm_ui$Internal$Model$Fill;
    var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
        if (data.$ === 1) {
            return true;
        }
        else {
            return false;
        }
    };
    var $krisajenkins$remotedata$RemoteData$isNotAsked = function (data) {
        if (!data.$) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Data$BillingAccount$isUnexpiredGift_fn = function (currentMinute, mGiftStatus) {
        if (mGiftStatus.$ === 1) {
            return false;
        }
        else {
            switch (mGiftStatus.a.$) {
                case 1:
                    var _v1 = mGiftStatus.a;
                    return true;
                case 2:
                    var _v2 = mGiftStatus.a;
                    return true;
                default:
                    var expiration = mGiftStatus.a.a.hn;
                    return $author$project$Util$Time$isAfter_fn(currentMinute, expiration);
            }
        }
    }, $author$project$Data$BillingAccount$isUnexpiredGift = F2($author$project$Data$BillingAccount$isUnexpiredGift_fn);
    var $author$project$Page$Billing$StripeGenerateSubscriptionManagementUrl = 0;
    var $author$project$Page$Billing$manageBillingButton = function (env) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_Nil, $author$project$View$Widgets$button_fn({
            hp: _List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(env.nI.aO),
                $mdgriffith$elm_ui$Element$Border$width(0),
                $mdgriffith$elm_ui$Element$padding(10),
                $mdgriffith$elm_ui$Element$Font$color(env.nI.aU),
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Background$color(env.nI.aP)
                ])),
                $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Background$color(env.nI.aP)
                ])),
                $mdgriffith$elm_ui$Element$Font$size(15)
            ]),
            l7: $elm$core$Maybe$Nothing,
            fQ: $elm$core$Maybe$Just(0)
        }, "Manage Billing"));
    };
    var $author$project$Page$Billing$view_fn = function (env, model) {
        var mSubscription = $elm$core$Maybe$andThen_fn(function ($) {
            return $.o0;
        }, env.pV);
        var subscriptionIsActive = $elm$core$Basics$composeR_fn($author$project$Data$Subscription$isActive_a0, $author$project$Data$Subscription$isActive_a1, mSubscription);
        var mBillingAccountGiftStatus = function () {
            var _v3 = env.db.kn;
            if (_v3.$ === 3) {
                var giftStatus = _v3.a.hA;
                return giftStatus;
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }();
        var isGift = $author$project$Data$BillingAccount$isUnexpiredGift_fn(env.k5, mBillingAccountGiftStatus);
        var showManageBillingButton = !isGift;
        var iconName = (!subscriptionIsActive) ? "plug" : (_Utils_eq(mBillingAccountGiftStatus, $elm$core$Maybe$Just($author$project$Data$BillingAccount$GiftedForever)) ? "trophy" : (isGift ? "gift" : "check"));
        var body = $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(20)
        ]), _List_Cons($mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
            $mdgriffith$elm_ui$Element$text("Subscription: "),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$bold,
                $mdgriffith$elm_ui$Element$Font$color(env.nI.a9)
            ]), $mdgriffith$elm_ui$Element$text($author$project$Util$Misc$if__fn(subscriptionIsActive, "Active", "Inactive")))
        ])), isGift ? _List_fromArray([
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$text(function () {
                    if (!mBillingAccountGiftStatus.$) {
                        switch (mBillingAccountGiftStatus.a.$) {
                            case 2:
                                var _v1 = mBillingAccountGiftStatus.a;
                                return "Thank you for all your help making Witful better! Your subscription is free forever.";
                            case 1:
                                var _v2 = mBillingAccountGiftStatus.a;
                                return "Thank you for being a Witful beta user!";
                            default:
                                var expiration = mBillingAccountGiftStatus.a.a.hn;
                                return "You joined Witful from a referral, so your subscription is free through " + (A2($author$project$Util$Time$monthDayYearFormatter, env.pu, expiration) + ".");
                        }
                    }
                    else {
                        return "Since you joined Witful in beta, you have a free membership.";
                    }
                }())
            ]))
        ]) : _List_fromArray([
            $author$project$View$Util$when_fn(showManageBillingButton, $author$project$Page$Billing$manageBillingButton(env)),
            $author$project$View$Util$when_fn(showManageBillingButton, $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(14)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$text("Click the 'Manage Billing' button to update your payment method, review payment history, or cancel your Witful subscription.")
            ])))
        ])));
        return $author$project$View$Layout$onePanel_fn(env, _List_Nil, _List_fromArray([
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(20)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(25),
                    $mdgriffith$elm_ui$Element$Font$light,
                    $mdgriffith$elm_ui$Element$centerX
                ]), $mdgriffith$elm_ui$Element$text("Billing Status")),
                $author$project$View$Util$horizontalLine_fn(env.nI, 1, _List_Nil),
                ($krisajenkins$remotedata$RemoteData$isLoading(env.db.kn) || $krisajenkins$remotedata$RemoteData$isNotAsked(env.db.kn)) ? $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]), $author$project$View$Widgets$loadingAnimation) : ($krisajenkins$remotedata$RemoteData$isFailure(env.db.kn) ? $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(20),
                    $mdgriffith$elm_ui$Element$centerX
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([$mdgriffith$elm_ui$Element$Font$center]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Sorry! We were unable to load your billing information. Our developers have been notified.")
                    ])),
                    $author$project$View$Widgets$contactOurTeam(env.nI)
                ])) : $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0),
                    $mdgriffith$elm_ui$Element$spacing(30)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$alignTop,
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(2))
                    ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Border$rounded(999),
                        $mdgriffith$elm_ui$Element$Background$color(env.nI.a3),
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(70)),
                        $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(70)),
                        $mdgriffith$elm_ui$Element$centerX
                    ]), $author$project$View$Icon$icon_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(32),
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.a7),
                        $mdgriffith$elm_ui$Element$centerX,
                        $mdgriffith$elm_ui$Element$centerY
                    ]), 1, iconName))),
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(6))
                    ]), body)
                ])))
            ]))
        ]));
    }, $author$project$Page$Billing$view = F2($author$project$Page$Billing$view_fn);
    var $author$project$View$Styling$backgroundTransition = $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "background-transition");
    var $author$project$View$Aria$label_a0 = "aria-label", $author$project$View$Aria$label = $author$project$View$Util$attribute($author$project$View$Aria$label_a0);
    var $author$project$View$Icon$buttonWithSize_fn = function (iconSize, _v0, iconStyle, iconName) {
        var onClick = _v0.fQ;
        var extraAttrs = _v0.hp;
        var ariaLabel = _v0.kb;
        return $mdgriffith$elm_ui$Element$Input$button_fn(_Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$medium,
            $mdgriffith$elm_ui$Element$Font$size(14),
            $mdgriffith$elm_ui$Element$Border$rounded(100),
            $author$project$View$Styling$backgroundTransition,
            $author$project$View$Styling$ripple,
            $author$project$View$Styling$focusable,
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(45)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(45)),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$grayAlphaLight)
            ])),
            $author$project$View$Util$attribute_fn($author$project$View$Aria$label_a0, ariaLabel)
        ]), extraAttrs), {
            fF: $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$Font$size(iconSize)
            ]), iconStyle, iconName),
            nz: onClick
        });
    }, $author$project$View$Icon$buttonWithSize = F4($author$project$View$Icon$buttonWithSize_fn);
    var $author$project$View$Icon$button_a0 = 20, $author$project$View$Icon$button = $author$project$View$Icon$buttonWithSize($author$project$View$Icon$button_a0);
    var $author$project$Util$Misc$dropFirstAndLast = function (list) {
        return $elm$core$List$reverse($elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$List$tail($elm$core$List$reverse($elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$List$tail(list))))));
    };
    var $author$project$Data$Settings$isShowWeekends_a0 = $author$project$Data$Settings$get, $author$project$Data$Settings$isShowWeekends_a1 = function ($) {
        return $.di;
    }, $author$project$Data$Settings$isShowWeekends = A2($elm$core$Basics$composeR, $author$project$Data$Settings$isShowWeekends_a0, $author$project$Data$Settings$isShowWeekends_a1);
    var $mdgriffith$elm_ui$Element$Font$hairline = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.pl);
    var $author$project$View$Meeting$meetingTitle_fn = function (palette, meeting) {
        return $elm$core$String$isEmpty(meeting.gj) ? $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(palette.aR)
        ]), $mdgriffith$elm_ui$Element$text("(Untitled Note)")) : $mdgriffith$elm_ui$Element$text($author$project$Util$Text$truncateToNChars_fn(100, meeting.gj));
    }, $author$project$View$Meeting$meetingTitle = F2($author$project$View$Meeting$meetingTitle_fn);
    var $author$project$View$Meeting$layoutterWithTime_fn = function (env, _v0) {
        var badge = _v0.kj;
        var isOngoing = _v0.mx;
        var isConflict = _v0.mu;
        var meeting = _v0.mV;
        var time = meeting.d7 ? "All Day" : ($elm$core$Basics$composeR_fn($author$project$Data$Settings$isShowArmyTime_a0, $author$project$Data$Settings$isShowArmyTime_a1, env) ? A2($author$project$Util$Time$formatTimeOfDayArmy, env.pu, meeting.bF) : A2($author$project$Util$Time$formatTimeOfDay, env.pu, meeting.bF));
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacingXY_fn(0, 5)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$alignTop
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $author$project$View$Util$attrWhen_fn((!isOngoing) && (!isConflict), $mdgriffith$elm_ui$Element$Font$hairline),
                    $author$project$View$Util$attrWhen_fn((!isOngoing) && isConflict, $mdgriffith$elm_ui$Element$Font$color(env.nI.eq)),
                    $mdgriffith$elm_ui$Element$alignTop,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), $mdgriffith$elm_ui$Element$text(time)),
                badge
            ])),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $author$project$View$Styling$breakWord,
                $mdgriffith$elm_ui$Element$Font$size(16)
            ]), _List_fromArray([
                $author$project$View$Meeting$meetingTitle_fn(env.nI, meeting)
            ]))
        ]));
    }, $author$project$View$Meeting$layoutterWithTime = F2($author$project$View$Meeting$layoutterWithTime_fn);
    var $ryannhg$date_format$DateFormat$MonthNameFull = { $: 4 };
    var $ryannhg$date_format$DateFormat$monthNameFull = $ryannhg$date_format$DateFormat$MonthNameFull;
    var $author$project$Util$Time$monthYearFormatter = $ryannhg$date_format$DateFormat$format(_List_fromArray([
        $ryannhg$date_format$DateFormat$monthNameFull,
        $ryannhg$date_format$DateFormat$text(" "),
        $ryannhg$date_format$DateFormat$yearNumber
    ]));
    var $mdgriffith$elm_ui$Element$scrollbarX = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.om);
    var $author$project$View$Styling$showScrollbar = $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "show-scrollbar");
    var $author$project$Util$Time$startOfWeek_a0 = 10, $author$project$Util$Time$startOfWeek = $justinmimbs$time_extra$Time$Extra$floor($author$project$Util$Time$startOfWeek_a0);
    var $mdgriffith$elm_ui$Internal$Model$Above = 0;
    var $mdgriffith$elm_ui$Element$above = function (element) {
        return $mdgriffith$elm_ui$Element$createNearby_fn(0, element);
    };
    var $mdgriffith$elm_ui$Internal$Model$Below = 1;
    var $mdgriffith$elm_ui$Element$below = function (element) {
        return $mdgriffith$elm_ui$Element$createNearby_fn(1, element);
    };
    var $elm$core$Basics$pi = _Basics_pi;
    var $elm$core$Basics$degrees = function (angleInDegrees) {
        return (angleInDegrees * $elm$core$Basics$pi) / 180;
    };
    var $mdgriffith$elm_ui$Internal$Model$Min_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Min = F2($mdgriffith$elm_ui$Internal$Model$Min_fn);
    var $mdgriffith$elm_ui$Element$minimum_fn = function (i, l) {
        return $mdgriffith$elm_ui$Internal$Model$Min_fn(i, l);
    }, $mdgriffith$elm_ui$Element$minimum = F2($mdgriffith$elm_ui$Element$minimum_fn);
    var $mdgriffith$elm_ui$Internal$Model$Rotate_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Rotate = F2($mdgriffith$elm_ui$Internal$Model$Rotate_fn);
    var $mdgriffith$elm_ui$Internal$Flag$rotate = $mdgriffith$elm_ui$Internal$Flag$flag(24);
    var $mdgriffith$elm_ui$Element$rotate = function (angle) {
        return $mdgriffith$elm_ui$Internal$Model$TransformComponent_fn($mdgriffith$elm_ui$Internal$Flag$rotate, $mdgriffith$elm_ui$Internal$Model$Rotate_fn(_Utils_Tuple3(0, 0, 1), angle));
    };
    var $author$project$View$Config$zIndices = { h7: 10, nR: 11, iJ: 3, iK: 4, i6: 2, js: 12 };
    var $author$project$View$Tooltip$customHelp_fn = function (hidden, palette, xOffset, tooltipContent) {
        var arrowThing = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(10)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(10)),
            $mdgriffith$elm_ui$Element$Background$color(palette.aU),
            $mdgriffith$elm_ui$Element$rotate($elm$core$Basics$degrees(45)),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$moveDown(5),
            $mdgriffith$elm_ui$Element$moveLeft(xOffset)
        ]), $mdgriffith$elm_ui$Element$none);
        var tooltip = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $author$project$View$Util$attrWhen_fn(hidden, $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "tooltip-text")),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$above(arrowThing),
            $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, $author$project$View$Config$zIndices.js),
            $mdgriffith$elm_ui$Element$moveDown(10),
            $mdgriffith$elm_ui$Element$moveRight(xOffset),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(15))
        ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0),
            $mdgriffith$elm_ui$Element$Border$rounded(5),
            $mdgriffith$elm_ui$Element$Background$color(palette.aU),
            $mdgriffith$elm_ui$Element$Font$color(palette.aM),
            $mdgriffith$elm_ui$Element$Font$size(14),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$minimum_fn(35, $mdgriffith$elm_ui$Element$fill))
        ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerY]), tooltipContent)));
        return $mdgriffith$elm_ui$Element$el(_List_fromArray([
            $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "tooltip"),
            $mdgriffith$elm_ui$Element$below(tooltip),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]));
    }, $author$project$View$Tooltip$customHelp = F4($author$project$View$Tooltip$customHelp_fn);
    var $author$project$View$Tooltip$custom_a0 = true, $author$project$View$Tooltip$custom = $author$project$View$Tooltip$customHelp($author$project$View$Tooltip$custom_a0);
    var $author$project$View$Shortcut$viewSmallKey_fn = function (palette, key) {
        var maybeMoveUp = function (isAlpha) {
            return $author$project$View$Util$attrWhen_fn(isAlpha, $mdgriffith$elm_ui$Element$moveUp(1));
        }($elm$core$Char$isAlpha($elm$core$Maybe$withDefault_fn(" ", $elm$core$List$head($elm$core$String$toList(key)))));
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$minimum_fn(20, $mdgriffith$elm_ui$Element$shrink)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$minimum_fn(20, $mdgriffith$elm_ui$Element$shrink)),
            $mdgriffith$elm_ui$Element$Border$rounded(4),
            $mdgriffith$elm_ui$Element$Background$color(palette.aS),
            $mdgriffith$elm_ui$Element$Font$size(14)
        ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY, maybeMoveUp]), $mdgriffith$elm_ui$Element$text($elm$core$String$toLower(key))));
    }, $author$project$View$Shortcut$viewSmallKey = F2($author$project$View$Shortcut$viewSmallKey_fn);
    var $author$project$View$Shortcut$tooltip_fn = function (palette, xOffset, _v0) {
        var key = _v0.mC;
        var shortDesc = _v0.ox;
        return $author$project$View$Tooltip$customHelp_fn($author$project$View$Tooltip$custom_a0, palette, xOffset, $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(15)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$text(shortDesc),
            $author$project$View$Shortcut$viewSmallKey_fn(palette, key)
        ])));
    }, $author$project$View$Shortcut$tooltip = F3($author$project$View$Shortcut$tooltip_fn);
    var $author$project$View$Meeting$viewLoadingBadge_fn = function (palette, showShimmer, attrs) {
        return $mdgriffith$elm_ui$Element$el_fn(_Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(20)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(20)),
            $mdgriffith$elm_ui$Element$Border$rounded(10),
            $author$project$View$Util$attrWhen_fn(showShimmer, $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "shimmer")),
            $author$project$View$Util$attrWhen_fn(!showShimmer, $mdgriffith$elm_ui$Element$Background$color(palette.aQ)),
            $mdgriffith$elm_ui$Element$alignRight,
            $mdgriffith$elm_ui$Element$centerY
        ]), attrs), $mdgriffith$elm_ui$Element$none);
    }, $author$project$View$Meeting$viewLoadingBadge = F3($author$project$View$Meeting$viewLoadingBadge_fn);
    var $author$project$View$Meeting$viewLoadingCalendarBlock_fn = function (palette, _v0) {
        var showShimmer = _v0.oA;
        var showBadge = _v0.jc;
        var grayLine = function (size) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $author$project$View$Util$style_fn("width", $elm$core$String$fromInt(size) + "%"),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(11)),
                $mdgriffith$elm_ui$Element$Border$rounded(6),
                $author$project$View$Util$attrWhen_fn(showShimmer, $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "shimmer")),
                $author$project$View$Util$attrWhen_fn(!showShimmer, $mdgriffith$elm_ui$Element$Background$color(palette.aQ)),
                $mdgriffith$elm_ui$Element$centerY
            ]), $mdgriffith$elm_ui$Element$none);
        };
        var grayLines = $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(10),
            $mdgriffith$elm_ui$Element$inFront($author$project$View$Util$when_fn(showBadge, $author$project$View$Meeting$viewLoadingBadge_fn(palette, showShimmer, _List_fromArray([$mdgriffith$elm_ui$Element$alignTop]))))
        ]), _List_fromArray([
            grayLine(35),
            grayLine(70)
        ]));
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(58)),
            $mdgriffith$elm_ui$Element$padding(10),
            $mdgriffith$elm_ui$Element$Border$rounded(10),
            $mdgriffith$elm_ui$Element$Background$color(palette.aO)
        ]), grayLines);
    }, $author$project$View$Meeting$viewLoadingCalendarBlock = F2($author$project$View$Meeting$viewLoadingCalendarBlock_fn);
    var $author$project$View$Meeting$blockSpacing = 14;
    var $mdgriffith$elm_ui$Element$Keyed$el_fn = function (attrs, child) {
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), attrs)), $mdgriffith$elm_ui$Internal$Model$Keyed(_List_fromArray([child])));
    }, $mdgriffith$elm_ui$Element$Keyed$el = F2($mdgriffith$elm_ui$Element$Keyed$el_fn);
    var $mdgriffith$elm_ui$Internal$Flag$bgGradient = $mdgriffith$elm_ui$Internal$Flag$flag(10);
    var $mdgriffith$elm_ui$Element$Background$gradient = function (_v0) {
        var angle = _v0.j6;
        var steps = _v0.oT;
        if (!steps.b) {
            return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
        }
        else {
            if (!steps.b.b) {
                var clr = steps.a;
                return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$bgColor, $mdgriffith$elm_ui$Internal$Model$Colored_fn("bg-" + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr), "background-color", clr));
            }
            else {
                return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$bgGradient, $mdgriffith$elm_ui$Internal$Model$Single_fn("bg-grad-" + $elm$core$String$join_fn("-", _List_Cons($mdgriffith$elm_ui$Internal$Model$floatClass(angle), $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$formatColorClass, steps))), "background-image", "linear-gradient(" + ($elm$core$String$join_fn(", ", _List_Cons($elm$core$String$fromFloat(angle) + "rad", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$formatColor, steps))) + ")")));
            }
        }
    };
    var $mdgriffith$elm_ui$Internal$Flag$borderStyle = $mdgriffith$elm_ui$Internal$Flag$flag(11);
    var $mdgriffith$elm_ui$Element$Border$solid = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$borderStyle, $mdgriffith$elm_ui$Internal$Style$classes.kv);
    var $author$project$Util$Time$startOfDay_a0 = 11, $author$project$Util$Time$startOfDay = $justinmimbs$time_extra$Time$Extra$floor($author$project$Util$Time$startOfDay_a0);
    var $author$project$Lib$Focuser$startingPoint = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
        $elm$core$Basics$composeL_fn($author$project$View$Util$id_a0, $author$project$View$Util$id_a1, $author$project$Lib$Focuser$startingPointId),
        $author$project$View$Util$tabIndex($elm$core$Maybe$Just(-1))
    ]), $mdgriffith$elm_ui$Element$none);
    var $author$project$View$Meeting$viewWeekdayHelper_fn = function (env, isLoadingShimmer, index, day, elts) {
        var isToday = _Utils_eq($justinmimbs$time_extra$Time$Extra$floor_fn($author$project$Util$Time$startOfDay_a0, env.pu, day), $justinmimbs$time_extra$Time$Extra$floor_fn($author$project$Util$Time$startOfDay_a0, env.pu, env.k5));
        var maybeTabIndexStart = $author$project$View$Util$when_fn(isToday && (!isLoadingShimmer), $author$project$Lib$Focuser$startingPoint);
        var gradientUnderline = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(3)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$alignBottom,
            $mdgriffith$elm_ui$Element$Background$gradient({
                j6: ($elm$core$Basics$pi / 2) * function () {
                    var _v1 = $elm$core$Basics$composeR_fn($author$project$Data$Settings$theme_a0, $author$project$Data$Settings$theme_a1, env);
                    switch (_v1) {
                        case 1:
                            return -1;
                        case 4:
                            return -1;
                        default:
                            return 1;
                    }
                }(),
                oT: _List_fromArray([env.nI.a2, env.nI.dF])
            })
        ]), $mdgriffith$elm_ui$Element$none);
        var borderWidths = (new $$Record115(0, (!index) ? 0 : 1, 0, 0));
        var _v0 = isToday ? _Utils_Tuple2(env.nI.a2, $mdgriffith$elm_ui$Element$Font$semiBold) : _Utils_Tuple2(env.nI.cd, $mdgriffith$elm_ui$Element$Font$regular);
        var foregroundColor = _v0.a;
        var headerWeight = _v0.b;
        return $mdgriffith$elm_ui$Element$Keyed$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), $elm$core$Tuple$pair_fn($elm$core$String$fromInt($elm$time$Time$posixToMillis(day)), $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$minimum_fn(170, $mdgriffith$elm_ui$Element$fill)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$Border$widthEach(borderWidths),
            $mdgriffith$elm_ui$Element$Border$color(env.nI.aO),
            $author$project$View$Util$attrWhen_fn(isLoadingShimmer, $mdgriffith$elm_ui$Element$spacingXY_fn(0, 15))
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$padding(2),
                $mdgriffith$elm_ui$Element$Border$solid,
                $mdgriffith$elm_ui$Element$Border$color(env.nI.aO),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Border$widthEach((new $$Record115(1, 0, 0, 0))),
                $mdgriffith$elm_ui$Element$inFront($author$project$View$Util$when_fn(isToday, gradientUnderline)),
                $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Background$color(env.nI.a0)
                ]))
            ]), $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Font$color(foregroundColor),
                headerWeight,
                $author$project$View$Styling$focusable,
                $mdgriffith$elm_ui$Element$paddingXY_fn(8, 6)
            ]), {
                fF: $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$column_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text($elm$core$String$toUpper($author$project$Util$Time$weekDayToWord($elm$time$Time$toWeekday_fn(env.pu, day))))
                    ])),
                    $mdgriffith$elm_ui$Element$text("  "),
                    $mdgriffith$elm_ui$Element$column_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text($elm$core$String$fromInt($elm$time$Time$toDay_fn(env.pu, day)))
                    ]))
                ])),
                dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteHome($elm$core$Maybe$Just($justinmimbs$date$Date$fromPosix_fn(env.pu, day))))
            })),
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0),
                $author$project$View$Util$attrWhen_fn(isLoadingShimmer, $mdgriffith$elm_ui$Element$spacingXY_fn(0, $author$project$View$Meeting$blockSpacing))
            ]), _List_Cons(maybeTabIndexStart, elts))
        ]))));
    }, $author$project$View$Meeting$viewWeekdayHelper = F5($author$project$View$Meeting$viewWeekdayHelper_fn);
    var $author$project$View$Meeting$viewLoadingWeekday_fn = function (_v0, env, index, day) {
        var showShimmer = _v0.oA;
        var _v1 = $elm$random$Random$step_fn($elm$random$Random$int_fn(1, 3), $elm$random$Random$initialSeed($elm$time$Time$posixToMillis(day) + index));
        var randomInt = _v1.a;
        var showBadge = function (blockIndex) {
            return _Basics_modBy_fn(4, (randomInt + blockIndex) + index) < 2;
        };
        var emptyBlocks = $elm$core$List$indexedMap_fn_unwrapped(function (i, showBadge_) {
            return $author$project$View$Meeting$viewLoadingCalendarBlock_fn(env.nI, {
                jc: showBadge_(i),
                oA: showShimmer
            });
        }, $elm$core$List$repeat_fn(randomInt, showBadge));
        return $author$project$View$Meeting$viewWeekdayHelper_fn(env, true, index, day, emptyBlocks);
    }, $author$project$View$Meeting$viewLoadingWeekday = F4($author$project$View$Meeting$viewLoadingWeekday_fn);
    var $author$project$Data$Meeting$BlockAdHocAdder = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Data$Meeting$BlockConflict = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$Meeting$BlockEmptyDayAdder = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Data$Meeting$BlockSingleMeeting = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$Meeting$BlockSpacer = { $: 5 };
    var $author$project$Data$Meeting$BlockUpNextDivider = { $: 2 };
    var $author$project$Data$Meeting$Building = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$Meeting$ConflictState_fn = function (conflictTime, eventless, declined, conflicting) {
        return (new $$Record128(conflictTime, conflicting, declined, eventless));
    }, $author$project$Data$Meeting$ConflictState = F4($author$project$Data$Meeting$ConflictState_fn);
    var $author$project$Data$Meeting$MeetingGroup_fn = function (allDay, timed) {
        return (new $$Record129(allDay, timed));
    }, $author$project$Data$Meeting$MeetingGroup = F2($author$project$Data$Meeting$MeetingGroup_fn);
    var $author$project$Data$Meeting$Ready = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$Meeting$hasEvent = function (_v0) {
        var parent = _v0.nJ;
        if (!parent.$) {
            return true;
        }
        else {
            var note = parent.b;
            return $author$project$Data$Note$hasEvent(note);
        }
    };
    var $author$project$Data$Meeting$addToConflicts_fn = function (meeting, conflictState) {
        var declined = meeting.bo;
        return ($author$project$Data$Meeting$hasEvent(meeting) && (!declined)) ? function () {
            var $r = conflictState.$c();
            $r.e6 = _List_Cons(meeting, conflictState.e6);
            return $r;
        }() : (($author$project$Data$Meeting$hasEvent(meeting) && declined) ? function () {
            var $r = conflictState.$c();
            $r.bo = _List_Cons(meeting, conflictState.bo);
            return $r;
        }() : function () {
            var $r = conflictState.$c();
            $r.fi = _List_Cons(meeting, conflictState.fi);
            return $r;
        }());
    }, $author$project$Data$Meeting$addToConflicts = F2($author$project$Data$Meeting$addToConflicts_fn);
    var $author$project$Data$Meeting$meetingsForTimeRange_fn = function (env, from, to) {
        var toPosix = $author$project$Data$Time$toPosix(env.pu);
        var timeInRange = function (time) {
            return $author$project$Util$Time$isOnOrAfter_fn(from, toPosix(time)) && $author$project$Util$Time$isBefore_fn(to, toPosix(time));
        };
        return $author$project$Data$Meeting$meetingsBy_fn(env.lw, env.fO, env.pu, {
            cA: function (note) {
                return timeInRange(note.gh) && (!note.lh);
            },
            cT: function (event) {
                return timeInRange(event.oN);
            },
            cU: F2(function (event, note) {
                return timeInRange(event.oN) && (!note.lh);
            })
        });
    }, $author$project$Data$Meeting$meetingsForTimeRange = F3($author$project$Data$Meeting$meetingsForTimeRange_fn);
    var $author$project$Util$Triple$third = function (_v0) {
        var a = _v0.a;
        var b = _v0.b;
        var c = _v0.c;
        return c;
    };
    var $author$project$Data$Meeting$buildAgenda_fn = function (time, env) {
        var timezoneUser = env.pu;
        var withDefaultList = F2(function (_default, l) {
            return $elm$core$List$isEmpty(l) ? _default : l;
        });
        var timeBetween = F2(function (recent, next) {
            return function (diff) {
                return A2($author$project$Util$Time$addMins, (diff / 2) | 0, recent.bF);
            }($justinmimbs$time_extra$Time$Extra$diff_fn(13, timezoneUser, recent.bF, next.bF));
        });
        var shouldDivide = F3(function (alreadyDivided, recent, next) {
            var beforeNext = $author$project$Util$Time$isBefore_fn($author$project$Util$Time$add_fn($author$project$Util$Time$minute * 5, next), env.k5);
            var afterRecent = $author$project$Util$Time$isAfter_fn(recent, env.k5);
            return (!alreadyDivided) && (afterRecent && beforeNext);
        });
        var reducer = F3(function (current, mNextMeeting, _v12) {
            var divided = _v12.a;
            var conflicts = _v12.b;
            var acc = _v12.c;
            var dividerPlaced = F2(function (recent, next) {
                return A3(shouldDivide, divided, recent.bF, next.bF);
            });
            var divider = F2(function (recent, next) {
                return A2(dividerPlaced, recent, next) ? _List_fromArray([$author$project$Data$Meeting$BlockUpNextDivider]) : _List_Nil;
            });
            var conflictsWithNext = $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(function (next) {
                return _Utils_eq(current.bF, next.bF);
            }, mNextMeeting));
            var nextConflicts = function () {
                var _v9 = _Utils_Tuple2(conflictsWithNext, conflicts);
                _v9$4: while (true) {
                    if (_v9.a) {
                        if (_v9.b.$ === 1) {
                            var _v11 = _v9.b;
                            return $elm$core$Maybe$Just($author$project$Data$Meeting$Building($author$project$Data$Meeting$addToConflicts_fn(current, $author$project$Data$Meeting$ConflictState_fn(current.bF, _List_Nil, _List_Nil, _List_Nil))));
                        }
                        else {
                            if (_v9.b.a.$ === 1) {
                                var conflictState = _v9.b.a.a;
                                return $elm$core$Maybe$Just($author$project$Data$Meeting$Building($author$project$Data$Meeting$addToConflicts_fn(current, conflictState)));
                            }
                            else {
                                break _v9$4;
                            }
                        }
                    }
                    else {
                        if (_v9.b.$ === 1) {
                            var _v10 = _v9.b;
                            return $elm$core$Maybe$Nothing;
                        }
                        else {
                            if (_v9.b.a.$ === 1) {
                                var conflictState = _v9.b.a.a;
                                return $elm$core$Maybe$Just($author$project$Data$Meeting$Ready($author$project$Data$Meeting$addToConflicts_fn(current, conflictState)));
                            }
                            else {
                                break _v9$4;
                            }
                        }
                    }
                }
                return $elm$core$Maybe$Nothing;
            }();
            var adHocNote = function (mins) {
                return $author$project$Data$Meeting$BlockAdHocAdder(A2($author$project$Util$Time$addMins, mins, current.bF));
            };
            var _v0 = _Utils_Tuple3(acc, nextConflicts, mNextMeeting);
            if (!_v0.b.$) {
                if (_v0.b.a.$ === 1) {
                    return _Utils_Tuple3(divided, nextConflicts, acc);
                }
                else {
                    if (!_v0.c.$) {
                        if (!_v0.a.b) {
                            var conflict = _v0.b.a.a;
                            var next = _v0.c.a;
                            return _Utils_Tuple3(A2(dividerPlaced, current, next), $elm$core$Maybe$Nothing, _Utils_ap(A2(divider, current, next), _List_Cons($author$project$Data$Meeting$BlockAdHocAdder(A2(timeBetween, current, next)), _List_Cons($author$project$Data$Meeting$BlockConflict(conflict), _List_Cons(adHocNote(-30), acc)))));
                        }
                        else {
                            var xs = _v0.a;
                            var conflict = _v0.b.a.a;
                            var next = _v0.c.a;
                            return _Utils_Tuple3(A2(dividerPlaced, current, next), $elm$core$Maybe$Nothing, _Utils_ap(A2(divider, current, next), _List_Cons($author$project$Data$Meeting$BlockAdHocAdder(A2(timeBetween, current, next)), _List_Cons($author$project$Data$Meeting$BlockConflict(conflict), xs))));
                        }
                    }
                    else {
                        if (!_v0.a.b) {
                            var conflict = _v0.b.a.a;
                            var _v1 = _v0.c;
                            return _Utils_Tuple3(divided, $elm$core$Maybe$Nothing, _List_Cons(adHocNote(30), _List_Cons($author$project$Data$Meeting$BlockConflict(conflict), _List_Cons(adHocNote(-30), acc))));
                        }
                        else {
                            var xs = _v0.a;
                            var conflict = _v0.b.a.a;
                            var _v2 = _v0.c;
                            return _Utils_Tuple3(divided, $elm$core$Maybe$Nothing, _List_Cons(adHocNote(30), _List_Cons($author$project$Data$Meeting$BlockConflict(conflict), xs)));
                        }
                    }
                }
            }
            else {
                if (_v0.c.$ === 1) {
                    if (!_v0.a.b) {
                        var _v3 = _v0.b;
                        var _v4 = _v0.c;
                        return _Utils_Tuple3(divided, $elm$core$Maybe$Nothing, _List_Cons(adHocNote(30), _List_Cons($author$project$Data$Meeting$BlockSingleMeeting(current), _List_Cons(adHocNote(-30), _List_Nil))));
                    }
                    else {
                        var xs = _v0.a;
                        var _v6 = _v0.b;
                        var _v7 = _v0.c;
                        return _Utils_Tuple3(divided, $elm$core$Maybe$Nothing, _List_Cons(adHocNote(30), _List_Cons($author$project$Data$Meeting$BlockSingleMeeting(current), xs)));
                    }
                }
                else {
                    if (!_v0.a.b) {
                        var _v5 = _v0.b;
                        var next = _v0.c.a;
                        return _Utils_Tuple3(A2(dividerPlaced, current, next), $elm$core$Maybe$Nothing, _Utils_ap(A2(divider, current, next), _List_Cons($author$project$Data$Meeting$BlockAdHocAdder(A2(timeBetween, current, next)), _List_Cons($author$project$Data$Meeting$BlockSingleMeeting(current), _List_Cons(adHocNote(-30), _List_Nil)))));
                    }
                    else {
                        var xs = _v0.a;
                        var _v8 = _v0.b;
                        var next = _v0.c.a;
                        return _Utils_Tuple3(A2(dividerPlaced, current, next), $elm$core$Maybe$Nothing, _Utils_ap(A2(divider, current, next), _List_Cons($author$project$Data$Meeting$BlockAdHocAdder(A2(timeBetween, current, next)), _List_Cons($author$project$Data$Meeting$BlockSingleMeeting(current), xs))));
                    }
                }
            }
        });
        var meetingGrouper = F2(function (meeting, acc) {
            return meeting.d7 ? function () {
                var $r = acc.$c();
                $r.dx = _List_Cons(meeting, acc.dx);
                return $r;
            }() : function () {
                var $r = acc.$c();
                $r.eP = _List_Cons(meeting, acc.eP);
                return $r;
            }();
        });
        var dayStart = $justinmimbs$time_extra$Time$Extra$floor_fn($author$project$Util$Time$startOfDay_a0, timezoneUser, time);
        var nineAM = $justinmimbs$time_extra$Time$Extra$add_fn(12, 9, timezoneUser, dayStart);
        var dayEnd = $author$project$Util$Time$subtract_fn(1, $justinmimbs$time_extra$Time$Extra$add_fn(11, 1, timezoneUser, dayStart));
        var meetings_ = $elm$core$List$foldr_fn(meetingGrouper, $author$project$Data$Meeting$MeetingGroup_fn(_List_Nil, _List_Nil), $author$project$Data$Meeting$meetingsForTimeRange_fn(env, dayStart, dayEnd));
        var timedBlocks = $elm$core$List$reverse($author$project$Util$Triple$third($author$project$Util$Misc$foldl2_fn(reducer, _Utils_Tuple3(false, $elm$core$Maybe$Nothing, _List_Nil), meetings_.eP)));
        var allDayBlocks = function (xs) {
            return $elm$core$List$isEmpty(xs) ? _List_Nil : _List_Cons($author$project$Data$Meeting$BlockSpacer, xs);
        }($elm$core$List$intersperse_fn($author$project$Data$Meeting$BlockSpacer, $elm$core$List$map_fn($author$project$Data$Meeting$BlockSingleMeeting, meetings_.dx)));
        return ($elm$core$List$isEmpty(allDayBlocks) && $elm$core$List$isEmpty(timedBlocks)) ? _List_fromArray([
            $author$project$Data$Meeting$BlockEmptyDayAdder(nineAM)
        ]) : _Utils_ap(allDayBlocks, A2(withDefaultList, _List_fromArray([
            $author$project$Data$Meeting$BlockAdHocAdder(nineAM)
        ]), timedBlocks));
    }, $author$project$Data$Meeting$buildAgenda = F2($author$project$Data$Meeting$buildAgenda_fn);
    var $mdgriffith$elm_ui$Element$Font$italic = $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mz);
    var $mdgriffith$elm_ui$Internal$Model$OnLeft = 3;
    var $mdgriffith$elm_ui$Element$onLeft = function (element) {
        return $mdgriffith$elm_ui$Element$createNearby_fn(3, element);
    };
    var $author$project$View$Meeting$viewAddNote_fn = function (palette, start) {
        var label = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Border$width(2),
            $mdgriffith$elm_ui$Element$Border$color(palette.a3),
            $mdgriffith$elm_ui$Element$Border$rounded(4),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$onLeft($mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(palette.a3),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(16)),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(16)),
                $mdgriffith$elm_ui$Element$Border$rounded(10),
                $mdgriffith$elm_ui$Element$moveRight(6),
                $mdgriffith$elm_ui$Element$moveUp(8)
            ]), $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$Font$size(12),
                $mdgriffith$elm_ui$Element$Font$color(palette.a6)
            ]), 3, "plus")))
        ]), $mdgriffith$elm_ui$Element$none);
        return $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
            $author$project$View$Util$tabIndex($elm$core$Maybe$Nothing),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$View$Meeting$blockSpacing)),
            $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "add-new-note")
        ]), {
            fF: label,
            dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteCreateAdHocNote($elm$core$Maybe$Just(start)))
        });
    }, $author$project$View$Meeting$viewAddNote = F2($author$project$View$Meeting$viewAddNote_fn);
    var $mdgriffith$elm_ui$Element$Border$dashed = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$borderStyle, $mdgriffith$elm_ui$Internal$Style$classes.kt);
    var $author$project$Util$Color$eventColorIdToColor = function (colorId) {
        switch (colorId) {
            case 1:
                return $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$rgb255_fn(121, 134, 203));
            case 2:
                return $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$rgb255_fn(51, 182, 121));
            case 3:
                return $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$rgb255_fn(142, 36, 170));
            case 4:
                return $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$rgb255_fn(230, 124, 115));
            case 5:
                return $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$rgb255_fn(246, 192, 38));
            case 6:
                return $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$rgb255_fn(245, 81, 29));
            case 7:
                return $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$rgb255_fn(3, 155, 229));
            case 8:
                return $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$rgb255_fn(97, 97, 97));
            case 9:
                return $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$rgb255_fn(63, 81, 181));
            case 10:
                return $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$rgb255_fn(11, 128, 67));
            case 11:
                return $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$rgb255_fn(214, 0, 0));
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$View$Icon$Solid = 0;
    var $author$project$Data$ActionItem$isActionItem = function (actionItem) {
        return $elm$core$List$any_fn(function (textEl) {
            _v0$2: while (true) {
                switch (textEl.$) {
                    case 1:
                        return true;
                    case 3:
                        if (!textEl.a.$) {
                            return true;
                        }
                        else {
                            break _v0$2;
                        }
                    default:
                        break _v0$2;
                }
            }
            return false;
        }, actionItem.jn);
    };
    var $author$project$Data$ActionItem$actionItems_a0 = $author$project$Data$ActionItem$isActionItem, $author$project$Data$ActionItem$actionItems = $elm$core$List$filter($author$project$Data$ActionItem$actionItems_a0);
    var $author$project$Data$Note$hasAttachment = function (note) {
        return $elm$core$List$any_fn(function (a) {
            return !(a.lh || a.cf);
        }, note.kd);
    };
    var $author$project$Data$Note$hasImage_a0 = function ($) {
        return $.f6;
    }, $author$project$Data$Note$hasImage_a1 = $elm$core$String$contains("\"type\":\"img\""), $author$project$Data$Note$hasImage = A2($elm$core$Basics$composeR, $author$project$Data$Note$hasImage_a0, $author$project$Data$Note$hasImage_a1);
    var $author$project$Content$Note$introductoryNoteIds = $elm$core$Set$fromList($elm$core$List$append_fn(_List_fromArray(["_example-recurring-meeting-1", "_example-recurring-meeting-2", "_example-recurring-meeting-3", "_example-recurring-meeting-4", $author$project$Content$Note$wizardNoteId]), $elm$core$List$map_fn($elm$core$Tuple$first, $author$project$Content$Note$introductoryNotes_fn($elm$time$Time$utc, $elm$time$Time$millisToPosix(0)))));
    var $author$project$Content$Note$isIntroductoryNoteId = function (noteId) {
        return $elm$core$Set$member_fn(noteId, $author$project$Content$Note$introductoryNoteIds);
    };
    var $author$project$Content$Note$useWelcomeNoteStyling = function (noteId) {
        return $author$project$Content$Note$isIntroductoryNoteId(noteId);
    };
    var $author$project$View$Meeting$noteStateBadge_fn = function (palette, isOngoing, noteId, note) {
        var useWelcomeNoteStyling = $author$project$Content$Note$useWelcomeNoteStyling(noteId);
        var slateActionItems = $elm$core$List$filter_fn($author$project$Data$ActionItem$actionItems_a0, note.gz);
        var uncheckedActionItemCount = $elm$core$List$length($elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $author$project$Data$ActionItem$isComplete, $elm$core$Basics$not), slateActionItems));
        var icon_ = F3(function (color, iconStyle, iconName) {
            return $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(color),
                $mdgriffith$elm_ui$Element$Font$size(16)
            ]), iconStyle, iconName);
        });
        var iconColor = (isOngoing || useWelcomeNoteStyling) ? palette.dw : palette.a7;
        var actionItemsCount = $elm$core$List$length(slateActionItems);
        var actionItemsBadge = ((isOngoing || useWelcomeNoteStyling) && (actionItemsCount > 0)) ? A3(icon_, palette.dw, 0, "check-circle") : ((uncheckedActionItemCount > 0) ? A3(icon_, palette.eg, 2, "check-circle") : ((actionItemsCount > 0) ? A3(icon_, palette.a6, 0, "check-circle") : $mdgriffith$elm_ui$Element$none));
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$alignTop,
            $mdgriffith$elm_ui$Element$spacing(10)
        ]), _List_fromArray([
            actionItemsBadge,
            $author$project$View$Util$when_fn($elm$core$Basics$composeR_fn($author$project$Data$Note$hasImage_a0, $author$project$Data$Note$hasImage_a1, note), A3(icon_, iconColor, 2, "image")),
            $author$project$View$Util$when_fn($author$project$Data$Note$hasAttachment(note), A3(icon_, iconColor, 2, "paperclip")),
            A3(icon_, iconColor, 2, "file-alt")
        ]));
    }, $author$project$View$Meeting$noteStateBadge = F4($author$project$View$Meeting$noteStateBadge_fn);
    var $mdgriffith$elm_ui$Element$Border$roundEach = function (_v0) {
        var topLeft = _v0.pF;
        var topRight = _v0.pG;
        var bottomLeft = _v0.kx;
        var bottomRight = _v0.ky;
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$borderRound, $mdgriffith$elm_ui$Internal$Model$Single_fn("br-" + ($elm$core$String$fromInt(topLeft) + ("-" + ($elm$core$String$fromInt(topRight) + ($elm$core$String$fromInt(bottomLeft) + ("-" + $elm$core$String$fromInt(bottomRight)))))), "border-radius", $elm$core$String$fromInt(topLeft) + ("px " + ($elm$core$String$fromInt(topRight) + ("px " + ($elm$core$String$fromInt(bottomRight) + ("px " + ($elm$core$String$fromInt(bottomLeft) + "px"))))))));
    };
    var $mdgriffith$elm_ui$Element$Font$strike = $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.oW);
    var $author$project$Util$Time$subMins = function (mins) {
        return $author$project$Util$Time$subtract($author$project$Util$Time$minute * mins);
    };
    var $author$project$View$Meeting$viewSingleMeeting_fn = function (palette, _v0, meeting) {
        var notes = _v0.fO;
        var currentMinute = _v0.k5;
        var layoutter = _v0.d8;
        var isConflict = _v0.mu;
        var useWelcomeNoteStyling = function () {
            var _v7 = meeting.nJ;
            if (_v7.$ === 1) {
                var noteId = _v7.a;
                return $author$project$Content$Note$useWelcomeNoteStyling(noteId);
            }
            else {
                return false;
            }
        }();
        var roundedAmount = 10;
        var viewCustomColorBar = function (customColor) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(7)),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Background$color(customColor),
                $mdgriffith$elm_ui$Element$moveRight(0),
                $mdgriffith$elm_ui$Element$Border$roundEach({ kx: roundedAmount, ky: 0, pF: roundedAmount, pG: 0 }),
                $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, 2)
            ]), $mdgriffith$elm_ui$Element$none);
        };
        var isOngoing = function () {
            var _v6 = _Utils_Tuple3(currentMinute, A2($author$project$Util$Time$subMins, 5, meeting.bF), A2($author$project$Util$Time$subMins, 5, meeting.b6));
            var currentTime = _v6.a;
            var start = _v6.b;
            var end = _v6.c;
            return $author$project$Util$Time$isOnOrAfter_fn(start, currentTime) && $author$project$Util$Time$isBefore_fn(end, currentTime);
        }();
        var maybeTooltip = (isOngoing && (!meeting.d7)) ? $author$project$View$Shortcut$tooltip_fn(palette, 0, $author$project$Data$Shortcut$keys.k4) : $elm$core$Basics$identity;
        var styling = function () {
            if (useWelcomeNoteStyling) {
                var theme = palette.pn;
                var gradientStyle = function (steps) {
                    return $mdgriffith$elm_ui$Element$Background$gradient({ j6: $elm$core$Basics$pi / 2, oT: steps });
                };
                var _v3 = function () {
                    if (!theme) {
                        return _Utils_Tuple2(_List_fromArray([palette.a8, palette.dF]), _List_fromArray([palette.a6, palette.dF]));
                    }
                    else {
                        return _Utils_Tuple2(_List_fromArray([palette.a4, palette.a8]), _List_fromArray([palette.a5, palette.a9]));
                    }
                }();
                var gradientSteps = _v3.a;
                var hoverSteps = _v3.b;
                return _List_fromArray([
                    gradientStyle(gradientSteps),
                    $mdgriffith$elm_ui$Element$Font$color(function () {
                        switch (theme) {
                            case 1:
                                return palette.cI;
                            case 4:
                                return palette.aU;
                            default:
                                return palette.dw;
                        }
                    }()),
                    $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                        gradientStyle(hoverSteps)
                    ])),
                    $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                        gradientStyle(hoverSteps)
                    ]))
                ]);
            }
            else {
                if (meeting.bo) {
                    return _List_fromArray([
                        $mdgriffith$elm_ui$Element$Border$solid,
                        $mdgriffith$elm_ui$Element$Border$width(1),
                        $mdgriffith$elm_ui$Element$Border$color(palette.aP),
                        $mdgriffith$elm_ui$Element$Background$color(palette.aL),
                        $mdgriffith$elm_ui$Element$Font$color(palette.aR),
                        $mdgriffith$elm_ui$Element$Font$strike,
                        $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Background$color(palette.aM)
                        ])),
                        $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Background$color(palette.aM)
                        ]))
                    ]);
                }
                else {
                    if (isOngoing) {
                        return _List_fromArray([
                            $mdgriffith$elm_ui$Element$Background$color(palette.a6),
                            $mdgriffith$elm_ui$Element$Font$color(palette.dw),
                            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Background$color(palette.a9)
                            ])),
                            $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Background$color(palette.a9)
                            ])),
                            $mdgriffith$elm_ui$Element$Border$shadow({
                                kp: 4,
                                kS: $mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.25),
                                nt: _Utils_Tuple2(0, 3),
                                oE: 1
                            })
                        ]);
                    }
                    else {
                        return _List_fromArray([
                            $mdgriffith$elm_ui$Element$Background$color(palette.a0),
                            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Background$color(palette.a3)
                            ])),
                            $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Background$color(palette.a3)
                            ]))
                        ]);
                    }
                }
            }
        }();
        var _v1 = function () {
            var _v2 = meeting.nJ;
            if (_v2.$ === 1) {
                var noteId = _v2.a;
                var note = _v2.b;
                return _Utils_Tuple3(function (mNote) {
                    return $author$project$View$Util$whenJust_fn(mNote, A3($author$project$View$Meeting$noteStateBadge, palette, isOngoing, noteId));
                }($author$project$Firestore$Collection$get_fn(noteId, notes)), $author$project$Routing$RouteNote_fn(noteId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing), note.kT);
            }
            else {
                var event = _v2.a;
                return _Utils_Tuple3($mdgriffith$elm_ui$Element$none, $author$project$Routing$RouteCreateEventNote_fn(event.l8, $author$project$Data$Event$masterId(event), $elm$core$Maybe$Nothing), event.kT);
            }
        }();
        var badge = _v1.a;
        var noteRoute = _v1.b;
        var mColorId = _v1.c;
        var maybeCustomColor = $elm$core$Maybe$andThen_fn($author$project$Util$Color$eventColorIdToColor, mColorId);
        return maybeTooltip($mdgriffith$elm_ui$Element$link_fn(_Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$minimum_fn(60, $mdgriffith$elm_ui$Element$shrink)),
            $author$project$View$Styling$backgroundTransition,
            $mdgriffith$elm_ui$Element$Border$rounded(roundedAmount),
            $mdgriffith$elm_ui$Element$Font$color(palette.cd),
            $mdgriffith$elm_ui$Element$pointer,
            $mdgriffith$elm_ui$Element$inFront($author$project$View$Util$whenJust_fn(maybeCustomColor, viewCustomColorBar)),
            $author$project$View$Styling$focusableOnlyBorderStyling
        ]), styling), {
            fF: $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$paddingEach((new $$Record115(10, 12, 16, 10)))
            ]), layoutter({ kj: badge, mu: isConflict, mx: isOngoing, mV: meeting })),
            dt: $author$project$Routing$pathFromRoute(noteRoute)
        }));
    }, $author$project$View$Meeting$viewSingleMeeting = F3($author$project$View$Meeting$viewSingleMeeting_fn);
    var $author$project$View$Meeting$viewConflicts_fn = function (_v0, layoutter, _v1) {
        var palette = _v0.nI;
        var timezoneUser = _v0.pu;
        var currentMinute = _v0.k5;
        var notes = _v0.fO;
        var conflictTime = _v1.kY;
        var eventless = _v1.fi;
        var declined = _v1.bo;
        var conflicting = _v1.e6;
        var sortToMeeting = A2($elm$core$Basics$composeR, $elm$core$List$sortBy(function ($) {
            return $.gj;
        }), $elm$core$List$map(function (meeting) {
            return $author$project$View$Meeting$viewSingleMeeting_fn(palette, (new $$Record130(currentMinute, true, layoutter, notes, timezoneUser)), meeting);
        }));
        var conflictElement = function () {
            if (!conflicting.b) {
                return $mdgriffith$elm_ui$Element$none;
            }
            else {
                if (!conflicting.b.b) {
                    var meeting = conflicting.a;
                    return $author$project$View$Meeting$viewSingleMeeting_fn(palette, (new $$Record130(currentMinute, true, layoutter, notes, timezoneUser)), meeting);
                }
                else {
                    var xs = conflicting;
                    return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Border$color(palette.eg),
                        $mdgriffith$elm_ui$Element$Border$width(2),
                        $mdgriffith$elm_ui$Element$Border$dashed,
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                        $mdgriffith$elm_ui$Element$Border$rounded(9),
                        $mdgriffith$elm_ui$Element$spacingXY_fn(0, $author$project$View$Meeting$blockSpacing),
                        $mdgriffith$elm_ui$Element$padding(1)
                    ]), sortToMeeting(xs));
                }
            }
        }();
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), $elm$core$List$intersperse_fn($author$project$View$Meeting$viewAddNote_fn(palette, conflictTime), _List_Cons(conflictElement, _Utils_ap(sortToMeeting(declined), sortToMeeting(eventless)))));
    }, $author$project$View$Meeting$viewConflicts = F3($author$project$View$Meeting$viewConflicts_fn);
    var $author$project$View$Meeting$viewBlock_fn = function (globalInfo, layoutter, block) {
        var palette = globalInfo.nI;
        var timezoneUser = globalInfo.pu;
        var currentMinute = globalInfo.k5;
        var notes = globalInfo.fO;
        switch (block.$) {
            case 0:
                var meeting = block.a;
                return $author$project$View$Meeting$viewSingleMeeting_fn(palette, (new $$Record130(currentMinute, false, layoutter, notes, timezoneUser)), meeting);
            case 3:
                var posix = block.a;
                return $author$project$View$Meeting$viewAddNote_fn(palette, posix);
            case 2:
                return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacingXY_fn(10, 0),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $author$project$View$Styling$paddingBottom(15)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(palette.aR),
                        $mdgriffith$elm_ui$Element$Font$italic,
                        $mdgriffith$elm_ui$Element$Font$size(12)
                    ]), $mdgriffith$elm_ui$Element$text("Up next")),
                    $author$project$View$Util$horizontalLine_fn(palette, 2, _List_fromArray([
                        $mdgriffith$elm_ui$Element$Border$color(palette.aO)
                    ]))
                ]));
            case 4:
                var posix = block.a;
                return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$paddingXY_fn(0, 13),
                    $mdgriffith$elm_ui$Element$spacing(18)
                ]), _List_fromArray([
                    $author$project$View$Icon$icon_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$centerX,
                        $mdgriffith$elm_ui$Element$Font$color(palette.aQ),
                        $mdgriffith$elm_ui$Element$Font$size(50)
                    ]), 3, "sun"),
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(palette.aQ),
                        $mdgriffith$elm_ui$Element$Font$size(16)
                    ]), $mdgriffith$elm_ui$Element$text("Nothing scheduled.")),
                    $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(palette.a7),
                        $mdgriffith$elm_ui$Element$centerX
                    ]), {
                        fF: $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
                            $mdgriffith$elm_ui$Element$spacing(5)
                        ]), _List_fromArray([
                            $author$project$View$Icon$icon_fn(_List_Nil, 3, "file-alt"),
                            $mdgriffith$elm_ui$Element$text("Add a note")
                        ])),
                        dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteCreateAdHocNote($elm$core$Maybe$Just(posix)))
                    })
                ]));
            case 1:
                var conflictState = block.a;
                return $author$project$View$Meeting$viewConflicts_fn(globalInfo, layoutter, conflictState);
            default:
                return $author$project$View$Util$spacer($author$project$View$Meeting$blockSpacing);
        }
    }, $author$project$View$Meeting$viewBlock = F3($author$project$View$Meeting$viewBlock_fn);
    var $author$project$View$Meeting$viewWeekday_fn = function (env, layoutter, index, day) {
        return $author$project$View$Meeting$viewWeekdayHelper_fn(env, false, index, day, $elm$core$List$map_fn(A2($author$project$View$Meeting$viewBlock, (new $$Record131(env.k5, env.fO, env.nI, env.pu)), layoutter), $author$project$Data$Meeting$buildAgenda_fn(day, env)));
    }, $author$project$View$Meeting$viewWeekday = F4($author$project$View$Meeting$viewWeekday_fn);
    var $justinmimbs$time_extra$Time$Extra$rangeHelp_fn = function (interval, step, zone, until, revList, current) {
        rangeHelp: while (true) {
            if (_Utils_cmp($elm$time$Time$posixToMillis(current), $elm$time$Time$posixToMillis(until)) < 0) {
                var $temp$interval = interval, $temp$step = step, $temp$zone = zone, $temp$until = until, $temp$revList = _List_Cons(current, revList), $temp$current = $justinmimbs$time_extra$Time$Extra$add_fn(interval, step, zone, current);
                interval = $temp$interval;
                step = $temp$step;
                zone = $temp$zone;
                until = $temp$until;
                revList = $temp$revList;
                current = $temp$current;
                continue rangeHelp;
            }
            else {
                return $elm$core$List$reverse(revList);
            }
        }
    }, $justinmimbs$time_extra$Time$Extra$rangeHelp = F6($justinmimbs$time_extra$Time$Extra$rangeHelp_fn);
    var $justinmimbs$time_extra$Time$Extra$range_fn = function (interval, step, zone, start, until) {
        return $justinmimbs$time_extra$Time$Extra$rangeHelp_fn(interval, $elm$core$Basics$max_fn(1, step), zone, until, _List_Nil, $justinmimbs$time_extra$Time$Extra$ceiling_fn(interval, zone, start));
    }, $justinmimbs$time_extra$Time$Extra$range = F5($justinmimbs$time_extra$Time$Extra$range_fn);
    var $author$project$Util$Time$weekDaysThisWeek_fn = function (zone, time) {
        var sunday = $justinmimbs$time_extra$Time$Extra$floor_fn($author$project$Util$Time$startOfWeek_a0, zone, time);
        var followingSunday = $justinmimbs$time_extra$Time$Extra$add_fn(3, 1, zone, sunday);
        return $justinmimbs$time_extra$Time$Extra$range_fn(11, 1, zone, sunday, followingSunday);
    }, $author$project$Util$Time$weekDaysThisWeek = F2($author$project$Util$Time$weekDaysThisWeek_fn);
    var $author$project$Page$Calendar$view_fn = function (env, model) {
        var startOfWeek = $justinmimbs$time_extra$Time$Extra$add_fn(3, model.U, env.pu, $justinmimbs$time_extra$Time$Extra$floor_fn($author$project$Util$Time$startOfWeek_a0, env.pu, env.k5));
        var sevenDays = $author$project$Util$Time$weekDaysThisWeek_fn(env.pu, startOfWeek);
        var maxWidth = $elm$core$Basics$composeR_fn($author$project$Data$Settings$isShowWeekends_a0, $author$project$Data$Settings$isShowWeekends_a1, env) ? 1700 : 1500;
        var layoutter = $author$project$View$Meeting$layoutterWithTime(env);
        var viewWeekday = $author$project$Data$App$isLoading(env.mK) ? A2($author$project$View$Meeting$viewLoadingWeekday, { oA: true }, env) : A2($author$project$View$Meeting$viewWeekday, env, layoutter);
        var days = $elm$core$Basics$composeR_fn($author$project$Data$Settings$isShowWeekends_a0, $author$project$Data$Settings$isShowWeekends_a1, env) ? sevenDays : $author$project$Util$Misc$dropFirstAndLast(sevenDays);
        var calendarHeader = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(20),
            $mdgriffith$elm_ui$Element$moveRight(10)
        ]), $mdgriffith$elm_ui$Element$text(A2($author$project$Util$Time$monthYearFormatter, env.pu, startOfWeek)));
        return $author$project$View$Layout$onePanel_fn(env, _List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(maxWidth, $mdgriffith$elm_ui$Element$fill)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0)
            ]), _List_fromArray([
                calendarHeader,
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([$mdgriffith$elm_ui$Element$alignRight]), _List_fromArray([
                    A4($author$project$View$Shortcut$tooltip, env.nI, 0, $author$project$Data$Shortcut$keys.g2, $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
                        kb: $author$project$Data$Shortcut$keys.g2.q,
                        hp: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.a7)
                        ]),
                        fQ: $elm$core$Maybe$Just($author$project$Page$Calendar$SetAgendaOffset(0))
                    }, 3, "calendar-day")),
                    A4($author$project$View$Shortcut$tooltip, env.nI, -16, $author$project$Data$Shortcut$keys.iI, $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
                        kb: $author$project$Data$Shortcut$keys.iI.q,
                        hp: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.a9)
                        ]),
                        fQ: $elm$core$Maybe$Just($author$project$Page$Calendar$SetAgendaOffset(model.U - 1))
                    }, 1, "chevron-left")),
                    A4($author$project$View$Shortcut$tooltip, env.nI, -48, $author$project$Data$Shortcut$keys.im, $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
                        kb: $author$project$Data$Shortcut$keys.im.q,
                        hp: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.a9)
                        ]),
                        fQ: $elm$core$Maybe$Just($author$project$Page$Calendar$SetAgendaOffset(model.U + 1))
                    }, 1, "chevron-right"))
                ]))
            ])),
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $author$project$View$Styling$showScrollbar,
                $mdgriffith$elm_ui$Element$scrollbarX,
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$padding(10)
            ]), $elm$core$List$indexedMap_fn(viewWeekday, days))
        ]));
    }, $author$project$Page$Calendar$view = F2($author$project$Page$Calendar$view_fn);
    var $author$project$Page$Collate$HandleBacktalk = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Page$Collate$NavBackward = { $: 0 };
    var $author$project$View$Widgets$gridColumn_fn = function (_v0, extraAttrs, gridItems) {
        var maxColWidth = _v0.mU;
        var gridGap = _v0.lU;
        return $mdgriffith$elm_ui$Element$column_fn(_Utils_ap(_List_fromArray([
            $author$project$View$Util$style_fn("display", "grid"),
            $author$project$View$Util$style_fn("grid-template-columns", "repeat(auto-fill, minmax(0px," + ($elm$core$String$fromInt(maxColWidth) + "px))")),
            $author$project$View$Util$style_fn("grid-gap", $elm$core$String$fromInt(gridGap) + "px"),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $author$project$View$Util$style_fn("justify-items", "center"),
            $author$project$View$Util$style_fn("justify-content", "center"),
            $mdgriffith$elm_ui$Element$centerX
        ]), extraAttrs), $elm$core$List$map_fn($mdgriffith$elm_ui$Element$el(_List_fromArray([
            $author$project$View$Util$style_fn("height", "100%"),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ])), gridItems));
    }, $author$project$View$Widgets$gridColumn = F3($author$project$View$Widgets$gridColumn_fn);
    var $author$project$Data$Person$lowerDomains_a0 = function ($) {
        return $.lo;
    }, $author$project$Data$Person$lowerDomains_a1 = A2($elm$core$Basics$composeR, $elm$core$List$map($elm$core$String$toLower), $elm_community$list_extra$List$Extra$unique), $author$project$Data$Person$lowerDomains = A2($elm$core$Basics$composeR, $author$project$Data$Person$lowerDomains_a0, $author$project$Data$Person$lowerDomains_a1);
    var $author$project$View$Collate$notesByPerson_fn = function (notes, people, personId, emailAddresses) {
        return A2($author$project$Firestore$Collection$filter, F2(function (_v0, note) {
            return $elm$core$List$any_fn(function (attendee) {
                var _v1 = attendee.n3;
                if (_v1.$ === 1) {
                    var email = _v1.a;
                    return $elm$core$List$member_fn(email, emailAddresses);
                }
                else {
                    var attendeePersonId = _v1.a;
                    return $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$eq(personId)), $author$project$Data$Person$resolvePerson_fn(attendeePersonId, people)));
                }
            }, note.ke) && (!note.lh);
        }), notes);
    }, $author$project$View$Collate$notesByPerson = F4($author$project$View$Collate$notesByPerson_fn);
    var $elm_community$string_extra$String$Extra$rightOf_fn = function (pattern, string) {
        return $elm$core$String$join_fn("", $elm$core$List$map_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.o$;
        }, $elm_community$string_extra$String$Extra$firstResult), _Regex_findAtMost_fn(1, $elm$core$Basics$composeR_fn($elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1, $elm_community$string_extra$String$Extra$regexEscape(pattern) + "(.*)$"), string)));
    }, $elm_community$string_extra$String$Extra$rightOf = F2($elm_community$string_extra$String$Extra$rightOf_fn);
    var $author$project$View$Collate$relevantNotes_fn = function (env, collation) {
        return A2($author$project$Util$Misc$sortByReverse, function (_v7) {
            var note = _v7.b;
            return $author$project$Data$Time$toMillis_fn(env.pu, note.gh);
        }, function () {
            switch (collation.$) {
                case 0:
                    var masterEventBaseId = collation.a.h8;
                    return A2($author$project$Firestore$Collection$filter, F2(function (_v1, note) {
                        var _v2 = note.hh;
                        if ((!_v2.$) && (_v2.a.$ === 1)) {
                            var masterId = _v2.a.a.mT;
                            return _String_startsWith_fn(masterEventBaseId, masterId) && (!note.lh);
                        }
                        else {
                            return false;
                        }
                    }), env.fO);
                case 1:
                    var personId = collation.a;
                    var _v3 = $author$project$Data$Person$resolvePerson_fn(personId, env.iz);
                    if (!_v3.$) {
                        var _v4 = _v3.a;
                        var person = _v4.b;
                        return $author$project$View$Collate$notesByPerson_fn(env.fO, env.iz, personId, person.lo);
                    }
                    else {
                        return _List_Nil;
                    }
                default:
                    var domainName = collation.a.g9;
                    var lowerDomain = $elm$core$String$toLower(domainName);
                    return A2($author$project$Firestore$Collection$filter, F2(function (_v5, note) {
                        return $elm$core$List$any_fn(function (a) {
                            var _v6 = a.n3;
                            if (_v6.$ === 1) {
                                var email = _v6.a;
                                return _Utils_eq(lowerDomain, $elm$core$String$toLower($elm_community$string_extra$String$Extra$rightOf_fn("@", email)));
                            }
                            else {
                                var id = _v6.a;
                                return $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, A2($elm$core$Basics$composeR, $author$project$Data$Person$lowerDomains, $elm$core$List$member(lowerDomain))), $author$project$Data$Person$resolvePerson_fn(id, env.iz)));
                            }
                        }, note.ke) && (!note.lh);
                    }), env.fO);
            }
        }());
    }, $author$project$View$Collate$relevantNotes = F2($author$project$View$Collate$relevantNotes_fn);
    var $mdgriffith$elm_ui$Element$Font$underline = $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.pN);
    var $author$project$View$Tooltip$basic_fn = function (palette, xOffset, tooltipText) {
        return $author$project$View$Tooltip$customHelp_fn($author$project$View$Tooltip$custom_a0, palette, xOffset, $mdgriffith$elm_ui$Element$text(tooltipText));
    }, $author$project$View$Tooltip$basic = F3($author$project$View$Tooltip$basic_fn);
    var $author$project$View$Styling$elevation10 = $mdgriffith$elm_ui$Element$Border$shadow({
        kp: 6,
        kS: $author$project$Data$Color$grayAlphaLight,
        nt: _Utils_Tuple2(0, 4),
        oE: 1.5
    });
    var $ryannhg$date_format$DateFormat$DayOfWeekNameFull = { $: 14 };
    var $ryannhg$date_format$DateFormat$dayOfWeekNameFull = $ryannhg$date_format$DateFormat$DayOfWeekNameFull;
    var $author$project$Util$Time$conciseDayMonthDayYearFormatter_fn = function (zone, time) {
        var dayName = $elm$core$String$left_fn(3, $elm$core$String$toUpper($ryannhg$date_format$DateFormat$formatWithLanguage_fn($ryannhg$date_format$DateFormat$format_a0, _List_fromArray([$ryannhg$date_format$DateFormat$dayOfWeekNameFull]), zone, time)));
        return $ryannhg$date_format$DateFormat$formatWithLanguage_fn($ryannhg$date_format$DateFormat$format_a0, _List_fromArray([
            $ryannhg$date_format$DateFormat$text(dayName),
            $ryannhg$date_format$DateFormat$text(" "),
            $ryannhg$date_format$DateFormat$monthNumber,
            $ryannhg$date_format$DateFormat$text("/"),
            $ryannhg$date_format$DateFormat$dayOfMonthNumber,
            $ryannhg$date_format$DateFormat$text("/"),
            $ryannhg$date_format$DateFormat$yearNumberLastTwo
        ]), zone, time);
    }, $author$project$Util$Time$conciseDayMonthDayYearFormatter = F2($author$project$Util$Time$conciseDayMonthDayYearFormatter_fn);
    var $author$project$Util$Time$formatTime_fn = function (armyTime, zone, time) {
        return function (x) {
            return A2(x, zone, time);
        }(armyTime ? $author$project$Util$Time$formatTimeOfDayArmy : $author$project$Util$Time$formatTimeOfDay);
    }, $author$project$Util$Time$formatTime = F3($author$project$Util$Time$formatTime_fn);
    var $author$project$Util$Time$isSameDay_fn = function (zone, t1, t2) {
        return _Utils_eq($justinmimbs$time_extra$Time$Extra$floor_fn($author$project$Util$Time$startOfDay_a0, zone, t1), $justinmimbs$time_extra$Time$Extra$floor_fn($author$project$Util$Time$startOfDay_a0, zone, t2));
    }, $author$project$Util$Time$isSameDay = F3($author$project$Util$Time$isSameDay_fn);
    var $author$project$Data$Time$formatTimeRange_fn = function (zone, armyTime, start, mEnd) {
        formatTimeRange: while (true) {
            var monthDayYear = $author$project$Util$Time$conciseDayMonthDayYearFormatter(zone);
            var formatTime = A2($author$project$Util$Time$formatTime, armyTime, zone);
            if (mEnd.$ === 1) {
                if (!start.$) {
                    var t = start.a;
                    return monthDayYear($author$project$Data$Time$toPosix_fn(zone, start)) + (" " + formatTime(t.gh));
                }
                else {
                    return monthDayYear($author$project$Data$Time$toPosix_fn(zone, start));
                }
            }
            else {
                var end = mEnd.a;
                var exactSameTime = _Utils_eq($author$project$Data$Time$toPosix_fn(zone, start), $author$project$Data$Time$toPosix_fn(zone, end));
                var _v2 = _Utils_Tuple2($author$project$Data$Time$toPosix_fn(zone, start), $author$project$Util$Time$subtract_fn(1, $author$project$Data$Time$toPosix_fn(zone, end)));
                var startDatePosix = _v2.a;
                var endDatePosix = _v2.b;
                var sameDay = $author$project$Util$Time$isSameDay_fn(zone, startDatePosix, endDatePosix);
                var _v3 = _Utils_Tuple2(start, end);
                if (!_v3.a.$) {
                    if (_v3.b.$ === 1) {
                        var $temp$zone = zone, $temp$armyTime = armyTime, $temp$start = start, $temp$mEnd = $elm$core$Maybe$Nothing;
                        zone = $temp$zone;
                        armyTime = $temp$armyTime;
                        start = $temp$start;
                        mEnd = $temp$mEnd;
                        continue formatTimeRange;
                    }
                    else {
                        var s = _v3.a.a;
                        var e = _v3.b.a;
                        if (exactSameTime) {
                            var $temp$zone = zone, $temp$armyTime = armyTime, $temp$start = start, $temp$mEnd = $elm$core$Maybe$Nothing;
                            zone = $temp$zone;
                            armyTime = $temp$armyTime;
                            start = $temp$start;
                            mEnd = $temp$mEnd;
                            continue formatTimeRange;
                        }
                        else {
                            if (sameDay) {
                                return monthDayYear(startDatePosix) + (" " + (formatTime(s.gh) + (" - " + formatTime(e.gh))));
                            }
                            else {
                                return monthDayYear(startDatePosix) + (" " + (formatTime(s.gh) + (" - " + (monthDayYear(endDatePosix) + (" " + formatTime(e.gh))))));
                            }
                        }
                    }
                }
                else {
                    if (!_v3.b.$) {
                        var $temp$zone = zone, $temp$armyTime = armyTime, $temp$start = start, $temp$mEnd = $elm$core$Maybe$Nothing;
                        zone = $temp$zone;
                        armyTime = $temp$armyTime;
                        start = $temp$start;
                        mEnd = $temp$mEnd;
                        continue formatTimeRange;
                    }
                    else {
                        return sameDay ? monthDayYear(startDatePosix) : (monthDayYear(startDatePosix) + (" - " + monthDayYear(endDatePosix)));
                    }
                }
            }
        }
    }, $author$project$Data$Time$formatTimeRange = F4($author$project$Data$Time$formatTimeRange_fn);
    var $author$project$View$SlateEditor$SlateDoc = 0;
    var $elm$virtual_dom$VirtualDom$lazy8 = _VirtualDom_lazy8;
    var $elm$html$Html$Lazy$lazy8 = $elm$virtual_dom$VirtualDom$lazy8;
    var $author$project$View$SlateEditor$Content_fn = function (data, tipe) {
        return (new $$Record132(data, tipe));
    }, $author$project$View$SlateEditor$Content = F2($author$project$View$SlateEditor$Content_fn);
    var $author$project$View$SlateEditor$encodeContent = function (content) {
        var encodeContentType = function (contentType) {
            return $elm$json$Json$Encode$string(function () {
                switch (contentType) {
                    case 0:
                        return "slateDoc";
                    case 1:
                        return "html";
                    default:
                        return "text";
                }
            }());
        };
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("data", $elm$json$Json$Encode$string(content.a)),
            _Utils_Tuple2("type", encodeContentType(content.pv))
        ]));
    };
    var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
    var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
    var $author$project$View$SlateEditor$slateCustomElement_fn = function (content, contentType, entityId, eventData, mentionNames, isReadOnly, actionItemId, palette) {
        return A3($elm$html$Html$node, "slate-editor", _List_fromArray([
            $elm$virtual_dom$VirtualDom$property_fn("content", $author$project$View$SlateEditor$encodeContent($author$project$View$SlateEditor$Content_fn(content, contentType))),
            $elm$virtual_dom$VirtualDom$property_fn("entityId", $elm$json$Json$Encode$string(entityId)),
            $elm$virtual_dom$VirtualDom$property_fn("eventData", $elm$json$Json$Encode$string(eventData)),
            $elm$virtual_dom$VirtualDom$property_fn("debug", $elm$json$Json$Encode$bool(false)),
            $elm$virtual_dom$VirtualDom$property_fn("readOnly", $elm$json$Json$Encode$bool(isReadOnly)),
            $elm$virtual_dom$VirtualDom$property_fn("actionItemId", $elm$json$Json$Encode$string(actionItemId)),
            $elm$virtual_dom$VirtualDom$property_fn("palette", $elm$json$Json$Encode$string(palette)),
            $elm$virtual_dom$VirtualDom$property_fn("mentionNames", $elm$json$Json$Encode$string(mentionNames))
        ]), _List_Nil);
    }, $author$project$View$SlateEditor$slateCustomElement = F8($author$project$View$SlateEditor$slateCustomElement_fn);
    var $author$project$Data$Color$colorsWithNames = _List_fromArray([
        _Utils_Tuple2("primary0", function ($) {
            return $.a0;
        }),
        _Utils_Tuple2("primary10", function ($) {
            return $.a1;
        }),
        _Utils_Tuple2("primary20", function ($) {
            return $.a3;
        }),
        _Utils_Tuple2("primary30", function ($) {
            return $.a4;
        }),
        _Utils_Tuple2("primary40", function ($) {
            return $.a5;
        }),
        _Utils_Tuple2("primary50", function ($) {
            return $.a6;
        }),
        _Utils_Tuple2("primary60", function ($) {
            return $.a7;
        }),
        _Utils_Tuple2("primary70", function ($) {
            return $.a8;
        }),
        _Utils_Tuple2("primary80", function ($) {
            return $.a9;
        }),
        _Utils_Tuple2("primary90", function ($) {
            return $.ba;
        }),
        _Utils_Tuple2("primary100", function ($) {
            return $.a2;
        }),
        _Utils_Tuple2("gray0", function ($) {
            return $.aL;
        }),
        _Utils_Tuple2("gray10", function ($) {
            return $.aM;
        }),
        _Utils_Tuple2("gray20", function ($) {
            return $.aN;
        }),
        _Utils_Tuple2("gray30", function ($) {
            return $.aO;
        }),
        _Utils_Tuple2("gray40", function ($) {
            return $.aP;
        }),
        _Utils_Tuple2("gray50", function ($) {
            return $.aQ;
        }),
        _Utils_Tuple2("gray60", function ($) {
            return $.aR;
        }),
        _Utils_Tuple2("gray70", function ($) {
            return $.aS;
        }),
        _Utils_Tuple2("gray80", function ($) {
            return $.aT;
        }),
        _Utils_Tuple2("gray90", function ($) {
            return $.aU;
        }),
        _Utils_Tuple2("gray100", function ($) {
            return $.cd;
        }),
        _Utils_Tuple2("red0", function ($) {
            return $.en;
        }),
        _Utils_Tuple2("red10", function ($) {
            return $.eo;
        }),
        _Utils_Tuple2("red20", function ($) {
            return $.ep;
        }),
        _Utils_Tuple2("red30", function ($) {
            return $.eq;
        }),
        _Utils_Tuple2("red40", function ($) {
            return $.er;
        }),
        _Utils_Tuple2("red50", function ($) {
            return $.es;
        }),
        _Utils_Tuple2("green0", function ($) {
            return $.dZ;
        }),
        _Utils_Tuple2("green10", function ($) {
            return $.d_;
        }),
        _Utils_Tuple2("green20", function ($) {
            return $.d$;
        }),
        _Utils_Tuple2("green30", function ($) {
            return $.d0;
        }),
        _Utils_Tuple2("green40", function ($) {
            return $.d1;
        }),
        _Utils_Tuple2("blue0", function ($) {
            return $.dA;
        }),
        _Utils_Tuple2("blue10", function ($) {
            return $.dB;
        }),
        _Utils_Tuple2("blue70", function ($) {
            return $.dC;
        }),
        _Utils_Tuple2("blue80", function ($) {
            return $.dD;
        }),
        _Utils_Tuple2("blue90", function ($) {
            return $.dE;
        }),
        _Utils_Tuple2("blueVivid", function ($) {
            return $.dF;
        }),
        _Utils_Tuple2("orange", function ($) {
            return $.eg;
        }),
        _Utils_Tuple2("yellowHighlight", function (p) {
            return p.eV(1);
        }),
        _Utils_Tuple2("yellowMedium", function (p) {
            return p.eW(1);
        }),
        _Utils_Tuple2("yellowDark", function (p) {
            return p.eU(1);
        }),
        _Utils_Tuple2("black", function ($) {
            return $.cI;
        }),
        _Utils_Tuple2("white", function ($) {
            return $.dw;
        })
    ]);
    var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
        unsafeToDigit: while (true) {
            switch (num) {
                case 0:
                    return "0";
                case 1:
                    return "1";
                case 2:
                    return "2";
                case 3:
                    return "3";
                case 4:
                    return "4";
                case 5:
                    return "5";
                case 6:
                    return "6";
                case 7:
                    return "7";
                case 8:
                    return "8";
                case 9:
                    return "9";
                case 10:
                    return "a";
                case 11:
                    return "b";
                case 12:
                    return "c";
                case 13:
                    return "d";
                case 14:
                    return "e";
                case 15:
                    return "f";
                default:
                    var $temp$num = num;
                    num = $temp$num;
                    continue unsafeToDigit;
            }
        }
    };
    var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits_fn = function (digits, num) {
        unsafePositiveToDigits: while (true) {
            if (num < 16) {
                return _List_Cons($rtfeldman$elm_hex$Hex$unsafeToDigit(num), digits);
            }
            else {
                var $temp$digits = _List_Cons($rtfeldman$elm_hex$Hex$unsafeToDigit(_Basics_modBy_fn(16, num)), digits), $temp$num = (num / 16) | 0;
                digits = $temp$digits;
                num = $temp$num;
                continue unsafePositiveToDigits;
            }
        }
    }, $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits_fn);
    var $rtfeldman$elm_hex$Hex$toString = function (num) {
        return $elm$core$String$fromList((num < 0) ? _List_Cons("-", $rtfeldman$elm_hex$Hex$unsafePositiveToDigits_fn(_List_Nil, -num)) : $rtfeldman$elm_hex$Hex$unsafePositiveToDigits_fn(_List_Nil, num));
    };
    var $author$project$Util$Color$toHexString = function (color) {
        var toHex = function (num) {
            var raw = $elm$core$String$toUpper($rtfeldman$elm_hex$Hex$toString($elm$core$Basics$max_fn(0, $elm$core$Basics$min_fn(255, num))));
            return ($elm$core$String$length(raw) === 1) ? ("0" + raw) : raw;
        };
        return function (_v0) {
            var red = _v0.iU;
            var green = _v0.hE;
            var blue = _v0.gR;
            return "#" + (toHex($elm$core$Basics$floor(255 * red)) + (toHex($elm$core$Basics$floor(255 * green)) + toHex($elm$core$Basics$floor(255 * blue))));
        }($mdgriffith$elm_ui$Element$toRgb(color));
    };
    var $author$project$Data$Color$encodePalette = function (palette) {
        return $elm$json$Json$Encode$object($elm$core$List$map_fn($elm$core$Tuple$mapSecond(function (accessor) {
            return $elm$json$Json$Encode$string($author$project$Util$Color$toHexString(accessor(palette)));
        }), $author$project$Data$Color$colorsWithNames));
    };
    var $author$project$Data$Color$stringifyPalette_a0 = $author$project$Data$Color$encodePalette, $author$project$Data$Color$stringifyPalette_a1 = $elm$json$Json$Encode$encode(0), $author$project$Data$Color$stringifyPalette = A2($elm$core$Basics$composeR, $author$project$Data$Color$stringifyPalette_a0, $author$project$Data$Color$stringifyPalette_a1);
    var $author$project$Data$Color$stringifiedPalettes = $elm$core$Dict$fromList($elm$core$List$map_fn(function (theme) {
        return _Utils_Tuple2($author$project$Data$Color$themeToString(theme), $elm$core$Basics$composeR_fn($author$project$Data$Color$stringifyPalette_a0, $author$project$Data$Color$stringifyPalette_a1, $author$project$Data$Color$paletteForTheme(theme)));
    }, _List_fromArray([0, 2, 3, 1, 4])));
    var $author$project$Data$Color$stringifiedPaletteForTheme = function (theme) {
        return $elm$core$Maybe$withDefault_fn($elm$core$Basics$composeR_fn($author$project$Data$Color$stringifyPalette_a0, $author$project$Data$Color$stringifyPalette_a1, $author$project$Data$Color$lightPalette), $elm$core$Dict$get_fn($author$project$Data$Color$themeToString(theme), $author$project$Data$Color$stringifiedPalettes));
    };
    var $author$project$View$SlateEditor$readOnly = function (config) {
        var encodedPalette = $author$project$Data$Color$stringifiedPaletteForTheme(config.pn);
        return $mdgriffith$elm_ui$Element$Keyed$el_fn(_List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(600, $mdgriffith$elm_ui$Element$minimum_fn(200, $mdgriffith$elm_ui$Element$fill))), _List_Cons($author$project$View$Styling$breakWord, config.hp)), _Utils_Tuple2(config.bq, $mdgriffith$elm_ui$Element$html($elm$html$Html$div_fn(_List_fromArray([
            _VirtualDom_style_fn("height", "100%"),
            _VirtualDom_style_fn("overflow-y", "scroll"),
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "show-scrollbar")
        ]), _List_fromArray([
            _VirtualDom_lazy8_fn($author$project$View$SlateEditor$slateCustomElement, config.f6, 0, config.bq, "null", "null", true, "null", encodedPalette)
        ])))));
    };
    var $author$project$View$Collate$viewCollatedNote_fn = function (env, _v0) {
        var noteId = _v0.a;
        var note = _v0.b;
        var noteTitle = $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$alignTop,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $author$project$View$Styling$focusable
        ]), {
            fF: $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$bold,
                        $mdgriffith$elm_ui$Element$Font$size(16),
                        $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.a7)
                        ])),
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aU),
                        $mdgriffith$elm_ui$Element$pointer,
                        $mdgriffith$elm_ui$Element$paddingEach((new $$Record115(3, 0, 0, 0)))
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$text(note.gj)
                    ])),
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$alignRight,
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink)
                    ]), A4($author$project$View$Tooltip$basic, env.nI, -20, "Edit note", $author$project$View$Icon$icon_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(16),
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aR),
                        $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.ba)
                        ])),
                        $mdgriffith$elm_ui$Element$padding(5),
                        $mdgriffith$elm_ui$Element$Border$rounded(100)
                    ]), 1, "edit")))
                ])),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.aR),
                    $mdgriffith$elm_ui$Element$paddingXY_fn(0, 5),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$Font$size(14)
                ]), $mdgriffith$elm_ui$Element$text($author$project$Data$Time$formatTimeRange_fn(env.pu, $elm$core$Basics$composeR_fn($author$project$Data$Settings$isShowArmyTime_a0, $author$project$Data$Settings$isShowArmyTime_a1, env), note.gh, $elm$core$Maybe$Just(note.fh))))
            ])),
            dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteNote_fn(noteId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing))
        });
        var noteContent = $author$project$View$SlateEditor$readOnly((new $$Record133(noteId, _List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$maximum_fn(300, $mdgriffith$elm_ui$Element$fill)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$alignTop,
            $mdgriffith$elm_ui$Element$Font$color(env.nI.aU)
        ]), note.f6, $elm$core$Basics$composeR_fn($author$project$Data$Settings$theme_a0, $author$project$Data$Settings$theme_a1, env))));
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$spacing(10),
            $mdgriffith$elm_ui$Element$Border$rounded(10),
            $mdgriffith$elm_ui$Element$Border$color(env.nI.aQ),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.dw),
            $author$project$View$Styling$elevation10,
            $mdgriffith$elm_ui$Element$paddingXY_fn(20, 15)
        ]), _List_fromArray([noteTitle, noteContent]));
    }, $author$project$View$Collate$viewCollatedNote = F2($author$project$View$Collate$viewCollatedNote_fn);
    var $author$project$Page$Collate$view_fn = function (env, model) {
        var notes = $author$project$View$Collate$relevantNotes_fn(env, model.b$);
        var relevantNoteCount = $elm$core$List$length(notes);
        var viewMoreLink = $author$project$View$Util$when_fn(_Utils_cmp(model.dv, relevantNoteCount) < 0, $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$paddingXY_fn(0, 30)
        ]), {
            fF: $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(env.nI.a9),
                $mdgriffith$elm_ui$Element$Font$size(22)
            ]), $mdgriffith$elm_ui$Element$text("View more")),
            dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteCollate_fn(model.b$, $elm$core$Maybe$Just($elm$core$Basics$min_fn(relevantNoteCount, model.dv + $author$project$Page$Collate$paginateByCount))))
        }));
        var seriesTitle = $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$center,
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$Font$size(24),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(30))
        ]), function () {
            var _v1 = model.b$;
            switch (_v1.$) {
                case 0:
                    return _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Meeting Series: "),
                        $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$Font$bold]), $mdgriffith$elm_ui$Element$text($elm$core$Maybe$withDefault_fn("Untitled", $elm$core$Maybe$map_fn(function (_v2) {
                            var n = _v2.b;
                            return n.gj;
                        }, $elm$core$List$head(notes)))))
                    ]);
                case 1:
                    var personId = _v1.a;
                    return _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("All notes with "),
                        $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$bold,
                            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Font$color(env.nI.a7)
                            ]))
                        ]), {
                            fF: $mdgriffith$elm_ui$Element$text($elm$core$Maybe$withDefault_fn("unnamed Person", $elm$core$Maybe$map_fn(function ($) {
                                return $.b;
                            }, $author$project$Firestore$Collection$get_fn(personId, env.iz)))),
                            dt: $author$project$Routing$pathFromRoute($author$project$Routing$RoutePerson(personId))
                        })
                    ]);
                default:
                    var domainName = _v1.a.g9;
                    return _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Meetings with " + domainName)
                    ]);
            }
        }());
        return $author$project$Data$App$isLoading(env.mK) ? $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]), $author$project$View$Widgets$loadingAnimation) : ($elm$core$List$isEmpty(notes) ? $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$spacing(20)
        ]), _List_fromArray([
            $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(50),
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$Font$color(env.nI.a7)
            ]), 3, "telescope"),
            A3($author$project$View$Styling$h3, env.nI, _List_fromArray([$mdgriffith$elm_ui$Element$centerX]), function () {
                var _v0 = model.b$;
                switch (_v0.$) {
                    case 0:
                        return "No notes in this series yet.";
                    case 1:
                        var personId = _v0.a;
                        return $elm$core$Maybe$withDefault_fn("No notes found with that person yet.", $elm$core$Maybe$map_fn(function (person) {
                            return "No notes with " + (person.b + " yet.");
                        }, $author$project$Firestore$Collection$get_fn(personId, env.iz)));
                    default:
                        var domainName = _v0.a.g9;
                        return "No notes with " + (domainName + " yet.");
                }
            }()),
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$pointer,
                    $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Collate$HandleBacktalk($author$project$Env$ShowSearch(true))),
                    $mdgriffith$elm_ui$Element$Font$underline,
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.ba)
                ]), $mdgriffith$elm_ui$Element$text("Try searching")),
                $mdgriffith$elm_ui$Element$text(" or "),
                $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$underline,
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.ba)
                ]), {
                    fF: $mdgriffith$elm_ui$Element$text("go back home"),
                    dt: "/"
                })
            ]))
        ])) : $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$spacingXY_fn(0, 30),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(1800, $mdgriffith$elm_ui$Element$fill)),
            $mdgriffith$elm_ui$Element$padding(20)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$spacing(20)
            ]), _List_fromArray([
                $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
                    kb: "Go back out of collation page",
                    hp: _List_fromArray([
                        $mdgriffith$elm_ui$Element$Border$width(0),
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.a7),
                        $mdgriffith$elm_ui$Element$Border$rounded(4),
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(30)),
                        $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(30)),
                        $mdgriffith$elm_ui$Element$centerY
                    ]),
                    fQ: $elm$core$Maybe$Just($author$project$Page$Collate$NavBackward)
                }, 1, "long-arrow-left"),
                seriesTitle
            ])),
            $author$project$View$Widgets$gridColumn_fn({ lU: 40, mU: 550 }, _List_Nil, $elm$core$List$map_fn($author$project$View$Collate$viewCollatedNote(env), $elm$core$List$take_fn(model.dv, notes))),
            viewMoreLink
        ])));
    }, $author$project$Page$Collate$view = F2($author$project$Page$Collate$view_fn);
    var $mdgriffith$elm_ui$Element$InternalColumn = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$GridPosition = function (a) {
        return { $: 9, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$GridTemplateStyle = function (a) {
        return { $: 8, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$AsGrid = 3;
    var $mdgriffith$elm_ui$Internal$Model$asGrid = 3;
    var $mdgriffith$elm_ui$Internal$Model$getSpacing_fn = function (attrs, _default) {
        return $elm$core$Maybe$withDefault_fn(_default, $elm$core$List$foldr_fn(F2(function (attr, acc) {
            if (!acc.$) {
                var x = acc.a;
                return $elm$core$Maybe$Just(x);
            }
            else {
                if ((attr.$ === 4) && (attr.b.$ === 5)) {
                    var _v2 = attr.b;
                    var x = _v2.b;
                    var y = _v2.c;
                    return $elm$core$Maybe$Just(_Utils_Tuple2(x, y));
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
        }), $elm$core$Maybe$Nothing, attrs));
    }, $mdgriffith$elm_ui$Internal$Model$getSpacing = F2($mdgriffith$elm_ui$Internal$Model$getSpacing_fn);
    var $mdgriffith$elm_ui$Internal$Flag$gridPosition = $mdgriffith$elm_ui$Internal$Flag$flag(35);
    var $mdgriffith$elm_ui$Internal$Flag$gridTemplate = $mdgriffith$elm_ui$Internal$Flag$flag(34);
    var $mdgriffith$elm_ui$Element$tableHelper_fn = function (attrs, config) {
        var onGrid = F3(function (rowLevel, columnLevel, elem) {
            return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, _List_fromArray([
                $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$gridPosition, $mdgriffith$elm_ui$Internal$Model$GridPosition((new $$Record134(columnLevel, 1, rowLevel, 1))))
            ]), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([elem])));
        });
        var columnWidth = function (col) {
            if (!col.$) {
                var colConfig = col.a;
                return colConfig.jJ;
            }
            else {
                var colConfig = col.a;
                return colConfig.jJ;
            }
        };
        var columnHeader = function (col) {
            if (!col.$) {
                var colConfig = col.a;
                return colConfig.hF;
            }
            else {
                var colConfig = col.a;
                return colConfig.hF;
            }
        };
        var maybeHeaders = function (headers) {
            return $elm$core$List$all_fn($elm$core$Basics$eq($mdgriffith$elm_ui$Internal$Model$Empty), headers) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($elm$core$List$indexedMap_fn_unwrapped(function (col, header) {
                return A3(onGrid, 1, col + 1, header);
            }, headers));
        }($elm$core$List$map_fn(columnHeader, config.kU));
        var add = F3(function (cell, columnConfig, cursor) {
            if (!columnConfig.$) {
                var col = columnConfig.a;
                return function () {
                    var $r = cursor.$c();
                    $r.aC = cursor.aC + 1;
                    $r.aE = _List_Cons(A3(onGrid, cursor.of, cursor.aC, A2(col.p$, _Utils_eq(maybeHeaders, $elm$core$Maybe$Nothing) ? (cursor.of - 1) : (cursor.of - 2), cell)), cursor.aE);
                    return $r;
                }();
            }
            else {
                var col = columnConfig.a;
                return (new $$Record135(cursor.aC + 1, _List_Cons(A3(onGrid, cursor.of, cursor.aC, col.p$(cell)), cursor.aE), cursor.of));
            }
        });
        var build = F3(function (columns, rowData, cursor) {
            var newCursor = $elm$core$List$foldl_fn(add(rowData), cursor, columns);
            return (new $$Record135(1, newCursor.aE, cursor.of + 1));
        });
        var children = $elm$core$List$foldl_fn(build(config.kU), (new $$Record135(1, _List_Nil, _Utils_eq(maybeHeaders, $elm$core$Maybe$Nothing) ? 1 : 2)), config.a);
        var _v0 = $mdgriffith$elm_ui$Internal$Model$getSpacing_fn(attrs, _Utils_Tuple2(0, 0));
        var sX = _v0.a;
        var sY = _v0.b;
        var template = $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$gridTemplate, $mdgriffith$elm_ui$Internal$Model$GridTemplateStyle({
            kU: $elm$core$List$map_fn(columnWidth, config.kU),
            og: $elm$core$List$repeat_fn($elm$core$List$length(config.a), $mdgriffith$elm_ui$Internal$Model$Content),
            oJ: _Utils_Tuple2($mdgriffith$elm_ui$Element$px(sX), $mdgriffith$elm_ui$Element$px(sY))
        }));
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asGrid, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill), _List_Cons(template, attrs)), $mdgriffith$elm_ui$Internal$Model$Unkeyed(function () {
            if (maybeHeaders.$ === 1) {
                return children.aE;
            }
            else {
                var renderedHeaders = maybeHeaders.a;
                return _Utils_ap(renderedHeaders, $elm$core$List$reverse(children.aE));
            }
        }()));
    }, $mdgriffith$elm_ui$Element$tableHelper = F2($mdgriffith$elm_ui$Element$tableHelper_fn);
    var $mdgriffith$elm_ui$Element$table_fn = function (attrs, config) {
        return $mdgriffith$elm_ui$Element$tableHelper_fn(attrs, {
            kU: $elm$core$List$map_fn($mdgriffith$elm_ui$Element$InternalColumn, config.kU),
            a: config.a
        });
    }, $mdgriffith$elm_ui$Element$table = F2($mdgriffith$elm_ui$Element$table_fn);
    var $author$project$Page$Demo$view_fn = function (env, model) {
        var swatch = function (color) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(color),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(32)),
                $mdgriffith$elm_ui$Element$alignRight,
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), $mdgriffith$elm_ui$Element$none);
        };
        var headerText = A2($elm$core$Basics$composeR, $mdgriffith$elm_ui$Element$text, $mdgriffith$elm_ui$Element$el(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$bold,
            $mdgriffith$elm_ui$Element$Font$size(16),
            $author$project$View$Styling$paddingBottom(4),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$Border$widthEach((new $$Record115(1, 0, 0, 0))),
            $mdgriffith$elm_ui$Element$Border$color(env.nI.aP),
            $mdgriffith$elm_ui$Element$Font$family(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$typeface("Lato"),
                $mdgriffith$elm_ui$Element$Font$sansSerif
            ]))
        ])));
        var columnForPalette = F2(function (paletteName, palette) {
            return (new $$Record136(headerText(paletteName), function (_v0) {
                var paletteAccessor = _v0.b;
                var color = paletteAccessor(palette);
                return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$spacing(5)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text($author$project$Util$Color$toHexString(color)),
                    swatch(color)
                ]));
            }, $mdgriffith$elm_ui$Element$fill));
        });
        return $author$project$View$Layout$onePanel_fn(env, _List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            A3($author$project$View$Layout$card, env.nI, _List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$table_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(12),
                    $mdgriffith$elm_ui$Element$Font$family(_List_fromArray([$mdgriffith$elm_ui$Element$Font$monospace])),
                    $mdgriffith$elm_ui$Element$spacingXY_fn(25, 0)
                ]), {
                    kU: _List_fromArray([
                        (new $$Record136(headerText("Color Name"), A2($elm$core$Basics$composeR, $elm$core$Tuple$first, A2($elm$core$Basics$composeR, $mdgriffith$elm_ui$Element$text, $mdgriffith$elm_ui$Element$el(_List_fromArray([$mdgriffith$elm_ui$Element$centerY])))), $mdgriffith$elm_ui$Element$shrink)),
                        A2(columnForPalette, "Light", $author$project$Data$Color$lightPalette),
                        A2(columnForPalette, "Winter", $author$project$Data$Color$winterPalette),
                        A2(columnForPalette, "Amber", $author$project$Data$Color$amberPalette),
                        A2(columnForPalette, "Evening", $author$project$Data$Color$eveningPalette),
                        A2(columnForPalette, "Midnight", $author$project$Data$Color$darkPalette)
                    ]),
                    a: $author$project$Data$Color$colorsWithNames
                })
            ]))
        ]));
    }, $author$project$Page$Demo$view = F2($author$project$Page$Demo$view_fn);
    var $author$project$View$Layout$primaryPanel_fn = function (viewport, palette, extraAttrs, innerElts) {
        var isDoubleColumned = $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, viewport);
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($author$project$Util$Misc$if__fn(isDoubleColumned, $mdgriffith$elm_ui$Element$maximum_fn((($author$project$View$Layout$maxPageWidth * 10) / 6) | 0, $mdgriffith$elm_ui$Element$fillPortion(6)), $mdgriffith$elm_ui$Element$fill)),
            $mdgriffith$elm_ui$Element$Background$color(palette.dw),
            $mdgriffith$elm_ui$Element$Border$shadow({
                kp: 7,
                kS: $author$project$Data$Color$grayAlphaLight,
                nt: $author$project$Util$Misc$if__fn(isDoubleColumned, _Utils_Tuple2(2, 0), _Utils_Tuple2(0, 2)),
                oE: 0.6
            }),
            $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, $author$project$View$Config$zIndices.iJ),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
        ]), $mdgriffith$elm_ui$Element$column_fn(_List_Cons($author$project$Util$Misc$if__fn(isDoubleColumned, $mdgriffith$elm_ui$Element$paddingXY_fn(30, 15), $mdgriffith$elm_ui$Element$paddingXY_fn(20, 30)), _List_Cons($mdgriffith$elm_ui$Element$spacing(15), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$centerX, extraAttrs))))), innerElts));
    }, $author$project$View$Layout$primaryPanel = F4($author$project$View$Layout$primaryPanel_fn);
    var $author$project$Data$Settings$reverseNoteColumns_a0 = $author$project$Data$Settings$get, $author$project$Data$Settings$reverseNoteColumns_a1 = function ($) {
        return $.df;
    }, $author$project$Data$Settings$reverseNoteColumns = A2($elm$core$Basics$composeR, $author$project$Data$Settings$reverseNoteColumns_a0, $author$project$Data$Settings$reverseNoteColumns_a1);
    var $author$project$View$Layout$secondaryPanel_fn = function (viewport, palette, extraAttrs, innerElts) {
        var isDoubleColumned = $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, viewport);
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($author$project$Util$Misc$if__fn(isDoubleColumned, $mdgriffith$elm_ui$Element$maximum_fn((($author$project$View$Layout$maxPageWidth * 10) / 4) | 0, $mdgriffith$elm_ui$Element$fillPortion(4)), $mdgriffith$elm_ui$Element$fill)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$Background$color(palette.aM),
            $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, $author$project$View$Config$zIndices.i6)
        ]), $mdgriffith$elm_ui$Element$column_fn(_List_Cons($mdgriffith$elm_ui$Element$paddingEach($author$project$Util$Misc$if__fn(isDoubleColumned, (new $$Record115(20, 30, 20, 40)), (new $$Record115(20, 20, 20, 50)))), _List_Cons($mdgriffith$elm_ui$Element$spacing(15), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(500, $mdgriffith$elm_ui$Element$fill)), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$alignLeft, extraAttrs))))), innerElts));
    }, $author$project$View$Layout$secondaryPanel = F4($author$project$View$Layout$secondaryPanel_fn);
    var $author$project$View$Layout$twoPanel_fn = function (env, _v0) {
        var major = _v0.mP;
        var minor = _v0.m4;
        var isDoubleColumned = $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, env.p1);
        var columnsReversed = $elm$core$Basics$composeR_fn($author$project$Data$Settings$reverseNoteColumns_a0, $author$project$Data$Settings$reverseNoteColumns_a1, env) && isDoubleColumned;
        var primaryPanelAlignment = function () {
            var _v2 = _Utils_Tuple2(isDoubleColumned, columnsReversed);
            if (_v2.a) {
                if (!_v2.b) {
                    return $mdgriffith$elm_ui$Element$alignRight;
                }
                else {
                    return $mdgriffith$elm_ui$Element$alignLeft;
                }
            }
            else {
                return $mdgriffith$elm_ui$Element$centerX;
            }
        }();
        var secondaryPanelAlignment = function () {
            var _v1 = _Utils_Tuple2(isDoubleColumned, columnsReversed);
            if (_v1.a) {
                if (!_v1.b) {
                    return $mdgriffith$elm_ui$Element$alignLeft;
                }
                else {
                    return $mdgriffith$elm_ui$Element$alignRight;
                }
            }
            else {
                return $mdgriffith$elm_ui$Element$centerX;
            }
        }();
        var withColumnOrdering = $author$project$Util$Misc$if__fn(columnsReversed, $elm$core$List$reverse, $elm$core$Basics$identity);
        var centerColumnWrapper = A4($author$project$Util$Misc$if_, isDoubleColumned, $mdgriffith$elm_ui$Element$row, $mdgriffith$elm_ui$Element$column, _List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn($elm$core$Basics$floor(env.p1.p1.jJ), $mdgriffith$elm_ui$Element$px($author$project$View$Layout$maxPageWidth))),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
        ]));
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
        ]), withColumnOrdering(_List_fromArray([
            $author$project$View$Util$when_fn(isDoubleColumned, $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Background$color(env.nI.dw),
                $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, $author$project$View$Config$zIndices.iK)
            ]), $mdgriffith$elm_ui$Element$none)),
            centerColumnWrapper(withColumnOrdering(_List_fromArray([
                $author$project$View$Layout$primaryPanel_fn(env.p1, env.nI, _List_fromArray([primaryPanelAlignment]), major),
                $author$project$View$Layout$secondaryPanel_fn(env.p1, env.nI, _List_fromArray([secondaryPanelAlignment]), minor)
            ]))),
            $author$project$View$Util$when_fn(isDoubleColumned, $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Background$color(env.nI.aM)
            ]), $mdgriffith$elm_ui$Element$none))
        ])));
    }, $author$project$View$Layout$twoPanel = F2($author$project$View$Layout$twoPanel_fn);
    var $author$project$Page$Home$SetThreadTab = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Page$Home$ThreadTabTopics = 1;
    var $author$project$View$Layout$minorPaneStandardSpacing = 40;
    var $author$project$View$ActionItems$shimmeringLine_fn = function (palette, shimmer, portion) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(portion)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(11)),
            $mdgriffith$elm_ui$Element$Border$rounded(6),
            $author$project$View$Util$attrWhen_fn(shimmer, $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "shimmer-light")),
            $author$project$View$Util$attrWhen_fn(!shimmer, $mdgriffith$elm_ui$Element$Background$color(palette.aP)),
            $mdgriffith$elm_ui$Element$centerY
        ]), $mdgriffith$elm_ui$Element$none);
    }, $author$project$View$ActionItems$shimmeringLine = F3($author$project$View$ActionItems$shimmeringLine_fn);
    var $author$project$View$ActionItems$spacer = function (portion) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(portion))
        ]), $mdgriffith$elm_ui$Element$none);
    };
    var $author$project$View$ActionItems$checkbox = function (palette) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Background$color(palette.aM),
            $mdgriffith$elm_ui$Element$Border$rounded(3),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(20)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(20)),
            $mdgriffith$elm_ui$Element$Border$shadow({
                kp: 3,
                kS: palette.aP,
                nt: _Utils_Tuple2(0, 0),
                oE: 1
            })
        ]), $mdgriffith$elm_ui$Element$none);
    };
    var $author$project$View$ActionItems$viewLoadingLine_fn = function (palette, shimmer, portion) {
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(20)
        ]), _List_fromArray([
            $author$project$View$ActionItems$checkbox(palette),
            $author$project$View$ActionItems$shimmeringLine_fn(palette, shimmer, portion),
            $author$project$View$ActionItems$spacer(10 - portion)
        ]));
    }, $author$project$View$ActionItems$viewLoadingLine = F3($author$project$View$ActionItems$viewLoadingLine_fn);
    var $author$project$View$ActionItems$viewLoadingNote_fn = function (palette, shimmer) {
        var noteTitle = $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $author$project$View$Styling$paddingBottom(10)
        ]), _List_fromArray([
            $author$project$View$ActionItems$shimmeringLine_fn(palette, shimmer, 5),
            $author$project$View$ActionItems$spacer(7)
        ]));
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(17)
        ]), _List_fromArray([
            noteTitle,
            $author$project$View$ActionItems$viewLoadingLine_fn(palette, shimmer, 8),
            $author$project$View$ActionItems$viewLoadingLine_fn(palette, shimmer, 4),
            $author$project$View$ActionItems$viewLoadingLine_fn(palette, shimmer, 6)
        ]));
    }, $author$project$View$ActionItems$viewLoadingNote = F2($author$project$View$ActionItems$viewLoadingNote_fn);
    var $author$project$Page$Home$viewActionItemsPanel_fn = function (env, model, chosenDay) {
        var viewActionItemsHelper = function (noteFilter) {
            return $elm$core$List$reverse($elm$core$List$map_fn($elm$core$Tuple$mapSecond($mdgriffith$elm_ui$Element$map($author$project$Page$Home$ActionItemMsg)), $author$project$View$ActionItems$viewAll_fn(env, (new $$Record127(model.bQ, function () {
                var _v5 = model.dl;
                if (!_v5) {
                    return $author$project$Data$ActionItem$isTodo;
                }
                else {
                    return A2($elm$core$Basics$composeR, $author$project$Data$ActionItem$isTodo, $elm$core$Basics$not);
                }
            }(), noteFilter, function () {
                var $r = $author$project$View$ActionItems$defaultViewConfig.$c();
                $r.eG = true;
                $r.oy = false;
                return $r;
            }())))));
        };
        var timeFilter = F2(function (f, note) {
            return f($author$project$Data$Time$toPosix_fn(env.pu, note.gh));
        });
        var tabButton = function (tab) {
            var isSelected = _Utils_eq(model.dl, tab);
            var iconSize = 16;
            var _v3 = function () {
                if (!tab) {
                    return _Utils_Tuple2("check-square", "TO-DO");
                }
                else {
                    return _Utils_Tuple2("comment-alt-lines", "TOPICS");
                }
            }();
            var iconName = _v3.a;
            var title = _v3.b;
            return $mdgriffith$elm_ui$Element$Input$button_fn(_List_fromArray([$author$project$View$Styling$focusable]), {
                fF: $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Border$widthEach((new $$Record115(2, 0, 0, 0))),
                    $mdgriffith$elm_ui$Element$paddingXY_fn(0, 10),
                    $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn(isSelected, env.nI.cI, env.nI.aS)),
                    $mdgriffith$elm_ui$Element$Border$color($author$project$Data$Color$transparent),
                    $author$project$Util$Misc$if__fn(isSelected, $mdgriffith$elm_ui$Element$Border$color(env.nI.cI), $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.cI)
                    ]))),
                    $mdgriffith$elm_ui$Element$spacing(3)
                ]), _List_fromArray([
                    $author$project$View$Icon$icon_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(iconSize)
                    ]), $author$project$Util$Misc$if__fn(isSelected, 1, 2), iconName),
                    $mdgriffith$elm_ui$Element$text(title)
                ])),
                nz: $elm$core$Maybe$Just($author$project$Page$Home$SetThreadTab(tab))
            });
        };
        var dividerLine = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(25)),
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(1)),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.aP)
        ]), $mdgriffith$elm_ui$Element$none);
        var sidePanelTabs = $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(15)
        ]), _List_fromArray([
            tabButton(0),
            dividerLine,
            tabButton(1)
        ]));
        var sectionHelper = function (items) {
            return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$spacing($author$project$View$Layout$minorPaneStandardSpacing)
            ]), _List_fromArray([
                sidePanelTabs,
                $mdgriffith$elm_ui$Element$Keyed$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing($author$project$View$Layout$minorPaneStandardSpacing),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), items)
            ]));
        };
        var chosenDaysActionItems = viewActionItemsHelper(timeFilter(A2($author$project$Util$Time$isSameDay, env.pu, chosenDay)));
        var noActionItems = function (_v2) {
            return $elm$core$List$isEmpty(chosenDaysActionItems);
        };
        var loadedActionItems = function (_v1) {
            return sectionHelper(noActionItems(0) ? _List_fromArray([
                _Utils_Tuple2("empty-state-placeholder", $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$spacing(20),
                    $mdgriffith$elm_ui$Element$paddingXY_fn(0, 35)
                ]), _List_fromArray([
                    $author$project$View$Icon$icon_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$centerX,
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aQ),
                        $mdgriffith$elm_ui$Element$Font$size(50)
                    ]), 3, "tasks"),
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aQ),
                        $mdgriffith$elm_ui$Element$Font$size(16)
                    ]), $mdgriffith$elm_ui$Element$text("No action items."))
                ])))
            ]) : chosenDaysActionItems);
        };
        var actionItems = function () {
            var _v0 = _Utils_Tuple2($author$project$View$EmptyState$isActive(env), $author$project$Data$App$isLoading(env.mK));
            _v0$0: while (true) {
                if (_v0.b) {
                    if (_v0.a) {
                        break _v0$0;
                    }
                    else {
                        return _List_fromArray([
                            sectionHelper($elm$core$List$map_fn($elm$core$Tuple$mapFirst($elm$core$String$fromInt), $elm$core$List$indexedMap_fn($elm$core$Tuple$pair, _List_fromArray([
                                $author$project$View$ActionItems$viewLoadingNote_fn(env.nI, true)
                            ]))))
                        ]);
                    }
                }
                else {
                    if (_v0.a) {
                        break _v0$0;
                    }
                    else {
                        return _List_fromArray([
                            loadedActionItems(0)
                        ]);
                    }
                }
            }
            return _List_fromArray([
                sectionHelper($elm$core$List$map_fn($elm$core$Tuple$mapFirst($elm$core$String$fromInt), $elm$core$List$indexedMap_fn($elm$core$Tuple$pair, _List_fromArray([
                    $author$project$View$ActionItems$viewLoadingNote_fn(env.nI, false),
                    $author$project$View$ActionItems$viewLoadingNote_fn(env.nI, false)
                ]))))
            ]);
        }();
        return actionItems;
    }, $author$project$Page$Home$viewActionItemsPanel = F3($author$project$Page$Home$viewActionItemsPanel_fn);
    var $author$project$Util$Time$dateFormatter = $ryannhg$date_format$DateFormat$format(_List_fromArray([
        $ryannhg$date_format$DateFormat$dayOfWeekNameFull,
        $ryannhg$date_format$DateFormat$text(", "),
        $ryannhg$date_format$DateFormat$monthNameAbbreviated,
        $ryannhg$date_format$DateFormat$text(" "),
        $ryannhg$date_format$DateFormat$dayOfMonthSuffix
    ]));
    var $author$project$Page$Home$header_fn = function (env, model, chosenDay) {
        var maybeNoTabIndex = $author$project$View$Util$attrWhen_fn($author$project$View$EmptyState$isActive(env), $author$project$View$Util$tabIndex($elm$core$Maybe$Nothing));
        var ifInteractive = $author$project$Util$Misc$toJustIf(!$author$project$View$EmptyState$isActive(env));
        var todayButton = A4($author$project$View$Shortcut$tooltip, env.nI, 0, $author$project$Data$Shortcut$keys.g0, $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
            kb: $author$project$Data$Shortcut$keys.g0.q,
            hp: _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(env.nI.aR),
                maybeNoTabIndex,
                $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.aT)
                ]))
            ]),
            fQ: ifInteractive($author$project$Page$Home$SetAgendaOffset(0))
        }, 1, "calendar-day"));
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, 1),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(10)
        ]), _List_fromArray([
            $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(20)
            ]), 1, "calendar-star"),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(20)
            ]), $mdgriffith$elm_ui$Element$text(A2($author$project$Util$Time$dateFormatter, env.pu, chosenDay))),
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([$mdgriffith$elm_ui$Element$alignRight]), _List_fromArray([
                todayButton,
                A4($author$project$View$Shortcut$tooltip, env.nI, 0, $author$project$Data$Shortcut$keys.iH, $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
                    kb: $author$project$Data$Shortcut$keys.iH.q,
                    hp: _List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aR),
                        maybeNoTabIndex,
                        $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.aT)
                        ]))
                    ]),
                    fQ: ifInteractive($author$project$Page$Home$SetAgendaOffset(model.U - 1))
                }, 1, "chevron-left")),
                A4($author$project$View$Shortcut$tooltip, env.nI, 0, $author$project$Data$Shortcut$keys.il, $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
                    kb: $author$project$Data$Shortcut$keys.il.q,
                    hp: _List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aR),
                        maybeNoTabIndex,
                        $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.aT)
                        ]))
                    ]),
                    fQ: ifInteractive($author$project$Page$Home$SetAgendaOffset(model.U + 1))
                }, 1, "chevron-right"))
            ]))
        ]));
    }, $author$project$Page$Home$header = F3($author$project$Page$Home$header_fn);
    var $author$project$View$Meeting$viewLoadingHomeBlock_fn = function (palette, _v0) {
        var showShimmer = _v0.oA;
        var showBadge = _v0.jc;
        var grayLine = function (portion) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(portion)),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(11)),
                $mdgriffith$elm_ui$Element$Border$rounded(6),
                $author$project$View$Util$attrWhen_fn(showShimmer, $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "shimmer")),
                $author$project$View$Util$attrWhen_fn(!showShimmer, $mdgriffith$elm_ui$Element$Background$color(palette.aQ)),
                $mdgriffith$elm_ui$Element$centerY
            ]), $mdgriffith$elm_ui$Element$none);
        };
        var grayLines = $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$inFront($author$project$View$Util$when_fn(showBadge, $author$project$View$Meeting$viewLoadingBadge_fn(palette, showShimmer, _List_Nil))),
            $mdgriffith$elm_ui$Element$spacing(20)
        ]), _List_fromArray([
            grayLine(1),
            grayLine(5),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(4))
            ]), $mdgriffith$elm_ui$Element$none)
        ]));
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(60)),
            $mdgriffith$elm_ui$Element$padding(10),
            $mdgriffith$elm_ui$Element$Border$rounded(10),
            $mdgriffith$elm_ui$Element$Background$color(palette.aO)
        ]), grayLines);
    }, $author$project$View$Meeting$viewLoadingHomeBlock = F2($author$project$View$Meeting$viewLoadingHomeBlock_fn);
    var $author$project$Page$Home$viewAgenda_fn = function (env, model, chosenDay) {
        var viewLoading = _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$paddingXY_fn(0, 12),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), $author$project$View$Meeting$viewLoadingHomeBlock_fn(env.nI, { jc: true, oA: true }))
        ]);
        var viewEmptyState = $elm$core$List$map_fn(function (showBadge) {
            return $author$project$View$Meeting$viewLoadingHomeBlock_fn(env.nI, { jc: showBadge, oA: false });
        }, _List_fromArray([true, false, true]));
        var timeFormatter = function (meeting) {
            return $mdgriffith$elm_ui$Element$text(meeting.d7 ? "All Day" : $author$project$Util$Time$formatTime_fn($elm$core$Basics$composeR_fn($author$project$Data$Settings$isShowArmyTime_a0, $author$project$Data$Settings$isShowArmyTime_a1, env), env.pu, meeting.bF));
        };
        var layoutter = function (_v1) {
            var isOngoing = _v1.mx;
            var meeting = _v1.mV;
            var badge = _v1.kj;
            var isConflict = _v1.mu;
            return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacingXY_fn(5, 0),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $author$project$View$Styling$breakWord
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.aS),
                    $author$project$View$Util$attrWhen_fn((!isOngoing) && (!isConflict), $mdgriffith$elm_ui$Element$Font$hairline),
                    $author$project$View$Util$attrWhen_fn((!isOngoing) && isConflict, $mdgriffith$elm_ui$Element$Font$color(env.nI.eg)),
                    $author$project$View$Util$attrWhen_fn(isOngoing, $mdgriffith$elm_ui$Element$Font$color(env.nI.dw)),
                    $mdgriffith$elm_ui$Element$Font$size(12),
                    $mdgriffith$elm_ui$Element$Font$regular,
                    $mdgriffith$elm_ui$Element$centerY,
                    $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(75))
                ]), timeFormatter(meeting)),
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$alignTop,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$Font$size(16)
                ]), _List_fromArray([
                    $author$project$View$Meeting$meetingTitle_fn(env.nI, meeting)
                ])),
                badge
            ]));
        };
        var todaysMeetings = function () {
            var _v0 = _Utils_Tuple2($author$project$View$EmptyState$isActive(env), $author$project$Data$App$isLoading(env.mK));
            _v0$0: while (true) {
                if (_v0.b) {
                    if (_v0.a) {
                        break _v0$0;
                    }
                    else {
                        return viewLoading;
                    }
                }
                else {
                    if (_v0.a) {
                        break _v0$0;
                    }
                    else {
                        return $elm$core$List$map_fn(A2($author$project$View$Meeting$viewBlock, (new $$Record137(env.k5, env.hr, env.fO, env.nI, env.pu)), layoutter), $author$project$Data$Meeting$buildAgenda_fn(chosenDay, env));
                    }
                }
            }
            return viewEmptyState;
        }();
        var addKeys = $elm$core$List$indexedMap(F2(function (index, element) {
            return _Utils_Tuple2($elm$core$String$fromInt($elm$time$Time$posixToMillis(chosenDay) + index), element);
        }));
        return _List_fromArray([
            $author$project$View$Util$spacer(10),
            $author$project$Page$Home$header_fn(env, model, chosenDay),
            $mdgriffith$elm_ui$Element$Keyed$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $author$project$View$Util$attrWhen_fn($author$project$View$EmptyState$isActive(env), $mdgriffith$elm_ui$Element$spacingXY_fn(0, 10))
            ]), addKeys(_List_Cons($author$project$Lib$Focuser$startingPoint, todaysMeetings)))
        ]);
    }, $author$project$Page$Home$viewAgenda = F3($author$project$Page$Home$viewAgenda_fn);
    var $author$project$Page$Home$view_fn = function (env, model) {
        var chosenDay = $justinmimbs$time_extra$Time$Extra$floor_fn($author$project$Util$Time$startOfDay_a0, env.pu, $elm$time$Time$millisToPosix($elm$time$Time$posixToMillis(env.k5) + ($author$project$Util$Time$day * model.U)));
        return $author$project$View$Layout$twoPanel_fn(env, {
            mP: $author$project$Page$Home$viewAgenda_fn(env, model, chosenDay),
            m4: $author$project$Page$Home$viewActionItemsPanel_fn(env, model, chosenDay)
        });
    }, $author$project$Page$Home$view = F2($author$project$Page$Home$view_fn);
    var $author$project$Page$Note$colWidth = 600;
    var $author$project$Page$Note$AttachmentInDropZone = function (a) {
        return { $: 28, a: a };
    };
    var $author$project$Page$Note$EditAdHocNoteTime = function (a) {
        return { $: 31, a: a };
    };
    var $author$project$Page$Note$EditorEscapeKeyPressed = { $: 16 };
    var $author$project$Page$Note$EditorFocused = function (a) {
        return { $: 15, a: a };
    };
    var $author$project$Page$Note$HandleBacktalk = function (a) {
        return { $: 35, a: a };
    };
    var $author$project$Analytics$NoteOpenVideoCall = { $: 29 };
    var $author$project$Analytics$NoteOpenZenMode = { $: 11 };
    var $author$project$Analytics$NoteRestored = { $: 13 };
    var $author$project$Analytics$NoteSoftDeleted = { $: 12 };
    var $author$project$Page$Note$RestoreNote = function (a) {
        return { $: 13, a: a };
    };
    var $author$project$Page$Note$ShowNoteMenu = function (a) {
        return { $: 32, a: a };
    };
    var $author$project$Page$Note$SoftDeleteNote = function (a) {
        return { $: 12, a: a };
    };
    var $author$project$View$Styling$elevation40 = $mdgriffith$elm_ui$Element$Border$shadow({
        kp: 8,
        kS: $author$project$Data$Color$grayAlphaDark,
        nt: _Utils_Tuple2(0.2, 1),
        oE: 2
    });
    var $author$project$View$FocusGroup$id_a0 = "data-group-id", $author$project$View$FocusGroup$id = $author$project$View$Util$attribute($author$project$View$FocusGroup$id_a0);
    var $author$project$View$Util$buttonRole = $author$project$View$Util$attribute_fn("role", "button");
    var $author$project$View$Icon$newTabWithSize_fn = function (iconSize, _v0, iconStyle, iconName, url) {
        var ariaLabel = _v0.kb;
        var extraAttrs = _v0.hp;
        return $mdgriffith$elm_ui$Element$newTabLink_fn(_Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(14),
            $mdgriffith$elm_ui$Element$Border$rounded(50),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(45)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(45)),
            $author$project$View$Styling$backgroundTransition,
            $author$project$View$Styling$ripple,
            $author$project$View$Styling$focusable,
            $author$project$View$Util$buttonRole,
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$grayAlphaLight)
            ])),
            $author$project$View$Util$attribute_fn($author$project$View$Aria$label_a0, ariaLabel)
        ]), extraAttrs), {
            fF: $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$Font$size(iconSize)
            ]), iconStyle, iconName),
            dt: url
        });
    }, $author$project$View$Icon$newTabWithSize = F5($author$project$View$Icon$newTabWithSize_fn);
    var $author$project$View$FocusGroup$relatedTargetGroupIdDecoder = $elm$json$Json$Decode$at_fn(_List_fromArray(["relatedTarget", "dataset", "groupId"]), $elm$json$Json$Decode$string);
    var $author$project$View$FocusGroup$targetGroupIdDecoder = $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "dataset", "groupId"]), $elm$json$Json$Decode$string);
    var $author$project$View$FocusGroup$onBlurDecoder = function (msg) {
        return _Json_andThen_fn(function (focusGroupWasBlurred) {
            return focusGroupWasBlurred ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail("still focused on an element in the group");
        }, $elm$json$Json$Decode$oneOf(_List_fromArray([
            _Json_map2_fn($elm$core$Basics$neq, $author$project$View$FocusGroup$targetGroupIdDecoder, $author$project$View$FocusGroup$relatedTargetGroupIdDecoder),
            $elm$json$Json$Decode$succeed(true)
        ])));
    };
    var $author$project$View$FocusGroup$onBlur = function (msg) {
        return $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$on_fn("blur", $author$project$View$FocusGroup$onBlurDecoder(msg)));
    };
    var $author$project$Analytics$NoteShareLinkCopied = { $: 16 };
    var $author$project$Analytics$NoteShared = { $: 14 };
    var $author$project$Analytics$NoteUnshared = { $: 15 };
    var $author$project$Page$Note$SetLinkSharing_fn = function (a, b) {
        return { $: 11, a: a, b: b };
    }, $author$project$Page$Note$SetLinkSharing = F2($author$project$Page$Note$SetLinkSharing_fn);
    var $author$project$View$Tooltip$customNonHidden_a0 = false, $author$project$View$Tooltip$customNonHidden = $author$project$View$Tooltip$customHelp($author$project$View$Tooltip$customNonHidden_a0);
    var $author$project$Routing$baseUrl = function (url) {
        var scheme = function () {
            var _v1 = url.nY;
            if (!_v1) {
                return "http://";
            }
            else {
                return "https://";
            }
        }();
        var port_ = function () {
            var _v0 = url.nT;
            if (!_v0.$) {
                var p = _v0.a;
                return ":" + $elm$core$String$fromInt(p);
            }
            else {
                return "";
            }
        }();
        return _Utils_ap(scheme, _Utils_ap(url.hK, port_));
    };
    var $author$project$Page$Note$notePublicUrl_fn = function (url, user, noteId) {
        return $author$project$Routing$baseUrl(url) + ("/pview/" + (user.l8 + ("/" + noteId)));
    }, $author$project$Page$Note$notePublicUrl = F3($author$project$Page$Note$notePublicUrl_fn);
    var $author$project$Page$Note$shareButton_fn = function (env, model, user, noteId, note) {
        var publicUrl = $author$project$Page$Note$notePublicUrl_fn(env.mM, user, noteId);
        var commonAttrs = _List_fromArray([
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(env.nI.aO)
            ])),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.aM),
            $mdgriffith$elm_ui$Element$Font$color(env.nI.aS)
        ]);
        var buttonHeight = 26;
        var clipboardIconAttrs = _Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(33)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(buttonHeight)),
            $mdgriffith$elm_ui$Element$Border$color(env.nI.aQ),
            $mdgriffith$elm_ui$Element$Border$roundEach({ kx: 5, ky: 0, pF: 5, pG: 0 }),
            $mdgriffith$elm_ui$Element$Border$widthEach((new $$Record115(0, 0, 1, 0)))
        ]), commonAttrs);
        var mClipboardIcon = (!note.mF) ? $mdgriffith$elm_ui$Element$el_fn(_List_Nil, $mdgriffith$elm_ui$Element$none) : (model.eF ? A4($author$project$View$Tooltip$customNonHidden, env.nI, 0, $mdgriffith$elm_ui$Element$text("Copied!"), $author$project$View$Icon$buttonWithSize_fn(15, {
            kb: "Link copied",
            hp: _Utils_ap(clipboardIconAttrs, _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(env.nI.dF)
            ])),
            fQ: $elm$core$Maybe$Nothing
        }, 1, "copy")) : A4($author$project$View$Tooltip$basic, env.nI, 0, "Copy share link", $author$project$View$Icon$buttonWithSize_fn(15, {
            kb: "Copy share link",
            hp: _Utils_ap(clipboardIconAttrs, _List_fromArray([
                $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "copy-to-clipboard"),
                $author$project$View$Util$attribute_fn("data-clipboard-text", publicUrl)
            ])),
            fQ: $elm$core$Maybe$Just($author$project$Page$Note$ManyMsgs(_List_fromArray([
                $author$project$Page$Note$ShowClipboardNotification(true),
                $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NoteShareLinkCopied)
            ])))
        }, 1, "copy")));
        var shareUnshareButtonAttrs = _Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(12),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(buttonHeight)),
            $mdgriffith$elm_ui$Element$paddingXY_fn(8, 0),
            $mdgriffith$elm_ui$Element$Border$roundEach({
                kx: $author$project$Util$Misc$if__fn(note.mF, 0, 5),
                ky: 5,
                pF: $author$project$Util$Misc$if__fn(note.mF, 0, 5),
                pG: 5
            }),
            $mdgriffith$elm_ui$Element$spacing(2),
            $mdgriffith$elm_ui$Element$centerX
        ]), commonAttrs);
        var shareUnshareButton = A4($author$project$View$Tooltip$basic, env.nI, 0, $author$project$Util$Misc$if__fn(note.mF, "Disable", "Enable") + " note sharing", $mdgriffith$elm_ui$Element$Input$button_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $author$project$View$Styling$focusableOnlyBorderStyling
        ]), {
            fF: $mdgriffith$elm_ui$Element$row_fn(shareUnshareButtonAttrs, _List_fromArray([
                $author$project$View$Util$when_fn(!note.mF, $author$project$View$Icon$icon_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(14)
                ]), 1, "lock-alt")),
                $mdgriffith$elm_ui$Element$text($author$project$Util$Misc$if__fn(note.mF, "UNSHARE", "SHARE"))
            ])),
            nz: $elm$core$Maybe$Just($author$project$Page$Note$ManyMsgs(_List_fromArray([
                $author$project$Page$Note$SetLinkSharing_fn(noteId, !note.mF),
                $author$project$Page$Note$AnalyticsEvent($author$project$Util$Misc$if__fn(note.mF, $author$project$Analytics$NoteUnshared, $author$project$Analytics$NoteShared))
            ])))
        }));
        return $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([mClipboardIcon, shareUnshareButton]));
    }, $author$project$Page$Note$shareButton = F5($author$project$Page$Note$shareButton_fn);
    var $author$project$Page$Note$controlPanel_fn = function (env, model, user, noteId, state, note) {
        var mEvent = $author$project$Data$Note$getEvent_fn(note, env.lw);
        var mVideoConfUrl = $elm$core$Maybe$andThen_fn(function ($) {
            return $.e5;
        }, mEvent);
        var noVideoTooltipText = function () {
            var _v3 = _Utils_Tuple2(mEvent, env.mK.lw.gF);
            if (!_v3.a.$) {
                return "Event does not have video call";
            }
            else {
                if (_v3.b) {
                    var _v4 = _v3.a;
                    return "Video call info not found";
                }
                else {
                    var _v5 = _v3.a;
                    return "Still loading events...";
                }
            }
        }();
        var focusGroupAttrs = _List_fromArray([
            $author$project$View$Util$attribute_fn($author$project$View$FocusGroup$id_a0, "note-menu"),
            $author$project$View$FocusGroup$onBlur($author$project$Page$Note$ShowNoteMenu(false))
        ]);
        var buttonSize = 30;
        var buttonSizeAttrs = _List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(buttonSize)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(buttonSize))
        ]);
        var maybeRestoreNote = A4($author$project$View$Tooltip$basic, env.nI, 0, "Restore deleted note", $author$project$View$Icon$buttonWithSize_fn(18, {
            kb: "Restore this note",
            hp: _List_Cons($mdgriffith$elm_ui$Element$Font$color(env.nI.d0), buttonSizeAttrs),
            fQ: $elm$core$Maybe$Just($author$project$Page$Note$ManyMsgs(_List_fromArray([
                $author$project$Page$Note$RestoreNote(noteId),
                $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NoteRestored)
            ])))
        }, 3, "trash-undo-alt"));
        var iconSize = buttonSize - 13;
        var eventConfButton = function () {
            var _v0 = _Utils_Tuple2(note.hh, mVideoConfUrl);
            if (_v0.a.$ === 1) {
                var _v1 = _v0.a;
                return $mdgriffith$elm_ui$Element$none;
            }
            else {
                if (!_v0.b.$) {
                    var videoConfUrl = _v0.b.a;
                    return A4($author$project$View$Shortcut$tooltip, env.nI, 0, $author$project$Data$Shortcut$keys.jG, $author$project$View$Icon$newTabWithSize_fn(iconSize, {
                        kb: $author$project$Data$Shortcut$keys.jG.q,
                        hp: _List_Cons($elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NoteOpenVideoCall)), _List_Cons($mdgriffith$elm_ui$Element$Font$color(env.nI.a2), _List_Cons($mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.a6)
                        ])), buttonSizeAttrs)))
                    }, 1, "video", videoConfUrl));
                }
                else {
                    var _v2 = _v0.b;
                    return $author$project$View$Util$when_fn(!$author$project$Content$Note$isIntroductoryNoteId(noteId), A4($author$project$View$Tooltip$basic, env.nI, 0, noVideoTooltipText, $mdgriffith$elm_ui$Element$el_fn(buttonSizeAttrs, $author$project$View$Icon$icon_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aO),
                        $mdgriffith$elm_ui$Element$Font$size(iconSize),
                        $mdgriffith$elm_ui$Element$centerX,
                        $mdgriffith$elm_ui$Element$centerY
                    ]), 1, "video"))));
                }
            }
        }();
        var buttonHelp = F4(function (btnText, btnIcon, color, msgs) {
            return $mdgriffith$elm_ui$Element$Input$button_fn(_Utils_ap(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$pointer,
                $mdgriffith$elm_ui$Element$paddingXY_fn(15, 12),
                $mdgriffith$elm_ui$Element$Background$color(env.nI.aL),
                $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Background$color(env.nI.a1)
                ])),
                $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Background$color(env.nI.a3)
                ])),
                $mdgriffith$elm_ui$Element$Font$size(14)
            ]), focusGroupAttrs), {
                fF: $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$spacing(10)
                ]), _List_fromArray([
                    $author$project$View$Icon$icon_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(color),
                        $mdgriffith$elm_ui$Element$alignLeft,
                        $mdgriffith$elm_ui$Element$Font$size(17)
                    ]), 2, btnIcon),
                    $mdgriffith$elm_ui$Element$text(btnText)
                ])),
                nz: $elm$core$Maybe$Just($author$project$Page$Note$ManyMsgs(msgs))
            });
        });
        var deleteNoteButton = A4(buttonHelp, "Delete note", "trash", env.nI.er, _List_fromArray([
            $author$project$Page$Note$SoftDeleteNote(noteId),
            $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NoteSoftDeleted)
        ]));
        var toggleZenModeButton = A4(buttonHelp, "Zen mode", "spa", env.nI.aT, _List_fromArray([
            $author$project$Page$Note$ToggleZenMode,
            $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NoteOpenZenMode)
        ]));
        var moreOptionsDropdown = $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Border$width(1),
            $mdgriffith$elm_ui$Element$Border$color(env.nI.aP),
            $author$project$View$Styling$elevation40,
            $mdgriffith$elm_ui$Element$Border$rounded(5),
            $mdgriffith$elm_ui$Element$moveLeft(140),
            $mdgriffith$elm_ui$Element$moveDown(35),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(170)),
            $mdgriffith$elm_ui$Element$clip,
            $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, $author$project$View$Config$zIndices.nR)
        ]), _List_fromArray([
            toggleZenModeButton,
            $author$project$View$Util$when_fn(!(note.lh || (!state)), deleteNoteButton)
        ]));
        var moreOptionsButton = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$inFront($author$project$View$Util$when_fn(model.c4, moreOptionsDropdown))
        ]), $author$project$View$Icon$buttonWithSize_fn(iconSize, {
            kb: "Open note menu",
            hp: _List_Cons($mdgriffith$elm_ui$Element$Font$color(env.nI.aR), _Utils_ap(buttonSizeAttrs, focusGroupAttrs)),
            fQ: $elm$core$Maybe$Just($author$project$Page$Note$ShowNoteMenu(true))
        }, 1, "ellipsis-v"));
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(env.nI.aS),
            $mdgriffith$elm_ui$Element$spacing(5)
        ]), _List_fromArray([
            $author$project$Util$Misc$if__fn(note.lh, maybeRestoreNote, $author$project$Page$Note$shareButton_fn(env, model, user, noteId, note)),
            $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([eventConfButton, moreOptionsButton]))
        ]));
    }, $author$project$Page$Note$controlPanel = F6($author$project$Page$Note$controlPanel_fn);
    var $author$project$View$Util$on_fn = function (eventName, msg) {
        return $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$on_fn(eventName, $elm$json$Json$Decode$succeed(msg)));
    }, $author$project$View$Util$on = F2($author$project$View$Util$on_fn);
    var $mdgriffith$elm_ui$Internal$Model$OnRight = 2;
    var $mdgriffith$elm_ui$Element$onRight = function (element) {
        return $mdgriffith$elm_ui$Element$createNearby_fn(2, element);
    };
    var $author$project$View$Styling$h6 = function (palette) {
        return A3($author$project$View$Styling$hHelp, palette, 12, _List_Nil);
    };
    var $author$project$Util$Time$monthDayTimeFormatter_fn = function (isArmyTime, zone, time) {
        var timeText = isArmyTime ? A2($author$project$Util$Time$formatTimeOfDayArmy, zone, time) : A2($author$project$Util$Time$formatTimeOfDay, zone, time);
        return $ryannhg$date_format$DateFormat$formatWithLanguage_fn($ryannhg$date_format$DateFormat$format_a0, _List_fromArray([
            $ryannhg$date_format$DateFormat$monthNameAbbreviated,
            $ryannhg$date_format$DateFormat$text(" "),
            $ryannhg$date_format$DateFormat$dayOfMonthSuffix,
            $ryannhg$date_format$DateFormat$text(", "),
            $ryannhg$date_format$DateFormat$text(timeText)
        ]), zone, time);
    }, $author$project$Util$Time$monthDayTimeFormatter = F3($author$project$Util$Time$monthDayTimeFormatter_fn);
    var $author$project$Data$Timestamp$toPosix = function (timestamp) {
        if (!timestamp.$) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var posix = timestamp.a;
            return $elm$core$Maybe$Just(posix);
        }
    };
    var $author$project$View$Widgets$savedState_fn = function (palette, zone, armyTime, updatedAt, state) {
        var lastUpdatedTooltip = $elm$core$Maybe$withDefault_fn($elm$core$Basics$identity, $elm$core$Maybe$map_fn(A2($author$project$View$Tooltip$basic, palette, -55), $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, A2($author$project$Util$Time$monthDayTimeFormatter, armyTime, zone), $elm$core$Basics$append("Last saved  ")), $author$project$Data$Timestamp$toPosix(updatedAt))));
        var iconArea = function () {
            switch (state) {
                case 0:
                    return $elm$core$Maybe$Nothing;
                case 3:
                    return $elm$core$Maybe$Just(_Utils_Tuple3("laptop", 0, $elm$core$Maybe$Just("Saved to this Device")));
                case 4:
                    return $elm$core$Maybe$Just(_Utils_Tuple3("cloud", 1, $elm$core$Maybe$Nothing));
                case 2:
                    return $elm$core$Maybe$Just(_Utils_Tuple3("sync-alt", 1, $elm$core$Maybe$Nothing));
                case 1:
                    return $elm$core$Maybe$Just(_Utils_Tuple3("sync-alt", 1, $elm$core$Maybe$Nothing));
                case 5:
                    return $elm$core$Maybe$Just(_Utils_Tuple3("trash", 1, $elm$core$Maybe$Just("Deleting...")));
                default:
                    return $elm$core$Maybe$Just(_Utils_Tuple3("trash", 1, $elm$core$Maybe$Just("Deleted")));
            }
        }();
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(8),
            $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0),
            $author$project$View$Util$attrWhen_fn(state === 3, $author$project$View$Util$style_fn("animation", "delay-reveal 750ms")),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(17))
        ]), function () {
            if (!iconArea.$) {
                var _v1 = iconArea.a;
                var name = _v1.a;
                var iconStyle = _v1.b;
                var mVerbage = _v1.c;
                return _List_fromArray([
                    $author$project$View$Util$whenJust_fn(mVerbage, A2($author$project$View$Styling$h6, palette, _List_fromArray([
                        $author$project$View$Util$attrWhen_fn(state === 4, $author$project$View$Util$style_fn("animation", "delay-remove-smooth 5000ms")),
                        $author$project$View$Util$attrWhen_fn(state === 4, $author$project$View$Util$style_fn("opacity", "0")),
                        $mdgriffith$elm_ui$Element$Font$color(palette.aR),
                        $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "no-select")
                    ]))),
                    lastUpdatedTooltip($author$project$View$Icon$icon_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(17)
                    ]), iconStyle, name))
                ]);
            }
            else {
                return _List_Nil;
            }
        }());
    }, $author$project$View$Widgets$savedState = F5($author$project$View$Widgets$savedState_fn);
    var $author$project$Page$Note$EditorInitialValue_fn = function (a, b) {
        return { $: 17, a: a, b: b };
    }, $author$project$Page$Note$EditorInitialValue = F2($author$project$Page$Note$EditorInitialValue_fn);
    var $author$project$Page$Note$UpdateDescription_fn = function (a, b, c) {
        return { $: 1, a: a, b: b, c: c };
    }, $author$project$Page$Note$UpdateDescription = F3($author$project$Page$Note$UpdateDescription_fn);
    var $author$project$Page$Note$breakpoints = $author$project$View$Layout$breakpoints;
    var $author$project$View$SlateEditor$Html = 1;
    var $author$project$View$SlateEditor$Text = 2;
    var $author$project$View$SlateEditor$ChangeEvent_fn = function (slateDoc, plaintext, actionItems) {
        return (new $$Record138(actionItems, plaintext, slateDoc));
    }, $author$project$View$SlateEditor$ChangeEvent = F3($author$project$View$SlateEditor$ChangeEvent_fn);
    var $author$project$View$SlateEditor$decodeContentChangeEvent = _Json_map3_fn($author$project$View$SlateEditor$ChangeEvent, $elm$json$Json$Decode$at_fn(_List_fromArray(["detail", "slateDoc"]), $elm$json$Json$Decode$string), $elm$json$Json$Decode$at_fn(_List_fromArray(["detail", "plaintext"]), $elm$json$Json$Decode$string), $elm$json$Json$Decode$at_fn(_List_fromArray(["detail", "actionItems"]), $elm$json$Json$Decode$list($author$project$Data$ActionItem$decode)));
    var $author$project$Data$MentionNames$encode = function (mentionNames) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("people", $elm$json$Json$Encode$dict_fn($elm$core$Basics$identity, $elm$json$Json$Encode$string, mentionNames.iz))
        ]));
    };
    var $hecrj$html_parser$Html$Parser$commentToString = function (comment_) {
        return "<!--" + (comment_ + "-->");
    };
    var $hecrj$html_parser$Html$Parser$elementToString_fn = function (name, attributes, children) {
        var attributeToString = function (_v2) {
            var attr = _v2.a;
            var value = _v2.b;
            return attr + ("=\"" + (value + "\""));
        };
        var maybeAttributes = function () {
            if (!attributes.b) {
                return "";
            }
            else {
                return " " + $elm$core$String$join_fn(" ", $elm$core$List$map_fn(attributeToString, attributes));
            }
        }();
        return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? $elm$core$String$concat(_List_fromArray(["<", name, maybeAttributes, ">"])) : $elm$core$String$concat(_List_fromArray([
            "<",
            name,
            maybeAttributes,
            ">",
            $elm$core$String$join_fn("", $elm$core$List$map_fn($hecrj$html_parser$Html$Parser$nodeToString, children)),
            "</",
            name,
            ">"
        ]));
    }, $hecrj$html_parser$Html$Parser$elementToString = F3($hecrj$html_parser$Html$Parser$elementToString_fn);
    var $hecrj$html_parser$Html$Parser$nodeToString = function (node_) {
        switch (node_.$) {
            case 0:
                var text_ = node_.a;
                return text_;
            case 1:
                var name = node_.a;
                var attributes = node_.b;
                var children = node_.c;
                return $hecrj$html_parser$Html$Parser$elementToString_fn(name, attributes, children);
            default:
                var comment_ = node_.a;
                return $hecrj$html_parser$Html$Parser$commentToString(comment_);
        }
    };
    var $author$project$Data$Html$keepAttribute_fn = function (nodeName, _v0) {
        var attributeName = _v0.a;
        return ((nodeName === "a") && (attributeName === "href")) || ((attributeName === "text-decoration-line") || (attributeName === "font-style"));
    }, $author$project$Data$Html$keepAttribute = F2($author$project$Data$Html$keepAttribute_fn);
    var $author$project$Data$Html$whiteListElements = _List_fromArray(["div", "span", "br", "u", "ul", "ol", "li", "b", "a", "i", "p", "font", "strong"]);
    function $author$project$Data$Html$cyclic$sanitize() {
        return A2($elm$core$List$foldr, F2(function (node, acc) {
            switch (node.$) {
                case 2:
                    return acc;
                case 0:
                    return _List_Cons(node, acc);
                default:
                    var nodeName_ = node.a;
                    var attrs = node.b;
                    var nodes = node.c;
                    var nodeName = $author$project$Util$Misc$if__fn(nodeName_ === "b", "strong", nodeName_);
                    return $elm$core$List$any_fn($elm$core$Basics$eq(nodeName), $author$project$Data$Html$whiteListElements) ? _List_Cons($hecrj$html_parser$Html$Parser$Element_fn(nodeName, $elm$core$List$filter_fn($author$project$Data$Html$keepAttribute(nodeName), attrs), $author$project$Data$Html$cyclic$sanitize()(nodes)), acc) : acc;
            }
        }), _List_Nil);
    }
    var $author$project$Data$Html$sanitize = $author$project$Data$Html$cyclic$sanitize();
    $author$project$Data$Html$cyclic$sanitize = function () {
        return $author$project$Data$Html$sanitize;
    };
    var $author$project$View$SlateEditor$element = function (config) {
        var scrollToActionItem = $elm$core$Maybe$withDefault_fn("null", $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$json$Json$Encode$string, $elm$json$Json$Encode$encode(0)), config.ok));
        var mentionNames = $elm$core$Maybe$withDefault_fn("null", $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $author$project$Data$MentionNames$encode, $elm$json$Json$Encode$encode(0)), config.mX));
        var eventData = $elm$core$Maybe$withDefault_fn("null", $elm$core$Maybe$map_fn(function (_v3) {
            var eventId = _v3.b7;
            var masterId = _v3.mT;
            var title = _v3.gj;
            return _Json_encode_fn(0, $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2("eventId", $author$project$Util$Json$encodeMaybe_fn($elm$json$Json$Encode$string, eventId)),
                _Utils_Tuple2("masterId", $author$project$Util$Json$encodeMaybe_fn($elm$json$Json$Encode$string, masterId)),
                _Utils_Tuple2("title", $elm$json$Json$Encode$string(title))
            ])));
        }, config.hg));
        var encodedPalette = $author$project$Data$Color$stringifiedPaletteForTheme(config.pn);
        var _v0 = config.a;
        var entityState = _v0.lq;
        var slateDoc = _v0.f6;
        var plaintext = _v0.nP;
        var _v1 = (!entityState) ? $elm$core$Result$withDefault_fn(_Utils_Tuple2(2, plaintext), $elm$core$Result$map_fn(A2($elm$core$Basics$composeR, $author$project$Data$Html$sanitize, A2($elm$core$Basics$composeR, $elm$core$List$map($hecrj$html_parser$Html$Parser$nodeToString), A2($elm$core$Basics$composeR, $elm$core$String$concat, $elm$core$Tuple$pair(1)))), $hecrj$html_parser$Html$Parser$run(plaintext))) : _Utils_Tuple2(0, slateDoc);
        var contentType = _v1.a;
        var content = _v1.b;
        return $mdgriffith$elm_ui$Element$Keyed$el_fn(_List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(600, $mdgriffith$elm_ui$Element$minimum_fn(200, $mdgriffith$elm_ui$Element$fill))), _List_Cons($author$project$View$Styling$breakWord, config.hp)), _Utils_Tuple2(config.bq, $mdgriffith$elm_ui$Element$html($elm$html$Html$div_fn(_List_fromArray([
            _VirtualDom_style_fn("height", "100%"),
            $elm$html$Html$Events$on_fn("slateDocChanged", _Json_map1_fn(config.nv, $author$project$View$SlateEditor$decodeContentChangeEvent)),
            function () {
                var _v2 = config.nx;
                if (!_v2.$) {
                    var toMsg = _v2.a;
                    return $elm$html$Html$Events$on_fn("slateInitialValue", _Json_map1_fn(toMsg, $elm$json$Json$Decode$at_fn(_List_fromArray(["detail", "slateDoc"]), $elm$json$Json$Decode$string)));
                }
                else {
                    return $elm$html$Html$Attributes$classList(_List_Nil);
                }
            }()
        ]), _List_fromArray([
            _VirtualDom_lazy8_fn($author$project$View$SlateEditor$slateCustomElement, content, contentType, config.bq, eventData, mentionNames, false, scrollToActionItem, encodedPalette)
        ])))));
    };
    var $author$project$Data$MentionNames$generate_fn = function (people, note) {
        var handleMention = function (aiText) {
            if (aiText.$ === 2) {
                var personId = aiText.a.iB;
                return $elm$core$Maybe$map_fn(function (_v1) {
                    var person = _v1.b;
                    return _Utils_Tuple2(personId, person.b);
                }, $author$project$Data$Person$resolvePerson_fn(personId, people));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        };
        var peopleNames = $elm$core$Dict$fromList($elm$core$List$filterMap_fn(handleMention, $elm$core$List$concatMap_fn(function ($) {
            return $.jn;
        }, note.gz)));
        return (new $$Record139(peopleNames));
    }, $author$project$Data$MentionNames$generate = F2($author$project$Data$MentionNames$generate_fn);
    var $author$project$View$Responsive$attrs_fn = function (breakpoints, viewport, attrs_, responsiveAttrs) {
        return _Utils_ap(attrs_, $elm$core$List$map_fn(function (_v0) {
            var toAttr = _v0;
            return A2(toAttr, breakpoints, viewport);
        }, responsiveAttrs));
    }, $author$project$View$Responsive$attrs = F4($author$project$View$Responsive$attrs_fn);
    var $author$project$Page$Note$responsiveAttrs_a0 = $author$project$Page$Note$breakpoints, $author$project$Page$Note$responsiveAttrs = $author$project$View$Responsive$attrs($author$project$Page$Note$responsiveAttrs_a0);
    var $author$project$View$Responsive$Attribute = $elm$core$Basics$identity;
    var $author$project$View$Responsive$attrHelper_fn = function (f, mode_, attr) {
        return F2(function (breakpoints, viewport) {
            return $author$project$View$Util$attrWhen_fn(A2(f, mode_, $author$project$View$Responsive$mode_fn(breakpoints, viewport)), attr);
        });
    }, $author$project$View$Responsive$attrHelper_fn_unwrapped = function (f, mode_, attr) {
        return F2(function (breakpoints, viewport) {
            return $author$project$View$Util$attrWhen_fn(f(mode_, $author$project$View$Responsive$mode_fn(breakpoints, viewport)), attr);
        });
    }, $author$project$View$Responsive$attrHelper = F3($author$project$View$Responsive$attrHelper_fn);
    var $author$project$View$Responsive$whenMobile_a0 = $elm$core$Basics$eq, $author$project$View$Responsive$whenMobile_a1 = 2, $author$project$View$Responsive$whenMobile = A2($author$project$View$Responsive$attrHelper, $author$project$View$Responsive$whenMobile_a0, $author$project$View$Responsive$whenMobile_a1);
    var $author$project$Page$Note$slateNoteInput_fn = function (env, mActionItemPath, noteId, state, note) {
        var toEventData = F2(function (eventRef, title) {
            if (!eventRef.$) {
                var eventId = eventRef.a.b7;
                return (new $$Record83($elm$core$Maybe$Just(eventId), $elm$core$Maybe$Nothing, title));
            }
            else {
                var masterId = eventRef.a.mT;
                return (new $$Record83($elm$core$Maybe$Nothing, $elm$core$Maybe$Just(masterId), title));
            }
        });
        var mentionNames = $author$project$Data$MentionNames$generate_fn(env.iz, note);
        var heightSubtraction = $author$project$View$Responsive$isDoubleColumned_fn($author$project$Page$Note$breakpoints, env.p1) ? 290 : 360;
        return $author$project$View$SlateEditor$element((new $$Record141((new $$Record140(state, note.fc, note.f6)), noteId, $elm$core$Maybe$map2_fn(toEventData, note.hh, note.lv), $author$project$View$Responsive$attrs_fn($author$project$Page$Note$responsiveAttrs_a0, env.p1, _List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$minimum_fn(300, $mdgriffith$elm_ui$Element$px($elm$core$Basics$floor(env.p1.p1.fo - heightSubtraction))))
        ]), _List_fromArray([
            $author$project$View$Responsive$attrHelper_fn($author$project$View$Responsive$whenMobile_a0, $author$project$View$Responsive$whenMobile_a1, $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($elm$core$Basics$floor(env.p1.p1.fo - 225))))
        ])), $elm$core$Maybe$Just(mentionNames), A2($author$project$Page$Note$UpdateDescription, noteId, note.hh), $elm$core$Maybe$Just($author$project$Page$Note$EditorInitialValue(noteId)), mActionItemPath, $elm$core$Basics$composeR_fn($author$project$Data$Settings$theme_a0, $author$project$Data$Settings$theme_a1, env))));
    }, $author$project$Page$Note$slateNoteInput = F5($author$project$Page$Note$slateNoteInput_fn);
    var $author$project$Page$Note$UpdateTitle_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Page$Note$UpdateTitle = F2($author$project$Page$Note$UpdateTitle_fn);
    var $author$project$Util$Color$toRgbString = function (color) {
        return function (_v0) {
            var red = _v0.iU;
            var green = _v0.hE;
            var blue = _v0.gR;
            return "rgb(" + ($elm$core$String$fromInt($elm$core$Basics$floor(255 * red)) + ("," + ($elm$core$String$fromInt($elm$core$Basics$floor(255 * green)) + ("," + ($elm$core$String$fromInt($elm$core$Basics$floor(255 * blue)) + ")")))));
        }($mdgriffith$elm_ui$Element$toRgb(color));
    };
    var $author$project$Page$Note$titleInput_fn = function (env, noteId, note) {
        return $mdgriffith$elm_ui$Element$Input$textHelper_fn($mdgriffith$elm_ui$Element$Input$text_a0, _List_fromArray([
            $mdgriffith$elm_ui$Element$Border$width(0),
            $author$project$View$Util$preventKeypressPropagation($author$project$Page$Note$NoOp),
            $mdgriffith$elm_ui$Element$Font$size(20),
            $mdgriffith$elm_ui$Element$Font$color(env.nI.cI),
            $author$project$View$Util$attrWhen_fn($author$project$Data$Note$hasEvent(note), $author$project$View$Util$attribute_fn("disabled", "true")),
            $author$project$View$Util$style_fn("-webkit-text-fill-color", $author$project$Util$Color$toRgbString(env.nI.cd)),
            $author$project$View$Util$style_fn("-webkit-opacity", "1"),
            $mdgriffith$elm_ui$Element$paddingXY_fn(0, 5),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.dw)
        ]), {
            fF: $mdgriffith$elm_ui$Element$Input$labelHidden("Title"),
            nu: $author$project$Page$Note$UpdateTitle(noteId),
            fV: $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$Input$Placeholder_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(env.nI.aQ)
            ]), $mdgriffith$elm_ui$Element$text("(Untitled Note)"))),
            jn: $elm$core$Maybe$withDefault_fn(note.gj, note.lv)
        });
    }, $author$project$Page$Note$titleInput = F3($author$project$Page$Note$titleInput_fn);
    var $author$project$View$Breadcrumb$routeToText = function (env) {
        var _v0 = $elm$core$List$head(env.nV);
        _v0$6: while (true) {
            if (!_v0.$) {
                switch (_v0.a.$) {
                    case 0:
                        return "Home";
                    case 6:
                        var _v1 = _v0.a;
                        var id = _v1.a;
                        return $elm$core$Maybe$withDefault_fn("(Untitled Note)", $elm$core$Maybe$map_fn(function ($) {
                            return $.gj;
                        }, $author$project$Firestore$Collection$get_fn(id, env.fO)));
                    case 9:
                        var id = _v0.a.a;
                        return $elm$core$Maybe$withDefault_fn("(Untitled Person)", $elm$core$Maybe$map_fn(function ($) {
                            return $.b;
                        }, $author$project$Firestore$Collection$get_fn(id, env.iz)));
                    case 10:
                        return "Calendar";
                    case 16:
                        var _v2 = _v0.a;
                        var collation = _v2.a;
                        switch (collation.$) {
                            case 0:
                                return "Event Series";
                            case 1:
                                var personId = collation.a;
                                return "Notes with " + $elm$core$Maybe$withDefault_fn("(Untitled Person)", $elm$core$Maybe$map_fn(function ($) {
                                    return $.b;
                                }, $author$project$Firestore$Collection$get_fn(personId, env.iz)));
                            default:
                                var domainName = collation.a.g9;
                                return "Notes with " + domainName;
                        }
                    case 12:
                        var _v4 = _v0.a;
                        return "search results";
                    default:
                        break _v0$6;
                }
            }
            else {
                break _v0$6;
            }
        }
        return "previous page";
    };
    var $author$project$View$Breadcrumb$view = function (env) {
        return $mdgriffith$elm_ui$Element$Input$button_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(env.nI.a6),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(env.nI.a2)
            ]))
        ]), {
            fF: $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(10),
                $mdgriffith$elm_ui$Element$paddingEach((new $$Record115(16, 0, 0, 8)))
            ]), _List_fromArray([
                $author$project$View$Icon$icon_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(12)
                ]), 0, "chevron-left"),
                $mdgriffith$elm_ui$Element$text("Return to " + $author$project$View$Breadcrumb$routeToText(env))
            ])),
            nz: $elm$core$Maybe$Just($author$project$Env$NavigateBackwards)
        });
    };
    var $author$project$Page$Note$noteEditor_fn = function (env, user, model, noteId, state, note) {
        var onEscapeKeyUp = $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$stopPropagationOn_fn("keyup", _Json_andThen_fn(function (code) {
            return (code === "Escape") ? $elm$json$Json$Decode$succeed(_Utils_Tuple2($author$project$Page$Note$EditorEscapeKeyPressed, true)) : $elm$json$Json$Decode$fail("Ignore other keyups");
        }, _Json_decodeField_fn("code", $elm$json$Json$Decode$string))));
        var isShowArmyTime = $elm$core$Basics$composeR_fn($author$project$Data$Settings$isShowArmyTime_a0, $author$project$Data$Settings$isShowArmyTime_a1, env);
        var timeString = $author$project$Data$Time$formatTimeRange_fn(env.pu, isShowArmyTime, note.gh, $elm$core$Maybe$Just(note.fh));
        var editAdHocTime = $author$project$View$Icon$buttonWithSize_fn(14, {
            kb: "Edit time of Note",
            hp: _List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(25)),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(25)),
                $mdgriffith$elm_ui$Element$moveRight(5)
            ]),
            fQ: $elm$core$Maybe$Just($author$project$Page$Note$EditAdHocNoteTime(noteId))
        }, 1, "pencil");
        var dateView = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(12),
            $mdgriffith$elm_ui$Element$Font$color(env.nI.aR),
            $mdgriffith$elm_ui$Element$paddingEach((new $$Record115(15, 0, 0, 5))),
            $mdgriffith$elm_ui$Element$onRight($author$project$View$Util$when_fn(!$author$project$Data$Note$hasEvent(note), editAdHocTime))
        ]), $mdgriffith$elm_ui$Element$text(timeString));
        return _List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$map_fn($author$project$Page$Note$HandleBacktalk, $author$project$View$Breadcrumb$view(env)),
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $author$project$View$Util$on_fn("focusin", $author$project$Page$Note$EditorFocused(true)),
                $author$project$View$Util$on_fn("focusout", $author$project$Page$Note$EditorFocused(false)),
                onEscapeKeyUp,
                $author$project$View$Util$stopPropagationOn_fn("dragenter", $author$project$Page$Note$AttachmentInDropZone(false)),
                $author$project$View$Util$stopPropagationOn_fn("dragleave", $author$project$Page$Note$AttachmentInDropZone(false)),
                $mdgriffith$elm_ui$Element$spacing(10),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Background$color(env.nI.dw),
                $mdgriffith$elm_ui$Element$Border$rounded(5),
                $mdgriffith$elm_ui$Element$Font$color(env.nI.cI)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$spaceEvenly,
                    $mdgriffith$elm_ui$Element$spacing(15)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$spacing(6),
                            $mdgriffith$elm_ui$Element$moveLeft(5),
                            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                        ]), _List_fromArray([
                            $author$project$View$Icon$icon_fn(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Font$size(20),
                                $mdgriffith$elm_ui$Element$Font$color(env.nI.cI)
                            ]), 1, "file-alt"),
                            $author$project$Page$Note$titleInput_fn(env, noteId, note)
                        ])),
                        dateView
                    ])),
                    $author$project$View$Util$when_fn(!model.aw, $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$alignTop]), $author$project$Page$Note$controlPanel_fn(env, model, user, noteId, state, note)))
                ])),
                $author$project$Page$Note$slateNoteInput_fn(env, model.f$, noteId, state, note),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$alignRight,
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.aQ)
                ]), $author$project$View$Widgets$savedState_fn(env.nI, env.pu, isShowArmyTime, note.pR, state))
            ]))
        ]);
    }, $author$project$Page$Note$noteEditor = F6($author$project$Page$Note$noteEditor_fn);
    var $author$project$Page$Note$viewZenMode_fn = function (env, user, model, noteId, state, note) {
        var exitZenMode = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
            $mdgriffith$elm_ui$Element$alignRight
        ]), A4($author$project$View$Shortcut$tooltip, env.nI, 0, $author$project$Data$Shortcut$keys.hk, $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
            kb: $author$project$Data$Shortcut$keys.hk.q,
            hp: _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(env.nI.ba)
            ]),
            fQ: $elm$core$Maybe$Just($author$project$Page$Note$ToggleZenMode)
        }, 2, "times")));
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $author$project$View$Styling$paddingBottom(25),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.aM)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$column_fn($author$project$View$Responsive$attrs_fn($author$project$Page$Note$responsiveAttrs_a0, env.p1, _List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$spacing(5),
                $mdgriffith$elm_ui$Element$padding(10),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn($author$project$Page$Note$colWidth, $mdgriffith$elm_ui$Element$fill))
            ]), _List_fromArray([
                $author$project$View$Responsive$attrHelper_fn($author$project$View$Responsive$whenMobile_a0, $author$project$View$Responsive$whenMobile_a1, $mdgriffith$elm_ui$Element$alignTop)
            ])), _List_Cons(exitZenMode, $author$project$Page$Note$noteEditor_fn(env, user, model, noteId, state, note)))
        ]));
    }, $author$project$Page$Note$viewZenMode = F6($author$project$Page$Note$viewZenMode_fn);
    var $author$project$Page$Note$ActionsIn = 0;
    var $author$project$Page$Note$ActionsOut = 1;
    var $author$project$View$Util$createStackingContext = $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, 1);
    var $author$project$Page$Note$dragAndDropIndicator = function (palette) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$minimum_fn(300, $mdgriffith$elm_ui$Element$fill)),
            $mdgriffith$elm_ui$Element$Background$color(palette.dw),
            $mdgriffith$elm_ui$Element$Border$width(3),
            $mdgriffith$elm_ui$Element$Border$rounded(5),
            $mdgriffith$elm_ui$Element$Border$dashed,
            $mdgriffith$elm_ui$Element$Border$color(palette.a5),
            $author$project$View$Util$createStackingContext,
            $mdgriffith$elm_ui$Element$alpha(0.94)
        ]), $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$spacing(25),
            $mdgriffith$elm_ui$Element$Font$color(palette.a6)
        ]), _List_fromArray([
            $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(60),
                $mdgriffith$elm_ui$Element$centerX
            ]), 1, "paperclip"),
            $mdgriffith$elm_ui$Element$text("Drop to attach files")
        ])));
    };
    var $author$project$Data$AttendeeList$deterministicSort_a0 = $elm$core$List$sortBy(function (_v0) {
        var noteAttendee = _v0.a;
        return _Utils_ap(noteAttendee.b, function () {
            var _v1 = noteAttendee.n3;
            if (_v1.$ === 1) {
                var email = _v1.a;
                return email;
            }
            else {
                var id = _v1.a;
                return id;
            }
        }());
    }), $author$project$Data$AttendeeList$deterministicSort_a1 = $elm$core$List$sortBy(function (attendeeLine) {
        if (!attendeeLine.b.$) {
            var _v3 = attendeeLine.b.a;
            var person = _v3.b;
            return person.b;
        }
        else {
            var email = attendeeLine.b.a;
            return email;
        }
    }), $author$project$Data$AttendeeList$deterministicSort = A2($elm$core$Basics$composeR, $author$project$Data$AttendeeList$deterministicSort_a0, $author$project$Data$AttendeeList$deterministicSort_a1);
    var $elm$core$Dict$map_fn = function (func, dict) {
        if (dict.$ === -2) {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
        else {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, A2(func, key, value), $elm$core$Dict$map_fn(func, left), $elm$core$Dict$map_fn(func, right));
        }
    }, $elm$core$Dict$map_fn_unwrapped = function (func, dict) {
        if (dict.$ === -2) {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
        else {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, func(key, value), $elm$core$Dict$map_fn_unwrapped(func, left), $elm$core$Dict$map_fn_unwrapped(func, right));
        }
    }, $elm$core$Dict$map = F2($elm$core$Dict$map_fn);
    var $author$project$Data$AttendeeList$generateAttendeeList_fn = function (people, userEmail, noteAttendees) {
        var reducer = function (attendee) {
            var _v1 = $author$project$Data$AttendeeList$resolveAttendeeRef_fn(people, attendee);
            if (!_v1.$) {
                if (!_v1.a.a.$) {
                    var _v2 = _v1.a;
                    var domain = _v2.a.a;
                    var ref = _v2.b;
                    return $elm$core$Tuple$mapFirst(A2($elm$core$Dict$update, domain, A2($elm$core$Basics$composeR, $elm$core$Maybe$withDefault(_List_Nil), A2($elm$core$Basics$composeR, $elm$core$List$cons(_Utils_Tuple2(attendee, ref)), $elm$core$Maybe$Just))));
                }
                else {
                    var _v3 = _v1.a;
                    var _v4 = _v3.a;
                    var ref = _v3.b;
                    return $elm$core$Tuple$mapSecond($elm$core$List$cons(_Utils_Tuple2(attendee, ref)));
                }
            }
            else {
                return $elm$core$Basics$identity;
            }
        };
        return $elm$core$Tuple$mapFirst_fn($elm$core$Dict$map(function (_v0) {
            return $author$project$Data$AttendeeList$deterministicSort;
        }), $elm$core$List$foldl_fn(reducer, _Utils_Tuple2($elm$core$Dict$empty, _List_Nil), $elm$core$List$filter_fn(function (a) {
            return !_Utils_eq(a.n3, $author$project$Data$Note$EmailRef(userEmail));
        }, noteAttendees)));
    }, $author$project$Data$AttendeeList$generateAttendeeList = F3($author$project$Data$AttendeeList$generateAttendeeList_fn);
    var $author$project$Page$Note$otherNotesInSeries_fn = function (env, noteId, note) {
        return $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$neq(noteId)), $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$andThen_fn(function (ref) {
            if (ref.$ === 1) {
                var masterId = ref.a.mT;
                return $elm$core$Maybe$Just($author$project$View$Collate$relevantNotes_fn(env, $author$project$Routing$CollateSeries({
                    h8: $author$project$Data$Event$baseId(masterId)
                })));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, note.hh)));
    }, $author$project$Page$Note$otherNotesInSeries = F3($author$project$Page$Note$otherNotesInSeries_fn);
    var $author$project$Analytics$NoteChangeTab = function (a) {
        return { $: 31, a: a };
    };
    var $author$project$Page$Note$sidePanelTabs_fn = function (currentRoute, palette, viewportWidth, model, tabCounts) {
        var viewCount = A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$core$String$fromInt), A2($elm$core$Basics$composeR, $elm$core$Maybe$withDefault("\u2013"), A2($elm$core$Basics$composeR, $mdgriffith$elm_ui$Element$text, $mdgriffith$elm_ui$Element$el(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$light,
            $mdgriffith$elm_ui$Element$Font$size(14),
            $mdgriffith$elm_ui$Element$centerY
        ])))));
        var valuesFor = function (tab) {
            switch (tab) {
                case 0:
                    return _Utils_Tuple3("tasks", "THREADS", $elm$core$Maybe$Just(tabCounts.gu));
                case 1:
                    return _Utils_Tuple3("user-circle", "ATTENDEES", $elm$core$Maybe$Just(tabCounts.ke));
                case 2:
                    return _Utils_Tuple3("paperclip", "ATTACHMENTS", $elm$core$Maybe$Just(tabCounts.kd));
                default:
                    return _Utils_Tuple3("file-alt", "SERIES", tabCounts.eE);
            }
        };
        var tooltipText = function (tab) {
            switch (tab) {
                case 0:
                    return $elm$core$Maybe$Nothing;
                case 1:
                    return $elm$core$Maybe$Nothing;
                case 2:
                    return $elm$core$Maybe$Just("Attachments");
                default:
                    var _v4 = tabCounts.eE;
                    if (!_v4.$) {
                        return $elm$core$Maybe$Just("Notes in series");
                    }
                    else {
                        return $elm$core$Maybe$Just("This note is not part of a series");
                    }
            }
        };
        var tabButton = function (tab) {
            var isSelected = _Utils_eq(model.b1, tab);
            var _v0 = (!tab) ? _Utils_Tuple2(6, 17) : _Utils_Tuple2(3, 20);
            var spacingAmount = _v0.a;
            var iconSize = _v0.b;
            var _v1 = valuesFor(tab);
            var iconName = _v1.a;
            var title = _v1.b;
            var count = _v1.c;
            var isEnabled = $elm_community$maybe_extra$Maybe$Extra$isJust(count);
            return (isEnabled ? function (tabView) {
                return $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                    $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NoteChangeTab(tab))),
                    $author$project$View$Styling$focusable
                ]), {
                    fF: tabView,
                    dt: $author$project$Routing$pathFromRoute($author$project$Routing$changeNotePageTabTo_fn(tab, currentRoute))
                });
            } : $elm$core$Basics$identity)(function () {
                var _v2 = tooltipText(tab);
                if (!_v2.$) {
                    var text = _v2.a;
                    return $author$project$View$Tooltip$basic_fn(palette, 0, text);
                }
                else {
                    return $elm$core$Basics$identity;
                }
            }()($mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Border$widthEach((new $$Record115(2, 0, 0, 0))),
                $author$project$View$Util$attrWhen_fn(isSelected, $mdgriffith$elm_ui$Element$Font$color(palette.cI)),
                $author$project$View$Util$attrWhen_fn(!isEnabled, $mdgriffith$elm_ui$Element$Font$color(palette.aS)),
                $mdgriffith$elm_ui$Element$Border$color($author$project$Data$Color$transparent),
                $author$project$Util$Misc$if__fn(isSelected, $mdgriffith$elm_ui$Element$Border$color(palette.cI), $author$project$View$Util$attrWhen_fn(isEnabled, $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(palette.cI)
                ])))),
                $mdgriffith$elm_ui$Element$paddingXY_fn(0, 10),
                $mdgriffith$elm_ui$Element$spacing(spacingAmount)
            ]), _List_fromArray([
                $author$project$View$Icon$icon_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(iconSize)
                ]), $author$project$Util$Misc$if__fn(isSelected, 1, 2), iconName),
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(4)
                ]), _List_fromArray([
                    $author$project$View$Util$when_fn((viewportWidth > 1050) && ((!tab) || (tab === 1)), $mdgriffith$elm_ui$Element$text(title)),
                    viewCount(count)
                ]))
            ]))));
        };
        var dividerLine = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(25)),
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(1)),
            $mdgriffith$elm_ui$Element$Background$color(palette.aP)
        ]), $mdgriffith$elm_ui$Element$none);
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(12),
            $mdgriffith$elm_ui$Element$Font$color(palette.aS)
        ]), $elm$core$List$intersperse_fn(dividerLine, _List_fromArray([
            tabButton(0),
            tabButton(1),
            tabButton(3),
            tabButton(2)
        ])));
    }, $author$project$Page$Note$sidePanelTabs = F5($author$project$Page$Note$sidePanelTabs_fn);
    var $author$project$Page$Note$DragStartActionItem = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Page$Note$ToggleActionItem_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $author$project$Page$Note$ToggleActionItem = F2($author$project$Page$Note$ToggleActionItem_fn);
    var $author$project$View$ActionItems$actionItemChip_fn = function (palette, greyScale) {
        return $author$project$View$ActionItems$chipHelp(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn(greyScale, palette.aR, palette.dC)),
            $mdgriffith$elm_ui$Element$Border$width(1),
            $mdgriffith$elm_ui$Element$Border$color($author$project$Util$Misc$if__fn(greyScale, palette.aR, palette.dC)),
            $mdgriffith$elm_ui$Element$paddingEach((new $$Record115(1, 2, 1, 1)))
        ]));
    }, $author$project$View$ActionItems$actionItemChip = F2($author$project$View$ActionItems$actionItemChip_fn);
    var $mdgriffith$elm_ui$Element$Font$alignLeft = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.pf);
    var $author$project$View$Widgets$emptyStateContainer_fn = function (palette, extraAttrs) {
        return $mdgriffith$elm_ui$Element$column(_Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$transparent),
            $mdgriffith$elm_ui$Element$Border$rounded($author$project$View$Layout$standardBorderRounding),
            $mdgriffith$elm_ui$Element$Border$dashed,
            $mdgriffith$elm_ui$Element$Border$color(palette.aQ),
            $mdgriffith$elm_ui$Element$Border$width(2),
            $mdgriffith$elm_ui$Element$padding(20),
            $mdgriffith$elm_ui$Element$Font$color(palette.aR),
            $mdgriffith$elm_ui$Element$Font$alignLeft,
            $mdgriffith$elm_ui$Element$spacing(20),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), extraAttrs));
    }, $author$project$View$Widgets$emptyStateContainer = F2($author$project$View$Widgets$emptyStateContainer_fn);
    var $author$project$View$ActionItems$viewActionItem_fn = function (env, config, msgs, actionItem) {
        return $author$project$View$ActionItems$viewActionItemHelp_fn(env, config, $elm$core$Set$empty, { nw: msgs.nw, pC: msgs.pC }, actionItem);
    }, $author$project$View$ActionItems$viewActionItem = F4($author$project$View$ActionItems$viewActionItem_fn);
    var $author$project$Page$Note$viewActionItems_fn = function (env, noteId, note, actionItemGroup, actionItems) {
        var mentionChip = $author$project$View$ActionItems$mentionChip(env.nI);
        var keyShortcutChip = $author$project$View$ActionItems$keyShortcutChip(env.nI);
        var actionItemChip = $author$project$View$ActionItems$actionItemChip(env.nI);
        var _v0 = function () {
            if (!actionItemGroup) {
                return _Utils_Tuple2("Topics", _List_fromArray([
                    $author$project$View$Util$when_fn($elm_community$maybe_extra$Maybe$Extra$isJust(note.hh), $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Topics arrive here when this meeting is mentioned within other notes.")
                    ]))),
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Type "),
                        A2(keyShortcutChip, true, "??"),
                        $mdgriffith$elm_ui$Element$text(" in your note to create a "),
                        A2(actionItemChip, true, "topic"),
                        $mdgriffith$elm_ui$Element$text(".")
                    ]))
                ]));
            }
            else {
                return _Utils_Tuple2("To-do", _List_fromArray([
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("To-do's will display in your day view, and in the next recurring meeting until they're checked off.")
                    ])),
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Type "),
                        A2(keyShortcutChip, true, "!!"),
                        $mdgriffith$elm_ui$Element$text(" to create a "),
                        A2(actionItemChip, true, "to-do"),
                        $mdgriffith$elm_ui$Element$text(".")
                    ]))
                ]));
            }
        }();
        var headerCopy = _v0.a;
        var placeholderContent = _v0.b;
        var titleElement = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn($elm$core$List$isEmpty(actionItems), env.nI.aS, env.nI.aU)),
            $mdgriffith$elm_ui$Element$Font$bold
        ]), $mdgriffith$elm_ui$Element$text(headerCopy));
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$minimum_fn(100, $mdgriffith$elm_ui$Element$shrink)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), $elm$core$List$isEmpty(actionItems) ? $elm$core$List$singleton(A3($author$project$View$Widgets$emptyStateContainer, env.nI, _List_Nil, _List_Cons(titleElement, placeholderContent))) : _List_Cons(titleElement, _List_Cons($author$project$View$Util$spacer(10), $elm$core$List$intersperse_fn($author$project$View$ActionItems$spacerLine(env.nI), $elm$core$List$filterMap_fn(A3($author$project$View$ActionItems$viewActionItem, env, function () {
            var $r = $author$project$View$ActionItems$defaultViewConfig.$c();
            $r.eG = true;
            $r.n8 = !actionItemGroup;
            return $r;
        }(), {
            nw: $elm$core$Maybe$Just($author$project$Page$Note$DragStartActionItem),
            pC: $author$project$Page$Note$ToggleActionItem(noteId)
        }), _List_sortBy_fn($author$project$Data$ActionItem$prioritizationNumber, actionItems))))));
    }, $author$project$Page$Note$viewActionItems = F5($author$project$Page$Note$viewActionItems_fn);
    var $author$project$Page$Note$attachmentBorderRadius = 6;
    var $author$project$Page$Note$attachmentMaxHeight = 80;
    var $author$project$Page$Note$attachmentMaxWidth = 120;
    var $author$project$Page$Note$AttachFiles_fn = function (a, b, c) {
        return { $: 29, a: a, b: b, c: c };
    }, $author$project$Page$Note$AttachFiles = F3($author$project$Page$Note$AttachFiles_fn);
    var $author$project$Analytics$NoteAttachmentFilePicker = { $: 22 };
    var $elm$html$Html$Attributes$for_a0 = "htmlFor", $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$for_a0);
    var $elm$html$Html$input = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "input"), $elm$html$Html$input_fn = $elm$html$Html$input.a2;
    var $elm$html$Html$Attributes$accept_a0 = "accept", $elm$html$Html$Attributes$accept = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$accept_a0);
    var $mpizenberg$elm_file$FileValue$inputAttributes_fn = function (id, mimes) {
        return _List_fromArray([
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$id_a0, id),
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$type__a0, "file"),
            _VirtualDom_style_fn("display", "none"),
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$accept_a0, $elm$core$String$join_fn(",", mimes))
        ]);
    }, $mpizenberg$elm_file$FileValue$inputAttributes = F2($mpizenberg$elm_file$FileValue$inputAttributes_fn);
    var $mpizenberg$elm_file$FileValue$File_fn = function (value, name, mime, size, lastModified) {
        return (new $$Record142(lastModified, mime, name, size, value));
    }, $mpizenberg$elm_file$FileValue$File = F5($mpizenberg$elm_file$FileValue$File_fn);
    var $elm$json$Json$Decode$map5 = _Json_map5;
    var $mpizenberg$elm_file$FileValue$decoder = _Json_map5_fn($mpizenberg$elm_file$FileValue$File, $elm$json$Json$Decode$value, _Json_decodeField_fn("name", $elm$json$Json$Decode$string), _Json_decodeField_fn("type", $elm$json$Json$Decode$string), _Json_decodeField_fn("size", $elm$json$Json$Decode$int), _Json_map1_fn($elm$time$Time$millisToPosix, _Json_decodeField_fn("lastModified", $elm$json$Json$Decode$int)));
    var $mpizenberg$elm_file$FileValue$loadFile = function (msgTag) {
        return $elm$html$Html$Events$custom_fn("change", _Json_map1_fn(function (file) {
            return {
                m_: msgTag(file),
                nU: true,
                oU: true
            };
        }, $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "files", "0"]), $mpizenberg$elm_file$FileValue$decoder)));
    };
    var $mpizenberg$elm_file$FileValue$hiddenInputSingle_fn = function (id, mimes, msgTag) {
        return $elm$html$Html$input_fn(_List_Cons($mpizenberg$elm_file$FileValue$loadFile(msgTag), $mpizenberg$elm_file$FileValue$inputAttributes_fn(id, mimes)), _List_Nil);
    }, $mpizenberg$elm_file$FileValue$hiddenInputSingle = F3($mpizenberg$elm_file$FileValue$hiddenInputSingle_fn);
    var $elm$html$Html$label = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "label"), $elm$html$Html$label_fn = $elm$html$Html$label.a2;
    var $mdgriffith$elm_ui$Internal$Model$NoStaticStyleSheet = 1;
    var $mdgriffith$elm_ui$Internal$Model$RenderModeOption = function (a) {
        return { $: 2, a: a };
    };
    var $mdgriffith$elm_ui$Element$noStaticStyleSheet = $mdgriffith$elm_ui$Internal$Model$RenderModeOption(1);
    var $mdgriffith$elm_ui$Internal$Model$FocusStyleOption = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Element$focusStyle = $mdgriffith$elm_ui$Internal$Model$FocusStyleOption;
    var $author$project$View$Styling$noFocusStyling = $mdgriffith$elm_ui$Element$focusStyle({ ki: $elm$core$Maybe$Nothing, ks: $elm$core$Maybe$Nothing, ov: $elm$core$Maybe$Nothing });
    var $author$project$View$Styling$options = (new $$Record143(_List_fromArray([$author$project$View$Styling$noFocusStyling])));
    var $author$project$View$Widgets$singleFileInput_fn = function (inputId, fileTypes, toMsg, palette, labelElement) {
        var appOptions = $author$project$View$Styling$options;
        return $mdgriffith$elm_ui$Element$row_fn(_List_Nil, $elm$core$List$map_fn($mdgriffith$elm_ui$Element$html, _List_fromArray([
            $elm$html$Html$label_fn(_List_fromArray([
                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$for_a0, inputId)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$layoutWith_fn(function () {
                    var $r = appOptions.$c();
                    $r.nE = _List_Cons($mdgriffith$elm_ui$Element$noStaticStyleSheet, appOptions.nE);
                    return $r;
                }(), $author$project$View$Styling$global(palette), labelElement)
            ])),
            $mpizenberg$elm_file$FileValue$hiddenInputSingle_fn(inputId, fileTypes, toMsg)
        ])));
    }, $author$project$View$Widgets$singleFileInput = F5($author$project$View$Widgets$singleFileInput_fn);
    var $author$project$Page$Note$withFilePicker_fn = function (palette, noteId) {
        return A4($author$project$View$Widgets$singleFileInput, "note-file-attach-text", _List_Nil, function (file) {
            return $author$project$Page$Note$ManyMsgs(_List_fromArray([
                $author$project$Page$Note$AttachFiles_fn(noteId, file, _List_Nil),
                $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NoteAttachmentFilePicker)
            ]));
        }, palette);
    }, $author$project$Page$Note$withFilePicker = F2($author$project$Page$Note$withFilePicker_fn);
    var $author$project$Page$Note$attachFileButton_fn = function (palette, noteId) {
        return A3($author$project$Page$Note$withFilePicker, palette, noteId, $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px($author$project$Page$Note$attachmentMaxWidth)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$Page$Note$attachmentMaxHeight)),
            $mdgriffith$elm_ui$Element$Border$width(1),
            $mdgriffith$elm_ui$Element$Border$dashed,
            $mdgriffith$elm_ui$Element$Border$rounded($author$project$Page$Note$attachmentBorderRadius),
            $mdgriffith$elm_ui$Element$Border$color(palette.aQ),
            $mdgriffith$elm_ui$Element$Font$color(palette.aS),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Border$color(palette.aS),
                $mdgriffith$elm_ui$Element$Font$color(palette.aT)
            ])),
            $mdgriffith$elm_ui$Element$pointer
        ]), $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$spacing(4),
            $mdgriffith$elm_ui$Element$Font$size(14)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$text("Attach file"),
            $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(18),
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$centerX
            ]), 2, "plus")
        ]))));
    }, $author$project$Page$Note$attachFileButton = F2($author$project$Page$Note$attachFileButton_fn);
    var $author$project$Page$Note$emptyState_fn = function (palette, _v0) {
        var headerText = _v0.d3;
        var copy = _v0.dR;
        var tailElts = _v0.eN;
        return A3($author$project$View$Widgets$emptyStateContainer, palette, _List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), _List_Cons($mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$bold,
            $mdgriffith$elm_ui$Element$Font$color(palette.aS)
        ]), $mdgriffith$elm_ui$Element$text(headerText)), _List_Cons($mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
            $mdgriffith$elm_ui$Element$text(copy)
        ])), tailElts)));
    }, $author$project$Page$Note$emptyState = F2($author$project$Page$Note$emptyState_fn);
    var $author$project$Data$StorageUpload$uploads_fn = function (entityId, _v0) {
        var tracker = _v0;
        return $elm$core$Dict$map_fn_unwrapped(function (_v1, state) {
            return state.gl;
        }, $elm$core$Maybe$withDefault_fn($elm$core$Dict$empty, $elm$core$Dict$get_fn(entityId, tracker)));
    }, $author$project$Data$StorageUpload$uploads = F2($author$project$Data$StorageUpload$uploads_fn);
    var $author$project$Page$Note$ViewAttachment = function (a) {
        return { $: 22, a: a };
    };
    var $author$project$Page$Note$ViewImage = function (a) {
        return { $: 23, a: a };
    };
    var $author$project$Page$Note$viewAttachmentMsg = function (attachment) {
        var _v0 = _Utils_Tuple2(_String_startsWith_fn("image/", attachment.c1), attachment.cR);
        if (_v0.a && (!_v0.b.$)) {
            var downloadUrl = _v0.b.a;
            return $author$project$Page$Note$ViewImage({ ma: downloadUrl });
        }
        else {
            return $author$project$Page$Note$ViewAttachment(attachment);
        }
    };
    var $author$project$Page$Note$attachmentWithThumbnail_fn = function (attachment, thumbnailUrl) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Border$rounded(6),
            $mdgriffith$elm_ui$Element$clip
        ]), $mdgriffith$elm_ui$Element$image_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn($author$project$Page$Note$attachmentMaxWidth, $mdgriffith$elm_ui$Element$fill)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$maximum_fn($author$project$Page$Note$attachmentMaxHeight, $mdgriffith$elm_ui$Element$fill)),
            $mdgriffith$elm_ui$Element$pointer,
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Note$viewAttachmentMsg(attachment))
        ]), (new $$Record114(attachment.b8 + " - thumbnail image", thumbnailUrl))));
    }, $author$project$Page$Note$attachmentWithThumbnail = F2($author$project$Page$Note$attachmentWithThumbnail_fn);
    var $elm_community$list_extra$List$Extra$find_fn = function (predicate, list) {
        find: while (true) {
            if (!list.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var first = list.a;
                var rest = list.b;
                if (predicate(first)) {
                    return $elm$core$Maybe$Just(first);
                }
                else {
                    var $temp$predicate = predicate, $temp$list = rest;
                    predicate = $temp$predicate;
                    list = $temp$list;
                    continue find;
                }
            }
        }
    }, $elm_community$list_extra$List$Extra$find = F2($elm_community$list_extra$List$Extra$find_fn);
    var $author$project$View$Icon$iconMimeTypeMap = _List_fromArray([
        _Utils_Tuple2("file-image", _List_fromArray(["image/"])),
        _Utils_Tuple2("file-pdf", _List_fromArray(["application/pdf"])),
        _Utils_Tuple2("file-excel", _List_fromArray(["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"])),
        _Utils_Tuple2("file-csv", _List_fromArray(["text/csv"])),
        _Utils_Tuple2("file-word", _List_fromArray(["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"])),
        _Utils_Tuple2("file-video", _List_fromArray(["video/"])),
        _Utils_Tuple2("file-audio", _List_fromArray(["audio/"])),
        _Utils_Tuple2("file-archive", _List_fromArray(["application/gzip", "application/x-bzip", "application/x-bzip2", "application/zip", "application/x-7z-compressed", "application/x-tar"])),
        _Utils_Tuple2("file-chart-pie", _List_fromArray(["application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.apple.keynote"]))
    ]);
    var $author$project$View$Icon$forMimeType = function (mimeType) {
        return $elm$core$Maybe$withDefault_fn("file-alt", $elm$core$Maybe$map_fn($elm$core$Tuple$first, $elm_community$list_extra$List$Extra$find_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$any(A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$String$startsWith, mimeType))), $author$project$View$Icon$iconMimeTypeMap)));
    };
    var $author$project$Page$Note$attachmentWithoutThumbnail_fn = function (palette, attachment) {
        var fileNameElement = $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$center,
            $mdgriffith$elm_ui$Element$Font$size(13),
            $mdgriffith$elm_ui$Element$alignBottom,
            $mdgriffith$elm_ui$Element$moveUp(14)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$text($author$project$Util$Text$truncateToNChars_fn(18, attachment.b8))
        ]));
        var fileIcon = $author$project$View$Icon$icon_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(30),
            $mdgriffith$elm_ui$Element$moveDown(8),
            $mdgriffith$elm_ui$Element$moveRight(2)
        ]), 3, $author$project$View$Icon$forMimeType(attachment.c1));
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px($author$project$Page$Note$attachmentMaxWidth)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$Page$Note$attachmentMaxHeight)),
            $mdgriffith$elm_ui$Element$Border$width(1),
            $mdgriffith$elm_ui$Element$Border$rounded($author$project$Page$Note$attachmentBorderRadius),
            $mdgriffith$elm_ui$Element$Border$color(palette.aQ),
            $mdgriffith$elm_ui$Element$Font$color(palette.aR),
            $mdgriffith$elm_ui$Element$inFront(fileIcon),
            $mdgriffith$elm_ui$Element$pointer,
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Note$viewAttachmentMsg(attachment))
        ]), fileNameElement);
    }, $author$project$Page$Note$attachmentWithoutThumbnail = F2($author$project$Page$Note$attachmentWithoutThumbnail_fn);
    var $author$project$Page$Note$DeleteAttachment = function (a) {
        return { $: 25, a: a };
    };
    var $author$project$Page$Note$DownloadAttachment = function (a) {
        return { $: 24, a: a };
    };
    var $author$project$Analytics$NoteAttachmentDownload = { $: 25 };
    var $author$project$Analytics$NoteAttachmentRemoved = { $: 24 };
    var $author$project$Analytics$NoteAttachmentRenameFormOpened = { $: 26 };
    var $author$project$Page$Note$SetAttachmentMenu = function (a) {
        return { $: 19, a: a };
    };
    var $author$project$Page$Note$SetAttachmentRenameForm = function (a) {
        return { $: 20, a: a };
    };
    var $author$project$Page$Note$attachmentMenuFocusGroupAttrs = function (_v0) {
        var storagePath = _v0.Y;
        return _List_fromArray([
            $author$project$View$Util$attribute_fn($author$project$View$FocusGroup$id_a0, "attachment-menu-" + storagePath),
            $author$project$View$FocusGroup$onBlur($author$project$Page$Note$SetAttachmentMenu($elm$core$Maybe$Nothing))
        ]);
    };
    var $author$project$View$Styling$elevation30 = $mdgriffith$elm_ui$Element$Border$shadow({
        kp: 8,
        kS: $author$project$Data$Color$grayAlphaDark,
        nt: _Utils_Tuple2(0.2, 1),
        oE: 1.5
    });
    var $author$project$Page$Note$attachmentMenu_fn = function (model, palette, attachment) {
        var toMenuOption = F3(function (fontColor, msgs, str) {
            return $author$project$View$Widgets$button_fn({
                hp: _Utils_ap(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Border$width(0),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(30)),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$padding(10),
                    $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Background$color(palette.aN)
                    ])),
                    $mdgriffith$elm_ui$Element$Font$size(12),
                    $mdgriffith$elm_ui$Element$Font$color(fontColor(palette))
                ]), $author$project$Page$Note$attachmentMenuFocusGroupAttrs(attachment)),
                l7: $elm$core$Maybe$Nothing,
                fQ: $elm$core$Maybe$Just($author$project$Page$Note$ManyMsgs(_List_Cons($author$project$Page$Note$SetAttachmentMenu($elm$core$Maybe$Nothing), msgs)))
            }, str);
        });
        return $author$project$View$Util$when_fn(_Utils_eq(model.cF, $elm$core$Maybe$Just(attachment.Y)), $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(130)),
            $mdgriffith$elm_ui$Element$Font$size(12),
            $mdgriffith$elm_ui$Element$Background$color(palette.dw),
            $mdgriffith$elm_ui$Element$Border$rounded(4),
            $author$project$View$Styling$elevation30,
            $mdgriffith$elm_ui$Element$moveLeft(10),
            $mdgriffith$elm_ui$Element$moveDown(28),
            $mdgriffith$elm_ui$Element$clip,
            $author$project$View$Util$createStackingContext
        ]), _List_fromArray([
            A3(toMenuOption, function ($) {
                return $.aU;
            }, _List_fromArray([
                $author$project$Page$Note$SetAttachmentRenameForm($elm$core$Maybe$Just({ dz: attachment })),
                $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NoteAttachmentRenameFormOpened)
            ]), "Rename"),
            $author$project$View$Util$whenJust_fn(attachment.cR, function (downloadUrl) {
                return A3(toMenuOption, function ($) {
                    return $.aU;
                }, _List_fromArray([
                    $author$project$Page$Note$DownloadAttachment({ cR: downloadUrl, lG: attachment.b8 }),
                    $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NoteAttachmentDownload)
                ]), "Download");
            }),
            A3(toMenuOption, function ($) {
                return $.er;
            }, _List_fromArray([
                $author$project$Page$Note$DeleteAttachment(attachment),
                $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NoteAttachmentRemoved)
            ]), "Delete attachment")
        ])));
    }, $author$project$Page$Note$attachmentMenu = F3($author$project$Page$Note$attachmentMenu_fn);
    var $author$project$Page$Note$attachmentMenuButton_fn = function (palette, attachment) {
        return $mdgriffith$elm_ui$Element$Input$button_fn(_Utils_ap(_List_fromArray([
            $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "attachment-menu-button"),
            $mdgriffith$elm_ui$Element$Border$rounded(5),
            $author$project$View$Styling$backgroundTransition,
            $author$project$View$Styling$focusable,
            $author$project$View$Styling$ripple,
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(20)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(20)),
            $mdgriffith$elm_ui$Element$moveLeft(5),
            $mdgriffith$elm_ui$Element$moveDown(5),
            $mdgriffith$elm_ui$Element$Font$color(palette.aM),
            $mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.5)),
            $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.5))
            ])),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.7))
            ])),
            $author$project$View$Util$attribute_fn($author$project$View$Aria$label_a0, "menu for attachment \"" + (attachment.b8 + "\"")),
            $mdgriffith$elm_ui$Element$pointer,
            $mdgriffith$elm_ui$Element$alignRight
        ]), $author$project$Page$Note$attachmentMenuFocusGroupAttrs(attachment)), {
            fF: $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$Font$size(20)
            ]), 1, "angle-down"),
            nz: $elm$core$Maybe$Just($author$project$Page$Note$SetAttachmentMenu($elm$core$Maybe$Just(attachment.Y)))
        });
    }, $author$project$Page$Note$attachmentMenuButton = F2($author$project$Page$Note$attachmentMenuButton_fn);
    var $author$project$Page$Note$RenameAttachment_fn = function (a, b) {
        return { $: 21, a: a, b: b };
    }, $author$project$Page$Note$RenameAttachment = F2($author$project$Page$Note$RenameAttachment_fn);
    var $author$project$Page$Note$handleAttachmentRenameFormKeyUp = function (_v0) {
        var attachmentBeforeRename = _v0.dz;
        var newAttachment = _v0.ik;
        return $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$custom_fn("keyup", _Json_map1_fn(function (msg) {
            return { m_: msg, nU: true, oU: true };
        }, _Json_andThen_fn(function (event) {
            var _v1 = event.mC;
            switch (_v1) {
                case "Enter":
                    return $elm$json$Json$Decode$succeed($author$project$Page$Note$SetAttachmentRenameForm($elm$core$Maybe$Nothing));
                case "Escape":
                    return $elm$json$Json$Decode$succeed($author$project$Page$Note$ManyMsgs(_List_fromArray([
                        $author$project$Page$Note$SetAttachmentRenameForm($elm$core$Maybe$Nothing),
                        $author$project$Page$Note$RenameAttachment_fn(newAttachment, attachmentBeforeRename.b8)
                    ])));
                default:
                    return $elm$json$Json$Decode$fail("enter not pressed");
            }
        }, $author$project$Data$Keypress$decoder))));
    };
    var $elm$html$Html$Events$onBlur = function (msg) {
        return $elm$html$Html$Events$on_fn("blur", $elm$json$Json$Decode$succeed(msg));
    };
    var $author$project$Page$Note$viewAttachmentRename_fn = function (model, palette, attachment) {
        var onBlurHandler = function (attachmentBeforeRename) {
            return $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$onBlur($author$project$Page$Note$ManyMsgs($elm_community$maybe_extra$Maybe$Extra$cons_fn($author$project$Util$Misc$toJustIf_fn($elm$core$String$isEmpty(attachment.b8), $author$project$Page$Note$RenameAttachment_fn(attachment, attachmentBeforeRename.b8)), _List_fromArray([
                $author$project$Page$Note$SetAttachmentRenameForm($elm$core$Maybe$Nothing)
            ])))));
        };
        var _v0 = model.cG;
        if (!_v0.$) {
            var attachmentBeforeRename = _v0.a.dz;
            return _Utils_eq(attachmentBeforeRename.Y, attachment.Y) ? $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$moveDown(5),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px($author$project$Page$Note$attachmentMaxWidth + 20)),
                $mdgriffith$elm_ui$Element$centerX
            ]), $mdgriffith$elm_ui$Element$Input$textHelper_fn($mdgriffith$elm_ui$Element$Input$text_a0, _List_fromArray([
                $elm$core$Basics$composeL_fn($author$project$View$Util$id_a0, $author$project$View$Util$id_a1, $author$project$Page$Note$attachmentRenameFormId),
                $author$project$Page$Note$handleAttachmentRenameFormKeyUp({ dz: attachmentBeforeRename, ik: attachment }),
                $author$project$View$Util$stopPropagationOn_fn("keydown", $author$project$Page$Note$NoOp("")),
                $author$project$View$Util$stopPropagationOn_fn("keypress", $author$project$Page$Note$NoOp("")),
                onBlurHandler(attachmentBeforeRename),
                $mdgriffith$elm_ui$Element$padding(5),
                $mdgriffith$elm_ui$Element$Border$width(0),
                $mdgriffith$elm_ui$Element$Font$size(13),
                $mdgriffith$elm_ui$Element$Background$color(palette.aP),
                $mdgriffith$elm_ui$Element$Border$width(2),
                $mdgriffith$elm_ui$Element$Border$color(palette.a5),
                $author$project$View$Styling$elevation30
            ]), {
                fF: $mdgriffith$elm_ui$Element$Input$labelHidden("New attachment name"),
                nu: $author$project$Page$Note$RenameAttachment(attachment),
                fV: $elm$core$Maybe$Nothing,
                jn: attachment.b8
            })) : $mdgriffith$elm_ui$Element$none;
        }
        else {
            return $mdgriffith$elm_ui$Element$none;
        }
    }, $author$project$Page$Note$viewAttachmentRename = F3($author$project$Page$Note$viewAttachmentRename_fn);
    var $author$project$View$Tooltip$hide = $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "hide-tooltip");
    var $author$project$Page$Note$withAttachmentTooltip_fn = function (palette, model, attachment) {
        var hideTooltip = $elm_community$maybe_extra$Maybe$Extra$isJust(model.cG) || $elm_community$maybe_extra$Maybe$Extra$isJust(model.cF);
        return A2($elm$core$Basics$composeR, $author$project$View$Tooltip$basic_fn(palette, 0, $author$project$Util$Text$truncateToNChars_fn(30, attachment.b8)), $mdgriffith$elm_ui$Element$el(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$centerX,
            $author$project$View$Util$attrWhen_fn(hideTooltip, $author$project$View$Tooltip$hide)
        ])));
    }, $author$project$Page$Note$withAttachmentTooltip = F3($author$project$Page$Note$withAttachmentTooltip_fn);
    var $author$project$Page$Note$toAttachmentThumbnail_fn = function (palette, model, attachment) {
        return A2($elm$core$Basics$composeR, $mdgriffith$elm_ui$Element$el(_List_fromArray([
            $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "attachment-thumbnail"),
            $mdgriffith$elm_ui$Element$inFront($author$project$Page$Note$attachmentMenuButton_fn(palette, attachment))
        ])), A2($elm$core$Basics$composeR, $author$project$Page$Note$withAttachmentTooltip_fn(palette, model, attachment), A2($elm$core$Basics$composeR, $elm$core$Tuple$pair(attachment.Y), $mdgriffith$elm_ui$Element$Keyed$el(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px($author$project$Page$Note$attachmentMaxWidth)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$Page$Note$attachmentMaxHeight)),
            $mdgriffith$elm_ui$Element$inFront($author$project$Page$Note$attachmentMenu_fn(model, palette, attachment)),
            $mdgriffith$elm_ui$Element$below($author$project$Page$Note$viewAttachmentRename_fn(model, palette, attachment))
        ])))));
    }, $author$project$Page$Note$toAttachmentThumbnail = F3($author$project$Page$Note$toAttachmentThumbnail_fn);
    var $author$project$Page$Note$viewAttachment_fn = function (model, palette, attachment) {
        return A4($author$project$Page$Note$toAttachmentThumbnail, palette, model, attachment, $elm$core$Maybe$withDefault_fn($author$project$Page$Note$attachmentWithoutThumbnail_fn(palette, attachment), $elm$core$Maybe$map_fn($author$project$Page$Note$attachmentWithThumbnail(attachment), attachment.ct)));
    }, $author$project$Page$Note$viewAttachment = F3($author$project$Page$Note$viewAttachment_fn);
    var $author$project$Page$Note$CancelUpload_fn = function (a, b) {
        return { $: 27, a: a, b: b };
    }, $author$project$Page$Note$CancelUpload = F2($author$project$Page$Note$CancelUpload_fn);
    var $author$project$Page$Note$viewPendingUpload_fn = function (palette, noteId, _v0) {
        var storagePath = _v0.a;
        var status = _v0.b;
        var percentTransfered = status.cK / status.dn;
        var loadingBar = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(8)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px($author$project$Page$Note$attachmentMaxWidth - 10)),
            $mdgriffith$elm_ui$Element$Border$rounded($author$project$Page$Note$attachmentBorderRadius),
            $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "shimmer-light"),
            $mdgriffith$elm_ui$Element$clip,
            $mdgriffith$elm_ui$Element$centerX
        ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $author$project$View$Util$style_fn("transform", "scaleX(" + ($elm$core$String$fromFloat(percentTransfered) + ")")),
            $author$project$View$Util$style_fn("transform-origin", "left"),
            $author$project$View$Util$style_fn("transition", "transform ease-out 200ms"),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$Background$color(palette.a5)
        ]), $mdgriffith$elm_ui$Element$none));
        var fileNameElement = $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$center,
            $mdgriffith$elm_ui$Element$Font$size(13)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$text($author$project$Util$Text$truncateToNChars_fn(18, status.b8))
        ]));
        var fileIcon = $author$project$View$Icon$icon_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(30),
            $mdgriffith$elm_ui$Element$moveDown(8),
            $mdgriffith$elm_ui$Element$moveRight(2)
        ]), 3, $author$project$View$Icon$forMimeType(status.c1));
        var cancelButton = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$alignRight,
            $mdgriffith$elm_ui$Element$moveLeft(3),
            $mdgriffith$elm_ui$Element$moveDown(3),
            $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, 1)
        ]), A4($author$project$View$Tooltip$basic, palette, 0, "Cancel Upload", $author$project$View$Icon$buttonWithSize_fn(15, {
            kb: "Cancel Upload",
            hp: _List_fromArray([
                $mdgriffith$elm_ui$Element$paddingXY_fn(0, 0),
                $mdgriffith$elm_ui$Element$alignRight,
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(25)),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(25)),
                $mdgriffith$elm_ui$Element$Font$color(palette.aQ)
            ]),
            fQ: $elm$core$Maybe$Just($author$project$Page$Note$CancelUpload_fn(noteId, storagePath))
        }, 2, "times")));
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px($author$project$Page$Note$attachmentMaxWidth)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$Page$Note$attachmentMaxHeight)),
            $mdgriffith$elm_ui$Element$Border$width(1),
            $mdgriffith$elm_ui$Element$Border$rounded($author$project$Page$Note$attachmentBorderRadius),
            $mdgriffith$elm_ui$Element$Border$color(palette.aP),
            $mdgriffith$elm_ui$Element$Font$color(palette.aR),
            $mdgriffith$elm_ui$Element$inFront(cancelButton),
            $mdgriffith$elm_ui$Element$inFront(fileIcon)
        ]), $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$alignBottom,
            $mdgriffith$elm_ui$Element$moveUp(4),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$spacing(6)
        ]), _List_fromArray([fileNameElement, loadingBar])));
    }, $author$project$Page$Note$viewPendingUpload = F3($author$project$Page$Note$viewPendingUpload_fn);
    var $mdgriffith$elm_ui$Internal$Model$Padding_fn = function (a, b, c, d, e) {
        return { $: 0, a: a, b: b, c: c, d: d, e: e };
    }, $mdgriffith$elm_ui$Internal$Model$Padding = F5($mdgriffith$elm_ui$Internal$Model$Padding_fn);
    var $mdgriffith$elm_ui$Internal$Model$Spaced_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $mdgriffith$elm_ui$Internal$Model$Spaced = F3($mdgriffith$elm_ui$Internal$Model$Spaced_fn);
    var $mdgriffith$elm_ui$Internal$Model$extractSpacingAndPadding = function (attrs) {
        return $elm$core$List$foldr_fn(F2(function (attr, _v0) {
            var pad = _v0.a;
            var spacing = _v0.b;
            return _Utils_Tuple2(function () {
                if (!pad.$) {
                    var x = pad.a;
                    return pad;
                }
                else {
                    if ((attr.$ === 4) && (attr.b.$ === 7)) {
                        var _v3 = attr.b;
                        var name = _v3.a;
                        var t = _v3.b;
                        var r = _v3.c;
                        var b = _v3.d;
                        var l = _v3.e;
                        return $elm$core$Maybe$Just($mdgriffith$elm_ui$Internal$Model$Padding_fn(name, t, r, b, l));
                    }
                    else {
                        return $elm$core$Maybe$Nothing;
                    }
                }
            }(), function () {
                if (!spacing.$) {
                    var x = spacing.a;
                    return spacing;
                }
                else {
                    if ((attr.$ === 4) && (attr.b.$ === 5)) {
                        var _v6 = attr.b;
                        var name = _v6.a;
                        var x = _v6.b;
                        var y = _v6.c;
                        return $elm$core$Maybe$Just($mdgriffith$elm_ui$Internal$Model$Spaced_fn(name, x, y));
                    }
                    else {
                        return $elm$core$Maybe$Nothing;
                    }
                }
            }());
        }), _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing), attrs);
    };
    var $mdgriffith$elm_ui$Element$wrappedRow_fn = function (attrs, children) {
        var _v0 = $mdgriffith$elm_ui$Internal$Model$extractSpacingAndPadding(attrs);
        var padded = _v0.a;
        var spaced = _v0.b;
        if (spaced.$ === 1) {
            return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asRow, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cL + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.aD + (" " + $mdgriffith$elm_ui$Internal$Style$classes.gv)))), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), attrs))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
        }
        else {
            var _v2 = spaced.a;
            var spaceName = _v2.a;
            var x = _v2.b;
            var y = _v2.c;
            var newPadding = function () {
                if (!padded.$) {
                    var _v5 = padded.a;
                    var name = _v5.a;
                    var t = _v5.b;
                    var r = _v5.c;
                    var b = _v5.d;
                    var l = _v5.e;
                    if ((_Utils_cmp(r, x / 2) > -1) && (_Utils_cmp(b, y / 2) > -1)) {
                        var newTop = t - (y / 2);
                        var newRight = r - (x / 2);
                        var newLeft = l - (x / 2);
                        var newBottom = b - (y / 2);
                        return $elm$core$Maybe$Just($mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$padding, $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn($mdgriffith$elm_ui$Internal$Model$paddingNameFloat_fn(newTop, newRight, newBottom, newLeft), newTop, newRight, newBottom, newLeft)));
                    }
                    else {
                        return $elm$core$Maybe$Nothing;
                    }
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }();
            if (!newPadding.$) {
                var pad = newPadding.a;
                return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asRow, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cL + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.aD + (" " + $mdgriffith$elm_ui$Internal$Style$classes.gv)))), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), _Utils_ap(attrs, _List_fromArray([pad]))))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
            }
            else {
                var halfY = -(y / 2);
                var halfX = -(x / 2);
                return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, attrs, $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asRow, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cL + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.aD + (" " + $mdgriffith$elm_ui$Internal$Style$classes.gv)))), _List_Cons($mdgriffith$elm_ui$Internal$Model$Attr(_VirtualDom_style_fn("margin", $elm$core$String$fromFloat(halfY) + ("px" + (" " + ($elm$core$String$fromFloat(halfX) + "px"))))), _List_Cons($mdgriffith$elm_ui$Internal$Model$Attr(_VirtualDom_style_fn("width", "calc(100% + " + ($elm$core$String$fromInt(x) + "px)"))), _List_Cons($mdgriffith$elm_ui$Internal$Model$Attr(_VirtualDom_style_fn("height", "calc(100% + " + ($elm$core$String$fromInt(y) + "px)"))), _List_Cons($mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$spacing, $mdgriffith$elm_ui$Internal$Model$SpacingStyle_fn(spaceName, x, y)), _List_Nil))))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(children))
                ])));
            }
        }
    }, $mdgriffith$elm_ui$Element$wrappedRow = F2($mdgriffith$elm_ui$Element$wrappedRow_fn);
    var $author$project$Page$Note$viewAttachments_fn = function (env, model, noteId, note) {
        var pendingUploads = $elm$core$List$filter_fn(function (_v0) {
            var upload = _v0.b;
            return !upload.cf;
        }, $elm$core$Dict$toList($author$project$Data$StorageUpload$uploads_fn(noteId, env.oV)));
        var nonDeletedAttachments = $elm$core$List$filter_fn(function (attachment) {
            return (!attachment.lh) && (!attachment.cf);
        }, note.kd);
        var emptyStateFilePicker = A3($author$project$Page$Note$withFilePicker, env.nI, noteId, $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(env.nI.a6),
            $mdgriffith$elm_ui$Element$Font$size(14),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(env.nI.a8)
            ])),
            $mdgriffith$elm_ui$Element$pointer,
            $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$transparent),
            $author$project$View$Util$buttonRole,
            $author$project$View$Styling$focusable,
            $author$project$View$Util$tabIndex($elm$core$Maybe$Just(0)),
            $mdgriffith$elm_ui$Element$padding(10),
            $mdgriffith$elm_ui$Element$spacing(10)
        ]), _List_fromArray([
            $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(16)
            ]), 2, "plus"),
            $mdgriffith$elm_ui$Element$text("Add a file")
        ])));
        return ($elm$core$List$isEmpty(nonDeletedAttachments) && $elm$core$List$isEmpty(pendingUploads)) ? $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(10),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$minimum_fn(250, $mdgriffith$elm_ui$Element$shrink))
        ]), _List_fromArray([
            $author$project$Page$Note$emptyState_fn(env.nI, {
                dR: "Drag & drop attachments here.",
                d3: "Attachments",
                eN: _List_fromArray([emptyStateFilePicker])
            })
        ])) : $mdgriffith$elm_ui$Element$wrappedRow_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacingXY_fn(20, 35)
        ]), _Utils_ap($elm$core$List$reverse($elm$core$List$map_fn(A2($author$project$Page$Note$viewAttachment, model, env.nI), nonDeletedAttachments)), _Utils_ap($elm$core$List$map_fn(A2($author$project$Page$Note$viewPendingUpload, env.nI, noteId), pendingUploads), _List_fromArray([
            $author$project$Page$Note$attachFileButton_fn(env.nI, noteId)
        ]))));
    }, $author$project$Page$Note$viewAttachments = F4($author$project$Page$Note$viewAttachments_fn);
    var $author$project$Data$Person$FrontendCalendarPerson = { $: 1 };
    var $author$project$Analytics$NoteAddPersonFormOpened = { $: 17 };
    var $author$project$Analytics$NoteAttendeeStatusOverridden = { $: 32 };
    var $author$project$Analytics$NotePersonRemoved = { $: 19 };
    var $author$project$Page$Note$OverrideAttendeeAttendance_fn = function (a, b, c) {
        return { $: 10, a: a, b: b, c: c };
    }, $author$project$Page$Note$OverrideAttendeeAttendance = F3($author$project$Page$Note$OverrideAttendeeAttendance_fn);
    var $author$project$Page$Note$RemoveNoteAttendee_fn = function (a, b) {
        return { $: 9, a: a, b: b };
    }, $author$project$Page$Note$RemoveNoteAttendee = F2($author$project$Page$Note$RemoveNoteAttendee_fn);
    var $author$project$Page$Note$ShowNoteAddAttendee = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Data$Note$attendeeResponseStatus = function (a) {
        return $elm$core$Maybe$withDefault_fn(0, $elm_community$maybe_extra$Maybe$Extra$orElse_fn(a.kC, a.nH));
    };
    var $elm_community$string_extra$String$Extra$ellipsisWith_fn = function (howLong, append, string) {
        return (_Utils_cmp($elm$core$String$length(string), howLong) < 1) ? string : _Utils_ap($elm$core$String$left_fn(howLong - $elm$core$String$length(append), string), append);
    }, $elm_community$string_extra$String$Extra$ellipsisWith = F3($elm_community$string_extra$String$Extra$ellipsisWith_fn);
    var $elm_community$string_extra$String$Extra$ellipsis_fn = function (howLong, string) {
        return $elm_community$string_extra$String$Extra$ellipsisWith_fn(howLong, "...", string);
    }, $elm_community$string_extra$String$Extra$ellipsis = F2($elm_community$string_extra$String$Extra$ellipsis_fn);
    var $author$project$View$Widgets$faviconChip = function (palette) {
        return A2($author$project$View$Widgets$favicon, 35, _List_fromArray([
            $author$project$View$Styling$ripple,
            $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$rgb255_fn(200, 200, 200))
            ])),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$rgb255_fn(200, 200, 200))
            ])),
            $mdgriffith$elm_ui$Element$Background$color(palette.aN),
            $mdgriffith$elm_ui$Element$Border$color(palette.aR),
            $mdgriffith$elm_ui$Element$Border$width(1)
        ]));
    };
    var $author$project$Page$Note$AddNoteAttendee_fn = function (a, b) {
        return { $: 7, a: a, b: b };
    }, $author$project$Page$Note$AddNoteAttendee = F2($author$project$Page$Note$AddNoteAttendee_fn);
    var $author$project$Page$Note$CreatePersonOnNote_fn = function (a, b) {
        return { $: 8, a: a, b: b };
    }, $author$project$Page$Note$CreatePersonOnNote = F2($author$project$Page$Note$CreatePersonOnNote_fn);
    var $author$project$Page$Note$NewNoteAttendee = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Analytics$NotePersonAdded = { $: 18 };
    var $author$project$View$Util$disableAutocomplete = $author$project$View$Util$attribute_fn("autocomplete", "off");
    var $author$project$Util$Text$hasText_fn = function (lookingFor, within) {
        return _String_contains_fn($elm$core$String$toLower(lookingFor), $elm$core$String$toLower(within));
    }, $author$project$Util$Text$hasText = F2($author$project$Util$Text$hasText_fn);
    var $author$project$View$Widgets$floatingLabelHelper_fn = function (palette, str) {
        return $mdgriffith$elm_ui$Element$inFront($mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Background$color(palette.dw),
            $mdgriffith$elm_ui$Element$moveUp(6),
            $mdgriffith$elm_ui$Element$Font$size(12),
            $mdgriffith$elm_ui$Element$moveRight(7),
            $mdgriffith$elm_ui$Element$paddingEach((new $$Record115(0, 6, 5, 0))),
            $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "no-select")
        ]), $mdgriffith$elm_ui$Element$text(str)));
    }, $author$project$View$Widgets$floatingLabelHelper = F2($author$project$View$Widgets$floatingLabelHelper_fn);
    var $author$project$View$Widgets$focusedBorderHelper = function (palette) {
        return $mdgriffith$elm_ui$Element$focused(_List_fromArray([
            $mdgriffith$elm_ui$Element$Border$shadow({
                kp: 1,
                kS: palette.a4,
                nt: _Utils_Tuple2(0, 0),
                oE: 1
            }),
            $mdgriffith$elm_ui$Element$Font$color(palette.cd)
        ]));
    };
    var $author$project$View$Widgets$focusedLabelHelper = function (palette) {
        return $mdgriffith$elm_ui$Element$focused(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(palette.a9)
        ]));
    };
    var $author$project$View$Widgets$textField_fn = function (_v0, palette) {
        var onChange = _v0.nu;
        var noOp = _v0.nf;
        var text = _v0.jn;
        var placeholder = _v0.fV;
        var label = _v0.fF;
        var floatingLabel = _v0.lJ;
        var extraAttrs = _v0.hp;
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $elm_community$maybe_extra$Maybe$Extra$unwrap_fn($mdgriffith$elm_ui$Element$inFront($mdgriffith$elm_ui$Element$none), $author$project$View$Widgets$floatingLabelHelper(palette), floatingLabel),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $author$project$View$Widgets$focusedLabelHelper(palette)
        ]), $mdgriffith$elm_ui$Element$Input$textHelper_fn($mdgriffith$elm_ui$Element$Input$text_a0, _Utils_ap(_List_fromArray([
            $author$project$View$Widgets$focusedBorderHelper(palette),
            $author$project$View$Util$preventKeypressPropagation(noOp)
        ]), extraAttrs), { fF: label, nu: onChange, fV: placeholder, jn: text }));
    }, $author$project$View$Widgets$textField = F2($author$project$View$Widgets$textField_fn);
    var $author$project$Page$Note$viewAddPerson_fn = function (model, env, noteId, note) {
        var addAttendeeRow = function (_v2) {
            var personId = _v2.a;
            var person = _v2.b;
            var attendee = (new $$Record31($elm$core$Maybe$Nothing, true, person.b, $elm$core$Maybe$Nothing, $author$project$Data$Note$PersonRef(personId)));
            var addPersonMsg = $author$project$Page$Note$ManyMsgs(_List_fromArray([
                $author$project$Page$Note$AddNoteAttendee_fn(noteId, attendee),
                $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NotePersonAdded)
            ]));
            return $mdgriffith$elm_ui$Element$Input$button_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), {
                fF: $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(5),
                    $mdgriffith$elm_ui$Element$padding(10),
                    $mdgriffith$elm_ui$Element$Font$regular,
                    $mdgriffith$elm_ui$Element$Font$size(14),
                    $mdgriffith$elm_ui$Element$Font$letterSpacing(0.6),
                    $author$project$View$Styling$ripple,
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Background$color(env.nI.a3)
                    ])),
                    $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Background$color(env.nI.a3)
                    ])),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$Border$rounded(3),
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.aT)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(15)
                    ]), $mdgriffith$elm_ui$Element$text(person.b)),
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(13),
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aR)
                    ]), $mdgriffith$elm_ui$Element$text($elm$core$Maybe$withDefault_fn("(no email)", $elm$core$List$head(person.lo))))
                ])),
                nz: $elm$core$Maybe$Just(addPersonMsg)
            });
        };
        var viewPeopleSuggestions = function () {
            var searchQuery = $elm$core$String$replace_fn("@", "", model.ar);
            var attendeeEmails = $elm$core$Set$fromList($elm$core$List$concatMap_fn(function (attendee) {
                var _v1 = attendee.n3;
                if (_v1.$ === 1) {
                    var email = _v1.a;
                    return _List_fromArray([email]);
                }
                else {
                    var personId = _v1.a;
                    return $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, function ($) {
                        return $.lo;
                    }), $author$project$Data$Person$resolvePerson_fn(personId, env.iz)));
                }
            }, note.ke));
            var isMatch = F2(function (_v0, person) {
                var personEmailNotAlreadyPresent = $elm$core$Set$isEmpty($elm$core$Set$intersect_fn(attendeeEmails, $elm$core$Set$fromList(person.lo)));
                return (!person.lh) && (personEmailNotAlreadyPresent && ($author$project$Util$Text$hasText_fn(searchQuery, person.b) || $elm$core$List$any_fn($author$project$Util$Text$hasText(searchQuery), person.lo)));
            });
            var matchRows = $elm$core$List$map_fn(addAttendeeRow, _List_sortBy_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, function ($) {
                return $.b;
            }), A2($author$project$Firestore$Collection$filter, isMatch, env.iz)));
            var addNewPersonRow = $author$project$View$Widgets$button_fn({
                hp: _List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$Border$width(0),
                    $mdgriffith$elm_ui$Element$Border$rounded(0),
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.a7),
                    $mdgriffith$elm_ui$Element$paddingXY_fn(10, 12)
                ]),
                l7: $elm$core$Maybe$Just(_Utils_Tuple3(1, "plus", _List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(14)
                ]))),
                fQ: $elm$core$Maybe$Just($author$project$Page$Note$CreatePersonOnNote_fn(noteId, searchQuery))
            }, "Create a new person \"" + (searchQuery + "\""));
            return $author$project$View$Util$when_fn($elm$core$String$length(model.ar) > 0, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(325)),
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$Background$color(env.nI.dw),
                $mdgriffith$elm_ui$Element$Border$color(env.nI.aN),
                $mdgriffith$elm_ui$Element$Border$widthEach((new $$Record115(1, 1, 1, 0))),
                $mdgriffith$elm_ui$Element$Border$roundEach({ kx: 4, ky: 4, pF: 0, pG: 0 }),
                $mdgriffith$elm_ui$Element$Border$shadow({
                    kp: 3,
                    kS: $author$project$Data$Color$grayAlphaDark,
                    nt: _Utils_Tuple2(0, 3),
                    oE: 2
                }),
                $mdgriffith$elm_ui$Element$padding(5)
            ]), _Utils_ap(matchRows, _List_fromArray([addNewPersonRow]))));
        }();
        return $author$project$View$Util$when_fn(model.bE, $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(330)),
            $mdgriffith$elm_ui$Element$below(viewPeopleSuggestions)
        ]), $author$project$View$Widgets$textField_fn({
            hp: _List_fromArray([
                $elm$core$Basics$composeL_fn($author$project$View$Util$id_a0, $author$project$View$Util$id_a1, "witful-note-add-attendee"),
                $mdgriffith$elm_ui$Element$Background$color(env.nI.dw),
                $author$project$View$Util$disableAutocomplete
            ]),
            lJ: $elm$core$Maybe$Nothing,
            fF: $mdgriffith$elm_ui$Element$Input$labelHidden("Add new person text input"),
            nf: $author$project$Page$Note$NoOp,
            nu: $author$project$Page$Note$NewNoteAttendee,
            fV: $elm$core$Maybe$Nothing,
            jn: model.ar
        }, env.nI)));
    }, $author$project$Page$Note$viewAddPerson = F4($author$project$Page$Note$viewAddPerson_fn);
    var $author$project$Page$Note$viewAttendees_fn = function (model, env, domainBuckets, noteId, note) {
        var viewManualAddButton = (!model.bE) ? $author$project$View$Widgets$button_fn({
            hp: _List_fromArray([
                $mdgriffith$elm_ui$Element$Border$width(0),
                $mdgriffith$elm_ui$Element$Font$color(env.nI.a6)
            ]),
            l7: $elm$core$Maybe$Just(_Utils_Tuple3(2, "plus", _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(16)
            ]))),
            fQ: $elm$core$Maybe$Just($author$project$Page$Note$ManyMsgs(_List_fromArray([
                $author$project$Page$Note$ShowNoteAddAttendee(true),
                $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NoteAddPersonFormOpened)
            ])))
        }, "Add Attendee") : $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
            kb: "Close new attendee field",
            hp: _List_fromArray([
                $mdgriffith$elm_ui$Element$moveLeft(3),
                $mdgriffith$elm_ui$Element$Font$color(env.nI.aQ),
                $mdgriffith$elm_ui$Element$Font$size(80)
            ]),
            fQ: $elm$core$Maybe$Just($author$project$Page$Note$ShowNoteAddAttendee(false))
        }, 2, "times");
        var viewAttendee = function (_v11) {
            var noteAttendee = _v11.a;
            var resolvedRef = _v11.b;
            var toggleAttendanceMsg = $author$project$Page$Note$OverrideAttendeeAttendance_fn(noteId, noteAttendee, function () {
                var _v10 = $author$project$Data$Note$attendeeResponseStatus(noteAttendee);
                if (_v10 === 1) {
                    return 0;
                }
                else {
                    return 1;
                }
            }());
            var _v3 = function () {
                var _v5 = $author$project$Data$Note$attendeeResponseStatus(noteAttendee);
                if (_v5 === 1) {
                    return _Utils_Tuple3(_Utils_Tuple2(2, env.nI.aR), env.nI.aR, "Mark present");
                }
                else {
                    return _Utils_Tuple3(_Utils_Tuple2(3, env.nI.aS), env.nI.aU, "Mark absent");
                }
            }();
            var _v4 = _v3.a;
            var iconStyle = _v4.a;
            var iconColor = _v4.b;
            var fontColor = _v3.b;
            var tooltipText = _v3.c;
            var tooltipContent = $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$padding(8),
                $mdgriffith$elm_ui$Element$spacing(8),
                $mdgriffith$elm_ui$Element$Font$size(15)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$text(tooltipText),
                $author$project$View$Util$whenJust_fn(noteAttendee.kC, function (status) {
                    return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aP),
                        $mdgriffith$elm_ui$Element$spacing(5),
                        $mdgriffith$elm_ui$Element$centerX
                    ]), _List_fromArray([
                        $author$project$View$Icon$icon_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$size(16)
                        ]), 2, "calendar-alt"),
                        $mdgriffith$elm_ui$Element$text(function () {
                            switch (status) {
                                case 0:
                                    return "Invite accepted";
                                case 1:
                                    return "Invite declined";
                                case 2:
                                    return "Tentatively accepted";
                                default:
                                    return "Invite - no response";
                            }
                        }())
                    ]));
                })
            ]));
            var _v6 = function () {
                if (!resolvedRef.$) {
                    var _v8 = resolvedRef.a;
                    var personId = _v8.a;
                    var person = _v8.b;
                    return _Utils_Tuple2(person.b, $author$project$Routing$pathFromRoute($author$project$Routing$RoutePerson(personId)));
                }
                else {
                    var email = resolvedRef.a;
                    return _Utils_Tuple2($author$project$Util$Text$nameFromEmail(email), $author$project$Routing$pathFromRoute($author$project$Routing$RouteCreatePerson((new $$Record39($author$project$Data$Person$FrontendCalendarPerson, $elm$core$Maybe$Just(email), $author$project$Util$Text$nameFromEmail(email))))));
                }
            }();
            var name = _v6.a;
            var actionUrl = _v6.b;
            return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
                $mdgriffith$elm_ui$Element$paddingXY_fn(3, 0)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$spaceEvenly
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$spacing(18),
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                        $author$project$View$Util$attrWhen_fn(noteAttendee.mR, $mdgriffith$elm_ui$Element$onRight($author$project$View$Icon$buttonWithSize_fn(15, {
                            kb: "Remove " + noteAttendee.b,
                            hp: _List_fromArray([
                                $mdgriffith$elm_ui$Element$paddingXY_fn(0, 0),
                                $mdgriffith$elm_ui$Element$alignRight,
                                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(25)),
                                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(25)),
                                $mdgriffith$elm_ui$Element$centerY,
                                $mdgriffith$elm_ui$Element$moveUp(6),
                                $mdgriffith$elm_ui$Element$Font$color(env.nI.aQ)
                            ]),
                            fQ: $elm$core$Maybe$Just($author$project$Page$Note$ManyMsgs(_List_fromArray([
                                $author$project$Page$Note$RemoveNoteAttendee_fn(noteId, noteAttendee),
                                $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NotePersonRemoved)
                            ])))
                        }, 2, "times")))
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$el_fn(_List_Nil, A4($author$project$View$Tooltip$custom, env.nI, 50, tooltipContent, $author$project$View$Icon$icon_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$size(16),
                            $mdgriffith$elm_ui$Element$Font$color(iconColor),
                            $mdgriffith$elm_ui$Element$pointer,
                            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Font$color(env.nI.aU)
                            ])),
                            $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Font$color(env.nI.aU)
                            ])),
                            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Note$ManyMsgs(_List_fromArray([
                                toggleAttendanceMsg,
                                $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NoteAttendeeStatusOverridden)
                            ]))),
                            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink)
                        ]), iconStyle, "user-circle"))),
                        $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$pointer,
                            $mdgriffith$elm_ui$Element$Font$color(fontColor),
                            $mdgriffith$elm_ui$Element$Font$size(15),
                            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Font$color(env.nI.a6)
                            ])),
                            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                        ]), {
                            fF: $mdgriffith$elm_ui$Element$text($elm_community$string_extra$String$Extra$ellipsis_fn(20, name)),
                            dt: actionUrl
                        })
                    ]))
                ]))
            ]));
        };
        var viewDomainBucket = F2(function (mDomain, attendees) {
            var domainLabel = function () {
                if (!mDomain.$) {
                    var domain = mDomain.a;
                    return $mdgriffith$elm_ui$Element$link_fn(_List_Nil, {
                        fF: $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$spacing(10),
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.aU)
                        ]), _List_fromArray([
                            A4($author$project$View$Tooltip$basic, env.nI, 0, "Notes with " + domain, A2($author$project$View$Widgets$faviconChip, env.nI, domain)),
                            $mdgriffith$elm_ui$Element$text($elm$core$String$toUpper(domain))
                        ])),
                        dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteCollate($author$project$Routing$CollateByDomain({ g9: domain }))($elm$core$Maybe$Nothing))
                    });
                }
                else {
                    return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$spacing(10),
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aU)
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(32)),
                            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(32)),
                            $mdgriffith$elm_ui$Element$Background$color(env.nI.aN),
                            $mdgriffith$elm_ui$Element$Border$rounded(100),
                            $mdgriffith$elm_ui$Element$Border$color(env.nI.aR),
                            $mdgriffith$elm_ui$Element$Border$width(1)
                        ]), $author$project$View$Icon$icon_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$size(18),
                            $mdgriffith$elm_ui$Element$centerX,
                            $mdgriffith$elm_ui$Element$centerY
                        ]), 1, "rocket")),
                        $mdgriffith$elm_ui$Element$text("NO DOMAIN")
                    ]));
                }
            }();
            return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(5)
            ]), _List_fromArray([
                domainLabel,
                $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(12),
                    $mdgriffith$elm_ui$Element$paddingXY_fn(6, 10),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), $elm$core$List$map_fn($mdgriffith$elm_ui$Element$el(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ])), $elm$core$List$map_fn(viewAttendee, attendees)))
            ]));
        });
        var addPersonsButtonSection = $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$centerX
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(env.nI.aR)
            ]), viewManualAddButton),
            $author$project$Page$Note$viewAddPerson_fn(model, env, noteId, note)
        ]));
        var _v0 = domainBuckets;
        var withDomains = _v0.a;
        var withoutDomains = _v0.b;
        var noAttendees = $elm$core$Dict$isEmpty(withDomains) && $elm$core$List$isEmpty(withoutDomains);
        var viewAttendeeList = noAttendees ? $author$project$Page$Note$emptyState_fn(env.nI, {
            dR: "This event does not include any attendees. People will display here when they are invited to the calendar event.",
            d3: "Attendees",
            eN: _List_fromArray([addPersonsButtonSection])
        }) : $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing($author$project$View$Layout$minorPaneStandardSpacing - 10),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), _Utils_ap($elm$core$List$map_fn(function (_v1) {
            var domain = _v1.a;
            var attendeeLines = _v1.b;
            return A2(viewDomainBucket, $elm$core$Maybe$Just(domain), attendeeLines);
        }, _List_sortBy_fn($elm$core$Tuple$first, $elm$core$Dict$toList(withDomains))), $elm$core$List$isEmpty(withoutDomains) ? _List_Nil : _List_fromArray([
            A2(viewDomainBucket, $elm$core$Maybe$Nothing, withoutDomains)
        ])));
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(10),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$minimum_fn(300, $mdgriffith$elm_ui$Element$shrink))
        ]), _List_fromArray([
            viewAttendeeList,
            $author$project$View$Util$when_fn(!noAttendees, addPersonsButtonSection)
        ]));
    }, $author$project$Page$Note$viewAttendees = F5($author$project$Page$Note$viewAttendees_fn);
    var $author$project$Page$Note$viewSeriesLink_fn = function (env, noteId, note) {
        var _v0 = note.hh;
        if ((!_v0.$) && (_v0.a.$ === 1)) {
            var masterId = _v0.a.a.mT;
            var relevantNotes = $author$project$Page$Note$otherNotesInSeries_fn(env, noteId, note);
            var seriesCount = $elm$core$List$length(relevantNotes);
            return $author$project$View$Util$when_fn(seriesCount > 0, $author$project$View$Widgets$linkButtonHelp_fn($author$project$View$Widgets$linkButton_a0, {
                hp: _List_fromArray([
                    $mdgriffith$elm_ui$Element$alignLeft,
                    $mdgriffith$elm_ui$Element$Border$width(0),
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.a7),
                    $mdgriffith$elm_ui$Element$Font$size(15),
                    $mdgriffith$elm_ui$Element$paddingXY_fn(5, 10),
                    $mdgriffith$elm_ui$Element$moveLeft(3)
                ]),
                l7: $elm$core$Maybe$Just(_Utils_Tuple3(1, "long-arrow-right", _List_Nil)),
                dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteCollate_fn($author$project$Routing$CollateSeries({
                    h8: $author$project$Data$Event$baseId(masterId)
                }), $elm$core$Maybe$Nothing))
            }, $elm$core$String$fromInt(seriesCount) + (" other note" + ($author$project$Util$Misc$if__fn(seriesCount > 1, "s", "") + " in this series"))));
        }
        else {
            return $mdgriffith$elm_ui$Element$none;
        }
    }, $author$project$Page$Note$viewSeriesLink = F3($author$project$Page$Note$viewSeriesLink_fn);
    var $author$project$Page$Note$viewSeries_fn = function (env, noteId, note) {
        var relevantNotes = $author$project$Page$Note$otherNotesInSeries_fn(env, noteId, note);
        var emptyStateCopy = function () {
            var _v0 = note.hh;
            if ((!_v0.$) && (_v0.a.$ === 1)) {
                return "There aren't other notes in this series yet.";
            }
            else {
                return "This note is not part of a series.";
            }
        }();
        return $elm$core$List$isEmpty(relevantNotes) ? $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(10),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$minimum_fn(250, $mdgriffith$elm_ui$Element$shrink))
        ]), $author$project$Page$Note$emptyState_fn(env.nI, { dR: emptyStateCopy, d3: "Note Series", eN: _List_Nil })) : $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(15)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(30),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$maximum_fn($elm$core$Basics$floor(env.p1.p1.fo - 300), $mdgriffith$elm_ui$Element$minimum_fn(400, $mdgriffith$elm_ui$Element$fill)))
            ]), $elm$core$List$map_fn(A2($elm$core$Basics$composeR, $author$project$View$Collate$viewCollatedNote(env), $mdgriffith$elm_ui$Element$el(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(14),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
            ]))), $elm$core$List$take_fn(3, relevantNotes))),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $author$project$Page$Note$viewSeriesLink_fn(env, noteId, note))
        ]));
    }, $author$project$Page$Note$viewSeries = F3($author$project$Page$Note$viewSeries_fn);
    var $author$project$Page$Note$sidePanel_fn = function (env, user, model, noteId, _v0, note) {
        var otherNotes = $author$project$Page$Note$otherNotesInSeries_fn(env, noteId, note);
        var seriesCount = function () {
            var _v4 = note.hh;
            if ((!_v4.$) && (_v4.a.$ === 1)) {
                return $elm$core$Maybe$Just($elm$core$List$length(otherNotes));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }();
        var domainBuckets = $author$project$Data$AttendeeList$generateAttendeeList_fn(env.iz, user.cS, note.ke);
        var attendeeCount = function () {
            var _v3 = domainBuckets;
            var withDomains = _v3.a;
            var withoutDomains = _v3.b;
            return $elm$core$List$length(withoutDomains) + $elm$core$List$sum($elm$core$List$map_fn($elm$core$List$length, $elm$core$Dict$values(withDomains)));
        }();
        var attachmentsCount = $elm$core$List$length($elm$core$List$filter_fn(function (attachment) {
            return (!attachment.lh) && (!attachment.cf);
        }, note.kd));
        var _v1 = model.bS;
        var incoming = _v1.cX;
        var currentNotesTopics = _v1.dT;
        var currentNotesActionItems = _v1.dS;
        var sidePanelBody = function () {
            var _v2 = model.b1;
            switch (_v2) {
                case 0:
                    return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                        $mdgriffith$elm_ui$Element$spacing($author$project$View$Layout$minorPaneStandardSpacing)
                    ]), _List_fromArray([
                        $author$project$Page$Note$viewActionItems_fn(env, noteId, note, 0, _Utils_ap(incoming, currentNotesTopics)),
                        $author$project$Page$Note$viewActionItems_fn(env, noteId, note, 1, currentNotesActionItems)
                    ]));
                case 1:
                    return $author$project$Page$Note$viewAttendees_fn(model, env, domainBuckets, noteId, note);
                case 2:
                    return $author$project$Page$Note$viewAttachments_fn(env, model, noteId, note);
                default:
                    return $author$project$Page$Note$viewSeries_fn(env, noteId, note);
            }
        }();
        var workflowCount = $elm$core$List$sum($elm$core$List$map_fn($elm$core$List$length, _List_fromArray([incoming, currentNotesActionItems, currentNotesTopics])));
        return _List_fromArray([
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$inFront($author$project$View$Util$when_fn(model.cE, $author$project$Page$Note$dragAndDropIndicator(env.nI))),
                $mdgriffith$elm_ui$Element$spacing(20),
                $mdgriffith$elm_ui$Element$paddingXY_fn(0, 20),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), _List_fromArray([
                $author$project$Page$Note$sidePanelTabs_fn(env.oe, env.nI, env.p1.p1.jJ, model, (new $$Record144(attachmentsCount, attendeeCount, seriesCount, workflowCount))),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$paddingXY_fn(0, 30)
                ]), sidePanelBody)
            ]))
        ]);
    }, $author$project$Page$Note$sidePanel = F6($author$project$Page$Note$sidePanel_fn);
    var $author$project$Page$Note$view__fn = function (env, user, model, noteId, state, note) {
        return $author$project$View$Layout$twoPanel_fn(env, {
            mP: $author$project$Page$Note$noteEditor_fn(env, user, model, noteId, state, note),
            m4: $author$project$Page$Note$sidePanel_fn(env, user, model, noteId, state, note)
        });
    }, $author$project$Page$Note$view_ = F6($author$project$Page$Note$view__fn);
    var $author$project$Analytics$NoteAttachmentDropped = { $: 23 };
    var $elm$json$Json$Decode$oneOrMoreHelp_fn = function (toValue, xs) {
        if (!xs.b) {
            return $elm$json$Json$Decode$fail("a ARRAY with at least ONE element");
        }
        else {
            var y = xs.a;
            var ys = xs.b;
            return $elm$json$Json$Decode$succeed(A2(toValue, y, ys));
        }
    }, $elm$json$Json$Decode$oneOrMoreHelp_fn_unwrapped = function (toValue, xs) {
        if (!xs.b) {
            return $elm$json$Json$Decode$fail("a ARRAY with at least ONE element");
        }
        else {
            var y = xs.a;
            var ys = xs.b;
            return $elm$json$Json$Decode$succeed(toValue(y, ys));
        }
    }, $elm$json$Json$Decode$oneOrMoreHelp = F2($elm$json$Json$Decode$oneOrMoreHelp_fn);
    var $elm$json$Json$Decode$oneOrMore_fn = function (toValue, decoder) {
        return _Json_andThen_fn($elm$json$Json$Decode$oneOrMoreHelp(toValue), $elm$json$Json$Decode$list(decoder));
    }, $elm$json$Json$Decode$oneOrMore = F2($elm$json$Json$Decode$oneOrMore_fn);
    var $author$project$View$Util$preventDefaultOn_fn = function (eventName, msg) {
        return $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$preventDefaultOn_fn(eventName, $elm$json$Json$Decode$succeed(_Utils_Tuple2(msg, true))));
    }, $author$project$View$Util$preventDefaultOn = F2($author$project$View$Util$preventDefaultOn_fn);
    var $author$project$Page$Note$withDragAndDrop = function (noteId) {
        var dropDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$at_fn(_List_fromArray(["dataTransfer", "files"]), $elm$json$Json$Decode$oneOrMore_fn(F2(function (file, files) {
                return _Utils_Tuple2($author$project$Page$Note$ManyMsgs(_List_fromArray([
                    $author$project$Page$Note$AttachFiles_fn(noteId, file, files),
                    $author$project$Page$Note$AnalyticsEvent($author$project$Analytics$NoteAttachmentDropped)
                ])), true);
            }), $mpizenberg$elm_file$FileValue$decoder)),
            $elm$json$Json$Decode$succeed(_Utils_Tuple2($author$project$Page$Note$AttachmentInDropZone(false), false))
        ]));
        return $mdgriffith$elm_ui$Element$el(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $author$project$View$Util$preventDefaultOn_fn("dragenter", $author$project$Page$Note$AttachmentInDropZone(true)),
            $author$project$View$Util$preventDefaultOn_fn("dragleave", $author$project$Page$Note$AttachmentInDropZone(false)),
            $author$project$View$Util$preventDefaultOn_fn("dragover", $author$project$Page$Note$AttachmentInDropZone(true)),
            $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$preventDefaultOn_fn("drop", dropDecoder))
        ]));
    };
    var $author$project$Page$Note$view_fn = function (env, model, noteId, state, note) {
        var viewFunc = $author$project$Util$Misc$if__fn(model.aw, $author$project$Page$Note$viewZenMode, $author$project$Page$Note$view_);
        var _v0 = env.pV;
        if (_v0.$ === 1) {
            return $author$project$View$Widgets$notFound(env.nI);
        }
        else {
            var user = _v0.a;
            return A2($author$project$Page$Note$withDragAndDrop, noteId, A6(viewFunc, env, user, model, noteId, state, note));
        }
    }, $author$project$Page$Note$view = F5($author$project$Page$Note$view_fn);
    var $author$project$Page$Person$deletedPersonView_fn = function (env, deletedPerson) {
        var mergedIntoCard = function (person) {
            return A3($author$project$View$Layout$card, env.nI, _List_fromArray([
                $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Background$color(env.nI.aL)
                ]))
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(15),
                    $mdgriffith$elm_ui$Element$Font$size(26)
                ]), _List_fromArray([
                    $elm$core$Maybe$withDefault_fn($author$project$View$Icon$icon_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(60)
                    ]), 3, "user-circle"), $elm$core$Maybe$map_fn(A2($author$project$View$Widgets$favicon, 60, _List_fromArray([
                        $mdgriffith$elm_ui$Element$Border$shadow({
                            kp: 5,
                            kS: env.nI.aP,
                            nt: _Utils_Tuple2(1, 1),
                            oE: 0.5
                        })
                    ])), $elm$core$Maybe$map_fn($elm_community$string_extra$String$Extra$rightOf("@"), $elm$core$List$head(person.lo)))),
                    $mdgriffith$elm_ui$Element$text(person.b)
                ]))
            ]));
        };
        var mergedInto = $elm$core$Maybe$andThen_fn(function (id) {
            return $author$project$Data$Person$resolvePerson_fn(id, env.iz);
        }, deletedPerson.mZ);
        if (!mergedInto.$) {
            var _v1 = mergedInto.a;
            var personId = _v1.a;
            var person = _v1.b;
            return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$spacing(30),
                $mdgriffith$elm_ui$Element$Font$size(18)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("This person has been merged, and can be found here:")
                ])),
                $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), {
                    fF: mergedIntoCard(person),
                    dt: $author$project$Routing$pathFromRoute($author$project$Routing$RoutePerson(personId))
                })
            ]));
        }
        else {
            return $author$project$View$Widgets$notFound(env.nI);
        }
    }, $author$project$Page$Person$deletedPersonView = F2($author$project$Page$Person$deletedPersonView_fn);
    var $author$project$Page$Person$HandleBacktalk = function (a) {
        return { $: 15, a: a };
    };
    var $author$project$Page$Person$dedupePrompt_fn = function (env, model) {
        var dupesPendingReview = $elm$core$List$length(model.au);
        return $author$project$View$Util$when_fn(dupesPendingReview > 0, $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(env.nI.aR),
            $mdgriffith$elm_ui$Element$Font$size(15),
            $mdgriffith$elm_ui$Element$spacing(8)
        ]), _List_fromArray([
            $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(17)
            ]), 3, "user-friends"),
            $mdgriffith$elm_ui$Element$text(function () {
                if (dupesPendingReview === 1) {
                    return "Duplicate detected (1)";
                }
                else {
                    return "Duplicates detected (" + ($elm$core$String$fromInt(dupesPendingReview) + ")");
                }
            }()),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$alignTop,
                $mdgriffith$elm_ui$Element$moveLeft(7)
            ]), $author$project$View$Widgets$button_fn({
                hp: _List_fromArray([
                    $mdgriffith$elm_ui$Element$Border$width(0),
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.a7),
                    $mdgriffith$elm_ui$Element$padding(10),
                    $mdgriffith$elm_ui$Element$Border$rounded(4),
                    $mdgriffith$elm_ui$Element$centerY,
                    $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Background$color(env.nI.aO),
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.a7)
                    ]))
                ]),
                l7: $elm$core$Maybe$Nothing,
                fQ: $elm$core$Maybe$Just($author$project$Page$Person$SetDialog($elm$core$Maybe$Just($author$project$Page$Person$AllCandidates)))
            }, "Review"))
        ])));
    }, $author$project$Page$Person$dedupePrompt = F2($author$project$Page$Person$dedupePrompt_fn);
    var $author$project$Page$Person$UpdateName_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Page$Person$UpdateName = F2($author$project$Page$Person$UpdateName_fn);
    var $author$project$Page$Person$nameInput_fn = function (palette, personId, person) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$Border$color($author$project$Data$Color$transparent),
            $mdgriffith$elm_ui$Element$Border$width(1),
            $mdgriffith$elm_ui$Element$Border$rounded(10),
            $author$project$View$Util$style_fn("transition", "border 0.15s ease-in-out"),
            $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                $mdgriffith$elm_ui$Element$Border$color(palette.a5)
            ])),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Border$color(palette.aP)
            ]))
        ]), $mdgriffith$elm_ui$Element$Input$textHelper_fn($mdgriffith$elm_ui$Element$Input$text_a0, _List_fromArray([
            $mdgriffith$elm_ui$Element$Border$width(0),
            $author$project$View$Util$preventKeypressPropagation($author$project$Page$Person$NoOp),
            $mdgriffith$elm_ui$Element$Background$color(palette.dw),
            $mdgriffith$elm_ui$Element$Border$rounded(10),
            $mdgriffith$elm_ui$Element$Font$size(20)
        ]), {
            fF: $mdgriffith$elm_ui$Element$Input$labelHidden("Name"),
            nu: $author$project$Page$Person$UpdateName(personId),
            fV: $elm$core$Maybe$Nothing,
            jn: person.b
        }));
    }, $author$project$Page$Person$nameInput = F3($author$project$Page$Person$nameInput_fn);
    var $author$project$Page$Person$responsiveAttrs_a0 = $author$project$View$Layout$breakpoints, $author$project$Page$Person$responsiveAttrs = $author$project$View$Responsive$attrs($author$project$Page$Person$responsiveAttrs_a0);
    var $author$project$Page$Person$RemoveEmailAddress_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $author$project$Page$Person$RemoveEmailAddress = F2($author$project$Page$Person$RemoveEmailAddress_fn);
    var $author$project$Page$Person$viewEmailAddress_fn = function (palette, person, emailToMsg, email) {
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(280, $mdgriffith$elm_ui$Element$fill)),
            $mdgriffith$elm_ui$Element$Font$color($author$project$Data$Color$transparent),
            $mdgriffith$elm_ui$Element$Font$size(14),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.aU)
            ])),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(18))
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.aU)
            ]), $mdgriffith$elm_ui$Element$text(email)),
            $author$project$View$Util$when_fn($elm$core$List$length(person.lo) > 1, $author$project$View$Icon$buttonWithSize_fn(15, {
                kb: "Remove email address",
                hp: _List_fromArray([
                    $mdgriffith$elm_ui$Element$centerY,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(28)),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(28)),
                    $mdgriffith$elm_ui$Element$alignRight,
                    $mdgriffith$elm_ui$Element$moveUp(5)
                ]),
                fQ: $elm$core$Maybe$Just(emailToMsg(email))
            }, 1, "times-circle"))
        ]));
    }, $author$project$Page$Person$viewEmailAddress = F4($author$project$Page$Person$viewEmailAddress_fn);
    var $author$project$Page$Person$viewEmailAddresses_fn = function (palette, personId, person) {
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(6)
        ]), $elm$core$List$map_fn(A3($author$project$Page$Person$viewEmailAddress, palette, person, $author$project$Page$Person$RemoveEmailAddress(personId)), person.lo));
    }, $author$project$Page$Person$viewEmailAddresses = F3($author$project$Page$Person$viewEmailAddresses_fn);
    var $author$project$Page$Person$AddEmailToPerson_fn = function (a, b) {
        return { $: 5, a: a, b: b };
    }, $author$project$Page$Person$AddEmailToPerson = F2($author$project$Page$Person$AddEmailToPerson_fn);
    var $author$project$Page$Person$DeleteConfirm = { $: 3 };
    var $author$project$Page$Person$EnableEmailValidation = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Data$Person$isDeleteable = function (person) {
        return (!person.lh) && _Utils_eq(person.k1, $author$project$Data$Person$FrontendAdhocPerson);
    };
    var $mdgriffith$elm_ui$Element$clipX = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.kM);
    var $mdgriffith$elm_ui$Element$Events$onLoseFocus_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Events$onLoseFocus_a1 = $elm$html$Html$Events$onBlur, $mdgriffith$elm_ui$Element$Events$onLoseFocus = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Events$onLoseFocus_a0, $mdgriffith$elm_ui$Element$Events$onLoseFocus_a1);
    var $author$project$Page$Person$submitOnEnter_fn = function (personId, model) {
        return $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$custom_fn("keyup", _Json_map1_fn(function (msg) {
            return { m_: msg, nU: true, oU: true };
        }, _Json_andThen_fn(function (event) {
            var _v0 = event.mC;
            if (_v0 === "Enter") {
                return $elm$json$Json$Decode$succeed($elm$core$Maybe$withDefault_fn($author$project$Page$Person$EnableEmailValidation(true), $elm$core$Maybe$map_fn($author$project$Page$Person$AddEmailToPerson(personId), $elm$core$Maybe$andThen_fn($author$project$Data$Email$create, model.u))));
            }
            else {
                return $elm$json$Json$Decode$fail("matching keypress not found");
            }
        }, $author$project$Data$Keypress$decoder))));
    }, $author$project$Page$Person$submitOnEnter = F2($author$project$Page$Person$submitOnEnter_fn);
    var $author$project$Page$Person$infoFormTextInput_fn = function (palette, personId, model) {
        return $mdgriffith$elm_ui$Element$Input$textHelper_fn($mdgriffith$elm_ui$Element$Input$text_a0, _List_fromArray([
            $mdgriffith$elm_ui$Element$Border$width(0),
            $author$project$View$Util$preventKeypressPropagation($author$project$Page$Person$NoOp),
            $author$project$Page$Person$submitOnEnter_fn(personId, model),
            $mdgriffith$elm_ui$Element$Border$rounded(5),
            $elm$core$Basics$composeL_fn($author$project$View$Util$id_a0, $author$project$View$Util$id_a1, "info-form-text-input"),
            $mdgriffith$elm_ui$Element$Background$color(palette.dw),
            $mdgriffith$elm_ui$Element$padding(7),
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onLoseFocus_a0, $mdgriffith$elm_ui$Element$Events$onLoseFocus_a1, $author$project$Page$Person$EnableEmailValidation(true))
        ]), {
            fF: $mdgriffith$elm_ui$Element$Input$labelHidden("Input new email address"),
            nu: A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Page$Person$UpdateEmailInput),
            fV: $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$Input$Placeholder_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.aQ)
            ]), $mdgriffith$elm_ui$Element$text("e.g. kermit@muppets.org"))),
            jn: $elm$core$Maybe$withDefault_fn("", model.u)
        });
    }, $author$project$Page$Person$infoFormTextInput = F3($author$project$Page$Person$infoFormTextInput_fn);
    var $author$project$Page$Person$viewInfoFormHelper_fn = function (palette, personId, model) {
        var borderColor = function () {
            var _v0 = model.u;
            if (!_v0.$) {
                var email = _v0.a;
                return $elm_community$maybe_extra$Maybe$Extra$isJust($author$project$Data$Email$create(email)) ? palette.d_ : (((email === "") || (!model.cw)) ? palette.aQ : palette.es);
            }
            else {
                return palette.aM;
            }
        }();
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px($elm_community$maybe_extra$Maybe$Extra$isJust(model.u) ? 300 : 0)),
            $mdgriffith$elm_ui$Element$clipX,
            $author$project$View$Util$attrWhenJust_fn(model.u, $elm$core$Basics$always($mdgriffith$elm_ui$Element$Border$width(1))),
            $mdgriffith$elm_ui$Element$Border$rounded(8),
            $mdgriffith$elm_ui$Element$Border$color(borderColor),
            $mdgriffith$elm_ui$Element$centerY,
            $author$project$View$Util$style_fn("transition", "all 0.2s ease-in-out")
        ]), _List_fromArray([
            $author$project$Page$Person$infoFormTextInput_fn(palette, personId, model)
        ]));
    }, $author$project$Page$Person$viewInfoFormHelper = F3($author$project$Page$Person$viewInfoFormHelper_fn);
    var $author$project$Page$Person$viewInfoForm_fn = function (palette, model, personId, person) {
        var submitIconHelper = F3(function (extraAttrs, _v0, msgHelper) {
            var iconStyle = _v0.a;
            var iconName = _v0.b;
            return $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
                kb: "Submit",
                hp: _List_Cons($author$project$View$Util$style_fn("transition", "transform 0.2s ease-in-out"), extraAttrs),
                fQ: $elm$core$Maybe$Just(msgHelper)
            }, iconStyle, iconName);
        });
        var submitButton = $author$project$View$Util$whenJust_fn(model.u, A2($elm$core$Basics$composeR, $author$project$Data$Email$create, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($author$project$Page$Person$AddEmailToPerson(personId)), A2($elm$core$Basics$composeR, $elm$core$Maybe$map(A2(submitIconHelper, _List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(palette.d0)
        ]), _Utils_Tuple2(1, "check-circle"))), $elm$core$Maybe$withDefault(A3(submitIconHelper, _List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(palette.aR)
        ]), _Utils_Tuple2(1, "check-circle"), $author$project$Page$Person$EnableEmailValidation(true)))))));
        var openCloseButton = $mdgriffith$elm_ui$Element$el_fn(_List_Nil, $author$project$View$Widgets$button_fn({
            hp: _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.aS),
                $mdgriffith$elm_ui$Element$Font$size(12),
                $mdgriffith$elm_ui$Element$padding(10),
                $mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Internal$Model$Rgba_fn(0, 0, 0, 0)),
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(palette.a2)
                ])),
                $author$project$View$Util$attrWhen_fn($elm_community$maybe_extra$Maybe$Extra$isJust(model.u), $mdgriffith$elm_ui$Element$Font$color(palette.aR))
            ]),
            l7: $elm_community$maybe_extra$Maybe$Extra$isJust(model.u) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple3(2, "envelope", _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(14)
            ]))),
            fQ: $elm$core$Maybe$Just($elm_community$maybe_extra$Maybe$Extra$isNothing(model.u) ? $author$project$Page$Person$UpdateEmailInput($elm$core$Maybe$Just("")) : $author$project$Page$Person$UpdateEmailInput($elm$core$Maybe$Nothing))
        }, $elm_community$maybe_extra$Maybe$Extra$isJust(model.u) ? "Cancel" : "Add email"));
        var deleteButton = $author$project$View$Util$when_fn($elm_community$maybe_extra$Maybe$Extra$isNothing(model.u) && $author$project$Data$Person$isDeleteable(person), $mdgriffith$elm_ui$Element$el_fn(_List_Nil, $author$project$View$Widgets$button_fn({
            hp: _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.aR),
                $mdgriffith$elm_ui$Element$padding(10),
                $mdgriffith$elm_ui$Element$Border$rounded(4),
                $mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Internal$Model$Rgba_fn(0, 0, 0, 0)),
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Background$color(palette.aN),
                    $mdgriffith$elm_ui$Element$Font$color(palette.a5)
                ]))
            ]),
            l7: $elm$core$Maybe$Just(_Utils_Tuple3(1, "trash", _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(14)
            ]))),
            fQ: $elm$core$Maybe$Just($author$project$Page$Person$SetDialog($elm$core$Maybe$Just($author$project$Page$Person$DeleteConfirm)))
        }, "Delete this person")));
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(5),
            $mdgriffith$elm_ui$Element$moveLeft(7),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(40)),
            $mdgriffith$elm_ui$Element$moveDown(5)
        ]), _List_fromArray([
            openCloseButton,
            $author$project$Page$Person$viewInfoFormHelper_fn(palette, personId, model),
            submitButton,
            deleteButton
        ]));
    }, $author$project$Page$Person$viewInfoForm = F4($author$project$Page$Person$viewInfoForm_fn);
    var $author$project$Page$Person$viewPersonIcon_fn = function (palette, _v0) {
        var emailAddresses = _v0.lo;
        var _v1 = $elm$core$List$head(emailAddresses);
        if (!_v1.$) {
            var email = _v1.a;
            var domain = $elm_community$string_extra$String$Extra$rightOf_fn("@", email);
            return $mdgriffith$elm_ui$Element$link_fn(_List_Nil, {
                fF: A4($author$project$View$Tooltip$basic, palette, 45, "Notes with " + domain, $author$project$View$Widgets$favicon_fn(65, _List_fromArray([
                    $mdgriffith$elm_ui$Element$Border$shadow({
                        kp: 5,
                        kS: $author$project$Data$Color$grayAlphaDark,
                        nt: _Utils_Tuple2(1, 1),
                        oE: 0.5
                    })
                ]), domain)),
                dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteCollate_fn($author$project$Routing$CollateByDomain({ g9: domain }), $elm$core$Maybe$Nothing))
            });
        }
        else {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(65)),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(65)),
                $mdgriffith$elm_ui$Element$Border$rounded(100),
                $mdgriffith$elm_ui$Element$Background$color(palette.dw),
                $mdgriffith$elm_ui$Element$Border$shadow({
                    kp: 5,
                    kS: $author$project$Data$Color$grayAlphaDark,
                    nt: _Utils_Tuple2(1, 1),
                    oE: 0.5
                })
            ]), $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(35),
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$Font$color(palette.aS)
            ]), 3, "rocket"));
        }
    }, $author$project$Page$Person$viewPersonIcon = F2($author$project$Page$Person$viewPersonIcon_fn);
    var $author$project$View$Responsive$whenNotDoubleColumn_a0 = $elm$core$Basics$neq, $author$project$View$Responsive$whenNotDoubleColumn_a1 = 0, $author$project$View$Responsive$whenNotDoubleColumn = A2($author$project$View$Responsive$attrHelper, $author$project$View$Responsive$whenNotDoubleColumn_a0, $author$project$View$Responsive$whenNotDoubleColumn_a1);
    var $author$project$Page$Person$personInfo_fn = function (env, model, personId, person) {
        return $mdgriffith$elm_ui$Element$row_fn($author$project$View$Responsive$attrs_fn($author$project$Page$Person$responsiveAttrs_a0, env.p1, _List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(15),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            $author$project$View$Responsive$attrHelper_fn($author$project$View$Responsive$whenNotDoubleColumn_a0, $author$project$View$Responsive$whenNotDoubleColumn_a1, $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn($author$project$Page$Note$colWidth, $mdgriffith$elm_ui$Element$fill)))
        ])), _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$alignTop,
                $mdgriffith$elm_ui$Element$moveDown(10),
                $author$project$View$Util$createStackingContext
            ]), $author$project$Page$Person$viewPersonIcon_fn(env.nI, person)),
            $mdgriffith$elm_ui$Element$column_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$moveLeft(10)
                ]), $author$project$Page$Person$nameInput_fn(env.nI, personId, person)),
                $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$moveRight(6),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$minimum_fn(300, $mdgriffith$elm_ui$Element$shrink))
                ]), _List_fromArray([
                    $author$project$Page$Person$viewEmailAddresses_fn(env.nI, personId, person)
                ])),
                $author$project$Page$Person$viewInfoForm_fn(env.nI, model, personId, person),
                $author$project$Page$Person$dedupePrompt_fn(env, model)
            ]))
        ]));
    }, $author$project$Page$Person$personInfo = F4($author$project$Page$Person$personInfo_fn);
    var $author$project$Page$Person$EditorFocused = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Page$Person$UpdateBio_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $author$project$Page$Person$UpdateBio = F2($author$project$Page$Person$UpdateBio_fn);
    var $author$project$Page$Person$slateBioInput_fn = function (env, personId, state, person) {
        return $author$project$View$SlateEditor$element((new $$Record141((new $$Record140(state, person.ko, person.f6)), personId, $elm$core$Maybe$Nothing, $author$project$View$Responsive$attrs_fn($author$project$Page$Person$responsiveAttrs_a0, env.p1, _List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(85)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            $author$project$View$Responsive$attrHelper_fn($author$project$View$Responsive$whenNotDoubleColumn_a0, $author$project$View$Responsive$whenNotDoubleColumn_a1, $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(150)))
        ])), $elm$core$Maybe$Nothing, $author$project$Page$Person$UpdateBio(personId), $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Basics$composeR_fn($author$project$Data$Settings$theme_a0, $author$project$Data$Settings$theme_a1, env))));
    }, $author$project$Page$Person$slateBioInput = F4($author$project$Page$Person$slateBioInput_fn);
    var $author$project$Page$Person$textEditor_fn = function (env, model, personId, state, person) {
        return $mdgriffith$elm_ui$Element$column_fn($author$project$View$Responsive$attrs_fn($author$project$Page$Person$responsiveAttrs_a0, env.p1, _List_fromArray([
            $author$project$View$Util$on_fn("focusin", $author$project$Page$Person$EditorFocused(true)),
            $author$project$View$Util$on_fn("focusout", $author$project$Page$Person$EditorFocused(false)),
            $mdgriffith$elm_ui$Element$Border$width(1),
            $mdgriffith$elm_ui$Element$Border$rounded($author$project$View$Layout$standardBorderRounding),
            $mdgriffith$elm_ui$Element$Border$color(env.nI.aO),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$padding(20),
            $mdgriffith$elm_ui$Element$spacing(10)
        ]), _List_fromArray([
            $author$project$View$Responsive$attrHelper_fn($author$project$View$Responsive$whenNotDoubleColumn_a0, $author$project$View$Responsive$whenNotDoubleColumn_a1, $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(600, $mdgriffith$elm_ui$Element$fill)))
        ])), _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(16),
                $mdgriffith$elm_ui$Element$Font$bold
            ]), $mdgriffith$elm_ui$Element$text("Bio")),
            $author$project$Page$Person$slateBioInput_fn(env, personId, state, person),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$alignRight,
                $mdgriffith$elm_ui$Element$Font$color(env.nI.aQ)
            ]), $author$project$View$Widgets$savedState_fn(env.nI, env.pu, $elm$core$Basics$composeR_fn($author$project$Data$Settings$isShowArmyTime_a0, $author$project$Data$Settings$isShowArmyTime_a1, env), person.pR, state))
        ]));
    }, $author$project$Page$Person$textEditor = F5($author$project$Page$Person$textEditor_fn);
    var $ryannhg$date_format$DateFormat$DayOfWeekNameAbbreviated = { $: 13 };
    var $ryannhg$date_format$DateFormat$dayOfWeekNameAbbreviated = $ryannhg$date_format$DateFormat$DayOfWeekNameAbbreviated;
    var $author$project$Util$Time$dayMonthDayYearTimeFormatter_fn = function (isArmyTime, zone, time) {
        var timeText = isArmyTime ? A2($author$project$Util$Time$formatTimeOfDayArmy, zone, time) : A2($author$project$Util$Time$formatTimeOfDay, zone, time);
        return $ryannhg$date_format$DateFormat$formatWithLanguage_fn($ryannhg$date_format$DateFormat$format_a0, _List_fromArray([
            $ryannhg$date_format$DateFormat$dayOfWeekNameAbbreviated,
            $ryannhg$date_format$DateFormat$text(" "),
            $ryannhg$date_format$DateFormat$monthNameAbbreviated,
            $ryannhg$date_format$DateFormat$text(" "),
            $ryannhg$date_format$DateFormat$dayOfMonthSuffix,
            $ryannhg$date_format$DateFormat$text(", "),
            $ryannhg$date_format$DateFormat$yearNumber,
            $ryannhg$date_format$DateFormat$text("  "),
            $ryannhg$date_format$DateFormat$text(timeText)
        ]), zone, time);
    }, $author$project$Util$Time$dayMonthDayYearTimeFormatter = F3($author$project$Util$Time$dayMonthDayYearTimeFormatter_fn);
    var $author$project$Util$Time$monthDayFormatter_fn = function (zone, time) {
        return $ryannhg$date_format$DateFormat$formatWithLanguage_fn($ryannhg$date_format$DateFormat$format_a0, _List_fromArray([
            $ryannhg$date_format$DateFormat$monthNameAbbreviated,
            $ryannhg$date_format$DateFormat$text(" "),
            $ryannhg$date_format$DateFormat$dayOfMonthSuffix
        ]), zone, time);
    }, $author$project$Util$Time$monthDayFormatter = F2($author$project$Util$Time$monthDayFormatter_fn);
    var $author$project$View$Meeting$layoutterWithDatetime_fn = function (palette, timezoneUser, currentMinute, showArmyTime, _v0) {
        var badge = _v0.kj;
        var meeting = _v0.mV;
        var isOngoing = _v0.mx;
        var _v1 = _Utils_eq($elm$time$Time$toYear_fn(timezoneUser, meeting.bF), $elm$time$Time$toYear_fn(timezoneUser, currentMinute)) ? _Utils_Tuple2($author$project$Util$Time$monthDayFormatter, $author$project$Util$Time$dayMonthDayYearTimeFormatter) : _Utils_Tuple2($author$project$Util$Time$monthDayYearFormatter, $author$project$Util$Time$dayMonthDayYearTimeFormatter);
        var allDayFormatter = _v1.a;
        var timedFormatter = _v1.b;
        var datetime = meeting.d7 ? (A2(allDayFormatter, timezoneUser, meeting.bF) + "  (All Day)") : A3(timedFormatter, showArmyTime, timezoneUser, meeting.bF);
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$alignTop,
                $mdgriffith$elm_ui$Element$spacing(8)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $author$project$View$Styling$breakWord,
                    $mdgriffith$elm_ui$Element$Font$size(16)
                ]), _List_fromArray([
                    $author$project$View$Meeting$meetingTitle_fn(palette, meeting)
                ])),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$alignTop,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$Font$size(12),
                    $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn(isOngoing, palette.dw, palette.aS))
                ]), $mdgriffith$elm_ui$Element$text($elm$core$String$toUpper(datetime)))
            ])),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$alignBottom,
                $mdgriffith$elm_ui$Element$paddingXY_fn(0, 2)
            ]), badge)
        ]));
    }, $author$project$View$Meeting$layoutterWithDatetime = F5($author$project$View$Meeting$layoutterWithDatetime_fn);
    var $author$project$Page$Person$lookAheadTime = $author$project$Util$Time$day * 180;
    var $author$project$Page$Person$lookBackTime = $author$project$Util$Time$day * 540;
    var $elm$core$List$partition_fn = function (f, xs) {
        var truesHead = _List_Cons(undefined, _List_Nil);
        var falsesHead = _List_Cons(undefined, _List_Nil);
        var truesEnd = truesHead;
        var falsesEnd = falsesHead;
        for (; xs.b; xs = xs.b) {
            var next = _List_Cons(xs.
                a, _List_Nil);
            if (f(xs.a)) {
                truesEnd.b = next;
                truesEnd = next;
            }
            else {
                falsesEnd.b = next;
                falsesEnd = next;
            }
        }
        return _Utils_Tuple2(truesHead
            .b, falsesHead.b);
    }, $elm$core$List$partition = F2($elm$core$List$partition_fn);
    var $author$project$Page$Person$viewMeetingsHelp_fn = function (env, meetingsView, personId, personEmailsList) {
        var showArmyTime = $elm$core$Basics$composeR_fn($author$project$Data$Settings$isShowArmyTime_a0, $author$project$Data$Settings$isShowArmyTime_a1, env);
        var viewMeetingBlock = A2($elm$core$Basics$composeR, $author$project$Data$Meeting$BlockSingleMeeting, A2($author$project$View$Meeting$viewBlock, env, A4($author$project$View$Meeting$layoutterWithDatetime, env.nI, env.pu, env.k5, showArmyTime)));
        var personEmails = $elm$core$Set$fromList(personEmailsList);
        var currentMills = $elm$time$Time$posixToMillis(env.k5);
        var timeInRange = function (time) {
            var millis = $elm$time$Time$posixToMillis($author$project$Data$Time$toPosix_fn(env.pu, time));
            return (_Utils_cmp(millis, currentMills - $author$project$Page$Person$lookBackTime) > -1) && (_Utils_cmp(millis, currentMills + $author$project$Page$Person$lookAheadTime) < 0);
        };
        var filterEventAttendees = F2(function (time, attendees) {
            return timeInRange(time) && $elm$core$List$any_fn(function (attendee) {
                return $elm$core$Set$member_fn(attendee.cS, personEmails);
            }, attendees);
        });
        var filterNoteAttendees = F2(function (time, attendees) {
            return timeInRange(time) && $elm$core$List$any_fn(function (attendee) {
                var _v4 = attendee.n3;
                if (_v4.$ === 1) {
                    var email = _v4.a;
                    return $elm$core$Set$member_fn(email, personEmails);
                }
                else {
                    var attendeePersonId = _v4.a;
                    return $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(function (_v5) {
                        var resolvedId = _v5.a;
                        return _Utils_eq(resolvedId, personId);
                    }, $author$project$Data$Person$resolvePerson_fn(attendeePersonId, env.iz)));
                }
            }, attendees);
        });
        var _v0 = $elm$core$List$partition_fn(function (meeting) {
            return _Utils_cmp($elm$time$Time$posixToMillis(meeting.bF), currentMills) < 0;
        }, $author$project$Data$Meeting$meetingsBy_fn(env.lw, env.fO, env.pu, {
            cA: function (note) {
                return A2(filterNoteAttendees, note.gh, note.ke) && (!note.lh);
            },
            cT: function (event) {
                return A2(filterEventAttendees, event.oN, $elm_community$list_extra$List$Extra$uniqueBy_fn(function ($) {
                    return $.cS;
                }, _List_Cons(event.c8, event.ke)));
            },
            cU: F2(function (event, note) {
                return A2(filterNoteAttendees, event.oN, note.ke) && (!note.lh);
            })
        }));
        var pastMeetings = _v0.a;
        var futureMeetings = _v0.b;
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(10)
        ]), function () {
            if (!meetingsView) {
                return function (past) {
                    if (!past.b) {
                        return _List_fromArray([
                            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                                $mdgriffith$elm_ui$Element$padding(5)
                            ]), $mdgriffith$elm_ui$Element$text("No recent meetings found"))
                        ]);
                    }
                    else {
                        return past;
                    }
                }($elm$core$List$map_fn(viewMeetingBlock, $elm$core$List$reverse(pastMeetings)));
            }
            else {
                return function (upcoming) {
                    if (!upcoming.b) {
                        return _List_fromArray([
                            $mdgriffith$elm_ui$Element$text("No upcoming meetings found")
                        ]);
                    }
                    else {
                        return upcoming;
                    }
                }($elm$core$List$map_fn(viewMeetingBlock, futureMeetings));
            }
        }());
    }, $author$project$Page$Person$viewMeetingsHelp = F4($author$project$Page$Person$viewMeetingsHelp_fn);
    var $author$project$Page$Person$viewMeetings_fn = function (env, model, personId, person) {
        var viewLoading = $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(10)
        ]), $elm$core$List$map_fn(function (showBadge) {
            return $author$project$View$Meeting$viewLoadingCalendarBlock_fn(env.nI, { jc: showBadge, oA: true });
        }, _List_fromArray([true, false, true, false])));
        var meetings = $author$project$Data$App$isLoading(env.mK) ? viewLoading : $author$project$Page$Person$viewMeetingsHelp_fn(env, model.aY, personId, person.lo);
        return meetings;
    }, $author$project$Page$Person$viewMeetings = F4($author$project$Page$Person$viewMeetings_fn);
    var $author$project$Page$Person$SetMeetingsView = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Page$Person$Upcoming = 1;
    var $author$project$Page$Person$viewMeetingsHeader_fn = function (palette, model) {
        var tabLinkHelper = F2(function (tabText, meetingsView) {
            return $mdgriffith$elm_ui$Element$Input$button_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.aR),
                $mdgriffith$elm_ui$Element$Font$size(14),
                $author$project$View$Util$attrWhen_fn(!_Utils_eq(model.aY, meetingsView), $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(palette.a7)
                ]))),
                $author$project$View$Util$attrWhen_fn(_Utils_eq(model.aY, meetingsView), $mdgriffith$elm_ui$Element$Font$color(palette.a2)),
                $author$project$View$Util$attrWhen_fn(_Utils_eq(model.aY, meetingsView), $mdgriffith$elm_ui$Element$Border$color(palette.a2)),
                $author$project$View$Util$attrWhen_fn(_Utils_eq(model.aY, meetingsView), $mdgriffith$elm_ui$Element$Border$widthEach((new $$Record115(2, 0, 0, 0)))),
                $author$project$View$Styling$paddingBottom(10),
                $author$project$View$Styling$focusable
            ]), {
                fF: $mdgriffith$elm_ui$Element$text(tabText),
                nz: $elm$core$Maybe$Just($author$project$Page$Person$SetMeetingsView(meetingsView))
            });
        });
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(25),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$padding(10)
        ]), _List_fromArray([
            A2(tabLinkHelper, "RECENT MEETINGS", 0),
            A2(tabLinkHelper, "UPCOMING MEETINGS", 1)
        ]));
    }, $author$project$Page$Person$viewMeetingsHeader = F2($author$project$Page$Person$viewMeetingsHeader_fn);
    var $author$project$Page$Person$viewBioAndMeetings_fn = function (env, model, personId, state, person) {
        return _List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$map_fn($author$project$Page$Person$HandleBacktalk, $author$project$View$Breadcrumb$view(env)),
            $author$project$Page$Person$personInfo_fn(env, model, personId, person),
            $author$project$Page$Person$textEditor_fn(env, model, personId, state, person),
            $author$project$View$Util$spacer(10),
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(8),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
            ]), _List_fromArray([
                $author$project$Page$Person$viewMeetingsHeader_fn(env.nI, model),
                $author$project$Page$Person$viewMeetings_fn(env, model, personId, person)
            ]))
        ]);
    }, $author$project$Page$Person$viewBioAndMeetings = F5($author$project$Page$Person$viewBioAndMeetings_fn);
    var $author$project$View$ActionItems$fadingCount = function (_v0) {
        var fading = _v0.O;
        return $elm$core$Set$size(fading);
    };
    var $author$project$Page$Person$viewMentions_fn = function (env, model, personId) {
        var viewLoading = $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$paddingXY_fn(0, 10),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(12)
        ]), _List_fromArray([
            $author$project$View$ActionItems$viewLoadingLine_fn(env.nI, true, 4),
            $author$project$View$ActionItems$viewLoadingLine_fn(env.nI, true, 7)
        ]));
        var viewActionItem = function (actionItem) {
            return $author$project$View$ActionItems$viewFadingActionItem_fn(env, $$update__eG($author$project$View$ActionItems$defaultViewConfig, false), model.bQ, actionItem);
        };
        var shouldIncludeActionItem = function (actionItem) {
            return $elm$core$List$any_fn(function (mentionRef) {
                if (mentionRef.$ === 2) {
                    var personRef = mentionRef.a;
                    return $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(function (_v4) {
                        var resolvedPersonId = _v4.a;
                        return _Utils_eq(resolvedPersonId, personId);
                    }, $author$project$Data$Person$resolvePerson_fn(personRef.iB, env.iz)));
                }
                else {
                    return false;
                }
            }, actionItem.jn);
        };
        var actionItems = $elm$core$List$concatMap_fn($elm$core$Tuple$second, _List_sortBy_fn($elm$core$Tuple$first, A2($author$project$Firestore$Collection$filterMap, F2(function (_v2, note) {
            var noteActionItems = $elm$core$List$filter_fn(shouldIncludeActionItem, note.gz);
            return (note.lh || $elm$core$List$isEmpty(noteActionItems)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple2($elm$time$Time$posixToMillis($elm$core$Maybe$withDefault_fn(env.k5, $author$project$Data$Timestamp$toPosix(note.e8))), noteActionItems));
        }), env.fO)));
        var actionItemInboxExplanation = F2(function (isTooltip, attrs) {
            var mentionChip = $author$project$View$ActionItems$mentionChip_fn(env.nI, isTooltip);
            var actionItemChip = $author$project$View$ActionItems$actionItemChip_fn(env.nI, isTooltip);
            return $mdgriffith$elm_ui$Element$column_fn(attrs, _List_fromArray([
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Threads arrive here when ")
                ])),
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(9)
                ]), _List_fromArray([
                    mentionChip("@person"),
                    $mdgriffith$elm_ui$Element$text(" + "),
                    actionItemChip("to-do"),
                    $mdgriffith$elm_ui$Element$text(" or ")
                ])),
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(9)
                ]), _List_fromArray([
                    mentionChip("@person"),
                    $mdgriffith$elm_ui$Element$text(" + "),
                    mentionChip("#meetingname")
                ])),
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text(" are used within other notes.")
                ]))
            ]));
        });
        var inboxIcon = $mdgriffith$elm_ui$Element$el_fn(_List_Nil, A4($author$project$View$Tooltip$custom, env.nI, 0, A2(actionItemInboxExplanation, true, _List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(230)),
            $mdgriffith$elm_ui$Element$padding(10),
            $mdgriffith$elm_ui$Element$spacing(9),
            $mdgriffith$elm_ui$Element$Font$center
        ])), $author$project$View$Icon$icon_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$moveDown(1)
        ]), 1, "inbox")));
        var actionItemElements = $elm$core$List$filterMap_fn(viewActionItem, actionItems);
        var actionItemsCount = $elm$core$List$length(actionItemElements);
        var _v0 = function () {
            var _v1 = _Utils_Tuple2($author$project$Data$App$isLoading(env.mK), actionItemsCount);
            if (_v1.a) {
                return _Utils_Tuple2($mdgriffith$elm_ui$Element$none, viewLoading);
            }
            else {
                if (!_v1.b) {
                    return _Utils_Tuple2($mdgriffith$elm_ui$Element$none, A2(actionItemInboxExplanation, false, _List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(16),
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aR),
                        $mdgriffith$elm_ui$Element$Font$center,
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                        $mdgriffith$elm_ui$Element$spacing(9),
                        $mdgriffith$elm_ui$Element$Font$light
                    ])));
                }
                else {
                    return _Utils_Tuple2($mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aS)
                    ]), $mdgriffith$elm_ui$Element$text(function (count) {
                        return "(" + ($elm$core$String$fromInt(count) + ")");
                    }(actionItemsCount - $author$project$View$ActionItems$fadingCount(model.bQ)))), $mdgriffith$elm_ui$Internal$Model$map_fn($author$project$Page$Person$ActionItemMsg, $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$spacing(5)
                    ]), $elm$core$List$intersperse_fn($author$project$View$ActionItems$spacerLine(env.nI), actionItemElements))));
                }
            }
        }();
        var viewCount = _v0.a;
        var mentionList = _v0.b;
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(20)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(10),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Font$size(18)
            ]), _List_fromArray([inboxIcon, viewCount])),
            mentionList
        ]));
    }, $author$project$Page$Person$viewMentions = F3($author$project$Page$Person$viewMentions_fn);
    var $author$project$Page$Person$viewMeetingsAndMentions_fn = function (env, model, personId) {
        return _List_fromArray([
            $author$project$Page$Person$viewMentions_fn(env, model, personId)
        ]);
    }, $author$project$Page$Person$viewMeetingsAndMentions = F3($author$project$Page$Person$viewMeetingsAndMentions_fn);
    var $author$project$Page$Person$view_fn = function (env, model, personId, state, person) {
        return person.lh ? $author$project$Page$Person$deletedPersonView_fn(env, person) : $author$project$View$Layout$twoPanel_fn(env, {
            mP: $author$project$Page$Person$viewBioAndMeetings_fn(env, model, personId, state, person),
            m4: $author$project$Page$Person$viewMeetingsAndMentions_fn(env, model, personId)
        });
    }, $author$project$Page$Person$view = F5($author$project$Page$Person$view_fn);
    var $author$project$Page$Search$SetCategory = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$View$Util$noSelect = $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "no-select");
    var $elm_community$string_extra$String$Extra$changeCase_fn = function (mutator, word) {
        return $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn(function (_v0) {
            var head = _v0.a;
            var tail = _v0.b;
            return _String_cons_fn(mutator(head), tail);
        }, $elm$core$String$uncons(word)));
    }, $elm_community$string_extra$String$Extra$changeCase = F2($elm_community$string_extra$String$Extra$changeCase_fn);
    var $elm$core$Char$toUpper = _Char_toUpper;
    var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
        return $elm_community$string_extra$String$Extra$changeCase_fn($elm$core$Char$toUpper, word);
    };
    var $author$project$Page$Search$viewCategoryTab_fn = function (palette, model, category) {
        var underline = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(3)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$Background$color(palette.a4),
            $mdgriffith$elm_ui$Element$moveUp(2)
        ]), $mdgriffith$elm_ui$Element$none);
        var isSelected = _Utils_eq(model.e1, category);
        return $mdgriffith$elm_ui$Element$Input$button_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$below($author$project$View$Util$when_fn(isSelected, underline)),
            $mdgriffith$elm_ui$Element$pointer,
            $author$project$View$Util$noSelect,
            $mdgriffith$elm_ui$Element$Border$rounded(4),
            $mdgriffith$elm_ui$Element$padding(2)
        ]), {
            fF: $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(5),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Font$size(14),
                $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn(isSelected, palette.aU, palette.aS)),
                $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(palette.aU)
                ]))
            ]), $mdgriffith$elm_ui$Element$text($elm_community$string_extra$String$Extra$toSentenceCase($author$project$Search$Query$categoryToString(category)))),
            nz: $elm$core$Maybe$Just($author$project$Page$Search$SetCategory(category))
        });
    }, $author$project$Page$Search$viewCategoryTab = F3($author$project$Page$Search$viewCategoryTab_fn);
    var $author$project$Page$Search$xPadding = 15;
    var $author$project$Page$Search$viewCategoryTabs_fn = function (palette, model) {
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(25),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$Border$widthEach($$update__kw($author$project$View$Styling$edges, 1)),
            $mdgriffith$elm_ui$Element$Border$color(palette.aP),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(25)),
            $mdgriffith$elm_ui$Element$paddingXY_fn($author$project$Page$Search$xPadding, 0)
        ]), $elm$core$List$map_fn(A2($author$project$Page$Search$viewCategoryTab, palette, model), _List_fromArray([0, 1, 2])));
    }, $author$project$Page$Search$viewCategoryTabs = F2($author$project$Page$Search$viewCategoryTabs_fn);
    var $author$project$Page$Search$viewCurrentQuery_fn = function (category, searchResult) {
        var totalResults = $elm$core$String$fromInt($author$project$Search$Result$size(searchResult));
        var query = $author$project$Search$Result$query(searchResult);
        var stringQuery = $elm$core$Basics$composeR_fn($author$project$Search$Query$stringQuery_a0, $author$project$Search$Query$stringQuery_a1, query);
        var headerText = $elm$core$String$isEmpty(stringQuery) ? ("Showing " + ($author$project$Util$Misc$if__fn($author$project$Search$Query$isEmpty(query), "all ", "") + (totalResults + (" " + $author$project$Search$Query$categoryToString(category))))) : (totalResults + (" results for \"" + (stringQuery + "\"")));
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$paddingXY_fn($author$project$Page$Search$xPadding, 15),
            $mdgriffith$elm_ui$Element$Font$bold,
            $mdgriffith$elm_ui$Element$Font$size(17)
        ]), $mdgriffith$elm_ui$Element$text(headerText));
    }, $author$project$Page$Search$viewCurrentQuery = F2($author$project$Page$Search$viewCurrentQuery_fn);
    var $author$project$Page$Search$Date = 2;
    var $author$project$Page$Search$FileType = 3;
    var $author$project$Page$Search$In = 0;
    var $author$project$Page$Search$With = 1;
    var $author$project$Page$Search$BasicFilterForm = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Page$Search$SetDateFilters = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Page$Search$AnyTime = 0;
    var $author$project$Page$Search$Last12Months = 5;
    var $author$project$Page$Search$Last30Days = 2;
    var $author$project$Page$Search$Last3Months = 3;
    var $author$project$Page$Search$Last6Months = 4;
    var $author$project$Page$Search$Last7Days = 1;
    var $author$project$Page$Search$availableDateFilterOptions = _List_fromArray([0, 1, 2, 3, 4, 5]);
    var $author$project$Page$Search$dateFiltersInQuery_a0 = F2(function (filter, acc) {
        switch (filter.$) {
            case 2:
                var before = filter.a;
                return function () {
                    var $r = acc.$c();
                    $r.bX = $elm$core$Maybe$Just(before);
                    return $r;
                }();
            case 3:
                var after = filter.a;
                return function () {
                    var $r = acc.$c();
                    $r.bT = $elm$core$Maybe$Just(after);
                    return $r;
                }();
            default:
                return acc;
        }
    }), $author$project$Page$Search$dateFiltersInQuery_a1 = (new $$Record145($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)), $author$project$Page$Search$dateFiltersInQuery = A2($elm$core$List$foldl, $author$project$Page$Search$dateFiltersInQuery_a0, $author$project$Page$Search$dateFiltersInQuery_a1);
    var $author$project$Page$Search$dateRangeOfOption_fn = function (timezoneUser, currentTime, dateFilterOption) {
        var today = $justinmimbs$date$Date$fromPosix_fn(timezoneUser, currentTime);
        var _return = function (after) {
            return $elm$core$Maybe$Just((new $$Record145(after, $justinmimbs$date$Date$add_fn(3, 1, today))));
        };
        switch (dateFilterOption) {
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                return _return($justinmimbs$date$Date$add_fn(3, -8, today));
            case 2:
                return _return($justinmimbs$date$Date$add_fn(3, -31, today));
            case 3:
                return _return($justinmimbs$date$Date$add_fn(1, -3, today));
            case 4:
                return _return($justinmimbs$date$Date$add_fn(1, -6, today));
            default:
                return _return($justinmimbs$date$Date$add_fn(1, -12, today));
        }
    }, $author$project$Page$Search$dateRangeOfOption = F3($author$project$Page$Search$dateRangeOfOption_fn);
    var $author$project$Page$Search$currentDateFilterOption_fn = function (env, query) {
        var dateRangeOfOption_ = A2($author$project$Page$Search$dateRangeOfOption, env.pu, env.k5);
        var currentFilters = $elm$core$List$foldl_fn($author$project$Page$Search$dateFiltersInQuery_a0, $author$project$Page$Search$dateFiltersInQuery_a1, query);
        var mCurrentDateRange = function () {
            var _v1 = _Utils_Tuple2(currentFilters.bT, currentFilters.bX);
            if ((!_v1.a.$) && (!_v1.b.$)) {
                var after = _v1.a.a;
                var before = _v1.b.a;
                return $elm$core$Maybe$Just((new $$Record145(after, before)));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }();
        return $elm$core$List$foldl_fn_unwrapped(function (option, acc) {
            if (!acc.$) {
                var currentOption = acc.a;
                return $elm$core$Maybe$Just(currentOption);
            }
            else {
                return $author$project$Util$Misc$toJustIf_fn(_Utils_eq(dateRangeOfOption_(option), mCurrentDateRange), option);
            }
        }, $elm$core$Maybe$Nothing, $author$project$Page$Search$availableDateFilterOptions);
    }, $author$project$Page$Search$currentDateFilterOption = F2($author$project$Page$Search$currentDateFilterOption_fn);
    var $author$project$Page$Search$dateFilterOptionToString = function (dateFilterOption) {
        switch (dateFilterOption) {
            case 0:
                return "Any time";
            case 1:
                return "Last 7 days";
            case 2:
                return "Last 30 days";
            case 3:
                return "Last 3 months";
            case 4:
                return "Last 6 months";
            default:
                return "Last 12 months";
        }
    };
    var $author$project$Page$Search$dateFilterForm_fn = function (env, model) {
        var mCurrentOption = $author$project$Page$Search$currentDateFilterOption_fn(env, $author$project$Search$Result$query(model.p));
        var optionIsSelected = function (option) {
            return _Utils_eq(mCurrentOption, $elm$core$Maybe$Just(option));
        };
        var onPress = function (option) {
            return $author$project$Page$Search$SetDateFilters(optionIsSelected(option) ? $elm$core$Maybe$Nothing : $author$project$Page$Search$dateRangeOfOption_fn(env.pu, env.k5, option));
        };
        return $author$project$Page$Search$BasicFilterForm((new $$Record146(onPress, optionIsSelected, $author$project$Page$Search$availableDateFilterOptions, A2($elm$core$Basics$composeR, $author$project$Page$Search$dateFilterOptionToString, $mdgriffith$elm_ui$Element$text), 250)));
    }, $author$project$Page$Search$dateFilterForm = F2($author$project$Page$Search$dateFilterForm_fn);
    var $author$project$Page$Search$SetFileType = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Search$Query$allFileTypes = _List_fromArray([2, 1, 0, 3, 4]);
    var $author$project$Page$Search$fileTypeFilters_a0 = function (filter) {
        if (filter.$ === 4) {
            var fileType = filter.a;
            return $elm$core$Maybe$Just(fileType);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Page$Search$fileTypeFilters = $elm$core$List$filterMap($author$project$Page$Search$fileTypeFilters_a0);
    var $author$project$Page$Search$fileTypeFilterForm_fn = function (_v0, model) {
        var currentFilters = $elm$core$List$filterMap_fn($author$project$Page$Search$fileTypeFilters_a0, $author$project$Search$Result$query(model.p));
        var optionIsSelected = function (option) {
            return $elm$core$List$member_fn(option, currentFilters);
        };
        var onPress = function (option) {
            return $author$project$Util$Misc$if__fn(optionIsSelected(option), $author$project$Page$Search$SetFileType($elm$core$Maybe$Nothing), $author$project$Page$Search$SetFileType($elm$core$Maybe$Just(option)));
        };
        return $author$project$Page$Search$BasicFilterForm((new $$Record146(onPress, optionIsSelected, $author$project$Search$Query$allFileTypes, A2($elm$core$Basics$composeR, $author$project$Search$Query$fileTypeToString, A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$toSentenceCase, $mdgriffith$elm_ui$Element$text)), 225)));
    }, $author$project$Page$Search$fileTypeFilterForm = F2($author$project$Page$Search$fileTypeFilterForm_fn);
    var $author$project$Page$Search$Active = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Page$Search$Inactive = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Page$Search$eventFilters_a0 = function (filter) {
        if ((!filter.$) && (!filter.a.$)) {
            var _v1 = filter.a;
            var eventId = _v1.b;
            return $elm$core$Maybe$Just(eventId);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Page$Search$eventFilters = $elm$core$List$filterMap($author$project$Page$Search$eventFilters_a0);
    var $author$project$Page$Search$peopleFilters_a0 = function (filter) {
        if ((filter.$ === 1) && (!filter.a.$)) {
            var _v1 = filter.a;
            var personId = _v1.b;
            return $elm$core$Maybe$Just(personId);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Page$Search$peopleFilters = $elm$core$List$filterMap($author$project$Page$Search$peopleFilters_a0);
    var $author$project$Page$Search$personDisplayText = function (person) {
        return $elm$core$String$isEmpty(person.b) ? $elm$core$Maybe$withDefault_fn("(No name)", $elm$core$List$head(person.lo)) : person.b;
    };
    var $author$project$Page$Search$filterFormButtonText_fn = function (env, query, filterForm) {
        switch (filterForm) {
            case 1:
                var _v1 = $elm$core$List$filterMap_fn($author$project$Page$Search$peopleFilters_a0, query);
                if (!_v1.b) {
                    return $author$project$Page$Search$Inactive("With");
                }
                else {
                    if (!_v1.b.b) {
                        var personId = _v1.a;
                        return $author$project$Page$Search$Active($elm$core$Maybe$withDefault_fn("With", $elm$core$Maybe$map_fn(function (p) {
                            return "With  @" + $author$project$Page$Search$personDisplayText(p);
                        }, $author$project$Firestore$Collection$get_fn(personId, env.iz))));
                    }
                    else {
                        var xs = _v1;
                        return $author$project$Page$Search$Active("With " + ($elm$core$String$fromInt($elm$core$List$length(xs)) + " people"));
                    }
                }
            case 0:
                var _v2 = $elm$core$List$filterMap_fn($author$project$Page$Search$eventFilters_a0, query);
                if (!_v2.b) {
                    return $author$project$Page$Search$Inactive("In");
                }
                else {
                    if (!_v2.b.b) {
                        var eventId = _v2.a;
                        return $author$project$Page$Search$Active($elm$core$Maybe$withDefault_fn("In", $elm$core$Maybe$map_fn(function (e) {
                            return "In  # " + $author$project$Util$Text$truncateToNChars_fn(20, e.gj);
                        }, $elm$core$Dict$get_fn(eventId, env.lw))));
                    }
                    else {
                        var xs = _v2;
                        return $author$project$Page$Search$Active("In " + ($elm$core$String$fromInt($elm$core$List$length(xs)) + " events"));
                    }
                }
            case 2:
                var _v3 = $author$project$Page$Search$currentDateFilterOption_fn(env, query);
                if (_v3.$ === 1) {
                    return $author$project$Page$Search$Active("Date");
                }
                else {
                    if (!_v3.a) {
                        var _v4 = _v3.a;
                        return $author$project$Page$Search$Inactive("Date");
                    }
                    else {
                        var option = _v3.a;
                        return $author$project$Page$Search$Active($author$project$Page$Search$dateFilterOptionToString(option));
                    }
                }
            default:
                var _v5 = $elm$core$List$head($elm$core$List$filterMap_fn($author$project$Page$Search$fileTypeFilters_a0, query));
                if (_v5.$ === 1) {
                    return $author$project$Page$Search$Inactive("File type");
                }
                else {
                    var fileType = _v5.a;
                    return $author$project$Page$Search$Active($elm_community$string_extra$String$Extra$toSentenceCase($author$project$Search$Query$fileTypeToString(fileType)));
                }
        }
    }, $author$project$Page$Search$filterFormButtonText = F3($author$project$Page$Search$filterFormButtonText_fn);
    var $author$project$Page$Search$AddFilter = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Page$Search$RemoveFilter = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Page$Search$SearchFilterForm = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Util$Time$dayTimeFormatter_fn = function (isArmyTime, zone, time) {
        var timeText = isArmyTime ? A2($author$project$Util$Time$formatTimeOfDayArmy, zone, time) : A2($author$project$Util$Time$formatTimeOfDay, zone, time);
        return $ryannhg$date_format$DateFormat$formatWithLanguage_fn($ryannhg$date_format$DateFormat$format_a0, _List_fromArray([
            $ryannhg$date_format$DateFormat$dayOfWeekNameAbbreviated,
            $ryannhg$date_format$DateFormat$text(" "),
            $ryannhg$date_format$DateFormat$text(timeText)
        ]), zone, time);
    }, $author$project$Util$Time$dayTimeFormatter = F3($author$project$Util$Time$dayTimeFormatter_fn);
    var $author$project$Page$Search$Searching = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Page$Search$Suggesting = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Page$Search$generateEventOptions_fn = function (env, searchQuery, selectedEvents) {
        var queryIsEmpty = $elm$core$String$isEmpty(searchQuery);
        var currentTimeInMillis = $elm$time$Time$posixToMillis(env.k5);
        var millisFromNow = function (eventTime) {
            return currentTimeInMillis - $author$project$Data$Time$toMillis_fn(env.pu, eventTime);
        };
        var reducer = F3(function (eventId, event, acc) {
            var millisFromNow_ = millisFromNow(event.oN);
            var insertWithScore = function (score) {
                return $elm$core$Dict$insert_fn($author$project$Data$Event$baseId(eventId), score, acc);
            };
            if (queryIsEmpty) {
                return $author$project$Util$Misc$if__fn(millisFromNow_ > 0, insertWithScore(-millisFromNow_), acc);
            }
            else {
                var searchScore = $author$project$Util$SimpleSearch$score_fn(searchQuery, _List_fromArray([event.gj]));
                return $author$project$Util$Misc$if__fn(searchScore > 0, insertWithScore(searchScore), acc);
            }
        });
        var results = $elm$core$List$map_fn($elm$core$Tuple$first, A2($author$project$Util$Misc$sortByReverse, $elm$core$Tuple$second, $elm$core$Dict$toList($elm$core$Dict$foldl_fn(reducer, $elm$core$Dict$empty, env.lw))));
        return queryIsEmpty ? $author$project$Page$Search$Suggesting((new $$Record147(selectedEvents, $elm$core$List$take_fn(5, results)))) : $author$project$Page$Search$Searching({ fX: results });
    }, $author$project$Page$Search$generateEventOptions = F3($author$project$Page$Search$generateEventOptions_fn);
    var $author$project$Page$Search$inMeetingFilterForm_fn = function (env, model) {
        var selectedEvents = $elm$core$List$filterMap_fn($author$project$Page$Search$eventFilters_a0, $author$project$Search$Result$query(model.p));
        var optionIsSelected = function (eventId) {
            return $elm$core$List$member_fn(eventId, selectedEvents);
        };
        var onPress = function (eventId) {
            var _v0 = $elm$core$Dict$get_fn(eventId, env.lw);
            if (!_v0.$) {
                var event = _v0.a;
                return A4($author$project$Util$Misc$if_, optionIsSelected(eventId), $author$project$Page$Search$RemoveFilter, $author$project$Page$Search$AddFilter, $author$project$Search$Query$In($author$project$Search$Query$Event_fn(event.gj, eventId)));
            }
            else {
                return $author$project$Page$Search$NoOp("Event not found");
            }
        };
        var isArmyTime = $elm$core$Basics$composeR_fn($author$project$Data$Settings$isShowArmyTime_a0, $author$project$Data$Settings$isShowArmyTime_a1, env);
        var viewOption = function (eventId) {
            return $author$project$View$Util$whenJust_fn($elm$core$Dict$get_fn(eventId, env.lw), function (event) {
                return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$paddingXY_fn(0, 5),
                    $author$project$View$Util$attribute_fn($author$project$View$Util$title_a0, event.gj),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(13),
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(135, $mdgriffith$elm_ui$Element$fill))
                    ]), $mdgriffith$elm_ui$Element$text($author$project$Util$Text$truncateToNChars_fn(36, event.gj))),
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(11),
                        $mdgriffith$elm_ui$Element$centerX,
                        $mdgriffith$elm_ui$Element$moveDown(1),
                        $mdgriffith$elm_ui$Element$alignRight
                    ]), $mdgriffith$elm_ui$Element$text($author$project$Util$Time$dayTimeFormatter_fn(isArmyTime, env.pu, $author$project$Data$Time$toPosix_fn(env.pu, event.oN))))
                ]));
            });
        };
        return $author$project$Page$Search$SearchFilterForm((new $$Record148("Search for event to filter by", onPress, optionIsSelected, $author$project$Page$Search$generateEventOptions_fn(env, model.aH, selectedEvents), "Ex. Standup", viewOption, 350)));
    }, $author$project$Page$Search$inMeetingFilterForm = F2($author$project$Page$Search$inMeetingFilterForm_fn);
    var $author$project$Page$Search$preventBlurringOnMousedown = $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$preventDefaultOn_fn("mousedown", $elm$json$Json$Decode$succeed(_Utils_Tuple2($author$project$Page$Search$NoOp("mousedown prevent blur"), true))));
    var $author$project$Page$Search$formOptionWrapper = function (palette) {
        return $mdgriffith$elm_ui$Element$Input$button(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(10),
            $mdgriffith$elm_ui$Element$paddingXY_fn($author$project$Page$Search$xPadding, 0),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(35)),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(palette.a9),
                $mdgriffith$elm_ui$Element$Font$color(palette.aN)
            ])),
            $mdgriffith$elm_ui$Element$pointer,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $author$project$View$Util$noSelect,
            $author$project$Page$Search$preventBlurringOnMousedown
        ]));
    };
    var $author$project$Page$Search$formWrapper_fn = function (palette, formWidth) {
        return $mdgriffith$elm_ui$Element$column(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(formWidth)),
            $mdgriffith$elm_ui$Element$Background$color(palette.aL),
            $mdgriffith$elm_ui$Element$Border$rounded(5),
            $mdgriffith$elm_ui$Element$Border$width(1),
            $mdgriffith$elm_ui$Element$Border$color(palette.aQ),
            $mdgriffith$elm_ui$Element$Font$color(palette.aT),
            $mdgriffith$elm_ui$Element$Font$size(14),
            $mdgriffith$elm_ui$Element$moveDown(6),
            $author$project$View$Styling$elevation30
        ]));
    }, $author$project$Page$Search$formWrapper = F2($author$project$Page$Search$formWrapper_fn);
    var $author$project$Page$Search$viewBasicFilterForm_fn = function (env, formConfig) {
        var viewOption = function (option) {
            var isSelected = formConfig.a_(option);
            return A2($author$project$Page$Search$formOptionWrapper, env.nI, {
                fF: $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(8),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(20))
                    ]), $author$project$View$Util$when_fn(isSelected, $author$project$View$Icon$icon_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(16)
                    ]), 1, "check"))),
                    formConfig.bh(option)
                ])),
                nz: $elm$core$Maybe$Just(formConfig.nz(option))
            });
        };
        var hiddenFocusElement = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$onBlur($author$project$Page$Search$SetSelectedFilterForm($elm$core$Maybe$Nothing))),
            $elm$core$Basics$composeL_fn($author$project$View$Util$id_a0, $author$project$View$Util$id_a1, $author$project$Page$Search$filterSearchInputId),
            $author$project$View$Util$tabIndex($elm$core$Maybe$Just(0))
        ]), $mdgriffith$elm_ui$Element$none);
        return A3($author$project$Page$Search$formWrapper, env.nI, formConfig.jJ, _List_Cons(hiddenFocusElement, $elm$core$List$map_fn(viewOption, formConfig.nE)));
    }, $author$project$Page$Search$viewBasicFilterForm = F2($author$project$Page$Search$viewBasicFilterForm_fn);
    var $author$project$Page$Search$SetFilterDropdownSearchText = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Page$Search$viewSearchFilterForm_fn = function (env, model, formConfig) {
        var viewOption = function (option) {
            var isSelected = formConfig.a_(option);
            return A2($author$project$Page$Search$formOptionWrapper, env.nI, {
                fF: $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(8),
                    $mdgriffith$elm_ui$Element$clip,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), _List_fromArray([
                    $author$project$View$Icon$icon_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(16)
                    ]), 1, $author$project$Util$Misc$if__fn(isSelected, "check-square", "square")),
                    formConfig.bh(option)
                ])),
                nz: $elm$core$Maybe$Just(formConfig.nz(option))
            });
        };
        var viewOptionsHelper = A2($elm$core$Basics$composeR, $elm$core$List$map(viewOption), $mdgriffith$elm_ui$Element$column(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$paddingXY_fn(0, 5)
        ])));
        var suggestionsHeader = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(13),
            $mdgriffith$elm_ui$Element$Font$color(env.nI.aU),
            $mdgriffith$elm_ui$Element$Font$light,
            $mdgriffith$elm_ui$Element$Border$widthEach($$update__kw($author$project$View$Styling$edges, 1)),
            $mdgriffith$elm_ui$Element$Border$color(env.nI.aQ),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$paddingXY_fn(25, 5)
        ]), $mdgriffith$elm_ui$Element$text("Suggestions"));
        var searchInput = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$paddingXY_fn(20, 15),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Background$color(env.nI.dw),
            $mdgriffith$elm_ui$Element$Border$width(1),
            $mdgriffith$elm_ui$Element$Border$color(env.nI.aQ),
            $mdgriffith$elm_ui$Element$Border$rounded(5),
            $mdgriffith$elm_ui$Element$paddingXY_fn(8, 0),
            $mdgriffith$elm_ui$Element$spacing(0),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(15)
            ]), 2, "search"),
            $mdgriffith$elm_ui$Element$Input$textHelper_fn($mdgriffith$elm_ui$Element$Input$text_a0, _List_fromArray([
                $mdgriffith$elm_ui$Element$Border$width(0),
                $mdgriffith$elm_ui$Element$paddingXY_fn(7, 10),
                $author$project$View$Util$preventKeypressPropagation($author$project$Page$Search$NoOp),
                $mdgriffith$elm_ui$Element$Background$color(env.nI.dw),
                $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$onBlur($author$project$Page$Search$SetSelectedFilterForm($elm$core$Maybe$Nothing))),
                $elm$core$Basics$composeL_fn($author$project$View$Util$id_a0, $author$project$View$Util$id_a1, $author$project$Page$Search$filterSearchInputId),
                $author$project$View$Util$disableAutocomplete
            ]), {
                fF: $mdgriffith$elm_ui$Element$Input$labelHidden(formConfig.kb),
                nu: $author$project$Page$Search$SetFilterDropdownSearchText,
                fV: $elm$core$Maybe$Just($mdgriffith$elm_ui$Element$Input$Placeholder_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.aQ),
                    $mdgriffith$elm_ui$Element$Font$light
                ]), $mdgriffith$elm_ui$Element$text(formConfig.fV))),
                jn: model.aH
            })
        ])));
        var listElements = function () {
            var _v0 = formConfig.nE;
            if (!_v0.$) {
                var suggestions = _v0.a.gf;
                var selected = _v0.a.f2;
                return _List_Cons(viewOptionsHelper(selected), $author$project$Util$Misc$if__fn($elm$core$List$isEmpty(suggestions), _List_Nil, _List_fromArray([
                    suggestionsHeader,
                    viewOptionsHelper(suggestions)
                ])));
            }
            else {
                var results = _v0.a.fX;
                return _List_fromArray([
                    viewOptionsHelper(results)
                ]);
            }
        }();
        return A3($author$project$Page$Search$formWrapper, env.nI, formConfig.jJ, _List_fromArray([
            searchInput,
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$scrollbarY,
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$maximum_fn(250, $mdgriffith$elm_ui$Element$fill)),
                $author$project$View$Styling$showScrollbar
            ]), listElements)
        ]));
    }, $author$project$Page$Search$viewSearchFilterForm = F3($author$project$Page$Search$viewSearchFilterForm_fn);
    var $author$project$Page$Search$withPersonFilterForm_fn = function (env, model) {
        var selectedPeople = $elm$core$List$filterMap_fn($author$project$Page$Search$peopleFilters_a0, $author$project$Search$Result$query(model.p));
        var suggestions = function (_v2) {
            return $elm$core$List$map_fn($elm$core$Tuple$first, $elm$core$List$filter_fn(function (_v1) {
                var personId = _v1.a;
                return !($elm$core$List$member_fn(personId, selectedPeople) || _Utils_eq(env.pY, $elm$core$Maybe$Just(personId)));
            }, $elm$core$List$take_fn(6, A2($author$project$Util$Misc$sortByReverse, $elm$core$Tuple$second, $elm$core$Dict$toList(env.oq.iz)))));
        };
        var results = $elm$core$List$map_fn($elm$core$Tuple$first, A2($author$project$Util$Misc$sortByReverse, $elm$core$Tuple$second, A2($author$project$Firestore$Collection$filterMap, F2(function (personId, person) {
            var score = $author$project$Util$SimpleSearch$score_fn(model.aH, _List_Cons(person.b, person.lo));
            return ((score <= 0) || (_Utils_eq($elm$core$Maybe$Just(personId), env.pY) || person.lh)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple2(personId, score));
        }), env.iz)));
        var options = $elm$core$String$isEmpty(model.aH) ? $author$project$Page$Search$Suggesting((new $$Record147(selectedPeople, suggestions(0)))) : $author$project$Page$Search$Searching({ fX: results });
        var optionIsSelected = function (personId) {
            return $elm$core$List$member_fn(personId, selectedPeople);
        };
        var onPress = function (personId) {
            var _v0 = $author$project$Firestore$Collection$get_fn(personId, env.iz);
            if (!_v0.$) {
                var person = _v0.a;
                return A4($author$project$Util$Misc$if_, optionIsSelected(personId), $author$project$Page$Search$RemoveFilter, $author$project$Page$Search$AddFilter, $author$project$Search$Query$With($author$project$Search$Query$Person_fn(person.b, personId)));
            }
            else {
                return $author$project$Page$Search$NoOp("Person not found");
            }
        };
        return $author$project$Page$Search$SearchFilterForm((new $$Record148("Search for person to filter", onPress, optionIsSelected, options, "Ex. Sam Jones", function (personId) {
            return $author$project$View$Util$whenJust_fn($author$project$Firestore$Collection$get_fn(personId, env.iz), A2($elm$core$Basics$composeR, $author$project$Page$Search$personDisplayText, $mdgriffith$elm_ui$Element$text));
        }, 300)));
    }, $author$project$Page$Search$withPersonFilterForm = F2($author$project$Page$Search$withPersonFilterForm_fn);
    var $author$project$Page$Search$viewFilterButton_fn = function (env, model, filterForm) {
        var viewFilterFormHelp = function (toConfig) {
            var _v3 = A2(toConfig, env, model);
            if (!_v3.$) {
                var searchFilterFormConfig = _v3.a;
                return $author$project$Page$Search$viewSearchFilterForm_fn(env, model, searchFilterFormConfig);
            }
            else {
                var selectFilterFormConfig = _v3.a;
                return $author$project$Page$Search$viewBasicFilterForm_fn(env, selectFilterFormConfig);
            }
        }, viewFilterFormHelp_unwrapped = function (toConfig) {
            var _v3 = toConfig(env, model);
            if (!_v3.$) {
                var searchFilterFormConfig = _v3.a;
                return $author$project$Page$Search$viewSearchFilterForm_fn(env, model, searchFilterFormConfig);
            }
            else {
                var selectFilterFormConfig = _v3.a;
                return $author$project$Page$Search$viewBasicFilterForm_fn(env, selectFilterFormConfig);
            }
        };
        var isSelected = _Utils_eq(model.dh, $elm$core$Maybe$Just(filterForm));
        var filterFormView = function () {
            switch (filterForm) {
                case 1:
                    return viewFilterFormHelp($author$project$Page$Search$withPersonFilterForm);
                case 0:
                    return viewFilterFormHelp($author$project$Page$Search$inMeetingFilterForm);
                case 2:
                    return viewFilterFormHelp($author$project$Page$Search$dateFilterForm);
                default:
                    return viewFilterFormHelp($author$project$Page$Search$fileTypeFilterForm);
            }
        }();
        var _v0 = function () {
            var _v1 = $author$project$Page$Search$filterFormButtonText_fn(env, $author$project$Search$Result$query(model.p), filterForm);
            if (!_v1.$) {
                var txt = _v1.a;
                return _Utils_Tuple3(txt, env.nI.a6, env.nI.aL);
            }
            else {
                var txt = _v1.a;
                return _Utils_Tuple3(txt, env.nI.aL, env.nI.aT);
            }
        }();
        var buttonText = _v0.a;
        var backgroundColor = _v0.b;
        var fontColor = _v0.c;
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$below($author$project$View$Util$when_fn(isSelected, filterFormView))
        ]), $mdgriffith$elm_ui$Element$Input$button_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Border$width(1),
            $mdgriffith$elm_ui$Element$Border$color(env.nI.aQ),
            $mdgriffith$elm_ui$Element$Border$rounded(5),
            $mdgriffith$elm_ui$Element$Background$color(backgroundColor),
            $mdgriffith$elm_ui$Element$padding(6),
            $author$project$Page$Search$preventBlurringOnMousedown
        ]), {
            fF: $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(10),
                $mdgriffith$elm_ui$Element$Font$color(fontColor)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$bold,
                    $mdgriffith$elm_ui$Element$Font$size(13)
                ]), $mdgriffith$elm_ui$Element$text(buttonText)),
                $author$project$View$Icon$icon_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(10),
                    $mdgriffith$elm_ui$Element$rotate($elm$core$Basics$degrees($author$project$Util$Misc$if__fn(isSelected, 180, 0))),
                    $author$project$View$Util$style_fn("transition", "transform ease-out 100ms")
                ]), 0, "chevron-down")
            ])),
            nz: $elm$core$Maybe$Just($author$project$Page$Search$SetSelectedFilterForm($author$project$Util$Misc$toJustIf_fn($elm_community$maybe_extra$Maybe$Extra$isNothing(model.dh), filterForm)))
        }));
    }, $author$project$Page$Search$viewFilterButton = F3($author$project$Page$Search$viewFilterButton_fn);
    var $author$project$Page$Search$viewFilterForms_fn = function (env, model) {
        var fitlerForms = function () {
            var _v0 = model.e1;
            switch (_v0) {
                case 0:
                    return _List_fromArray([1, 0, 2]);
                case 1:
                    return _List_Nil;
                default:
                    return _List_fromArray([1, 0, 2, 3]);
            }
        }();
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$Util$Misc$if__fn($elm$core$List$isEmpty(fitlerForms), 0, 55))),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$paddingXY_fn($author$project$Page$Search$xPadding, 0),
            $mdgriffith$elm_ui$Element$spacing(15)
        ]), $elm$core$List$map_fn(A2($author$project$Page$Search$viewFilterButton, env, model), fitlerForms));
    }, $author$project$Page$Search$viewFilterForms = F2($author$project$Page$Search$viewFilterForms_fn);
    var $author$project$Page$Search$ShowSearch = { $: 10 };
    var $author$project$Page$Search$breakpoints = { m6: 550, oD: 730 };
    var $author$project$Search$Result$isEmpty = function (_v0) {
        var items = _v0.mA;
        return $elm$core$Dict$isEmpty(items);
    };
    var $author$project$Search$Result$toAttachments = function (_v0) {
        var items = _v0.mA;
        return $elm$core$List$filterMap_fn(function (_v1) {
            var k = _v1.a;
            var v = _v1.b;
            if (v.$ === 2) {
                var doc = v.a;
                return $elm$core$Maybe$Just(_Utils_Tuple2(k, doc));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, $elm$core$Dict$toList(items));
    };
    var $author$project$Search$Result$toNotes = function (_v0) {
        var items = _v0.mA;
        return $elm$core$List$filterMap_fn(function (_v1) {
            var k = _v1.a;
            var v = _v1.b;
            if (v.$ === 1) {
                var doc = v.a;
                return $elm$core$Maybe$Just(_Utils_Tuple2(k, doc));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, $elm$core$Dict$toList(items));
    };
    var $author$project$Search$Result$toPeople = function (_v0) {
        var items = _v0.mA;
        return $elm$core$List$filterMap_fn(function (_v1) {
            var k = _v1.a;
            var v = _v1.b;
            if (!v.$) {
                var doc = v.a;
                return $elm$core$Maybe$Just(_Utils_Tuple2(k, doc));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, $elm$core$Dict$toList(items));
    };
    var $author$project$Lib$Highlighter$Text = $elm$core$Basics$identity;
    var $author$project$Lib$Highlighter$Match = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Lib$Highlighter$NonMatch = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Util$String$isSpacer = function (str) {
        return (str === " ") || (str === "\n");
    };
    var $author$project$Util$String$beginsWithSpacer_a0 = $elm$core$String$left(1), $author$project$Util$String$beginsWithSpacer_a1 = $author$project$Util$String$isSpacer, $author$project$Util$String$beginsWithSpacer = A2($elm$core$Basics$composeR, $author$project$Util$String$beginsWithSpacer_a0, $author$project$Util$String$beginsWithSpacer_a1);
    var $author$project$Lib$Highlighter$consNonMatch_fn = function (str, acc) {
        return $elm$core$String$isEmpty(str) ? acc : _List_Cons($author$project$Lib$Highlighter$NonMatch(str), acc);
    }, $author$project$Lib$Highlighter$consNonMatch = F2($author$project$Lib$Highlighter$consNonMatch_fn);
    var $author$project$Lib$Highlighter$trimmable = $elm$core$Set$fromList(_List_fromArray([":", ",", ";", "\\", "|", "/", "<", "(", "-", ".", "\n", " ", "[", "{"]));
    var $author$project$Lib$Highlighter$customTrimRight = function (str) {
        var helper = function (newStr) {
            helper: while (true) {
                var _v0 = $elm$core$String$uncons(newStr);
                if (_v0.$ === 1) {
                    return newStr;
                }
                else {
                    var _v1 = _v0.a;
                    var _char = _v1.a;
                    var xs = _v1.b;
                    if (!$elm$core$Set$member_fn(_char, $author$project$Lib$Highlighter$trimmable)) {
                        return newStr;
                    }
                    else {
                        var $temp$newStr = xs;
                        newStr = $temp$newStr;
                        continue helper;
                    }
                }
            }
        };
        return $elm$core$String$reverse(helper($elm$core$String$reverse(str)));
    };
    var $author$project$Lib$Highlighter$endOfWordDelimeters = $elm$core$Set$fromList(_List_fromArray([" ", "\n", "-", ":", "\"", ";", "\\", "/"]));
    var $elm_community$string_extra$String$Extra$isBlank = function (string) {
        return _Regex_contains_fn($elm$core$Basics$composeR_fn($elm_community$string_extra$String$Extra$regexFromString_a0, $elm_community$string_extra$String$Extra$regexFromString_a1, "^\\s*$"), string);
    };
    var $elm_community$string_extra$String$Extra$nonBlank = function (string) {
        return $elm_community$string_extra$String$Extra$isBlank(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
    };
    var $author$project$Lib$Highlighter$firstWord = function (body) {
        var helper = F2(function (mUncons, count) {
            helper: while (true) {
                if (mUncons.$ === 1) {
                    return count;
                }
                else {
                    var _v1 = mUncons.a;
                    var x = _v1.a;
                    var xs = _v1.b;
                    if ($elm$core$Set$member_fn($elm$core$String$fromChar(x), $author$project$Lib$Highlighter$endOfWordDelimeters)) {
                        return count;
                    }
                    else {
                        var $temp$mUncons = $elm$core$String$uncons(xs), $temp$count = count + 1;
                        mUncons = $temp$mUncons;
                        count = $temp$count;
                        continue helper;
                    }
                }
            }
        });
        return $elm_community$string_extra$String$Extra$nonBlank(function (len) {
            return $elm$core$String$left_fn(len, body);
        }(A2(helper, $elm$core$String$uncons(body), 0)));
    };
    var $elm$core$String$trimRight = _String_trimRight;
    var $author$project$Util$String$Right = 1;
    var $author$project$Util$String$wordsToHelp_fn = function (direction, _v0, str) {
        var maxWords = _v0.ia;
        var maxChar = _v0.eb;
        var words = $elm$core$String$words(str);
        var reverseIfLeft = function () {
            if (direction === 1) {
                return $elm$core$Basics$identity;
            }
            else {
                return $elm$core$List$reverse;
            }
        }();
        var dontExceedCharCount = F3(function (count, acc, words_) {
            dontExceedCharCount: while (true) {
                if (!words_.b) {
                    return $elm$core$List$reverse(acc);
                }
                else {
                    var x = words_.a;
                    var xs = words_.b;
                    var currentCount = $elm$core$String$length(x) + count;
                    if (_Utils_cmp(currentCount, maxChar) > 0) {
                        return $elm$core$List$reverse(acc);
                    }
                    else {
                        var $temp$count = currentCount + 1, $temp$acc = _List_Cons(x, acc), $temp$words_ = xs;
                        count = $temp$count;
                        acc = $temp$acc;
                        words_ = $temp$words_;
                        continue dontExceedCharCount;
                    }
                }
            }
        });
        return $elm$core$String$join_fn(" ", reverseIfLeft(A3(dontExceedCharCount, 0, _List_Nil, $elm$core$List$take_fn(maxWords, reverseIfLeft(words)))));
    }, $author$project$Util$String$wordsToHelp = F3($author$project$Util$String$wordsToHelp_fn);
    var $author$project$Util$String$wordsToRight_a0 = 1, $author$project$Util$String$wordsToRight = $author$project$Util$String$wordsToHelp($author$project$Util$String$wordsToRight_a0);
    var $author$project$Lib$Highlighter$ellipsisHelper_fn = function (_v0, maxChar, matches) {
        ellipsisHelper: while (true) {
            var acc = _v0.cz;
            var currentCount = _v0.cM;
            var addEllipsis = function (finalAcc) {
                if (!finalAcc.b) {
                    return _List_Nil;
                }
                else {
                    if (finalAcc.a.$ === 1) {
                        var str = finalAcc.a.a;
                        var xs = finalAcc.b;
                        return _List_Cons($author$project$Lib$Highlighter$NonMatch("..."), _List_Cons($author$project$Lib$Highlighter$NonMatch($author$project$Lib$Highlighter$customTrimRight(str)), xs));
                    }
                    else {
                        return _List_Cons($author$project$Lib$Highlighter$NonMatch("..."), finalAcc);
                    }
                }
            };
            if (!matches.b) {
                return acc;
            }
            else {
                if (matches.a.$ === 1) {
                    var current = matches.a.a;
                    var xs = matches.b;
                    var returnLeadingSpace = function (trimmedAndChomped) {
                        return $elm$core$Basics$composeR_fn($author$project$Util$String$beginsWithSpacer_a0, $author$project$Util$String$beginsWithSpacer_a1, current) ? (" " + trimmedAndChomped) : trimmedAndChomped;
                    };
                    var newCurrentCount = $elm$core$String$length(current) + currentCount;
                    if (_Utils_cmp(newCurrentCount, maxChar) > 0) {
                        return addEllipsis(function (s) {
                            return $author$project$Lib$Highlighter$consNonMatch_fn(s, acc);
                        }($elm$core$String$trimRight(returnLeadingSpace($author$project$Util$String$wordsToHelp_fn($author$project$Util$String$wordsToRight_a0, (new $$Record149(maxChar - currentCount, maxChar * 3)), current)))));
                    }
                    else {
                        var $temp$_v0 = {
                            cz: _List_Cons($author$project$Lib$Highlighter$NonMatch(current), acc),
                            cM: newCurrentCount
                        }, $temp$maxChar = maxChar, $temp$matches = xs;
                        _v0 = $temp$_v0;
                        maxChar = $temp$maxChar;
                        matches = $temp$matches;
                        continue ellipsisHelper;
                    }
                }
                else {
                    if (matches.b.b && (matches.b.a.$ === 1)) {
                        var current = matches.a.a;
                        var xs = matches.b;
                        var next = xs.a.a;
                        var restOfWordLength = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$String$length, $author$project$Lib$Highlighter$firstWord(next)));
                        var newCurrentCount = $elm$core$String$length(current) + currentCount;
                        if (_Utils_cmp(newCurrentCount + restOfWordLength, maxChar) > 0) {
                            return addEllipsis(acc);
                        }
                        else {
                            var $temp$_v0 = {
                                cz: _List_Cons($author$project$Lib$Highlighter$Match(current), acc),
                                cM: newCurrentCount
                            }, $temp$maxChar = maxChar, $temp$matches = xs;
                            _v0 = $temp$_v0;
                            maxChar = $temp$maxChar;
                            matches = $temp$matches;
                            continue ellipsisHelper;
                        }
                    }
                    else {
                        var current = matches.a.a;
                        var xs = matches.b;
                        var newCurrentCount = $elm$core$String$length(current) + currentCount;
                        if (_Utils_cmp(newCurrentCount, maxChar) > 0) {
                            return addEllipsis(acc);
                        }
                        else {
                            var $temp$_v0 = {
                                cz: _List_Cons($author$project$Lib$Highlighter$Match(current), acc),
                                cM: newCurrentCount
                            }, $temp$maxChar = maxChar, $temp$matches = xs;
                            _v0 = $temp$_v0;
                            maxChar = $temp$maxChar;
                            matches = $temp$matches;
                            continue ellipsisHelper;
                        }
                    }
                }
            }
        }
    }, $author$project$Lib$Highlighter$ellipsisHelper = F3($author$project$Lib$Highlighter$ellipsisHelper_fn);
    var $author$project$Lib$Highlighter$ellipsisAfter_fn = function (maxChar, _v0) {
        var text = _v0;
        return $elm$core$List$reverse($author$project$Lib$Highlighter$ellipsisHelper_fn({ cz: _List_Nil, cM: 0 }, maxChar, text));
    }, $author$project$Lib$Highlighter$ellipsisAfter = F2($author$project$Lib$Highlighter$ellipsisAfter_fn);
    var $author$project$Lib$Highlighter$consMatch_fn = function (str, acc) {
        return $elm$core$String$isEmpty(str) ? acc : _List_Cons($author$project$Lib$Highlighter$Match(str), acc);
    }, $author$project$Lib$Highlighter$consMatch = F2($author$project$Lib$Highlighter$consMatch_fn);
    var $author$project$Lib$Highlighter$startOfWordDelimeters = $elm$core$Set$insert_fn("'", $author$project$Lib$Highlighter$endOfWordDelimeters);
    var $author$project$Lib$Highlighter$matchQueryHelp_fn = function (query, bodyText) {
        var isBeginningOfWord = function (index) {
            if (!index) {
                return true;
            }
            else {
                return $elm$core$Set$member_fn(_String_slice_fn(index - 1, index, bodyText), $author$project$Lib$Highlighter$startOfWordDelimeters);
            }
        };
        var toWordRanges = function (index) {
            return isBeginningOfWord(index) ? $elm$core$Maybe$andThen_fn(function (word) {
                return _Utils_eq(query.eK, $rluiten$stemmer$Stemmer$stem(word)) ? $elm$core$Maybe$Just({
                    b6: index + $elm$core$String$length(word),
                    bF: index
                }) : (_String_startsWith_fn(query.eh, word) ? $elm$core$Maybe$Just({ b6: index + query.fG, bF: index }) : $elm$core$Maybe$Nothing);
            }, $elm$core$Maybe$map_fn($elm$core$String$toLower, $author$project$Lib$Highlighter$firstWord($elm$core$String$dropLeft_fn(index, bodyText)))) : $elm$core$Maybe$Nothing;
        };
        var indicesOf = function (queryText) {
            return $elm$core$Set$fromList(_String_indexes_fn($elm$core$String$toLower(queryText), $elm$core$String$toLower(bodyText)));
        };
        var indices = $elm$core$List$filterMap_fn(toWordRanges, $elm$core$Set$toList($elm$core$Set$union_fn(indicesOf(query.eK), indicesOf(query.eh))));
        var at = function (_v2) {
            var start = _v2.bF;
            var end = _v2.b6;
            return _String_slice_fn(start, end, bodyText);
        };
        var helper = F2(function (indices_, acc) {
            helper: while (true) {
                if (!indices_.b) {
                    return acc;
                }
                else {
                    if (!indices_.b.b) {
                        var last = indices_.a;
                        return $author$project$Lib$Highlighter$consNonMatch_fn($elm$core$String$dropLeft_fn(last.b6, bodyText), $author$project$Lib$Highlighter$consMatch_fn(at(last), acc));
                    }
                    else {
                        var current = indices_.a;
                        var xs = indices_.b;
                        var next = xs.a;
                        var $temp$indices_ = xs, $temp$acc = $author$project$Lib$Highlighter$consNonMatch_fn(at({ b6: next.bF, bF: current.b6 }), $author$project$Lib$Highlighter$consMatch_fn(at(current), acc));
                        indices_ = $temp$indices_;
                        acc = $temp$acc;
                        continue helper;
                    }
                }
            }
        });
        if (!indices.b) {
            return $author$project$Lib$Highlighter$consNonMatch_fn(bodyText, _List_Nil);
        }
        else {
            var first = indices.a;
            return $author$project$Lib$Highlighter$consNonMatch_fn(_String_slice_fn(0, first.bF, bodyText), $elm$core$List$reverse(A2(helper, indices, _List_Nil)));
        }
    }, $author$project$Lib$Highlighter$matchQueryHelp = F2($author$project$Lib$Highlighter$matchQueryHelp_fn);
    var $author$project$Lib$Highlighter$matchQuery = function (query) {
        return $elm$core$List$concatMap(function (match) {
            if (match.$ === 1) {
                var str = match.a;
                return $author$project$Lib$Highlighter$matchQueryHelp_fn(query, str);
            }
            else {
                return _List_fromArray([match]);
            }
        });
    };
    var $author$project$Lib$Highlighter$toQuery = function (query) {
        return {
            fG: $elm$core$String$length(query),
            eh: $elm$core$String$toLower(query),
            eK: $rluiten$stemmer$Stemmer$stem($elm$core$String$toLower(query))
        };
    };
    var $author$project$Lib$Highlighter$findHelp_fn = function (queryWords, matches) {
        findHelp: while (true) {
            if (!queryWords.b) {
                return matches;
            }
            else {
                var x = queryWords.a;
                var xs = queryWords.b;
                var $temp$queryWords = xs, $temp$matches = A2($author$project$Lib$Highlighter$matchQuery, $author$project$Lib$Highlighter$toQuery(x), matches);
                queryWords = $temp$queryWords;
                matches = $temp$matches;
                continue findHelp;
            }
        }
    }, $author$project$Lib$Highlighter$findHelp = F2($author$project$Lib$Highlighter$findHelp_fn);
    var $author$project$Lib$Highlighter$find_fn = function (query, body) {
        var _v0 = _Utils_Tuple2($elm$core$String$words(query), $elm$core$String$join_fn(" ", $elm$core$String$words(body)));
        var queryWords = _v0.a;
        var trimmedBody = _v0.b;
        return $author$project$Lib$Highlighter$findHelp_fn(queryWords, _List_fromArray([
            $author$project$Lib$Highlighter$NonMatch(trimmedBody)
        ]));
    }, $author$project$Lib$Highlighter$find = F2($author$project$Lib$Highlighter$find_fn);
    var $author$project$View$Util$preventClickPropagation = function (noOpMsg) {
        return $author$project$View$Util$stopPropagationOn_fn("click", noOpMsg("preventClickPropagation"));
    };
    var $author$project$Search$Bar$textHighlightColor = function (palette) {
        return $mdgriffith$elm_ui$Element$Font$color(palette.a6);
    };
    var $author$project$Lib$Highlighter$view_fn = function (_v0, attrs, _v1) {
        var multiline = _v0.ii;
        var mapMatch = _v0.h6;
        var matches = _v1;
        var wrapperEl = multiline ? $mdgriffith$elm_ui$Element$paragraph : $mdgriffith$elm_ui$Element$row;
        return A2(wrapperEl, attrs, $elm$core$List$map_fn(function (match) {
            if (!match.$) {
                var str = match.a;
                return mapMatch(str);
            }
            else {
                var str = match.a;
                return $mdgriffith$elm_ui$Element$text(str);
            }
        }, matches));
    }, $author$project$Lib$Highlighter$view = F3($author$project$Lib$Highlighter$view_fn);
    var $author$project$Search$Bar$viewHighlight = function (palette) {
        return $author$project$Lib$Highlighter$view({
            h6: A2($elm$core$Basics$composeR, $mdgriffith$elm_ui$Element$text, $mdgriffith$elm_ui$Element$el(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$bold,
                $author$project$Search$Bar$textHighlightColor(palette)
            ]))),
            ii: false
        });
    };
    var $author$project$Search$Bar$viewMonthAndDay_fn = function (timezoneUser, time) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(70)),
            $mdgriffith$elm_ui$Element$Font$size(14),
            $mdgriffith$elm_ui$Element$alignRight,
            $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0)
        ]), $mdgriffith$elm_ui$Element$text($ryannhg$date_format$DateFormat$formatWithLanguage_fn($ryannhg$date_format$DateFormat$format_a0, _List_fromArray([
            $ryannhg$date_format$DateFormat$monthNumber,
            $ryannhg$date_format$DateFormat$text("/"),
            $ryannhg$date_format$DateFormat$dayOfMonthNumber,
            $ryannhg$date_format$DateFormat$text("/"),
            $ryannhg$date_format$DateFormat$yearNumberLastTwo
        ]), timezoneUser, $author$project$Data$Time$toPosix_fn(timezoneUser, time))));
    }, $author$project$Search$Bar$viewMonthAndDay = F2($author$project$Search$Bar$viewMonthAndDay_fn);
    var $author$project$Search$Bar$viewAttachmentItem_fn = function (timezoneUser, noOp, palette, _v0, stringQuery, _v1) {
        var doc = _v1.ll;
        var nameWithoutExtension = $elm_community$string_extra$String$Extra$leftOfBack_fn(".", doc.kc.b8);
        var imageSize = 50;
        var thumbnailImage = function () {
            var _v2 = doc.kc.ct;
            if (!_v2.$) {
                var thumbnailUrl = _v2.a;
                return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$centerY,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(imageSize)),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(imageSize))
                ]), $mdgriffith$elm_ui$Element$image_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$pointer,
                    $mdgriffith$elm_ui$Element$Border$rounded(3),
                    $mdgriffith$elm_ui$Element$clip,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(imageSize, $mdgriffith$elm_ui$Element$shrink)),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$maximum_fn(imageSize, $mdgriffith$elm_ui$Element$shrink)),
                    $mdgriffith$elm_ui$Element$centerY,
                    $mdgriffith$elm_ui$Element$centerX,
                    $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "attachment-thumbnail")
                ]), (new $$Record114(doc.kc.b8 + " - thumbnail image", thumbnailUrl))));
            }
            else {
                return $author$project$View$Icon$icon_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(40),
                    $mdgriffith$elm_ui$Element$Font$color(palette.aS)
                ]), 3, $author$project$View$Icon$forMimeType(doc.kc.c1));
            }
        }();
        var displayName = $author$project$Util$Misc$if__fn($elm$core$String$isEmpty(nameWithoutExtension), doc.kc.b8, nameWithoutExtension);
        var title = $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
            $author$project$View$Util$preventClickPropagation(noOp),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$pointer,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.a9)
            ]))
        ]), {
            fF: $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(5),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
            ]), _List_fromArray([
                A3($author$project$Search$Bar$viewHighlight, palette, _List_Nil, $author$project$Lib$Highlighter$ellipsisAfter_fn(25, $author$project$Lib$Highlighter$find_fn(stringQuery, displayName))),
                $mdgriffith$elm_ui$Element$text("-"),
                A3($author$project$Search$Bar$viewHighlight, palette, _List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(14)
                ]), $author$project$Lib$Highlighter$ellipsisAfter_fn(25, $author$project$Lib$Highlighter$find_fn(stringQuery, doc.l.gj)))
            ])),
            dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteNote_fn(doc.ip, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(2)))
        });
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(60)),
            $mdgriffith$elm_ui$Element$spacing(18)
        ]), _List_fromArray([
            thumbnailImage,
            title,
            $author$project$Search$Bar$viewMonthAndDay_fn(timezoneUser, doc.l.gh)
        ]));
    }, $author$project$Search$Bar$viewAttachmentItem = F6($author$project$Search$Bar$viewAttachmentItem_fn);
    var $author$project$Page$Search$RouteToItem = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Page$Search$viewItem_fn = function (palette, itemViewer, _v0) {
        var index = _v0.a;
        var item = _v0.b;
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$pointer,
            $mdgriffith$elm_ui$Element$paddingXY_fn(15, 0),
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Search$RouteToItem(index)),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(palette.aM)
            ]))
        ]), itemViewer(item));
    }, $author$project$Page$Search$viewItem = F3($author$project$Page$Search$viewItem_fn);
    var $author$project$Util$String$Left = 0;
    var $author$project$Util$String$wordsToLeft_a0 = 0, $author$project$Util$String$wordsToLeft = $author$project$Util$String$wordsToHelp($author$project$Util$String$wordsToLeft_a0);
    var $author$project$Lib$Highlighter$ellipsisBefore_fn = function (config, _v0) {
        var text = _v0;
        var normalizedConfig = function () {
            var $r = config.$c();
            $r.eb = config.eb - 4;
            return $r;
        }();
        var ellipsisBeforeHelp = function (str) {
            var truncated = $author$project$Util$String$wordsToHelp_fn($author$project$Util$String$wordsToLeft_a0, normalizedConfig, str);
            return (_Utils_cmp($elm$core$String$length(str), $elm$core$String$length(truncated) + 1) < 1) ? str : ($elm$core$String$isEmpty(truncated) ? "..." : ("..." + (truncated + " ")));
        };
        if (!text.b) {
            return text;
        }
        else {
            if (!text.a.$) {
                return text;
            }
            else {
                if (!text.b.b) {
                    return text;
                }
                else {
                    var str = text.a.a;
                    var xs = text.b;
                    return ((config.eb <= 0) || (config.ia <= 0)) ? xs : _List_Cons($author$project$Lib$Highlighter$NonMatch(ellipsisBeforeHelp(str)), xs);
                }
            }
        }
    }, $author$project$Lib$Highlighter$ellipsisBefore = F2($author$project$Lib$Highlighter$ellipsisBefore_fn);
    var $author$project$Search$Bar$itemHeight = 40;
    var $author$project$Lib$Highlighter$length = function (_v0) {
        var text = _v0;
        return $elm$core$List$sum($elm$core$List$map_fn(function (match) {
            if (!match.$) {
                var str = match.a;
                return $elm$core$String$length(str);
            }
            else {
                var str = match.a;
                return $elm$core$String$length(str);
            }
        }, text));
    };
    var $author$project$Search$Bar$viewNoteItem_fn = function (timezoneUser, palette, responsiveMode, stringQuery, _v0) {
        var doc = _v0.ll;
        var primaryText = $author$project$Lib$Highlighter$ellipsisAfter_fn(25, $author$project$Lib$Highlighter$find_fn(stringQuery, $author$project$Util$Misc$if__fn($elm$core$String$isEmpty(doc.gj), "(Untitled)", doc.gj)));
        var primaryLength = $author$project$Lib$Highlighter$length(primaryText);
        var primaryElement = A3($author$project$Search$Bar$viewHighlight, palette, _List_fromArray([
            $author$project$View$Styling$paddingRight(12)
        ]), primaryText);
        var maybePaperclip = $author$project$View$Util$when_fn($author$project$Data$Note$hasAttachment(doc), $author$project$View$Icon$icon_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(palette.a7),
            $mdgriffith$elm_ui$Element$Font$size(16)
        ]), 2, "paperclip"));
        var maybeImageIcon = $author$project$View$Util$when_fn($elm$core$Basics$composeR_fn($author$project$Data$Note$hasImage_a0, $author$project$Data$Note$hasImage_a1, doc), $author$project$View$Icon$icon_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(palette.a7),
            $mdgriffith$elm_ui$Element$Font$size(16)
        ]), 2, "image"));
        var badges = $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(4)
        ]), _List_fromArray([maybeImageIcon, maybePaperclip]));
        var _v1 = function () {
            switch (responsiveMode) {
                case 0:
                    return {
                        aW: 80 - primaryLength,
                        aX: 4,
                        eB: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$size(15),
                            $mdgriffith$elm_ui$Element$moveDown(1)
                        ])
                    };
                case 1:
                    return {
                        aW: 52 - primaryLength,
                        aX: 2,
                        eB: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$size(14),
                            $mdgriffith$elm_ui$Element$moveDown(1)
                        ])
                    };
                default:
                    return {
                        aW: 0,
                        aX: 0,
                        eB: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$size(13),
                            $mdgriffith$elm_ui$Element$moveDown(2)
                        ])
                    };
            }
        }();
        var secondaryAttrs = _v1.eB;
        var maxWordsBefore = _v1.aX;
        var maxChars = _v1.aW;
        var secondaryElement = A3($author$project$Search$Bar$viewHighlight, palette, _List_Cons($mdgriffith$elm_ui$Element$Font$color(palette.aR), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$clipX, secondaryAttrs)))), $author$project$Lib$Highlighter$ellipsisAfter_fn(maxChars, $author$project$Lib$Highlighter$ellipsisBefore_fn((new $$Record149(26, maxWordsBefore)), $author$project$Lib$Highlighter$find_fn(stringQuery, doc.fc))));
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$Search$Bar$itemHeight))
        ]), _List_fromArray([
            primaryElement,
            secondaryElement,
            badges,
            $author$project$Search$Bar$viewMonthAndDay_fn(timezoneUser, doc.gh)
        ]));
    }, $author$project$Search$Bar$viewNoteItem = F5($author$project$Search$Bar$viewNoteItem_fn);
    var $author$project$Lib$Highlighter$matchCount = function (_v0) {
        var text = _v0;
        return $elm$core$List$length($elm$core$List$filter_fn(function (match) {
            if (!match.$) {
                return true;
            }
            else {
                return false;
            }
        }, text));
    };
    var $author$project$Lib$Highlighter$hasMatches = function (text) {
        return $author$project$Lib$Highlighter$matchCount(text) > 0;
    };
    var $author$project$Search$Bar$viewPersonItem_fn = function (palette, responsiveMode, stringQuery, _v0) {
        var doc = _v0.ll;
        var primaryText = $author$project$Lib$Highlighter$find_fn(stringQuery, $author$project$Util$Misc$if__fn($elm$core$String$isEmpty(doc.b), "(Untitled)", doc.b));
        var primaryElement = A3($author$project$Search$Bar$viewHighlight, palette, _List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(1)),
            $author$project$View$Styling$paddingRight(15)
        ]), primaryText);
        var _v1 = function () {
            switch (responsiveMode) {
                case 0:
                    return {
                        aW: 70,
                        aX: 4,
                        eC: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$size(15),
                            $mdgriffith$elm_ui$Element$moveDown(1)
                        ])
                    };
                case 1:
                    return {
                        aW: 55,
                        aX: 2,
                        eC: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$size(14),
                            $mdgriffith$elm_ui$Element$moveDown(1)
                        ])
                    };
                default:
                    return {
                        aW: 55,
                        aX: 1,
                        eC: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$size(13),
                            $mdgriffith$elm_ui$Element$moveDown(2)
                        ])
                    };
            }
        }();
        var secondaryAtts = _v1.eC;
        var maxWordsBefore = _v1.aX;
        var maxChars = _v1.aW;
        var secondaryText = function () {
            var _v3 = $elm_community$list_extra$List$Extra$find_fn($elm$core$String$contains(stringQuery), doc.lo);
            if (!_v3.$) {
                var email = _v3.a;
                return $author$project$Lib$Highlighter$find_fn(stringQuery, email);
            }
            else {
                var bioMatches = $author$project$Lib$Highlighter$find_fn(stringQuery, doc.ko);
                return $author$project$Lib$Highlighter$hasMatches(bioMatches) ? $author$project$Lib$Highlighter$ellipsisBefore_fn((new $$Record149(26, maxWordsBefore)), bioMatches) : $author$project$Lib$Highlighter$find_fn(stringQuery, $elm$core$Maybe$withDefault_fn("", $elm$core$List$head(doc.lo)));
            }
        }();
        var secondaryElement = A3($author$project$Search$Bar$viewHighlight, palette, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(3)), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$clipX, _List_Cons($mdgriffith$elm_ui$Element$Font$color(palette.aR), secondaryAtts)))), $author$project$Lib$Highlighter$ellipsisAfter_fn(maxChars, secondaryText));
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$Search$Bar$itemHeight))
        ]), _List_fromArray([primaryElement, secondaryElement]));
    }, $author$project$Search$Bar$viewPersonItem = F4($author$project$Search$Bar$viewPersonItem_fn);
    var $author$project$Page$Search$viewResults_fn = function (env, model) {
        var stringQuery = $elm$core$Basics$composeR_fn($author$project$Search$Query$stringQuery_a0, $author$project$Search$Query$stringQuery_a1, $author$project$Search$Result$query(model.p));
        var responsiveMode = $author$project$View$Responsive$mode_fn($author$project$Page$Search$breakpoints, env.p1);
        var viewItemHelp = function (viewFn) {
            return A2($author$project$Page$Search$viewItem, env.nI, A3(viewFn, env.nI, responsiveMode, stringQuery));
        }, viewItemHelp_unwrapped = function (viewFn) {
            return A2($author$project$Page$Search$viewItem, env.nI, viewFn(env.nI, responsiveMode, stringQuery));
        };
        var noResultstext = "No results" + $author$project$Util$Misc$if__fn($elm$core$String$isEmpty(stringQuery), "", " for \"" + (stringQuery + "\""));
        var _v0 = _Utils_Tuple3($elm$core$List$map_fn(viewItemHelp($author$project$Search$Bar$viewPersonItem), $author$project$Search$Result$toPeople(model.p)), $elm$core$List$map_fn(viewItemHelp($author$project$Search$Bar$viewNoteItem(env.pu)), $author$project$Search$Result$toNotes(model.p)), $elm$core$List$map_fn(viewItemHelp(A2($author$project$Search$Bar$viewAttachmentItem, env.pu, $author$project$Page$Search$NoOp)), $author$project$Search$Result$toAttachments(model.p)));
        var people = _v0.a;
        var notes = _v0.b;
        var attachments = _v0.c;
        var resultElements = $elm$core$List$concat($elm$core$List$intersperse_fn(_List_fromArray([
            $author$project$View$Util$spacer(10)
        ]), $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not), _List_fromArray([people, notes, attachments]))));
        return $author$project$Search$Result$isEmpty(model.p) ? $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$spacing(20),
            $mdgriffith$elm_ui$Element$paddingXY_fn(0, 40)
        ]), _List_fromArray([
            $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(50),
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$Font$color(env.nI.a7)
            ]), 3, "telescope"),
            A3($author$project$View$Styling$h3, env.nI, _List_fromArray([$mdgriffith$elm_ui$Element$centerX]), noResultstext),
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$pointer,
                    $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Search$ShowSearch),
                    $mdgriffith$elm_ui$Element$Font$underline,
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.ba)
                ]), $mdgriffith$elm_ui$Element$text("Try another search")),
                $mdgriffith$elm_ui$Element$text(" or "),
                $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$underline,
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.ba)
                ]), {
                    fF: $mdgriffith$elm_ui$Element$text("go back home"),
                    dt: "/"
                })
            ]))
        ])) : $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), resultElements);
    }, $author$project$Page$Search$viewResults = F2($author$project$Page$Search$viewResults_fn);
    var $author$project$Page$Search$view_fn = function (env, model) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$paddingXY_fn(25, 110),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(850, $mdgriffith$elm_ui$Element$fill))
        ]), A3($author$project$View$Layout$card, env.nI, _List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(6),
            $mdgriffith$elm_ui$Element$padding(0),
            $author$project$View$Util$createStackingContext
        ]), _List_fromArray([
            $author$project$Page$Search$viewCurrentQuery_fn(model.e1, model.p),
            $author$project$Page$Search$viewCategoryTabs_fn(env.nI, model),
            $author$project$Page$Search$viewFilterForms_fn(env, model),
            $author$project$Page$Search$viewResults_fn(env, model)
        ])));
    }, $author$project$Page$Search$view = F2($author$project$Page$Search$view_fn);
    var $author$project$Page$Settings$ReloadPreloadedContent = { $: 15 };
    var $author$project$Page$Settings$ResetNotificationBell = { $: 14 };
    var $author$project$Page$Settings$UnlinkCalendar = function (a) {
        return { $: 13, a: a };
    };
    var $author$project$Page$Settings$SetAnalyticsEnabled = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Data$Settings$analyticsEnabled_a0 = $author$project$Data$Settings$get, $author$project$Data$Settings$analyticsEnabled_a1 = function ($) {
        return $.cC;
    }, $author$project$Data$Settings$analyticsEnabled = A2($elm$core$Basics$composeR, $author$project$Data$Settings$analyticsEnabled_a0, $author$project$Data$Settings$analyticsEnabled_a1);
    var $elm$html$Html$br = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "br"), $elm$html$Html$br_fn = $elm$html$Html$br.a2;
    var $author$project$View$Util$br = $mdgriffith$elm_ui$Element$html($elm$html$Html$br_fn(_List_Nil, _List_Nil));
    var $author$project$View$Widgets$checkbox_a0 = 1, $author$project$View$Widgets$checkbox_a1 = $elm$core$Maybe$Nothing, $author$project$View$Widgets$checkbox = A2($author$project$View$Widgets$sizedCheckbox, $author$project$View$Widgets$checkbox_a0, $author$project$View$Widgets$checkbox_a1);
    var $author$project$Page$Settings$analyticsSetting = function (env) {
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(10)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(9)),
                    $mdgriffith$elm_ui$Element$spacing(6),
                    $mdgriffith$elm_ui$Element$moveRight(10)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Help us improve Witful by sending usage data and diagnostics."),
                    $author$project$View$Util$br,
                    $mdgriffith$elm_ui$Element$text("Your shared data will not include your private information like note content, "),
                    $mdgriffith$elm_ui$Element$text("calendar event data, or data about people like name or email address.")
                ])),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(2))
                ]), $mdgriffith$elm_ui$Element$none)
            ])),
            $author$project$View$Widgets$sizedCheckbox_fn($author$project$View$Widgets$checkbox_a0, $author$project$View$Widgets$checkbox_a1, {
                kH: $elm$core$Basics$composeR_fn($author$project$Data$Settings$analyticsEnabled_a0, $author$project$Data$Settings$analyticsEnabled_a1, env),
                fF: $mdgriffith$elm_ui$Element$text("Share analytics"),
                nu: $author$project$Page$Settings$SetAnalyticsEnabled
            }, env.nI)
        ]));
    };
    var $author$project$Content$ImagePaths$signupExtensionScreenshot = "/static/img/signup-extension-screenshot.png";
    var $author$project$Page$Settings$browserExtensionLink = function (env) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), $mdgriffith$elm_ui$Element$wrappedRow_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(10)
        ]), $elm$core$List$reverse(_List_fromArray([
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$minimum_fn(200, $mdgriffith$elm_ui$Element$fill)),
                $mdgriffith$elm_ui$Element$spacing(20)
            ]), _List_fromArray([
                $author$project$View$Widgets$linkButtonHelp_fn($author$project$View$Widgets$linkButton_a0, {
                    hp: _List_fromArray([
                        $mdgriffith$elm_ui$Element$Background$color(env.nI.a1),
                        $mdgriffith$elm_ui$Element$Border$width(0),
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.ba),
                        $mdgriffith$elm_ui$Element$padding(10),
                        $mdgriffith$elm_ui$Element$centerY,
                        $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Background$color(env.nI.a3)
                        ])),
                        $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Background$color(env.nI.a3)
                        ])),
                        $mdgriffith$elm_ui$Element$Font$size(14)
                    ]),
                    l7: $elm$core$Maybe$Just(_Utils_Tuple3(2, "external-link", _List_Nil)),
                    dt: "https://chrome.google.com/webstore/detail/witful/ajaichojcfflncoaihhaibcodjkbcpmn"
                }, "Open in Chrome Webstore"),
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$center,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(250, $mdgriffith$elm_ui$Element$fill)),
                    $mdgriffith$elm_ui$Element$centerX
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Use our Chrome extension to quickly access Witful from within your calendar.")
                ]))
            ])),
            $mdgriffith$elm_ui$Element$image_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$minimum_fn(150, $mdgriffith$elm_ui$Element$maximum_fn(300, $mdgriffith$elm_ui$Element$fill)))
            ]), (new $$Record114("Witful Chrome Extension Screenshot", $author$project$Content$ImagePaths$signupExtensionScreenshot)))
        ]))));
    };
    var $author$project$Page$Settings$AnalyticsEvent = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Page$Settings$ManyMsgs = function (a) {
        return { $: 12, a: a };
    };
    var $author$project$Page$Settings$SetArmyTime = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Page$Settings$SetDefaultToAttendeesTab = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Page$Settings$SetKeyboardShortcutEnabled = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Page$Settings$SetNextMeetingNotifications = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Page$Settings$SetReverseNoteColumns = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Page$Settings$SetShowWeekends = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Analytics$SettingsArmyTime = function (a) {
        return { $: 50, a: a };
    };
    var $author$project$Analytics$SettingsKeyboardShortcuts = function (a) {
        return { $: 48, a: a };
    };
    var $author$project$Analytics$SettingsReverseNoteColumns = function (a) {
        return { $: 52, a: a };
    };
    var $author$project$Analytics$SettingsSetDefaultToAttendeesTab = function (a) {
        return { $: 53, a: a };
    };
    var $author$project$Analytics$SettingsShowWeekends = function (a) {
        return { $: 51, a: a };
    };
    var $author$project$Page$Settings$ShowKeyboardShortcuts = { $: 11 };
    var $author$project$Data$Settings$nextMeetingNotifications_a0 = $author$project$Data$Settings$get, $author$project$Data$Settings$nextMeetingNotifications_a1 = function ($) {
        return $.c3;
    }, $author$project$Data$Settings$nextMeetingNotifications = A2($elm$core$Basics$composeR, $author$project$Data$Settings$nextMeetingNotifications_a0, $author$project$Data$Settings$nextMeetingNotifications_a1);
    var $author$project$View$Styling$paddingLeft = function (amount) {
        return $mdgriffith$elm_ui$Element$paddingEach($$update__mE($author$project$View$Styling$edges, amount));
    };
    var $author$project$Page$Settings$settingsInputs = function (env) {
        var checkboxRow = $mdgriffith$elm_ui$Element$row(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(10),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$minimum_fn(30, $mdgriffith$elm_ui$Element$shrink))
        ]));
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $author$project$View$Styling$paddingLeft(10),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(5)
        ]), _List_fromArray([
            checkboxRow(_List_fromArray([
                $author$project$View$Widgets$sizedCheckbox_fn($author$project$View$Widgets$checkbox_a0, $author$project$View$Widgets$checkbox_a1, {
                    kH: $elm$core$Basics$composeR_fn($author$project$Data$Settings$isShowArmyTime_a0, $author$project$Data$Settings$isShowArmyTime_a1, env),
                    fF: $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Use 24 Hour Time")
                    ])),
                    nu: function (flag) {
                        return $author$project$Page$Settings$ManyMsgs(_List_fromArray([
                            $author$project$Page$Settings$SetArmyTime(flag),
                            $author$project$Page$Settings$AnalyticsEvent($author$project$Analytics$SettingsArmyTime(flag))
                        ]));
                    }
                }, env.nI)
            ])),
            checkboxRow(_List_fromArray([
                $author$project$View$Widgets$sizedCheckbox_fn($author$project$View$Widgets$checkbox_a0, $author$project$View$Widgets$checkbox_a1, {
                    kH: $elm$core$Basics$composeR_fn($author$project$Data$Settings$isShowWeekends_a0, $author$project$Data$Settings$isShowWeekends_a1, env),
                    fF: $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Display weekends")
                    ])),
                    nu: function (flag) {
                        return $author$project$Page$Settings$ManyMsgs(_List_fromArray([
                            $author$project$Page$Settings$SetShowWeekends(flag),
                            $author$project$Page$Settings$AnalyticsEvent($author$project$Analytics$SettingsShowWeekends(flag))
                        ]));
                    }
                }, env.nI)
            ])),
            checkboxRow(_List_fromArray([
                $author$project$View$Widgets$sizedCheckbox_fn($author$project$View$Widgets$checkbox_a0, $author$project$View$Widgets$checkbox_a1, {
                    kH: $elm$core$Basics$composeR_fn($author$project$Data$Settings$keyboardShortcutsEnabled_a0, $author$project$Data$Settings$keyboardShortcutsEnabled_a1, env),
                    fF: $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Enable keyboard shortcuts")
                    ])),
                    nu: function (flag) {
                        return $author$project$Page$Settings$ManyMsgs(_List_fromArray([
                            $author$project$Page$Settings$SetKeyboardShortcutEnabled(flag),
                            $author$project$Page$Settings$AnalyticsEvent($author$project$Analytics$SettingsKeyboardShortcuts(flag))
                        ]));
                    }
                }, env.nI),
                $mdgriffith$elm_ui$Element$el_fn(_List_Nil, A4($author$project$View$Shortcut$tooltip, env.nI, 0, $author$project$Data$Shortcut$keys.oB, $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
                    kb: "View keyboard shortcuts",
                    hp: _List_fromArray([
                        $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(40)),
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(40)),
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aT)
                    ]),
                    fQ: $elm$core$Maybe$Just($author$project$Page$Settings$ShowKeyboardShortcuts)
                }, 2, "question-circle")))
            ])),
            checkboxRow(_List_fromArray([
                $author$project$View$Widgets$sizedCheckbox_fn($author$project$View$Widgets$checkbox_a0, $author$project$View$Widgets$checkbox_a1, {
                    kH: $elm$core$Basics$composeR_fn($author$project$Data$Settings$reverseNoteColumns_a0, $author$project$Data$Settings$reverseNoteColumns_a1, env),
                    fF: $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Primary panel on right")
                    ])),
                    nu: function (flag) {
                        return $author$project$Page$Settings$ManyMsgs(_List_fromArray([
                            $author$project$Page$Settings$SetReverseNoteColumns(flag),
                            $author$project$Page$Settings$AnalyticsEvent($author$project$Analytics$SettingsReverseNoteColumns(flag))
                        ]));
                    }
                }, env.nI),
                $mdgriffith$elm_ui$Element$el_fn(_List_Nil, A4($author$project$View$Tooltip$custom, env.nI, 0, $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(200)),
                    $mdgriffith$elm_ui$Element$padding(5)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Keeps the detail pane on the left side of the screen")
                ])), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(40)),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(40))
                ]), $author$project$View$Icon$icon_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.aT),
                    $mdgriffith$elm_ui$Element$centerY,
                    $mdgriffith$elm_ui$Element$centerX
                ]), 2, "question-circle"))))
            ])),
            checkboxRow(_List_fromArray([
                $author$project$View$Widgets$sizedCheckbox_fn($author$project$View$Widgets$checkbox_a0, $author$project$View$Widgets$checkbox_a1, {
                    kH: $elm$core$Basics$composeR_fn($author$project$Data$Settings$defaultToAttendeesTab_a0, $author$project$Data$Settings$defaultToAttendeesTab_a1, env),
                    fF: $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink)
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Default to Attendees tab if Threads is empty")
                    ])),
                    nu: function (flag) {
                        return $author$project$Page$Settings$ManyMsgs(_List_fromArray([
                            $author$project$Page$Settings$SetDefaultToAttendeesTab(flag),
                            $author$project$Page$Settings$AnalyticsEvent($author$project$Analytics$SettingsSetDefaultToAttendeesTab(flag))
                        ]));
                    }
                }, env.nI),
                $mdgriffith$elm_ui$Element$el_fn(_List_Nil, A4($author$project$View$Tooltip$custom, env.nI, 0, $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(200)),
                    $mdgriffith$elm_ui$Element$padding(7)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("When opening a note, automatically show the meeting attendees if Threads is empty")
                ])), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(40)),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(40)),
                    $mdgriffith$elm_ui$Element$alignRight
                ]), $author$project$View$Icon$icon_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.aT),
                    $mdgriffith$elm_ui$Element$centerY,
                    $mdgriffith$elm_ui$Element$centerX
                ]), 2, "question-circle"))))
            ])),
            checkboxRow(_List_fromArray([
                $author$project$View$Widgets$sizedCheckbox_fn($author$project$View$Widgets$checkbox_a0, $author$project$View$Widgets$checkbox_a1, {
                    kH: $elm_community$maybe_extra$Maybe$Extra$isJust($elm$core$Basics$composeR_fn($author$project$Data$Settings$nextMeetingNotifications_a0, $author$project$Data$Settings$nextMeetingNotifications_a1, env)),
                    fF: $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Reminder notification before next meeting starts")
                    ])),
                    nu: function (flag) {
                        return $author$project$Page$Settings$ManyMsgs(_List_fromArray([
                            $author$project$Page$Settings$SetNextMeetingNotifications(flag ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing),
                            $author$project$Page$Settings$AnalyticsEvent($author$project$Analytics$SettingsShowWeekends(flag))
                        ]));
                    }
                }, env.nI)
            ])),
            $author$project$View$Util$when_fn($elm_community$maybe_extra$Maybe$Extra$isJust($elm$core$Basics$composeR_fn($author$project$Data$Settings$nextMeetingNotifications_a0, $author$project$Data$Settings$nextMeetingNotifications_a1, env)), function () {
                var viewOption = F2(function (title, option) {
                    return $mdgriffith$elm_ui$Element$Input$button_fn(_List_Nil, {
                        fF: $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$spacing(5)
                        ]), _List_fromArray([
                            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Border$rounded(999),
                                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(18)),
                                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(18)),
                                $mdgriffith$elm_ui$Element$centerX,
                                $mdgriffith$elm_ui$Element$centerY,
                                $mdgriffith$elm_ui$Element$Border$color(env.nI.a6),
                                $mdgriffith$elm_ui$Element$Border$width(3),
                                $mdgriffith$elm_ui$Element$Background$color($author$project$Util$Misc$if__fn(_Utils_eq($elm$core$Basics$composeR_fn($author$project$Data$Settings$nextMeetingNotifications_a0, $author$project$Data$Settings$nextMeetingNotifications_a1, env), $elm$core$Maybe$Just(option)), env.nI.a6, env.nI.dw))
                            ]), $mdgriffith$elm_ui$Element$none),
                            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                                $mdgriffith$elm_ui$Element$centerX,
                                $mdgriffith$elm_ui$Element$Font$size(14)
                            ]), $mdgriffith$elm_ui$Element$text(title))
                        ])),
                        nz: $elm$core$Maybe$Just($author$project$Page$Settings$SetNextMeetingNotifications($elm$core$Maybe$Just(option)))
                    });
                });
                return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$paddingEach((new $$Record115(20, 50, 0, 10))),
                    $mdgriffith$elm_ui$Element$spacing(20)
                ]), _List_fromArray([
                    A2(viewOption, "2m", 2),
                    A2(viewOption, "5m", 1),
                    A2(viewOption, "10m", 0)
                ]));
            }())
        ]));
    };
    var $author$project$Page$Settings$SetSnapshotEmail = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Analytics$SettingsSnapshotEmail = function (a) {
        return { $: 54, a: a };
    };
    var $author$project$Data$Settings$snapshotEmailConfig_a0 = $author$project$Data$Settings$get, $author$project$Data$Settings$snapshotEmailConfig_a1 = function ($) {
        return $.cN;
    }, $author$project$Data$Settings$snapshotEmailConfig = A2($elm$core$Basics$composeR, $author$project$Data$Settings$snapshotEmailConfig_a0, $author$project$Data$Settings$snapshotEmailConfig_a1);
    var $author$project$Data$Settings$snapshotEmailEnabled_a0 = $author$project$Data$Settings$get, $author$project$Data$Settings$snapshotEmailEnabled_a1 = function ($) {
        return $.cO;
    }, $author$project$Data$Settings$snapshotEmailEnabled = A2($elm$core$Basics$composeR, $author$project$Data$Settings$snapshotEmailEnabled_a0, $author$project$Data$Settings$snapshotEmailEnabled_a1);
    var $author$project$Page$Settings$SnapshotEmailEnableWeekday_fn = function (a, b) {
        return { $: 8, a: a, b: b };
    }, $author$project$Page$Settings$SnapshotEmailEnableWeekday = F2($author$project$Page$Settings$SnapshotEmailEnableWeekday_fn);
    var $author$project$Page$Settings$weekdayToggle_fn = function (palette, mConfig, day) {
        var label = function () {
            switch (day) {
                case 6:
                    return "S";
                case 0:
                    return "M";
                case 1:
                    return "T";
                case 2:
                    return "W";
                case 3:
                    return "T";
                case 4:
                    return "F";
                default:
                    return "S";
            }
        }();
        var isChecked = $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeL, $elm$core$List$member(day), function ($) {
            return $.fa;
        }), mConfig));
        var checkboxIcon = function (enabled) {
            var focusAndHoverStyling = _List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($author$project$Util$Misc$if__fn(enabled, palette.a7, palette.aO))
            ]);
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($author$project$Util$Misc$if__fn(enabled, palette.a6, palette.aN)),
                $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn(enabled, palette.aM, palette.aT)),
                $mdgriffith$elm_ui$Element$Border$width(1),
                $mdgriffith$elm_ui$Element$Border$color(palette.aO),
                $mdgriffith$elm_ui$Element$mouseOver(focusAndHoverStyling),
                $mdgriffith$elm_ui$Element$focused(focusAndHoverStyling),
                $author$project$View$Styling$ripple,
                $mdgriffith$elm_ui$Element$Font$size(13),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(30)),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(30)),
                $mdgriffith$elm_ui$Element$Border$rounded(50)
            ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerY, $mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$text(label)));
        };
        return $mdgriffith$elm_ui$Element$Input$checkbox_fn(_List_Nil, {
            kH: isChecked,
            l7: checkboxIcon,
            fF: $mdgriffith$elm_ui$Element$Input$labelHidden(label),
            nu: $author$project$Page$Settings$SnapshotEmailEnableWeekday(day)
        });
    }, $author$project$Page$Settings$weekdayToggle = F3($author$project$Page$Settings$weekdayToggle_fn);
    var $author$project$Page$Settings$snapshotEmailSettings = function (env) {
        var snapshotEmailConfig = $elm$core$Basics$composeR_fn($author$project$Data$Settings$snapshotEmailConfig_a0, $author$project$Data$Settings$snapshotEmailConfig_a1, env);
        var snapshotEmailUpdateTime = $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeL, $elm$core$String$fromInt, function ($) {
            return $.fr;
        }), snapshotEmailConfig));
        var weekdayToggle_ = A2($author$project$Page$Settings$weekdayToggle, env.nI, snapshotEmailConfig);
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(10),
            $mdgriffith$elm_ui$Element$moveRight(15)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(10)
            ]), _List_fromArray([
                $author$project$View$Widgets$toggleSwitch_fn({
                    kb: "Enable/disable snapshot emails",
                    kH: $elm$core$Basics$composeR_fn($author$project$Data$Settings$snapshotEmailEnabled_a0, $author$project$Data$Settings$snapshotEmailEnabled_a1, env),
                    nu: function (flag) {
                        return $author$project$Page$Settings$ManyMsgs(_List_fromArray([
                            $author$project$Page$Settings$SetSnapshotEmail(flag),
                            $author$project$Page$Settings$AnalyticsEvent($author$project$Analytics$SettingsSnapshotEmail(flag))
                        ]));
                    }
                }, env.nI),
                $mdgriffith$elm_ui$Element$text("Enable snapshot emails"),
                A4($author$project$View$Tooltip$custom, env.nI, 0, $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(200)),
                    $mdgriffith$elm_ui$Element$padding(5)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Emails summarizing your action items and day/week.")
                ])), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(40)),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(40))
                ]), $author$project$View$Icon$icon_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.aT),
                    $mdgriffith$elm_ui$Element$centerY,
                    $mdgriffith$elm_ui$Element$centerX
                ]), 2, "question-circle")))
            ])),
            $author$project$View$Util$when_fn($elm$core$Basics$composeR_fn($author$project$Data$Settings$snapshotEmailEnabled_a0, $author$project$Data$Settings$snapshotEmailEnabled_a1, env), $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(20),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(10)
                ]), _List_fromArray([
                    weekdayToggle_(0),
                    weekdayToggle_(1),
                    weekdayToggle_(2),
                    weekdayToggle_(3),
                    weekdayToggle_(4),
                    weekdayToggle_(5),
                    weekdayToggle_(6)
                ])),
                $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(450, $mdgriffith$elm_ui$Element$fill)),
                    $mdgriffith$elm_ui$Element$spacing(20)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$spacing(8)
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$text($elm$core$String$concat(_List_fromArray(["We'll email your snapshot at ", snapshotEmailUpdateTime, ":00am on each day specified."])))
                    ])),
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$italic,
                        $mdgriffith$elm_ui$Element$spacing(8)
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Note: This is an experimental feature that's rapidly evolving. We'd love your feedback on the content that would be most helpful to you.")
                    ]))
                ]))
            ])))
        ]));
    };
    var $author$project$Page$Settings$SetTheme = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Analytics$SettingsTheme = function (a) {
        return { $: 49, a: a };
    };
    var $author$project$View$Util$noPointerEvents = $author$project$View$Util$style_fn("pointer-events", "none");
    var $author$project$Page$Settings$themePicker = function (env) {
        var themeBox = F3(function (name, theme, copy) {
            var palette = $author$project$Data$Color$paletteForTheme(theme);
            var isSelected = _Utils_eq(palette.pn, env.nI.pn);
            return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$spacing(8),
                $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Settings$ManyMsgs(_List_fromArray([
                    $author$project$Page$Settings$SetTheme(theme),
                    $author$project$Page$Settings$AnalyticsEvent($author$project$Analytics$SettingsTheme(theme))
                ]))),
                $mdgriffith$elm_ui$Element$pointer
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn(isSelected, env.nI.a2, env.nI.aR))
                ]), $mdgriffith$elm_ui$Element$text(name)),
                $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
                    $mdgriffith$elm_ui$Element$Border$color($author$project$Util$Misc$if__fn(isSelected, env.nI.a2, env.nI.aP)),
                    $mdgriffith$elm_ui$Element$Border$width(2),
                    $mdgriffith$elm_ui$Element$Border$rounded(8),
                    $mdgriffith$elm_ui$Element$Background$color(palette.aM),
                    $mdgriffith$elm_ui$Element$paddingXY_fn(28, 14),
                    $mdgriffith$elm_ui$Element$spacing(5),
                    $author$project$View$Util$noPointerEvents,
                    $author$project$View$Util$buttonRole,
                    $author$project$View$Styling$focusableOnlyBorderStyling,
                    $author$project$View$Util$tabIndex($elm$core$Maybe$Just(0))
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$wrappedRow_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(palette.aS),
                        $mdgriffith$elm_ui$Element$spacing(5),
                        $mdgriffith$elm_ui$Element$centerX
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$text(copy),
                        $author$project$View$Icon$icon_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(palette.a9)
                        ]), 3, "spa"),
                        $author$project$View$Icon$icon_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(palette.a7)
                        ]), 3, "fan"),
                        $author$project$View$Icon$icon_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(palette.a2)
                        ]), 3, "box-heart")
                    ])),
                    $author$project$View$Widgets$button_fn({
                        hp: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Background$color(palette.a7),
                            $mdgriffith$elm_ui$Element$Border$width(0),
                            $mdgriffith$elm_ui$Element$Font$color(palette.dw),
                            $mdgriffith$elm_ui$Element$paddingXY_fn(8, 5),
                            $mdgriffith$elm_ui$Element$centerY,
                            $mdgriffith$elm_ui$Element$Font$size(14),
                            $mdgriffith$elm_ui$Element$centerX,
                            $author$project$View$Util$tabIndex($elm$core$Maybe$Nothing)
                        ]),
                        l7: $elm$core$Maybe$Just(_Utils_Tuple3(3, "rocket", _List_Nil)),
                        fQ: $elm$core$Maybe$Nothing
                    }, "Sample Button")
                ]))
            ]));
        });
        return $mdgriffith$elm_ui$Element$wrappedRow_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(20),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(20),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$alignTop
            ]), _List_fromArray([
                A3(themeBox, "Classic", 0, "Classic Witful purple."),
                A3(themeBox, "Amber", 3, "Warm amber colors.")
            ])),
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(20),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$alignTop
            ]), _List_fromArray([
                A3(themeBox, "Evening", 4, "Soft dark theme."),
                A3(themeBox, "Midnight", 1, "Black and purple.")
            ]))
        ]));
    };
    var $author$project$Page$Settings$view = function (env) {
        var linkAttrs = _List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$pointer,
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(env.nI.a8),
                $mdgriffith$elm_ui$Element$Background$color(env.nI.aN)
            ])),
            $mdgriffith$elm_ui$Element$Border$rounded(5),
            $mdgriffith$elm_ui$Element$Font$color(env.nI.a6),
            $mdgriffith$elm_ui$Element$padding(5),
            $mdgriffith$elm_ui$Element$Font$size(14),
            $author$project$View$Styling$focusable
        ]);
        var developerButtonAttrs = _List_fromArray([
            $mdgriffith$elm_ui$Element$Background$color(env.nI.aO),
            $mdgriffith$elm_ui$Element$Border$width(1),
            $mdgriffith$elm_ui$Element$Border$color(env.nI.aQ),
            $mdgriffith$elm_ui$Element$Font$color(env.nI.cI),
            $mdgriffith$elm_ui$Element$padding(15),
            $mdgriffith$elm_ui$Element$alignLeft,
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(env.nI.aL)
            ])),
            $mdgriffith$elm_ui$Element$Font$size(14)
        ]);
        return $author$project$View$Layout$onePanel_fn(env, _List_Nil, _List_fromArray([
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacingXY_fn(0, 35),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), _List_fromArray([
                A3($author$project$View$Styling$h2, env.nI, _List_fromArray([$mdgriffith$elm_ui$Element$Font$medium]), "Settings"),
                $author$project$Page$Settings$settingsInputs(env),
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(7)
                ]), _List_fromArray([
                    A3($author$project$View$Styling$h3, env.nI, _List_fromArray([$mdgriffith$elm_ui$Element$Font$medium]), "Snapshot Emails"),
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(13),
                        $mdgriffith$elm_ui$Element$moveDown(2)
                    ]), $mdgriffith$elm_ui$Element$text("(experimental)"))
                ])),
                $author$project$Page$Settings$snapshotEmailSettings(env),
                A3($author$project$View$Styling$h3, env.nI, _List_fromArray([$mdgriffith$elm_ui$Element$Font$medium]), "Chrome Extension"),
                $author$project$Page$Settings$browserExtensionLink(env),
                A3($author$project$View$Styling$h3, env.nI, _List_fromArray([$mdgriffith$elm_ui$Element$Font$medium]), "Theme"),
                $author$project$Page$Settings$themePicker(env)
            ])),
            $author$project$View$Util$horizontalLine_fn(env.nI, 2, _List_fromArray([
                $mdgriffith$elm_ui$Element$Border$color(env.nI.aO)
            ])),
            $author$project$Page$Settings$analyticsSetting(env),
            $author$project$View$Util$horizontalLine_fn(env.nI, 2, _List_fromArray([
                $mdgriffith$elm_ui$Element$Border$color(env.nI.aO)
            ])),
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(20),
                $mdgriffith$elm_ui$Element$centerX
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$link_fn(linkAttrs, {
                    fF: $mdgriffith$elm_ui$Element$text("Terms of Service"),
                    dt: "https://witful.com/terms/"
                }),
                $mdgriffith$elm_ui$Element$link_fn(linkAttrs, {
                    fF: $mdgriffith$elm_ui$Element$text("Privacy Policy"),
                    dt: "https://witful.com/privacy/"
                })
            ])),
            $author$project$View$Util$when_fn(!$author$project$Data$App$isProd(env.mM), $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$spacingXY_fn(0, 30)
            ]), _List_fromArray([
                $author$project$View$Util$horizontalLine_fn(env.nI, 2, _List_fromArray([
                    $mdgriffith$elm_ui$Element$Border$color(env.nI.aO)
                ])),
                A3($author$project$View$Styling$h2, env.nI, _List_fromArray([$mdgriffith$elm_ui$Element$Font$medium]), "Developer Activities"),
                $mdgriffith$elm_ui$Element$text("These buttons are not available on App or Next."),
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                        $mdgriffith$elm_ui$Element$spacing(20)
                    ]), _List_fromArray([
                        $author$project$View$Widgets$button_fn({
                            hp: developerButtonAttrs,
                            l7: $elm$core$Maybe$Just(_Utils_Tuple3(3, "brackets-curly", _List_Nil)),
                            fQ: $elm$core$Maybe$Just($author$project$Page$Settings$ResetNotificationBell)
                        }, "Reset Notification Bell"),
                        $author$project$View$Widgets$button_fn({
                            hp: developerButtonAttrs,
                            l7: $elm$core$Maybe$Just(_Utils_Tuple3(3, "brackets-curly", _List_Nil)),
                            fQ: $elm$core$Maybe$Just($author$project$Page$Settings$ReloadPreloadedContent)
                        }, "Reload Introductory Content")
                    ])),
                    $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                        $mdgriffith$elm_ui$Element$spacing(20)
                    ]), _List_fromArray([
                        $author$project$View$Widgets$button_fn({
                            hp: developerButtonAttrs,
                            l7: $elm$core$Maybe$Just(_Utils_Tuple3(3, "brackets-curly", _List_Nil)),
                            fQ: $elm$core$Maybe$Just($author$project$Page$Settings$UnlinkCalendar({ ex: false }))
                        }, "Unlink Calendar"),
                        $author$project$View$Widgets$button_fn({
                            hp: _Utils_ap(developerButtonAttrs, _List_fromArray([
                                $mdgriffith$elm_ui$Element$Background$color(env.nI.en),
                                $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                                    $mdgriffith$elm_ui$Element$Background$color(env.nI.eo)
                                ]))
                            ])),
                            l7: $elm$core$Maybe$Just(_Utils_Tuple3(3, "brackets-curly", _List_Nil)),
                            fQ: $elm$core$Maybe$Just($author$project$Page$Settings$UnlinkCalendar({ ex: true }))
                        }, "Restart Onboarding")
                    ]))
                ])),
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("\"Restart Onboarding\" launches the entire onboarding flow again. It will reset your settings and reload the intro content. ")
                ])),
                $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.a7),
                    $author$project$View$Styling$focusable
                ]), {
                    fF: $mdgriffith$elm_ui$Element$text("Click here to view all color palettes"),
                    dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteDemo)
                })
            ])))
        ]));
    };
    var $author$project$Content$ImagePaths$googleSignInButton = { li: "/static/img/google_signin_buttons/web/2x/btn_google_signin_dark_pressed_web@2x.png", l1: "/static/img/google_signin_buttons/web/2x/btn_google_signin_dark_focus_web@2x.png", nn: "/static/img/google_signin_buttons/web/2x/btn_google_signin_dark_normal_web@2x.png" };
    var $author$project$Page$Signup$headerTextForStep = function (signupStep) {
        switch (signupStep.$) {
            case 0:
                return "Welcome to Witful!";
            case 1:
                return "Choose your subscription";
            case 2:
                return "";
            case 3:
                return "Next, let's sync Google Calendar";
            case 4:
                return "Learn the basics in 60 seconds";
            default:
                return "Try out one of our shortcuts";
        }
    };
    var $author$project$View$Icon$gradientIcon_fn = function (name, size, _v0, style) {
        var angle = _v0.j6;
        var start = _v0.bF;
        var end = _v0.b6;
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(size)
        ]), $mdgriffith$elm_ui$Element$html($elm$html$Html$i_fn(_List_fromArray([
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $author$project$View$Icon$stylePrefix(style) + (" fa-fw fa-" + name)),
            _VirtualDom_style_fn("color", "transparent"),
            _VirtualDom_style_fn("background-clip", "text"),
            _VirtualDom_style_fn("-webkit-background-clip", "text"),
            _VirtualDom_style_fn("background-image", "linear-gradient(" + ($elm$core$String$fromInt(angle) + ("deg, " + ($author$project$Util$Color$toRgbString(start) + (", " + ($author$project$Util$Color$toRgbString(end) + ")"))))))
        ]), _List_Nil)));
    }, $author$project$View$Icon$gradientIcon = F4($author$project$View$Icon$gradientIcon_fn);
    var $author$project$View$Responsive$isMobile_fn = function (breakpoints, viewport) {
        return $author$project$View$Responsive$mode_fn(breakpoints, viewport) === 2;
    }, $author$project$View$Responsive$isMobile = F2($author$project$View$Responsive$isMobile_fn);
    var $author$project$Page$Signup$primaryButtonAttrs = function (palette) {
        return _List_fromArray([
            $mdgriffith$elm_ui$Element$Background$color(palette.ba),
            $mdgriffith$elm_ui$Element$Border$width(0),
            $mdgriffith$elm_ui$Element$Font$color(palette.dw),
            $mdgriffith$elm_ui$Element$paddingXY_fn(25, 15),
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$focused(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(palette.a7)
            ])),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(palette.a7)
            ])),
            $mdgriffith$elm_ui$Element$Border$rounded(5),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$Font$size(16)
        ]);
    };
    var $author$project$Content$ImagePaths$signupCalendarGoogle = "/static/img/signup-calendar-google.png";
    var $author$project$Content$ImagePaths$signupCalendarWitful = "/static/img/signup-calendar-witful.png";
    var $author$project$Content$ImagePaths$signupHeroImage = "/static/img/signup-hero-image.png";
    var $author$project$Page$Signup$SetBillingPeriod = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Page$Signup$viewChooseSubscription_fn = function (env, model) {
        var monthlyPrice = function (period) {
            if (!period) {
                return 30;
            }
            else {
                return 24;
            }
        };
        var isMobile = $author$project$View$Responsive$isMobile_fn($author$project$View$Layout$breakpoints, env.p1);
        var isDoubleColumned = $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, env.p1);
        var renderPrice = function (price) {
            return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(5),
                $mdgriffith$elm_ui$Element$centerX
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size($author$project$Util$Misc$if__fn(isDoubleColumned, 60, 35))
                ]), $mdgriffith$elm_ui$Element$text("$ " + $elm$core$String$fromInt(price))),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(20),
                    $mdgriffith$elm_ui$Element$alignBottom,
                    $mdgriffith$elm_ui$Element$moveUp(5)
                ]), $mdgriffith$elm_ui$Element$text("/mo"))
            ]));
        };
        var billingPeriodString = function (period) {
            if (!period) {
                return "Billed Monthly";
            }
            else {
                return "Billed Annually";
            }
        };
        var billingPeriodText = function (period) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn(_Utils_eq(period, model.az), env.nI.ba, env.nI.aQ)),
                $mdgriffith$elm_ui$Element$Font$size($author$project$Util$Misc$if__fn(isMobile, 14, 18)),
                $mdgriffith$elm_ui$Element$Font$regular,
                $mdgriffith$elm_ui$Element$centerX,
                $author$project$Util$Misc$if__fn(_Utils_eq(period, model.az), $mdgriffith$elm_ui$Element$Font$bold, $mdgriffith$elm_ui$Element$Font$regular)
            ]), $mdgriffith$elm_ui$Element$text(billingPeriodString(period)));
        };
        var billingPanelChoice = function (period) {
            return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Border$color($author$project$Util$Misc$if__fn(_Utils_eq(period, model.az), env.nI.ba, env.nI.aP)),
                $mdgriffith$elm_ui$Element$Border$width(2),
                $mdgriffith$elm_ui$Element$Border$rounded(5),
                $mdgriffith$elm_ui$Element$spacing(20),
                $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Signup$SetBillingPeriod(period)),
                $author$project$View$Styling$ripple,
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px($author$project$Util$Misc$if__fn(isDoubleColumned, 250, 140))),
                $mdgriffith$elm_ui$Element$padding($author$project$Util$Misc$if__fn(isDoubleColumned, 40, 30)),
                $mdgriffith$elm_ui$Element$pointer
            ]), _List_fromArray([
                billingPeriodText(period),
                renderPrice(monthlyPrice(period))
            ]));
        };
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(20)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$Font$center,
                $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$text("Your first 30 days are free if Witful isn't for you. No questions asked.")
            ])),
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$padding(20),
                $mdgriffith$elm_ui$Element$spacing(40)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$spacing($author$project$Util$Misc$if__fn(isMobile, 15, 30))
                ]), _List_fromArray([
                    billingPanelChoice(1),
                    billingPanelChoice(0)
                ]))
            ])),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$Font$center,
                $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$text("Save 20% with annual billing.")
            ]))
        ]));
    }, $author$project$Page$Signup$viewChooseSubscription = F2($author$project$Page$Signup$viewChooseSubscription_fn);
    var $author$project$Page$Signup$ToggleWizardActionItem = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Page$Signup$card_fn = function (palette, extraAttrs) {
        return $author$project$View$Layout$card_fn(palette, _Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$padding(25),
            $mdgriffith$elm_ui$Element$Border$rounded(7),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$Border$shadow({
                kp: 10,
                kS: $author$project$Data$Color$grayAlphaDark,
                nt: _Utils_Tuple2(0.2, 1),
                oE: 1.5
            })
        ]), extraAttrs));
    }, $author$project$Page$Signup$card = F2($author$project$Page$Signup$card_fn);
    var $author$project$Page$Signup$UpdateWizardNoteDescription = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$Page$Signup$wizardEditorHeight = function (isMobile) {
        return $author$project$Util$Misc$if__fn(isMobile, 200, 266);
    };
    var $author$project$Page$Signup$editorComponent_fn = function (env, isMobile, _v0) {
        var noteState = _v0.a;
        var note = _v0.b;
        var mentionNames = $author$project$Data$MentionNames$generate_fn(env.iz, note);
        return $author$project$View$SlateEditor$element((new $$Record141((new $$Record140(4, note.fc, note.f6)), $author$project$Content$Note$wizardNoteId, $elm$core$Maybe$Nothing, _List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$Page$Signup$wizardEditorHeight(isMobile) - 80))
        ]), $elm$core$Maybe$Just(mentionNames), $author$project$Page$Signup$UpdateWizardNoteDescription, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, env.nI.pn)));
    }, $author$project$Page$Signup$editorComponent = F3($author$project$Page$Signup$editorComponent_fn);
    var $author$project$Data$ActionItem$isTalkingPoint = function (actionItem) {
        return $elm$core$List$any_fn(function (textEl) {
            if ((textEl.$ === 3) && (textEl.a.$ === 1)) {
                var _v1 = textEl.a;
                return true;
            }
            else {
                return false;
            }
        }, actionItem.jn);
    };
    var $author$project$Page$Signup$viewWizard_fn = function (env, model) {
        var todoChip = $author$project$View$Widgets$actionItemChip_fn(env.nI, { mt: false, my: false, mQ: false }, "to-do");
        var isMobile = $author$project$View$Responsive$isMobile_fn($author$project$View$Layout$breakpoints, env.p1);
        var grayLine = function (width_) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $author$project$View$Util$style_fn("width", $elm$core$String$fromInt(width_) + "%"),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(11)),
                $mdgriffith$elm_ui$Element$Border$rounded(6),
                $mdgriffith$elm_ui$Element$Background$color(env.nI.aO),
                $mdgriffith$elm_ui$Element$centerY
            ]), $mdgriffith$elm_ui$Element$none);
        };
        var followupsCard = F2(function (iconName, actionItemList) {
            return A3($author$project$Page$Signup$card, env.nI, _List_fromArray([
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$minimum_fn(200, $mdgriffith$elm_ui$Element$fill)),
                $mdgriffith$elm_ui$Element$paddingXY_fn(10, 20),
                $mdgriffith$elm_ui$Element$spacing(5)
            ]), _List_fromArray([
                $author$project$View$Icon$icon_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.aQ),
                    $mdgriffith$elm_ui$Element$Font$size(19),
                    $mdgriffith$elm_ui$Element$Font$regular,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
                    $mdgriffith$elm_ui$Element$paddingXY_fn(4, 3)
                ]), 2, iconName),
                $author$project$View$Util$spacer(2),
                $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$spacing(10),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$minimum_fn(39, $mdgriffith$elm_ui$Element$shrink))
                ]), $elm$core$List$isEmpty(actionItemList) ? _List_fromArray([
                    grayLine(100),
                    grayLine(35)
                ]) : $elm$core$List$filterMap_fn(A3($author$project$View$ActionItems$viewActionItem, env, function () {
                    var $r = $author$project$View$ActionItems$defaultViewConfig.$c();
                    $r.eG = true;
                    $r.jT = 8;
                    $r.kG = 0.9;
                    $r.lL = 14;
                    $r.lp = false;
                    return $r;
                }(), { nw: $elm$core$Maybe$Nothing, pC: $author$project$Page$Signup$ToggleWizardActionItem }), actionItemList))
            ]));
        });
        var _v0 = $elm$core$Maybe$withDefault_fn(_Utils_Tuple2(0, $author$project$Content$Note$wizardDefaultNote_fn(env.pu, env.k5)), $author$project$Firestore$Collection$getWithState_fn($author$project$Content$Note$wizardNoteId, env.fO));
        var noteState = _v0.a;
        var note = _v0.b;
        var centerContent = _List_fromArray([
            A3($author$project$Page$Signup$card, env.nI, _List_fromArray([
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$Page$Signup$wizardEditorHeight(isMobile))),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(4))
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$bold,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), $mdgriffith$elm_ui$Element$text("This is my first meeting note")),
                $author$project$View$Util$horizontalLine_fn(env.nI, 1, _List_fromArray([
                    $mdgriffith$elm_ui$Element$paddingXY_fn(0, 2),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ])),
                $author$project$Page$Signup$editorComponent_fn(env, isMobile, _Utils_Tuple2(noteState, note))
            ])),
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(20),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(3)),
                $mdgriffith$elm_ui$Element$alignTop
            ]), _List_fromArray([
                $author$project$View$Util$when_fn(!isMobile, A2(followupsCard, "inbox", $elm$core$List$filter_fn($author$project$Data$ActionItem$isTalkingPoint, note.gz))),
                A2(followupsCard, "paper-plane", $elm$core$List$filter_fn($author$project$Data$ActionItem$isTodo, note.gz))
            ]))
        ]);
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$alignTop,
            $mdgriffith$elm_ui$Element$spacing(30),
            $mdgriffith$elm_ui$Element$paddingXY_fn(0, 25),
            $mdgriffith$elm_ui$Element$Font$size(15),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
            $mdgriffith$elm_ui$Element$moveUp(10),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            A5($author$project$Util$Misc$if_, isMobile, $mdgriffith$elm_ui$Element$column, $mdgriffith$elm_ui$Element$row, _List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$spacing(20),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(700, $mdgriffith$elm_ui$Element$fill))
            ]), centerContent),
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(20),
                $mdgriffith$elm_ui$Element$paddingXY_fn(30, 0),
                $mdgriffith$elm_ui$Element$Font$center,
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(600, $mdgriffith$elm_ui$Element$fill)),
                $mdgriffith$elm_ui$Element$Font$light,
                $mdgriffith$elm_ui$Element$Font$size(18)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                    $mdgriffith$elm_ui$Element$text("Just type "),
                    A3($author$project$View$ActionItems$actionItemChip, env.nI, false, "!!"),
                    $mdgriffith$elm_ui$Element$text(" in the note above \u261D\uFE0F to make your first "),
                    todoChip,
                    $mdgriffith$elm_ui$Element$text(".")
                ]))
            ]))
        ]));
    }, $author$project$Page$Signup$viewWizard = F2($author$project$Page$Signup$viewWizard_fn);
    var $author$project$Page$Signup$heroContent_fn = function (env, model, signupStep) {
        var isMobile = $author$project$View$Responsive$isMobile_fn($author$project$View$Layout$breakpoints, env.p1);
        var isDoubleColumned = $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, env.p1);
        var calendarDetailSection = F2(function (name, content) {
            return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(20),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$alignTop
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$Font$regular]), $mdgriffith$elm_ui$Element$text(name)),
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(2)
                ]), content)
            ]));
        });
        switch (signupStep.$) {
            case 0:
                return $mdgriffith$elm_ui$Element$image_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(600, $mdgriffith$elm_ui$Element$fill)),
                    $mdgriffith$elm_ui$Element$centerX
                ]), (new $$Record114("Signup Hero Image", $author$project$Content$ImagePaths$signupHeroImage)));
            case 1:
                return $author$project$Page$Signup$viewChooseSubscription_fn(env, model);
            case 2:
                return ($elm_community$maybe_extra$Maybe$Extra$isJust($elm$core$Maybe$andThen_fn(function ($) {
                    return $.o0;
                }, env.pV)) && $krisajenkins$remotedata$RemoteData$isNotAsked(env.db.o5)) ? $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$centerY,
                    $mdgriffith$elm_ui$Element$Font$size(22),
                    $mdgriffith$elm_ui$Element$spacing(20),
                    $mdgriffith$elm_ui$Element$Font$center
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Currently you can only link a brand new account.")
                    ])),
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Linking existing accounts is a feature coming soon.")
                    ])),
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(15)
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Is this really important to you? Send an email to "),
                        $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.a2)
                        ]), {
                            fF: $mdgriffith$elm_ui$Element$text("support@witful.com"),
                            dt: "mailto:support@witful.com"
                        })
                    ])),
                    $mdgriffith$elm_ui$Element$link_fn($author$project$Page$Signup$primaryButtonAttrs(env.nI), {
                        fF: $mdgriffith$elm_ui$Element$text("Return Home \u2192"),
                        dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteHome($elm$core$Maybe$Nothing))
                    })
                ])) : $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]), $author$project$View$Widgets$loadingAnimation);
            case 3:
                return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$spacing(20),
                    $mdgriffith$elm_ui$Element$paddingXY_fn(0, 30),
                    $mdgriffith$elm_ui$Element$centerX
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn($author$project$Util$Misc$if__fn(env.p1.p1.fo < 800, 450, 600), $mdgriffith$elm_ui$Element$fill)),
                        $mdgriffith$elm_ui$Element$centerX
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$image_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(8))
                        ]), (new $$Record114("Google Calendar screenshot", $author$project$Content$ImagePaths$signupCalendarGoogle))),
                        $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(3))
                        ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $author$project$View$Icon$gradientIcon_fn("long-arrow-right", $author$project$Util$Misc$if__fn(isMobile, 30, 60), { j6: 90, b6: env.nI.a8, bF: env.nI.dF }, 2))),
                        $mdgriffith$elm_ui$Element$image_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fillPortion(9))
                        ]), (new $$Record114("Witful Calendar screenshot", $author$project$Content$ImagePaths$signupCalendarWitful)))
                    ])),
                    A2(isMobile ? $mdgriffith$elm_ui$Element$column : $mdgriffith$elm_ui$Element$row, _List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$size(15),
                        $mdgriffith$elm_ui$Element$Font$alignLeft,
                        $mdgriffith$elm_ui$Element$spacing(30),
                        $mdgriffith$elm_ui$Element$moveDown(15)
                    ]), _List_fromArray([
                        A2(calendarDetailSection, "Encrypted", _List_fromArray([
                            $mdgriffith$elm_ui$Element$text("Witful uses an encrypted database in Google Cloud to safely sync and store your calendar event data.")
                        ])),
                        A2(calendarDetailSection, "Private", _List_fromArray([
                            $mdgriffith$elm_ui$Element$text("Witful does not edit your Google Calendar meeting descriptions, create events, or share "),
                            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$Font$regular]), $mdgriffith$elm_ui$Element$text("any")),
                            $mdgriffith$elm_ui$Element$text(" content with meeting attendees.")
                        ])),
                        A2(calendarDetailSection, "Secure", _List_fromArray([
                            $mdgriffith$elm_ui$Element$text("Your data is never shared with any third party or accessed by our team without your express written consent.")
                        ]))
                    ]))
                ]));
            case 4:
                return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(30),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$centerX
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$centerX,
                        $mdgriffith$elm_ui$Element$moveUp(15),
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
                        $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink)
                    ]), $author$project$View$Widgets$youtubeVideo({
                        oM: $author$project$Content$Videos$howToUseWitful,
                        p2: isDoubleColumned ? $elm$core$Basics$floor(env.p1.p1.jJ - 450) : $elm$core$Basics$floor(env.p1.p1.jJ)
                    })),
                    $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$centerX,
                        $mdgriffith$elm_ui$Element$centerY,
                        $mdgriffith$elm_ui$Element$Font$size(18),
                        $mdgriffith$elm_ui$Element$spacing(20),
                        $mdgriffith$elm_ui$Element$Font$center
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                            $mdgriffith$elm_ui$Element$text("Get ready to flow effortlessly through your busy day. Watch how \u261D\uFE0F")
                        ]))
                    ]))
                ]));
            default:
                return $author$project$Page$Signup$viewWizard_fn(env, model);
        }
    }, $author$project$Page$Signup$heroContent = F3($author$project$Page$Signup$heroContent_fn);
    var $author$project$Page$Signup$preloadImage = function (src) {
        return $mdgriffith$elm_ui$Element$image_fn(_List_fromArray([
            $author$project$View$Util$style_fn("display", "none")
        ]), (new $$Record114("", src)));
    };
    var $author$project$Page$Signup$progressBreadcrumbs_fn = function (env, model, signupStep) {
        var isSignInStep = function () {
            if (!signupStep.$) {
                return true;
            }
            else {
                return false;
            }
        }();
        var isDoubleColumned = $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, env.p1);
        var expandedBreadcrumb = F2(function (copy, _v2) {
            var isCurrent = _v2.bv;
            var isComplete = _v2.mt;
            return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(20)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Border$rounded(999),
                    $author$project$View$Util$attrWhen_fn(isComplete, $mdgriffith$elm_ui$Element$Background$color(env.nI.a1)),
                    $mdgriffith$elm_ui$Element$Border$color($author$project$Util$Misc$if__fn(isCurrent, env.nI.a6, env.nI.a4)),
                    $author$project$View$Util$attrWhen_fn(!isComplete, $mdgriffith$elm_ui$Element$Border$width(2)),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(26)),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(26))
                ]), $author$project$View$Util$when_fn(isComplete, $author$project$View$Icon$icon_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.a7),
                    $mdgriffith$elm_ui$Element$Font$size(14),
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$centerY
                ]), 1, "check"))),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn(isCurrent, env.nI.a7, env.nI.aQ))
                ]), $mdgriffith$elm_ui$Element$text(copy))
            ]));
        });
        var collapsedBreadcrumb = F2(function (_v0, _v1) {
            var isCurrent = _v1.bv;
            var isComplete = _v1.mt;
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Border$rounded(999),
                $author$project$View$Util$attrWhen_fn(isComplete, $mdgriffith$elm_ui$Element$Background$color(env.nI.a1)),
                $mdgriffith$elm_ui$Element$Border$color($author$project$Util$Misc$if__fn(isCurrent, env.nI.a6, env.nI.a4)),
                $author$project$View$Util$attrWhen_fn(!isComplete, $mdgriffith$elm_ui$Element$Border$width(2)),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(18)),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(18))
            ]), $author$project$View$Util$when_fn(isComplete, $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(env.nI.a7),
                $mdgriffith$elm_ui$Element$Font$size(11),
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$centerY
            ]), 1, "check")));
        });
        var progressBreadcrumb = $author$project$Util$Misc$if__fn(isDoubleColumned, expandedBreadcrumb, collapsedBreadcrumb);
        return _List_fromArray([
            A2(progressBreadcrumb, "Sign in with Google", { mt: !isSignInStep, bv: isSignInStep }),
            A2(progressBreadcrumb, "Set up billing", {
                mt: !(isSignInStep || _Utils_eq(signupStep, $author$project$Routing$SignupStepChooseSubscription)),
                bv: _Utils_eq(signupStep, $author$project$Routing$SignupStepChooseSubscription)
            }),
            A2(progressBreadcrumb, "Connect your calendar", {
                mt: !(isSignInStep || (_Utils_eq(signupStep, $author$project$Routing$SignupStepChooseSubscription) || _Utils_eq(signupStep, $author$project$Routing$SignupStepLinkCalendar))),
                bv: _Utils_eq(signupStep, $author$project$Routing$SignupStepLinkCalendar)
            }),
            A2(progressBreadcrumb, "Watch our Getting Started video", {
                mt: _Utils_eq(signupStep, $author$project$Routing$SignupStepWizard),
                bv: _Utils_eq(signupStep, $author$project$Routing$SignupStepWatchVideo)
            }),
            A2(progressBreadcrumb, "Practice in a Witful note", {
                mt: model.bR,
                bv: _Utils_eq(signupStep, $author$project$Routing$SignupStepWizard)
            })
        ]);
    }, $author$project$Page$Signup$progressBreadcrumbs = F3($author$project$Page$Signup$progressBreadcrumbs_fn);
    var $author$project$Page$Signup$AddLinkedAccount = { $: 3 };
    var $author$project$Page$Signup$AnalyticsEvent = function (a) {
        return { $: 8, a: a };
    };
    var $perzanko$elm_loading$Loading$BouncingBalls = 2;
    var $author$project$Page$Signup$CompleteSignup = { $: 6 };
    var $author$project$Page$Signup$LinkCalendar = { $: 7 };
    var $author$project$Page$Signup$ManyMsgs = function (a) {
        return { $: 11, a: a };
    };
    var $perzanko$elm_loading$Loading$On = 0;
    var $author$project$Analytics$SignupChangeGoogleAccounts = { $: 60 };
    var $author$project$Analytics$SignupInitLinkCalendar = { $: 58 };
    var $author$project$Analytics$SignupLinkCalendarSkipped = { $: 59 };
    var $author$project$Analytics$SignupNoGoogleAccount = { $: 57 };
    var $author$project$Analytics$SignupSubscriptionChosen = function (a) {
        return { $: 56, a: a };
    };
    var $author$project$Page$Signup$StripeCreateCheckoutSession = { $: 2 };
    var $author$project$View$Util$cursor_a0 = "cursor", $author$project$View$Util$cursor = $author$project$View$Util$style($author$project$View$Util$cursor_a0);
    var $author$project$Page$Signup$disabledButtonAttrs = function (palette) {
        return _List_fromArray([
            $mdgriffith$elm_ui$Element$Background$color(palette.aQ),
            $mdgriffith$elm_ui$Element$Border$width(0),
            $mdgriffith$elm_ui$Element$Font$color(palette.aO),
            $mdgriffith$elm_ui$Element$paddingXY_fn(25, 15),
            $mdgriffith$elm_ui$Element$Border$rounded(5),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$Font$size(16),
            $author$project$View$Util$style_fn($author$project$View$Util$cursor_a0, "default"),
            $mdgriffith$elm_ui$Element$focused(_List_Nil),
            $mdgriffith$elm_ui$Element$mouseOver(_List_Nil)
        ]);
    };
    var $author$project$Page$Signup$secondaryButtonAttrs = function (palette) {
        return _List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$pointer,
            $mdgriffith$elm_ui$Element$Font$color(palette.a6),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.a8),
                $mdgriffith$elm_ui$Element$Background$color(palette.aN)
            ])),
            $mdgriffith$elm_ui$Element$paddingXY_fn(25, 15),
            $mdgriffith$elm_ui$Element$Border$rounded(5),
            $mdgriffith$elm_ui$Element$Font$size(14)
        ]);
    };
    var $author$project$Page$Signup$emailAndTermsLinks = function (palette) {
        var fontColor = $mdgriffith$elm_ui$Element$Font$color(palette.aQ);
        var grayLinkAttrs = _Utils_ap($author$project$Page$Signup$secondaryButtonAttrs(palette), _List_fromArray([
            fontColor,
            $mdgriffith$elm_ui$Element$padding(5),
            $mdgriffith$elm_ui$Element$Font$size(12),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.a8),
                $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$transparent)
            ]))
        ]));
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$padding(20),
            $mdgriffith$elm_ui$Element$alignBottom,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            fontColor
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$link_fn(_Utils_ap(grayLinkAttrs, _List_fromArray([$mdgriffith$elm_ui$Element$alignLeft])), {
                fF: $mdgriffith$elm_ui$Element$text("support@witful.com"),
                dt: "mailto:support@witful.com"
            }),
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([$mdgriffith$elm_ui$Element$alignRight]), _List_fromArray([
                $mdgriffith$elm_ui$Element$link_fn(grayLinkAttrs, {
                    fF: $mdgriffith$elm_ui$Element$text("Terms"),
                    dt: "https://witful.com/terms/"
                }),
                $mdgriffith$elm_ui$Element$text("|"),
                $mdgriffith$elm_ui$Element$link_fn(grayLinkAttrs, {
                    fF: $mdgriffith$elm_ui$Element$text("Privacy Policy"),
                    dt: "https://witful.com/privacy/"
                })
            ]))
        ]));
    };
    var $robinheghan$murmur3$Murmur3$HashData_fn = function (shift, seed, hash, charsProcessed) {
        return { b_: charsProcessed, ce: hash, S: seed, ow: shift };
    }, $robinheghan$murmur3$Murmur3$HashData = F4($robinheghan$murmur3$Murmur3$HashData_fn);
    var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
    var $robinheghan$murmur3$Murmur3$c2 = 461845907;
    var $robinheghan$murmur3$Murmur3$multiplyBy_fn = function (b, a) {
        return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
    }, $robinheghan$murmur3$Murmur3$multiplyBy = F2($robinheghan$murmur3$Murmur3$multiplyBy_fn);
    var $robinheghan$murmur3$Murmur3$rotlBy_fn = function (b, a) {
        return (a << b) | (a >>> (32 - b));
    }, $robinheghan$murmur3$Murmur3$rotlBy = F2($robinheghan$murmur3$Murmur3$rotlBy_fn);
    var $robinheghan$murmur3$Murmur3$finalize = function (data) {
        var acc = (!(!data.ce)) ? (data.S ^ $robinheghan$murmur3$Murmur3$multiplyBy_fn($robinheghan$murmur3$Murmur3$c2, $robinheghan$murmur3$Murmur3$rotlBy_fn(15, $robinheghan$murmur3$Murmur3$multiplyBy_fn($robinheghan$murmur3$Murmur3$c1, data.ce)))) : data.S;
        var h0 = acc ^ data.b_;
        var h1 = $robinheghan$murmur3$Murmur3$multiplyBy_fn(2246822507, h0 ^ (h0 >>> 16));
        var h2 = $robinheghan$murmur3$Murmur3$multiplyBy_fn(3266489909, h1 ^ (h1 >>> 13));
        return (h2 ^ (h2 >>> 16)) >>> 0;
    };
    var $robinheghan$murmur3$Murmur3$mix_fn = function (h1, k1) {
        return $robinheghan$murmur3$Murmur3$multiplyBy_fn(5, $robinheghan$murmur3$Murmur3$rotlBy_fn(13, h1 ^ $robinheghan$murmur3$Murmur3$multiplyBy_fn($robinheghan$murmur3$Murmur3$c2, $robinheghan$murmur3$Murmur3$rotlBy_fn(15, $robinheghan$murmur3$Murmur3$multiplyBy_fn($robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
    }, $robinheghan$murmur3$Murmur3$mix = F2($robinheghan$murmur3$Murmur3$mix_fn);
    var $robinheghan$murmur3$Murmur3$hashFold_fn = function (c, data) {
        var res = data.ce | ((255 & $elm$core$Char$toCode(c)) << data.ow);
        var _v0 = data.ow;
        if (_v0 === 24) {
            return {
                b_: data.b_ + 1,
                ce: 0,
                S: $robinheghan$murmur3$Murmur3$mix_fn(data.S, res),
                ow: 0
            };
        }
        else {
            return { b_: data.b_ + 1, ce: res, S: data.S, ow: data.ow + 8 };
        }
    }, $robinheghan$murmur3$Murmur3$hashFold = F2($robinheghan$murmur3$Murmur3$hashFold_fn);
    var $robinheghan$murmur3$Murmur3$hashString_fn = function (seed, str) {
        return $robinheghan$murmur3$Murmur3$finalize(_String_foldl_fn($robinheghan$murmur3$Murmur3$hashFold, $robinheghan$murmur3$Murmur3$HashData_fn(0, seed, 0, 0), str));
    }, $robinheghan$murmur3$Murmur3$hashString = F2($robinheghan$murmur3$Murmur3$hashString_fn);
    var $rtfeldman$elm_css$Hash$initialSeed = 15739;
    var $rtfeldman$elm_css$Hash$fromString = function (str) {
        return _String_cons_fn("_", $rtfeldman$elm_hex$Hex$toString($robinheghan$murmur3$Murmur3$hashString_fn($rtfeldman$elm_css$Hash$initialSeed, str)));
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles_fn = function (_v0, styles) {
        var isCssStyles = _v0.b;
        var cssTemplate = _v0.c;
        if (isCssStyles) {
            var _v1 = $elm$core$Dict$get_fn(cssTemplate, styles);
            if (!_v1.$) {
                return styles;
            }
            else {
                return $elm$core$Dict$insert_fn(cssTemplate, $rtfeldman$elm_css$Hash$fromString(cssTemplate), styles);
            }
        }
        else {
            return styles;
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute_fn = function (styles, _v0) {
        var val = _v0.a;
        var isCssStyles = _v0.b;
        var cssTemplate = _v0.c;
        if (isCssStyles) {
            var _v1 = $elm$core$Dict$get_fn(cssTemplate, styles);
            if (!_v1.$) {
                var classname = _v1.a;
                return $elm$virtual_dom$VirtualDom$property_fn("className", $elm$json$Json$Encode$string(classname));
            }
            else {
                return $elm$virtual_dom$VirtualDom$property_fn("className", $elm$json$Json$Encode$string("_unstyled"));
            }
        }
        else {
            return val;
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = F2($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS_fn = function (styles, _v0) {
        var val = _v0.a;
        var isCssStyles = _v0.b;
        var cssTemplate = _v0.c;
        if (isCssStyles) {
            var _v1 = $elm$core$Dict$get_fn(cssTemplate, styles);
            if (!_v1.$) {
                var classname = _v1.a;
                return $elm$virtual_dom$VirtualDom$attribute_fn("class", classname);
            }
            else {
                return $elm$virtual_dom$VirtualDom$attribute_fn("class", "_unstyled");
            }
        }
        else {
            return val;
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS = F2($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS_fn);
    var $elm$virtual_dom$VirtualDom$keyedNodeNS_fn = function (namespace, tag) {
        return _VirtualDom_keyedNodeNS_fn(namespace, _VirtualDom_noScript(tag));
    }, $elm$virtual_dom$VirtualDom$keyedNodeNS = F2($elm$virtual_dom$VirtualDom$keyedNodeNS_fn);
    var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
        return _VirtualDom_nodeNS(_VirtualDom_noScript(tag));
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml_fn = function (_v6, _v7) {
        var key = _v6.a;
        var html = _v6.b;
        var pairs = _v7.a;
        var styles = _v7.b;
        switch (html.$) {
            case 4:
                var vdom = html.a;
                return _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, vdom), pairs), styles);
            case 0:
                var elemType = html.a;
                var properties = html.b;
                var children = html.c;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v9 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v9.a;
                var finalStyles = _v9.b;
                var vdom = A3($elm$virtual_dom$VirtualDom$node, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, vdom), pairs), finalStyles);
            case 1:
                var ns = html.a;
                var elemType = html.b;
                var properties = html.c;
                var children = html.d;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v10 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v10.a;
                var finalStyles = _v10.b;
                var vdom = A4($elm$virtual_dom$VirtualDom$nodeNS, ns, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, vdom), pairs), finalStyles);
            case 2:
                var elemType = html.a;
                var properties = html.b;
                var children = html.c;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v11 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v11.a;
                var finalStyles = _v11.b;
                var vdom = A3($elm$virtual_dom$VirtualDom$keyedNode, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, vdom), pairs), finalStyles);
            default:
                var ns = html.a;
                var elemType = html.b;
                var properties = html.c;
                var children = html.d;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v12 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v12.a;
                var finalStyles = _v12.b;
                var vdom = A4($elm$virtual_dom$VirtualDom$keyedNodeNS, ns, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, vdom), pairs), finalStyles);
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml_fn = function (html, _v0) {
        var nodes = _v0.a;
        var styles = _v0.b;
        switch (html.$) {
            case 4:
                var vdomNode = html.a;
                return _Utils_Tuple2(_List_Cons(vdomNode, nodes), styles);
            case 0:
                var elemType = html.a;
                var properties = html.b;
                var children = html.c;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v2 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v2.a;
                var finalStyles = _v2.b;
                var vdomNode = A3($elm$virtual_dom$VirtualDom$node, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(vdomNode, nodes), finalStyles);
            case 1:
                var ns = html.a;
                var elemType = html.b;
                var properties = html.c;
                var children = html.d;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v3 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v3.a;
                var finalStyles = _v3.b;
                var vdomNode = A4($elm$virtual_dom$VirtualDom$nodeNS, ns, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(vdomNode, nodes), finalStyles);
            case 2:
                var elemType = html.a;
                var properties = html.b;
                var children = html.c;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v4 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v4.a;
                var finalStyles = _v4.b;
                var vdomNode = A3($elm$virtual_dom$VirtualDom$keyedNode, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(vdomNode, nodes), finalStyles);
            default:
                var ns = html.a;
                var elemType = html.b;
                var properties = html.c;
                var children = html.d;
                var combinedStyles = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
                var _v5 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml, _Utils_Tuple2(_List_Nil, combinedStyles), children);
                var childNodes = _v5.a;
                var finalStyles = _v5.b;
                var vdomNode = A4($elm$virtual_dom$VirtualDom$keyedNodeNS, ns, elemType, $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles), properties), $elm$core$List$reverse(childNodes));
                return _Utils_Tuple2(_List_Cons(vdomNode, nodes), finalStyles);
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp_fn = function (candidate, properties) {
        stylesFromPropertiesHelp: while (true) {
            if (!properties.b) {
                return candidate;
            }
            else {
                if (!properties.a.b) {
                    var _v1 = properties.a;
                    var classname = _v1.c;
                    var rest = properties.b;
                    var $temp$candidate = candidate, $temp$properties = rest;
                    candidate = $temp$candidate;
                    properties = $temp$properties;
                    continue stylesFromPropertiesHelp;
                }
                else {
                    var _v2 = properties.a;
                    var cssTemplate = _v2.c;
                    var rest = properties.b;
                    var $temp$candidate = $elm$core$Maybe$Just(cssTemplate), $temp$properties = rest;
                    candidate = $temp$candidate;
                    properties = $temp$properties;
                    continue stylesFromPropertiesHelp;
                }
            }
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2($rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
        var _v0 = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp_fn($elm$core$Maybe$Nothing, properties);
        if (_v0.$ === 1) {
            return $elm$core$Dict$empty;
        }
        else {
            var cssTemplate = _v0.a;
            return $elm$core$Dict$singleton_fn(cssTemplate, $rtfeldman$elm_css$Hash$fromString(cssTemplate));
        }
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin = "\u0007";
    var $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration_fn = function (template, classname, declaration) {
        return declaration + ("\n" + $elm$core$String$replace_fn($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, classname, template));
    }, $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration = F3($rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
        return $elm$core$Dict$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration, "", dict);
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
        return A3($elm$virtual_dom$VirtualDom$node, "span", _List_fromArray([
            $elm$virtual_dom$VirtualDom$attribute_fn("style", "display: none;"),
            $elm$virtual_dom$VirtualDom$attribute_fn("class", "elm-css-style-wrapper")
        ]), _List_fromArray([
            A3($elm$virtual_dom$VirtualDom$node, "style", _List_Nil, $elm$core$List$singleton($elm$virtual_dom$VirtualDom$text($rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))))
        ]));
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$unstyle_fn = function (elemType, properties, children) {
        var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
        var _v0 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml, _Utils_Tuple2(_List_Nil, initialStyles), children);
        var childNodes = _v0.a;
        var styles = _v0.b;
        var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
        var unstyledProperties = $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles), properties);
        return A3($elm$virtual_dom$VirtualDom$node, elemType, unstyledProperties, _List_Cons(styleNode, $elm$core$List$reverse(childNodes)));
    }, $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3($rtfeldman$elm_css$VirtualDom$Styled$unstyle_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$containsKey_fn = function (key, pairs) {
        containsKey: while (true) {
            if (!pairs.b) {
                return false;
            }
            else {
                var _v1 = pairs.a;
                var str = _v1.a;
                var rest = pairs.b;
                if (_Utils_eq(key, str)) {
                    return true;
                }
                else {
                    var $temp$key = key, $temp$pairs = rest;
                    key = $temp$key;
                    pairs = $temp$pairs;
                    continue containsKey;
                }
            }
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2($rtfeldman$elm_css$VirtualDom$Styled$containsKey_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey_fn = function (_default, pairs) {
        getUnusedKey: while (true) {
            if (!pairs.b) {
                return _default;
            }
            else {
                var _v1 = pairs.a;
                var firstKey = _v1.a;
                var rest = pairs.b;
                var newKey = "_" + firstKey;
                if ($rtfeldman$elm_css$VirtualDom$Styled$containsKey_fn(newKey, rest)) {
                    var $temp$default = newKey, $temp$pairs = rest;
                    _default = $temp$default;
                    pairs = $temp$pairs;
                    continue getUnusedKey;
                }
                else {
                    return newKey;
                }
            }
        }
    }, $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode_fn = function (allStyles, keyedChildNodes) {
        var styleNodeKey = $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey_fn("_", keyedChildNodes);
        var finalNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
        return _Utils_Tuple2(styleNodeKey, finalNode);
    }, $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed_fn = function (elemType, properties, keyedChildren) {
        var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
        var _v0 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml, _Utils_Tuple2(_List_Nil, initialStyles), keyedChildren);
        var keyedChildNodes = _v0.a;
        var styles = _v0.b;
        var keyedStyleNode = $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode_fn(styles, keyedChildNodes);
        var unstyledProperties = $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles), properties);
        return A3($elm$virtual_dom$VirtualDom$keyedNode, elemType, unstyledProperties, _List_Cons(keyedStyleNode, $elm$core$List$reverse(keyedChildNodes)));
    }, $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS_fn = function (ns, elemType, properties, keyedChildren) {
        var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
        var _v0 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml, _Utils_Tuple2(_List_Nil, initialStyles), keyedChildren);
        var keyedChildNodes = _v0.a;
        var styles = _v0.b;
        var keyedStyleNode = $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode_fn(styles, keyedChildNodes);
        var unstyledProperties = $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles), properties);
        return A4($elm$virtual_dom$VirtualDom$keyedNodeNS, ns, elemType, unstyledProperties, _List_Cons(keyedStyleNode, $elm$core$List$reverse(keyedChildNodes)));
    }, $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS_fn = function (ns, elemType, properties, children) {
        var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
        var _v0 = $elm$core$List$foldl_fn($rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml, _Utils_Tuple2(_List_Nil, initialStyles), children);
        var childNodes = _v0.a;
        var styles = _v0.b;
        var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
        var unstyledProperties = $elm$core$List$map_fn($rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles), properties);
        return A4($elm$virtual_dom$VirtualDom$nodeNS, ns, elemType, unstyledProperties, _List_Cons(styleNode, $elm$core$List$reverse(childNodes)));
    }, $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
        switch (vdom.$) {
            case 4:
                var plainNode = vdom.a;
                return plainNode;
            case 0:
                var elemType = vdom.a;
                var properties = vdom.b;
                var children = vdom.c;
                return $rtfeldman$elm_css$VirtualDom$Styled$unstyle_fn(elemType, properties, children);
            case 1:
                var ns = vdom.a;
                var elemType = vdom.b;
                var properties = vdom.c;
                var children = vdom.d;
                return $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS_fn(ns, elemType, properties, children);
            case 2:
                var elemType = vdom.a;
                var properties = vdom.b;
                var children = vdom.c;
                return $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed_fn(elemType, properties, children);
            default:
                var ns = vdom.a;
                var elemType = vdom.b;
                var properties = vdom.c;
                var children = vdom.d;
                return $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS_fn(ns, elemType, properties, children);
        }
    };
    var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
    var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
        return { $: 6, a: a };
    };
    var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
        return { $: 0, a: a };
    };
    var $rtfeldman$elm_css$Css$Internal$property_fn = function (key, value) {
        return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (":" + value));
    }, $rtfeldman$elm_css$Css$Internal$property = F2($rtfeldman$elm_css$Css$Internal$property_fn);
    var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty_fn = function (functionName, desiredKey, style) {
        getOverloadedProperty: while (true) {
            switch (style.$) {
                case 0:
                    var str = style.a;
                    var key = $elm$core$Maybe$withDefault_fn("", $elm$core$List$head($elm$core$String$split_fn(":", str)));
                    return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, key);
                case 1:
                    var selector = style.a;
                    return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, "elm-css-error-cannot-apply-" + (functionName + "-with-inapplicable-Style-for-selector"));
                case 2:
                    var combinator = style.a;
                    return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, "elm-css-error-cannot-apply-" + (functionName + "-with-inapplicable-Style-for-combinator"));
                case 3:
                    var pseudoElement = style.a;
                    return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, "elm-css-error-cannot-apply-" + (functionName + "-with-inapplicable-Style-for-pseudo-element setter"));
                case 4:
                    return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, "elm-css-error-cannot-apply-" + (functionName + "-with-inapplicable-Style-for-media-query"));
                case 5:
                    return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, "elm-css-error-cannot-apply-" + (functionName + "-with-inapplicable-Style-for-keyframes"));
                default:
                    if (!style.a.b) {
                        return $rtfeldman$elm_css$Css$Internal$property_fn(desiredKey, "elm-css-error-cannot-apply-" + (functionName + "-with-empty-Style"));
                    }
                    else {
                        if (!style.a.b.b) {
                            var _v1 = style.a;
                            var only = _v1.a;
                            var $temp$functionName = functionName, $temp$desiredKey = desiredKey, $temp$style = only;
                            functionName = $temp$functionName;
                            desiredKey = $temp$desiredKey;
                            style = $temp$style;
                            continue getOverloadedProperty;
                        }
                        else {
                            var _v2 = style.a;
                            var first = _v2.a;
                            var rest = _v2.b;
                            var $temp$functionName = functionName, $temp$desiredKey = desiredKey, $temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
                            functionName = $temp$functionName;
                            desiredKey = $temp$desiredKey;
                            style = $temp$style;
                            continue getOverloadedProperty;
                        }
                    }
            }
        }
    }, $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3($rtfeldman$elm_css$Css$Internal$getOverloadedProperty_fn);
    var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
    var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
    var $rtfeldman$elm_css$Css$Internal$lengthConverter_fn = function (units, unitLabel, numericValue) {
        return (new $$Record150(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, numericValue, 0, unitLabel, units, _Utils_ap($elm$core$String$fromFloat(numericValue), unitLabel)));
    }, $rtfeldman$elm_css$Css$Internal$lengthConverter = F3($rtfeldman$elm_css$Css$Internal$lengthConverter_fn);
    var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = $rtfeldman$elm_css$Css$Internal$lengthConverter_fn(0, "", 0);
    var $rtfeldman$elm_css$Css$alignItems = function (fn) {
        return $rtfeldman$elm_css$Css$Internal$getOverloadedProperty_fn("alignItems", "align-items", fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
    };
    var $rtfeldman$elm_css$Css$Preprocess$WithKeyframes = function (a) {
        return { $: 5, a: a };
    };
    var $rtfeldman$elm_css$Css$property_fn = function (key, value) {
        return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (":" + value));
    }, $rtfeldman$elm_css$Css$property = F2($rtfeldman$elm_css$Css$property_fn);
    var $rtfeldman$elm_css$Css$prop1_fn = function (key, arg) {
        return $rtfeldman$elm_css$Css$property_fn(key, arg.p_);
    }, $rtfeldman$elm_css$Css$prop1 = F2($rtfeldman$elm_css$Css$prop1_fn);
    var $rtfeldman$elm_css$Css$animationName = function (arg) {
        return ((arg.p_ === "none") || ((arg.p_ === "inherit") || ((arg.p_ === "unset") || (arg.p_ === "initial")))) ? $rtfeldman$elm_css$Css$prop1_fn("animation-name", arg) : $rtfeldman$elm_css$Css$Preprocess$WithKeyframes(arg.p_);
    };
    var $rtfeldman$elm_css$Css$auto = { j2: 0, c: 0, ca: 0, d6: 0, mB: 0, cg: 0, aV: 0, ap: 0, cm: 0, af: 0, eM: 0, cs: 0, T: 0, p_: "auto" };
    var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
        return $rtfeldman$elm_css$Css$property_fn("background-color", c.p_);
    };
    var $rtfeldman$elm_css$Css$borderRadius_a0 = "border-radius", $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$borderRadius_a0);
    var $rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3($rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$property_fn = function (key, value) {
        return $rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn($elm$virtual_dom$VirtualDom$property_fn(key, value), false, "");
    }, $rtfeldman$elm_css$VirtualDom$Styled$property = F2($rtfeldman$elm_css$VirtualDom$Styled$property_fn);
    var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn = function (key, string) {
        return $rtfeldman$elm_css$VirtualDom$Styled$property_fn(key, $elm$json$Json$Encode$string(string));
    }, $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn);
    var $rtfeldman$elm_css$Html$Styled$Attributes$class_a0 = "className", $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty($rtfeldman$elm_css$Html$Styled$Attributes$class_a0);
    var $rtfeldman$elm_css$Css$Structure$compactHelp_fn = function (declaration, _v0) {
        var keyframesByName = _v0.a;
        var declarations = _v0.b;
        switch (declaration.$) {
            case 0:
                var _v2 = declaration.a;
                var properties = _v2.c;
                return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 1:
                var styleBlocks = declaration.b;
                return $elm$core$List$all_fn(function (_v3) {
                    var properties = _v3.c;
                    return $elm$core$List$isEmpty(properties);
                }, styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 2:
                var otherDeclarations = declaration.b;
                return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 3:
                return _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 4:
                var properties = declaration.b;
                return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 5:
                var properties = declaration.a;
                return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 6:
                var record = declaration.a;
                return $elm$core$String$isEmpty(record.le) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2($elm$core$Dict$insert_fn(record.b, record.le, keyframesByName), declarations);
            case 7:
                var properties = declaration.a;
                return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            case 8:
                var properties = declaration.a;
                return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
            default:
                var tuples = declaration.a;
                return $elm$core$List$all_fn(function (_v4) {
                    var properties = _v4.b;
                    return $elm$core$List$isEmpty(properties);
                }, tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(keyframesByName, _List_Cons(declaration, declarations));
        }
    }, $rtfeldman$elm_css$Css$Structure$compactHelp = F2($rtfeldman$elm_css$Css$Structure$compactHelp_fn);
    var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
        return { $: 6, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations_fn = function (keyframesByName, compactedDeclarations) {
        return $elm$core$List$append_fn($elm$core$List$map_fn(function (_v0) {
            var name = _v0.a;
            var decl = _v0.b;
            return $rtfeldman$elm_css$Css$Structure$Keyframes((new $$Record151(decl, name)));
        }, $elm$core$Dict$toList(keyframesByName)), compactedDeclarations);
    }, $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations_fn);
    var $rtfeldman$elm_css$Css$Structure$compactDeclarations = function (declarations) {
        var _v0 = $elm$core$List$foldr_fn($rtfeldman$elm_css$Css$Structure$compactHelp, _Utils_Tuple2($elm$core$Dict$empty, _List_Nil), declarations);
        var keyframesByName = _v0.a;
        var compactedDeclarations = _v0.b;
        return $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations_fn(keyframesByName, compactedDeclarations);
    };
    var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
        var charset = _v0.gX;
        var imports = _v0.hO;
        var namespaces = _v0.ij;
        var declarations = _v0.lf;
        return {
            gX: charset,
            lf: $rtfeldman$elm_css$Css$Structure$compactDeclarations(declarations),
            hO: imports,
            ij: namespaces
        };
    };
    var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
        return $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn(function (str) {
            return "@charset \"" + (str + "\"");
        }, charset));
    };
    var $rtfeldman$elm_css$Css$String$mapJoinHelp_fn = function (map, sep, strs, result) {
        mapJoinHelp: while (true) {
            if (!strs.b) {
                return result;
            }
            else {
                if (!strs.b.b) {
                    var first = strs.a;
                    return result + (map(first) + "");
                }
                else {
                    var first = strs.a;
                    var rest = strs.b;
                    var $temp$map = map, $temp$sep = sep, $temp$strs = rest, $temp$result = result + (map(first) + (sep + ""));
                    map = $temp$map;
                    sep = $temp$sep;
                    strs = $temp$strs;
                    result = $temp$result;
                    continue mapJoinHelp;
                }
            }
        }
    }, $rtfeldman$elm_css$Css$String$mapJoinHelp = F4($rtfeldman$elm_css$Css$String$mapJoinHelp_fn);
    var $rtfeldman$elm_css$Css$String$mapJoin_fn = function (map, sep, strs) {
        return $rtfeldman$elm_css$Css$String$mapJoinHelp_fn(map, sep, strs, "");
    }, $rtfeldman$elm_css$Css$String$mapJoin = F3($rtfeldman$elm_css$Css$String$mapJoin_fn);
    var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
        return "(" + (expression.hq + ($elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn($elm$core$Basics$append(": "), expression.p_)) + ")"));
    };
    var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
        switch (mediaType) {
            case 0:
                return "print";
            case 1:
                return "screen";
            default:
                return "speech";
        }
    };
    var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
        var prefixWith = F3(function (str, mediaType, expressions) {
            return str + (" " + $elm$core$String$join_fn(" and ", _List_Cons($rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType), $elm$core$List$map_fn($rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
        });
        switch (mediaQuery.$) {
            case 0:
                var expressions = mediaQuery.a;
                return $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, " and ", expressions);
            case 1:
                var mediaType = mediaQuery.a;
                var expressions = mediaQuery.b;
                return A3(prefixWith, "only", mediaType, expressions);
            case 2:
                var mediaType = mediaQuery.a;
                var expressions = mediaQuery.b;
                return A3(prefixWith, "not", mediaType, expressions);
            default:
                var str = mediaQuery.a;
                return str;
        }
    };
    var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString_fn = function (name, mediaQuery) {
        return "@import \"" + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + "\""));
    }, $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2($rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString_fn);
    var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
        var name = _v0.a;
        var mediaQueries = _v0.b;
        return $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name), "\n", mediaQueries);
    };
    var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
        var prefix = _v0.a;
        var str = _v0.b;
        return "@namespace " + (prefix + ("\"" + (str + "\"")));
    };
    var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
        return $rtfeldman$elm_css$Css$String$mapJoin_fn(function (prop) {
            return prop + ";";
        }, "", properties);
    };
    var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
        var str = _v0;
        return "::" + str;
    };
    var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
        switch (combinator) {
            case 0:
                return "+";
            case 1:
                return "~";
            case 2:
                return ">";
            default:
                return "";
        }
    };
    var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
        switch (repeatableSimpleSelector.$) {
            case 0:
                var str = repeatableSimpleSelector.a;
                return "." + str;
            case 1:
                var str = repeatableSimpleSelector.a;
                return "#" + str;
            case 2:
                var str = repeatableSimpleSelector.a;
                return ":" + str;
            default:
                var str = repeatableSimpleSelector.a;
                return "[" + (str + "]");
        }
    };
    var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
        switch (simpleSelectorSequence.$) {
            case 0:
                var str = simpleSelectorSequence.a;
                var repeatableSimpleSelectors = simpleSelectorSequence.b;
                return _Utils_ap(str, $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, "", repeatableSimpleSelectors));
            case 1:
                var repeatableSimpleSelectors = simpleSelectorSequence.a;
                return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? "*" : $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, "", repeatableSimpleSelectors);
            default:
                var str = simpleSelectorSequence.a;
                var repeatableSimpleSelectors = simpleSelectorSequence.b;
                return _Utils_ap(str, $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, "", repeatableSimpleSelectors));
        }
    };
    var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
        var combinator = _v0.a;
        var sequence = _v0.b;
        return $rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator) + (" " + $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence));
    };
    var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
        var simpleSelectorSequence = _v0.a;
        var chain = _v0.b;
        var pseudoElement = _v0.c;
        var segments = _List_Cons($rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence), $elm$core$List$map_fn($rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
        var pseudoElementsString = $elm$core$Maybe$withDefault_fn("", $elm$core$Maybe$map_fn($rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement));
        return _String_append_fn($elm$core$String$join_fn(" ", segments), pseudoElementsString);
    };
    var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = function (_v0) {
        var firstSelector = _v0.a;
        var otherSelectors = _v0.b;
        var properties = _v0.c;
        var selectorStr = $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$selectorToString, ",", _List_Cons(firstSelector, otherSelectors));
        return selectorStr + ("{" + ($rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties) + "}"));
    };
    var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
        switch (decl.$) {
            case 0:
                var styleBlock = decl.a;
                return $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(styleBlock);
            case 1:
                var mediaQueries = decl.a;
                var styleBlocks = decl.b;
                var query = $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, ", ", mediaQueries);
                var blocks = $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, "\n", styleBlocks);
                return "@media " + (query + ("{" + (blocks + "}")));
            case 2:
                return "TODO";
            case 3:
                return "TODO";
            case 4:
                return "TODO";
            case 5:
                return "TODO";
            case 6:
                var name = decl.a.b;
                var declaration = decl.a.le;
                return "@keyframes " + (name + ("{" + (declaration + "}")));
            case 7:
                return "TODO";
            case 8:
                return "TODO";
            default:
                return "TODO";
        }
    };
    var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
        var charset = _v0.gX;
        var imports = _v0.hO;
        var namespaces = _v0.ij;
        var declarations = _v0.lf;
        return $rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset) + ($rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$importToString, "\n", imports) + ($rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$namespaceToString, "\n", namespaces) + ($rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, "\n", declarations) + "")));
    };
    var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
        return { $: 8, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
        return { $: 5, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$PageRule_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Structure$PageRule = F2($rtfeldman$elm_css$Css$Structure$PageRule_fn);
    var $rtfeldman$elm_css$Css$Structure$Selector_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $rtfeldman$elm_css$Css$Structure$Selector = F3($rtfeldman$elm_css$Css$Structure$Selector_fn);
    var $rtfeldman$elm_css$Css$Structure$StyleBlock_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $rtfeldman$elm_css$Css$Structure$StyleBlock = F3($rtfeldman$elm_css$Css$Structure$StyleBlock_fn);
    var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
        return { $: 0, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$SupportsRule_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Structure$SupportsRule = F2($rtfeldman$elm_css$Css$Structure$SupportsRule_fn);
    var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
        return { $: 7, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$MediaRule_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Structure$MediaRule = F2($rtfeldman$elm_css$Css$Structure$MediaRule_fn);
    var $rtfeldman$elm_css$Css$Structure$mapLast_fn = function (update, list) {
        if (!list.b) {
            return list;
        }
        else {
            if (!list.b.b) {
                var only = list.a;
                return _List_fromArray([
                    update(only)
                ]);
            }
            else {
                var first = list.a;
                var rest = list.b;
                return _List_Cons(first, $rtfeldman$elm_css$Css$Structure$mapLast_fn(update, rest));
            }
        }
    }, $rtfeldman$elm_css$Css$Structure$mapLast = F2($rtfeldman$elm_css$Css$Structure$mapLast_fn);
    var $rtfeldman$elm_css$Css$Structure$withPropertyAppended_fn = function (property, _v0) {
        var firstSelector = _v0.a;
        var otherSelectors = _v0.b;
        var properties = _v0.c;
        return $rtfeldman$elm_css$Css$Structure$StyleBlock_fn(firstSelector, otherSelectors, _Utils_ap(properties, _List_fromArray([property])));
    }, $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2($rtfeldman$elm_css$Css$Structure$withPropertyAppended_fn);
    var $rtfeldman$elm_css$Css$Structure$appendProperty_fn = function (property, declarations) {
        if (!declarations.b) {
            return declarations;
        }
        else {
            if (!declarations.b.b) {
                switch (declarations.a.$) {
                    case 0:
                        var styleBlock = declarations.a.a;
                        return _List_fromArray([
                            $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration($rtfeldman$elm_css$Css$Structure$withPropertyAppended_fn(property, styleBlock))
                        ]);
                    case 1:
                        var _v1 = declarations.a;
                        var mediaQueries = _v1.a;
                        var styleBlocks = _v1.b;
                        return _List_fromArray([
                            $rtfeldman$elm_css$Css$Structure$MediaRule_fn(mediaQueries, $rtfeldman$elm_css$Css$Structure$mapLast_fn($rtfeldman$elm_css$Css$Structure$withPropertyAppended(property), styleBlocks))
                        ]);
                    default:
                        return declarations;
                }
            }
            else {
                var first = declarations.a;
                var rest = declarations.b;
                return _List_Cons(first, $rtfeldman$elm_css$Css$Structure$appendProperty_fn(property, rest));
            }
        }
    }, $rtfeldman$elm_css$Css$Structure$appendProperty = F2($rtfeldman$elm_css$Css$Structure$appendProperty_fn);
    var $rtfeldman$elm_css$Css$Structure$appendToLastSelector_fn = function (f, styleBlock) {
        if (!styleBlock.b.b) {
            var only = styleBlock.a;
            var properties = styleBlock.c;
            return _List_fromArray([
                $rtfeldman$elm_css$Css$Structure$StyleBlock_fn(only, _List_Nil, properties),
                $rtfeldman$elm_css$Css$Structure$StyleBlock_fn(f(only), _List_Nil, _List_Nil)
            ]);
        }
        else {
            var first = styleBlock.a;
            var rest = styleBlock.b;
            var properties = styleBlock.c;
            var newRest = $elm$core$List$map_fn(f, rest);
            var newFirst = f(first);
            return _List_fromArray([
                $rtfeldman$elm_css$Css$Structure$StyleBlock_fn(first, rest, properties),
                $rtfeldman$elm_css$Css$Structure$StyleBlock_fn(newFirst, newRest, _List_Nil)
            ]);
        }
    }, $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2($rtfeldman$elm_css$Css$Structure$appendToLastSelector_fn);
    var $rtfeldman$elm_css$Css$Structure$applyPseudoElement_fn = function (pseudo, _v0) {
        var sequence = _v0.a;
        var selectors = _v0.b;
        return $rtfeldman$elm_css$Css$Structure$Selector_fn(sequence, selectors, $elm$core$Maybe$Just(pseudo));
    }, $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2($rtfeldman$elm_css$Css$Structure$applyPseudoElement_fn);
    var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector_fn = function (pseudo, styleBlock) {
        return $rtfeldman$elm_css$Css$Structure$appendToLastSelector_fn($rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo), styleBlock);
    }, $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2($rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector_fn);
    var $rtfeldman$elm_css$Css$Structure$CustomSelector_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Structure$CustomSelector = F2($rtfeldman$elm_css$Css$Structure$CustomSelector_fn);
    var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2($rtfeldman$elm_css$Css$Structure$TypeSelectorSequence_fn);
    var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
        return { $: 1, a: a };
    };
    var $rtfeldman$elm_css$Css$Structure$appendRepeatable_fn = function (selector, sequence) {
        switch (sequence.$) {
            case 0:
                var typeSelector = sequence.a;
                var list = sequence.b;
                return $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence_fn(typeSelector, _Utils_ap(list, _List_fromArray([selector])));
            case 1:
                var list = sequence.a;
                return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_Utils_ap(list, _List_fromArray([selector])));
            default:
                var str = sequence.a;
                var list = sequence.b;
                return $rtfeldman$elm_css$Css$Structure$CustomSelector_fn(str, _Utils_ap(list, _List_fromArray([selector])));
        }
    }, $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2($rtfeldman$elm_css$Css$Structure$appendRepeatable_fn);
    var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator_fn = function (selector, list) {
        if (!list.b) {
            return _List_Nil;
        }
        else {
            if (!list.b.b) {
                var _v1 = list.a;
                var combinator = _v1.a;
                var sequence = _v1.b;
                return _List_fromArray([
                    _Utils_Tuple2(combinator, $rtfeldman$elm_css$Css$Structure$appendRepeatable_fn(selector, sequence))
                ]);
            }
            else {
                var first = list.a;
                var rest = list.b;
                return _List_Cons(first, $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator_fn(selector, rest));
            }
        }
    }, $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator_fn);
    var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector_fn = function (repeatableSimpleSelector, selector) {
        if (!selector.b.b) {
            var sequence = selector.a;
            var pseudoElement = selector.c;
            return $rtfeldman$elm_css$Css$Structure$Selector_fn($rtfeldman$elm_css$Css$Structure$appendRepeatable_fn(repeatableSimpleSelector, sequence), _List_Nil, pseudoElement);
        }
        else {
            var firstSelector = selector.a;
            var tuples = selector.b;
            var pseudoElement = selector.c;
            return $rtfeldman$elm_css$Css$Structure$Selector_fn(firstSelector, $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator_fn(repeatableSimpleSelector, tuples), pseudoElement);
        }
    }, $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2($rtfeldman$elm_css$Css$Structure$appendRepeatableSelector_fn);
    var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector_fn = function (selector, styleBlock) {
        return $rtfeldman$elm_css$Css$Structure$appendToLastSelector_fn($rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector), styleBlock);
    }, $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2($rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
        collectSelectors: while (true) {
            if (!declarations.b) {
                return _List_Nil;
            }
            else {
                if (!declarations.a.$) {
                    var _v1 = declarations.a.a;
                    var firstSelector = _v1.a;
                    var otherSelectors = _v1.b;
                    var rest = declarations.b;
                    return _Utils_ap(_List_Cons(firstSelector, otherSelectors), $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
                }
                else {
                    var rest = declarations.b;
                    var $temp$declarations = rest;
                    declarations = $temp$declarations;
                    continue collectSelectors;
                }
            }
        }
    };
    var $rtfeldman$elm_css$Css$Structure$DocumentRule_fn = function (a, b, c, d, e) {
        return { $: 3, a: a, b: b, c: c, d: d, e: e };
    }, $rtfeldman$elm_css$Css$Structure$DocumentRule = F5($rtfeldman$elm_css$Css$Structure$DocumentRule_fn);
    var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock_fn = function (update, declarations) {
        _v0$12: while (true) {
            if (!declarations.b) {
                return declarations;
            }
            else {
                if (!declarations.b.b) {
                    switch (declarations.a.$) {
                        case 0:
                            var styleBlock = declarations.a.a;
                            return $elm$core$List$map_fn($rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration, update(styleBlock));
                        case 1:
                            if (declarations.a.b.b) {
                                if (!declarations.a.b.b.b) {
                                    var _v1 = declarations.a;
                                    var mediaQueries = _v1.a;
                                    var _v2 = _v1.b;
                                    var styleBlock = _v2.a;
                                    return _List_fromArray([
                                        $rtfeldman$elm_css$Css$Structure$MediaRule_fn(mediaQueries, update(styleBlock))
                                    ]);
                                }
                                else {
                                    var _v3 = declarations.a;
                                    var mediaQueries = _v3.a;
                                    var _v4 = _v3.b;
                                    var first = _v4.a;
                                    var rest = _v4.b;
                                    var _v5 = $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock_fn(update, _List_fromArray([
                                        $rtfeldman$elm_css$Css$Structure$MediaRule_fn(mediaQueries, rest)
                                    ]));
                                    if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
                                        var _v6 = _v5.a;
                                        var newMediaQueries = _v6.a;
                                        var newStyleBlocks = _v6.b;
                                        return _List_fromArray([
                                            $rtfeldman$elm_css$Css$Structure$MediaRule_fn(newMediaQueries, _List_Cons(first, newStyleBlocks))
                                        ]);
                                    }
                                    else {
                                        var newDeclarations = _v5;
                                        return newDeclarations;
                                    }
                                }
                            }
                            else {
                                break _v0$12;
                            }
                        case 2:
                            var _v7 = declarations.a;
                            var str = _v7.a;
                            var nestedDeclarations = _v7.b;
                            return _List_fromArray([
                                $rtfeldman$elm_css$Css$Structure$SupportsRule_fn(str, $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock_fn(update, nestedDeclarations))
                            ]);
                        case 3:
                            var _v8 = declarations.a;
                            var str1 = _v8.a;
                            var str2 = _v8.b;
                            var str3 = _v8.c;
                            var str4 = _v8.d;
                            var styleBlock = _v8.e;
                            return $elm$core$List$map_fn(A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4), update(styleBlock));
                        case 4:
                            var _v9 = declarations.a;
                            return declarations;
                        case 5:
                            return declarations;
                        case 6:
                            return declarations;
                        case 7:
                            return declarations;
                        case 8:
                            return declarations;
                        default:
                            return declarations;
                    }
                }
                else {
                    break _v0$12;
                }
            }
        }
        var first = declarations.a;
        var rest = declarations.b;
        return _List_Cons(first, $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock_fn(update, rest));
    }, $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
        last: while (true) {
            if (!list.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                if (!list.b.b) {
                    var singleton = list.a;
                    return $elm$core$Maybe$Just(singleton);
                }
                else {
                    var rest = list.b;
                    var $temp$list = rest;
                    list = $temp$list;
                    continue last;
                }
            }
        }
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
        lastDeclaration: while (true) {
            if (!declarations.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                if (!declarations.b.b) {
                    var x = declarations.a;
                    return $elm$core$Maybe$Just(_List_fromArray([x]));
                }
                else {
                    var xs = declarations.b;
                    var $temp$declarations = xs;
                    declarations = $temp$declarations;
                    continue lastDeclaration;
                }
            }
        }
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
        oneOf: while (true) {
            if (!maybes.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var maybe = maybes.a;
                var rest = maybes.b;
                if (maybe.$ === 1) {
                    var $temp$maybes = rest;
                    maybes = $temp$maybes;
                    continue oneOf;
                }
                else {
                    return maybe;
                }
            }
        }
    };
    var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
        return { $: 9, a: a };
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
        var expandTuples = function (tuplesToExpand) {
            if (!tuplesToExpand.b) {
                return _List_Nil;
            }
            else {
                var properties = tuplesToExpand.a;
                var rest = tuplesToExpand.b;
                return _List_Cons(properties, expandTuples(rest));
            }
        };
        var newTuples = expandTuples(tuples);
        return _List_fromArray([
            $rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
        ]);
    };
    var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule_fn = function (mediaQueries, declaration) {
        if (!declaration.$) {
            var styleBlock = declaration.a;
            return $rtfeldman$elm_css$Css$Structure$MediaRule_fn(mediaQueries, _List_fromArray([styleBlock]));
        }
        else {
            return declaration;
        }
    }, $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2($rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule_fn = function (str1, str2, str3, str4, declaration) {
        if (!declaration.$) {
            var structureStyleBlock = declaration.a;
            return $rtfeldman$elm_css$Css$Structure$DocumentRule_fn(str1, str2, str3, str4, structureStyleBlock);
        }
        else {
            return declaration;
        }
    }, $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule_fn = function (mediaQueries, declaration) {
        switch (declaration.$) {
            case 0:
                var structureStyleBlock = declaration.a;
                return $rtfeldman$elm_css$Css$Structure$MediaRule_fn(mediaQueries, _List_fromArray([structureStyleBlock]));
            case 1:
                var newMediaQueries = declaration.a;
                var structureStyleBlocks = declaration.b;
                return $rtfeldman$elm_css$Css$Structure$MediaRule_fn(_Utils_ap(mediaQueries, newMediaQueries), structureStyleBlocks);
            case 2:
                var str = declaration.a;
                var declarations = declaration.b;
                return $rtfeldman$elm_css$Css$Structure$SupportsRule_fn(str, $elm$core$List$map_fn($rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries), declarations));
            case 3:
                var str1 = declaration.a;
                var str2 = declaration.b;
                var str3 = declaration.c;
                var str4 = declaration.d;
                var structureStyleBlock = declaration.e;
                return $rtfeldman$elm_css$Css$Structure$DocumentRule_fn(str1, str2, str3, str4, structureStyleBlock);
            case 4:
                return declaration;
            case 5:
                return declaration;
            case 6:
                return declaration;
            case 7:
                return declaration;
            case 8:
                return declaration;
            default:
                return declaration;
        }
    }, $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2($rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule_fn);
    var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
        var declarations = _v0;
        return declarations;
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast_fn = function (nestedStyles, rest, f, declarations) {
        var withoutParent = function (decls) {
            return $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$List$tail(decls));
        };
        var nextResult = $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(rest, $elm$core$Maybe$withDefault_fn(_List_Nil, $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
        var newDeclarations = function () {
            var _v14 = _Utils_Tuple2($elm$core$List$head(nextResult), $rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
            if ((!_v14.a.$) && (!_v14.b.$)) {
                var nextResultParent = _v14.a.a;
                var originalParent = _v14.b.a;
                return _Utils_ap($elm$core$List$take_fn($elm$core$List$length(declarations) - 1, declarations), _List_fromArray([
                    (!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
                ]));
            }
            else {
                return declarations;
            }
        }();
        var insertStylesToNestedDecl = function (lastDecl) {
            return $elm$core$List$concat($rtfeldman$elm_css$Css$Structure$mapLast_fn($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles), $elm$core$List$map_fn($elm$core$List$singleton, $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock_fn(f, lastDecl))));
        };
        var initialResult = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(insertStylesToNestedDecl, $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
        return _Utils_ap(newDeclarations, _Utils_ap(withoutParent(initialResult), withoutParent(nextResult)));
    }, $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4($rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn = function (styles, declarations) {
        if (!styles.b) {
            return declarations;
        }
        else {
            switch (styles.a.$) {
                case 0:
                    var property = styles.a.a;
                    var rest = styles.b;
                    return $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(rest, $rtfeldman$elm_css$Css$Structure$appendProperty_fn(property, declarations));
                case 1:
                    var _v4 = styles.a;
                    var selector = _v4.a;
                    var nestedStyles = _v4.b;
                    var rest = styles.b;
                    return $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast_fn(nestedStyles, rest, $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector), declarations);
                case 2:
                    var _v5 = styles.a;
                    var selectorCombinator = _v5.a;
                    var snippets = _v5.b;
                    var rest = styles.b;
                    var chain = F2(function (_v9, _v10) {
                        var originalSequence = _v9.a;
                        var originalTuples = _v9.b;
                        var originalPseudoElement = _v9.c;
                        var newSequence = _v10.a;
                        var newTuples = _v10.b;
                        var newPseudoElement = _v10.c;
                        return $rtfeldman$elm_css$Css$Structure$Selector_fn(originalSequence, _Utils_ap(originalTuples, _List_Cons(_Utils_Tuple2(selectorCombinator, newSequence), newTuples)), $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(_List_fromArray([newPseudoElement, originalPseudoElement])));
                    });
                    var expandDeclaration = function (declaration) {
                        switch (declaration.$) {
                            case 0:
                                var _v7 = declaration.a;
                                var firstSelector = _v7.a;
                                var otherSelectors = _v7.b;
                                var nestedStyles = _v7.c;
                                var newSelectors = $elm$core$List$concatMap_fn(function (originalSelector) {
                                    return $elm$core$List$map_fn(chain(originalSelector), _List_Cons(firstSelector, otherSelectors));
                                }, $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
                                var newDeclarations = function () {
                                    if (!newSelectors.b) {
                                        return _List_Nil;
                                    }
                                    else {
                                        var first = newSelectors.a;
                                        var remainder = newSelectors.b;
                                        return _List_fromArray([
                                            $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration($rtfeldman$elm_css$Css$Structure$StyleBlock_fn(first, remainder, _List_Nil))
                                        ]);
                                    }
                                }();
                                return $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(nestedStyles, newDeclarations);
                            case 1:
                                var mediaQueries = declaration.a;
                                var styleBlocks = declaration.b;
                                return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule_fn(mediaQueries, styleBlocks);
                            case 2:
                                var str = declaration.a;
                                var otherSnippets = declaration.b;
                                return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule_fn(str, otherSnippets);
                            case 3:
                                var str1 = declaration.a;
                                var str2 = declaration.b;
                                var str3 = declaration.c;
                                var str4 = declaration.d;
                                var styleBlock = declaration.e;
                                return $elm$core$List$map_fn(A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4), $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
                            case 4:
                                var str = declaration.a;
                                var properties = declaration.b;
                                return _List_fromArray([
                                    $rtfeldman$elm_css$Css$Structure$PageRule_fn(str, properties)
                                ]);
                            case 5:
                                var properties = declaration.a;
                                return _List_fromArray([
                                    $rtfeldman$elm_css$Css$Structure$FontFace(properties)
                                ]);
                            case 6:
                                var properties = declaration.a;
                                return _List_fromArray([
                                    $rtfeldman$elm_css$Css$Structure$Viewport(properties)
                                ]);
                            case 7:
                                var properties = declaration.a;
                                return _List_fromArray([
                                    $rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
                                ]);
                            default:
                                var tuples = declaration.a;
                                return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
                        }
                    };
                    return $elm$core$List$concat(_Utils_ap(_List_fromArray([
                        $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(rest, declarations)
                    ]), $elm$core$List$map_fn(expandDeclaration, $elm$core$List$concatMap_fn($rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
                case 3:
                    var _v11 = styles.a;
                    var pseudoElement = _v11.a;
                    var nestedStyles = _v11.b;
                    var rest = styles.b;
                    return $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast_fn(nestedStyles, rest, $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement), declarations);
                case 5:
                    var str = styles.a.a;
                    var rest = styles.b;
                    var name = $rtfeldman$elm_css$Hash$fromString(str);
                    var newProperty = "animation-name:" + name;
                    var newDeclarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(rest, $rtfeldman$elm_css$Css$Structure$appendProperty_fn(newProperty, declarations));
                    return $elm$core$List$append_fn(newDeclarations, _List_fromArray([
                        $rtfeldman$elm_css$Css$Structure$Keyframes((new $$Record151(str, name)))
                    ]));
                case 4:
                    var _v12 = styles.a;
                    var mediaQueries = _v12.a;
                    var nestedStyles = _v12.b;
                    var rest = styles.b;
                    var extraDeclarations = function () {
                        var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
                        if (!_v13.b) {
                            return _List_Nil;
                        }
                        else {
                            var firstSelector = _v13.a;
                            var otherSelectors = _v13.b;
                            return $elm$core$List$map_fn($rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries), $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(nestedStyles, $elm$core$List$singleton($rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration($rtfeldman$elm_css$Css$Structure$StyleBlock_fn(firstSelector, otherSelectors, _List_Nil)))));
                        }
                    }();
                    return _Utils_ap($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(rest, declarations), extraDeclarations);
                default:
                    var otherStyles = styles.a.a;
                    var rest = styles.b;
                    return $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(_Utils_ap(otherStyles, rest), declarations);
            }
        }
    }, $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
        var firstSelector = _v2.a;
        var otherSelectors = _v2.b;
        var styles = _v2.c;
        return $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles_fn(styles, _List_fromArray([
            $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration($rtfeldman$elm_css$Css$Structure$StyleBlock_fn(firstSelector, otherSelectors, _List_Nil))
        ]));
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
        if (!snippetDeclarations.b) {
            return _List_Nil;
        }
        else {
            var first = snippetDeclarations.a;
            var rest = snippetDeclarations.b;
            return _Utils_ap($rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first), $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
        }
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule_fn = function (mediaQueries, styleBlocks) {
        var handleStyleBlock = function (styleBlock) {
            return $elm$core$List$map_fn($rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries), $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
        };
        return $elm$core$List$concatMap_fn(handleStyleBlock, styleBlocks);
    }, $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule_fn = function (str, snippets) {
        var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract($elm$core$List$concatMap_fn($rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
        return _List_fromArray([
            $rtfeldman$elm_css$Css$Structure$SupportsRule_fn(str, declarations)
        ]);
    }, $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule_fn);
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
        switch (snippetDeclaration.$) {
            case 0:
                var styleBlock = snippetDeclaration.a;
                return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
            case 1:
                var mediaQueries = snippetDeclaration.a;
                var styleBlocks = snippetDeclaration.b;
                return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule_fn(mediaQueries, styleBlocks);
            case 2:
                var str = snippetDeclaration.a;
                var snippets = snippetDeclaration.b;
                return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule_fn(str, snippets);
            case 3:
                var str1 = snippetDeclaration.a;
                var str2 = snippetDeclaration.b;
                var str3 = snippetDeclaration.c;
                var str4 = snippetDeclaration.d;
                var styleBlock = snippetDeclaration.e;
                return $elm$core$List$map_fn(A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4), $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
            case 4:
                var str = snippetDeclaration.a;
                var properties = snippetDeclaration.b;
                return _List_fromArray([
                    $rtfeldman$elm_css$Css$Structure$PageRule_fn(str, properties)
                ]);
            case 5:
                var properties = snippetDeclaration.a;
                return _List_fromArray([
                    $rtfeldman$elm_css$Css$Structure$FontFace(properties)
                ]);
            case 6:
                var properties = snippetDeclaration.a;
                return _List_fromArray([
                    $rtfeldman$elm_css$Css$Structure$Viewport(properties)
                ]);
            case 7:
                var properties = snippetDeclaration.a;
                return _List_fromArray([
                    $rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
                ]);
            default:
                var tuples = snippetDeclaration.a;
                return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
        }
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
        var charset = _v0.gX;
        var imports = _v0.hO;
        var namespaces = _v0.ij;
        var snippets = _v0.je;
        var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract($elm$core$List$concatMap_fn($rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
        return { gX: charset, lf: declarations, hO: imports, ij: namespaces };
    };
    var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (sheet) {
        return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint($rtfeldman$elm_css$Css$Structure$compactStylesheet($rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
    };
    var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
    var $rtfeldman$elm_css$Css$Preprocess$StyleBlock_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3($rtfeldman$elm_css$Css$Preprocess$StyleBlock_fn);
    var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
        return { $: 0, a: a };
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet_fn = function (styles, sequence) {
        var selector = $rtfeldman$elm_css$Css$Structure$Selector_fn(sequence, _List_Nil, $elm$core$Maybe$Nothing);
        return _List_fromArray([
            $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration($rtfeldman$elm_css$Css$Preprocess$StyleBlock_fn(selector, _List_Nil, styles))
        ]);
    }, $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2($rtfeldman$elm_css$VirtualDom$Styled$makeSnippet_fn);
    var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
        return { gX: $elm$core$Maybe$Nothing, hO: _List_Nil, ij: _List_Nil, je: snippets };
    };
    var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
        return { $: 0, a: a };
    };
    var $rtfeldman$elm_css$VirtualDom$Styled$templateSelector = $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_fromArray([
        $rtfeldman$elm_css$Css$Structure$ClassSelector($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin)
    ]));
    var $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate = function (styles) {
        if (!styles.b) {
            return "";
        }
        else {
            var otherwise = styles;
            return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile($rtfeldman$elm_css$Css$Preprocess$stylesheet(_List_fromArray([
                $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet_fn(styles, $rtfeldman$elm_css$VirtualDom$Styled$templateSelector)
            ])));
        }
    };
    var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
        var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
        var classProperty = $elm$virtual_dom$VirtualDom$attribute_fn("", "");
        return $rtfeldman$elm_css$VirtualDom$Styled$Attribute_fn(classProperty, true, cssTemplate);
    };
    var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
    var $rtfeldman$elm_css$VirtualDom$Styled$Node_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $rtfeldman$elm_css$VirtualDom$Styled$Node = F3($rtfeldman$elm_css$VirtualDom$Styled$Node_fn);
    var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
    var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
    var $rtfeldman$elm_css$Html$Styled$div_a0 = "div", $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node($rtfeldman$elm_css$Html$Styled$div_a0);
    var $rtfeldman$elm_css$Css$flexEnd_a0 = "flex-end", $rtfeldman$elm_css$Css$flexEnd = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$flexEnd_a0);
    var $rtfeldman$elm_css$Css$height_a0 = "height", $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$height_a0);
    var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
        return _String_startsWith_fn("#", str) ? str : _String_cons_fn("#", str);
    };
    var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
        return {
            bU: 1,
            gR: 0,
            kS: 0,
            hE: 0,
            iU: 0,
            p_: $rtfeldman$elm_css$Css$withPrecedingHash(str)
        };
    };
    var $rtfeldman$elm_css$Css$validHex_fn = function (str, _v0, _v1, _v2, _v3) {
        var r1 = _v0.a;
        var r2 = _v0.b;
        var g1 = _v1.a;
        var g2 = _v1.b;
        var b1 = _v2.a;
        var b2 = _v2.b;
        var a1 = _v3.a;
        var a2 = _v3.b;
        var toResult = A2($elm$core$Basics$composeR, $elm$core$String$fromList, A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
        var results = _Utils_Tuple2(_Utils_Tuple2(toResult(_List_fromArray([r1, r2])), toResult(_List_fromArray([g1, g2]))), _Utils_Tuple2(toResult(_List_fromArray([b1, b2])), toResult(_List_fromArray([a1, a2]))));
        if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
            var _v5 = results.a;
            var red = _v5.a.a;
            var green = _v5.b.a;
            var _v6 = results.b;
            var blue = _v6.a.a;
            var alpha = _v6.b.a;
            return {
                bU: alpha / 255,
                gR: blue,
                kS: 0,
                hE: green,
                iU: red,
                p_: $rtfeldman$elm_css$Css$withPrecedingHash(str)
            };
        }
        else {
            return $rtfeldman$elm_css$Css$erroneousHex(str);
        }
    }, $rtfeldman$elm_css$Css$validHex = F5($rtfeldman$elm_css$Css$validHex_fn);
    var $rtfeldman$elm_css$Css$hex = function (str) {
        var withoutHash = _String_startsWith_fn("#", str) ? $elm$core$String$dropLeft_fn(1, str) : str;
        var _v0 = $elm$core$String$toList(withoutHash);
        _v0$4: while (true) {
            if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
                if (!_v0.b.b.b.b) {
                    var r = _v0.a;
                    var _v1 = _v0.b;
                    var g = _v1.a;
                    var _v2 = _v1.b;
                    var b = _v2.a;
                    return $rtfeldman$elm_css$Css$validHex_fn(str, _Utils_Tuple2(r, r), _Utils_Tuple2(g, g), _Utils_Tuple2(b, b), _Utils_Tuple2("f", "f"));
                }
                else {
                    if (!_v0.b.b.b.b.b) {
                        var r = _v0.a;
                        var _v3 = _v0.b;
                        var g = _v3.a;
                        var _v4 = _v3.b;
                        var b = _v4.a;
                        var _v5 = _v4.b;
                        var a = _v5.a;
                        return $rtfeldman$elm_css$Css$validHex_fn(str, _Utils_Tuple2(r, r), _Utils_Tuple2(g, g), _Utils_Tuple2(b, b), _Utils_Tuple2(a, a));
                    }
                    else {
                        if (_v0.b.b.b.b.b.b) {
                            if (!_v0.b.b.b.b.b.b.b) {
                                var r1 = _v0.a;
                                var _v6 = _v0.b;
                                var r2 = _v6.a;
                                var _v7 = _v6.b;
                                var g1 = _v7.a;
                                var _v8 = _v7.b;
                                var g2 = _v8.a;
                                var _v9 = _v8.b;
                                var b1 = _v9.a;
                                var _v10 = _v9.b;
                                var b2 = _v10.a;
                                return $rtfeldman$elm_css$Css$validHex_fn(str, _Utils_Tuple2(r1, r2), _Utils_Tuple2(g1, g2), _Utils_Tuple2(b1, b2), _Utils_Tuple2("f", "f"));
                            }
                            else {
                                if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
                                    var r1 = _v0.a;
                                    var _v11 = _v0.b;
                                    var r2 = _v11.a;
                                    var _v12 = _v11.b;
                                    var g1 = _v12.a;
                                    var _v13 = _v12.b;
                                    var g2 = _v13.a;
                                    var _v14 = _v13.b;
                                    var b1 = _v14.a;
                                    var _v15 = _v14.b;
                                    var b2 = _v15.a;
                                    var _v16 = _v15.b;
                                    var a1 = _v16.a;
                                    var _v17 = _v16.b;
                                    var a2 = _v17.a;
                                    return $rtfeldman$elm_css$Css$validHex_fn(str, _Utils_Tuple2(r1, r2), _Utils_Tuple2(g1, g2), _Utils_Tuple2(b1, b2), _Utils_Tuple2(a1, a2));
                                }
                                else {
                                    break _v0$4;
                                }
                            }
                        }
                        else {
                            break _v0$4;
                        }
                    }
                }
            }
            else {
                break _v0$4;
            }
        }
        return $rtfeldman$elm_css$Css$erroneousHex(str);
    };
    var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
        return $rtfeldman$elm_css$Css$Internal$getOverloadedProperty_fn("justifyContent", "justify-content", fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
    };
    var $rtfeldman$elm_css$Css$Internal$printKeyframeSelector = function (_v0) {
        var percentage = _v0.a;
        var properties = _v0.b;
        var propertiesStr = $rtfeldman$elm_css$Css$String$mapJoin_fn(function (_v1) {
            var prop = _v1;
            return prop + ";";
        }, "", properties);
        var percentageStr = $elm$core$String$fromInt(percentage) + "%";
        return percentageStr + ("{" + (propertiesStr + "}"));
    };
    var $rtfeldman$elm_css$Css$Internal$compileKeyframes = function (tuples) {
        return $rtfeldman$elm_css$Css$String$mapJoin_fn($rtfeldman$elm_css$Css$Internal$printKeyframeSelector, "", tuples);
    };
    var $rtfeldman$elm_css$Css$Animations$keyframes = function (tuples) {
        return $elm$core$List$isEmpty(tuples) ? { fE: 0, fN: 0, p_: "none" } : {
            fE: 0,
            fN: 0,
            p_: $rtfeldman$elm_css$Css$Internal$compileKeyframes(tuples)
        };
    };
    var $rtfeldman$elm_css$Css$prop2_fn = function (key, argA, argB) {
        return $rtfeldman$elm_css$Css$property_fn(key, argA.p_ + (" " + argB.p_));
    }, $rtfeldman$elm_css$Css$prop2 = F3($rtfeldman$elm_css$Css$prop2_fn);
    var $rtfeldman$elm_css$Css$margin2_a0 = "margin", $rtfeldman$elm_css$Css$margin2 = $rtfeldman$elm_css$Css$prop2($rtfeldman$elm_css$Css$margin2_a0);
    var $rtfeldman$elm_css$Css$position_a0 = "position", $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$position_a0);
    var $rtfeldman$elm_css$Css$Internal$Property = $elm$core$Basics$identity;
    var $rtfeldman$elm_css$Css$Animations$property_fn = function (key, value) {
        return key + (":" + value);
    }, $rtfeldman$elm_css$Css$Animations$property = F2($rtfeldman$elm_css$Css$Animations$property_fn);
    var $rtfeldman$elm_css$Css$PxUnits = 0;
    var $rtfeldman$elm_css$Css$px_a0 = 0, $rtfeldman$elm_css$Css$px_a1 = "px", $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1);
    var $rtfeldman$elm_css$Css$relative = { dd: 0, p_: "relative" };
    var $rtfeldman$elm_css$Css$spaceBetween_a0 = "space-between", $rtfeldman$elm_css$Css$spaceBetween = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$spaceBetween_a0);
    var $rtfeldman$elm_css$Css$width_a0 = "width", $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$width_a0);
    var $perzanko$elm_loading$Loading$Bars$view = function (config) {
        var withSpeed = function (x) {
            return $elm$core$String$fromFloat(x / config.oK);
        };
        var outerStyle = _List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$position_a0, $rtfeldman$elm_css$Css$relative),
            $rtfeldman$elm_css$Css$prop2_fn($rtfeldman$elm_css$Css$margin2_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0), $rtfeldman$elm_css$Css$auto),
            $rtfeldman$elm_css$Css$property_fn("display", "flex"),
            $rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
            $rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexEnd)
        ]);
        var childStyle = _List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE / 3.5)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE / 3.5)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$borderRadius_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 5)),
            $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$hex(config.kS)),
            $rtfeldman$elm_css$Css$property_fn("animation-duration", withSpeed(1.5) + "s"),
            $rtfeldman$elm_css$Css$property_fn("animation-iteration-count", "infinite"),
            $rtfeldman$elm_css$Css$property_fn("animation-timing-function", "ease-in-out"),
            $rtfeldman$elm_css$Css$animationName($rtfeldman$elm_css$Css$Animations$keyframes(_List_fromArray([
                _Utils_Tuple2(0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Animations$property_fn("height", $elm$core$String$fromFloat(config.oE / 3.5) + "px"),
                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "translate3d(0,0,0)")
                ])),
                _Utils_Tuple2(50, _List_fromArray([
                    $rtfeldman$elm_css$Css$Animations$property_fn("height", $elm$core$String$fromFloat(config.oE) + "px"),
                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "translate3d(0,0,0)")
                ])),
                _Utils_Tuple2(100, _List_fromArray([
                    $rtfeldman$elm_css$Css$Animations$property_fn("height", $elm$core$String$fromFloat(config.oE / 3.5) + "px"),
                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "translate3d(0,0,0)")
                ]))
            ])))
        ]);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, config.kJ)
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(childStyle, _List_fromArray([
                    $rtfeldman$elm_css$Css$property_fn("animation-delay", withSpeed(1) + "s")
                ])))
            ]), _List_Nil),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(childStyle, _List_fromArray([
                    $rtfeldman$elm_css$Css$property_fn("animation-delay", withSpeed(0.5) + "s")
                ])))
            ]), _List_Nil),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(childStyle, _List_fromArray([
                    $rtfeldman$elm_css$Css$property_fn("animation-delay", withSpeed(1e-7) + "s")
                ])))
            ]), _List_Nil)
        ]));
    };
    var $rtfeldman$elm_css$Css$block = { r: 0, p_: "block" };
    var $rtfeldman$elm_css$Css$center_a0 = "center", $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$center_a0);
    var $rtfeldman$elm_css$Css$display_a0 = "display", $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$display_a0);
    var $rtfeldman$elm_css$Css$PercentageUnits = 0;
    var $rtfeldman$elm_css$Css$pct_a0 = 0, $rtfeldman$elm_css$Css$pct_a1 = "%", $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1);
    var $perzanko$elm_loading$Loading$BouncingBalls$view = function (config) {
        var withSpeed = function (x) {
            return $elm$core$String$fromFloat(x / config.oK);
        };
        var outerStyle = _List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$position_a0, $rtfeldman$elm_css$Css$relative),
            $rtfeldman$elm_css$Css$prop2_fn($rtfeldman$elm_css$Css$margin2_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0), $rtfeldman$elm_css$Css$auto),
            $rtfeldman$elm_css$Css$property_fn("display", "flex"),
            $rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
            $rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
        ]);
        var childStyle = _List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$display_a0, $rtfeldman$elm_css$Css$block),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE / 3.5)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE / 3.5)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$borderRadius_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 100)),
            $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$hex(config.kS)),
            $rtfeldman$elm_css$Css$property_fn("animation-duration", withSpeed(0.6) + "s"),
            $rtfeldman$elm_css$Css$property_fn("animation-delay", withSpeed(0.1) + "s"),
            $rtfeldman$elm_css$Css$property_fn("animation-timing-function", "linear"),
            $rtfeldman$elm_css$Css$property_fn("animation-iteration-count", "infinite"),
            $rtfeldman$elm_css$Css$animationName($rtfeldman$elm_css$Css$Animations$keyframes(_List_fromArray([
                _Utils_Tuple2(0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "translate3d(0,0,0) translateZ(0) translate(0,0)")
                ])),
                _Utils_Tuple2(50, _List_fromArray([
                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "translate3d(0,0,0) translateZ(0) translate(0," + ($elm$core$String$fromFloat(config.oE / 3.5) + "px)"))
                ])),
                _Utils_Tuple2(100, _List_fromArray([
                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "translate3d(0,0,0) translateZ(0) translate(0,0)")
                ]))
            ])))
        ]);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, config.kJ)
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(childStyle, _List_fromArray([
                    $rtfeldman$elm_css$Css$property_fn("animation-delay", withSpeed(0.1) + "s")
                ])))
            ]), _List_Nil),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(childStyle, _List_fromArray([
                    $rtfeldman$elm_css$Css$property_fn("animation-delay", withSpeed(0.2) + "s")
                ])))
            ]), _List_Nil),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_Utils_ap(childStyle, _List_fromArray([
                    $rtfeldman$elm_css$Css$property_fn("animation-delay", withSpeed(0.3) + "s")
                ])))
            ]), _List_Nil)
        ]));
    };
    var $rtfeldman$elm_css$Css$absolute = { dd: 0, p_: "absolute" };
    var $rtfeldman$elm_css$Css$left_a0 = "left", $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$left_a0);
    var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
    var $rtfeldman$elm_css$Css$num = function (val) {
        return {
            bx: 0,
            ap: 0,
            nr: 0,
            ef: 0,
            aZ: val,
            cv: "",
            dq: 0,
            p_: $elm$core$String$fromFloat(val)
        };
    };
    var $rtfeldman$elm_css$Css$opacity_a0 = "opacity", $rtfeldman$elm_css$Css$opacity = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$opacity_a0);
    var $rtfeldman$elm_css$Css$top_a0 = "top", $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1($rtfeldman$elm_css$Css$top_a0);
    var $perzanko$elm_loading$Loading$Circle$view = function (config) {
        var withSpeed = function (x) {
            return $elm$core$String$fromFloat(x / config.oK);
        };
        var outerStyle = _List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE * 0.95)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$position_a0, $rtfeldman$elm_css$Css$relative),
            $rtfeldman$elm_css$Css$prop2_fn($rtfeldman$elm_css$Css$margin2_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0), $rtfeldman$elm_css$Css$auto)
        ]);
        var childStyle = _List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE - (2 * (config.oE * 0.17)))),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE - (2 * (config.oE * 0.17)))),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$borderRadius_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 50)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$position_a0, $rtfeldman$elm_css$Css$absolute),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$top_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$left_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0)),
            $rtfeldman$elm_css$Css$property_fn("animation-duration", withSpeed(1.33) + "s"),
            $rtfeldman$elm_css$Css$property_fn("animation-timing-function", "cubic-bezier(.51,.92,.24,1.15)"),
            $rtfeldman$elm_css$Css$property_fn("animation-iteration-count", "infinite"),
            $rtfeldman$elm_css$Css$animationName($rtfeldman$elm_css$Css$Animations$keyframes(_List_fromArray([
                _Utils_Tuple2(0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "translate3d(0,0,0) rotate(0deg)")
                ])),
                _Utils_Tuple2(100, _List_fromArray([
                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "translate3d(0,0,0) rotate(720deg)")
                ]))
            ])))
        ]);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, config.kJ)
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css($elm$core$List$concat(_List_fromArray([
                    childStyle,
                    _List_fromArray([
                        $rtfeldman$elm_css$Css$property_fn("border", $elm$core$String$fromFloat(config.oE * 0.17) + ("px " + (config.kS + " solid"))),
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$opacity_a0, $rtfeldman$elm_css$Css$num(0.25))
                    ])
                ])))
            ]), _List_Nil),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css($elm$core$List$concat(_List_fromArray([
                    childStyle,
                    _List_fromArray([
                        $rtfeldman$elm_css$Css$property_fn("border", $elm$core$String$fromFloat(config.oE * 0.17) + "px transparent solid"),
                        $rtfeldman$elm_css$Css$property_fn("border-top", $elm$core$String$fromFloat(config.oE * 0.17) + ("px " + (config.kS + " solid"))),
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$opacity_a0, $rtfeldman$elm_css$Css$num(0.8))
                    ])
                ])))
            ]), _List_Nil)
        ]));
    };
    var $perzanko$elm_loading$Loading$DoubleBounce$view = function (config) {
        var outerStyle = _List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$position_a0, $rtfeldman$elm_css$Css$relative),
            $rtfeldman$elm_css$Css$prop2_fn($rtfeldman$elm_css$Css$margin2_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0), $rtfeldman$elm_css$Css$auto)
        ]);
        var innerStyle = _List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 100)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 100)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$borderRadius_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 50)),
            $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$hex(config.kS)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$opacity_a0, $rtfeldman$elm_css$Css$num(0.6)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$position_a0, $rtfeldman$elm_css$Css$absolute),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$top_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$left_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0)),
            $rtfeldman$elm_css$Css$animationName($rtfeldman$elm_css$Css$Animations$keyframes(_List_fromArray([
                _Utils_Tuple2(0, _List_fromArray([
                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(0.0)")
                ])),
                _Utils_Tuple2(50, _List_fromArray([
                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(1.0)")
                ])),
                _Utils_Tuple2(100, _List_fromArray([
                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(0.0)")
                ]))
            ]))),
            $rtfeldman$elm_css$Css$property_fn("animation-duration", $elm$core$String$fromFloat(2 / config.oK) + "s"),
            $rtfeldman$elm_css$Css$property_fn("animation-timing-function", "ease-in-out"),
            $rtfeldman$elm_css$Css$property_fn("animation-iteration-count", "infinite")
        ]);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, config.kJ)
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(innerStyle)
            ]), _List_Nil),
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css($elm$core$List$concat(_List_fromArray([
                    innerStyle,
                    _List_fromArray([
                        $rtfeldman$elm_css$Css$property_fn("animation-delay", "-" + ($elm$core$String$fromFloat(1 / config.oK) + "s"))
                    ])
                ])))
            ]), _List_Nil)
        ]));
    };
    var $rtfeldman$elm_css$Css$Structure$PseudoElement = $elm$core$Basics$identity;
    var $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement = F2($rtfeldman$elm_css$Css$Preprocess$WithPseudoElement_fn);
    var $rtfeldman$elm_css$Css$pseudoElement = function (element) {
        return $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement(element);
    };
    var $rtfeldman$elm_css$Css$after = $rtfeldman$elm_css$Css$pseudoElement("after");
    var $rtfeldman$elm_css$Css$before = $rtfeldman$elm_css$Css$pseudoElement("before");
    var $rtfeldman$elm_css$Css$prop3_fn = function (key, argA, argB, argC) {
        return $rtfeldman$elm_css$Css$property_fn(key, argA.p_ + (" " + (argB.p_ + (" " + argC.p_))));
    }, $rtfeldman$elm_css$Css$prop3 = F4($rtfeldman$elm_css$Css$prop3_fn);
    var $rtfeldman$elm_css$Css$border3_a0 = "border", $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3($rtfeldman$elm_css$Css$border3_a0);
    var $rtfeldman$elm_css$Css$Animations$opacity = function (_v0) {
        var value = _v0.p_;
        return "opacity:" + value;
    };
    var $rtfeldman$elm_css$Css$solid = { I: 0, bG: 0, p_: "solid" };
    var $perzanko$elm_loading$Loading$Sonar$view = function (config) {
        var outerStyle = _List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$position_a0, $rtfeldman$elm_css$Css$relative),
            $rtfeldman$elm_css$Css$prop2_fn($rtfeldman$elm_css$Css$margin2_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0), $rtfeldman$elm_css$Css$auto),
            $rtfeldman$elm_css$Css$before(_List_fromArray([
                $rtfeldman$elm_css$Css$property_fn("content", "' '"),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$position_a0, $rtfeldman$elm_css$Css$absolute),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$borderRadius_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 50)),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE / 3)),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE / 3)),
                $rtfeldman$elm_css$Css$property_fn("top", "calc(50% - " + ($elm$core$String$fromFloat(config.oE / 6) + "px)")),
                $rtfeldman$elm_css$Css$property_fn("left", "calc(50% - " + ($elm$core$String$fromFloat(config.oE / 6) + "px)")),
                $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$hex(config.kS)),
                $rtfeldman$elm_css$Css$property_fn("animation-duration", $elm$core$String$fromFloat(3 / config.oK) + "s"),
                $rtfeldman$elm_css$Css$property_fn("animation-timing-funtion", "linear"),
                $rtfeldman$elm_css$Css$property_fn("animation-iteration-count", "infinite"),
                $rtfeldman$elm_css$Css$animationName($rtfeldman$elm_css$Css$Animations$keyframes(_List_fromArray([
                    _Utils_Tuple2(0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Animations$opacity($rtfeldman$elm_css$Css$num(1))
                    ])),
                    _Utils_Tuple2(15, _List_fromArray([
                        $rtfeldman$elm_css$Css$Animations$opacity($rtfeldman$elm_css$Css$num(1)),
                        $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(0.5)")
                    ])),
                    _Utils_Tuple2(60, _List_fromArray([
                        $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(4)"),
                        $rtfeldman$elm_css$Css$Animations$opacity($rtfeldman$elm_css$Css$num(0))
                    ])),
                    _Utils_Tuple2(90, _List_fromArray([
                        $rtfeldman$elm_css$Css$Animations$opacity($rtfeldman$elm_css$Css$num(0)),
                        $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(3)")
                    ])),
                    _Utils_Tuple2(95, _List_fromArray([
                        $rtfeldman$elm_css$Css$Animations$opacity($rtfeldman$elm_css$Css$num(1))
                    ])),
                    _Utils_Tuple2(100, _List_fromArray([
                        $rtfeldman$elm_css$Css$Animations$opacity($rtfeldman$elm_css$Css$num(1)),
                        $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(1)")
                    ]))
                ])))
            ])),
            $rtfeldman$elm_css$Css$after(_List_fromArray([
                $rtfeldman$elm_css$Css$property_fn("content", "' '"),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$position_a0, $rtfeldman$elm_css$Css$absolute),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$borderRadius_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 50)),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE / 3)),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE / 3)),
                $rtfeldman$elm_css$Css$property_fn("top", "calc(50% - " + ($elm$core$String$fromFloat(config.oE / 6) + "px)")),
                $rtfeldman$elm_css$Css$property_fn("left", "calc(50% - " + ($elm$core$String$fromFloat(config.oE / 6) + "px)")),
                $rtfeldman$elm_css$Css$prop3_fn($rtfeldman$elm_css$Css$border3_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 1), $rtfeldman$elm_css$Css$solid, $rtfeldman$elm_css$Css$hex(config.kS)),
                $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$opacity_a0, $rtfeldman$elm_css$Css$num(0)),
                $rtfeldman$elm_css$Css$property_fn("animation-duration", $elm$core$String$fromFloat(3 / config.oK) + "s"),
                $rtfeldman$elm_css$Css$property_fn("animation-timing-funtion", "linear"),
                $rtfeldman$elm_css$Css$property_fn("animation-iteration-count", "infinite"),
                $rtfeldman$elm_css$Css$animationName($rtfeldman$elm_css$Css$Animations$keyframes(_List_fromArray([
                    _Utils_Tuple2(0, _List_fromArray([
                        $rtfeldman$elm_css$Css$Animations$opacity($rtfeldman$elm_css$Css$num(0)),
                        $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(1)")
                    ])),
                    _Utils_Tuple2(30, _List_fromArray([
                        $rtfeldman$elm_css$Css$Animations$opacity($rtfeldman$elm_css$Css$num(0)),
                        $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(1)")
                    ])),
                    _Utils_Tuple2(60, _List_fromArray([
                        $rtfeldman$elm_css$Css$Animations$opacity($rtfeldman$elm_css$Css$num(0.3))
                    ])),
                    _Utils_Tuple2(90, _List_fromArray([
                        $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(3)")
                    ])),
                    _Utils_Tuple2(100, _List_fromArray([
                        $rtfeldman$elm_css$Css$Animations$opacity($rtfeldman$elm_css$Css$num(0))
                    ]))
                ])))
            ]))
        ]);
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, config.kJ)
        ]), _List_Nil);
    };
    var $perzanko$elm_loading$Loading$Spinner$view = function (config) {
        var outerStyle = _List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, config.oE)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$position_a0, $rtfeldman$elm_css$Css$relative),
            $rtfeldman$elm_css$Css$prop2_fn($rtfeldman$elm_css$Css$margin2_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0), $rtfeldman$elm_css$Css$auto)
        ]);
        var childs = $elm$core$List$range_fn(1, 12);
        var childStyle = _List_fromArray([
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 100)),
            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 100))
        ]);
        var calcAnimationDelay = function (x) {
            return (x === 1) ? "0s" : ($elm$core$String$fromFloat(-((1.1 - (x / 10)) / config.oK)) + "s");
        };
        return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
            $rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
            $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty_fn($rtfeldman$elm_css$Html$Styled$Attributes$class_a0, config.kJ)
        ]), _List_fromArray([
            $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
            ]), $elm$core$List$map_fn(function (x) {
                return $rtfeldman$elm_css$VirtualDom$Styled$Node_fn($rtfeldman$elm_css$Html$Styled$div_a0, _List_fromArray([
                    $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_fromArray([
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 100)),
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 100)),
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$position_a0, $rtfeldman$elm_css$Css$absolute),
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$left_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0)),
                        $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$top_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0)),
                        $rtfeldman$elm_css$Css$property_fn("transform", "rotate(" + ($elm$core$String$fromInt((30 * x) - 30) + "deg)")),
                        $rtfeldman$elm_css$Css$before(_List_fromArray([
                            $rtfeldman$elm_css$Css$property_fn("animation-delay", calcAnimationDelay(x)),
                            $rtfeldman$elm_css$Css$property_fn("content", "' '"),
                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$display_a0, $rtfeldman$elm_css$Css$block),
                            $rtfeldman$elm_css$Css$prop2_fn($rtfeldman$elm_css$Css$margin2_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$px_a0, $rtfeldman$elm_css$Css$px_a1, 0), $rtfeldman$elm_css$Css$auto),
                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$width_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 15)),
                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$height_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 15)),
                            $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$hex(config.kS)),
                            $rtfeldman$elm_css$Css$prop1_fn($rtfeldman$elm_css$Css$borderRadius_a0, $rtfeldman$elm_css$Css$Internal$lengthConverter_fn($rtfeldman$elm_css$Css$pct_a0, $rtfeldman$elm_css$Css$pct_a1, 100)),
                            $rtfeldman$elm_css$Css$property_fn("animation-duration", $elm$core$String$fromFloat(1.2 / config.oK) + "s"),
                            $rtfeldman$elm_css$Css$property_fn("animation-iteration-count", "infinite"),
                            $rtfeldman$elm_css$Css$property_fn("animation-fill-mode", "both"),
                            $rtfeldman$elm_css$Css$animationName($rtfeldman$elm_css$Css$Animations$keyframes(_List_fromArray([
                                _Utils_Tuple2(0, _List_fromArray([
                                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(0.0)")
                                ])),
                                _Utils_Tuple2(40, _List_fromArray([
                                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(1.0)")
                                ])),
                                _Utils_Tuple2(80, _List_fromArray([
                                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(0.0)")
                                ])),
                                _Utils_Tuple2(100, _List_fromArray([
                                    $rtfeldman$elm_css$Css$Animations$property_fn("transform", "scale(0.0)")
                                ]))
                            ])))
                        ]))
                    ]))
                ]), _List_Nil);
            }, childs))
        ]));
    };
    var $perzanko$elm_loading$Loading$render_fn = function (loaderType, config, loadingState) {
        var loader = function () {
            switch (loaderType) {
                case 0:
                    return $rtfeldman$elm_css$Html$Styled$toUnstyled($perzanko$elm_loading$Loading$DoubleBounce$view(config));
                case 1:
                    return $rtfeldman$elm_css$Html$Styled$toUnstyled($perzanko$elm_loading$Loading$Spinner$view(config));
                case 2:
                    return $rtfeldman$elm_css$Html$Styled$toUnstyled($perzanko$elm_loading$Loading$BouncingBalls$view(config));
                case 3:
                    return $rtfeldman$elm_css$Html$Styled$toUnstyled($perzanko$elm_loading$Loading$Bars$view(config));
                case 4:
                    return $rtfeldman$elm_css$Html$Styled$toUnstyled($perzanko$elm_loading$Loading$Circle$view(config));
                default:
                    return $rtfeldman$elm_css$Html$Styled$toUnstyled($perzanko$elm_loading$Loading$Sonar$view(config));
            }
        }();
        if (!loadingState) {
            return $elm$html$Html$div_fn(_List_fromArray([
                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "loading")
            ]), _List_fromArray([loader]));
        }
        else {
            return $elm$html$Html$text(" ");
        }
    }, $perzanko$elm_loading$Loading$render = F3($perzanko$elm_loading$Loading$render_fn);
    var $author$project$Page$Signup$SignIn = { $: 0 };
    var $author$project$Page$Signup$SignInButtonDepressed = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Page$Signup$SignInButtonHovered = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Analytics$SignupInitGoogleLogin = { $: 55 };
    var $elm$html$Html$Events$onMouseDown = function (msg) {
        return $elm$html$Html$Events$on_fn("mousedown", $elm$json$Json$Decode$succeed(msg));
    };
    var $mdgriffith$elm_ui$Element$Events$onMouseDown_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Events$onMouseDown_a1 = $elm$html$Html$Events$onMouseDown, $mdgriffith$elm_ui$Element$Events$onMouseDown = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Events$onMouseDown_a0, $mdgriffith$elm_ui$Element$Events$onMouseDown_a1);
    var $elm$html$Html$Events$onMouseEnter = function (msg) {
        return $elm$html$Html$Events$on_fn("mouseenter", $elm$json$Json$Decode$succeed(msg));
    };
    var $mdgriffith$elm_ui$Element$Events$onMouseEnter_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Events$onMouseEnter_a1 = $elm$html$Html$Events$onMouseEnter, $mdgriffith$elm_ui$Element$Events$onMouseEnter = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Events$onMouseEnter_a0, $mdgriffith$elm_ui$Element$Events$onMouseEnter_a1);
    var $elm$html$Html$Events$onMouseLeave = function (msg) {
        return $elm$html$Html$Events$on_fn("mouseleave", $elm$json$Json$Decode$succeed(msg));
    };
    var $mdgriffith$elm_ui$Element$Events$onMouseLeave_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Events$onMouseLeave_a1 = $elm$html$Html$Events$onMouseLeave, $mdgriffith$elm_ui$Element$Events$onMouseLeave = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Events$onMouseLeave_a0, $mdgriffith$elm_ui$Element$Events$onMouseLeave_a1);
    var $elm$html$Html$Events$onMouseUp = function (msg) {
        return $elm$html$Html$Events$on_fn("mouseup", $elm$json$Json$Decode$succeed(msg));
    };
    var $mdgriffith$elm_ui$Element$Events$onMouseUp_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Events$onMouseUp_a1 = $elm$html$Html$Events$onMouseUp, $mdgriffith$elm_ui$Element$Events$onMouseUp = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Events$onMouseUp_a0, $mdgriffith$elm_ui$Element$Events$onMouseUp_a1);
    var $author$project$Page$Signup$signInWithGoogleButton = function (model) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Signup$ManyMsgs(_List_fromArray([
                $author$project$Page$Signup$SignIn,
                $author$project$Page$Signup$AnalyticsEvent($author$project$Analytics$SignupInitGoogleLogin)
            ]))),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$pointer,
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onMouseEnter_a0, $mdgriffith$elm_ui$Element$Events$onMouseEnter_a1, $author$project$Page$Signup$SignInButtonHovered(true)),
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onMouseLeave_a0, $mdgriffith$elm_ui$Element$Events$onMouseLeave_a1, $author$project$Page$Signup$SignInButtonHovered(false)),
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onMouseDown_a0, $mdgriffith$elm_ui$Element$Events$onMouseDown_a1, $author$project$Page$Signup$SignInButtonDepressed(true)),
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onMouseUp_a0, $mdgriffith$elm_ui$Element$Events$onMouseUp_a1, $author$project$Page$Signup$SignInButtonDepressed(false))
        ]), $mdgriffith$elm_ui$Element$image_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(200))
        ]), (new $$Record114("Sign in with Google", (model.eH ? function ($) {
            return $.li;
        } : (model.eI ? function ($) {
            return $.l1;
        } : function ($) {
            return $.nn;
        }))($author$project$Content$ImagePaths$googleSignInButton)))));
    };
    var $author$project$Page$Signup$viewMainButton_fn = function (env, model, signupStep) {
        var tutorialComplete = $elm_community$maybe_extra$Maybe$Extra$unwrap_fn(false, function ($) {
            return $.pL;
        }, env.pV);
        var isDoubleColumned = $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, env.p1);
        switch (signupStep.$) {
            case 0:
                return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$spacing(5)
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                        $author$project$View$Styling$paddingBottom(25),
                        $mdgriffith$elm_ui$Element$Font$regular,
                        $mdgriffith$elm_ui$Element$Font$center,
                        $mdgriffith$elm_ui$Element$spacing(5),
                        $mdgriffith$elm_ui$Element$Font$light
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([$mdgriffith$elm_ui$Element$Font$center]), _List_fromArray([
                            $mdgriffith$elm_ui$Element$text("Witful is designed to make your workday better.")
                        ])),
                        $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([$mdgriffith$elm_ui$Element$Font$center]), _List_fromArray([
                            $mdgriffith$elm_ui$Element$text("Sign in using your work email.")
                        ]))
                    ])),
                    $author$project$Page$Signup$signInWithGoogleButton(model),
                    $mdgriffith$elm_ui$Element$link_fn(_List_Cons($elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Signup$AnalyticsEvent($author$project$Analytics$SignupNoGoogleAccount)), $author$project$Page$Signup$secondaryButtonAttrs(env.nI)), {
                        fF: $mdgriffith$elm_ui$Element$text("Don't have a Google account?"),
                        dt: "https://witful.typeform.com/to/ESG4qs7N"
                    }),
                    $author$project$View$Util$when_fn(!isDoubleColumned, $author$project$Page$Signup$emailAndTermsLinks(env.nI))
                ]));
            case 2:
                return $mdgriffith$elm_ui$Element$none;
            case 3:
                return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$spacing(30)
                ]), _List_fromArray([
                    A4($author$project$Util$Misc$if_, !isDoubleColumned, $mdgriffith$elm_ui$Element$column(_List_fromArray([
                        $mdgriffith$elm_ui$Element$centerX,
                        $mdgriffith$elm_ui$Element$spacing(20)
                    ])), A2($elm$core$Basics$composeR, $elm$core$List$reverse, $mdgriffith$elm_ui$Element$row(_List_fromArray([
                        $mdgriffith$elm_ui$Element$centerX,
                        $mdgriffith$elm_ui$Element$spacing(30)
                    ]))), _List_fromArray([
                        $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$Input$button_fn(_Utils_ap($author$project$Page$Signup$primaryButtonAttrs(env.nI), _List_fromArray([
                            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(250))
                        ])), {
                            fF: $mdgriffith$elm_ui$Element$text("Connect Google Calendar"),
                            nz: $elm$core$Maybe$Just($author$project$Page$Signup$ManyMsgs(_List_fromArray([
                                $author$project$Page$Signup$LinkCalendar,
                                $author$project$Page$Signup$AnalyticsEvent($author$project$Analytics$SignupInitLinkCalendar)
                            ])))
                        })),
                        $mdgriffith$elm_ui$Element$el_fn(_List_Cons($elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Signup$ManyMsgs(_List_fromArray([
                            $author$project$Page$Signup$AddLinkedAccount,
                            $author$project$Page$Signup$AnalyticsEvent($author$project$Analytics$SignupChangeGoogleAccounts)
                        ]))), _Utils_ap($author$project$Page$Signup$secondaryButtonAttrs(env.nI), _List_fromArray([
                            $mdgriffith$elm_ui$Element$Border$width(1),
                            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(250))
                        ]))), $mdgriffith$elm_ui$Element$text("Use a different Google account"))
                    ])),
                    $mdgriffith$elm_ui$Element$link_fn(_List_Cons($elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Page$Signup$AnalyticsEvent($author$project$Analytics$SignupLinkCalendarSkipped)), _Utils_ap($author$project$Page$Signup$secondaryButtonAttrs(env.nI), _List_fromArray([
                        $mdgriffith$elm_ui$Element$paddingXY_fn(0, 5),
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.a6),
                        $mdgriffith$elm_ui$Element$Font$size(12),
                        $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Background$color(env.nI.dw),
                            $mdgriffith$elm_ui$Element$Font$color(env.nI.a2)
                        ])),
                        $mdgriffith$elm_ui$Element$centerX
                    ]))), {
                        fF: $mdgriffith$elm_ui$Element$text("I'll do this later"),
                        dt: $author$project$Routing$pathFromRoute($author$project$Util$Misc$if__fn(tutorialComplete, $author$project$Routing$RouteHome($elm$core$Maybe$Nothing), $author$project$Routing$RouteSignup($author$project$Routing$SignupStepWatchVideo)))
                    })
                ]));
            case 4:
                return $mdgriffith$elm_ui$Element$link_fn(_Utils_ap($author$project$Page$Signup$primaryButtonAttrs(env.nI), _List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(160))
                ])), {
                    fF: $mdgriffith$elm_ui$Element$text("Continue"),
                    dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteSignup($author$project$Routing$SignupStepWizard))
                });
            case 5:
                var isEnabled = model.bR;
                return $mdgriffith$elm_ui$Element$Input$button_fn(A4($author$project$Util$Misc$if_, isEnabled, $author$project$Page$Signup$primaryButtonAttrs, $author$project$Page$Signup$disabledButtonAttrs, env.nI), {
                    fF: $mdgriffith$elm_ui$Element$text("Launch Witful"),
                    nz: $author$project$Util$Misc$toJustIf_fn(isEnabled, $author$project$Page$Signup$CompleteSignup)
                });
            default:
                var loadingButton = $mdgriffith$elm_ui$Element$el_fn(_List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(46)), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(114)), $author$project$Page$Signup$primaryButtonAttrs(env.nI))), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$moveUp(7),
                    $mdgriffith$elm_ui$Element$centerX
                ]), $mdgriffith$elm_ui$Element$html($perzanko$elm_loading$Loading$render_fn(2, { kJ: "", kS: "fff", oE: 25, oK: 1 }, 0))));
                return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), function () {
                    var _v1 = env.db.oX;
                    switch (_v1.$) {
                        case 1:
                            return loadingButton;
                        case 3:
                            return loadingButton;
                        default:
                            return $mdgriffith$elm_ui$Element$Input$button_fn(_List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(200)), $author$project$Page$Signup$primaryButtonAttrs(env.nI)), {
                                fF: $mdgriffith$elm_ui$Element$text("Continue to Payment"),
                                nz: $elm$core$Maybe$Just($author$project$Page$Signup$ManyMsgs(_List_fromArray([
                                    $author$project$Page$Signup$StripeCreateCheckoutSession,
                                    $author$project$Page$Signup$AnalyticsEvent($author$project$Analytics$SignupSubscriptionChosen(model.az))
                                ])))
                            });
                    }
                }());
        }
    }, $author$project$Page$Signup$viewMainButton = F3($author$project$Page$Signup$viewMainButton_fn);
    var $author$project$Page$Signup$viewMainPane_fn = function (env, model, signupStep) {
        var isDoubleColumned = $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, env.p1);
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $author$project$View$Util$attrWhen_fn(isDoubleColumned, $mdgriffith$elm_ui$Element$Border$shadow({
                kp: 8,
                kS: env.nI.aO,
                nt: _Utils_Tuple2(-2, 6),
                oE: 1
            }))
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(22),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$Font$light,
                $mdgriffith$elm_ui$Element$paddingXY_fn(20, 30),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(750, $mdgriffith$elm_ui$Element$fill))
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(35),
                    $mdgriffith$elm_ui$Element$Font$family(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$typeface("Lato"),
                        $mdgriffith$elm_ui$Element$Font$sansSerif
                    ])),
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.a7),
                    $mdgriffith$elm_ui$Element$Font$center
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text($author$project$Page$Signup$headerTextForStep(signupStep))
                ])),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$paddingXY_fn(0, 20),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
                ]), $author$project$Page$Signup$heroContent_fn(env, model, signupStep)),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(17),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(400, $mdgriffith$elm_ui$Element$fill)),
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$Font$center,
                    $mdgriffith$elm_ui$Element$spacing(40),
                    $mdgriffith$elm_ui$Element$Font$regular
                ]), $author$project$Page$Signup$viewMainButton_fn(env, model, signupStep)),
                $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([
                    $author$project$Page$Signup$preloadImage($author$project$Content$ImagePaths$googleSignInButton.nn),
                    $author$project$Page$Signup$preloadImage($author$project$Content$ImagePaths$googleSignInButton.li),
                    $author$project$Page$Signup$preloadImage($author$project$Content$ImagePaths$googleSignInButton.l1)
                ])),
                $author$project$View$Util$when_fn(!isDoubleColumned, $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$spacing(20),
                    $mdgriffith$elm_ui$Element$centerX,
                    $mdgriffith$elm_ui$Element$alignBottom,
                    $mdgriffith$elm_ui$Element$padding(15)
                ]), $author$project$Page$Signup$progressBreadcrumbs_fn(env, model, signupStep)))
            ]))
        ]));
    }, $author$project$Page$Signup$viewMainPane = F3($author$project$Page$Signup$viewMainPane_fn);
    var $author$project$View$Util$antialiasedFont = $author$project$View$Util$style_fn("-webkit-font-smoothing", "antialiased");
    var $author$project$Data$App$environmentName = function (url) {
        var _v0 = url.hK;
        switch (_v0) {
            case "app.witful.com":
                return "APP";
            case "next.witful.com":
                return "NEXT";
            case "app.witful.rodeo":
                return "SANDBOX";
            case "app.witful.dev":
                return "STAGING";
            case "localhost":
                return "LOCALHOST";
            default:
                return "UNKNOWN";
        }
    };
    var $author$project$View$Widgets$witfulIcon_fn = function (palette, size) {
        var innerSize = ((4 * size) / 5) | 0;
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(size)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(size)),
            $mdgriffith$elm_ui$Element$Border$rounded((size / 5) | 0),
            $mdgriffith$elm_ui$Element$Background$color(palette.a2)
        ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(innerSize)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(innerSize)),
            $mdgriffith$elm_ui$Element$Border$rounded(size),
            $mdgriffith$elm_ui$Element$Background$color(palette.dw),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY
        ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(((2 * size) / 5) | 0)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(((2 * size) / 5) | 0)),
            $mdgriffith$elm_ui$Element$Background$color(palette.a2),
            $mdgriffith$elm_ui$Element$Border$rounded(size),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY
        ]), $mdgriffith$elm_ui$Element$none)));
    }, $author$project$View$Widgets$witfulIcon = F2($author$project$View$Widgets$witfulIcon_fn);
    var $author$project$View$Widgets$witfulIconWithText_fn = function (palette, linkTo, model) {
        var innerElt = $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(10),
            $mdgriffith$elm_ui$Element$centerX,
            $author$project$View$Styling$paddingLeft(5)
        ]), _List_fromArray([
            $author$project$View$Widgets$witfulIcon_fn(palette, 35),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(24),
                $author$project$View$Util$antialiasedFont,
                $mdgriffith$elm_ui$Element$Font$family(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$typeface("Open Sans"),
                    $mdgriffith$elm_ui$Element$Font$sansSerif
                ])),
                $author$project$View$Util$attrWhen_fn(!$author$project$Data$App$isProd(model.mM), $mdgriffith$elm_ui$Element$below($mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(10),
                    $mdgriffith$elm_ui$Element$Font$color(palette.aR),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
                    $mdgriffith$elm_ui$Element$alignRight
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text($author$project$Data$App$environmentName(model.mM))
                ]))))
            ]), $mdgriffith$elm_ui$Element$text("Witful"))
        ]));
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$Font$color(palette.a2)
        ]), function () {
            if (!linkTo.$) {
                var url = linkTo.a;
                return $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                    $author$project$View$Util$tabIndex($elm$core$Maybe$Nothing)
                ]), { fF: innerElt, dt: url });
            }
            else {
                return innerElt;
            }
        }());
    }, $author$project$View$Widgets$witfulIconWithText = F3($author$project$View$Widgets$witfulIconWithText_fn);
    var $author$project$Page$Signup$viewSidebar_fn = function (env, model, signupStep) {
        var breadcrumbConnectorBar = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$moveRight(12),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(2)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(30)),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.a1)
        ]), $mdgriffith$elm_ui$Element$none);
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Background$color(env.nI.aM),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(350))
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$padding(20)
            ]), $author$project$View$Widgets$witfulIconWithText_fn(env.nI, $elm$core$Maybe$Nothing, env)),
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$alignLeft,
                $mdgriffith$elm_ui$Element$paddingXY_fn(27, 50),
                $mdgriffith$elm_ui$Element$spacing(2)
            ]), $elm$core$List$intersperse_fn(breadcrumbConnectorBar, $author$project$Page$Signup$progressBreadcrumbs_fn(env, model, signupStep))),
            $author$project$Page$Signup$emailAndTermsLinks(env.nI)
        ]));
    }, $author$project$Page$Signup$viewSidebar = F3($author$project$Page$Signup$viewSidebar_fn);
    var $author$project$Page$Signup$view_fn = function (env, model, signupStep) {
        var isDoubleColumned = $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, env.p1);
        return ((!env.pX) || _Utils_eq(env.db.kf, $krisajenkins$remotedata$RemoteData$Loading)) ? $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]), $author$project$View$Widgets$loadingAnimation) : (($krisajenkins$remotedata$RemoteData$isLoading(env.db.oX) || $krisajenkins$remotedata$RemoteData$isSuccess(env.db.oX)) ? $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$Font$size(20)
        ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$moveUp(35),
            $mdgriffith$elm_ui$Element$above($mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$moveUp(20)
            ]), $mdgriffith$elm_ui$Element$text("Redirecting to checkout...")))
        ]), $author$project$View$Widgets$loadingAnimation)) : (_Utils_eq(env.db.kW, $krisajenkins$remotedata$RemoteData$Loading) ? $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$Font$size(20)
        ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$moveUp(35),
            $mdgriffith$elm_ui$Element$above($mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$moveUp(20)
            ]), $mdgriffith$elm_ui$Element$text("Setting up your account...")))
        ]), $author$project$View$Widgets$loadingAnimation)) : $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            $author$project$View$Util$when_fn(isDoubleColumned, $author$project$Page$Signup$viewSidebar_fn(env, model, signupStep)),
            $author$project$Page$Signup$viewMainPane_fn(env, model, signupStep)
        ]))));
    }, $author$project$Page$Signup$view = F3($author$project$Page$Signup$view_fn);
    var $author$project$View$mainView_fn = function (page, env) {
        var mapMsgTo = function (childMsg) {
            return $mdgriffith$elm_ui$Element$map(A2($elm$core$Basics$composeR, childMsg, $author$project$Model$HandlePageMsg));
        };
        switch (page.$) {
            case 0:
                var subModel = page.a;
                return A2(mapMsgTo, $author$project$Model$HomeMsg, $author$project$Page$Home$view_fn(env, subModel));
            case 1:
                var subModel = page.a;
                return A2(mapMsgTo, $author$project$Model$ActionItemsMsg, $author$project$Page$ActionItems$view_fn(env, subModel));
            case 2:
                var subModel = page.a;
                return A2(mapMsgTo, $author$project$Model$SearchMsg, $author$project$Page$Search$view_fn(env, subModel));
            case 3:
                var personId = page.a;
                var subModel = page.b;
                return A2(mapMsgTo, $author$project$Model$PersonMsg, $elm$core$Maybe$withDefault_fn($author$project$View$Widgets$loadingOrNotFound_fn(env.nI, env.mK), $elm$core$Maybe$map_fn(function (_v1) {
                    var state = _v1.a;
                    var person = _v1.b;
                    return $author$project$Page$Person$view_fn(env, subModel, personId, state, person);
                }, $author$project$Firestore$Collection$getWithState_fn(personId, env.iz))));
            case 4:
                var noteId = page.a;
                var subModel = page.b;
                return $mdgriffith$elm_ui$Internal$Model$map_fn($elm$core$Basics$identity, A2(mapMsgTo, $author$project$Model$NoteMsg, $elm$core$Maybe$withDefault_fn($author$project$View$Widgets$loadingOrNotFound_fn(env.nI, env.mK), $elm$core$Maybe$map_fn(function (_v2) {
                    var state = _v2.a;
                    var note = _v2.b;
                    return $author$project$Page$Note$view_fn(env, subModel, noteId, state, note);
                }, $author$project$Firestore$Collection$getWithState_fn(noteId, env.fO)))));
            case 6:
                return A2(mapMsgTo, $author$project$Model$SettingsMsg, $author$project$Page$Settings$view(env));
            case 5:
                var subModel = page.a;
                return A2(mapMsgTo, $author$project$Model$CalendarMsg, $author$project$Page$Calendar$view_fn(env, subModel));
            case 7:
                var subModel = page.a;
                return A2(mapMsgTo, $author$project$Model$CollateMsg, $author$project$Page$Collate$view_fn(env, subModel));
            case 8:
                var subModel = page.a;
                return A2(mapMsgTo, $author$project$Model$DemoMsg, $author$project$Page$Demo$view_fn(env, subModel));
            case 9:
                var signupStep = page.a;
                var subModel = page.b;
                return A2(mapMsgTo, $author$project$Model$SignupMsg, $author$project$Page$Signup$view_fn(env, subModel, signupStep));
            case 10:
                var subModel = page.a;
                return A2(mapMsgTo, $author$project$Model$BillingMsg, $author$project$Page$Billing$view_fn(env, subModel));
            case 11:
                return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]), $author$project$View$Widgets$loadingAnimation);
            default:
                return $author$project$View$Widgets$notFound(env.nI);
        }
    }, $author$project$View$mainView = F2($author$project$View$mainView_fn);
    var $author$project$View$NextMeetingNudger$isDisplayed = function (env) {
        var state = $author$project$Data$Settings$get(env).ed;
        return ((state === 1) || (state === 2)) && (!$author$project$Routing$isSignup(env.oe));
    };
    var $author$project$View$HelpMenu$shouldShow = function (env) {
        return (!$author$project$Routing$isSignup(env.oe)) && ($elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn(function ($) {
            return $.pL;
        }, env.pV)) && (env.pX && ($author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, env.p1) && ((!$author$project$View$NextMeetingNudger$isDisplayed(env)) && (!$author$project$View$ImageViewer$isDisplaying(env.ft))))));
    };
    var $author$project$Lib$Snackbar$SendMsg = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Lib$Snackbar$viewItem_fn = function (palette, id, snack) {
        var countdownBar = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(3)),
            $mdgriffith$elm_ui$Element$centerY,
            $author$project$View$Util$style_fn("transform", "scaleX(0)"),
            $author$project$View$Util$style_fn("transform-origin", "left"),
            $author$project$View$Util$style_fn("animation", "scaleX-1-to-0 linear " + ($elm$core$String$fromInt($author$project$Lib$Snackbar$countdownTime) + "ms both")),
            $mdgriffith$elm_ui$Element$Background$color(palette.a6),
            $mdgriffith$elm_ui$Element$Border$rounded(2)
        ]), $mdgriffith$elm_ui$Element$none);
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$alignTop,
                $mdgriffith$elm_ui$Element$spacing(10),
                $mdgriffith$elm_ui$Element$centerY,
                $author$project$View$Styling$paddingLeft(15),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$bold,
                    $mdgriffith$elm_ui$Element$Font$size(15)
                ]), $mdgriffith$elm_ui$Element$text(snack.dG.hF)),
                $author$project$View$Util$whenJust_fn(snack.dG.cp, function (subText) {
                    return $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$spacing(0),
                        $mdgriffith$elm_ui$Element$Font$size(14),
                        $mdgriffith$elm_ui$Element$Font$color(palette.aT)
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$text(subText)
                    ]));
                })
            ])),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Border$widthEach((new $$Record115(0, 1, 0, 0))),
                $mdgriffith$elm_ui$Element$Border$color(palette.aP),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$alignRight
            ]), $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$alignRight,
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
                $mdgriffith$elm_ui$Element$spacing(8),
                $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0)
            ]), _List_fromArray([
                $author$project$View$Util$when_fn(snack.g6, $author$project$View$Icon$buttonWithSize_fn(17, {
                    kb: "Close snackbar item: " + snack.dG.hF,
                    hp: _List_fromArray([
                        $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(25)),
                        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(25)),
                        $mdgriffith$elm_ui$Element$Border$rounded(7),
                        $mdgriffith$elm_ui$Element$alignRight,
                        $mdgriffith$elm_ui$Element$centerY,
                        $mdgriffith$elm_ui$Element$Font$color(palette.aR)
                    ]),
                    fQ: $elm$core$Maybe$Just($author$project$Lib$Snackbar$SetVisibility_fn(0, id))
                }, 2, "times")),
                $author$project$View$Util$whenJust_fn(snack.eX, function (_v0) {
                    var buttonText = _v0.kA;
                    return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([$mdgriffith$elm_ui$Element$clip, $mdgriffith$elm_ui$Element$centerY, $mdgriffith$elm_ui$Element$centerX]), _List_fromArray([
                        $author$project$View$Widgets$button_fn({
                            hp: _List_fromArray([
                                $mdgriffith$elm_ui$Element$Border$width(0),
                                $mdgriffith$elm_ui$Element$Background$color(palette.aO),
                                $mdgriffith$elm_ui$Element$Font$color(palette.a6),
                                $mdgriffith$elm_ui$Element$Font$size(13),
                                $mdgriffith$elm_ui$Element$Font$semiBold
                            ]),
                            l7: $elm$core$Maybe$Nothing,
                            fQ: $elm$core$Maybe$Just($author$project$Lib$Snackbar$SendMsg(id))
                        }, buttonText),
                        $author$project$View$Util$when_fn(!snack.fU, countdownBar)
                    ]));
                })
            ])))
        ]));
    }, $author$project$Lib$Snackbar$viewItem = F3($author$project$Lib$Snackbar$viewItem_fn);
    var $author$project$Lib$Snackbar$viewSnack_fn = function (palette, _v0) {
        var id = _v0.a;
        var _v1 = _v0.b;
        var visibility = _v1.a;
        var snack = _v1.b;
        var _v2 = _Utils_Tuple2(100, 320);
        var snackHeight = _v2.a;
        var snackWidth = _v2.b;
        var xPosition = function () {
            if (visibility === 1) {
                return 0;
            }
            else {
                return snackWidth + 15;
            }
        }();
        var _v3 = {
            iP: {
                b2: $mdgriffith$elm_ui$Element$rgb255_fn(130, 87, 217),
                cj: $mdgriffith$elm_ui$Element$rgb255_fn(205, 88, 226)
            },
            iU: {
                b2: $mdgriffith$elm_ui$Element$rgb255_fn(255, 106, 92),
                cj: $mdgriffith$elm_ui$Element$rgb255_fn(255, 200, 120)
            },
            jm: {
                b2: $mdgriffith$elm_ui$Element$rgb255_fn(70, 255, 177),
                cj: $mdgriffith$elm_ui$Element$rgb255_fn(105, 249, 255)
            }
        };
        var purple = _v3.iP;
        var teal = _v3.jm;
        var red = _v3.iU;
        var borderGradientSteps = function () {
            var _v4 = snack.jh;
            switch (_v4) {
                case 0:
                    return _List_fromArray([purple.b2, purple.cj]);
                case 1:
                    return _List_fromArray([red.b2, red.cj]);
                default:
                    return _List_fromArray([teal.b2, teal.cj]);
            }
        }();
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(snackWidth)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(snackHeight)),
            $mdgriffith$elm_ui$Element$Border$roundEach({ kx: 0, ky: 5, pF: 0, pG: 5 }),
            $mdgriffith$elm_ui$Element$Border$shadow({
                kp: 6,
                kS: palette.aP,
                nt: _Utils_Tuple2(1, 0),
                oE: 2.5
            }),
            $mdgriffith$elm_ui$Element$clip,
            $mdgriffith$elm_ui$Element$moveLeft(xPosition),
            $author$project$View$Util$style_fn("transition", "transform " + ($elm$core$String$fromInt($author$project$Lib$Snackbar$slideInAnimationTime) + "ms"))
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(10)),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Background$gradient({
                    j6: $elm$core$Basics$degrees(170),
                    oT: borderGradientSteps
                })
            ]), $mdgriffith$elm_ui$Element$none),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Background$color(palette.aN)
            ]), $author$project$Lib$Snackbar$viewItem_fn(palette, id, snack))
        ]));
    }, $author$project$Lib$Snackbar$viewSnack = F2($author$project$Lib$Snackbar$viewSnack_fn);
    var $author$project$Lib$Snackbar$view_fn = function (palette, model) {
        return $mdgriffith$elm_ui$Element$Keyed$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$paddingXY_fn(0, 20),
            $mdgriffith$elm_ui$Element$spacing(15),
            $mdgriffith$elm_ui$Element$alignBottom
        ]), $elm$core$List$map_fn(function (_v0) {
            var id = _v0.a;
            var snack = _v0.b;
            return _Utils_Tuple2($elm$core$String$fromInt(id), $author$project$Lib$Snackbar$viewSnack_fn(palette, _Utils_Tuple2(id, snack)));
        }, _List_sortBy_fn($elm$core$Tuple$first, $elm$core$Dict$toList(model.ai))));
    }, $author$project$Lib$Snackbar$view = F2($author$project$Lib$Snackbar$view_fn);
    var $mdgriffith$elm_ui$Element$scrollbars = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.ol);
    var $PaackEng$elm_ui_dialog$Dialog$dialogMask = $mdgriffith$elm_ui$Internal$Model$Rgba_fn(0, 0, 0, 0.3);
    var $PaackEng$elm_ui_dialog$Dialog$wrapBody = function (_v0) {
        var body = _v0.dG;
        var bodyAttributes = _v0.kq;
        if (body.$ === 1) {
            return $mdgriffith$elm_ui$Element$none;
        }
        else {
            var body_ = body.a;
            return $mdgriffith$elm_ui$Element$el_fn(_Utils_ap(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$padding(1)
            ]), bodyAttributes), body_);
        }
    };
    var $PaackEng$elm_ui_dialog$Dialog$wrapFooter = function (_v0) {
        var footer = _v0.lM;
        var footerAttributes = _v0.lN;
        if (footer.$ === 1) {
            return $mdgriffith$elm_ui$Element$none;
        }
        else {
            var footer_ = footer.a;
            return $mdgriffith$elm_ui$Element$el_fn(_Utils_ap(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$padding(1)
            ]), footerAttributes), footer_);
        }
    };
    var $PaackEng$elm_ui_dialog$Dialog$closeButton = function (closeMessage) {
        return $mdgriffith$elm_ui$Element$Input$button_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$alignRight,
            $mdgriffith$elm_ui$Element$padding(1),
            $mdgriffith$elm_ui$Element$Font$size(16)
        ]), {
            fF: $mdgriffith$elm_ui$Element$text("x"),
            nz: $elm$core$Maybe$Just(closeMessage)
        });
    };
    var $PaackEng$elm_ui_dialog$Dialog$maybe_fn = function (_default, f, value) {
        if (!value.$) {
            var value_ = value.a;
            return f(value_);
        }
        else {
            return _default;
        }
    }, $PaackEng$elm_ui_dialog$Dialog$maybe = F3($PaackEng$elm_ui_dialog$Dialog$maybe_fn);
    var $PaackEng$elm_ui_dialog$Dialog$wrapHeader = function (_v0) {
        var header = _v0.hF;
        var headerAttributes = _v0.lX;
        var closeMessage = _v0.kP;
        return (_Utils_eq(header, $elm$core$Maybe$Nothing) && _Utils_eq(closeMessage, $elm$core$Maybe$Nothing)) ? $mdgriffith$elm_ui$Element$none : $mdgriffith$elm_ui$Element$row_fn(_Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$padding(2)
        ]), headerAttributes), _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$alignLeft]), $elm$core$Maybe$withDefault_fn($mdgriffith$elm_ui$Element$none, header)),
            $PaackEng$elm_ui_dialog$Dialog$maybe_fn($mdgriffith$elm_ui$Element$none, $PaackEng$elm_ui_dialog$Dialog$closeButton, closeMessage)
        ]));
    };
    var $PaackEng$elm_ui_dialog$Dialog$view = function (maybeConfig) {
        if (maybeConfig.$ === 1) {
            return $mdgriffith$elm_ui$Element$none;
        }
        else {
            var config = maybeConfig.a;
            return $mdgriffith$elm_ui$Element$el_fn(_Utils_ap(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($PaackEng$elm_ui_dialog$Dialog$dialogMask),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
            ]), config.mS), $mdgriffith$elm_ui$Element$column_fn(config.kZ, _List_fromArray([
                $PaackEng$elm_ui_dialog$Dialog$wrapHeader(config),
                $PaackEng$elm_ui_dialog$Dialog$wrapBody(config),
                $PaackEng$elm_ui_dialog$Dialog$wrapFooter(config)
            ])));
        }
    };
    var $author$project$View$Dialog$BaseDialog$view_fn = function (palette, d) {
        return $PaackEng$elm_ui_dialog$Dialog$view($elm$core$Maybe$Just((new $$Record152($elm$core$Maybe$Just($mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$width(d.jJ),
            $mdgriffith$elm_ui$Element$height(d.fo),
            $mdgriffith$elm_ui$Element$padding(d.dc),
            $mdgriffith$elm_ui$Element$clip,
            $mdgriffith$elm_ui$Element$scrollbars,
            $author$project$View$Styling$showScrollbar,
            $mdgriffith$elm_ui$Element$spacing(20),
            $mdgriffith$elm_ui$Element$Background$color(palette.dw),
            $mdgriffith$elm_ui$Element$Border$rounded(10),
            $mdgriffith$elm_ui$Element$Border$shadow({
                kp: 30,
                kS: $author$project$Data$Color$grayAlphaLight,
                nt: _Utils_Tuple2(1.5, 2),
                oE: 6
            }),
            $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "blow-up-animation"),
            function () {
                var _v0 = d.dL;
                if (!_v0.$) {
                    var closeButton = _v0.a;
                    return $mdgriffith$elm_ui$Element$inFront($mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$alignTop,
                        $mdgriffith$elm_ui$Element$alignRight,
                        $mdgriffith$elm_ui$Element$padding(6)
                    ]), $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
                        kb: "Close dialog",
                        hp: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(palette.aR)
                        ]),
                        fQ: $elm$core$Maybe$Just(closeButton)
                    }, 1, "times")));
                }
                else {
                    return $author$project$View$Util$attrNone;
                }
            }(),
            function () {
                var _v1 = d.gK;
                if (!_v1.$) {
                    var backButton = _v1.a;
                    return $mdgriffith$elm_ui$Element$inFront($author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
                        kb: "Close dialog",
                        hp: _List_fromArray([
                            $mdgriffith$elm_ui$Element$alignTop,
                            $mdgriffith$elm_ui$Element$alignLeft,
                            $mdgriffith$elm_ui$Element$Font$color(palette.a7)
                        ]),
                        fQ: $elm$core$Maybe$Just(backButton)
                    }, 1, "arrow-left"));
                }
                else {
                    return $author$project$View$Util$attrNone;
                }
            }()
        ]), _List_fromArray([
            $author$project$View$Util$whenJust_fn(d.gj, function (t) {
                return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Element$Font$size(22),
                    $author$project$View$Util$attrWhen_fn(d.e2, $mdgriffith$elm_ui$Element$Font$center)
                ]), $mdgriffith$elm_ui$Element$text(t));
            }),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Font$size(20)
            ]), d.dG),
            (d.cJ ? A2($elm$core$Basics$composeR, $elm$core$List$reverse, $mdgriffith$elm_ui$Element$row(_List_fromArray([
                $mdgriffith$elm_ui$Element$alignRight,
                $mdgriffith$elm_ui$Element$spacing(10)
            ]))) : $mdgriffith$elm_ui$Element$column(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$spacing(10)
            ])))(_List_fromArray([
                $author$project$View$Util$whenJust_fn(d.de, function (_v2) {
                    var buttonText = _v2.a;
                    var buttonMsg = _v2.b;
                    return $author$project$View$Widgets$button_fn({
                        hp: d.b3 ? _List_fromArray([
                            $mdgriffith$elm_ui$Element$Background$color(palette.aR),
                            $mdgriffith$elm_ui$Element$Border$width(0),
                            $mdgriffith$elm_ui$Element$Font$color(palette.aO),
                            $mdgriffith$elm_ui$Element$paddingXY_fn(25, 15),
                            $mdgriffith$elm_ui$Element$centerY,
                            $mdgriffith$elm_ui$Element$Font$size(16),
                            $author$project$View$Util$style_fn($author$project$View$Util$cursor_a0, "default"),
                            $mdgriffith$elm_ui$Element$focused(_List_Nil),
                            $mdgriffith$elm_ui$Element$mouseOver(_List_Nil)
                        ]) : _List_fromArray([
                            $mdgriffith$elm_ui$Element$Background$color(palette.ba),
                            $mdgriffith$elm_ui$Element$Border$width(0),
                            $mdgriffith$elm_ui$Element$Font$color(palette.dw),
                            $mdgriffith$elm_ui$Element$paddingXY_fn(25, 15),
                            $mdgriffith$elm_ui$Element$centerY,
                            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Background$color(palette.a7)
                            ])),
                            $mdgriffith$elm_ui$Element$Font$size(16)
                        ]),
                        l7: $elm$core$Maybe$Nothing,
                        fQ: d.b3 ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(buttonMsg)
                    }, buttonText);
                }),
                $author$project$View$Util$whenJust_fn(d.i5, function (_v3) {
                    var buttonText = _v3.a;
                    var buttonMsg = _v3.b;
                    return $author$project$View$Widgets$button_fn({
                        hp: _List_fromArray([
                            $mdgriffith$elm_ui$Element$Border$width(0),
                            $mdgriffith$elm_ui$Element$Font$color(palette.a8),
                            $elm$core$Basics$composeL_fn($author$project$View$Util$id_a0, $author$project$View$Util$id_a1, $author$project$View$Dialog$BaseDialog$secondaryButtonId),
                            $mdgriffith$elm_ui$Element$paddingXY_fn(25, 15)
                        ]),
                        l7: $elm$core$Maybe$Nothing,
                        fQ: $elm$core$Maybe$Just(buttonMsg)
                    }, buttonText);
                })
            ])),
            $author$project$View$Util$when_fn(!_Utils_eq(d.co, $mdgriffith$elm_ui$Element$none), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), d.co))
        ]))), _List_fromArray([
            $author$project$View$Util$preventClickPropagation(d.nf),
            $mdgriffith$elm_ui$Element$centerY
        ]), $elm$core$Maybe$Nothing, _List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$padding(50)
        ]), $elm$core$Maybe$Nothing, _List_Nil, $elm$core$Maybe$Nothing, _List_Nil, _List_Cons($mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.6)), $elm_community$maybe_extra$Maybe$Extra$toList($elm$core$Maybe$map_fn($mdgriffith$elm_ui$Element$Events$onClick, d.c7)))))));
    }, $author$project$View$Dialog$BaseDialog$view = F2($author$project$View$Dialog$BaseDialog$view_fn);
    var $author$project$Model$HelpMenuOpen = function (a) {
        return { $: 30, a: a };
    };
    var $author$project$Analytics$HelpMenuOpened = { $: 66 };
    var $author$project$Data$Dialog$Closeable$ColorCodingVideo = { $: 8 };
    var $author$project$Analytics$HelpMenuShowKeyboardShortcuts = { $: 68 };
    var $author$project$Analytics$HelpMenuVideoModalOpened = { $: 67 };
    var $author$project$Data$Dialog$Closeable$HowToUseWitfulVideo = { $: 6 };
    var $author$project$Data$Dialog$Closeable$SmartTagsVideo = { $: 7 };
    var $author$project$Data$Dialog$Closeable$VideoCallVideo = { $: 9 };
    var $author$project$Firestore$Collection$member_fn = function (id, _v0) {
        var docs = _v0.n;
        return $elm$core$Dict$member_fn(id, docs);
    }, $author$project$Firestore$Collection$member = F2($author$project$Firestore$Collection$member_fn);
    var $author$project$View$HelpMenu$viewMenu = function (env) {
        var menuItem = F3(function (iconName, copy, action) {
            return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(20),
                $mdgriffith$elm_ui$Element$Font$size(16),
                $mdgriffith$elm_ui$Element$Font$color(env.nI.aT),
                $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.a7)
                ])),
                $mdgriffith$elm_ui$Element$pointer,
                $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Model$ManyMsgs(_List_fromArray([
                    $author$project$Model$HandleBacktalk(action),
                    $author$project$Model$HelpMenuOpen(false)
                ])))
            ]), _List_fromArray([
                $author$project$View$Icon$icon_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$size(16)
                ]), 2, iconName),
                $mdgriffith$elm_ui$Element$text(copy)
            ]));
        });
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$spacing(15),
            $mdgriffith$elm_ui$Element$padding(20),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.dw),
            $mdgriffith$elm_ui$Element$Border$rounded(3),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(280)),
            $mdgriffith$elm_ui$Element$moveLeft(245),
            $mdgriffith$elm_ui$Element$moveUp(10),
            $author$project$View$Styling$elevation40,
            $mdgriffith$elm_ui$Element$Font$light
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(22),
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$padding(5)
            ]), $mdgriffith$elm_ui$Element$text("Help & Tips")),
            $author$project$View$Util$horizontalLine_fn(env.nI, 1, _List_Nil),
            A3(menuItem, "seedling", "Watch how to use Witful", $author$project$Env$Tantrum(_List_fromArray([
                $author$project$Env$SetDialog($elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$HowToUseWitfulVideo)),
                $author$project$Env$AnalyticsEvent($author$project$Analytics$HelpMenuVideoModalOpened)
            ]))),
            A3(menuItem, "tag", "Witful Smart Tags", $author$project$Env$Tantrum(_List_fromArray([
                $author$project$Env$SetDialog($elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$SmartTagsVideo)),
                $author$project$Env$AnalyticsEvent($author$project$Analytics$HelpMenuVideoModalOpened)
            ]))),
            A3(menuItem, "palette", "Color coding in Witful", $author$project$Env$Tantrum(_List_fromArray([
                $author$project$Env$SetDialog($elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$ColorCodingVideo)),
                $author$project$Env$AnalyticsEvent($author$project$Analytics$HelpMenuVideoModalOpened)
            ]))),
            A3(menuItem, "video", "Witful video calls", $author$project$Env$Tantrum(_List_fromArray([
                $author$project$Env$SetDialog($elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$VideoCallVideo)),
                $author$project$Env$AnalyticsEvent($author$project$Analytics$HelpMenuVideoModalOpened)
            ]))),
            A3(menuItem, "keyboard", "Keyboard shortcuts", $author$project$Env$Tantrum(_List_fromArray([
                $author$project$Env$SetDialog($elm$core$Maybe$Just($author$project$Data$Dialog$Closeable$KeyboardShortcuts)),
                $author$project$Env$AnalyticsEvent($author$project$Analytics$HelpMenuShowKeyboardShortcuts)
            ]))),
            $author$project$View$Util$when_fn($author$project$Firestore$Collection$member_fn($author$project$Content$Person$introductoryPersonId, env.iz), A3(menuItem, "user", "See a sample person page", $author$project$Env$RouteToURLRequest($author$project$Routing$RoutePerson($author$project$Content$Person$introductoryPersonId))))
        ]));
    };
    var $author$project$View$HelpMenu$view = function (env) {
        var onClickMsg = env.lY ? $author$project$Model$HelpMenuOpen(false) : $author$project$Model$ManyMsgs(_List_fromArray([
            $author$project$Model$HelpMenuOpen(true),
            $author$project$Model$HandleBacktalk($author$project$Env$AnalyticsEvent($author$project$Analytics$HelpMenuOpened))
        ]));
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$alignRight,
            $mdgriffith$elm_ui$Element$alignBottom,
            $mdgriffith$elm_ui$Element$moveLeft(20),
            $mdgriffith$elm_ui$Element$moveUp(20),
            $author$project$View$Util$attrWhen_fn(env.lY, $mdgriffith$elm_ui$Element$above($author$project$View$HelpMenu$viewMenu(env)))
        ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$pointer,
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, onClickMsg),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(env.nI.a6)
            ])),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(35)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(35)),
            $mdgriffith$elm_ui$Element$Border$rounded(20),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.a7),
            $mdgriffith$elm_ui$Element$Border$shadow({
                kp: 10,
                kS: $mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.3),
                nt: _Utils_Tuple2(1, 1),
                oE: 3
            })
        ]), $author$project$View$Icon$icon_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$Font$size(13),
            $mdgriffith$elm_ui$Element$Font$color(env.nI.dw)
        ]), 0, "question")));
    };
    var $author$project$View$ImageViewer$CloseImage = { $: 3 };
    var $author$project$View$ImageViewer$Decrease = 1;
    var $author$project$View$ImageViewer$Increase = 0;
    var $author$project$View$ImageViewer$ResetSize = { $: 2 };
    var $author$project$View$ImageViewer$horizontalMargin = function (viewport) {
        return $author$project$Util$Misc$if__fn($author$project$View$Responsive$isMobile_fn($author$project$View$Layout$breakpoints, viewport), 20, 100);
    };
    var $author$project$View$ImageViewer$verticalMargin = 60;
    var $author$project$View$ImageViewer$toImageScene = function (viewport) {
        var scene = viewport.oh;
        return (new $$Record35(scene.fo - ($author$project$View$ImageViewer$verticalMargin * 2), scene.jJ - ($author$project$View$ImageViewer$horizontalMargin(viewport) * 2)));
    };
    var $author$project$View$ImageViewer$zoomOutStep = 15;
    var $author$project$View$ImageViewer$getPercentage_fn = function (viewport, zoomLevel, _v0) {
        var width = _v0.jJ;
        var height = _v0.fo;
        var imageScene = $author$project$View$ImageViewer$toImageScene(viewport);
        var basePercentage = $elm$core$Basics$min_fn(1, $elm$core$Basics$min_fn(imageScene.jJ / width, imageScene.fo / height));
        return (!zoomLevel) ? basePercentage : ((zoomLevel < 0) ? (((zoomLevel * $author$project$View$ImageViewer$zoomOutStep) / 100) + basePercentage) : ((zoomLevel + 1) * basePercentage));
    }, $author$project$View$ImageViewer$getPercentage = F3($author$project$View$ImageViewer$getPercentage_fn);
    var $author$project$View$ImageViewer$AdjustSize = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$View$ImageViewer$palette = $author$project$Data$Color$lightPalette;
    var $author$project$View$ImageViewer$zoomButton_fn = function (percentage, sizeAdjustment) {
        var _v0 = function () {
            if (sizeAdjustment === 1) {
                return _Utils_Tuple2("minus", _Utils_cmp($elm$core$Basics$floor(percentage * 100), $author$project$View$ImageViewer$zoomOutStep) > 0);
            }
            else {
                return _Utils_Tuple2("plus", $elm$core$Basics$floor(percentage * 100) < 300);
            }
        }();
        var icon = _v0.a;
        var isEnabled = _v0.b;
        return $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
            kb: "Zoom " + icon,
            hp: _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(40),
                $author$project$View$Util$attrWhen_fn(!isEnabled, $mdgriffith$elm_ui$Element$Font$color($author$project$View$ImageViewer$palette.aS)),
                $mdgriffith$elm_ui$Element$pointer
            ]),
            fQ: $author$project$Util$Misc$toJustIf_fn(isEnabled, $author$project$View$ImageViewer$AdjustSize(sizeAdjustment))
        }, 2, icon);
    }, $author$project$View$ImageViewer$zoomButton = F2($author$project$View$ImageViewer$zoomButton_fn);
    var $author$project$View$ImageViewer$header_fn = function (viewport, _v0) {
        var imageUrl = _v0.ma;
        var mImageDimensions = _v0.c0;
        var zoomLevel = _v0.bP;
        var resetButton = $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
            kb: "Reset image size",
            hp: _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(40)
            ]),
            fQ: $author$project$Util$Misc$toJustIf_fn(!(!zoomLevel), $author$project$View$ImageViewer$ResetSize)
        }, 0, $author$project$Util$Misc$if__fn(zoomLevel < 0, "expand-alt", "compress-alt"));
        var mPercentage = $elm$core$Maybe$map_fn(A2($author$project$View$ImageViewer$getPercentage, viewport, zoomLevel), mImageDimensions);
        var imageControls = function (percentage) {
            return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$Font$size(18),
                $mdgriffith$elm_ui$Element$spacing(4),
                $mdgriffith$elm_ui$Element$onRight($author$project$View$Util$when_fn(!(!zoomLevel), resetButton))
            ]), _List_fromArray([
                $author$project$View$ImageViewer$zoomButton_fn(percentage, 1),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $author$project$View$Util$noSelect,
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(35))
                ]), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$text($elm$core$String$fromInt($elm$core$Basics$floor(percentage * 100)) + "%"))),
                $author$project$View$ImageViewer$zoomButton_fn(percentage, 0)
            ]));
        };
        var closeButton = $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
            kb: "Close image viewer",
            hp: _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(40),
                $mdgriffith$elm_ui$Element$alignRight,
                $mdgriffith$elm_ui$Element$moveLeft(10),
                $mdgriffith$elm_ui$Element$centerY
            ]),
            fQ: $elm$core$Maybe$Just($author$project$View$ImageViewer$CloseImage)
        }, 2, "times");
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$moveDown(5),
            $mdgriffith$elm_ui$Element$inFront($author$project$View$Util$whenJust_fn(mPercentage, imageControls)),
            $mdgriffith$elm_ui$Element$inFront(closeButton)
        ]), $mdgriffith$elm_ui$Element$none);
    }, $author$project$View$ImageViewer$header = F2($author$project$View$ImageViewer$header_fn);
    var $author$project$View$ImageViewer$backgroundGray = $mdgriffith$elm_ui$Element$rgba255_fn(30, 30, 30, 0.9);
    var $author$project$View$ImageViewer$transluscentBackground = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
        $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
        $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$View$ImageViewer$CloseImage),
        $mdgriffith$elm_ui$Element$Background$color($author$project$View$ImageViewer$backgroundGray)
    ]), $mdgriffith$elm_ui$Element$none);
    var $author$project$View$ImageViewer$ImageDimensions_fn = function (width, height) {
        return (new $$Record35(height, width));
    }, $author$project$View$ImageViewer$ImageDimensions = F2($author$project$View$ImageViewer$ImageDimensions_fn);
    var $author$project$View$ImageViewer$ImageLoaded = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$View$ImageViewer$decodeImgLoad = _Json_map1_fn($author$project$View$ImageViewer$ImageLoaded, _Json_decodeField_fn("target", _Json_map2_fn($author$project$View$ImageViewer$ImageDimensions, _Json_decodeField_fn("width", $elm$json$Json$Decode$int), _Json_decodeField_fn("height", $elm$json$Json$Decode$int))));
    var $elm$html$Html$Attributes$hidden_a0 = "hidden", $elm$html$Html$Attributes$hidden = $elm$html$Html$Attributes$boolProperty($elm$html$Html$Attributes$hidden_a0);
    var $elm$html$Html$img = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "img"), $elm$html$Html$img_fn = $elm$html$Html$img.a2;
    var $author$project$View$ImageViewer$viewLoadingImage = function (imageUrl) {
        return $mdgriffith$elm_ui$Element$html($elm$html$Html$img_fn(_List_fromArray([
            $elm$html$Html$Events$on_fn("load", $author$project$View$ImageViewer$decodeImgLoad),
            $elm$html$Html$Attributes$src(imageUrl),
            $elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$hidden_a0, true)
        ]), _List_Nil));
    };
    var $author$project$View$ImageViewer$viewImage_fn = function (viewport, _v0) {
        var scene = viewport.oh;
        var imageUrl = _v0.ma;
        var mImageDimensions = _v0.c0;
        var zoomLevel = _v0.bP;
        if (!mImageDimensions.$) {
            var imageDimensions = mImageDimensions.a;
            var percentage = $author$project$View$ImageViewer$getPercentage_fn(viewport, zoomLevel, imageDimensions);
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$scrollbars,
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn($elm$core$Basics$floor(scene.jJ - ($author$project$View$ImageViewer$horizontalMargin(viewport) * 2)), $mdgriffith$elm_ui$Element$shrink)),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$maximum_fn($elm$core$Basics$floor(scene.fo - ($author$project$View$ImageViewer$verticalMargin * 2)), $mdgriffith$elm_ui$Element$shrink)),
                $mdgriffith$elm_ui$Element$moveDown($author$project$View$ImageViewer$verticalMargin / 3)
            ]), $mdgriffith$elm_ui$Element$image_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px($elm$core$Basics$floor(imageDimensions.jJ * percentage)))
            ]), (new $$Record114("Attachment image", imageUrl))));
        }
        else {
            return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]), _List_fromArray([
                $mdgriffith$elm_ui$Element$text("Loading..."),
                $author$project$View$ImageViewer$viewLoadingImage(imageUrl)
            ]));
        }
    }, $author$project$View$ImageViewer$viewImage = F2($author$project$View$ImageViewer$viewImage_fn);
    var $author$project$View$ImageViewer$viewHelp_fn = function (viewport, model) {
        if (!model.$) {
            return $mdgriffith$elm_ui$Element$none;
        }
        else {
            var internalModel = model.a;
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$rgb255_fn(255, 255, 255)),
                $mdgriffith$elm_ui$Element$behindContent($author$project$View$ImageViewer$transluscentBackground),
                $mdgriffith$elm_ui$Element$inFront($author$project$View$ImageViewer$viewImage_fn(viewport, internalModel)),
                $mdgriffith$elm_ui$Element$inFront($author$project$View$ImageViewer$header_fn(viewport, internalModel))
            ]), $mdgriffith$elm_ui$Element$none);
        }
    }, $author$project$View$ImageViewer$viewHelp = F2($author$project$View$ImageViewer$viewHelp_fn);
    var $author$project$View$ImageViewer$view_a0 = $author$project$View$ImageViewer$viewHelp, $author$project$View$ImageViewer$view = $mdgriffith$elm_ui$Element$Lazy$lazy2($author$project$View$ImageViewer$view_a0);
    var $author$project$Model$GiftAreaOpen = function (a) {
        return { $: 31, a: a };
    };
    var $author$project$Model$NotificationAreaOpen = function (a) {
        return { $: 29, a: a };
    };
    var $author$project$View$Mask$view = function (_v0) {
        var env = _v0.dW;
        var page = _v0.ix;
        var toMask = function (attrs) {
            return $mdgriffith$elm_ui$Element$el_fn(_Utils_ap(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, $author$project$View$Config$zIndices.h7),
                $mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.15))
            ]), attrs), $mdgriffith$elm_ui$Element$none);
        };
        return env.iO ? toMask(_List_fromArray([
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Model$ProfileMenuOpen(false))
        ])) : (env.nq ? toMask(_List_fromArray([
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Model$NotificationAreaOpen(false))
        ])) : (env.lQ ? toMask(_List_fromArray([
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Model$GiftAreaOpen(false))
        ])) : ((env.oz && (!$author$project$Routing$isSearch(env.oe))) ? toMask(_List_fromArray([
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Model$HandleBacktalk($author$project$Env$ShowSearch(false)))
        ])) : (env.lY ? toMask(_List_fromArray([
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Model$HelpMenuOpen(false))
        ])) : $mdgriffith$elm_ui$Element$none))));
    };
    var $author$project$Analytics$NextMeetingNudgerDismissed = function (a) {
        return { $: 65, a: a };
    };
    var $author$project$Analytics$NextMeetingNudgerMinimized = function (a) {
        return { $: 64, a: a };
    };
    var $author$project$View$NextMeetingNudger$CreateNoteContent = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$View$NextMeetingNudger$LinkToMeeting = { $: 0 };
    var $author$project$View$NextMeetingNudger$computeContentState_a0 = F2(function (ai, acc) {
        return $elm$core$List$foldl_fn_unwrapped(function (textEl, innerAcc) {
            if (textEl.$ === 1) {
                var currentTopic = textEl.c.k7;
                return currentTopic ? function () {
                    var $r = innerAcc.$c();
                    $r.d2 = true;
                    return $r;
                }() : innerAcc;
            }
            else {
                return innerAcc;
            }
        }, acc, ai.jn);
    }), $author$project$View$NextMeetingNudger$computeContentState_a1 = (new $$Record153(false)), $author$project$View$NextMeetingNudger$computeContentState = A2($elm$core$List$foldl, $author$project$View$NextMeetingNudger$computeContentState_a0, $author$project$View$NextMeetingNudger$computeContentState_a1);
    var $author$project$View$NextMeetingNudger$currentStep_fn = function (env, nextMeetingId) {
        return $elm$core$Maybe$withDefault_fn($author$project$View$NextMeetingNudger$LinkToMeeting, $elm$core$Maybe$map_fn(function (note) {
            return _Utils_eq($author$project$Data$Note$getEventId(note), $elm$core$Maybe$Just(nextMeetingId)) ? $author$project$View$NextMeetingNudger$CreateNoteContent($elm$core$List$foldl_fn($author$project$View$NextMeetingNudger$computeContentState_a0, $author$project$View$NextMeetingNudger$computeContentState_a1, note.gz)) : $author$project$View$NextMeetingNudger$LinkToMeeting;
        }, $elm$core$Maybe$andThen_fn(A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Firestore$Collection$get, env.fO), $author$project$Routing$currentNoteId(env.oe))));
    }, $author$project$View$NextMeetingNudger$currentStep = F2($author$project$View$NextMeetingNudger$currentStep_fn);
    var $mdgriffith$elm_ui$Internal$Model$Active = 2;
    var $mdgriffith$elm_ui$Internal$Flag$active = $mdgriffith$elm_ui$Internal$Flag$flag(32);
    var $mdgriffith$elm_ui$Element$mouseDown = function (decs) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$active, $mdgriffith$elm_ui$Internal$Model$PseudoSelector_fn(2, $mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
    };
    var $author$project$View$NextMeetingNudger$viewHelp_fn = function (env, event) {
        var palette = env.nI;
        var setNudgerState = function (newState) {
            return $author$project$Env$UpdateSettings(function (settings) {
                return $$update__ed(settings, newState);
            });
        };
        var onClickHelp = function (msgs) {
            return $author$project$Model$HandleBacktalk($author$project$Env$Tantrum(msgs));
        };
        var nudgerState = $author$project$Data$Settings$get(env).ed;
        var nudgerIsMinimized = nudgerState === 2;
        var minimizeNudgerHandler = onClickHelp($author$project$Util$Misc$if__fn(nudgerIsMinimized, _List_fromArray([
            setNudgerState(1),
            $author$project$Env$AnalyticsEvent($author$project$Analytics$NextMeetingNudgerMinimized(false))
        ]), _List_fromArray([
            setNudgerState(2),
            $author$project$Env$AnalyticsEvent($author$project$Analytics$NextMeetingNudgerMinimized(true))
        ])));
        var eventUrl = $author$project$Routing$pathFromRoute($author$project$Routing$RouteCreateEventNote_fn(event.l8, $author$project$Data$Event$masterId(event), $elm$core$Maybe$Nothing));
        var buttonAttrs = F2(function (xPadding, activeLooking) {
            return _List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn(activeLooking, palette.dw, palette.a7)),
                $mdgriffith$elm_ui$Element$Background$color($author$project$Util$Misc$if__fn(activeLooking, palette.a7, palette.dw)),
                $author$project$View$Util$attrWhen_fn(activeLooking, $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Background$color(palette.a6)
                ]))),
                $author$project$View$Util$attrWhen_fn(activeLooking, $mdgriffith$elm_ui$Element$mouseDown(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Background$color(palette.a5)
                ]))),
                $mdgriffith$elm_ui$Element$paddingXY_fn(xPadding, 8),
                $mdgriffith$elm_ui$Element$Border$width(1),
                $mdgriffith$elm_ui$Element$alignBottom,
                $mdgriffith$elm_ui$Element$Font$light
            ]);
        });
        var _v0 = function () {
            var _v1 = $author$project$View$NextMeetingNudger$currentStep_fn(env, event.l8);
            if (!_v1.$) {
                return _Utils_Tuple3("Prepare for your next meeting", _List_fromArray([
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$regular,
                            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Font$color(palette.a8)
                            ]))
                        ]), {
                            fF: $mdgriffith$elm_ui$Element$text(event.gj),
                            dt: eventUrl
                        }),
                        $mdgriffith$elm_ui$Element$text(" is coming up. ")
                    ])),
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_Nil, _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("See how easy it is to get prepared")
                    ]))
                ]), $author$project$View$Widgets$linkButtonHelp_fn($author$project$View$Widgets$linkButton_a0, {
                    hp: A2(buttonAttrs, 10, true),
                    l7: $elm$core$Maybe$Nothing,
                    dt: eventUrl
                }, "View meeting"));
            }
            else {
                var hasTopic = _v1.a.d2;
                return _Utils_Tuple3("Jot down some discussion topics", _List_fromArray([
                    $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$spacing(8)
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Element$text("Type "),
                        A3($author$project$View$ActionItems$keyShortcutChip, palette, false, "??"),
                        $mdgriffith$elm_ui$Element$text(" to create a discussion "),
                        A3($author$project$View$ActionItems$mentionChip, palette, false, "topic"),
                        $mdgriffith$elm_ui$Element$text(" for this meeting.")
                    ]))
                ]), $author$project$View$Widgets$button_fn({
                    hp: A2(buttonAttrs, 24, hasTopic),
                    l7: $elm$core$Maybe$Nothing,
                    fQ: $elm$core$Maybe$Just(onClickHelp(_List_fromArray([
                        setNudgerState(3),
                        $author$project$Env$AnalyticsEvent($author$project$Analytics$NextMeetingNudgerDismissed({ mt: hasTopic }))
                    ])))
                }, "Dismiss"));
            }
        }();
        var title = _v0.a;
        var bodyEls = _v0.b;
        var button = _v0.c;
        var body = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(150)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$light,
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$Font$size(17),
            $mdgriffith$elm_ui$Element$spacing(20),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$paddingEach((new $$Record115(0, 50, 20, 0))),
                $mdgriffith$elm_ui$Element$spacing(8)
            ]), bodyEls),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$alignRight,
                $mdgriffith$elm_ui$Element$moveLeft(20)
            ]), button)
        ])));
        var header = $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Background$color(palette.a1),
            $mdgriffith$elm_ui$Element$Font$color(palette.a7),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(50)),
            $mdgriffith$elm_ui$Element$spacing(15),
            $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0),
            $author$project$View$Util$attrWhen_fn(nudgerIsMinimized, $mdgriffith$elm_ui$Element$pointer),
            $author$project$View$Util$attrWhen_fn(nudgerIsMinimized, $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, minimizeNudgerHandler))
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(25)),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(25)),
                $mdgriffith$elm_ui$Element$Background$color(palette.a4),
                $mdgriffith$elm_ui$Element$Border$rounded(100)
            ]), $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(14),
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$moveDown(1)
            ]), 1, "lightbulb")),
            $mdgriffith$elm_ui$Element$el_fn(_List_Nil, $mdgriffith$elm_ui$Element$text(title)),
            $author$project$View$Icon$buttonWithSize_fn(14, {
                kb: "Minimize next meeting tour",
                hp: _List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(palette.aR),
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(30)),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(30)),
                    $mdgriffith$elm_ui$Element$alignRight,
                    $mdgriffith$elm_ui$Element$moveLeft(5)
                ]),
                fQ: $elm$core$Maybe$Just(minimizeNudgerHandler)
            }, 1, $author$project$Util$Misc$if__fn(nudgerState === 2, "chevron-up", "chevron-down"))
        ]));
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(350)),
            $mdgriffith$elm_ui$Element$Background$color(palette.dw),
            $author$project$View$Styling$elevation30,
            $mdgriffith$elm_ui$Element$Border$rounded(8),
            $mdgriffith$elm_ui$Element$clip
        ]), _List_fromArray([
            header,
            $author$project$View$Util$when_fn(!nudgerIsMinimized, body)
        ]));
    }, $author$project$View$NextMeetingNudger$viewHelp = F2($author$project$View$NextMeetingNudger$viewHelp_fn);
    var $author$project$View$NextMeetingNudger$view = function (env) {
        return $author$project$View$NextMeetingNudger$isDisplayed(env) ? $elm_community$basics_extra$Basics$Extra$flip_fn($author$project$View$Util$whenJust, $author$project$View$NextMeetingNudger$viewHelp(env), $elm$core$Maybe$andThen_fn(A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$Dict$get, env.lw), env.nd)) : $mdgriffith$elm_ui$Element$none;
    };
    var $mdgriffith$elm_ui$Element$clipY = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.kN);
    var $author$project$Routing$isAuth = function (route) {
        if (route.$ === 17) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Page$Note$isZenMode = function ($) {
        return $.aw;
    };
    var $author$project$View$Header$mobileBreakpoint = 600;
    var $author$project$View$Header$onboardingDoubleColumnHeaderAttrs_fn = function (palette, isMobile) {
        return _List_fromArray([
            $mdgriffith$elm_ui$Element$Border$widthEach($$update__pE($author$project$View$Styling$edges, 5)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(5)),
            $mdgriffith$elm_ui$Element$Border$color(palette.a2),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$paddingXY_fn($author$project$Util$Misc$if__fn(isMobile, 10, 25), 0)
        ]);
    }, $author$project$View$Header$onboardingDoubleColumnHeaderAttrs = F2($author$project$View$Header$onboardingDoubleColumnHeaderAttrs_fn);
    var $author$project$View$Header$innerHeaderAttrs = _List_fromArray([
        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn($author$project$View$Layout$maxPageWidth, $mdgriffith$elm_ui$Element$fill)),
        $mdgriffith$elm_ui$Element$centerX,
        $mdgriffith$elm_ui$Element$centerY,
        $mdgriffith$elm_ui$Element$paddingXY_fn(30, 0),
        $mdgriffith$elm_ui$Element$spacing(20)
    ]);
    var $author$project$Analytics$ProfileMenuOpen = { $: 3 };
    var $author$project$View$Header$profileButton_fn = function (env, user) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$alignRight,
            $author$project$View$Styling$paddingLeft(10)
        ]), A4($author$project$View$Shortcut$tooltip, env.nI, -50, $author$project$Data$Shortcut$keys.bb, $mdgriffith$elm_ui$Element$Input$button_fn(_List_fromArray([
            $elm$core$Basics$composeL_fn($author$project$View$Util$id_a0, $author$project$View$Util$id_a1, $author$project$View$Header$profileButtonId),
            $author$project$View$Util$attrWhen_fn(env.iO, $mdgriffith$elm_ui$Element$Background$color(env.nI.aO)),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(env.nI.aP)
            ])),
            $mdgriffith$elm_ui$Element$Border$rounded(50),
            $author$project$View$Styling$ripple,
            $author$project$View$Styling$focusable,
            $mdgriffith$elm_ui$Element$clip
        ]), {
            fF: $mdgriffith$elm_ui$Element$image_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(40)),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(40))
            ]), (new $$Record114("Profile Menu", user.nN))),
            nz: $elm$core$Maybe$Just($author$project$Model$ManyMsgs(_List_fromArray([
                $author$project$Model$ProfileMenuOpen(!env.iO),
                $author$project$Model$HandleBacktalk($author$project$Env$AnalyticsEvent($author$project$Analytics$ProfileMenuOpen))
            ])))
        })));
    }, $author$project$View$Header$profileButton = F2($author$project$View$Header$profileButton_fn);
    var $author$project$Analytics$ProfileMenuFeedback = { $: 6 };
    var $author$project$Analytics$ProfileMenuKeyboardShortcuts = { $: 7 };
    var $author$project$Analytics$ProfileMenuSignOut = { $: 4 };
    var $author$project$Routing$RedirectLanding = { $: 0 };
    var $author$project$Model$SignOut = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$View$ProfileMenu$borderRounding = 8;
    var $author$project$View$ProfileMenu$overlayAreaAttrs = function (palette) {
        return _List_fromArray([
            $mdgriffith$elm_ui$Element$Border$rounded($author$project$View$ProfileMenu$borderRounding),
            $mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.1)),
            $mdgriffith$elm_ui$Element$Border$width(1),
            $mdgriffith$elm_ui$Element$Background$color(palette.dw),
            $elm$core$Basics$composeL_fn($author$project$View$Util$class_a0, $author$project$View$Util$class_a1, "blow-up-animation"),
            $mdgriffith$elm_ui$Element$Border$shadow({
                kp: 7,
                kS: $mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.2),
                nt: _Utils_Tuple2(0, 3),
                oE: -2
            })
        ]);
    };
    var $author$project$Analytics$ProfileMenuAddLinkedAccount = { $: 8 };
    var $author$project$Analytics$ProfileMenuSwitchAccount = { $: 9 };
    var $author$project$Env$SwitchAccount = function (a) {
        return { $: 17, a: a };
    };
    var $author$project$View$ProfileMenu$viewLinkedAccounts_fn = function (palette, user, linkedAccountReqStatus) {
        var buttonAttrs = _List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(palette.aT),
            $mdgriffith$elm_ui$Element$alignBottom,
            $mdgriffith$elm_ui$Element$Border$width(0),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$Border$rounded(0),
            $mdgriffith$elm_ui$Element$Font$size(12),
            $mdgriffith$elm_ui$Element$paddingXY_fn(10, 13),
            $mdgriffith$elm_ui$Element$Font$regular,
            $author$project$View$Styling$ripple,
            $author$project$View$Styling$focusable,
            $mdgriffith$elm_ui$Element$Font$letterSpacing(0.6),
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$grayAlphaLight)
            ]))
        ]);
        var viewAddLinkedAccount = $mdgriffith$elm_ui$Element$Input$button_fn(buttonAttrs, {
            fF: $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$text("Add an account")),
            nz: $elm$core$Maybe$Just($author$project$Model$HandleBacktalk($author$project$Env$Tantrum(_List_fromArray([
                $author$project$Env$AddLinkedAccount,
                $author$project$Env$AnalyticsEvent($author$project$Analytics$ProfileMenuAddLinkedAccount)
            ]))))
        });
        var viewLinkedAccount = function (_v1) {
            var email = _v1.cS;
            return $mdgriffith$elm_ui$Element$Input$button_fn(buttonAttrs, {
                fF: $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$text(email)),
                nz: $elm$core$Maybe$Just($author$project$Model$HandleBacktalk($author$project$Env$Tantrum(_List_fromArray([
                    $author$project$Env$SwitchAccount({ cS: email }),
                    $author$project$Env$AnalyticsEvent($author$project$Analytics$ProfileMenuSwitchAccount)
                ]))))
            });
        };
        var viewAddAccountOptions = function (accounts) {
            return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$paddingXY_fn(0, 0)
            ]), _List_Cons($author$project$View$Util$horizontalLine_fn(palette, 1, _List_Nil), $elm$core$List$isEmpty(accounts) ? _List_fromArray([viewAddLinkedAccount]) : $elm$core$List$map_fn(viewLinkedAccount, accounts)));
        };
        if (linkedAccountReqStatus.$ === 3) {
            var linkedAccounts = linkedAccountReqStatus.a.mI;
            return viewAddAccountOptions($elm$core$List$filter_fn(A2($elm$core$Basics$composeR, function ($) {
                return $.cS;
            }, $elm$core$Basics$neq(user.cS)), linkedAccounts));
        }
        else {
            return $mdgriffith$elm_ui$Element$none;
        }
    }, $author$project$View$ProfileMenu$viewLinkedAccounts = F3($author$project$View$ProfileMenu$viewLinkedAccounts_fn);
    var $author$project$View$ProfileMenu$view_fn = function (palette, user, linkedAccountReqStatus, isOnboarding) {
        var showDialog = A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, $author$project$Env$SetDialog, $author$project$Model$HandleBacktalk));
        var profileMenuHeaderItems = _List_fromArray([
            $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.aT),
                $mdgriffith$elm_ui$Element$Font$size(13),
                $mdgriffith$elm_ui$Element$paddingXY_fn(20, 15),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$spacing(15),
                $mdgriffith$elm_ui$Element$Background$color(palette.aM),
                $mdgriffith$elm_ui$Element$Border$roundEach({ kx: 0, ky: 0, pF: $author$project$View$ProfileMenu$borderRounding, pG: $author$project$View$ProfileMenu$borderRounding })
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$image_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(60)),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(60)),
                    $mdgriffith$elm_ui$Element$Border$rounded(50),
                    $mdgriffith$elm_ui$Element$clip,
                    $mdgriffith$elm_ui$Element$centerX
                ]), (new $$Record114("User Profile", user.nN))),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX]), $mdgriffith$elm_ui$Element$text(user.cS))
            ])),
            $author$project$View$Util$horizontalLine_fn(palette, 1, _List_Nil)
        ]);
        var iconAttrs = _List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(15),
            $mdgriffith$elm_ui$Element$Font$color(palette.aS)
        ]);
        var extraAttrs = _List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(palette.aT),
            $mdgriffith$elm_ui$Element$alignBottom,
            $mdgriffith$elm_ui$Element$Border$width(0),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$alignLeft,
            $mdgriffith$elm_ui$Element$Border$rounded(0),
            $mdgriffith$elm_ui$Element$paddingXY_fn(20, 15)
        ]);
        var linkHelp = F3(function (icon_, text_, route) {
            return $author$project$View$Widgets$linkButtonHelp_fn($author$project$View$Widgets$linkButton_a0, {
                hp: extraAttrs,
                l7: $elm$core$Maybe$Just(icon_),
                dt: $author$project$Routing$pathFromRoute(route)
            }, text_);
        });
        var buttonHelp = F4(function (icon_, text_, msg, analyticEvent) {
            return $author$project$View$Widgets$button_fn({
                hp: extraAttrs,
                l7: $elm$core$Maybe$Just(icon_),
                fQ: $elm$core$Maybe$Just($author$project$Model$ManyMsgs(_List_fromArray([
                    msg,
                    $author$project$Model$HandleBacktalk($author$project$Env$AnalyticsEvent(analyticEvent))
                ])))
            }, text_);
        });
        var signOutButton = A4(buttonHelp, _Utils_Tuple3(3, "sign-out", iconAttrs), "Sign Out", $author$project$Model$SignOut($author$project$Routing$RedirectLanding), $author$project$Analytics$ProfileMenuSignOut);
        var menuOptions = isOnboarding ? _List_fromArray([signOutButton]) : _List_fromArray([
            A3(linkHelp, _Utils_Tuple3(1, "cog", iconAttrs), "Settings", $author$project$Routing$RouteSettings),
            A3(linkHelp, _Utils_Tuple3(1, "credit-card", iconAttrs), "Billing", $author$project$Routing$RouteBilling),
            A4(buttonHelp, _Utils_Tuple3(1, "comment-alt-lines", iconAttrs), "Send feedback", showDialog($author$project$Data$Dialog$Closeable$FeedbackForm(0)), $author$project$Analytics$ProfileMenuFeedback),
            A4(buttonHelp, _Utils_Tuple3(1, "keyboard", iconAttrs), "Shortcuts", showDialog($author$project$Data$Dialog$Closeable$KeyboardShortcuts), $author$project$Analytics$ProfileMenuKeyboardShortcuts),
            signOutButton,
            $author$project$View$ProfileMenu$viewLinkedAccounts_fn(palette, user, linkedAccountReqStatus)
        ]);
        return $mdgriffith$elm_ui$Element$column_fn(_List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$minimum_fn(240, $mdgriffith$elm_ui$Element$shrink)), $author$project$View$ProfileMenu$overlayAreaAttrs(palette)), _Utils_ap(profileMenuHeaderItems, menuOptions));
    }, $author$project$View$ProfileMenu$view = F4($author$project$View$ProfileMenu$view_fn);
    var $author$project$View$Header$profileMenu = function (env) {
        return $author$project$View$Util$when_fn(env.iO, $author$project$View$Util$whenJust_fn(env.pV, function (user) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$alignRight,
                $mdgriffith$elm_ui$Element$moveLeft(5),
                $mdgriffith$elm_ui$Element$moveDown(3),
                $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, $author$project$View$Config$zIndices.nR)
            ]), $author$project$View$ProfileMenu$view_fn(env.nI, user, env.db.kn, $author$project$Routing$isSignup(env.oe)));
        }));
    };
    var $author$project$View$Header$onboardingHeader = function (env) {
        var isMobile = $author$project$View$Responsive$isMobile_fn($author$project$View$Layout$breakpoints, env.p1);
        var isDoubleColumned = $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, env.p1);
        return $mdgriffith$elm_ui$Element$row_fn(_List_Cons($mdgriffith$elm_ui$Element$inFront($author$project$View$Header$profileMenu(env)), $author$project$View$Header$innerHeaderAttrs), _List_fromArray([
            (_Utils_cmp(env.p1.p1.jJ, $author$project$View$Layout$breakpoints.oD) < 0) ? $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                (isMobile && _Utils_eq(env.pV, $elm$core$Maybe$Nothing)) ? $mdgriffith$elm_ui$Element$centerX : $mdgriffith$elm_ui$Element$alignLeft
            ]), $author$project$View$Widgets$witfulIconWithText_fn(env.nI, $elm$core$Maybe$Nothing, env)) : $mdgriffith$elm_ui$Element$none,
            $author$project$View$Util$whenJust_fn(env.pV, function (user) {
                return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(0)),
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(0)),
                    $author$project$View$Util$attrWhen_fn(isDoubleColumned, $mdgriffith$elm_ui$Element$moveDown(10)),
                    $author$project$View$Util$attrWhen_fn(isDoubleColumned, $mdgriffith$elm_ui$Element$moveRight(10)),
                    $mdgriffith$elm_ui$Element$alignRight,
                    $mdgriffith$elm_ui$Element$alignTop,
                    $mdgriffith$elm_ui$Element$inFront($author$project$View$Header$profileButton_fn(env, user)),
                    $author$project$View$Util$createStackingContext
                ]), $mdgriffith$elm_ui$Element$none);
            })
        ]));
    };
    var $author$project$View$Header$outerHeaderAttrs_fn = function (palette, _v0) {
        return _List_fromArray([
            $mdgriffith$elm_ui$Element$Border$widthEach($$update__kw($author$project$View$Styling$edges, 1)),
            $mdgriffith$elm_ui$Element$Border$color(palette.aO),
            $mdgriffith$elm_ui$Element$Background$color(palette.dw),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(60)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]);
    }, $author$project$View$Header$outerHeaderAttrs = F2($author$project$View$Header$outerHeaderAttrs_fn);
    var $author$project$Analytics$SearchBarOpen = { $: 33 };
    var $author$project$View$Icon$linkWithSize_fn = function (iconSize, _v0, iconStyle, iconName, url) {
        var ariaLabel = _v0.kb;
        var extraAttrs = _v0.hp;
        return $mdgriffith$elm_ui$Element$link_fn(_Utils_ap(_List_fromArray([
            $author$project$View$Util$attribute_fn($author$project$View$Aria$label_a0, ariaLabel),
            $mdgriffith$elm_ui$Element$Font$size(14),
            $mdgriffith$elm_ui$Element$Border$rounded(50),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(45)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(45)),
            $author$project$View$Styling$backgroundTransition,
            $author$project$View$Styling$ripple,
            $author$project$View$Styling$focusable,
            $author$project$View$Util$buttonRole,
            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color($author$project$Data$Color$grayAlphaLight)
            ]))
        ]), extraAttrs), {
            fF: $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$centerY,
                $mdgriffith$elm_ui$Element$Font$size(iconSize)
            ]), iconStyle, iconName),
            dt: url
        });
    }, $author$project$View$Icon$linkWithSize = F5($author$project$View$Icon$linkWithSize_fn);
    var $author$project$View$Icon$link_a0 = 20, $author$project$View$Icon$link = $author$project$View$Icon$linkWithSize($author$project$View$Icon$link_a0);
    var $author$project$View$Header$mTabIndex_fn = function (tabIndexNum, env) {
        return $author$project$View$Util$tabIndex($author$project$Util$Misc$toJustIf_fn(!$author$project$View$EmptyState$isActive(env), tabIndexNum));
    }, $author$project$View$Header$mTabIndex = F2($author$project$View$Header$mTabIndex_fn);
    var $author$project$View$Header$mDisableTabbing_a0 = 0, $author$project$View$Header$mDisableTabbing = $author$project$View$Header$mTabIndex($author$project$View$Header$mDisableTabbing_a0);
    var $author$project$Util$Time$diff_fn = function (t1, t2) {
        return $elm$core$Basics$abs($elm$time$Time$posixToMillis(t1) - $elm$time$Time$posixToMillis(t2));
    }, $author$project$Util$Time$diff = F2($author$project$Util$Time$diff_fn);
    var $author$project$Util$Time$week = $author$project$Util$Time$day * 7;
    var $author$project$Util$Time$formatDuration_fn = function (concise, duration) {
        var f = F2(function (s, v) {
            return _Utils_ap($elm$core$String$fromInt(v), _Utils_ap($author$project$Util$Misc$if__fn(concise, "", " "), _Utils_ap(s, ((v !== 1) && (!concise)) ? "s" : "")));
        });
        return (_Utils_cmp(duration, $author$project$Util$Time$minute) < 1) ? A2(f, $author$project$Util$Misc$if__fn(concise, "s", "second"), (duration / $author$project$Util$Time$second) | 0) : ((_Utils_cmp(duration, $author$project$Util$Time$hour) < 1) ? A2(f, $author$project$Util$Misc$if__fn(concise, "m", "minute"), (duration / $author$project$Util$Time$minute) | 0) : ((_Utils_cmp(duration, $author$project$Util$Time$day) < 1) ? A2(f, $author$project$Util$Misc$if__fn(concise, "h", "hour"), (duration / $author$project$Util$Time$hour) | 0) : ((_Utils_cmp(duration, $author$project$Util$Time$week * 2) < 1) ? A2(f, $author$project$Util$Misc$if__fn(concise, "d", "day"), (duration / $author$project$Util$Time$day) | 0) : A2(f, $author$project$Util$Misc$if__fn(concise, "w", "week"), (duration / $author$project$Util$Time$week) | 0))));
    }, $author$project$Util$Time$formatDuration = F2($author$project$Util$Time$formatDuration_fn);
    var $author$project$Util$Time$formatTimestampRelative_fn = function (concise, now, zone, timestamp) {
        var fullDateFormat = $ryannhg$date_format$DateFormat$formatWithLanguage_fn($ryannhg$date_format$DateFormat$format_a0, _List_fromArray([
            $ryannhg$date_format$DateFormat$monthNameFull,
            $ryannhg$date_format$DateFormat$text(" "),
            $ryannhg$date_format$DateFormat$dayOfMonthSuffix,
            $ryannhg$date_format$DateFormat$text(", "),
            $ryannhg$date_format$DateFormat$yearNumber
        ]), zone, timestamp);
        var duration = $author$project$Util$Time$diff_fn(now, timestamp);
        return (_Utils_cmp(duration, 4 * $author$project$Util$Time$week) > 0) ? fullDateFormat : (_Utils_eq(now, timestamp) ? "Now" : ((_Utils_cmp($elm$time$Time$posixToMillis(now), $elm$time$Time$posixToMillis(timestamp)) > 0) ? ($author$project$Util$Time$formatDuration_fn(concise, duration) + " ago") : ("In " + $author$project$Util$Time$formatDuration_fn(concise, duration))));
    }, $author$project$Util$Time$formatTimestampRelative = F4($author$project$Util$Time$formatTimestampRelative_fn);
    var $author$project$Data$Meeting$startedWithinMinutes_fn = function (env, maxMinutes) {
        var toPosix = $author$project$Data$Time$toPosix(env.pu);
        var floor = A2($justinmimbs$time_extra$Time$Extra$floor, 11, env.pu);
        var currentDayStart = floor(env.k5);
        var eventFilter = function (_v1) {
            var startTime = _v1.oN;
            var responseStatus = _v1.ew;
            return (responseStatus !== 1) && ((!$author$project$Data$Time$isDate(startTime)) && ((_Utils_cmp($elm$core$Basics$abs($justinmimbs$time_extra$Time$Extra$diff_fn(13, env.pu, env.k5, toPosix(startTime))), maxMinutes) < 1) && _Utils_eq(floor(toPosix(startTime)), currentDayStart)));
        };
        return $elm$core$List$head($author$project$Data$Meeting$meetingsBy_fn(env.lw, env.fO, env.pu, {
            cA: function (_v0) {
                return false;
            },
            cT: function (event) {
                return eventFilter(event);
            },
            cU: F2(function (event, note) {
                return eventFilter(event) && (!note.lh);
            })
        }));
    }, $author$project$Data$Meeting$startedWithinMinutes = F2($author$project$Data$Meeting$startedWithinMinutes_fn);
    var $author$project$View$Header$nextMeetingInfo = function (env) {
        var widgetContent = function (meeting) {
            return $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, env.p1) ? _List_fromArray([
                $author$project$Util$Time$isAfter_fn(meeting.bF, env.k5) ? $mdgriffith$elm_ui$Element$text("Meeting began") : $mdgriffith$elm_ui$Element$text("Next meeting"),
                $mdgriffith$elm_ui$Element$text($author$project$Util$Time$formatTimestampRelative_fn(false, env.k5, env.pu, meeting.bF))
            ]) : _List_fromArray([
                $author$project$Util$Time$isAfter_fn(meeting.bF, env.k5) ? $mdgriffith$elm_ui$Element$text("Meeting") : $mdgriffith$elm_ui$Element$text("Meeting"),
                $mdgriffith$elm_ui$Element$text($author$project$Util$Time$formatTimestampRelative_fn(true, env.k5, env.pu, meeting.bF))
            ]);
        };
        var meetingWindowMinutes = $elm$core$Maybe$map_fn(function (n) {
            switch (n) {
                case 0:
                    return 10;
                case 1:
                    return 5;
                default:
                    return 2;
            }
        }, $elm$core$Basics$composeR_fn($author$project$Data$Settings$nextMeetingNotifications_a0, $author$project$Data$Settings$nextMeetingNotifications_a1, env));
        var meetingToShow = $elm$core$Maybe$andThen_fn($author$project$Data$Meeting$startedWithinMinutes(env), meetingWindowMinutes);
        var isShowArmyTime = $elm$core$Basics$composeR_fn($author$project$Data$Settings$isShowArmyTime_a0, $author$project$Data$Settings$isShowArmyTime_a1, env);
        var hoverAttrs = _List_fromArray([
            $mdgriffith$elm_ui$Element$Background$color(env.nI.aO)
        ]);
        var formatTime = A2($author$project$Util$Time$formatTime, isShowArmyTime, env.pu);
        var tooltipContent = function (meeting) {
            return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(5),
                $mdgriffith$elm_ui$Element$padding(5)
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.dw),
                    $mdgriffith$elm_ui$Element$Font$size(16),
                    $mdgriffith$elm_ui$Element$centerX
                ]), $mdgriffith$elm_ui$Element$text($author$project$Util$Text$truncateToNChars_fn(25, meeting.gj))),
                $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.aQ),
                    $mdgriffith$elm_ui$Element$centerX
                ]), _List_fromArray([
                    $mdgriffith$elm_ui$Element$text(formatTime(meeting.bF)),
                    $mdgriffith$elm_ui$Element$text(" - "),
                    $mdgriffith$elm_ui$Element$text(formatTime(meeting.b6))
                ]))
            ]));
        };
        var viewMeetingNotification = function (meeting) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$alignRight,
                $author$project$View$Styling$paddingRight(10)
            ]), $mdgriffith$elm_ui$Element$link_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Border$rounded(5),
                $mdgriffith$elm_ui$Element$Border$color(env.nI.aP),
                $mdgriffith$elm_ui$Element$Border$width(1),
                $mdgriffith$elm_ui$Element$mouseOver(hoverAttrs)
            ]), {
                fF: $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink)
                ]), A4($author$project$View$Tooltip$custom, env.nI, 0, tooltipContent(meeting), $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$paddingXY_fn(5, 3),
                    $mdgriffith$elm_ui$Element$spacing(3)
                ]), _List_fromArray([
                    $author$project$View$Icon$icon_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aS)
                    ]), 2, "watch"),
                    $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.aT),
                        $mdgriffith$elm_ui$Element$spacing(2),
                        $mdgriffith$elm_ui$Element$Font$size(12),
                        $author$project$View$Styling$paddingRight(5)
                    ]), widgetContent(meeting))
                ])))),
                dt: $author$project$Routing$pathFromRoute($author$project$Routing$meetingToRoute(meeting))
            }));
        };
        return $author$project$View$Util$whenJust_fn(meetingToShow, viewMeetingNotification);
    };
    var $author$project$Analytics$NotificationAreaOpen = { $: 10 };
    var $elm$core$Set$filter_fn = function (isGood, _v0) {
        var dict = _v0;
        return $elm$core$Dict$filter_fn_unwrapped(function (key, _v1) {
            return isGood(key);
        }, dict);
    }, $elm$core$Set$filter = F2($elm$core$Set$filter_fn);
    var $author$project$Data$Notification$Announcement = 2;
    var $author$project$Data$Notification$Bugfix = 1;
    var $author$project$Data$Notification$Link = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Data$Notification$MentionChip = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Data$Notification$NewFeature = 0;
    var $author$project$Data$Notification$Plaintext = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Data$Notification$Refinement = 3;
    var $author$project$Content$NotificationArea$batchId = { bK: "v101", gm: "v106", gn: "v119", av: "v48", go: "v51", gp: "v54", jB: "v55", eR: "v57", jC: "v61", eS: "v75" };
    var $author$project$Content$NotificationArea$threadsPageRoute = $author$project$Routing$RouteThreads($author$project$Routing$defaultThreadsParams);
    var $author$project$Content$NotificationArea$latestNotifications = _List_fromArray([
        (new $$Record154($author$project$Content$NotificationArea$batchId.gn, 3, _List_fromArray([
            $author$project$Data$Notification$Plaintext("Search just got more powerful. Now when you use search, in addition to the quick results that display right away, you can hit ENTER to access a bunch of new search options. Further refine your results, for example, by adding filters like people, date ranges or attachment types.")
        ]), "Search upgrade")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.gn, 3, _List_fromArray([
            $author$project$Data$Notification$Plaintext("At long last, attachments now display thumbnails when you attach images beside a note. You can also edit the name of an attachment after it\u2019s been added so that it\u2019s easier to search for the right attachment later.")
        ]), "Attachments upgrade")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.gm, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("Now when you add a to-do to a meeting by typing !! it will automatically carry forward to future meetings in that recurring series until you mark it complete.")
        ]), "To-dos carry forward into future meetings")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.gm, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("If you signed up for Witful with your personal Gmail account, and would like to add your work account, now you can click on your profile and click \u201CAdd an account\u201D. You can then quickly toggle back and forth between both accounts from your profile menu.")
        ]), "Quickly add, and switch accounts")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.bK, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("Sometimes it\u2019s helpful to copy a topic or a to-do from the right hand column beside your note into the note body. Now you can just drag and drop the text of your topic or to-do into your note. It will even preserve the link to the original note where the topic or to-do was created.")
        ]), "Drag and drop topics and to-dos")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.bK, 1, _List_fromArray([
            $author$project$Data$Notification$Plaintext("We fixed an issue affecting some users where topics captured using ?? would display \u201Cloading\u201D.")
        ]), "Topics displaying as \u201Cloading\u201D")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.bK, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("Ever wish Witful would remind you when your next meeting is about to start? Go to Profile menu \u2192 Settings \u2192 Reminder notification before next meeting starts. You\u2019ll see a reminder at the top of Witful before the start of your next meeting.")
        ]), "Next meeting start reminder")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.bK, 1, _List_fromArray([
            $author$project$Data$Notification$Plaintext("We fixed an issue where linked text inside of a note would sometimes also grab the text before or after the link in an undesirable way. Now linked text does no undesirable grabbing.")
        ]), "Link bug fix")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.bK, 3, _List_fromArray([
            $author$project$Data$Notification$Plaintext("We\u2019ve made it easier to find reminders for how to use !!, ??, "),
            $author$project$Data$Notification$MentionChip("@mention"),
            $author$project$Data$Notification$Plaintext(", or "),
            $author$project$Data$Notification$MentionChip("#meeting"),
            $author$project$Data$Notification$Plaintext(". Use the keyboard shortcut ? to launch the shortcuts menu and see these helpers.")
        ]), "Updated keyboard shortcuts menu")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.bK, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("This is still experimental! Witful can send you a daily email with the to-dos and topics you captured and completed yesterday. Go to Profile menu \u2192 Settings \u2192 Snapshot Emails to enable this feature. Send us your thoughts as we\u2019re still refining this new feature.")
        ]), "Daily Snapshot email")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.eS, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("We've added a dedicated "),
            $author$project$Data$Notification$Link({
                jn: "Threads",
                dt: $author$project$Routing$pathFromRoute($author$project$Content$NotificationArea$threadsPageRoute)
            }),
            $author$project$Data$Notification$Plaintext(" page. You can now view your \u2018completed\u2019 threads, or sort threads by date.")
        ]), "Threads page")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.eS, 3, _List_fromArray([
            $author$project$Data$Notification$Plaintext("We no longer show action items with "),
            $author$project$Data$Notification$MentionChip("#meeting"),
            $author$project$Data$Notification$Plaintext(" references on the home page. Instead, these action items will surface when the time is right - in the referenced meeting. They'll still appear in your complete list on your "),
            $author$project$Data$Notification$Link({
                jn: "Threads",
                dt: $author$project$Routing$pathFromRoute($author$project$Content$NotificationArea$threadsPageRoute)
            }),
            $author$project$Data$Notification$Plaintext(" page.")
        ]), "De-cluttered Home page")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.eS, 3, _List_fromArray([
            $author$project$Data$Notification$Plaintext("We've made it easier to edit notes and use rich text when using Witful on your phone by showing a fixed editor toolbar at the top of the note.")
        ]), "Mobile improvements")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.jC, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("Ever need something to stand out as higher priority than your other action items from a meeting? In the body of your note just type !!! (3 exclamation points) and your action item will get highlighted and rise to the top of your list.")
        ]), "High priority action items")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.eR, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("Now you can easily add an action item to your next meeting by using "),
            $author$project$Data$Notification$MentionChip("#next meeting"),
            $author$project$Data$Notification$Plaintext(" within a note. Even better, you can combine this with "),
            $author$project$Data$Notification$MentionChip("@person"),
            $author$project$Data$Notification$Plaintext(" to add an action item to your next meeting with that person. For example, \u201CAsk "),
            $author$project$Data$Notification$MentionChip("@maya"),
            $author$project$Data$Notification$Plaintext(" about our marketing goals in the "),
            $author$project$Data$Notification$MentionChip("#next meeting"),
            $author$project$Data$Notification$Plaintext(".\u201C will ensure you remember to address the task in all future meetings with Maya until it is marked as done.")
        ]), "#next meeting")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.eR, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("It\u2019s now much easier to see the meeting where you completed an action item. When you complete an action item in a meeting, Witful will add the date completed and link to the meeting where that action item was marked as complete.")
        ]), "Action item completion")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.eR, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("When typing in a note use '>' to quote someone or '#' to add a header. Six header sizes exist from '#' to '######'")
        ]), "Quotes and headers")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.jB, 1, _List_fromArray([
            $author$project$Data$Notification$Plaintext("Resolved a number of incorrect behaviors around pasting content into and out of lists.")
        ]), "List issues")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.gp, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("Now, in your meeting notes you\u2019ll notice a new Workflow tab. Use !! in combination with #meeting name or @person name to send action items to upcoming meetings. Use ?? for items you want to discuss in the current meeting.")
        ]), "Introducing Workflow")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.gp, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("We have re-worked the column beside your meetings to make it easier to manage your workflow, view attendees, see related notes in a recurring meeting series and manage note attachments.")
        ]), "Updated meeting note design")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.go, 2, _List_fromArray([
            $author$project$Data$Notification$Plaintext("We've optimized how calendar events are loaded into the app. If you have a lot of events, you might notice up to 5x faster load times.")
        ]), "Improved load times")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.go, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("For those who like notes on the left side of the screen, but want to be looking as close to the camera as possible during video calls. Check this out in the "),
            $author$project$Data$Notification$Link({ jn: "settings page", dt: "/settings" }),
            $author$project$Data$Notification$Plaintext(".")
        ]), "Reversible note page columns")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.av, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("If you have your Google Calendar open all day, like we do, our new Chrome extension makes it easy to launch your Witful notes for each meeting right from your calendar event. Download it now from the "),
            $author$project$Data$Notification$Link({ jn: "Chrome Web Store", dt: "https://chrome.google.com/webstore/detail/witful/ajaichojcfflncoaihhaibcodjkbcpmn" }),
            $author$project$Data$Notification$Plaintext(".")
        ]), "Google Calendar Chrome extension")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.av, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("We've added new theme options to Witful! Check them out on the "),
            $author$project$Data$Notification$Link({ jn: "settings page", dt: "/settings" }),
            $author$project$Data$Notification$Plaintext(".")
        ]), "Themes")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.av, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("Every now and then a duplicate person may find their way into Witful. Witful will now auto-detect these duplicates based on similar names or email addresses and ask if you\u2019d like to merge them. The prompt to merge duplicates will display on the person page for a suspected duplicate.")
        ]), "Merge duplicate people")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.av, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("Now you can now easily add a person as an attendee to a meeting even if they don\u2019t exist in Witful. In a note, head to the Attendees list on the right and click the \u201Cadd attendees\u201D icon. Just type the name of the person you\u2019d like to add and click \u201CCreate a new person\u201D.")
        ]), "Add a new person to a meeting")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.av, 0, _List_fromArray([
            $author$project$Data$Notification$Plaintext("Action items can be hard to find inside of long notes. Now you can click on the text of an action item from the right hand context column beside a note, or from your home page, and find that text right away within the note when the text is briefly highlighted in purple.")
        ]), "Action item highlighting in notes")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.av, 1, _List_fromArray([
            $author$project$Data$Notification$Plaintext("Your scroll position is now properly reset when navigating through pages in the app.")
        ]), "Scroll position inconsistency")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.av, 1, _List_fromArray([
            $author$project$Data$Notification$Plaintext("We fixed an issue related to long email addresses that would cause visual layout problems in some situations.")
        ]), "Long email address issues")),
        (new $$Record154($author$project$Content$NotificationArea$batchId.av, 1, _List_fromArray([
            $author$project$Data$Notification$Plaintext("Some users experienced issues where a calendar event description would disappear if the attendee list was edited before editing the note body. This now behaves properly.")
        ]), "Disappearing calendar event description"))
    ]);
    var $author$project$Data$Settings$notificationBatchFirstSeen_a0 = $author$project$Data$Settings$get, $author$project$Data$Settings$notificationBatchFirstSeen_a1 = function ($) {
        return $.c5;
    }, $author$project$Data$Settings$notificationBatchFirstSeen = A2($elm$core$Basics$composeR, $author$project$Data$Settings$notificationBatchFirstSeen_a0, $author$project$Data$Settings$notificationBatchFirstSeen_a1);
    var $author$project$View$NotificationArea$viewCategoryBadge_fn = function (palette, category) {
        var _v0 = function () {
            switch (category) {
                case 0:
                    return _Utils_Tuple3(palette.d1, palette.dZ, "NEW FEATURE");
                case 1:
                    return _Utils_Tuple3(palette.er, palette.en, "BUG FIX");
                case 2:
                    return _Utils_Tuple3(palette.ba, palette.a3, "ANNOUNCEMENT");
                default:
                    return _Utils_Tuple3(palette.dC, palette.dA, "REFINEMENT");
            }
        }();
        var fontColor = _v0.a;
        var bgColor = _v0.b;
        var string = _v0.c;
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color(fontColor),
            $mdgriffith$elm_ui$Element$Background$color(bgColor),
            $mdgriffith$elm_ui$Element$Border$rounded(10),
            $mdgriffith$elm_ui$Element$paddingXY_fn(20, 3),
            $mdgriffith$elm_ui$Element$Font$size(12)
        ]), $mdgriffith$elm_ui$Element$text(string));
    }, $author$project$View$NotificationArea$viewCategoryBadge = F2($author$project$View$NotificationArea$viewCategoryBadge_fn);
    var $author$project$View$NotificationArea$viewNotification_fn = function (palette, today, notificationBatchFirstSeen, notification) {
        var firstSeen = $elm$core$Dict$get_fn(notification.g, notificationBatchFirstSeen);
        var showNewIndicator = function () {
            if (!firstSeen.$) {
                var date = firstSeen.a;
                return $justinmimbs$date$Date$diff_fn(3, date, today) <= 1;
            }
            else {
                return true;
            }
        }();
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$padding(15),
            $mdgriffith$elm_ui$Element$spacing(8)
        ]), _List_fromArray([
            $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([
                $author$project$View$NotificationArea$viewCategoryBadge_fn(palette, notification.e1),
                $author$project$View$Util$when_fn(showNewIndicator, $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(palette.d1),
                    $mdgriffith$elm_ui$Element$Font$italic,
                    $mdgriffith$elm_ui$Element$paddingXY_fn(10, 3),
                    $mdgriffith$elm_ui$Element$Font$size(12)
                ]), $mdgriffith$elm_ui$Element$text("New arrival!")))
            ])),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$bold,
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$Font$color(palette.cd)
            ]), $mdgriffith$elm_ui$Element$text(notification.gj)),
            $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$spacing(5),
                $mdgriffith$elm_ui$Element$Font$size(15)
            ]), $elm$core$List$map_fn(function (descriptionText) {
                switch (descriptionText.$) {
                    case 0:
                        var str = descriptionText.a;
                        return $mdgriffith$elm_ui$Element$text(str);
                    case 1:
                        var str = descriptionText.a;
                        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                            $mdgriffith$elm_ui$Element$Background$color(palette.dA),
                            $mdgriffith$elm_ui$Element$Font$color(palette.dC),
                            $mdgriffith$elm_ui$Element$paddingXY_fn(3, 0),
                            $mdgriffith$elm_ui$Element$Border$rounded(4)
                        ]), $mdgriffith$elm_ui$Element$text(str));
                    default:
                        var linkInfo = descriptionText.a;
                        return A2(_String_startsWith_fn("/", linkInfo.dt) ? $mdgriffith$elm_ui$Element$link : $mdgriffith$elm_ui$Element$newTabLink, _List_fromArray([
                            $mdgriffith$elm_ui$Element$Font$color(palette.a6),
                            $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                                $mdgriffith$elm_ui$Element$Font$color(palette.a4)
                            ]))
                        ]), {
                            fF: $mdgriffith$elm_ui$Element$text(linkInfo.jn),
                            dt: linkInfo.dt
                        });
                }
            }, notification.fc))
        ]));
    }, $author$project$View$NotificationArea$viewNotification = F4($author$project$View$NotificationArea$viewNotification_fn);
    var $author$project$View$NotificationArea$view_fn = function (env, notifications) {
        var today = $justinmimbs$date$Date$fromPosix_fn(env.pu, env.k5);
        var notificationBatchFirstSeen = $elm$core$Basics$composeR_fn($author$project$Data$Settings$notificationBatchFirstSeen_a0, $author$project$Data$Settings$notificationBatchFirstSeen_a1, env);
        return $mdgriffith$elm_ui$Element$column_fn(_List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(380)), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$maximum_fn(500, $mdgriffith$elm_ui$Element$shrink)), _List_Cons($mdgriffith$elm_ui$Element$scrollbarY, _List_Cons($author$project$View$Styling$showScrollbar, $author$project$View$ProfileMenu$overlayAreaAttrs(env.nI))))), $elm$core$List$isEmpty(notifications) ? _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$padding(20),
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$Font$italic
            ]), $mdgriffith$elm_ui$Element$text("No recent updates. Check back soon!"))
        ]) : $elm$core$List$map_fn(A3($author$project$View$NotificationArea$viewNotification, env.nI, today, notificationBatchFirstSeen), notifications));
    }, $author$project$View$NotificationArea$view = F2($author$project$View$NotificationArea$view_fn);
    var $author$project$View$Header$notificationArea = function (env) {
        return $author$project$View$Util$whenJust_fn(env.pV, $elm$core$Basics$always($author$project$View$Util$when_fn(env.nq, $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$alignRight,
            $mdgriffith$elm_ui$Element$moveDown(45),
            $mdgriffith$elm_ui$Element$moveLeft(10),
            $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, $author$project$View$Config$zIndices.nR)
        ]), $author$project$View$NotificationArea$view_fn(env, $author$project$Content$NotificationArea$latestNotifications)))));
    };
    var $author$project$View$Header$notificationBell = function (env) {
        var today = $justinmimbs$date$Date$fromPosix_fn(env.pu, env.k5);
        var seenBatches = $elm$core$Basics$composeR_fn($author$project$Data$Settings$notificationBatchFirstSeen_a0, $author$project$Data$Settings$notificationBatchFirstSeen_a1, env);
        var unseenBatchIds = $elm$core$Set$filter_fn(function (batchId) {
            return $elm_community$maybe_extra$Maybe$Extra$isNothing($elm$core$Dict$get_fn(batchId, seenBatches));
        }, $elm$core$Set$fromList($elm$core$List$map_fn(function ($) {
            return $.g;
        }, $author$project$Content$NotificationArea$latestNotifications)));
        var unseenMarkedAsSeen = $elm$core$Dict$fromList($elm$core$List$map_fn(function (id) {
            return _Utils_Tuple2(id, today);
        }, $elm$core$Set$toList(unseenBatchIds)));
        var hasUnreadNotifications = !$elm$core$Set$isEmpty(unseenBatchIds);
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
            $mdgriffith$elm_ui$Element$alignRight,
            $author$project$View$Util$attrWhen_fn(hasUnreadNotifications, $mdgriffith$elm_ui$Element$inFront($mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(env.nI.dF),
                $mdgriffith$elm_ui$Element$Border$rounded(99),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(9)),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(9)),
                $mdgriffith$elm_ui$Element$moveDown(14),
                $mdgriffith$elm_ui$Element$moveRight(23)
            ]), $mdgriffith$elm_ui$Element$none))),
            $mdgriffith$elm_ui$Element$inFront($author$project$View$Header$notificationArea(env))
        ]), A4($author$project$View$Tooltip$basic, env.nI, 0, "What's new", $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
            kb: "What's new",
            hp: _List_fromArray([
                $author$project$View$Header$mTabIndex_fn($author$project$View$Header$mDisableTabbing_a0, env),
                $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn(hasUnreadNotifications, env.nI.a6, env.nI.aQ))
            ]),
            fQ: $elm$core$Maybe$Just($author$project$Model$ManyMsgs(_List_fromArray([
                $author$project$Model$NotificationAreaOpen(!env.nq),
                $author$project$Model$HandleBacktalk($author$project$Env$AnalyticsEvent($author$project$Analytics$NotificationAreaOpen)),
                $author$project$Model$HandleBacktalk($author$project$Env$UpdateSettings(function (settings) {
                    return $$update__c5(settings, $elm$core$Dict$union_fn(unseenMarkedAsSeen, settings.c5));
                }))
            ])))
        }, 1, "bell")));
    };
    var $author$project$View$Header$standardHeader = function (env) {
        var verticalSeparatorLine = $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(5))
            ]), $mdgriffith$elm_ui$Element$none),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(1)),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(20)),
                $mdgriffith$elm_ui$Element$Background$color(env.nI.aO)
            ]), $mdgriffith$elm_ui$Element$none),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(5))
            ]), $mdgriffith$elm_ui$Element$none)
        ]));
        var searchIcon = A4($author$project$View$Shortcut$tooltip, env.nI, 0, $author$project$Data$Shortcut$keys.f0, $author$project$View$Icon$buttonWithSize_fn($author$project$View$Icon$button_a0, {
            kb: "Search",
            hp: _List_fromArray([
                $author$project$View$Header$mTabIndex_fn($author$project$View$Header$mDisableTabbing_a0, env),
                $mdgriffith$elm_ui$Element$Font$color(env.nI.aR),
                $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$color(env.nI.a2)
                ]))
            ]),
            fQ: $elm$core$Maybe$Just($author$project$Model$HandleBacktalk($author$project$Env$Tantrum(_List_fromArray([
                $author$project$Env$ShowSearch(true),
                $author$project$Env$AnalyticsEvent($author$project$Analytics$SearchBarOpen)
            ]))))
        }, 3, "search"));
        var pageIcon = function (route) {
            var isActive = function () {
                var _v2 = _Utils_Tuple2(route, env.oe);
                _v2$3: while (true) {
                    switch (_v2.a.$) {
                        case 10:
                            if (_v2.b.$ === 10) {
                                return true;
                            }
                            else {
                                break _v2$3;
                            }
                        case 0:
                            if (!_v2.b.$) {
                                return true;
                            }
                            else {
                                break _v2$3;
                            }
                        case 1:
                            if (_v2.b.$ === 1) {
                                return true;
                            }
                            else {
                                break _v2$3;
                            }
                        default:
                            break _v2$3;
                    }
                }
                return false;
            }();
            var activeUnderline = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Background$color(env.nI.a2),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(2)),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px(22)),
                $mdgriffith$elm_ui$Element$centerX,
                $mdgriffith$elm_ui$Element$moveUp(7)
            ]), $mdgriffith$elm_ui$Element$none);
            var _v0 = function () {
                switch (route.$) {
                    case 10:
                        return _Utils_Tuple3("Calendar", "calendar-week", $author$project$Data$Shortcut$keys.gV);
                    case 0:
                        return _Utils_Tuple3("Day", "calendar-star", $author$project$Data$Shortcut$keys.hJ);
                    case 1:
                        return _Utils_Tuple3("Threads", "tasks", $author$project$Data$Shortcut$keys.po);
                    default:
                        return _Utils_Tuple3("No other pages supported", "bug", $author$project$Data$Shortcut$keys.hk);
                }
            }();
            var ariaLabel = _v0.a;
            var icon = _v0.b;
            var shortcutKey = _v0.c;
            return A4($author$project$View$Shortcut$tooltip, env.nI, 0, shortcutKey, $author$project$View$Icon$linkWithSize_fn($author$project$View$Icon$link_a0, {
                kb: ariaLabel,
                hp: _List_fromArray([
                    $author$project$View$Header$mTabIndex_fn($author$project$View$Header$mDisableTabbing_a0, env),
                    $mdgriffith$elm_ui$Element$Font$color($author$project$Util$Misc$if__fn(isActive, env.nI.a2, env.nI.aR)),
                    $mdgriffith$elm_ui$Element$below($author$project$View$Util$when_fn(isActive, activeUnderline)),
                    $mdgriffith$elm_ui$Element$mouseOver(_List_fromArray([
                        $mdgriffith$elm_ui$Element$Font$color(env.nI.a2)
                    ]))
                ])
            }, 1, icon, $author$project$Routing$pathFromRoute(route)));
        };
        var newNoteIcon = A4($author$project$View$Shortcut$tooltip, env.nI, 0, $author$project$Data$Shortcut$keys.jV, $author$project$View$Icon$linkWithSize_fn($author$project$View$Icon$link_a0, {
            kb: "New Note",
            hp: _List_fromArray([
                $author$project$View$Header$mTabIndex_fn($author$project$View$Header$mDisableTabbing_a0, env),
                $mdgriffith$elm_ui$Element$Font$color(env.nI.aR)
            ])
        }, 1, "file-medical", $author$project$Routing$pathFromRoute($author$project$Routing$RouteCreateAdHocNote($elm$core$Maybe$Nothing))));
        var isMobile = $author$project$View$Responsive$isMobile_fn($author$project$View$Layout$breakpoints, env.p1);
        var isDoubleColumned = $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, env.p1);
        return $mdgriffith$elm_ui$Element$row_fn(_List_Cons($mdgriffith$elm_ui$Element$inFront($author$project$View$Header$profileMenu(env)), $author$project$View$Header$innerHeaderAttrs), _List_fromArray([
            $mdgriffith$elm_ui$Element$link_fn(_List_Nil, {
                fF: $author$project$View$Widgets$witfulIcon_fn(env.nI, 35),
                dt: $author$project$Routing$pathFromRoute($author$project$Routing$RouteHome($elm$core$Maybe$Nothing))
            }),
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(env.nI.a8)
            ]), _List_fromArray([
                pageIcon($author$project$Routing$RouteHome($elm$core$Maybe$Nothing)),
                $author$project$View$Util$when_fn(!isMobile, pageIcon($author$project$Routing$RouteCalendar($elm$core$Maybe$Nothing))),
                pageIcon($author$project$Routing$RouteThreads($author$project$Routing$defaultThreadsParams)),
                searchIcon,
                verticalSeparatorLine,
                newNoteIcon
            ])),
            $author$project$View$Header$nextMeetingInfo(env),
            $author$project$View$Util$when_fn(isDoubleColumned, $author$project$View$Header$notificationBell(env)),
            $author$project$View$Util$whenJust_fn(env.pV, $author$project$View$Header$profileButton(env))
        ]));
    };
    var $author$project$Search$Bar$barWidth = function (mode) {
        switch (mode) {
            case 0:
                return 700;
            case 1:
                return 500;
            default:
                return 370;
        }
    };
    var $author$project$Search$Bar$breakpoints = { m6: 550, oD: 730 };
    var $author$project$Search$Bar$itemPadding = 15;
    var $mdgriffith$elm_ui$Element$Lazy$apply4_fn = function (fn, a, b, c, d) {
        return $mdgriffith$elm_ui$Element$Lazy$embed(A4(fn, a, b, c, d));
    }, $mdgriffith$elm_ui$Element$Lazy$apply4_fn_unwrapped = function (fn, a, b, c, d) {
        return $mdgriffith$elm_ui$Element$Lazy$embed(fn(a, b, c, d));
    }, $mdgriffith$elm_ui$Element$Lazy$apply4 = F5($mdgriffith$elm_ui$Element$Lazy$apply4_fn);
    var $elm$virtual_dom$VirtualDom$lazy6 = _VirtualDom_lazy6;
    var $mdgriffith$elm_ui$Element$Lazy$lazy4_fn = function (fn, a, b, c, d) {
        return $mdgriffith$elm_ui$Internal$Model$Unstyled(A6($elm$virtual_dom$VirtualDom$lazy6, $mdgriffith$elm_ui$Element$Lazy$apply4, fn, a, b, c, d));
    }, $mdgriffith$elm_ui$Element$Lazy$lazy4 = F5($mdgriffith$elm_ui$Element$Lazy$lazy4_fn);
    var $author$project$Search$Result$toCollations = function (_v0) {
        var items = _v0.mA;
        return $elm$core$List$filterMap_fn(function (_v1) {
            var k = _v1.a;
            var v = _v1.b;
            if (v.$ === 4) {
                var doc = v.a;
                return $elm$core$Maybe$Just(_Utils_Tuple2(k, doc));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, $elm$core$Dict$toList(items));
    };
    var $author$project$Search$Result$toEvents = function (_v0) {
        var items = _v0.mA;
        return $elm$core$List$filterMap_fn(function (_v1) {
            var k = _v1.a;
            var v = _v1.b;
            if (v.$ === 3) {
                var doc = v.a;
                return $elm$core$Maybe$Just(_Utils_Tuple2(k, doc));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, $elm$core$Dict$toList(items));
    };
    var $author$project$Search$Bar$viewAllResultsItem_fn = function (searchQuery, palette, _v0, stringQuery, _v1) {
        var innerText = $author$project$Search$Query$isEmpty(searchQuery) ? _List_fromArray([
            $mdgriffith$elm_ui$Element$text("Hit "),
            A3($author$project$View$ActionItems$mentionChip, palette, true, "Enter"),
            $mdgriffith$elm_ui$Element$text("to see all notes, people, attachments, etc.")
        ]) : ($elm$core$String$isEmpty(stringQuery) ? _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_Nil, $mdgriffith$elm_ui$Element$text("Search notes, files and more"))
        ]) : _List_fromArray([
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.aT),
                $mdgriffith$elm_ui$Element$Font$bold
            ]), $mdgriffith$elm_ui$Element$text($elm_community$string_extra$String$Extra$ellipsis_fn(70, stringQuery))),
            $mdgriffith$elm_ui$Element$text(" - "),
            $mdgriffith$elm_ui$Element$text("Search notes, files and more")
        ]));
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$clipX,
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$Search$Bar$itemHeight + 5)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$spacing(14),
            $mdgriffith$elm_ui$Element$moveLeft(2)
        ]), _List_fromArray([
            $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$color(palette.aR),
                $mdgriffith$elm_ui$Element$Font$size(15)
            ]), 1, "search"),
            $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$spacing(3),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
            ]), innerText)
        ]));
    }, $author$project$Search$Bar$viewAllResultsItem = F5($author$project$Search$Bar$viewAllResultsItem_fn);
    var $author$project$Search$Bar$viewCollationItem_fn = function (_v0, _v1, _v2, _v3) {
        var doc = _v3.ll;
        if (doc.$ === 2) {
            var domainName = doc.a.g9;
            return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$Search$Bar$itemHeight))
            ]), _List_fromArray([
                $mdgriffith$elm_ui$Element$text("All notes with "),
                $mdgriffith$elm_ui$Element$text(domainName)
            ]));
        }
        else {
            return $mdgriffith$elm_ui$Element$none;
        }
    }, $author$project$Search$Bar$viewCollationItem = F4($author$project$Search$Bar$viewCollationItem_fn);
    var $author$project$Search$Bar$viewEventItem_fn = function (timezoneUser, palette, _v0, stringQuery, _v1) {
        var doc = _v1.ll;
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$Search$Bar$itemHeight))
        ]), _List_fromArray([
            A3($author$project$Search$Bar$viewHighlight, palette, _List_fromArray([
                $author$project$View$Styling$paddingRight(12)
            ]), $author$project$Lib$Highlighter$ellipsisAfter_fn(25, $author$project$Lib$Highlighter$find_fn(stringQuery, doc.gj))),
            $author$project$Search$Bar$viewMonthAndDay_fn(timezoneUser, doc.oN)
        ]));
    }, $author$project$Search$Bar$viewEventItem = F5($author$project$Search$Bar$viewEventItem_fn);
    var $author$project$Search$Bar$SetFocusItem = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Search$Bar$preventBlurringOnMousedown = $mdgriffith$elm_ui$Element$htmlAttribute($elm$html$Html$Events$preventDefaultOn_fn("mousedown", $elm$json$Json$Decode$succeed(_Utils_Tuple2($author$project$Search$Bar$NoOp("mousedown prevent blur"), true))));
    var $author$project$Search$Bar$viewItem_fn = function (focusColor, model, itemViewer, _v0) {
        var index = _v0.a;
        var item = _v0.b;
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$pointer,
            $mdgriffith$elm_ui$Element$paddingXY_fn($author$project$Search$Bar$itemPadding, 0),
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onMouseEnter_a0, $mdgriffith$elm_ui$Element$Events$onMouseEnter_a1, $author$project$Search$Bar$SetFocusItem($elm$core$Maybe$Just(index))),
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onMouseLeave_a0, $mdgriffith$elm_ui$Element$Events$onMouseLeave_a1, $author$project$Search$Bar$SetFocusItem($elm$core$Maybe$Nothing)),
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Search$Bar$RouteToItem(index)),
            $author$project$Search$Bar$preventBlurringOnMousedown,
            $author$project$View$Util$attrWhen_fn(_Utils_eq(model.z, $elm$core$Maybe$Just(index)), $mdgriffith$elm_ui$Element$Background$color(focusColor))
        ]), itemViewer(item));
    }, $author$project$Search$Bar$viewItem = F4($author$project$Search$Bar$viewItem_fn);
    var $author$project$Search$Bar$resultList_fn = function (palette, timezoneUser, responsiveMode, model) {
        var query = $author$project$Search$Result$query(model.p);
        var stringQuery = $elm$core$Basics$composeR_fn($author$project$Search$Query$stringQuery_a0, $author$project$Search$Query$stringQuery_a1, query);
        var viewItemHelp = F2(function (focusColor, viewFn) {
            return A3($author$project$Search$Bar$viewItem, focusColor, model, A4($mdgriffith$elm_ui$Element$Lazy$lazy4, viewFn, palette, responsiveMode, stringQuery));
        }), viewItemHelp_unwrapped = function (viewFn) {
            return A2($author$project$Page$Search$viewItem, env.nI, viewFn(env.nI, responsiveMode, stringQuery));
        };
        var resultSections = _List_fromArray([
            _Utils_Tuple2("People", $elm$core$List$map_fn(A2(viewItemHelp, palette.a3, $author$project$Search$Bar$viewPersonItem), $author$project$Search$Result$toPeople(model.p))),
            _Utils_Tuple2("Notes", $elm$core$List$map_fn(A2(viewItemHelp, palette.a3, $author$project$Search$Bar$viewNoteItem(timezoneUser)), $author$project$Search$Result$toNotes(model.p))),
            _Utils_Tuple2("Attachments", $elm$core$List$map_fn(A2(viewItemHelp, palette.a3, A2($author$project$Search$Bar$viewAttachmentItem, timezoneUser, function (_v1) {
                return $author$project$Search$Bar$CloseSearchBar;
            })), $author$project$Search$Result$toAttachments(model.p))),
            _Utils_Tuple2("Events", $elm$core$List$map_fn(A2(viewItemHelp, palette.a3, $author$project$Search$Bar$viewEventItem(timezoneUser)), $author$project$Search$Result$toEvents(model.p))),
            _Utils_Tuple2("Domains", $elm$core$List$map_fn(A2(viewItemHelp, palette.a3, $author$project$Search$Bar$viewCollationItem), $author$project$Search$Result$toCollations(model.p)))
        ]);
        var viewAllResults = $author$project$Search$Bar$viewItem_fn(palette.aO, model, A4($author$project$Search$Bar$viewAllResultsItem, query, palette, responsiveMode, stringQuery), _Utils_Tuple2($author$project$Search$Bar$viewAllResultsIndex, 0));
        var noResultsText = $author$project$Util$Misc$if__fn($elm$core$String$isEmpty(stringQuery), "No results found", "No results found for \"" + (stringQuery + "\""));
        var noResults = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$paddingEach((new $$Record115(15, $author$project$Search$Bar$itemPadding, 0, 15))),
            $mdgriffith$elm_ui$Element$Font$color(palette.aR)
        ]), $mdgriffith$elm_ui$Element$text(noResultsText));
        var header = function (title) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$paddingEach((new $$Record115(5, $author$project$Search$Bar$itemPadding, 0, 15))),
                $mdgriffith$elm_ui$Element$Font$color(palette.aR)
            ]), $mdgriffith$elm_ui$Element$text(title));
        };
        var resultElements = $elm$core$List$concat($elm$core$List$intersperse_fn(_List_fromArray([
            $author$project$View$Util$horizontalLine_fn(palette, 2, _List_fromArray([
                $mdgriffith$elm_ui$Element$paddingXY_fn(0, 5)
            ]))
        ]), $elm$core$List$map_fn(function (_v0) {
            var name = _v0.a;
            var results = _v0.b;
            return _List_Cons(header(name), results);
        }, $elm$core$List$filter_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)), resultSections))));
        return $author$project$Search$Query$isEmpty(query) ? _List_fromArray([viewAllResults]) : ($author$project$Search$Result$isEmpty(model.p) ? _List_fromArray([noResults]) : _List_Cons(viewAllResults, _Utils_ap(resultElements, _List_fromArray([
            $author$project$View$Util$spacer(3)
        ]))));
    }, $author$project$Search$Bar$resultList = F4($author$project$Search$Bar$resultList_fn);
    var $author$project$Search$Bar$viewFilter_fn = function (env, filter) {
        var withStringDefault = F2(function (str, _default) {
            return $author$project$Util$Misc$if__fn($elm$core$String$isEmpty(str), _default, str);
        });
        switch (filter.$) {
            case 0:
                if (!filter.a.$) {
                    var _v1 = filter.a;
                    var eventId = _v1.b;
                    return $elm$core$Maybe$withDefault_fn($mdgriffith$elm_ui$Element$none, $elm$core$Maybe$map_fn(function (event) {
                        return $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([
                            $mdgriffith$elm_ui$Element$text("in:"),
                            $mdgriffith$elm_ui$Element$el_fn(_List_Cons($mdgriffith$elm_ui$Element$Background$color(env.nI.dA), _List_Cons($mdgriffith$elm_ui$Element$Font$color(env.nI.dC), $author$project$View$Widgets$baseChipAttrs)), $mdgriffith$elm_ui$Element$text("#" + A2(withStringDefault, event.gj, "(Untitled)")))
                        ]));
                    }, $elm$core$Dict$get_fn(eventId, env.lw)));
                }
                else {
                    var meetingSearch = filter.a.a;
                    return $mdgriffith$elm_ui$Element$text("in:" + meetingSearch);
                }
            case 1:
                if (!filter.a.$) {
                    var _v2 = filter.a;
                    var personId = _v2.b;
                    return $elm$core$Maybe$withDefault_fn($mdgriffith$elm_ui$Element$none, $elm$core$Maybe$map_fn(function (person) {
                        return $mdgriffith$elm_ui$Element$row_fn(_List_Nil, _List_fromArray([
                            $mdgriffith$elm_ui$Element$text("with:"),
                            $mdgriffith$elm_ui$Element$el_fn(_List_Cons($mdgriffith$elm_ui$Element$Background$color(env.nI.dA), _List_Cons($mdgriffith$elm_ui$Element$Font$color(env.nI.dC), $author$project$View$Widgets$baseChipAttrs)), $mdgriffith$elm_ui$Element$text("@" + A2(withStringDefault, person.b, "(No name)")))
                        ]));
                    }, $author$project$Firestore$Collection$get_fn(personId, env.iz)));
                }
                else {
                    var personSearch = filter.a.a;
                    return $mdgriffith$elm_ui$Element$text("with:" + personSearch);
                }
            case 2:
                var date = filter.a;
                return $mdgriffith$elm_ui$Element$text("before:" + $justinmimbs$date$Date$toIsoString(date));
            case 3:
                var date = filter.a;
                return $mdgriffith$elm_ui$Element$text("after:" + $justinmimbs$date$Date$toIsoString(date));
            case 4:
                var fileType = filter.a;
                return $mdgriffith$elm_ui$Element$text("file-type:" + $author$project$Search$Query$fileTypeToString(fileType));
            default:
                var string = filter.a;
                return $mdgriffith$elm_ui$Element$text(string);
        }
    }, $author$project$Search$Bar$viewFilter = F2($author$project$Search$Bar$viewFilter_fn);
    var $author$project$Search$Bar$viewSuggestion_fn = function (env, query) {
        return $mdgriffith$elm_ui$Element$row_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px($author$project$Search$Bar$itemHeight)),
            $mdgriffith$elm_ui$Element$spacing(2),
            $mdgriffith$elm_ui$Element$paddingEach($$update__mE($author$project$View$Styling$edges, 27))
        ]), $elm$core$List$map_fn($author$project$Search$Bar$viewFilter(env), query));
    }, $author$project$Search$Bar$viewSuggestion = F2($author$project$Search$Bar$viewSuggestion_fn);
    var $author$project$Search$Bar$dropbox_fn = function (env, responsiveMode, model, searchPageView) {
        var _v0 = model.gf;
        if (!_v0.$) {
            var suggestions = _v0.a;
            return $elm$core$List$singleton($mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$scrollbarX
            ]), $elm$core$List$map_fn(A3($author$project$Search$Bar$viewItem, env.nI.a3, model, $author$project$Search$Bar$viewSuggestion(env)), $elm$core$Dict$toList(suggestions))));
        }
        else {
            return searchPageView ? _List_Nil : $author$project$Search$Bar$resultList_fn(env.nI, env.pu, responsiveMode, model);
        }
    }, $author$project$Search$Bar$dropbox = F4($author$project$Search$Bar$dropbox_fn);
    var $author$project$Search$Bar$SearchbarQueryChangeEvent = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Search$Bar$EnterPressed = { $: 6 };
    var $author$project$Search$Bar$ItemDown = { $: 5 };
    var $author$project$Search$Bar$ItemUp = { $: 4 };
    var $author$project$Search$Bar$onKeydown = $elm$html$Html$Events$custom_fn("keydown", _Json_map1_fn(function (msg) {
        return { m_: msg, nU: true, oU: true };
    }, _Json_andThen_fn(function (event) {
        var _v0 = event.mC;
        switch (_v0) {
            case "ArrowUp":
                return $elm$json$Json$Decode$succeed($author$project$Search$Bar$ItemUp);
            case "ArrowDown":
                return $elm$json$Json$Decode$succeed($author$project$Search$Bar$ItemDown);
            case "Tab":
                return $elm$json$Json$Decode$succeed($author$project$Util$Misc$if__fn(event.ow, $author$project$Search$Bar$ItemUp, $author$project$Search$Bar$ItemDown));
            case "Enter":
                return $elm$json$Json$Decode$succeed($author$project$Search$Bar$EnterPressed);
            default:
                return $elm$json$Json$Decode$fail("matching keypress not found");
        }
    }, $author$project$Data$Keypress$decoder)));
    var $author$project$Search$Bar$onKeypress = $elm$html$Html$Events$stopPropagationOn_fn("keypress", $elm$json$Json$Decode$succeed(_Utils_Tuple2($author$project$Search$Bar$NoOp("searchbar keypress"), true)));
    var $author$project$Search$Bar$EscPressed = { $: 7 };
    var $author$project$Search$Bar$onKeyup = $elm$html$Html$Events$custom_fn("keyup", _Json_map1_fn(function (msg) {
        return { m_: msg, nU: true, oU: true };
    }, _Json_andThen_fn(function (event) {
        var _v0 = event.mC;
        if (_v0 === "Escape") {
            return $elm$json$Json$Decode$succeed($author$project$Search$Bar$EscPressed);
        }
        else {
            return $elm$json$Json$Decode$fail("matching keypress not found");
        }
    }, $author$project$Data$Keypress$decoder)));
    var $author$project$Search$Bar$searchFieldCustomElement_fn = function (theme, stringifiedQuery) {
        return $mdgriffith$elm_ui$Element$html(A3($elm$html$Html$node, "witful-searchbar", _List_fromArray([
            $elm$virtual_dom$VirtualDom$property_fn("searchbarQuery", $elm$json$Json$Encode$string(stringifiedQuery)),
            $elm$virtual_dom$VirtualDom$property_fn("palette", $elm$json$Json$Encode$string($author$project$Data$Color$stringifiedPaletteForTheme(theme))),
            $elm$html$Html$Events$on_fn("searchQueryChanged", _Json_map1_fn($author$project$Search$Bar$SearchbarQueryChangeEvent, _Json_decodeField_fn("detail", $elm$json$Json$Decode$value))),
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$id_a0, $author$project$Search$Bar$inputId),
            $author$project$Search$Bar$onKeydown,
            $author$project$Search$Bar$onKeyup,
            $author$project$Search$Bar$onKeypress
        ]), _List_Nil));
    }, $author$project$Search$Bar$searchFieldCustomElement = F2($author$project$Search$Bar$searchFieldCustomElement_fn);
    var $author$project$Search$Bar$searchIcon = function (palette) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$centerY,
            $mdgriffith$elm_ui$Element$moveRight(10),
            $mdgriffith$elm_ui$Element$Font$color(palette.aR)
        ]), $author$project$View$Icon$icon_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(15)
        ]), 1, "search"));
    };
    var $author$project$Search$Bar$searchField_fn = function (palette, model) {
        return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$paddingEach((new $$Record115(10, 38, 10, 10))),
            $mdgriffith$elm_ui$Element$inFront($author$project$Search$Bar$searchIcon(palette)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$px(50))
        ]), $mdgriffith$elm_ui$Element$Lazy$lazy2_fn($author$project$Search$Bar$searchFieldCustomElement, palette.pn, $elm$core$Basics$composeR_fn($author$project$Search$Query$encodeToString_a0, $author$project$Search$Query$encodeToString_a1, model.n$)));
    }, $author$project$Search$Bar$searchField = F2($author$project$Search$Bar$searchField_fn);
    var $author$project$Search$Bar$view_fn = function (env, model) {
        var responsiveMode = $author$project$View$Responsive$mode_fn($author$project$Search$Bar$breakpoints, env.p1);
        var onSearchPage = $author$project$Routing$isSearch(env.oe);
        var results = $author$project$Search$Bar$dropbox_fn(env, responsiveMode, model, onSearchPage);
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$clip,
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$px($author$project$Search$Bar$barWidth(responsiveMode))),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.dw),
            $mdgriffith$elm_ui$Element$Border$rounded(3),
            $mdgriffith$elm_ui$Element$Border$shadow({
                kp: 4,
                kS: $mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.2),
                nt: _Utils_Tuple2(0, 0),
                oE: 3
            })
        ]), _List_Cons($author$project$Search$Bar$searchField_fn(env.nI, model), results));
    }, $author$project$Search$Bar$view = F2($author$project$Search$Bar$view_fn);
    var $author$project$View$Alerts$alertElementAttrs = _List_fromArray([
        $author$project$View$Util$style_fn("grid-column", "1 / 1"),
        $author$project$View$Util$style_fn("grid-row", "1 / 1"),
        $author$project$View$Util$style_fn("height", "100%"),
        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
        $mdgriffith$elm_ui$Element$padding(10)
    ]);
    var $author$project$View$Alerts$linkCalendarAlertHelp_fn = function (palette, user) {
        return $author$project$View$Util$when_fn(!user.kB, $mdgriffith$elm_ui$Element$el_fn(_Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$Background$color(palette.ep)
        ]), $author$project$View$Alerts$alertElementAttrs), $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]), $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size(16),
            $mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.8)),
            $mdgriffith$elm_ui$Element$pointer,
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Model$HandleBacktalk($author$project$Env$LinkCalendar)),
            $mdgriffith$elm_ui$Element$Font$center
        ]), _List_fromArray([
            $author$project$View$Icon$icon_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0)
            ]), 2, "calendar-star"),
            $mdgriffith$elm_ui$Element$text("Witful works best when you "),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$underline,
                $mdgriffith$elm_ui$Element$mouseOver(_List_Nil)
            ]), $mdgriffith$elm_ui$Element$text("connect your calendar."))
        ])))));
    }, $author$project$View$Alerts$linkCalendarAlertHelp = F2($author$project$View$Alerts$linkCalendarAlertHelp_fn);
    var $author$project$View$Alerts$linkCalendarAlert_fn = function (env, user) {
        return $mdgriffith$elm_ui$Element$Lazy$lazy2_fn($author$project$View$Alerts$linkCalendarAlertHelp, env.nI, user);
    }, $author$project$View$Alerts$linkCalendarAlert = F2($author$project$View$Alerts$linkCalendarAlert_fn);
    var $author$project$View$Alerts$linkWorkAccountAlertHelp_fn = function (palette, currentMinute, user, events) {
        var singleAndMasterEventCount = function (_v4) {
            return $elm$core$Dict$foldl_fn_unwrapped(function (_v1, _v2, acc) {
                var tipe = _v2.pv;
                switch (tipe.$) {
                    case 0:
                        return acc + 1;
                    case 1:
                        return acc + 1;
                    default:
                        return acc;
                }
            }, 0, events);
        };
        var isGmailUser = _String_endsWith_fn("@gmail.com", user.cS);
        var dismissedOverAWeekAgo = function (dismissedAt) {
            return function (weeksAgo) {
                return weeksAgo > 1;
            }($elm$core$Basics$abs($justinmimbs$time_extra$Time$Extra$diff_fn(3, $elm$time$Time$utc, currentMinute, dismissedAt)));
        };
        var dismissButton = function (showDismissForever) {
            return $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Border$width(1),
                $mdgriffith$elm_ui$Element$Border$color(palette.aR),
                $mdgriffith$elm_ui$Element$Font$color(palette.aT),
                $mdgriffith$elm_ui$Element$paddingXY_fn(5, 4),
                $mdgriffith$elm_ui$Element$Font$size(12),
                $mdgriffith$elm_ui$Element$Border$rounded(5),
                $mdgriffith$elm_ui$Element$alignRight,
                $mdgriffith$elm_ui$Element$moveDown(2),
                $mdgriffith$elm_ui$Element$pointer,
                $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Model$SetLinkWorkAccountStatus($author$project$Util$Misc$if__fn(showDismissForever, $author$project$Data$User$DismissedForever, $author$project$Data$User$Dismissed(currentMinute))))
            ]), $mdgriffith$elm_ui$Element$text($author$project$Util$Misc$if__fn(showDismissForever, "Dismiss forever", "Dismiss")));
        };
        var alertElement = function (showIgnoreForever) {
            return $author$project$View$Util$when_fn(isGmailUser && (singleAndMasterEventCount(0) <= 10), $mdgriffith$elm_ui$Element$el_fn(_List_Cons($mdgriffith$elm_ui$Element$Background$color(palette.eV(1)), $author$project$View$Alerts$alertElementAttrs), $mdgriffith$elm_ui$Element$paragraph_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$Font$size(16),
                $mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$rgba255_fn($author$project$Data$Color$grayAlpha_a0, $author$project$Data$Color$grayAlpha_a1, $author$project$Data$Color$grayAlpha_a2, 0.8)),
                $mdgriffith$elm_ui$Element$Font$center,
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$centerY
            ]), _List_fromArray([
                $author$project$View$Icon$icon_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$paddingXY_fn(10, 0)
                ]), 2, "calendar-star"),
                $mdgriffith$elm_ui$Element$text("Witful is designed for work. It's fast and easy to "),
                $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                    $mdgriffith$elm_ui$Element$Font$underline,
                    $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, $author$project$Model$HandleBacktalk($author$project$Env$AddLinkedAccount)),
                    $mdgriffith$elm_ui$Element$pointer
                ]), $mdgriffith$elm_ui$Element$text("switch to your work account.")),
                dismissButton(showIgnoreForever)
            ]))));
        };
        var _v0 = user.gB.mH;
        switch (_v0.$) {
            case 0:
                return $mdgriffith$elm_ui$Element$none;
            case 1:
                return alertElement(false);
            case 2:
                var dismissedAt = _v0.a;
                return $author$project$View$Util$when_fn(dismissedOverAWeekAgo(dismissedAt), alertElement(true));
            default:
                return $mdgriffith$elm_ui$Element$none;
        }
    }, $author$project$View$Alerts$linkWorkAccountAlertHelp = F4($author$project$View$Alerts$linkWorkAccountAlertHelp_fn);
    var $author$project$View$Alerts$linkWorkAccountAlert_fn = function (env, user) {
        return $mdgriffith$elm_ui$Element$Lazy$lazy4_fn($author$project$View$Alerts$linkWorkAccountAlertHelp, env.nI, env.k5, user, env.lw);
    }, $author$project$View$Alerts$linkWorkAccountAlert = F2($author$project$View$Alerts$linkWorkAccountAlert_fn);
    var $author$project$View$Alerts$alertElements_fn = function (env, user) {
        return _List_fromArray([
            $author$project$View$Alerts$linkWorkAccountAlert_fn(env, user),
            $author$project$View$Alerts$linkCalendarAlert_fn(env, user)
        ]);
    }, $author$project$View$Alerts$alertElements = F2($author$project$View$Alerts$alertElements_fn);
    var $author$project$View$Alerts$viewHelp_fn = function (env, user) {
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $author$project$View$Util$style_fn("display", "grid"),
            $author$project$View$Util$style_fn("place-items", "center"),
            $author$project$View$Util$style_fn("grid-template", "1fr / 1fr"),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), $author$project$View$Alerts$alertElements_fn(env, user));
    }, $author$project$View$Alerts$viewHelp = F2($author$project$View$Alerts$viewHelp_fn);
    var $author$project$View$Alerts$view = function (env) {
        var _v0 = _Utils_Tuple2(env.pV, env.oe);
        if (_v0.a.$ === 1) {
            var _v1 = _v0.a;
            return $mdgriffith$elm_ui$Element$none;
        }
        else {
            if (_v0.b.$ === 13) {
                return $mdgriffith$elm_ui$Element$none;
            }
            else {
                var user = _v0.a.a;
                return $author$project$View$Alerts$viewHelp_fn(env, user);
            }
        }
    };
    var $author$project$View$Header$withAlerts_fn = function (env, headerEl) {
        return $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), _List_fromArray([
            $author$project$View$Alerts$view(env),
            headerEl
        ]));
    }, $author$project$View$Header$withAlerts = F2($author$project$View$Header$withAlerts_fn);
    var $author$project$View$Header$view_fn = function (searchbar, env) {
        var searchHeader = $mdgriffith$elm_ui$Internal$Model$map_fn($author$project$Model$SearchbarMsg, $author$project$Search$Bar$view_fn(env, searchbar));
        var isMobile = _Utils_cmp(env.p1.p1.jJ, $author$project$View$Header$mobileBreakpoint) < 1;
        var isDoubleColumned = $author$project$View$Responsive$isDoubleColumned_fn($author$project$View$Layout$breakpoints, env.p1);
        var signupHeaderAttrs = $author$project$Util$Misc$if__fn(isDoubleColumned, $author$project$View$Header$onboardingDoubleColumnHeaderAttrs, $author$project$View$Header$outerHeaderAttrs);
        var headerView = $author$project$Routing$isSearch(env.oe) ? $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$inFront($mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$moveDown(100),
                $mdgriffith$elm_ui$Element$centerX,
                $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, $author$project$View$Config$zIndices.h7)
            ]), searchHeader)),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
        ]), $author$project$View$Header$standardHeader(env)) : (env.oz ? $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $elm$core$Basics$composeL_fn($author$project$View$Util$zIndex_a0, $author$project$View$Util$zIndex_a1, $author$project$View$Config$zIndices.nR),
            $mdgriffith$elm_ui$Element$centerX,
            $mdgriffith$elm_ui$Element$moveDown(10)
        ]), searchHeader) : $author$project$View$Header$standardHeader(env));
        return $author$project$Routing$isSignup(env.oe) ? $mdgriffith$elm_ui$Element$el_fn(A2(signupHeaderAttrs, env.nI, isMobile), $author$project$View$Header$onboardingHeader(env)) : $author$project$View$Header$withAlerts_fn(env, $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$Border$widthEach($$update__pE($author$project$View$Styling$edges, 5)),
            $mdgriffith$elm_ui$Element$Border$color(env.nI.a2),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
        ]), $mdgriffith$elm_ui$Element$el_fn($author$project$View$Header$outerHeaderAttrs_fn(env.nI, isMobile), headerView)));
    }, $author$project$View$Header$view = F2($author$project$View$Header$view_fn);
    var $author$project$View$withHeader_fn = function (model, contentPaneView) {
        var page = model.ix;
        var env = model.dW;
        var searchbar = model.f0;
        var viewWithoutHeader = $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
        ]), contentPaneView);
        var viewWithHeader = $mdgriffith$elm_ui$Element$column_fn(_List_fromArray([
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$inFront($author$project$View$Mask$view(model))
        ]), _List_fromArray([
            $author$project$View$Header$view_fn(searchbar, env),
            $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                $mdgriffith$elm_ui$Element$scrollbarX,
                $mdgriffith$elm_ui$Element$clipY
            ]), contentPaneView)
        ]));
        if (page.$ === 4) {
            var subModel = page.b;
            return $author$project$Page$Note$isZenMode(subModel) ? viewWithoutHeader : viewWithHeader;
        }
        else {
            return $author$project$Routing$isAuth(env.oe) ? viewWithoutHeader : viewWithHeader;
        }
    }, $author$project$View$withHeader = F2($author$project$View$withHeader_fn);
    var $author$project$View$body = function (model) {
        var env = model.dW;
        var maskIsShown = !_Utils_eq($author$project$View$Mask$view(model), $mdgriffith$elm_ui$Element$none);
        var mCurrentDialog = $author$project$View$Dialog$highestPriority(model);
        return $mdgriffith$elm_ui$Element$layoutWith_fn($author$project$View$Styling$options, _Utils_ap($author$project$View$Styling$global(env.nI), _List_fromArray([
            $mdgriffith$elm_ui$Element$inFront($elm$core$Maybe$withDefault_fn($mdgriffith$elm_ui$Element$none, $elm$core$Maybe$map_fn($author$project$View$Dialog$BaseDialog$view(model.dW.nI), mCurrentDialog))),
            $mdgriffith$elm_ui$Element$inFront($author$project$View$Util$when_fn($elm_community$maybe_extra$Maybe$Extra$isNothing(mCurrentDialog), $mdgriffith$elm_ui$Internal$Model$map_fn(A2($elm$core$Basics$composeR, $author$project$Env$ImageViewerMsg, $author$project$Model$HandleBacktalk), $mdgriffith$elm_ui$Element$Lazy$lazy2_fn($author$project$View$ImageViewer$view_a0, env.p1, env.ft)))),
            $mdgriffith$elm_ui$Element$inFront($mdgriffith$elm_ui$Internal$Model$map_fn(A2($elm$core$Basics$composeR, $author$project$Env$SnackbarMsg, $author$project$Model$HandleBacktalk), $author$project$Lib$Snackbar$view_fn(env.nI, model.dW.dj))),
            $mdgriffith$elm_ui$Element$inFront($author$project$View$Util$when_fn($author$project$View$HelpMenu$shouldShow(env) && ((env.lY || (!maskIsShown)) && $elm_community$maybe_extra$Maybe$Extra$isNothing(mCurrentDialog)), $author$project$View$HelpMenu$view(env))),
            $mdgriffith$elm_ui$Element$inFront($mdgriffith$elm_ui$Element$el_fn(_List_fromArray([
                $mdgriffith$elm_ui$Element$alignRight,
                $mdgriffith$elm_ui$Element$alignBottom,
                $mdgriffith$elm_ui$Element$moveLeft(30),
                $mdgriffith$elm_ui$Element$moveUp(30)
            ]), $author$project$View$NextMeetingNudger$view(env))),
            $mdgriffith$elm_ui$Element$Background$color(env.nI.dw),
            $author$project$View$URLRequest$eventListener(env.mM)
        ])), $author$project$View$EmptyState$isActive(env) ? $author$project$View$withHeader_fn(model, $mdgriffith$elm_ui$Internal$Model$map_fn(A2($elm$core$Basics$composeR, $author$project$Model$HomeMsg, $author$project$Model$HandlePageMsg), $author$project$Page$Home$view_fn(env, $author$project$Page$Home$init_fn(env, $elm$core$Maybe$Nothing)))) : ((!env.pX) ? $mdgriffith$elm_ui$Element$el_fn(_List_fromArray([$mdgriffith$elm_ui$Element$centerY, $mdgriffith$elm_ui$Element$centerX]), $author$project$View$Widgets$loadingAnimation) : $author$project$View$withHeader_fn(model, $mdgriffith$elm_ui$Element$Lazy$lazy2_fn($author$project$View$mainView, model.ix, model.dW))));
    };
    var $author$project$View$loadingOrNotFound_fn = function (_v0, entityName) {
        var loadState = _v0.mK;
        return $author$project$Data$App$isLoading(loadState) ? "Loading..." : (entityName + " Not Found");
    }, $author$project$View$loadingOrNotFound = F2($author$project$View$loadingOrNotFound_fn);
    var $author$project$View$title = function (env) {
        var toNoteTitle = function (noteId) {
            return "Witful: " + $elm$core$Maybe$withDefault_fn($author$project$View$loadingOrNotFound_fn(env, "Note"), $elm$core$Maybe$map_fn(function (note) {
                var noteTitle = $elm$core$Maybe$withDefault_fn(note.gj, note.lv);
                return (noteTitle === "") ? "(Untitled Note)" : noteTitle;
            }, $author$project$Firestore$Collection$get_fn(noteId, env.fO)));
        };
        var _v0 = env.oe;
        switch (_v0.$) {
            case 0:
                return "Witful";
            case 1:
                return "Witful: Threads";
            case 6:
                var noteId = _v0.a;
                return toNoteTitle(noteId);
            case 4:
                return "Witful: Loading...";
            case 3:
                var noteId = _v0.a;
                return toNoteTitle(noteId);
            case 2:
                return "Witful: Loading...";
            case 5:
                var noteId = _v0.a;
                return toNoteTitle(noteId);
            case 7:
                return "Witful: Loading...";
            case 8:
                return "Witful: Loading...";
            case 9:
                var id = _v0.a;
                return "Witful: " + $elm$core$Maybe$withDefault_fn($author$project$View$loadingOrNotFound_fn(env, "Person"), $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, function ($) {
                    return $.b;
                }), $author$project$Data$Person$resolvePerson_fn(id, env.iz)));
            case 13:
                if (!_v0.a.$) {
                    var _v1 = _v0.a;
                    return "Witful: Sign in";
                }
                else {
                    return "Witful: Account Setup";
                }
            case 14:
                return "Witful: Account Setup";
            case 10:
                return "Witful: Calendar";
            case 11:
                return "Witful: Settings";
            case 12:
                return "Witful: Search";
            case 16:
                switch (_v0.a.$) {
                    case 0:
                        return "Witful: Event Series";
                    case 1:
                        var id = _v0.a.a;
                        return $elm$core$Maybe$withDefault_fn("Witful: Person not found", $elm$core$Maybe$map_fn(function (_v2) {
                            var p = _v2.b;
                            return "Witful: Meetings with " + p.b;
                        }, $author$project$Data$Person$resolvePerson_fn(id, env.iz)));
                    default:
                        var domainName = _v0.a.a.g9;
                        return "Witful: Events with " + domainName;
                }
            case 19:
                return "Witful: Not Found";
            case 17:
                return "Witful: Loading...";
            case 18:
                return "Witful: Dev Demo";
            default:
                return "Witful: Billing";
        }
    };
    var $author$project$View$view = function (model) {
        return (new $$Record155(_List_fromArray([
            $author$project$View$body(model)
        ]), $author$project$View$title(model.dW)));
    };
    var $author$project$Main$main = $elm$browser$Browser$application({ me: $author$project$Init$init, nB: $author$project$Model$URLChange, nC: $author$project$Model$URLRequest, o2: $author$project$Subscriptions$subscriptions, pP: $author$project$Update$update, p$: $author$project$View$view });
    export const Elm = { "Main": { "init": $author$project$Main$main(_Json_andThen_fn(function (userSettings) {
                return _Json_andThen_fn(function (uidEntropy) {
                    return _Json_andThen_fn(function (timeZoneOffset) {
                        return _Json_andThen_fn(function (timeZone) {
                            return _Json_andThen_fn(function (isChrome) {
                                return _Json_andThen_fn(function (initialLoadWindow) {
                                    return _Json_andThen_fn(function (currentTimeMillis) {
                                        return _Json_andThen_fn(function (appVersion) {
                                            return $elm$json$Json$Decode$succeed({ gG: appVersion, g1: currentTimeMillis, mf: initialLoadWindow, ms: isChrome, jq: timeZone, pr: timeZoneOffset, pM: uidEntropy, pZ: userSettings });
                                        }, _Json_decodeField_fn("appVersion", $elm$json$Json$Decode$int));
                                    }, _Json_decodeField_fn("currentTimeMillis", $elm$json$Json$Decode$int));
                                }, _Json_decodeField_fn("initialLoadWindow", _Json_andThen_fn(function (start) {
                                    return _Json_andThen_fn(function (end) {
                                        return $elm$json$Json$Decode$succeed({ b6: end, bF: start });
                                    }, _Json_decodeField_fn("end", $elm$json$Json$Decode$int));
                                }, _Json_decodeField_fn("start", $elm$json$Json$Decode$int))));
                            }, _Json_decodeField_fn("isChrome", $elm$json$Json$Decode$bool));
                        }, _Json_decodeField_fn("timeZone", $elm$json$Json$Decode$oneOf(_List_fromArray([
                            $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
                            _Json_map1_fn($elm$core$Maybe$Just, $elm$json$Json$Decode$string)
                        ]))));
                    }, _Json_decodeField_fn("timeZoneOffset", $elm$json$Json$Decode$int));
                }, _Json_decodeField_fn("uidEntropy", $elm$json$Json$Decode$list($elm$json$Json$Decode$int)));
            }, _Json_decodeField_fn("userSettings", $elm$json$Json$Decode$value)))(0) } };
export default Elm;
